(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 7189:
/***/ ((module) => {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 47708:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var stringify = __webpack_require__(49647);
var parse = __webpack_require__(90713);
var formats = __webpack_require__(7189);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 90713:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(27651);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: true,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        var existing = has.call(obj, key);
        if (existing && options.duplicates === 'combine') {
            obj[key] = utils.combine(obj[key], val);
        } else if (!existing || options.duplicates === 'last') {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = options.allowEmptyArrays && leaf === '' ? [] : [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 49647:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var getSideChannel = __webpack_require__(37478);
var utils = __webpack_require__(27651);
var formats = __webpack_require__(7189);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, '%2E') : prefix;

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, '%2E') : key;
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 27651:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var formats = __webpack_require__(7189);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 93379:
/***/ ((module) => {

/* The following list is defined in React's core */
var IS_UNITLESS = {
  animationIterationCount: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  stopOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};

module.exports = function(name, value) {
  if(typeof value === 'number' && !IS_UNITLESS[ name ]) {
    return value + 'px';
  } else {
    return value;
  }
};

/***/ }),

/***/ 79742:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 58509:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qp": () => (/* binding */ disableBodyScroll),
/* harmony export */   "tG": () => (/* binding */ enableBodyScroll)
/* harmony export */ });
/* unused harmony export clearAllBodyScrollLocks */
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Older browsers don't support event options, feature detect it.

// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi

var hasPassiveEvents = false;
if (typeof window !== 'undefined') {
  var passiveTestOptions = {
    get passive() {
      hasPassiveEvents = true;
      return undefined;
    }
  };
  window.addEventListener('testPassive', null, passiveTestOptions);
  window.removeEventListener('testPassive', null, passiveTestOptions);
}

var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);


var locks = [];
var documentListenerAdded = false;
var initialClientY = -1;
var previousBodyOverflowSetting = void 0;
var previousBodyPosition = void 0;
var previousBodyPaddingRight = void 0;

// returns true if `el` should be allowed to receive touchmove events.
var allowTouchMove = function allowTouchMove(el) {
  return locks.some(function (lock) {
    if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
      return true;
    }

    return false;
  });
};

var preventDefault = function preventDefault(rawEvent) {
  var e = rawEvent || window.event;

  // For the case whereby consumers adds a touchmove event listener to document.
  // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
  // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
  // the touchmove event on document will break.
  if (allowTouchMove(e.target)) {
    return true;
  }

  // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
  if (e.touches.length > 1) return true;

  if (e.preventDefault) e.preventDefault();

  return false;
};

var setOverflowHidden = function setOverflowHidden(options) {
  // If previousBodyPaddingRight is already set, don't set it again.
  if (previousBodyPaddingRight === undefined) {
    var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
    var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;

    if (_reserveScrollBarGap && scrollBarGap > 0) {
      var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'), 10);
      previousBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = computedBodyPaddingRight + scrollBarGap + 'px';
    }
  }

  // If previousBodyOverflowSetting is already set, don't set it again.
  if (previousBodyOverflowSetting === undefined) {
    previousBodyOverflowSetting = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
};

var restoreOverflowSetting = function restoreOverflowSetting() {
  if (previousBodyPaddingRight !== undefined) {
    document.body.style.paddingRight = previousBodyPaddingRight;

    // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
    // can be set again.
    previousBodyPaddingRight = undefined;
  }

  if (previousBodyOverflowSetting !== undefined) {
    document.body.style.overflow = previousBodyOverflowSetting;

    // Restore previousBodyOverflowSetting to undefined
    // so setOverflowHidden knows it can be set again.
    previousBodyOverflowSetting = undefined;
  }
};

var setPositionFixed = function setPositionFixed() {
  return window.requestAnimationFrame(function () {
    // If previousBodyPosition is already set, don't set it again.
    if (previousBodyPosition === undefined) {
      previousBodyPosition = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left
      };

      // Update the dom inside an animation frame 
      var _window = window,
          scrollY = _window.scrollY,
          scrollX = _window.scrollX,
          innerHeight = _window.innerHeight;

      document.body.style.position = 'fixed';
      document.body.style.top = -scrollY;
      document.body.style.left = -scrollX;

      setTimeout(function () {
        return window.requestAnimationFrame(function () {
          // Attempt to check if the bottom bar appeared due to the position change
          var bottomBarHeight = innerHeight - window.innerHeight;
          if (bottomBarHeight && scrollY >= innerHeight) {
            // Move the content further up so that the bottom bar doesn't hide it
            document.body.style.top = -(scrollY + bottomBarHeight);
          }
        });
      }, 300);
    }
  });
};

var restorePositionSetting = function restorePositionSetting() {
  if (previousBodyPosition !== undefined) {
    // Convert the position from "px" to Int
    var y = -parseInt(document.body.style.top, 10);
    var x = -parseInt(document.body.style.left, 10);

    // Restore styles
    document.body.style.position = previousBodyPosition.position;
    document.body.style.top = previousBodyPosition.top;
    document.body.style.left = previousBodyPosition.left;

    // Restore scroll
    window.scrollTo(x, y);

    previousBodyPosition = undefined;
  }
};

// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
  return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};

var handleScroll = function handleScroll(event, targetElement) {
  var clientY = event.targetTouches[0].clientY - initialClientY;

  if (allowTouchMove(event.target)) {
    return false;
  }

  if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
    // element is at the top of its scroll.
    return preventDefault(event);
  }

  if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
    // element is at the bottom of its scroll.
    return preventDefault(event);
  }

  event.stopPropagation();
  return true;
};

var disableBodyScroll = function disableBodyScroll(targetElement, options) {
  // targetElement must be provided
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
    return;
  }

  // disableBodyScroll must not have been called on this targetElement before
  if (locks.some(function (lock) {
    return lock.targetElement === targetElement;
  })) {
    return;
  }

  var lock = {
    targetElement: targetElement,
    options: options || {}
  };

  locks = [].concat(_toConsumableArray(locks), [lock]);

  if (isIosDevice) {
    setPositionFixed();
  } else {
    setOverflowHidden(options);
  }

  if (isIosDevice) {
    targetElement.ontouchstart = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        initialClientY = event.targetTouches[0].clientY;
      }
    };
    targetElement.ontouchmove = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        handleScroll(event, targetElement);
      }
    };

    if (!documentListenerAdded) {
      document.addEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = true;
    }
  }
};

var clearAllBodyScrollLocks = function clearAllBodyScrollLocks() {
  if (isIosDevice) {
    // Clear all locks ontouchstart/ontouchmove handlers, and the references.
    locks.forEach(function (lock) {
      lock.targetElement.ontouchstart = null;
      lock.targetElement.ontouchmove = null;
    });

    if (documentListenerAdded) {
      document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = false;
    }

    // Reset initial clientY.
    initialClientY = -1;
  }

  if (isIosDevice) {
    restorePositionSetting();
  } else {
    restoreOverflowSetting();
  }

  locks = [];
};

var enableBodyScroll = function enableBodyScroll(targetElement) {
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
    return;
  }

  locks = locks.filter(function (lock) {
    return lock.targetElement !== targetElement;
  });

  if (isIosDevice) {
    targetElement.ontouchstart = null;
    targetElement.ontouchmove = null;

    if (documentListenerAdded && locks.length === 0) {
      document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = false;
    }
  }

  if (isIosDevice) {
    restorePositionSetting();
  } else {
    restoreOverflowSetting();
  }
};



/***/ }),

/***/ 48764:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



const base64 = __webpack_require__(79742)
const ieee754 = __webpack_require__(80645)
const customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

const K_MAX_LENGTH = 0x7fffffff
__webpack_unused_export__ = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    const arr = new Uint8Array(1)
    const proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  const buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  const valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  const b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length)
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  const length = byteLength(string, encoding) | 0
  let buf = createBuffer(length)

  const actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  const length = array.length < 0 ? 0 : checked(array.length) | 0
  const buf = createBuffer(length)
  for (let i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    const copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  let buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    const len = checked(obj.length) | 0
    const buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  let x = a.length
  let y = b.length

  for (let i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  let i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  const buffer = Buffer.allocUnsafe(length)
  let pos = 0
  for (i = 0; i < list.length; ++i) {
    let buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)
        buf.copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  const len = string.length
  const mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  let loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  const i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  const len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (let i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  const len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (let i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  const len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (let i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  const length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  let str = ''
  const max = exports.h2
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  let x = thisEnd - thisStart
  let y = end - start
  const len = Math.min(x, y)

  const thisCopy = this.slice(thisStart, thisEnd)
  const targetCopy = target.slice(start, end)

  for (let i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  let indexSize = 1
  let arrLength = arr.length
  let valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  let i
  if (dir) {
    let foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      let found = true
      for (let j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  const remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  const strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  let i
  for (i = 0; i < length; ++i) {
    const parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  const remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  const res = []

  let i = start
  while (i < end) {
    const firstByte = buf[i]
    let codePoint = null
    let bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      let secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  const len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  let res = ''
  let i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  const len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  let out = ''
  for (let i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  const bytes = buf.slice(start, end)
  let res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (let i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  const len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  const newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  let val = this[offset + --byteLength]
  let mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const lo = first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24

  const hi = this[++offset] +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    last * 2 ** 24

  return BigInt(lo) + (BigInt(hi) << BigInt(32))
})

Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const hi = first * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  const lo = this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last

  return (BigInt(hi) << BigInt(32)) + BigInt(lo)
})

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let i = byteLength
  let mul = 1
  let val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = this[offset + 4] +
    this[offset + 5] * 2 ** 8 +
    this[offset + 6] * 2 ** 16 +
    (last << 24) // Overflow

  return (BigInt(val) << BigInt(32)) +
    BigInt(first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24)
})

Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  return (BigInt(val) << BigInt(32)) +
    BigInt(this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last)
})

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let mul = 1
  let i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let i = byteLength - 1
  let mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function wrtBigUInt64LE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  return offset
}

function wrtBigUInt64BE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset + 7] = lo
  lo = lo >> 8
  buf[offset + 6] = lo
  lo = lo >> 8
  buf[offset + 5] = lo
  lo = lo >> 8
  buf[offset + 4] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset + 3] = hi
  hi = hi >> 8
  buf[offset + 2] = hi
  hi = hi >> 8
  buf[offset + 1] = hi
  hi = hi >> 8
  buf[offset] = hi
  return offset + 8
}

Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = 0
  let mul = 1
  let sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = byteLength - 1
  let mul = 1
  let sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  const len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      const code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  let i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    const bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    const len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// CUSTOM ERRORS
// =============

// Simplified versions from Node, changed for Buffer-only usage
const errors = {}
function E (sym, getMessage, Base) {
  errors[sym] = class NodeError extends Base {
    constructor () {
      super()

      Object.defineProperty(this, 'message', {
        value: getMessage.apply(this, arguments),
        writable: true,
        configurable: true
      })

      // Add the error code to the name to include it in the stack trace.
      this.name = `${this.name} [${sym}]`
      // Access the stack to generate the error message including the error code
      // from the name.
      this.stack // eslint-disable-line no-unused-expressions
      // Reset the name to the actual name.
      delete this.name
    }

    get code () {
      return sym
    }

    set code (value) {
      Object.defineProperty(this, 'code', {
        configurable: true,
        enumerable: true,
        value,
        writable: true
      })
    }

    toString () {
      return `${this.name} [${sym}]: ${this.message}`
    }
  }
}

E('ERR_BUFFER_OUT_OF_BOUNDS',
  function (name) {
    if (name) {
      return `${name} is outside of buffer bounds`
    }

    return 'Attempt to access memory outside buffer bounds'
  }, RangeError)
E('ERR_INVALID_ARG_TYPE',
  function (name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`
  }, TypeError)
E('ERR_OUT_OF_RANGE',
  function (str, range, input) {
    let msg = `The value of "${str}" is out of range.`
    let received = input
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input))
    } else if (typeof input === 'bigint') {
      received = String(input)
      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
        received = addNumericalSeparator(received)
      }
      received += 'n'
    }
    msg += ` It must be ${range}. Received ${received}`
    return msg
  }, RangeError)

function addNumericalSeparator (val) {
  let res = ''
  let i = val.length
  const start = val[0] === '-' ? 1 : 0
  for (; i >= start + 4; i -= 3) {
    res = `_${val.slice(i - 3, i)}${res}`
  }
  return `${val.slice(0, i)}${res}`
}

// CHECK FUNCTIONS
// ===============

function checkBounds (buf, offset, byteLength) {
  validateNumber(offset, 'offset')
  if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
    boundsError(offset, buf.length - (byteLength + 1))
  }
}

function checkIntBI (value, min, max, buf, offset, byteLength) {
  if (value > max || value < min) {
    const n = typeof min === 'bigint' ? 'n' : ''
    let range
    if (byteLength > 3) {
      if (min === 0 || min === BigInt(0)) {
        range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`
      } else {
        range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` +
                `${(byteLength + 1) * 8 - 1}${n}`
      }
    } else {
      range = `>= ${min}${n} and <= ${max}${n}`
    }
    throw new errors.ERR_OUT_OF_RANGE('value', range, value)
  }
  checkBounds(buf, offset, byteLength)
}

function validateNumber (value, name) {
  if (typeof value !== 'number') {
    throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value)
  }
}

function boundsError (value, length, type) {
  if (Math.floor(value) !== value) {
    validateNumber(value, type)
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value)
  }

  if (length < 0) {
    throw new errors.ERR_BUFFER_OUT_OF_BOUNDS()
  }

  throw new errors.ERR_OUT_OF_RANGE(type || 'offset',
                                    `>= ${type ? 1 : 0} and <= ${length}`,
                                    value)
}

// HELPER FUNCTIONS
// ================

const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  let codePoint
  const length = string.length
  let leadSurrogate = null
  const bytes = []

  for (let i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  let c, hi, lo
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  let i
  for (i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = (function () {
  const alphabet = '0123456789abcdef'
  const table = new Array(256)
  for (let i = 0; i < 16; ++i) {
    const i16 = i * 16
    for (let j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()

// Return not function with Error if BigInt not supported
function defineBigIntMethod (fn) {
  return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn
}

function BufferBigIntNotDefined () {
  throw new Error('BigInt not supported')
}


/***/ }),

/***/ 25730:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(58612);

var $apply = __webpack_require__(1768);
var $call = __webpack_require__(68928);
var $reflectApply = __webpack_require__(59770);

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);


/***/ }),

/***/ 1768:
/***/ ((module) => {

"use strict";


/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;


/***/ }),

/***/ 68928:
/***/ ((module) => {

"use strict";


/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;


/***/ }),

/***/ 40319:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(58612);
var $TypeError = __webpack_require__(14453);

var $call = __webpack_require__(68928);
var $actualApply = __webpack_require__(25730);

/** @type {import('.')} */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};


/***/ }),

/***/ 59770:
/***/ ((module) => {

"use strict";


/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ }),

/***/ 17379:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var callBindBasic = __webpack_require__(40319);

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	// eslint-disable-next-line no-extra-parens
	var intrinsic = /** @type {Parameters<typeof callBindBasic>[0][0]} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic([intrinsic]);
	}
	return intrinsic;
};


/***/ }),

/***/ 53879:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var prefix = __webpack_require__(87236)
var toCamelCase = __webpack_require__(6189)
var cache = { 'float': 'cssFloat' }
var addPxToStyle = __webpack_require__(93379)

function style (element, property, value) {
  var camel = cache[property]
  if (typeof camel === 'undefined') {
    camel = detect(property)
  }

  // may be false if CSS prop is unsupported
  if (camel) {
    if (value === undefined) {
      return element.style[camel]
    }

    element.style[camel] = addPxToStyle(camel, value)
  }
}

function each (element, properties) {
  for (var k in properties) {
    if (properties.hasOwnProperty(k)) {
      style(element, k, properties[k])
    }
  }
}

function detect (cssProp) {
  var camel = toCamelCase(cssProp)
  var result = prefix(camel)
  cache[camel] = cache[cssProp] = cache[result] = result
  return result
}

function set () {
  if (arguments.length === 2) {
    if (typeof arguments[1] === 'string') {
      arguments[0].style.cssText = arguments[1]
    } else {
      each(arguments[0], arguments[1])
    }
  } else {
    style(arguments[0], arguments[1], arguments[2])
  }
}

module.exports = set
module.exports.set = set

module.exports.get = function (element, properties) {
  if (Array.isArray(properties)) {
    return properties.reduce(function (obj, prop) {
      obj[prop] = style(element, prop || '')
      return obj
    }, {})
  } else {
    return style(element, properties || '')
  }
}


/***/ }),

/***/ 96504:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var callBind = __webpack_require__(40319);
var gOPD = __webpack_require__(27296);

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;


/***/ }),

/***/ 67238:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g3": () => (/* binding */ StoreProvider),
  "aD": () => (/* binding */ action),
  "MT": () => (/* binding */ dist_createStore),
  "tl": () => (/* binding */ createTypedHooks)
});

// UNUSED EXPORTS: actionOn, computed, createContextStore, createStoreActionsHook, createStoreDispatchHook, createStoreRehydratedHook, createStoreStateHook, createTransform, debug, effectOn, generic, initializeUseStoreState, persist, reducer, thunk, thunkOn, useLocalStore, useStore, useStoreActions, useStoreDispatch, useStoreRehydrated, useStoreState

// EXTERNAL MODULE: ./node_modules/easy-peasy/node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(19509);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
;// CONCATENATED MODULE: ./node_modules/redux/es/redux.js


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {}

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = (/* unused pure expression or super */ null && (createStore));

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 0);
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}



;// CONCATENATED MODULE: ./node_modules/redux-thunk/es/index.js
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ const es = (thunk);
;// CONCATENATED MODULE: ./node_modules/easy-peasy/node_modules/immer/dist/immer.esm.mjs
function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if(false){ var i, o; }throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return"'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return!!n&&!!n[Q]}function t(n){var r;return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var r=Object.getPrototypeOf(n);if(null===r)return!0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!(null===(r=n.constructor)||void 0===r?void 0:r[L])||s(n)||v(n))}function e(t){return r(t)||n(23,t),t[Q].t}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n)})):n.forEach((function(t,e){return r(e,t,n)}))}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?n.add(t):n[r]=t}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]})}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)||(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0)),n}function h(){n(2)}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function m(n,r){tn[n]||(tn[n]=r)}function _(){return true||0,U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r)}function g(n){O(n),n.p.forEach(S),n.p=null}function O(n){n===U&&(U=n.l)}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.g=!0}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.O||b("ES5").S(e,r,o),o?(i[Q].P&&(g(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),g(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o,u=o,a=!1;3===e.i&&(u=new Set(o),o.clear(),a=!0),i(u,(function(r,i){return A(n,e,o,r,i,t,a)})),x(n,o,!1),t&&n.u&&b("Patches").N(e,t,n.u,n.s)}return e.o}function A(e,i,o,a,c,s,v){if( false&&0,r(c)){var p=M(e,c,s&&i&&3!==i.i&&!u(i.R,a)?s.concat(a):void 0);if(f(o,a,p),!r(p))return;e.m=!1}else v&&o.add(c);if(t(c)&&!y(c)){if(!e.h.D&&e._<1)return;M(e,c),i&&i.A.l||x(e,c)}}function x(n,r,t){void 0===t&&(t=!1),!n.l&&n.h.D&&n.m&&d(r,t)}function z(n,r){var t=n[Q];return(t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t)}}function k(n){n.P||(n.P=!0,n.l&&k(n.l))}function E(n){n.o||(n.o=l(n.t))}function N(n,r,t){var e=s(r)?b("MapSet").F(r,t):v(r)?b("MapSet").T(r,t):n.O?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return(t?t.A:_()).p.push(e),e}function R(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=D(r,c),u.I=!1}else e=D(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t))})),3===c?new Set(e):e}(e)}function D(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function F(){function t(n,r){var t=s[n];return t?t.enumerable=r:s[n]=t={configurable:!0,enumerable:r,get:function(){var r=this[Q];return false&&0,en.get(r,n)},set:function(r){var t=this[Q]; false&&0,en.set(t,n,r)}},t}function e(n){for(var r=n.length-1;r>=0;r--){var t=n[r][Q];if(!t.P)switch(t.i){case 5:a(t)&&k(t);break;case 4:o(t)&&k(t)}}}function o(n){for(var r=n.t,t=n.k,e=nn(t),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=r[o];if(void 0===a&&!u(r,o))return!0;var f=t[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return!0}}var v=!!r[Q];return e.length!==nn(r).length+(v?0:1)}function a(n){var r=n.k;if(r.length!==n.t.length)return!0;var t=Object.getOwnPropertyDescriptor(r,r.length-1);if(t&&!t.get)return!0;for(var e=0;e<r.length;e++)if(!r.hasOwnProperty(e))return!0;return!1}function f(r){r.g&&n(3,JSON.stringify(p(r)))}var s={};m("ES5",{J:function(n,r){var e=Array.isArray(n),i=function(n,r){if(n){for(var e=Array(r.length),i=0;i<r.length;i++)Object.defineProperty(e,""+i,t(i,!0));return e}var o=rn(r);delete o[Q];for(var u=nn(o),a=0;a<u.length;a++){var f=u[a];o[f]=t(f,n||!!o[f].enumerable)}return Object.create(Object.getPrototypeOf(r),o)}(e,n),o={i:e?5:4,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:i,o:null,g:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,t,o){o?r(t)&&t[Q].A===n&&e(n.p):(n.u&&function n(r){if(r&&"object"==typeof r){var t=r[Q];if(t){var e=t.t,o=t.k,f=t.R,c=t.i;if(4===c)i(o,(function(r){r!==Q&&(void 0!==e[r]||u(e,r)?f[r]||n(o[r]):(f[r]=!0,k(t)))})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,k(t))}));else if(5===c){if(a(t)&&(k(t),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)o.hasOwnProperty(l)||(f[l]=!0),void 0===f[l]&&n(o[l])}}}}(n.p[0]),e(n.p))},K:function(n){return 4===n.i?o(n):a(n)}})}function T(){function e(n){if(!t(n))return n;if(Array.isArray(n))return n.map(e);if(s(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],e(n[1])]})));if(v(n))return new Set(Array.from(n).map(e));var r=Object.create(Object.getPrototypeOf(n));for(var i in n)r[i]=e(n[i]);return u(n,L)&&(r[L]=n[L]),r}function f(n){return r(n)?e(n):n}var c="add";m("Patches",{$:function(r,t){return t.forEach((function(t){for(var i=t.path,u=t.op,f=r,s=0;s<i.length-1;s++){var v=o(f),p=i[s];"string"!=typeof p&&"number"!=typeof p&&(p=""+p),0!==v&&1!==v||"__proto__"!==p&&"constructor"!==p||n(24),"function"==typeof f&&"prototype"===p&&n(24),"object"!=typeof(f=a(f,p))&&n(15,i.join("/"))}var l=o(f),d=e(t.value),h=i[i.length-1];switch(u){case"replace":switch(l){case 2:return f.set(h,d);case 3:n(16);default:return f[h]=d}case c:switch(l){case 1:return"-"===h?f.push(d):f.splice(h,0,d);case 2:return f.set(h,d);case 3:return f.add(d);default:return f[h]=d}case"remove":switch(l){case 1:return f.splice(h,1);case 2:return f.delete(h);case 3:return f.delete(t.value);default:return delete f[h]}default:n(17,u)}})),r},N:function(n,r,t,e){switch(n.i){case 0:case 4:case 2:return function(n,r,t,e){var o=n.t,s=n.o;i(n.R,(function(n,i){var v=a(o,n),p=a(s,n),l=i?u(o,n)?"replace":c:"remove";if(v!==p||"replace"!==l){var d=r.concat(n);t.push("remove"===l?{op:l,path:d}:{op:l,path:d,value:p}),e.push(l===c?{op:"remove",path:d}:"remove"===l?{op:c,path:d,value:f(v)}:{op:"replace",path:d,value:f(v)})}}))}(n,r,t,e);case 5:case 1:return function(n,r,t,e){var i=n.t,o=n.R,u=n.o;if(u.length<i.length){var a=[u,i];i=a[0],u=a[1];var s=[e,t];t=s[0],e=s[1]}for(var v=0;v<i.length;v++)if(o[v]&&u[v]!==i[v]){var p=r.concat([v]);t.push({op:"replace",path:p,value:f(u[v])}),e.push({op:"replace",path:p,value:f(i[v])})}for(var l=i.length;l<u.length;l++){var d=r.concat([l]);t.push({op:c,path:d,value:f(u[l])})}i.length<u.length&&e.push({op:"replace",path:r.concat(["length"]),value:i.length})}(n,r,t,e);case 3:return function(n,r,t,e){var i=n.t,o=n.o,u=0;i.forEach((function(n){if(!o.has(n)){var i=r.concat([u]);t.push({op:"remove",path:i,value:n}),e.unshift({op:c,path:i,value:n})}u++})),u=0,o.forEach((function(n){if(!i.has(n)){var o=r.concat([u]);t.push({op:c,path:o,value:n}),e.unshift({op:"remove",path:o,value:n})}u++}))}(n,r,t,e)}},M:function(n,r,t,e){t.push({op:"replace",path:[],value:r===H?void 0:r}),e.push({op:"replace",path:[],value:n})}})}function C(){function r(n,r){function t(){this.constructor=n}a(n,r),n.prototype=(t.prototype=r.prototype,new t)}function e(n){n.o||(n.R=new Map,n.o=new Map(n.t))}function o(n){n.o||(n.o=new Set,n.t.forEach((function(r){if(t(r)){var e=N(n.A.h,r,n);n.p.set(r,e),n.o.add(e)}else n.o.add(r)})))}function u(r){r.g&&n(3,JSON.stringify(p(r)))}var a=function(n,r){return(a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,r){n.__proto__=r}||function(n,r){for(var t in r)r.hasOwnProperty(t)&&(n[t]=r[t])})(n,r)},f=function(){function n(n,r){return this[Q]={i:2,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,R:void 0,t:n,k:this,C:!1,g:!1},this}r(n,Map);var o=n.prototype;return Object.defineProperty(o,"size",{get:function(){return p(this[Q]).size}}),o.has=function(n){return p(this[Q]).has(n)},o.set=function(n,r){var t=this[Q];return u(t),p(t).has(n)&&p(t).get(n)===r||(e(t),k(t),t.R.set(n,!0),t.o.set(n,r),t.R.set(n,!0)),this},o.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),e(r),k(r),r.t.has(n)?r.R.set(n,!1):r.R.delete(n),r.o.delete(n),!0},o.clear=function(){var n=this[Q];u(n),p(n).size&&(e(n),k(n),n.R=new Map,i(n.t,(function(r){n.R.set(r,!1)})),n.o.clear())},o.forEach=function(n,r){var t=this;p(this[Q]).forEach((function(e,i){n.call(r,t.get(i),i,t)}))},o.get=function(n){var r=this[Q];u(r);var i=p(r).get(n);if(r.I||!t(i))return i;if(i!==r.t.get(n))return i;var o=N(r.A.h,i,r);return e(r),r.o.set(n,o),o},o.keys=function(){return p(this[Q]).keys()},o.values=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.values()},n.next=function(){var n=t.next();return n.done?n:{done:!1,value:r.get(n.value)}},n},o.entries=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.entries()},n.next=function(){var n=t.next();if(n.done)return n;var e=r.get(n.value);return{done:!1,value:[n.value,e]}},n},o[V]=function(){return this.entries()},n}(),c=function(){function n(n,r){return this[Q]={i:3,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,t:n,k:this,p:new Map,g:!1,C:!1},this}r(n,Set);var t=n.prototype;return Object.defineProperty(t,"size",{get:function(){return p(this[Q]).size}}),t.has=function(n){var r=this[Q];return u(r),r.o?!!r.o.has(n)||!(!r.p.has(n)||!r.o.has(r.p.get(n))):r.t.has(n)},t.add=function(n){var r=this[Q];return u(r),this.has(n)||(o(r),k(r),r.o.add(n)),this},t.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),o(r),k(r),r.o.delete(n)||!!r.p.has(n)&&r.o.delete(r.p.get(n))},t.clear=function(){var n=this[Q];u(n),p(n).size&&(o(n),k(n),n.o.clear())},t.values=function(){var n=this[Q];return u(n),o(n),n.o.values()},t.entries=function(){var n=this[Q];return u(n),o(n),n.o.entries()},t.keys=function(){return this.values()},t[V]=function(){return this.values()},t.forEach=function(n,r){for(var t=this.values(),e=t.next();!e.done;)n.call(r,e.value,e.value,this),e=t.next()},n}();m("MapSet",{F:function(n,r){return new f(n,r)},T:function(n,r){return new c(n,r)}})}function J(){F(),C(),T()}function K(n){return n}function $(n){return n}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",V="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return"Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return"Unsupported patch operation: "+n},18:function(n){return"The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return"produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return"'current' expects a draft, got: "+n},23:function(n){return"'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t)})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=N(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.R[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return!0;E(n),k(n)}return n.o[r]===t&&(void 0!==t||r in n.o)||Number.isNaN(t)&&Number.isNaN(n.o[r])||(n.o[r]=t,n.R[r]=!0),!0},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.R[r]=!1,E(n),k(n)):delete n.R[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12)}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)}})),on.deleteProperty=function(r,t){return false&&0,on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return false&&0,en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.O=B,this.D=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return(t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=N(e,r,void 0),v=!0;try{f=i(s),v=!1}finally{v?g(c):O(c)}return"undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw g(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.D&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l)}return f}n(21,r)},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r}));return"undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return[n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze)}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=R(e));var i=w(this),o=N(this,e,void 0);return o[Q].C=!0,O(i),o},i.finishDraft=function(r,t){var e=r&&r[Q]; false&&(0);var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.D=n},i.setUseProxies=function(r){r&&!B&&n(20),this.O=r},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce,cn=an.produceWithPatches.bind(an),sn=an.setAutoFreeze.bind(an),vn=an.setUseProxies.bind(an),pn=an.applyPatches.bind(an),ln=an.createDraft.bind(an),dn=an.finishDraft.bind(an);/* harmony default export */ const immer_esm = ((/* unused pure expression or super */ null && (fn)));
//# sourceMappingURL=immer.esm.js.map

// EXTERNAL MODULE: ./node_modules/fast-deep-equal/es6/index.js
var es6 = __webpack_require__(62991);
var es6_default = /*#__PURE__*/__webpack_require__.n(es6);
;// CONCATENATED MODULE: ./node_modules/easy-peasy/dist/index.js








var StoreContext = (0,react.createContext)();

var useNotInitialized = function useNotInitialized() {
  throw new Error('uSES not initialized!');
};
var useSyncExternalStoreWithSelector = useNotInitialized;
var initializeUseStoreState = function initializeUseStoreState(fn) {
  useSyncExternalStoreWithSelector = fn;
};
var refEquality = function refEquality(a, b) {
  return a === b;
};
function createStoreStateHook(Context) {
  return function useStoreState(mapState, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }
    if (false) {}
    var store = (0,react.useContext)(Context);

    /*
    function useSyncExternalStoreWithSelector<Snapshot, Selection>(
        subscribe: (onStoreChange: () => void) => () => void,
        getSnapshot: () => Snapshot,
        getServerSnapshot: undefined | null | (() => Snapshot),
        selector: (snapshot: Snapshot) => Selection,
        isEqual?: (a: Selection, b: Selection) => boolean,
    ): Selection;
    */
    var selectedState = useSyncExternalStoreWithSelector(store.subscribe, store.getState, store.getState,
    // getServerSnapshot = getState
    mapState, equalityFn);
    (0,react.useDebugValue)(selectedState);
    return selectedState;
  };
}
var useStoreState = createStoreStateHook(StoreContext);
function createStoreActionsHook(Context) {
  return function useStoreActions(mapActions) {
    var store = (0,react.useContext)(Context);
    return mapActions(store.getActions());
  };
}
var useStoreActions = createStoreActionsHook(StoreContext);
function createStoreDispatchHook(Context) {
  return function useStoreDispatch() {
    var store = (0,react.useContext)(Context);
    return store.dispatch;
  };
}
var useStoreDispatch = createStoreDispatchHook(StoreContext);
function useStore() {
  return (0,react.useContext)(StoreContext);
}
function createStoreRehydratedHook(Context) {
  return function useStoreRehydrated() {
    var store = (0,react.useContext)(Context);
    var _useState = (0,react.useState)(false),
      rehydrated = _useState[0],
      setRehydrated = _useState[1];
    (0,react.useEffect)(function () {
      store.persist.resolveRehydration().then(function () {
        return setRehydrated(true);
      });
    }, []);
    return rehydrated;
  };
}
var useStoreRehydrated = createStoreRehydratedHook(StoreContext);
function createTypedHooks() {
  return {
    useStoreActions: useStoreActions,
    useStoreDispatch: useStoreDispatch,
    useStoreState: useStoreState,
    useStoreRehydrated: useStoreRehydrated,
    useStore: useStore
  };
}

var actionSymbol = '$_a';
var actionOnSymbol = '$_aO';
var computedSymbol = '$_c';
var effectOnSymbol = '$_e';
var persistSymbol = '$_p';
var reducerSymbol = '$_r';
var thunkOnSymbol = '$_tO';
var thunkSymbol = '$_t';

var debug = function debug(state) {
  if (isDraft(state)) {
    return current(state);
  }
  return state;
};
var actionOn = function actionOn(targetResolver, fn, config) {
  var _ref;
  return _ref = {}, _ref[actionOnSymbol] = true, _ref.fn = fn, _ref.targetResolver = targetResolver, _ref.config = config, _ref;
};
var action = function action(fn, config) {
  var _ref2;
  return _ref2 = {}, _ref2[actionSymbol] = true, _ref2.fn = fn, _ref2.config = config, _ref2;
};
var defaultStateResolvers = [function (state) {
  return state;
}];
var computed = function computed(fnOrStateResolvers, fn) {
  var _ref4;
  if (typeof fn === 'function') {
    var _ref3;
    return _ref3 = {}, _ref3[computedSymbol] = true, _ref3.fn = fn, _ref3.stateResolvers = fnOrStateResolvers, _ref3;
  }
  return _ref4 = {}, _ref4[computedSymbol] = true, _ref4.fn = fnOrStateResolvers, _ref4.stateResolvers = defaultStateResolvers, _ref4;
};
function effectOn(dependencyResolvers, fn) {
  var _ref5;
  return _ref5 = {}, _ref5[effectOnSymbol] = true, _ref5.dependencyResolvers = dependencyResolvers, _ref5.fn = fn, _ref5;
}
function generic(value) {
  return value;
}
var persist = function persist(model, config) {
  var _objectSpread2;
  return (
    // if we are not running in a browser context this becomes a no-op
    typeof window === 'undefined' ? model : _objectSpread(_objectSpread({}, model), {}, (_objectSpread2 = {}, _objectSpread2[persistSymbol] = config, _objectSpread2))
  );
};
var thunkOn = function thunkOn(targetResolver, fn) {
  var _ref6;
  return _ref6 = {}, _ref6[thunkOnSymbol] = true, _ref6.fn = fn, _ref6.targetResolver = targetResolver, _ref6;
};
var dist_thunk = function thunk(fn) {
  var _ref7;
  return _ref7 = {}, _ref7[thunkSymbol] = true, _ref7.fn = fn, _ref7;
};
var reducer = function reducer(fn, config) {
  var _ref8;
  return _ref8 = {}, _ref8[reducerSymbol] = true, _ref8.fn = fn, _ref8.config = config, _ref8;
};

/**
 * We create our own immer instance to avoid potential issues with autoFreeze
 * becoming default enabled everywhere. We want to disable autofreeze as it
 * does not suit the design of Easy Peasy.
 * https://github.com/immerjs/immer/issues/681#issuecomment-705581111
 */
var easyPeasyImmer;
function dist_isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto;
}
function clone(source) {
  function recursiveClone(current) {
    var next = Object.keys(current).reduce(function (acc, key) {
      if (Object.getOwnPropertyDescriptor(current, key).get == null) {
        acc[key] = current[key];
      }
      return acc;
    }, {});
    Object.keys(next).forEach(function (key) {
      if (dist_isPlainObject(next[key])) {
        next[key] = recursiveClone(next[key]);
      }
    });
    return next;
  }
  return recursiveClone(source);
}
function isPromise(x) {
  return x != null && typeof x === 'object' && typeof x.then === 'function';
}
function get(path, target) {
  return path.reduce(function (acc, cur) {
    return dist_isPlainObject(acc) ? acc[cur] : undefined;
  }, target);
}
function newify(currentPath, currentState, finalValue) {
  if (currentPath.length === 0) {
    return finalValue;
  }
  var newState = (0,objectSpread2/* default */.Z)({}, currentState);
  var key = currentPath[0];
  if (currentPath.length === 1) {
    newState[key] = finalValue;
  } else {
    newState[key] = newify(currentPath.slice(1), newState[key], finalValue);
  }
  return newState;
}
function set(path, target, value) {
  if (path.length === 0) {
    if (typeof value === 'object') {
      Object.keys(target).forEach(function (key) {
        delete target[key];
      });
      Object.keys(value).forEach(function (key) {
        target[key] = value[key];
      });
    }
    return;
  }
  path.reduce(function (acc, cur, idx) {
    if (idx + 1 === path.length) {
      acc[cur] = value;
    } else {
      acc[cur] = acc[cur] || {};
    }
    return acc[cur];
  }, target);
}
function createSimpleProduce(disableImmer) {
  if (disableImmer === void 0) {
    disableImmer = false;
  }
  return function simpleProduce(path, state, fn, config) {
    if (config && 'immer' in config ? (config == null ? void 0 : config.immer) === false : disableImmer) {
      var _current = get(path, state);
      var next = fn(_current);
      if (_current !== next) {
        return newify(path, state, next);
      }
      return state;
    }
    if (!easyPeasyImmer) {
      easyPeasyImmer = new un({
        // We need to ensure that we disable proxies if they aren't available
        // on the environment. Users need to ensure that they use the enableES5
        // feature of immer.
        useProxies: typeof Proxy !== 'undefined' && typeof Proxy.revocable !== 'undefined' && typeof Reflect !== 'undefined',
        // Autofreezing breaks easy-peasy, we need a mixed version of immutability
        // and mutability in order to apply updates to our computed properties
        autoFreeze: false
      });
    }
    if (path.length === 0) {
      var _draft = easyPeasyImmer.createDraft(state);
      var _result = fn(_draft);
      if (_result) {
        return r(_result) ? easyPeasyImmer.finishDraft(_result) : _result;
      }
      return easyPeasyImmer.finishDraft(_draft);
    }
    var parentPath = path.slice(0, path.length - 1);
    var draft = easyPeasyImmer.createDraft(state);
    var parent = get(parentPath, state);
    var current = get(path, draft);
    var result = fn(current);
    if (result) {
      parent[path[path.length - 1]] = result;
    }
    return easyPeasyImmer.finishDraft(draft);
  };
}
var pReduce = function pReduce(iterable, reducer, initialValue) {
  return new Promise(function (resolve, reject) {
    var iterator = iterable[Symbol.iterator]();
    var index = 0;
    var next = function next(total) {
      var element = iterator.next();
      if (element.done) {
        resolve(total);
        return;
      }
      Promise.all([total, element.value]).then(function (value) {
        return (
          // eslint-disable-next-line no-plusplus
          next(reducer(value[0], value[1], index++))
        );
      }).catch(function (err) {
        return reject(err);
      });
    };
    next(initialValue);
  });
};
var pSeries = function pSeries(tasks) {
  var results = [];
  return pReduce(tasks, function (_, task) {
    return task().then(function (value) {
      results.push(value);
    });
  }).then(function () {
    return results;
  });
};
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i = 0; i < newInputs.length; i += 1) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }
  return true;
}
function useMemoOne(
// getResult changes on every call,
getResult,
// the inputs array changes on every call
inputs) {
  // using useState to generate initial value as it is lazy
  var initial = React.useState(function () {
    return {
      inputs: inputs,
      result: getResult()
    };
  })[0];
  var committed = React.useRef(initial);

  // persist any uncommitted changes after they have been committed

  var isInputMatch = Boolean(inputs && committed.current.inputs && areInputsEqual(inputs, committed.current.inputs));

  // create a new cache if required
  var cache = isInputMatch ? committed.current : {
    inputs: inputs,
    result: getResult()
  };

  // commit the cache
  React.useEffect(function () {
    committed.current = cache;
  }, [cache]);
  return cache.result;
}
var logEventListenerError = function logEventListenerError(type, err) {
  // eslint-disable-next-line no-console
  console.log("Error in " + type);
  // eslint-disable-next-line no-console
  console.log(err);
};
var handleEventDispatchErrors = function handleEventDispatchErrors(type, dispatcher) {
  return function () {
    try {
      var result = dispatcher.apply(void 0, arguments);
      if (isPromise(result)) {
        result.catch(function (err) {
          logEventListenerError(type, err);
        });
      }
    } catch (err) {
      logEventListenerError(type, err);
    }
  };
};

function createReducer(disableImmer, _aRD, _cR, _cP) {
  var simpleProduce = createSimpleProduce(disableImmer);
  var runActionReducerAtPath = function runActionReducerAtPath(state, action, actionReducer, path, config) {
    return simpleProduce(path, state, function (draft) {
      return actionReducer(draft, action.payload);
    }, config);
  };
  var reducerForActions = function reducerForActions(state, action) {
    var actionReducer = _aRD[action.type];
    if (actionReducer) {
      return runActionReducerAtPath(state, action, actionReducer, actionReducer.def.meta.parent, actionReducer.def.config);
    }
    return state;
  };
  var reducerForCustomReducers = function reducerForCustomReducers(state, action) {
    return _cR.reduce(function (acc, _ref) {
      var parentPath = _ref.parentPath,
        key = _ref.key,
        reducer = _ref.reducer,
        config = _ref.config;
      return simpleProduce(parentPath, acc, function (draft) {
        draft[key] = reducer(r(draft[key]) ? e(draft[key]) : draft[key], action);
        return draft;
      }, config);
    }, state);
  };
  var rootReducer = function rootReducer(state, action) {
    var stateAfterActions = reducerForActions(state, action);
    var next = _cR.length > 0 ? reducerForCustomReducers(stateAfterActions, action) : stateAfterActions;
    if (state !== next) {
      _cP.forEach(function (_ref2) {
        var parentPath = _ref2.parentPath,
          bindComputedProperty = _ref2.bindComputedProperty;
        var parentState = get(parentPath, next);
        if (parentState != null) bindComputedProperty(parentState, next);
      });
    }
    return next;
  };
  return rootReducer;
}

var migrate = function migrate(data, migrations) {
  var _data$_migrationVersi;
  sn(false);
  var version = (_data$_migrationVersi = data._migrationVersion) != null ? _data$_migrationVersi : 0;
  var toVersion = migrations.migrationVersion;
  if (typeof version !== "number" || typeof toVersion !== 'number') {
    throw new Error('No migration version found');
  }
  while (version < toVersion) {
    var nextVersion = version + 1;
    var migrator = migrations[nextVersion];
    if (!migrator) {
      throw new Error("No migrator found for `migrationVersion` " + nextVersion);
    }
    data = fn(data, migrator);
    data._migrationVersion = nextVersion;
    version = data._migrationVersion;
  }
  sn(true);
  return data;
};

var noopStorage = {
  getItem: function getItem() {
    return undefined;
  },
  setItem: function setItem() {
    return undefined;
  },
  removeItem: function removeItem() {
    return undefined;
  }
};
var getBrowserStorage = function getBrowserStorage(storageName) {
  var storageCache;
  return function () {
    if (!storageCache) {
      try {
        if (typeof window !== 'undefined' && typeof window[storageName] !== 'undefined') {
          storageCache = window[storageName];
        }
      } catch (_) {
        // swallow the failure
      }
      if (!storageCache) {
        storageCache = noopStorage;
      }
    }
    return storageCache;
  };
};
var localStorage = getBrowserStorage('localStorage');
var sessionStorage = getBrowserStorage('sessionStorage');
function createStorageWrapper(storage, transformers, migrations) {
  if (transformers === void 0) {
    transformers = [];
  }
  if (migrations === void 0) {
    migrations = {};
  }
  if (storage == null) {
    storage = sessionStorage();
  }
  if (typeof storage === 'string') {
    if (storage === 'localStorage') {
      storage = localStorage();
    } else if (storage === 'sessionStorage') {
      storage = sessionStorage();
    } else {
      if (false) {}
      storage = noopStorage;
    }
  }
  var outTransformers = [].concat(transformers).reverse();
  var serialize = function serialize(data) {
    if (transformers.length > 0 && data != null && typeof data === 'object') {
      Object.keys(data).forEach(function (key) {
        data[key] = transformers.reduce(function (acc, cur) {
          return cur.in(acc, key, data);
        }, data[key]);
      });
    }
    return storage === localStorage() || storage === sessionStorage() ? JSON.stringify({
      data: data
    }) : data;
  };
  var deserialize = function deserialize(data) {
    var storageData = storage === localStorage() || storage === sessionStorage() ? JSON.parse(data).data : data;
    var hasMigrations = Object.keys(migrations).length > 0;
    var result = hasMigrations ? migrate(storageData, migrations) : storageData;
    if (outTransformers.length > 0 && result != null && typeof result === 'object') {
      Object.keys(result).forEach(function (key) {
        result[key] = outTransformers.reduce(function (acc, cur) {
          return cur.out(acc, key, result);
        }, result[key]);
      });
    }
    return result;
  };
  var isAsync = isPromise(storage.getItem('_'));
  return {
    getItem: function getItem(key) {
      if (isAsync) {
        return storage.getItem(key).then(function (wrapped) {
          return wrapped != null ? deserialize(wrapped) : undefined;
        });
      }
      var wrapped = storage.getItem(key);
      return wrapped != null ? deserialize(wrapped) : undefined;
    },
    setItem: function setItem(key, data) {
      return storage.setItem(key, serialize(data));
    },
    removeItem: function removeItem(key) {
      return storage.removeItem(key);
    }
  };
}
function extractPersistConfig(path, persistdef) {
  if (persistdef === void 0) {
    persistdef = {};
  }
  return {
    path: path,
    config: {
      allow: persistdef.allow || [],
      deny: persistdef.deny || [],
      mergeStrategy: persistdef.mergeStrategy || 'mergeDeep',
      storage: createStorageWrapper(persistdef.storage, persistdef.transformers, persistdef.migrations)
    }
  };
}
function resolvePersistTargets(target, allow, deny) {
  var targets = Object.keys(target);
  if (allow.length > 0) {
    targets = targets.reduce(function (acc, cur) {
      if (allow.findIndex(function (x) {
        return x === cur;
      }) !== -1) {
        return [].concat(acc, [cur]);
      }
      return acc;
    }, []);
  }
  if (deny.length > 0) {
    targets = targets.reduce(function (acc, cur) {
      if (deny.findIndex(function (x) {
        return x === cur;
      }) !== -1) {
        return acc;
      }
      return [].concat(acc, [cur]);
    }, []);
  }
  return targets;
}
function createPersistenceClearer(persistKey, _r) {
  return function () {
    if (_r._i._persistenceConfig.length === 0) {
      return Promise.resolve();
    }
    return pSeries(_r._i._persistenceConfig.map(function (_ref) {
      var path = _ref.path,
        config = _ref.config;
      return function () {
        return Promise.resolve(config.storage.removeItem(persistKey(path)));
      };
    }));
  };
}
function createPersistor(persistKey, _r) {
  var persistPromise = Promise.resolve();
  var isPersisting = false;
  var nextPersistOperation;
  var timingMethod = typeof window === 'undefined' ? function (fn) {
    return fn();
  } : window.requestIdleCallback != null ?
  // We need to wrap requestIdleCallback, because it doesn't work without
  // a second parameter on iOS with ReactNative
  function (fn) {
    return window.requestIdleCallback(fn, {
      timeout: 0
    });
  } : window.requestAnimationFrame;
  var persist = function persist(nextState) {
    if (_r._i._persistenceConfig.length === 0) {
      return;
    }
    var operation = function operation() {
      isPersisting = true;
      persistPromise = new Promise(function (resolve) {
        timingMethod(function () {
          pSeries(_r._i._persistenceConfig.map(function (_ref2) {
            var path = _ref2.path,
              config = _ref2.config;
            return function () {
              var storage = config.storage,
                allow = config.allow,
                deny = config.deny;
              var persistRootState = clone(get(path, nextState));
              var persistTargets = resolvePersistTargets(persistRootState, allow, deny);
              var stateToPersist = {};
              persistTargets.map(function (key) {
                var targetPath = [].concat(path, [key]);
                var rawValue = get(targetPath, nextState);
                var value = dist_isPlainObject(rawValue) ? clone(rawValue) : rawValue;
                stateToPersist[key] = value;
              });
              return Promise.resolve(storage.setItem(persistKey(path), stateToPersist));
            };
          })).finally(function () {
            isPersisting = false;
            if (nextPersistOperation) {
              var next = nextPersistOperation;
              nextPersistOperation = null;
              next();
            } else {
              resolve();
            }
          });
        });
      });
    };
    if (isPersisting) {
      nextPersistOperation = operation;
    } else {
      operation();
    }
  };
  return {
    persist: persist,
    clear: createPersistenceClearer(persistKey, _r),
    flush: function flush() {
      if (nextPersistOperation) {
        nextPersistOperation();
      }
      return persistPromise;
    }
  };
}
function createPersistMiddleware(persistor, _r) {
  return function (_ref3) {
    var getState = _ref3.getState;
    return function (next) {
      return function (action) {
        var state = next(action);
        if (action && action.type !== '@action.ePRS' && _r._i._persistenceConfig.length > 0) {
          persistor.persist(getState());
        }
        return state;
      };
    };
  };
}
function rehydrateStateFromPersistIfNeeded(persistKey, replaceState, _r, root) {
  if (_r._i._persistenceConfig.length === 0) {
    return Promise.resolve();
  }
  var state = clone(_r._i._dS);
  var rehydrating = false;
  return pSeries(_r._i._persistenceConfig.map(function (persistInstance) {
    return function () {
      var path = persistInstance.path,
        config = persistInstance.config;
      var mergeStrategy = config.mergeStrategy,
        storage = config.storage;
      if (root && (path.length < 1 || path[0] !== root)) {
        return Promise.resolve();
      }
      var hasDataModelChanged = function hasDataModelChanged(dataModel, rehydratingModelData) {
        return dataModel != null && rehydratingModelData != null && (typeof dataModel !== typeof rehydratingModelData || Array.isArray(dataModel) && !Array.isArray(rehydratingModelData));
      };
      var applyRehydrationStrategy = function applyRehydrationStrategy(persistedState) {
        if (mergeStrategy === 'overwrite') {
          set(path, state, persistedState);
        } else if (mergeStrategy === 'mergeShallow') {
          var targetState = get(path, state);
          Object.keys(persistedState).forEach(function (key) {
            if (hasDataModelChanged(targetState[key], persistedState[key])) ; else {
              targetState[key] = persistedState[key];
            }
          });
        } else if (mergeStrategy === 'mergeDeep') {
          var _targetState = get(path, state);
          var setAt = function setAt(currentTargetState, currentPersistedState) {
            Object.keys(currentPersistedState).forEach(function (key) {
              if (hasDataModelChanged(currentTargetState[key], currentPersistedState[key])) ; else if (dist_isPlainObject(currentPersistedState[key])) {
                currentTargetState[key] = currentTargetState[key] || {};
                setAt(currentTargetState[key], currentPersistedState[key]);
              } else {
                currentTargetState[key] = currentPersistedState[key];
              }
            });
          };
          setAt(_targetState, persistedState);
        }
      };
      var rehydate = function rehydate(persistedState) {
        if (persistedState != null) {
          applyRehydrationStrategy(persistedState);
          rehydrating = true;
        }
      };
      var getItemResult = storage.getItem(persistKey(path));
      if (isPromise(getItemResult)) {
        return getItemResult.then(rehydate);
      }
      return Promise.resolve(rehydate(getItemResult));
    };
  })).then(function () {
    if (rehydrating) {
      replaceState(state);
    }
  });
}

function createActionCreator(def, _r) {
  function actionCreator(payload) {
    var action = {
      type: def.meta.type,
      payload: payload,
      config: def.config
    };
    if (def[actionOnSymbol] && def.meta.resolvedTargets) {
      payload.resolvedTargets = [].concat(def.meta.resolvedTargets);
    }
    return _r.dispatch(action);
  }

  // We bind the types to the creator for easy reference by consumers
  actionCreator.type = def.meta.type;
  return actionCreator;
}

function createThunkHandler(def, _r, injections, _aC) {
  return function (payload, fail) {
    var helpers = {
      dispatch: _r.dispatch,
      fail: fail,
      getState: function getState() {
        return get(def.meta.parent, _r.getState());
      },
      getStoreActions: function getStoreActions() {
        return _aC;
      },
      getStoreState: _r.getState,
      injections: injections,
      meta: {
        key: def.meta.actionName,
        parent: def.meta.parent,
        path: def.meta.path
      }
    };
    if (def[thunkOnSymbol] && def.meta.resolvedTargets) {
      payload.resolvedTargets = [].concat(def.meta.resolvedTargets);
    }
    return def.fn(get(def.meta.parent, _aC), payload, helpers);
  };
}
function createThunkActionsCreator(def, _r) {
  var actionCreator = function actionCreator(payload) {
    var dispatchStart = handleEventDispatchErrors(def.meta.startType, function () {
      return _r.dispatch({
        type: def.meta.startType,
        payload: payload
      });
    });
    var dispatchFail = handleEventDispatchErrors(def.meta.failType, function (err) {
      return _r.dispatch({
        type: def.meta.failType,
        payload: payload,
        error: err
      });
    });
    var dispatchSuccess = handleEventDispatchErrors(def.meta.successType, function (result) {
      return _r.dispatch({
        type: def.meta.successType,
        payload: payload,
        result: result
      });
    });
    dispatchStart();
    var failure = null;
    var fail = function fail(_failure) {
      failure = _failure || new Error();
    };
    var result = _r.dispatch(function () {
      return def.thunkHandler(payload, fail);
    });
    if (isPromise(result)) {
      return result.then(function (resolved) {
        if (failure) {
          dispatchFail(failure);
        } else {
          dispatchSuccess(resolved);
        }
        return resolved;
      });
    }
    if (failure) {
      dispatchFail(failure);
    } else {
      dispatchSuccess(result);
    }
    return result;
  };
  actionCreator.type = def.meta.type;
  actionCreator.successType = def.meta.successType;
  actionCreator.failType = def.meta.failType;
  actionCreator.startType = def.meta.startType;
  return actionCreator;
}

function createListenerMiddleware(_r) {
  return function () {
    return function (next) {
      return function (action) {
        var result = next(action);
        if (action && _r._i._lAM[action.type] && _r._i._lAM[action.type].length > 0) {
          var sourceAction = _r._i._aCD[action.type];
          _r._i._lAM[action.type].forEach(function (actionCreator) {
            actionCreator({
              type: sourceAction ? sourceAction.def.meta.type : action.type,
              payload: action.payload,
              error: action.error,
              result: action.result
            });
          });
        }
        return result;
      };
    };
  };
}
function bindListenerdefs(listenerdefs, _aC, _aCD, _lAM) {
  listenerdefs.forEach(function (def) {
    var targets = def.targetResolver(get(def.meta.parent, _aC), _aC);
    var targetTypes = (Array.isArray(targets) ? targets : [targets]).reduce(function (acc, target) {
      if (typeof target === 'function' && target.def.meta.type && _aCD[target.def.meta.type]) {
        if (target.def.meta.successType) {
          acc.push(target.def.meta.successType);
        } else {
          acc.push(target.def.meta.type);
        }
      } else if (typeof target === 'string') {
        acc.push(target);
      }
      return acc;
    }, []);
    def.meta.resolvedTargets = targetTypes;
    targetTypes.forEach(function (targetType) {
      var listenerReg = _lAM[targetType] || [];
      listenerReg.push(_aCD[def.meta.type]);
      _lAM[targetType] = listenerReg;
    });
  });
}

function createComputedPropertyBinder(key, def, _r) {
  var hasRunOnce = false;
  var prevInputs = [];
  var prevValue;
  var prevStoreState;
  var performingEqualityCheck = false;
  var areEqual = function areEqual(a, b) {
    performingEqualityCheck = true;
    var result = es6_default()(a, b);
    performingEqualityCheck = false;
    return result;
  };
  return function createComputedProperty(parentState, storeState) {
    Object.defineProperty(parentState, key, {
      configurable: true,
      enumerable: true,
      get: function get() {
        if (performingEqualityCheck) {
          return prevValue;
        }
        var inputs = def.stateResolvers.map(function (resolver) {
          return resolver(parentState, storeState);
        });
        if (hasRunOnce && (storeState === prevStoreState && areInputsEqual(inputs, prevInputs) ||
        // We don't want computed properties resolved every time an action
        // is handled by the reducer. They need to remain lazy, only being
        // computed when used by a component or getState call;
        _r._i._cS.isInReducer &&
        // This is to account for strange errors that may occur via immer;
        new Error().stack.match(/shallowCopy/gi) !== null)) {
          return prevValue;
        }
        var newValue = def.fn.apply(def, inputs);
        if (!areEqual(newValue, prevValue)) {
          prevValue = newValue;
        }
        prevInputs = inputs;
        prevStoreState = storeState;
        hasRunOnce = true;
        return prevValue;
      }
    });
  };
}
function createComputedPropertiesMiddleware(_r) {
  return function () {
    return function (next) {
      return function (action) {
        _r._i._cS.isInReducer = true;
        var result = next(action);
        _r._i._cS.isInReducer = false;
        return result;
      };
    };
  };
}

function createEffectsMiddleware(_r) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (_r._i._e.length === 0) {
          return next(action);
        }
        var prevState = store.getState();
        var result = next(action);
        var nextState = store.getState();
        if (prevState !== nextState) {
          _r._i._e.forEach(function (def) {
            var prevLocal = get(def.meta.parent, prevState);
            var nextLocal = get(def.meta.parent, nextState);
            var prevDependencies = def.dependencyResolvers.map(function (resolver) {
              return resolver(prevLocal, prevState);
            });
            var nextDependencies = def.dependencyResolvers.map(function (resolver) {
              return resolver(nextLocal, nextState);
            });
            var hasChanged = prevDependencies.some(function (dependency, idx) {
              return dependency !== nextDependencies[idx];
            });
            if (hasChanged) {
              def.actionCreator(prevDependencies, nextDependencies, action);
            }
          });
        }
        return result;
      };
    };
  };
}
var logEffectError = function logEffectError(err) {
  // As users can't get a handle on effects we need to report the error
  // eslint-disable-next-line no-console
  console.error(err);
};
function createEffectHandler(def, _r, injections, _aC) {
  var dispose;
  return function (change) {
    var helpers = {
      dispatch: _r.dispatch,
      getState: function getState() {
        return get(def.meta.parent, _r.getState());
      },
      getStoreActions: function getStoreActions() {
        return _aC;
      },
      getStoreState: _r.getState,
      injections: injections,
      meta: {
        key: def.meta.actionName,
        parent: def.meta.parent,
        path: def.meta.path
      }
    };
    if (dispose !== undefined) {
      var disposeResult = dispose();
      dispose = undefined;
      if (isPromise(disposeResult)) {
        disposeResult.catch(logEffectError);
      }
    }
    var actions = get(def.meta.parent, _aC);
    var effectResult = def.fn(actions, change, helpers);
    if (isPromise(effectResult)) {
      return effectResult.then(function (resolved) {
        if (typeof resolved === 'function') {
          if (false) {}
        }
      });
    }
    if (typeof effectResult === 'function') {
      dispose = effectResult;
    }
    return undefined;
  };
}
function createEffectActionsCreator(def, _r, effectHandler) {
  var actionCreator = function actionCreator(previousDependencies, nextDependencies, action) {
    var change = {
      prev: previousDependencies,
      current: nextDependencies,
      action: action
    };
    var dispatchStart = handleEventDispatchErrors(def.meta.startType, function () {
      return _r.dispatch({
        type: def.meta.startType,
        change: change
      });
    });
    var dispatchSuccess = handleEventDispatchErrors(def.meta.successType, function () {
      return _r.dispatch({
        type: def.meta.successType,
        change: change
      });
    });
    dispatchStart();
    try {
      var result = _r.dispatch(function () {
        return effectHandler(change);
      });
      if (isPromise(result)) {
        return result.then(function (resolved) {
          dispatchSuccess(resolved);
          return resolved;
        }, logEffectError);
      }
      dispatchSuccess(result);
      return result;
    } catch (err) {
      logEffectError(err);
    }
    return undefined;
  };
  actionCreator.type = def.meta.type;
  actionCreator.startType = def.meta.startType;
  actionCreator.successType = def.meta.successType;
  actionCreator.failType = def.meta.failType;
  return actionCreator;
}

function extractDataFromModel(model, initialState, injections, _r) {
  var _dS = initialState;
  var _aCD = {};
  var _aC = {};
  var _aRD = {};
  var _cP = [];
  var _cR = [];
  var _e = [];
  var _lAC = {};
  var _lAM = {};
  var listenerdefs = [];
  var _persistenceConfig = [];
  var _cS = {
    isInReducer: false
  };
  var recursiveExtractFromModel = function recursiveExtractFromModel(current, parentPath) {
    return Object.keys(current).forEach(function (key) {
      var value = current[key];
      var path = [].concat(parentPath, [key]);
      var meta = {
        parent: parentPath,
        path: path,
        key: key
      };
      var handleValueAsState = function handleValueAsState() {
        var initialParentRef = get(parentPath, initialState);
        if (initialParentRef && key in initialParentRef) {
          set(path, _dS, initialParentRef[key]);
        } else {
          set(path, _dS, value);
        }
      };
      if (key === persistSymbol) {
        _persistenceConfig.push(extractPersistConfig(parentPath, value));
        return;
      }
      if (value != null && typeof value === 'object') {
        if (value[actionSymbol] || value[actionOnSymbol]) {
          var def = (0,objectSpread2/* default */.Z)({}, value);

          // Determine the category of the action
          var category = def[actionSymbol] ? '@action' : '@actionOn';

          // Establish the meta data describing the action
          def.meta = {
            actionName: meta.key,
            category: category,
            type: category + "." + meta.path.join('.'),
            parent: meta.parent,
            path: meta.path
          };

          // Create the "action creator" function
          def.actionCreator = createActionCreator(def, _r);

          // Create a bidirectional relationship of the def/actionCreator
          def.actionCreator.def = def;

          // Create a bidirectional relationship of the def/reducer
          def.fn.def = def;

          // Add the action creator to lookup map
          _aCD[def.meta.type] = def.actionCreator;

          // Add the reducer to lookup map
          _aRD[def.meta.type] = def.fn;

          // We don't want to expose the internal action to consumers
          if (meta.key !== 'ePRS') {
            // Set the action creator in the "actions" object tree for
            // either the listeners object tree, or the standard actions/thunks
            // object tree
            if (def[actionOnSymbol]) {
              listenerdefs.push(def);
              set(path, _lAC, def.actionCreator);
            } else {
              set(path, _aC, def.actionCreator);
            }
          }
        } else if (value[thunkSymbol] || value[thunkOnSymbol]) {
          var _def = (0,objectSpread2/* default */.Z)({}, value);

          // Determine the category of the thunk
          var _category = _def[thunkSymbol] ? '@thunk' : '@thunkOn';

          // Establish the meta data describing the thunk
          var type = _category + "." + meta.path.join('.');
          _def.meta = {
            actionName: meta.key,
            parent: meta.parent,
            path: meta.path,
            type: type,
            startType: type + "(start)",
            successType: type + "(success)",
            failType: type + "(fail)"
          };

          // Create the function that will handle, i.e. be executed, when
          // the thunk action is created/dispatched
          _def.thunkHandler = createThunkHandler(_def, _r, injections, _aC);

          // Create the "action creator" function
          _def.actionCreator = createThunkActionsCreator(_def, _r);

          // Create a bidirectional relationship of the def/actionCreator
          _def.actionCreator.def = _def;

          // Register the action creator within the lookup map
          _aCD[_def.meta.type] = _def.actionCreator;

          // Set the action creator in the "actions" object tree for
          // either the listeners object tree, or the standard actions/thunks
          // object tree
          if (_def[thunkOnSymbol]) {
            listenerdefs.push(_def);
            set(path, _lAC, _def.actionCreator);
          } else {
            set(path, _aC, _def.actionCreator);
          }
        } else if (value[computedSymbol]) {
          var parent = get(parentPath, _dS);
          var bindComputedProperty = createComputedPropertyBinder(key, value, _r);
          bindComputedProperty(parent, _dS);
          _cP.push({
            key: key,
            parentPath: parentPath,
            bindComputedProperty: bindComputedProperty
          });
        } else if (value[reducerSymbol]) {
          _cR.push({
            key: key,
            parentPath: parentPath,
            reducer: value.fn,
            config: value.config
          });
        } else if (value[effectOnSymbol]) {
          var _def2 = (0,objectSpread2/* default */.Z)({}, value);

          // Establish the meta data describing the effect
          var _type = "@effectOn." + meta.path.join('.');
          _def2.meta = {
            type: _type,
            actionName: meta.key,
            parent: meta.parent,
            path: meta.path,
            startType: _type + "(start)",
            successType: _type + "(success)",
            failType: _type + "(fail)"
          };
          var effectHandler = createEffectHandler(_def2, _r, injections, _aC);
          var actionCreator = createEffectActionsCreator(_def2, _r, effectHandler);
          _def2.actionCreator = actionCreator;
          _e.push(_def2);
        } else if (dist_isPlainObject(value)) {
          var existing = get(path, _dS);
          if (existing == null) {
            set(path, _dS, {});
          }
          recursiveExtractFromModel(value, path);
        } else {
          handleValueAsState();
        }
      } else {
        handleValueAsState();
      }
    });
  };
  _persistenceConfig = _persistenceConfig.sort(function (a, b) {
    var aPath = a.path.join('.');
    var bPath = b.path.join('.');
    if (aPath < bPath) {
      return -1;
    }
    if (aPath > bPath) {
      return 1;
    }
    return 0;
  });
  recursiveExtractFromModel(model, []);
  bindListenerdefs(listenerdefs, _aC, _aCD, _lAM);
  return {
    _aCD: _aCD,
    _aC: _aC,
    _aRD: _aRD,
    _cP: _cP,
    _cR: _cR,
    _cS: _cS,
    _dS: _dS,
    _e: _e,
    _lAC: _lAC,
    _lAM: _lAM,
    _persistenceConfig: _persistenceConfig
  };
}

function dist_createStore(model, options) {
  if (options === void 0) {
    options = {};
  }
  var modelClone = clone(model);
  var _options = options,
    compose$1 = _options.compose,
    _options$devTools = _options.devTools,
    devTools = _options$devTools === void 0 ? "production" !== 'production' : _options$devTools,
    _options$disableImmer = _options.disableImmer,
    disableImmer = _options$disableImmer === void 0 ? false : _options$disableImmer,
    _options$enhancers = _options.enhancers,
    enhancers = _options$enhancers === void 0 ? [] : _options$enhancers,
    _options$initialState = _options.initialState,
    initialState = _options$initialState === void 0 ? undefined : _options$initialState,
    _options$injections = _options.injections,
    injections = _options$injections === void 0 ? {} : _options$injections,
    _options$middleware = _options.middleware,
    middleware = _options$middleware === void 0 ? [] : _options$middleware,
    _options$mockActions = _options.mockActions,
    mockActions = _options$mockActions === void 0 ? false : _options$mockActions,
    _options$name = _options.name,
    storeName = _options$name === void 0 ? "EasyPeasyStore" : _options$name,
    _options$version = _options.version,
    version = _options$version === void 0 ? 0 : _options$version,
    _options$reducerEnhan = _options.reducerEnhancer,
    reducerEnhancer = _options$reducerEnhan === void 0 ? function (rootReducer) {
      return rootReducer;
    } : _options$reducerEnhan;
  var bindReplaceState = function bindReplaceState(modelDef) {
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, modelDef), {}, {
      ePRS: action(function (_, payload) {
        return payload;
      })
    });
  };
  var _r = {};
  var modeldef = bindReplaceState(modelClone);
  var mockedActions = [];
  var persistKey = function persistKey(targetPath) {
    return "[" + storeName + "][" + version + "]" + (targetPath.length > 0 ? "[" + targetPath.join('.') + "]" : '');
  };
  var persistor = createPersistor(persistKey, _r);
  var persistMiddleware = createPersistMiddleware(persistor, _r);
  var replaceState = function replaceState(nextState) {
    return _r._i._aCD['@action.ePRS'](nextState);
  };
  var bindStoreInternals = function bindStoreInternals(state) {
    if (state === void 0) {
      state = {};
    }
    var data = extractDataFromModel(modeldef, state, injections, _r);
    _r._i = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, data), {}, {
      reducer: reducerEnhancer(createReducer(disableImmer, data._aRD, data._cR, data._cP))
    });
  };
  var mockActionsMiddleware = function mockActionsMiddleware() {
    return function () {
      return function (action) {
        if (action != null) {
          mockedActions.push(action);
        }
        return undefined;
      };
    };
  };
  var devToolConfig = devTools === true ? {} : devTools;
  var composeEnhancers = compose$1 || (devTools && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__((0,objectSpread2/* default */.Z)({
    name: storeName
  }, devToolConfig)) : compose);
  bindStoreInternals(initialState || {});
  var easyPeasyMiddleware = [createComputedPropertiesMiddleware(_r)].concat(middleware, [es, createListenerMiddleware(_r), createEffectsMiddleware(_r), persistMiddleware]);
  if (mockActions) {
    easyPeasyMiddleware.push(mockActionsMiddleware);
  }
  var store = createStore(_r._i.reducer, _r._i._dS, composeEnhancers.apply(void 0, [applyMiddleware.apply(void 0, easyPeasyMiddleware)].concat(enhancers)));
  store.subscribe(function () {
    _r._i._cS.isInReducer = false;
  });
  _r.dispatch = store.dispatch;
  _r.getState = store.getState;
  var bindActionCreators = function bindActionCreators() {
    Object.keys(store.dispatch).forEach(function (actionsKey) {
      delete store.dispatch[actionsKey];
    });
    Object.keys(_r._i._aC).forEach(function (key) {
      store.dispatch[key] = _r._i._aC[key];
    });
  };
  bindActionCreators();
  var rebindStore = function rebindStore(removeKey) {
    var currentState = store.getState();
    if (removeKey) {
      delete currentState[removeKey];
    }
    bindStoreInternals(currentState);
    store.replaceReducer(_r._i.reducer);
    replaceState(_r._i._dS);
    bindActionCreators();
  };
  var _resolveRehydration = rehydrateStateFromPersistIfNeeded(persistKey, replaceState, _r);
  return Object.assign(store, {
    addModel: function addModel(key, modelForKey) {
      if (modeldef[key] && "production" !== 'production') {}
      modeldef[key] = modelForKey;
      rebindStore();
      // There may have been persisted state for a dynamic model. We should try
      // and rehydrate the specifc node
      var addModelRehydration = rehydrateStateFromPersistIfNeeded(persistKey, replaceState, _r, key);
      return {
        resolveRehydration: function resolveRehydration() {
          return addModelRehydration;
        }
      };
    },
    clearMockedActions: function clearMockedActions() {
      mockedActions = [];
    },
    getActions: function getActions() {
      return _r._i._aC;
    },
    getListeners: function getListeners() {
      return _r._i._lAC;
    },
    getMockedActions: function getMockedActions() {
      return [].concat(mockedActions);
    },
    persist: {
      clear: persistor.clear,
      flush: persistor.flush,
      resolveRehydration: function resolveRehydration() {
        return _resolveRehydration;
      }
    },
    reconfigure: function reconfigure(newModel) {
      modeldef = bindReplaceState(newModel);
      rebindStore();
    },
    removeModel: function removeModel(key) {
      if (!modeldef[key]) {
        return;
      }
      delete modeldef[key];
      rebindStore(key);
    }
  });
}

function createContextStore(model, config) {
  if (config === void 0) {
    config = {};
  }
  // We create a mutable injections reference to allow updating it
  var _config = config,
    _config$injections = _config.injections,
    mutableInjections = _config$injections === void 0 ? {} : _config$injections;
  var StoreContext = createContext();
  function Provider(_ref) {
    var children = _ref.children,
      runtimeModel = _ref.runtimeModel,
      injections = _ref.injections;
    // If the user provided injections we need to ensure our mutable ref
    // is up to date. We could consider doing a shallow compare here?
    if (injections != null) {
      var nextInjections = typeof injections === 'function' ? injections(mutableInjections) : injections;
      var nextKeys = Object.keys(nextInjections);
      var removeKeys = Object.keys(mutableInjections).filter(function (k) {
        return !nextKeys.includes(k);
      });
      removeKeys.forEach(function (k) {
        delete mutableInjections[k];
      });
      Object.assign(mutableInjections, nextInjections);
    }
    var store = useMemoOne(function () {
      return dist_createStore(typeof model === 'function' ? model(runtimeModel) : model, _objectSpread(_objectSpread({}, config), {}, {
        originalInjections: mutableInjections
      }));
    }, []);
    return /*#__PURE__*/React.createElement(StoreContext.Provider, {
      value: store
    }, children);
  }
  function useStore() {
    return useContext(StoreContext);
  }
  return {
    Provider: Provider,
    useStore: useStore,
    useStoreState: createStoreStateHook(StoreContext),
    useStoreActions: createStoreActionsHook(StoreContext),
    useStoreDispatch: createStoreDispatchHook(StoreContext),
    useStoreRehydrated: createStoreRehydratedHook(StoreContext)
  };
}

/**
 * This file has been copied from redux-persist.
 * The intention being to support as much of the redux-persist API as possible.
 */

function createTransform(inbound, outbound, config) {
  if (config === void 0) {
    config = {};
  }
  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;
  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }
  return {
    in: function _in(data, key, fullState) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(data, key, fullState) : data;
    },
    out: function out(data, key, fullState) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(data, key, fullState) : data;
    }
  };
}

/* eslint-disable react/prop-types */
function StoreProvider(_ref) {
  var children = _ref.children,
    store = _ref.store;
  return /*#__PURE__*/react.createElement(StoreContext.Provider, {
    value: store
  }, children);
}

function useLocalStore(modelCreator, dependencies, configCreator) {
  if (dependencies === void 0) {
    dependencies = [];
  }
  if (configCreator === void 0) {
    configCreator = null;
  }
  var storeRef = useRef();
  var configRef = useRef();
  var store = useMemoOne(function () {
    var previousState = storeRef.current != null ? storeRef.current.getState() : undefined;
    var config = configCreator != null ? configCreator(previousState, configRef.current) : undefined;
    var _store = dist_createStore(modelCreator(previousState), config);
    configRef.current = config;
    storeRef.current = _store;
    return _store;
  }, dependencies);
  var _useState = useState(function () {
      return store.getState();
    }),
    currentState = _useState[0],
    setCurrentState = _useState[1];
  useEffect(function () {
    setCurrentState(store.getState());
    return store.subscribe(function () {
      var nextState = store.getState();
      if (currentState !== nextState) {
        setCurrentState(nextState);
      }
    });
  }, [store]);
  return [currentState, store.getActions(), store];
}

// React 18 requires the use of the useSyncExternalStore hook for external
initializeUseStoreState(with_selector.useSyncExternalStoreWithSelector);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 98364:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var React = __webpack_require__(67294);
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useState = React.useState,
  useEffect = React.useEffect,
  useLayoutEffect = React.useLayoutEffect,
  useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
  var value = getSnapshot(),
    _useState = useState({ inst: { value: value, getSnapshot: getSnapshot } }),
    inst = _useState[0].inst,
    forceUpdate = _useState[1];
  useLayoutEffect(
    function () {
      inst.value = value;
      inst.getSnapshot = getSnapshot;
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
    },
    [subscribe, value, getSnapshot]
  );
  useEffect(
    function () {
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      return subscribe(function () {
        checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      });
    },
    [subscribe]
  );
  useDebugValue(value);
  return value;
}
function checkIfSnapshotChanged(inst) {
  var latestGetSnapshot = inst.getSnapshot;
  inst = inst.value;
  try {
    var nextValue = latestGetSnapshot();
    return !objectIs(inst, nextValue);
  } catch (error) {
    return !0;
  }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
  return getSnapshot();
}
var shim =
  "undefined" === typeof window ||
  "undefined" === typeof window.document ||
  "undefined" === typeof window.document.createElement
    ? useSyncExternalStore$1
    : useSyncExternalStore$2;
exports.useSyncExternalStore =
  void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;


/***/ }),

/***/ 50968:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var React = __webpack_require__(67294),
  shim = __webpack_require__(99378);
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useSyncExternalStore = shim.useSyncExternalStore,
  useRef = React.useRef,
  useEffect = React.useEffect,
  useMemo = React.useMemo,
  useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function (
  subscribe,
  getSnapshot,
  getServerSnapshot,
  selector,
  isEqual
) {
  var instRef = useRef(null);
  if (null === instRef.current) {
    var inst = { hasValue: !1, value: null };
    instRef.current = inst;
  } else inst = instRef.current;
  instRef = useMemo(
    function () {
      function memoizedSelector(nextSnapshot) {
        if (!hasMemo) {
          hasMemo = !0;
          memoizedSnapshot = nextSnapshot;
          nextSnapshot = selector(nextSnapshot);
          if (void 0 !== isEqual && inst.hasValue) {
            var currentSelection = inst.value;
            if (isEqual(currentSelection, nextSnapshot))
              return (memoizedSelection = currentSelection);
          }
          return (memoizedSelection = nextSnapshot);
        }
        currentSelection = memoizedSelection;
        if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
        var nextSelection = selector(nextSnapshot);
        if (void 0 !== isEqual && isEqual(currentSelection, nextSelection))
          return (memoizedSnapshot = nextSnapshot), currentSelection;
        memoizedSnapshot = nextSnapshot;
        return (memoizedSelection = nextSelection);
      }
      var hasMemo = !1,
        memoizedSnapshot,
        memoizedSelection,
        maybeGetServerSnapshot =
          void 0 === getServerSnapshot ? null : getServerSnapshot;
      return [
        function () {
          return memoizedSelector(getSnapshot());
        },
        null === maybeGetServerSnapshot
          ? void 0
          : function () {
              return memoizedSelector(maybeGetServerSnapshot());
            }
      ];
    },
    [getSnapshot, getServerSnapshot, selector, isEqual]
  );
  var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
  useEffect(
    function () {
      inst.hasValue = !0;
      inst.value = value;
    },
    [value]
  );
  useDebugValue(value);
  return value;
};


/***/ }),

/***/ 99378:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(98364);
} else {}


/***/ }),

/***/ 19509:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(50968);
} else {}


/***/ }),

/***/ 24429:
/***/ ((module) => {

"use strict";


/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),

/***/ 53981:
/***/ ((module) => {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),

/***/ 81648:
/***/ ((module) => {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),

/***/ 24726:
/***/ ((module) => {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),

/***/ 26712:
/***/ ((module) => {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),

/***/ 33464:
/***/ ((module) => {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),

/***/ 14453:
/***/ ((module) => {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),

/***/ 43915:
/***/ ((module) => {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),

/***/ 68892:
/***/ ((module) => {

"use strict";


/** @type {import('.')} */
module.exports = Object;


/***/ }),

/***/ 17187:
/***/ ((module) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),

/***/ 62991:
/***/ ((module) => {

"use strict";


// do not edit .js files directly - edit src/index.jst


  var envHasBigInt64Array = typeof BigInt64Array !== 'undefined';


module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }


    if ((a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      for (i of a.entries())
        if (!equal(i[1], b.get(i[0]))) return false;
      return true;
    }

    if ((a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      return true;
    }

    if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }


    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 17648:
/***/ ((module) => {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 58612:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var implementation = __webpack_require__(17648);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 40210:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var undefined;

var $Object = __webpack_require__(68892);

var $Error = __webpack_require__(81648);
var $EvalError = __webpack_require__(53981);
var $RangeError = __webpack_require__(24726);
var $ReferenceError = __webpack_require__(26712);
var $SyntaxError = __webpack_require__(33464);
var $TypeError = __webpack_require__(14453);
var $URIError = __webpack_require__(43915);

var abs = __webpack_require__(59738);
var floor = __webpack_require__(76329);
var max = __webpack_require__(52264);
var min = __webpack_require__(55730);
var pow = __webpack_require__(20707);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__(27296);
var $defineProperty = __webpack_require__(24429);

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(41405)();
var getDunderProto = __webpack_require__(96504);

var getProto = (typeof Reflect === 'function' && Reflect.getPrototypeOf)
	|| $Object.getPrototypeOf
	|| getDunderProto;

var $apply = __webpack_require__(1768);
var $call = __webpack_require__(68928);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(58612);
var hasOwn = __webpack_require__(48824);
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 40690:
/***/ ((module) => {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ }),

/***/ 27296:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(40690);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 41405:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(55419);

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 55419:
/***/ ((module) => {

"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 48824:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(58612);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),

/***/ 80645:
/***/ ((__unused_webpack_module, exports) => {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 96486:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 59738:
/***/ ((module) => {

"use strict";


/** @type {import('./abs')} */
module.exports = Math.abs;


/***/ }),

/***/ 76329:
/***/ ((module) => {

"use strict";


/** @type {import('./abs')} */
module.exports = Math.floor;


/***/ }),

/***/ 52264:
/***/ ((module) => {

"use strict";


/** @type {import('./max')} */
module.exports = Math.max;


/***/ }),

/***/ 55730:
/***/ ((module) => {

"use strict";


/** @type {import('./min')} */
module.exports = Math.min;


/***/ }),

/***/ 20707:
/***/ ((module) => {

"use strict";


/** @type {import('./pow')} */
module.exports = Math.pow;


/***/ }),

/***/ 6840:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(99956);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13001:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/svip_badage.fa062dc7.png","height":32,"width":60,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAj0lEQVR4nAGEAHv/Ab/93FMCAgKaAgACEvz9/P/7+wYA/v8SAfn2CO7/9wJmAcb/4vPc2NYM3dHa/wYKFAEGCxsA29PX/ysjNQEvIzLzAcL/5PLh2eQNzcLY/wwNEwEaFSIA17y+/zctQgEmIir0AbP16VP++w6aAfoIEgLv/v8I9AAACfoCAQH5AO78+/9mEcZAwZw5emwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});

/***/ }),

/***/ 51149:
/***/ ((module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(31032)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(12845)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(13353));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 36956:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(12845)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 13353:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(31032)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(12845)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadableContext = __webpack_require__(36956);
const { useSyncExternalStore  } =  true ? __webpack_require__(67294) : 0;
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 56105:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * 全局接口 code 状态码定义
 */ const CODE = {
    /** 成功 */ OK: 0,
    /** 用户端-未登录 */ UNAUTHORIZED: [
        401
    ]
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CODE);


/***/ }),

/***/ 78264:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AJ": () => (/* binding */ getAppKey),
/* harmony export */   "Cu": () => (/* binding */ getIntranetHost),
/* harmony export */   "Em": () => (/* binding */ getWsHostname),
/* harmony export */   "OG": () => (/* binding */ getPrePageFix),
/* harmony export */   "R": () => (/* binding */ TITLE),
/* harmony export */   "SR": () => (/* binding */ WORKBENCH_DESCRIPTION),
/* harmony export */   "X6": () => (/* binding */ getPreFix),
/* harmony export */   "Z8": () => (/* binding */ WORKBENCH_KEYWORDS),
/* harmony export */   "ce": () => (/* binding */ MODULE_ID),
/* harmony export */   "cr": () => (/* binding */ MATRIX_CHANNEL),
/* harmony export */   "e3": () => (/* binding */ HOME_KEYWORDS),
/* harmony export */   "hg": () => (/* binding */ getPPTUrl),
/* harmony export */   "i4": () => (/* binding */ PREVIEW_MODE),
/* harmony export */   "jN": () => (/* binding */ HOME_DESCRIPTION),
/* harmony export */   "kU": () => (/* binding */ getClientID),
/* harmony export */   "vX": () => (/* binding */ SCENE),
/* harmony export */   "y$": () => (/* binding */ getDesignHome)
/* harmony export */ });
/* unused harmony exports CLIENT_ID, getApiHostForWeb */
/* harmony import */ var _utils_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20695);
/* harmony import */ var _meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99861);


const MODULE_ID = "hbsj";
const SCENE = "aippt";
const CLIENT_ID = "1189857523";
const getClientID = ()=>{
    const query = (0,_utils_query__WEBPACK_IMPORTED_MODULE_1__/* .getQuery */ .pm)();
    return (query === null || query === void 0 ? void 0 : query.clientId) || CLIENT_ID;
};
const getAppKey = (oid)=>{
    const identity = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .getLocalIdentity */ .u5)();
    if (oid !== null && oid !== void 0 ? oid : identity === null || identity === void 0 ? void 0 : identity.oid) {
        return  true ? "3EDDE044EAA4A219" : 0;
    }
    return  true ? "C5F34252F04B6D50" : 0;
};
// 1 为(预发布+正式),0 或者不传 为正式模式
const PREVIEW_MODE =  true ? 0 : 0;
const MATRIX_CHANNEL = "mtsjs_web";
const getPreFix = ()=>{
    let preFix = "release";
    if (preFix === "release") {
        preFix = "";
    }
    return preFix;
};
const getPrePageFix = ()=>{
    let preFix = "release";
    if (preFix === "release") {
        preFix = "www";
    }
    return preFix;
};
const getPPTUrl = ()=>{
    return "https://".concat(getPrePageFix(), ".designkit.cn/ppt");
};
const getApiHostForWeb = ()=>{
    return "https://".concat(getPreFix(), "webapi.designkit.cn");
};
// api内网域名
const getIntranetHost = ()=>{
    // 开发环境继续走公网
    if (true) {
        return getApiHostForWeb();
    }
    return "http://".concat(getPreFix(), "webapi-pc.m.com");
};
const getWsHostname = ()=>{
    let preFix = "release";
    return preFix === "pre" ? "wss://prewebsocket-design.meitu.com" : preFix === "beta" ? "wss://betawebsocket-design.meitu.com" : "wss://websocket-design.meitu.com";
};
const getDesignHome = ()=>{
    if (false) {}
    let preFix = "release";
    if (preFix === "release") {
        preFix = "www";
    }
    return "https://".concat(preFix, ".designkit.cn");
};
const TITLE = "美图设计室LivePPT";
const WORKBENCH_DESCRIPTION = "美图设计室AI PPT是一款AI智能化生成演示内容的在线工具,只需输入一句话,即可实现AI生成高质量PPT.借助强大的 AI 技术,轻松实现ai生成ppt、ai合成ppt、ai制作ppt、一键生成ppt,美图ai ppt工具让你轻松打造精美的PPT,支持一键智能排版/配色,以及丰富的模板和素材库。";
const WORKBENCH_KEYWORDS = "ai 生成 ppt,ai 合成 ppt,ai 制作 ppt,一键生成 ppt 的 ai,美图 ai ppt";
const HOME_DESCRIPTION = "美图设计室AI PPT是一款AI智能化生成演示内容的在线工具,只需输入一句话,即可实现AI生成高质量PPT.借助强大的 AI 技术,轻松实现ai生成ppt、ai合成ppt、ai制作ppt、一键生成ppt,美图ai ppt工具让你轻松打造精美的PPT,支持一键智能排版/配色,以及丰富的模板和素材库。";
const HOME_KEYWORDS = "ai 生成 ppt,ai 合成 ppt,ai 制作 ppt,一键生成 ppt 的 ai,美图 ai ppt";


/***/ }),

/***/ 99697:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$i": () => (/* binding */ UPLOAD_FILE_MEMBER_FORMAT),
/* harmony export */   "$p": () => (/* binding */ FOOTER_TABS),
/* harmony export */   "AI": () => (/* binding */ MTCCDataScene),
/* harmony export */   "G7": () => (/* binding */ TABS),
/* harmony export */   "H1": () => (/* binding */ generateMap),
/* harmony export */   "HZ": () => (/* binding */ FILE_TEXT_MAX_LEN),
/* harmony export */   "M4": () => (/* binding */ FooterTabKey),
/* harmony export */   "Mh": () => (/* binding */ lenMap),
/* harmony export */   "NG": () => (/* binding */ MIN_PAGE_COUNT),
/* harmony export */   "Ph": () => (/* binding */ MAX_PAGE_COUNT),
/* harmony export */   "Rc": () => (/* binding */ TabKey),
/* harmony export */   "WU": () => (/* binding */ StepType),
/* harmony export */   "aR": () => (/* binding */ RICH_TEXT_MAX_LEN),
/* harmony export */   "gA": () => (/* binding */ MTCCData),
/* harmony export */   "gV": () => (/* binding */ SDK_PLATFORM),
/* harmony export */   "pR": () => (/* binding */ BTN_UUID),
/* harmony export */   "pZ": () => (/* binding */ TRACK_MAP),
/* harmony export */   "pf": () => (/* binding */ MESSAGE_KEY),
/* harmony export */   "re": () => (/* binding */ PPTProcessStatus),
/* harmony export */   "sB": () => (/* binding */ SdkModuleName),
/* harmony export */   "xs": () => (/* binding */ Scene)
/* harmony export */ });
/* unused harmony exports DownloadImgType, DOWNLOAD_SELECT, TIP_TEXT */
/* harmony import */ var _assets_images_svip_badage_png__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13001);

var DownloadImgType;
(function(DownloadImgType) {
    DownloadImgType["jpg"] = "jpg";
    DownloadImgType["png"] = "png";
    DownloadImgType["ppt"] = "ppt";
    DownloadImgType["pdf"] = "pdf";
})(DownloadImgType || (DownloadImgType = {}));
const RICH_TEXT_MAX_LEN = 20000;
const BTN_UUID = "create_ppt_submit";
const FILE_TEXT_MAX_LEN = 30000;
var StepType;
(function(StepType) {
    StepType[StepType[/**
   * 前置输入，一句话，导入文件，粘贴文本
   */ "write"] = 0] = "write";
    StepType[StepType[/**
   * 生成大纲
   */ "outline"] = 1] = "outline";
    StepType[StepType[/**
   * 生成PPT
   */ "ppt"] = 2] = "ppt";
    StepType[StepType[/**
   * 选择模板
   */ "template"] = 3] = "template";
    StepType[StepType[/**
   * 分段分页
   */ "page"] = 4] = "page";
})(StepType || (StepType = {}));
var TabKey;
(function(TabKey) {
    TabKey["inAWord"] = "0";
    TabKey["pasteText"] = "1";
    TabKey["importFile"] = "2";
})(TabKey || (TabKey = {}));
const lenMap = {
    short: "1",
    medium: "2",
    long: "3"
};
const generateMap = {
    retain: "2",
    simplify: "1",
    expand: "3"
};
const TABS = [
    {
        key: TabKey.inAWord,
        icon: "MagicWandBold",
        title: "一句话生成"
    },
    {
        key: TabKey.pasteText,
        icon: "TextSquareBold",
        title: "已有文本生成"
    },
    {
        key: TabKey.importFile,
        icon: "UploadFlowBold",
        title: "导入文件生成",
        tag: _assets_images_svip_badage_png__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z
    }
];
var FooterTabKey;
(function(FooterTabKey) {
    FooterTabKey["record"] = "0";
    FooterTabKey["template"] = "1";
})(FooterTabKey || (FooterTabKey = {}));
const FOOTER_TABS = [
    {
        key: FooterTabKey.record,
        title: "历史记录",
        forceLogin: true
    },
    {
        key: FooterTabKey.template,
        title: "PPT模板"
    }
];
const TRACK_MAP = {
    [TabKey.inAWord]: "one_sentence_subject",
    [TabKey.pasteText]: "text_subject",
    [TabKey.importFile]: "upload_file"
};
const DOWNLOAD_SELECT = [
    {
        type: DownloadImgType.jpg,
        title: "JPG",
        message: "文件较小，不支持透明背景"
    },
    {
        type: DownloadImgType.png,
        title: "PNG",
        message: "无损图片，文件较大，不支持透明背景"
    },
    {
        type: DownloadImgType.ppt,
        title: "PPT",
        message: "文件较大，可编辑"
    },
    {
        type: DownloadImgType.pdf,
        title: "PDF",
        message: "比 PPT 文件大，不可编辑"
    }
];
var PPTProcessStatus;
(function(PPTProcessStatus) {
    PPTProcessStatus[PPTProcessStatus[// 不存在该记录
    "noExist"] = 0] = "noExist";
    PPTProcessStatus[PPTProcessStatus[// 投递成功待处理
    "pending"] = 1] = "pending";
    PPTProcessStatus[PPTProcessStatus[// 处理进行中
    "processing"] = 10] = "processing";
    PPTProcessStatus[PPTProcessStatus[// 处理失败
    "fail"] = 20] = "fail";
    PPTProcessStatus[PPTProcessStatus[// 处理成功
    "success"] = 30] = "success";
})(PPTProcessStatus || (PPTProcessStatus = {}));
const MESSAGE_KEY = "MESSAGE_KEY";
const MAX_PAGE_COUNT = 30;
const MIN_PAGE_COUNT = 1;
var SdkModuleName;
(function(SdkModuleName) {
    SdkModuleName["aippt"] = "aippt-sdk";
})(SdkModuleName || (SdkModuleName = {}));
var Scene;
(function(Scene) {
    Scene["AiPPT"] = "aippt";
})(Scene || (Scene = {}));
const SDK_PLATFORM = {
    "221": "roboneo"
};
const MTCCDataScene = {
    aippt: "00119"
};
// 成本分摊埋点 https://cf.meitu.com/confluence/pages/viewpage.action?pageId=416230853
const MTCCData = {
    // 生成完整 PPT
    "/ppt/apply": {
        positionKey: "",
        function: MTCCDataScene["aippt"],
        position: {
            default: MTCCDataScene["aippt"]
        }
    }
};
const TIP_TEXT = "您的内容已加密，生成后将自动删除";
/**
 * 上传文件需要会员的格式
 */ const UPLOAD_FILE_MEMBER_FORMAT = [
    "txt",
    "pdf",
    "docx"
];


/***/ }),

/***/ 99956:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _meitu_x_design_roboneo_web_fork_lib_style_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83901);
/* harmony import */ var _meitu_x_design_roboneo_web_fork_lib_style_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_meitu_x_design_roboneo_web_fork_lib_style_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _meitu_x_design_roboneo_dist_style_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57894);
/* harmony import */ var _meitu_x_design_roboneo_dist_style_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_meitu_x_design_roboneo_dist_style_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_globals_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26869);
/* harmony import */ var _styles_globals_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_globals_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var easy_peasy__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67238);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29358);
/* harmony import */ var _appLogic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47468);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_mtstat__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40582);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67294);
/* harmony import */ var _meitu_xdesign_widgets_dist_utils_sessionRecentPages__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(29777);












// @ts-ignore
const WpsPayModal = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(()=>__webpack_require__.e(/* import() */ 7762).then(__webpack_require__.bind(__webpack_require__, 37762)).then((mod)=>mod.WpsPayModal), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(37762)
            ]
    },
    ssr: false
});
Promise.all(/* import() */[__webpack_require__.e(2788), __webpack_require__.e(9876), __webpack_require__.e(6402), __webpack_require__.e(4162), __webpack_require__.e(1697), __webpack_require__.e(1455)]).then(__webpack_require__.bind(__webpack_require__, 51950)).then((param)=>{
    let { initResignedListener  } = param;
    initResignedListener();
});
const MyApp = (param)=>{
    let { Component , pageProps  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        (0,_meitu_xdesign_widgets_dist_utils_sessionRecentPages__WEBPACK_IMPORTED_MODULE_11__/* .pushSessionRecentPage */ .z)();
    }, [
        router.pathname
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(easy_peasy__WEBPACK_IMPORTED_MODULE_4__/* .StoreProvider */ .g3, {
        store: _store__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_appLogic__WEBPACK_IMPORTED_MODULE_6__["default"], {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WpsPayModal, {
                onStatTrack: _utils_mtstat__WEBPACK_IMPORTED_MODULE_8__/* .statTrack */ .SF
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                ...pageProps
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MyApp);


/***/ }),

/***/ 47468:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ appLogic)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/mtstat.ts
var mtstat = __webpack_require__(40582);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/configProvider/index.js
var configProvider = __webpack_require__(84480);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/uidKit.js
var uidKit = __webpack_require__(53421);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/hooks/useWpsNavigationIntercept.js
var useWpsNavigationIntercept = __webpack_require__(173);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/source.js
var source = __webpack_require__(58730);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/index.js
var utils = __webpack_require__(68626);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(78264);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(29358);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/index.js
var dist_teamInfo = __webpack_require__(72838);
;// CONCATENATED MODULE: ./src/services/enterprise/index.ts



async function initEnterprise() {
    (0,configProvider/* setConfigPartial */.qK)({
        client_id: (0,constants/* getClientID */.kU)(),
        env: "release"
    });
    // 企业相关配置，目前主要使用到上传app
    const res = await (0,dist_teamInfo/* enterpriseInit */.P3)();
}
// 是否企业标识
const isEnterprise = ()=>!!getEnterpriseID();

// EXTERNAL MODULE: ./src/utils/index.ts
var src_utils = __webpack_require__(16598);
;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-core/dist/esm/constants.js
/**
 * ABTest 环境变量
 */
var ABTestEnv;
(function (ABTestEnv) {
    /** 正式环境 */
    ABTestEnv["Release"] = "release";
    /** 测试环境 */
    ABTestEnv["Beta"] = "beta";
    /** 预发环境 */
    ABTestEnv["Test"] = "test";
})(ABTestEnv || (ABTestEnv = {}));
/**
 * ABTest code信息列表接口请求地址
 */
const ABTestApi = {
    [ABTestEnv.Release]: 'https://meepo.meitustat.com/ab_allot_web_v2',
    [ABTestEnv.Beta]: 'https://test-meepo.meitustat.com/ab_allot_web_v2', // https://api-mock.meitu-int.com/mock/14/ab_allot  http://test.meepo.meitustat.com/ab_allot_web
    [ABTestEnv.Test]: 'https://test-meepo.meitustat.com/ab_allot_web_v2'
};
/**
 * 本地存储 key
 *
 * @since 1.3.0
 *
 * @deprecated 已弃用，请改用 `cacheKey` 属性替代
 */
const LS_AB_TEST = 'abTest';
/**
 * 埋点统计sdk 存储的 本地缓存 为了取 wgid;
 *
 *  @since 1.3.0
 */
const MTSTAT_COOKIE_NAME = 'meitustat';
/**
 * ABTest Web 服务端设备标记 cookie 名称
 *
 * @since 1.3.0
 */
const COOKIE_NAME_WEB_SERVER_ID = '__mt_ab_test_wsid__';
/**
 * ABTest Web 服务端进入实验 code cookie 名称
 *
 * @since 1.3.0
 */
const COOKIE_NAME_SERVER_IN_TEST_CODE = '__mt_ab_test_server_codes__';
/**
 * 协议版本 目前 Web 是传 3
 */
const ProtocolVersion = 3;
/**
 * ABTest 进入实验 默认上报的事件名称
 */
const ABCODE_ENTER_TEST = 'abcode_enter_test';
/**
 * 控制台日志前缀
 *
 * @since 1.2.0
 */
const LOG_PREFIX = '[@meitu/ab-test]';
/**
 * 实验状态
 */
var ExperimentStatus;
(function (ExperimentStatus) {
    /** 已创建 */
    ExperimentStatus[ExperimentStatus["Created"] = 0] = "Created";
    /** 进行中 */
    ExperimentStatus[ExperimentStatus["InProgress"] = 1] = "InProgress";
    /** 已完成 */
    ExperimentStatus[ExperimentStatus["Completed"] = 2] = "Completed";
    /** 人为终止 */
    ExperimentStatus[ExperimentStatus["Terminated"] = 3] = "Terminated";
    /** 一键发布 */
    ExperimentStatus[ExperimentStatus["Publish"] = 4] = "Publish";
    /** 已发布 */
    ExperimentStatus[ExperimentStatus["Published"] = 5] = "Published";
    /** 已结束 */
    ExperimentStatus[ExperimentStatus["End"] = 6] = "End";
})(ExperimentStatus || (ExperimentStatus = {}));
/**
 * 实验类型
 */
var ExperimentType;
(function (ExperimentType) {
    /** 客户端实验 */
    ExperimentType[ExperimentType["Client"] = 1] = "Client";
    /** 客户端本地实验 */
    ExperimentType[ExperimentType["ClientLocal"] = 2] = "ClientLocal";
    /** 服务端实验 */
    ExperimentType[ExperimentType["Server"] = 3] = "Server";
    /** 异步实验-通用实验 */
    ExperimentType[ExperimentType["AsyncCommon"] = 4] = "AsyncCommon";
    /** 异步实验-push */
    ExperimentType[ExperimentType["AsyncPush"] = 5] = "AsyncPush";
    /** 异步实验-推荐 */
    ExperimentType[ExperimentType["AsyncRecommend"] = 6] = "AsyncRecommend";
})(ExperimentType || (ExperimentType = {}));
/**
 * 标识类型
 */
var IdentifyType;
(function (IdentifyType) {
    /** 用户id */
    IdentifyType["Uid"] = "type1";
    /** app gid */
    IdentifyType["AppGid"] = "type2";
    /** web gid */
    IdentifyType["WebGid"] = "type3";
    /** pc gid */
    IdentifyType["PcGid"] = "type4";
    /** Mac 地址 */
    IdentifyType["MacAddress"] = "type5";
    /**
     * Web 服务端设备标记
     *
     * @since 1.3.0
     **/
    IdentifyType["WebServerId"] = "type6";
})(IdentifyType || (IdentifyType = {}));

;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-core/dist/esm/types.js

/**
 * 获取 ABTest 类的默认配置选项
 *
 * @since 1.2.0
 */
function getDefaultABTestOptions() {
    return {
        appKey: '',
        gid: '',
        wgid: '',
        custom: [],
        env: ABTestEnv.Release
    };
}
/**
 * 验证配置项是否有效
 *
 * @since 1.3.1
 */
function validateOptions(options) {
    var _a, _b;
    if (!((_b = (_a = options === null || options === void 0 ? void 0 : options.appKey) === null || _a === void 0 ? void 0 : _a.trim) === null || _b === void 0 ? void 0 : _b.call(_a))) {
        throw new Error('appKey 为必传参数');
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-core/dist/esm/utils.js
/**
 * 将字符串转成十六进制
 *
 * @param str 需要转成十六进制的字符串
 */
function strToHex(str) {
    let val = '';
    for (let i = 0; i < str.length; i++) {
        val += str.charCodeAt(i).toString(16);
    }
    return val.toUpperCase();
}
/**
 * 打平设备自定义标识数组
 *
 * @since 1.3.0
 */
function flatIdentify(custom) {
    return custom.reduce((acc, current) => {
        const { type, value } = current;
        acc[type] = value;
        return acc;
    }, {});
}
/**
 * 转换成特定的命名法
 * @param transform 转换函数
 * @param input 输入值
 *
 * @since 1.3.0
 */
function toSpecificCase(transform, input) {
    if (Array.isArray(input)) {
        return input.map(toSpecificCase.bind(null, transform));
    }
    if (typeof input === 'object' && input !== null) {
        return Object.keys(input).reduce((acc, key) => Object.assign(acc, {
            [transform(key)]: toSpecificCase(transform, input[key])
        }), {});
    }
    return input;
}
/**
 * 转换为小驼峰
 * @param input 输入
 *
 * @since 1.3.0
 * @example
 * // returns { eventProduct: '美图秀秀社区后台' }
 * // toCamelCase<{ eventProduct: string; }>({ event_product: '美图秀秀社区后台' })
 */
function toCamelCase(input) {
    return toSpecificCase(camelCase, input);
}
/**
 * 将给定的字符串转换为小驼峰
 */
function camelCase(str) {
    const words = str
        .replace(/[^a-zA-Z0-9]+/g, ' ')
        .split(' ')
        .filter(Boolean);
    return words
        .map((word, index) => {
        if (index === 0) {
            return word.toLowerCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
        .join('');
}

;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-core/dist/esm/AbTest.js



/**
 * A/B 测试核心 / 基类
 */
class ABTestCore {
    /**
     * Web 服务端设备标记
     *
     * @readonly
     * @since 1.3.0
     */
    get webServerId() {
        return '';
    }
    /**
     * Web 服务端进入实验测试 codes
     *
     * @readonly
     * @since 1.3.0
     */
    get webServerTestCodes() {
        return [];
    }
    constructor(options) {
        /**
         * ABTest 配置
         */
        this.options = getDefaultABTestOptions();
        /**
         * 是否已经初始化完成
         *
         * 异步请求 A/B 测试数据之后才能调用其他相关的接口
         *
         * @default false
         */
        this.initialize = false;
        this.options = Object.assign(Object.assign({}, this.options), options);
        validateOptions(this.options);
        this._storage = this.createStorageCache();
    }
    /**
     * 版本号
     *
     * @getter
     * @readonly
     * @since 1.2.0
     */
    get version() {
        return '1.3.1';
    }
    /**
     * 当前运行环境
     *
     * @getter
     * @readonly
     */
    get env() {
        return this.options.env || ABTestEnv.Release;
    }
    /**
     * 存储实例对象
     *
     * @getter
     * @readonly
     * @since 1.3.0
     */
    get storage() {
        return this._storage;
    }
    /**
     * 不同环境变量对应请求的 api 地址
     *
     * @getter
     * @readonly
     */
    get url() {
        return ABTestApi[this.env];
    }
    /**
     * 自定义设备标识列表
     *
     * @getter
     * @readonly
     */
    get custom() {
        var _a, _b;
        return (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.custom) !== null && _b !== void 0 ? _b : [];
    }
    /**
     * 平铺后的自定义设备标识列表
     *
     * @getter
     * @readonly
     * @protected
     */
    get identifyMap() {
        return flatIdentify(this.custom);
    }
    /**
     * 本地存储 key
     *
     * 不同 appKey 之间对应不同的存储 key
     * @getter
     * @readonly
     * @since 1.3.1
     */
    get cacheKey() {
        return `${LS_AB_TEST}_${this.options.appKey}`;
    }
    /**
     * A/B 测试编码列表（本地缓存）
     *
     * @getter
     * @protected
     * @readonly
     */
    get abCodes() {
        // 兼容旧数据
        const oldCodes = this.storage.getItem(LS_AB_TEST);
        return this.storage.getItem(this.cacheKey, oldCodes !== null && oldCodes !== void 0 ? oldCodes : []);
    }
    /**
     * A/B 测试编码列表映射对象（按 code）
     *
     * @getter
     * @protected
     * @readonly
     */
    get abCodesMap() {
        return this.abCodes.reduce((codes, ab) => {
            codes[ab.abCode] = ab;
            return codes;
        }, {});
    }
    /**
     * 检查是否已经初始化完毕 ABTest SDK
     *
     * @since 1.3.0
     */
    checkHasInit(methodName = '该') {
        if (!this.initialize) {
            console.warn(LOG_PREFIX, `尚未初始化成功，请确保初始化完毕再调用 【${methodName}】 方法`);
        }
        return this.initialize;
    }
    /**
     * 判断当前 code 是否进入 A/B 实验当中
     *
     * @param code A/B 实验编码
     */
    isInABTesting(code) {
        var _a, _b;
        if (!this.checkHasInit('isInABTesting')) {
            return false;
        }
        const abCodes = this.abCodes;
        const index = abCodes.findIndex(({ abCode }) => abCode === code);
        if (index >= 0) {
            const count = ((_a = abCodes[index]) === null || _a === void 0 ? void 0 : _a.count) || 0;
            if (count === 0) {
                // 第一次进入实验 上报默认埋点事件 abcode_enter_test
                const code = ((_b = abCodes[index]) === null || _b === void 0 ? void 0 : _b.abCode) || 0;
                if (code) {
                    this.reportABCodeEnterTest(code);
                }
            }
            abCodes[index].count += 1;
            this.storage.setItem(this.cacheKey, abCodes); // count 进入实验后 自增 1 并更新本地缓存
            return true;
        }
        return false;
    }
    /**
     * 获取进入 A/B 测试实验的编码
     *
     * @param codes 做实验的整组 code [1001,1002,1003] | example: 实验组 1 code = 1001, 实验组 2 code = 1002, 对照组 3 code = 1003
     * @returns 返回命中的 AB Test code 值；返回值为 0 表示没有命中
     */
    inABTestingCode(codes) {
        if (!this.checkHasInit('inABTestingCode')) {
            return 0;
        }
        const codeMap = this.abCodesMap;
        const code = codes.find((code) => codeMap[code]);
        if (code) {
            this.isInABTesting(code); // 如果进入实验需要更新 本地 count 并上报默认事件
        }
        return code || 0;
    }
    /**
     * 获取服务端实验中的 A/B 测试编码列表
     */
    getABTestingServerCodes() {
        if (!this.checkHasInit('getABTestingServerCodes')) {
            return [];
        }
        const abCodes = this.abCodes;
        return abCodes.reduce((acc, current) => {
            const { abCode, et: experimentType } = current;
            const types = [
                ExperimentType.Server,
                ExperimentType.AsyncCommon,
                ExperimentType.AsyncPush,
                ExperimentType.AsyncRecommend
            ];
            if (types.indexOf(experimentType) >= 0) {
                acc.push(abCode);
            }
            return acc;
        }, []);
    }
    /**
     * 设置服务端实验中的 A/B 测试码
     *
     * 更新本地缓存中对应实验中 count 计数 目前 count 由前端维护 代表进入实验的次数
     *
     * 作用：
     *
     * 1. `count` => 1 需要上报，默认的 `abcode_enter_test` 事件 通过埋点sdk 上报 当作进入实验的指标
     * 2. 预留以后需要统计进入`实验次数`这个口子
     *
     */
    setABTestingServerCodes(codes) {
        if (!(codes === null || codes === void 0 ? void 0 : codes.length)) {
            console.warn(LOG_PREFIX, `setABTestingServerCodes: codes is empty`);
            return;
        }
        if (!this.checkHasInit('setABTestingServerCodes')) {
            return;
        }
        codes.forEach((code) => {
            this.isInABTesting(code);
        });
    }
    /**
     * 获取 A/B 测试（关键）信息
     */
    getABInfo() {
        const codes = this.abCodes.reduce((acc, { abCode, status, count }) => {
            if (status === ExperimentStatus.InProgress) {
                acc.push({
                    code: abCode,
                    count
                });
            }
            return acc;
        }, []);
        return {
            // eslint-disable-next-line camelcase
            ab_codes: codes, // 此处用 snakeCase 是为了用户调用接口获取到的数据，可以直接用作 WebSDK 上报的行为日志
            version: this.version
        };
    }
    /**
     * 设置本地缓存 abCodes 信息
     *
     * @protected
     * @since 1.3.0
     */
    cacheABInfo(codes = []) {
        const codeMap = this.abCodesMap;
        const abInfo = codes.map(({ abCode, et, status, v }) => {
            const localABInfo = ((codeMap === null || codeMap === void 0 ? void 0 : codeMap[abCode]) || {});
            const count = (localABInfo === null || localABInfo === void 0 ? void 0 : localABInfo.v) === v ? localABInfo.count || 0 : 0; // 当版本变更时需要重置 count 为 0；
            return {
                abCode,
                et,
                status,
                v,
                count
            };
        });
        this.storage.setItem(this.cacheKey, abInfo); // 设置本地缓存
    }
    /**
     * 生成请求 ABCode 接口参数
     *
     * @protected
     */
    toQueryParams() {
        const { identifyMap } = this;
        const { appKey, gid, uid } = this.options;
        const result = {
            appKey,
            version: ProtocolVersion
        };
        if (gid) {
            result[IdentifyType.AppGid] = gid;
            console.warn(LOG_PREFIX, 'uid 将在未来的版本中废弃，请使用 `custom` 来自定义标识类型');
        }
        if (uid) {
            result[IdentifyType.Uid] = uid;
            console.warn(LOG_PREFIX, 'uid 将在未来的版本中废弃，请使用 `custom` 来自定义标识类型');
        }
        return Object.assign(Object.assign({}, result), identifyMap);
    }
    /**
     * 获取所有实验中的 A/B 测试编码列表
     */
    getABTestingCodes() {
        if (!this.checkHasInit('getABTestingCodes')) {
            return [];
        }
        const abCodes = this.abCodes;
        return abCodes.reduce((acc, current) => {
            const { abCode, status } = current;
            if (status === ExperimentStatus.InProgress) {
                acc.push(abCode);
            }
            return acc;
        }, []);
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-core/dist/esm/index.js





// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-web/dist/esm/storage.js
const storage = typeof window !== 'undefined' && window.localStorage;
/**
 * 设置本地存储项
 * @param key 键
 * @param value 值
 */
function setItem(key, value) {
    storage.setItem(key, JSON.stringify(value === undefined ? null : value));
}
/**
 * 获取本地存储项
 * @param key 键
 */
function getItem(key, defaultValue) {
    try {
        const item = storage.getItem(key);
        const value = item == null ? null : JSON.parse(item);
        return value !== null && value !== void 0 ? value : defaultValue;
    }
    catch (err) {
        return defaultValue;
    }
}
/**
 * 移除本地存储项
 * @param key 键
 */
function removeItem(key) {
    storage.removeItem(key);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-web/dist/esm/AbTest.js

/// <reference types="@meitu/mtstat-sdk" />



/**
 * A/B 测试类
 */
class ABTest extends ABTestCore {
    /**
     * 通过埋点统计 Web SDK 生成的设备标识
     *
     * @getter
     * @readonly
     */
    get wgid() {
        var _a, _b;
        let webGid = '';
        try {
            webGid = (_a = window.mtstat) === null || _a === void 0 ? void 0 : _a.getDeviceId();
        }
        catch (err) {
            console.warn(err);
        }
        return (((_b = this.identifyMap) === null || _b === void 0 ? void 0 : _b[IdentifyType.WebGid]) || webGid) + ''; // 默认使用 WebSDK 里的 wgid,如果自定传入 wgid 的话再覆盖
    }
    /**
     * Web 服务端设备标记
     *
     * @getter
     * @readonly
     * @since 1.3.0
     */
    get webServerId() {
        var _a, _b;
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.wsid) {
            return (_b = this.options) === null || _b === void 0 ? void 0 : _b.wsid;
        }
        const webServerIdValue = js_cookie/* default.get */.Z.get(COOKIE_NAME_WEB_SERVER_ID) || '';
        try {
            const value = JSON.parse(webServerIdValue);
            return value[this.options.appKey] || '';
        }
        catch (error) {
            console.warn(error);
            return webServerIdValue;
        }
    }
    /**
     * Web 服务端进入实验测试 codes
     *
     * @getter
     * @readonly
     * @since 1.3.0
     */
    get webServerTestCodes() {
        var _a, _b;
        const codesValue = (_a = js_cookie/* default.get */.Z.get(COOKIE_NAME_SERVER_IN_TEST_CODE)) !== null && _a !== void 0 ? _a : '';
        let abCodes = [];
        if (!codesValue) {
            return abCodes;
        }
        try {
            const value = JSON.parse(codesValue);
            abCodes = Array.isArray(value)
                ? value
                : (_b = value[this.options.appKey]) !== null && _b !== void 0 ? _b : [];
        }
        catch (error) {
            console.warn(error);
        }
        return abCodes;
    }
    createStorageCache() {
        return {
            getItem: getItem,
            setItem: setItem,
            removeItem: removeItem
        };
    }
    /**
     * 合并目标 ABTestCode 数组与结果 ABTestCode 数组。
     *
     * @since 1.3.0
     */
    mergeAbTestCodes(abCodes, target) {
        const map = abCodes.reduce((acc, item) => {
            acc[item.abCode] = Object.assign({ count: 0 }, item);
            return acc;
        }, {});
        target.forEach((item) => {
            if (!map[item.abCode]) {
                // 没有的话，直接添加
                map[item.abCode] = Object.assign(Object.assign({}, item), { count: 0 });
            }
        });
        return Object.values(map);
    }
    // 保证主包 JS API 文档的正确生成
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    init(options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            var _a;
            let abCodes = [];
            // 保证初始化【埋点统计SDK】并生成 wgid 之后再初始化【ABTest SDK】
            if (window.mtstat &&
                typeof window.mtstat.init === 'function' &&
                this.wgid) {
                try {
                    const abInfo = yield this.fetchABCodes(); // 获取服务端abCodes
                    abCodes = this.mergeAbTestCodes(abInfo.abCodes, this.webServerTestCodes);
                }
                catch (err) {
                    console.error(err);
                }
                this.cacheABInfo(abCodes); // 设置本地缓存
                // 在这里先设置初始化完毕是为了能够在 setABTestingServerCodes 中 count + 1，让后上报
                this.initialize = true; // 初始化完毕
                if (this.webServerTestCodes.length) {
                    if (this.webServerId) {
                        // 有接收服务器给的 ab code 时，需要提前设置 abInfo 后续才能上报
                        const abInfo = this.getABInfo();
                        (_a = window.mtstat) === null || _a === void 0 ? void 0 : _a.setABInfo(abInfo);
                    }
                    // 有接收服务器给的 ab code 时，需要 count + 1
                    this.setABTestingServerCodes(this.webServerTestCodes.map((item) => item.abCode));
                    try {
                        const codesValue = js_cookie/* default.get */.Z.get(COOKIE_NAME_SERVER_IN_TEST_CODE);
                        const value = JSON.parse(codesValue);
                        if (Array.isArray(value)) {
                            js_cookie/* default.remove */.Z.remove(COOKIE_NAME_SERVER_IN_TEST_CODE);
                        }
                        else {
                            delete value[this.options.appKey];
                            js_cookie/* default.set */.Z.set(COOKIE_NAME_SERVER_IN_TEST_CODE, JSON.stringify(value));
                        }
                    }
                    catch (error) {
                        console.warn(error);
                    }
                }
            }
            else {
                console.warn(LOG_PREFIX, '请确保先引入埋点统计 JS SDK（@meitu/mtstat-sdk），并调用 mtstat.init() 初始化之后，再进行 ABTest SDK 的初始化');
            }
            return abCodes;
        });
    }
    fetchABCodes() {
        if (typeof fetch === 'undefined') {
            throw new Error('Fetch API undefined');
        }
        const postData = this.toQueryParams();
        if (this.webServerId) {
            postData[IdentifyType.WebServerId] = this.webServerId;
        }
        const hexStr = strToHex(JSON.stringify(Object.assign(Object.assign({}, postData), { [IdentifyType.WebGid]: this.wgid })));
        return new Promise((resolve, reject) => {
            fetch === null || fetch === void 0 ? void 0 : fetch(this.url, {
                method: 'POST',
                body: hexStr
            }).then((res) => (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
                const result = yield res.json();
                resolve(toCamelCase(result));
            })).catch((error) => reject(error));
        });
    }
    /**
     * 获取 A/B 测试（关键）信息
     */
    getABInfo() {
        const abInfo = super.getABInfo();
        return this.webServerId
            ? Object.assign(Object.assign({}, abInfo), { 
                // eslint-disable-next-line camelcase
                ab_wsid: this.webServerId }) : abInfo;
    }
    /**
     * 第一次进入实验 上报默认埋点事件 `abcode_enter_test`
     *
     * 埋点事件数据示例：`{event_id: "abcode_enter_test", params: { current_abcode: 100x }}`
     */
    reportABCodeEnterTest(code) {
        var _a;
        if (!this.checkHasInit('reportABCodeEnterTest')) {
            return;
        }
        (_a = window.mtstat) === null || _a === void 0 ? void 0 : _a.track(ABCODE_ENTER_TEST, {
            // eslint-disable-next-line camelcase
            current_abcode: code
        });
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-web/dist/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test/dist/esm/index.js


;// CONCATENATED MODULE: ./src/utils/abtest.ts

let abInfo = {};
let abTest = null;
const initABTest = async ()=>{
    var // 通过websdk 设置ab_info的信息
    ref;
    const abTestParams = {
        /** Web项目id */ appKey: "C5F34252F04B6D50",
        /** 环境变量 不传默认选择正式环境*/ env: ABTestEnv.Release
    };
    // 实例化 ABTest SDK
    const abTestInstance = new ABTest(abTestParams);
    await abTestInstance.init(); // 初始化 ABTest SDK
    abTest = abTestInstance;
    abInfo = abTest.getABInfo();
    (ref = window.mtstat) === null || ref === void 0 ? void 0 : ref.setABInfo(abInfo);
};
const getAbInfo = ()=>{
    return abInfo;
};
/**
 * ppt商业化
 */ const isOpenPptCommercialization = async ()=>{
    if (!abTest) await initABTest();
    // 对照组，默认关闭
    if (abTest === null || abTest === void 0 ? void 0 : abTest.isInABTesting(27220)) {
        return {
            isHitGroupOne: false,
            isHitGroupTwo: false
        };
    }
    // 实验组1
    if (abTest === null || abTest === void 0 ? void 0 : abTest.isInABTesting(27221)) {
        return {
            isHitGroupOne: true,
            isHitGroupTwo: false
        };
    }
    // 实验组2
    if (abTest === null || abTest === void 0 ? void 0 : abTest.isInABTesting(27222)) {
        return {
            isHitGroupOne: false,
            isHitGroupTwo: true
        };
    }
    return {
        isHitGroupOne: false,
        isHitGroupTwo: false
    };
};

// EXTERNAL MODULE: ./src/utils/sdk.ts
var sdk = __webpack_require__(67887);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(69222);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(80331);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(38389);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/i18n/index.js + 12 modules
var i18n = __webpack_require__(32907);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/recentFeatures/types.js
var RecentFeatureKey = /*#__PURE__*/ function(RecentFeatureKey) {
    RecentFeatureKey["CutOut"] = "cutOut";
    RecentFeatureKey["Eliminate"] = "eliminate";
    RecentFeatureKey["HD"] = "hd";
    RecentFeatureKey["ProductSetImages"] = "productSetImages";
    RecentFeatureKey["LongPicturePoster"] = "longPicturePoster";
    RecentFeatureKey["ClothSetImages"] = "clothSetImages";
    RecentFeatureKey["IDPhoto"] = "idPhoto";
    RecentFeatureKey["Portrait"] = "portrait";
    RecentFeatureKey["LivePPT"] = "livePPT";
    RecentFeatureKey["AiProducts"] = "aiProducts";
    RecentFeatureKey["Puzzle"] = "puzzle";
    RecentFeatureKey["BatchProcess"] = "batchProcess";
    RecentFeatureKey["Upscale"] = "upscale";
    RecentFeatureKey["AiModel"] = "aiModel";
    RecentFeatureKey["AiFitting"] = "aiFitting";
    RecentFeatureKey["AiLogo"] = "aiLogo";
    RecentFeatureKey["AiShoes"] = "aiShoes";
    RecentFeatureKey["AiCopywriting"] = "aiCopywriting";
    RecentFeatureKey["AiPoster"] = "aiPoster";
    RecentFeatureKey["PhotoEditor"] = "photoEditor";
    RecentFeatureKey["Design"] = "design";
    RecentFeatureKey["ClothesWrinkle"] = "clothesWrinkle";
    RecentFeatureKey["ClothesRecolor"] = "clothesRecolor";
    RecentFeatureKey["PortraitBackground"] = "portraitBackground";
    RecentFeatureKey["AiProductVideo"] = "aiProductVideo";
    RecentFeatureKey["AiPosterNote"] = "aiPosterNote";
    return RecentFeatureKey;
}({});

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/recentFeatures/constants.js

var _RECENT_FEATURE_META;


var constants_RECENT_FEATURE_COOKIE_KEY = "xdesign_recent_features_v1";
/** @deprecated 请改用 RECENT_FEATURE_COOKIE_KEY */ var RECENT_FEATURE_STORAGE_KEY = (/* unused pure expression or super */ null && (constants_RECENT_FEATURE_COOKIE_KEY));
var constants_DEFAULT_RECENT_FEATURE_LIMIT = 10;
var RECENT_FEATURE_COOKIE_EXPIRES_DAYS = 365;
var _getLocaleStore = (0,i18n/* getLocaleStore */.IK)(), $t = _getLocaleStore.$t;
var constants_RECENT_FEATURE_META = (_RECENT_FEATURE_META = {}, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)(_RECENT_FEATURE_META, RecentFeatureKey.CutOut, {
    name: $t(function(v) {
        return v.Tool_ImageBgRemover;
    }),
    icon: "CutOut",
    url: "/cutout/edit"
}), RecentFeatureKey.Eliminate, {
    name: $t(function(v) {
        return v.Tool_AiObjectsRemover;
    }),
    icon: "Eliminate",
    url: "/aieraser"
}), RecentFeatureKey.HD, {
    name: $t(function(v) {
        return v.Tool_ImageEnhancer;
    }),
    icon: "Hd",
    url: "/quality"
}), RecentFeatureKey.ProductSetImages, {
    name: $t(function(v) {
        return v.Title_Nav_ImageSet;
    }),
    icon: "ProductSetImages",
    url: "/product-kit"
}), RecentFeatureKey.LongPicturePoster, {
    name: $t(function(v) {
        return v.Title_DetailPage_ProductCase;
    }),
    icon: "LongPicturePoster",
    url: "/product-kit/detailpage"
}), RecentFeatureKey.ClothSetImages, {
    name: $t(function(v) {
        return v.Tips_Material2_Home;
    }),
    icon: "ClothSetImages",
    url: "/product-kit/try-on"
}), RecentFeatureKey.IDPhoto, {
    name: $t(function(v) {
        return v.Tool_IDPhoto;
    }),
    icon: "IDPhoto",
    url: "/certified"
}), RecentFeatureKey.Portrait, {
    name: $t(function(v) {
        return v.Tool_PortraitPhoto;
    }),
    icon: "IDPhoto",
    url: "/portrait-photo"
}), RecentFeatureKey.LivePPT, {
    name: "LivePPT",
    icon: "Ppt",
    url: "/ppt/edit"
}), RecentFeatureKey.AiProducts, {
    name: $t(function(v) {
        return v.Title_More3_Home;
    }),
    icon: "AiProducts",
    url: "/product-shoot-editor"
}), (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)(_RECENT_FEATURE_META, RecentFeatureKey.Puzzle, {
    name: $t(function(v) {
        return v.Tag_Jigsaw;
    }),
    icon: "Jigsaw",
    url: "/puzzle"
}), RecentFeatureKey.BatchProcess, {
    name: $t(function(v) {
        return v.Tool_ImageBatchProcess;
    }),
    icon: "Batch",
    url: "/bulk-ai-editor"
}), RecentFeatureKey.AiModel, {
    name: $t(function(v) {
        return v.Tool_AiModelMannequin;
    }),
    icon: "AiModel",
    url: "/model"
}), RecentFeatureKey.Upscale, {
    name: $t(function(v) {
        return v.Tool_ImageUpscaler;
    }),
    icon: "LosslessAmplification",
    url: "/upscale"
}), RecentFeatureKey.AiFitting, {
    name: $t(function(v) {
        return v.Tool_AiModelFlatlay;
    }),
    icon: "Suit",
    url: "/clothes"
}), RecentFeatureKey.AiLogo, {
    name: $t(function(v) {
        return v.Tool_AiLogo;
    }),
    icon: "Logo",
    url: "/logo-design"
}), RecentFeatureKey.AiShoes, {
    name: $t(function(v) {
        return v.Tool_AiShoes;
    }),
    icon: "Shoes",
    url: "/shoes"
}), RecentFeatureKey.AiCopywriting, {
    name: $t(function(v) {
        return v.Tool_AiCopywriting;
    }),
    icon: "AiFile",
    url: "/copywriting"
}), RecentFeatureKey.AiPoster, {
    name: $t(function(v) {
        return v.Tool_AiPoster;
    }),
    icon: "AiPoster",
    url: "/poster"
}), RecentFeatureKey.PhotoEditor, {
    name: $t(function(v) {
        return v.Tool_AiPhotoEditor;
    }),
    icon: "Picture",
    url: "/editor"
}), (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)(_RECENT_FEATURE_META, RecentFeatureKey.Design, {
    name: $t(function(v) {
        return v.Tool_OnlineDesign;
    }),
    icon: "FrameToPoster",
    url: "/design"
}), RecentFeatureKey.ClothesWrinkle, {
    name: $t(function(v) {
        return v.Tool_ClothesDewrinkle;
    }),
    icon: "Clothes",
    url: "/rmwrinkle"
}), RecentFeatureKey.ClothesRecolor, {
    name: $t(function(v) {
        return v.Tool_AiImageRecolor;
    }),
    icon: "AiVirtualTryOn",
    url: "/recolor"
}), RecentFeatureKey.PortraitBackground, {
    name: $t(function(v) {
        return v.Tool_PortraitBackground;
    }),
    icon: "PortraitBackground",
    url: "/person-shoot"
}), RecentFeatureKey.AiProductVideo, {
    name: $t(function(v) {
        return v.Tool_ViralVideo;
    }),
    icon: "Video",
    url: "/viral-video"
}), RecentFeatureKey.AiPosterNote, {
    name: $t(function(v) {
        return v.Tool_AiPosterNote;
    }),
    icon: "Poster",
    url: "/post-gen"
}));
var RECENT_FEATURE_KEY_SET = new Set(Object.values(RecentFeatureKey));

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/recentFeatures/storage.js




var memoryData = null;
var persistScheduled = false;
var isBrowser = function isBrowser() {
    return  true && typeof document !== "undefined";
};
var isRecentFeatureKey = function isRecentFeatureKey(key) {
    return RECENT_FEATURE_KEY_SET.has(key);
};
var normalizeRecord = function normalizeRecord(input) {
    if (!input || (0,esm_typeof/* default */.Z)(input) !== "object") return {};
    return Object.entries(input).reduce(function(acc, _ref) {
        var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2), key = _ref2[0], value = _ref2[1];
        if (!isRecentFeatureKey(key)) return acc;
        var timestamp = Number(value);
        if (!Number.isFinite(timestamp) || timestamp <= 0) return acc;
        acc[key] = timestamp;
        return acc;
    }, {});
};
var getCookieValue = function getCookieValue(cookie) {
    void cookie;
    if (!isBrowser()) return undefined;
    try {
        return js_cookie/* default.get */.Z.get(constants_RECENT_FEATURE_COOKIE_KEY);
    } catch (error) {
        return undefined;
    }
};
var loadFromCookie = function loadFromCookie(cookie) {
    try {
        var raw = getCookieValue(cookie);
        if (!raw) return {};
        var parsed = JSON.parse(raw);
        if (!parsed || (0,esm_typeof/* default */.Z)(parsed) !== "object") return {};
        if ("data" in parsed) {
            return normalizeRecord(parsed.data);
        }
        return normalizeRecord(parsed);
    } catch (error) {
        return {};
    }
};
var getMemoryData = function getMemoryData(cookie) {
    if (!isBrowser()) return {};
    if (memoryData) return memoryData;
    memoryData = loadFromCookie(cookie);
    return memoryData;
};
var persistToCookie = function persistToCookie() {
    persistScheduled = false;
    if (!isBrowser()) return;
    try {
        var payload = {
            version: 1,
            data: getMemoryData()
        };
        js_cookie/* default.set */.Z.set(constants_RECENT_FEATURE_COOKIE_KEY, JSON.stringify(payload), {
            expires: RECENT_FEATURE_COOKIE_EXPIRES_DAYS,
            path: "/",
            sameSite: "lax"
        });
    } catch (error) {
    /* noop */ }
};
var schedulePersist = function schedulePersist() {
    if (!isBrowser()) return;
    if (persistScheduled) return;
    persistScheduled = true;
    if ("requestIdleCallback" in window) {
        window.requestIdleCallback(function() {
            persistToCookie();
        });
        return;
    }
    setTimeout(function() {
        persistToCookie();
    }, 0);
};
var normalizeLimit = function normalizeLimit(limit) {
    if (!Number.isFinite(limit)) return DEFAULT_RECENT_FEATURE_LIMIT;
    var normalized = Math.floor(limit);
    return normalized > 0 ? normalized : 0;
};
var markRecentFeature = function markRecentFeature(key) {
    var lastUsedAt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
    if (!constants_RECENT_FEATURE_META[key]) return;
    if (!isBrowser()) return;
    getMemoryData()[key] = lastUsedAt;
    schedulePersist();
};
var normalizeGetRecentFeaturesOptions = function normalizeGetRecentFeaturesOptions(options) {
    var _options$limit;
    if (typeof options === "number") {
        return {
            limit: normalizeLimit(options),
            cookie: undefined
        };
    }
    return {
        limit: normalizeLimit((_options$limit = options === null || options === void 0 ? void 0 : options.limit) !== null && _options$limit !== void 0 ? _options$limit : DEFAULT_RECENT_FEATURE_LIMIT),
        cookie: options === null || options === void 0 ? void 0 : options.cookie
    };
};
var getRecentFeatures = function getRecentFeatures(options) {
    var _normalizeGetRecentFe = normalizeGetRecentFeaturesOptions(options), limit = _normalizeGetRecentFe.limit;
    var normalizedLimit = limit;
    if (normalizedLimit === 0) return [];
    return Object.entries(getMemoryData()).filter(function(_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2), key = _ref4[0], lastUsedAt = _ref4[1];
        return isRecentFeatureKey(key) && Number.isFinite(lastUsedAt);
    }).sort(function(_ref5, _ref6) {
        var _ref7 = _slicedToArray(_ref5, 2), leftTime = _ref7[1];
        var _ref8 = _slicedToArray(_ref6, 2), rightTime = _ref8[1];
        return Number(rightTime) - Number(leftTime);
    }).slice(0, normalizedLimit).map(function(_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2), key = _ref10[0], lastUsedAt = _ref10[1];
        var featureKey = key;
        var meta = RECENT_FEATURE_META[featureKey];
        return {
            key: featureKey,
            name: meta.name,
            icon: meta.icon,
            url: meta.url,
            lastUsedAt: Number(lastUsedAt)
        };
    });
};
var clearRecentFeatures = function clearRecentFeatures() {
    memoryData = {};
    if (!isBrowser()) return;
    try {
        Cookies.remove(RECENT_FEATURE_COOKIE_KEY, {
            path: "/"
        });
    } catch (error) {
    /* noop */ }
};

// EXTERNAL MODULE: ./src/utils/login.tsx + 6 modules
var login = __webpack_require__(93567);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(19945);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(70072);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 8 modules
var regeneratorRuntime = __webpack_require__(89255);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(87406);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/storageCost/alertDailyLimit.js
/** 弹窗每日频次维度：文件时间告警 / 空间告警 */ var STORAGE_KEY_PREFIX = "xdesign-widgets:storage-cost-alert-shown:";
var getTodayDateKey = function getTodayDateKey() {
    var now = new Date();
    var year = now.getFullYear();
    var month = String(now.getMonth() + 1).padStart(2, "0");
    var day = String(now.getDate()).padStart(2, "0");
    return "".concat(year, "-").concat(month, "-").concat(day);
};
var getStorageKey = function getStorageKey(pageMode, kind) {
    return "".concat(STORAGE_KEY_PREFIX).concat(pageMode, "-").concat(kind);
};
/** 当前 pageMode + 告警类型今日是否已展示过 */ var hasStorageCostAlertShownToday = function hasStorageCostAlertShownToday(pageMode, kind) {
    if (false) {}
    try {
        return window.localStorage.getItem(getStorageKey(pageMode, kind)) === getTodayDateKey();
    } catch (_unused) {
        return false;
    }
};
/** 记录当前 pageMode + 告警类型今日已展示 */ var markStorageCostAlertShownToday = function markStorageCostAlertShownToday(pageMode, kind) {
    if (false) {}
    try {
        window.localStorage.setItem(getStorageKey(pageMode, kind), getTodayDateKey());
    } catch (_unused2) {
    // localStorage 不可用时忽略，不影响主流程
    }
};

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/request.js + 1 modules
var request = __webpack_require__(1225);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/storageCost/api.js



/**
 * 商业存储摘要接口返回（后端字段）。
 */ /**
 * 获取商业存储摘要信息。
 * docs: https://api-mock.meitu-int.com/project/2110/interface/api/226590
 */ var fetchStorageCostSummary = /*#__PURE__*/ function() {
    var _ref = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", (0,request/* default */.ZP)("/v1/my_space/summary", {
                        method: "GET"
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function fetchStorageCostSummary() {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/react-modal-open/dist/createModalComponent.js + 1 modules
var createModalComponent = __webpack_require__(52260);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-icon-font/dist/IconFont.js + 2 modules
var IconFont = __webpack_require__(15328);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/commonModal/index.js
var commonModal = __webpack_require__(49143);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/storageCost/components/storageCostAlertModal/index.less
var storageCostAlertModal = __webpack_require__(85236);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/storageCost/components/storageCostAlertModal/index.js





var StorageCostAlertModalInner = function StorageCostAlertModalInner(_ref) {
    var iconColor = _ref.iconColor, title = _ref.title, description = _ref.description, onClose = _ref.onClose, setMode = _ref.setMode, primaryAction = _ref.primaryAction, secondaryAction = _ref.secondaryAction;
    var handleClose = function handleClose() {
        var isManualClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        setMode === null || setMode === void 0 || setMode("");
        onClose === null || onClose === void 0 || onClose(isManualClose);
    };
    var renderPrimaryAction = function renderPrimaryAction() {
        if (!primaryAction) {
            return null;
        }
        return /*#__PURE__*/ react.createElement("button", {
            type: "button",
            className: "xdesign-storage-cost-modal__action xdesign-storage-cost-modal__action--primary",
            onClick: function onClick() {
                var _primaryAction$onClic;
                (_primaryAction$onClic = primaryAction.onClick) === null || _primaryAction$onClic === void 0 || _primaryAction$onClic.call(primaryAction);
                handleClose();
            },
            disabled: primaryAction.disabled
        }, /*#__PURE__*/ react.createElement("span", {
            className: "xdesign-storage-cost-modal__action-main"
        }, /*#__PURE__*/ react.createElement("span", {
            className: "xdesign-storage-cost-modal__action-title"
        }, primaryAction.iconName ? /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
            name: primaryAction.iconName,
            fontSize: 12
        }) : null, /*#__PURE__*/ react.createElement("span", null, primaryAction.text)), primaryAction.subText ? /*#__PURE__*/ react.createElement("span", {
            className: "xdesign-storage-cost-modal__action-sub-title"
        }, primaryAction.subText) : null));
    };
    var renderSecondaryAction = function renderSecondaryAction() {
        if (!secondaryAction) {
            return null;
        }
        return /*#__PURE__*/ react.createElement("button", {
            type: "button",
            className: "xdesign-storage-cost-modal__action xdesign-storage-cost-modal__action--secondary",
            onClick: function onClick() {
                var _secondaryAction$onCl;
                (_secondaryAction$onCl = secondaryAction.onClick) === null || _secondaryAction$onCl === void 0 || _secondaryAction$onCl.call(secondaryAction);
                handleClose();
            },
            disabled: secondaryAction.disabled
        }, /*#__PURE__*/ react.createElement("span", null, secondaryAction.text));
    };
    return /*#__PURE__*/ react.createElement(commonModal/* default */.Z, {
        open: true,
        destroyOnClose: true,
        className: "xdesign-storage-cost-modal"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-storage-cost-modal__panel"
    }, /*#__PURE__*/ react.createElement("button", {
        type: "button",
        className: "xdesign-storage-cost-modal__close",
        onClick: function onClick() {
            return handleClose(true);
        }
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        name: "CrossBlack",
        fontSize: 14,
        color: "var(--content-system-tertiary, #939599)"
    })), /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-storage-cost-modal__header"
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        name: "InfoCircleFill",
        fontSize: 54,
        color: iconColor !== null && iconColor !== void 0 ? iconColor : "var(--background-btn-svip, #ffcaa8)"
    }), /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-storage-cost-modal__title"
    }, title), /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-storage-cost-modal__description",
        dangerouslySetInnerHTML: {
            __html: description
        }
    })), /*#__PURE__*/ react.createElement("div", {
        className: "xdesign-storage-cost-modal__actions"
    }, renderPrimaryAction(), renderSecondaryAction())));
};
var StorageCostAlertModalModalController = (0,createModalComponent/* default */.Z)(StorageCostAlertModalInner);
var openStorageCostAlertModal = function openStorageCostAlertModal(options) {
    StorageCostAlertModalModalController.open(options);
};

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/types/teamInfo.js
var teamInfo = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/types/userInfo.js
var userInfo = __webpack_require__(71755);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/storageCost/type.js
/**
 * 存储管理的身份枚举。
 */ var StorageCostUserIdentityKind = /*#__PURE__*/ function(StorageCostUserIdentityKind) {
    StorageCostUserIdentityKind["PersonalFreeOther"] = "personal_free_other";
    StorageCostUserIdentityKind["PersonalFreeNewlyExpired"] = "personal_free_newly_expired";
    StorageCostUserIdentityKind["PersonalStandardVip"] = "personal_standard_vip";
    StorageCostUserIdentityKind["PersonalProVip"] = "personal_pro_vip";
    StorageCostUserIdentityKind["TeamFreeAdmin"] = "team_free_admin";
    StorageCostUserIdentityKind["TeamFreeMember"] = "team_free_member";
    StorageCostUserIdentityKind["TeamVipAdmin"] = "team_vip_admin";
    StorageCostUserIdentityKind["TeamVipMember"] = "team_vip_member";
    StorageCostUserIdentityKind["EnterpriseNoExpiredAdmin"] = "enterprise_no_expired_admin";
    StorageCostUserIdentityKind["EnterpriseNoExpiredMember"] = "enterprise_no_expired_member";
    StorageCostUserIdentityKind["EnterpriseExpiredAdmin"] = "enterprise_expired_admin";
    StorageCostUserIdentityKind["EnterpriseExpiredMember"] = "enterprise_expired_member";
    return StorageCostUserIdentityKind;
}({}); /**
 * 初始化参数：用于 initStorageCost 初始化逻辑（含弹窗等业务扩展入口）。
 */  /**
 * 空间状态。
 */  /**
 * 存储商业化所有相关的信息汇总。
 */ 

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/storageCost/transform.js




var LOW_SPACE_THRESHOLD = 0.1;
var MEMBERSHIP_SOON_EXPIRE_DAYS = 7;
var PERSONAL_FREE_NEWLY_EXPIRED_DAYS = 60;
var resolvePersonalIdentityKind = function resolvePersonalIdentityKind(options) {
    if (!options.userInfo.isVip) {
        var isPersonalFreeNewlyExpired = options.userInfo.vipDays < 0 && options.userInfo.vipDays >= -PERSONAL_FREE_NEWLY_EXPIRED_DAYS;
        if (isPersonalFreeNewlyExpired) {
            return StorageCostUserIdentityKind.PersonalFreeNewlyExpired;
        }
        return StorageCostUserIdentityKind.PersonalFreeOther;
    }
    var isProVip = options.userInfo.vipLevel === userInfo/* VipLevel.ProCn */.Dv.ProCn;
    return isProVip ? StorageCostUserIdentityKind.PersonalProVip : StorageCostUserIdentityKind.PersonalStandardVip;
};
var isTeamManagerRole = function isTeamManagerRole(role) {
    return role === teamInfo/* TeamRoleType.owner */.xO.owner || role === teamInfo/* TeamRoleType.admin */.xO.admin;
};
var resolveIdentityKind = function resolveIdentityKind(options) {
    var _teamInfo$member, _checkTeamStatusIsVip;
    var teamInfo = (0,dist_teamInfo/* getTeamInfo */.Iu)();
    if (!(0,dist_teamInfo/* checkIsTeam */.hU)(teamInfo)) {
        return resolvePersonalIdentityKind(options);
    }
    var isManager = isTeamManagerRole(teamInfo === null || teamInfo === void 0 || (_teamInfo$member = teamInfo.member) === null || _teamInfo$member === void 0 ? void 0 : _teamInfo$member.role);
    var isEnterprise = (0,dist_teamInfo/* checkTeamIsEnterprise */.Yt)(teamInfo);
    var isTeamVip = (_checkTeamStatusIsVip = (0,dist_teamInfo/* checkTeamStatusIsVip */.zb)(teamInfo)) !== null && _checkTeamStatusIsVip !== void 0 ? _checkTeamStatusIsVip : false;
    if (isEnterprise) {
        if (isTeamVip) {
            return isManager ? StorageCostUserIdentityKind.EnterpriseNoExpiredAdmin : StorageCostUserIdentityKind.EnterpriseNoExpiredMember;
        }
        return isManager ? StorageCostUserIdentityKind.EnterpriseExpiredAdmin : StorageCostUserIdentityKind.EnterpriseExpiredMember;
    }
    if (isTeamVip) {
        return isManager ? StorageCostUserIdentityKind.TeamVipAdmin : StorageCostUserIdentityKind.TeamVipMember;
    }
    return isManager ? StorageCostUserIdentityKind.TeamFreeAdmin : StorageCostUserIdentityKind.TeamFreeMember;
};
/**
 * 后端结构 -> 通用状态结构
 */ var transformStorageCostStatus = function transformStorageCostStatus(apiData, options) {
    var _apiData$soon_expire_, _apiData$expired_coun;
    var _options$userInfo = options.userInfo, vipDays = _options$userInfo.vipDays, isVip = _options$userInfo.isVip;
    var isMembershipNewlyExpired = !isVip && vipDays < 0 && vipDays >= -PERSONAL_FREE_NEWLY_EXPIRED_DAYS;
    var isMembershipSoonExpire = isVip && !isMembershipNewlyExpired && vipDays > 0 && vipDays <= MEMBERSHIP_SOON_EXPIRE_DAYS;
    return {
        identity: resolveIdentityKind(options),
        space: {
            capacity: apiData.capacity,
            usedSize: apiData.used_size,
            lowSpaceThreshold: LOW_SPACE_THRESHOLD
        },
        lifecycle: {
            isMembershipSoonExpire: isMembershipSoonExpire,
            isMembershipNewlyExpired: isMembershipNewlyExpired
        },
        soonExpireFileCount: (_apiData$soon_expire_ = apiData.soon_expire_count) !== null && _apiData$soon_expire_ !== void 0 ? _apiData$soon_expire_ : 0,
        expiredFileCount: (_apiData$expired_coun = apiData.expired_count) !== null && _apiData$expired_coun !== void 0 ? _apiData$expired_coun : 0
    };
};

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/storageCost/init.js













/**
 * 仅用于 {@link StorageCostService.init} 内弹窗调度，不写入 {@link StorageCostStatus}、不对外导出。
 */ var StorageCostInitModalKind = /*#__PURE__*/ function(StorageCostInitModalKind) {
    StorageCostInitModalKind["FileSoonExpire"] = "file_soon_expire";
    StorageCostInitModalKind["SpaceLow"] = "space_low";
    StorageCostInitModalKind["SpaceFull"] = "space_full";
    StorageCostInitModalKind["MembershipNewlyExpired"] = "membership_newly_expired";
    return StorageCostInitModalKind;
}(StorageCostInitModalKind || {});
var TEAM_OR_ENTERPRISE_MEMBER_IDENTITIES = new Set([
    StorageCostUserIdentityKind.TeamFreeMember,
    StorageCostUserIdentityKind.TeamVipMember,
    StorageCostUserIdentityKind.EnterpriseNoExpiredMember,
    StorageCostUserIdentityKind.EnterpriseExpiredMember
]);
var ALERT_PRIORITY = [
    StorageCostInitModalKind.FileSoonExpire,
    StorageCostInitModalKind.MembershipNewlyExpired,
    StorageCostInitModalKind.SpaceFull
];
var resolvePageMode = function resolvePageMode(options) {
    var _options$pageMode;
    return (_options$pageMode = options.pageMode) !== null && _options$pageMode !== void 0 ? _options$pageMode : "no-aigc";
};
var isAlertShownToday = function isAlertShownToday(pageMode, alertType) {
    var resolveAlertDailyLimitKind = function resolveAlertDailyLimitKind(alertType) {
        switch(alertType){
            case StorageCostInitModalKind.FileSoonExpire:
                return "fileTime";
            case StorageCostInitModalKind.SpaceFull:
            case StorageCostInitModalKind.SpaceLow:
            case StorageCostInitModalKind.MembershipNewlyExpired:
                return "space";
            default:
                return null;
        }
    };
    var limitKind = resolveAlertDailyLimitKind(alertType);
    return limitKind ? hasStorageCostAlertShownToday(pageMode, limitKind) : false;
};
var ensureTeamInfoReady = /*#__PURE__*/ function() {
    var _ref = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
        var _getConfig, isTeam;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    _getConfig = (0,configProvider/* getConfig */.iE)(), isTeam = _getConfig.isTeam;
                    if (isTeam) {
                        _context.next = 3;
                        break;
                    }
                    return _context.abrupt("return");
                case 3:
                    _context.prev = 3;
                    _context.next = 6;
                    return (0,dist_teamInfo/* fetchTeamInfo */.mR)();
                case 6:
                    _context.next = 11;
                    break;
                case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](3);
                    ;
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                3,
                8
            ]
        ]);
    }));
    return function ensureTeamInfoReady() {
        return _ref.apply(this, arguments);
    };
}();
var getMatchedAlerts = function getMatchedAlerts(status, isSpaceLow, isSpaceFull, options) {
    var pageMode = resolvePageMode(options);
    var hasFileRisk = status.expiredFileCount > 0 || status.soonExpireFileCount > 0;
    // 首页只弹文件时间告警
    if (pageMode === "home" && hasFileRisk) {
        return [
            StorageCostInitModalKind.FileSoonExpire
        ];
    }
    var matchedAlerts = [];
    if (hasFileRisk) {
        matchedAlerts.push(StorageCostInitModalKind.FileSoonExpire);
    }
    if (status.lifecycle.isMembershipNewlyExpired) {
        matchedAlerts.push(StorageCostInitModalKind.MembershipNewlyExpired);
    }
    if (isSpaceFull) {
        matchedAlerts.push(StorageCostInitModalKind.SpaceFull);
    } else if (isSpaceLow) {
        matchedAlerts.push(StorageCostInitModalKind.SpaceLow);
    }
    return matchedAlerts;
};
var getTopPriorityAlert = function getTopPriorityAlert(status, isSpaceLow, isSpaceFull, options) {
    var pageMode = resolvePageMode(options);
    // space-manage / no-aigc：不弹 widgets 告警弹窗，由业务自行承接（如编辑器 TopBanner）
    if (pageMode === "space-manage" || pageMode === "no-aigc") return null;
    if (isSpaceFull && pageMode !== "home" && !isAlertShownToday(pageMode, StorageCostInitModalKind.SpaceFull)) {
        return StorageCostInitModalKind.SpaceFull;
    }
    var matchedAlerts = getMatchedAlerts(status, isSpaceLow, isSpaceFull, options);
    for(var _i = 0, _ALERT_PRIORITY = ALERT_PRIORITY; _i < _ALERT_PRIORITY.length; _i++){
        var alertType = _ALERT_PRIORITY[_i];
        if (matchedAlerts.includes(alertType) && !isAlertShownToday(pageMode, alertType)) {
            return alertType;
        }
    }
    return null;
};
/**
 * 是否阻止商业化存储弹窗
 * 团队版、企业版的相关通知，都只下发到管理员和创建团队的uid进行展示
 */ var shouldBlockAlertForIdentity = function shouldBlockAlertForIdentity(identity) {
    return TEAM_OR_ENTERPRISE_MEMBER_IDENTITIES.has(identity);
};
var canShowUpgradeAction = function canShowUpgradeAction(identity) {
    return identity !== StorageCostUserIdentityKind.PersonalProVip && identity !== StorageCostUserIdentityKind.TeamVipAdmin && identity !== StorageCostUserIdentityKind.EnterpriseNoExpiredAdmin;
};
var resolveSpaceFullModalConfig = function resolveSpaceFullModalConfig(status, options) {
    var pageMode = resolvePageMode(options);
    var isFree = [
        StorageCostUserIdentityKind.PersonalFreeOther,
        StorageCostUserIdentityKind.PersonalFreeNewlyExpired,
        StorageCostUserIdentityKind.TeamFreeAdmin,
        StorageCostUserIdentityKind.TeamFreeMember,
        StorageCostUserIdentityKind.EnterpriseExpiredAdmin,
        StorageCostUserIdentityKind.EnterpriseExpiredMember
    ].includes(status.identity);
    var showUpgradeAction = canShowUpgradeAction(status.identity);
    var iconColor = showUpgradeAction ? undefined : "var(--content-system-info-icon-regular)";
    var _getLocaleStore = (0,i18n/* getLocaleStore */.IK)(), $t = _getLocaleStore.$t;
    var title = showUpgradeAction ? $t(function(v) {
        return v.Title_StorageFull;
    }) : $t(function(v) {
        return v.Title_StorageFullPleaseClean;
    });
    var freeText = isFree ? $t(function(v) {
        return v.Text_Free;
    }) : "";
    var upgradeText = showUpgradeAction ? $t(function(v) {
        return v.Text_OrUpgradeMember;
    }) : "";
    switch(pageMode){
        case "home":
        case "space-manage":
            return null;
        case "project":
            return {
                iconColor: iconColor,
                title: title,
                description: $t(function(v, _ref2) {
                    var r = _ref2.r;
                    return r(v.Desc_StorageFull, [
                        freeText,
                        upgradeText
                    ]);
                }),
                showUpgradeAction: showUpgradeAction
            };
        case "aigc":
            return {
                iconColor: iconColor,
                title: title,
                description: $t(function(v, _ref3) {
                    var r = _ref3.r;
                    return r(v.Desc_StorageFullAigc, [
                        freeText,
                        upgradeText
                    ]);
                }),
                showUpgradeAction: showUpgradeAction
            };
        default:
            return null;
    }
};
var buildUpgradeSubText = function buildUpgradeSubText(alertType, options) {
    var pageMode = resolvePageMode(options);
    var _getLocaleStore2 = (0,i18n/* getLocaleStore */.IK)(), $t = _getLocaleStore2.$t;
    if (alertType === StorageCostInitModalKind.SpaceFull) {
        return $t(function(v) {
            return v.Text_UnlockMoreStorage;
        });
    }
    if (pageMode !== "home") {
        return $t(function(v) {
            return v.Text_FilesSavedForever;
        });
    }
    return $t(function(v) {
        return v.Text_UnlockMoreStorage;
    });
};
var openAlertModal = function openAlertModal(status, alertType, options) {
    var pageMode = resolvePageMode(options);
    if (shouldBlockAlertForIdentity(status.identity)) {
        return;
    }
    var _getLocaleStore3 = (0,i18n/* getLocaleStore */.IK)(), $t = _getLocaleStore3.$t;
    var handleClickTrack = function handleClickTrack(clickType) {
        var _options$onTrack;
        (_options$onTrack = options.onTrack) === null || _options$onTrack === void 0 || _options$onTrack.call(options, "space_upgrade_click", {
            class: alertType === StorageCostInitModalKind.SpaceFull ? "lack" : "expiring_soon",
            click_type: clickType
        });
    };
    var handleShowTrack = function handleShowTrack(showType) {
        var _options$onTrack2;
        (_options$onTrack2 = options.onTrack) === null || _options$onTrack2 === void 0 || _options$onTrack2.call(options, "space_upgrade_show", {
            class: showType === "spaceRisk" ? "lack" : "expiring_soon"
        });
    };
    var hasUpgradeAction = canShowUpgradeAction(status.identity);
    var openVipByContext = function openVipByContext() {
        var _options$onOpenVipMod;
        handleClickTrack("yes");
        (_options$onOpenVipMod = options.onOpenVipModal) === null || _options$onOpenVipMod === void 0 || _options$onOpenVipMod.call(options);
    };
    var openSpaceManager = function openSpaceManager(options) {
        handleClickTrack("clean");
        if (options.onOpenSpaceManager) {
            options.onOpenSpaceManager();
            return;
        }
        window.location.href = "/space/manage/";
    };
    // 首页不弹空间满弹窗
    if (alertType === StorageCostInitModalKind.SpaceFull && options.pageMode !== "home") {
        if (hasStorageCostAlertShownToday(pageMode, "space")) {
            return;
        }
        var spaceFullModalConfig = resolveSpaceFullModalConfig(status, options);
        if (spaceFullModalConfig) {
            handleShowTrack("spaceRisk");
            markStorageCostAlertShownToday(pageMode, "space");
            openStorageCostAlertModal({
                iconColor: spaceFullModalConfig.iconColor,
                title: spaceFullModalConfig.title,
                description: spaceFullModalConfig.description,
                primaryAction: spaceFullModalConfig.showUpgradeAction ? {
                    iconName: "VipBoldFill",
                    text: $t(function(v) {
                        return v.Button_UpgradeMember;
                    }),
                    subText: buildUpgradeSubText(alertType, options),
                    onClick: openVipByContext
                } : undefined,
                secondaryAction: {
                    text: $t(function(v) {
                        return v.Button_CleanSpace;
                    }),
                    onClick: function onClick() {
                        return openSpaceManager(options);
                    }
                },
                onClose: function onClose(isManualClose) {
                    if (isManualClose) {
                        handleClickTrack("close");
                    }
                }
            });
        }
        return;
    }
    // 首页才弹文件时间告警弹窗
    if (alertType === StorageCostInitModalKind.FileSoonExpire && options.pageMode === "home") {
        if (hasStorageCostAlertShownToday(pageMode, "fileTime")) {
            return;
        }
        handleShowTrack("fileTimeRisk");
        markStorageCostAlertShownToday(pageMode, "fileTime");
        openStorageCostAlertModal({
            title: $t(function(v) {
                return v.Title_FileExpiringSoon;
            }),
            description: $t(function(v) {
                return v.Desc_FileExpireAutoClean;
            }),
            primaryAction: hasUpgradeAction ? {
                iconName: "VipBoldFill",
                text: $t(function(v) {
                    return v.Button_UpgradeMember;
                }),
                subText: buildUpgradeSubText(alertType, options),
                onClick: openVipByContext
            } : undefined,
            secondaryAction: {
                text: $t(function(v) {
                    return v.Button_OrganizeFiles;
                }),
                onClick: function onClick() {
                    return openSpaceManager(options);
                }
            },
            onClose: function onClose(isManualClose) {
                if (isManualClose) {
                    handleClickTrack("close");
                }
            }
        });
        return;
    }
};
var checkIsMobile = function checkIsMobile() {
    var ua = navigator.userAgent.toLowerCase();
    var isPCWechat = ua.includes("macwechat") || ua.includes("windowswechat");
    return /iphone|ipod|android.*mobile|mobile|windows phone|micromessenger/i.test(ua) && !isPCWechat;
};
/**
 * 存储治理通用服务：
 * - new 时不需要传参
 * - init 时才接收业务参数
 * - 支持读取最近一次状态，供业务自行控制提示
 */ var StorageCostService = /*#__PURE__*/ function() {
    function StorageCostService() {
        (0,classCallCheck/* default */.Z)(this, StorageCostService);
        (0,defineProperty/* default */.Z)(this, "storageCostStatus", null);
    }
    (0,createClass/* default */.Z)(StorageCostService, [
        {
            key: "init",
            value: function() {
                var _init = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee2(options) {
                    var apiData, status, spaceRatio, isSpaceLow, isSpaceFull, topAlertType;
                    return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
                        while(1)switch(_context2.prev = _context2.next){
                            case 0:
                                if (!checkIsMobile()) {
                                    _context2.next = 2;
                                    break;
                                }
                                throw new Error("storage cost is not supported on mobile");
                            case 2:
                                _context2.next = 4;
                                return ensureTeamInfoReady();
                            case 4:
                                _context2.next = 6;
                                return fetchStorageCostSummary();
                            case 6:
                                apiData = _context2.sent;
                                status = transformStorageCostStatus(apiData, options);
                                spaceRatio = status.space.capacity > 0 ? status.space.usedSize / status.space.capacity : 0;
                                isSpaceLow = status.space.capacity > 0 && spaceRatio >= 1 - status.space.lowSpaceThreshold;
                                isSpaceFull = status.space.capacity > 0 && status.space.usedSize >= status.space.capacity;
                                topAlertType = getTopPriorityAlert(status, isSpaceLow, isSpaceFull, options);
                                this.storageCostStatus = status;
                                if (topAlertType) {
                                    openAlertModal(status, topAlertType, options);
                                }
                                return _context2.abrupt("return", status);
                            case 15:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function init(_x) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "getStorageCostStatus",
            value: function getStorageCostStatus() {
                return this.storageCostStatus;
            }
        }
    ]);
    return StorageCostService;
}();

;// CONCATENATED MODULE: ./src/services/storage-cost.ts


const storageCostService = new StorageCostService();
let isChecking = false;
const triggerGenerateStorageAlert = (param)=>{
    let { userInfo , onOpenVipModal , onOpenSpaceManager  } = param;
    if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || isChecking) {
        return;
    }
    isChecking = true;
    var _vip_level, _vip_days, _vip_end_time;
    storageCostService.init({
        pageMode: "aigc",
        userInfo: {
            isVip: Boolean(userInfo.is_vip),
            vipLevel: (_vip_level = userInfo.vip_level) !== null && _vip_level !== void 0 ? _vip_level : 0,
            vipDays: (_vip_days = userInfo.vip_days) !== null && _vip_days !== void 0 ? _vip_days : 0,
            vipEndTime: (_vip_end_time = userInfo.vip_end_time) !== null && _vip_end_time !== void 0 ? _vip_end_time : -1
        },
        onOpenVipModal,
        onOpenSpaceManager,
        onTrack: mtstat/* statTrack */.SF
    }).catch((error)=>{
        ;
    }).finally(()=>{
        isChecking = false;
    });
};

// EXTERNAL MODULE: ./src/utils/request.ts + 5 modules
var utils_request = __webpack_require__(35707);
;// CONCATENATED MODULE: ./src/pages/appLogic.tsx















const AppLogic = ()=>{
    const finishWidgetsConfig = (0,store/* useStoreActions */.WX)((action)=>action.finishWidgetsConfig);
    const setIsOpenDeepSeek = (0,store/* useStoreActions */.WX)((actions)=>actions.setIsOpenDeepSeek);
    const setIsOpenPptCommercialization = (0,store/* useStoreActions */.WX)((actions)=>actions.setIsOpenPptCommercialization);
    const finishTrack = (0,store/* useStoreState */.Kw)((state)=>state.finishTrack);
    const userInfo = (0,store/* useStoreState */.Kw)((state)=>state.userModel.userInfo);
    const finishFetchUserInfo = (0,store/* useStoreState */.Kw)((state)=>state.userModel.isRequested);
    const storageCostInitUserIdRef = (0,react.useRef)(null);
    const disposeMtstatRef = (0,react.useRef)();
    const handleInitAbTest = async ()=>{
        await initABTest();
        if ((0,src_utils/* isMobile */.tq)()) {
            setIsOpenDeepSeek(true);
            return;
        }
        if ((0,sdk/* checkIsInSdk */.X)()) {
            setIsOpenDeepSeek(false);
        } else {
            setIsOpenDeepSeek(true);
        }
        isOpenPptCommercialization().then((isOpen)=>{
            setIsOpenPptCommercialization(isOpen);
        });
    };
    (0,useWpsNavigationIntercept/* useWpsNavigationIntercept */.d)();
    (0,source/* syncWpsSourceParamsFromUrl */._i)();
    const setWidgetsConfig = async ()=>{
        (0,configProvider/* setConfig */.v6)("client_id", (0,constants/* getClientID */.kU)());
        (0,configProvider/* setConfig */.v6)("env", "release");
        (0,configProvider/* setConfig */.v6)("app_key", (0,constants/* getAppKey */.AJ)());
        (0,configProvider/* setConfig */.v6)("module_id", constants/* MODULE_ID */.ce);
        (0,configProvider/* setConfig */.v6)("theme", "light");
        (0,configProvider/* setConfig */.v6)("isTeam", true);
        (0,configProvider/* setConfig */.v6)("isWpsUser", (0,utils/* isFromWPS */.ji)());
        (0,configProvider/* setConfig */.v6)("gid", (await (0,utils_request/* getCommonParams */.Kj)()).gid);
    };
    (0,react.useEffect)(()=>{
        // xdesign-widgets组件公共参数
        setWidgetsConfig();
        finishWidgetsConfig();
        // 依赖上面env的设置
        (0,uidKit/* initLocalUid */.sw)();
        const initFn = async ()=>{
            // 定制企业版逻辑
            await initEnterprise();
            const is = await __webpack_require__.e(/* import() */ 4437).then(__webpack_require__.bind(__webpack_require__, 34437));
            const runInitMtstat = ()=>{
                var ref;
                (ref = disposeMtstatRef.current) === null || ref === void 0 ? void 0 : ref.call(disposeMtstatRef);
                disposeMtstatRef.current = (0,mtstat/* initMtstat */.jt)(handleInitAbTest);
            };
            if (is.isMobile && (is.isXiuXiu || is.isPoster) && is.isIOS) {
                const onWebviewJsBridgeReady = ()=>{
                    ;
                    // 初始化埋点SDK逻辑
                    runInitMtstat();
                };
                window.addEventListener("WebviewJsBridgeReady", onWebviewJsBridgeReady);
                return ()=>{
                    window.removeEventListener("WebviewJsBridgeReady", onWebviewJsBridgeReady);
                };
            } else {
                // 初始化埋点SDK逻辑
                runInitMtstat();
            }
        };
        let isDisposed = false;
        let cleanupMtstatInit;
        initFn().then((cleanup)=>{
            if (isDisposed) {
                cleanup === null || cleanup === void 0 ? void 0 : cleanup();
                return;
            }
            cleanupMtstatInit = cleanup;
        });
        markRecentFeature(RecentFeatureKey.LivePPT);
        return ()=>{
            var ref;
            isDisposed = true;
            cleanupMtstatInit === null || cleanupMtstatInit === void 0 ? void 0 : cleanupMtstatInit();
            (ref = disposeMtstatRef.current) === null || ref === void 0 ? void 0 : ref.call(disposeMtstatRef);
            disposeMtstatRef.current = undefined;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    //埋点初始化完成并且用户信息请求完成
    (0,react.useEffect)(()=>{
        ;
        if (finishTrack && finishFetchUserInfo) {
            (0,mtstat/* setUserCommonParams */.xT)({
                isVip: userInfo === null || userInfo === void 0 ? void 0 : userInfo.is_vip,
                availableAmount: userInfo === null || userInfo === void 0 ? void 0 : userInfo.available_amount
            });
        }
    }, [
        finishTrack,
        finishFetchUserInfo,
        userInfo === null || userInfo === void 0 ? void 0 : userInfo.available_amount,
        userInfo === null || userInfo === void 0 ? void 0 : userInfo.is_vip
    ]);
    (0,react.useEffect)(()=>{
        if (userInfo) {
            (0,configProvider/* setConfig */.v6)("userInfo", userInfo);
        }
    }, [
        userInfo
    ]);
    (0,react.useEffect)(()=>{
        if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.id)) {
            return;
        }
        if (storageCostInitUserIdRef.current === userInfo.id) {
            return;
        }
        storageCostInitUserIdRef.current = userInfo.id;
        triggerGenerateStorageAlert({
            userInfo,
            onOpenVipModal: ()=>{
                (0,login/* openVipModal */.C2)({
                    entrance: "storage_space",
                    subscribe_type: ""
                });
            }
        });
    }, [
        userInfo
    ]);
    return null;
};
/* harmony default export */ const appLogic = (AppLogic);


/***/ }),

/***/ 29358:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": () => (/* binding */ src_store),
  "WX": () => (/* binding */ useStoreActions),
  "Kw": () => (/* binding */ useStoreState)
});

// UNUSED EXPORTS: useStoreDispatch

// EXTERNAL MODULE: ./node_modules/easy-peasy/dist/index.js + 3 modules
var dist = __webpack_require__(67238);
;// CONCATENATED MODULE: ./src/store/userModel/index.ts

const userModel = {
    userInfo: undefined,
    setUserInfo: (0,dist/* action */.aD)((state, value)=>{
        state.userInfo = value;
    }),
    meidouInfo: null,
    setMeidouInfo: (0,dist/* action */.aD)((state, value)=>{
        state.meidouInfo = value;
    }),
    cutoutInfo: null,
    setCutoutInfo: (0,dist/* action */.aD)((state, value)=>{
        state.cutoutInfo = value;
    }),
    isRequested: false,
    setIsRequested: (0,dist/* action */.aD)((state, value)=>{
        state.isRequested = value;
    })
};

;// CONCATENATED MODULE: ./src/store/index.ts


const store = (0,dist/* createStore */.MT)({
    userModel: userModel,
    isWidgetsConfigDone: false,
    finishWidgetsConfig: (0,dist/* action */.aD)((state)=>{
        state.isWidgetsConfigDone = true;
    }),
    isOpenDeepSeek: true,
    setIsOpenDeepSeek: (0,dist/* action */.aD)((state, payload)=>{
        state.isOpenDeepSeek = payload;
    }),
    finishTrack: false,
    setFinishTrack: (0,dist/* action */.aD)((state, payload)=>{
        state.finishTrack = payload;
    }),
    isOpenPptCommercialization: undefined,
    setIsOpenPptCommercialization: (0,dist/* action */.aD)((state, payload)=>{
        state.isOpenPptCommercialization = payload;
    })
});
const typedHooks = (0,dist/* createTypedHooks */.tl)();
const useStoreState = typedHooks.useStoreState;
const useStoreActions = typedHooks.useStoreActions;
const useStoreDispatch = typedHooks.useStoreDispatch;
/* harmony default export */ const src_store = (store);


/***/ }),

/***/ 35084:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": () => (/* binding */ getFirstUrl)
/* harmony export */ });
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20695);

/**
 * 首次进入页 URL：优先地址栏 first_url，其次 sessionStorage
 */ const getFirstUrl = ()=>{
    if (false) {}
    return decodeURIComponent((0,_query__WEBPACK_IMPORTED_MODULE_0__/* .getQueryParam */ .Ph)("first_url") || "") || window.sessionStorage.getItem("first_url") || "";
};


/***/ }),

/***/ 66138:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": () => (/* binding */ waitUntilGetGid)
/* harmony export */ });
/* unused harmony export getUnionDeviceId */
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57632);

let wgid = "";
let iframeDom = {};
/**
 * 同步主站(designkit.com)的wgid
 *
 * @return {*}  {Promise<string>}
 * const deviceId = await getUnionDeviceId();
 */ function getUnionDeviceId() {
    var ref, ref1;
    const gid = ((ref = window.mtstat) === null || ref === void 0 ? void 0 : (ref1 = ref.getStatsMarker) === null || ref1 === void 0 ? void 0 : ref1.call(ref)) || "";
    return gid;
}
/**
 * 循环取gid, 如果1s内没取到就随机生成(可能遇到埋点web sdk初始化失败)
 * @returns Promise<string>  返回gid
 */ const waitUntilGetGid = ()=>{
    return new Promise((resolve)=>{
        if (wgid) {
            resolve(wgid);
            return;
        }
        let loopTimes = 4;
        const getData = async ()=>{
            wgid = await getUnionDeviceId();
            if (!wgid && loopTimes === 0) {
                wgid = (0,uuid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
                resolve(wgid);
            } else if (!wgid) {
                setTimeout(()=>{
                    loopTimes = loopTimes - 1;
                    getData();
                }, 500);
            } else {
                resolve(wgid);
            }
        };
        getData();
    });
};


/***/ }),

/***/ 16598:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dt": () => (/* binding */ isAndroid),
/* harmony export */   "FZ": () => (/* binding */ isPcPlatform),
/* harmony export */   "G6": () => (/* binding */ isSafari),
/* harmony export */   "GP": () => (/* binding */ isQQ),
/* harmony export */   "Hq": () => (/* binding */ workerSleep),
/* harmony export */   "Lt": () => (/* binding */ filterParams),
/* harmony export */   "MH": () => (/* binding */ isFromHuaweiCustom),
/* harmony export */   "Q1": () => (/* binding */ thumbnail),
/* harmony export */   "R$": () => (/* binding */ isSupportWebp),
/* harmony export */   "T5": () => (/* binding */ getMatrixChannel),
/* harmony export */   "WY": () => (/* binding */ isJsonStr),
/* harmony export */   "_v": () => (/* binding */ sleep),
/* harmony export */   "b5": () => (/* binding */ getSource),
/* harmony export */   "fP": () => (/* binding */ getOsType),
/* harmony export */   "gn": () => (/* binding */ isIOS),
/* harmony export */   "iX": () => (/* binding */ getJSONByUrl),
/* harmony export */   "mr": () => (/* binding */ getChannel),
/* harmony export */   "qW": () => (/* binding */ isWeiXin),
/* harmony export */   "tq": () => (/* binding */ isMobile)
/* harmony export */ });
/* unused harmony exports loadScript, is, isNumber, getCookies, getClientInfo */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78264);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82289);


const getSessionStorage = (key)=>{
    return window.sessionStorage.getItem(key) && decodeURIComponent(window.sessionStorage.getItem(key));
};
const getChannel = ()=>{
    const params = query_string__WEBPACK_IMPORTED_MODULE_1__/* ["default"].parse */ .Z.parse(window.location.search);
    return params.channel && decodeURIComponent(params.channel) || getSessionStorage("channel") || "";
};
/**
 * 动态创建script标签
 * @param url
 * @param callback
 */ const loadScript = (url, callback)=>{
    const eleScript = document.createElement("script");
    eleScript.type = "text/javascript";
    eleScript.src = url;
    document.getElementsByTagName("head")[0].appendChild(eleScript);
    if (eleScript.readyState) {
        eleScript.onreadystatechange = function() {
            if (eleScript.readyState === "loaded" || eleScript.readyState === "complete") {
                eleScript.onreadystatechange = null;
                callback();
            }
        };
    } else {
        eleScript.onload = function() {
            callback();
        };
    }
};
const getMatrixChannel = ()=>{
    const params = query_string__WEBPACK_IMPORTED_MODULE_1__/* ["default"].parse */ .Z.parse(window.location.search);
    return params.matrix_channel || window.sessionStorage.getItem("matrix_channel") || _constants__WEBPACK_IMPORTED_MODULE_0__/* .MATRIX_CHANNEL */ .cr;
};
const is = (val, type)=>{
    return toString.call(val) === "[object ".concat(type, "]");
};
const isNumber = (val)=>{
    return is(val, "Number");
};
function getCookies(cookies) {
    try {
        if (!cookies) return {};
        const list = cookies.split(";");
        const params = {};
        for(let i = 0; i < list.length; i++){
            const [key, value] = list[i].split("=");
            params[key.trim()] = decodeURIComponent(value);
        }
        return params;
    } catch (e) {
        ;
        return {};
    }
}
const isMobile = ()=>{
    if (false) {}
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const sleep = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
// 判断gpt_content 是否为json字符串
const isJsonStr = (str)=>{
    if (typeof str === "string") {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    }
    return false;
};
const isSafari = ()=>{
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};
// 判断是否来自华为PC预装定制版内嵌
const isFromHuaweiCustom = ()=>{
    if (false) {}
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes("channel:zhyshop");
};
let supportWebp = undefined;
const isSupportWebp = ()=>{
    if (false) {}
    if (supportWebp === void 0) {
        supportWebp = document.createElement("canvas").toDataURL("image/webp").indexOf("data:image/webp") === 0;
    }
    return supportWebp;
};
const thumbnail = function(url, width) {
    let quality = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 80;
    var ref, ref1, ref2;
    if (/\.svg$/.test(url) || /\.(webp)$/.test(url)) return url;
    const params = query_string__WEBPACK_IMPORTED_MODULE_1__/* ["default"].parseUrl */ .Z.parseUrl(url);
    // imageView2 加上这个后，会导致不校验 token
    // 暂时不处理 token 地址
    if (params === null || params === void 0 ? void 0 : (ref = params.query) === null || ref === void 0 ? void 0 : ref.token) return url;
    // 加签参数需要保留
    const signString = (params === null || params === void 0 ? void 0 : (ref1 = params.query) === null || ref1 === void 0 ? void 0 : ref1.k) && (params === null || params === void 0 ? void 0 : (ref2 = params.query) === null || ref2 === void 0 ? void 0 : ref2.t) ? "&k=".concat(params.query.k, "&t=").concat(params.query.t) : "";
    // 分割参数，转 webp 将会被丢弃
    const uri = url.split("?");
    // 分割缩略图 https://material-center-pre.meitudata.com/material/image/6462f5d0f05f84631.png!thumb-w240
    const realUrl = uri[0].split("!");
    const currentUrl = "".concat(realUrl[0], "?imageView2/2").concat(width ? "/w/" + width : "");
    if (isSupportWebp()) {
        return "".concat(currentUrl, "/format/webp/q/").concat(quality, "/ignore-error/1").concat(signString);
    }
    return "".concat(currentUrl, "/q/").concat(quality, "/ignore-error/1").concat(signString);
};
const isAndroid = ()=>{
    if (false) {}
    return /Android/i.test(navigator.userAgent);
};
const isQQ = ()=>{
    if (false) {}
    return /QQ/i.test(navigator.userAgent);
};
const isWeiXin = ()=>{
    if (false) {}
    // 微信浏览器 或者 企业微信浏览器
    return /MicroMessenger/i.test(navigator.userAgent) || /wxwork/i.test(navigator.userAgent);
};
const workerScript = "\n    onmessage = function(event) {\n        const { timeout } = event.data;\n\n        setTimeout(() => {\n            postMessage('done');\n        }, timeout);\n    };\n";
const workerSleep = function() {
    let timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1000;
    return new Promise((resolve)=>{
        const blob = new Blob([
            workerScript
        ], {
            type: "application/javascript"
        });
        const worker = new Worker(URL.createObjectURL(blob));
        worker.onmessage = function() {
            resolve();
            worker.terminate(); // 结束工作者线程
        };
        worker.postMessage({
            timeout
        });
    });
};
const getJSONByUrl = async (url)=>{
    return new Promise((resolve, reject)=>{
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "json";
        xhr.onload = ()=>{
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve(xhr.response);
            } else {
                reject(new Error("请求失败，状态码：".concat(xhr.status)));
            }
        };
        xhr.onerror = ()=>{
            reject(new Error("网络错误"));
        };
        xhr.send();
    });
};
const isIOS = ()=>{
    if (false) {}
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};
const filterParams = (params)=>{
    let paramsStr = "?";
    for(const key in params){
        paramsStr += "".concat(key, "=").concat(key === "tool_url" ? encodeURIComponent(params[key]) : params[key], "&");
    }
    return paramsStr.slice(0, -1);
};
let clientInfo = undefined;
const getClientInfo = async ()=>{
    if (!clientInfo && "object" !== "undefined") {
        clientInfo = await __webpack_require__.e(/* import() */ 1022).then(__webpack_require__.t.bind(__webpack_require__, 21022, 23)).then((res)=>res.clientInfo);
    }
    return clientInfo;
};
const isPcPlatform = async ()=>{
    if (!clientInfo && "object" !== "undefined") {
        clientInfo = await getClientInfo();
    }
    if (clientInfo === null || clientInfo === void 0 ? void 0 : clientInfo.isClient) {
        return true;
    }
    return false;
};
const getOsType = async ()=>{
    let osType = "web";
    if ((await getClientInfo()).isClient) {
        osType = (await getClientInfo()).isMac ? "macos" : "windows";
    }
    return osType;
};
const getSource = async ()=>{
    const clientInfo = await getClientInfo();
    let source = "";
    if (clientInfo.isMac || clientInfo.isMacAppStore) {
        source = "MTXX-MAC";
    } else if (clientInfo.isPC) {
        source = "MTXX-PC";
    } else if (clientInfo.isLinux) {
        source = "MTXX-LINUX";
    } else {
        source = "MTXX-WEB";
    }
    return source;
};


/***/ }),

/***/ 93567:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "RN": () => (/* binding */ getCallback),
  "bG": () => (/* binding */ getUserInfo),
  "hY": () => (/* binding */ handleLogout),
  "Br": () => (/* binding */ initAccount),
  "lU": () => (/* binding */ jumpToLogin),
  "C2": () => (/* binding */ openVipModal)
});

// UNUSED EXPORTS: updateLogoutAccessToken

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-identity/lib/index.js
var lib = __webpack_require__(99861);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/overseasAccessModal/jumpQuery.js
var overseasAccessModal_jumpQuery = __webpack_require__(50767);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/index.js
var teamInfo = __webpack_require__(72838);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/uidKit.js
var uidKit = __webpack_require__(53421);
// EXTERNAL MODULE: ./src/constants/code.ts
var code = __webpack_require__(56105);
// EXTERNAL MODULE: ./src/utils/request.ts + 5 modules
var utils_request = __webpack_require__(35707);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(78264);
;// CONCATENATED MODULE: ./src/services/user/index.ts
/* provided dependency */ var process = __webpack_require__(34155);


/**
 * 用户信息详情
 * @docs: https://api-mock.meitu-int.com/project/1594/interface/api/82889
 */ const fetchUserInfo = async function() {
    return await (0,utils_request/* default */.ZP)("".concat((0,constants/* getIntranetHost */.Cu)(), "/user/info"), {
        method: "GET",
        hideErrorToast: true
    });
};
const fetchUnReadMessage = async function(params) {
    return await request("".concat(process.env.REACT_APP_API_FEEDBACK, "/im_v2/unread_count.json"), {
        method: "GET",
        data: params
    });
};

// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(29358);
// EXTERNAL MODULE: ./src/utils/gid.ts
var utils_gid = __webpack_require__(66138);
;// CONCATENATED MODULE: ./node_modules/@meitu/saas-subscription-popup/dist/esm/types/enum.js
/**
 * 环境变量枚举
 */
var EnvEnum = /*#__PURE__*/function (EnvEnum) {
  EnvEnum["LOCAL"] = "local";
  EnvEnum["PRE"] = "pre";
  EnvEnum["BETA"] = "beta";
  EnvEnum["RELEASE"] = "release";
  return EnvEnum;
}({});
/**
 * 主题色
 */
var ThemeEnum = /*#__PURE__*/function (ThemeEnum) {
  ThemeEnum["DARK"] = "dark";
  ThemeEnum["LIGHT"] = "light";
  return ThemeEnum;
}({});
/**
 * 事件名称枚举
 */
var EventNameEnum = /*#__PURE__*/function (EventNameEnum) {
  EventNameEnum["SUCCESS"] = "success";
  EventNameEnum["FAIL"] = "fail";
  EventNameEnum["LOGININVALID"] = "login-invalid";
  EventNameEnum["CLOSE"] = "close";
  return EventNameEnum;
}({});
var CloseFromEnum = /*#__PURE__*/function (CloseFromEnum) {
  CloseFromEnum["PAYSUCCESS"] = "pay-success";
  CloseFromEnum["UNLOGIN"] = "unLogin";
  CloseFromEnum["CLOSE"] = "close";
  return CloseFromEnum;
}({});
;// CONCATENATED MODULE: ./node_modules/@meitu/saas-subscription-popup/dist/esm/constants/index.js
/**
 * 订阅弹窗样式
 */
var dialogCss = "\n  .saas-subscription-popup {\n    background-color: rgba(21, 20, 23, 0.75);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    z-index: 9999;\n  }\n\n  .saas-subscription-popup__inner {\n    width: 931px;\n    height: 588px;\n    border-radius: 12px;\n    background-color: #000;\n    position: relative;\n  }\n\n  .saas-subscription-popup.dark .saas-subscription-popup__inner {\n    background-color: #000;\n  }\n\n  .saas-subscription-popup__inner iframe {\n    border-radius: 12px;\n  }\n\n  .saas-subscription-popup__close {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    position: absolute;\n    right: 8px;\n    top: 8px;\n    transition: all 0.5s ease;\n  }\n\n  .saas-subscription-popup__close:hover {\n    transform: rotate(180deg);\n  }\n\n  @media screen and (max-height: 620px) {\n    .saas-subscription-popup {\n      display: block;\n      overflow: auto;\n      /* \u706B\u72D0\u7279\u5B9A\u6EDA\u52A8\u6761\u6837\u5F0F */\n      scrollbar-width: none;\n    }\n\n    .saas-subscription-popup::-webkit-scrollbar {\n      display: none;\n    }\n\n    .saas-subscription-popup__inner {\n      margin: 30px auto 0;\n    }\n  }\n";

/**
 * 权益对比弹窗样式
 */
var popupCss = "\n  .vip-compare-modal {\n    background-color: var(--background-system-overlay-mask, rgba(0, 0, 0, 0.5));\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1000000001;\n  }\n\n  .vip-compare-modal * {\n    box-sizing: border-box;\n  }\n\n  .vip-compare-modal__inner {\n    width: 630px;\n    max-width: 100vw;\n    height: 565px;\n    max-height: 100vh;\n    padding: 16px 16px 20px;\n    border-radius: 12px;\n    background: var(--background-system-frame-floatpanel, #FFF);\n    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.08), 0px 24px 128px 0px rgba(0, 0, 0, 0.16);\n    display: flex;\n    flex-direction: column;\n  }\n\n  .vip-compare-modal__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .vip-compare-modal__title {\n    color: var(--content-system-primary, #1C1D1F);\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 22px;\n  }\n\n  .vip-compare-modal__close {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    transition: all 0.5s ease;\n  }\n\n  .vip-compare-modal__close:hover {\n    transform: rotate(180deg);\n  }\n\n  .vip-compare-modal__body {\n    flex: 1;\n    margin-top: 16px;\n    padding-right: 2px;\n    overflow-y: auto;\n  }\n\n  .vip-compare-modal__body-inner {\n    color: var(--content-web-primary, #17181A);\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    border-radius: 4px;\n    border: 1px solid var(--stroke-system-border-overlay, rgba(0, 0, 0, 0.08));\n    position: relative;\n  }\n\n  .vip-compare-modal__body::-webkit-scrollbar {\n    display: block;\n    -webkit-appearance: none;\n  }\n\n  .vip-compare-modal__body::-webkit-scrollbar:vertical {\n    width: 4px;\n  }\n\n  .vip-compare-modal__body::-webkit-scrollbar-thumb {\n    border-radius: 8px;\n    border: 4px solid rgba(0, 0, 0, 0.2);\n    background-color: rgba(0, 0, 0, 0.2);\n  }\n\n  .vip-compare-modal__body-header {\n    position: sticky;\n    top: 0;\n    background: var(--background-system-frame-floatpanel, #FFF);\n  }\n\n  .vip-compare-modal__thead {\n    height: 40px;\n    background: var(--background-system-selected, #E5F2FF);\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid var(--stroke-system-border-overlay, rgba(0, 0, 0, 0.08));\n  }\n\n  .vip-compare-modal__trow {\n    height: 40px;\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid var(--stroke-system-border-overlay, rgba(0, 0, 0, 0.08));\n  }\n\n  .vip-compare-modal__cell {\n    width: 145px;\n    padding: 10px;\n    text-align: center;\n  }\n\n  .vip-compare-modal__cell:nth-child(1) {\n    width: auto;\n    flex: 1;\n    text-align: left;\n  }\n\n  .vip-compare-modal__tbody .vip-compare-modal__trow:last-child {\n    border-bottom: none;\n  }\n\n  .vip-compare-modal__trow-title {\n    background: var(--background-web-secondary, rgba(0, 30, 89, 0.04));\n  }\n";

/**
 * 阻断弹窗样式
 */
var retentionCss = "\n  .vip-retention-modal {\n    background-color: var(--background-system-overlay-mask, rgba(0, 0, 0, 0.5));\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1000000001;\n  }\n\n  .vip-retention-modal * {\n    box-sizing: border-box;\n  }\n\n  .vip-retention-modal__inner {\n    width: 300px;\n    height: 400px;\n    max-width: 100vw;\n    max-height: 100vh;\n    position: relative;\n  }\n\n  .vip-retention-modal__inner img {\n    width: 100%;\n  }\n\n  .vip-retention-modal__close {\n    width: 25px;\n    height: 25px;\n    cursor: pointer;\n    position: absolute;\n    right: 22px;\n    top: 22px;\n  }\n\n  .vip-retention-modal__btn {\n    width: 170px;\n    height: 45px;\n    cursor: pointer;\n    position: absolute;\n    left: 50%;\n    bottom: 33px;\n    transform: translateX(-50%);\n  }\n";

// 弹窗阻断次数缓存
var SAAS_SUBSCRIPTION_POPUP_RETENTION_NUMBER = "saas-subscription-popup-retention-number";
;// CONCATENATED MODULE: ./node_modules/@meitu/saas-subscription-popup/dist/esm/utils/index.js

/**
 * 版本权益对比弹窗
 */
var openVipComparePopup = function openVipComparePopup() {
  var dataSource = {
    内容服务: [["免费模版/PPT", true, true, true], ["免费字体", true, true, true], ["免费素材", true, true, true], ["付费模版/PPT", false, true, true], ["付费字体", false, true, true], ["付费素材", false, true, true], ["商用授权", false, "个人商用", "企业商用(1个主体)"]],
    创作工具: [["拼图", true, true, true], ["AI消除", false, true, true], ["AI尺寸延展", "限时免费", true, true], ["服装去皱", false, true, true], ["无损放大", false, true, true], ["变清晰", false, true, true]],
    多人协同: [["文件共享", true, true, true], ["文件夹共享", false, false, true], ["共享权限管理", false, false, true], ["品牌规范", false, false, true], ["模版库(PSD上传)", false, false, true]],
    团队管理: [["角色管理", false, false, true], ["数据看板", false, false, true], ["订单管理", false, false, true]],
    消耗品: [
    // ["智能抠图", false, "1200张/年", "100张*席位数/月"],
    ["会员美豆", false, "330个/月", "330个*席位数/月"]]
  };
  console.log(Object.keys(dataSource));
  var ele = document.createElement("div");
  ele.className = "vip-compare-modal";
  var strDom = "\n      <div class=\"vip-compare-modal__inner\">\n          <div class=\"vip-compare-modal__header\">\n              <span class=\"vip-compare-modal__title\">\u7248\u672C\u6743\u76CA\u8BF4\u660E</span>\n              <img class=\"vip-compare-modal__close\" src=\"https://public.static.meitudata.com/xiuxiu-pc/saas-subscription/close-icon.png\" alt=\"\">\n          </div>\n          <div class=\"vip-compare-modal__body\">\n            <div class=\"vip-compare-modal__body-inner\">\n              <div class=\"vip-compare-modal__body-header\">\n                  <div class=\"vip-compare-modal__thead\">\n                      <div class=\"vip-compare-modal__cell\">\u7248\u672C</div>\n                      <div class=\"vip-compare-modal__cell\">\u514D\u8D39\u7248</div>\n                      <div class=\"vip-compare-modal__cell\">\u4E2A\u4EBA\u7248VIP</div>\n                      <div class=\"vip-compare-modal__cell\">\u56E2\u961F\u7248VIP</div>\n                  </div>\n                  <div class=\"vip-compare-modal__trow\">\n                      <div class=\"vip-compare-modal__cell\">\u4EF7\u683C</div>\n                      <div class=\"vip-compare-modal__cell\">\xA50/\u5E74</div>\n                      <div class=\"vip-compare-modal__cell\">\xA5288/\u5E74</div>\n                      <div class=\"vip-compare-modal__cell\">\xA5318/\u5E74/\u4EBA</div>\n                  </div>\n                  <div class=\"vip-compare-modal__trow\">\n                      <div class=\"vip-compare-modal__cell\">\u9002\u7528\u4EBA\u6570</div>\n                      <div class=\"vip-compare-modal__cell\">1\u4EBA</div>\n                      <div class=\"vip-compare-modal__cell\">1\u4EBA</div>\n                      <div class=\"vip-compare-modal__cell\">\u591A\u4EBA</div>\n                  </div>\n              </div>\n              <div class=\"vip-compare-modal__tbody\">\n                  ";
  Object.keys(dataSource).forEach(function (key) {
    strDom += "\n          <div class=\"vip-compare-modal__trow\">\n              <div class=\"vip-compare-modal__cell vip-compare-modal__trow-title\">".concat(key, "</div>\n          </div>\n      ");
    dataSource[key].forEach(function (item) {
      strDom += "\n              <div class=\"vip-compare-modal__trow\">\n                  ";
      item.forEach(function (data) {
        if (typeof data === "string") {
          strDom += "\n                      <div class=\"vip-compare-modal__cell\">".concat(data, "</div>\n                  ");
        } else if (!!data) {
          strDom += "\n                      <div class=\"vip-compare-modal__cell\">\n                          <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\">\n                              <path d=\"M11.4018 2.21587C11.6968 2.50668 11.7001 2.98154 11.4093 3.2765L5.12216 9.6515C4.97783 9.79789 4.77975 9.87861 4.57421 9.87481C4.36868 9.87101 4.17372 9.78301 4.03491 9.63139L0.572068 5.86055C0.292363 5.55504 0.313286 5.08063 0.6188 4.80092C0.924313 4.52122 1.39873 4.54214 1.67843 4.84766L4.60823 8.03626L10.3412 2.22338C10.632 1.92842 11.1069 1.92506 11.4018 2.21587Z\" fill=\"#3388FF\"/>\n                          </svg>    \n                      </div>\n                  ";
        } else {
          strDom += "\n                      <div class=\"vip-compare-modal__cell\"></div>\n                  ";
        }
      });
      strDom += "\n              </div>\n          ";
    });
  });
  strDom += "\n              </div>\n          </div>\n        </div>\n      </div>\n    ";
  ele.innerHTML = strDom;
  document.body.appendChild(ele);

  // 创建样式
  var eleStyle = document.createElement("style");
  eleStyle.innerHTML = popupCss;
  document.head.appendChild(eleStyle);
  var eleClose = document.querySelector(".vip-compare-modal__close");
  if (eleClose) {
    eleClose.onclick = function () {
      document.body.removeChild(ele);
      document.head.removeChild(eleStyle);
    };
  }
};
// EXTERNAL MODULE: ./node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js
var bodyScrollLock_esm = __webpack_require__(58509);
;// CONCATENATED MODULE: ./node_modules/@meitu/saas-subscription-popup/dist/esm/lib/index.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




var SaasSubscription = /*#__PURE__*/function () {
  function SaasSubscription(_params) {
    var _this = this;
    _classCallCheck(this, SaasSubscription);
    _defineProperty(this, "env", void 0);
    _defineProperty(this, "theme", void 0);
    _defineProperty(this, "commonParams", void 0);
    _defineProperty(this, "eventHandlers", {});
    _defineProperty(this, "shouldRetention", false);
    _defineProperty(this, "onTrack", void 0);
    /**
     * 弹窗元素
     */
    _defineProperty(this, "ele", null);
    /**
     * 弹窗元素
     */
    _defineProperty(this, "eleIframe", null);
    /**
     * 权益对比弹窗元素
     */
    _defineProperty(this, "elePopup", null);
    /**
     * 关闭按钮元素
     */
    _defineProperty(this, "eleClose", null);
    _defineProperty(this, "messageHandler", function (e) {
      var data = e.data || e.originalEvent && e.originalEvent.data;
      if (typeof data === "string" && /^[\[\{]/.test(data)) {
        data = JSON.parse(data);
      }

      // 关闭订阅弹窗通知
      if (data && data.action === "closeVipSubscribeDialog") {
        // 未登录
        if (data.data && data.data.needLogin) {
          var handler = _this.eventHandlers[EventNameEnum.LOGININVALID];
          if (handler) {
            handler();
          }
          _this.close(false, CloseFromEnum.UNLOGIN);
          return;
        }

        // 支付成功
        if (data.data && data.data.success) {
          var _handler = _this.eventHandlers[EventNameEnum.SUCCESS];
          if (_handler) {
            _handler();
          }
          _this.close(false, CloseFromEnum.PAYSUCCESS);
          return;
        }
        _this.close(false, CloseFromEnum.CLOSE);
      } else if (data && data.action === "changeCloseVipSubscribeDialogCloseIcon") {
        // 显示/隐藏弹窗关闭按钮
        if (data.data) {
          if (_this.eleClose) {
            var _data$data;
            _this.eleClose.style.visibility = (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.status ? "visible" : "hidden";
          }
        }
      } else if (data && data.action === "openVipComparePopup") {
        // 打开版本权益说明弹窗
        openVipComparePopup();
      }
    });
    /**
     * 获取最新的订阅访问URL
     * @param customParams 自定义参数
     * @returns
     */
    _defineProperty(this, "getLatestUrl", function (customParams) {
      var params = Object.assign({}, _this.commonParams, customParams);
      var queryString = Object.keys(params).reduce(function (str, key) {
        return str + "".concat(key, "=").concat(encodeURIComponent(params[key] || ""), "&");
      }, "");
      var preHost = "";
      if (
      // /\.meitu\.com/.test(window.location.host) ||
      /localhost/.test(window.location.host)) {
        // .meitu.com 域名，都统一走pc.meitu.com域名
        switch (_this.env) {
          case EnvEnum.PRE:
          case EnvEnum.LOCAL:
            preHost = "https://prepc.meitu.com";
            break;
          case EnvEnum.BETA:
            preHost = "https://betapc.meitu.com";
            break;
          case EnvEnum.RELEASE:
            preHost = "https://pc.meitu.com";
            break;
          default:
        }
      } else {
        // 非.meitu.com 域名，都统一走当前域名
        preHost = "".concat(window.location.protocol, "//").concat(window.location.host);
      }

      // 本地开发
      if (_this.env === EnvEnum.LOCAL) {
        preHost = "https://prepc.meitu.com";
      }
      return "".concat(preHost, "/vip?theme=").concat(_this.theme, "&").concat(queryString);
    });
    /**
     * 更新弹窗大小
     */
    _defineProperty(this, "updateDialogSize", function (isOnlyShowScanUIPopup) {
      if (!_this.ele) return;
      var eleInner = _this.ele.querySelector(".saas-subscription-popup__inner");
      if (!eleInner) return;
      if (isOnlyShowScanUIPopup) {
        eleInner.style.width = "400px";
        eleInner.style.height = "430px";
      } else {
        // 恢复默认大小（通过移除内联样式，使用CSS默认值）
        eleInner.style.width = "";
        eleInner.style.height = "";
      }
    });
    /**
     * 创建弹窗容器
     */
    _defineProperty(this, "createDialog", function (isOnlyShowScanUIPopup) {
      // 创建容器
      var eleDialog = document.createElement("div");
      eleDialog.className = "saas-subscription-popup ".concat(_this.theme);
      var eleInner = document.createElement("div");
      eleInner.className = "saas-subscription-popup__inner";
      if (isOnlyShowScanUIPopup) {
        eleInner.style.width = "400px";
        eleInner.style.height = "430px";
      }

      // 创建关闭安按钮
      var eleClose = document.createElement("img");
      eleClose.className = "saas-subscription-popup__close";
      eleClose.src = "https://public.static.meitudata.com/x-design/subscription/close.png";
      eleClose.onclick = function () {
        var _window;
        // 重置为业务的uid
        // window.mtstat埋点login的uid值
        // 解决个人版打开团队版订阅弹窗场景，导致埋点的uid不对问题
        var uid = window.localStorage.getItem("uid");
        if (uid) (_window = window) === null || _window === void 0 || (_window = _window.mtstat) === null || _window === void 0 || _window.login(uid);
        _this.close();
      };

      // 创建iframe
      var iframe = document.createElement("iframe");
      iframe.style.width = "100%";
      iframe.style.height = "100%";
      iframe.style.border = "none";
      iframe.src = _this.getLatestUrl({});
      eleInner.appendChild(iframe);
      eleInner.appendChild(eleClose);
      eleDialog.appendChild(eleInner);

      // 创建样式
      var eleStyle = document.createElement("style");
      eleStyle.innerHTML = dialogCss;
      document.head.appendChild(eleStyle);
      _this.ele = eleDialog;
      _this.eleClose = eleClose;
      _this.eleIframe = iframe;
    });
    /**
     *
     * 阻断弹窗
     */
    _defineProperty(this, "createRetentionDialog", function () {
      var _this$onTrack3;
      var ele = document.createElement("div");
      ele.className = "vip-retention-modal";
      var strDom = "\n        <div class=\"vip-retention-modal__inner\">\n            <img src=\"https://public.static.meitudata.com/xiuxiu-pc/saas-subscription/retention-bg.png\" alt=\"\">\n            <div class=\"vip-retention-modal__close\"></div>\n            <div class=\"vip-retention-modal__btn\"></div>    \n        </div>\n        ";
      ele.innerHTML = strDom;
      document.body.appendChild(ele);

      // 创建样式
      var eleStyle = document.createElement("style");
      eleStyle.innerHTML = retentionCss;
      document.head.appendChild(eleStyle);
      var eleClose = document.querySelector(".vip-retention-modal__close");
      var eleBtn = document.querySelector(".vip-retention-modal__btn");
      if (eleClose) {
        eleClose.onclick = function () {
          var _this$onTrack;
          // 关闭阻断弹窗
          document.body.removeChild(ele);
          // 关闭订阅弹窗
          _this.close(false);
          (_this$onTrack = _this.onTrack) === null || _this$onTrack === void 0 || _this$onTrack.call(_this, "operations_popup_click", {
            func: "retention_popup",
            class: "close"
          });
        };
      }
      if (eleBtn) {
        eleBtn.onclick = function () {
          var _this$eleIframe, _this$onTrack2;
          // 重置阻拦状态
          _this.shouldRetention = false;
          // 关闭阻断弹窗
          document.body.removeChild(ele);
          // 通知订阅弹窗展示会员购买场景
          (_this$eleIframe = _this.eleIframe) === null || _this$eleIframe === void 0 || (_this$eleIframe = _this$eleIframe.contentWindow) === null || _this$eleIframe === void 0 || _this$eleIframe.postMessage(JSON.stringify({
            action: "viewSubscription" // 查看购买会员商品组
          }), _this.getLatestUrl({}).replace(/\/vip?.+/, ""));
          (_this$onTrack2 = _this.onTrack) === null || _this$onTrack2 === void 0 || _this$onTrack2.call(_this, "operations_popup_click", {
            func: "retention_popup",
            class: "to_see"
          });
        };
      }
      (_this$onTrack3 = _this.onTrack) === null || _this$onTrack3 === void 0 || _this$onTrack3.call(_this, "operations_popup_show", {
        func: "retention_popup"
      });
    });
    this.env = _params.env || "release";
    this.theme = _params.theme || "light";
    this.commonParams = _params.commonParams || {};
  }

  /**
   * 监听事件
   *
   * @param eventName 事件名
   * @param handler 回调函数
   * @returns
   */
  _createClass(SaasSubscription, [{
    key: "on",
    value: function on(eventName, handler) {
      this.eventHandlers[eventName] = handler;
      return this;
    }

    /**
     * 打开弹窗
     * @param customParams 自定义参数
     * @returns
     */
  }, {
    key: "open",
    value: function open(customParams, otherParams) {
      this.shouldRetention = !!(otherParams !== null && otherParams !== void 0 && otherParams.shouldRetention);
      this.onTrack = otherParams === null || otherParams === void 0 ? void 0 : otherParams.onTrack;
      if (!this.ele) {
        this.createDialog(!!(customParams !== null && customParams !== void 0 && customParams.isOnlyShowScanUI));
      } else {
        // 弹窗已存在时，更新弹窗大小
        this.updateDialogSize(!!(customParams !== null && customParams !== void 0 && customParams.isOnlyShowScanUI));
      }
      if (this.eleIframe) {
        this.eleIframe.src = this.getLatestUrl(customParams);
      }
      if (this.ele) {
        document.body.appendChild(this.ele);
        (0,bodyScrollLock_esm/* disableBodyScroll */.Qp)(this.ele, {
          reserveScrollBarGap: true
        });
      }
      window.addEventListener("message", this.messageHandler, false);
      return this;
    }

    /**
     * 关闭弹窗
     * @returns
     */
  }, {
    key: "close",
    value: function close() {
      var shouldCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CloseFromEnum.CLOSE;
      var curDate = "".concat(new Date().getFullYear(), "-").concat(new Date().getMonth() + 1, "-").concat(new Date().getDate());
      var local = JSON.parse(window.localStorage.getItem(SAAS_SUBSCRIPTION_POPUP_RETENTION_NUMBER) || "{}");
      var localNum = local.date === curDate ? +(local.value || "0") : 0;
      if (shouldCheck && this.shouldRetention && localNum < 3) {
        window.localStorage.setItem(SAAS_SUBSCRIPTION_POPUP_RETENTION_NUMBER, JSON.stringify({
          date: curDate,
          value: localNum + 1
        }));
        this.createRetentionDialog();
        return;
      }
      var handler = this.eventHandlers[EventNameEnum.CLOSE];
      if (handler) {
        handler(from);
      }
      if (this.ele) {
        (0,bodyScrollLock_esm/* enableBodyScroll */.tG)(this.ele);
        document.body.removeChild(this.ele);
      }
      if (typeof window.removeEventListener !== "undefined") {
        window.removeEventListener("message", this.messageHandler, false);
      }
      return this;
    }

    /**
     * 动态设置更新公共参数
     * @param params
     * @returns
     */
  }, {
    key: "setCommonParams",
    value: function setCommonParams(params) {
      if (params) {
        this.commonParams = Object.assign({}, this.commonParams, params);
      }
    }

    /**
     * 动态设置更新主题色
     * @param val
     * @returns
     */
  }, {
    key: "setTheme",
    value: function setTheme(val) {
      if (val) {
        this.theme = val;
        if (this.ele) this.ele.className = "saas-subscription-popup ".concat(this.theme);
      }
    }
  }]);
  return SaasSubscription;
}();
/* harmony default export */ const esm_lib = (SaasSubscription);
;// CONCATENATED MODULE: ./node_modules/@meitu/saas-subscription-popup/dist/esm/index.js





/* harmony default export */ const esm = (esm_lib);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(16598);
// EXTERNAL MODULE: ./src/utils/firstUrl.ts
var firstUrl = __webpack_require__(35084);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/index.js
var wps_utils = __webpack_require__(68626);
;// CONCATENATED MODULE: ./src/utils/login.tsx
// import * as Sentry from "@sentry/react";














let processingLogin = ()=>{};
// HACK 退登问题
let accessToken = "";
let actionType;
let vipModalCloseCallback = undefined;
let vipModalPayCallback = undefined;
const updateLogoutAccessToken = (token)=>{
    accessToken = token;
};
const LOGIN_COVER_WITH_LOCALE_CONFIG_CN = {
    "zh-Hans": {
        cover: "https://public.static.meitudata.com/xiuxiu-pc/x-design/videoframe_1193.jpg",
        video: "https://public.static.meitudata.com/xiuxiu-pc/x-design/login-banner2.webm"
    },
    en: {
        cover: "https://xiuxiu-pro-new.meitudata.com/poster/84053d9139882d9d66c12d2bad8a1b5c.png",
        video: "https://public.static.meitudata.com/xiuxiu-pc/x-design/login-banner-en.webm"
    }
};
const getEnvValue = (env)=>{
    // 1 test, 0 线上（默认）, 2 beta
    let value;
    switch(env){
        case "release":
            value = 0;
            break;
        case "beta":
            value = 2;
            break;
        default:
            value = 1;
    }
    return value;
};
const getCallback = ()=>{
    const url = "".concat(window.location.protocol, "//").concat(window.location.host, "/callback.html?refresh=0");
    return url;
};
/**
 * 初始化订阅弹窗组件
 */ const initVipModal = async (initVipModalOptions)=>{
    let env = "release";
    if (false) {}
    const first_url = (0,firstUrl/* getFirstUrl */.q)();
    // 订阅团队id
    const localIdentity = (0,lib/* getLocalIdentity */.u5)();
    const jumpQuery = (0,overseasAccessModal_jumpQuery/* getJumpQuery */.H)();
    const instanceVipModal = new esm({
        env,
        theme: "light",
        commonParams: {
            entrance: constants/* SCENE */.vX,
            module_id: constants/* SCENE */.vX,
            source: constants/* SCENE */.vX,
            app_key: (0,constants/* getAppKey */.AJ)(),
            client_id: (0,constants/* getClientID */.kU)(),
            matrix_channel: (0,utils/* getMatrixChannel */.T5)(),
            callback_origin: window.location.origin,
            channel: (0,utils/* getChannel */.mr)(),
            first_ur: first_url,
            subscribe_type: "meidou",
            client_language: "zh-Hans",
            ...jumpQuery,
            ...localIdentity ? {
                oid: (localIdentity === null || localIdentity === void 0 ? void 0 : localIdentity.oid) || 0,
                groupId: (localIdentity === null || localIdentity === void 0 ? void 0 : localIdentity.groupId) || 0,
                purchase_scene: "normal"
            } : {},
            ...initVipModalOptions
        }
    });
    instanceVipModal.on(EventNameEnum.SUCCESS, async ()=>{
        // 更新接口
        await getUserInfo();
        vipModalPayCallback === null || vipModalPayCallback === void 0 ? void 0 : vipModalPayCallback();
    }).on(EventNameEnum.LOGININVALID, ()=>{
        // 登录态失效
        handleLogout();
    }).on(EventNameEnum.CLOSE, ()=>{
        vipModalCloseCallback === null || vipModalCloseCallback === void 0 ? void 0 : vipModalCloseCallback();
    });
    window.instanceVipModal = instanceVipModal;
};
const initAccount = async ()=>{
    const gid = await (0,utils_gid/* waitUntilGetGid */.S)();
    const { MeituAccount  } = await Promise.all(/* import() */[__webpack_require__.e(4067), __webpack_require__.e(4772), __webpack_require__.e(4640), __webpack_require__.e(8959), __webpack_require__.e(1173), __webpack_require__.e(2991), __webpack_require__.e(8652), __webpack_require__.e(402), __webpack_require__.e(5112), __webpack_require__.e(3999), __webpack_require__.e(8739), __webpack_require__.e(2480)]).then(__webpack_require__.bind(__webpack_require__, 61445));
    window.account = MeituAccount({
        env: getEnvValue("release"),
        gid,
        clientId: (0,constants/* getClientID */.kU)(),
        theme: "mtxx",
        clientLanguage: "zh-Hans",
        overseas: 0,
        clientConfigs: {
            abroad: false,
            needPhone: false,
            enableWeChatOfficialAccount: true,
            // 移动端不展示三方登录
            showThirdPartyAccounts: !(0,utils/* isMobile */.tq)(),
            customQRCodeLogin: {
                name: "美图设计室",
                icon: "https://xiuxiu-pro-new.meitudata.com/poster/5ce9f95aa32b36358438f16afe666485.png",
                texts: {
                    title: "美图设计室扫码登录",
                    appName: "美图设计室",
                    scanGuide: "使用我的-右上方“扫一扫”登录"
                },
                statisticPlatform: "designkit"
            }
        },
        syncDomains: true,
        onNeedLogin () {},
        onLogining () {},
        onLoginError () {},
        onLoginSuccess: async (result)=>{
            actionType = "login";
            window.localStorage.setItem("access_token", result.accessToken);
            ;
            if (!(0,utils/* isMobile */.tq)()) {
                const status = await (0,teamInfo/* openIdentitySwitchPopupAfterLogin */.lz)(result.uid, result.accessToken);
                if (!status) return;
            }
            // 登录成功
            processingLogin(result.accessToken);
            (0,uidKit/* setLocalUid */.Tc)(result.uid);
            getUserInfo();
            // 登录成功默认切换为个人身份
            (0,lib/* setLocalIdentity */.kF)(0, 0);
        },
        onLogoutError () {},
        onLogoutSuccess () {
            actionType = "logout";
        },
        syncDomainsOptions: {
            onComplete () {
                if (actionType === "logout") {
                    window.location.reload();
                }
            }
        }
    });
};
const openAccount = async ()=>{
    //第三方帐号登录，退出后使用页面跳转涉及帐号内部状态同步，须确保帐号内部登录态清除
    await window.account.isLogin();
    const { openLoginPopup  } = await Promise.all(/* import() */[__webpack_require__.e(4067), __webpack_require__.e(4644), __webpack_require__.e(4772), __webpack_require__.e(4640), __webpack_require__.e(8959), __webpack_require__.e(8652), __webpack_require__.e(4574), __webpack_require__.e(402), __webpack_require__.e(5112), __webpack_require__.e(3999), __webpack_require__.e(8241), __webpack_require__.e(5629)]).then(__webpack_require__.bind(__webpack_require__, 38241));
    const { ThirdPartyPlatform  } = await Promise.all(/* import() */[__webpack_require__.e(4772), __webpack_require__.e(4640), __webpack_require__.e(8959), __webpack_require__.e(8652), __webpack_require__.e(402), __webpack_require__.e(5112), __webpack_require__.e(940)]).then(__webpack_require__.bind(__webpack_require__, 75112));
    const loginCoverData = LOGIN_COVER_WITH_LOCALE_CONFIG_CN["zh-Hans"];
    openLoginPopup({
        // ...登录弹窗配置选项，详见：LoginPopupProps
        title (text) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    color: "var(--content-primary, #0f1729)",
                    textAlign: "center",
                    fontSize: "24px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "32px"
                },
                children: text
            });
        },
        autoDetectAndSetDarkTheme: false,
        theme: "v4",
        containerStyle: {
            minHeight: 473
        },
        useLoginMethod: "",
        showMeituXiuXiuQRCode: false,
        thirdPartyAccounts: [
            ThirdPartyPlatform.CustomQRCode,
            ThirdPartyPlatform.Meitu,
            ThirdPartyPlatform.Weibo,
            ThirdPartyPlatform.WeChat,
            ThirdPartyPlatform.QQ
        ],
        borderRadius: "14px",
        // 隐藏关闭按钮
        showCloseButton: true,
        closeable: true,
        switch: true,
        leftSide () {
            return '<video poster="'.concat(loginCoverData.cover, '" src="').concat(loginCoverData.video, '" autoplay muted loop playsinline style="width: 334px; height: 100%; min-height: 509px; border-radius: 24px 0 0 24px; object-fit: cover; object-position: center center; display: block;"></video>');
        },
        onClose () {
        // 关闭弹窗后的自定义处理，略...
        }
    });
};
// 未登录态时，打开登录弹窗
const jumpToLogin = async ()=>{
    // WPS 场景：走 WPS 授权登录流程
    if ((0,wps_utils/* isFromWPS */.ji)()) {
        await (0,wps_utils/* wpsCheckLogin */.jJ)();
        return localStorage.getItem("access_token") || "";
    }
    if (!window.account) {
        await initAccount();
    }
    // 打开登录弹窗
    await openAccount();
    // 等待登录结果
    return await new Promise((resolve)=>processingLogin = resolve);
};
const handleLogout = async ()=>{
    var // 清楚埋点中的uid
    ref, ref1;
    (ref = window.mtstat) === null || ref === void 0 ? void 0 : ref.logout();
    // 清空用户信息和美豆信息
    store/* default.getActions */.ZP.getActions().userModel.setUserInfo(undefined);
    store/* default.getActions */.ZP.getActions().userModel.setMeidouInfo(null);
    // 清除团队信息
    (0,teamInfo/* clearTeamInfo */.bl)();
    // 移除身份切换监听
    (0,teamInfo/* disableIdentityChangeListener */.t2)();
    const { STORAGE_KEY_LOGIN_BY_WEB  } = await Promise.all(/* import() */[__webpack_require__.e(4067), __webpack_require__.e(4772), __webpack_require__.e(4640), __webpack_require__.e(8959), __webpack_require__.e(1173), __webpack_require__.e(2991), __webpack_require__.e(8652), __webpack_require__.e(402), __webpack_require__.e(5112), __webpack_require__.e(3999), __webpack_require__.e(8739), __webpack_require__.e(2480)]).then(__webpack_require__.bind(__webpack_require__, 61445));
    window.sessionStorage.removeItem(STORAGE_KEY_LOGIN_BY_WEB);
    !window.account && await initAccount();
    // HACK 退登问题
    let options = {};
    if (accessToken) {
        options = {
            headers: {
                "Access-Token": accessToken
            }
        };
    }
    (ref1 = window.account) === null || ref1 === void 0 ? void 0 : ref1.logout({}, options);
};
// 打开VIP会员弹窗
const openVipModal = async function() {
    let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, closeCallback = arguments.length > 1 ? arguments[1] : void 0, payCallback = arguments.length > 2 ? arguments[2] : void 0, initVipModalOptions = arguments.length > 3 ? arguments[3] : void 0;
    var ref;
    // WPS 场景：走 WPS 支付弹窗
    if ((0,wps_utils/* isFromWPS */.ji)()) {
        await (0,wps_utils/* openWpsPayModal */.kS)(params);
        return;
    }
    vipModalCloseCallback = closeCallback;
    vipModalPayCallback = payCallback;
    if (!window.instanceVipModal) {
        await initVipModal(initVipModalOptions);
    }
    if (params === null || params === void 0 ? void 0 : params.oid) {
        // 如果场景透传了oid，则需要实时根据最新的oid去透传对应的app_key
        params.app_key = (0,constants/* getAppKey */.AJ)(params.oid);
    }
    (ref = window.instanceVipModal) === null || ref === void 0 ? void 0 : ref.open(params);
};
/**
 * 获取用户信息
 */ const getUserInfo = async ()=>{
    const res = await fetchUserInfo();
    const data = res.data.data;
    if (res.data.code === code/* default.OK */.Z.OK && data) {
        var ref;
        window.localStorage.setItem("access_token", data.access_token);
        (0,uidKit/* setLocalUid */.Tc)(data.userInfo.id);
        (ref = window.mtstat) === null || ref === void 0 ? void 0 : ref.login(String(data.userInfo.id));
        updateLogoutAccessToken(data.access_token);
        store/* default.getActions */.ZP.getActions().userModel.setUserInfo({
            id: data.userInfo.id,
            screen_name: data.userInfo.screen_name,
            avatar: data.userInfo.avatar,
            is_vip: data.vipInfo.is_vip,
            vip_level: data.vipInfo.vip_level,
            vip_end_time: data.vipInfo.vip_end_time,
            vip_days: data.vipInfo.vip_days,
            available_amount: data.coinInfo.available_amount
        });
        store/* default.getActions */.ZP.getActions().userModel.setMeidouInfo(data.coinInfo);
        store/* default.getActions */.ZP.getActions().userModel.setCutoutInfo(data.cutoutInfo);
        // 开启身份切换监听
        (0,teamInfo/* enableIdentityChangeListener */.sr)();
    } else {
        store/* default.getActions */.ZP.getActions().userModel.setUserInfo(undefined);
        store/* default.getActions */.ZP.getActions().userModel.setMeidouInfo(null);
        store/* default.getActions */.ZP.getActions().userModel.setCutoutInfo(null);
    }
    store/* default.getActions */.ZP.getActions().userModel.setIsRequested(true);
};


/***/ }),

/***/ 40582:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SF": () => (/* binding */ statTrack),
/* harmony export */   "hP": () => (/* binding */ getOperateSource),
/* harmony export */   "jt": () => (/* binding */ initMtstat),
/* harmony export */   "xT": () => (/* binding */ setUserCommonParams)
/* harmony export */ });
/* unused harmony export getParameterValue */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78264);
/* harmony import */ var _gid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66138);
/* harmony import */ var _meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99861);
/* harmony import */ var _meitu_xdesign_widgets_dist_overseasAccessModal_jumpQuery__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50767);
/* harmony import */ var _meitu_xdesign_widgets_dist_teamExports__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72838);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20695);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29358);
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67887);
/* harmony import */ var _constants_workbench__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99697);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31955);
/* harmony import */ var _meitu_xdesign_widgets_dist_stat_page_type__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43585);











let disposePageTypeCommonParams;
const getParameterValue = (inputString, key)=>{
    // 构造正则表达式，匹配 "key=值" 的模式
    const regex = new RegExp("".concat(key, "=([^&]*)"));
    // 使用正则表达式查找匹配项
    const match = inputString.match(regex);
    // 如果匹配成功，返回匹配的值，否则返回 null
    return match ? decodeURIComponent(match[1]) : "";
};
const initMtstat = (callback)=>{
    let isDisposed = false;
    const sdkAppId = (0,_sdk__WEBPACK_IMPORTED_MODULE_4__/* .checkIsInSdk */ .X)() ? _sdk__WEBPACK_IMPORTED_MODULE_4__/* .getAppId */ .r : ()=>Promise.resolve({
            app_id: ""
        });
    Promise.all([
        (0,_gid__WEBPACK_IMPORTED_MODULE_1__/* .waitUntilGetGid */ .S)(),
        sdkAppId()
    ]).then(async (param)=>{
        let [wgid, { app_id  }] = param;
        var ref;
        if (isDisposed) {
            return;
        }
        ;
        // 团队id
        const oid = String(((ref = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)()) === null || ref === void 0 ? void 0 : ref.oid) || "");
        const query = (0,_query__WEBPACK_IMPORTED_MODULE_7__/* .getQuery */ .pm)();
        const tool_url = decodeURIComponent(decodeURIComponent(query.tool_url || ""));
        const is = await __webpack_require__.e(/* import() */ 4437).then(__webpack_require__.bind(__webpack_require__, 34437));
        if (app_id) {
            if (_constants_workbench__WEBPACK_IMPORTED_MODULE_5__/* .SDK_PLATFORM */ .gV[app_id]) {
                if (true) {
                    window._appId = app_id;
                }
            }
        }
        const mtxxWebGid = js_cookie__WEBPACK_IMPORTED_MODULE_6__/* ["default"].get */ .Z.get("mtxx_web_gid".concat( false ? 0 :  false ? 0 : ""));
        const jumpQuery = (0,_meitu_xdesign_widgets_dist_overseasAccessModal_jumpQuery__WEBPACK_IMPORTED_MODULE_8__/* .getJumpQuery */ .H)();
        // 埋点信息配置
        const statConfig = {
            appKey: (0,_constants__WEBPACK_IMPORTED_MODULE_0__/* .getAppKey */ .AJ)(),
            client_language: "zh-Hans",
            env:  true ? "release" : 0,
            moduleId: _constants__WEBPACK_IMPORTED_MODULE_0__/* .MODULE_ID */ .ce,
            app_id: app_id,
            is_sdk: query.origin === _constants_workbench__WEBPACK_IMPORTED_MODULE_5__/* .SdkModuleName.aippt */ .sB.aippt && (0,_sdk__WEBPACK_IMPORTED_MODULE_4__/* .checkIsInSdk */ .X)() ? query.origin : "",
            company_key: _constants_workbench__WEBPACK_IMPORTED_MODULE_5__/* .SDK_PLATFORM */ .gV[app_id] || query.platform || "",
            channel: query.hb_position || query.hb_operation ? "app" : query.channel && decodeURIComponent(query.channel) || window.sessionStorage.getItem("channel") || "",
            hb_position: (0,_query__WEBPACK_IMPORTED_MODULE_7__/* .getQuery */ .pm)().hb_position || getParameterValue(tool_url, "hb_position") || "",
            hb_operation: (0,_query__WEBPACK_IMPORTED_MODULE_7__/* .getQuery */ .pm)().hb_operation || getParameterValue(tool_url, "hb_operation") || "",
            indtool_source: query.indtool_source || "",
            operate_source: await getOperateSource(),
            from_app: is.isMobile && is.isXiuXiu ? "mtxx_app" : is.isMobile && is.isPoster ? "mtsjs_app" : "browser",
            funcEnter: "",
            abTestKey: "",
            sdkModuleName: "",
            customizedStatsMarker: false,
            oid,
            user_mode: (0,_meitu_xdesign_widgets_dist_teamExports__WEBPACK_IMPORTED_MODULE_9__/* .getEnterpriseID */ .DG)() ? "1" : "",
            enterprise_id: (0,_meitu_xdesign_widgets_dist_teamExports__WEBPACK_IMPORTED_MODULE_9__/* .getEnterpriseID */ .DG)() || "",
            mtxx_web_gid: mtxxWebGid || "",
            global_page_type: (0,_meitu_xdesign_widgets_dist_stat_page_type__WEBPACK_IMPORTED_MODULE_10__/* .getPageTypeByPath */ .q0)(),
            initAbTest: ()=>{
                callback === null || callback === void 0 ? void 0 : callback();
            },
            successCallback: ()=>{
                _store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getActions */ .ZP.getActions().setFinishTrack(true);
                disposePageTypeCommonParams === null || disposePageTypeCommonParams === void 0 ? void 0 : disposePageTypeCommonParams();
                if (isDisposed) {
                    disposePageTypeCommonParams = undefined;
                    return;
                }
                disposePageTypeCommonParams = (0,_meitu_xdesign_widgets_dist_stat_page_type__WEBPACK_IMPORTED_MODULE_10__/* .initPageTypeCommonParams */ .JF)();
            },
            ...jumpQuery
        };
        if (is.isMobile && (is.isXiuXiu || is.isPoster)) {
            try {
                const hogger = await Promise.all(/* import() */[__webpack_require__.e(1173), __webpack_require__.e(2991), __webpack_require__.e(8028), __webpack_require__.e(7982)]).then(__webpack_require__.bind(__webpack_require__, 88028));
                const [appInfo] = await hogger.getAppInfo();
                statConfig.gid = appInfo.gid;
            } catch (e) {
                ;
            }
        }
        // 实例化埋点
        __webpack_require__.e(/* import() */ 7663).then(__webpack_require__.bind(__webpack_require__, 47663)).then((res)=>{
            if (isDisposed) {
                return;
            }
            new res.SaasMTStat(statConfig);
        });
    });
    return ()=>{
        isDisposed = true;
        disposePageTypeCommonParams === null || disposePageTypeCommonParams === void 0 ? void 0 : disposePageTypeCommonParams();
        disposePageTypeCommonParams = undefined;
    };
};
const getOperateSource = async ()=>{
    const is = await __webpack_require__.e(/* import() */ 4437).then(__webpack_require__.bind(__webpack_require__, 34437));
    if (is.isMobile) return "h5";
    const clientInfo = await __webpack_require__.e(/* import() */ 1022).then(__webpack_require__.t.bind(__webpack_require__, 21022, 23)).then((res)=>res.clientInfo);
    let operate_source = "web";
    if (clientInfo.isClient) {
        operate_source = clientInfo.isMac ? "macos" : "windows";
    }
    return operate_source;
};
/**
 * 埋点上报函数
 * @param eventName 事件名
 * @param args 参数
 */ function statTrack(eventName, args) {
    if (!window._stat_track) {
        if (!window.__stat_stack) {
            window.__stat_stack = [];
        }
        window.__stat_stack.push({
            name: eventName,
            options: args
        });
    } else {
        var ref;
        (ref = window._stat_track) === null || ref === void 0 ? void 0 : ref.call(window, eventName, args);
    }
}
/**
 * 设置用户公共参数
 * @param userInfo
 */ const setUserCommonParams = (param)=>{
    let { isVip , availableAmount  } = param;
    var // 1）user_type（用户vip类型）：0非会员，1svip，2未登陆
    // 2) residual_meidou：剩余美豆数，未登陆上报no_login
    ref;
    (ref = window.mtstat) === null || ref === void 0 ? void 0 : ref.setCommonParams({
        user_type: isVip == null ? "2" : isVip ? "1" : "0",
        residual_meidou: availableAmount == null ? "no_login" : String(availableAmount)
    });
};


/***/ }),

/***/ 20695:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DZ": () => (/* binding */ appendQueryParams),
/* harmony export */   "Ow": () => (/* binding */ deleteQueryParams),
/* harmony export */   "Ph": () => (/* binding */ getQueryParam),
/* harmony export */   "pm": () => (/* binding */ getQuery)
/* harmony export */ });
/* unused harmony exports stringifyQuery, parseQueryString */
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);

/**
 * 获取地址参数对象
 * @return
 */ const getQuery = ()=>{
    if (false) {}
    return parseQueryString(window.location.search);
};
function stringifyQuery(params) {
    let sort = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return qs.stringify(params, sort ? {
        sort: (a, b)=>a.localeCompare(b)
    } : undefined);
}
function parseQueryString(query) {
    // Remove any leading '?' from the query string
    if (query.startsWith("?")) {
        query = query.slice(1);
    }
    return qs__WEBPACK_IMPORTED_MODULE_0___default().parse(query);
}
/**
 * 获取指定的参数
 * @param key
 * @param defaultValue
 * @param query
 * @return
 */ const getQueryParam = (key, defaultValue, query)=>{
    const q = query || getQuery();
    return q[key] || defaultValue;
};
const appendQueryParams = function() {
    let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const url = new URL(window.location.href);
    Object.entries(params).forEach((param)=>{
        let [key, value] = param;
        if (value !== undefined && value !== null) {
            url.searchParams.set(key, value);
        }
    });
    const newUrl = url.toString();
    window.history.replaceState({}, "", newUrl);
};
const deleteQueryParams = (keys)=>{
    const url = new URL(window.location.href);
    const keyList = Array.isArray(keys) ? keys : [
        keys
    ];
    keyList.forEach((key)=>{
        url.searchParams.delete(key);
    });
    const newUrl = url.toString();
    window.history.replaceState({}, "", newUrl);
};


/***/ }),

/***/ 35707:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": () => (/* binding */ request),
  "Kj": () => (/* binding */ getCommonParams)
});

// UNUSED EXPORTS: genMtccHeader

// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 42 modules
var axios = __webpack_require__(5121);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-identity/lib/index.js
var lib = __webpack_require__(99861);
// EXTERNAL MODULE: ./src/constants/code.ts
var constants_code = __webpack_require__(56105);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(78264);
// EXTERNAL MODULE: ./src/utils/query.ts
var utils_query = __webpack_require__(20695);
// EXTERNAL MODULE: ./src/utils/sdk.ts
var sdk = __webpack_require__(67887);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(29358);
// EXTERNAL MODULE: ./src/utils/gid.ts
var utils_gid = __webpack_require__(66138);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(16598);
// EXTERNAL MODULE: ./src/constants/workbench.ts
var workbench = __webpack_require__(99697);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/index.js
var dist_utils = __webpack_require__(54345);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-utils/node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ const esm_browser_native = ({ randomUUID });

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-utils/node_modules/uuid/dist/esm-browser/rng.js
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
    if (!getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) {
            throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        }
        getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return getRandomValues(rnds8);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-utils/node_modules/uuid/dist/esm-browser/stringify.js

const byteToHex = [];
for (let i = 0; i < 256; ++i) {
    byteToHex.push((i + 0x100).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
    return (byteToHex[arr[offset + 0]] +
        byteToHex[arr[offset + 1]] +
        byteToHex[arr[offset + 2]] +
        byteToHex[arr[offset + 3]] +
        '-' +
        byteToHex[arr[offset + 4]] +
        byteToHex[arr[offset + 5]] +
        '-' +
        byteToHex[arr[offset + 6]] +
        byteToHex[arr[offset + 7]] +
        '-' +
        byteToHex[arr[offset + 8]] +
        byteToHex[arr[offset + 9]] +
        '-' +
        byteToHex[arr[offset + 10]] +
        byteToHex[arr[offset + 11]] +
        byteToHex[arr[offset + 12]] +
        byteToHex[arr[offset + 13]] +
        byteToHex[arr[offset + 14]] +
        byteToHex[arr[offset + 15]]).toLowerCase();
}
function stringify(arr, offset = 0) {
    const uuid = unsafeStringify(arr, offset);
    if (!validate(uuid)) {
        throw TypeError('Stringified UUID is invalid');
    }
    return uuid;
}
/* harmony default export */ const esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-utils/node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
    if (esm_browser_native.randomUUID && !buf && !options) {
        return esm_browser_native.randomUUID();
    }
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? rng();
    if (rnds.length < 16) {
        throw new Error('Random bytes length must be >= 16');
    }
    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    rnds[8] = (rnds[8] & 0x3f) | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) {
            throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        }
        for (let i = 0; i < 16; ++i) {
            buf[offset + i] = rnds[i];
        }
        return buf;
    }
    return unsafeStringify(rnds);
}
/* harmony default export */ const esm_browser_v4 = (v4);

// EXTERNAL MODULE: ./node_modules/web-vitals/dist/web-vitals.js
var web_vitals = __webpack_require__(38085);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-utils/dist/index.es.js





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var LOCALSTORAGE_COUNTRYCODE_KEY = "xdesign-utils__country-code";
// 是否更新过本地国家码缓存
var hasUpdateLocalCountryCode = false;
// 正在请求状态
var fetchLoading = false;
var processingFetch = function () { };
var instanceFetch = null;
var getRequestUrl = function () {
    if (window.isIntl && window.deployApp === 'designkit') {
        return 'designkit-webapi.designkit.com';
    }
    return window.isIntl ? "www.x-design.com/api" : "webapi.designkit.cn";
};
var fetchRequest = function (timeout) { return __awaiter(void 0, void 0, void 0, function () {
    var defaultCode, res, data, info, code;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                defaultCode = window.isIntl ? "SG" : "CN";
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                fetchLoading = true;
                return [4 /*yield*/, (0,axios/* default */.Z)("https://".concat(getRequestUrl(), "/common/ip_location"), {
                        params: { ts_random_id: esm_browser_v4() },
                        timeout: timeout,
                    })];
            case 2:
                res = _b.sent();
                data = ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data) || {};
                info = Object.values(data)[0] || {};
                code = info === null || info === void 0 ? void 0 : info.nation_code;
                if (code) {
                    hasUpdateLocalCountryCode = true;
                    // 更新缓存
                    window.localStorage.setItem(LOCALSTORAGE_COUNTRYCODE_KEY, code);
                }
                processingFetch(code || defaultCode);
                fetchLoading = false;
                return [3 /*break*/, 4];
            case 3:
                _b.sent();
                processingFetch(defaultCode);
                fetchLoading = false;
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
var handleGetCodeProcess = function (timeout) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                fetchRequest(timeout || 200);
                return [4 /*yield*/, new Promise(function (resolve) { return (processingFetch = resolve); })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * 获取云储存分摊埋点透传值
 * @param timeout ip_location接口超时时间
 * @returns
 */
var getCountryCode = function (timeout) { return __awaiter(void 0, void 0, void 0, function () {
    var country_code, country_code_local, _a;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                country_code_local = (_b = window === null || window === void 0 ? void 0 : window.localStorage) === null || _b === void 0 ? void 0 : _b.getItem(LOCALSTORAGE_COUNTRYCODE_KEY);
                if (!!country_code_local) return [3 /*break*/, 5];
                if (!instanceFetch) return [3 /*break*/, 2];
                return [4 /*yield*/, instanceFetch];
            case 1:
                _a = _c.sent();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, (instanceFetch = handleGetCodeProcess(timeout))];
            case 3:
                _a = _c.sent();
                _c.label = 4;
            case 4:
                // 处理并发情况
                country_code = _a;
                // 成功后释放实例
                instanceFetch = null;
                return [3 /*break*/, 6];
            case 5:
                country_code = country_code_local;
                _c.label = 6;
            case 6:
                // 如果还没请求过接口，异步更新本地缓存
                if (!hasUpdateLocalCountryCode && !fetchLoading) {
                    fetchRequest(3000);
                }
                return [2 /*return*/, country_code];
        }
    });
}); };

/**
 * 获取云储存分摊埋点透传值
 * @param options
 * @returns
 */
var getMTCCClient = function (options) { return __awaiter(void 0, void 0, void 0, function () {
    var gid, functionInfo, positionInfo, isToB, virtualId, uid, osType, app_id, isIntl, isTeam, isPcPlatform, mediaType, resMediaType, country_code, appId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                gid = options.gid, functionInfo = options.functionInfo, positionInfo = options.positionInfo, isToB = options.isToB, virtualId = options.virtualId, uid = options.uid, osType = options.osType, app_id = options.app_id, isIntl = options.isIntl, isTeam = options.isTeam, isPcPlatform = options.isPcPlatform, mediaType = options.mediaType, resMediaType = options.resMediaType;
                return [4 /*yield*/, getCountryCode()];
            case 1:
                country_code = _a.sent();
                appId = '';
                if (app_id) {
                    // 业务自定义
                    appId = app_id;
                }
                else if (isPcPlatform) {
                    // pc内嵌下
                    appId = '8045';
                }
                else if (isIntl || window.isIntl) {
                    // designKit 全球化 / 海外 x-design
                    appId = window.deployApp === 'designkit' ? '227' : '2000010';
                }
                else {
                    // web国内
                    appId = '178';
                }
                return [2 /*return*/, btoa(JSON.stringify({
                        app_id: appId,
                        os_type: osType,
                        country_code: country_code,
                        gnum: gid,
                        function: functionInfo,
                        position: positionInfo,
                        media_type: mediaType,
                        res_media_type: resMediaType,
                        ext_info: {
                            biz_type: isTeam ? 'team' : isToB ? 'api' : '',
                            virtual_id: virtualId,
                        },
                        uid: uid || '',
                    }))];
        }
    });
}); };

var num = 0;
var getDemo = function () {
    num++;
    return num;
};

/**
 * 初始化访问两个页面上报代码
 * @param callback
 */
var initViewMoreThan2Pages = function (callback) {
    var pageViewCount = Number(localStorage.getItem("gaPageViewCount"));
    pageViewCount++;
    if (pageViewCount === 3) {
        // 广告转化
        callback("conversion", {
            send_to: "AW-871914325/YIzgCInN5ssZENW24Z8D",
        });
        // ga 事件
        callback("view_more_than_2_pages", {});
    }
    localStorage.setItem("gaPageViewCount", String(pageViewCount));
};
/**
 * 初始化访问超过1分钟页面上报代码
 * @param callback
 */
var initViewMoreThan1Min = function (callback) {
    var currentTotalTime = Number(localStorage.getItem("gaTotalTime")) || 0;
    var timer;
    if (currentTotalTime < 60) {
        var totalTime_1 = 0;
        timer = setInterval(function () {
            if (localStorage.getItem("gaTotalTime") != null) {
                totalTime_1 = Number(localStorage.getItem("gaTotalTime")) || 0;
                totalTime_1++;
                if (totalTime_1 > 60) {
                    clearInterval(timer);
                    return;
                }
                localStorage.setItem("gaTotalTime", String(totalTime_1));
                if (totalTime_1 == 60) {
                    // 广告转化
                    callback("conversion", {
                        send_to: "AW-871914325/mF1GCIbN5ssZENW24Z8D",
                    });
                    //GA4
                    callback("view_more_than_1_min", {});
                }
            }
            else {
                totalTime_1 = 0;
                localStorage.setItem("gaTotalTime", String(totalTime_1));
            }
        }, 1000);
    }
};
/**
 * @description 轮询获取gtag 是否已经动态插入
 * @returns
 */
var checkGtagLoaded = function () {
    var count = 0;
    return new Promise(function (res, rej) {
        // 如果 gtag 未定义，轮询检查,超过1分钟直接暂停
        var interval = setInterval(function () {
            if (window.dataLayer && window.gtag) {
                clearInterval(interval);
                res(true);
            }
            count++;
            // 超过60秒 放弃轮询
            if (count > 30) {
                clearInterval(interval);
                rej({ message: "not gtag" });
            }
        }, 2000); // 每2秒检查一次
    });
};
/**
 * @description 初始化基础分析
 * @param param
 */
var initBasicAnalysis = function (_a) {
    var hasViewMoreThan2Pages = _a.hasViewMoreThan2Pages, hasViewMoreThan1Min = _a.hasViewMoreThan1Min, callback = _a.callback;
    return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, checkGtagLoaded()];
                case 1:
                    _b.sent();
                    hasViewMoreThan2Pages && initViewMoreThan2Pages(callback);
                    hasViewMoreThan1Min && initViewMoreThan1Min(callback);
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _b.sent();
                    console.log(e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
};

// 埋点文档 https://dayu.starii-rover.com/requirement/requirement?sso_code=7218504577643970560_1721025604
var DEFAULT_CONFIG = {
    debug_mode: true,
    traffic_type: "internal",
};
/**
 * @description GAEventTracker 类 谷歌自定义事件埋点
 */
var GAEventTracker = /** @class */ (function () {
    function GAEventTracker() {
        this.entrance = null;
        this.isStopGa = false; // 默认收集 ga 自定义事件
        this.env = "pre"; // 默认为pre环境
    }
    /**
     * @description 获取当前埋点入口
     * @returns
     */
    GAEventTracker.prototype.getEntrance = function () {
        return this.entrance;
    };
    /**
     * @description 设置当前埋点入口
     * @param newEntrance
     * @example
     *     比如用户在导航登录按钮点击之后需要设置当前埋点入口为 TopNav
     *     gaEventTracker.setEntrance('TopNav')
     */
    GAEventTracker.prototype.setEntrance = function (newEntrance) {
        this.entrance = newEntrance;
    };
    /**
     * @description 获取是否暂停ga 收集 状态
     * @returns
     */
    GAEventTracker.prototype.getIsStopGa = function () {
        return this.isStopGa;
    };
    /**
     * @description 设置是否暂停ga 收集
     * @param {boolean} bool     是否暂停
     * @example
     *     setStopGa(true)   // 停止收集
     *     setStopGa(false)  // 开始收集
     */
    GAEventTracker.prototype.setStopGa = function (bool) {
        this.isStopGa = bool;
    };
    /**
     * @description 设置配置
     * @param {"pre"|"beta"|"release"}  pre                          环境
     * @param {boolean} [isStopGa = false] isStopGa                  是否暂停ga 收集 默认为false
     * @example
     *     setConfig({env:'pre'}) // 设置环境为pre
     *     setConfig({env:'pre',isStopGa: true}) // 设置环境为pre,暂停ga 自定义事件收集
     */
    GAEventTracker.prototype.setConfig = function (config) {
        var _this = this;
        var env = config.env, _a = config.isStopGa, isStopGa = _a === void 0 ? false : _a, _b = config.hasViewMoreThan1Min, hasViewMoreThan1Min = _b === void 0 ? true : _b, _c = config.hasViewMoreThan2Pages, hasViewMoreThan2Pages = _c === void 0 ? true : _c;
        this.env = env;
        this.isStopGa = isStopGa;
        // 默认添加 网页浏览超过2页面 & 网页浏览超过1分钟 统计
        if (typeof window !== "undefined") {
            initBasicAnalysis({
                hasViewMoreThan2Pages: hasViewMoreThan2Pages,
                hasViewMoreThan1Min: hasViewMoreThan1Min,
                callback: function (eventName, eventParams) {
                    _this.sendGaEvent(eventName, eventParams);
                },
            });
        }
    };
    /**
     * @description 获取当前环境
     * @returns
     */
    GAEventTracker.prototype.getEnv = function () {
        return this.env;
    };
    /**
     * @description 获取GAEventTracker实例
     * @returns
     */
    GAEventTracker.getInstance = function () {
        if (!GAEventTracker.instance) {
            GAEventTracker.instance = new GAEventTracker();
        }
        return GAEventTracker.instance;
    };
    /**
     * @description 发送GA事件
     * @param {string} eventName
     * @param {any} eventParams
     * @example
     *     目前之封装了注册|登录、购买成功的、保存成功的事件（都是基于 sendGaEvent 事件来的），如果其他事件需要发送，可以直接调用sendGaEvent方法
     */
    GAEventTracker.prototype.sendGaEvent = function (eventName, eventParams) {
        var _a;
        if (this.isStopGa) {
            // 暂停事件收集，直接退出
            return;
        }
        // 发送GA事件
        // debug_mode 模式打开可在谷歌分析后台debugview 里查看实时事件
        // traffic_type = internal 区分内部测试数据，beta|pre 环境都是内部测试数据，release 环境是正式数据
        if (window.dataLayer && window.gtag) {
            var params = eventParams;
            if (this.env !== "release") {
                params = __assign(__assign({}, params), DEFAULT_CONFIG);
            }
            (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, "event", eventName, params);
        }
    };
    /**
     * @description 发送登录/注册结果GA事件
     * @param {boolean} isRegister                          是否注册  MeituAccount里的 onLoginSuccess 第二个参数可以区分是否注册
     * @param {string|undefined} [platform='email']         平台（登录方式） MeituAccount里的 onLoginSuccess 第一个参数的platform属性 可以区分平台，
     * @param {string} pageName                             页面名称
     * @param {string|undefined} [entrance]                 入口名称
     * @example
     *     MeituAccount({
     *            ......
     *            onLoginSuccess: (result, isRegister) => {
     *                    //result.platform 是存在undefined 的情况的
     *                    const pageName = 'home'
     *                    const entrance = 'xxxxx' // 入口名称
     *                    gaEventTracker.sendLoginGaTrack(isRegister, result.platform, pageName, entrance)
     *            }
     *            ....
     *    })
     * @see MeituAccount 登录注册接口文档 https://f2er.meitu.com/account/api/account-alipay-mini-program/function/onLoginSuccess
     */
    GAEventTracker.prototype.sendLoginGaTrack = function (isRegister, platform, pageName, entrance) {
        if (platform === void 0) { platform = "email"; }
        // ads转化代码
        if (isRegister) {
            this.sendGaEvent("conversion", {
                send_to: "AW-871914325/fpXBCIPN5ssZENW24Z8D",
            });
        }
        this.sendGaEvent(isRegister ? "register_result" : "login_result", {
            page_name: pageName,
            method: platform,
            entrance: entrance || this.entrance || "topnav",
        });
    };
    /**
     * @description 发送购买结果GA事件
     * @param {OrderTradeProgress[]} tradeProgress        订单交易数据
     * @param {boolean} isVip                             是否是会员
     * @param {string} funcSource                         功能来源
     * @param {string|undefined} [entrance]               入口名称
     * @example
     *    openSubscribePopup({
     *            ......
     *            onTradeFinish(tradeProgress) {
     *                const isVip = true // 假设是会员
     *                const funcSource = 'home' // 假设是首页
     *                const entrance = 'xxxxx' // 入口名称
     *                gaEventTracker.sendPurchaseGaTrack(tradeProgress, isVip, funcSource,entrance)
     *            }
     *            ......
     *    })
     * @see tradeProgress 交易接口文档 https://f2er.meitu.com/subscribe/api/subscribe-core/interface/OrderTradeProgressProduct
     */
    GAEventTracker.prototype.sendPurchaseGaTrack = function (tradeProgress, isVip, funcSource, entrance) {
        var _this = this;
        tradeProgress.forEach(function (v, i) {
            var _a = v.product, productId = _a.productId, moneyUnit = _a.moneyUnit, price = _a.price, isProbation = _a.isProbation, payChannel = v.payChannel, transactionId = v.transactionId;
            var gaData = {
                value: price,
                currency: moneyUnit,
                transaction_id: transactionId,
                user_type: isVip ? 1 : 0,
                item_id: productId,
                payment_type: payChannel,
                is_try: isProbation ? 0 : 1,
                func_source: funcSource,
                entrance: entrance || _this.entrance || "topnav",
            };
            // ads转化代码
            _this.sendGaEvent("conversion", {
                send_to: "AW-871914325/CMpSCIzN5ssZENW24Z8D",
            });
            // ga
            _this.sendGaEvent("purchase", gaData);
        });
    };
    /**
     * @description     发送保存成功GA事件
     * @param {string} from                               来源
     * @param {string} func                               功能名称
     * @example
     *      const from = 'home';// 假设是home, 可以调用 getFrom() 方法获取来源，如果有的话
     *      const func = 'create_now';// 假设是create_now
     *      sendSaveSuccessGaTrack(from, func)
     */
    GAEventTracker.prototype.sendSaveSuccessGaTrack = function (from, func) {
        if (func === void 0) { func = "create_now"; }
        // 获取链接from参数
        this.sendGaEvent("save_success", {
            source: from || "other",
            func: func,
        });
    };
    GAEventTracker.prototype.sendUploadClickGaTrack = function () {
        // 获取链接from参数
        this.sendGaEvent("upload_click", {});
    };
    return GAEventTracker;
}());
var gaEventTracker = GAEventTracker.getInstance();

/**
 * @description 弹窗弹出管理器，目前支持登录和下载 时机时主动弹出订阅弹窗
 */
var PopupManager = /** @class */ (function () {
    // 私有构造函数，防止外部实例化
    function PopupManager() {
        this.maxLoginPopupCount = 1;
        this.maxDownloadPopupCount = 1;
        this.state = {
            currentLoginPopupCount: 0,
            currentDownloadPopupCount: 0,
        };
        if (typeof window !== "undefined") {
            // 仅在客户端环境中访问 localStorage
            var savedState = localStorage.getItem("popupState");
            if (savedState) {
                this.state = JSON.parse(savedState);
            }
            else {
                this.updateState();
            }
        }
    }
    // 获取单例实例
    PopupManager.getInstance = function () {
        if (!PopupManager.instance) {
            PopupManager.instance = new PopupManager();
        }
        return PopupManager.instance;
    };
    // 设置配置方法
    /**
     * @description 设置配置方法
     * @param config PopupConfig
     * @example
     *
     *      //项目初始化的时候
     *      setConfig({
     *        maxLoginPopupCount: 1, // 最大登录弹窗次数
              maxDownloadPopupCount: 1, // 最大下载弹窗次数
     *      })
     */
    PopupManager.prototype.setConfig = function (config) {
        var maxLoginPopupCount = config.maxLoginPopupCount, maxDownloadPopupCount = config.maxDownloadPopupCount;
        if (maxLoginPopupCount !== undefined) {
            this.maxLoginPopupCount = maxLoginPopupCount;
        }
        if (maxDownloadPopupCount !== undefined) {
            this.maxDownloadPopupCount = maxDownloadPopupCount;
        }
    };
    // 更新并保存状态到 localStorage
    PopupManager.prototype.updateState = function () {
        localStorage.setItem("popupState", JSON.stringify(this.state));
    };
    /**
     * @description 弹出处理方法
     * @param popupType
     * @param callback
     * @example
     *     在需要主动弹出订阅时调用
     *     popupManager.handlePopup("login", () => {
     *        // 弹出订阅窗口 逻辑，比如 (openVipModal 是业务方打开订阅窗口公共方法)
     *        openVipModal({
                entrance: xxxx,
                source: xxxx,
                trackEntrance: xxxxx,
              })
     *     })
     */
    PopupManager.prototype.handlePopup = function (popupType, callback) {
        if (popupType === "login") {
            if (this.state.currentLoginPopupCount < this.maxLoginPopupCount) {
                this.state.currentLoginPopupCount++;
                this.updateState();
                callback();
            }
        }
        else if (popupType === "download") {
            if (this.state.currentDownloadPopupCount < this.maxDownloadPopupCount) {
                this.state.currentDownloadPopupCount++;
                this.updateState();
                callback();
            }
        }
    };
    /**
     * @description 退出登录清空数据
     * @example
     *      //退出登录时调用
     *      popupManager.logout()
     */
    PopupManager.prototype.logout = function () {
        if (typeof window !== "undefined") {
            localStorage.removeItem("popupState");
        }
        this.state = {
            currentLoginPopupCount: 0,
            currentDownloadPopupCount: 0,
        };
    };
    return PopupManager;
}());
var popupManager = PopupManager.getInstance();

var checkDebugConfig = function () {
    var localConfig = window.localStorage.getItem("performanceMonitor");
    if (!localConfig) {
        return false;
    }
    try {
        var debug = JSON.parse(localConfig).debug;
        return !!debug;
    }
    catch (e) {
        return false;
    }
};
var prettyLog = function (title, text, rating) {
    var color = "#00a67d";
    if (rating === "needs-improvement") {
        color = "#ffc92e";
    }
    if (rating === "poor") {
        color = "#f22c3d";
    }
    console.log("%c ".concat(title, " %c ").concat(text, "ms %c"), "background:".concat(color, ";border:1px solid ").concat(color, "; padding: 1px; border-radius: 2px 0 0 2px; color: #fff;"), "border:1px solid ".concat(color, "; padding: 1px; border-radius: 0 2px 2px 0; color: ").concat(color, ";"), "background:transparent");
};
var log = function (name, data) {
    if (!checkDebugConfig()) {
        return;
    }
    var arr = __spreadArray([], (0,lodash.map)(data, function (value, key) { return ({ key: key, value: value }); }), true);
    console.table(arr, ["key", "value"]);
    prettyLog(name, data.value || data.duration, data.rating);
};
/**
 * 获取当前网络信息
 * @returns 网络信息对象
 */
var getNetworkInfo = function () {
    var networkInfo = {};
    // 获取连接类型信息
    if (navigator.connection) {
        var connection = navigator.connection;
        networkInfo.effectiveType = connection.effectiveType || "unknown"; // 有效网络类型：4g、3g、2g、slow-2g
        networkInfo.downlink = connection.downlink || 0; // 下行速度(Mbps)
        networkInfo.rtt = connection.rtt || 0; // 往返时间(ms)
        networkInfo.saveData = connection.saveData || false; // 是否启用省流量模式
        networkInfo.type = connection.type || "unknown"; // 网络类型
    }
    // 获取在线状态
    networkInfo.online = navigator.onLine;
    return networkInfo;
};
/**
 * @description 上报埋点
 * @param data
 */
var handlerWebVitalsTrack = function (data) {
    var metric = data.metric, name = data.name, statTrack = data.statTrack, domInfo = data.domInfo;
    log(name, metric);
    statTrack("tech_metric_web_basic", {
        metric_type: name,
        duration: metric.value,
        score: metric.rating,
        //源数据
        metricData: metric,
        //是否登录, 首页和工作台访问需要区分是否登录
        isLogin: !!window.localStorage.getItem("uid"),
        // 网络情况数据
        networkInfo: getNetworkInfo(),
        // 元素信息
        domInfo: domInfo,
    });
};
/**
 *
 * @param url 获取url参数长度
 * @returns
 */
var getUrlParamsLength = function (url) {
    var queryIndex = url.indexOf("?");
    if (queryIndex === -1)
        return 0; // 没有参数
    return url.length - queryIndex - 1;
};
/**
 * 获取请求参数数据
 * @param response Axios响应对象
 * @returns POST请求返回data数据，GET请求返回params数据
 */
var getUrlParamsData = function (config) {
    var method = config.method;
    if ((method === null || method === void 0 ? void 0 : method.toUpperCase()) === "POST") {
        return config.data;
    }
    else {
        return config.params;
    }
};
/**
 * 获取请求 status 对应的 code (埋点用), 2xx 都算成功
 * @param status 状态码
 * @returns number 1: 成功，0: 失败
 */
var getRequestSuccess = function (status) {
    return status >= 200 && status < 300 ? 1 : 0;
};
/**
 * @description 获取DOM元素的className
 * @param metric
 * @returns
 */
var getDomInfo = function (metric) {
    var className = "";
    var nodeName = "";
    var innerText = "";
    try {
        var entriesData = metric.entries;
        if (entriesData && entriesData[0]) {
            var target = entriesData[0].target;
            if (target) {
                if (target.className) {
                    className = target.className;
                }
                if (target.nodeName) {
                    nodeName = target.nodeName;
                }
                if (target.innerText) {
                    innerText = target.innerText;
                }
            }
        }
    }
    catch (e) {
        console.log(e);
    }
    return {
        className: className,
        nodeName: nodeName,
        innerText: innerText,
    };
};

/**
 * @description 性能监控与埋点工具箱
 * 提供Web性能监控和各类操作耗时统计的能力
 * @link 埋点文档: https://dayu.starii-rover.com/requirement/requirement?id=3096&appId=227&platformAgg=WEB&fullScreen=true
 * @link 需求文档：https://cf.meitu.com/confluence/pages/viewpage.action?pageId=549555498
 */
var performanceMonitor = {
    utils: {
        getUrlParamsData: getUrlParamsData,
        getUrlParamsLength: getUrlParamsLength,
    },
    setConfig: function (config) {
        window.localStorage.setItem("performanceMonitor", JSON.stringify(config));
    },
    /**
     * @description 监控并上报Web Vitals核心性能指标
     * 包括：TTFB, LCP, FCP, INP, CLS
     * @param statTrack 数据上报函数
     * @param sentry Sentry实例 （预留）
     */
    reportWebVitals: function (statTrack, sentry) {
        /**
         * @description 测量 TTFB (Time to First Byte)
         * 测量从请求开始到收到第一个字节的时间
         * 反映服务器响应速度
         * @example 如果 value 是 200，表示用了 200ms 接收到首字节
         */
        (0,web_vitals/* onTTFB */.mr)(function (metric) {
            handlerWebVitalsTrack({ metric: metric, name: "TTFB", statTrack: statTrack });
        });
        /**
         * @description  LCP (Largest Contentful Paint)
         * 测量页面最大内容元素的渲染时间
         * 反映页面加载性能
         * @example 如果 value 是 2000，表示最大内容元素渲染了 2000ms
         */
        (0,web_vitals/* onLCP */.NO)(function (metric) {
            handlerWebVitalsTrack({ metric: metric, name: "LCP", statTrack: statTrack });
        }, { reportAllChanges: true });
        /**
         * @description  FCP (First Contentful Paint)
         * 测量首次内容绘制时间
         * 反映用户首次看到实际内容的时间
         * @example 如果 value 是 1000，表示用户在 1 秒后看到第一个内容
         */
        (0,web_vitals/* onFCP */.a4)(function (metric) {
            handlerWebVitalsTrack({ metric: metric, name: "FCP", statTrack: statTrack });
        });
        /**
         * @description  INP (Interaction to Next Paint)
         * 测量交互到下一次绘制的时间
         * 反映页面交互响应性能
         * @example 如果 value 是 200，表示用户交互后200ms内完成了视觉更新
         */
        (0,web_vitals/* onINP */.Yn)(function (metric) {
            handlerWebVitalsTrack({
                metric: metric,
                name: "INP",
                statTrack: statTrack,
                domInfo: getDomInfo(metric),
            });
        }, { reportAllChanges: true });
        /**
         * @description  CLS (Cumulative Layout Shift)
         * 测量累积布局偏移
         * 反映页面视觉稳定性
         * @example 如果 value 是 0.1，表示页面的视觉稳定性较好，得分范围通常在 0-1 之间，越接近 0 越好
         */
        (0,web_vitals/* onCLS */.mw)(function (metric) {
            handlerWebVitalsTrack({ metric: metric, name: "CLS", statTrack: statTrack });
        }, { reportAllChanges: true });
    },
    /**
     * @description 获取操作开始时间戳
     * 用于记录任意操作的开始时间，如API请求、资源下载、计算过程等
     * @example
     * const startTime = performanceMonitor.getStartTime();
     * @returns {number} 当前时间戳（performance.now()）
     */
    getStartTime: function () {
        return performance.now();
    },
    /**
     * @description 上报操作耗时[通用]
     * 计算并上报任意操作的耗时数据，如API请求、资源下载、计算过程等
     * @param data.startTime 操作开始时间戳
     * @param data.statTrack 数据上报函数
     * @param data.eventName 埋点事件名称
     * @param data.trackData 可选，附加数据
     * @param data.sentry Sentry实例 （预留）
     * @param callback 可选，回调函数，用于处理补充逻辑
     *
     * @example
     * // API请求耗时上报
     * performanceMonitor.reportTiming({
     *   startTime,
     *   statTrack,
     *   eventName: "api_request",
     *   trackData: { url: "/api/users", method: "GET" }
     * });
     *
     * // 资源加载耗时上报
     * performanceMonitor.reportTiming({
     *   startTime,
     *   statTrack,
     *   eventName: "resource_load",
     *   trackData: { type: "image", url: "https://example.com/image.png" }
     * });
     */
    reportTiming: function (data, callback) {
        var startTime = data.startTime, statTrack = data.statTrack, _a = data.eventName, eventName = _a === void 0 ? "general_timing" : _a, _b = data.trackData, trackData = _b === void 0 ? {} : _b;
        var duration = performance.now() - startTime;
        log(eventName, __assign(__assign({}, trackData), { duration: duration }));
        statTrack(eventName, __assign(__assign({}, trackData), { duration: duration }));
        callback === null || callback === void 0 ? void 0 : callback();
    },
    /**
     * @description 上报Axios请求耗时
     * 计算并上报 Axios 请求的耗时数据
     * @param data.statTrack 数据上报函数
     * @param data.config Axios请求配置
     * @param data.status 响应状态码
     * @param data.sentry 可选 Sentry实例 （预留）
     * @param callback 可选，回调函数，用于处理补充逻辑
     * @example
     * @example
     * // 假设在Axios请求拦截器中记录了请求开始时间
     * axios.interceptors.request.use(config => {
     *   config.startTime = performance.now();  // 记录请求开始时间
     *   return config;
     * });
     *
     * // 在响应拦截器中计算并上报耗时
     * axios.interceptors.response.use(response => {
     *   const { startTime, statTrack } = response.config;   // 从请求配置中获取开始时间
     *   performanceMonitor.reportRequestTiming({
     *     statTrack,
     *     status: response.status,  // 响应状态码
     *     config: response.config  // 完整的请求配置
     *   });
     *   return response;  // 继续处理响应
     * })
     */
    reportRequestTiming: function (data, callback) {
        var config = data.config, statTrack = data.statTrack, status = data.status;
        if (!config)
            return;
        var startTime = config.startTime, method = config.method, url = config.url;
        if (!startTime || !url)
            return;
        this.reportTiming({
            startTime: startTime,
            statTrack: statTrack,
            eventName: "tech_metric_api_request_result",
            trackData: {
                is_success: status !== undefined ? getRequestSuccess(status) : 0,
                api_endpoint: url,
                request_method: method ? method.toUpperCase() : undefined,
                request_params: getUrlParamsData(config),
                param_length: getUrlParamsLength(url),
            },
        }, callback);
    },
    /**
     * @description 监控DOM元素渲染时间
     * 使用MutationObserver监听特定DOM元素的变化，计算并上报渲染耗时
     * @param data.startTime 可选，开始时间戳
     * @param data.statTrack 数据上报函数
     * @param data.element 要监控的DOM元素引用（例如React的ref.current）
     * @param data.eventName 埋点事件名称
     * @param data.trackData 可选，额外上报数据
     * @param data.config 可选，MutationObserver配置
     * @param data.timeout 可选，监控超时时间(ms)，默认10000ms
     * @param data.waitForImages 可选，是否要等待src属性的图片加载完成，默认true [大部分都是图片列表，如果只是简单监听dom渲染可以直接设置为false]
     * @param data.sentry 可选 Sentry实例 （预留）
     * @param callback 可选，回调函数，用于处理补充逻辑
     *
     * @returns MutationObserver实例，可用于手动断开观察
     * @example
     * // 在React组件中使用
     * const contentRef = useRef(null);
     * useEffect(() => {
     *   // startTime 可选，reportRenderTime 方法里有做自动获取 startTime 处理
     *   const startTime = performanceMonitor.getStartTime();
     *   // 数据加载完成后监控DOM渲染
     *   performanceMonitor.reportRenderTime({
     *     startTime,
     *     element: contentRef.current,
     *     statTrack,
     *     eventName: "list_render",
     *     trackData: { itemsCount: items.length }
     *   });
     * }, [items]);
     */
    reportRenderTime: function (data, callback) {
        var _a = data.startTime, startTime = _a === void 0 ? this.getStartTime() : _a, statTrack = data.statTrack, element = data.element, eventName = data.eventName, _b = data.trackData, trackData = _b === void 0 ? {} : _b, _c = data.config, config = _c === void 0 ? {
            childList: true,
            subtree: true,
            attributes: true,
        } : _c, _d = data.timeout, timeout = _d === void 0 ? 10000 : _d, _e = data.waitForImages, waitForImages = _e === void 0 ? true : _e;
        if (!element) {
            console.warn("reportRenderTime：The element is null.");
            return null;
        }
        // 防止重复上报
        var hasReported = false;
        // 创建MutationObserver实例
        var observer = new MutationObserver(function (mutations) {
            if (hasReported)
                return;
            // 确保DOM渲染后再检查图片
            requestAnimationFrame(function () {
                if (waitForImages) {
                    // 获取容器内所有图片
                    var images_1 = element.querySelectorAll("img");
                    if (images_1.length === 0) {
                        // 没有图片，直接上报DOM渲染时间
                        reportTiming();
                        return;
                    }
                    // 检查所有图片是否已加载
                    var loadedCount_1 = 0;
                    var imageArray = Array.from(images_1);
                    // 已加载的图片计数
                    imageArray.forEach(function (img) {
                        if (img.complete) {
                            loadedCount_1++;
                        }
                        else {
                            // 为未加载完的图片添加事件监听
                            img.addEventListener("load", function () {
                                if (hasReported)
                                    return; // 先检查是否已上报
                                loadedCount_1++;
                                if (loadedCount_1 === images_1.length) {
                                    reportTiming();
                                }
                            });
                            // 处理图片加载失败情况
                            img.addEventListener("error", function () {
                                if (hasReported)
                                    return; // 先检查是否已上报
                                loadedCount_1++;
                                if (loadedCount_1 === images_1.length) {
                                    reportTiming();
                                }
                            });
                        }
                    });
                    // 如果所有图片已经加载完成，直接上报
                    if (loadedCount_1 === images_1.length && !hasReported) {
                        // 确保这里也检查hasReported
                        reportTiming();
                    }
                }
                else {
                    // 不等待图片加载，仅监控DOM变化
                    reportTiming();
                }
            });
        });
        // 上报时间的函数
        function reportTiming() {
            if (hasReported)
                return; // 即使被多次调用也不会重复上报
            var duration = performance.now() - startTime;
            log(eventName, __assign(__assign({}, trackData), { duration: duration }));
            statTrack(eventName, __assign(__assign({}, trackData), { duration: duration }));
            hasReported = true;
            observer.disconnect();
            callback === null || callback === void 0 ? void 0 : callback();
        }
        observer.observe(element, config);
        // 设置超时，防止无限等待
        setTimeout(function () {
            if (!hasReported) {
                var duration = -1;
                statTrack(eventName, __assign(__assign({}, trackData), { duration: duration }));
                observer.disconnect();
                callback === null || callback === void 0 ? void 0 : callback({ timeout: true });
            }
        }, timeout);
    },
};



;// CONCATENATED MODULE: ./src/utils/request.ts

// import qs from "qs";












// 接口公共参数
const getCommonParams = async ()=>{
    if (false) {}
    const gid = await (0,utils_gid/* waitUntilGetGid */.S)();
    return {
        client_id: (0,constants/* getClientID */.kU)(),
        client_language: (0,dist_utils/* getClientLanguage */.XF)("zh-Hans"),
        country_code: await getCountryCode(),
        gid,
        enter_source: await (0,utils/* getSource */.b5)(),
        preview_mode: constants/* PREVIEW_MODE */.i4
    };
};
// 成本分摊埋点公共参数
const getMtccCommonParams = async ()=>{
    var ref, ref1;
    const isToB = (0,sdk/* checkIsInSdk */.X)();
    const params = {
        gid: (await getCommonParams()).gid,
        app_id: window._appId || undefined,
        osType: await (0,utils/* getOsType */.fP)(),
        isToB,
        // 设计室web:2
        // 内嵌:6
        virtualId: await (0,utils/* isPcPlatform */.FZ)() ? "6" : "2",
        functionInfo: {
            name: workbench/* MTCCDataScene */.AI[workbench/* Scene.AiPPT */.xs.AiPPT]
        },
        positionInfo: {
            level1: workbench/* MTCCDataScene */.AI[workbench/* Scene.AiPPT */.xs.AiPPT]
        },
        uid: (ref = store/* default.getState */.ZP.getState().userModel.userInfo) === null || ref === void 0 ? void 0 : ref.id,
        isPcPlatform: await (0,utils/* isPcPlatform */.FZ)(),
        isTeam: !!((ref1 = (0,lib/* getLocalIdentity */.u5)()) === null || ref1 === void 0 ? void 0 : ref1.oid),
        preview_mode: constants/* PREVIEW_MODE */.i4
    };
    return params;
};
// 成本分摊埋点 header
const genMtccHeader = async (config)=>{
    var ref;
    if (!config) {
        // 无配置则默认为抠图
        config = {
            key: "plugin-matting"
        };
    }
    const MatchMTCC = Object.keys(workbench/* MTCCData */.gA).find((key)=>{
        var ref;
        return config.key === key || ((ref = config.url) === null || ref === void 0 ? void 0 : ref.indexOf(key)) >= 0;
    });
    const isToB = ((ref = config.headers) === null || ref === void 0 ? void 0 : ref["Enterprise-Access-Key"]) ? true : (0,sdk/* checkIsInSdk */.X)();
    if (MatchMTCC) {
        var ref1;
        // 根据 url 匹配到的 MTCCData 的 key，获取对应的 position
        const findKey = workbench/* MTCCData */.gA[MatchMTCC].positionKey;
        const positionKey = findKey && config.data[findKey];
        const specialPosition = positionKey && ((ref1 = workbench/* MTCCData */.gA[MatchMTCC].position) === null || ref1 === void 0 ? void 0 : ref1[positionKey]) || "";
        const defaultMtccParams = await getMtccCommonParams();
        const params = {
            ...defaultMtccParams,
            isToB,
            mediaType: "",
            resMediaType: "",
            functionInfo: {
                ...defaultMtccParams.functionInfo,
                name: defaultMtccParams.functionInfo.name || workbench/* MTCCData */.gA[MatchMTCC].function || ""
            },
            positionInfo: {
                ...defaultMtccParams.positionInfo,
                level1: specialPosition || workbench/* MTCCData */.gA[MatchMTCC].position.default || workbench/* MTCCData */.gA[MatchMTCC].position[workbench/* Scene.AiPPT */.xs.AiPPT] || ""
            }
        };
        ;
        const headerString = await getMTCCClient(params);
        return headerString;
    }
};
// 全局的 axios 默认值
// ATTENTION: 这里的默认值会导致 x-design-widgets NavVipEntrance 组件请求接口错误
// axios.defaults.baseURL = "";
axios/* default.defaults.withCredentials */.Z.defaults.withCredentials = true;
axios/* default.defaults.headers.post.Content-Type */.Z.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
// 接口公共参数
// export const serverCommonParams = {
//   client_id: getClientID(),
//   preview_mode: PREVIEW_MODE,
// } as Record<string, string | number>;
// 添加请求拦截器
axios/* default.interceptors.request.use */.Z.interceptors.request.use(async (config)=>{
    var ref;
    // 国家码 SDK 复用全局 Axios；首次访问无缓存时若继续等待 getCountryCode 会形成请求死锁
    const isCountryCodeRequest = (ref = config.url) === null || ref === void 0 ? void 0 : ref.includes("/common/ip_location");
    const commonParams = config.skipAsyncCommonParams || isCountryCodeRequest ? {
        client_id: (0,constants/* getClientID */.kU)(),
        preview_mode: constants/* PREVIEW_MODE */.i4
    } : await getCommonParams();
    if (config.method === "post") {
        const data = Object.assign({}, commonParams, config.data || {});
        try {
            const headers = await genMtccHeader(config);
            if (headers) {
                config.headers["x-mtcc-client"] = headers;
            }
        } catch (error) {
            ;
        }
        if (config.headers["Content-Type"] === "application/x-www-form-urlencoded") {
        // config.data = qs.stringify(data);
        } else {
            config.data = data;
        }
        config.params = {
            ...commonParams,
            ...config.params
        };
    } else if (config.method === "get") {
        config.params = Object.assign({
            timestamp: new Date().getTime()
        }, commonParams, config.params || {});
    }
    return config;
}, (error)=>{
    // 对请求错误做些什么
    return Promise.reject(error);
});
// 添加响应拦截器
axios/* default.interceptors.response.use */.Z.interceptors.response.use(async (response)=>{
    var ref;
    if (![
        "get",
        "post"
    ].includes(((ref = response.config) === null || ref === void 0 ? void 0 : ref.method) || "")) return response;
    // const config: RequestConfig = response.config;
    // const hideErrorToast = config.hideErrorToast;
    // console.log('hideErrorToast: ', hideErrorToast);
    // 只针对get/post请求方式的返回做处理
    const code = response.data.error_code;
    // const msg = response.data.msg;
    // console.log('msg: ', msg);
    if (code !== constants_code/* default.OK */.Z.OK) {
    // if (!hideErrorToast) message.error(msg || '请求出错，请稍后再试');
    }
    // 对响应数据做点什么
    return response;
}, (error)=>{
    var ref, ref1;
    // message.error('您的网络发生异常，无法连接服务器');
    // return Promise.reject("您的网络发生异常，无法连接服务器");
    const res = error.response;
    const msg = (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.message) || (res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.msg) || "请求出错，请稍后再试";
    ;
    return Promise.reject({
        msg,
        network: true,
        data: (res === null || res === void 0 ? void 0 : res.data) || {}
    });
});
function request(api, config) {
    const requestOptions = Object.assign({
        hideErrorToast: false
    }, {
        url: api
    }, config);
    if (!requestOptions.headers) {
        requestOptions.headers = {};
    }
    // 团队版请求头标识
    requestOptions.headers = Object.assign(requestOptions.headers, (0,lib/* getRequestIdentityHeader */.AW)());
    let token = "";
    if (true) {
        const query = (0,utils_query/* getQuery */.pm)();
        token = query.accessToken || window.localStorage.getItem("access_token") || "";
    }
    requestOptions.headers.access_token = token;
    return (0,axios/* default */.Z)(requestOptions);
}


/***/ }),

/***/ 67887:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": () => (/* binding */ checkIsInSdk),
/* harmony export */   "r": () => (/* binding */ getAppId)
/* harmony export */ });
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82289);
/* harmony import */ var _constants_workbench__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99697);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20695);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78264);




const checkIsInSdk = ()=>{
    var ref;
    const origin = (ref = query_string__WEBPACK_IMPORTED_MODULE_2__/* ["default"].parse */ .Z.parse(window.location.search)) === null || ref === void 0 ? void 0 : ref.origin;
    return origin === _constants_workbench__WEBPACK_IMPORTED_MODULE_0__/* .SdkModuleName.aippt */ .sB.aippt && window.self !== window.top;
};
const getAppId = ()=>{
    const query = (0,_query__WEBPACK_IMPORTED_MODULE_3__/* .getQuery */ .pm)();
    return new Promise((resolve, reject)=>{
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) {
                if (xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) {
                    const res = JSON.parse(xhr.responseText);
                    if (res.data && res.data.app_id !== void 0) {
                        resolve(res.data);
                    } else {
                        reject();
                    }
                } else {
                    reject();
                }
            }
        };
        xhr.open("get", "".concat((0,_constants__WEBPACK_IMPORTED_MODULE_1__/* .getIntranetHost */ .Cu)(), "/common/get_app_id?client_id=").concat((0,_constants__WEBPACK_IMPORTED_MODULE_1__/* .getClientID */ .kU)()), true);
        xhr.setRequestHeader("access_token", query.accessToken || "");
        xhr.send(null);
    });
};


/***/ }),

/***/ 73811:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$8": () => (/* reexport */ createLocaleText),
  "s0": () => (/* reexport */ createLocaleTextWithDevI18nKey),
  "Kd": () => (/* reexport */ getLocale),
  "i_": () => (/* reexport */ setLocale),
  "og": () => (/* reexport */ useLocaleText)
});

// UNUSED EXPORTS: LocaleProvider

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-i18n/lib/createLocale.js
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function replacer(template, data) {
    var strTemplate = Array.isArray(template) ? template.join("") : template;
    var arrays = strTemplate.split(/(\${\d+})/);
    var results = [];
    for(var i = 0; i < arrays.length; i += 1){
        var match = arrays[i].match(/^\$\{(\d+)\}$/);
        if (match) {
            var index = parseInt(match[1], 10);
            results.push(data[index]);
        } else {
            results.push(arrays[i]);
        }
    }
    return results;
}
function nodeReplacer(template, data) {
    return replacer(template, data);
}
function textReplacer(template, data) {
    return replacer(template, data).join("");
}
function textWrapper(template, data) {
    var strTemplate = Array.isArray(template) ? template.join("") : template;
    var arrays = strTemplate.split(/<>|<\/>/);
    var count = Math.floor(arrays.length / 2);
    var results = [];
    for(var i = 0; i < arrays.length; i += 1){
        if (i % 2 === 1 && i <= count + 1) {
            var wrapper = data[(i - 1) / 2];
            results.push(wrapper ? wrapper(arrays[i]) : arrays[i]);
        } else {
            results.push(arrays[i]);
        }
    }
    return results;
}
/**
 * 解析 HTML 代码字符串为 HTML 节点对象
 *
 * @since 0.1.0
 * @param html - HTML 代码字符串
 */ function parseHtmlString(html) {
    var result = [];
    var regex = /<([a-z]+)([^>]*)\s*(?:>(.*?)<\/\1>|\/>)/gi;
    var match;
    while((match = regex.exec(html)) !== null){
        var tagName = match[1].toLowerCase();
        var attributes = match[2];
        var content = match[3];
        var attrsMatch = attributes.match(/([a-zA-Z_:][a-zA-Z0-9:._-]*)(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s"'>]+))?/g);
        var styleRegex = /style\s*=\s*"([^"]*)"/i;
        var styleMatch = attributes.match(styleRegex);
        var styleObj = {};
        var attrs = attrsMatch === null || attrsMatch === void 0 ? void 0 : attrsMatch.reduce(function(prev, attr) {
            var attrData = attr.replace(/"/g, "").split("=");
            var attrName = attrData[0] === "class" ? "className" : attrData[0];
            if (attrName) {
                prev[attrName] = attrData[1];
            }
            return prev;
        }, {});
        if (styleMatch && styleMatch[1]) {
            var styles = styleMatch[1].split(";");
            var _iterator = _createForOfIteratorHelper(styles), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var style = _step.value;
                    if (style.trim()) {
                        var colonIndex = style.indexOf(":");
                        if (colonIndex > -1) {
                            var key = style.substring(0, colonIndex).trim();
                            var value = style.substring(colonIndex + 1).trim();
                            if (key && value) {
                                styleObj[key] = value;
                            }
                        }
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        result.push({
            tag: tagName,
            props: _objectSpread(_objectSpread({}, attrs), {}, {
                style: styleObj
            }),
            children: [
                content
            ]
        });
    }
    return result;
}
/**
 * HTML 标签节点替换方法
 *
 * @since 0.1.0
 * @param template - 模板
 * @param replacer - 替换方法
 */ function htmlReplacer(template, replacer) {
    return replacer(parseHtmlString(template));
}
/**
 * 创建多语言本地化翻译文本数据映射及替换方法
 *
 * @param textResource - 翻译文本源数据
 */ function createLocaleText(textResource) {
    return function(print) {
        if (!textResource) return "";
        try {
            return print(textResource, {
                r: textReplacer,
                w: textWrapper,
                n: nodeReplacer,
                h: htmlReplacer
            });
        } catch (_e) {
            return "";
        }
    };
}

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-i18n/lib/context.js

var context_LocaleTextContext = /*#__PURE__*/ (0,react.createContext)("");

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-i18n/lib/useLocale.js


var localeInstance = "";
var getLocale = function getLocale() {
    return localeInstance;
};
var setLocale = function setLocale(_locale) {
    localeInstance = _locale;
};
var useLocaleText = function useLocaleText() {
    var locale = (0,react.useContext)(context_LocaleTextContext) || getLocale();
    return locale;
};

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-i18n/lib/LocaleProvider.js



function LocaleProvider(_ref) {
    var children = _ref.children, locale = _ref.locale;
    return /*#__PURE__*/ _jsx(LocaleTextContext.Provider, {
        value: locale,
        children: children
    });
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-i18n/lib/createLocaleTextWithDevI18nKey.js
function createLocaleTextWithDevI18nKey_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = createLocaleTextWithDevI18nKey_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function createLocaleTextWithDevI18nKey_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return createLocaleTextWithDevI18nKey_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return createLocaleTextWithDevI18nKey_arrayLikeToArray(o, minLen);
}
function createLocaleTextWithDevI18nKey_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function createLocaleTextWithDevI18nKey_typeof(o) {
    "@babel/helpers - typeof";
    return createLocaleTextWithDevI18nKey_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, createLocaleTextWithDevI18nKey_typeof(o);
}

/**
 * 拦截 `$t` 的输出，记录「翻译值 -\> i18n key」反向映射，挂在 window 方便调试。
 * `window.__DEV_I18N_VALUE_KEY_MAP__`：`{ next: {}, legacy: {} }`
 * - `next`：`{ [translatedValue]: string[] }`，值为 path 数组
 * - `legacy`：`{ [chunkKey]: { [translatedValue]: string[] } }`，按 legacyChunkKey 分组
 * 多个 path 时逐个判断：在 next zh-Hans 中的归入 `next`，否则归入 `legacy[chunkKey]`。
 */ function createLocaleTextWithDevI18nKey(localeText, legacyChunkKey) {
    if ( false || !window.__LOCALE_TEXT_NEXT_MAP__) {
        return createLocaleText(localeText);
    }
    // Proxy 只能包对象；locale 未在 localeTextMap 中命中时会是 undefined，需降级为原始 createLocaleText
    var canTrackKeys = localeText !== null && localeText !== undefined && createLocaleTextWithDevI18nKey_typeof(localeText) === "object";
    if (!canTrackKeys) {
        return createLocaleText(localeText);
    }
    var accessedKeys = [];
    var seenKeys = new Set();
    var tracked = createNestedTrackedLocale(localeText, "", accessedKeys, seenKeys);
    var printTranslated = createLocaleText(tracked);
    return function(print) {
        accessedKeys.length = 0;
        seenKeys.clear();
        var result = printTranslated(print);
        syncI18nValueToKeyStore(accessedKeys, result, legacyChunkKey);
        return result;
    };
}
function syncI18nValueToKeyStore(accessedKeys, translationResult, legacyChunkKey) {
    var _window$__DEV_I18N_VA;
    if ( false || accessedKeys.length === 0) {
        return;
    }
    var translatedValue = extractTranslationText(translationResult);
    if (!translatedValue) {
        return;
    }
    window.__DEV_I18N_VALUE_KEY_MAP__ = (_window$__DEV_I18N_VA = window.__DEV_I18N_VALUE_KEY_MAP__) !== null && _window$__DEV_I18N_VA !== void 0 ? _window$__DEV_I18N_VA : {
        next: {},
        legacy: {}
    };
    var lookup = window.__LOCALE_TEXT_NEXT_MAP__;
    var nextSegments = [];
    var legacySegments = [];
    var _iterator = createLocaleTextWithDevI18nKey_createForOfIteratorHelper(accessedKeys), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var segment = _step.value;
            if (Object.prototype.hasOwnProperty.call(lookup, segment)) {
                nextSegments.push(segment);
            } else {
                legacySegments.push(segment);
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var maps = window.__DEV_I18N_VALUE_KEY_MAP__;
    mergeKeyPathsIntoBucket(maps.next, translatedValue, nextSegments);
    // legacy 按 legacyChunkKey 分组存储，结构为 { [chunkKey]: { [translatedValue]: string[] } }
    var chunkKey = legacyChunkKey || "_unknown";
    var legacyMap = maps.legacy;
    if (!legacyMap[chunkKey]) {
        legacyMap[chunkKey] = {};
    }
    mergeKeyPathsIntoBucket(legacyMap[chunkKey], translatedValue, legacySegments);
}
/** 将本次 path 合并进该 bucket 下对应译文的数组（与历史记录去重合并） */ function mergeKeyPathsIntoBucket(bucket, translatedValue, segments) {
    if (segments.length === 0) {
        return;
    }
    var prev = bucket[translatedValue];
    var merged = new Set(prev !== null && prev !== void 0 ? prev : []);
    var _iterator2 = createLocaleTextWithDevI18nKey_createForOfIteratorHelper(segments), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var s = _step2.value;
            merged.add(s);
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    bucket[translatedValue] = Array.from(merged);
}
function extractTranslationText(value) {
    if (value === null || value === undefined || typeof value === "boolean") {
        return "";
    }
    if (typeof value === "string" || typeof value === "number") {
        return String(value);
    }
    if (Array.isArray(value)) {
        return value.map(function(item) {
            return extractTranslationText(item);
        }).filter(Boolean).join("");
    }
    if (createLocaleTextWithDevI18nKey_typeof(value) === "object" && value !== null && "props" in value) {
        var props = value.props;
        return extractTranslationText(props === null || props === void 0 ? void 0 : props.children);
    }
    return "";
}
/** 仅对「普通对象」继续包 Proxy；数组/Date 等视为叶子，记录完整 path 后原样返回 */ function isNestedLocaleNode(value) {
    if (value === null || createLocaleTextWithDevI18nKey_typeof(value) !== "object") {
        return false;
    }
    if (Array.isArray(value)) {
        return false;
    }
    var tag = Object.prototype.toString.call(value);
    return tag === "[object Object]";
}
/**
 * @param pathPrefix - 当前节点路径，根为 ''，子节点为 `watermarkRemover` 等
 */ function createNestedTrackedLocale(target, pathPrefix, accessedKeys, seenKeys) {
    return new Proxy(target, {
        get: function get(obj, prop, receiver) {
            if (typeof prop !== "string" || prop === "then") {
                return Reflect.get(obj, prop, receiver);
            }
            var segment = pathPrefix ? "".concat(pathPrefix, ".").concat(prop) : prop;
            var value = Reflect.get(obj, prop, receiver);
            if (isNestedLocaleNode(value)) {
                return createNestedTrackedLocale(value, segment, accessedKeys, seenKeys);
            }
            if (!seenKeys.has(segment)) {
                seenKeys.add(segment);
                accessedKeys.push(segment);
            }
            return value;
        }
    });
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-i18n/lib/index.js







/***/ }),

/***/ 15328:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ dist_IconFont)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-icon-font/dist/config.js
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var config = {
    isIntl: false
};
var getConfig = function getConfig() {
    return _objectSpread({}, config);
};
var setConfig = function setConfig(params) {
    for(var key in params){
        if (Object.prototype.hasOwnProperty.call(params, key)) {
            var typedKey = key;
            config[typedKey] = params[typedKey];
        }
    }
};

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-icon-font/dist/iconHash.js
// ⚠️ 此文件由 scripts/gen-icon-hash.ts 自动生成，请勿手动修改 
var ICON_HASH = "1aabf9b2";

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-icon-font/dist/IconFont.js
/* provided dependency */ var process = __webpack_require__(34155);
function IconFont_typeof(o) {
    "@babel/helpers - typeof";
    return IconFont_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, IconFont_typeof(o);
}
var _excluded = [
    "name",
    "className",
    "color",
    "fontSize",
    "style",
    "onClick"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function IconFont_ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function IconFont_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? IconFont_ownKeys(Object(t), !0).forEach(function(r) {
            IconFont_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : IconFont_ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function IconFont_defineProperty(obj, key, value) {
    key = IconFont_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function IconFont_toPropertyKey(t) {
    var i = IconFont_toPrimitive(t, "string");
    return "symbol" == IconFont_typeof(i) ? i : String(i);
}
function IconFont_toPrimitive(t, r) {
    if ("object" != IconFont_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != IconFont_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    _regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t1) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t1) {
            return {
                type: "throw",
                arg: t1
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == IconFont_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw new Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError(IconFont_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw new Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        catch: function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r1) {
            o = !0, n = r1;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var iconCache = new Map();
var pendingFetches = new Map();
var IconFont = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var name = props.name, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, color = props.color, fontSize = props.fontSize, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style, onClick = props.onClick, restProps = _objectWithoutProperties(props, _excluded);
    var _useState = (0,react.useState)(null), _useState2 = _slicedToArray(_useState, 2), svgContent = _useState2[0], setSvgContent = _useState2[1];
    var _useState3 = (0,react.useState)(false), _useState4 = _slicedToArray(_useState3, 2), error = _useState4[0], setError = _useState4[1];
    var _getConfig = getConfig(), isIntl = _getConfig.isIntl;
    (0,react.useEffect)(function() {
        var _process$env;
        if (!name) return;
        var isMounted = true;
        var isDev = typeof process !== "undefined" && ((_process$env = process.env) === null || _process$env === void 0 ? void 0 : _process$env.UMI_APP_ENV) === "development"; // 兼容SSR环境
        var cdnPrefix = isIntl ? "https://x-design-static-release.stariicloud.com" : "https://pc.meitudata.com";
        var nameOriginal = name.charAt(0).toLowerCase() + name.slice(1);
        var url = isDev ? "/x-design-icons/icons/".concat(nameOriginal, ".svg") : "".concat(cdnPrefix, "/x-design-icons/").concat(ICON_HASH, "/").concat(nameOriginal, ".svg");
        var loadSVG = /*#__PURE__*/ function() {
            var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee2() {
                var content, fetchPromise, svg;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while(1)switch(_context2.prev = _context2.next){
                        case 0:
                            if (!iconCache.has(name)) {
                                _context2.next = 3;
                                break;
                            }
                            setSvgContent(iconCache.get(name));
                            return _context2.abrupt("return");
                        case 3:
                            if (!pendingFetches.has(name)) {
                                _context2.next = 9;
                                break;
                            }
                            _context2.next = 6;
                            return pendingFetches.get(name);
                        case 6:
                            content = _context2.sent;
                            if (isMounted) setSvgContent(content);
                            return _context2.abrupt("return");
                        case 9:
                            fetchPromise = fetch(url).then(/*#__PURE__*/ function() {
                                var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee(res) {
                                    var svgText, parser, doc, svg;
                                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                                        while(1)switch(_context.prev = _context.next){
                                            case 0:
                                                if (res.ok) {
                                                    _context.next = 2;
                                                    break;
                                                }
                                                throw new Error("Failed to load ".concat(name));
                                            case 2:
                                                _context.next = 4;
                                                return res.text();
                                            case 4:
                                                svgText = _context.sent;
                                                // 用 DOMParser 解析 SVG 内容为 DOM
                                                parser = new DOMParser();
                                                doc = parser.parseFromString(svgText, "image/svg+xml");
                                                svg = doc.querySelector("svg");
                                                if (svg) {
                                                    _context.next = 10;
                                                    break;
                                                }
                                                throw new Error("Invalid SVG content for icon [".concat(name, "]"));
                                            case 10:
                                                // 设置 width/height 为 1em
                                                svg.setAttribute("width", "1em");
                                                svg.setAttribute("height", "1em");
                                                // 设置 fill="currentColor"（排除 fill="none"）
                                                svg.querySelectorAll("[fill]").forEach(function(el) {
                                                    var fill = el.getAttribute("fill");
                                                    if (fill && fill.toLowerCase() !== "none") {
                                                        el.setAttribute("fill", "currentColor");
                                                    }
                                                });
                                                // 移除 <defs> 节点
                                                svg.querySelectorAll("defs").forEach(function(defs) {
                                                    return defs.remove();
                                                });
                                                // 移除 clip-path、mask、filter 属性
                                                [
                                                    "clip-path",
                                                    "mask",
                                                    "filter"
                                                ].forEach(function(attr) {
                                                    svg.querySelectorAll("[".concat(attr, "]")).forEach(function(el) {
                                                        el.removeAttribute(attr);
                                                    });
                                                });
                                                return _context.abrupt("return", svg.outerHTML);
                                            case 16:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(_x) {
                                    return _ref2.apply(this, arguments);
                                };
                            }()).then(function(svg) {
                                iconCache.set(name, svg);
                                return svg;
                            }).catch(function(err) {
                                ;
                                setError(true);
                                return "";
                            });
                            pendingFetches.set(name, fetchPromise);
                            _context2.next = 13;
                            return fetchPromise;
                        case 13:
                            svg = _context2.sent;
                            if (isMounted) setSvgContent(svg);
                        case 15:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2);
            }));
            return function loadSVG() {
                return _ref.apply(this, arguments);
            };
        }();
        loadSVG();
        return function() {
            isMounted = false;
        };
    }, [
        name
    ]);
    var size = style.fontSize || fontSize || 12;
    return /*#__PURE__*/ react.createElement("span", _extends({
        className: "iconfont icon-".concat(name, " ").concat(className),
        "alias-name": name,
        style: IconFont_objectSpread({
            width: size,
            height: size,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: color,
            fontSize: size
        }, style),
        dangerouslySetInnerHTML: svgContent && !error ? {
            __html: svgContent
        } : undefined,
        ref: ref
    }, restProps, {
        onClick: onClick
    }));
});
/* harmony default export */ const dist_IconFont = (/*#__PURE__*/react.memo(IconFont));


/***/ }),

/***/ 99861:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AW": () => (/* binding */ getRequestIdentityHeader),
/* harmony export */   "LW": () => (/* binding */ setMemoryIdentity),
/* harmony export */   "Nz": () => (/* binding */ setLocalOriginUid),
/* harmony export */   "Rw": () => (/* binding */ getIdentityFromCookie),
/* harmony export */   "Yb": () => (/* binding */ disableTeamIdentity),
/* harmony export */   "kF": () => (/* binding */ setLocalIdentity),
/* harmony export */   "lD": () => (/* binding */ enableTeamIdentity),
/* harmony export */   "lQ": () => (/* binding */ addStorageChangeListener),
/* harmony export */   "mK": () => (/* binding */ removeLocalIdentity),
/* harmony export */   "pB": () => (/* binding */ getLocalRecentIdentity),
/* harmony export */   "tK": () => (/* binding */ removeLocalRecentIdentity),
/* harmony export */   "u5": () => (/* binding */ getLocalIdentity)
/* harmony export */ });
/* unused harmony exports LOCAL_OUID_KEY, setLocalRecentIdentity */
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);

// 当前身份的缓存key
var LOCAL_USER_IDENTITY_KEY = "user_identity".concat(getSuffix());
// 最近登录身份的缓存key
var LOCAL_USER_IDENTITY_RECENT_KEY = "user_identity_recent".concat(getSuffix());
// origin_uid缓存key
var LOCAL_ORIGIN_UID_KEY = "origin_uid".concat(getSuffix());
// 当前身份下的uid
var LOCAL_OUID_KEY = "ouid".concat(getSuffix());
var isNode = "object" === "undefined";
// 同步历史身份缓存到cookie中
if (!isNode) {
    try {
        var oldVersionValue = window.localStorage.getItem(LOCAL_USER_IDENTITY_KEY);
        if (oldVersionValue) {
            js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(LOCAL_USER_IDENTITY_KEY, oldVersionValue, {
                domain: getRootDomain(),
                expires: 36500
            });
            window.localStorage.removeItem(LOCAL_USER_IDENTITY_KEY);
        }
    } catch (e) {
        ;
    }
}
var personalIdentity = {
    oid: 0,
    groupId: 0
};
var localInit = isNode ? personalIdentity : getIdentityFromCookie();
var local_oid = (localInit === null || localInit === void 0 ? void 0 : localInit.oid) || 0;
var local_groupId = (localInit === null || localInit === void 0 ? void 0 : localInit.groupId) || 0;
var changeHandle;
if (!isNode) {
    var workerCode = '\n    self.onmessage = function(event) {\n      setInterval(() => {\n        // 向主线程发送消息\n        postMessage("");\n      }, 1000);\n    };\n  ';
    var blob = new Blob([
        workerCode
    ], {
        type: "application/javascript"
    });
    // 创建一个新的 Worker
    var worker = new Worker(URL.createObjectURL(blob));
    // 接收 Worker 发来的消息
    worker.onmessage = function() {
        var curValue = getIdentityFromCookie();
        if (curValue.oid !== local_oid && local_groupId !== curValue.groupId) {
            // 发生变化
            changeHandle === null || changeHandle === void 0 ? void 0 : changeHandle(curValue.oid, curValue.groupId);
        }
    };
    // 发送消息给 Worker，启动定时器
    worker.postMessage("");
}
var isDisableTeam = false;
/**
 * 禁用团队功能
 */ function disableTeamIdentity() {
    isDisableTeam = true;
}
/**
 * 开启团队功能
 */ function enableTeamIdentity() {
    isDisableTeam = false;
}
/**
 * 更新内存的身份信息
 * @param oid
 * @param groupId
 */ function setMemoryIdentity(oid, groupId) {
    local_oid = oid;
    local_groupId = groupId;
}
function addStorageChangeListener(cb) {
    changeHandle = cb;
}
/**
 * 获取cookie最新的身份
 * @returns
 */ function getIdentityFromCookie() {
    return JSON.parse(js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LOCAL_USER_IDENTITY_KEY) || "".concat(JSON.stringify(personalIdentity)));
}
/**
 * 获取缓存中的身份
 * @returns
 */ function getLocalIdentity() {
    if (isDisableTeam) return personalIdentity;
    return {
        oid: local_oid,
        groupId: local_groupId
    };
}
/**
 * 获取缓存中的最近身份信息
 * @returns
 */ function getLocalRecentIdentity() {
    var _a, _b, _c, _d;
    if (isDisableTeam) return {
        oid: 0,
        groupId: 0,
        ouid: 0,
        originUid: 0
    };
    var localStr = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LOCAL_USER_IDENTITY_RECENT_KEY);
    if (!localStr) {
        return null;
    }
    var list = [];
    try {
        list = JSON.parse(localStr);
    } catch (e) {}
    return {
        oid: (_a = list[0]) === null || _a === void 0 ? void 0 : _a.oid,
        groupId: (_b = list[0]) === null || _b === void 0 ? void 0 : _b.groupId,
        ouid: (_c = list[0]) === null || _c === void 0 ? void 0 : _c.ouid,
        originUid: (_d = list[0]) === null || _d === void 0 ? void 0 : _d.originUid
    };
}
/**
 * 移除缓存
 */ function removeLocalIdentity() {
    local_oid = 0;
    local_groupId = 0;
    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove(LOCAL_USER_IDENTITY_KEY, {
        domain: getRootDomain()
    });
}
/**
 * 移除最近登录身份信息缓存
 */ function removeLocalRecentIdentity() {
    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove(LOCAL_USER_IDENTITY_RECENT_KEY, {
        domain: getRootDomain()
    });
}
/**
 * 写入身份缓存
 * @param oid
 * @param groupId
 * @param shouldUpateRecent 是否需要更新最近登录身份的数据
 */ function setLocalIdentity(oid, groupId, shouldUpateRecent) {
    if (shouldUpateRecent === void 0) {
        shouldUpateRecent = true;
    }
    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(LOCAL_USER_IDENTITY_KEY, JSON.stringify({
        oid: oid,
        groupId: groupId
    }), {
        domain: getRootDomain(),
        expires: 36500
    });
    if (shouldUpateRecent) {
        setLocalRecentIdentity(oid, groupId);
    }
    if (oid !== local_oid && local_groupId !== groupId) {
        // 发生变化
        changeHandle === null || changeHandle === void 0 ? void 0 : changeHandle(oid, groupId);
    }
}
/**
 * 写入最近登录身份的缓存
 * @param oid
 * @param groupId
 */ function setLocalRecentIdentity(oid, groupId) {
    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(LOCAL_USER_IDENTITY_RECENT_KEY, JSON.stringify([
        {
            oid: oid,
            groupId: groupId,
            ouid: Number(js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LOCAL_OUID_KEY) || 0),
            originUid: Number(js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LOCAL_ORIGIN_UID_KEY) || 0)
        }
    ]), {
        domain: getRootDomain(),
        expires: 36500
    });
}
/**
 * 写入origin_uid缓存
 * @param uid
 */ function setLocalOriginUid(uid) {
    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(LOCAL_ORIGIN_UID_KEY, String(uid), {
        domain: getRootDomain(),
        expires: 36500
    });
}
/**
 * 获取请求头部
 * @returns
 */ function getRequestIdentityHeader() {
    var _a, _b;
    return {
        "Client-OID": ((_a = getLocalIdentity()) === null || _a === void 0 ? void 0 : _a.oid) || 0,
        "Client-OGroupID": ((_b = getLocalIdentity()) === null || _b === void 0 ? void 0 : _b.oid) || 0
    };
}
/**
 * 当前地址的环境: pre/beta/release
 */ function getSuffix() {
    if (false) {}
    if (window.location.origin.includes("//localhost")) {
        return "--local";
    } else if (window.location.origin.includes("//pre")) {
        return "--pre";
    } else if (window.location.origin.includes("//beta")) {
        return "--beta";
    } else {
        return "";
    }
}
/**
 * 获取根域名
 * @returns
 */ function getRootDomain() {
    var hostname = window.location.hostname;
    // 分割域名为各个部分
    var parts = hostname.split(".").reverse();
    // 如果域名部分少于两个，直接返回
    if (parts.length < 2) {
        return hostname;
    }
    // 常见的二级顶级域名（ccTLDs）列表
    var commonTlds = [
        "co",
        "com",
        "org",
        "net",
        "gov",
        "edu",
        "mil"
    ];
    // 获取根域名
    var rootDomain = parts[1] + "." + parts[0];
    // 处理二级顶级域名情况
    if (commonTlds.includes(parts[1].toLowerCase()) && parts.length > 2) {
        rootDomain = parts[2] + "." + rootDomain;
    }
    return rootDomain;
}


/***/ }),

/***/ 26985:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56369);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73009);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _cls__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12482);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16178);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_2__);


var _excluded = [
    "className",
    "icon",
    "type",
    "htmlType",
    "size",
    "children"
];




var subPrefix = "Button";
var cls$ = (0,_cls__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(subPrefix);
var Button = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_ref, ref) {
    var _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, icon = _ref.icon, _ref$type = _ref.type, type = _ref$type === void 0 ? "default" : _ref$type, _ref$htmlType = _ref.htmlType, htmlType = _ref$htmlType === void 0 ? "button" : _ref$htmlType, _ref$size = _ref.size, size = _ref$size === void 0 ? "large" : _ref$size, children = _ref.children, restProps = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("button", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        /* eslint-disable-next-line react/button-has-type */ type: htmlType,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(cls$(), className),
        "data-type": type,
        "data-size": size
    }, restProps, {
        ref: ref
    }), icon, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: cls$("children")
    }, children));
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Button);


/***/ }),

/***/ 12482:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony exports basicPrefix, getPrefix */
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69222);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);


var basicPrefix = "mt-design-rc";
var getPrefix = function getPrefix(subPrefix) {
    return "".concat(basicPrefix, "-").concat(subPrefix);
};
var getClsWithPrefix = function getClsWithPrefix(subPrefix) {
    var prefix = getPrefix(subPrefix);
    var cls = function cls() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (args.length === 0) return prefix;
        return classnames__WEBPACK_IMPORTED_MODULE_0___default()(args.map(function(arg) {
            if (typeof arg === "string") {
                return arg === "" ? prefix : "".concat(prefix, "__").concat(arg);
            } else if (Array.isArray(arg)) {
                return arg.map(function(a) {
                    return cls(a);
                }).join(" ");
            }
            return Object.entries(arg).filter(function(_ref) {
                var _ref2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, 2), _ = _ref2[0], v = _ref2[1];
                return v;
            }).map(function(_ref3) {
                var _ref4 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref3, 1), arg = _ref4[0];
                return arg === "" ? prefix : "".concat(prefix, "__").concat(arg);
            });
        }));
    };
    return cls;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (getClsWithPrefix);


/***/ }),

/***/ 49143:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56369);
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81549);
/* harmony import */ var body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58509);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73935);
/* harmony import */ var _cls__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12482);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23250);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_4__);








var subPrefix = "CommonModal";
var cls$ = (0,_cls__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(subPrefix);
var CommonModal = function CommonModal(_ref) {
    var _ref$open = _ref.open, open = _ref$open === void 0 ? false : _ref$open, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, _ref$wrapClassName = _ref.wrapClassName, wrapClassName = _ref$wrapClassName === void 0 ? "" : _ref$wrapClassName, wrapProps = _ref.wrapProps, metaNode = _ref.metaNode, children = _ref.children, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 999 : _ref$zIndex, _ref$maskClosable = _ref.maskClosable, maskClosable = _ref$maskClosable === void 0 ? false : _ref$maskClosable, _ref$destroyOnClose = _ref.destroyOnClose, destroyOnClose = _ref$destroyOnClose === void 0 ? false : _ref$destroyOnClose, onClose = _ref.onClose, _ref$lockScroll = _ref.lockScroll, lockScroll = _ref$lockScroll === void 0 ? true : _ref$lockScroll;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (open && lockScroll) {
            (0,body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__/* .disableBodyScroll */ .Qp)(document.body, {
                reserveScrollBarGap: true
            });
            return function() {
                (0,body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__/* .enableBodyScroll */ .tG)(document.body);
            };
        }
    }, [
        open,
        lockScroll
    ]);
    if (!open && destroyOnClose) return null;
    return /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_3__.createPortal)(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, wrapProps, {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(cls$(), wrapClassName),
        style: (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            "--zindex": zIndex,
            display: open ? undefined : "none"
        }, wrapProps === null || wrapProps === void 0 ? void 0 : wrapProps.style)
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        className: cls$("mask"),
        onClick: function onClick(e) {
            // 阻止蒙层点击透传到后面的dom
            e.stopPropagation();
            e.preventDefault();
            if (maskClosable) onClose === null || onClose === void 0 || onClose();
        }
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(cls$("inner"), className)
    }, children), metaNode), document.body);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CommonModal);


/***/ }),

/***/ 77977:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "j": () => (/* binding */ MESSAGE_LIST_CLASS_NAME)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81549);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(33641);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73009);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69222);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var rc_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24557);
/* harmony import */ var rc_util_lib_React_render__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81725);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15328);
/* harmony import */ var _cls__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12482);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61824);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_5__);




var _excluded = [
    "key",
    "zIndex"
];








var subPrefix = "Message";
var cls$ = (0,_cls__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(subPrefix);
var MESSAGE_LIST_CLASS_NAME = cls$("list");
var defaultZIndex = 1010;
var defaultDuration = 3;
var MessageUI = function MessageUI(_ref) {
    var _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? defaultDuration : _ref$duration, icon = _ref.icon, content = _ref.content;
    var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true), _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (duration === 0) return;
        var timer = setTimeout(function() {
            setOpen(false);
        }, duration * 1000);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        duration
    ]);
    var edgeCss = {
        padding: 0,
        height: 0,
        opacity: 0
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(rc_motion__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        motionName: cls$("move"),
        visible: open,
        onAppearStart: function onAppearStart() {
            return edgeCss;
        },
        onEnterStart: function onEnterStart() {
            return edgeCss;
        },
        onLeaveActive: function onLeaveActive() {
            return edgeCss;
        }
    }, function(_ref2) {
        var style = _ref2.style, motionClassName = _ref2.className;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(cls$(), motionClassName),
            style: style
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
            className: cls$("inner")
        }, !!icon && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
            className: cls$("icon")
        }, icon), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
            className: cls$("content")
        }, content)));
    });
};
var MessageListWrapper = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.forwardRef(function(_, ref) {
    var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]), _useState4 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_useState3, 2), messageList = _useState4[0], setMessageList = _useState4[1];
    var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(defaultZIndex), _useState6 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_useState5, 2), zIndex = _useState6[0], setZIndex = _useState6[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useImperativeHandle)(ref, function() {
        return {
            open: function open(_ref3) {
                var _ref3$key = _ref3.key, key = _ref3$key === void 0 ? "".concat(Date.now()) : _ref3$key, _ref3$zIndex = _ref3.zIndex, nextZIndex = _ref3$zIndex === void 0 ? defaultZIndex : _ref3$zIndex, cfg = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref3, _excluded);
                setZIndex(nextZIndex);
                setMessageList(function(list) {
                    return (0,lodash__WEBPACK_IMPORTED_MODULE_1__.uniqBy)([].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(list), [
                        {
                            key: key,
                            cfg: cfg
                        }
                    ]), "key");
                });
            }
        };
    }, [
        setMessageList,
        setZIndex
    ]);
    if (!messageList.length) return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, null);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
        className: MESSAGE_LIST_CLASS_NAME,
        style: {
            zIndex: zIndex
        }
    }, messageList.map(function(_ref4) {
        var key = _ref4.key, _ref4$cfg = _ref4.cfg, icon = _ref4$cfg.icon, content = _ref4$cfg.content, _ref4$cfg$duration = _ref4$cfg.duration, duration = _ref4$cfg$duration === void 0 ? defaultDuration : _ref4$cfg$duration;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(MessageUI, {
            key: key,
            icon: icon,
            content: content,
            duration: duration
        });
    }));
});
var messageWrapperEl;
var commonMessage = function commonMessage(cfg) {
    if (!messageWrapperEl || !document.contains(messageWrapperEl)) {
        messageWrapperEl = document.createElement("div");
        document.body.appendChild(messageWrapperEl);
    }
    (0,rc_util_lib_React_render__WEBPACK_IMPORTED_MODULE_3__/* .render */ .sY)(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(MessageListWrapper, {
        ref: function ref(_ref5) {
            return _ref5 === null || _ref5 === void 0 ? void 0 : _ref5.open(cfg);
        }
    }), messageWrapperEl);
};
var getSuccessLikeFn = function getSuccessLikeFn(_ref6) {
    var defaultIconName = _ref6.defaultIconName, defaultIconColor = _ref6.defaultIconColor;
    return function(config) {
        var defaultIcon = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            name: defaultIconName,
            fontSize: 20,
            color: defaultIconColor
        });
        commonMessage(typeof config === "string" ? {
            icon: defaultIcon,
            content: config
        } : (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
            icon: defaultIcon
        }, config));
    };
};
var message = {
    config: commonMessage,
    success: getSuccessLikeFn({
        defaultIconName: "CheckCircleFillBold",
        defaultIconColor: "var(--content-system-info-icon-success, #4FC62B)"
    }),
    info: getSuccessLikeFn({
        defaultIconName: "InfoCircleBoldFill",
        defaultIconColor: "var(--content-system-info-icon-regular, #8CC0FF)"
    }),
    error: getSuccessLikeFn({
        defaultIconName: "ExclamationMarkCircleBoldFill",
        defaultIconColor: "var(--content-system-info-icon-warning, #F74640)"
    })
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (message);


/***/ }),

/***/ 84480:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BD": () => (/* binding */ ENV_ENUM),
/* harmony export */   "ZR": () => (/* binding */ useConfig),
/* harmony export */   "iE": () => (/* binding */ getConfig),
/* harmony export */   "qK": () => (/* binding */ setConfigPartial),
/* harmony export */   "v6": () => (/* binding */ setConfig)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81549);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69222);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pubsub_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1798);
/* harmony import */ var pubsub_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pubsub_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var ConfigUpdateEvent = "xdesign-widgets__config-update-event";
var ENV_ENUM = /*#__PURE__*/ function(ENV_ENUM) {
    ENV_ENUM["dev"] = "dev";
    ENV_ENUM["pre"] = "pre";
    ENV_ENUM["beta"] = "beta";
    ENV_ENUM["release"] = "release";
    return ENV_ENUM;
}({});
/**
 * 获取country_code 兜底
 * @param language  通过navigator.language获取的值
 * @returns
 */ var getCountryCode = function getCountryCode() {
    // 如果是在 SSR 环境下，直接返回空字符串
    if (false) {}
    var language = navigator.language;
    var regionMap = {
        "zh-CN": "CN",
        "zh-TW": "TW",
        "ja-JP": "JP",
        "ko-KR": "KR",
        "en-US": "US",
        "en-AU": "AU",
        "en-CA": "CA",
        "zh-HK": "HK",
        "th-TH": "TH",
        "en-GB": "GB",
        "en-SG": "SG",
        "ms-SG": "SG",
        "zh-SG": "SG",
        "vi-VN": "VN",
        "zh-MO": "MO",
        "pt-MO": "MO",
        "tl-PH": "PH",
        "en-PH": "PH",
        "id-ID": "ID",
        "en-NZ": "NZ",
        "mi-NZ": "NZ",
        fil: "PH"
    };
    if (regionMap[language]) {
        return regionMap[language];
    }
    // 如果有区域代码，格式是 <language>-<region>，
    // 例如：en-US — 英语（美国）、zh-CN — 简体中文（中国）
    if (language && language.includes("-")) {
        var _language$split = language.split("-"), _language$split2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_language$split, 2), _ = _language$split2[0], rg = _language$split2[1];
        if (rg) {
            return rg;
        }
    }
    // 用语言匹配
    var keys = Object.keys(regionMap);
    for(var i = 0; i < keys.length; i++){
        var element = keys[i];
        if (element.includes(language)) {
            return regionMap[element];
        }
    }
    return language;
};
var _configState = {
    theme: "light",
    env: ENV_ENUM.release,
    client_id: "",
    gid: "",
    device_id: "",
    channel: "",
    /**
   * 外部传入的 country_code 都采用 utils 包异步设置的方式，所以会有一个“空窗期”
   * 这里兜底一个默认值，默认是取 navigator.language 进行判断
   */ country_code: getCountryCode(),
    app_key: "",
    module_id: "",
    silent_token_key: "access_token",
    lang: "zh-Hans",
    isIntl: false,
    isTeam: false,
    isCutoutGlobal: false,
    appName: "x-design",
    colorGroupCommonConfig: {
        openVipModal: lodash__WEBPACK_IMPORTED_MODULE_0__.noop,
        ifNoOnToggleBizTabProp: lodash__WEBPACK_IMPORTED_MODULE_0__.noop
    },
    loginIdentitySwitchModalConfig: {
        /** 编辑器都需要加这个提示 */ showEditorSaveTip: false
    },
    meituAccountInstance: null,
    userInfo: {
        screen_name: "",
        id: 0
    },
    isWpsUser: false,
    wpsRedirectPath: undefined,
    reportError: undefined
};
var getConfig = function getConfig() {
    return (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _configState);
};
var setConfig = function setConfig(key, value) {
    _configState[key] = value;
    if (key === "env" && value === ENV_ENUM.dev) {
        _configState["env"] = ENV_ENUM.pre;
    }
    pubsub_js__WEBPACK_IMPORTED_MODULE_1___default().publish(ConfigUpdateEvent);
};
var setConfigPartial = function setConfigPartial(params) {
    for(var _key in params){
        if (Object.prototype.hasOwnProperty.call(params, _key)) {
            // @ts-expect-error TS suppress
            setConfig(_key, params[_key]);
        }
    }
};
var useConfig = function useConfig() {
    var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(_configState), _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useState, 2), ctx = _useState2[0], setCtx = _useState2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var onSub = function onSub() {
            setCtx((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _configState));
        };
        pubsub_js__WEBPACK_IMPORTED_MODULE_1___default().subscribe(ConfigUpdateEvent, onSub);
        return function() {
            pubsub_js__WEBPACK_IMPORTED_MODULE_1___default().unsubscribe(onSub);
        };
    }, []);
    return ctx;
};
var ConfigProvider = function ConfigProvider(_ref) {
    var value = _ref.value, children = _ref.children;
    var isFirst = useRef(true);
    if (isFirst.current) {
        setConfigPartial(value);
        isFirst.current = false;
    }
    useEffect(function() {
        setConfigPartial(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ConfigProvider)));


/***/ }),

/***/ 32907:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IK": () => (/* binding */ getLocaleStore),
  "bU": () => (/* binding */ useLocale),
  "Ee": () => (/* binding */ useLocaleStore)
});

// UNUSED EXPORTS: SUPPORT_LOCALES, initLocaleStore, localeTextMap

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/x-design-locales-legacy/chunks/xDesignWidgets/en.json
const en_namespaceObject = JSON.parse('{"satisfaction":{"effectSatisfaction":"Satisfaction","noWarn":"Don\'t show again","dissatisfied":"Dissatisfied","normal":"Neutral","satisfied":"Satisfied","placeholder":"Enter feedback (200 character limit)","submitBtn":"Submit"},"userInfo":{"notVipTip":"Zawa Pro subscription grants access to extensive copyrighted elements and features.","notLoginText":"You are not yet a member","businessText":"Online consultation","feedbackText":"Feedback","downloadText":"Download App","settingText":"Settings","loginText":"Log in","copyText":"Copy","svipExpires":"Zawa Pro expiration date: ${0}","renewalText":"Renew","openText":"Subscribe","tips":"Enjoy worry-free commercial use of copyrighted works during your membership period.","logoutText":"Log out","lightText":"Light","dartText":"Dark","teamExpires":"Team membership expires on: ${0}","teamNotVipTitle":"Subscribe to Team Membership","teamNotVipTip":"Enjoy exclusive membership benefits and team collaboration","teamExpiresDays":"Your team membership expired ${0} days ago","copySuccess":"Copied!","notVipTipTitle":"Become a member to access all design resources and tools","notVipTipSubscript":"Commercial rights covered","teamVersion":"Team","personalVersion":"Personal","vipExpiresDays":"Your subscription expired ${0} days ago","countAmount":"Cutout amount","meidouAmount":"Credits","owner":"Super Admin","admin":"Administrator","vipValidUntil":"Expires on: ${0}","teamNotVipTip2":"Experience SVIP benefits and exclusive features","enterpriseVersion":"Enterprise","freeTeamVersion":"Free","initialFreeDesc":"Become a member to access all design resources and tools","initialFreeTeamDesc":"Subscribe to share team resources and tools","languageSwitch":"Language","pro":"Pro Plan","plus":"Plus Plan","renewOn":"Renew on","tryProForFree":"Try Pro For Free","expiresOn":"Expires on","upgradeToPro":"Upgrade to Pro","credit":"Credit","manageSubscriptions":"Manage Subscriptions","termsAndPolicies":"Terms and Policies","benefitsUpgraded":"Benefits Upgraded","basic":"Basic","startFreeTrial":"Start Free Trial","upgradeNow":"Upgrade Now"},"utils":{"requestErrorText":"Network error. Unable to connect to the server."},"upload":{"errorText":"Failed to upload","cancelText":"Cancel","uploadingText":"Uploading...","fileText":"File","picText":"Images","blockText":"Upload canceled","cancelUploadText":"Cancel upload","maxLengthTips":"You can upload up to 20 images at the same time","formatFailTips":"Upload of ${0} images failed. Currently, only images in ${1} formats are supported.","formatFailTips1":"Only supports images in ${0} format for now","formatFailTips2":"Upload of ${0} images failed. Currently, only images in JPG, JPEG and PNG formats are supported.","sizeFailTips":"Upload of ${0} images failed. Please ensure each image is under 20 MB and no larger than 8000×8000 pixels.","sizeFailTips1":"Please ensure each image is under 20 MB and no larger than 8000×8000 pixels.","widthHeightFailTips":"Only supports images no larger than 8000×8000 pixels","sizeFailTips2":"Only supports images up to ${0} MB"},"meidouInfo":{"emptyText":"Top up","buyText":"Purchase credits plan","openText":"Subscribe","rechargeText":"Top up","remainingText":"My credits","tips1":"Prioritize expiring credits for consumption.","tips2":"Your purchased credits will never expire","tips3":"Including ${0} permanently-valid paid credits.","tips4":"Credits will be automatically deducted with each generation.","detailText":"Details","whatIsMeidou":"What are credits?","giftTips":"40 credits added to your account!","giftTips1":"Expires at the end of today. Don’t forget to use them!","genText":"Generate","deductionTips":"${0} credits will be deducted for this generation. Do you want to continue?","genBtnText":"Generate","inadequateTips":"Insufficient credits. Please top up at least ${0} credits first.","inadequateTipsForNoVip":"Insufficient credits. Subscribe for more.","inadequateTipsForVip":"Insufficient credits. Top up for more.","tryTimes":"Trial times ${0} /${1}","meidouCountModalTitle":"Remaining credits","meidouCountModalTips":"Expiring credits will be used first.","meidouCountModalTips1":"About Credits","meidouCountModalEmpty":"No credits. Purchase now!","meidouCountModalBtn":"OK","meidouCountModalPermanent":"Permanently valid","meidouCountModalExpired":"Expire in ${0} day(s)","creditTransactionDetails":"Credit Overview","deductionTipsIntl":"Need to consume ${0} credits","deductionTips2Intl":"${0} credits will be deducted for this generation. Do you want to continue?","autoDeductCredits":"Automatically deduct credits","generate":"Generate","close":"Close","creditsBalance":"Credits Balance","whatAreCredits":"What are credits?","usageDetail":"Usage details","getMoreCredits":"Get More Credits"},"floatHelp":{"modalTitle":"Meitu Assistant","businessTitle":"Online Consultation","communityText1":"Use WeChat or Wecom to scan the QR code to join","communityText2":"Join [Zawa User Group]","communityText3":"As an early beta user, your feedback is crucial. Share your thoughts with us.","feedbackTitle":"Feedback"},"designCreater":{"tab1":"Create","tab2":"Upload","uploadFail":"Failed to upload","uploadDragTips":"Click the \\"Upload\\" button or drag and drop here","uploadBtn":"Upload","uploadTips":"Tips: We recommend uploading JPG or PNG images within 20 MB.","unitPxText":"Pixels","unitMmText":"mm","unitCmText":"cm","sizeMinText":"Smaller than the required size of ${0} * ${1}","sizeMaxText":"Exceeds the required size of ${0} * ${1}","createBtn":"Create","widthText":"W","widthText1":"W","heightText":"H","heightText1":"H","customText":"Custom","uploadDragTips_v2":"Upload or drop images here","uploadBtn_v2":"Upload","uploadTips_v2":"JPG and PNG images within 20 MB are supported","sizeMinText_v2":"Smaller than the required size of ${0} * ${1} ${2}","sizeMaxText_v2":"Exceeds the required size of ${0} * ${1} ${2}","canvasSize":"Canvas size","canvasBackground":"Background"},"space":{"onlyU":"Only you","anyone":"Anyone with the link","viewAble":"View","editAble":"Edit","viewAble2":"Visit","shareTitle":"Share your creation","copyLink":"Copy link","copied":"Copied"},"imageBatchUpload":{"buttonText":"Upload","uploadDirText":"Upload folder >","buttonDescription":"Paste or drag an image or URL here.","buttonDescription1":"Batch process up to ${0} images","batchButtonText":"Batch upload","upperUploadLimit":"You can upload up to ${0} images","errTipTitle":"Files exceed upload limits or are out of format","errTipSubTitle":"Please upload ${1} images within ${0} MB.","maxValueAndSize":"Only supports images with a maximum file size of ${0} MB","maxWidthAndHeight":"Only supports images no larger than ${0} pixels","errTipUpload":"Upload","errTipConfirm":"Got it","getFormatText":"Only supports images in ${0} format for now","heicResolveFailed":"The HEIC image failed to load. We recommend converting it to another image format before uploading.","imageUploadFailed":"Failed to upload","cvDescription":"Paste image","demoDesc":"Try one of these"},"logo":{"homeTip":"Click to navigate to the homepage","toolTip":"Drag Zawa\\\\\'s logo to the bookmarks bar for convenient access in the future."},"cutoutInfo":{"remainingText":"Remaining number of cutouts","openText":"Subscribe","rechargeText":"Top up","emptyText":"Top up"},"textFontFamily":{"empty":"No content","changeSearchWord":"Try using a different search term","fontFamily":"Font","searchFont":"Search font","buyVipEnjoyFontFamily":"Free for commercial use","currentFontFamily":"Fonts used in this template"},"infiniteScroll":{"loading":"Loading..."},"colorGroup":{"emptyText":"Empty","upgradeTeamEdition":"Upgrade","systemColor":"System color","teamColor":"Brand color card","cover":"Fill","repeat":"Tiling","fillingMode":"Display mode","recommendedTexture":"Recommended","uploadImage":"Upload","replaceImage":"Replace"},"downloadBtn":{"downloadBtnTxt":"Download","modalTitle":"Download","editMoreTitle":"Advanced Editing","downloadNow":"Download","addTxt":"Add Text","addMaterial":"Add Element","eraser":"Eraser","cutout":"BG Remover","quality":"Enhancer","editMore":"Photo Editor","customSize":"Custom","customSizeInputTips":"Enter size limit","customSizeError":"Please fill in file size","processing":"Processing...","aicp":"AI Background Generator","upscale":"Image Upscaler"},"interceptModal":{"title":"Allow pop-up windows for Zawa.","desc":"Authorize Zawa to open multiple windows in your browser.","stepTitle":"Step ${0}","btnText":"Got it","firstStep":"Click the blocking alert that appears in the top right of your browser","secondStep":"Click \\"Always allow pop-ups and redirects\\".","thirdStep":"Click \\"Done\\" to start using Zawa.","xDesignTitle":"Allow pop-up windows for Zawa.","xDesignDesc":"Authorize Zawa to open multiple windows in your browser.","xDesignThirdStep":"Click \\"Done\\" to start using Zawa.","safariFirstStep":"Click the menu bar on the left > Safari, then select designkit.com.","safariSecondStep":"In the pop-up window, select “Pop-ups” > “Allow” to access Zawa features smoothly."},"workListPanel":{"history":"Creations","upload":"Upload","failed":"Failed","pending":"Loading...","cancelText":"Cancel","confirmText":"Confirm","deleteText":"After deletion, the generated results will be lost. Are you sure you want to delete?","generating":"Generating"},"feedbackVoting":{"defaultText":"Rate the result","thanks":"Thanks for your feedback.","modalTitle":"Feedback","modalDesc":"Your feedback will help us improve our service.","modalIpt":"Please describe which part you are not satisfied with","iptMaxLength":"Content exceeds the limit. Please keep it under ${0} characters or contact customer service.","cancel":"Close","submit":"Submit","other":"Other"},"newDesignCreater":{"title":"Create blank canvas","allCategory":"All","openImage":"Upload","openFile":"File","pleaseInputSize":"Enter the size","categorySection":{"lookMore":"More","canvasSize":{"create":"Create"}},"create":"Create","commonSize":"Common size"},"psdModal":{"uploadTemplate":"Upload","uploadFile":"Upload","uploadSuccess":"Uploaded","uploadFailed":"Failed to upload","uploadPSD":"Upload PSD"},"userPolicy":{"btnTomorrow":"Not now","btnVip":"Update now","btnMy":"Get More Credits","buyVip":"Daily trial limit reached. Go VIP for unlimited access!","buyMy":"You’ve reached your trial limit. Get more credits to keep going!","buyVipOrBackTomorrow":"Daily trial limit reached. Go VIP for unlimited access!","backTomorrow":"Daily trial limit reached. Go VIP for unlimited access!","trialLimitReached":"Trial Limit Reached"},"batchTaskList":{"loading":"Loading","fail":"Generation failed","batchEdit":"Batch edit","upload":"Upload More"},"navVipEntrance":{"getFreePro":"Get Free Pro","unlockPro":"Unlock Pro","renewNow":"Renew Now","upgradeToPro":"Upgrade to Pro","upgradeForFree":"Upgrade for Free"},"brandSDK":{"bgInput":{"placeholder":"Describe your brand concept, industry, and style preference."},"brandCard":{"nameLimitTip":"Enter a name (up to 10 characters)"},"delBrandSureModal":{"okText":"Confirm","cancelText":"Cancel","title":"Delete this brand kit?","message":"Applied designs will not be affected."},"brandList":{"createBrandText":"Add","emptyText":"Empty"},"logoCard":{"coverCornerText1":"Cover","coverCornerText2":"Main logo","delSureModal":{"okText":"Confirm","cancelText":"Cancel","title":"Delete this logo?"},"nameLimitTip":"Enter a name (up to ${0} characters)","replaceText":"Replace"},"colorList":{"countLimitTip":"Add up to ${0} color(s) to each color palette"},"colorCard":{"colorCountLimitTip":"Add up to ${0} color(s) to each color palette","nameLimitTip":"Enter a name (up to ${0} characters)","nameInputPlaceholder":"Enter a name (up to ${0} characters)","colorEmptyText":"Empty"},"page":{"brandStandards":"Brand Kit","createStandard":"Add","createBrand":"Brand Kit"},"editBrand":{"sections":{"logo":"Logos","colorCard":"Color systems","textStyle":"Text styles","template":"Templates","reference":"Reference","primaryColor":"Main color","secondaryColor":"Secondary color"},"brandBackground":"Brand description","nameLimitTip":"Enter a name (up to 10 characters)","saveLastStyle":"Save changes to continue","saveLastColorCard":"Save changes to continue","saveLastElement":"Save changes to continue","addColorCard":"Add new","addStyle":"Add new","addPrimaryColor":"Add main color","addSecondaryColor":"Add secondary color","referenceDesc":"Upload your posters and favorite reference images — Zawa will learn their style to craft unique visual assets that reflect your taste.","bgInput":{"openBtnText":"Expand","foldBtnText":"Collapse","title":"Style Guide"},"addPrimaryLogo":"Add main logo"},"textCard":{"nameLimitTip":"Enter a name (up to ${0} characters)","selectFont":"Select a font","selectFontSize":"Select font size","fontSizePlaceholder":"Size","save":"Save","fontSize":"号","bold":"Bold","standard":"Standard","italic":"Italic","defaultCategoryName":"General"},"templateCard":{"delSureModal":{"title":"Delete this item?","okText":"Confirm","cancelText":"Cancel"},"nameLimitTip":"Enter a name (up to ${0} characters)","defaultName":"Templates"},"selectBrandElementModal":{"brandAssets":"Brand Kit","localUpload":"Upload from Device","brandLogo":"Logos","brandTemplate":"Templates","reference":"Reference","uploadImage":"Upload","uploadDragTips":"Upload or drop images here","uploadTips":"Upload up to ${1} JPG or PNG images (max ${0} MB each)"},"tooltip":{"message":"The Brand Poster feature is now live!","desc":"Upload your brand posters and let AI Agent take a peek. It’ll learn your vibe and create future visuals that match your brand’s style!"}},"userReviews":{"hello":"Hi ${0},","wordsOfThanks":"Thanks for being part of Zawa!","desc":"Your feedback means the world to us. If you’re enjoying Zawa, we’d love it if you could leave us a review on Trustpilot — it really helps us grow and improve.","leave":"Leave a Review"},"aih5DownloadBtn":{"signInText":"Sign in","fullQualityText":"Full Quality","previewText":"Preview","freeText":"Free","downloadText":"Download","fullQualityLimitReached":"Full-quality limit reached. Please come back tomorrow.","todayLimitReached":"Today\'s limit reached. Come back tomorrow or upgrade now."}}');
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/x-design-locales-legacy/chunks/xDesignWidgets/es.json
const es_namespaceObject = JSON.parse('{"satisfaction":{"effectSatisfaction":"Satisfacción","noWarn":"No mostrar de nuevo","dissatisfied":"Insatisfecho","normal":"Neutral","satisfied":"Satisfecho","placeholder":"Ingresa tus comentarios (límite 200 caracteres)","submitBtn":"Enviar"},"userInfo":{"notVipTip":"La suscripción a Zawa Pro te da acceso a numerosos elementos y funciones con derechos de autor.","notLoginText":"Aún no eres miembro","businessText":"Consulta en línea","feedbackText":"Comentarios","downloadText":"Descarga la app","settingText":"Configuración","loginText":"Iniciar sesión","copyText":"Copiar","svipExpires":"Fecha de expiración de Zawa Pro: ${0}","renewalText":"Renovar","openText":"Suscríbete","tips":"Usa obras con derechos de autor de manera comercial sin preocupaciones durante el periodo de tu membresía.","logoutText":"Cerrar sesión","lightText":"Claro","dartText":"Oscuro","teamExpires":"La membresía equipo expira el: ${0}","teamNotVipTitle":"Suscríbete a la membresía de equipo","teamNotVipTip":"Disfruta beneficios exclusivos de tu membresía y colaboración en equipo","teamExpiresDays":"Tu membresía de equipo expiró hace ${0} días","copySuccess":"¡Copiado!","notVipTipTitle":"Conviértete en miembro para acceder a todos los recursos y herramientas de diseño","notVipTipSubscript":"Derechos comerciales cubiertos","teamVersion":"Equipo","personalVersion":"Personal","vipExpiresDays":"Tu suscripción expiró hace ${0} días","countAmount":"Cantidad de recorte","meidouAmount":"Créditos","owner":"Súper Administrador","admin":"Administrador","vipValidUntil":"Expira el: ${0}","teamNotVipTip2":"Disfruta beneficios SVIP y funciones exclusivas","enterpriseVersion":"Grandes empresas","freeTeamVersion":"Gratis","initialFreeDesc":"Conviértete en miembro para acceder a todos los recursos y herramientas de diseño","initialFreeTeamDesc":"Suscríbete para compartir recursos y herramientas con tu equipo","languageSwitch":"Idioma","pro":"Pro","plus":"Plus Plan","renewOn":"Renovación el","tryProForFree":"Prueba Pro gratis","expiresOn":"Expira el","upgradeToPro":"Actualizar a Pro","credit":"Crédito","manageSubscriptions":"Administrar suscripciones","termsAndPolicies":"Términos y políticas","benefitsUpgraded":"Beneficios mejorados","basic":"Básico","startFreeTrial":"Start Free Trial","upgradeNow":"Upgrade Now"},"utils":{"requestErrorText":"Error de red. No se pudo conectar con el servidor."},"upload":{"errorText":"Error al subir","cancelText":"Cancelar","uploadingText":"Subiendo…","fileText":"Archivo","picText":"Imágenes","blockText":"Carga cancelada","cancelUploadText":"Cancelar carga","maxLengthTips":"Puedes subir hasta 20 imágenes a la vez","formatFailTips":"Error al subir ${0} imágenes. Por el momento, solo se admiten imágenes en formato${1}.","formatFailTips1":"Solo se admiten imágenes en formato ${0} por ahora","formatFailTips2":"Error al subir ${0} imágenes. Por el momento, solo se admiten imágenes en formato JPG, JPEG y PNG.","sizeFailTips":"Error al subir ${0} imágenes. Asegúrate de que cada imagen sea menor a 20 MB y no mayor a 8,000×8,000 pixeles.","sizeFailTips1":"Asegúrate de que cada imagen sea menor a 20 MB y no mayor a 8,000×8,000 pixeles.","widthHeightFailTips":"Solo se admiten imágenes de hasta 8000 px (alto × ancho)","sizeFailTips2":"Solo se admiten imágenes de hasta ${0} MB"},"meidouInfo":{"emptyText":"Recargar","buyText":"Compra un plan de créditos","openText":"Suscríbete","rechargeText":"Recargar","remainingText":"Mis créditos","tips1":"Prioriza los créditos próximos a expirar para su consumo.","tips2":"Tus créditos comprados nunca expiran","tips3":"Incluye ${0} créditos pagados con validez permanente.","tips4":"Los créditos se descontarán automáticamente con cada generación.","detailText":"Detalles","whatIsMeidou":"¿Qué son los créditos?","giftTips":"Se agregaron 40 créditos a tu cuenta.","giftTips1":"Expira al final del día. ¡No olvides usarlos!","genText":"Generar","deductionTips":"Se descontarán ${0} créditos para esta generación. ¿Deseas continuar?","genBtnText":"Generar","inadequateTips":"Créditos insuficientes. Primero recarga al menos ${0} créditos.","inadequateTipsForNoVip":"Insufficient credits. Subscribe for more.","inadequateTipsForVip":"Insufficient credits. Top up for more.","tryTimes":"Tiempos de prueba ${0}/${1}","meidouCountModalTitle":"Créditos restantes","meidouCountModalTips":"Los créditos próximos a expirar se usarán primero.","meidouCountModalTips1":"Acerca de los créditos","meidouCountModalEmpty":"No tienes créditos. Compra ahora.","meidouCountModalBtn":"Aceptar","meidouCountModalPermanent":"Validez permanente","meidouCountModalExpired":"Expira en ${0} día(s)","creditTransactionDetails":"Resumen de los créditos","deductionTipsIntl":"Necesita consumir ${0} créditos","deductionTips2Intl":"Se descontarán ${0} créditos para esta generación. ¿Deseas continuar?","autoDeductCredits":"Descontar créditos automáticamente","generate":"Generar","close":"Cerrar","creditsBalance":"Saldo de créditos","whatAreCredits":"¿Qué son los créditos?","usageDetail":"Detalles de uso","getMoreCredits":"Obtén más créditos"},"floatHelp":{"modalTitle":"Asistente de Meitu","businessTitle":"Consulta en línea","communityText1":"Usa WeChat o WeCom para escanear el código QR y unirte","communityText2":"Únete al [grupo de usuarios de Zawa]","communityText3":"Como usuario beta, tus comentarios son cruciales. Comparte tus opiniones con nosotros.","feedbackTitle":"Comentarios"},"designCreater":{"tab1":"Nuevo diseño","tab2":"Subir","uploadFail":"Error al subir","uploadDragTips":"Haz clic en el botón “Subir” o arrastra y suelta aquí","uploadBtn":"Subir","uploadTips":"Sugerencias: te recomendamos subir imágenes JPG o PNG de menos de 20 MB.","unitPxText":"Pixeles","unitMmText":"mm","unitCmText":"cm","sizeMinText":"Más pequeño que el tamaño requerido de ${0} * ${1}","sizeMaxText":"Supera el tamaño requerido de ${0} * ${1}","createBtn":"Crear","widthText":"Ancho","widthText1":"Ancho","heightText":"Alto","heightText1":"Alto","customText":"Personalizado","uploadDragTips_v2":"Sube tu imagen o suéltala aquí","uploadBtn_v2":"Subir","uploadTips_v2":"Se admiten imágenes JPG y PNG de menos de 20 MB","sizeMinText_v2":"Más pequeño que el tamaño requerido de ${0} * ${1} ${2}","sizeMaxText_v2":"Supera el tamaño requerido de ${0} * ${1} ${2}","canvasSize":"Tamaño del lienzo","canvasBackground":"Fondo"},"space":{"onlyU":"Solo tú","anyone":"Cualquier persona que tenga el enlace","viewAble":"Ver","editAble":"Editar","viewAble2":"Visitar","shareTitle":"Comparte tu creación","copyLink":"Copiar enlace","copied":"Copiado"},"imageBatchUpload":{"buttonText":"Subir","uploadDirText":"Subir carpeta >","buttonDescription":"Pega o arrastra una imagen o URL aquí.","buttonDescription1":"Procesa por lotes hasta ${0} imágenes","batchButtonText":"Carga por lotes","upperUploadLimit":"Puedes subir hasta ${0} imágenes","errTipTitle":"Los archivos superan los límites de carga o no tienen el formato correcto","errTipSubTitle":"Sube ${1} imágenes de menos de ${0} MB.","maxValueAndSize":"Solo se admiten imágenes con un tamaño de archivo máximo de ${0} MB","maxWidthAndHeight":"Solo se admiten imágenes de hasta ${0} px de ambos lados","errTipUpload":"Subir","errTipConfirm":"Entendido","getFormatText":"Solo se admiten imágenes en formato ${0} por ahora","heicResolveFailed":"Error al cargar la imagen HEIC. Te recomendamos convertirla a otro formato de imagen antes de subirla.","imageUploadFailed":"Error al subir","cvDescription":"Pegar imagen","demoDesc":"Prueba uno de estos"},"logo":{"homeTip":"Haz clic para navegar a la página de inicio","toolTip":"Arrastra el logotipo de Zawa a la barra de favoritos para tener un acceso conveniente en el futuro."},"cutoutInfo":{"remainingText":"Cantidad restante de recortes","openText":"Suscríbete","rechargeText":"Recargar","emptyText":"Recargar"},"textFontFamily":{"empty":"Sin contenido","changeSearchWord":"Prueba un término de búsqueda diferente","fontFamily":"Fuente","searchFont":"Buscar fuente","buyVipEnjoyFontFamily":"Gratis para uso comercial","currentFontFamily":"Fuentes usadas en esta plantilla"},"infiniteScroll":{"loading":"Cargando…"},"colorGroup":{"emptyText":"Vacío","upgradeTeamEdition":"Actualizar","systemColor":"Color del sistema","teamColor":"Tarjeta de colores de marca","cover":"Rellenar","repeat":"Mosaico","fillingMode":"Modo de visualización","recommendedTexture":"Recomendado","uploadImage":"Subir","replaceImage":"Reemplazar"},"downloadBtn":{"downloadBtnTxt":"Descargar","modalTitle":"Descargar","editMoreTitle":"Edición avanzada","downloadNow":"Descargar","addTxt":"Agregar texto","addMaterial":"Agregar elemento","eraser":"Borrador","cutout":"Eliminador de fondo","quality":"Mejorar","editMore":"Editor de fotos","customSize":"Personalizado","customSizeInputTips":"Ingresa el límite de tamaño","customSizeError":"Llena el tamaño del archivo","processing":"Procesando…","aicp":"Generador de fondos con IA","upscale":"Ampliador de imagen"},"interceptModal":{"title":"Permite ventanas emergentes para Zawa.","desc":"Autoriza que Zawa abra múltiples ventanas en tu navegador.","stepTitle":"Paso ${0}","btnText":"Entendido","firstStep":"Haz clic en la alerta de bloqueo que aparece en la esquina superior derecha de tu navegador","secondStep":"Haz clic en “Siempre permitir ventanas emergentes y redireccionamientos”.","thirdStep":"Haz clic en “Listo” para comenzar a usar Zawa.","xDesignTitle":"Permite ventanas emergentes para Zawa.","xDesignDesc":"Autoriza que Zawa abra múltiples ventanas en tu navegador.","xDesignThirdStep":"Haz clic en “Listo” para comenzar a usar Zawa.","safariFirstStep":"Haz clic en la barra de menú de la izquierda > Safari, luego selecciona designkit.com.","safariSecondStep":"En la ventana emergente, selecciona Ventanas emergentes > Permitir para acceder fácilmente a las funciones de Zawa."},"workListPanel":{"history":"Creaciones","upload":"Subir","failed":"Error","pending":"Cargando…","cancelText":"Cancelar","confirmText":"Confirmar","deleteText":"Después de eliminarlos, los resultados generados se perderán. ¿Desear borrarlos?","generating":"Procesando..."},"feedbackVoting":{"defaultText":"Califica el resultado","thanks":"Gracias por tus comentarios.","modalTitle":"Comentarios","modalDesc":"Tus comentarios nos ayudarán a mejorar nuestro servicio.","modalIpt":"Describe qué parte no te pareció satisfactoria","iptMaxLength":"El contenido excede el límite. Sigue el límite de ${0} caracteres o comunícate con el servicio de atención al cliente.","cancel":"Cerrar","submit":"Enviar","other":"Otro"},"newDesignCreater":{"title":"Nuevo diseño","allCategory":"Todo","openImage":"Subir","openFile":"Archivo","pleaseInputSize":"Ingresa el tamaño","categorySection":{"lookMore":"Más","canvasSize":{"create":"Crear"}},"create":"Crear","commonSize":"Tamaño común"},"psdModal":{"uploadTemplate":"Subir","uploadFile":"Subir","uploadSuccess":"Subido","uploadFailed":"Error al subir","uploadPSD":"Subir PSD"},"userPolicy":{"btnTomorrow":"Ahora no","btnVip":"Actualizar ahora","btnMy":"Obtén más créditos","buyVip":"Llegaste al límite diario de prueba. Con VIP obtienes acceso ilimitado.","buyMy":"Llegaste a tu límite de prueba. Obtén más créditos para continuar.","buyVipOrBackTomorrow":"Llegaste al límite diario de prueba. Con VIP obtienes acceso ilimitado.","backTomorrow":"Llegaste al límite diario de prueba. Con VIP obtienes acceso ilimitado.","trialLimitReached":"Alcanzaste el límite de prueba"},"batchTaskList":{"loading":"Cargando","fail":"Error al generar","batchEdit":"Edición por lotes","upload":"Subir más"},"navVipEntrance":{"getFreePro":"Obtén Pro gratis","unlockPro":"Desbloquear Pro","renewNow":"Renovar ahora","upgradeToPro":"Actualizar a Pro","upgradeForFree":"Upgrade for Free"},"brandSDK":{"bgInput":{"placeholder":"Describe el concepto de tu marca, industria y preferencia de estilo."},"brandCard":{"nameLimitTip":"Ingresa un nombre (hasta 10 caracteres)"},"delBrandSureModal":{"okText":"Confirmar","cancelText":"Cancelar","title":"¿Deseas borrar este kit de marca?","message":"Los diseños aplicados no se verán afectados."},"brandList":{"createBrandText":"Agregar","emptyText":"Vacío"},"logoCard":{"coverCornerText1":"Portada","coverCornerText2":"Logotipo principal","delSureModal":{"okText":"Confirmar","cancelText":"Cancelar","title":"¿Deseas eliminar este logotipo?"},"nameLimitTip":"Ingresa un nombre (hasta ${0} caracteres)","replaceText":"Reemplazar"},"colorList":{"countLimitTip":"Agrega hasta ${0} color(es) a cada paleta de color"},"colorCard":{"colorCountLimitTip":"Agrega hasta ${0} color(es) a cada paleta de color","nameLimitTip":"Ingresa un nombre (hasta ${0} caracteres)","nameInputPlaceholder":"Ingresa un nombre (hasta ${0} caracteres)","colorEmptyText":"Vacío"},"page":{"brandStandards":"Kit de marca","createStandard":"Agregar","createBrand":"Kit de marca"},"editBrand":{"sections":{"logo":"Logotipos","colorCard":"Paleta de colores","textStyle":"Estilos de texto","template":"Plantillas","reference":"Reference","primaryColor":"Color principal","secondaryColor":"Color secundario"},"brandBackground":"Descripción de marca","nameLimitTip":"Ingresa un nombre (hasta 10 caracteres)","saveLastStyle":"Guarda los cambios para continuar","saveLastColorCard":"Guarda los cambios para continuar","saveLastElement":"Guarda los cambios para continuar","addColorCard":"Agregar nuevo","addStyle":"Agregar nuevo","addPrimaryColor":"Agregar color principal","addSecondaryColor":"Agregar color secundario","referenceDesc":"Upload your posters and favorite reference images — Zawa will learn their style to craft unique visual assets that reflect your taste.","bgInput":{"openBtnText":"Expandir","foldBtnText":"Contraer","title":"Guía de estilo"},"addPrimaryLogo":"Agregar logotipo principal"},"textCard":{"nameLimitTip":"Ingresa un nombre (hasta ${0} caracteres)","selectFont":"Selecciona una fuente","selectFontSize":"Seleccionar tamaño de fuente","fontSizePlaceholder":"Tamaño","save":"Guardar","fontSize":"号","bold":"Negrita","standard":"Estándar","italic":"Cursiva","defaultCategoryName":"General"},"templateCard":{"delSureModal":{"title":"¿Deseas borrar esta plantilla?","okText":"Confirmar","cancelText":"Cancelar"},"nameLimitTip":"Ingresa un nombre (hasta ${0} caracteres)","defaultName":"Plantillas"},"selectBrandElementModal":{"brandAssets":"Kit de marca","localUpload":"Subir desde dispositivo","brandLogo":"Logotipos","brandTemplate":"Plantillas","reference":"Reference","uploadImage":"Subir","uploadDragTips":"Sube tu imagen o suéltala aquí","uploadTips":"Sube hasta ${1} imágenes JPG o PNG (máx. ${0} MB cada una)"},"tooltip":{"message":"¡La función Póster de marca ya está disponible!","desc":"Sube tus pósters de marca y permite que el Agente de IA eche un vistazo. Aprenderá tus gustos y en el futuro creará recursos visuales que coincidan con el estilo de tu marca."}},"userReviews":{"hello":"Hola ${0}","wordsOfThanks":"¡Gracias por ser parte de Zawa!","desc":"Tus comentarios son muy importantes para nosotros. Si estás disfrutando Zawa, nos encantaría que dejaras una reseña en Trustpilot. Nos ayuda mucho a crecer y mejorar.","leave":"Deja una reseña"},"aih5DownloadBtn":{"signInText":"Iniciar sesión","fullQualityText":"Calidad total","previewText":"Vista previa","freeText":"Gratis","downloadText":"Descargar","fullQualityLimitReached":"Se alcanzó el límite de calidad total. Vuelve mañana.","todayLimitReached":"Se alcanzó el límite de hoy. Vuelve mañana o actualiza ahora."}}');
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/x-design-locales-legacy/chunks/xDesignWidgets/id.json
const id_namespaceObject = JSON.parse('{"satisfaction":{"effectSatisfaction":"Kepuasan","noWarn":"Jangan tampilkan lagi","dissatisfied":"Tidak puas","normal":"Netral","satisfied":"Puas","placeholder":"Berikan masukan (maksimal 200 karakter)","submitBtn":"Kirim"},"userInfo":{"notVipTip":"Langganan Zawa Pro memberikan akses ke berbagai elemen dan fitur yang memiliki hak cipta.","notLoginText":"Anda belum jadi anggota","businessText":"Konsultasi online","feedbackText":"Masukan","downloadText":"Unduh Aplikasi","settingText":"Pengaturan","loginText":"Login","copyText":"Salin","svipExpires":"Tanggal kedaluwarsa Zawa Pro: ${0}","renewalText":"Perpanjang","openText":"Berlangganan","tips":"Nikmati penggunaan komersial karya berhak cipta sepuasnya selama periode keanggotaan.","logoutText":"Logout","lightText":"Terang","dartText":"Gelap","teamExpires":"Keanggotaan tim berakhir pada: ${0}","teamNotVipTitle":"Berlangganan Keanggotaan Tim","teamNotVipTip":"Dapatkan manfaat keanggotaan eksklusif dan kolaborasi tim","teamExpiresDays":"Keanggotaan tim Anda berakhir ${0} hari lalu","copySuccess":"Disalin!","notVipTipTitle":"Daftar anggota untuk mengakses semua sumber daya dan alat desain","notVipTipSubscript":"Termasuk hak komersial","teamVersion":"Tim","personalVersion":"Personal","vipExpiresDays":"Langganan Anda berakhir ${0} hari lalu","countAmount":"Jumlah pemotongan","meidouAmount":"Kredit","owner":"Admin Super","admin":"Administrator","vipValidUntil":"Berakhir pada: ${0}","teamNotVipTip2":"Nikmati manfaat SVIP dan fitur eksklusif","enterpriseVersion":"Perusahaan","freeTeamVersion":"Gratis","initialFreeDesc":"Daftar anggota untuk mengakses semua sumber daya dan alat desain","initialFreeTeamDesc":"Berlangganan untuk berbagi sumber daya dan alat tim","languageSwitch":"Bahasa","pro":"Pro","plus":"Plus Plan","renewOn":"Perpanjang pada","tryProForFree":"Coba Pro Gratis","expiresOn":"Berakhir pada","upgradeToPro":"Upgrade ke Pro","credit":"Kredit","manageSubscriptions":"Kelola Langganan","termsAndPolicies":"Ketentuan dan Kebijakan","benefitsUpgraded":"Manfaat Diupgrade","basic":"Dasar","startFreeTrial":"Start Free Trial","upgradeNow":"Upgrade Now"},"utils":{"requestErrorText":"Kesalahan jaringan. Tidak dapat terhubung ke server."},"upload":{"errorText":"Gagal mengunggah","cancelText":"Batal","uploadingText":"Mengunggah...","fileText":"File","picText":"Gambar","blockText":"Unggahan dibatalkan","cancelUploadText":"Batalkan unggahan","maxLengthTips":"Anda dapat mengunggah maksimal 20 foto sekaligus","formatFailTips":"Unggahan ${0} gambar gagal. Saat ini hanya mendukung format gambar ${1}.","formatFailTips1":"Saat ini hanya mendukung format gambar ${0}","formatFailTips2":"Unggahan ${0} gambar gagal. Saat ini hanya mendukung format gambar JPG, JPEG, dan PNG.","sizeFailTips":"Unggahan ${0} gambar gagal. Pastikan setiap gambar berukuran maksimal 20 MB dan tidak lebih dari 8000×8000 piksel.","sizeFailTips1":"Pastikan setiap gambar berukuran maksimal 20 MB dan tidak lebih dari 8000×8000 piksel.","widthHeightFailTips":"Hanya mendukung gambar maks 8000px (P&L)","sizeFailTips2":"Hanya mendukung gambar maks ${0} MB"},"meidouInfo":{"emptyText":"Isi ulang","buyText":"Beli paket kredit","openText":"Berlangganan","rechargeText":"Isi ulang","remainingText":"Kredit saya","tips1":"Prioritaskan penggunaan kredit yang akan segera kedaluwarsa.","tips2":"Kredit yang dibeli tidak akan pernah kedaluwarsa","tips3":"Termasuk ${0} kredit berbayar yang berlaku permanen.","tips4":"Kredit akan otomatis berkurang setiap kali memproses.","detailText":"Detail","whatIsMeidou":"Apa itu kredit?","giftTips":"40 kredit ditambahkan ke akun Anda!","giftTips1":"Kedaluwarsa di penghujung hari ini. Jangan lupa untuk menggunakannya!","genText":"Proses","deductionTips":"${0} kredit akan dipotong untuk pemrosesan ini. Anda ingin melanjutkan?","genBtnText":"Proses","inadequateTips":"Kredit tidak cukup. Harap isi ulang dahulu minimal ${0} kredit.","inadequateTipsForNoVip":"Insufficient credits. Subscribe for more.","inadequateTipsForVip":"Insufficient credits. Top up for more.","tryTimes":"Waktu uji coba ${0} /${1}","meidouCountModalTitle":"Kredit tersisa","meidouCountModalTips":"Kredit yang akan kedaluwarsa digunakan terlebih dahulu.","meidouCountModalTips1":"Tentang Kredit","meidouCountModalEmpty":"Tidak ada kredit. Beli sekarang!","meidouCountModalBtn":"OK","meidouCountModalPermanent":"Valid permanen","meidouCountModalExpired":"Berakhir dalam ${0} hari","creditTransactionDetails":"Gambaran Umum Kredit","deductionTipsIntl":"Perlu menggunakan ${0} kredit","deductionTips2Intl":"${0} kredit akan dipotong untuk pemrosesan ini. Anda ingin melanjutkan?","autoDeductCredits":"Otomatis potong kredit","generate":"Proses","close":"Tutup","creditsBalance":"Saldo Kredit","whatAreCredits":"Apa itu kredit?","usageDetail":"Detail penggunaan","getMoreCredits":"Dapatkan Lebih Banyak Kredit"},"floatHelp":{"modalTitle":"Asisten Meitu","businessTitle":"Konsultasi online","communityText1":"Gunakan WeChat atau Wecom untuk memindai kode QR dan bergabung","communityText2":"Bergabung [Grup Pengguna Zawa]","communityText3":"Sebagai pengguna versi beta awal, masukan Anda sangat penting. Sampaikan pendapat Anda kepada kami.","feedbackTitle":"Masukan"},"designCreater":{"tab1":"Desain Baru","tab2":"Unggah","uploadFail":"Gagal mengunggah","uploadDragTips":"Klik tombol \\"Unggah\\" atau seret dan lepaskan di sini","uploadBtn":"Unggah","uploadTips":"Tips: Sebaiknya unggah gambar JPG atau PNG dengan ukuran maks 20 MB.","unitPxText":"Piksel","unitMmText":"mm","unitCmText":"cm","sizeMinText":"Lebih kecil dari ukuran minimal ${0} * ${1}","sizeMaxText":"Melampaui ukuran maksimal ${0} * ${1}","createBtn":"Buat","widthText":"P","widthText1":"L","heightText":"L","heightText1":"T","customText":"Kustom","uploadDragTips_v2":"Unggah atau seret foto di sini","uploadBtn_v2":"Unggah","uploadTips_v2":"Mendukung gambar JPG dan PNG berukuran maks 20 MB","sizeMinText_v2":"Lebih kecil dari ukuran minimal ${0} * ${1} ${2}","sizeMaxText_v2":"Melampaui ukuran maksimal ${0} * ${1} ${2}","canvasSize":"Ukuran kanvas","canvasBackground":"Background"},"space":{"onlyU":"Hanya Anda","anyone":"Semua yang punya tautan","viewAble":"Lihat","editAble":"Edit","viewAble2":"Kunjungi","shareTitle":"Bagikan kreasi Anda","copyLink":"Salin tautan","copied":"Disalin"},"imageBatchUpload":{"buttonText":"Unggah","uploadDirText":"Folder unggahan >","buttonDescription":"Rekatkan atau seret gambar atau URL di sini.","buttonDescription1":"Proses massal hingga ${0} foto","batchButtonText":"Unggah massal","upperUploadLimit":"Anda dapat mengunggah maksimal ${0} foto","errTipTitle":"Unggahan melebihi batas ukuran atau format file salah","errTipSubTitle":"Unggah ${1} gambar maks ${0} MB.","maxValueAndSize":"Hanya mendukung gambar berukuran maks ${0} MB","maxWidthAndHeight":"Hanya mendukung gambar berukuran maks ${0} px PxL","errTipUpload":"Unggah","errTipConfirm":"Mengerti","getFormatText":"Saat ini hanya mendukung format gambar ${0}","heicResolveFailed":"Gagal memuat gambar HEIC. Sebaiknya konversi ke format lain sebelum mengunggah.","imageUploadFailed":"Gagal mengunggah","cvDescription":"Rekatkan gambar","demoDesc":"Cobalah salah satu"},"logo":{"homeTip":"Klik untuk kembali ke beranda","toolTip":"Seret logo Zawa ke bilah bookmark untuk memudahkan akses."},"cutoutInfo":{"remainingText":"Jumlah pemotongan tersisa","openText":"Berlangganan","rechargeText":"Isi ulang","emptyText":"Isi ulang"},"textFontFamily":{"empty":"Tidak ada konten","changeSearchWord":"Coba istilah pencarian lain","fontFamily":"Font","searchFont":"Cari fon","buyVipEnjoyFontFamily":"Gratis untuk penggunaan komersial","currentFontFamily":"Fon yang digunakan di templat ini"},"infiniteScroll":{"loading":"Memuat..."},"colorGroup":{"emptyText":"Kosong","upgradeTeamEdition":"Upgrade","systemColor":"Warna sistem","teamColor":"Kartu warna merek","cover":"Isi","repeat":"Ubin","fillingMode":"Mode tampilan","recommendedTexture":"Disarankan","uploadImage":"Unggah","replaceImage":"Ganti"},"downloadBtn":{"downloadBtnTxt":"Unduh","modalTitle":"Unduh","editMoreTitle":"Editing Lanjutan","downloadNow":"Unduh","addTxt":"Tambah Teks","addMaterial":"Tambah Elemen","eraser":"Penghapus","cutout":"Penghapus Latar","quality":"Penyempurna","editMore":"Editor Foto","customSize":"Kustom","customSizeInputTips":"Masukkan batasan ukuran","customSizeError":"Masukkan ukuran file","processing":"Memproses...","aicp":"AI Background","upscale":"Upscale"},"interceptModal":{"title":"Izinkan jendela pop-up untuk Zawa.","desc":"Izinkan Zawa membuka beberapa jendela di browser.","stepTitle":"Langkah ${0}","btnText":"Mengerti","firstStep":"Klik peringatan pemblokiran yang muncul di kanan atas browser","secondStep":"Klik \\"Always allow pop-ups and redirects\\" (Selalu izinkan pop-up dan pengalihan).","thirdStep":"Klik \\"Done\\" (Selesai) untuk mulai menggunakan Zawa.","xDesignTitle":"Izinkan jendela pop-up untuk Zawa.","xDesignDesc":"Izinkan Zawa membuka beberapa jendela di browser.","xDesignThirdStep":"Klik \\"Done\\" (Selesai) untuk mulai menggunakan Zawa.","safariFirstStep":"Klik bilah menu di kiri > Safari, lalu pilih designkit.com.","safariSecondStep":"Di jendela pop-up, pilih “Pop-up” > “Allow” (Izinkan) untuk mengakses fitur Zawa."},"workListPanel":{"history":"Kreasi","upload":"Unggah","failed":"Gagal","pending":"Memuat...","cancelText":"Batal","confirmText":"Konfirmasi","deleteText":"Setelah dihapus, hasil yang dibuat akan hilang. Anda yakin ingin menghapus?","generating":"Memproses..."},"feedbackVoting":{"defaultText":"Nilai hasil","thanks":"Terima kasih atas masukan Anda.","modalTitle":"Masukan","modalDesc":"Masukan Anda akan membantu meningkatkan layanan kami.","modalIpt":"Jelaskan pada bagian mana Anda tidak puas","iptMaxLength":"Konten melampaui batas. Dibatasi maksimal ${0} karakter atau hubungi layanan pelanggan.","cancel":"Tutup","submit":"Kirim","other":"Lainnya"},"newDesignCreater":{"title":"Desain Baru","allCategory":"Semua","openImage":"Unggah","openFile":"File","pleaseInputSize":"Masukkan ukuran","categorySection":{"lookMore":"Lainnya","canvasSize":{"create":"Buat"}},"create":"Buat","commonSize":"Ukuran umum"},"psdModal":{"uploadTemplate":"Unggah","uploadFile":"Unggah","uploadSuccess":"Diunggah","uploadFailed":"Gagal mengunggah","uploadPSD":"Unggah PSD"},"userPolicy":{"btnTomorrow":"Lain kali","btnVip":"Perbarui Sekarang","btnMy":"Dapatkan Lebih Banyak Kredit","buyVip":"Uji coba harian sudah maksimal. Daftar VIP untuk akses sepuasnya!","buyMy":"Uji coba sudah maksimal. Dapatkan lebih banyak kredit untuk melanjutkan!","buyVipOrBackTomorrow":"Uji coba harian sudah maksimal. Daftar VIP untuk akses sepuasnya!","backTomorrow":"Uji coba harian sudah maksimal. Daftar VIP untuk akses sepuasnya!","trialLimitReached":"Uji Coba Sudah Maksimal"},"batchTaskList":{"loading":"Memuat","fail":"Pemrosesan gagal","batchEdit":"Teks massal","upload":"Unggah Lainnya"},"navVipEntrance":{"getFreePro":"Dapatkan Pro Gratis","unlockPro":"Dapatkan Pro","renewNow":"Perpanjang Sekarang","upgradeToPro":"Upgrade ke Pro","upgradeForFree":"Upgrade for Free"},"brandSDK":{"bgInput":{"placeholder":"Jelaskan konsep merek, industri, dan preferensi gayamu."},"brandCard":{"nameLimitTip":"Masukkan nama (maksimal 10 karakter)"},"delBrandSureModal":{"okText":"Konfirmasi","cancelText":"Batal","title":"Hapus kit merek ini?","message":"Desain yang diterapkan tidak terpengaruh."},"brandList":{"createBrandText":"Tambah","emptyText":"Kosong"},"logoCard":{"coverCornerText1":"Kover","coverCornerText2":"Logo utama","delSureModal":{"okText":"Konfirmasi","cancelText":"Batal","title":"Hapus logo ini?"},"nameLimitTip":"Masukkan nama (maksimal ${0} karakter)","replaceText":"Ganti"},"colorList":{"countLimitTip":"Tambahkan maksimal ${0} warna ke setiap palet warna"},"colorCard":{"colorCountLimitTip":"Tambahkan maksimal ${0} warna ke setiap palet warna","nameLimitTip":"Masukkan nama (maksimal ${0} karakter)","nameInputPlaceholder":"Masukkan nama (maksimal ${0} karakter)","colorEmptyText":"Kosong"},"page":{"brandStandards":"Kit Merek","createStandard":"Tambah","createBrand":"Kit Merek"},"editBrand":{"sections":{"logo":"Logo","colorCard":"Sistem warna","textStyle":"Gaya teks","template":"Templat","reference":"Reference","primaryColor":"Warna primer","secondaryColor":"Warna sekunder"},"brandBackground":"Deskripsi merek","nameLimitTip":"Masukkan nama (maksimal 10 karakter)","saveLastStyle":"Simpan perubahan untuk melanjutkan","saveLastColorCard":"Simpan perubahan untuk melanjutkan","saveLastElement":"Simpan perubahan untuk melanjutkan","addColorCard":"Tambahkan baru","addStyle":"Tambahkan baru","addPrimaryColor":"Tambahkan warna primer","addSecondaryColor":"Tambahkan warna sekunder","referenceDesc":"Upload your posters and favorite reference images — Zawa will learn their style to craft unique visual assets that reflect your taste.","bgInput":{"openBtnText":"Perluas","foldBtnText":"Susutkan","title":"Panduan Gaya"},"addPrimaryLogo":"Tambahkan logo utama"},"textCard":{"nameLimitTip":"Masukkan nama (maksimal ${0} karakter)","selectFont":"Pilih fon","selectFontSize":"Pilih ukuran fon","fontSizePlaceholder":"Ukuran","save":"Simpan","fontSize":"号","bold":"Tebal","standard":"Standar","italic":"Miring","defaultCategoryName":"Umum"},"templateCard":{"delSureModal":{"title":"Hapus templat ini?","okText":"Konfirmasi","cancelText":"Batal"},"nameLimitTip":"Masukkan nama (maksimal ${0} karakter)","defaultName":"Templat"},"selectBrandElementModal":{"brandAssets":"Kit Merek","localUpload":"Unggah dari Perangkat","brandLogo":"Logo","brandTemplate":"Templat","reference":"Reference","uploadImage":"Unggah","uploadDragTips":"Unggah atau seret foto di sini","uploadTips":"Unggah maksimal ${1} gambar JPG atau PNG (masing-masing maks ${0} MB)"},"tooltip":{"message":"Fitur Poster Merek kini sudah tersedia!","desc":"Unggah poster merek sebagai referensi Agen AI. AI akan mempelajari gaya dan membuat visual yang sesuai dengan gaya merekmu!"}},"userReviews":{"hello":"Hai ${0},","wordsOfThanks":"Terima kasih telah menggunakan Zawa!","desc":"Masukan Anda sangat berarti bagi kami. Jika Anda suka Zawa, kami akan sangat berterima kasih jika Anda bisa memberikan ulasan di Trustpilot untuk membantu kami memperbaiki dan meningkatkan layanan.","leave":"Tulis Ulasan"},"aih5DownloadBtn":{"signInText":"Masuk","fullQualityText":"Kualitas Penuh","previewText":"Pratinjau","freeText":"Bebas","downloadText":"Unduh","fullQualityLimitReached":"Kualitas penuh sudah maksimal. Silakan kembali besok.","todayLimitReached":"Batasan harian tercapai. Kembali lagi besok atau upgrade sekarang."}}');
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/x-design-locales-legacy/chunks/xDesignWidgets/it.json
const it_namespaceObject = JSON.parse('{"satisfaction":{"effectSatisfaction":"Soddisfazione","noWarn":"Non mostrare più","dissatisfied":"Insoddisfatto/a","normal":"Neutro","satisfied":"Soddisfatto/a","placeholder":"Inserisci un feedback (limite di 200 caratteri)","submitBtn":"Invia"},"userInfo":{"notVipTip":"L\'abbonamento a Zawa Pro offre l\'accesso a un\'ampia gamma di elementi e funzionalità protetti da copyright.","notLoginText":"Non sei ancora un membro","businessText":"Consulenza online","feedbackText":"Feedback","downloadText":"Scarica l\'app","settingText":"Impostazioni","loginText":"Accedi","copyText":"Copia","svipExpires":"Data di scadenza di Zawa Pro: ${0}","renewalText":"Rinnova","openText":"Abbonati","tips":"Usa le opere coperte da copyright per scopi commerciali senza pensieri durante il periodo di abbonamento.","logoutText":"Disconnettersi","lightText":"Chiaro","dartText":"Scuro","teamExpires":"L\'abbonamento del team scade il: ${0}","teamNotVipTitle":"Abbonati al piano Team","teamNotVipTip":"Usufruisci dei vantaggi esclusivi dell\'abbonamento e della collaborazione in team","teamExpiresDays":"L\'abbonamento del tuo team è scaduto ${0} giorni fa","copySuccess":"Copiato!","notVipTipTitle":"Diventa membro per accedere a tutte le risorse e gli strumenti di design","notVipTipSubscript":"Diritti commerciali inclusi","teamVersion":"Team","personalVersion":"Personale","vipExpiresDays":"Il tuo abbonamento è scaduto ${0} giorni fa","countAmount":"Numero di ritagli","meidouAmount":"Crediti","owner":"Super amministratore","admin":"Amministratore","vipValidUntil":"Scade il ${0}","teamNotVipTip2":"Scopri i vantaggi SVIP e le funzionalità esclusive","enterpriseVersion":"Enterprise","freeTeamVersion":"Gratuito","initialFreeDesc":"Diventa membro per accedere a tutte le risorse e gli strumenti di design","initialFreeTeamDesc":"Abbonati per condividere risorse e strumenti del team","languageSwitch":"Lingua","pro":"Piano Pro","plus":"Piano Plus","renewOn":"Si rinnova il","tryProForFree":"Prova Pro gratis","expiresOn":"Scade il","upgradeToPro":"Passa a Pro","credit":"Credito","manageSubscriptions":"Gestisci gli abbonamenti","termsAndPolicies":"Termini e informative","benefitsUpgraded":"Vantaggi aggiornati","basic":"Base","startFreeTrial":"Inizia la prova gratuita","upgradeNow":"Aggiorna ora"},"utils":{"requestErrorText":"Errore di rete. Impossibile connettersi al server."},"upload":{"errorText":"Caricamento non riuscito","cancelText":"Annulla","uploadingText":"Caricamento...","fileText":"File","picText":"Immagini","blockText":"Caricamento annullato","cancelUploadText":"Annulla caricamento","maxLengthTips":"Puoi caricare fino a 20 immagini alla volta","formatFailTips":"Caricamento di ${0} immagini non riuscito. Attualmente sono supportate solo immagini nei formati ${1}.","formatFailTips1":"Al momento sono supportate solo le immagini in formato ${0}","formatFailTips2":"Caricamento di ${0} immagini non riuscito. Al momento sono supportate solo immagini nei formati JPG, JPEG e PNG.","sizeFailTips":"Il caricamento di ${0} immagini non è riuscito. Assicurati che ogni immagine sia inferiore a 20 MB e non superi 8000×8000 pixel.","sizeFailTips1":"Assicurati che ogni immagine sia inferiore a 20 MB e non superi 8000×8000 pixel.","widthHeightFailTips":"Sono supportate solo immagini fino a 8000×8000 pixel","sizeFailTips2":"Supporta solo immagini fino a ${0} MB"},"meidouInfo":{"emptyText":"Ricarica","buyText":"Piano di acquisto crediti","openText":"Abbonati","rechargeText":"Ricarica","remainingText":"I miei crediti","tips1":"Usa prima i crediti in scadenza.","tips2":"I crediti acquistati non scadono mai","tips3":"Include ${0} crediti a pagamento validi per sempre.","tips4":"I crediti verranno detratti automaticamente a ogni generazione.","detailText":"Dettagli","whatIsMeidou":"Cosa sono i crediti?","giftTips":"40 crediti aggiunti al tuo account!","giftTips1":"Scadono a fine giornata. Non dimenticare di usarli!","genText":"Genera","deductionTips":"Per questa generazione verranno detratti ${0} crediti. Vuoi continuare?","genBtnText":"Genera","inadequateTips":"Crediti insufficienti. Ricarica prima almeno ${0} crediti.","inadequateTipsForNoVip":"Crediti insufficienti. Abbonati per ottenerne altri.","inadequateTipsForVip":"Crediti insufficienti. Ricarica per averne altri.","tryTimes":"Utilizzi di prova ${0}/${1}","meidouCountModalTitle":"Crediti rimanenti","meidouCountModalTips":"Verranno usati per primi i crediti più vicini alla scadenza.","meidouCountModalTips1":"Informazioni sui crediti","meidouCountModalEmpty":"Crediti esauriti. Acquista ora!","meidouCountModalBtn":"OK","meidouCountModalPermanent":"Validità permanente","meidouCountModalExpired":"Scade tra ${0} giorni","creditTransactionDetails":"Panoramica crediti","deductionTipsIntl":"Richiede ${0} crediti","deductionTips2Intl":"Per questa generazione verranno scalati ${0} crediti. Vuoi continuare?","autoDeductCredits":"Detrai automaticamente i crediti","generate":"Genera","close":"Chiudi","creditsBalance":"Saldo crediti","whatAreCredits":"Cosa sono i crediti?","usageDetail":"Dettagli di utilizzo","getMoreCredits":"Ottieni più crediti"},"floatHelp":{"modalTitle":"Assistente Meitu","businessTitle":"Consulenza online","communityText1":"Usa WeChat o WeCom per scansionare il codice QR e unirti","communityText2":"Unisciti a [Zawa User Group]","communityText3":"Come utente della beta iniziale, il tuo feedback è fondamentale. Condividi con noi la tua opinione.","feedbackTitle":"Feedback"},"designCreater":{"tab1":"Nuovo design","tab2":"Carica","uploadFail":"Caricamento non riuscito","uploadDragTips":"Fai clic sul pulsante \\"Carica\\" oppure trascina e rilascia qui","uploadBtn":"Carica","uploadTips":"Suggerimento: Consigliamo di caricare immagini JPG o PNG di massimo 20 MB.","unitPxText":"Pixel","unitMmText":"mm","unitCmText":"cm","sizeMinText":"Inferiore alle dimensioni richieste di ${0} * ${1}","sizeMaxText":"Supera le dimensioni richieste di ${0} * ${1}","createBtn":"Crea","widthText":"L","widthText1":"L","heightText":"H","heightText1":"H","customText":"Personalizzato","uploadDragTips_v2":"Carica o trascina qui le immagini","uploadBtn_v2":"Carica","uploadTips_v2":"Sono supportate immagini JPG e PNG fino a 20 MB","sizeMinText_v2":"Dimensioni inferiori a quelle richieste: ${0} * ${1} ${2}","sizeMaxText_v2":"Supera le dimensioni richieste di ${0} * ${1} ${2}","canvasSize":"Dimensioni della tela","canvasBackground":"Sfondo"},"space":{"onlyU":"Solo tu","anyone":"Chiunque abbia il link","viewAble":"Visualizza","editAble":"Modifica","viewAble2":"Visita","shareTitle":"Condividi la tua creazione","copyLink":"Copia link","copied":"Copiato"},"imageBatchUpload":{"buttonText":"Carica","uploadDirText":"Carica cartella","buttonDescription":"Incolla o trascina qui un\'immagine o un URL.","buttonDescription1":"Elabora in gruppo fino a ${0} immagini","batchButtonText":"Caricamento in blocco","upperUploadLimit":"Puoi caricare fino a ${0} immagini","errTipTitle":"I file superano i limiti di caricamento o sono in un formato non supportato","errTipSubTitle":"Carica ${1} immagini da massimo ${0} MB.","maxValueAndSize":"Sono supportate solo immagini fino a ${0} MB","maxWidthAndHeight":"Sono supportate solo immagini fino a ${0} pixel","errTipUpload":"Carica","errTipConfirm":"Ho capito","getFormatText":"Al momento sono supportate solo immagini in formato ${0}","heicResolveFailed":"Impossibile caricare l\'immagine HEIC. Ti consigliamo di convertirla in un altro formato immagine prima di caricarla.","imageUploadFailed":"Caricamento non riuscito","cvDescription":"Incolla immagine","demoDesc":"Prova uno di questi"},"logo":{"homeTip":"Fai clic per andare alla homepage","toolTip":"Trascina il logo di Zawa nella barra dei preferiti per accedervi rapidamente in futuro."},"cutoutInfo":{"remainingText":"Numero di ritagli rimanenti","openText":"Abbonati","rechargeText":"Ricarica","emptyText":"Ricarica"},"textFontFamily":{"empty":"Nessun contenuto","changeSearchWord":"Prova con un altro termine di ricerca","fontFamily":"Font","searchFont":"Cerca font","buyVipEnjoyFontFamily":"Gratuito per uso commerciale","currentFontFamily":"Font utilizzati in questo template"},"infiniteScroll":{"loading":"Caricamento..."},"colorGroup":{"emptyText":"Vuoto","upgradeTeamEdition":"Upgrade","systemColor":"Colore di sistema","teamColor":"Scheda colori del brand","cover":"Riempimento","repeat":"Affiancamento","fillingMode":"Modalità di visualizzazione","recommendedTexture":"Consigliato","uploadImage":"Carica","replaceImage":"Sostituisci"},"downloadBtn":{"downloadBtnTxt":"Scarica","modalTitle":"Scarica","editMoreTitle":"Modifica avanzata","downloadNow":"Scarica","addTxt":"Aggiungi testo","addMaterial":"Aggiungi elemento","eraser":"Gomma","cutout":"Rimozione sfondo","quality":"Enhancer di immagini","editMore":"Editor fotografico","customSize":"Personalizzato","customSizeInputTips":"Inserisci il limite di dimensione","customSizeError":"Inserisci la dimensione del file","processing":"Elaborazione in corso...","aicp":"Generatore di sfondi AI","upscale":"Upscaler di immagini"},"interceptModal":{"title":"Consenti le finestre pop-up per Zawa.","desc":"Autorizza Zawa ad aprire più finestre nel browser.","stepTitle":"Passaggio ${0}","btnText":"Ho capito","firstStep":"Fai clic sull\'avviso di blocco che appare in alto a destra nel browser","secondStep":"Fai clic su \\"Consenti sempre popup e reindirizzamenti\\".","thirdStep":"Fai clic su \\"Fine\\" per iniziare a usare Zawa.","xDesignTitle":"Consenti le finestre pop-up per Zawa.","xDesignDesc":"Autorizza Zawa ad aprire più finestre nel browser.","xDesignThirdStep":"Fai clic su \\"Fine\\" per iniziare a usare Zawa.","safariFirstStep":"Fai clic sulla barra dei menu a sinistra > Safari, quindi seleziona designkit.com.","safariSecondStep":"Nella finestra pop-up, seleziona “Finestre a comparsa” > “Consenti” per usare le funzionalità di Zawa senza problemi."},"workListPanel":{"history":"Creazioni","upload":"Carica","failed":"Non riuscita","pending":"Caricamento...","cancelText":"Annulla","confirmText":"Conferma","deleteText":"Dopo l\'eliminazione, i risultati generati andranno persi. Vuoi davvero eliminarli?","generating":"Elaborazione in corso..."},"feedbackVoting":{"defaultText":"Valuta il risultato","thanks":"Grazie per il tuo feedback.","modalTitle":"Feedback","modalDesc":"Il tuo feedback ci aiuterà a migliorare il nostro servizio.","modalIpt":"Descrivi cosa non ti ha soddisfatto","iptMaxLength":"Il contenuto supera il limite. Mantienilo entro ${0} caratteri o contatta il servizio clienti.","cancel":"Chiudi","submit":"Invia","other":"Altro"},"newDesignCreater":{"title":"Nuovo design","allCategory":"Tutto","openImage":"Carica","openFile":"File","pleaseInputSize":"Inserisci le dimensioni","categorySection":{"lookMore":"Altro","canvasSize":{"create":"Crea"}},"create":"Crea","commonSize":"Dimensioni comuni"},"psdModal":{"uploadTemplate":"Carica","uploadFile":"Carica","uploadSuccess":"Caricato","uploadFailed":"Caricamento non riuscito","uploadPSD":"Carica PSD"},"userPolicy":{"btnTomorrow":"Non adesso","btnVip":"Aggiorna ora","btnMy":"Ottieni più crediti","buyVip":"Limite di prove giornaliere raggiunto. Passa a VIP per l\'accesso illimitato!","buyMy":"Hai raggiunto il limite di prova. Ottieni altri crediti per continuare!","buyVipOrBackTomorrow":"Limite di prove giornaliere raggiunto. Passa a VIP per accesso illimitato!","backTomorrow":"Limite di prove giornaliere raggiunto. Passa a VIP per accesso illimitato!","trialLimitReached":"Limite della prova raggiunto"},"batchTaskList":{"loading":"Caricamento","fail":"Generazione fallita","batchEdit":"Modifica in gruppo","upload":"Carica altro"},"navVipEntrance":{"getFreePro":"Ottieni Pro gratis","unlockPro":"Sblocca Pro","renewNow":"Rinnova ora","upgradeToPro":"Passa a Pro","upgradeForFree":"Aggiorna gratis"},"brandSDK":{"bgInput":{"placeholder":"Descrivi il concept del tuo brand, il settore e le preferenze di stile."},"brandCard":{"nameLimitTip":"Inserisci un nome (max 10 caratteri)"},"delBrandSureModal":{"okText":"Conferma","cancelText":"Annulla","title":"Eliminare questo kit del brand?","message":"I design applicati non subiranno modifiche."},"brandList":{"createBrandText":"Aggiungi","emptyText":"Vuoto"},"logoCard":{"coverCornerText1":"Copertina","coverCornerText2":"Logo principale","delSureModal":{"okText":"Conferma","cancelText":"Annulla","title":"Eliminare questo logo?"},"nameLimitTip":"Inserisci un nome (max ${0} caratteri)","replaceText":"Sostituisci"},"colorList":{"countLimitTip":"Aggiungi fino a ${0} colori a ogni palette"},"colorCard":{"colorCountLimitTip":"Aggiungi fino a ${0} colori a ogni palette di colori","nameLimitTip":"Inserisci un nome (massimo ${0} caratteri)","nameInputPlaceholder":"Inserisci un nome (massimo ${0} caratteri)","colorEmptyText":"Vuoto"},"page":{"brandStandards":"Kit della marca","createStandard":"Aggiungi","createBrand":"Kit della marca"},"editBrand":{"sections":{"logo":"Loghi","colorCard":"Sistemi di colore","textStyle":"Stili testo","template":"Template","reference":"Riferimento","primaryColor":"Colore principale","secondaryColor":"Colore secondario"},"brandBackground":"Descrizione del brand","nameLimitTip":"Inserisci un nome (massimo 10 caratteri)","saveLastStyle":"Salva le modifiche per continuare","saveLastColorCard":"Salva le modifiche per continuare","saveLastElement":"Salva le modifiche per continuare","addColorCard":"Aggiungi nuovo","addStyle":"Aggiungi nuovo","addPrimaryColor":"Aggiungi colore principale","addSecondaryColor":"Aggiungi colore secondario","referenceDesc":"Carica i tuoi poster e le immagini di riferimento preferite: Zawa ne apprenderà lo stile per creare risorse visive uniche che rispecchiano i tuoi gusti.","bgInput":{"openBtnText":"Espandi","foldBtnText":"Riduci","title":"Guida di stile"},"addPrimaryLogo":"Aggiungi logo principale"},"textCard":{"nameLimitTip":"Inserisci un nome (massimo ${0} caratteri)","selectFont":"Seleziona un carattere","selectFontSize":"Seleziona la dimensione del carattere","fontSizePlaceholder":"Dimensione","save":"Salva","fontSize":"pt","bold":"Grassetto","standard":"Standard","italic":"Corsivo","defaultCategoryName":"Generale"},"templateCard":{"delSureModal":{"title":"Eliminare questo elemento?","okText":"Conferma","cancelText":"Annulla"},"nameLimitTip":"Inserisci un nome (max ${0} caratteri)","defaultName":"Template"},"selectBrandElementModal":{"brandAssets":"Kit della marca","localUpload":"Carica dal dispositivo","brandLogo":"Loghi","brandTemplate":"Template","reference":"Riferimento","uploadImage":"Carica","uploadDragTips":"Carica o trascina qui le immagini","uploadTips":"Carica fino a ${1} immagini JPG o PNG (max ${0} MB ciascuna)"},"tooltip":{"message":"La funzione Poster del brand è ora disponibile!","desc":"Carica i poster del tuo brand e lascia che AI Agent dia un’occhiata. Imparerà il tuo stile e creerà visual futuri in linea con l’identità del tuo brand!"}},"userReviews":{"hello":"Ciao ${0},","wordsOfThanks":"Grazie per far parte di Zawa!","desc":"Il tuo feedback è molto importante per noi. Se Zawa ti piace, ci farebbe davvero piacere se lasciassi una recensione su Trustpilot: ci aiuta molto a crescere e migliorare.","leave":"Lascia una recensione"},"aih5DownloadBtn":{"signInText":"Accedi","fullQualityText":"Qualità massima","previewText":"Anteprima","freeText":"Gratuito","downloadText":"Scarica","fullQualityLimitReached":"Limite per la qualità massima raggiunto. Torna domani.","todayLimitReached":"Hai raggiunto il limite di oggi. Torna domani o effettua l\'upgrade ora."}}');
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/x-design-locales-legacy/chunks/xDesignWidgets/pt.json
const pt_namespaceObject = JSON.parse('{"satisfaction":{"effectSatisfaction":"Satisfação","noWarn":"Não mostrar novamente","dissatisfied":"Insatisfação","normal":"Neutral","satisfied":"Satisfeito/a","placeholder":"Insira o feedback (limite de 200 caracteres)","submitBtn":"Enviar"},"userInfo":{"notVipTip":"A assinatura do Zawa Pro concede acesso a diversos elementos e recursos protegidos por direitos autorais.","notLoginText":"Você ainda não é assinante","businessText":"Consulta online","feedbackText":"Feedback","downloadText":"Baixar aplicativo","settingText":"Configurações","loginText":"Entrar","copyText":"Copiar","svipExpires":"Data de expiração do Zawa Pro: ${0}","renewalText":"Renovar","openText":"Assinar","tips":"Aproveite o uso comercial sem preocupações de obras protegidas por direitos autorais durante o período de sua assinatura.","logoutText":"Sair","lightText":"Claro","dartText":"Escuro","teamExpires":"A assinatura de equipe expira em: ${0}","teamNotVipTitle":"Inscreva-se na Assinatura de equipe","teamNotVipTip":"Aproveite os benefícios exclusivos da associação e a colaboração em equipe","teamExpiresDays":"Sua assinatura de equipe expirou há ${0} dias","copySuccess":"Copiado!","notVipTipTitle":"Torne-se membro para acessar todos os recursos e ferramentas de design","notVipTipSubscript":"Direitos comerciais cobertos","teamVersion":"Equipe","personalVersion":"Pessoal","vipExpiresDays":"Sua assinatura expirou há ${0} dias.","countAmount":"Valor de recorte","meidouAmount":"Créditos","owner":"Superadministrador","admin":"Administrador","vipValidUntil":"Expira em: ${0}","teamNotVipTip2":"Experimente os benefícios SVIP e recursos exclusivos","enterpriseVersion":"Empresa","freeTeamVersion":"Gratuito","initialFreeDesc":"Torne-se membro para acessar todos os recursos e ferramentas de design","initialFreeTeamDesc":"Assine para compartilhar recursos e ferramentas de equipe","languageSwitch":"Idioma","pro":"Pro","plus":"Plus Plan","renewOn":"Renovar agora","tryProForFree":"Experimente a versão Pro gratuitamente","expiresOn":"Expira em","upgradeToPro":"Atualizar para Pro","credit":"Crédito","manageSubscriptions":"Gerenciar Assinaturas","termsAndPolicies":"Termos e Políticas","benefitsUpgraded":"Benefícios atualizados","basic":"Básico","startFreeTrial":"Start Free Trial","upgradeNow":"Upgrade Now"},"utils":{"requestErrorText":"Erro de rede. Não foi possível conectar-se ao servidor."},"upload":{"errorText":"Falha ao carregar","cancelText":"Cancelar","uploadingText":"Carregando...","fileText":"Arquivo","picText":"Imagens","blockText":"Carregamento cancelado","cancelUploadText":"Cancelar carregamento","maxLengthTips":"Você pode carregar até 20 imagens ao mesmo tempo.","formatFailTips":"Falha ao carregar ${0} imagens. Atualmente, apenas imagens nos formatos ${1} são suportadas.","formatFailTips1":"Por enquanto, só suporta imagens no formato ${0}","formatFailTips2":"Falha ao carregar ${0} imagens. Atualmente, apenas imagens nos formatos JPG, JPEG e PNG são suportadas.","sizeFailTips":"Falha ao carregar ${0}imagens. Certifique-se de que cada imagem tenha menos de 20 MB e não exceda 8000×8000 pixels.","sizeFailTips1":"Certifique-se de que cada imagem tenha menos de 20 MB e não exceda 8000×8000 pixels.","widthHeightFailTips":"Suporta apenas imagens com 8000 px (altura e largura)","sizeFailTips2":"Suporta apenas imagens até ${0} MB"},"meidouInfo":{"emptyText":"Recarregar","buyText":"Comprar plano de créditos","openText":"Assinar","rechargeText":"Recarregar","remainingText":"Meus créditos","tips1":"Priorize o consumo dos créditos que estão prestes a expirar.","tips2":"Os créditos adquiridos nunca expiram","tips3":"Incluindo ${0} créditos pagos com validade permanente.","tips4":"Os créditos serão deduzidos automaticamente a cada geração.","detailText":"Detalhes","whatIsMeidou":"O que são os créditos?","giftTips":"40 créditos adicionados à sua conta!","giftTips1":"Expira no final do dia de hoje. Não se esqueça de usá-los!","genText":"Gerar","deductionTips":"${0} créditos serão deduzidos para esta geração. Deseja continuar?","genBtnText":"Gerar","inadequateTips":"Créditos insuficientes. Por favor, recarregue pelo menos ${0} créditos primeiro.","inadequateTipsForNoVip":"Insufficient credits. Subscribe for more.","inadequateTipsForVip":"Insufficient credits. Top up for more.","tryTimes":"Períodos de avaliação ${0} /${1}","meidouCountModalTitle":"Créditos restantes","meidouCountModalTips":"Os créditos que estiverem expirando serão usados primeiro.","meidouCountModalTips1":"Sobre os créditos","meidouCountModalEmpty":"Sem créditos. Compre agora mesmo!","meidouCountModalBtn":"OK","meidouCountModalPermanent":"Validade permanente","meidouCountModalExpired":"Expira em ${0} dia(s)","creditTransactionDetails":"Visão geral do crédito","deductionTipsIntl":"Precisa consumir ${0} créditos","deductionTips2Intl":"${0} créditos serão deduzidos por esta geração. Deseja continuar?","autoDeductCredits":"Deduzir créditos automaticamente","generate":"Gerar","close":"Fechar","creditsBalance":"Balanço de créditos","whatAreCredits":"O que são os créditos?","usageDetail":"Detalhes de uso","getMoreCredits":"Obter mais créditos"},"floatHelp":{"modalTitle":"Assistente Meitu","businessTitle":"Consulta online","communityText1":"Use WeChat ou Wecom para escanear o código QR e ingressar","communityText2":"Junte-se ao [Grupo de Usuários Zawa]","communityText3":"Como um dos primeiros usuários beta, sua opinião é fundamental. Compartilhe suas ideias conosco.","feedbackTitle":"Feedback"},"designCreater":{"tab1":"Novo Design","tab2":"Enviar","uploadFail":"Falha ao carregar","uploadDragTips":"Clique no botão “Carregar” ou arraste e solte aqui","uploadBtn":"Carregar","uploadTips":"Dicas: Recomendamos enviar imagens JPG ou PNG com tamanho inferior a 20 MB.","unitPxText":"Pixels","unitMmText":"mm","unitCmText":"cm","sizeMinText":"Menor que o tamanho exigido de ${0} * ${1}","sizeMaxText":"Excede o tamanho exigido de ${0} * ${1}","createBtn":"Criar","widthText":"b","widthText1":"Largura","heightText":"h","heightText1":"Altura","customText":"Personalizar","uploadDragTips_v2":"Carregue ou solte imagens aqui","uploadBtn_v2":"Carregar","uploadTips_v2":"Imagens JPG e PNG com tamanho inferior a 20 MB são suportadas","sizeMinText_v2":"Menor que o tamanho exigido de ${0} * ${1} ${2}","sizeMaxText_v2":"Excede o tamanho exigido de ${0} * ${1} ${2}","canvasSize":"Tamanho da tela","canvasBackground":"Fundo"},"space":{"onlyU":"Somente você","anyone":"Qualquer pessoa com o link","viewAble":"Visualizar","editAble":"Editar","viewAble2":"Visitar","shareTitle":"Compartilhar sua criação","copyLink":"Copiar link","copied":"Copiado"},"imageBatchUpload":{"buttonText":"Carregar","uploadDirText":"Carregar pasta >","buttonDescription":"Cole ou arraste uma imagem ou URL aqui.","buttonDescription1":"Processe em lote até ${0} imagens","batchButtonText":"Carregar em lote","upperUploadLimit":"Você pode carregar até ${0} imagens","errTipTitle":"Os arquivos excedem os limites de carregamento ou estão fora do formato","errTipSubTitle":"Por favor, carregue ${1} imagens com tamanho máximo de ${0} MB.","maxValueAndSize":"Suporta apenas imagens com tamanho máximo de arquivo de ${0} MB","maxWidthAndHeight":"Suporta apenas imagens com até ${0} px em ambos os lados","errTipUpload":"Carregar","errTipConfirm":"Entendi","getFormatText":"Por enquanto, só suporta imagens no formato ${0}","heicResolveFailed":"Falha ao carregar a imagem HEIC. Recomendamos convertê-la para outro formato antes de fazer o upload.","imageUploadFailed":"Falha ao carregar","cvDescription":"Colar imagem","demoDesc":"Experimente uma destas opções"},"logo":{"homeTip":"Clique para ir para a página inicial","toolTip":"Arraste o logotipo do Zawa para a barra de favoritos a fim de facilitar o acesso no futuro."},"cutoutInfo":{"remainingText":"Número restante de recortes","openText":"Assinar","rechargeText":"Recarregar","emptyText":"Recarregar"},"textFontFamily":{"empty":"Sem conteúdo","changeSearchWord":"Tente usar um termo de busca diferente","fontFamily":"Fonte","searchFont":"Procurar fonte","buyVipEnjoyFontFamily":"Gratuito para uso comercial","currentFontFamily":"Fontes utilizadas neste modelo"},"infiniteScroll":{"loading":"Carregando..."},"colorGroup":{"emptyText":"Vazio","upgradeTeamEdition":"Atualizar","systemColor":"Cor do sistema","teamColor":"Cartão de cores da marca","cover":"Preencher","repeat":"Aplicação de azulejos","fillingMode":"Modo de exibição","recommendedTexture":"Recomendado","uploadImage":"Carregar","replaceImage":"Substituir"},"downloadBtn":{"downloadBtnTxt":"Baixar","modalTitle":"Baixar","editMoreTitle":"Edição avançada","downloadNow":"Baixar","addTxt":"Adicionar texto","addMaterial":"Adicionar elemento","eraser":"Borracha","cutout":"Removedor de fundo","quality":"Aprimoramento","editMore":"Editor de fotos","customSize":"Personalizado","customSizeInputTips":"Insira o limite de tamanho","customSizeError":"Insira o tamanho do arquivo","processing":"Processando...","aicp":"Gerador de fundo com IA","upscale":"Aumentador de resolução de imagem"},"interceptModal":{"title":"Permitir janelas pop-up para o Zawa.","desc":"Autorize o Zawa a abrir várias janelas no seu navegador.","stepTitle":"Passo ${0}","btnText":"Entendi","firstStep":"Clique no alerta de bloqueio que aparece no canto superior direito do seu navegador","secondStep":"Clique em “Sempre permitir pop-ups e redirecionamentos”.","thirdStep":"Clique em “Concluído” para começar a usar o Zawa.","xDesignTitle":"Permitir janelas pop-up para o Zawa.","xDesignDesc":"Autorize o Zawa a abrir várias janelas no seu navegador.","xDesignThirdStep":"Clique em “Concluído” para começar a usar o Zawa.","safariFirstStep":"Clique na barra de menus à esquerda > Safari e selecione designkit.com.","safariSecondStep":"Na janela pop-up, selecione “Pop-ups” > “Permitir” para acessar os recursos do Zawa sem problemas."},"workListPanel":{"history":"Criações","upload":"Carregar","failed":"Falhou","pending":"Carregando...","cancelText":"Cancelar","confirmText":"Confirmar","deleteText":"Após a exclusão, os resultados gerados serão perdidos. Tem certeza de que deseja excluir?","generating":"Processando..."},"feedbackVoting":{"defaultText":"Avalie o resultado","thanks":"Agradecemos pelo seu feedback.","modalTitle":"Feedback","modalDesc":"Seus comentários nos ajudarão a melhorar nosso serviço.","modalIpt":"Descreva qual parte você não está satisfeito.","iptMaxLength":"O conteúdo excede o limite. Mantenha-o abaixo de ${0} caracteres ou entre em contato com o atendimento ao cliente.","cancel":"Fechar","submit":"Enviar","other":"Outros"},"newDesignCreater":{"title":"Novo Design","allCategory":"Tudo","openImage":"Enviar","openFile":"Arquivo","pleaseInputSize":"Insira o tamanho","categorySection":{"lookMore":"Mais","canvasSize":{"create":"Criar"}},"create":"Criar","commonSize":"Tamanho padrão"},"psdModal":{"uploadTemplate":"Carregar","uploadFile":"Carregar","uploadSuccess":"Carregado","uploadFailed":"Falha ao carregar","uploadPSD":"Carregar PSD"},"userPolicy":{"btnTomorrow":"Agora não","btnVip":"Atualizar agora","btnMy":"Obter mais créditos","buyVip":"Limite diário de teste atingido. Torne-se VIP para ter acesso ilimitado!","buyMy":"Você atingiu o limite da sua versão de teste. Adquira mais créditos para continuar!","buyVipOrBackTomorrow":"Limite diário de teste atingido. Torne-se VIP para ter acesso ilimitado!","backTomorrow":"Limite diário de teste atingido. Torne-se VIP para ter acesso ilimitado!","trialLimitReached":"Limite de avaliação atingido"},"batchTaskList":{"loading":"Carregando","fail":"Falha na geração","batchEdit":"Editar lote","upload":"Carregar mais"},"navVipEntrance":{"getFreePro":"Obtenha o Pro gratuitamente","unlockPro":"Desbloquear Pro","renewNow":"Renovar Agora","upgradeToPro":"Atualizar para Pro","upgradeForFree":"Upgrade for Free"},"brandSDK":{"bgInput":{"placeholder":"Descreva o conceito da sua marca, o setor e suas preferências de estilo."},"brandCard":{"nameLimitTip":"Insira um nome (até 10 caracteres)"},"delBrandSureModal":{"okText":"Confirmar","cancelText":"Cancelar","title":"Apagar este kit de marca?","message":"Os projetos aplicados não serão afetados."},"brandList":{"createBrandText":"Adicionar","emptyText":"Vazio"},"logoCard":{"coverCornerText1":"Capa","coverCornerText2":"Logotipo principal","delSureModal":{"okText":"Confirmar","cancelText":"Cancelar","title":"Excluir este logotipo?"},"nameLimitTip":"Insira um nome (até ${0} caracteres)","replaceText":"Substituir"},"colorList":{"countLimitTip":"Adicione até ${0} cor(es) a cada paleta de cores"},"colorCard":{"colorCountLimitTip":"Adicione até ${0} cor(es) a cada paleta de cores","nameLimitTip":"Insira um nome (até ${0} caracteres)","nameInputPlaceholder":"Insira um nome (até ${0} caracteres)","colorEmptyText":"Vazio"},"page":{"brandStandards":"Kit de marca","createStandard":"Adicionar","createBrand":"Kit de marca"},"editBrand":{"sections":{"logo":"Logotipos","colorCard":"Sistemas de cores","textStyle":"Estilos de texto","template":"Modelos","reference":"Reference","primaryColor":"Cor principal","secondaryColor":"Cor secundária"},"brandBackground":"Descrição da marca","nameLimitTip":"Insira um nome (até 10 caracteres)","saveLastStyle":"Salve as alterações para continuar","saveLastColorCard":"Salve as alterações para continuar","saveLastElement":"Salve as alterações para continuar","addColorCard":"Adicionar novo","addStyle":"Adicionar novo","addPrimaryColor":"Adicionar cor principal","addSecondaryColor":"Adicionar cor secundária","referenceDesc":"Upload your posters and favorite reference images — Zawa will learn their style to craft unique visual assets that reflect your taste.","bgInput":{"openBtnText":"Expandir","foldBtnText":"Recolher","title":"Guia de estilo"},"addPrimaryLogo":"Adicionar logotipo principal"},"textCard":{"nameLimitTip":"Insira um nome (até ${0} caracteres)","selectFont":"Selecione uma fonte","selectFontSize":"Selecione o tamanho da fonte","fontSizePlaceholder":"Tamanho","save":"Salvar","fontSize":"号","bold":"Negrito","standard":"Padrão","italic":"Itálico","defaultCategoryName":"Geral"},"templateCard":{"delSureModal":{"title":"Excluir este modelo?","okText":"Confirmar","cancelText":"Cancelar"},"nameLimitTip":"Insira um nome (até ${0} caracteres)","defaultName":"Modelos"},"selectBrandElementModal":{"brandAssets":"Kit de marca","localUpload":"Carregar a partir do dispositivo","brandLogo":"Logotipos","brandTemplate":"Modelos","reference":"Reference","uploadImage":"Carregar","uploadDragTips":"Carregue ou solte a imagem aqui","uploadTips":"Carregue até ${1} imagens JPG ou PNG (máximo de ${0} MB cada)"},"tooltip":{"message":"O recurso Cartaz da Marca já está disponível!","desc":"Carregue os cartazes da sua marca e deixe o Agente de IA dar uma olhada. Ele aprenderá o seu estilo e criará visuais futuros que combinam com a sua marca!"}},"userReviews":{"hello":"Olá ${0},","wordsOfThanks":"Agradecemos por fazer parte do Zawa!","desc":"A sua opinião é muito importante para nós. Se você está gostando do Zawa, adoraríamos que deixasse uma avaliação no Trustpilot — isso nos ajuda muito a crescer e melhorar.","leave":"Deixe uma avaliação"},"aih5DownloadBtn":{"signInText":"Fazer login","fullQualityText":"Qualidade total","previewText":"Pré-visualizar","freeText":"Gratuito","downloadText":"Baixar","fullQualityLimitReached":"Limite de qualidade total atingido. Volte amanhã.","todayLimitReached":"Limite diário atingido. Volte amanhã ou faça um upgrade agora."}}');
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/x-design-locales-legacy/chunks/xDesignWidgets/zh-Hans.json
const zh_Hans_namespaceObject = JSON.parse('{"satisfaction":{"effectSatisfaction":"效果满意度","noWarn":"不再提醒","dissatisfied":"不满意","normal":"一般","satisfied":"满意","placeholder":"请输入您的建议(200字内)","submitBtn":"提交"},"userInfo":{"notVipTip":"开通会员SVIP享海量版权素材和功能权益","notLoginText":"您还未开通会员","businessText":"在线咨询","feedbackText":"意见反馈","downloadText":"下载客户端","settingText":"设置","loginText":"立即登录","copyText":"复制","svipExpires":"SVIP到期: ${0}","renewalText":"立即续费","openText":"立即开通","tips":"会员期间享作品商用版权无忧","logoutText":"退出登录","lightText":"浅色","dartText":"深色","teamExpires":"团队会员到期: ${0}","teamNotVipTitle":"开通团队版会员","teamNotVipTip":"畅享会员权益与团队协作","teamExpiresDays":"团队会员已过期${0}天","copySuccess":"复制成功","notVipTipTitle":"开通会员畅享全站设计资源和工具","notVipTipSubscript":"商用版权无忧","teamVersion":"团队版","personalVersion":"个人版","vipExpiresDays":"会员已过期${0}天","countAmount":"张数","meidouAmount":"美豆","owner":"超级管理员","admin":"管理员","vipValidUntil":"有效期至: ${0}","teamNotVipTip2":"畅享SVIP权益与团队专属功能","enterpriseVersion":"企业版","freeTeamVersion":"免费版","initialFreeDesc":"开通会员畅享全站设计资源和工具","initialFreeTeamDesc":"开通会员共享团队资源和协作工具","languageSwitch":"语言","pro":"Pro Plan","plus":"Plus Plan","renewOn":"续费","tryProForFree":"免费体验pro版本","expiresOn":"到期","upgradeToPro":"升级到pro版本","credit":"积分","manageSubscriptions":"管理订阅","termsAndPolicies":"条款与政策","benefitsUpgraded":"权益已升级","basic":"Basic","startFreeTrial":"开始免费试用","upgradeNow":"立即升级"},"utils":{"requestErrorText":"您的网络发生异常，无法连接服务器"},"upload":{"errorText":"图片上传失败","cancelText":"取消","uploadingText":"上传中","fileText":"文件","picText":"图片","blockText":"上传过程中取消了上传","cancelUploadText":"取消上传","maxLengthTips":"最多允许同时上传20张图片","formatFailTips":"${0}张图片上传失败，暂时只支持${1}格式的图片","formatFailTips1":"暂时只支持${0}格式的图片","formatFailTips2":"${0}张图片上传失败，暂时只支持JPG/JPEG/PNG格式的图片","sizeFailTips":"${0}张图片上传失败，仅支持20M，宽高均为8000px以内的图片","sizeFailTips1":"仅支持20M，宽高均为8000px以内的图片","widthHeightFailTips":"仅支持宽高均为8000px以内的图片","sizeFailTips2":"仅支持${0}M以内的图片"},"meidouInfo":{"emptyText":"充值","buyText":"购买美豆套餐","openText":"开通会员送美豆","rechargeText":"立即充值","remainingText":"我的美豆","tips1":"优先消耗临期的美豆","tips2":"付费美豆永久有效","tips3":"含${0}个付费美豆，永久有效","tips4":"每次生成后自动扣除美豆","detailText":"美豆消耗明细","whatIsMeidou":"什么是美豆","giftTips":"Hi! 今日登录奖励40美豆已到账~","giftTips1":"当天有效，尽快使用吧！","genText":"生成","deductionTips":"生成将扣除${0}美豆，是否生成？","genBtnText":"去生成","inadequateTips":"您的美豆数不足，请先至少充值${0}个美豆","inadequateTipsForNoVip":"您的美豆数不足，可开通会员送美豆","inadequateTipsForVip":"您的美豆数不足，请充值","tryTimes":"试用次数${0}/${1}","meidouCountModalTitle":"剩余美豆","meidouCountModalTips":"优先消耗临期美豆","meidouCountModalTips1":"美豆介绍 &gt;","meidouCountModalEmpty":"没有美豆哦～请前往购买吧","meidouCountModalBtn":"好的","meidouCountModalPermanent":"永久有效","meidouCountModalExpired":"${0}天过期","creditTransactionDetails":"积分交易详情","deductionTipsIntl":"需要消耗${0}积分","deductionTips2Intl":"本次生成需要消耗${0}积分，您是否还要继续？","autoDeductCredits":"自动扣除积分","generate":"生成","close":"关闭","creditsBalance":"积分余额","whatAreCredits":"什么是积分","usageDetail":"使用详情","getMoreCredits":"获取更多积分"},"floatHelp":{"modalTitle":"美图小助手","businessTitle":"在线咨询","communityText1":"使用微信或企业微信扫码加入","communityText2":"加入【美图设计室AI用户群】","communityText3":"作为首批内测用户，你的使用体验和反馈对我们非常重要，欢迎与我们交流你的想法或需求。","feedbackTitle":"意见反馈"},"designCreater":{"tab1":"创建设计","tab2":"打开图片","uploadFail":"上传失败","uploadDragTips":"点击“上传文件”按钮或拖放到这里","uploadBtn":"上传文件","uploadTips":"Tips:建议上传 200M以内 jpg、png 图片","unitPxText":"像素","unitMmText":"毫米","unitCmText":"厘米","sizeMinText":"低于画布尺寸${0} * ${1}","sizeMaxText":"超出画布尺寸${0} * ${1}","createBtn":"创建","widthText":"宽度","widthText1":"宽","heightText":"高度","heightText1":"高","customText":"自定义尺寸","uploadDragTips_v2":"点击/拖拽图片至此处","uploadBtn_v2":"上传图片","uploadTips_v2":"支持上传 20M以内 jpg、png 图片","sizeMinText_v2":"低于画布尺寸限制：${0} * ${1} ${2}","sizeMaxText_v2":"超出画布尺寸限制：${0} * ${1} ${2}","canvasSize":"画布尺寸","canvasBackground":"画布背景"},"space":{"onlyU":"仅你自己获得链接","anyone":"任何获得链接的人","viewAble":"可查看","editAble":"可编辑","viewAble2":"可访问","shareTitle":"分享你的作品","copyLink":"复制链接","copied":"已复制"},"imageBatchUpload":{"buttonText":"上传图片","uploadDirText":"上传文件夹 >","buttonDescription":"粘贴图片、网址，或拖拽图片至此。","buttonDescription1":"支持批量处理${0}张图片。","batchButtonText":"批量上传","upperUploadLimit":"批量模式最多支持${0}张图片","errTipTitle":"以下文件超过上传限制或不符合格式","errTipSubTitle":"请上传${0}M以内的${1}格式图片","maxValueAndSize":"仅支持${0}M以内的图片","maxWidthAndHeight":"仅支持宽高均为${0}px以内的图片","errTipUpload":"上传图片","errTipConfirm":"我知道了","getFormatText":"暂时只支持${0}格式的图片","heicResolveFailed":"HEIC图片解析失败，建议您转换为其他图片格式上传","imageUploadFailed":"图片上传失败","cvDescription":"粘贴图片","demoDesc":"试试这些"},"logo":{"homeTip":"点击可以前往首页","toolTip":"拖动Logo到书签栏，收藏美图设计室，打开更便捷～"},"cutoutInfo":{"remainingText":"剩余抠图张数","openText":"立即开通","rechargeText":"充值张数","emptyText":"充值"},"textFontFamily":{"empty":"暂无内容","changeSearchWord":"换个搜索词再试试","fontFamily":"字体","searchFont":"搜索字体","buyVipEnjoyFontFamily":"开通会员，可免费商用该字体","currentFontFamily":"当前模版使用的字体"},"infiniteScroll":{"loading":"玩命加载中..."},"colorGroup":{"emptyText":"空","upgradeTeamEdition":"升级团队版","systemColor":"系统颜色","teamColor":"品牌色卡","cover":"充满图框","repeat":"平铺","fillingMode":"填充方式","recommendedTexture":"推荐图案","uploadImage":"上传图片","replaceImage":"替换图片"},"downloadBtn":{"downloadBtnTxt":"下载","modalTitle":"下载","editMoreTitle":"去更多功能中使用","downloadNow":"立即下载","addTxt":"添加文字","addMaterial":"添加素材","eraser":"消除笔","cutout":"智能抠图","quality":"变清晰","editMore":"图片编辑","customSize":"自定义大小","customSizeInputTips":"输入限定大小","customSizeError":"请填写文件大小","processing":"处理中…","aicp":"AI换背景","upscale":"无损放大"},"interceptModal":{"title":"允许显示美图设计室弹出窗口","desc":"你需要授权美图设计室在浏览器打开多个窗口。","stepTitle":"第${0}步","btnText":"我知道啦","firstStep":"点击浏览器右侧顶部弹出的阻止程序图标。","secondStep":"点击始终允许显示弹出式窗口和进行重定向。","thirdStep":"点击完成按钮，即可正常使用美图设计室的功能啦～","xDesignTitle":"允许显示美图设计室弹出窗口","xDesignDesc":"你需要授权美图设计室在浏览器打开多个窗口。","xDesignThirdStep":"点击完成按钮，即可正常使用美图设计室的功能啦～","safariFirstStep":"点击左侧菜单栏-Safari浏览器, 选择designkit.com设置","safariSecondStep":"在弹窗中选择【弹出式窗口】，点击【允许】即可正常使用美图设计室的功能啦~"},"workListPanel":{"history":"历史记录","upload":"上传","failed":"失败","pending":"生成中","cancelText":"取消","confirmText":"确定","deleteText":"删除后，此次生成结果将会丢失，确定删除吗？","generating":"处理中"},"feedbackVoting":{"defaultText":"给这个结果评分","thanks":"感谢您的反馈。","modalTitle":"反馈详情","modalDesc":"您的反馈将会帮助我们进一步优化美图设计室的AI功能","modalIpt":"请详细描述您对结果不满意的原因","iptMaxLength":"内容超出长度限制，输入字数最多为${0}。如需更多帮助，请联系客服。","cancel":"关闭","submit":"提交","other":"其他"},"newDesignCreater":{"title":"创建设计","allCategory":"全部","openImage":"打开图片","openFile":"打开文件","pleaseInputSize":"请输入尺寸","categorySection":{"lookMore":"查看更多","canvasSize":{"create":"创建"}},"create":"创建","commonSize":"常用尺寸"},"psdModal":{"uploadTemplate":"上传模板","uploadFile":"上传文件","uploadSuccess":"上传成功","uploadFailed":"上传失败","uploadPSD":"上传PSD"},"userPolicy":{"btnTomorrow":"明日再来","btnVip":"立即开通","btnMy":"立即获取","buyVip":"今日试用次数已达上限，开通会员不受限。","buyMy":"试用次数已达上限，充值美豆获得更多使用机会。","buyVipOrBackTomorrow":"今日试用次数已达上限，开通会员不受限。","backTomorrow":"今日试用次数已达上限，开通会员不受限。","trialLimitReached":"试用已达上限"},"batchTaskList":{"loading":"加载中","fail":"生成失败","batchEdit":"批量编辑","upload":"上传"},"navVipEntrance":{"getFreePro":"免费体验Pro版本","unlockPro":"解锁Pro版本","renewNow":"立即续费","upgradeToPro":"升级到Pro版本","upgradeForFree":"免费升级"},"brandSDK":{"bgInput":{"placeholder":"请简短描述你的品牌理念、服务行业、偏好风格"},"brandCard":{"nameLimitTip":"请输入10字内的名称"},"delBrandSureModal":{"okText":"确定","cancelText":"取消","title":"确认删除这个品牌资产吗？","message":"已应用的作图记录不会受到影响"},"brandList":{"createBrandText":"创建品牌规范","emptyText":"空"},"logoCard":{"coverCornerText1":"封面","coverCornerText2":"主Logo","delSureModal":{"okText":"确定","cancelText":"取消","title":"确定要删除该logo吗？"},"nameLimitTip":"请输入${0}字以内的名称","replaceText":"替换"},"colorList":{"countLimitTip":"每套色卡仅支持添加${0}个色块"},"colorCard":{"colorCountLimitTip":"每套色卡仅支持添加${0}个色块","nameLimitTip":"请输入${0}字以内的名称","nameInputPlaceholder":"请输入${0}字以内的名称","colorEmptyText":"空"},"page":{"brandStandards":"品牌规范","createStandard":"创建规范","createBrand":"品牌规范"},"editBrand":{"sections":{"logo":"logo","colorCard":"色卡","textStyle":"文字样式","template":"模板","reference":"Reference","primaryColor":"主色","secondaryColor":"辅助色"},"brandBackground":"你的品牌背景是？","nameLimitTip":"请输入10字内的名称","saveLastStyle":"请保存上个样式","saveLastColorCard":"请保存上个色卡","saveLastElement":"请先保存上个元素","addColorCard":"新建色卡","addStyle":"新建样式","addPrimaryColor":"新建主色","addSecondaryColor":"新建辅助色","referenceDesc":"Upload your posters and favorite reference images — Zawa will learn their style to craft unique visual assets that reflect your taste.","bgInput":{"openBtnText":"展开","foldBtnText":"收起","title":"设计指导"},"addPrimaryLogo":"新建主Logo"},"textCard":{"nameLimitTip":"请输入${0}字以内的名称","selectFont":"请选择字体","selectFontSize":"请选择字号大小","fontSizePlaceholder":"字号","save":"保存","fontSize":"号","bold":"粗体","standard":"标准","italic":"斜体","defaultCategoryName":"通用"},"templateCard":{"delSureModal":{"title":"确认删除此项吗？","okText":"确定","cancelText":"取消"},"nameLimitTip":"请输入${0}字以内的名称","defaultName":"品牌模板"},"selectBrandElementModal":{"brandAssets":"品牌资产","localUpload":"本地上传","brandLogo":"品牌logo","brandTemplate":"品牌模板","reference":"Reference","uploadImage":"上传图片","uploadDragTips":"点击/拖拽图片至此处","uploadTips":"支持上传 ${0}M以内 jpg、png 图片，最多支持${1}张"},"tooltip":{"message":"品牌海报上线啦！","desc":"上传你的海报，Agent将学习你的品牌调性，后续在对话中调用品牌库时可生成与品牌风格契合的海报～"}},"userReviews":{"hello":"你好${0}，","wordsOfThanks":"感谢加入zawa","desc":"你的反馈对我们非常重要。如果你喜欢zawa，欢迎您在Trustpilot上留下评论，我们将不胜感激。这可以帮助我们提升和成长","leave":"去评价"},"aih5DownloadBtn":{"signInText":"登录","fullQualityText":"大图","previewText":"小图","freeText":"免费","downloadText":"下载","fullQualityLimitReached":"今日高清图下载次数已用完","todayLimitReached":"今日次数已用完，立即升级"}}');
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/x-design-locales-next/en.json
const x_design_locales_next_en_namespaceObject = JSON.parse('{"Tab_Design":"Design","Button_Send":"Send","Input_Describe_Workspace":"Describe your image and I will create it for you","Tab_AgentCase":"Agent case","Tab_RecentCreations":"Recents","Tag_Hot":"Trending","Tag_BrandDesign":"Brand Design","Tag_Logo":"Logos","Tag_Posters":"Posters","Tab_Agent":"Agent","Tool_AiPhotoEditor":"Image Editor","Button_Upload":"Upload","Tool_Designer":"Designer","Title_AiTool":"AI Tools","Tool_ImageBackgroundRemover":"AI Background Remover","Tool_AiBackgroundGenerator":"AI Background Generator","Tool_ImageEnhancer":"Image Enhancer","Tool_AiObjectsRemover":"Object Remover","Tool_AiModelMannequin":"AI Model - Mannequin","Tool_AiModelFlatlay":"AI Model - Flatlay","Tool_AiImageRecolor":"AI Image Recolor","Tool_AiImageExtender":"AI Image Extender","Tool_ImageUpscaler":"AI Image Upscaler","Tool_AiLogo":"AI Logo Generator","Button_BlankCanvas":"Create","Sidebar_Create":"Home","Sidebar_Tools":"AI Tools","Sidebar_Batch":"Bulk Editor","Sidebar_MyDesigns":"My Designs","Sidebar_Inspire":"Inspire Me","Sidebar_Brand":"Brand Kit","Sidebar_PackUp":"Close sidebar","Tag_All":"All","Tag_Design":"Design","Sidebar_Unfold":"Open sidebar","Menu_Edit":"Edit","Menu_Download":"Download","Menu_Delete":"Delete","Tab_RecentlyCreated":"Recents","Tab_GenerateRecords":"Creations","Menu_Total":"Total","Menu_Total_Explain_AgentCredits":"For AI Agent only and will be used first.","Menu_DueToday":"Daily bonus credits","Menu_DueToday_Explain":"Valid until the end of the day.","Menu_Else_AgentCredits":"Other credits","Button_GoPro_GetMore":"Get more credits","Menu_Total_Explain_PaidCredits":"For all features and valid through membership period.","Menu_Pro":"Subscription credits","Menu_Pro_Explain":"Valid through membership period.","Menu_Else":"Other credits","Menu_Else_Explain_PaidCredits":"Credits from other sources. Each type may have its own expiration.","Menu_Else_Explain_AgentCredits":"Credits from other sources. Valid for a longer period.","Menu_UsageDetail":"Usage details","Menu_Total_Explain_SuspendCredits":"Unavailable until your membership is reactivated.","Tab_Invite":"Invite","Menu_InviteReward":"Invite Friends Reward","Tab_Reward":"Rewards","Title_AgentCreditForRewards":"Agent credit rewards:","Table_Time":"Time","Table_Invitee":"Invitee","Title_ShareWithFriends":"Share with your friends","Title_ShareWithFriends_ExplainOne":"<span style=\\"color:#616266;\\">Invite a friend and both of you will receive </span><span style=\\"color:#2D990C;\\">${0} Agent Credits!</span>","Title_InvitationLink":"Share this link with your friends","Button_Copy":"Copy","Title_Tips":"Tips","Title_Tips_ExplainOne":"1. Agent Credits can only be used to access AI Agent features. Reward credits are valid for two years.","Title_Tips_ExplainTwo":"2. New friends will receive a reward after successful registration. If you have any questions, please contact our support team.","Title_GetRewarded":"Successful invitation!","Title_GetRewarded_Explain":"Credits can only be used for AI Agent features and are valid for two years.","Button_Ok":"Got it","Title_FailedToReceiveReward":"Operation failed","Title_FailedToReceiveReward_Explain":"If you have any questions, please contact our support team.","Tool_AiBackgroundGenrator":"AI Background Generator","Title_YouCannotUseYourOwnLink":"Private links are not allowed","Table_AgentCredit":"Agent Credits","Title_ShareWithFriends_ExplainTwo":"<span style=\\"color:#616266;\\">You can invite up to </span><span style=\\"color:#2D990C;\\">${0} new friends</span><span style=\\"color:#616266;\\"> and earn a maximum of ${1} Agent Credits!</span>","Button_Invite":"Invite","Menu_Title_Invite":"Refer a Friend","Text_Button_Invite":"Earn Credits","Title_Dialog_Invite":"Refer a Friend","Desc_Dialog_Invite":"Share your link with friends or on social media. When a friend signs up via your link, both you and your friend will receive ${0} credits. If they subscribe, you will each receive up to ${1} extra credits.","Detail_Dialog_Invite":"Details","Text_Copy_Invite":"Copy link","Title_Rewards_Invite":"Rewards","SubTitle_Rewards1_Invite":"Total earned credits","SubTitle_Rewards2_Invite":"Referred free users","SubTitle_Rewards3_Invite":"Referred paid users","Success_Copy_Invite":"Link copied","Title1_Invited_Invite":"You\'ve been invited!","Text_Rule1_Invite":"For every friend who signs up using your link, you both earn <strong>${0} credits</strong>.","Text_Rule2_Invite":"If your friend subscribes, you each get extra credits (<strong>${0} for Plus, ${1} for Pro</strong>).","Text_Rule3_Invite":"Purchased subscriptions cannot be refunded if the plan has been used or any granted credits have been spent. Also, free credits cannot be revoked once used.","Text_Rule4_Invite":"Each user can invite up to ${0} friends.","Text_Rule5_Invite":"Rewards are not granted for referrals with existing accounts, self-referrals, duplicate accounts, or fraudulent activity.","Text_Rule6_Invite":"${0} reserves the right to adjust the program and revoke rewards from abnormal accounts.","Text_Divider_Invite":"or share the link","Title2_Invited_Invite":"Join ${0} and claim your rewards","SubTitle1_Invited_Invite":"A friend invited you to try our professional brand Al agent. Create high-quality brand marketing designs such as logos, posters, menus, and social media assets with ease.","SubTitle2_Invited_Invite":"<strong>Sign up now</strong> and both you and your friend will <strong>receive ${0} credits</strong>.<strong> If you subscribe,</strong> you will each receive additional credits based on the plan you choose (<strong>${1} credits with Plus or ${2} credits with Pro</strong>). Sign up now to claim your rewards.","Button_Invited_Invite":"Sign up to claim your rewards","Success_Invited_Invite":"You joined via a referral and received ${0} credits.","Error_Invited_Invite":"You already have an account.","Text_Share_Invite":"I’ve been using ${0} to create logos, visuals, and videos really fast. Sign up with my link and we’ll both get bonus credits.","Title_Share_Invite":"Join ${0} and earn credits together!","Share_Email_Invite":"Email","Text_Rule7_Invite":"You can use the credits for AI Agent. Credits expire after one month.","Title_AgentCredits":"+50 Agent Credits","Input_Models":"Model","Button_TryItNow":"Try it now","Account_Pricing":"Pricing","Account_Language":"Language","Account_Language_English":"English","Account_Language_Chinese":"Chinese","Tips_Adding":"Processing...","Tips_Loading":"Loading...","Tips_Creating":"Processing...","Tips_Downloading":"Downloading…","Tips_Sending":"Sending…","Tips_AddSuccess":"Added successfully","Tips_MakeSameError":"Unable to recreate","Tips_UnsupportedGradientColor":"Gradients are not supported","Tips_CanNotAdding":"Failed to add","Tips_Uninitialized":"Failed to send messages","Tips_UploadFailed":"Upload failed. Please try again.","Tips_UploadMaxCountLimit":"Upload up to ${n} ${type} file(s)","Tips_UploadMaxFileSize":"Unable to upload file ${file}. Please use a file up to ${n} MB.","Tips_UploadImageAndVideoLimit":"You can upload 1 image and 1 video at the same time","Tips_UnsupportedSvgFile":"SVG files are not supported","Tips_UnsupportedUploadFileFormats":"The format of your file ${files} is not supported","Tips_CanNotAddSameFileTips":"This file already exists","Tips_TextMinLengthTips":"Enter at least ${n} characters","Tips_TextMaxLengthTips":"Enter up to ${n} characters. Each Chinese character or emoji counts as 2.","Tips_AccessDenied":"Access denied","Tips_CreateFailed":"Chat initiation failed","Tips_Error":"An error occurred","Tips_NotFound":"Chat does not exist","Tips_RequestAgentModelListError":"Failed to request the Agent model list","Desc_Ended":"End","Button_PeopleUse_Agent":"${n} users tried","Dropdown_AddToChat":"Add to Chat","Dropdown_AddToBrandKit":"Add to Brand Kit","Dropdown_SaveToBrandKit":"Save as brand logo","Dropdown_SaveToBrandTemplate":"Save as brand template","Title_Design_Agent":"Design","Title_MainColor":"Main color","Title_SecondaryColor":"Secondary color","Bitton_ViewTheBrandKit":"Click to view the brand kit","Dropdown_InportImages":"Import images","Title_Upgrade_Pro":"Upgrade","Desc_SubscribeToUnlock_Pro":"Subscribe to unlock more!","Desc_RunOutOfFreeUses_Pro":"You\'ve run out of free uses.","Desc_RunOutOfUsesForToday_Pro":"You\'ve run out of free uses for today. Come back tomorrow.","Desc_PurchaseCompleted_Pro":"Purchase complete","Desc_ContinueDesign_Pro":"Now you can continue your design!","Button_UnlockNow":"Subscribe","Tips_Copied":"Copied!","Tips_Credit_Explain_Paid":"What are purchased credits?","Title_Total_InactiveCredits":"Total inactive credits","Title_Total_PaidCredits":"Total purchased credits","Menu_SuspendCredits":"Inactive credits","Menu_Credits":"Credits","Tab_RecentCreations_Agent":"Agent","Tab_RecentCreations_Design":"Smart Tools","Menu_FunctionalPricing":"Agent Pricing","Title_Total_AgentCredits":"Total - Agent credits","Tips_Credit_Explain_Agent":"What are Agent credits?","Title_FeaturePricing":"Agent Pricing","Tab_Category":"Category","Tab_TaskType":"Task","Tab_Consume":"Price (Credits)","Tab_ExampleContent":"Examples","Tips_CreditExplain_Inactive":"What are inactive credits?","langding_more_bg_remover":"Background Remover","langding_more_enhancer":"Image Enhancer","langding_more_objects_remover":"AI Object Remover","langding_more_bg_generator":"AI Background Generator","Title_More1_Home":"Image Enhancer","Title_More2_Home":"AI Object Remover","Title_More3_Home":"AI Background Generator","Title_More4_Home":"AI Background Remover","Title_More5_Home":"Batch Image Tools","Title_Home":"Your <span>E-Commerce</span> Design AI Agent","Placeholder_Input_Home":"Describe your image and I will create it for you.","Title_Card4_Home":"Visuals for Amazon","Title_Card1_Home":"Apparel & Accessory Try-on Images","Title_Card3_Home":"Product Detail Page Images","Title_Card2_Home":"Background Generator","Desc_Features1_Home":"AI automatically extracts product features and style preferences to determine the ideal design solutions.","Desc_Features2_Home":"Just enter one sentence, and the AI will generate a complete collection of e-commerce images, including the main image, supporting visuals, and a full product detail page.","Text_Btn_Home":"Get Started for Free","Desc_Features3_Home":"Automatically create platform-ready visuals tailored to Amazon, Etsy, TEMU, eBay, and more, ensuring images are always optimized to attract the right audience.","Desc_Features4_Home":"Just enter your request, and the AI will adapt the language, style, tone, and cultural elements to produce localized versions for each target market.","Desc_Features5_Home":"Save your design workflow as a reusable template, and let the AI automatically generate images for all your SKUs in bulk.","Desc_Features6_Home":"Whether you’re working with 10 products or 1,000, you can quickly produce a complete, consistent visual suite with ease.","Title_Qualification_Home":"Trusted by Over 5 Million E-commerce Sellers!","Text_Btn_Qualification_Home":"View Certification","Title_Carousel_Home":"More AI tools","Title_Footer_Home":"Your E-Commerce Design AI Agent","Title_Footer1_Home":"Social Media Account","Subtitle_Footer1_Home":"YouTube","Subtitle_Footer2_Home":"X","Subtitle_Footer3_Home":"Instagram","Subtitle_Footer4_Home":"TikTok","Title_Footer2_Home":"Help & Legal","Subtitle_Footer5_Home":"Terms of Service","Subtitle_Footer6_Home":"Privacy Policy","Copyright_Footer_Home":"Copyright ${0} Meitu, Inc.","Desc_Evaluation1_Home":"Love Designkit! The AI lifestyle images are natural — cozy and Nordic, perfect for my candle shop. My listings look polished and sales have increased. Worth it.","Job_Evaluation5_Home":"TEMU seller in Mexico","Job_Evaluation6_Home":"Amazon operations specialist","Job_Evaluation12_Home":"Store manager of a multi-SKU Amazon shop in Indonesia","Job_Evaluation2_Home":"Amazon & Mercado Libre store owner","Name_Evaluation12_Home":"Arif","Desc_Evaluation11_Home":"The lifestyle scene images look really natural, almost like they were professionally shot. My customers seem to love them too, and I’ve actually seen my conversion rates go up.","Name_Evaluation11_Home":"Siti","Job_Evaluation10_Home":"Cross-border store owner on Lazada & Shopee (Indonesia)","Name_Evaluation10_Home":"Nina","Job_Evaluation3_Home":"DTC E-commerce Designer","Job_Evaluation8_Home":"Walmart Outdoor Products store owner in America","Name_Evaluation8_Home":"Jason","Job_Evaluation9_Home":"Mercado Libre seller in Argentina","Desc_Evaluation7_Home":"The pet product scenes the AI generates are super cute! The cats and dogs look perfectly proportioned and natural. Plus, the size and scale fit platform requirements, so the images are really easy to use right away.","Job_Evaluation7_Home":"Mercado Libre store owner in Brazil","Desc_Evaluation8_Home":"The camping scenes for my tents look really realistic. The lighting and angles feel natural, and the proportions are spot on. It saves me so much time compared to shooting everything myself.","Name_Evaluation7_Home":"Thiago","Desc_Evaluation9_Home":"The tool is really fast, and the images it generates can basically be uploaded straight to Mercado Libre and Amazon without any extra tweaks.","Desc_Evaluation6_Home":"I used to worry that AI would mess up the fabric textures, but they barely look different from the original. Knitwear looks like knitwear, denim like denim, and it even meets Amazon\'s image requirements. Launching new products has become so much faster.","Name_Evaluation9_Home":"Lucas","Name_Evaluation6_Home":"Emma","Desc_Evaluation5_Home":"The AI-generated product images are really accurate. The cable length and connector shapes are spot on, and they even match TEMU’s style. It’s a huge time-saver compared to taking the photos myself.","Desc_Evaluation12_Home":"With just one prompt, I can get usable graphics instantly, which is way faster than waiting for a designer. It’s honestly super convenient.","Name_Evaluation3_Home":"Chloe","Name_Evaluation1_Home":"Sofia","Desc_Evaluation4_Home":"The metallic textures and structural details are really clear, which makes the images look professional. I can use them straight away without any edits.","Name_Evaluation4_Home":"Leon","Desc_Evaluation10_Home":"Batch generation is super convenient. I can process dozens of SKUs at once, and it’s way faster than doing everything manually like before.","Name_Evaluation2_Home":"Mariana","Desc_Evaluation3_Home":"I sell clothing, and I was worried that AI might mess up the colors or fabric textures,but it actually did great! The model poses look natural, and the images are basically ready to use right away.","Job_Evaluation1_Home":"SHEIN store operations specialist","Name_Evaluation5_Home":"Diego","Job_Evaluation11_Home":"Amazon Operations Specialist","Desc_Evaluation2_Home":"The tool is super fast, and the images are basically ready to upload to Mercado Libre or Amazon. It even adapts backgrounds and models to local tastes, and the results look totally professional.","Job_Evaluation4_Home":"eBay seller in Germany","Title_Evaluation_Home":"Their Stories","Title_Introduction_Home":"Premium AI design that drives stronger sales","Desc_Qualification_Home":"Amazon SPN Certified Service Provider","Title_Seo_Home":"AI Product Image & Video Generator for E-commerce","Desc_Seo_Home":"Instantly generate product images, posters, and videos for Amazon, TikTok, and more online shops with Designkit\'s AI Agent. Start designing for free today!<br>","Keywords_Seo_Home":"AI Agent for E-commerce, E-commerce AI tools, AI Product Image Generator, AI Product Video Generator, AI Product Photo Editor, AI Background Remover","Title_Features1_Home":"From a single request to a complete set of visuals","Title_Features2_Home":"Fully automated localization to sell your products globally across multiple platforms","Title_Features3_Home":"Automatically generate images in bulk for multiple SKUs and beat competitors to market!","Title_Designkit_Home":"Designkit","Tips_AboveTheFold2_Home":"Scroll to explore","Tips_Material1_Home":"Listing image set","Tips_Material2_Home":"Virtual try-on","Tips_Material3_Home":"A+ content","Tips_Material4_Home":"Background generator","Free_Button_Home":"Try for free","Title_Header1_Home":"Product","Title_Header2_Home":"solution","Title_Header3_Home":"Inspiration","Title_Header4_Home":"Learn","Title_Header5_Home":"Pricing","SecondTitle_Header1_Home":"AI E-Commerce Agent","SecondTitle_Header2_Home":"AI Image Tools","SecondTitle_Header3_Home":"AI Video Tools","SecondTitle_Header4_Home":"Amazon Design Solution","SecondTitle_Header5_Home":"Social Media E-Commerce Solution","SecondTitle_Header6_Home":"AI Product Image Generator","SecondTitle_Header7_Home":"AI Fashion Model Generator","SecondTitle_Header8_Home":"Clothes Color Changer","SecondTitle_Header9_Home":"Product Video Generator","SecondTitle_Header10_Home":"AI Tools","SecondTitle_Header11_Home":"AI Photo Editor","SecondTitle_Header12_Home":"AI Photo Editor Online","SecondTitle_Header13_Home":"Bulk Photo Editor","SecondTitle_Header14_Home":"Bulk AI Photo Editor","SecondTitle_Header15_Home":"Batch Image Enhancer","SecondTitle_Header16_Home":"Bulk Watermark Remover","SecondTitle_Header17_Home":"Batch Background Generator","SecondTitle_Header18_Home":"Batch Background Remover","Title_Footer3_Home":"Design Tools","Subtitle_Footer8_Home":"AI Photo Editor","Subtitle_Footer7_Home":"AI Background Changer","Subtitle_Footer9_Home":"Transparent Background","Subtitle_Footer10_Home":"Change Background Color","Subtitle_Footer11_Home":"Image Watermark Remover","Subtitle_Footer12_Home":"Remove Text from Image","Subtitle_Footer13_Home":"Add Stickers to Photos","Subtitle_Footer14_Home":"Add Watermark to Photos","Title_Footer4_Home":"Image Models","Subtitle_Footer15_Home":"Nano Banana Pro (Gemini 3.0 Pro)","Title_Footer5_Home":"Download for Free","Subtitle_Footer16_Home":"iOS APP","Subtitle_Footer17_Home":"Android APP","Title_Footer6_Home":"Follow Us","Subtitle_Footer18_Home":"Kling 3.0","Subtitle_Footer19_Home":"Seedance 2.0","Title_Footer7_Home":"Video Models","Button_Export":"Download","Title_Layer":"Layers","InputNumber_Opacity":"Opacity","Buttom_Comfirm":"Confirm","Button_Share":"Share","Button_Delete":"Delete","Title_LoginPopup":"Log in to start trial","SubTitle_LoginPopup":"Start creating with Zawa today","Tip_ModalTitle":"Reminder","TipContent_HistoryDelete":"Once deleted, this record cannot be restored. Confirm deletion?","Title_Logo":"Logo","Title_BrandKit":"Templates","Tab_BrandKit":"Brand Kit","Tab_UploadLocal":"Choose from album","Button_UploadImage":"Upload Images","Button_UploadProductImage":"Upload Product Image","Button_UploadReferImage":"Upload References","Tip_ClickDragParseImage":"Upload, drop or paste images here.","Tip_UploadMax":"Upload JPG, JPEG, or PNG files up to ${0} MB, with a maximum of N images.","Tooltip_SwitchBrandKit":"Switch brand kit","Discribe_BrandKitSelect":"Select a brand style as the reference for this design.","Title_Models":"Models","Switch_Auto":"Auto","Tab_Image":"Image","Tab_Video":"Video","MenuItem_AddToBrandLogo":"Save as brand logo","MenuItem_AddToBrandTemplate":"Save as brand template","Button_ExportImage":"Import images","Button_ExportMedia":"Import videos","Button_ExportFromBrandkit":"Import from Brand Kit","Dropdown_AddFromBrandkit":"Add from Brand Kit","Placeholder_ChatInput":"Let\'s get started!","MenuItem_AiChange":"AI Editing","MenuItem_AiExpend":"AI Extender","MenuItem_AiHD":"AI Clarity","MenuItem_Eliminate":"AI Removal","MenuItem_SplitLayers":"Split Layers","MenuItem_Cutout":"BG Remover","MenuItem_ChangeText":"Edit Text","MenuItem_Crop":"Image Size","MenuItem_AddToChat":"Add to Chat","MenuItem_AddToBrand":"Add to Brand Kit","Tooltip_Layer":"Layers","Tooltip_Grab":"Hand tool","Tooltip_Select":"Select","Tooltip_Redo":"Redo","Tooltip_Undo":"Undo","Tooltip_Add":"Add","Tooltip_ShowAll":"Show all","Tip_UploadType":"Unsupported file format","Tip_UploadSize":"Only files up to ${0} MB are supported","Tip_UploadWH":"Please ensure each image is no larger than ${0}×${1} pixels","Tip_UploadTypeTranslate":"Failed to change file format","Tip_UploadFail":"Upload failed","Tooltip_AddText":"Add text","Text_AddDefault":"This is sample text.","Tooltip_OverflowImageSize":"Please resize your image to within ${0} pixels","Placeholder_ImageFusion":"Let me know how you\'d like the images blended","Button_ImageFusion":"Blend","Button_Cancel":"Cancel","Button_AiChange":"Edit","Placeholder_AiChange":"Let me know what you want to change","Button_Eliminate":"Eraser","Label_OriginSize":"Original","Label_CropRadio":"Aspect ratio","Button_Free":"Free","Button_Origin":"Original","Button_Crop":"Crop","Placeholder_ChangeText":"Enter text. Example: Hello","Button_ChangeText":"Confirm","InputNumber_PanSize":"Brush size","Label_TargetSize":"Target","Tooltip_ImageFusion":"You can blend ${0}-${1} images","Title_Workspace":"Your AI Agent\\nfor Social Content","Button_Pro":"Get Free Pro","Title_NanoPro":"🍌🍌Nano Banana Pro is now available on Zawa.","Dropdown_AdvancedFeatures_Title":"Advanced Features","Dropdown_AdvancedFeatures_Conent":"Full access to all AI-powered tools to enhance your efficiency.","Dropdown_MassiveContent_Title":"Extensive Content","Dropdown_MassiveContent_Content":"Unlimited access to premium templates and a vast array of Plus stock assets.","Dropdown_CommercialRights_Title":"Commercial Rights","Dropdown_CommercialRights_Content":"Use your personal creations with confidence, backed by guaranteed copyright protection.","Popup_SubscribeIntl_Desc":"Get the most from Zawa with Pro","Popup_SubscribeIntl_Desc1":"Unlock more creations with credits","Popup_SubscribeIntl_Detail":"View plan details & Help","Popup_StripeCheckout":"Stripe checkout","Popup_LiveSupport":"Live support","Popup_CancelAnytime":"Cancel anytime","Menu_Language":"Language","Menu_ManageSubscription":"Manage Subscriptions","Menu_TermsPolices":"Terms and Policies","Menu_ManageSubscriptions":"Manage Subscriptions","Menu_ReferralLink":"Referral Link","Menu_BenefitsUpgraded":"Benefits","Menu_TermsPolicies":"Terms and Policies","Menu_AccountManagement":"Account","Title_ReferralCode":"Referral Code","Title_ReferralLink":"Referral Link","Desc_NoActiveSubscription":"No active subscription","Button_ClickToSubscibe":"Click here to subscribe","Title_SubscriptionCancel":"Your subscription has been cancelled","Title_SeeYou":"Sorry to see you go...😭","Desc_NextBillingDate":"Renews on","Desc_EstimatedAmount":"Estimated total","Button_CancelSubscription":"Cancel subscription","Button_StaySubscribed":"Keep subscription","Title_ReasonCancelling":"Please select a reason for cancelling:","Desc_BenefitsContinue":"You can still enjoy your membership benefits until the end of the subscription.","Desc_GiftedCredits":"After your subscription expires, the gifted credits","Desc_SeeYou":"Thanks for being with us. We\'re sorry to see you go.","Desc_NoNoreCharges":"You won\'t be charged again, and your membership remains active until","Desc_MayBeRevoked":"may be revoked.","Desc_CancelingNoRefund":"Cancellation does <span>not include a refund<span>. For refund inquiries, please contact online support.","Button_ClearSelection":"Unselect","Button_Confirm":"Confirm","Message_Processing":"Processing...","Title_Opacity":"Opacity","Button_ExpandImage":"Extender","Button_ExpandRadio":"Aspect ratio","Title_NoDesigns":"No designs yet.","Title_NoGenerations":"No generations yet.","Desc_NoDesigns":"Your designs will show up here.","Desc_NoGenerations":"Your generations will show up here.","Title_DeleteDesign":"Delete this design","Popup_DeleteDesign":"Are you sure you want to delete this design permanently? This action can\'t be undone.","Message_SaveFail":"Failed to save","Title_Pricing":"Choose the Right Plan for You","Title_Tags1_Pricing":"Monthly","Text_Discount_Pricing":"${0} off","Title_Tags2_Pricing":"Yearly","Title_Plan1_Pricing":"Free","Current_Plan_Pricing":"Current plan","Title_Instruction1_Pricing":"Get 20 credits for first login","Title_Instruction2_Pricing":"Generate up to 20 images with AI Agent","Title_Instruction3_Pricing":"Generate up to 10 images with AI Background Generator","Title_Rights1_Pricing":"Limited background or object removal","Title_Rights3_Pricing":"Limited HD image enhancement","Title_Plan2_Pricing":"Basic Plan","Month_Plan_Pricing":"month","Title_Button1_Pricing":"Subscribe","Title_Instruction4_Pricing":"500 credits/mo","Title_Instruction5_Pricing":"Generate up to 500 images with AI Agent","Title_Instruction6_Pricing":"Generate up to 250 images with AI Background Generator","Title_Plan3_Pricing":"Pro Plan","Desc_Plan_Pricing":"7-day free trial. Then ${0}/year.","Title_Button2_Pricing":"7-day free trial","Title_Instruction7_Pricing":"1,500 credits/mo","Title_Instruction8_Pricing":"Generate up to 1,500 images with AI Agent","Title_Instruction9_Pricing":"Generate up to 750 images with AI Background Generator","Title_Rights4_Pricing":"Unlimited background or object removal","Title_Rights5_Pricing":"Unlimited use of AI removal feature","Title_Rights6_Pricing":"Unlimited UHD image enhancement","Title_Rights7_Pricing":"Batch processing tools","Title_Best_Pricing":"Chosen by 90% of users","Title_AllFeatures_Pricing":"Compare Free and Paid Plans","Desc_AllFeatures_Pricing":"Unlock Premium to create stunning designs effortlessly with advanced AI tools","Month_AllFeatures_Pricing":"month","Title_Features1_Pricing":"AI Agent","SubTitle_Features1_Pricing":"Image Editing","SubTitle_Features15_Pricing":"Generate up to ${0} images","SubTitle_Features16_Pricing":"Generate up to ${0} images/mo","SubTitle_Features2_Pricing":"Image Generation","SubTitle_Features3_Pricing":"E-commerce Image Generation","SubTitle_Features4_Pricing":"Poster Generation","Title_Features2_Pricing":"AI Image Tools","SubTitle_Features5_Pricing":"AI Background Remover","SubTitle_Features17_Pricing":"Limited use","SubTitle_Features19_Pricing":"Unlimited use","SubTitle_Features6_Pricing":"AI Object Remover","SubTitle_Features7_Pricing":"Image Enhancer","SubTitle_Features18_Pricing":"Limited use (HD)","SubTitle_Features20_Pricing":"Unlimited use (HD/UHD)","SubTitle_Features8_Pricing":"AI Image Upscaler","SubTitle_Features9_Pricing":"AI Image Extender","SubTitle_Features10_Pricing":"AI Background Generator","Title_Features3_Pricing":"More Design Features","SubTitle_Features11_Pricing":"Advanced Features and Templates","SubTitle_Features12_Pricing":"Remove Watermark","SubTitle_Features13_Pricing":"Bulk AI Image Tools","SubTitle_Features14_Pricing":"Basic Design Features","Title_Credits_Pricing":"Running low on credits? We\'ve got you covered.","Desc_Credits_Pricing":"One-time purchase, no subscription needed.","TransactionPrice_Credits_Pricing":"Price: ${0}","Credit_Credits_Pricing":"Credits","Popular_Credits_Pricing":"Most Popular","Buy_Credits_Pricing":"Purchase Now","Title_FAQ_Pricing":"FAQs","Title_Button4_Pricing":"Upgrade now for a 7-day free trial","SubTitle_FAQ1_Pricing":"What are credits?","Content_FAQ1_Pricing":"Credits allow you to continue accessing AI tools. The number of credits required varies depending on the specific tool.","Content_FAQ2_Pricing":"Purchased credits are valid for one year.","Content_FAQ3_Pricing":"Membership credits are valid during the membership period.","SubTitle_FAQ2_Pricing":"How do I cancel my subscription and what happens to my credits after cancellation?","Content_FAQ4_Pricing":"After canceling your subscription,","Content_FAQ5_Pricing":"your membership credits will remain valid until your membership expires. Any credits you\'ve purchased separately will not be affected.","Content_FAQ6_Pricing":"If you need to cancel your subscription, please follow the steps below at least 24 hours before the next billing cycle begins:","Content_FAQ7_Pricing":"1. Go to Designkit and log in.","Content_FAQ8_Pricing":"2. Enter the subscription pop-up window.","Content_FAQ9_Pricing":"3. Select \\"Manage Subscriptions\\".","Content_FAQ10_Pricing":"4. Select your current plan and click \\"Cancel Subscription\\".","Content_FAQ11_Pricing":"Your subscription will remain active until the end of the current billing cycle. If you are unable to cancel, please take a screenshot and contact our online support as soon as possible.","SubTitle_FAQ3_Pricing":"What is your refund policy?","Content_FAQ12_Pricing":"1. 7-Day Money-Back Guarantee:","SubTitle_FAQ4_Pricing":"How can I upgrade or downgrade my subscription?","Content_FAQ25_Pricing":"1. Upgrade: You can simply subscribe to a higher-tier plan, and it will take effect immediately. Your old subscription will be cancelled, and any remaining balance will be refunded.","SubTitle_FAQ5_Pricing":"Can I get a copy of my invoice?","Content_FAQ27_Pricing":"Yes! After a successful payment, you will receive an email from the payment provider containing an electronic invoice. If you do not receive an invoice, please contact our support team.","SubTitle_FAQ6_Pricing":"What payment methods do you support?","Content_FAQ28_Pricing":"We use Stripe to manage payments and subscriptions. We accept all major credit cards, PayPal, and Google Pay.","SubTitle_FAQ7_Pricing":"How can I contact support?","Content_FAQ29_Pricing":"Email: support@designkit.com. Response time: 3-10 business days.","Content_FAQ13_Pricing":"If you purchased subscriptions and have not used them within 7 days, you may be eligible for a full refund.","Content_FAQ14_Pricing":"If you purchased credits, you may be eligible for a refund for any unused credits within 7 days.","Content_FAQ15_Pricing":"2. Dissatisfaction with Service","Content_FAQ16_Pricing":"If you\'re unsatisfied with the results, please contact our online support team. We may provide compensation or a refund depending on the circumstances.","Content_FAQ17_Pricing":"3. Purchases via Google Play or App Store","Content_FAQ18_Pricing":"If you subscribed through Google Play Store or the App Store, you need to request a refund directly from Google or Apple.","Content_FAQ19_Pricing":"Important Notes:","Content_FAQ20_Pricing":"This refund policy does not apply to API users. If you use our API, please contact us for refund eligibility.","Content_FAQ21_Pricing":"We reserve the right to deny refunds in cases of misuse, abuse, or violations of our terms.","Content_FAQ22_Pricing":"Refunds may take several business days to process, depending on your payment method.","Content_FAQ23_Pricing":"We may update this refund policy from time to time. Please check it periodically for any changes.","Content_FAQ24_Pricing":"For further assistance, please contact our support team.","Content_FAQ26_Pricing":"2. Downgrade: First, cancel your current subscription. Once your current billing period ends, subscribe to a new plan.","Content_Modal_Pricing":"Thank you for your support! Get ready to take your creativity to the next level.","Tip_Modal_Pricing":"Tips: If your membership isn\'t showing up yet, please refresh the page.","Title_Modal_Pricing":"Successfully purchased","Title_Rights2_Pricing":"Limited use of AI Removal feature","Title_Button3_Pricing":"Available benefits","Title_Button5_Pricing":"Upgrade","Tool_ImageBgRemover":"Background Remover","Tool_AiBgGenerator":"AI Background Generator","Tool_AiLogoGenerator":"Logo Generator","Tool_FootwearModel":"Footwear Model","Tool_ImageTranslation":"Image Translation","Tool_BatchImageBgRemover":"Batch Image Background Remover","Tool_BatchImageEnhancer":"Batch Image Enhancer","Tool_BatchAiObjectsRemover":"Batch Object Remover","Tool_VideoEnhancer":"AI Video Enhancer","Tool_VideoBgRemover":"Video Background Remover","Tool_VideoWatermarkRemover":"Video Watermark Remover","Title_Models_Dropdown":"Models","Tips_Uninitialized_Chat":"Failed to send messages","Dropdown_AddImage":"Add image","Action_SeeAll":"See all","Desc_Seedream":"Realistic and detailed image creation.","Dropdown_AddVideo":"Add video","Tips_NotFound_Chat":"Chat does not exist","Desc_Seedance":"Realistic and expressive video creation.","Dropdown_SupportedFormatFile":"Supports Word, Excel, Text and PDF files.","Dropdown_Example_Option":"Example","Dropdown_NoReference_Option":"No reference available","Menu_AgentCredits":"Agent Credits","Desc_SeedEdit":"Precise and natural image editing.","Dropdown_BrandKit_Title":"Brand Kit","Desc_GeminiNanoBanana":"Fast, editable, and consistent image generation.","Dropdown_Models_Title":"Models","Dropdown_AddDocument":"Add document","Dropdown_BrandKit_Desc":"Select a brand style as the reference for this design.","Desc_MidjourneyVideo":"Creative and artistic video generation.","Desc_MidjourneyImage":"Artistic and imaginative image generation.","Dropdown_SaveAsBrandTemplate":"Save as brand template","Dropdown_SaveAsBrandLogo":"Save as brand logo","BatchProcessTable_ImageType":"Image type","BatchProcessTable_PictureRequirement":"Design details","BatchProcessTable_CopywritingRequirements":"Product description","BatchProcessTable_Proportion":"Aspect ratio","BatchProcessTable_Actions":"Action","BatchProcessTable_AddOneRow":"Add","BatchProcessList_DeleteError":"Deletion failed","BatchProcessList_SurePrompt":"Delete this guideline?","BatchProcessList_SurePrompt_SureText":"Confirm","BatchProcessList_SurePrompt_CancelText":"Cancel","BatchProcessList_EmptyText":"Empty","EditBatchProcess_NameLimitTip":"Enter a name (up to 10 characters)","EditBatchProcess_Tip":"Any changes to the guidelines will affect the generated results.","EditBatchProcess_Start":"Start with a guideline","EditBatchProcess_GenerateTip":"Upload your product images, and designs will be generated based on the guidelines.","Text_AdvanceSetting":"Expert","Text_MainImage":"Main image","Text_ProductAgentUploadGuide1":"1. Upload multiple images of the same product from different angles to help AI better capture product details.","Text_ProductAgentUploadGuide2":"2. Up to 10 images. The first image will be used as the primary reference, so please choose the most best angle.","Text_Optional":"(Optional)","Tip_ClickDragImageWithSize":"Upload or drop JPEG, JPG, or PNG images up to ${0} MB.","Button_AddReferenceImage":"Upload","Title_ReferenceImage":"Reference","Input_Placeholder":"Please select","Radio_ReferenceColor":"Reference color","Radio_ReferenceLayout":"Reference layout","Tag_FirstImage":"First image","Tag_FirstImageNoPartial":"Partial first image","Tag_Blur":"Blurry","Tag_Jigsaw":"Collage","Button_Understood":"Got it","Text_ReferenceImageIndex":"Image ${0} is for reference","Text_ReferenceDimensions":"Use ${0} from reference","Tag_Cropped":"Cropped","Tag_Underexposed":"Underexposed","Tag_Blurry":"Blurry","SelectOption_ColorPalette":"Color Palette","SelectOption_Layout":"Layout","SelectOption_Fonts":"Fonts","SelectOption_Style":"Style","SelectOption_ShapeElements":"Shape Elements","Text_SocialMediaAgentUploadGuide":"Upload your featured product first. Ensure the picture is clear and complete.","Video_SR_Success":"Video clarity enhanced","Video_Desubtitle_Success":"Subtitle removed","Video_Dewatermark_Success":"Watermark removed","Video_Process_Failed":"Processing failed. The credits will be refunded to your account.","Video_SR":"AI Clarity","Video_Dewatermark":"Remove Watermark","Video_Desubtitle":"Remove Subtitle","Video_Task_Price_Estimate":"${0} credits required","Video_SR_Start":"Enhancing clarity... ${0} credits will be used.","Video_Dewatermark_Start":"Removing watermarks... ${0} credits will be used.","Video_Desubtitle_Start":"Removing subtitles... ${0} credits will be used.","Video_Desubtitle_Start_VIP":"Removing subtitles...","Video_Dewatermark_Start_VIP":"Removing watermarks...","Video_SR_Start_VIP":"Enhancing clarity...","Text_Help_Center":"Help Center","Title_Request":"Chat","Button_Continue":"Continue","Button_EditContent":"Edit message","Title_ChooseImageType":"Select generated image type (Multiple options)","Button_BatchGenerate":"Confirmed. Run the template now.","Text_ChatCancelStatus":"Task terminated","Text_ChatRespondedStatus":"Task processing","BatchProcess_SaveSuccessTip":"Your workflow kits are saved here.","Button_GotIt":"Got it","Title_Congrats":"Congrats","SubTitle_BrandCreate":"You\'ve built your first brand kit—time to explore its potential!","Button_CheckUse":"Check it out now","Chat_Prompt_Brand":"Create a promo poster","Tooltip_UseBrand":"You can switch or add your brand kit here!","Tooltip_PosterBrand":"Tap to create your first poster based on your brand kit","Popup_CreateBrand":"Create a brand from scratch","Desc_CreateBrand":"Create stunning, original logos with our AI Agent.","Popup_UploadBrand":"Upload your brand information","Desc_UploadBrand":"Upload it and Zawa will keep every design aligned.","Title_BrandEntry":"Get a tailored brand system now","Desc_BrandEntry":"Let our Al be your stylist. Answer a few questions and receive a complete brand system tailored to your vision.","Tooltip_UseBrand_Agent":"Once the brand kit is applied, the design will automatically reference the logo, color palette, and overall style.","Tooltip_PosterBrand_Agent":"You\'re all set to design with your brand kit","BatchProcess_createText":"Workflow Kit","Label_NormalMode":"Basic:","Label_AdvancedMode":"Advanced:","Text_NormalMode":"Basic","Text_AdvancedMode":"Advanced","BatchProcess_DefaultPrompt":"Generate Images","Title_CreateBrand":"Don\'t have a brand?","Title_UploadBrand":"Already have a logo?","Button_CreateBrand":"Create a brand","BatchProcess_EditContent":"Edit content","BatchProcess_PleaseSelect":"Select a workflow kit","BatchProcess_SelectTip":"All uploaded images will be generated in batch using the selected workflow kit.","BatchProcess_ListEmptyTip":"Save workflow kit after generating to instantly create similar sets in batches.","BatchProcess_Tip":"Workflow Kit","BatchProcess_Generate":"Use it now","BatchProcess_Save":"Save","BatchProcess_GeneratingFormula":"Generating workflow kit...","BatchProcess_GenerateCancel":"Cancel","BatchProcess_WorkFlowCreateError":"Creation Failed","ProductInfo_PleaseUploadImage":"Upload product images","BatchProcess_IntelligenceGenerate":"Create workflow kit","BatchProcess_CreateWorkflow":"Create","BatchProcess_Formula":"Workflow Kit","BatchProcess_WorkFlowSaveSuccess":"Workflow kit saved","ProductInfo_ImageSizeLimit":"Images within ${0} MB are supported","ProductInfo_ImageUpload":"Add product image","ProductInfo_UploadDemo":"Example photos","ProductInfo_ECPlatform":"Platform","ProductInfo_PleaseSelect":"Please select","ProductInfo_InputCustomize":"Custom","ProductInfo_CountryAndLanguage":"Target region/language","ProductInfo_Name":"Product name","ProductInfo_Desc":"Product details (Features/Size/Usage scenarios)","ProductInfo_DescPlaceholder":"Enter product information including features, size, usage scenarios, target audience, etc.","ProductInfo_NamePrompt":"The product name is ${0};","ProductInfo_ECPlatformPrompt":"The target platform is ${0};","ProductInfo_CountryAndLanguagePrompt":"The language is ${0};","ProductInfo_DescPrompt":"The product details are ${0}.","ProductInfo_PleaseInput":"Please enter","Button_UnlockPro":"Unlock Pro","Button_UpgradeToPro":"Upgrade to Pro","Button_RenewNow":"Renew Now","AgentEmpty_CaseUseBtn":"Use","AgentEmpty_CaseRefreshBtn":"Refresh","MenuItem_Effect":"Effects","MenuItem_Shadow":"Shadows","MenuItem_Stroke":"Stroke","Title_ChangeText":"Replace Text","Button_Logout":"Log out","Message_ExtractText":"Extracting text","Message_ExtractTextError":"Failed to extract the text. Please try again.","Tip_CreditConsume":"This generation uses ${0} credits","Tip_EstimatedTime":"Ready in about ${0} minutes","BatchProcess_SaveSuccessTip_GotIt":"Got it","BatchProcess_SaveSuccessTip_Title":"Using Workflow Kits","BatchProcess_SaveSuccessTip_Desc":"Your workflow kits are saved here. Choose one to quickly generate images using the saved templates.","BatchProcess_tutorial":"Tutorial","Text_HandTool":"Hand tool","Text_Function":"Function","Text_WindowsSystem":"Windows system","Text_MacSystem":"Mac system","Menu_KeyboardShortcuts":"Shortcuts","Title_KeyboardShortcuts":"Shortcuts","Text_Undo":"Undo","Text_MouseLeft":"Left mouse button","Text_Redo":"Redo","Text_Delete":"Delete","Text_Cut":"Cut","Text_Copy":"Copy","Text_Paste":"Paste","Text_PasteFixed":"Paste in place","Text_CreateCopy":"Create a copy","Text_SelectAll":"Select all","Text_SelectMultiple":"Multi-select","Text_Group":"Group","Text_Ungroup":"Ungroup","Text_LockLayer":"Lock","Text_Save":"Save","Text_Move":"Move","Text_MoveWithCombinedKeys":"Quick move","Text_TouchEditFastMode":"Quick Point to Edit","Text_Pan":"Pan","Title_Canvas":"Canvas","Title_Edit":"Edit","Title_Elements":"Elements","Title_Tools":"Tools","Title_Blogs":"Blog","Text_NewText":"New text","Text_NewLine":"New line","Text_NewRectangle":"New rectangle","Text_NewCircle":"New circle","Text_ExitFullScreen":"Exit full screen","Text_MoveUpOneLayer":"Bring forward","Text_MoveDownOneLayer":"Send backward","Text_Top":"Bring to front","Text_Bottom":"Send to back","Text_CanvasZoom":"Zoom in/Zoom out","Text_ToggleReferenceLine":"Show/hide guides","Text_ToggleRulerBar":"Show/hide rulers","Text_ArrowKey":"Arrow keys","Text_CanvasShowAll":"Show all canvas","Title_Unsupported_Multilayer":"This feature works with a single layer only.","Btn_CreateBatchProcessFormula":"Create","Button_Hide_Otherlayers":"Keep first layer and continue","Button_Merge_Alllayers":"Merge all layers and continue","Checkbox_Disable_Remind":"Don\'t show again","Button_Tool":"Tools","Button_Custom_Ratio":"Custom","Label_Spacing":"Spacing","Button_Download_Whole":"Export as Image","Button_Download_Layer":"Export by Layer","Button_Origin_Ratio":"Original","Text_TouchEdit_Title":"Point to Edit","Text_TouchEdit_Description":"Point to an object and describe your changes. The image will be edited exactly as you specify.","Tooltip_TouchEdit_Max_Count":"You can point out up to ${0} areas","Tooltip_TouchEdit_Usage":"Point to Edit shortcut: ${0} + click","Text_TouchEdit_Recognition_Custom":"Custom","Text_TouchEdit_Recognition_Title1":"Detect and recognize","Text_TouchEdit_Recognition_Title2":"No target found. Enter the object\'s name.","Text_TouchEdit_Name":"Point to Edit","Btn_LoginToViewBatchProcess":"Log in to view the workflow kit","Btn_Login":"Log in","Menu_Main_Beautify":"Refine","Text_Model_Pricing":"Model Pricing","Text_Pro_discount":"Pro Plan: Half-Price Video Generation","Text_TemplatePrompt":"Let’s start with inspirations","Text_Hi":"Hi, ${0}!","Text_Account_Popup_Left":"Meet your dedicated AI design assistant for e-commerce. Crafted for professionals who seek faster launches, stronger presentation, and higher profitability.","Text_PleaseWaitImageUploaded":"Please proceed after the upload is complete","Menu_Redeem_Rights":"Redeem","Text_Redeem_Now":"Redeem Now","Text_Redeem_Placeholder":"Enter the redemption code, case sensitive","Text_Redeem_Success":"Redeemed successfully!","Text_Redeem_Use":"Redeem your code","Tooltip_BrandAutoUse":"Your new brand kit is applied!","Redeem_Redeem_Note":"Note: \\nPlease log in and enter the redemption code.\\nOnce the redemption is successful, you can enjoy the corresponding benefits and services.\\nPlease use the redemption code within its validity period. Expired codes will be invalidated and are non-refundable.\\nPlease protect your code. We are not responsible for lost, leaked, or incorrectly used codes. \\nThis code may not be resold or transferred, cannot be exchanged for cash, and is not eligible for invoicing.","Tooltip_Color_Fill":"Color","Tootip_StartPoint":"Start","Tootip_ChangePoint":"Switch","Tootip_EndPoint":"End","Sidebar_NewDesign":"New chat","Retouch_Filter_Clear":"Clear","Retouch_Filter_Enhance":"Vivid","Retouch_Filter_Dehaze":"Dehaze","Retouch_Filter_Texture":"Texture","Retouch_Filter_Nature":"Natural","Retouch_Filter_Fade":"Fade","Modal_Button_Known":"OK","Modal_Button_GotIt":"Accept","Modal_Button_Later":"Later","Text_Appeal_Confirm":"Yes","Text_Vip_Open":"Subscribe","Text_Appeal_ReGenerate":"Edited results are not eligible for review.","Text_Appeal_Left":"Attempts left this month\\n<i>${0}</i>/${1}","Text_Appeal_Refunded":"The credits have been refunded to your account.","MenuItem_Appeal":"Result Review","Tooltip_Downloading":"Downloading…","Tooltip_Download_Video":"Download videos separately, one at a time.","Tooltip_Download_NoneSelected":"Please select the content you want to download","Text_AI_Thinking":"AI is working on it...","Text_Server_Busy":"The server is busy. Please try again later.","Text_Prompt_Help_Placeholder":"Type your keywords, and I\'ll turn them into a ready-to-use prompt.","Text_Prompt_Helping":"Processing... Please wait.","Button_Retry":"Retry","Button_Rewrite":"Try again","Button_Start_Prompt_Help":"Start writing","Title_Prompt_Helper":"AI Writing","Menu_Text_Subscriptions":"Subscriptions","Menu_View_Subscriptions":"View Subscriptions","Text_Download_XdesignApp":"Please download the <span>Zawa</span> app to use features","Text_Free_Trial":"Download for a 7-day Free Trial","Text_Install_App":"Install App","Text_Scan_Download":"Scan to download","Text_Download_the":"Download on the","Text_Available_On":"Available on","Desc_ExpireDate":"Expires on","DownloadApp_Title_Widgets":"Please download the ${0} app to use features","DownloadApp_SubTitle_Widgets":"Download for a ${0}-day Free Trial","InstallApp_Title_Widgets":"Install App","InstallApp_Desc_Widgets":"Scan to download","AppStore_Desc_Widgets":"Download on the App Store","GooglePlay_Desc_Widgets":"Get it on Google Play","Text_Tips_GetFree":"You\'ve got one free use","Text_AgentLib":"Assets","Tip_ModelSetSaveSuccess":"Your model image is saved! Tap to use it.","Text_BatchProcess":"Workflow Kit","Button_Add":"Add","Tab_Recent":"Recently saved","Tab_Models":"My Models","Prompt_Model":"Image ${0} is my model","Tip_SaveSuccess":"Saved","Text_ModelsLogin":"Log in to view your models","Loading_CheckFace":"Detecting face...","Name_InitialModelName":"Model Library","EmptyTip_ModelList":"No model yet. Let’s create one!","Text_UploadModel":"Upload model","Text_Model":"Model","Tips_UnsupportedFormat":"Unsupported file format","Tips_InputModelName":"Enter a name","Tips_UploadModelImage":"Upload model images","Title_CreateModel":"Create your model","Text_ModelName":"Name","Placeholder_Input":"Please enter","Text_UploadModelHint":"Tap to upload or drag images here\\nJPEG/JPG/PNG/HEIC/SVG","Button_SubmitUpload":"Upload","Tips_NameLengthLimit":"Enter a name (up to ${0} characters)","Tips_DeleteFailed":"Deletion failed","Title_ConfirmDeleteModel":"Delete this model?","Tips_CreateSuccess":"Model created","Tab_BatchTemplate":"Workflow Kit","Tab_MyModel":"My Models","Placeholder_InputContent":"Enter content","Title_ChooseSceneType_VideoGenerateCard":"Select a content type and storyboard structure:","Button_ConfirmGenerate_VideoGenerateCard":"Start video generation","Title_ShotType_VideoGenerateModal":"Storyboard type","Title_ShotRequirement_VideoGenerateModal":"Storyboard description","Title_Duration_VideoGenerateModal":"Duration","Btn_AddOneTableRow":"Add","Label_Gender_ModelModal":"Gender","Label_Appearance_ModelModal":"Appearance","Label_AgeGroup_ModelModal":"Age group","Label_Persona_ModelModal":"Role","Label_BodyType_ModelModal":"Body type","Tips_GenerateModelFailed_ModelModal":"Generation failed. Please try again later.","Tips_NetworkError_ModelModal":"Network error. Try again later.","Tab_CustomModel_ModelModal":"Custom","Tab_OfficialModel_ModelModal":"Official","Tab_UploadModel_ModelModal":"Upload","Text_ModelPreview_ModelModal":"Preview","Button_Generating_ModelModal":"Generating...","Button_Regenerate_ModelModal":"Retry","Button_Generate_ModelModal":"Generate","Button_Saving_ModelModal":"Saving…","Button_SaveAndUse_ModelModal":"Save and use","Button_CreateNewModel_AgentLibList":"New model","Message_NotFilled_RequiredField":"${0} information is required","Title_ChooseSceneType2_VideoGenerateCard":"Select a storyboard structure","Title_ContentType_VideoGenerateCard":"Content type","Title_StoryboardStructure_VideoGenerateCard":"Storyboard structure","Text_Offical":"Official","Title_AboveTheFold_Main_HomeV2":"Make every product <br /> image <span>ready to sell</span>","Title_Designkit_Slogan":"Make every product image ready to sell","Button_StartFree_HomeV2":"Start Free","Title_AboveTheFoldMobile_Main_HomeV2":"Make every product <br /><span>ready to sell</span>","SubTitle_AboveTheFoldMobile_HomeV2":"From pro photo editing to automated listing generation, everything you need in one place.","Text_TopBanner_HomeV2":"Seedance 2.0 is coming soon with unlimited access","Title_ModuleCard_HomeV2":"First, Generate Winning Assets","SubTitle_ModuleCard_HomeV2":"No more empty canvases. Use our Intelligent Creative Suite of AI Agents to generate complete <br /> listing stacks, dynamic videos, virtual try-ons, and global adaptations in seconds.","Title_Faq_Q1_HomeV2":"Do you offer a free trial?","Text_Faq_A1_HomeV2":"Yes! New users receive 20 free credits instantly upon sign-up. Plus, you can claim 10 free credits every day just by logging in. This allows you to continually test all core features, including image and video generation, before upgrading to a paid plan.","Title_Faq_Q2_HomeV2":"Are the images compliant with Amazon/Shopify guidelines?","Text_Faq_A2_HOMEV2":"Absolutely. For main hero shots, our AI strictly outputs the pure white backgrounds (RGB 255,255,255) required by Amazon and Shopify. For lifestyle and social media images, it ensures perfect dimensions and high-resolution quality to keep your listings fully compliant and professional.","Title_Faq_Q3_HomeV2":"Can I use generated assets for commercial purposes?","Text_Faq_A3_HomeV2":"Yes. All images and videos generated on our paid plans are 100% royalty-free and fully cleared for commercial use. You own the rights to use these assets across your Shopify store, Amazon listings, social media ads, and any other marketing channels without restrictions.","Title_Faq_Q4_HomeV2":"How does batch generation and editing work?","Text_Faq_A4_HomeV2":"Batch processing is natively built into every feature of Designkit. Simply upload multiple images directly into the workspace. Whether you are generating new lifestyle backgrounds, removing original backgrounds, erasing unwanted objects, or upscaling resolution, you can apply your chosen action to the entire batch with a single click. This ensures perfectly consistent assets for your store while saving you hours of manual work.","Title_Faq_Q5_HomeV2":"What file formats do you support?","Text_Faq_A5_HomeV2":"Video outputs are available in MP4 format, optimized for social media and e-commerce websites.","Title_Questions_Main_HomeV2":"Frequently Asked Questions","Title_Scale_Main_HomeV2":"Ready to Scale?","SubTitle_Scale_HomeV2":"Join 10,000+ sellers automating their design workflow with Designkit.","Title_Evaluation_HomeV2":"Finally, Launch Faster & Sell More","SubTitle_Evaluation_HomeV2":"Cut production time by 90%. Get verified listings live on Amazon and Shopify before your competitors do.","Tab_Module_ProductImage_HomeV2":"AI Product Image","Desc_Module_ProductImage_HomeV2":"Turn one supplier photo into a complete listing stack instantly. Generate white-bg hero shots, lifestyle scenes, and infographics, while effortlessly batch-processing hundreds of SKUs and auto-translating text for global markets.","Tip_Module_ProductImage_HomeV2":"Generate an Amazon listing set for the pink headphone.","Tab_Module_ModelImage_HomeV2":"AI Fashion Model","Desc_Module_ModelImage_HomeV2":"No models? No problem. Visualize apparel on diverse AI models to boost click-through rates without booking expensive photoshoots.","Tip_Module_ModelImage_HomeV2":"Show this yellow-and-green suit on a 25-year-old female model.","Tab_Module_Video_HomeV2":"AI Product Video","Desc_Module_Video_HomeV2":"Bring your products to life. Generate dynamic product showcases, engaging AI spokesperson videos, and high-converting ads from just a text prompt or a single image. Capture attention and drive sales across e-commerce platforms and your social media.","Tip_Module_Video_HomeV2":"Generate a product video for this blue vase.","Tab_Module_DetailPage_HomeV2":"AI Product Detail Page","Desc_Module_DetailPage_HomeV2":"Create premium A+ content and seamless promotional banners for your online store in just minutes, no design skills required. Transform basic product photos into highly engaging layouts, and differentiate your listings from competitors effortlessly.","Tip_Module_DetailPage_HomeV2":"Generate a product detail page for the orange sofa.","Tab_Module_Photography_HomeV2":"AI Product Photography","Desc_Module_Photography_HomeV2":"Ditch generic stock photos. Place your products in unique, on-brand settings that resonate with US and EU markets.","Tip_Module_Photography_HomeV2":"Generate a photography background for this perfume.","Title_Module_SecondTitle_HomeV2":"Then, Perfect Details with AI Precision","SubTitle_Module_SecondSubTitle_HomeV2":"Assets generated? Now make them perfect. Use our AI Photo Editor to remove backgrounds, clean up defects, and upscale low-res images in bulk.","Text_Upload_HomeV2":"Upload","Text_TopBannerMobile_HomeV2":"Seedance 2.0 is coming soon","Text_Prompt1_HomeV2":"Generate a full Amazon listing image set.","Text_Prompt2_HomeV2":"Generate a model wearing this outfit.","Text_Prompt3_HomeV2":"Generate a product marketing video.","Text_Prompt4_HomeV2":"Generate an A+ Content product details page.","Text_Prompt5_HomeV2":"Generate appropriate backgrounds for product images.","Desc_Evaluation1_HomeV2":"Super fast! Images are instantly ready for Mercado Libre and Amazon. It adapts backgrounds and models to local tastes perfectly. Totally professional results.","Desc_Evaluation2_HomeV2":"Love Designkit! The AI lifestyle images are natural, cozy, and Nordic—perfect for my candle shop. My listings look polished and sales have increased. Worth it.","Desc_Evaluation3_HomeV2":"I sell clothing and was worried AI would ruin the textures. Designkit nailed it! Colors are perfect, model poses look natural, and images are instantly ready.","Header_products_socialMediaPostGenerator":"Social Media Post Generator","Pricing_Seedance_UnlockLimited":"Unlock Unlimited Access","Pricing_Seedance_SeedanceV1":"<span>Seedance 2.0</span> Early Access","Pricing_Seedance_SeedanceDesc":"Be the first to experience the power of Seedance 2.0. Subscribe to any Pro plan now and get exclusive unlimited access to our next-generation AI model.","Pricing_Seedance_Monthly":"Monthly Plan Bonus","Pricing_Seedance_DaysUnLimit":"7 Days <span>Unlimited</span>","Pricing_Seedance_SeedanceV2":"Seedance 2.0 Access","Pricing_Seedance_BestValue":"BEST VALUE","Pricing_Seedance_Yearly":"Yearly Plan Bonus","Pricing_Seedance_MonthUnLimit":"1 Month <span>Unlimited</span>","Title_AIBrand_Tools":"AI Branding Tools","Title_AISocialMediaPosts":"Social Media Posts","Title_AILogoMaker":"AI Logo Generator","Option_Child_Age":"Child","Option_Infant_Age":"Baby","Option_MiddleAged_Age":"Adult","Option_Senior_Age":"Elderly","Option_Teen_Age":"Teenager","Option_YoungAdult_Age":"Young adult","Button_GenerateImages_DetailPageAction":"Generate","Text_GenerateImagesCount_DetailPageAction":"(${0} images)","Text_GenerateImagesCount_DetailPageAction1":"(${0} image)","Option_MercadoLivre_Platform":"Mercado Livre","Option_Etsy_Platform":"Etsy","Option_Walmart_Platform":"Walmart","Option_eBay_Platform":"eBay","Option_Poshmark_Platform":"Poshmark","Button_GeneratePlan_DetailPageAction":"Create Product Page Design","Option_AdvancedMobile_DetailPageMode":"Premium A+ (Mobile)","Option_AdvancedWeb_DetailPageMode":"Premium A+ (Web)","Option_Standard_DetailPageMode":"Standard A+","Option_Accessories_DetailSection":"Accessories/Gifts","Option_ServiceSupport_DetailSection":"Warranty","Option_BeforeAfter_DetailSection":"Before & After","Option_BrandStory_DetailSection":"Brand Story","Option_KeyHighlights_DetailSection":"Product Highlights","Option_CraftProcess_DetailSection":"Exploded View","Option_HeroVisual_DetailSection":"Key Art","Option_Composition_DetailSection":"Components","Option_MultiAngle_DetailSection":"Multi-Angle","Option_DetailCloseups_DetailSection":"Product Details","Option_SceneMood_DetailSection":"Lifestyle/Mood","Option_SeriesShowcase_DetailSection":"Product Series","Option_SizeCapacity_DetailSection":"Dimensions","Option_Specifications_DetailSection":"Spec Sheet","Option_UsageScenario_DetailSection":"Use Cases","Option_UsageTips_DetailSection":"Usage Guidelines","Paragraph_ServicePolicy_DetailSection":"Warranty, returns and exchange policy","Paragraph_BeforeAfter_DetailSection":"Results before and after use","Paragraph_BrandConcept_DetailSection":"Brand concepts and values","Paragraph_CoreValue_DetailSection":"Core value showcase","Paragraph_CraftProcess_DetailSection":"From drawing to reality","Paragraph_Differentiators_DetailSection":"Key advantage highlights","Paragraph_Composition_DetailSection":"Materials and components that go into the product","Paragraph_MaterialAndCraft_DetailSection":"Material and process highlights","Paragraph_MultiAngleAppearance_DetailSection":"Product looks from different angles","Paragraph_MultiOptionDisplay_DetailSection":"Multiple colors or SKUs","Paragraph_IncludedItems_DetailSection":"Everything included in the package","Paragraph_DetailData_DetailSection":"Detailed specifications","Paragraph_RealUsageScene_DetailSection":"Real-life use references","Paragraph_Specifications_DetailSection":"Size guide at a glance","Paragraph_UsageNotes_DetailSection":"Usage notes and precautions","Paragraph_UsageScenario_DetailSection":"Product in context","Title_Nav_DetailPage":"A+ Content","Title_ImageSet_DetailPage":"A+ Product Detail Image Set","Input_TaskName_Batch":"Enter task name","Paragraph_FullAssetSetDescription_Batch":"Includes a full set of marketing assets such as key art, use case images, and white-background images that can be used across multiple platforms.","Paragraph_LongFormVisualDescription_Batch":"Creates visual storytelling for long-form product images, A+ product detail pages, and comparison images.","Message_JsonGenerated_Batch":"Form verified. JSON generated.","Message_JsonCopied_Batch":"JSON copied.","Message_IncompleteRequiredFields_Batch":"Missing required fields. Please complete the form to submit.","Message_PleaseUploadSourceImage_Batch":"Please upload product images.","Message_PleaseCompleteStrategySettings_Batch":"Please complete strategy configuration","Message_TaskValidationFailed_Batch":"Please review and complete unverified tasks.","Message_CopyJsonFailed_Batch":"Copy failed. Please check JSON in the dashboard.","Message_PleaseEnterTitle_Batch":"Please enter title.","Message_PleaseEnterKeyHighlights_Batch":"Please enter product highlights","Message_PleaseGenerateJsonFirst_Batch":"Please submit to generate JSON.","Title_DetailPage_Batch":"Product Page A+","Title_DetailTask_Batch":"A+ Task ${0}","Title_IndependentParameters_Batch":"Configure individually","Title_ImageSet_Batch":"Ecommerce Image Set","Title_ItemTask_Batch":"Product Task","Option_Curvy_BodyType":"Curvy","Option_Muscular_BodyType":"Muscular","Option_PlusSize_BodyType":"Full-figured","Option_Slim_BodyType":"Slim","Option_Standard_BodyType":"Average","Button_Reset_Common":"Reset","Button_Back_Common":"Back","Button_Collapse_Common":"Collapse","Button_Expand_Common":"Expand","Button_Generate_Common":"Generate","Button_PreviousStep_Common":"Undo","Button_RemoveFavorite_Common":"Unfavorite","Button_StartNow_Common":"Try now","Paragraph_ExitWarning_Common":"Data will be lost if you exit.","Paragraph_Content1_VirtualModelDisclaimer":"2. Please understand what to expect from AI-generated content. AI-generated content is produced based on algorithms and data learning, and results may vary. The facial appearance generated by AI may differ from the original assets provided, and imperfections and unsatisfactory results may occur. Our platform does not guarantee the accuracy, visual quality, or suitability of the generated content.","Paragraph_Content2_VirtualModelDisclaimer":"3. Please acknowledge user responsibilities. You are responsible for the images containing faces and the content generated. You must ensure that your use does not infringe upon any third party\'s legal rights, including but not limited to rights of publicity, privacy, and reputation, and that it complies with all applicable laws and regulations. You shall not use the generated content for any purpose that is unlawful, infringing (such as defamation or fraud), or in violation of public order and morals or the dignity of others.","Paragraph_Content3_VirtualModelDisclaimer":"Please confirm that you fully understand and accept the terms above before uploading.","Title_Notice_VirtualModelDisclaimer":"Before using the AI Product Image-Virtual Try-On feature, please read and understand the following:","Message_FailedRetry_Download":"Download failed. Please try again later.","Message_Failed_Download":"Download failed.","Message_Success_Download":"Download complete.","Message_NoImagesAvailable_Download":"No image available.","Option_Asian_Ethnicity":"Asian","Option_Black_Ethnicity":"African","Option_Chinese_Ethnicity":"Chinese","Option_Latino_Ethnicity":"Hispanic or Latino","Option_MiddleEastern_Ethnicity":"Middle Eastern","Option_SoutheastAsian_Ethnicity":"Southeast Asian","Option_White_Ethnicity":"White","Option_Female_Gender":"Female","Option_Male_Gender":"Male","FormLabel_Ethnicity_Common":"Race and Ethnicity","FormLabel_OriginalImage_Common":"Original","FormLabel_OutputLanguage_Common":"Language","FormLabel_TargetMarket_Common":"Market","FormLabel_TargetPlatform_Common":"Platform","Option_German_Language":"German","Option_Japanese_Language":"Japanese","Option_None_Language":"No text","Option_Portuguese_Language":"Portuguese","Option_PortugueseBr_Language":"Portuguese (Brazil)","Option_Russian_Language":"Russian","Option_Spanish_Language":"Spanish","Option_SpanishMX_Language":"Spanish (Mexico)","Option_Thai_Language":"Thai","Option_Brazil_Market":"Brazil","Option_China_Market":"China","Option_Europe_Market":"Europe","Option_Germany_Market":"Germany","Option_Japan_Market":"Japan","Option_Russia_Market":"Russia","Option_SoutheastAsia_Market":"Southeast Asia","Option_Spain_Market":"Spain","Option_UnitedStates_Market":"USA","Message_MaxLimit_DetailSectionSelection":"Select up to ${0} sections","Option_FollowGlobalSettings_Common":"Use global settings","Text_MaxTasks_Batch":"Add up to ${0} task(s)","Text_MinTasks_Batch":"Keep at least one task","Text_MaxImagesPerTask_Batch":"Upload up to ${0} images per task","Text_SupportedImageFormats_Batch":"Supported image formats: JPG, JPEG, PNG, HEIC, and WebP.","Input_AppearanceDetailsExample_TryOn":"For example: tanned skin, straight-across bangs, a beauty mark near the corner of the eye...","Input_SourceInfoGuide_Batch":"For more accurate results, please include the following information:\\n1. Product name\\n2. Product highlights\\n3. Target audience\\n4. Intended use cases\\n5. Detailed specifications","Tooltip_OutputStyleConsistent_Clone":"Enabling it keeps all generated images consistent in color and style. Disabling it allows each image to follow the style of its own reference image.","Option_AlibabaInternational_Platform":"Alibaba","Option_AliExpress_Platform":"AliExpress","Option_Amazon_Platform":"Amazon","Option_Douyin_Platform":"TikTok","Option_DouyinEcommerce_Platform":"TikTok","Option_IndependentSite_Platform":"Shopify","Option_Indonesian_Language":"Bahasa Indonesia","Option_JD_Platform":"JD.com","Option_Pinduoduo_Platform":"Pinduoduo","Option_Taobao_Platform":"Taobao","Option_TaobaoTmall1688_Platform":"Taobao, Tmall, 1688","Button_Generate_ImageSet":"Generate Image Set","Title_Nav_ImageSet":"Listing Images","Message_GenerateFailedRetry_ImageSet":"Generation failed. Please try again.","Message_PleaseSelectStyleFirst_ImageSet":"Please choose a style first.","Message_CreateTaskFailed_ImageSet":"Failed to create task","Title_StyleAnalysis_ImageSet":"Trending style analysis","Option_TrafficMaximization_TitleStrategy":"Maximize traffic","Option_ConversionPriority_TitleStrategy":"Conversion first","Option_SceneImmersion_TitleStrategy":"Immersive scenes","Text_ExtractingVisualAttributes_TitleGenerationStatus":"Extracting key features from assets...","Text_AnalyzingKeyHighlights_TitleGenerationStatus":"Generating high-conversion keywords based on product highlights...","Text_MatchingSeoStrategy_TitleGenerationStatus":"Matching the best SEO strategies...","Text_GeneratingOptions_TitleGenerationStatus":"Generating multiple captions from different perspectives...","Message_TaskFailedWithStatus_TitleGeneration":"Task failed (status: ${0}): ${1}","Message_TaskTimedOut_TitleGeneration":"Request timed out. Please try again.","Message_GenerateFailed_TitleGeneration":"Failed to generate title. Please try again.","Message_QueryResultFailed_TitleGeneration":"Failed to retrieve task","Paragraph_Content_VirtualModelConsent":"1. Portrait rights authorization: This feature uses the images you upload that contain faces to generate virtual model faces using AI. You must ensure that you have the right of portrait of the images uploaded or have acquired explicit, valid written consent from the rights holder to use their portraits for this purpose and any generated content. If the image contains a minor, consent from their legal guardian is required.","Button_ConfirmTextChange_TextEdit":"Update","Input_ModifyText_TextEdit":"Edit Captions","Message_NoImagesAvailable_ResultDownload":"No images available for download","Message_Failed_TextRecognition":"Failed to recognize text","Text_Generating_ResultStatus":"Generating...","Option_CustomColor_SceneSetting":"Custom","Option_UseOriginalBackground_SceneSetting":"Use original background","Text_InsufficientCredits_Common":"Insufficient coins","Button_LoadMore_Common":"Load More","Text_ImageUploadLimit_Common":"Upload up to ${0} images","Text_AnalyzingTrend_Common":"Analyzing trends on ${0}","Text_ChineseOutputProOnly_Common":"Chinese text generation is available on Pro only. Text has been removed from the current result.","Text_SourceImageUploadLimit_Common":"Upload up to ${0} images","Text_WritingInProgress_AiWriting":"Processing...","Text_DeepThinking_AiWriting":"Deep thinking...","Text_ThinkingProcess_AiWriting":"Thought Process:","Text_ImageSelectionLimit_Common":"Select up to ${0} images","Message_RegenerationSubmitted_Regeneration":"Regeneration submitted. Please refresh to view the results later.","Button_MoreEditOptions_ResultEditor":"More","FormLabel_DetailSection_DetailPage":"Product Detail Section","Message_GeneratePlanFailed_DetailPagePlan":"Failed to generate plan","Message_PlanGenerationFailed_DetailPagePlan":"Failed to generate plan","Text_PlanUnavailable_DetailPagePlan":"No plan available","Message_SourceImageMissing_Common":"Product image missing","Message_GenerationFailed_Common":"Generation failed","Paragraph_ConfirmDiscardChanges_Common":"Your changes will be lost if you go back. Are you sure you want to go back?","Message_ProcessFailed_Common":"Failed","Text_GeneratingEllipsis_Common":"Generating...","Text_StyleGenerationInProgress_ImageSet":"Generating trending styles...","Message_FavoriteAdded_Common":"Added to Favorites","Message_FavoriteRemoved_Common":"Removed from Favorites","Text_LoadingPlain_Common":"Loading","Text_MultiSelectAvailable_Common":"Select multiple","Text_NoData_Common":"No data available","Text_NoDataAvailable_Common":"No data","Text_NoMoreResults_Common":"No more content","Message_PleaseEnterKeyHighlights_DetailPage":"Please enter product highlights","Message_PleaseSelectAiModel_TryOn":"Please select an AI model","Message_SelectSectionMin_DetailPage":"Please select at least ${0} sections","Message_SelectScenePoseMin_TryOn":"Please select at least ${0} scenes and postures","Message_PleaseSelectBaseModel_TryOn":"Please select a base model","Message_PleaseSelectCustomModel_TryOn":"Please select a custom model","Message_PleaseSelectModel_TryOn":"Please select a model first","Message_PleaseSelectSection_DetailPage":"Please select a section","Message_SelectUploadCustomModel_TryOn":"Please select or upload a model image","Message_PleaseSelectScene_TryOn":"Select a scenario","Message_PleaseSelectStrategy_DetailPage":"Please select a strategy","Message_PleaseUploadGarmentImage_TryOn":"Please upload a clothing image","Message_UploadGarmentFile_TryOn":"Please upload a clothing image","Message_PleaseUploadSourceImage_Common":"Please upload product pictures first","Message_PleaseUploadItemImage_Common":"Please upload a product image","Message_UploadItemFirst_Common":"Please upload product pictures first","Message_RegenerateFailedWithReason_Regeneration":"Failed to regenerate:","Message_SelectResultImages_Result":"Please select an image with generated results","Text_ReleaseToRefresh_Common":"Release to refresh","Message_TextRecognitionFormatInvalid_TextRecognition":"Invalid format recognized","Message_TextRecognitionParseFailed_TextRecognition":"Failed to parse recognition results","Message_TextRecognitionTaskFailed_TextRecognition":"Failed to recognize text","Message_QueryTaskStatusFailed_TextRecognition":"Failed to retrieve task status","Message_SubmitTaskFailed_TextRecognition":"Failed to submit text recognition task","Text_RegenerationProcessing_Regeneration":"Regeneration request submitted. Processing...","Message_RegenerateFailedRetry_Regeneration":"Failed to regenerate. Please try again later.","Message_OpenEditorFailed_ResultEditor":"Failed to open editor","Message_RegenerateFailed_Regeneration":"Failed to regenerate","Message_RefreshFailedRetry_Common":"Failed to refresh. Please try again.","Message_UploadGarmentSelectModel_TryOn":"Please upload a clothing image and select a model","Message_PollingTimedOut_Common":"Query timed out","Title_KeyHighlights_DetailPage":"Product Highlights","Title_FullStrategyGuide_DetailPage":"Full Strategy & Design Guidelines","Title_IncludedSections_DetailPage":"Sections","Title_IncludedSectionsMultiple_DetailPage":"Sections (Select multiple)","Title_ModelSelection_TryOn":"Select Model","Title_SectionContent_DetailPage":"Section Content","Title_SectionStrategyGuide_DetailPage":"Section Strategy & Design Guidelines","Title_OutputAspectRatio_Common":"Aspect Ratio","Title_OutputSpecification_Common":"Specifications","Title_SelectModel_TryOn":"Select model","Title_SelectScene_TryOn":"Select a scene","Title_StrategySettings_DetailPage":"Strategy","Title_UploadAssets_Common":"Upload","Button_GenerateBaseModel_TryOn":"Generate base model","Button_GenerateRecommendedScenes_TryOn":"Generate recommended scene","Button_GenerateSceneImages_TryOn":"Generate (${0} images)","Text_GeneratingBaseModel_TryOn":"Generating base model...","Option_CloseUp_Framing":"Close-up","Option_FullBody_Framing":"Full-body","Option_HalfBody_Framing":"Half-body","Option_ThreeQuarter_Framing":"3/4","Title_Hero_TryOn":"AI Try-On","Option_Ai_TryOnModelMode":"AI Generated","Title_Nav_TryOn":"Try-On","Option_Back_Perspective":"Back","Option_Front_Perspective":"Front","Option_Side_Perspective":"Side","Option_ThreeQuarterSide_Perspective":"3/4 View","Input_AppearanceDetailsHint_TryOn":"Appearance details: tanned skin, straight across bangs, a beauty mark near the corner of the eye…","Message_SaveToAlbumSuccess_Common":"Saved to album","Text_GeneratingSceneImages_TryOn":"Generating scene images...","Message_RefreshFailed_Common":"Failed to refresh","Message_FailedRefunded_Generation":"AI design failed. The credits have been refunded.","Title_BaseModelImage_TryOn":"Base Model Image","Title_CustomModel_TryOn":"Custom Model","Paragraph_Intro_TryOn":"Upload a clothing image and customize your model to generate a variety of scenes and postures.","Title_UploadGarmentImage_TryOn":"Apparel Image","Tips_UploadFailedPure":"Failed to upload","Tips_Uploading":"Uploading...","Text_UploadNewModel":"New model","Text_AllBackgrounds":"All Backgrounds","Text_DefaultTemplateScene":"Default","Text_ColorScene":"Colors","Text_SameProductMax_Common":"Up to ${0} image(s) per product","Text_Max_Common":"Up to ${0} image(s)","Button_Generate_ImageClone":"Start Generating","Button_RefreshStyle_Common":"Refresh","Button_Favorite_Common":"Favorite","Text_PreviewLargeImage":"Full preview","Text_BaseImage":"Benchmark","Button_BatchDownload_Common":"Batch download","Button_BatchEdit_Common":"Batch edit","Button_BatchWatermark_Common":"Add watermark","Text_GeneratedResults":"Results","Button_DownloadAllImages_Common":"Download all","Text_NoGeneratedResults":"No results yet","Text_SameProductMax_TryOn":"A full outfit or multiple angles of the same item, up to ${0} images.","Title_AdvancedImageGenerationModel":"Premium Image Model","Text_SupportChineseOutput_Common":"Supports Chinese output and provide better aesthetic details and greater creative control.","Text_SelectMultipleModules_DetailPage":"Select multiple sections to generate a full product detail page","Button_CollapseAll_Common":"All","Label_AppearanceDetails_TryOn":"Appearance Details (Optional)","Text_WaitingForGeneration_TryOn":"Pending generation","Title_SmartTitleAI_ProductTitle":"Generate Viral Headlines","Message_ResultMissing_TitleGeneration":"${0} missing in AI-generated results","Message_InvalidJSONFormat_TitleGeneration":"Invalid result returned","Message_InvalidJSONFormat_TitleGeneration1":"Invalid JSON format returned","Text_AutoGeneratedTitleScheme_ProductTitle":"Here are the auto-generated titles based on your product","Text_SelectBestTitle_ProductTitle":"Pick a title that sells and click to copy","Button_Copy_Common":"Copy","Message_PleaseUploadImage_Common":"Please upload an image first","Text_DeepThinking1_AiWriting":"DeepSeek is working on it...","Button_Rewrite1":"Retry","Text_TotalImages_Common":"Count: ${0}","Text_EditText_ResultEditor":"Edit text","Text_NoTextRecognition_ResultEditor":"No text detected","Text_PreviewLongImage_ResultGroup":"Long image preview","Text_LimitFree":"Flash Deal","Text_UploadSameProductTip1":"1. Upload original images of the same product from multiple angles to help AI recreate product details more accurately","Text_UploadSameProductTip2":"2. Up to ${0} images are supported. The first image will be used as the main reference, so choose the one with the most complete view.","Text_UploadProductImage_APlusCase":"Upload product image","Text_GenerateEcommerceLongImage_APlusCase":"Generate long image","Text_MultiPlatform_APlusCase":"Compliant with multiple ecommerce platform standards","Text_MainImage_ProductCase":"01 Header Image (White background/Standard)","Text_SceneDisplay_ProductCase":"02 Use Case Scenarios","Text_ModelSceneImage_ProductCase":"03 Model Images","Text_DetailDescription_ProductCase":"04 Details","Text_FeatureExplanation_ProductCase":"05 Product Highlights","Text_UploadProductImage_ProductCase":"Upload product images and AI will instantly generate high-converting image sets <span>that are compliant with multiple ecommerce platform standards</span>.","Text_UploadGarmentImage_TryOn":"Upload clothing images and create your custom model to instantly generate multiple scenes and postures.","Text_UploadProductImage_DetailPage":"Upload product images and AI will instantly generate a professional product detail page <span>that are compliant with multiple ecommerce platform standards</span>.","Title_DetailPage_ProductCase":"A+/Product Detail Page","Option_Temu_Platform":"Temu","Option_TikTokShop_Platform":"TikTok Shop","Option_TikTok_Platform":"TikTok","Option_Ozon_Platform":"OZON","Option_Shopee_Platform":"Shopee","Option_SHEIN_Platform":"SHEIN","Login_Zawa_Title":"Log in to unlock your free trial","Login_DK_Title":"Create stunning designs for Free","Login_Zawa_Des":"Start creating with Zawa today","Login_DK_Des":"Sign up or log in to keep designing. Start now!","Tab_Module_ProductImage_TryOn_MultiMix":"Style pieces into one outfit","Tab_Module_ProductImage_TryOn_SingleHero":"From one piece to a complete look","Tab_Module_ProductImage_TryOn_Accessories":"Perfect accessory styling","Text_ShowAdvancedModelTip":"Show premium model tips","Text_HideAdvancedModelTip":"Hide premium model tips","Text_DeepSeekR1HelpWrite":"Help me write (DeepSeek R1)","Message_PollingMaxAttempts_Common":"Exceeded maximum attempts ${0}","Title_StandardEdition":"Standard","Text_FastAndEfficient_Common":"Fast and Efficient","Text_PremiumEdition":"Premium","Text_QualityAndDetailEnhancement_Common":"Enhanced Quality and Details","Text_PremiumEngineActivated":"<strong>Premium engine activated:</strong> Supports Chinese output and provide better aesthetic details and greater creative control.","Text_EditBrand_DropTitle1":"Drag and drop JPG, PNG, or WEBP files here,","Text_EditBrand_DropTitle2":"or <>browse</> from your computer.","Text_BaseToolbar_AlignTop":"Top Align","Text_BaseToolbar_AlignBottom":"Bottom Align","Text_LayerSort":"Order","Text_BaseToolbar_AlignCenter":"Center","Text_Attr_Strong":"Bold","Text_GeneratingPlan_DetailPagePlan":"Generating plan...","Text_PlanGenerationFailed_ReTry":"Failed to generate plan. Please try again later.","Button_StartAnalyze_ProductCase":"Let\'s Start","Message_SubmitSuccessTip_Batch":"Submitted","Button_ClickAnalyze_ProductCase":"Analyze bestseller styles","Button_StartAnalyzing_ProductCase":"Analyzing","Title_ModelImage":"Model","Text_Cookie_Title":"First things first, cookies 🍪","Text_Cookie_Content":"We would like to use cookies on this website to ensure security, efficient performance, and service optimization. To learn more about how we use cookies, please click","Text_Cookie_LearnMore":"Details","Button_Cookie_Manage":"Manage Cookies","Button_Cookie_Accept":"Accept","Text_CookieModal_Title1":"Cookie Settings","Text_CookieModal_Desc1":"Cookies are small text files that websites store on your device to help us remember your preferences, track website traffic, and improve our services. Your privacy is important to us, and we want you to be in control of your data. Here, you can customize your cookie preferences to optimize your browsing experience. Please note that changing cookie settings may affect the functionality and services of our website.","Text_CookieModal_Title2":"Necessary Cookies","Text_CookieModal_Desc2":"These cookies are essential for the website\'s functionality, security, and core performance. Without them, key features and security measures of Zawa will not function properly, which may adversely affect your experience.","Text_CookieModal_Title3":"Optional Cookies","Text_CookieModal_Desc3":"These cookies help us understand the number of Zawa users, where they come from, and how they use the website. If you choose to disable these cookies, we will not be able to collect feedback to improve Zawa or to provide better services for you and other users.","Button_CookieModal_Save":"Save","Text_CookieModal":"Always Active","Text_Agent_Chat_DK":"Type your idea…","Text_Agent_Chat_XD":"What would you like to design","Radio_Color":"Palette","Radio_Layout":"Layout","Radio_Reference":"${0}","Radio_Posture":"Pose","Radio_Background":"Background","Language_Banner_Message":"Would you like to switch to ${0}?","Language_Banner_Change":"Yes","Language_Banner_Other":"More languages","Title_ItemTaskWithIndex_Batch":"Product Task ${0}","Title_DetailTaskPrefix_Batch":"A+ Task","Text_CopiedTaskTitle_Batch":"${0} (Copy)","Message_SelectSectionMin_Batch":"Please select at least one section.","Title_GlobalBatchSettings_Batch":"Global settings (Apply to the following tasks)","Text_Parameters_Batch":"Parameters","Text_Modules_Batch":"Sections","Title_KeyHighlights_Batch":"Product Highlights","Text_ModulesFollowGlobal_Batch":"Sections - Use Global Settings","Title_SelectManagedBusinessType_Batch":"Select Task Type","Button_SubmitTask_Batch":"Submit","Text_NewTaskCurrentCount_Batch":"Create Task","Title_NotificationSettings_Batch":"Notifications","Title_ManagedMode_Batch":"Scheduler","Button_SaveSettings_Batch":"Save settings","Button_SaveAndContinueSubmit_Batch":"Save & submit","Message_PhoneFormatInvalid_Batch":"Please enter a valid 11-digit phone number.","Message_VerificationCodeSent_Batch":"Verification code sent. The code is valid for 5 minutes.","Message_VerificationCodeSendFailed_Batch":"Failed to send. Please try again later.","Message_PleaseEnterCode_Batch":"Please enter the verification code.","Message_GetCodeFirst_Batch":"Please first get a verification code.","Message_VerificationCodeExpired_Batch":"Verification code expired. Please request a new one.","Message_SaveNotificationSettingsFailed_Batch":"Failed to save notification settings. Please try again later.","Text_WebMessageNotification_Batch":"You’ll be notified in Web messages when the task is complete.","Title_AppPushRecommended_Batch":"App Notifications (Recommended)","Paragraph_AppPushDesc_Batch":"Track progress and see results on your phone in real time. Keep your designs at your fingertips and never miss out on any opportunity.","Text_AppDownloadQrCode_Batch":"Scan to download the app","Title_SmsNotification_Batch":"SMS Notifications","Placeholder_Phone11Digits_Batch":"An 11-digit phone number","Placeholder_VerificationCode5Min_Batch":"Verification code","Text_SendingEllipsis_Batch":"Sending...","Text_RetryAfterSeconds_Batch":"Try again in ${0}s","Button_GetVerificationCode_Batch":"Send Code","Message_SubmitSuccess_Batch":"Submitted","Message_SubmitFailedRetry_Batch":"Failed to submit. Please try again later.","Message_FormValidationPassed_Batch":"Valid content","Message_CompleteNotificationSettingsFirst_Batch":"Please set up notifications before submitting the task.","Paragraph_CancelManagedTaskWarning_Record":"The scheduled task will be removed permanently if you cancel now.","Button_ConfirmCancel_Record":"Cancel anyway","Message_CancelManagedTaskFailed_Record":"Failed to cancel. Please try again later.","Text_WaitingManagedGeneration_Batch":"Scheduling task...","Text_WaitingManagedSubmit_Batch":"In queue","Message_NoExtendableImages_Result":"No images available","Text_IntelligentMultiSizeAdaptation_Result":"Smart resize your images to fit every screen","Button_IntelligentResize_Result":"Smart Resize","Option_CustomSize_DetailPageMode":"Custom","Title_AdvancedAPlus_DetailPageMode":"Premium A+","Title_ManagedModeLaunched_Batch":"Scheduler is ready to help!","Text_ManagedModeSlogan_Batch":"Works overnight to have your designs ready when you wake up.","Title_BatchProduction_Batch":"Batch Generation","Paragraph_BatchProductionDesc_Batch":"Runs up to ${0} tasks simultaneously and boosts your productivity by ${1}×.","Title_AiIntelligentExtraction_Batch":"AI Analysis","Paragraph_AiIntelligentExtractionDesc_Batch":"Analyzes your images and automatically generates high-converting product highlights.","Title_SaveCost20_Batch":"Save ${0}% on credits","Paragraph_SaveCost20Desc_Batch":"You can schedule tasks at night and enjoy discounted credit usage.","重写":"Batch Download","Brand_AutoExtract_Button":"Palette Extractor","Brand_AutoExtract_Success":"Palette extracted","Brand_AutoExtract_Failure":"Failed to extract color palette. Please try again.","Brand_AutoExtract_Unavailable":"Unable to extract color palette.","Brand_AutoExtract_ConfirmTitle":"Extract color palette from logo?","Title_ImageSetConfig_ImageSet":"Listing Design","Title_DefaultConfig_ImageSet":"AI Design","Desc_DefaultConfig_ImageSet":"AI analyzes product images and matches the best listing image set","Title_CustomConfig_ImageSet":"Custom Design","Desc_CustomConfig_ImageSet":"Adjust the number of images for each type. Select at least ${0} images.","Label_WhiteBackground_ImageSet":"White Background Images","Desc_WhiteBackground_ImageSet":"Showcase your product from multiple angles on a white background.","Label_Scene_ImageSet":"Lifestyle Scenes","Desc_Scene_ImageSet":"Present your product in real-life scenarios.","Label_SellingPoint_ImageSet":"Product Highlights","Desc_SellingPoint_ImageSet":"Emphasize the key features that make your product stand out.","Label_Other_ImageSet":"Other","Desc_Other_ImageSet":"Auto-curated content for your product, including comparisons, specs, and more.","Tip_MinTotal_ImageSet":"At least ${0} images","Text_ManagedBatchEntry_Header":"Scheduler","Option_Coupang_Platform":"Coupang","Option_Wayfair_Platform":"Wayfair","Button_Credit_Plan":"Credit Plan","Text_Higher_Plan":"Already on a Higher Plan","Text_Try_Free":"Try Now for $0","Text_Plus_Plan":"Plus Plan","Text_Pro_Plan":"Pro Plan","Button_Generate_Short_Common":"Generate","Message_DuplicateTaskSubmitConfirm_Common":"Results already generated with these settings. Generate again?","Text_CreditUnit_Common":"Credits","Text_NewUserDiscountDesc_Product":"${0} credits for the first listing. ${2} credits for each additional ${1} listings.","Text_NewUserLimitedTag_Product":"New User Discount","Text_OriginalPrice_Product":"Original: ${0} credits","Tip_MaxTotal_ImageSet":"Up to ${0} images","Text_AddDocumentTips":"Word, Excel, Text, PDF and Markdown files are supported","Tab_SolidColor":"Solid Color","Tab_Gradient":"Gradient","Title_PresetGradient":"Presets","Title_PresetSolidColor":"Presets","Title_RecentlyUsed":"Recently used","Title_Patterns":"Pattern","Title_NoFill":"None","Description_Brand_Reference":"Upload your favorite posters or art assets and Zawa will use the style to create designs tailored to your taste.","Text_Generating":"Generating...","Text_ChartSending":"Submitting","Text_PeopleUnSupport":"Portrait mode is not supported yet","Button_CancelManagedBatch_ResultGroup":"Cancel task","Button_DownloadZip_ResultGroup":"Download ZIP","Button_DownloadLongImage_ResultGroup":"Download combined","Text_ManagedTaskDispatchedCannotCancel_ResultGroup":"Submitted task cannot be canceled","Button_GlobalAiWriting_Batch":"AI Writing","Text_StandardModel_DistributionBatch":"Standard Model (Bulk Listing)","Text_StandardModelDescription_Batch":"Best for high-volume SKUs to maximize market reach.","Text_AdvancedModel_PremiumBatch":"Advanced Model (Targeted Listing)","Text_AdvancedModelDescription_Batch":"Premium quality images that are best for precision-driven profitability.","Message_MinSubmitTasks_Batch":"Submit at least ${0} tasks.","Message_OverwriteSellingPointsConfirm_Batch":"The product highlight section has been filled in ${0} tasks. How would you like to apply AI writing results?","Button_OverwriteAll_Batch":"Replace all","Button_FillEmptyOnly_Batch":"Incomplete only","Message_NoEmptySellingPointsToFill_Batch":"Product highlights for all tasks are already complete.","Message_AiWritingFailedRetry_Batch":"AI writing failed. Please try again later.","Button_NewTask_Common":"New task","Message_Generating_Time":"Your tasks will run overnight (${0}-${1}). Come back tomorrow to check the results.","Title_Total_Credits":"Total credits","Text_Used_AllFeatures":"Applicable to all features","Daily_Present_Credits":"Use-today credits","Daily_Credits_Desc":"Claim daily. Valid till the end of the day.","Text_Inactive":"Inactive","Text_Inactive_Monthly":"${0} credits will expire within the next 30 days","TITLE_GUIDE_CUTOUT_LITE":"Stamps or logos detected","GUIDE_DESC_CUTOUT_LITE":"Use Stamp/Logo Cutout for precise cutout","GUIDE_ACTION_CUTOUT_LITE":"Stamp/Logo Cutout","TITLE_CUTOUT_LITE":"Stamp/Logo Cutout","TIP_CUTOUT_LITE":"Accurate cutouts of stamps or logos","PROCESSING_CUTOUT_LITE":"Generating images...","AFTER_CUTOUT_LITE":"Results","Button_Previous":"Previous","Button_Next":"Next","Button_Skip":"Skip","Button_Apply":"Apply","Text_AgentExpert":"Expert","Message_PleaseEnterLinkOrAsin_Clone":"Enter a link or ASIN","Message_LinkAnalyzeFailed_Clone":"Link analysis failed","Message_UploadProductImageFirst_Clone":"Please upload product images first","Message_ProductImageThumbGenerateFailed_Clone":"Thumbnail generation failed. Upload again.","Message_UploadProductImageFirst_ProductCase":"Please upload a reference image or paste a product link","Message_ReferenceImageThumbGenerateFailed_Clone":"Thumbnail generation failed. Upload again.","Title_ReferenceSource_Clone":"Reference","Option_LinkAsin_Clone":"Link","Input_PasteProductLinkOrAsin_Clone":"Paste Amazon link","Button_Parsing_Clone":"Analyzing...","Button_Parse_Clone":"Analyze","Text_SupportAmazonTiktokLinks_Clone":"Amazon and TikTok links are supported","Text_Cloning_ResultStatus":"Processing...","Input_CloneRequirementOptional_Clone":"Requirements (Optional)","Title_ProductOriginalImage_Clone":"Product Image","Title_CloneLevel_Clone":"Replication Style","Option_CompositionReference_Clone":"Style","Desc_CompositionReference_Clone":"Creates a new scene inspired by your reference\'s mood and styling.","Option_HighFidelityClone_Clone":"High-Fidelity","Desc_HighFidelityClone_Clone":"Closely recreates your reference, with only product and text swapped.","Label_OutputStyleConsistent_Clone":"Consistent Style","Title_SupplementaryNotesOptional_Clone":"Additional instructions (Optional)","Input_SupplementaryNotesExample_Clone":"Example: Generate English product copy, keep the same model, and replace only the product.","Title_HotClone_Welcome":"Image Remix","Text_HotCloneDescription_Welcome":"Your hit reference + your product image = your own viral image","Text_DefaultTaskName_Clone":"Image Clone Strategy","Label_ProductImage_CloneCase":"Product Image","Label_ReferenceComposition_CloneCase":"Style reference","Label_HighFidelityClone_CloneCase":"High-Fidelity","Tag_AiSmartMatch_ImageSet":"AI intelligent matching","Title_Date":"Date","Title_Topic":"Theme","Button_Replace":"Replace","Title_SingleCloneRequirement_Clone":"Individual Requirements","Text_UploadedReferenceImagesTip_Clone":"Individual requirements for each reference image. Default settings will be applied if requirements are not specified.","Label_ReferenceImageIndex_Clone":"Reference image ${0}","Option_Mexico_Market":"Mexico","Text_ParsingReferenceImages_Clone":"Analyzing...","Text_ParseReferenceImagesSuccess_Clone":"Analysis complete. ${0} reference images obtained.","Text_Renew_Restore":"The credits will be restored once your subscription is renewed.","Title_UsageNotice_Clone":"User Guide","Text_UsageNoticeDescription_Clone":"Please confirm that you have the legal right to use the content of this link. Generated results are based on AI style analysis and are for creative reference only.","Label_ReadAndAgreeUsageNotice_Clone":"I accept the above terms","Label_DoNotShowAgain_Clone":"Do not show this again","Text_InterceptModal":"Allow pop-up windows for Designkit.","Text_InterceptModal_ThirdStep":"Click \\"Done\\" to start using Designkit.","Text_InterceptModal_Desc":"Authorize Designkit to open multiple windows in your browser.","Brand_StatusPopup_ProcessingTitle":"Zawa is learning your brand style...","Brand_StatusPopup_FailedTitle":"Failed to extract data from Square. Try again later.","Brand_StatusPopup_Retry":"Try again","SecondTitle_Header19_Home":"Clone Video Ads","SquareBrandGuide_BrandKitCreatedTip":"Your brand kit has been created based on Square data","SquareBrandGuide_DefaultPrompt":"Design a product poster for social media promotion","SquareBrandGuide_SendTip":"Click Send to get started!","Paragraph_BatchProductionDescUnlimited_Batch":"Handles multiple tasks simultaneously, drastically cutting down your project timelines.","Menu_ViewDetail":"Details","Menu_CopyFullText":"Copy","Tip_CopiedToClipboard":"Copied to clipboard","Tip_CopyFailed":"Copy failed","Menu_DownloadImage":"Download","Tip_NoImage":"No images","Tip_DownloadStarted":"Download in progress","Menu_CopyText":"Copy","Tip_NoTextToCopy":"No text available","Message_LinkImageFetchFailed_Clone":"We couldn\'t load images from this link. Try a different link or upload the images instead.","Tab_Chat":"Chat","Tab_Files":"Files","Button_Create_New_Chat":"New chat","Tip_Agent_Team_Chat_Shared":"Viewing read-only version","Title_ViralVideoMaker":"AI Viral Video Generator","Title_ProductVideoMaker":"Product Video Generator","designkit_agent_watermark_protocol":"You may choose to save the images with or without the \\"AI result\\" watermark. By saving without the watermark, you agree to: 1. Not use Zawa AI Agent to create, publish, or spread false information. 2. Comply with applicable laws and clearly label AI-generated content when using or sharing it.","Text_Document":"File","Button_BrandAssets_UploadDevice":"Upload from Device","Button_SocialBrief_Complete":"Complete brief","Button_SocialBrief_Edit":"Edit brief","Button_SocialBrief_Generate":"Generate based on brief","Description_BrandAssets":"Your brand information helps us provide more relevant results.","Name_BrandAssets":"Brand Assets","Placeholder_BrandAssets_Link":"e.g., Instagram or Google Maps links.","Text_BrandAssets_KitImported":"Import from Brand Kit","Text_BrandAssets_LinkEntry":"Enter your link","Text_SocialResult_Post":"Post","Title_SocialBrief":"Brief","Toast_BrandAssets_DuplicateSkipped":"Duplicate images skipped","Toast_BrandAssets_EmptyAssets":"No brand kit found","Toast_BrandAssets_InvalidUrl":"Enter a valid link","Toast_BrandAssets_LoadAssetsFailed":"Failed to obtain brand assets","Toast_BrandAssets_LoadKitsFailed":"Failed to obtain brand kits","Toast_BrandAssets_PartialReadFailed":"Some images could not be loaded","Toast_BrandAssets_ReadFailed":"Images could not be loaded","Toast_BrandAssets_SaveFailed":"Failed to save brand assets","Toast_BrandAssets_UploadFailed":"Some brand asset information failed to upload. Please try again.","Title_AgentDesignPreference":"Personalize Your AI Style Agent","Desc_AgentLibWorkflowUnify":"Save your models and signature styles for faster, more consistent creations across every workflow.","Button_ViewAgentGuide":"Instructions","Desc_BatchRecipeRetain":"Save image settings and scene compositions as reusable presets you can instantly apply to future projects.","Button_NewBatchRecipe":"Create preset","Desc_CustomModelUpload":"Upload your model images and reuse them across multiple generations to build a consistent brand identity.","Button_NewExclusiveModel":"Create model","Text_AiRecommend_TryOn":"Smart Scene Recommendations","Desc_AiRecommendSceneMode_TryOn":"Automatically select the best scene based on clothing.","Message_LoadSceneFailedRetry_TryOn":"Loading failed. Please try again later.","Text_OptionalCustomSceneDescription_TryOn":"Describe Your Scene (Optional)","Placeholder_CustomSceneDescription_TryOn":"Provide details, e.g. golden autumn streets, soft sunset lighting, a model leaning against a tree…","Message_PleaseSelectOrDescribeScene_TryOn":"Select or enter a scene description","Placeholder_SearchProduct_Record":"Search by product name or keywords","Title_RecentSearches":"History","Button_Clear":"Clear","Title_ShootingScene_TryOn":"Scene Settings","Button_Charged_Continue":"Top-up complete","Title_SplitImagePlugin":"Image Layering","Description_SplitImagePlugin":"Detect image elements and separate them into editable layers.","Tip_SplitImageLoading":"Processing...","Tip_SplitImageFail":"Processing failed. Please try again.","Brand_SquareSync_ToastPartial":"Some Square data couldn\'t be imported","Brand_SquareSync_ToastSuccess":"Your Square data is ready","Brand_SquareSync_Failed":"Failed to extract data from Square","Brand_SquareSync_Button":"Import from Square","Title_Format":"Format","Message_CancelManagedTaskSuccessRefunded_Record":"Task canceled. Credits have been refunded to your account.","Text_AspectRatio_Common":"Ratio","Text_Country_Common":"Country/Region","Text_Language_Common":"Language","Text_Platform_Common":"Platform","Option_Korea_Market":"South Korea","Option_Korean_Language":"Korean","Title_AgentLibRecentBrainOn":"Agent intelligence enabled","Desc_AgentLibRecentRecipesSidebar":"Your presets are added to Agent Assets. Use them to instantly apply your brand style across designs.","Title_CreateBatchRecipe":"Create preset","Tips_Not_Files":"No files","Message_PleaseEnterProductHighlights":"Please enter your product highlights","Message_UploadProductImageRequired":"Upload at least one product image","Tips_Agent_Teams_Mode":"Best for sophisticated workflows that require multiple AI capabilities.","Tips_Agent_Teams_Mode_Actived":"Agent Team Mode coordinates AI agents across every stage, from strategy to final production.","Tip_SocialBrief_MissingImages":"{count} posts are missing required images. Add them to continue.","Tips_Agent_Teams_Mode_Active_Zawa":"Agent Team is ready — research and content creation on autopilot. Tell me what you need.","Tip_AiGeneratedContent":"AI-generated content may contain errors.","Button_ContinueUpload":"Continue","Button_GenerateNow":"Generate","Button_ReplaceClothes":"Replace","Desc_ReplaceClothesMultiUpload":"Change the whole outfit simultaneously","FileName_MyClothes":"Uploaded","Message_SelectReplaceClothes":"Select your apparel images","Message_UploadClothesFailed":"Image upload failed, please try again.","Message_UploadClothesSizeLimit":"Upload apparel images up to 10MB","Text_MoreActionEmpty":"Set up actions","Tip_UploadClothesFormat":"Drop or upload ${0} images up to ${1}.","Title_ReplaceClothes":"Replace apparel","Title_TryOnAccessoryMatch":"Add smart accessories to create a signature brand look","Title_TryOnMultiPose":"Create lookbooks with natural, lifelike model poses","Title_TryOnOutfitMix":"Style full outfits by mixing and matching items","Title_TryOnSceneSwitch":"Switch backgrounds to fit any vibe or campaign style","Title_TryOnAIRecommend":"AI Recommendations","Text_SocialBrief_Generating":"Generating in progress. Please wait.","Tag_New":"New","Title_Designer":"Designer","Button_Blank_Canva":"Blank canvas","Tool_AiViralImageRemix":"Image Remix","Title_ViralVideoReplace":"Video Remix","Title_SocialMedia_Tools":"Social Creative Tools","Title_HotTags":"Trending","Tip_LogoNotRecognized":"Logo not found","Tip_LogoNotRecognized_Eraser":"Logo not found. Swipe to select the area you want to remove.","Placeholder_RemoveGrassDebris":"Remove clutter from grass","Placeholder_RemoveGroundShadow":"Remove shadows on the ground","Placeholder_RemoveRedClothesPerson":"Remove the person in red clothes","Placeholder_DescribeRemovalPart":"Enter what you want to remove, for example: ${0}","Modal_LeavePageTitle":"You are about to leave this page","Modal_OpenRoboNeoNewTab":"Open RoboNeo in a new tab?","Button_ReplicateVideo":"Remix this video","Button_RemixImage":"Remix this image","Message_ContentProcessFailed_Text":"Failed to process. Try other words.","Message_ContentProcessFailed_Image":"This image can\'t be processed. Try another one.","Text_ProductImageOptionalUploadTip_Clone":"Add a product photo if you want it included in the result","Option_EcommerceProductImage_Clone":"E-commerce Product Image","Option_ApparelEcommerceImage_Clone":"Apparel E-commerce Image","Option_SocialGraphicImage_Clone":"Social Media Post","Option_MarketingPoster_Clone":"Marketing Poster","Option_CreativePoster_Clone":"Creative Poster","Option_ReferenceImageSize_Clone":"Reference Image Ratio","Option_Instagram_Platform":"Instagram","Home_Tools_Title":"Supercharge your social content with our powerful toolkit","Home_Tools_Tab_SocialCreative":"Social Creative","Home_Tools_SeeAllImageTools":"See all image tools","Home_Tools_SeeAllSocialCreative":"See all social content tools","Home_Tools_ImageObjectRemover":"Image Object Remover","Home_Tools_TextToVideo":"Text To Video","Home_Tools_FoodPhotography":"Food Photography","Home_Tools_FlyerGenerator":"Flyer Generator","Home_Tools_MenuGenerator":"Menu Generator","Home_Tools_PosterGenerator":"Poster Generator","Home_Tools_MockupGenerator":"Mockup Generator","Home_Tools_ImageExtender":"Image Extender","Home_Tools_ImageToVideo":"Image To Video","title_upgrade2GetMoreCredits":"Upgrade for more credits.","tip_insufficientCredits":"Insufficient credits. Top up for more.","tip_insufficientCredits_upgrade":"Insufficient credits. Subscribe for more.","Title_DownloadPromotion_ViralVideo":"Want more videos like this?","Subtitle_DownloadPromotion_ViralVideo":"Go Pro for more video creations.","Tag_DownloadPromotionOffer_ViralVideo":"Limited time offer","Title_DownloadPromotionCard_ViralVideo":"Keep creating with Pro","Text_DownloadPromotionPrice_ViralVideo":"${0}/mo","Text_DownloadPromotionBenefitViralVideo_ViralVideo":"Product Video Generator/Video Remix (up to ${0} videos/month)","Text_DownloadPromotionBenefitNanoBanana_ViralVideo":"Unlimited Nano Banana Pro creations","Text_DownloadPromotionBenefitImageEnhance_ViralVideo":"Unlimited AI removal & quality enhancement","Button_DownloadPromotionGetPro_ViralVideo":"Get Pro for ${0} off","Button_DownloadPromotionLater_ViralVideo":"No thank you","Tag_NewUserLimitedFree":"Limited time offer","Text_FirstImageCreditDiscount":"${0} credits for the first image. ${2} credits for each additional ${1} images.","Tag_NewUser_FirstImageLimitedFree":"Limited time offer","Tag_FirstImageFree":"1 Free Trial","Title_OtherSettings":"Other Settings","Title_GenerateListing":"Generate listing copy","Button_GenerateListing":"Generate listing copy","Message_Copied":"Copied","Text_Generating_Listing":"Generating...","Text_GenerateFailed_Listing":"Failed to generate","Button_Translate":"Translate","Title_ListingCopy":"Listing Copy","Message_NoTaskForListing":"No listing generation task found.","Message_RenameSuccess":"Modified","Message_RenameFailedRetry":"Failed to modify. Please try again.","Title_RegenerateDirection":"Edit Generation","Placeholder_RegeneratePrompt":"Leave blank to regenerate or add instructions to edit the result (optional). E.g., \\"Move the product left\\" or \\"Change background to light gray\\".","Title_TrialLimitReached_ViralVideo":"Free Video Used","Subtitle_TrialLimitReached_ViralVideo":"Your free trial can generate 1 video. Upgrade to Pro to generate more.","Button_UpgradeNow":"Upgrade Now","Text_WPS_NavVipEntrance":"Purchase","Text_WPS_Only":"(WPS only)","Text_WPS_Credits_Card_Tip":"Designkit has a separate subscription system and is not included in standard WPS memberships.","Text_WPS_Welcome_Modal_Pricing":"Designkit Subscription","Text_WPS_Welcome_Modal_Pricing_Description":"AI Design is provided by a third-party WPS partner and requires a separate purchase.","Text_WPS_Welcome_Modal_Meidou":"First Login","Text_WPS_Welcome_Modal_Meidou_Description":"WPS Members get 50 free credits to try it out! No extra charges will apply to your account.","Text_WPS_Welcome_Modal_Vip":"Subscription Bonus","Text_WPS_Welcome_Modal_Vip_Description":"Purchase an AI Design plan and get WPS Super Membership for the same duration, for a limited time.","Text_WPS_Welcome_Modal_Title":"Create with Designkit","Text_WPS_Welcome_Modal_Agreement":"By continuing, you have read and agree to the terms above.","Button_Generate_ImageListingSet":"Listing Images & Copy","Tip_GenerateListing":"Generate platform-ready visuals and copy for your selected marketplace.","Text_SelectedCount":"${0} selected","RoboNeo_Web_input_default_content":"Chat with RoboNeo","RoboNeo_Web_chatbox_maximum":"Chat limit reached","RoboNeo_Web_chatbox_maximum_text":"Chat limit reached. Create a new task.","RoboNeo_Web_chatbox_new_task":"New project","RoboNeo_Web_history_share_text":"Share","RoboNeo_Web_history_delete_text":"Delete","RoboNeo_Web_history_delete_hint_text":"Note","RoboNeo_Web_history_delete_main_text":"Project will be permanently deleted. Continue?","RoboNeo_Web_history_delete_hint_confirm":"Delete","RoboNeo_Web_history_delete_hint_cancel":"Cancel","RoboNeo_Web_studio_download":"Download","RoboNeo_Web_toast_share_text":"Share this chat","RoboNeo_Web_toast_share_main_text":"Anyone with the chat link can view your chat history","RoboNeo_Web_toast_share_copy":"Copy link","RoboNeo_Web_toast_cancel":"Cancel","RoboNeo_Web_toast_confirm":"Confirm","RoboNeo_Web_studio_changing_toast":"No free uses left for today. This will reset by midnight. You can also feed \\"Cyber Carrots\\" to Neo to continue.","RoboNeo_Web_studio_changing_toast2":"No free uses left for today.","RoboNeo_Web_new_studio":"New chat","RoboNeo_Web_sidebar_close":"Collapse","RoboNeo_Web_history_text":"History","RoboNeo_Web_sidebar_open":"Expand","RoboNeo_Web_upload_warning_text":"Cannot upload pictures and videos at the same time.","RoboNeo_Web_upload_format_text":"Supported image formats: JPG, PNG, and JPEG. Supported video formats: MP4 and MOV.","RoboNeo_Web_upload_fail_text":"Failed to upload","RoboNeo_Web_upload_image_maximum":"You can upload up to {max_num} images","RoboNeo_Web_upload_video_size_maximum":"Videos larger than {max_size} MB are not supported.","RoboNeo_Web_upload_image_size_maximum":"Images above {max_size} MB are not supported.","RoboNeo_Web_upload_video_maximum":"You can upload up to {max_num} videos","RoboNeo_Web_history_dafult_text":"No history found, chat now.","RoboNeo_Web_upload_content_warning_text":"Files with potentially inappropriate content will not be imported.","RoboNeo_Web_chat_send_fail":"Sending failed, please try again later.","RoboNeo_Web_network_fail":"Connection failed or timed out, please try again.","RoboNeo_Web_studio_layer_fail":"Failed to split layers.","RoboNeo_Web_studio_layer_success":"Completed","RoboNeo_Web_network_error":"Network error","RoboNeo_Web_delete_success":"Deleted","RoboNeo_Web_delete_fail":"Delete failed","RoboNeo_Web_copy_success":"Copied","RoboNeo_Web_file_uploading":"Uploading {num} files","RoboNeo_Web_file_upload_fail":"Error uploading {num} files","RoboNeo_Web_file_upload_single_fail":"Error uploading 1 file","RoboNeo_Web_file_uploading_single":"Uploading 1 file","RoboNeo_Web_upload_video_maximum_one":"You can upload up to 1 video","RoboNeo_Web_sharepage_wanna_try":"Try Now","RoboNeo_Web_sharepage_load_to_end":"Go to Results","RoboNeo_Web_studio_loading_text":"Loading canvas...","RoboNeo_Web_chatbox_add_image":"Add images","RoboNeo_Web_chatbox_add_video":"Add video","RoboNeo_Web_image_editor_max":"Max 10MB with 4096px on the longest side","RoboNeo_Web_unlimited_pass_expired":"Unlimited Pass expired. Using available free uses now.","RoboNeo_Web_studio_ai_image_successful":"AI UHD - completed","RoboNeo_Web_studio_ai_image_failed":"AI UHD - failed","RoboNeo_Web_studio_cutout_successful":"Cutout successful","RoboNeo_Web_studio_cutout_failed":"Cutout failed","RoboNeo_Web_studio_ai_edit_failed":"AI Editing - failed","RoboNeo_Web_studio_ai_edit_successful":"AI Editing - completed","RoboNeo_Web_AI_generated":"Content generated by AI","RoboNeo_Web_loading":"Loading","RoboNeo_Web_view_creative_process":"View Creative Process","RoboNeo_Web_try_now":"Try Now","RoboNeo_web_extender_successful":"AI Extender - completed","RoboNeo_web_extender_failed":"AI Extender - failed","RoboNeo_web_eliminate_successful":"AI Removal - completed","RoboNeo_web_eliminate_failed":"AI Removal - failed","roboneo_web_continue":"Continue","roboneo_web_video":"Video","roboneo_web_HTML":"HTML","roboneo_web_shared_error_message":"This chat cannot be shared, try starting a new one.","roboneo_web_open_the_APP_experience":"Try in app","roboneo_web_AI_generated_logo":"This AI-generated content is for reference only.","roboneo_web_change_word_success":"Replace Text - completed","roboneo_web_change_word_fail":"Replace Text - failed","roboneo_web_canvas_loading_failed":"Loading canvas failed","roboneo_web_export_failed":"Export failed","roboneo_web_export_tips2":"Only supports exporting one image (up to {width}px*{height}px).","roboneo_web_new_topic":"New chat","roboneo_web_waiting_reply":"Waiting for response","roboneo_web_file_saving_preferences":"File preference","roboneo_web_includes_AI_watermark":"Include AI watermarks","roboneo_web_no_remind":"Don\'t show again","roboneo_web_agree_continue":"Agree and continue","roboneo_web_watermark_protocol":"You may choose to save the images with or without \\"AI result\\" watermarks. Choosing to save without the watermark means you agree to: 1. Not use RoboNeoAI to create, publish, or spread false information. 2. Ensure law compliance and clearly indicate such content as AI-generated when using or sharing it.","roboneo_web_rectangle":"Square","roboneo_web_circle":"Round","roboneo_web_arrow":"Arrow","roboneo_web_image_fusion_success":"Completed","roboneo_web_image_fusion_failure":"Failed","roboneo_chat_resources_num_limit_tips":"You can add up to {img_num} video and {video_num} images.","RoboNeo_Web_export_confirm_tip_popup_title":"You can choose whether to export with an \\"AI-generated\\" watermark.","RoboNeo_Web_export_confirm_tip_popup_btn":"Got it.","Tip_UploadImagesFormat_Batch":"Drag or click to upload JPEG/JPG/PNG images within ${0} MB. Up to ${1} images supported.","Text_SelectedModulesCount_Batch":"${0} items selected","Tip_DefaultFollowGlobal_Batch":"If unchanged, follows global settings by default","Label_ModuleSelection_Batch":"Module Selection","Label_SelectRequiredModules_Batch":"Choose The Modules You Need","Title_Dialog_Invite2":"Invite Friends, Earn Pro Days and Credits","Desc_Dialog_Invite2":"Share the link with friends or post it on social media. When a friend registers through your link, both of you receive <strong>${0} days of Pro + ${1} credits</strong>; if your friend subscribes <strong>within ${2} days</strong>, both of you get up to <strong>${3}</strong> additional credits.","SubTitle_Rewards1_Invite2":"Pro Days Earned","SubTitle_Rewards2_Invite2":"Credits Earned","SubTitle_Rewards3_Invite2":"Friends Invited","Text_Rule1_Invite2":"When a friend signs up through your link, you both get <strong>${0} days of Pro + ${1} credits</strong>.","Text_Rule2_Invite_zawa":"If your friend <strong>subscribes within ${0} days</strong>, you’ll both get extra credits (<strong>Plus +${1}, Pro +${2}, Max +${3}</strong>). Each friend can earn this bonus once, based on their first active plan.","Text_Rule3_Invite2":"Gifted Pro days are added to your subscription period: if you\'re already subscribed, your expiration date will be extended, and you\'ll always receive the highest-tier benefits currently available.","Text_Rule4_Invite2":"Credits are added to your balance, <strong>valid for 30 days</strong>, and can be used for Fast generation with all AI Agent models.","Text_Rule5_Invite2":"Subscriptions are non-refundable once plan benefits have been used or bonus credits have been consumed; free rewards cannot be reversed once used.","Text_Rule6_Invite2":"Rewards will not be issued for existing accounts, self-invites, duplicate accounts, or fraudulent activity; ${0} reserves the right to adjust the promotion and reclaim rewards from accounts with irregular activity.","Title1_Invited_Invite2":"A friend invited you to join ${0}. Get ${1} days of Pro + ${2} credits","Text_DaysBadge_Invite":"${0} day(s)","Title_Reward_Registered":"Try Pro free for ${0} days","Title_Reward_Invite":"Get ${0} days of Pro free, plus ${1} credits","Desc_Reward_Invite":"Get ${0}-Day Free Pro, Unlimited AI Tools","Button_StartCreate_Invite":"Start Editing","Text_InviteMore_Invite":"Invite friends to get more Pro days and credits","Title_WelcomeOnboarding":"Welcome to Zawa!","Title_ContentIntentOnboarding":"What is your main goal for creating content?","Text_ReferralCreditsOnboarding":"You signed up through a referral, so we\'ll automatically add <>${0} credits</> to your account.","Option_ProductVideoOnboarding":"Videos for my product","Option_SocialPostOnboarding":"Social media posts","Option_LogoBrandOnboarding":"Create logos and brands","Button_MaybeLaterOnboarding":"Later","Title_FirstVideoOnboarding":"Create your first video for free","Desc_FirstVideoOnboarding":"Start with a product photo or reference image and generate a video ready to post on Instagram.","Title_FirstSocialPostOnboarding":"Create your first social media post for free","Desc_FirstSocialPostOnboarding":"Upload a photo or describe what you need to get a set of polished, ready-to-post social media posts.","Title_FirstLogoBrandOnboarding":"Create your first logo or brand for free","Desc_FirstLogoBrandOnboarding":"Describe your brand and quickly get a professional logo and visual concept.","Text_TryFreeProOnboarding":"<>Try Zawa Pro free for 3 days</>, no bank card or payment required.","Text_FreeVideoOnboarding":"<>Get 1 free video generation chance</>. No bank card or payment required.","Text_FreeImagesOnboarding":"<>Get 4 free image generations</>, no credit card or payment required.","SubTitle_Invited_Invite_zawa":"Your friend invites you to try Zawa, an AI Agent dedicated to brand design. Easily create logos, visual identity, posters, menus, social media assets, and brand videos. Sign up now — both you and your friend will get a ${0}-day Pro membership and ${1} credits. If you subscribe within ${2} days, you\'ll also receive bonus credits: Plus +${3} credits, Pro +${4} credits, Max +${5} credits.","SubTitle_Invited_Invite_dk":"Your friend invited you to try Designkit, an AI Agent focused on commercial design. Easily create product images, detail pages, promotional posters, e-commerce banners, social media assets, and product videos. Sign up now to get ${0} days of Pro membership and ${1} credits for both you and your friend. Subscribe within ${2} days to earn extra rewards: ${3} bonus credits for Basic and ${4} bonus credits for Pro.","Text_Rule2_Invite_dk":"When a friend <strong>subscribes within ${0} days</strong>, you both get extra credits (<strong>Basic +${1}, Pro +${2}</strong>). One reward per friend, based on the first active plan.","Tool_AIVideoGenerator":"AI Video Generation","Tool_AIVideoAdMaker":"AI Video Ad Creation","Tool_AIVideoEditor":"AI Video Editor","Title_AIWatermark":"AI Watermark","Title_FileSavePreference":"File Saving Preferences","Label_IncludeAIWatermark":"Includes AI Watermark","Button_ConfirmDownload":"Confirm Download","Button_AgreeAndContinue":"Agree and continue","Text_DontRemindAgain":"Do not notify me again.","Button_DownloadApp":"Download the app","Title_DownloadAppForMoreFeatures":"Download the app to access more advanced features","Tip_Download7DaysFreeTrial":"Download to start a 7-day free trial","Message_LoginExpiredRelogin":"Login error. Please log in again.","Title_BindPhone":"Bind phone number","Tip_BindPhoneForCollaboration":"Link your phone number to collaborate with others in real time.","Tip_OnlyPSDSupported":"Only PSD files are supported","Button_OpenPSD":"Open PSD","Desc_AIDisclaimer":"Before using this service, you must understand that AI-generated content is based on artificial intelligence\'s deep learning from large datasets, and some information may contain flaws, be unreasonable, or cause discomfort. Therefore, Meitu makes no guarantees regarding the accuracy, completeness, or functionality of content generated by algorithms, and assumes no legal liability, including for infringement of third-party rights. In addition, because the AI design service generates related content based on the text you enter, you are responsible for making reasonable choices regarding the information you enter and the generated content. You must ensure that you use this service and the AI-generated works it produces in accordance with the law, do not infringe any third party\'s copyrights, trademarks, or other legal rights, and do not use the generated works for any illegal purpose. If your improper use causes damage to any third-party rights or interests, you will bear the corresponding legal liability in accordance with the law.","Text_Disclaimer":"Disclaimer","Message_ConnectFailed":"Connection failed: ${0}","Placeholder_SelectFont":"Select Font","Message_MaxImageUploadSize":"Only supports images up to ${0} x ${1}","Title_StorageFull":"Your storage is full","Title_StorageFullPleaseClean":"Storage is full. Free up space.","Desc_StorageFull":"Your ${0} storage is full. Delete some content ${1}, or previous editing records may be lost.","Desc_StorageFullAigc":"Your ${0} storage is full. This generated content will be <strong>temporarily stored for 7 days</strong>. Delete some content ${1}, or your creation history may disappear.","Text_Free":"Free","Text_OrUpgradeMember":"Or upgrade your membership","Text_UnlockMoreStorage":"Unlock more storage space","Text_FilesSavedForever":"Files can be saved indefinitely.","Button_UpgradeMember":"Upgrade","Button_CleanSpace":"Clean up","Title_FileExpiringSoon":"Your file is about to expire","Desc_FileExpireAutoClean":"Files will be automatically cleared after they expire. Manage your creations promptly.","Button_OrganizeFiles":"Organize Files","Title_RemainingDownloads":"Remaining downloads","Text_PriorityConsumeExpiring":"Use expiring downloads first","Text_PermanentValid":"Permanently valid","Text_Sheet":"image(s)","Text_ExpireInDays":"Expires in ${0} days","Text_ConsumeTiming":"Downloads:","Tip_CutoutConsumeRule1":"When you download cutout images in the cutout editor, we will deduct the corresponding number of downloads.","Tip_CutoutConsumeRule2":"2. Repeated downloads of images that have not been reprocessed or cut out will not be deducted from your download count.","Text_InviteSuccessReward":"You’ve been invited successfully. Join Meitu Posters to claim your reward.","Desc_DesignKitIntro":"Meitu Designer, the essential AI design tool for e-commerce sellers. From product image sets and model image sets to shoppable video generation, poster design, and photo editing, it helps users create a full set of e-commerce assets in one place with AI.","Title_TeamMeidouShared":"Team credits are available to all members","Desc_PersonalMeidouTransfer":"To transfer personal credits to a team, contact customer service.","Button_SwitchTeamRecharge":"Switch teams and top up","Button_CreateTeamRecharge":"Create A Team And Top Up","Title_SubscribeSuccess":"Subscription successful","Text_MeidouRechargedTo":"Credits have been added to","Button_GoToTeam":"Go to Team","Text_OnePayMultiShare":"Top Up Once, Share Across Multiple Accounts","Text_InviteMembersShareMeidou":"Invite Members To Share Credits","Menu_SwitchPersonalTeam":"Switch Personal/Team","Menu_TeamManagement":"Team Management","Menu_InviteFriendsEarnCash":"Invite Friends to Earn Cash","Text_Personal":"Personal","Text_PersonalDesigner":"Individual Designer","Text_EnterpriseSwitch":"Switch Enterprise","Button_Recharge":"Top up","Text_Detail":"Details","Tip_DesignKitIndependentPlan":"Meitu Design Studio has its own subscription plans and does not share benefits with WPS membership.","Text_MeidouWpsOnly":"Credits (WPS Only)","Text_SheetCount":"Cutout amount","Desc_ExchangeConfirm":"Are you sure you want to redeem ${0} cutout credits for ${1} days of membership?","Message_LoadOrderFailed":"Failed to load order data","Message_ExchangeSuccess":"Redeemed successfully","Message_ExchangeFailed":"Failed to redeem","Text_NoOrderRecords":"No order records found","Text_OrderDate":"Order Date:","Text_VipExchangeRule1":"1. Cutout is unlimited during your subscription and won’t use any credits.","Text_VipExchangeRule2":"2. Paid Cutout credits can be redeemed for a subscription.","Text_VipExchangeLocation":"· Redemption location: Tap profile picture -> Photo count.","Text_VipExchangeNoExchange":"·If you choose not to redeem, you can continue using your membership. The validity period will remain unchanged.","Text_VipExchangeGiftSheets":"·Bonus credits from your membership can’t be used to redeem a membership and can be used before they expire.","Text_VipExchangeRule3":"3. Membership no longer includes free credits","Text_BackToPrevious":"Previous","Title_WpsPay":"WPS Pay","Text_CloseModal":"Close","Text_FavoriteDesignKit":"Bookmark Meitu Design Studio","Button_Visit":"Access","Desc_VisitChinaSite_Cutout":"Do You Want To Visit The Meitu Cutout China Site? Click Visit To Go To The China Site.","Desc_VisitChinaSite":"Would you like to visit the Meitu DesignRoom China site? Click [Visit] to proceed.","Desc_VisitingGlobalSite_Cutout":"You’re visiting Designkit Cutout (Meitu Cutout global site). Users in China, please visit the China site.","Desc_VisitingGlobalSite":"You are visiting Designkit, the global site of Meitu Design Studio. Users in China, please visit the China site.","Button_StayCurrent":"Stay Here","Button_BackToChinaSite":"Back to China Site","Title_DownloadWork":"Download","Label_WorkType":"Type","Button_Downloading":"Downloading...","Tip_UploadImageForBetterResult":"After uploading an image, enter clear editing instructions for better results.","Label_SceneElement":"Scene Elements","Placeholder_SceneElementDesc":"Edit image elements or subjects with a text prompt. For example: Replace the XX in the image with the XX I uploaded.","Label_MainTitle":"Main title","Label_SubTitle":"Subtitle","Label_Copywriting":"Copywriting","Tip_ModifyBeforeGenerate":"Edit the image and text before generating","Button_ReEdit":"Re-Edit","Message_MaxUploadImages":"You can upload up to ${0} images","Text_CompletedPercent":"(${0}% Complete)","Text_PreviewImage":"Preview","Text_EnterCanvasEdit":"Edit in Canvas","Title_GenerateSame":"Create","Text_ConfirmLeaveGenerating":"Generating. Are you sure you want to leave?","Text_BuildingVisualScheme":"Creating visual design...","Text_OptimizingLayout":"Optimizing layout and information hierarchy...","Text_FineTuningFont":"Fine-tuning font and spacing...","Message_GenerateSuccessCost":"Generated successfully! Spent ${0} credits","Title_ConfirmDelete":"Confirm Delete","Text_DeleteFontWarning":"After deletion, all team members will no longer be able to apply this font.","Text_AppliedWillReplace":"The applied creation record/font style will be automatically replaced with","Text_DefaultReplaceFontName":"Alibaba-PuHuiTi-R","Text_Deleting":"Deleting...","Message_DeleteSuccess":"Successfully deleted!","Text_NoMore":"No more content...","Text_NoFonts":"No fonts yet","Button_UploadFont":"Upload Font","Message_FontFormatInvalid":"Font file ${0} is in an invalid format","Title_AuthConfirm":"Authorization Confirmation","Text_FontAuthConfirm":"For fonts you add yourself, make sure you have the necessary authorization from the copyright owner and/or related rights holders.","Text_DuplicateFontsConfirm":"The following fonts may be identical. Please confirm.","Text_Uploaded":"Photo uploaded","Button_ConfirmUpload":"Confirm Upload","Text_FontsCannotUpload":"Unable to upload the following fonts","Button_ReUpload":"Upload again","Message_MaxFontUpload":"You can upload up to 20 font files at once","Message_UploadSuccess":"Uploaded","Text_FontUploading":"Uploading fonts...","Tip_FontUsageRight":"Reminder: Make sure you have the right to use the font and a commercial license.","Title_FriendlyTip":"Friendly Reminder","Text_TemplateMigrated":"Templates from Template Library have been moved to Projects. Go to Projects to view team templates.","Button_GoNow":"Enter now","Tab_FontLib":"Font Library","Tip_SwitchIdentityHint":"Tap your profile picture in the top-right corner to switch between Personal and Team profiles.","Text_IdentityResourcesIndependent":"Design resources (such as Editing Records) are kept separate for each identity","Text_IdentitySwitched":"Account switched","Text_DefaultTeamName":"${0}\'s Team","Message_FillTeamInfo":"Fill in all team information","Message_TeamNameMaxLength":"Enter a team or company name (up to 20 characters)","Title_CreateTeam":"Create Team","Label_TeamName":"Team Name","Placeholder_TeamName":"Enter a team name","Button_FreeCreate":"Create for Free","Tip_TeamNameEditable":"Team name can be changed anytime","Text_EnjoySvipRights":"Enjoy SVIP Benefits","Text_TeamPermissionMgmt":"Team Permissions Management","Text_MemberFolderCollab":"Member Folder Collaboration","Text_TeamExpired":"This team has expired","Text_RenewToUse":"Renew or update to continue using it.","Text_VipTeamRights":"VIP Team Benefits","Text_ViewDetailRights":"View Benefit Details","Button_SwitchPersonal":"Switch to Personal","Text_Frozen":"Your account has been frozen.","Text_MemberOverLimit":"Member limit exceeded","Text_ContactOwner":"Contact the team owner to continue using this.","Text_TeamNoSupport":"This feature is not available for team/business accounts yet.","Text_SwitchToPersonalHint":"Switch to Personal if needed","Button_SwitchToPersonal":"Switch to Personal","Text_FeatureNotAvailable":"This feature is currently unavailable.","Text_ReloginPersonal":"Log in again with a personal account to use this feature.","Button_BackHome":"Home","Text_PersonalEdition":"Personal","Text_TeamEdition":"Team","Text_EnterpriseEdition":"Enterprise Plan","Text_FreeEdition":"Free","Text_RemovedFromTeam":"You have been removed from the team","Text_RejoinTeamHint":"To rejoin the team","Text_ContactOwnerToInvite":"Contact the owner/admin to send an invitation","Button_SwitchOtherIdentity":"Switch to Another Account","Button_FreeCreateTeam":"Create a Team for Free","Text_SelectIdentity":"Select Account Role","Text_SelectTeamIdentity":"Select a team role","Text_EditingSaveLocation":"If an edit is in progress, your editing/generation records will be saved to ${0}\'s space.","Text_CreateNewTeamFree":"Create a New Team for Free","Text_MemberCount":"${0} customers","Text_SavedToHelloDigitalAsset":"Saved to HelloRF Digital Assets","Text_Admin":"Administrator","Text_Member":"Member","Title_FreeMemberLimit":"Free plan supports up to ${0} members","Title_SeatInsufficient":"Not Enough Membership Seats","Button_UpgradeTeam":"Upgrade to Team","Button_AddSeat":"Add Seats","Text_UpgradeForMoreSeats":"Upgrade to Team Membership to increase the seat limit","Text_AddSeatToInvite":"Add more seats to invite more members.","Title_InviteMember":"Invite","Text_InviteSeatRemaining_Free":"You can invite ${0} more members to join the team for free","Text_InviteSeatRemaining":"You can invite ${0} more members to join the team","Text_ShareDesignAssets":"Share design work and elements together","Text_ShareVipAndCredits":"Share your membership and AI generation credits","Text_InvitedUserPermission":"Invited User Permissions:","Text_NoInvitePermission":"Only team owners or admins can invite others. You don\'t have permission to invite people to the team yet.","Text_RemainingCount":"Remaining: <span>${0}</span>","Button_RedeemMemberDays":"Redeem <span>${0}</span>-day membership","Desc_InviteReward_DesignKit":"Join Meitu DesignKit now and get a total of <strong>80 credits</strong> for image generation and editing. You will also receive a subscription discount, with <strong>up to ¥22 off.</strong>","Text_ClickTopRight":"Click the <span class=\\"primary\\">top-right corner</span> of the website","Option_SetEditable":"Set as editable","Option_SetViewable":"Set As Viewable","Option_Reject":"Reject","Message_BindSuccessPermissionAdjusted":"Successfully linked. Permissions updated","Message_ModifyFailedBindPhone":"Update failed. Bind a phone number, then try again.","Text_AskersApplyAccess":"Access requested by ${0} and ${1} others","Text_PersonalUser":"Personal users","Text_ApplyAccess":"Request Access","Option_Viewable":"View","Option_Editable":"Edit","Option_Manageable":"Manageable","Text_Invited":"Invited","Text_NoSearchResult":"No results","Title_AddCollaborator":"Add Collaborator","Placeholder_AddCollaboratorByName":"Enter a member name to add collaborators","Title_Recommend":"Recommended","Text_PeopleCount":"${0} customers","Message_BindSuccessCollaboratorAdded":"Successfully linked. Collaborator added","Message_AddFailedChangePermissionOrBindPhone":"Failed to add. Change the permission to \\"Can view\\" or link your phone number, then try again.","Message_SelectAtLeastOneCollaborator":"Select at least one collaborator!","Message_ShareSuccess":"Shared successfully!","Tip_AddCollaboratorDirectAccess":"Once added, they can access it directly from \\"Shared With Me\\" without a link.","Text_TotalPeople":"${0} People","Option_Remove":"Remove","Tip_PermissionChangedToEdit":"This collaborator\'s actual permission has been changed to Edit","Tip_AnyoneWithLinkCanEdit":"Because anyone with the link can edit","Tip_TeamMemberWithLinkCanEdit":"Because team members with the link can edit.","Title_CollaboratorManage":"Collaborator Management","Tag_OutsideTeam":"Outside the team","Title_RemoveKeepTeamMembers":"Once removed, only collaborators currently on the team can continue to access it.","Title_RemoveOnlySelfAccess":"After removal, only you can access it.","Option_OnlyCollaborators":"Collaborators only","Option_OnlySelf":"Only Me","Text_OthersNeedApply":"(Others need to request access)","Option_PermissionUnchanged":"Permissions unchanged","Option_TeamMembers":"Team Members","Text_TeamMembersViaLink":"Team members via link","Option_Anyone":"Anyone","Text_AnyoneViaLink":"Anyone with the link","Text_UntitledDesign":"Unnamed design","Message_BindSuccessLinkCopied":"Successfully linked. Share link copied","Message_ShareFailedChangePermissionOrBindPhone":"Failed to share. Change the permission to \\"Can View\\" or link a phone number to share.","Text_LinkUpdating":"Updating link...","Tip_FolderShareTeamOnly":"Folders can only be shared with team members.","Text_CollaboratorCount":"Collaborators: ${0}","Button_Manage":"Manage","Tooltip_PartialPermissionChanged":"Some collaborators\' permissions have changed","Tip_FolderLinkVisitorBecomeMember":"Users who access the folder via the link will automatically become members of your team.","Tip_OnlyTeamMembersCanAccess":"Currently, only team members can access this","Tip_InviteUserNotInTeam":"If the user you want to share with hasn’t joined the team yet, please","Button_InviteMember":"Invite","Text_ShareLinkView":"${0}#I shared ${1}. Tap to view","Text_ShareLinkJoin":"${0} invites you to join ${1}. Tap to join.","Text_ShareLinkApplyVisit":"${0}#I request access to ${1}. Tap to process the application.","Text_ShareLinkApplyEdit":"${0}#I have requested to edit [${1}]. Tap to process the request.","Option_7Days":"7 days","Option_30Days":"30 days","Option_Permanent":"Permanent","Text_Slogan_DesignKit":"A Must-Have Tool for E-commerce Professionals","Button_RemoveNonTeamCollaborator":"Remove External Collaborators","Button_RemoveNonPersonalCollaborator":"Remove non-individual collaborators","Text_freePlan_Zawa":"Free","Text_standardPlan_Zawa":"Plus","Text_proPlan_Zawa":"PRO","Text_maxPlan_Zawa":"Max","Tool_IDPhoto":"ID Photo","Tool_PortraitPhoto":"Profile Photos","Tool_ImageBatchProcess":"Batch Image Processing","Tool_AiShoes":"Footwear Model","Tool_AiCopywriting":"AI Copywriting","Tool_AiPoster":"AI Poster","Tool_OnlineDesign":"Online Design","Tool_ClothesDewrinkle":"Remove Clothing Wrinkles","Tool_PortraitBackground":"Background","Tool_ViralVideo":"Viral Video","Tool_AiPosterNote":"AI Image & Text Notes","Title_WholeProductClone_DomesticCloneCase":"Reuse Entire Product Set","Title_ApparelClone_DomesticCloneCase":"Reuse outfits with ease","Title_PosterCoverClone_DomesticCloneCase":"Reuse Poster Cover","Prompt_PosterThemeChange_DomesticCloneCase":"Recreate instructions: Change to a city-themed poster","Title_SocialGraphicsClone_DomesticCloneCase":"One-Tap Social Post Reuse","Prompt_SocialThemeChange_DomesticCloneCase":"Recreate instructions: Change to a Xiamen travel-themed image and text post","Title_CloneType_LeftPanelClone":"Reuse Type","Text_CloneReferenceUploadLimitTip_Clone":"Add up to ${0} images — each reference generates 1 output.","Option_MatchStyle_Clone":"Match Style","Option_MatchReference_Clone":"Match Reference","Message_ClaimFailed":"This benefit can’t be claimed right now. Please try again later.","Message_RedeemFailed":"Redemption failed. Try again later.","Button_UpgradeTeamVip":"Upgrade to Team Membership","Message_SystemError":"Something went wrong. Try again later.","Label_AgentTeam":"AI Agent Teams","Desc_AgentTeamBanner":"Enter AI Agent Teams mode, where experts automatically team up to handle complete planning and visual design with a single prompt.","Text_SearchResultCount":"Search results · ${0} results","Button_ExitAdmin":"Exit Management","Text_InviteReward":"Invitation Benefits","Button_More":"More","Text_TeamExpiredTip":"This team has expired. You can only view and move items within the team. Renew or upgrade to continue using all features.","Text_TeamFrozenTip":"This team has exceeded the member limit. Your account has been frozen. Contact the team owner to continue using it.","Desc_ImageEdit":"Import an image and start editing","Desc_ViralVideo":"Generate multiple types of viral videos in bulk with one click","Desc_ProductImageSet":"Generate a full set of e-commerce product images in one click","Title_RecommendTools":"Recommended Tools","Button_CloseVideoPreview":"Disable Video Preview","Label_PromptDesc":"Prompt Description","Tab_Preview":"Effect","Tab_Report":"Analysis Report","Button_Preview":"Preview","Button_PrevPage":"Previous","Button_NextPage":"Next","Text_LoadingHard":"Loading...","Button_ReplicateOne":"AI Recreate","Text_EmptyContent":"No items found","Text_Today":"Today","Text_Tomorrow":"Tomorrow","Text_Yesterday":"Yesterday","Text_DaysLater":"${0} day(s) later","Text_DaysAgo":"${0} days ago","Desc_CreateDesign":"Start with a blank canvas","Title_ClaimSuccess":"Claimed","Text_VipExpiry":"VIP Validity:","Title_ClaimFailed":"Failed to claim","Button_GoDesign":"Design Now","Title_ClientDownload":"Client Download","Desc_DesignKitApp":"Sync creation records across phone and computer for efficient design anytime, anywhere","Title_MeituXiuxiuPC":"Meitu PC","Desc_MeituXiuxiuPC1":"A photo editor for everyday life and work","Desc_MeituXiuxiuPC2":"And easy-to-use design tools!","Button_DownloadNow":"Download Now","Text_Pending":"Awaiting Payment","Text_MoreFunctions":"Multiple formats","Text_NoMessages":"No messages found","Tab_SystemMessage":"System Messages","Tab_Notification":"Notification","Button_MarkAllRead":"Mark all as read","Label_Folder":"Folder","Label_Record":"Editing Records","Label_Template":"Templates","Text_RequestAccess":"Request Access","Text_EditViewDownload":"(Edit, View, Download)","Text_ViewDownloadOnly":"(View and download only)","Text_TeamRenewSuccess":"Your Team Membership has been successfully renewed","Text_TeamRenewExpiredTip":"Renew now to unlock unlimited access to enterprise commercial templates, elements, and exclusive features for the whole team.","Label_SystemNotice":"System Notification","Label_PromptTutorial":"Prompt Tutorial","Label_BrandSpec":"Brand Guidelines","Label_ContactBusiness":"Contact Sales","Text_ScanConsultant":"Scan to contact a dedicated team consultant","Tab_Project":"Project","Placeholder_SearchProject":"Enter a project name or keywords","Placeholder_SearchRecipe":"Enter template or model name","Placeholder_SearchTemplate":"Enter template keywords or feature name","Title_HotTools":"Trending Tools","Title_HotTemplates":"Trending Templates","Title_PosterTemplate":"Graphic Design Templates","Text_NotFoundTemplate":"Can’t find a template you like? Click here","Button_Feedback":"Feedback","Button_ViewAllTemplates":"View all templates","Tooltip_OpenNewTab":"Open in New Tab","Button_BookDemo":"Schedule a Demo","Title_ApplyTeamDemo":"Request a Team Demo","Desc_ContactWithinOneDay":"After you submit your information, we will contact you within 1 business day.","Title_LeaveContactInfo":"Please leave your contact information so we can provide better 1v1 support.","Title_FreeTeamVipSurvey":"Fill in your team details to get a 7-day free Team Membership","Label_SingleUser":"Single-person use","Text_MemberCountRange":"${0}~${1} customers","Text_MemberCountRangeDash":"${0}-${1} People","Text_MemberCountOrMore":"${0}+ people","Label_TemplateReuse":"Upload and reuse templates","Label_MultiCollaboration":"Collaborative Editing","Label_EnterpriseLicense":"Enterprise Commercial Licensing","Label_SharedCredits":"Team-shared credits and cutouts","Label_BrandManagement":"Brand Specifications Management","Label_YourName":"Your Name","Message_PleaseEnterName":"Please enter your name","Label_YourPhone":"Your Mobile Phone Number","Message_PleaseEnterPhone":"Enter your mobile or landline number","Message_PleaseEnterValidPhone":"Enter a valid mobile number","Label_CompanyName":"Enterprise Name","Message_PleaseEnterCompanyName":"Please enter your company name","Placeholder_EnterCompanyName":"Enter your company name","Label_ProductUsers":"Number of people using the product","Message_PleaseSelectProductUsers":"Select the number of people who will use the product","Label_TeamCapabilitiesInterest":"Which Posters Team features would you like to learn about most?","Text_MultiSelectParen":"(Multiple choice)","Message_PleaseSelectCapabilities":"Select the Meitu Design Studio features you’d like to learn more about","Placeholder_TeamCapabilities":"Commercial Copyright Protection, Shared Benefits For Multiple Users, Digital Asset Management, Team Collaboration, Other","Button_Submit":"Submit","Desc_ManagerWillContact":"Your dedicated account manager will contact you within 1–2 business days. Please make sure you’re reachable by phone.","Title_ScanToInvoice":"Scan the QR code with your mobile browser to get an invoice","Text_InvoiceOrderScope":"Use this link to request an invoice for Meitu Design Studio orders.","Text_TransferInvoiceContact":"For corporate bank transfer orders, click Contact in the bottom-right corner to request issuance.","Desc_MenuProjectGuide1":"[My space] and [Shared with me]","Desc_MenuProjectGuide2":"Everything is now organized in Projects","Text_SetPrefix":"Set as","Text_TodayWithTime":"Today ${0}","Text_YesterdayWithTime":"Yesterday ${0}","Format_MonthDay":"M D","Format_YearMonthDay":"M/D/YYYY","Text_MultiPage":"Multiple Pages","Text_PageCount":"${0} pages","Text_ViewOnly":"View Only","Text_NoPermission":"No access","Button_JumpToStorage":"Skip To Storage Location","Label_PageUnit":"Page","Label_JumpTo":"Try Now","Text_TotalDataCount":"${0} items","Title_RelateRecommend":"Recommended","Title_HotSearch":"Popular Searches","Title_LatestMaterial":"Latest elements","Title_TopicList":"Hot Topics","Title_ArticleList":"Popular Articles","Title_ToolList":"Popular Tools","Text_AccountOnePerson":"Account: 1 person","Text_AccountTenMin":"Accounts: Minimum 10 users","Text_LetsTalk":"Let\'s Chat","Text_NewUserExperience":"New User Experience","Text_Buy12Months":"Buy 12 Months","Text_LinkExpired":"This link is unavailable","Text_ContactAdminToJoin":"Contact the administrator to join","Desc_JoinOrgCollaboration":"Join the organization and start collaborating efficiently with your team","Button_AcceptInvite":"Accept Invitation","Title_ConfirmNickname":"Confirm your nickname for the team","Placeholder_NameWithin20":"Please enter a name within 20 characters","Desc_NicknameHelp":"Your nickname helps your colleagues find you more easily.","Title_TeamVipExpired":"Team membership expired","Title_TeamSeatsInsufficient":"Not enough Team Membership seats","Button_SeatAssignment":"Seat Assignment","Text_MemberSeatCount":"Members/Seats:","Text_FreeSeatsFrozen":"Members beyond the free seat limit have been frozen","Desc_RenewTeamForAll":"To keep access for all members, renew your Team Membership.","Text_SeatsExceededFrozen":"Members over the seat limit have been frozen.","Desc_AddSeatsForAll":"To enable access for everyone, purchase additional Team Membership seats.","Title_TeamToolUnsupported":"This tool is not supported in Posters Team Edition.","Desc_SwitchPersonalToUse":"To use this tool, switch to the Personal version.","Label_RegularTemplate":"Standard Templates","Label_Suite":"Set","Label_Filter":"Filter","Label_Sort":"Order","Label_Scene":"Scenario","Label_Materials":"Materials","Label_Purpose":"Use","Label_Industry":"Industry","Label_Color":"Color","Label_Format":"Layout","Label_Category":"Category","DesignKit":"美图设计室","Placeholder_SearchTemplateMobile":"Search templates","Label_DesignType":"Design Type","Label_TemplatePurpose":"Template Purpose","Label_TemplateStyle":"Template Style","Label_TemplateColor":"Template Colors","Label_ApplicableIndustry":"Applicable Industries","Label_TemplateSize":"Template size","Label_UsageThreshold":"Beginners can use","Label_TemplateNumber":"Template Number","Desc_ScrollViewAllPages":"Scroll up or down to view all pages","Title_SimilarPosterRecommend":"Similar Poster Recommendations","Button_EditCurrentTemplate":"Edit current template","Button_EditAllTemplates":"Edit All Templates","Button_EditNow":"Edit now","Title_RecordUpgrade":"New updates available!","Desc_RecordUpgrade1":"Includes all poster templates and photo editing records under this account. Seamlessly switch from editing photos to designing posters.","Desc_RecordUpgrade2":"Seamlessly switch from editing images to designing posters.","Footer_AboutUs":"About us","Footer_JoinUs":"Join Us","Footer_ContributeCenter":"Contributor Center","Title_HomeAgentTeam":"AI Agent Teams - Business Design That Looks Great and Gets Results","Title_HomeChat":"Tell me what you’d like to create.","Nav_Home":"Homepage","Title_BrandManagement":"Brand Management","Nav_HelpDesign":"Design for Me","Title_OrgInfo":"Organization Information","Title_MemberManage":"Member Management","Title_DataDashboard":"Data Dashboard","Title_CommercialAuth":"Worry-Free Commercial Use","Title_OrderInvoice":"Order Invoice","Title_TeamCollaboration":"Team Collaboration","Title_CopyrightGallery":"Copyright Photo Gallery","Title_DownloadCenter":"Download Center","Nav_TodayRecommend":"Recommended Today","Nav_HotCalendar":"Festivals","Nav_InspirationFormula":"Inspiration Templates","Nav_OneClickSame":"Derivatives","Title_PosterTemplateNav":"Poster Templates","Message_NetworkError":"Network error, cannot connect to the server.","Text_Downloading":"Downloading resources","Text_DownloadResourceFailed":"Failed to download resources","Title_DesignKitScanLogin":"美图设计室 Scan to Log In","Desc_ScanGuideLogin":"Go to Me and tap \\"Scan\\" in the top right to log in","Message_AlreadyFullVip":"You already have full membership benefits. No purchase needed.","Message_ImageSizeExceeded":"Image size limit is exceeded","Text_NotLoggedIn":"Not logged in","Button_CreateBrandSpec":"Create Specifications","Title_BrandAdvQuestion":"Still asking colleagues for LOGO, fonts, and brand color values?","Desc_BrandAdv1":"Designer Preset Logo, Brand Color Values, Text Style, Font Library","Desc_BrandAdv2":"Configure visual guidelines for different brands or projects.","Desc_BrandAdv3":"Team members across departments can quickly add and apply specifications in the editor","Button_UpgradeTeamForBrand":"Upgrade to Team Membership to use brand guidelines now","Title_ConfirmDeleteBrandGroup":"Delete this set of standards?","Text_DeleteBrandNoAffect":"Applied editing records will not be affected.","Button_CreateBrandStandard":"Create Brand Specifications","Title_DeleteHint":"Delete image","Text_DeleteIrreversible":"Once deleted, it cannot be retrieved. Proceed with caution.","Label_General":"General","Label_ColorCard":"Color Card","Label_TextStyle":"Text style","Message_SavePrevStyle":"Save previous style","Message_SavePrevColorCard":"Save the previous color card","Message_SavePrevElement":"Please save the previous element first.","Button_NewColorCard":"Create Shade","Button_NewStyle":"Create Style","Message_NameWithinN":"Enter a name (up to ${0} characters)","Message_ColorBlockLimit":"Each color palette supports up to ${0} color swatches","Message_PleaseSelectFont":"Please Select A Font","Message_PleaseSelectFontSize":"Select a font size","Placeholder_FontSize":"Text Size","Label_Bold":"Bold","Label_Italic":"Italic","Text_FontSizeUnit":"No. ${0}","Text_Claiming":"Claiming...","Button_ClaimFreeBenefit":"Claim Free Benefits","Message_MissingExchangeCode":"Missing Redemption Code","Message_SwitchToPersonalFirst":"Please switch to Personal first","Desc_ClaimBenefitSuccess":"You\'ve claimed this benefit. Head to Meitu Posters and start creating!","Message_ClaimNewUserOnly":"This free benefit is only available to new users registering for the first time.","Text_AiDesignTagline":"AI Design At Your Fingertips","Text_FreeBenefitLimited":"Claim Free Benefits for a Limited Time","Text_ExchangeSceneFeatures":"Commercial Posters · E-Commerce Main Image · AI Removal · AI Cutout","Text_LimitedNewUserOnly":"Limited-Time Offer, New Users Only","Text_SearchWithKeyword":"Search \\"${0}\\"","Text_HelpEmptyHint":"No content yet. Xiaomei will add more soon.","Placeholder_HelpSearch":"What would you like to know?","Button_Search":"Search","Message_SelectImageForTranslation":"Select a picture before using Image Translation.","Text_InviteCopyPrefix":"# Stop wasting time on e-commerce images! Register for Meitu Designer and get free credits instantly. Product sets, detail pages, promotional videos and more — all generated with one click. Click the link to start creating!","Label_DistributionAgreement":"Meitu Design Studio Distribution Service Agreement","Label_DistributionConduct":"Meitu Design Studio Affiliate Service Commission Code of Conduct","Alt_InviteFriendIcon":"Invite friends icon","Alt_BothGetBeanIcon":"Both Get Credits Icon","Text_BothGetBean":"Both Get Credits","Alt_FriendFirstOrderIcon":"Friend\'s First Order Completed Icon","Text_FriendFirstOrder":"Friend completes first order","Alt_RedPacketIcon":"Red Packet Received Icon","Text_RedPacketArrived":"Red Packet Received","Desc_InviteRule1":"1. When a friend you invite successfully signs up, you’ll both get 40 credits. Use them for image generation or photo editing. Valid for one month.","Desc_InviteRule2":"2. You can invite up to 15 friends.","Desc_InviteRule3":"3. Earn cashback when a friend subscribes. Reward calculation: Reward amount = actual payment amount × reward rate (e.g., if a friend purchases an annual auto-renewal subscription, you can get 196 × 15% = 29.4 USD cash reward). Rewards may be adjusted during special events or promotions; the actual credited amount shall prevail.","Desc_InviteRule4":"4. If credits from the plan or any bonus credits have been used, the purchase cannot be canceled, refunded, or exchanged.","Desc_InviteRule5":"5. Users who already have a registered account, refer themselves, create duplicate accounts, or engage in fraudulent activity will not be eligible for rewards.","Desc_InviteRule6":"6. Meitu Design Studio reserves the right to adjust the campaign and revoke rewards from abnormal accounts.","Message_SwitchToPersonal":"Switch to Personal","Message_GetInviteLinkFailed":"Failed to obtain the invitation link.","Message_InviteLinkRetry":"Failed to get invitation link. Please try again later.","Message_CopySuccess":"Copied!","Message_CopyFailedManual":"Copy failed. Copy the link manually.","Text_LoginForInviteLink":"Log in first to get the invitation link","Text_SwitchPersonalForInviteLink":"Switch to your personal profile to get the invitation link","Alt_InviteRewardTitle":"Invite friends to get credits, and subscribe to get cashback","Alt_InviteHeroVisual":"Invite Friends Cashback Key Visual","Button_CopyInviteLink":"Copy the invitation link.","Alt_ActivityRules":"Activity Rules","Desc_InviteRewardSummary":"Invite friends to sign up—both you and your friend get 40 credits each. You can earn up to 600 credits. Your friend also gets a limited-time 7-day subscription discount. If your friend subscribes to Meitu Design Studio membership during the promotion, you\'ll receive cash back.","Text_CommissionRate15":"Commission rate up to 15%!","Text_DetailRules":"Details Rules","Alt_CashoutTutorial":"Withdrawal Guide","Desc_InviteDetailAppPath":"Go to the Meitu Design Studio app > Me > Invite & Earn > Earnings Wallet to view your invitation details.","Desc_InviteDetailAppPathShort":"Go to the Meitu Design Studio app > Me > Invite & Earn > Earnings Wallet to view invitation details.","Desc_InviteSettlementCycle":"Settlement cycle: Subscription orders are settled one month after the order date. This one-month period is the refund cooling-off period. Refunded orders cannot be withdrawn during this period. After the cooling-off period, the revenue share for the corresponding orders can be withdrawn.","Button_LoginToGet":"Log in to get","Button_ClaimNow":"CLAIM NOW","Title_SameStyleReplicate":"Recreate This Look 🌟","Text_PageNotFound":"Page not found","Label_PricingPlan":"Pricing","Title_ChooseMembershipPlan":"Choose the membership plan that suits you","Tab_RenewalYear":"Yearly Renewal","Tab_RenewalMonth":"Continuous Monthly Subscription","Tab_SingleYear":"Annual Purchase","Tab_SingleMonth":"One-Month Purchase","Text_MeidouPerMonth":"${0} credits/month","Title_PersonalVipOnly":"This subscription is only available for Personal accounts. Switch to Personal?","Button_Switch":"Switch","Text_ComingSoon":"Coming soon","Button_SubscribeNow":"Subscribe Now","Text_MostPopular":"Most Liked","Text_Trial7DaysPerYear":"Try 7 Days (${0}/year)","Label_Year":"year","Text_StartingFrom":"Start","Label_DesignRecord":"Design","Label_AgentRecord":"Agent Record","Button_ViewMore":"View more","Placeholder_PleaseEnterContent":"Enter the content","Text_InviteLinkExpired":"This link is unavailable.","Text_RegenerateInviteLink":"Contact your admin to regenerate the invitation link.","Text_JoinedSuccess":"You\'ve successfully joined","Text_UseTeamOnPc":"Visit ${0} on your computer to create with your team","Button_CopyUrl":"Copy URL","Text_InviteYouToJoin":"\\"${0}\\" invites you to join","Button_JoinNow":"Join now","Title_TemplateCenter":"Template Center","Text_NoSuchTemplate":"No templates of this type yet. We’ll add more soon.","Title_DesignKitHome":"Posters Homepage","Label_Tags":"Label","Button_DownloadAppToEdit":"Download X-Design APP to edit","Title_DesignKitTeam":"X-Design ${0}","Desc_TeamLandingQuestion":"Designs rely entirely on designers. How to improve team design efficiency?","Button_UseNow":"Use Now","Text_ViewTeamIntro":"View Full Team Overview","Button_ViewPricing":"View Pricing","Button_EnterTeamNow":"Enter Now","Title_EnterpriseSolution":"Learn More About Enterprise Solutions","Desc_EnterpriseContactForm":"Please fill out the form, and the Meitu Posters team will contact you within 1-3 business days.","Message_CompanyNameMaxLength":"Company name must be 100 characters or less.","Label_Position":"Job title","Message_PleaseEnterPosition":"Enter your current position at this company","Placeholder_EnterPhone":"Enter phone number","Placeholder_EnterPosition":"Enter your current position at this company","Label_ExpectedUsers":"Estimated Users","Title_TeamMaterialEasier":"Create Team Assets More Easily","Label_CommercialTemplate":"Choose any commercial template","Desc_CommercialTemplate":"Authorized businesses can edit and publish a wide range of templates and elements for worry-free commercial use.","Label_BatchDesignSpeed":"Speed Up Batch Design","Desc_BatchDesignSpeed":"Batch Cutout, templates, and automated image production save you tons of time.","Label_VisualStandard":"Unified Visual Specifications","Desc_VisualStandardWork":"Preset color palettes, font styles, and other guidelines to ensure a consistent brand design style.","Desc_VisualStandardHome":"Preset color palettes, text styles, and other guidelines (with font upload support) to keep designs consistent.","Title_TeamCollabEfficient":"More Efficient Collaborative Design","Label_TeamSharedResource":"Team Shared Resources","Desc_TeamSharedResource":"Share folders by department or project with one click and quickly build a design asset library.","Label_FlexiblePermission":"Flexible Permission Settings","Desc_FlexiblePermission":"Set permissions flexibly for each file to prevent design assets from being leaked.","Label_TemplateQuickReuse":"Quickly Reuse Templates","Desc_TemplateQuickReuse":"Upload PSDs to the template library for quick reuse across your team. No more waiting for files.","Title_TeamManageEasier":"Manage members and assets with ease","Label_TeamDataReview":"Team Data Review","Desc_TeamDataReview":"Regularly review members\' creation activity in the backend and adjust team seats as needed.","Label_MemberRoleManage":"Member Role Management","Desc_MemberRoleManage":"Set team administrators, manage member changes, and handle asset handovers.","Tag_ConvenientCreate":"Easy Creation","Desc_FreeEditionAudience":"Available for individuals and teams","Desc_FreeTemplateMaterial":"Free Templates/Elements","Desc_PartialFreeTools":"Smart Tools (Some Free)","Button_FreeExperience":"Free trial","Tag_QualityContent":"High-quality content","Desc_PersonalEditionAudience":"For individual merchants, designers, or independent creators","Desc_IncludesFreeBenefits":"Includes free plan benefits","Desc_PaidTemplateMaterial":"Premium Templates/Elements","Desc_PersonalCommercialAuth":"Personal Commercial License","Desc_Meidou330PerMonth":"330 Credits/Month (For AI Generation Tools)","Tag_EfficientCollab":"Effective Collaboration","Desc_TeamEditionAudience":"For small businesses or freelance teams that need team collaboration","Desc_IncludesProBenefits":"Includes Pro benefits (excluding ID Photo)","Desc_EnterpriseAuthOne":"Commercial licensing*1","Desc_BrandSpecBrief":"Brand Guidelines (Logo/Color Card/Fonts)","Desc_PsdTemplateUpload":"Upload PSD Template","Desc_TeamDataAnalysis":"Team Data Analysis","Desc_TeamResourceShare":"Team Creative Resource Sharing","Desc_SharedPermissionManage":"Shared Permissions Management","Desc_SeatsMeidouPerMonth":"Seats * 330 credits/month (for AI generation features)","Title_MarketingCostControl":"More controllable marketing costs for your company","Label_AiPhotoCostDown":"Cut Costs With AI Product Photography","Desc_AiPhotoCostDown":"AI Product Image and AI Model Try-On help you create polished photos effortlessly, without the need for studio setups or hiring models, ensuring your results never look \\"budget-limited.\\"","Label_AiEditEfficiency":"AI Retouch","Desc_AiEditEfficiency":"Complete photo adjustments, color correction, and product retouching in one click to keep up with product launches and reduce manual retouching costs.","Label_SmartVideoCreate":"AI Video Creation","Desc_SmartVideoCreate":"Image to Video and 3D Commercial Video lower the barrier to creation, so video promotions are no longer held back by long editing cycles and high modeling costs.","Text_TeamAuthSubLabel":"(Team Membership includes an enterprise commercial license)","Title_MoreOptions":"More Options","Title_FreeImageCreate":"Create images for free","Desc_FreeTemplateSlashMaterial":"Free Templates/Element","Desc_PartialFreeSmartTools":"Some free AI tools","Title_IncludesPersonalPlus":"Includes all Personal benefits, plus:","Desc_EnterpriseBizAuthOne":"Enterprise Commercial License (1 Entity)","Desc_TeamAssetShare":"Team Asset Sharing","Desc_BrandSpecFull":"Brand Guidelines (Logo/Color Card/Text Style)","Desc_MemberAccountHandover":"Member Account Management and Offboarding Asset Handover","Desc_TeamUsageAnalytics":"Team Use Data Analysis","Desc_MonthlyMeidouShared":"Get ${0} credits monthly, shared across multiple accounts","Title_IncludesTeamPlus":"Includes all Team benefits, plus:","Desc_EnterpriseBizAuthThree":"Enterprise Commercial Licensing (3 Entities)","Desc_CustomBrandNav":"Custom Enterprise Brand Navigation Bar","Desc_SsoAccess":"SSO Integration","Desc_MonthlyMeidou20000":"20,000+ free credits monthly, shared across multiple accounts","Title_OpenClawApi":"OpenClaw API Integration","Desc_OpenClawApi":"Access X-Design AI image processing capabilities and manage your API token and credit balance.","Title_OpenClawApiShort":"OpenClaw API","Desc_OpenClawMobile":"Manage your API token and credit balance","Title_QuickStart":"Quick Start","Desc_OpenClawQuickStart":"After completing the OpenClaw deployment, send the following command to Lobster to automatically install all skill packages:","Button_CopyInstallConfig":"Copy Installation Configuration","Text_SeeTutorial":"See Detailed Tutorial","Text_DesignkitSkillsDoc":"designkit-skills Documentation","Title_VersionChangelog":"Update to New Version","Text_NoChangelog":"No update history","Message_InstallCmdCopied":"Installation instructions and Token copied","Title_ApiToken":"API Token (AK)","Desc_ApiToken":"Use Token for API request authentication. Click \\"Replace\\" to generate a new Token (the old Token becomes invalid immediately).","Button_CopyToken":"Copy Token","Button_Reset":"More","Button_ResetToken":"More Token","Text_PleaseLoginFirst":"Please log in first.","Text_PleaseLoginDash":"Log in first","Title_ResetToken":"Change Token","Desc_ResetTokenWarning":"Once replaced, the old token will become invalid immediately, and any API calls in progress may fail. Continue?","Message_TokenReset":"Token Reset","Message_TokenCopied":"Token Copied","Desc_OpenClawMeidou":"Credits are the billing unit for OpenClaw API calls. If the balance is insufficient, the API request will fail.","Label_CurrentBalance":"Current balance","Button_BuyMeidou":"Buy credits","Button_ConsumptionRecords":"Spending History","Title_OpenClawFeatures":"OpenClaw Feature Introduction","Desc_OpenClawFeatures":"X-Design\'s AI capabilities are now available via OpenClaw. After AK authentication, you can directly use the following capabilities, billed by credits, with automatic refund on failure.","Desc_OpenClawProductImageSet":"Upload product images, and AI will automatically generate a set of product images that comply with multiple e-commerce platform standards and drive high conversion rates, meeting all image needs for product listing.","Desc_OpenClawSmartCutout":"Powered by Meitu AI, it accurately detects your subject and automatically removes the background, supporting portraits, products, and more scenarios.","Desc_OpenClawEnhanceClarity":"AI Image Quality Repair restores blurry or low-quality images to HD quality with enhanced details.","Button_ConfirmReset":"Confirm","Message_MeidouQuotaMinZero":"Enter a credit amount of 0 or more","Message_MeidouQuotaRange":"Enter a credit amount from 0 to ${0}","Message_AssignSuccess":"Assigned successfully!","Message_SelectAssignableMember":"Select members to assign credit quotas","Message_NameLength1To20":"Please enter a name within 1-20 characters","Placeholder_EnterQuota":"Enter credits","Text_Unlimited":"Unlimited","Text_Unassigned":"Unassigned","Label_MemberName":"Member Name","Text_Me":"Me","Text_Deactivated":"Log out","Text_OverQuotaFrozen":"Frozen due to overage","Label_PhoneNumber":"Phone Number","Label_Role":"Role","Text_Owner":"Owner","Label_QuotaLimit":"Available Credit Limit","Message_SelectMemberCount":"Please select ${0} members","Text_SelectedMemberCount":"${0} selected","Text_RemainingSeats":"Seats remaining:","Button_ConfirmAssign":"Confirm Allocation","Button_BatchSetQuota":"Batch Settings Limit","Title_ChangeRole":"Change Character","Button_RemoveMember":"Remove a member","Text_PartialMemberFrozenTip":"Some members are over-frozen. Try again","Text_Or":"Or","Button_RenewMembership":"Renew","Label_RemainingMeidou":"Remaining credits","Desc_MemberQuotaTip":"Tip: The credits set for members are the usage limit. Actual availability depends on the team’s remaining credits.","Text_MemberEmpty":"No members","Message_DataLoadFailed":"Failed to load data","Title_BatchAssignMeidou":"Distribute credits evenly among the selected ${0} members","Label_AssignCount":"Assigned Customers","Label_TotalConsumption":"Total consumption","Title_ConfirmTransferAssets":"Transfer assets?","Message_TransferAssetsSuccess":"Assets transferred successfully from departing member. Go to check.","Label_MySpace":"My Space","Message_RemoveMemberProgress":"Member removed successfully. Go to check the asset transfer progress.","Message_RemoveMemberSuccess":"Member removed successfully","Title_RemoveMember":"Remove a member","Text_RemovingStep1":"Removing...","Text_AssetHandleStep2":"2. Assets created by this member","Option_TransferToUser":"Transfer to Another User","Text_TransferableAssets":"Transferable Assets","Text_DeletedAssets":"Deleted Assets","Desc_RemovedAssetFolder":"Created folders/editing records (including unshared resources)","Desc_RemovedAssetTemplate":"Uploaded Templates/Elements (Including Unshared Assets)","Desc_RemovedAssetAiRecord":"AI Sets History/Favorites","Text_SelectAssetReceiver":"3. Select Asset Receiving Member","Desc_RejoinAssetRecovery":"If this member rejoins within 30 days, the assets above will reappear in their personal space.","Desc_RejoinAssetExpire":"After 30 days, it will be permanently deleted and can’t be recovered.","Button_ConfirmRemove":"Remove","Text_Last7Days":"Last 7 days","Text_Last30Days":"Last 30 days","Text_Last90Days":"Last 90 days","Text_MemberActiveCount":"Active Members","Text_NewAssetCount":"New Assets","Title_TeamOverview":"Team Overview","Title_ActiveMembers":"Active Members","Desc_ActiveMembers":"Number of members who logged in within the specified time range","Label_PersonUnit":"People","Label_TotalCount":"Total","Title_AiToolGeneration":"AI Tool Generations","Desc_AiToolGeneration":"Total generations by all members using the platform\'s AI tools within the specified time range","Label_TimesUnit":"Times","Label_Accumulative":"Total","Title_TotalAssetDownload":"Total Asset Downloads","Desc_TotalAssetDownload":"Total downloads by all members on the platform within the specified time range","Label_CopyUnit":"reports","Nav_MySpace":"My space","Nav_ShareWithMe":"Shared Content","Nav_SpaceManage":"Storage Management","Nav_AssetHandover":"Offboarding Assets","Label_Text":"Text","Label_Group":"Combination","Label_Table":"Sheet","Label_Chart":"Chart","Label_AiProductShoot":"AI Commercial Photography","Label_AiProductDesign":"AI Product Design","Label_SameStyleReplicate":"Recreate","Button_CreateFolder":"Create Folder","Button_NewFolder":"New folder","Button_UploadFile":"Upload","Button_UploadFolder":"Upload folder","Button_UploadTemplate":"Upload Template","Menu_Rename":"Rename","Button_UseTemplate":"Use","Button_CopyToTeam":"Copy to Team","Text_MoveToMySpace":"Move to my space","Button_ExportContent":"Export","Button_Deselect":"Clear Selection","Text_SelectAllWithCount":"Select All (${0} selected)","Message_PartialFileCannot":"Some of the files you selected cannot be ${0}","Text_NoSearchResultYet":"No results found","Text_SearchNoMatch":"No results found","Text_EmptyGoCreate":"No content yet. Create now!","Text_EmptyGoAction":"No content yet. Go to ${0}.","Text_ActionCreate":"Create","Desc_OrganizeWorks":"Efficiently organize personal or team projects","Message_EnterName":"Enter a ${0} name","Message_EnterNameWithin20":"Please enter a ${0} name within 20 characters","Message_OperationSuccess":"Operation successful!","Message_EnterFolderName":"Enter a folder name!","Message_EnterFolderNameWithin20":"Enter a folder name up to 20 characters","Text_CopyTo":"Copy to","Text_CopyingMayTakeMinutes":"Copying... This may take a few minutes.","Button_GoTeamView":"View In Team","Message_BrowserNoUploadFolder":"Folder uploads are not supported in this browser.","Title_MoveAfterMySpace":"After moving, it will be in My space","Desc_MixSortAfterMove":"Mixed with other assets by update time","Message_HandoverFailed":"Handoff failed","Message_CreateSuccessExclaim":"Created!","Message_NoFilePermission":"You do not have permission to perform this action on this file.","Title_ConfirmDeleteRecord":"Delete the following records?","Title_ConfirmUnfavorite":"If you remove it from favorites, this design result record will be lost. Are you sure?","Title_ConfirmDeleteGenerate":"After deletion, the generated results will be lost. Are you sure you want to delete it?","Text_To":"To","Text_FileOperating":"In file ${0}...","Message_OperateSuccess":"${0} pinned","Text_CurrentDir":"Current Directory","Text_OperateDir":"Action Menu","Text_Creating":"Creating","Text_NoContent":"No content","Title_CancelUploadConfirm":"Uploads are still in progress. Cancel all ongoing uploads?","Button_CancelUpload":"Quit","Message_MaxUploadFiles":"You can upload up to 500 files at a time","Message_PersonalUploadLimit":"Personal accounts support uploading up to 20 files at a time. To upload more than 20 files, create a team.","Title_PsdToTemplate":"Upload a PSD to convert it directly into a team template","Desc_TemplateEditOnly":"Only you can edit the template. Other members can only duplicate it and cannot change the original template.","Link_WhatIsTemplate":"What Are Templates","Button_ConvertTemplate":"Convert to template","Button_UploadOnly":"Upload only","Text_WaitUpload":"Waiting for upload","Text_Transferring":"Transferring...","Text_AllUploadComplete":"All uploads complete","Text_FilesUploadFailed":"Failed to upload ${0} files","Text_UploadingProgress":"Uploading... (${0}/${1})","Button_StartAll":"Start all","Button_PauseAll":"Pause all","Button_CollapseDetail":"Collapse Details","Button_ExpandDetail":"Expand Details","Text_FailDetail":"Failure Details","Text_SharedFolderToYou":"Shared a folder with you","Desc_ClickJoinTeam":"Tap to view and automatically join this team","Text_SeatInsufficientFolder":"Not enough seats. You can\'t join the team to access this folder.","Title_FolderTeamShareOnly":"Folders can only be shared within a team","Button_SwitchTeamCopyFolder":"Switch team and copy folder","Button_CreateTeamCopyFolder":"Create Team and Copy Folder","Message_FolderCopiedToTeam":"Created successfully. The folder has been copied to your team.","Text_UsedSpace":"Used:","Text_StorageSpace":"Storage space:","Text_UsedSpaceLabel":"Used space","Text_UnlockSpace":"Unlock ${0} of extra storage","Button_UpgradeToMember":"Upgrade to Membership","Button_UpgradePremium":"Upgrade to Premium","Desc_SpaceFullUpgrade":"Storage is full. Upgrade for more storage.","Desc_SpaceFullContactAdmin":"Storage is full. Contact the administrator.","Desc_SpaceFullClean":"Storage is full. Free up space now.","Desc_SpaceLowUpgrade":"Less than 10% storage remaining. Upgrade for more storage.","Desc_SpaceLowContactAdmin":"Less than 10% storage space remaining. Contact your administrator.","Desc_SpaceLowClean":"Less than 10% storage space remaining. Free up storage as soon as possible.","Desc_VipExpiredRenew":"Your membership benefits have expired. Renew now.","Desc_VipSoonExpireRenew":"Your membership is expiring soon. Remember to renew.","Desc_SpaceNormal":"This space is available. You can continue saving your creations.","Text_CountUnit":"${0}","Text_SoonExpire":"Expiring soon ${0}","Text_Expired":"Expired ${0}","Text_FileStatus":"File status: ${0}. Please organize it soon.","Desc_TopBannerFilesExpire":"Some of your files are about to reach their storage limit. Manage your files now, or upgrade your subscription to keep them permanently.","Desc_TopBannerSpaceLow":"Less than 10% of your storage space remains. Upgrade your plan for more storage.","Desc_TopBannerSpaceUrgent":"Storage is running low, and some projects will expire soon. Upgrade your subscription for more storage and keep your projects forever.","Desc_TopBannerSpaceLowPremium":"Less than 10% of your storage remains. Upgrade to Premium for more storage.","Desc_TopBannerVipSoonExpire":"Your membership is about to expire. Renew in time to prevent your editing history from expiring and being deleted.","Desc_TopBannerVipExpired":"Your membership has expired. Renew now to avoid losing storage space or editing history.","Desc_TopBannerSpaceLowClean":"Less than 10% of your storage remains. Clear some space now.","Desc_TopBannerVipSoonExpireNoPeriod":"Your membership is expiring soon. Failure to renew in time may result in the deletion of your editing records. Please renew promptly.","Text_AssetHandovering":"Transferring assets...","Text_TransferringStatus":"Transferring","Text_ResignationTime":"Resignation date:","Desc_AssetHandoverTip":"Generation records in departed members\' assets cannot be edited. Other assets do not support moving or uploading. If needed, please move the assets to My Space first.","Message_SelectFileLimit":"Select up to ${0} files","Text_ExpandVersionComparison":"Expand Feature Comparison Across Versions","Text_CollapseVersionComparison":"Collapse Version Feature Comparison","Text_VersionComparisonToggle":"${0} Version Feature Comparison","Text_Consult":"Advice","Text_PricePerMonthWithSymbol":"¥${0}/month","Title_RightsComparison":"Compare Benefits","Text_Trial7Days":"7-Day Trial","Text_UsingNow":"In Use","Text_ConsultBusiness":"Contact Sales","Title_PriceComparison":"Price Comparison","Text_StandardMember":"Standard Premium","Text_EnterpriseMember":"Enterprise Premium","Text_BeansPerMonth":"${0} credits/month","Text_BeansPerMonthFrom":"Starting at ${0} credits/month","Text_WanBeansPerMonthFrom":"From ${0}k credits/mo","Text_SheetsPerMonth":"${0} images/month","Text_SheetsPerMonthFrom":"From ${0} photos/month","Text_WanSheetsPerMonthFrom":"From ${0}K images/month","Desc_FeatureOnlyNote":"${0}<span style=\\"color: #d0d2d6\\">(This feature only)</span>","Text_PersonalCommercial":"Personal Commercial Use","Text_EnterpriseCommercialEntities":"Enterprise Commercial Licensing Entity*${0}","Text_PurchasableSeparately":"Available as a separate purchase","Desc_MeidouAiQuota":"Credits (AI Generation Allowance)","Label_AiAgentImageEdit":"AI Agent: Photo Editing","Label_AiAgentImageGen":"AI Agent: Image Generation","Label_AiAgentEcommerce_ImageSet":"AI Agent: E-commerce Image Set","Label_PortraitBgReplace":"Change Background","Label_AiPartialRedraw":"AI Modify","Label_AiImageGen":"AI Generation","Label_AiFloralText":"AI Calligraphy","Label_LivePpt":"Live PPT","Label_AiSizeExtend":"AI Size Expand","Label_BatchTemplate":"Batch Templates","Label_CreateCustomSize":"Create custom size design","Label_EditLocalImage":"Edit Local Images","Label_ExportJpgPng":"Export design/image as JPG/PNG","Label_FreeTemplate":"Free Templates","Label_FreeFont":"Free Fonts","Label_FreeAsset":"Free elements","Label_PaidTemplate":"Paid Template","Label_PaidFont":"Paid Fonts","Label_PaidAsset":"Premium content","Label_RealtimeMultiEdit":"Real-time collaborative editing","Label_ShareDesignRecord":"Share Editing Records","Label_ShareElements":"Share Elements (Images/Text/Tables)","Label_ShareTemplate":"Share Template","Label_ShareFolder":"Share Folder","Label_SharePermission":"Sharing Permissions Management","Label_RecordToTemplate":"Convert Editing Records To Template","Label_EnterpriseBrandNav":"Enterprise Brand Navigation Bar","Label_Sso":"Single Sign-On (SSO)","Label_ModelCustomization":"Model Customization","Label_SceneCustomization":"Scene Customization","Label_OnlineAiSupport":"Online Smart Customer Service","Label_OnlineManualGuide":"Online Manual","Label_OperationGuide":"User Guide","Label_CustomerImSupport":"Customer IM Group Support","Label_DedicatedCsm":"Dedicated Customer Success Service","Label_TechPriorityResponse":"Priority Technical Services Response","Label_TrainingSession":"Dedicated Training","Label_OffboardAssetTransfer":"Resignation Asset Handover","Label_MemberPurchaseLimit":"Member Purchase Restrictions","Label_MemberActivity":"Member Activity","Label_MemberDesignActivity":"Member editing activity","Label_MemberAiActivity":"Member AI Generation Status","Title_ContentDesign":"Content design","Title_MultiCollaboration":"Multi-Person Collaboration","Title_VisualManagement":"Visual Management","Title_OrgManagement":"Organization Management","Title_DataStatistics":"Statistics","Title_ExclusiveCustomization":"Exclusive Customization","Title_ServiceGuarantee":"Service Assurance","Title_EnterpriseAuthConfirm":"Confirm Enterprise Commercial License Information","Text_ConfirmAuthInfoTip":"Please confirm the following authorization information. It cannot be changed after submission.","Label_Name":"Name","Label_UnifiedSocialCreditCode":"Unified Social Credit Identifier","Label_IdCardNumber":"ID card No.","Label_ContactPhone":"Phone number","Title_AuthSuccess":"Authorization successful","Text_AuthSubjectFilled":"Authorization entity completed successfully","Button_BackAdmin":"Return to backend","Button_DownloadAuthBook":"Download Authorization Letter","Title_EnterpriseAuthFill":"Enter Enterprise Commercial Licensing Information","Label_AuthType":"Authorization Type","Text_Enterprise":"Enterprise","Message_EnterCompanyNameWithin30":"Enter your company name (up to 30 characters)","Message_PleaseEnterNameShort":"Please enter your name","Message_Max30Chars":"Maximum 30 characters","Message_EnterCompanyName":"Enter your company name","Message_EnterUnifiedSocialCreditCode":"Enter Unified Social Credit Identifier","Message_EnterIdCardNumber":"Enter ID card No.","Message_InvalidUnifiedSocialCreditCode":"Invalid Unified Social Credit Identifier format.","Message_InvalidIdCardNumber":"Invalid ID card No. format.","Message_EnterPhoneNumber":"Please enter your phone number","Message_InvalidPhoneNumber":"Invalid phone number format.","Placeholder_PhoneExample":"Example: 0592-12345678 / 13912345678","Desc_AuthInfoBindTip":"Once submitted, the information above will be linked and cannot be changed unless you purchase an additional authorized commercial entity.","Desc_AuthInfoRiskTip":"If you do not provide the above information accurately and completely, you may be unable to provide valid proof in the event of copyright risks and may not receive commercial use protection from the Meitu Design Studio platform.","Desc_AuthSingleSubjectTip":"The Worry-Free Commercial Use License is granted to a single entity and is limited to use by the authorized party that purchased and bound it. Sharing or transfer is prohibited.","Text_OfflineOrderScanBusiness":"For offline orders, scan the code to contact Sales and request an authorization letter","Label_AuthSubjectInfo":"Authorized Entity Information","Text_NotFilledYet":"Not filled in yet","Text_ServiceValidity":"Service Term","Text_AuthInactive":"Not active","Text_AuthActive":"Active","Text_AuthExpired":"Expired","Text_AuthNotStarted":"Not started","Text_OfflineOrder":"In-Store Orders","Label_RelatedOrder":"Related Order","Button_ContactSupport":"Contact","Button_Fill":"Enter","Title_MemberCommercialAuthBook":"Member Commercial License","Button_PurchaseAuthSubject":"Add authorized entity","Desc_PurchaseAuthSubjectScan":"To purchase additional authorized entities, scan the QR code to contact our sales team","Label_AuthTime":"Licensing Period","Label_AuthStatus":"Authorization Status","Text_OrderCancelled":"Canceled","Text_OrderPaid":"Paid","Text_OrderRefunded":"Refunded","Text_TeamVipProductName":"Team Membership ${0}","Text_CutoutCountProductName":"Remaining number of cutouts ${0}","Text_MemberMeidouProductName":"Member Credits: ${0}","Message_CancelSuccess":"Canceled","Message_CancelFailed":"Failed to cancel","Title_ConfirmCancel":"Confirm Cancellation","Text_CancelOrderTip":"After canceling your order, you can place a new order to purchase the service.","Button_IssueInvoice":"Invoice","Text_NoOrders":"No orders yet","Label_ProductInfo":"Product Information","Label_Quantity":"Amount","Label_OrderTotal":"Total","Label_OrderStatus":"Order Status","Text_OrderNoPrefix":"Order Number: ${0}","Text_PayBeforeDeadline":"Complete payment by ${0}. Late payments will be canceled automatically.","Button_CancelOrder":"Cancelling Orders","Button_PayNow":"Pay Now","Title_TransferAmount":"Transfer Amount","Desc_TransferAmountMatch":"Transfer amount must match the current order amount.","Desc_TransferUniqueCode":"2. Each order has a unique payment code. This code is valid for this order only. Do not pay more than once.","Desc_TransferAutoActivate":"3. Your membership will be activated automatically within 30 minutes after the transfer is successful. Complete the payment promptly.","Title_ReceiveAccountInfo":"Account Information","Label_AccountName":"Account name","Label_BankAccount":"Bank Account","Label_IssueBank":"Bank name","Label_RemittanceCode":"Remittance Code","Text_CopyRemittanceInfo":"Copy Remittance Information","Message_CopiedToClipboard":"Copy to clipboard","Text_CopyRemittanceTemplate":"Account Name: ${0}\\nBank Account: ${1}\\nBank Name: ${2}\\n  Remittance Code: ${3}","Label_MemberSeats":"Members/Seats","Label_RemainingSheets":"Remaining credits","Label_EnterpriseAuthSubject":"Enterprise Commercial Licensing Entity","Button_Purchase":"Purchase","Message_EditSuccessExclaim":"Changed successfully!","Text_InactiveSeats":"Pending Seats ${0}","Text_ExpiredDays":"Expired ${0} days ago","Text_ExpireOn":"Expires on ${0}","Label_OrgId":"Organization ID","Label_CreatedAt":"Created at:","Title_ContactInfo":"Contact information","Desc_ContactExpectation":"We’d love to connect with you 🤝 and help your team get more out of Posters.","Text_ContactFor1v1":"Fill this out to get one-on-one VIP service.","Label_ContactPerson":"Contacts","Label_ContactMethod":"Contact Information","Text_MemberActivity":"Member Activities","Label_LastOnlineTime":"Latest Release Time","Label_ActiveDays":"Active Days","Title_GenerationCount":"Generations","Label_PosterImageEdit":"Poster/Image editing","Alt_Avatar":"Avatar","Label_ProductPortrait":"Product/Portrait","Label_TryOnFaceSwapRecolor":"Try On/Change Face/Color","Text_MemberActivityExport":"Member Activities.xls","Title_IncludesFreePlus":"Includes all Free benefits, plus:","Title_IncludesStandardPlus":"Includes all Standard membership benefits, plus:","Title_IncludesTeamMemberPlus":"Includes all Team Membership benefits, plus:","Text_AccountLimitOne":"Account limit: 1 user","Text_PaidTemplateMaterial":"Premium Templates/Elements","Text_FreeTemplateMaterial":"Free Templates/Elements","Desc_SmartToolsBundle":"Smart Cutout/AI Removal/Enhance, and other smart tools","Desc_MeidouMonthlyUsage":"Monthly credits can be used for:","Desc_AgentProductSuite":"AI Agent: Product image sets, detail pages, videos, and more","Desc_AiShootSuite":"AI Commercial Photography: AI Product Images, Portrait Backgrounds, AI Models, And More","Desc_AiDesignSuite":"AI Design: AI Logo, Live PPT, AI Graphic, and more","Text_TeamSeatsFromPrice":"10 Seats / From ¥15,000","Desc_BulkMeidouOneTime":"One-Time Large Credit Bonus, Shared Across Multiple Accounts","Label_OneMonth":"1 month","Label_ThreeMonths":"3 months","Label_TwelveMonths":"12 months","Text_EnterpriseCommercialLicensed":"Authorized for Enterprise Commercial Use","Button_BuyTeamEdition":"Purchase Team","Title_ChooseByCommercialAuth":"Choose by Commercial Licensing","Label_LicenseTarget":"Authorized Party:","Desc_PersonalLicenseTarget":"The business entity is a natural person, and the beneficiary is also a natural person.","Label_LicenseScope":"Application Scope:","Desc_PersonalLicenseScope":"Personal office use (PPT, reports), personal websites, promotional use of online stores registered under personal entity, personal social media, WeChat Official Accounts, personal short video creation, etc.","Title_EnterpriseCommercialAuth":"Enterprise Commercial Licensing","Desc_EnterpriseLicenseTarget":"Legal persons and unincorporated organizations, including enterprises, individually owned businesses, administrative organizations, and social groups.","Desc_EnterpriseLicenseScope":"Manage websites, official accounts, mini programs, e-commerce product images/detail pages, social media feeds, online ads, and online product catalogs.","Tip_PersonalLicenseWarning":"Note: Using a personal commercial license for business purposes is considered infringing.","Alt_ContactServiceQrcode":"Contact Support QR Code","Text_ScanContactManager":"Scan the QR code to contact the account manager","Button_LearnQuote":"View Detailed Pricing","Title_PricingPartners":"Customers Across Industries Use Meitu Design Studio","Title_FaqSectionPricing":"FAQs","Title_FaqCommercialUse":"Can I use it commercially after subscribing?","Desc_FaqCommercialUse":"Personal membership (SVIP) is for individual commercial use only. Team/Enterprise memberships can be used for business commercial use. Please purchase the membership plan that matches your commercial use case.","Title_FaqInvoice":"How do I get an invoice?","Desc_FaqInvoicePersonal":"Individual membership VAT invoice: Open the Meitu Design Studio website, log in to your membership account, click your profile photo in the top right, click Renew Membership, then click I Want an Invoice in the bottom right of the pop-up and scan the QR code with WeChat to get an invoice.<br/>","Desc_FaqInvoiceTeam":"Team Membership Regular Invoice: Go to team management dashboard, select Order Invoice - choose the order to invoice - click Invoice - scan the QR code to fill in the relevant information.<br/>","Desc_FaqInvoiceSpecial":"Special VAT invoice: Contact online customer service via Online Consultation.<br/>","Title_FaqDeviceLimit":"How Many Devices Can One Membership Account Be Used On?","Desc_FaqDeviceLimit":"MTid is a personal account. To protect your account security and creation privacy, <span style=\\"color: #fff; font-weight: bold;\\">each membership account can only be logged in on one computer at a time</span> and does not support simultaneous login on multiple computers.<br/>If you need to log in on multiple devices simultaneously, we recommend purchasing the <span style=\\"color: #fff; font-weight: bold;\\">Meitu Design Studio Team/Enterprise Membership</span> to activate multiple seats and assign accounts for login.","Title_FaqUpgradeTeam":"How do I upgrade from an individual membership to a Team Membership?","Desc_FaqUpgradeTeam":"Because Team and Individual subscriptions are priced differently, to upgrade to a Team subscription, purchase the Team plan first, then contact online support to migrate your personal account credits and process any remaining subscription balance. You can copy assets from your individual account to the team yourself.","Title_FaqMeidou":"What are credits and how do I buy them?","Desc_FaqMeidou":"In addition to free and member features, Meitu Designer also offers AI functions that require Credits to use, such as AI Product Image, AI Model, and Flatlay. Once the Credits included with your membership are used up, you can purchase more separately. Access the purchase page from the top right corner of any AI function. Link: <a target=\\"_blank\\" style=\\"color: #66A8FF\\" href=\\"https://www.designkit.cn/product-shoot-editor/?from=home\\">https://www.designkit.cn/product-shoot-editor/?from=home</a>","Message_PermissionAlreadyRejected":"Permission request rejected","Message_PermissionAlreadyProcessed":"This permission request has been processed","Text_TeamRenewRemainingPrefix":"Your team membership has only","Text_UnitDay":"days","Text_SharedItemToYou":"Shared a ${0}【${1}】 with you.","Label_AccountColon":"Account number:","Text_PriceYuanPerPersonPerMonth":"¥${0}/person/month","Text_OrTry":"Or try","Title_DesignKitApp":"美图设计室 APP","Title_OpenClawGuide":"OpenClaw Manual","Label_AllColors":"All Colors","Alt_TemplateImage":"Template Image","Text_NestedTemplateSuiteCount":"Set Templates ${0} images","roboneo_agent_queue_tier_fast":"Fast","roboneo_agent_queue_tier_relax":"Relax","roboneo_agent_queue_tier_change_failed":"Switch failed, please try again.","Label_ImageProcessing":"Image Processing","Tool_ProductRetouching":"Product Retouch","Message_SelectImageBefore_ImageTranslation":"Select a picture before using Image Translation.","Message_SelectImageBefore_Expand":"Select an image before using AI Background Expansion.","Label_AiCreation":"AI Generation","Tool_AiImageText":"AI Image & Text","Label_DefaultModel":"Default Model","Desc_AgentMode_Advanced":"AI credits consumption 3x Generate a variety of results for promotion 3x","Desc_AgentMode_Normal":"Ideal for simple everyday creations and saving computing power","Desc_AgentMode_FlagshipAi":"·Flagship AI Mode","Desc_AgentMode_MultilingualText":"·Precise Multilingual Text Matching","Desc_AgentMode_ProductFidelity":"· 95% Product restoration accuracy","Desc_AgentMode_ComplexScene":"·Complex Scenario Processing Capabilities","Tool_AIVideoAgent":"AI Video Agent","Tool_UGCVideoMaker":"UGC Video Maker","Tool_MarketingVideoMaker":"Marketing Video Maker","Tool_PromoVideoMaker":"Promo Video Maker","Tool_ExplainerVideoMaker":"Explainer Video Maker","Tool_BeforeAfterVideoMaker":"Before and After Video Maker","roboneo_agent_queue_tier_upgrade_title":"Unlimited access to Relax","roboneo_agent_queue_tier_upgrade_desc":"${0} Membership Benefits. Generated in Relax mode with no credits required.","roboneo_agent_queue_tier_upgrade_primary":"Upgrade to Pro","roboneo_agent_queue_tier_upgrade_secondary":"Use Fast Mode","Label_PageIndex":"Page ${0}","Title_PPTTask":"PPT Task","Button_ReplicateNow":"Reuse Now","Label_ImageIndex":"Figure ${0}","Button_Cases_ViralVideo":"Example","Message_ImageReviewFailedRetry_Batch":"Image review failed. Try again later.","Message_ImageReviewRejected_Batch":"Image rejected","Text_PageRange":"Page ${0}~${1}","Text_AllPagesRange":"All pages (1~${0})","Text_AllPages":"All pages","Text_SelectedPages":"Selected page (${0})","Text_NoPageSelected":"No page selected","Title_InsertDocument":"Insert Document","Title_SelectPages":"Select page","Button_Insert":"Insert","Message_ProductInfoReviewRejected_Batch":"Selling point copy rejected. Please fill it in again.","Tool_VideoBackgroundRemover":"Video Background Remover","Title_StayUpdated_Designkit":"Stay updated with Designkit","Title_StayUpdated_Zawa":"Stay updated with Zawa","Desc_WebPushPrompt":"Be the first to know about new AI tools, feature updates, and trending content.","Button_NotNow":"Not now","Button_TurnOn":"Turn on","Placeholder_Enter":"Please enter ${0}","Placeholder_Select":"Please select ${0}","Label_AiMarketingVideo":"AI Product Promo Video","Title_ImageProcessing":"Process image","Title_AiDesign":"AI Design","Label_Ecommerce":"E-commerce","Label_SocialMedia":"Social media","Label_WechatMarketing":"WeChat marketing","Label_OfficialAccount":"Official Account","Label_OfficeEducation":"Admin & Office/Education","Label_LifeEntertainment":"Lifestyle & Entertainment","Title_DesignScene":"Design Scenarios","Label_MarketingSales":"Marketing and Sales","Label_Promotion":"Promotion","Label_Greeting":"Greetings & Blessings","Label_CommunicationSharing":"Share And Connect","Label_LifeScience":"Lifestyle Tips","Label_Recruitment":"Recruitment","Title_UsagePromotion":"Marketing Use","Label_FoodBeverage":"Dining and Gourmet","Label_ApparelBags":"Clothing, Shoes and Bags","Label_EducationTraining":"Education and training","Label_BeautySkincare":"Beauty & Skincare","Title_IndustryResource":"Industry resources","Text_FirstDiscountBadge_ViralVideo":"First video discount","Title_ManagedBatchTip":"Get some sleep. Your images will be ready when you wake up.","Tag_ManagedBatchDiscount":"Batch ${0}% Off","Desc_ManagedBatchTip":"Generate images in bulk at ${0}% off. Wake up to everything done.","Title_Resize":"Resize","Title_SocialContentCreation":"Social Content Tools","Title_BatchResize":"Batch Resize","Title_ImageRecolor":"Image Recolor","Title_BatchRetouch":"Batch Retouch","OnlineConsultation":"Online Consultation","PayAmount":"Pay ¥${0}","PriceBreakdown":"¥${0} × ${1} seats × ${2} months","ScanToPay":"Scan to Pay with ${0}","PaymentAgreementHint":"By paying, you agree to","MeidouRechargeAgreement":"\\"Credit Top-up Agreement\\"","DesignStudioServiceAgreement":"Meitu Design Studio Subscription Service Agreement","CommercialLicenseAgreement":"Commercial License","CutoutQuotaNotice":"Bonus Cutout Credits Notice","RenewalMemberNote":"If you purchased an auto-renewing membership:","AutoDeliveryOnPurchase":"After purchase, it will be automatically added to your current account.","NonRenewalMemberNote":"If you purchase a non-renewing subscription:","AutoDeliveryOnTransaction":"Once the transaction is successful, it will be automatically added to your current account.","CutoutQuotaLabel":"Cutout credits:","CutoutQuotaDesc":"The number of free cutouts is based on the bonus amount marked on the product detail page of the membership you actually purchased.","CutoutQuotaExpiryLabel":"Cutout credits validity period:","CutoutQuotaExpiryDesc":"Subject to the usage period shown on the order page","TrialAddressLabel":"Experience link:","ServiceNotice":"Service Notice","AutoRenewNote1":"1. After activating this service, your membership will automatically renew in the 24 hours before expiration. Once renewed, your membership will be extended for the corresponding period;","AutoRenewNote2":"2. Your renewal fee will be deducted from your linked payment account;","AutoRenewNote3":"3. You can cancel auto-renewal at any time. Once canceled, your subscription will no longer renew automatically;","AutoRenewNote4":"4. How to cancel:","AutoRenewNote5":"5. For any other questions, call customer support at 4000093360","Label_WeChat":"WeChat","Label_Alipay":"Alipay","Label_BatchTrialCount":"Free Batch Processing Uses","Desc_WindowsOnly":"Windows desktop app only","Label_MemberFeature":"VIP Features","Label_MemberAsset":"VIP Elements","Label_MemberEffect":"VIP Effects","Label_NoAds":"No Ads","Label_NoPoster":"No Meitu Pictorial","Label_EffectFilter":"Special Filters","Label_Enhance":"Enhance","Label_FaceRemodel":"Reshape","Label_SkinAdjust":"Skin","Label_HeadAdjust":"Head Adjustment","Label_HeightShape":"Body Shape","Label_Border":"Frame","Label_RechargeMeidou":"Top Up Credits","Text_InsufficientBenefits":"Insufficient benefits. Contact your dedicated advisor: ${0} ${1}","Text_OnlinePurchaseDisabled":"Online purchases aren’t supported in this version. Contact your administrator if needed.","Desc_ProtectMemberExperience":"To ensure your membership experience,","Desc_BindPhoneFirst":"Link your primary phone number first.","Button_GoToBind":"Link now","Text_AlreadyActiveMember":"You\'ve already subscribed to membership on ${0}","Text_ContactServicePrefix":"If you have any questions, please","Label_ServicePhone":"Customer Service Hotline","Text_ServiceTime":"Customer Service Hours: 9:00 AM - 9:00 PM","Text_LargeOrderContact":"For large orders or failed payments, scan the QR code to contact sales for assistance.","Text_ConsultEnterprise":"Enterprise Commercial Use Inquiry","Message_CreateFail":"Creation failed. Try again later.","Title_TransferReminder":"Transfer Reminder","Text_ViewOrderProgress":"You can track this order later in Admin Dashboard > Orders & Invoices.","Title_PendingTransfer":"Transfer Order in Progress","Text_HasPendingTransfer":"You have a corporate bank transfer order in progress. View it?","Button_CancelAndCreate":"Cancel and create new order","Button_ViewTransferOrder":"View Transfer Order in Progress","Text_CancelOrderNote1":"After canceling the order, you can create a new one,","Text_CancelOrderNote2":"However, the order with a transfer in progress will be closed.","Button_ConfirmCancelCreate":"Confirm Cancellation and Create","Link_ViewBenefitDetail":"View benefit details >","Label_RedeemCode":"Redemption Code","Message_RedeemSuccess":"Successfully redeemed!","Message_RedeemVipSuccess_DesignKit":"You’ve successfully redeemed your Meitu Design Studio VIP membership!","Message_RedeemSvipSuccess_MeituXiuXiu":"You’ve successfully redeemed your Meitu SVIP membership!","Placeholder_EnterInviteCode":"Enter Invitation Code","Placeholder_EnterRedeemCode":"Enter Redemption Code","Title_CodeCenter":"Coupon Center","Desc_SelectCodeType":"Select your code type to verify and redeem","Title_InviteCodeDesc":"Invitation Code Instructions","Title_RedeemCodeDesc":"Redemption Code Instructions","Text_InviteCodeIntro":"Enter the exclusive invitation code you received from social media or other channels:","Text_InviteCodeBenefit1":"Exclusive channel subscription discount with limited-time free benefits","Text_InviteCodeBenefit2":"Each invitation code can only be used once","Text_InviteCodeBenefit3":"Cannot be combined with other promotions","Text_RedeemCodeIntro":"Use a membership redemption code obtained from official channels:","Text_RedeemCodeBenefit1":"Log in to your account and enter the redemption code to redeem","Text_RedeemCodeBenefit2":"After redeeming, you’ll get the corresponding subscription benefits and services","Text_RedeemCodeBenefit3":"Use the redemption code before it expires. Expired codes are invalid and non-refundable.","Text_InvoiceLink":"This link can be used to issue invoices for ${0} orders","Text_InvoiceOtherBusiness":"For invoices for other Meitu services, follow the Meitu Payment Service official account","Desc_ConsumeSoonExpiredMeidou":"Use Expiring Credits First","Link_MeidouIntro":"About Credits >","Text_NoMeidouGoToBuy":"No credits. Purchase now!","Text_ThankYouSupport":"Thanks for your support. We’ll keep bringing you new services.","Text_PurchaseBatchSuccess_MeituXiuXiu":"You have purchased Meitu batch processing credits.","Text_PurchaseCutoutSuccess":"You have purchased Meitu Cutout downloads.","Label_BoundAccount":"Linked account:","Text_PurchaseCount":"Purchase quantity: ${0}","Label_TeamMemberExpiry":"Team Membership Valid Until:","Label_ProMemberExpiry":"Premium Membership Valid Until:","Label_StandardMemberExpiry":"Standard membership valid until:","Text_PurchaseSeatCount":"Seats purchased: ${0}","Button_GotItCountdown":"Got it (${0}s)","Text_Trial":"Try ${0}","Text_OriginalPrice":"Original price ${0}","Text_PerSheet":"/image","Text_PerPersonPerMonth":"/person/month","Text_FreeTrialDays":"${0}-Day Free Trial","Text_FreeTrialMonths":"${0}-Month Free Trial","Text_FreeTrialQuarters":"${0}-Quarter Free Trial","Text_FreeTrialYears":"${0}-Year Free Trial","Text_ScanToBuy":"Scan with ${0} to purchase","Text_ScanToActivate":"Scan with ${0} to activate","Text_AlsoSupportWechatBuy":"(or scan with Wechat)","Text_AlsoSupportWechatActivate":"(or scan with Wechat)","Text_ServiceAgreement_DesignKit":"Meitu Design Studio Subscription Policy","Text_ServiceAgreement_MeituXiuXiu":"Meitu SVIP Subscription Policy","Text_ServiceAgreement_Meidou":"Credit Top-up Agreement","Text_ServiceAgreement_Cutout":"Cutout Service Agreement","Text_ServiceAgreement_BatchMeituXiuXiu":"Meitu Batch Processing Service Agreement","Button_ClickLogin":"Log in","Text_CheckAgreementFirst":"Check the box to agree first.","Text_LoadError":"Failed to load","Button_ClickRefresh":"Tap to refresh","Label_Pay":"Pay:","Text_ExtendAfterPurchase":"After purchase, extends until: ${0}","Button_Agree":"Agree","Title_ThankYouSubscription":"Thank you for subscribing!","Text_MemberServiceAgreement":"VIP Service","Title_PayFail":"Payment Failed","Button_RepayNow":"Try again","Desc_OneYearValidTeam":"Valid for 1 year. Can only be used with your current team.","Text_SharedMeidouPrompt":"To share credits with more than 5 people, please","Button_ActivateTeamMember":"Subscribe to Team Membership","Text_SeatPurchaseEffect":"Additional seats take effect immediately and expire on ${0} (same expiration date as the active team membership order)","Label_Gift":"Bonus","Text_FirstMonthMeidouGift":"Subscribe to get ${0} credits in your first month and ${1} credits each month after that. Valid for the current month.","Text_MonthlyMeidouGift":"Granted monthly, valid for the current month","Desc_TeamOnlyCutout":"Purchased download credits can only be used with your current team.","Text_DownloadDeductRule":"Each successful image download uses 1 download credit.","Text_CutoutAdjustRule":"Adjust your cutout as many times as you like. Downloads are only deducted when you download.","Text_UnlimitedCutout":"Unlimited cutouts while your membership is active","Text_ValidityThreeMonths":"Validity: 3 months","Text_ValidityOneYear":"Validity: 1 year","Title_VipLimitedOffer":"VIP Special Offer","Text_TeamSeatRequirement":"Your current team has ${0} members. Please purchase the corresponding number of seats.","Text_TeamMemberSeatMinimum":"Team membership starts at ${0} seats","Text_MeidouGiftPerMonth":"Bonus credits: ${0}/month","Label_SeatCount":"Seats","Text_SeatOrderEffect":"The new order seats will take effect at ${0}. To add seats immediately, please","Button_ActivateMemberUnlimited":"Subscribe for unlimited access","Button_BuyMember":"Subscribe","Button_BuyCount":"Purchase Quantity","Text_BatchRemainingCount":"Batch images remaining: ${0}","Label_RemainingCutout":"Remaining cutouts:","Text_RemainingMeidouCount":"${0} credits left","Text_TeamMemberExpiry":"Team membership expires on ${0}","Text_BoundPhoneAccount":"(Linked account: ${0})","Button_ClickLoginRegister":"Tap to log in (registration included)","Text_LoginToBuyMember":"Log in to subscribe and keep your VIP creations safe.","Text_LoginToBuy":"Log in to purchase","Button_CorporateTransfer":"Corporate Bank Transfer","Button_ApplyInvoice":"Invoice","Button_InviteOrRedeemCode":"Activate With Invitation/Redemption Code","Button_RedeemCodeActivate":"Activate With Redemption Code","Text_MarchPromo":"March E-Commerce Sale: Double Credits On Your First Top-Up","Button_BackToBuy":"Back to Purchase","Label_EstimatedConsumption":"Estimated consumption:","Text_ValidOneYear":"Valid for 1 year","Text_PerMonth":"/month","Desc_Monthly330Meidou":"330 free credits monthly (valid for the current month), usable for:","Text_UnitPrice1000":"Only ¥0.0532 per credit","Text_Capacity1000":"Generate approximately 500 images or 66 videos","Text_SingleImageLow1000":"As Low as ¥0.176 per Image","Text_SingleVideoLow1000":"As low as ¥1.320 per video (5s)","Text_SingleImageYearly1000":"As low as ¥0.106 per image","Text_SingleVideoYearly1000":"As low as ¥0.798 per video (5s)","Text_UnitPrice1800":"Only ¥0.0462 per credit","Text_Capacity1800":"Generate approximately 900 images or 120 videos","Text_SingleImageLow1800":"As low as ¥0.164 per image","Text_SingleVideoLow1800":"As low as ¥1.233 per video (5s)","Text_SingleImageYearly1800":"As low as ¥0.092 per image","Text_SingleVideoYearly1800":"As low as ¥0.693 per video (5s)","Text_UnitPrice3600":"Only ¥0.0437 per credit","Text_Capacity3600":"Generate approximately 1,800 images or 240 videos","Text_SingleImageLow3600":"As low as ¥0.154 per image","Text_SingleVideoLow3600":"As low as ¥1.158 per video (5s)","Text_SingleImageYearly3600":"As low as ¥0.087 per image","Text_SingleVideoYearly3600":"As low as ¥0.656 per video (5s)","Text_UnitPrice7500":"Only ¥0.0410 per credit","Text_Capacity7500":"Generate approximately 3,750 images or 500 videos","Text_SingleImageLow7500":"As low as ¥0.138 per image","Text_SingleVideoLow7500":"As low as ¥1.037 per video (5s)","Text_SingleImageYearly7500":"As low as ¥0.082 per image","Text_SingleVideoYearly7500":"As low as ¥0.615 per video (5s)","Desc_IncludesStandardAll":"Includes all Standard benefits, plus:","Desc_MonthlyMeidou":"${0} Credits included monthly (valid for the current month), usable for:","Text_FewCredits":"Limited credits","Label_BasicPlan":"Basic Version","Text_TrialMeidouGift":"120 credits included with trial, valid for 7 days","Text_Monthly330MeidouBenefit":"Subscribe to get 330 credits each month, valid for the current month.","Label_LimitedPrivilege":"Limited-Time Perks","Text_SeedancePrivilege":"Unlimited free slow generation with Seedance 2.0 and early access to new features","Label_MeidouPrefix":"Credits:","Text_LoginToBuyMemberShort":"Log in to purchase a membership","Text_TeamMinimumSeat":"Your team currently has ${0} members. You need to purchase at least ${0} seats.","Message_AbnormalSubscriptionNoSeat":"Adding seats is not supported for team memberships with an abnormal subscription status.","Text_TeamMemberExpires":"Your team membership will expire on ${0}.","Text_ProMemberExpires":"Your Premium membership will expire on ${0}.","Text_BasicMemberExpires":"Your Basic membership will expire on ${0}.","Text_SvipMemberExpires_MeituXiuXiu":"Your SVIP will expire on ${0}.","Text_ActivateVip_DesignKit":"Subscribe to Meitu Design Studio VIP to enjoy member benefits","Text_UpgradeToSvip_MeituXiuXiu":"You’re already subscribed to Meitu VIP. Upgrade to SVIP to enjoy design services across devices.","Text_ActivateTeamMember_DesignKit":"Subscribe to Team Membership to unlock X-Design VIP benefits and team collaboration features","Text_ActivateMember":"Subscribe to enjoy tons of member benefits","Text_ActivateMember_MeituXiuXiu":"Subscribe to enjoy Meitu VIP, SVIP, and Meitu desktop membership benefits","Text_ExpiredDays_Team":"Expired ${0} days ago. Purchase now to restore access.","Text_VipExpiredDays_DesignKit":"Your VIP expired ${0} days ago. Welcome back!","Text_VipExpiredDays_MeituXiuXiu":"Your Meitu SVIP expired ${0} days ago. Welcome back.","Text_ValidDays":"Valid for ${0} days","Text_ValidWeeks":"Valid for ${0} weeks","Text_ValidMonths":"Valid for ${0} months","Text_ValidQuarters":"Valid for ${0} quarters","Text_ValidYears":"Valid for ${0} years","Text_CountdownDays":"${0} days ${1}","Label_Week":"Week","Label_Quarter":"Quarter","Desc_BatchCutoutConsumption":"After using Cutout, downloading and saving 1 image uses ${0} credits. Other features use ${1} credits.","Text_TieredSeatBilling":"Membership includes ${0} seats. Additional users beyond ${1} are billed at ${2}/year/person.","Text_PerYearPerPerson":"/year/person","Text_BoundAccountPrefix":"(Linked account:","Text_BoundAccountSuffix":")","Title_GlobalSettingsMobile_Batch":"Global Settings","Tip_ApplyToAllTasksBelowMobile_Batch":"Apply to all tasks below","Tip_UploadImagesFormatMobile_Batch":"Click to upload JPEG/JPG/PNG images up to ${0} MB. Up to ${1} images supported.","Title_EcommerceTools":"E-commerce Tools","Title_MoreVideoTools":"More Video Editing Features","Text_AppMessageNotification_Batch":"You\'ll get an in-app message when the task is complete.","Tool_ProductDemoVideoMaker":"Product Demo Maker","Tool_Video360Maker":"360 Video Maker","Tool_UnboxingVideoMaker":"Unboxing Video Maker","Tool_FashionVideoMaker":"Fashion Video Maker","Tool_CommercialVideoMaker":"Commercial Video Maker","Tag_Cover":"Cover","Option_ExportLayered_Psd":"Layered Export","Option_ExportFlat_Psd":"Export without layers","Message_NoExportableLayer":"No exportable layers selected","Message_UnsupportedLayerForPsd":"This layer type does not support PSD export.","Message_VideoLayerPsdBlocked":"Contains video layers. Cannot export PSD.","Message_ExportUnitsOverLimit":"Selection exceeds ${0} export items","Message_LayerSplitRightDenied":"No Layer Splitting Benefits","AiTemplate_Desc":"Enter a poster theme or describe your edits. AI will recreate this template and generate a poster in one click.","AiTemplate_Upload":"Element Upload","AiTemplate_Upload_Desc":"Click to upload element images to replace product images, models, QR codes, and more.","AiTemplate_Prompt":"Poster Theme/Edit Details","AiTemplate_Prompt_Placeholder":"Enter a poster theme or describe what you want to edit. For example: Change the theme to \'Autumn Equinox Moisture\'; replace the XX in the image with the XX I uploaded.","AiTemplate_Generate":"Generate Poster","Text_OpenClawInstallCmd":"Help me install ${0}","Text_SupportLinkImport":"Supports importing links","Text_ModifyLogoPrompt":"Please help me modify this logo","Text_ModifyImagePrompt":"Please help me modify this image","Title_UserCenter":"Personal Center","Button_Login":"Log in","Button_Signup":"Sign up","Title_FreeBackgroundRemoverOnline":"Free Background Remover Online","Title_RemoveThe":"Remove the background from images instantly and automatically with Designkit for free. No design skills are required.","Title_NoPic":"No picture on hand? Try with one of these","Title_IndustryLeading":"A Leader in Image Cutout Quality","Title_GlobalRunner":"Global Runner-up at the CVPR 2024 competition. Breakthrough research published at AAAI and CVPR.","Title_FastAnd":"Fast and Flawless Background Removal","Title_SImplyUpload":"Upload your photo, and Designkit will take care of the rest, from subject detection to background removal—no complex steps, no learning curve.","Title_FineTune":"Fine-Tune Your Images Like a Pro","Titel_Whether":"Whether it\'s soft hair, fabric edges, or shadows, Designkit preserves the fine details that matter most. You can also fine-tune edges and corners for greater accuracy to achieve a polished, professional finish.","Title_FlawlessStamp":"Flawless Stamp and Signature Processing","Title_RemoveDull":"Remove dull and faded backgrounds from signatures and stamps. Designkit identifies the details of each subject and prepares them for any layout - solid background or transparent PNG.","Title_PerfecCutouts":"Perfect Cutouts for Every Use Case","Title_GetFlawless":"Get flawless background removal for any image type.","Button_ECommerco":"E-Commerce","Button_Portraits":"Portraits","Button_Pets":"Pets","Button_LogoSignaure":"Logo & Signature","Title_HowTo":"How do I remove background from images?","Title_UploadYour":"Upload your image","Title_ChooseAn":"Choose an image from your device in JPEG, PNG, or WEBP format.","Title_AIRemoves":"Al removes the background","Title_AiEditor":"Al editor tool identifies the subject and removes the background.","Title_EditOrExport":"Edit or export","Title_DownloadOr":"Download or use the built-in photo editor to edit the image.","Title_FrequentlyAskedQuestions":"FAQs","Title_IsThis":"ls this tool free to use?","Answer_IsThis":"Yes, the Image Background Remover by Designkit is a free tool to remove image backgrounds.","Title_CanIChange":"Can I change the background after the cutout is done?","Title_WhichImage":"Which image formats are supported for cutout?","Title_CanIManually":"Can I manually adjust the results if it is not accurate?","Answer_CanIchange":"Yes, after the cutout is complete, you can directly select a solid color, a gradient, or add a custom image as the new background using Designkit. The operation is simple, flexible, and fully customizable.","Answer_WhichImage":"Designkit supports popular formats like JPG, PNG, and WEBP for upload. You can also export the final cutout as a transparent PNG for seamless integration into your other design projects.","Answer_CanIManually":"Absolutely. If the edges are not perfect after the automatic recognition, you can use the built-in editor to manually refine them to match your requirements.","Button_Reupload":"Re-upload","Button_Download":"Download","Button_Edit_Refine":"Refine","Button_Edit_Backgrounds":"Backgrounds","Button_Edit_Crop":"Crop","Button_Edit_Edges":"Edges","Button_Edit_Filter":"Filters","Pop_Download_Freetip":"Free","Pop_Download_UHD":"Full Resolution","Pop_Download_preview":"Preview","Guid_More_ColorPanel":"All","Button_Remove_ColorPanel":"Remove","Button_Upload_ColorPanel":"Upload","Size_Original_SizePanel":"Original size","Button_Upload_Batch":"Batch Upload","Desc_Upload":"Click or drop to upload, paste files.","SubTitle_Header1_Home":"AI Product Listing Image Generator","SubTitle_Header2_Home":"AI Poster Generator","SubTitle_Header3_Home":"AI Product Video Generator","SubTitle_Header4_Home":"AI Product Photography Generator","SubTitle_Header5_Home":"AI Website Visual Design","SubTitle_Header6_Home":"Virtual Try-On","SubTitle_Header7_Home":"AI Product Detail Page Design","SubTitle_Header8_Home":"AI Photo Editor","SubTitle_Header9_Home":"Image Enhancer","SubTitle_Header10_Home":"Object Remover","SubTitle_Header11_Home":"AI Background Remover","SubTitle_Header12_Home":"AI Background Generator","SubTitle_Header13_Home":"Image Resizer","SubTitle_Header14_Home":"Add Text to Image","SubTitle_Header15_Home":"AI Image Generator","SubTitle_Header16_Home":"Batch Photo Editor","Size_ToEdge":"To Edge","Pop_Download_UHD_LimitTip":"Limit time · ${0}","Before_Text":"Before","After_Text":"After","Button_OpenVipFreeDownloadPsd":"Subscribe to download PSD for free","Text_LogoSlogan_DesignKit":"Make commercial design look great and deliver results","LogoDesign_ModeTitle":"Choose what you want to generate","LogoDesign_ModeFast":"Quick Logo","LogoDesign_ModeFastDesc":"Quick generation, core info only.","LogoDesign_ModePro":"Logo & Visual Design","LogoDesign_ModeProDesc":"Strategy Concepts & Real-scene Preview.","LogoDesign_Essentials":"Brand information","LogoDesign_BrandNamePlaceholder":"Brand Name (Required)","LogoDesign_IndustryPlaceholder":"Industry (Required)","LogoDesign_Description":"Description","LogoDesign_DescriptionPlaceholder":"Describe your brand story, slogan, target audience, or specific elements you want in your logo...","LogoDesign_MoreSettings":"Settings","LogoDesign_LogoType":"Logo Type","LogoDesign_StyleCount":"Style & Amount","LogoDesign_Model":"Image generation model","LogoDesign_BrandColors":"Brand Colors","LogoDesign_AutoColor":"Auto Color","LogoDesign_DragUpload":"Drag or click to upload","LogoDesign_DragUploadHint":"PNG, JPG, and WEBP supported. Upload one clear image.","LogoDesign_UploadingImage":"Uploading...","LogoDesign_ReplaceImage":"Change Image","LogoDesign_ReferenceDimensions":"Reference Size","LogoDesign_GenerateLogos":"Generate Logo","LogoDesign_GenerateExpressLogos":"Generate 8 logos","LogoDesign_GenerateConcepts":"Generate Concept Proposals","LogoDesign_Processing":"Generating...","LogoDesign_StrategyTitle":"Choose a Direction","LogoDesign_StrategyDesc":"Please select a strategy direction before generating the final logo.","LogoDesign_RegenerateStrategies":"Try Another Strategy","LogoDesign_SelectStrategy":"Choose a Strategy","LogoDesign_GenerationHistory":"Generation History","LogoDesign_NoHistory":"No generation history yet.","LogoDesign_EditInAgent":"Edit in Agent","LogoDesign_GenerateMockups":"Generate Mockup","LogoDesign_SelectMockupType":"Select mockup type","LogoDesign_VoteLike":"Like","LogoDesign_VoteDislike":"Don\'t like it","LogoDesign_HeroTitlePro":"Professional brand visual identity.","LogoDesign_HeroDescPro":"From core concepts to multi-scenario applications, build a unified brand system.","LogoDesign_HeroTitleExpress":"AI Logo Solution","LogoDesign_HeroDescExpress":"Explore 8 different visual styles in a single generation.","LogoDesign_Items":"Project","LogoDesign_UntitledBrand":"Untitled Brand","LogoDesign_NoStrategy":"No Strategy Selected","LogoDesign_StrategyBadge":"Option","LogoDesign_Inspiration":"Inspiration","LogoDesign_MockupGridPlaceholder":"AI-generated mockup collection scenes","LogoDesign_ValidationBrand":"Enter a brand name","LogoDesign_ValidationIndustry":"Select or enter an industry","LogoDesign_ValidationStrategy":"Please select a strategy first","LogoDesign_ValidationMockup":"Select at least one mockup type","LogoDesign_Style_Minimalist":"Minimal","LogoDesign_Style_Vintage":"Retro","LogoDesign_Style_Geometric":"Geometry","LogoDesign_Style_Abstract":"Abstract","LogoDesign_Style_HandDrawn":"Hand painted","LogoDesign_Style_Luxury":"Luxury","LogoDesign_Style_Tech":"High-tech","LogoDesign_Style_Nature":"Daily","LogoDesign_LogoType_IconText":"Icon + Text","LogoDesign_LogoType_TextOnly":"Text Only","LogoDesign_LogoType_IconOnly":"Icon Only","LogoDesign_LogoType_Lettermark":"Letter Logo","LogoDesign_LogoType_Emblem":"Badge Logo","LogoDesign_LogoType_Mascot":"Mascot","LogoDesign_MockupType_BusinessCard":"Business card","LogoDesign_MockupType_Signage":"Store sign","LogoDesign_MockupType_Packaging":"Post-Production","LogoDesign_MockupType_Shirt":"T-shirt","LogoDesign_MockupType_ToteBag":"Tote Bag","LogoDesign_MockupType_Sticker":"Stickers","LogoDesign_MockupType_OfficeSupplies":"Office Supplies","LogoDesign_MockupType_AppIcon":"App Icon","LogoDesign_AddColor":"Add Color","LogoDesign_ReferenceDimension_Graphics":"Graphics","roboneo_agent_queue_tier_fast_description":"Generate instantly. Credits are charged per generation.","roboneo_agent_queue_tier_relax_description":"Unlimited free generation at a slightly slower speed. No credits used.","roboneo_agent_queue_tier_relax_locked_description":"A ${0} benefit — generate for free without credits.","roboneo_agent_queue_tier_upgrade_unlock":"Upgrade to unlock","Button_UpgradeForFree":"Upgrade for Free","Label_Teams":"Teams","Title_AiModelAccess_Pricing":"AI Model Access","Text_LimitedAiModels_Pricing":"Limited Video and Image Models","Label_GptImage2_Pricing":"GPT Image 2.0","Label_NanoBananaPro_Pricing":"Nano Banana Pro","Label_NanoBanana2_Pricing":"Nano Banana 2","Label_GeminiOmniFlash_Pricing":"Gemini omni Flash","Label_Seedance2Mini_Pricing":"Seedance2.0 Mini","Label_Seedance2Fast_Pricing":"Seedance 2.0 Fast","Label_Kling26_Pricing":"Kling 2.6","Label_Veo31_Pricing":"Veo 3.1","Label_Sora2_Pricing":"Sora 2","Label_Midjourney_Pricing":"Midjourney","Label_Seedance25ComingSoon_Pricing":"Seedance 2.5 (Coming soon)","Label_Seedream50Pro_Pricing":"Seedream 5.0 Pro","Label_NanoBanana_Pricing":"Nano Banana","Label_Seedream40_Pricing":"Seedream 4.0","Label_SeedEdit30_Pricing":"SeedEdit 3.0","Tab_VideoObjectRemover":"Video Removal","Text_WholeProductGuide_DomesticCloneCase":"Upload a bestselling product image as a reference and easily recreate the same style","Text_ApparelGuide_DomesticCloneCase":"Upload a trending fashion image as a reference and easily recreate the look","Text_PosterCoverGuide_DomesticCloneCase":"Upload a trending poster image as a reference and easily recreate the look","Text_SocialGraphicsGuide_DomesticCloneCase":"Upload a trending social media image as a reference and easily recreate the look.","TaskName_WholeProductClone_DomesticCloneCase":"Mint Green Cat-Pattern Insulated Tumbler","TaskName_ApparelClone_DomesticCloneCase":"Girls\' Floral Peter Pan Collar Shirt","TaskName_PosterCoverClone_DomesticCloneCase":"Shunde Food Guide Poster","TaskName_SocialGraphicsClone_DomesticCloneCase":"Jingdezhen Travel Guide","Label_SwitchToPage":"Switch to page ${0}","File_Mention_Upload_Text":"Add from Device","File_Mention_Empty_Text":"You haven\'t uploaded anything yet","Empty_Agent_Canvas_Text":"AI Canvas","Empty_Agent_Canvas_Description":"Generate with AI. Endless creativity.","Label_Height":"Height","Label_Width":"Width","Agent_Guide_Placeholder_Title":"Start Now, Create Freely","Agent_Guide_Placeholder_Agent_Title":"Chat Agent","Agent_Guide_Placeholder_Agent_Subtitle":"Create from Scratch","Agent_Guide_Placeholder_Upload_Subtitle":"Edit Existing Image","Label_Text_Then":"Then","Meta_Title_LogoDesign":"Professional Logo Design Made Simple with Zawa AI","Title_AppEnhancer":"AI Video Enhancement","Desc_AppEnhancer":"Enhance to 4K HD in one click, with improved quality and frame rate.","Title_AppWatermarkRemover":"Video Watermark & Subtitle Remover","Desc_AppWatermarkRemover":"Quickly remove watermarks and logos from videos.","Title_AppBackgroundRemover":"Video Background Remover","Desc_AppBackgroundRemover":"Remove video backgrounds in one click, no sign-up required.","Title_VideoDemos":"Try These Videos","Button_DownloadPreview":"Download 5-Second Preview","Text_PreviewDownloading":"Downloading 5-second video...","Title_PreviewVideo":"5-Second Preview Video","Title_FullVideo":"Full Video","Button_DownloadFull":"Download full video","Text_FullDownloading":"Downloading full video...","Tip_FullVideoReady":"Your full video is ready to download.","Tip_Processing":"Processing may take some time. Don’t refresh the page. Check back later.","Tip_ProcessComplete":"Processing complete. Tap to save the video to your phone.","Tag_Purchased":"Purchased","Text_Uploading":"Uploading...","Message_ProcessFailed":"Video processing failed.","Button_UploadVideo":"Upload Video","Text_SupportFormat":"Supported formats: ${0}","Button_UploadNew":"+ Upload New Video","Message_ProcessFailedRetry":"Video processing failed. Check your network connection and try again.","Tip_MaxProcessNum":"Up to ${0} videos can be processed at once. Try again later.","Tip_MaxUploadNum":"You can upload up to ${0} video files at a time.","Message_VideoLoadFailed":"Failed to load video","Tip_VideoResolutionLimit":"Videos with a resolution higher than 4K are not supported.","Tip_VideoDurationLimit":"Video exceeds the limit. Keep it under 20 minutes.","Tip_VideoSizeLimit":"Video is too large. Upload a video under ${0} MB.","Tip_VideoFormatLimit":"Supported video formats: ${0}. Upload a video in a supported format.","Tip_Done":"Done","Text_IsProMember":"You’re a Pro member.","Text_SubscribeToUnlock":"Subscribe to unlock.","Button_Enhance":"Start Enhancing","Button_Remove":"Start","Text_Enhancing":"Enhancing...","Text_EnhancingFull":"Enhancing full video...","Text_Removing":"Removing...","Text_RemovingFull":"Removing from full video...","Text_RemovingSelectedArea":"Removing selected area...","Tag_Enhanced":"Enhanced","Tag_Removed":"Removed","Tag_Preview":"5-Second Preview","Label_SelectResolution":"Select Resolution","Message_DownloadFailed":"Failed to download. Please check your internet connection and try again.","Message_DownloadFailedRetry":"Download failed. Try downloading again.","Tab_Smart":"Intelligent Recognition","Tab_Watermark":"Watermark","Tab_Subtitle":"Subtitles","Tab_Manual":"Manual","Label_BoxItem":"Select the area to remove","Tip_ClearManualBoxOnSwitch":"Switching modes will clear the selection","Label_Multiplier":"${0}x","Label_Resolution1K":"1K","Label_Resolution2K":"2K","Label_Resolution4K":"4K","Title_ConfirmVideoRights":"Confirm you have the right to use this video.","Desc_ConfirmVideoRights":"Do not upload or import any content that you do not own or are not legally authorized to use. By clicking \\"Confirm\\", you confirm that you own this content and that none of the following will infringe any third-party rights or violate applicable laws: (i) The content itself; (ii) Your use of our services; or (iii) Our use of the content to provide the services you requested.","Button_Import":"Import","Title_ImportVideoLink":"Import your video link","Label_ConfirmContentPermission":"By uploading the link, I confirm that I own this content.","Placeholder_VideoLink_WatermarkRemover":"Enter a video link to remove the watermark...","Placeholder_VideoLink_SocialPlatforms":"Supports TikTok, IG, YouTube, and Facebook links","Placeholder_VideoLink_SocialPlatforms_Domestic":"Supports Douyin, Kuaishou, Xiaohongshu, and TikTok links","Tip_InvalidLink":"Please import a valid link","Tip_LinkImportFailed":"Import failed. Please try again.","Text_FileFromLink":"Linked File ${0}","Text_LinkImporting":"Importing ${0}%","Button_Batch":"Batch","Button_Link":"Link","Title_MobileBatchUnsupported":"Batch processing is not supported on mobile yet","Text_VisitOnDesktop":"Open on a computer:","Button_CopyAddress":"Copy","Text_UploadDropPasteClick":"Drag and drop, paste, or click to upload","Text_UploadDropPasteClick_Support":"Supports .mp4, .mov, and m4v","Tips_UploadMaxVideoCountLimit":"Upload up to ${0} video files","Title_AILogoDesign":"AI Logo Design","Title_AILogoPreview":"AI Logo Design","Message_IndustryLoadFailed":"Failed to load industry data","Message_LogoResultPartialFailed":"Failed to retrieve some Logo generation results","Label_LogoGenerateMode":"Logo Generation Mode","Tab_GeneralMode":"General Mode","Desc_StrongerLogoModel":"Powered by a more powerful model for higher-quality logos","Button_CloseTip":"Dismiss Tip","Label_LogoName":"Logo Name","Label_LogoSlogan":"Subtitle/Slogan","Label_Optional":"Optional","Placeholder_LogoDescription":"Describe the brand tone, style keywords, use cases, etc.","Title_AIServiceStatement":"AI Service Statement","Label_LogoCreateGuide":"Logo Creation Guide","Title_StartCreateLogo":"Start Creating Your Logo","Desc_CreateLogoSchemes":"Enter the brand information on the left to generate ${0} curated options","Text_FillBrandInfo":"Enter Brand Info","Text_SelectGenerateMode":"Select Generation Mode","Text_GetLogoScheme":"Get Logo Designs","Label_AILogoPreview":"AI Logo Enlarged Preview","Button_ClosePreview":"Disable Preview","Label_AILogoLarge":"Large AI-Generated Logo Image","Button_PreviousLogo":"View Previous Logo","Button_NextLogo":"View Next Logo","Button_ScrollThumbnailsLeft":"Scroll thumbnails left","Label_LogoPreviewList":"Logo Preview List","Button_SwitchLogo":"Switch To This Logo","Button_ScrollThumbnailsRight":"Scroll Thumbnails Right","Message_LogoDownloadFailed":"Logo download failed. Try again later.","Label_LogoGenerateResult":"Logo Results","Title_GenerateResult":"Results:","Button_WatermarkPreference":"Set Download Watermark Preferences","Button_SelectLogo":"Select This Logo","Text_LogoGenerating":"Generating logo...","Message_LogoGenerateFailedRetry":"Generation failed. Please try again.","Label_AIGeneratedLogo":"AI-Generated Logo","Button_EditLogo":"Edit This Logo","Button_DownloadLogo":"Download This Logo","Button_PreviewLogo":"Preview This Logo","Message_RecordLoadFailed":"Failed to load generation records","Message_MoreRecordsLoadFailed":"Failed to load more records","Message_LogoBatchDownloadFailed":"Batch Logo download failed. Try again later.","Label_RecordLoading":"Loading history...","Label_LogoRecords":"Logo History","Label_GenerateMode":"Generation Mode","Text_GenerateTime":"Generation time: ${0}","Button_ZoomLogo":"View Logo Fullscreen","Text_NoMoreRecords":"No more records","Message_GenerateTaskSubmitted":"Generation task submitted","Message_LogoGenerateFailed":"Logo generation failed. Please try again later.","Button_QuickGenerate":"Quick Generate","Label_GenerateViral_ViralVideo":"Generate Viral Video","Label_ReplicateViral_ViralVideo":"Replicate Viral Video","Message_SelectMarket_ViralVideo":"Please select a target market","Message_SelectLanguage_ViralVideo":"Please select a video language","Message_SelectRatio_ViralVideo":"Please select an aspect ratio","Message_FillScript_ViralVideo":"Please fill in the custom script","Message_SetScriptCount_ViralVideo":"Please set the number of custom scripts to generate","Message_SelectViralType_ViralVideo":"Please select at least one viral type","Message_MaxViralTypes_ViralVideo":"Total viral types cannot exceed ${0}","Message_InputTaskTitle_ViralVideo":"Please enter a task title","Message_FillSellingPoints_ViralVideo":"Please fill in the selling point description","Message_ProductImageShortEdgeLimit_ViralVideo":"Please upload an image with the short side greater than 300px","Message_ProductImageAspectRatioSuggestion_ViralVideo":"We recommend uploading a 16:9, 9:16, or 1:1 image","Message_UploadRefVideo_ViralVideo":"Please upload a reference video","Message_TaskCancelled_ViralVideo":"Task cancelled","Text_GenerateTaskTitle_ViralVideo":"Generate Viral Task ${0}","Text_ReplicateTaskTitle_ViralVideo":"Replicate Viral Task ${0}","Text_TaskCopyTitle_ViralVideo":"${0}-Copy","Message_FetchConfigFailed_ViralVideo":"Failed to load initial viral video configuration","Title_VideoResult_ViralVideo":"Video Result","Text_AiGenerating_ViralVideo":"AI is generating...","Text_CheckingSellingPoints_ViralVideo":"Checking content...","Label_EmailNotify_ViralVideo":"Notify me by email when ready","Title_LinkEmail_ViralVideo":"Link an email address","Text_LinkEmailDesc_ViralVideo":"Your account doesn\'t have an email address yet. Link one in Account Center, then come back to turn on email notifications.","Text_LinkEmailRedirect_ViralVideo":"You will be redirected to Account Center to complete email binding and verification.","Button_GoToAccountCenter_ViralVideo":"Go to Account Center","Title_EmailNotifyConfirm_ViralVideo":"Get email notifications?","Text_EmailNotifyConfirm_ViralVideo":"We\'ll notify ${0} when your videos are ready.","Message_EmailLinked_ViralVideo":"Email linked. Turn on notifications if you want to be notified when this video is ready.","Message_EmailNotifyOff_ViralVideo":"Email notifications turned off","Message_EmailNotifyOn_ViralVideo":"Email notifications turned on","Text_NoHistory_ViralVideo":"No history yet","Text_MobileGuideGenerate_ViralVideo":"Upload product images and selling points to quickly create viral videos for promotion.","Text_MobileGuideReplicate_ViralVideo":"Upload product images and a reference video to replicate the rhythm and visual style of a viral video.","Label_DKGenerateViralMobileGuideNavTitle_ViralVideo":"Generate Viral Video","Label_DKGenerateViralMobileGuideTitle_ViralVideo":"Generate Viral Video","Text_DKGenerateViralMobileGuideSubtitle_ViralVideo":"Upload product images and selling points to quickly create viral videos for promotion.","Label_DKReplicateViralMobileGuideNavTitle_ViralVideo":"Replicate Viral Video","Label_DKReplicateViralMobileGuideTitle_ViralVideo":"Replicate Viral Video","Text_DKReplicateViralMobileGuideSubtitle_ViralVideo":"Upload product images and a reference video to replicate the rhythm and visual style of a viral video.","Label_ZawaGenerateViralMobileGuideNavTitle_ViralVideo":"Product Video Generator","Label_ZawaGenerateViralMobileGuideTitle_ViralVideo":"Product Video Generator","Text_ZawaGenerateViralMobileGuideSubtitle_ViralVideo":"Upload product images and selling points to quickly create viral videos for promotion.","Label_ZawaReplicateViralMobileGuideNavTitle_ViralVideo":"Video Remix","Label_ZawaReplicateViralMobileGuideTitle_ViralVideo":"Video Remix","Text_ZawaReplicateViralMobileGuideSubtitle_ViralVideo":"Upload product images and a reference video to replicate the rhythm and visual style of a viral video.","Button_ConfirmGenerate_ViralVideo":"Confirm & Generate","Button_Close_ViralVideo":"Close","Button_Previous_ViralVideo":"Previous","Button_Next_ViralVideo":"Next","Message_CreateTaskFailed_ViralVideo":"Failed to create task, please try again later","Message_RefreshFailed_ViralVideo":"Refresh failed, please try again later","Message_VideoFormatLimit_ViralVideo":"Reference video currently only supports mp4 / mpeg / mov / avi / flv / mpg / webm / wmv / 3gpp","Message_ReferenceVideoSizeLimit_ViralVideo":"Reference video size cannot exceed ${0}MB","Message_UploadRefVideoFirst_ViralVideo":"Viral replication requires uploading a reference video first","Message_FillProductInfo_ViralVideo":"Please fill in product selling points","Message_SelectVideoType_ViralVideo":"Please select video type and quantity","Button_Disabled_ViralVideo":"Disable","Text_LoadingCreator_ViralVideo":"Loading my creators...","Text_NoCreatorYet_ViralVideo":"No creator image yet, try uploading one","Text_TotalCount_ViralVideo":"(Total ${0})","Text_Submitting_ViralVideo":"Submitting...","Text_LoadingConfig_ViralVideo":"Loading configuration...","Button_Decrease_ViralVideo":"Decrease","Button_Increase_ViralVideo":"Increase","Title_NightHosted_ViralVideo":"Overnight Hosting","Message_CreatorGenSuccess_ViralVideo":"Creator generated successfully","Button_ContinueNewTask_ViralVideo":"Start a New Task","Text_CustomScriptCount_ViralVideo":"Custom Script × ${0}","Text_ViralTypeCount_ViralVideo":"Viral Types × ${0}","Text_FissionCount_ViralVideo":"Viral Variations × ${0}","Text_AiModelEnabled_ViralVideo":"AI Model Enabled","Label_ModelTab_ViralVideo":"Model Tab","Label_ModelParams_ViralVideo":"Model Parameters","Text_ParamsAdjusted_ViralVideo":"Parameters customized individually","Text_NoSellingPoints_ViralVideo":"No selling points provided","Message_FillSellingPointsPlease_ViralVideo":"Please add a selling point description","Message_ThanksForFeedback_ViralVideo":"Thanks for your feedback!","Title_AdditionalFeedback_ViralVideo":"Additional feedback","Placeholder_FeedbackBetter_ViralVideo":"what could be better?","Button_SubmitFeedback_ViralVideo":"submit feedback","Button_LikeFeedback_ViralVideo":"Like","Button_DislikeFeedback_ViralVideo":"Dislike","Text_ProductImageCount_ViralVideo":"${0} Product Image(s)","Text_RefVideoCount_ViralVideo":"${0} Reference Video(s)","Text_FollowGlobal_ViralVideo":"Following global settings","Message_BatchSubmitSuccess_ViralVideo":"Successfully submitted ${0} viral video tasks","Message_BatchSubmitFailed_ViralVideo":"Viral video batch submission failed, please try again later","Text_MaxSelectionTip_ViralVideo":"Up to ${0} video types can be selected at once","Text_DeselectItem_ViralVideo":"Deselect ${0}","Text_SelectItem_ViralVideo":"Select ${0}","Tab_CustomCreatorSection_ViralVideo":"Custom Creator","Tab_MyCreatorSection_ViralVideo":"My Creators","Tab_PersonalAssets_ViralVideo":"Personal Assets","Tab_OfficialRecommendation_ViralVideo":"Official Picks","Title_CustomCreatorSection_ViralVideo":"Create Your Custom Creator","Text_InProgress_ViralVideo":"Generating...","Text_NothingToDownload_ViralVideo":"No downloadable results at the moment","Text_ResultNotReady_ViralVideo":"This result isn\'t ready to download yet","Text_PreparingDownload_ViralVideo":"Preparing download...","Text_PreDownloaded_ViralVideo":"Processing complete. Tap to save the video to your phone.","Message_RedoSubmitted_ViralVideo":"Redo request submitted","Message_RedoFailed_ViralVideo":"Redo failed, please try again later","Text_CancelHostedConfirm_ViralVideo":"Cancelling hosting will stop any generation in progress.","Button_Later_ViralVideo":"Later","Message_HostedCancelled_ViralVideo":"Hosting cancelled","Text_BatchFailed_ViralVideo":"This batch didn\'t return results — you can regenerate later.","Title_ViralTypeConfig_ViralVideo":"Viral Type Configuration (Total ${0})","Title_ReplicateConfig_ViralVideo":"Replication Configuration","Label_ReplicateCount_ViralVideo":"Replication Count","Label_StylePreference_ViralVideo":"Style Preference","Placeholder_StylePreference_ViralVideo":"You can specify preferences such as rhythm, mood, camera language, color tone, etc.","Label_SupplementNote_ViralVideo":"Additional Notes","Placeholder_SupplementNote_ViralVideo":"Add structures you don\'t want changed, shots that must be preserved, special selling point requirements, etc.","Text_FourthSection_ViralVideo":"4. Variation Count","Message_RequestFailed_ViralVideo":"Request failed","Message_PromptOptimizeFailed_ViralVideo":"Prompt optimization failed, please try again later","Message_ModelImageFailed_ViralVideo":"Model image generation failed, please try again later","Desc_BatchGenerateViral_ViralVideo":"Batch upload product images, configure selling points and generate viral video tasks.","Desc_BatchReplicateViral_ViralVideo":"Batch upload product images and add reference videos for each task to replicate viral content.","Text_RecordRetentionTip_ViralVideo":"Generation records are only kept for 2 months. Please download and save them as soon as possible to avoid loss.","Message_PromptOptimizeEmpty_ViralVideo":"Prompt optimization returned no result","Message_CompleteModelInfo_ViralVideo":"Please complete the model information first","Message_ModelGenFailed_ViralVideo":"Model generation failed, please try again later","Text_VideoFormatSupport_ViralVideo":"Reference video currently only supports mp4 / mpeg / mov / avi / flv / mpg / webm / wmv / 3gpp formats","Message_UnsupportedVideoFiltered_ViralVideo":"Some video formats are not supported and have been filtered out","Message_FreeTrialOneVideoOnly_ViralVideo":"Free trial covers 1 video only. Upgrade to Pro to generate more.","Button_AddToMyCreator_ViralVideo":"Add to My Creators","Button_ResetGlobal_ViralVideo":"Reset to Global","Button_TaskLevelCustomCreator_ViralVideo":"Task-Level Custom Creator","Button_TaskLevelReplicateModel_ViralVideo":"Task-Level Replication Model","Label_ModelReference_ViralVideo":"Model Reference Image","Placeholder_CreatorStyle_ViralVideo":"Add creator persona, speaking style, camera presence requirements, etc.","Text_CreatorDisabledTip_ViralVideo":"When creator configuration is not enabled, the system will generate using the default general on-camera style.","Text_GenerateViralResult_ViralVideo":"Generated Viral Results","Text_OverrideCount_ViralVideo":"Override ${0} item(s)","Text_ReplicateViralResult_ViralVideo":"Replicated Viral Results","Text_SavedCreatorProfiles_ViralVideo":"Saved creator profiles — fill in with one click.","Label_GenerateScheme_ViralVideo":"Viral Generation Plan ${0}","Label_ReplicateScheme_ViralVideo":"Viral Replication Plan ${0}","Text_VideoResult_ViralVideo":"Video Result","Button_ContinueGenerate_ViralVideo":"Continue Generating","Desc_CreatorImageEmptyHint_ViralVideo":"Generated creator images will appear here for direct reuse on this page.","Text_ItemCountUnit_ViralVideo":"${0} items","Text_CreditAmount_ViralVideo":"${0} credits","Text_TotalItems_ViralVideo":"Total: ${0}","Text_SelectedVideoTypeCount_ViralVideo":"${0} video types selected","Text_FirstVideoDiscountBadge_ViralVideo":"First video discount","Text_DesignKitFirstDiscountVipBadge_ViralVideo":"50% OFF for 1st","Text_DesignKitFirstDiscountTryBadge_ViralVideo":"Try for $1.99","Text_FreeVideoBadge_ViralVideo":"${0} Free Video","Text_FirstDiscountPrice_ViralVideo":"Generate your first video for only ${0} credits (original ${1} credits)","Text_UpgradeProDiscount_ViralVideo":"Upgrade to Pro for 25% off","Text_EnjoyedProDiscount_ViralVideo":"Member 25% off applied","Text_BatchFeatureRequiresMembership_ViralVideo":"Batch generation requires a membership","Text_OpenProGenerationDiscount_ViralVideo":"Subscribe to Pro for a 25% generation discount","Text_EnjoyedProGenerationDiscount_ViralVideo":"Pro 25% generation discount applied","Button_OpenProOrMembership_ViralVideo":"Subscribe to Pro / Membership","Text_MemberExclusiveBadge_ViralVideo":"Members only","Text_VipFunctionLimitedTimeOpen_ViralVideo":"VIP features available for a limited time","Title_NetworkDisconnected_ViralVideo":"Network connection lost","Text_NetworkDisconnectedRefresh_ViralVideo":"Your task is still generating in the background and will not be lost. Check your network, then refresh the page to view the latest progress.","Button_RefreshPage_ViralVideo":"Refresh Page","Message_NetworkDisconnectedRetry_ViralVideo":"Network connection lost. Check your network and try again.","Tip_InvalidLink_ViralVideo":"Please enter a valid video link","Title_GenerateParams_ViralVideo":"Generation Parameters","Label_PreviewMarket_ViralVideo":"Target Market:","Label_PreviewLanguage_ViralVideo":"Target Language:","Label_PreviewAspectRatio_ViralVideo":"Aspect Ratio:","Label_PreviewScriptType_ViralVideo":"Script Type:","Label_PreviewProductInfo_ViralVideo":"Product Selling Points:","Text_GeneratingBrowserTitle_ViralVideo":"⏳ Generating... | ${0}","Text_SimplePreviewSwipeGuide_ViralVideo":"Swipe up to see more","Button_UploadImageReplicate_ViralVideo":"Upload image to replicate","Label_PlayVideo_ViralVideo":"Play video","Label_NoWatermark_ViralVideo":"No Watermark","Tool_LosslessUpscale":"Image Upscaler","Tool_AiRecolor":"AI Image Recolor","Tool_AiPhotoEditorTitle":"AI Photo Editor","Message_ZipOnlyOne":"You can only upload one archive at a time","Message_ZipSizeLimit":"Compressed file size cannot exceed ${0} MB","Message_ZipExtractFailed":"Failed to parse archive ${0}","Message_ZipNoUploadableFiles":"${0} No uploadable files found in this compressed package","Message_ZipAlreadyUploaded":"All files in ${0} have already been uploaded. Duplicate uploads were skipped.","Title_VideoWatermark":"Your video contains a watermark","Desc_VideoWatermark":"Videos exported during the trial will include a ${0} watermark. Upgrade to Premium to download videos without a watermark.","Button_RemoveWatermark":"Remove Watermark","Button_DownloadAnyway":"Download Anyway","Message_DownloadFailedTryAgain":"Download failed. Try again.","MenuItem_ProductRestore":"Product Restoration","Title_ProductRestore":"Product Restore","Desc_ProductRestore":"Upload an original image to correct product distortion","Tip_ProductRestoreUpload":"Choose an image with an angle and orientation similar to the current result. The product should be clear and fully visible.","Button_StartProductRestore":"Start Restoration","Message_ProductRestoreUploadLimit":"Please upload an image in JPEG, JPG, PNG, or HEIC format, up to 10 MB.","Message_ProductRestoreUploadFailed":"Failed to upload the product restoration image. Please try again.","Message_VideoDownloadingInBackground":"Downloading in the background. You can continue using ${0}","Button_AdjustParameters":"Adjust Settings","Text_WPS_Welcome_Modal_Meidou_Description1":"Premium Members: One-Time Bonus of 50 Credits","Text_WPS_Welcome_Modal_Meidou_Description2":"Non-Premium members: One-time bonus of 25 credits","Text_WPS_Meidou_Rules":"Credit Usage Rules","Text_WPS_Meidou_Details":"Credit Usage Details","Button_ImportLink":"Import Link","Tip_ProductImagesUpload":"Upload more product angles for better results","Button_EditSkill":"Editing Skills","Title_CategorySkills":"${0} Skills","Button_AllSkills":"All Skills","Text_NoSkills":"No skills available","Aria_ScrollLeft":"Scroll left","Aria_ScrollRight":"Scroll Right","Message_CompleteRequired":"Please complete the required fields","Button_InsertToDesc":"Add to Description","Aria_ExpandOptions":"Expand Options","Message_FileUploadFailedRetry":"File upload failed. Please try again.","Button_UploadImageVideo":"Upload images/videos","Aria_DeleteFile":"Delete files","Aria_PauseVideo":"Pause Video","Aria_SwitchToSlide":"Switch to image ${0}","Tip_PleaseFill":"Please fill in ${0}","Tool_ImageToVideoGenerator":"Image to Video Generator","Tool_TextToVideoGenerator":"Text to Video Generator","Tool_TikTokVideoGenerator":"TikTok Video Generator","Tool_InstagramVideoGenerator":"Instagram Video Generator","Tool_YouTubeVideoGenerator":"YouTube Video Generator","Tool_YouTubeShortsGenerator":"YouTube Shorts Generator"}');
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/x-design-locales-next/es.json
const x_design_locales_next_es_namespaceObject = JSON.parse('{"Tab_Design":"Diseño","Button_Send":"Enviar","Input_Describe_Workspace":"Describe tu imagen y la crearé por ti","Tab_AgentCase":"Caso de Agente","Tab_RecentCreations":"Recientes","Tag_Hot":"Tendencias","Tag_BrandDesign":"Diseño de marca","Tag_Logo":"Logotipos","Tag_Posters":"Pósteres","Tab_Agent":"Agente","Tool_AiPhotoEditor":"Editor de imagen","Button_Upload":"Subir","Tool_Designer":"Diseñador","Title_AiTool":"Herramientas de IA","Tool_ImageBackgroundRemover":"Eliminador de fondos con IA","Tool_AiBackgroundGenerator":"Generador de fondos con IA","Tool_ImageEnhancer":"Mejorador de imagen","Tool_AiObjectsRemover":"Eliminador de objetos","Tool_AiModelMannequin":"Modelo de IA: Maniquí","Tool_AiModelFlatlay":"Modelo de IA: Flatlay","Tool_AiImageRecolor":"Recolorear imágenes con IA","Tool_AiImageExtender":"Ampliador de imagen con IA","Tool_ImageUpscaler":"Refinador de imágenes con IA","Tool_AiLogo":"Generador de logotipos","Button_BlankCanvas":"Crear","Sidebar_Create":"Inicio","Sidebar_Tools":"Herramientas de IA","Sidebar_Batch":"Editor por lotes","Sidebar_MyDesigns":"Mis diseños","Sidebar_Inspire":"Inspírame","Sidebar_Brand":"Kit de marca","Sidebar_PackUp":"Cerrar barra lateral","Tag_All":"Todo","Tag_Design":"Diseño","Sidebar_Unfold":"Abrir barra lateral","Menu_Edit":"Editar","Menu_Download":"Descargar","Menu_Delete":"Eliminar","Tab_RecentlyCreated":"Recientes","Tab_GenerateRecords":"Creaciones","Menu_Total":"Total","Menu_Total_Explain_AgentCredits":"Solo para el Agente de IA y se usarán primero.","Menu_DueToday":"Créditos de bonificación diarios","Menu_DueToday_Explain":"Válidos hasta el final del día.","Menu_Else_AgentCredits":"Otros créditos","Button_GoPro_GetMore":"Obtén más créditos","Menu_Total_Explain_PaidCredits":"Para todas las funciones, válidos durante la vigencia de la membresía.","Menu_Pro":"Créditos de suscripción","Menu_Pro_Explain":"Válido durante la vigencia de la membresía.","Menu_Else":"Otros créditos","Menu_Else_Explain_PaidCredits":"Créditos de otras fuentes. Cada tipo puede tener su propio vencimiento.","Menu_Else_Explain_AgentCredits":"Créditos de otras fuentes. Válidos por más tiempo.","Menu_UsageDetail":"Detalles de uso","Menu_Total_Explain_SuspendCredits":"No estarán disponibles hasta que se reactive tu membresía.","Tab_Invite":"Invitar","Menu_InviteReward":"Recompensa por invitar amigos","Tab_Reward":"Recompensas","Title_AgentCreditForRewards":"Recompensas de créditos de Agente:","Table_Time":"Fecha y hora","Table_Invitee":"Invitado","Title_ShareWithFriends":"Comparte con tus amigos","Title_ShareWithFriends_ExplainOne":"<span style=\\"color:#616266;\\">¡Invita a un amigo y ambos recibirán </span><span style=\\"color:#2D990C;\\">${0} créditos de Agente!</span>","Title_InvitationLink":"Comparte este enlace con tus amigos","Button_Copy":"Copiar","Title_Tips":"Consejos","Title_Tips_ExplainOne":"1. Los créditos de Agente solo se pueden usar para acceder a las funciones del Agente de IA. Los créditos de recompensa son válidos por dos años.","Title_Tips_ExplainTwo":"2. Los amigos nuevos recibirán una recompensa después de completar su registro. Si tienes preguntas, comunícate con nuestro equipo de asistencia.","Title_GetRewarded":"¡Invitación exitosa!","Title_GetRewarded_Explain":"Los créditos solo se pueden usar para las funciones del Agente de IA y son válidos por dos años.","Button_Ok":"Entendido","Title_FailedToReceiveReward":"Error en la operación","Title_FailedToReceiveReward_Explain":"Si tienes preguntas, comunícate con nuestro equipo de asistencia.","Tool_AiBackgroundGenrator":"Generador de fondos con IA","Title_YouCannotUseYourOwnLink":"No se permiten los enlaces privados","Table_AgentCredit":"Créditos de Agente","Title_ShareWithFriends_ExplainTwo":"<span style=\\"color:#616266;\\">¡Puedes invitar hasta </span><span style=\\"color:#2D990C;\\">${0} amigos nuevos </span><span style=\\"color:#616266;\\"> y obtener un máximo de ${1} créditos de Agente!</span>","Button_Invite":"Invitar","Menu_Title_Invite":"Refiere a un amigo","Text_Button_Invite":"Obtener créditos","Title_Dialog_Invite":"Refiere a un amigo","Desc_Dialog_Invite":"Comparte tu enlace con amigos o en redes sociales. Cuando un amigo se registre mediante tu enlace, ambos recibirán ${0} créditos. Si se suscribe, ambos recibirán hasta ${1} créditos adicionales.","Detail_Dialog_Invite":"Detalles","Text_Copy_Invite":"Copiar enlace","Title_Rewards_Invite":"Recompensas","SubTitle_Rewards1_Invite":"Créditos totales obtenidos","SubTitle_Rewards2_Invite":"Usuarios gratuitos referidos","SubTitle_Rewards3_Invite":"Usuarios de pago referidos","Success_Copy_Invite":"Enlace copiado","Title1_Invited_Invite":"¡Recibiste una invitación!","Text_Rule1_Invite":"Por cada amigo que se registre con tu enlace, ambos ganarán <strong>${0} créditos</strong>.","Text_Rule2_Invite":"Si tu amigo se suscribe, ambos obtendrán créditos adicionales (<strong>${0} para Plus, ${1} para Pro</strong>).","Text_Rule3_Invite":"Las suscripciones de pago no se pueden reembolsar si el plan se usó o se consumieron los créditos concedidos, en todo o en parte. Además, los créditos gratuitos no se pueden revocar una vez que se usan.","Text_Rule4_Invite":"Cada usuario puede invitar a hasta ${0} amigos.","Text_Rule5_Invite":"No se concederán recompensas por referencias a cuentas existentes, autorreferencias, cuentas duplicadas o actividad fraudulenta.","Text_Rule6_Invite":"${0} se reserva el derecho de ajustar el programa y revocar las recompensas de cuentas anormales.","Text_Divider_Invite":"o comparte el enlace","Title2_Invited_Invite":"Únete a ${0} y reclama tus recompensas","SubTitle1_Invited_Invite":"Un amigo te invitó a probar nuestro agente profesional de IA para marcas. Crea fácilmente diseños para marketing de marca de alta calidad, como logos, posters, menús y recursos para redes sociales.","SubTitle2_Invited_Invite":"<strong>Regístrate ahora</strong> y tanto tú como tu amigo <strong>recibirán ${0} créditos</strong>. <strong>Si te suscribes</strong>, cada uno recibirá créditos adicionales según el plan que elijas (<strong>${1} créditos con Plus o ${2} créditos con Pro</strong>). ¡Regístrate ahora para reclamar tus recompensas!","Button_Invited_Invite":"Regístrate para reclamar tus recompensas","Success_Invited_Invite":"Te uniste mediante una referencia y recibiste ${0} créditos.","Error_Invited_Invite":"Ya tienes una suscripción activa.","Text_Share_Invite":"Estoy usando ${0} para crear rápidamente logos, elementos visuales y videos. Regístrate con mi enlace y ambos obtendremos créditos adicionales.","Title_Share_Invite":"¡Únete a ${0} y obtengamos créditos juntos!","Share_Email_Invite":"Correo","Text_Rule7_Invite":"Puedes usar los créditos para el Agente de IA. Los créditos expiran después de un mes.","Title_AgentCredits":"+50 créditos de Agente","Input_Models":"Modelo","Button_TryItNow":"Pruébalo ahora","Account_Pricing":"Precios","Account_Language":"Idioma","Account_Language_English":"Inglés","Account_Language_Chinese":"Chino","Tips_Adding":"Procesando…","Tips_Loading":"Cargando…","Tips_Creating":"Procesando…","Tips_Downloading":"Descargando…","Tips_Sending":"Enviando…","Tips_AddSuccess":"Se agregó correctamente","Tips_MakeSameError":"No se puede volver a crear","Tips_UnsupportedGradientColor":"No se admiten gradientes","Tips_CanNotAdding":"Error al agregar","Tips_Uninitialized":"Error al enviar el mensajes","Tips_UploadFailed":"Error al cargar. Inténtalo de nuevo.","Tips_UploadMaxCountLimit":"Sube hasta ${n} archivo(s) ${type}","Tips_UploadMaxFileSize":"No se pudo subir el archivo ${file}. Usa un archivo de hasta ${n} MB.","Tips_UploadImageAndVideoLimit":"Puedes subir 1 imagen y 1 video a la vez","Tips_UnsupportedSvgFile":"No se admiten archivos SVG","Tips_UnsupportedUploadFileFormats":"No se admite el formato de tu archivo ${files}","Tips_CanNotAddSameFileTips":"Este archivo ya existe","Tips_TextMinLengthTips":"Ingresa al menos ${n} caracteres","Tips_TextMaxLengthTips":"Ingresa hasta ${n} caracteres. Cada carácter chino o emoji cuenta por 2.","Tips_AccessDenied":"Acceso denegado","Tips_CreateFailed":"Error al iniciar el chat","Tips_Error":"Ocurrió un error","Tips_NotFound":"El chat no existe","Tips_RequestAgentModelListError":"Error al solicitar la lista de modelos de Agente","Desc_Ended":"Fin","Button_PeopleUse_Agent":"${n} usuarios lo probaron","Dropdown_AddToChat":"Agregar al chat","Dropdown_AddToBrandKit":"Agregar al Kit de marca","Dropdown_SaveToBrandKit":"Guardar como logotipo de marca","Dropdown_SaveToBrandTemplate":"Guardar como plantilla de marca","Title_Design_Agent":"Diseño","Title_MainColor":"Color principal","Title_SecondaryColor":"Color secundario","Bitton_ViewTheBrandKit":"Haz clic para ver el kit de marca","Dropdown_InportImages":"Importar imágenes","Title_Upgrade_Pro":"Actualizar","Desc_SubscribeToUnlock_Pro":"¡Suscríbete para desbloquear más!","Desc_RunOutOfFreeUses_Pro":"Se te acabaron los usos gratuitos.","Desc_RunOutOfUsesForToday_Pro":"Te has quedado sin usos gratuitos por hoy. Regresa mañana.","Desc_PurchaseCompleted_Pro":"Compra completada","Desc_ContinueDesign_Pro":"¡Ahora puedes continuar con tu diseño!","Button_UnlockNow":"Suscríbete","Tips_Copied":"¡Copiado!","Tips_Credit_Explain_Paid":"¿Qué son los créditos comprados?","Title_Total_InactiveCredits":"Créditos inactivos totales","Title_Total_PaidCredits":"Créditos totales comprados","Menu_SuspendCredits":"Créditos inactivos","Menu_Credits":"Créditos","Tab_RecentCreations_Agent":"Agente","Tab_RecentCreations_Design":"Herramientas inteligentes","Menu_FunctionalPricing":"Precios del Agente","Title_Total_AgentCredits":"Total: créditos de Agente","Tips_Credit_Explain_Agent":"¿Qué son los créditos de Agente?","Title_FeaturePricing":"Precios del Agente","Tab_Category":"Categoría","Tab_TaskType":"Tarea","Tab_Consume":"Precio (créditos)","Tab_ExampleContent":"Ejemplos","Tips_CreditExplain_Inactive":"¿Qué son los créditos inactivos?","langding_more_bg_remover":"Eliminador de fondo","langding_more_enhancer":"Mejorador de imagen","langding_more_objects_remover":"Eliminador de objetos","langding_more_bg_generator":"Generador de fondos con IA","Title_More1_Home":"Mejorador de imagen","Title_More2_Home":"Borrador de objetos con IA","Title_More3_Home":"Generador de fondos con IA","Title_More4_Home":"Eliminador de fondos con IA","Title_More5_Home":"Herramientas de imagen por lotes","Title_Home":"Tu Agente de IA para el diseño de <span>e-commerce</span>","Placeholder_Input_Home":"Describe tu imagen y la crearé por ti.","Title_Card4_Home":"Recursos visuales para Amazon","Title_Card1_Home":"Imágenes de prueba de ropa y accesorios","Title_Card3_Home":"Imágenes de la página de detalles del producto","Title_Card2_Home":"Generador de fondos","Desc_Features1_Home":"La IA extrae automáticamente las características del producto y las preferencias de estilo para determinar las soluciones ideales de diseño.","Desc_Features2_Home":"Solo ingresa una oración y la IA generará una colección completa de imágenes para e-commerce, incluyendo la imagen principal, recursos visuales de apoyo y una página completa de detalles del producto.","Text_Btn_Home":"Comienza gratis","Desc_Features3_Home":"Crea automáticamente recursos visuales listos para distintas plataformas, como Amazon, Etsy, TEMU, eBay y más. Esto garantiza que las imágenes siempre estén optimizadas para atraer al público adecuado.","Desc_Features4_Home":"Solo ingresa tu solicitud y la IA adaptará el lenguaje, estilo, tono y los elementos culturales para producir versiones localizadas para cada mercado objetivo.","Desc_Features5_Home":"Guarda el flujo de trabajo de tu diseño como una plantilla reutilizable y deja que la IA genere automáticamente imágenes por lotes para todos tus SKU.","Desc_Features6_Home":"Sin importar si trabajas con 10 o 1,000 productos, puedes producir rápidamente un conjunto visual completo y uniforme.","Title_Qualification_Home":"¡Avalado por más de 5 millones de vendedores de e-commerce!","Text_Btn_Qualification_Home":"Ver certificación","Title_Carousel_Home":"Más herramientas de IA","Title_Footer_Home":"Tu Agente de IA para el diseño de e-commerce","Title_Footer1_Home":"Cuenta de redes sociales","Subtitle_Footer1_Home":"YouTube","Subtitle_Footer2_Home":"X","Subtitle_Footer3_Home":"Instagram","Subtitle_Footer4_Home":"TikTok","Title_Footer2_Home":"Ayuda y legal","Subtitle_Footer5_Home":"Términos de servicio","Subtitle_Footer6_Home":"Política de privacidad","Copyright_Footer_Home":"Copyright ${0} Meitu, Inc.","Desc_Evaluation1_Home":"¡Me encanta Designkit! Las imágenes de estilo de vida generadas con IA son naturales: cálidas y de estilo nórdico, perfectas para mi tienda de velas. Mis publicaciones se ven increíbles y las ventas aumentaron. Vale la pena.","Job_Evaluation5_Home":"Vendedora de TEMU en México","Job_Evaluation6_Home":"Especialista de operaciones de Amazon","Job_Evaluation12_Home":"Gerente de una tienda de Amazon con múltiples SKU en Indonesia","Job_Evaluation2_Home":"Dueño de tienda en Amazon y Mercado Libre","Name_Evaluation12_Home":"Arif","Desc_Evaluation11_Home":"Las imágenes de estilo de vida se ven muy naturales, casi como si las hubiera tomado un profesional. A mis clientes también les encantan, pues he notado que mis tasas de conversión están subiendo.","Name_Evaluation11_Home":"Siti","Job_Evaluation10_Home":"Propietario de una tienda transfronteriza en Lazada y Shopee (Indonesia)","Name_Evaluation10_Home":"Nina","Job_Evaluation3_Home":"Diseñador de e-commerce DTC","Job_Evaluation8_Home":"Propietario de una tienda de productos de exteriores para Walmart en Estados Unidos","Name_Evaluation8_Home":"Jason","Job_Evaluation9_Home":"Vendedor de Mercado Libre en Argentina","Desc_Evaluation7_Home":"¡Las escenas de los productos para mascotas que genera la IA son súper lindas! Los perros y gatos se ven perfectamente proporcionados y naturales. Además, el tamaño y la escala coinciden con los requisitos de la plataforma, por lo que las imágenes son realmente fáciles de usar de inmediato.","Job_Evaluation7_Home":"Propietario de una tienda de Mercado Libre en Brasil","Desc_Evaluation8_Home":"Las escenas que uso para mis tiendas de campaña son muy realistas. La iluminación y los ángulos se ven naturales, y las proporciones son exactas. Me ahorra muchísimo tiempo en comparación con hacerlo todo por mi cuenta.","Name_Evaluation7_Home":"Thiago","Desc_Evaluation9_Home":"La herramienta es realmente rápida y las imágenes que genera pueden subirse casi directamente a Mercado Libre y Amazon sin modificaciones.","Desc_Evaluation6_Home":"Antes me preocupaba que la IA hiciera un desastre con las texturas de la tela, pero apenas se ven diferentes del original. Los tejidos parecen tejidos, la mezclilla parece mezclilla e incluso cumple los requisitos de imagen de Amazon. Lanzar productos nuevos ahora es mucho más rápido.","Name_Evaluation9_Home":"Lucas","Name_Evaluation6_Home":"Emma","Desc_Evaluation5_Home":"Las imágenes de producto generadas con IA son realmente precisas. La longitud del cable y la forma de los conectores son exactas, e incluso coinciden con el estilo de TEMU. Es un gran ahorro de tiempo en comparación con tomar las fotos yo mismo.","Desc_Evaluation12_Home":"Con una sola indicación, puedo obtener gráficos utilizables al instante, lo cual es mucho más rápido que esperar al diseñador. Honestamente, es súper conveniente.","Name_Evaluation3_Home":"Chloe","Name_Evaluation1_Home":"Sofia","Desc_Evaluation4_Home":"Las texturas metálicas y los detalles estructurales son muy claros, así que las imágenes se ven profesionales. Puedo usarlas al instante sin editarlas.","Name_Evaluation4_Home":"León","Desc_Evaluation10_Home":"La generación por lotes es súper conveniente. Puedo procesar decenas de SKU a la vez, y es mucho más rápido que hacer todo manualmente como antes.","Name_Evaluation2_Home":"Mariana","Desc_Evaluation3_Home":"Vendo ropa y me preocupaba que la IA hiciera un desastre con los colores o las texturas de las telas, pero de hecho lo hizo muy bien. Las poses de la modelo se ven naturales y las imágenes quedan prácticamente listas para usarse al instante.","Job_Evaluation1_Home":"Especialista de operaciones de una tienda de SHEIN","Name_Evaluation5_Home":"Diego","Job_Evaluation11_Home":"Especialista de operaciones de Amazon","Desc_Evaluation2_Home":"La herramienta es súper rápida y las imágenes quedan prácticamente listas para subir a Mercado Libre o Amazon. Incluso adapta los fondos y los modelos a los gustos locales, y los resultados se ven totalmente profesionales.","Job_Evaluation4_Home":"Vendedor de eBay en Alemania","Title_Evaluation_Home":"Sus historias","Title_Introduction_Home":"Diseño premium con IA que impulsa las ventas","Desc_Qualification_Home":"Proveedor certificado de servicios SPN de Amazon","Title_Seo_Home":"Generador de imagen y video de producto con IA para e-commerce","Desc_Seo_Home":"Genera instantáneamente imágenes de producto, pósteres y videos para Amazon, TikTok y otras tiendas en línea con el Agente de IA de Designkit. ¡Comienza a diseñar sin costo hoy!<br>","Keywords_Seo_Home":"Agente de IA para e-commerce, Herramientas de IA para e-commerce, Generador de imagen de producto con IA, Generador de video de producto con IA, Editor de foto de producto con IA, Eliminador fondo con IA","Title_Features1_Home":"De una sola solicitud a un conjunto completo de recursos visuales","Title_Features2_Home":"Localización completamente automatizada para vender tus productos a nivel global en múltiples plataformas","Title_Features3_Home":"Genera automáticamente imágenes por lotes para múltiples SKU, ¡y vence a la competencia!","Title_Designkit_Home":"Designkit","Tips_AboveTheFold2_Home":"Desplázate para explorar","Tips_Material1_Home":"Conjunto de imágenes para publicaciones","Tips_Material2_Home":"Prueba virtual","Tips_Material3_Home":"Contenido A+","Tips_Material4_Home":"Generador de fondos","Free_Button_Home":"Probar gratis","Title_Header1_Home":"Producto","Title_Header2_Home":"solución","Title_Header3_Home":"Inspiración","Title_Header4_Home":"Aprender","Title_Header5_Home":"Precios","SecondTitle_Header1_Home":"Agente de e-commerce con IA","SecondTitle_Header2_Home":"Herramientas de imagen con IA","SecondTitle_Header3_Home":"Herramientas de video con IA","SecondTitle_Header4_Home":"Solución de diseño de Amazon","SecondTitle_Header5_Home":"Solución de e-commerce para redes sociales","SecondTitle_Header6_Home":"Generador de imagen de producto con IA","SecondTitle_Header7_Home":"Generador de modelos de moda con IA","SecondTitle_Header8_Home":"Cambiador de color de ropa","SecondTitle_Header9_Home":"Generador de video de producto","SecondTitle_Header10_Home":"Herramientas de IA","SecondTitle_Header11_Home":"Editor de fotos con IA","SecondTitle_Header12_Home":"Editor de fotos con IA en línea","SecondTitle_Header13_Home":"Editor de fotos masivo","SecondTitle_Header14_Home":"Editor de fotos masivo con IA","SecondTitle_Header15_Home":"Mejorador de imágenes por lotes","SecondTitle_Header16_Home":"Eliminador de marcas de agua masivo","SecondTitle_Header17_Home":"Generador de fondos por lotes","SecondTitle_Header18_Home":"Eliminador de fondos masivo","Title_Footer3_Home":"Herramientas de diseño","Subtitle_Footer8_Home":"Editor de fotos con IA","Subtitle_Footer7_Home":"Cambiador de fondos con IA","Subtitle_Footer9_Home":"Fondo transparente","Subtitle_Footer10_Home":"Cambiar el color de fondo","Subtitle_Footer11_Home":"Eliminador de marcas de agua de imagen","Subtitle_Footer12_Home":"Eliminar texto de la imagen","Subtitle_Footer13_Home":"Agregar stickers a fotos","Subtitle_Footer14_Home":"Agregar marca de agua en la foto","Title_Footer4_Home":"Modelos de imagen","Subtitle_Footer15_Home":"Nano Banana Pro (Gemini 3.0 Pro)","Title_Footer5_Home":"Descargar gratis","Subtitle_Footer16_Home":"Aplicación para iOS","Subtitle_Footer17_Home":"Aplicación para Android","Title_Footer6_Home":"Síguenos","Subtitle_Footer18_Home":"Kling 3.0","Subtitle_Footer19_Home":"Seedance 2.0","Title_Footer7_Home":"Modelos de video","Button_Export":"Descargar","Title_Layer":"Capas","InputNumber_Opacity":"Opacidad","Buttom_Comfirm":"Confirmar","Button_Share":"Compartir","Button_Delete":"Borrar","Title_LoginPopup":"Inicia sesión para comenzar la prueba","SubTitle_LoginPopup":"Comienza a crear con Zawa hoy","Tip_ModalTitle":"Recordatorio","TipContent_HistoryDelete":"Después de borrarlo, no se podrá restablecer este registro. ¿Confirmas que deseas borrarlo?","Title_Logo":"Logotipo","Title_BrandKit":"Plantillas","Tab_BrandKit":"Kit de marca","Tab_UploadLocal":"Elegir del álbum","Button_UploadImage":"Subir imágenes","Button_UploadProductImage":"Subir imagen de producto","Button_UploadReferImage":"Subir referencias","Tip_ClickDragParseImage":"Sube, suelta o pega imágenes aquí.","Tip_UploadMax":"Sube archivos JPG, JPEG o PNG de hasta ${0} MB, con un máximo de N imágenes.","Tooltip_SwitchBrandKit":"Cambiar el kit de marca","Discribe_BrandKitSelect":"Selecciona un estilo de marca como referencia para este diseño.","Title_Models":"Modelos","Switch_Auto":"Automático","Tab_Image":"Imagen","Tab_Video":"Video","MenuItem_AddToBrandLogo":"Guardar como logotipo de marca","MenuItem_AddToBrandTemplate":"Guardar como plantilla de marca","Button_ExportImage":"Importar imágenes","Button_ExportMedia":"Importar videos","Button_ExportFromBrandkit":"Importar desde el kit de marca","Dropdown_AddFromBrandkit":"Añadir desde el kit de marca","Placeholder_ChatInput":"¡Comencemos!","MenuItem_AiChange":"Edición con IA","MenuItem_AiExpend":"Ampliador con IA","MenuItem_AiHD":"Claridad con IA","MenuItem_Eliminate":"Eliminación con IA","MenuItem_SplitLayers":"Dividir capas","MenuItem_Cutout":"Eliminador de fondos","MenuItem_ChangeText":"Editar texto","MenuItem_Crop":"Tamaño de la imagen","MenuItem_AddToChat":"Agregar al chat","MenuItem_AddToBrand":"Agregar al Kit de marca","Tooltip_Layer":"Capas","Tooltip_Grab":"Herramienta de mano","Tooltip_Select":"Seleccionar","Tooltip_Redo":"Rehacer","Tooltip_Undo":"Deshacer","Tooltip_Add":"Agregar","Tooltip_ShowAll":"Mostrar todo","Tip_UploadType":"Formato de archivo no admitido","Tip_UploadSize":"Solo se admiten archivos de hasta ${0} MB","Tip_UploadWH":"Asegúrate de que cada imagen tenga menos de ${0}×${1} píxeles","Tip_UploadTypeTranslate":"Error al cambiar el formato de archivo","Tip_UploadFail":"Error al subir","Tooltip_AddText":"Agregar texto","Text_AddDefault":"Esto es un texto de muestra.","Tooltip_OverflowImageSize":"Cambia el tamaño de tu imagen a menos de ${0} píxeles","Placeholder_ImageFusion":"Dime cómo te gustaría que se fusionen las imágenes","Button_ImageFusion":"Fusionar","Button_Cancel":"Cancelar","Button_AiChange":"Editar","Placeholder_AiChange":"Dime qué quieres cambiar","Button_Eliminate":"Borrador","Label_OriginSize":"Original","Label_CropRadio":"Relación de aspecto","Button_Free":"Gratis","Button_Origin":"Original","Button_Crop":"Recortar","Placeholder_ChangeText":"Ingresa texto. Ejemplo: Hola","Button_ChangeText":"Confirmar","InputNumber_PanSize":"Tamaño del pincel","Label_TargetSize":"Objetivo","Tooltip_ImageFusion":"Puedes fusionar de ${0} a ${1} imágenes","Title_Workspace":"Tu agente de IA\\npara contenido en redes sociales","Button_Pro":"Obtén Pro gratis","Title_NanoPro":"🍌🍌Nano Banana Pro ya está disponible en Zawa.","Dropdown_AdvancedFeatures_Title":"Funciones avanzadas","Dropdown_AdvancedFeatures_Conent":"Acceso total a todas las herramientas potenciadas por IA para mejorar tu eficiencia.","Dropdown_MassiveContent_Title":"Gran cantidad de contenido","Dropdown_MassiveContent_Content":"Acceso ilimitado a plantillas premium y a una gran colección de recursos de stock Plus.","Dropdown_CommercialRights_Title":"Derechos comerciales","Dropdown_CommercialRights_Content":"Usa tus creaciones personales con confianza, con protección de derechos de autor garantizada.","Popup_SubscribeIntl_Desc":"Aprovecha al máximo Zawa con Pro","Popup_SubscribeIntl_Desc1":"Desbloquea más creaciones con créditos","Popup_SubscribeIntl_Detail":"Consulta los detalles de los planes y Ayuda","Popup_StripeCheckout":"Pago con Stripe","Popup_LiveSupport":"Asistencia en vivo","Popup_CancelAnytime":"Cancela en cualquier momento","Menu_Language":"Idioma","Menu_ManageSubscription":"Administrar suscripciones","Menu_TermsPolices":"Términos y políticas","Menu_ManageSubscriptions":"Administrar suscripciones","Menu_ReferralLink":"Enlace de referencia","Menu_BenefitsUpgraded":"Beneficios","Menu_TermsPolicies":"Términos y políticas","Menu_AccountManagement":"Cuenta","Title_ReferralCode":"Código de referencia","Title_ReferralLink":"Enlace de referencia","Desc_NoActiveSubscription":"No hay una suscripción activa","Button_ClickToSubscibe":"Haz clic aquí para suscribirte","Title_SubscriptionCancel":"Tu suscripción ha sido cancelada","Title_SeeYou":"Lamentamos que te vayas…😭","Desc_NextBillingDate":"Se renueva el","Desc_EstimatedAmount":"Total estimado","Button_CancelSubscription":"Cancelar suscripción","Button_StaySubscribed":"Mantener suscripción","Title_ReasonCancelling":"Selecciona un motivo para cancelar:","Desc_BenefitsContinue":"Puedes seguir disfrutando de los beneficios de tu membresía hasta el fin de la suscripción.","Desc_GiftedCredits":"Una vez que venza tu suscripción, los créditos de regalo","Desc_SeeYou":"Gracias por acompañarnos. Lamentamos que te vayas.","Desc_NoNoreCharges":"No se te volverá a cobrar, tu membresía se mantendrá activa hasta el","Desc_MayBeRevoked":"podrían revocarse.","Desc_CancelingNoRefund":"Cancelar <span>no incluye un reembolso</span>. Para realizar consultas sobre reembolsos, comunícate con el servicio de asistencia en línea.","Button_ClearSelection":"Deseleccionar","Button_Confirm":"Confirmar","Message_Processing":"Procesando…","Title_Opacity":"Opacidad","Button_ExpandImage":"Ampliador","Button_ExpandRadio":"Relación de aspecto","Title_NoDesigns":"Aún no hay diseños.","Title_NoGenerations":"Aún no hay generaciones.","Desc_NoDesigns":"Tus diseños aparecerán aquí.","Desc_NoGenerations":"Tus generaciones aparecerán aquí.","Title_DeleteDesign":"Borrar este diseño","Popup_DeleteDesign":"¿Deseas borrar este diseño de forma permanente? Esta acción no se puede deshacer.","Message_SaveFail":"Error al guardar","Title_Pricing":"Elige el plan adecuado para ti","Title_Tags1_Pricing":"Mensual","Text_Discount_Pricing":"${0} de descuento","Title_Tags2_Pricing":"Anual","Title_Plan1_Pricing":"Gratis","Current_Plan_Pricing":"Plan actual","Title_Instruction1_Pricing":"Obtén 20 créditos por el primer inicio de sesión","Title_Instruction2_Pricing":"Genera hasta 20 imágenes con el Agente de IA","Title_Instruction3_Pricing":"Genera hasta 10 imágenes con el Generador de fondos con IA","Title_Rights1_Pricing":"Eliminación limitada de fondos u objetos","Title_Rights3_Pricing":"Mejora limitada de imágenes en HD","Title_Plan2_Pricing":"Plan Básico","Month_Plan_Pricing":"mes","Title_Button1_Pricing":"Suscríbete","Title_Instruction4_Pricing":"500 créditos/mes","Title_Instruction5_Pricing":"Genera hasta 500 imágenes con el Agente de IA","Title_Instruction6_Pricing":"Genera hasta 250 imágenes con el Generador de fondos con IA","Title_Plan3_Pricing":"Plan Pro","Desc_Plan_Pricing":"Prueba gratuita de 7 días. Luego ${0}/año.","Title_Button2_Pricing":"Prueba gratuita de 7 días","Title_Instruction7_Pricing":"1,500 créditos/mes","Title_Instruction8_Pricing":"Genera hasta 1,500 imágenes con el Agente de IA","Title_Instruction9_Pricing":"Genera hasta 750 imágenes con el Generador de fondos con IA","Title_Rights4_Pricing":"Eliminación ilimitada de fondos u objetos","Title_Rights5_Pricing":"Uso ilimitado de la función Eliminación con IA","Title_Rights6_Pricing":"Mejora de imágenes en UHD ilimitada","Title_Rights7_Pricing":"Herramientas de procesamiento por lotes","Title_Best_Pricing":"Elegido por el 90 % de los usuarios","Title_AllFeatures_Pricing":"Compara los planes Gratuito y Pago","Desc_AllFeatures_Pricing":"Desbloquea Premium para crear diseños sorprendentes sin esfuerzo con herramientas avanzadas de IA","Month_AllFeatures_Pricing":"mes","Title_Features1_Pricing":"Agente de IA","SubTitle_Features1_Pricing":"Edición de imágenes","SubTitle_Features15_Pricing":"Genera hasta ${0} imágenes","SubTitle_Features16_Pricing":"Genera hasta ${0} imágenes/mes","SubTitle_Features2_Pricing":"Generación de imágenes","SubTitle_Features3_Pricing":"Generación de imágenes para e-commerce","SubTitle_Features4_Pricing":"Generación de pósteres","Title_Features2_Pricing":"Herramientas de imagen con IA","SubTitle_Features5_Pricing":"Eliminador de fondos con IA","SubTitle_Features17_Pricing":"Uso limitado","SubTitle_Features19_Pricing":"Uso ilimitado","SubTitle_Features6_Pricing":"Borrador de objetos con IA","SubTitle_Features7_Pricing":"Mejorador de imagen","SubTitle_Features18_Pricing":"Uso limitado (HD)","SubTitle_Features20_Pricing":"Uso ilimitado (HD/UHD)","SubTitle_Features8_Pricing":"Refinador de imágenes con IA","SubTitle_Features9_Pricing":"Ampliador de imágenes con IA","SubTitle_Features10_Pricing":"Generador de fondos con IA","Title_Features3_Pricing":"Más funciones de diseño","SubTitle_Features11_Pricing":"Funciones avanzadas y plantillas","SubTitle_Features12_Pricing":"Eliminar marca de agua","SubTitle_Features13_Pricing":"Herramientas de imágenes con IA por lotes","SubTitle_Features14_Pricing":"Funciones de diseño básicas","Title_Credits_Pricing":"¿Te estás quedando sin créditos? Nosotros nos encargamos.","Desc_Credits_Pricing":"Compra única, no se requiere suscripción.","TransactionPrice_Credits_Pricing":"Precio: ${0}","Credit_Credits_Pricing":"Créditos","Popular_Credits_Pricing":"Más popular","Buy_Credits_Pricing":"Comprar ahora","Title_FAQ_Pricing":"Preguntas frecuentes","Title_Button4_Pricing":"Actualiza ahora y obtén una prueba gratuita de 7 días","SubTitle_FAQ1_Pricing":"¿Qué son los créditos?","Content_FAQ1_Pricing":"Los créditos te permiten seguir accediendo a las herramientas de IA. La cantidad de créditos necesaria varía dependiendo de la herramienta específica.","Content_FAQ2_Pricing":"Los créditos comprados son válidos por un año.","Content_FAQ3_Pricing":"Los créditos de membresía son válidos durante el período de la membresía.","SubTitle_FAQ2_Pricing":"¿Cómo cancelo mi suscripción y qué sucederá con mis créditos después de la cancelación?","Content_FAQ4_Pricing":"Después de cancelar tu suscripción,","Content_FAQ5_Pricing":"los créditos de tu membresía seguirán siendo válidos hasta que expire tu membresía. Los créditos que hayas comprado por separado no se verán afectados.","Content_FAQ6_Pricing":"Si necesitas cancelar tu suscripción, sigue estos pasos al menos 24 horas antes de que comience el siguiente ciclo de facturación:","Content_FAQ7_Pricing":"1. Inicia sesión en Designkit.","Content_FAQ8_Pricing":"2. Ingresa a la ventana emergente de suscripción.","Content_FAQ9_Pricing":"3. Selecciona \\"Administrar suscripciones\\".","Content_FAQ10_Pricing":"4. Selecciona tu plan actual y haz clic en \\"Cancelar suscripción\\".","Content_FAQ11_Pricing":"Tu suscripción seguirá activa hasta el final del ciclo de facturación actual. Si no puedes cancelarla, toma una captura de pantalla y comunícate con nuestro en servicio de asistencia en línea lo antes posible","SubTitle_FAQ3_Pricing":"¿Cuál es su política de reembolsos?","Content_FAQ12_Pricing":"1. Garantía de devolución del dinero de 7 días:","SubTitle_FAQ4_Pricing":"¿Cómo puedo aumentar o disminuir mi suscripción?","Content_FAQ25_Pricing":"1. Mejora: puedes suscribirte fácilmente a un plan de nivel superior, que entrará en vigor inmediatamente. Tu suscripción anterior se cancelará y se reembolsará el saldo restante.","SubTitle_FAQ5_Pricing":"¿Puedo obtener una copia de mi factura?","Content_FAQ27_Pricing":"¡Sí! Una vez realizado el pago, recibirás un correo electrónico del proveedor de pago con una factura electrónica. Si no la recibes, comunícate con nuestro equipo de asistencia.","SubTitle_FAQ6_Pricing":"¿Qué métodos de pago aceptan?","Content_FAQ28_Pricing":"Usamos Stripe para administrar pagos y suscripciones. Aceptamos las principales tarjetas de crédito, PayPal y Google Pay.","SubTitle_FAQ7_Pricing":"¿Cómo me comunico con el servicio de asistencia?","Content_FAQ29_Pricing":"Correo electrónico: support@designkit.com; tiempo de respuesta: de 3 a 10 días hábiles.","Content_FAQ13_Pricing":"Si compraste suscripciones y no las utilizaste en un plazo de 7 días, podrías recibir un reembolso total.","Content_FAQ14_Pricing":"Si compraste créditos, podrías recibir un reembolso por los créditos no utilizados en un plazo de 7 días.","Content_FAQ15_Pricing":"2. Disconformidad con el servicio","Content_FAQ16_Pricing":"Si no te satisfacen los resultados, comunícate con nuestro equipo de asistencia en línea. Podríamos ofrecerte una compensación o un reembolso dependiendo de las circunstancias.","Content_FAQ17_Pricing":"3. Compras mediante Google Play o App Store","Content_FAQ18_Pricing":"Si te suscribiste mediante Google Play Store o App Store, debes solicitar un reembolso directamente a Google o Apple.","Content_FAQ19_Pricing":"Notas importantes:","Content_FAQ20_Pricing":"Esta política de reembolso no aplica para usuarios de la API. Si usas nuestra API, comunícate con nosotros para saber si cumples con los requisitos para un reembolso.","Content_FAQ21_Pricing":"Nos reservamos el derecho a denegar reembolsos en casos de mal uso, abuso o incumplimiento de nuestros términos.","Content_FAQ22_Pricing":"Los reembolsos pueden tomar varios días hábiles en procesarse, dependiendo de tu método de pago.","Content_FAQ23_Pricing":"Es posible que actualicemos esta política de reembolso de vez en cuando. Consúltala periódicamente para conocer los cambios.","Content_FAQ24_Pricing":"Para recibir ayuda adicional, comunícate con nuestro equipo de asistencia.","Content_FAQ26_Pricing":"2. Disminución: primero, cancela tu suscripción actual. Cuando termine tu período de facturación actual, suscríbete al plan nuevo.","Content_Modal_Pricing":"¡Gracias por tu apoyo! Prepárate para llevar tu creatividad al siguiente nivel.","Tip_Modal_Pricing":"Sugerencias: si tu membresía aún no aparece, actualiza la página.","Title_Modal_Pricing":"Compra realizada con éxito","Title_Rights2_Pricing":"Uso limitado de la función Eliminación con IA","Title_Button3_Pricing":"Beneficios disponibles","Title_Button5_Pricing":"Mejorar","Tool_ImageBgRemover":"Eliminador de fondo","Tool_AiBgGenerator":"Generador de fondos con IA","Tool_AiLogoGenerator":"Generador de logotipos","Tool_FootwearModel":"Modelo de calzado","Tool_ImageTranslation":"Traducción de imágenes","Tool_BatchImageBgRemover":"Eliminador de fondos por lotes","Tool_BatchImageEnhancer":"Mejorador de imágenes por lotes","Tool_BatchAiObjectsRemover":"Eliminador de objetos por lotes","Tool_VideoEnhancer":"Mejorar el video","Tool_VideoBgRemover":"Borrador de fondos de video","Tool_VideoWatermarkRemover":"Borrador de marca de agua en video","Title_Models_Dropdown":"Modelos","Tips_Uninitialized_Chat":"Error al enviar mensajes","Dropdown_AddImage":"Agregar imagen","Action_SeeAll":"Ver todo","Desc_Seedream":"Creación de imagen realista y detallada.","Dropdown_AddVideo":"Agregar video","Tips_NotFound_Chat":"El chat no existe","Desc_Seedance":"Creación de video realista y expresiva.","Dropdown_SupportedFormatFile":"Admite archivos de Word, Excel, texto y PDF.","Dropdown_Example_Option":"Ejemplo","Dropdown_NoReference_Option":"No hay referencia disponible","Menu_AgentCredits":"Créditos de Agente","Desc_SeedEdit":"Edición de imagen precisa y natural.","Dropdown_BrandKit_Title":"Kit de marca","Desc_GeminiNanoBanana":"Generación de imagen rápida, editable y uniforme.","Dropdown_Models_Title":"Modelos","Dropdown_AddDocument":"Agregar documento","Dropdown_BrandKit_Desc":"Selecciona un estilo de marca como referencia para este diseño.","Desc_MidjourneyVideo":"Generación de video creativa y artística.","Desc_MidjourneyImage":"Generación de imagen artística e imaginativa.","Dropdown_SaveAsBrandTemplate":"Guardar como plantilla de marca","Dropdown_SaveAsBrandLogo":"Guardar como logotipo de marca","BatchProcessTable_ImageType":"Tipo de imagen","BatchProcessTable_PictureRequirement":"Detalles de diseño","BatchProcessTable_CopywritingRequirements":"Descripción del producto","BatchProcessTable_Proportion":"Relación de aspecto","BatchProcessTable_Actions":"Acción","BatchProcessTable_AddOneRow":"Agregar","BatchProcessList_DeleteError":"Error al borrar","BatchProcessList_SurePrompt":"¿Deseas borrar esta directriz?","BatchProcessList_SurePrompt_SureText":"Confirmar","BatchProcessList_SurePrompt_CancelText":"Cancelar","BatchProcessList_EmptyText":"Vacío","EditBatchProcess_NameLimitTip":"Ingresa un nombre (hasta 10 caracteres)","EditBatchProcess_Tip":"Cualquier cambio a las directrices afectará los resultados generados.","EditBatchProcess_Start":"Comienza con una directriz","EditBatchProcess_GenerateTip":"Sube tus imágenes de producto y se generarán diseños basados en las directrices.","Text_AdvanceSetting":"Especialista","Text_MainImage":"Imagen principal","Text_ProductAgentUploadGuide1":"1. Sube múltiples imágenes del mismo producto desde diferentes ángulos para ayudar a que la IA capture mejor los detalles del producto.","Text_ProductAgentUploadGuide2":"2. Hasta 10 imágenes. La primera imagen se usará como la referencia principal, por lo que te sugerimos que elijas el mejor ángulo.","Text_Optional":"(Opcional)","Tip_ClickDragImageWithSize":"Sube o arrastra imágenes JPEG, JPG o PNG de hasta ${0}MB.","Button_AddReferenceImage":"Subir referencias","Title_ReferenceImage":"Referencia","Input_Placeholder":"Selecciona","Radio_ReferenceColor":"Color de referencia","Radio_ReferenceLayout":"Composición de referencia","Tag_FirstImage":"Primera imagen","Tag_FirstImageNoPartial":"La primera foto está incompleta","Tag_Blur":"Desenfocado","Tag_Jigsaw":"Collage","Button_Understood":"Entendido","Text_ReferenceImageIndex":"La foto ${0}  es de referencia","Text_ReferenceDimensions":"Usar ${0} a partir de referencia","Tag_Cropped":"Recortado","Tag_Underexposed":"Subexpuesto","Tag_Blurry":"Desenfocado","SelectOption_ColorPalette":"Paleta de colores","SelectOption_Layout":"Composición","SelectOption_Fonts":"Fuentes","SelectOption_Style":"Estilo","SelectOption_ShapeElements":"Figuras geométricas","Text_SocialMediaAgentUploadGuide":"Sube primero tu producto destacado. Asegúrate de que la foto sea nítida y esté completa.","Video_SR_Success":"Claridad de video mejorada","Video_Desubtitle_Success":"Subtítulo eliminado","Video_Dewatermark_Success":"Marca de agua eliminada","Video_Process_Failed":"Error al procesar. Los créditos se reembolsarán a tu cuenta.","Video_SR":"Claridad con IA","Video_Dewatermark":"Eliminar marca de agua","Video_Desubtitle":"Eliminar subtítulos","Video_Task_Price_Estimate":"Se requieren ${0} créditos","Video_SR_Start":"Mejorando la claridad… Se usarán ${0} créditos.","Video_Dewatermark_Start":"Eliminando marcas de agua… Se usarán ${0} créditos.","Video_Desubtitle_Start":"Eliminando subtítulos… Se usarán ${0} créditos.","Video_Desubtitle_Start_VIP":"Eliminando subtítulos…","Video_Dewatermark_Start_VIP":"Eliminando marcas de agua…","Video_SR_Start_VIP":"Mejorando la claridad…","Text_Help_Center":"Centro de ayuda","Title_Request":"Chat","Button_Continue":"Continuar","Button_EditContent":"Editar mensaje","Title_ChooseImageType":"Selecciona el tipo de imagen generada (múltiples opciones)","Button_BatchGenerate":"Confirmado. Ejecuta la plantilla ahora.","Text_ChatCancelStatus":"Tarea terminada","Text_ChatRespondedStatus":"Procesamiento de tarea","BatchProcess_SaveSuccessTip":"Tus kits de flujo de trabajo se guardan aquí.","Button_GotIt":"Entendido","Title_Congrats":"Felicitaciones","SubTitle_BrandCreate":"Creaste tu primer kit de marca: ¡es hora de explorar su potencial!","Button_CheckUse":"Echa un vistazo ahora","Chat_Prompt_Brand":"Crea un póster promocional","Tooltip_UseBrand":"¡Aquí puedes cambiar o agregar tu kit de marca!","Tooltip_PosterBrand":"Toca para crear tu primer póster a partir de tu kit de marca","Popup_CreateBrand":"Crea una marca desde cero","Desc_CreateBrand":"Crea sorprendentes logotipos originales con nuestro Agente de IA.","Popup_UploadBrand":"Sube la información de tu marca","Desc_UploadBrand":"Súbelo y Zawa mantendrá todos los diseños alineados.","Title_BrandEntry":"Obtén un sistema de marca personalizado ahora","Desc_BrandEntry":"Deja que nuestra IA se encargue del estilo. Responde unas cuantas preguntas y recibe un sistema de marca completo que se adapte a tu visión.","Tooltip_UseBrand_Agent":"Una vez que se aplique el kit de marca, el diseño se remitirá automáticamente al logotipo, la paleta de color y el estilo general.","Tooltip_PosterBrand_Agent":"Todo listo para que diseñes con tu kit de marca","BatchProcess_createText":"Kit de flujo de trabajo","Label_NormalMode":"Básico:","Label_AdvancedMode":"Avanzado:","Text_NormalMode":"Básico","Text_AdvancedMode":"Avanzado","BatchProcess_DefaultPrompt":"Generar imágenes","Title_CreateBrand":"¿No tienes una marca?","Title_UploadBrand":"¿Ya tienes un logotipo?","Button_CreateBrand":"Crear una marca","BatchProcess_EditContent":"Editar contenido","BatchProcess_PleaseSelect":"Selecciona un kit de flujo de trabajo","BatchProcess_SelectTip":"Todas las imágenes subidas se generarán en lote usando el kit de flujo de trabajo seleccionado.","BatchProcess_ListEmptyTip":"Guarda el kit de flujo de trabajo después de generarlo para crear conjuntos similares en lotes al instante.","BatchProcess_Tip":"Kit de flujo de trabajo","BatchProcess_Generate":"Úsalo ahora","BatchProcess_Save":"Guardar","BatchProcess_GeneratingFormula":"Generando kit de flujo de trabajo…","BatchProcess_GenerateCancel":"Cancelar","BatchProcess_WorkFlowCreateError":"Error al crear","ProductInfo_PleaseUploadImage":"Sube imágenes de producto","BatchProcess_IntelligenceGenerate":"Crea un kit de flujo de trabajo","BatchProcess_CreateWorkflow":"Crear","BatchProcess_Formula":"Kit de flujo de trabajo","BatchProcess_WorkFlowSaveSuccess":"Kit de flujo de trabajo guardado","ProductInfo_ImageSizeLimit":"Se admiten imágenes de menos de ${0} MB","ProductInfo_ImageUpload":"Agrega imagen de producto","ProductInfo_UploadDemo":"Fotos de ejemplo","ProductInfo_ECPlatform":"Plataforma","ProductInfo_PleaseSelect":"Selecciona","ProductInfo_InputCustomize":"Personalizado","ProductInfo_CountryAndLanguage":"Región/idioma de destino","ProductInfo_Name":"Nombre del producto","ProductInfo_Desc":"Detalles del producto (características/tamaño/escenarios de uso)","ProductInfo_DescPlaceholder":"Ingresa información del producto como características, tamaño, escenarios de uso, público objetivo, etc.","ProductInfo_NamePrompt":"El nombre del producto es ${0};","ProductInfo_ECPlatformPrompt":"La plataforma de destino es ${0};","ProductInfo_CountryAndLanguagePrompt":"El idioma es ${0};","ProductInfo_DescPrompt":"Los detalles del producto son ${0}.","ProductInfo_PleaseInput":"Por favor, ingresa","Button_UnlockPro":"Desbloquear Pro","Button_UpgradeToPro":"Actualizar a Pro","Button_RenewNow":"Renovar ahora","AgentEmpty_CaseUseBtn":"Usar","AgentEmpty_CaseRefreshBtn":"Actualizar","MenuItem_Effect":"Efectos","MenuItem_Shadow":"Sombras","MenuItem_Stroke":"Trazo","Title_ChangeText":"Reemplazar texto","Button_Logout":"Cerrar sesión","Message_ExtractText":"Extrayendo texto","Message_ExtractTextError":"Error al extraer texto. Por favor, inténtalo de nuevo.","Tip_CreditConsume":"Esta generación usa ${0} créditos","Tip_EstimatedTime":"Estará listo en alrededor de ${0} minutos","BatchProcess_SaveSuccessTip_GotIt":"Entendido","BatchProcess_SaveSuccessTip_Title":"Usando kits de flujo de trabajo","BatchProcess_SaveSuccessTip_Desc":"Aquí se guardan tus kits de flujo de trabajo. Elige uno para generar imágenes rápidamente usando las plantillas guardadas.","BatchProcess_tutorial":"Tutoriales","Text_HandTool":"Herramienta de mano","Text_Function":"Función","Text_WindowsSystem":"Sistema de Windows","Text_MacSystem":"Sistema de Mac","Menu_KeyboardShortcuts":"Combinaciones de teclas","Title_KeyboardShortcuts":"Combinaciones de teclas","Text_Undo":"Deshacer","Text_MouseLeft":"Botón izquierdo del mouse","Text_Redo":"Rehacer","Text_Delete":"Borrar","Text_Cut":"Cortar","Text_Copy":"Copiar","Text_Paste":"Pegar","Text_PasteFixed":"Pegar en su lugar","Text_CreateCopy":"Crear una copia","Text_SelectAll":"Seleccionar todo","Text_SelectMultiple":"Selección múltiple","Text_Group":"Agrupar","Text_Ungroup":"Desagrupar","Text_LockLayer":"Bloquear","Text_Save":"Guardar","Text_Move":"Mover","Text_MoveWithCombinedKeys":"Mover rápido","Text_TouchEditFastMode":"Apuntar para editar rápidamente","Text_Pan":"Paneo","Title_Canvas":"Lienzo","Title_Edit":"Editar","Title_Elements":"Elementos","Title_Tools":"Herramientas","Title_Blogs":"Blog","Text_NewText":"Texto nuevo","Text_NewLine":"Línea nueva","Text_NewRectangle":"Rectángulo nuevo","Text_NewCircle":"Círculo nuevo","Text_ExitFullScreen":"Salir de pantalla completa","Text_MoveUpOneLayer":"Traer adelante","Text_MoveDownOneLayer":"Enviar atrás","Text_Top":"Traer al frente","Text_Bottom":"Enviar al fondo","Text_CanvasZoom":"Acercar/alejar","Text_ToggleReferenceLine":"Mostrar/ocultar guías","Text_ToggleRulerBar":"Mostrar/ocultar reglas","Text_ArrowKey":"Teclas de flecha","Text_CanvasShowAll":"Mostrar todo el lienzo","Title_Unsupported_Multilayer":"Esta función solo funciona con una sola capa.","Btn_CreateBatchProcessFormula":"Crear","Button_Hide_Otherlayers":"Mantener la primera capa y continuar","Button_Merge_Alllayers":"Combinar todas las capas y continuar","Checkbox_Disable_Remind":"No mostrar de nuevo","Button_Tool":"Herramientas","Button_Custom_Ratio":"Personalizado","Label_Spacing":"Espacio","Button_Download_Whole":"Exportar como imagen","Button_Download_Layer":"Exportar como capa","Button_Origin_Ratio":"Original","Text_TouchEdit_Title":"Apuntar para editar","Text_TouchEdit_Description":"Apunta a un objeto y describe tus cambios. La imagen se editará exactamente como lo especifiques.","Tooltip_TouchEdit_Max_Count":"Puedes apuntar hasta ${0} áreas","Tooltip_TouchEdit_Usage":"Combinación de teclas de Apuntar para editar: ${0} + clic","Text_TouchEdit_Recognition_Custom":"Personalizado","Text_TouchEdit_Recognition_Title1":"Detectar y reconocer","Text_TouchEdit_Recognition_Title2":"No se encontró un objetivo. Ingresa el nombre del objeto.","Text_TouchEdit_Name":"Apuntar para editar","Btn_LoginToViewBatchProcess":"Inicia sesión para ver el kit de flujo de trabajo","Btn_Login":"Iniciar sesión","Menu_Main_Beautify":"Refinar","Text_Model_Pricing":"Precios de modelos","Text_Pro_discount":"Plan pro: generación de videos a mitad de precio","Text_TemplatePrompt":"Empecemos con inspiraciones","Text_Hi":"¡Hola {0}!","Text_Account_Popup_Left":"Conoce a tu asistente de diseño de IA dedicado al comercio electrónico. Creado para profesionales que buscan lanzamientos más rápidos, presentaciones más sólidas y mayor rentabilidad.","Text_PleaseWaitImageUploaded":"Continúa después de que se complete la carga","Menu_Redeem_Rights":"Canjear","Text_Redeem_Now":"Canjea ahora","Text_Redeem_Placeholder":"Ingresa el código de canje, respetando las mayúsculas y minúsculas","Text_Redeem_Success":"¡Canje exitoso!","Text_Redeem_Use":"Canjea tu código","Tooltip_BrandAutoUse":"¡Se aplicó tu kit nuevo!","Redeem_Redeem_Note":"Nota: \\nInicia sesión e ingresa el código de canje.\\nCuando se complete el canje, podrás disfrutar los beneficios y servicios correspondientes.\\nUsa el código de canje durante su periodo de validez. Los códigos expirados no serán válidos y no son reembolsables.\\nProtege tu código. No nos haremos responsables por códigos perdidos, divulgados o usados de manera incorrecta. \\nEste código no es transferible ni se puede revender, intercambiar por dinero en efectivo ni es elegible para la emisión de facturas.","Tooltip_Color_Fill":"Color","Tootip_StartPoint":"Comenzar","Tootip_ChangePoint":"Cambiar","Tootip_EndPoint":"Fin","Sidebar_NewDesign":"Nuevo chat","Retouch_Filter_Clear":"Nítido","Retouch_Filter_Enhance":"Vívido","Retouch_Filter_Dehaze":"Borrar neblina","Retouch_Filter_Texture":"Textura","Retouch_Filter_Nature":"Natural","Retouch_Filter_Fade":"Desvanecer","Modal_Button_Known":"Aceptar","Modal_Button_GotIt":"Aceptar","Modal_Button_Later":"Más tarde","Text_Appeal_Confirm":"Sí","Text_Vip_Open":"Suscríbete","Text_Appeal_ReGenerate":"Los resultados editados no son cumplen las condiciones para su revisión.","Text_Appeal_Left":"Intentos restantes este mes\\n<i>${0}</i>/${1}","Text_Appeal_Refunded":"Los créditos fueron reembolsados a tu cuenta.","MenuItem_Appeal":"Revisión de resultados","Tooltip_Downloading":"Descargando…","Tooltip_Download_Video":"Descarga videos por separado, uno a la vez.","Tooltip_Download_NoneSelected":"Selecciona el contenido que quieres descargar","Text_AI_Thinking":"La IA está trabajando en ello…","Text_Server_Busy":"El servidor está ocupado. Intenta de nuevo más tarde.","Text_Prompt_Help_Placeholder":"Escribe tus palabras clave y las convertiré en una indicación lista para usar.","Text_Prompt_Helping":"Procesando… Espera un momento.","Button_Retry":"Intentar de nuevo","Button_Rewrite":"Intenta de nuevo","Button_Start_Prompt_Help":"Comienza a escribir","Title_Prompt_Helper":"Escritura con IA","Menu_Text_Subscriptions":"Suscripciones","Menu_View_Subscriptions":"Ver suscripciones","Text_Download_XdesignApp":"Descarga la aplicación de <span>Zawa</span> para usar las funciones","Text_Free_Trial":"Descarga para obtener una prueba gratuita por 7 días","Text_Install_App":"Instalar la app","Text_Scan_Download":"Escanea para descargar","Text_Download_the":"Descargar en la","Text_Available_On":"Disponible en","Desc_ExpireDate":"Expira el","DownloadApp_Title_Widgets":"Descarga la aplicación de ${0} para usar las funciones","DownloadApp_SubTitle_Widgets":"Descarga para obtener una prueba gratuita por ${0} días","InstallApp_Title_Widgets":"Instalar la app","InstallApp_Desc_Widgets":"Escanea para descargar","AppStore_Desc_Widgets":"Descargar en la App Store","GooglePlay_Desc_Widgets":"Disponible en Google Play","Text_Tips_GetFree":"Tienes un uso gratuito","Text_AgentLib":"Recursos","Tip_ModelSetSaveSuccess":"¡Se guardó la imagen de tu modelo! Toca para usarla.","Text_BatchProcess":"Kit de flujo de trabajo","Button_Add":"Agregar","Tab_Recent":"Recientemente guardado","Tab_Models":"Mis modelos","Prompt_Model":"La imagen ${0} es mi modelo","Tip_SaveSuccess":"Guardado","Text_ModelsLogin":"Inicia sesión para ver tus modelos","Loading_CheckFace":"Detectando rostro…","Name_InitialModelName":"Mis modelos","EmptyTip_ModelList":"Todavía no tienes un modelo. ¡Vamos a crear uno!","Text_UploadModel":"Subir modelo","Text_Model":"Modelo","Tips_UnsupportedFormat":"Formato de archivo no admitido","Tips_InputModelName":"Ingresa un nombre","Tips_UploadModelImage":"Sube imágenes del modelo","Title_CreateModel":"Crea tu modelo","Text_ModelName":"Nombre","Placeholder_Input":"Ingresa","Text_UploadModelHint":"Toca para subir o arrastra imágenes aquí\\n<br>JPEG/JPG/PNG/HEIC/SVG","Button_SubmitUpload":"Subir","Tips_NameLengthLimit":"Ingresa un nombre (hasta ${0} caracteres)","Tips_DeleteFailed":"Error al borrar","Title_ConfirmDeleteModel":"¿Deseas borrar este modelo?","Tips_CreateSuccess":"Modelo creado","Tab_BatchTemplate":"Kit de flujo de trabajo","Tab_MyModel":"Mis modelos","Placeholder_InputContent":"Introduce contenido","Title_ChooseSceneType_VideoGenerateCard":"Selecciona un tipo de contenido y una estructura de storyboard:","Button_ConfirmGenerate_VideoGenerateCard":"Iniciar generación de video","Title_ShotType_VideoGenerateModal":"Tipo de storyboard","Title_ShotRequirement_VideoGenerateModal":"Descripción del storyboard","Title_Duration_VideoGenerateModal":"Duración","Btn_AddOneTableRow":"Agregar","Label_Gender_ModelModal":"Sexo","Label_Appearance_ModelModal":"Apariencia","Label_AgeGroup_ModelModal":"Grupo de edad","Label_Persona_ModelModal":"Función","Label_BodyType_ModelModal":"Tipo de cuerpo","Tips_GenerateModelFailed_ModelModal":"Error de generación. Intenta de nuevo más tarde.","Tips_NetworkError_ModelModal":"Error de red. Intenta de nuevo más tarde.","Tab_CustomModel_ModelModal":"Personalizado","Tab_OfficialModel_ModelModal":"Oficial","Tab_UploadModel_ModelModal":"Subir","Text_ModelPreview_ModelModal":"Vista previa","Button_Generating_ModelModal":"Generando…","Button_Regenerate_ModelModal":"Intentar de nuevo","Button_Generate_ModelModal":"Generar","Button_Saving_ModelModal":"Guardando…","Button_SaveAndUse_ModelModal":"Guardar y usar","Button_CreateNewModel_AgentLibList":"Modelo nuevo","Message_NotFilled_RequiredField":"Se requiere información de ${0}","Title_ChooseSceneType2_VideoGenerateCard":"Selecciona una estructura de storyboard","Title_ContentType_VideoGenerateCard":"Tipo de contenido","Title_StoryboardStructure_VideoGenerateCard":"Estructura de storyboard","Text_Offical":"Oficial","Title_AboveTheFold_Main_HomeV2":"Haz que cada foto <br /> de producto quede <span>lista para vender</span>","Title_Designkit_Slogan":"Haz que cada foto de producto quede lista para vender","Button_StartFree_HomeV2":"Comienza gratis","Title_AboveTheFoldMobile_Main_HomeV2":"Haz que cada producto quede <br /><span>listo para vender</span>","SubTitle_AboveTheFoldMobile_HomeV2":"Desde edición profesional de fotos hasta generación automatizada de listados, todo lo que necesitas en un solo lugar.","Text_TopBanner_HomeV2":"Seedance 2.0 pronto estará disponible con acceso ilimitado","Title_ModuleCard_HomeV2":"Primero, genera recursos ganadores","SubTitle_ModuleCard_HomeV2":"No más lienzos vacíos. Usa nuestra Suite Creativa Inteligente de Agentes de IA para generar <br /> pilas de listado completas, videos dinámicos, pruebas virtuales de ropa y adaptaciones globales en segundos.","Title_Faq_Q1_HomeV2":"¿Ofrecen una prueba gratuita?","Text_Faq_A1_HomeV2":"¡Sí! Los usuarios nuevos reciben 20 créditos gratuitos al registrarse. Además, puedes reclamar 10 créditos gratuitos todos los días con tan solo iniciar sesión. Esto te permite probar todas las funciones principales, como generación de imagen y video, antes de adquirir un plan pagado.","Title_Faq_Q2_HomeV2":"¿Las imágenes cumplen con los lineamientos de Amazon o Shopify?","Text_Faq_A2_HOMEV2":"Sin duda. Para las fotografías principales, las salidas de nuestra IA son estrictamente los fondos blancos (RGB 255,255,255) que exigen Amazon y Shopify. Para las imágenes de estilo de vida y redes sociales, garantiza dimensiones perfectas y calidad de alta resolución para que tus listados cumplan con todos los lineamientos y sean profesionales.","Title_Faq_Q3_HomeV2":"¿Puedo usar recursos generados para fines comerciales?","Text_Faq_A3_HomeV2":"Sí. Todas las imágenes y videos que se generen en nuestros planes de pago están 100% libres de regalías y totalmente autorizados para su uso uso comercial. Los derechos son tuyos para usar estos recursos en tu tienda de Shopify, listados de Amazon, anuncios de redes sociales y cualquier otro canal de marketing, sin restricciones.","Title_Faq_Q4_HomeV2":"¿Cómo funcionan la generación y edición por lotes?","Text_Faq_A4_HomeV2":"El procesamiento por lotes está integrado de manera nativa en todas las funciones de Designkit. Tan solo sube múltiples imágenes directamente al espacio de trabajo. Ya sea que generes fondos nuevos de estilo de vida, elimines fondos originales, borres objetos no deseados o aumentes la resolución, puedes aplicar la acción que elijas al lote completo con un solo clic. Esto garantiza recursos perfectamente uniformes para tu tienda que te ahorrarán horas de trabajo manual.","Title_Faq_Q5_HomeV2":"¿Qué formatos de archivo admiten?","Text_Faq_A5_HomeV2":"Las salidas de video están disponibles en formato MP4, optimizadas para redes sociales y sitios web de comercio electrónico.","Title_Questions_Main_HomeV2":"Preguntas frecuentes","Title_Scale_Main_HomeV2":"¿Todo listo para escalar?","SubTitle_Scale_HomeV2":"Únete a más de 10,000 vendedores que automatizaron su flujo de trabajo de diseño con Designkit.","Title_Evaluation_HomeV2":"Finalmente, lanza más rápido y vende más","SubTitle_Evaluation_HomeV2":"Reduce el tiempo de producción en un 90%. Lanza listados verificados en Amazon y Shopify antes que tus competidores.","Tab_Module_ProductImage_HomeV2":"Imagen de producto con IA","Desc_Module_ProductImage_HomeV2":"Convierte una foto de proveedor en una pila de listado completa. Genera fotos principales con fondo blanco, escenas de estilo de vida e infografías, procesa sin esfuerzo lotes de cientos de SKU y traduce automáticamente texto para mercados globales.","Tip_Module_ProductImage_HomeV2":"Genera un conjunto de listados de Amazon para los audífonos rosas.","Tab_Module_ModelImage_HomeV2":"Modelo de moda con IA","Desc_Module_ModelImage_HomeV2":"¿No tienes modelos? No hay problema. Visualiza prendas en distintos modelos de IA para aumentar las tasas de clics sin necesidad de costosas sesiones de fotografía.","Tip_Module_ModelImage_HomeV2":"Muestra este traje amarillo con verde en una modelo de 25 años.","Tab_Module_Video_HomeV2":"Video de producto con IA","Desc_Module_Video_HomeV2":"Dales vida a tus productos. Genera exhibidores dinámicos de producto, atractivos videos de portavoces con IA y anuncios con una alta tasa de conversión a partir de una indicación de texto o una sola imagen. Capta la atención y aumenta las ventas en distintas plataformas de comercio electrónico y tus redes sociales.","Tip_Module_Video_HomeV2":"Genera un video de producto para este florero azul.","Tab_Module_DetailPage_HomeV2":"Página de detalle de productos con IA","Desc_Module_DetailPage_HomeV2":"Crea contenido premium A+ y banners promocionales perfectos para tu tienda en línea en unos cuantos minutos: no necesitas habilidades de diseño. Transforma fotos básicas de producto en layouts altamente atractivos y diferencia tus listados de tu competencia sin esfuerzo.","Tip_Module_DetailPage_HomeV2":"Genera una página de detalles de producto para el sillón naranja.","Tab_Module_Photography_HomeV2":"Fotografía de producto con IA","Desc_Module_Photography_HomeV2":"Deshazte de las fotos de stock genéricas. Coloca tus productos en entornos únicos y relevantes para tu marca que resuenen con el mercado estadounidense y europeo.","Tip_Module_Photography_HomeV2":"Genera un fondo de fotografía para este perfume.","Title_Module_SecondTitle_HomeV2":"Luego, perfecciona los detalles con la precisión de la IA","SubTitle_Module_SecondSubTitle_HomeV2":"¿Ya generaste los recursos? Ahora perfecciónalos. Usa nuestro Editor de fotos con IA para eliminar fondos, limpiar defectos y mejorar en masa imágenes en baja resolución.","Text_Upload_HomeV2":"Subir","Text_TopBannerMobile_HomeV2":"Seedance 2.0 pronto estará disponible","Text_Prompt1_HomeV2":"Genera un conjunto completo de imágenes para listados de Amazon.","Text_Prompt2_HomeV2":"Genera una modelo que use este outfit.","Text_Prompt3_HomeV2":"Genera un video de marketing para un producto.","Text_Prompt4_HomeV2":"Genera una página de detalles de producto de contenido A+.","Text_Prompt5_HomeV2":"Genera fondos adecuados para imágenes de producto.","Desc_Evaluation1_HomeV2":"¡Súper rápido! Las imágenes están listas al instante para Mercado Libre y Amazon. Adapta a la perfección fondos y modelos según el gusto local. Resultados totalmente profesionales.","Desc_Evaluation2_HomeV2":"¡Me encanta Designkit! Las imágenes de estilo de vida generadas con IA son naturales, cálidas y de estilo nórdico: perfectas para mi tienda de velas. Mis listados se ven increíbles y las ventas aumentaron. Vale la pena.","Desc_Evaluation3_HomeV2":"Vendo ropa y me preocupaba que la IA arruinara las texturas. ¡Designkit lo hizo increíble! Los colores son perfectos, las poses de la modelo se ven naturales y las imágenes están listas al instante.","Header_products_socialMediaPostGenerator":"Generador de publicaciones para redes sociales","Pricing_Seedance_UnlockLimited":"Obtén acceso ilimitado","Pricing_Seedance_SeedanceV1":"Acceso anticipado a <span>Seedance 2.0</span>","Pricing_Seedance_SeedanceDesc":"Sé de los primeros en experimentar la potencia de Seedance 2.0. Suscríbete a cualquier plan Pro ahora y obtén acceso ilimitado exclusivo a nuestro modelo de IA de próxima generación.","Pricing_Seedance_Monthly":"Bono de plan mensual","Pricing_Seedance_DaysUnLimit":"7 días <span>ilimitado</span>","Pricing_Seedance_SeedanceV2":"Acceso a Seedance 2.0","Pricing_Seedance_BestValue":"MEJOR OFERTA","Pricing_Seedance_Yearly":"Bono de plan anual","Pricing_Seedance_MonthUnLimit":"1 mes <span> ilimitado</span>","Title_AIBrand_Tools":"Herramientas de branding con IA","Title_AISocialMediaPosts":"Publicaciones para redes sociales","Title_AILogoMaker":"Generador de logotipos","Option_Child_Age":"Niño","Option_Infant_Age":"Bebé","Option_MiddleAged_Age":"Adulto","Option_Senior_Age":"Adulto mayor","Option_Teen_Age":"Juvenil","Option_YoungAdult_Age":"Adulto joven","Button_GenerateImages_DetailPageAction":"Generar","Text_GenerateImagesCount_DetailPageAction":"(${0} imágenes)","Text_GenerateImagesCount_DetailPageAction1":"(${0} imagen)","Option_MercadoLivre_Platform":"Mercado Livre","Option_Etsy_Platform":"Etsy","Option_Walmart_Platform":"Walmart","Option_eBay_Platform":"eBay","Option_Poshmark_Platform":"Poshmark","Button_GeneratePlan_DetailPageAction":"Crear diseño de Página de producto","Option_AdvancedMobile_DetailPageMode":"Premium A+ (Móvil)","Option_AdvancedWeb_DetailPageMode":"Premium A+ (Web)","Option_Standard_DetailPageMode":"Standard A+","Option_Accessories_DetailSection":"Accesorios/Regalos","Option_ServiceSupport_DetailSection":"Garantía","Option_BeforeAfter_DetailSection":"Antes y después","Option_BrandStory_DetailSection":"Historia de marca","Option_KeyHighlights_DetailSection":"Características destacadas del producto","Option_CraftProcess_DetailSection":"Vista explosionada","Option_HeroVisual_DetailSection":"Arte principal","Option_Composition_DetailSection":"Componentes","Option_MultiAngle_DetailSection":"Múltiples ángulos","Option_DetailCloseups_DetailSection":"Detalle de producto","Option_SceneMood_DetailSection":"Estilo / Vibras","Option_SeriesShowcase_DetailSection":"Series de producto","Option_SizeCapacity_DetailSection":"Dimensiones","Option_Specifications_DetailSection":"Ficha técnica","Option_UsageScenario_DetailSection":"Casos de uso","Option_UsageTips_DetailSection":"Guía de uso","Paragraph_ServicePolicy_DetailSection":"Políticas de garantía, cambios y devoluciones","Paragraph_BeforeAfter_DetailSection":"Resultados antes y después del uso","Paragraph_BrandConcept_DetailSection":"Conceptos y valores de la marca","Paragraph_CoreValue_DetailSection":"Muestra de valores clave","Paragraph_CraftProcess_DetailSection":"Del boceto a la realidad","Paragraph_Differentiators_DetailSection":"Principales beneficios","Paragraph_Composition_DetailSection":"Materiales y componentes del producto","Paragraph_MaterialAndCraft_DetailSection":"Materiales y procesos del producto","Paragraph_MultiAngleAppearance_DetailSection":"El producto desde distintos ángulos","Paragraph_MultiOptionDisplay_DetailSection":"Múltiples colores o SKUs","Paragraph_IncludedItems_DetailSection":"Contenido del paquete","Paragraph_DetailData_DetailSection":"Especificaciones detalladas","Paragraph_RealUsageScene_DetailSection":"Referencias reales de uso","Paragraph_Specifications_DetailSection":"Guía de tallas resumida","Paragraph_UsageNotes_DetailSection":"Notas de uso y precauciones","Paragraph_UsageScenario_DetailSection":"El producto en contexto","Title_Nav_DetailPage":"Contenido A+","Title_ImageSet_DetailPage":"Set de imágenes detalladas del producto A+","Input_TaskName_Batch":"Ingresa el nombre de la tarea","Paragraph_FullAssetSetDescription_Batch":"Incluye un set completo de recursos de marketing, como imágenes principales, imágenes de uso real e imágenes con fondo blanco, que puedes usar en múltiples plataformas.","Paragraph_LongFormVisualDescription_Batch":"Crea una narrativa visual para imágenes de producto en formato largo, páginas de detalles de producto A+ e imágenes comparativas.","Message_JsonGenerated_Batch":"Formato verificado. JSON generado.","Message_JsonCopied_Batch":"JSON copiado.","Message_IncompleteRequiredFields_Batch":"Faltan campos obligatorios. Por favor completa el formulario para poder enviarlo.","Message_PleaseUploadSourceImage_Batch":"Sube las imágenes del producto","Message_PleaseCompleteStrategySettings_Batch":"Por favor, completa la configuración de la estrategia.","Message_TaskValidationFailed_Batch":"Por favor, revisa y completa las tareas sin verificar.","Message_CopyJsonFailed_Batch":"La copia falló. Por favor, revisar el JSON en el panel de control.","Message_PleaseEnterTitle_Batch":"Por favor, ingresa el título.","Message_PleaseEnterKeyHighlights_Batch":"Inserta las características destacadas del producto","Message_PleaseGenerateJsonFirst_Batch":"Por favor, envíar para generar el JSON.","Title_DetailPage_Batch":"Página de producto A+","Title_DetailTask_Batch":"Tarea A+ ${0}","Title_IndependentParameters_Batch":"Configurar individualmente","Title_ImageSet_Batch":"Set de imágenes para e-commerce","Title_ItemTask_Batch":"Tarea de producto","Option_Curvy_BodyType":"Curvilíneo","Option_Muscular_BodyType":"Musculoso","Option_PlusSize_BodyType":"Complexión robusta","Option_Slim_BodyType":"Delgado","Option_Standard_BodyType":"Promedio","Button_Reset_Common":"Restablecer","Button_Back_Common":"Atrás","Button_Collapse_Common":"Plegar","Button_Expand_Common":"Expandir","Button_Generate_Common":"Generar","Button_PreviousStep_Common":"Deshacer","Button_RemoveFavorite_Common":"Quitar favorito","Button_StartNow_Common":"Probar ahora","Paragraph_ExitWarning_Common":"Si sales, se perderán los datos.","Paragraph_Content1_VirtualModelDisclaimer":"2. Por favor, sea consciente de lo que puede esperar del contenido generado por IA. El contenido que se genera con IA se produce mediante algoritmos y aprendizaje de datos, por lo que los resultados pueden variar. El aspecto facial generado por la IA puede diferir de los recursos originales proporcionados, y pueden producirse imperfecciones o resultados no satisfactorios. Nuestra plataforma no garantiza la precisión, la calidad visual ni la idoneidad del contenido generado.","Paragraph_Content2_VirtualModelDisclaimer":"3. Por favor, considere sus responsabilidades como usuario. Usted es responsable de las imágenes que contienen rostros y del contenido que genere. Debe asegurarse de que su uso no infrinja los derechos legales de terceros, incluidos, entre otros, los derechos de imagen, privacidad y reputación, y que cumpla con todas las leyes y normativas aplicables. No debe usar el contenido generado con fines ilegales, de infracción (como difamación o fraude), o que atenten contra el orden público, la moral o la dignidad de otras personas.","Paragraph_Content3_VirtualModelDisclaimer":"Confirma que comprendes y aceptas los términos anteriores antes de subir tu contenido.","Title_Notice_VirtualModelDisclaimer":"Antes de usar el Probador Virtual con IA, lee detenidamente lo siguiente:","Message_FailedRetry_Download":"Error al descargar. Por favor, inténtalo de nuevo más tarde.","Message_Failed_Download":"Error al descargar.","Message_Success_Download":"Descarga completada.","Message_NoImagesAvailable_Download":"No hay imágenes disponibles.","Option_Asian_Ethnicity":"Asiática/Asiático","Option_Black_Ethnicity":"Africana/Africano","Option_Chinese_Ethnicity":"China","Option_Latino_Ethnicity":"Hispano o Latino","Option_MiddleEastern_Ethnicity":"Medio Oriente","Option_SoutheastAsian_Ethnicity":"Sudeste asiático","Option_White_Ethnicity":"Blanca/o","Option_Female_Gender":"Mujer","Option_Male_Gender":"Hombre","FormLabel_Ethnicity_Common":"Raza y etnicidad","FormLabel_OriginalImage_Common":"Original","FormLabel_OutputLanguage_Common":"Idioma","FormLabel_TargetMarket_Common":"Mercado","FormLabel_TargetPlatform_Common":"Plataforma","Option_German_Language":"Alemán","Option_Japanese_Language":"Japonés","Option_None_Language":"Ninguno","Option_Portuguese_Language":"Portugués","Option_PortugueseBr_Language":"Portugués (Brasil)","Option_Russian_Language":"Ruso","Option_Spanish_Language":"Español","Option_SpanishMX_Language":"Español (México)","Option_Thai_Language":"Tailandés","Option_Brazil_Market":"Brasil","Option_China_Market":"China","Option_Europe_Market":"Europa","Option_Germany_Market":"Alemania","Option_Japan_Market":"Japón","Option_Russia_Market":"Rusia","Option_SoutheastAsia_Market":"Sudeste asiático","Option_Spain_Market":"España","Option_UnitedStates_Market":"Estados Unidos","Message_MaxLimit_DetailSectionSelection":"Seleccionar hasta ${0} secciones","Option_FollowGlobalSettings_Common":"Usar ajustes globales","Text_MaxTasks_Batch":"Añadir hasta ${0} tarea(s)","Text_MinTasks_Batch":"Mantener al menos una tarea","Text_MaxImagesPerTask_Batch":"Cargar hasta ${0} imágenes por tarea","Text_SupportedImageFormats_Batch":"Formatos de imagen compatibles: JPG, JPEG, PNG, HEIC y WebP.","Input_AppearanceDetailsExample_TryOn":"Por ejemplo: piel bronceada, flequillo recto, un lunar cerca del ojo...","Input_SourceInfoGuide_Batch":"Para obtener resultados más precisos, por favor, incluye la siguiente información: \\n1. Nombre del producto \\n2. Características destacadas \\n3. Público objetivo \\n4. Casos de uso previstos \\n5. Especificaciones detalladas","Tooltip_OutputStyleConsistent_Clone":"Al activarlo, todas las imágenes generadas mantendrán un color y estilo consistentes. Al desactivarlo, cada imagen seguirá el estilo de su propia imagen de referencia.","Option_AlibabaInternational_Platform":"Alibaba","Option_AliExpress_Platform":"AliExpress","Option_Amazon_Platform":"Amazon","Option_Douyin_Platform":"TikTok","Option_DouyinEcommerce_Platform":"TikTok","Option_IndependentSite_Platform":"Shopify","Option_Indonesian_Language":"Indonesio","Option_JD_Platform":"JD.com","Option_Pinduoduo_Platform":"Pinduoduo","Option_Taobao_Platform":"Taobao","Option_TaobaoTmall1688_Platform":"Taobao, Tmall, 1688","Button_Generate_ImageSet":"Generar set de imágenes","Title_Nav_ImageSet":"Listado de imágenes","Message_GenerateFailedRetry_ImageSet":"Error al generar. Intenta de nuevo.","Message_PleaseSelectStyleFirst_ImageSet":"Primero elige un estilo.","Message_CreateTaskFailed_ImageSet":"Error al crear la tarea","Title_StyleAnalysis_ImageSet":"Análisis de estilos en tendencia","Option_TrafficMaximization_TitleStrategy":"Maximizar tráfico","Option_ConversionPriority_TitleStrategy":"Prioridad a las conversiones","Option_SceneImmersion_TitleStrategy":"Escenas inmersivas","Text_ExtractingVisualAttributes_TitleGenerationStatus":"Extrayendo características clave de los recursos…","Text_AnalyzingKeyHighlights_TitleGenerationStatus":"Generando palabras clave de alta conversión basadas en las características destacadas del producto...","Text_MatchingSeoStrategy_TitleGenerationStatus":"Aplicando las mejores estrategias de SEO…","Text_GeneratingOptions_TitleGenerationStatus":"Generando múltiples subtítulos desde diferentes perspectivas…","Message_TaskFailedWithStatus_TitleGeneration":"Error en la tarea (estado: ${0}): ${1}","Message_TaskTimedOut_TitleGeneration":"Se agotó el tiempo de espera de la solicitud. Intenta de nuevo.","Message_GenerateFailed_TitleGeneration":"Error al generar título. Intenta de nuevo.","Message_QueryResultFailed_TitleGeneration":"Error al recuperar tarea","Paragraph_Content_VirtualModelConsent":"1. Autorización de derechos de imagen: Esta función usa las imágenes que subes que contengan rostros para generar modelos virtuales con IA. Debes asegurarte de tener los derechos sobre las imágenes que subas o de adquirir el consentimiento explícito, válido y por escrito del propietario de los derechos para usar su imagen con este fin y cualquier contenido generado. Si imagen contiene a un menor de edad, se requiere el consentimiento de su tutor legal.","Button_ConfirmTextChange_TextEdit":"Actualizar","Input_ModifyText_TextEdit":"Editar subtítulos","Message_NoImagesAvailable_ResultDownload":"No hay imágenes disponibles para descargar","Message_Failed_TextRecognition":"Error al reconocer texto","Text_Generating_ResultStatus":"Generando…","Option_CustomColor_SceneSetting":"Personalizado","Option_UseOriginalBackground_SceneSetting":"Usar fondo original","Text_InsufficientCredits_Common":"Monedas insuficientes","Button_LoadMore_Common":"Cargar más","Text_ImageUploadLimit_Common":"Sube hasta ${0} imágenes","Text_AnalyzingTrend_Common":"Analizando tendencias sobre ${0}","Text_ChineseOutputProOnly_Common":"La generación de texto en chino es solo está disponible en Pro. Se eliminó el texto del resultado actual.","Text_SourceImageUploadLimit_Common":"Sube hasta ${0} imágenes","Text_WritingInProgress_AiWriting":"Procesando…","Text_DeepThinking_AiWriting":"Analizando a fondo…","Text_ThinkingProcess_AiWriting":"Proceso de pensamiento:","Text_ImageSelectionLimit_Common":"Selecciona hasta ${0} imágenes","Message_RegenerationSubmitted_Regeneration":"Regeneración enviada. Actualiza en unos momentos para ver el resultado.","Button_MoreEditOptions_ResultEditor":"Más","FormLabel_DetailSection_DetailPage":"Sección de detalles del producto","Message_GeneratePlanFailed_DetailPagePlan":"Error al generar plan","Message_PlanGenerationFailed_DetailPagePlan":"Error al generar plan","Text_PlanUnavailable_DetailPagePlan":"No hay planes disponibles","Message_SourceImageMissing_Common":"Falta la imagen del producto","Message_GenerationFailed_Common":"Error al generar","Paragraph_ConfirmDiscardChanges_Common":"Si regresas, se perderán tus cambios. ¿Deseas regresar?","Message_ProcessFailed_Common":"Error","Text_GeneratingEllipsis_Common":"Generando…","Text_StyleGenerationInProgress_ImageSet":"Generando estilos en tendencia…","Message_FavoriteAdded_Common":"Agregado a Favoritos","Message_FavoriteRemoved_Common":"Eliminado de Favoritos","Text_LoadingPlain_Common":"Cargando","Text_MultiSelectAvailable_Common":"Selección múltiple","Text_NoData_Common":"Sin datos disponibles","Text_NoDataAvailable_Common":"Sin datos","Text_NoMoreResults_Common":"No hay más contenido","Message_PleaseEnterKeyHighlights_DetailPage":"Inserta las características destacadas del producto","Message_PleaseSelectAiModel_TryOn":"Selecciona un modelo de IA","Message_SelectSectionMin_DetailPage":"Selecciona al menos ${0} secciones","Message_SelectScenePoseMin_TryOn":"Selecciona al menos ${0} escenas y poses","Message_PleaseSelectBaseModel_TryOn":"Selecciona un modelo de base","Message_PleaseSelectCustomModel_TryOn":"Selecciona un modelo personalizado","Message_PleaseSelectModel_TryOn":"Primero selecciona un modelo","Message_PleaseSelectSection_DetailPage":"Selecciona una sección","Message_SelectUploadCustomModel_TryOn":"Selecciona o sube una imagen de modelo","Message_PleaseSelectScene_TryOn":"Selecciona una situación","Message_PleaseSelectStrategy_DetailPage":"Selecciona una estrategia","Message_PleaseUploadGarmentImage_TryOn":"Sube una imagen de ropa","Message_UploadGarmentFile_TryOn":"Sube una imagen de ropa","Message_PleaseUploadSourceImage_Common":"Sube primero imágenes del producto","Message_PleaseUploadItemImage_Common":"Sube una imagen de producto","Message_UploadItemFirst_Common":"Sube primero imágenes del producto","Message_RegenerateFailedWithReason_Regeneration":"Error al regenerar:","Message_SelectResultImages_Result":"Selecciona una imagen con resultados generados","Text_ReleaseToRefresh_Common":"Suelta para actualizar","Message_TextRecognitionFormatInvalid_TextRecognition":"Formato no válido reconocido","Message_TextRecognitionParseFailed_TextRecognition":"Error al procesar los resultados de reconocimiento","Message_TextRecognitionTaskFailed_TextRecognition":"Error al reconocer texto","Message_QueryTaskStatusFailed_TextRecognition":"Error al recuperar el estado de la tarea","Message_SubmitTaskFailed_TextRecognition":"Error al enviar la solicitud de reconocimiento","Text_RegenerationProcessing_Regeneration":"Solicitud de regeneración enviada. Procesando…","Message_RegenerateFailedRetry_Regeneration":"Error al regenerar. Intenta de nuevo más tarde.","Message_OpenEditorFailed_ResultEditor":"Error al abrir el editor","Message_RegenerateFailed_Regeneration":"Error al regenerar","Message_RefreshFailedRetry_Common":"Error al actualizar. Intenta de nuevo.","Message_UploadGarmentSelectModel_TryOn":"Sube una imagen de la prenda y selecciona un modelo","Message_PollingTimedOut_Common":"La consulta caducó","Title_KeyHighlights_DetailPage":"Características destacadas del producto","Title_FullStrategyGuide_DetailPage":"Lineamientos completos de estrategia y diseño","Title_IncludedSections_DetailPage":"Secciones","Title_IncludedSectionsMultiple_DetailPage":"Secciones (selección múltiple)","Title_ModelSelection_TryOn":"Seleccionar modelo","Title_SectionContent_DetailPage":"Contenido de la sección","Title_SectionStrategyGuide_DetailPage":"Lineamientos de estrategia y diseño por sección","Title_OutputAspectRatio_Common":"Relación de aspecto","Title_OutputSpecification_Common":"Especificaciones","Title_SelectModel_TryOn":"Seleccionar modelo","Title_SelectScene_TryOn":"Selecciona una escena","Title_StrategySettings_DetailPage":"Estrategia","Title_UploadAssets_Common":"Subir","Button_GenerateBaseModel_TryOn":"Generar modelo de base","Button_GenerateRecommendedScenes_TryOn":"Generar escena recomendada","Button_GenerateSceneImages_TryOn":"Generar (${0} imágenes)","Text_GeneratingBaseModel_TryOn":"Generando modelo de base…","Option_CloseUp_Framing":"Primer plano","Option_FullBody_Framing":"Cuerpo completo","Option_HalfBody_Framing":"Medio cuerpo","Option_ThreeQuarter_Framing":"3/4","Title_Hero_TryOn":"Probador con IA","Option_Ai_TryOnModelMode":"Generado con IA","Title_Nav_TryOn":"Probador","Option_Back_Perspective":"Atrás","Option_Front_Perspective":"Frente","Option_Side_Perspective":"Lado","Option_ThreeQuarterSide_Perspective":"Vista en 3/4","Input_AppearanceDetailsHint_TryOn":"Detalles de apariencia: piel bronceada, flequillo recto, un lunar cerca del ojo…","Message_SaveToAlbumSuccess_Common":"Guardado en el álbum","Text_GeneratingSceneImages_TryOn":"Generando imágenes de escenas…","Message_RefreshFailed_Common":"Error al actualizar","Message_FailedRefunded_Generation":"Error de diseño con IA. Los créditos fueron reembolsados.","Title_BaseModelImage_TryOn":"Imagen de modelo de base","Title_CustomModel_TryOn":"Modelo personalizado","Paragraph_Intro_TryOn":"Sube una imagen de la prenda y personaliza tu modelo para generar diversas escenas y poses.","Title_UploadGarmentImage_TryOn":"Imagen de ropa","Tips_UploadFailedPure":"Error al subir","Tips_Uploading":"Subiendo…","Text_UploadNewModel":"Modelo nuevo","Text_AllBackgrounds":"Todos los fondos","Text_DefaultTemplateScene":"Predeterminado","Text_ColorScene":"Colores","Text_SameProductMax_Common":"Hasta ${0} imagen(es) por producto","Text_Max_Common":"Añade hasta ${0} imágenes — cada referencia genera 1 resultado.","Button_Generate_ImageClone":"Comenzar a generar","Button_RefreshStyle_Common":"Actualizar","Button_Favorite_Common":"Favoritos","Text_PreviewLargeImage":"Vista previa completa","Text_BaseImage":"Comparativa de referencia","Button_BatchDownload_Common":"Descarga por lotes","Button_BatchEdit_Common":"Edición por lotes","Button_BatchWatermark_Common":"Añadir marca de agua","Text_GeneratedResults":"Resultados","Button_DownloadAllImages_Common":"Descargar todo","Text_NoGeneratedResults":"Sin resultados","Text_SameProductMax_TryOn":"Un outfit completo o varios ángulos de la misma prenda, hasta $ {0} imágenes.","Title_AdvancedImageGenerationModel":"Modelo de imagen premium","Text_SupportChineseOutput_Common":"Admite resultados en chino para proporcionar una estética superior y mayor control creativo.","Text_SelectMultipleModules_DetailPage":"Selecciona varias secciones para generar una página completa de detalles del producto","Button_CollapseAll_Common":"Todo","Label_AppearanceDetails_TryOn":"Detalles de apariencia (opcional)","Text_WaitingForGeneration_TryOn":"Por generar","Title_SmartTitleAI_ProductTitle":"Genera Titulares Virales","Message_ResultMissing_TitleGeneration":"Faltan ${0} resultados generados con IA","Message_InvalidJSONFormat_TitleGeneration":"Resultado no válido","Message_InvalidJSONFormat_TitleGeneration1":"Formato de JSON no válido","Text_AutoGeneratedTitleScheme_ProductTitle":"Aquí tienes los títulos generados automáticamente a partir de tu producto","Text_SelectBestTitle_ProductTitle":"Elige el título que venda más y haz clic para copiar","Button_Copy_Common":"Copiar","Message_PleaseUploadImage_Common":"Sube una foto primero","Text_DeepThinking1_AiWriting":"DeepSeek está trabajando en ello…","Button_Rewrite1":"Reintentar","Text_TotalImages_Common":"Recuento: ${0}","Text_EditText_ResultEditor":"Editar texto","Text_NoTextRecognition_ResultEditor":"No se ha detectado texto","Text_PreviewLongImage_ResultGroup":"Vista previa de imagen larga","Text_LimitFree":"Oferta relámpago","Text_UploadSameProductTip1":"1. Sube imágenes originales del mismo producto desde varios ángulos para ayudar a la IA a recrear los detalles con mayor precisión","Text_UploadSameProductTip2":"2. Puedes subir hasta ${0} imágenes. La primera se usará como referencia principal, así que elige la que tenga la vista más completa.","Text_UploadProductImage_APlusCase":"Sube una imagen de producto","Text_GenerateEcommerceLongImage_APlusCase":"Generar imagen larga","Text_MultiPlatform_APlusCase":"Cumple con los estándares de múltiples plataformas de e-commerce","Text_MainImage_ProductCase":"01 Imagen principal (Fondo blanco / Estándar)","Text_SceneDisplay_ProductCase":"02 Situaciones de uso","Text_ModelSceneImage_ProductCase":"03 Imágenes de modelos","Text_DetailDescription_ProductCase":"04 Detalles","Text_FeatureExplanation_ProductCase":"05 Características destacadas del producto","Text_UploadProductImage_ProductCase":"Sube imágenes de producto y la IA generará al instante sets de imágenes con altas tasas de conversión <span>que cumplen con los estándares de múltiples plataformas de e-commerce</span>.","Text_UploadGarmentImage_TryOn":"Sube imágenes de tus prendas y crea un modelo personalizado para generar al instante distintas escenas y poses.","Text_UploadProductImage_DetailPage":"Sube imágenes de producto y la IA generará al instante una página profesional de detalles del producto <span>que cumple con los estándares de múltiples plataformas de e-commerce</span>.","Title_DetailPage_ProductCase":"A+/Página de detalles del producto","Option_Temu_Platform":"Temu","Option_TikTokShop_Platform":"TikTok Shop","Option_TikTok_Platform":"TikTok","Option_Ozon_Platform":"OZON","Option_Shopee_Platform":"Shopee","Option_SHEIN_Platform":"SHEIN","Login_Zawa_Title":"Inicia sesión para desbloquear tu prueba gratuita","Login_DK_Title":"Crea sorprendentes diseños gratis","Login_Zawa_Des":"Comienza a crear con Zawa hoy","Login_DK_Des":"Regístrate o inicia sesión para seguir diseñando. ¡Comienza ahora!","Tab_Module_ProductImage_TryOn_MultiMix":"Combina tus prendas en un outfit","Tab_Module_ProductImage_TryOn_SingleHero":"De una sola prenda a un look completo","Tab_Module_ProductImage_TryOn_Accessories":"El toque perfecto con accesorios","Text_ShowAdvancedModelTip":"Mostrar tips de modelos premium","Text_HideAdvancedModelTip":"Ocultar tips de modelos premium","Text_DeepSeekR1HelpWrite":"Ayúdame a escribir (DeepSeek R1)","Message_PollingMaxAttempts_Common":"Superaste el máximo de ${0} intentos","Title_StandardEdition":"Estándar","Text_FastAndEfficient_Common":"Rápido y eficiente","Text_PremiumEdition":"Premium","Text_QualityAndDetailEnhancement_Common":"Mejora de calidad y detalles","Text_PremiumEngineActivated":"<strong>Motor premium activado:</strong> admite resultados en chino y ofrece detalles estéticos superiores con un mayor control creativo.","Text_EditBrand_DropTitle1":"Arrastra y suelta aquí archivos JPG, PNG o WEBP,","Text_EditBrand_DropTitle2":"o <>navega</> desde tu computadora.","Text_BaseToolbar_AlignTop":"Alinear arriba","Text_BaseToolbar_AlignBottom":"Alinear abajo","Text_LayerSort":"Ordenar","Text_BaseToolbar_AlignCenter":"Centro","Text_Attr_Strong":"Negrita","Text_GeneratingPlan_DetailPagePlan":"Generando plan…","Text_PlanGenerationFailed_ReTry":"Error al generar plan. Intenta de nuevo más tarde.","Button_StartAnalyze_ProductCase":"Comencemos","Message_SubmitSuccessTip_Batch":"Enviado","Button_ClickAnalyze_ProductCase":"Analiza los estilos más vendidos","Button_StartAnalyzing_ProductCase":"Analizando","Title_ModelImage":"Modelo","Text_Cookie_Title":"Primero lo primero, las cookies 🍪","Text_Cookie_Content":"Nos gustaría usar cookies en este sitio web para garantizar la seguridad, un rendimiento eficiente y la optimización del servicio. Para saber más sobre cómo usamos las cookies, haz clic","Text_Cookie_LearnMore":"Detalles","Button_Cookie_Manage":"Administrar cookies","Button_Cookie_Accept":"Aceptar","Text_CookieModal_Title1":"Configuración de cookies","Text_CookieModal_Desc1":"Las cookies son pequeños archivos de texto que los sitios web guardan en tu dispositivo para ayudarnos a recordar tus preferencias, analizar el tráfico y mejorar nuestros servicios. Tu privacidad es importante para nosotros y queremos que tengas el control de tus datos. Aquí puedes personalizar tus preferencias de cookies para optimizar tu experiencia de navegación. Ten en cuenta que cambiar esta configuración podría afectar el funcionamiento y los servicios de nuestro sitio web.","Text_CookieModal_Title2":"Cookies necesarias","Text_CookieModal_Desc2":"Estas cookies son esenciales para el funcionamiento, la seguridad y el rendimiento básico del sitio web. Sin ellas, las funciones clave y las medidas de seguridad de Zawa no funcionarán correctamente, lo que podría afectar negativamente tu experiencia.","Text_CookieModal_Title3":"Cookies opcionales","Text_CookieModal_Desc3":"Estas cookies nos ayudan a entender la cantidad de usuarios de Zawa, de dónde vienen y cómo usan el sitio web. Si decides desactivar estas cookies, no podremos recopilar información para mejorar Zawa ni ofrecerles un mejor servicio a ti y a otros usuarios.","Button_CookieModal_Save":"Guardar","Text_CookieModal":"Siempre activado","Text_Agent_Chat_DK":"Escribe tu idea...","Text_Agent_Chat_XD":"¿Qué te gustaría diseñar?","Radio_Color":"Paleta","Radio_Layout":"Diseño","Radio_Reference":"${0}","Radio_Posture":"Posar","Radio_Background":"Fondo","Language_Banner_Message":"¿Te gustaría cambiar a ${0}?","Language_Banner_Change":"Sí","Language_Banner_Other":"Más idiomas","Title_ItemTaskWithIndex_Batch":"Tarea de producto ${0}","Title_DetailTaskPrefix_Batch":"Tarea A+","Text_CopiedTaskTitle_Batch":"${0} (copia)","Message_SelectSectionMin_Batch":"Selecciona al menos una sección.","Title_GlobalBatchSettings_Batch":"Configuración global (se aplica a las siguientes tareas)","Text_Parameters_Batch":"Parámetros","Text_Modules_Batch":"Secciones","Title_KeyHighlights_Batch":"Características destacadas del producto","Text_ModulesFollowGlobal_Batch":"Secciones: usar configuración global","Title_SelectManagedBusinessType_Batch":"Seleccionar tipo de tarea","Button_SubmitTask_Batch":"Enviar","Text_NewTaskCurrentCount_Batch":"Crear tarea","Title_NotificationSettings_Batch":"Notificaciones","Title_ManagedMode_Batch":"Planificador","Button_SaveSettings_Batch":"Guardar configuración","Button_SaveAndContinueSubmit_Batch":"Guardar y enviar","Message_PhoneFormatInvalid_Batch":"Ingresa un número de teléfono válido de 11 dígitos.","Message_VerificationCodeSent_Batch":"Código de verificación enviado. El código es válido por 5 minutos.","Message_VerificationCodeSendFailed_Batch":"Error al enviar. Inténtalo de nuevo más tarde.","Message_PleaseEnterCode_Batch":"Ingresa el código de verificación.","Message_GetCodeFirst_Batch":"Primero, obtén un código de verificación.","Message_VerificationCodeExpired_Batch":"El código de verificación ha caducado. Solicita uno nuevo.","Message_SaveNotificationSettingsFailed_Batch":"Error al guardar la configuración de las notificaciones. Inténtalo de nuevo más tarde.","Text_WebMessageNotification_Batch":"Recibirás una notificación en los mensajes web cuando se complete la tarea.","Title_AppPushRecommended_Batch":"Notificaciones de la aplicación (recomendado)","Paragraph_AppPushDesc_Batch":"Haz seguimiento del progreso y consulta los resultados en tu teléfono en tiempo real. Mantén tus diseños siempre a mano y no pierdas ninguna oportunidad.","Text_AppDownloadQrCode_Batch":"Escanea para descargar la aplicación","Title_SmsNotification_Batch":"Notificaciones por SMS","Placeholder_Phone11Digits_Batch":"Un número de teléfono de 11 dígitos","Placeholder_VerificationCode5Min_Batch":"Código de verificación","Text_SendingEllipsis_Batch":"Enviando...","Text_RetryAfterSeconds_Batch":"Inténtalo de nuevo en ${0}s","Button_GetVerificationCode_Batch":"Enviar código","Message_SubmitSuccess_Batch":"Enviado","Message_SubmitFailedRetry_Batch":"Error al enviar. Inténtalo de nuevo más tarde.","Message_FormValidationPassed_Batch":"Contenido válido","Message_CompleteNotificationSettingsFirst_Batch":"Configura las notificaciones antes de enviar la tarea.","Paragraph_CancelManagedTaskWarning_Record":"La tarea programada se eliminará permanentemente si cancelas ahora.","Button_ConfirmCancel_Record":"Cancelar de todas formas","Message_CancelManagedTaskFailed_Record":"Error al cancelar. Inténtalo de nuevo más tarde.","Text_WaitingManagedGeneration_Batch":"Programando tarea...","Text_WaitingManagedSubmit_Batch":"En fila","Message_NoExtendableImages_Result":"No hay imágenes disponibles","Text_IntelligentMultiSizeAdaptation_Result":"Redimensiona tus imágenes de forma inteligente para adaptarlas a cualquier pantalla","Button_IntelligentResize_Result":"Redimensionado inteligente","Option_CustomSize_DetailPageMode":"Personalizado","Title_AdvancedAPlus_DetailPageMode":"Premium A+","Title_ManagedModeLaunched_Batch":"¡El planificador está listo para ayudarte!","Text_ManagedModeSlogan_Batch":"Trabaja por la noche para tener tus diseños listos cuando te despiertes.","Title_BatchProduction_Batch":"Generación por lotes","Paragraph_BatchProductionDesc_Batch":"Ejecuta hasta ${0} tareas simultáneamente y aumenta tu productividad en ${1}×.","Title_AiIntelligentExtraction_Batch":"Análisis con IA","Paragraph_AiIntelligentExtractionDesc_Batch":"Analiza tus imágenes y genera automáticamente características destacadas de productos de alta conversión.","Title_SaveCost20_Batch":"Ahorra ${0}% en créditos","Paragraph_SaveCost20Desc_Batch":"Puedes programar tareas por la noche y disfrutar de un menor consumo de créditos.","重写":"Descarga por lotes","Brand_AutoExtract_Button":"Extraer colores","Brand_AutoExtract_Success":"Colores extraídos","Brand_AutoExtract_Failure":"No se pudieron extraer los colores. Inténtalo de nuevo.","Brand_AutoExtract_Unavailable":"No es posible extraer la paleta de colores.","Brand_AutoExtract_ConfirmTitle":"¿Extraer paleta de colores del logo?","Title_ImageSetConfig_ImageSet":"Diseño de publicación de productos","Title_DefaultConfig_ImageSet":"Diseño con IA","Desc_DefaultConfig_ImageSet":"La IA analiza las imágenes del producto y selecciona el mejor conjunto de imágenes para la publicación","Title_CustomConfig_ImageSet":"Diseño personalizado","Desc_CustomConfig_ImageSet":"Ajusta la cantidad de imágenes para cada tipo. Selecciona al menos ${0} imágenes.","Label_WhiteBackground_ImageSet":"Imágenes con fondo blanco","Desc_WhiteBackground_ImageSet":"Muestra tu producto desde múltiples ángulos sobre un fondo blanco.","Label_Scene_ImageSet":"Escenarios de estilo de vida","Desc_Scene_ImageSet":"Presenta tu producto en escenarios de la vida real.","Label_SellingPoint_ImageSet":"Características destacadas del producto","Desc_SellingPoint_ImageSet":"Destaca las características claves que hacen que tu producto se destaque.","Label_Other_ImageSet":"Otro","Desc_Other_ImageSet":"Contenido seleccionado automáticamente para tu producto, incluyendo comparativas, especificaciones y más.","Tip_MinTotal_ImageSet":"Al menos ${0} imágenes","Text_ManagedBatchEntry_Header":"Planificador","Option_Coupang_Platform":"Coupang","Option_Wayfair_Platform":"Wayfair","Button_Credit_Plan":"Plan de créditos","Text_Higher_Plan":"Ya estás en un plan superior","Text_Try_Free":"Pruébalo ahora por $ 0","Text_Plus_Plan":"Plan Plus","Text_Pro_Plan":"Plan Pro","Button_Generate_Short_Common":"Generar","Message_DuplicateTaskSubmitConfirm_Common":"Los resultados ya fueron generados con estos ajustes. ¿Quieres generarlos de nuevo?","Text_CreditUnit_Common":"Créditos","Text_NewUserDiscountDesc_Product":"${0} créditos por la primera publicación de producto. ${2} créditos por cada {1} publicación(es) de producto adicional.","Text_NewUserLimitedTag_Product":"Descuento por nuevo usuario","Text_OriginalPrice_Product":"Original: ${0} créditos","Tip_MaxTotal_ImageSet":"Hasta ${0} imágenes","Text_AddDocumentTips":"Se admiten archivos Word, Excel, texto, PDF y Markdown","Tab_SolidColor":"Color liso","Tab_Gradient":"Degradado","Title_PresetGradient":"Ajustes preestablecidos","Title_PresetSolidColor":"Ajustes preestablecidos","Title_RecentlyUsed":"Recientemente utilizado","Title_Patterns":"Patrón","Title_NoFill":"Ninguno","Description_Brand_Reference":"Sube tus pósteres o tus recursos artísticos favoritos y Zawa usará ese estilo para crear diseños adaptados a tu estilo.","Text_Generating":"Generando…","Text_ChartSending":"Enviando","Text_PeopleUnSupport":"Aún no se admiten retratos","Button_CancelManagedBatch_ResultGroup":"Eliminar tarea","Button_DownloadZip_ResultGroup":"Descargar ZIP","Button_DownloadLongImage_ResultGroup":"Descarga combinada","Text_ManagedTaskDispatchedCannotCancel_ResultGroup":"No se puede cancelar una tarea ya esta enviada.","Button_GlobalAiWriting_Batch":"Escritura con IA","Text_StandardModel_DistributionBatch":"Modelo Estándar (Por lote)","Text_StandardModelDescription_Batch":"Ideal para inventarios extensos; maximiza tu alcance en el mercado.","Text_AdvancedModel_PremiumBatch":"Modelo Pro (Enfoque Específico)","Text_AdvancedModelDescription_Batch":"Imágenes de calidad superior, ideales para una rentabilidad basada en la precisión.","Message_MinSubmitTasks_Batch":"Envía al menos ${0} tareas.","Message_OverwriteSellingPointsConfirm_Batch":"La sección de características destacadas del producto se ha completado con ${0} tareas. ¿Cómo te gustaría aplicar los resultados del texto generado por IA?","Button_OverwriteAll_Batch":"Reemplazar todo","Button_FillEmptyOnly_Batch":"Incompletas","Message_NoEmptySellingPointsToFill_Batch":"Ya se han completado las características destacadas del producto para todas las tareas.","Message_AiWritingFailedRetry_Batch":"Error en la redacción por IA. Inténtalo de nuevo más tarde.","Button_NewTask_Common":"Nueva tareas","Message_Generating_Time":"Tus tareas se realizarán durante la noche（${0}-${1}）. Vuelve mañana para revisar los resultados","Title_Total_Credits":"Créditos totales","Text_Used_AllFeatures":"Disponible para todas las funciones","Daily_Present_Credits":"Créditos del día","Daily_Credits_Desc":"Reclama a diario. Válido solo hasta el final del día.","Text_Inactive":"Inactivo","Text_Inactive_Monthly":"${0} créditos vencerán en los próximos 30 días.","TITLE_GUIDE_CUTOUT_LITE":"Se detectaron sellos o logos","GUIDE_DESC_CUTOUT_LITE":"Usa \\"Recorte de Sello/Logo\\" para un resultado más preciso.","GUIDE_ACTION_CUTOUT_LITE":"Recorte de Sello/Logo","TITLE_CUTOUT_LITE":"Recorte de Sello/Logo","TIP_CUTOUT_LITE":"Recortes precisos de sellos o logos","PROCESSING_CUTOUT_LITE":"Creando imágenes...","AFTER_CUTOUT_LITE":"Resultados","Button_Previous":"Anterior","Button_Next":"Siguiente","Button_Skip":"Omitir","Button_Apply":"Aplicar","Text_AgentExpert":"Especialista","Message_PleaseEnterLinkOrAsin_Clone":"Ingresa un enlace o un ASIN","Message_LinkAnalyzeFailed_Clone":"Error al analizar enlace","Message_UploadProductImageFirst_Clone":"Sube primero las imágenes del producto","Message_ProductImageThumbGenerateFailed_Clone":"Error al generar la miniatura. Vuelve a subirla.","Message_UploadProductImageFirst_ProductCase":"Sube una imagen de referencia o pega un enlace de producto","Message_ReferenceImageThumbGenerateFailed_Clone":"Error al generar la miniatura. Vuelve a subirla.","Title_ReferenceSource_Clone":"Referencia","Option_LinkAsin_Clone":"Enlace","Input_PasteProductLinkOrAsin_Clone":"Pega un enlace de Amazon","Button_Parsing_Clone":"Analizando…","Button_Parse_Clone":"Analiza","Text_SupportAmazonTiktokLinks_Clone":"Se admiten enlaces de Amazon y TikTok","Text_Cloning_ResultStatus":"Procesando…","Input_CloneRequirementOptional_Clone":"Requisitos (Opcional)","Title_ProductOriginalImage_Clone":"Imagen de producto","Title_CloneLevel_Clone":"Estilo de replicación","Option_CompositionReference_Clone":"Igualar estilo","Desc_CompositionReference_Clone":"Crea una nueva escena inspirada en el ambiente y el estilo de tu referencia.","Option_HighFidelityClone_Clone":"Igualar referencia","Desc_HighFidelityClone_Clone":"Recrea fielmente tu referencia, cambiando solo el producto y el texto.","Label_OutputStyleConsistent_Clone":"Estilo consistente","Title_SupplementaryNotesOptional_Clone":"Instrucciones adicionales (Opcional)","Input_SupplementaryNotesExample_Clone":"Ejemplo: genera textos de producto en inglés, mantén el mismo modelo y reemplaza solo el producto.","Title_HotClone_Welcome":"Remix de imágenes","Text_HotCloneDescription_Welcome":"Tu referencia ganadora + tu imagen de producto = tu propia imagen viral","Text_DefaultTaskName_Clone":"Estrategia de clonación de imágenes","Label_ProductImage_CloneCase":"Imagen de producto","Label_ReferenceComposition_CloneCase":"Igualar estilo","Label_HighFidelityClone_CloneCase":"Igualar con la referencia","Tag_AiSmartMatch_ImageSet":"Ajuste inteligente con IA","Title_Date":"Fecha","Title_Topic":"Tema","Button_Replace":"Reemplazar","Title_SingleCloneRequirement_Clone":"Requisitos individuales","Text_UploadedReferenceImagesTip_Clone":"Requisitos individuales para cada imagen de referencia. Se aplicarán los ajustes predeterminados si no se especifican requisitos.","Label_ReferenceImageIndex_Clone":"Imagen de referencia ${0}","Option_Mexico_Market":"México","Text_ParsingReferenceImages_Clone":"Analizando…","Text_ParseReferenceImagesSuccess_Clone":"Análisis completo. ${0} imágenes de referencia obtenidas.","Text_Renew_Restore":"Los créditos se restablecerán cuando se renueve tu suscripción.","Title_UsageNotice_Clone":"Guía del usuario","Text_UsageNoticeDescription_Clone":"Confirma que tienes el derecho legal para usar el contenido de este enlace. Los resultados generados se basan en un análisis de estilo realizado con IA y son solo de referencia creativa.","Label_ReadAndAgreeUsageNotice_Clone":"Acepto los términos anteriores","Label_DoNotShowAgain_Clone":"No volver a mostrar","Text_InterceptModal":"Permite ventanas emergentes para Designkit.","Text_InterceptModal_ThirdStep":"Haz clic en “Listo” para comenzar a usar Designkit.","Text_InterceptModal_Desc":"Autoriza a Designkit para que abra múltiples ventanas en tu navegador.","Brand_StatusPopup_ProcessingTitle":"Zawa está analizando el estilo de tu marca...","Brand_StatusPopup_FailedTitle":"Error al extraer datos de Square. Inténtalo de nuevo más tarde.","Brand_StatusPopup_Retry":"Inténtalo de nuevo","SecondTitle_Header19_Home":"Clonar anuncios de video","SquareBrandGuide_BrandKitCreatedTip":"Tu kit de marca ha sido creado a partir de los datos de Square","SquareBrandGuide_DefaultPrompt":"Diseña un póster de producto para promocionarlo en redes sociales","SquareBrandGuide_SendTip":"¡Haz clic en Enviar para comenzar!","Paragraph_BatchProductionDescUnlimited_Batch":"Maneja múltiples tareas a la vez, lo que reduce drásticamente el cronograma de tus proyectos.","Menu_ViewDetail":"Detalles","Menu_CopyFullText":"Copiar","Tip_CopiedToClipboard":"Copiado en el portapapeles","Tip_CopyFailed":"Error al copiar","Menu_DownloadImage":"Descargar","Tip_NoImage":"Sin imágenes","Tip_DownloadStarted":"Descarga en curso","Menu_CopyText":"Copiar","Tip_NoTextToCopy":"No hay texto disponible","Message_LinkImageFetchFailed_Clone":"No pudimos cargar imágenes desde este enlace. Prueba con un enlace diferente o sube las imágenes.","Tab_Chat":"Chat","Tab_Files":"Archivos","Button_Create_New_Chat":"Nuevo chat","Tip_Agent_Team_Chat_Shared":"Visualizando versión de solo lectura","Title_ViralVideoMaker":"Generador de videos virales con IA","Title_ProductVideoMaker":"Generador de videos de productos","designkit_agent_watermark_protocol":"Puedes elegir guardar las imágenes con o sin la marca de agua \\"Resultado de IA\\". Al guardar sin la marca de agua, aceptas: 1. No usar Zawa AI Agent para crear, publicar o difundir información falsa. 2. Cumplir con las leyes aplicables y etiquetar claramente el contenido generado por IA al usarlo o compartirlo.","Text_Document":"Archivo","Button_BrandAssets_UploadDevice":"Subir desde dispositivo","Button_SocialBrief_Complete":"Completar resumen","Button_SocialBrief_Edit":"Editar resumen","Button_SocialBrief_Generate":"Generar basado en resumen","Description_BrandAssets":"La información de tu marca nos ayuda a ofrecer resultados más relevantes.","Name_BrandAssets":"Recursos de marca","Placeholder_BrandAssets_Link":"p. ej., enlaces a Instagram o Google Maps.","Text_BrandAssets_KitImported":"Importar desde el kit de marca","Text_BrandAssets_LinkEntry":"Introduce tu enlace","Text_SocialResult_Post":"Publicar","Title_SocialBrief":"Resumen","Toast_BrandAssets_DuplicateSkipped":"Imágenes duplicadas omitidas","Toast_BrandAssets_EmptyAssets":"No se encontró el kit de marca","Toast_BrandAssets_InvalidUrl":"Introduce un enlace válido","Toast_BrandAssets_LoadAssetsFailed":"Error al obtener los recursos de marca","Toast_BrandAssets_LoadKitsFailed":"Error al obtener los kits de marca","Toast_BrandAssets_PartialReadFailed":"Algunas imágenes no se pudieron cargar","Toast_BrandAssets_ReadFailed":"No se pudieron cargar las imágenes","Toast_BrandAssets_SaveFailed":"Error al guardar los recursos de marca","Toast_BrandAssets_UploadFailed":"No se ha podido cargar parte de la información sobre los recursos de marca. Inténtalo de nuevo.","Title_AgentDesignPreference":"Personaliza tu Agente de Estilo de IA","Desc_AgentLibWorkflowUnify":"Guarda tus modelos y estilos de firma para creaciones más rápidas y consistentes en cada flujo de trabajo.","Button_ViewAgentGuide":"Instrucciones","Desc_BatchRecipeRetain":"Guarda la configuración de imágenes y las composiciones de escenas como ajustes preestablecidos reutilizables que puedes aplicar instantáneamente a futuros proyectos.","Button_NewBatchRecipe":"Crear preajuste","Desc_CustomModelUpload":"Sube las imágenes de tus modelos y reutilízalas en varias generaciones para crear una identidad de marca coherente.","Button_NewExclusiveModel":"Crear modelo","Text_AiRecommend_TryOn":"Recomendaciones de Escenas Inteligentes","Desc_AiRecommendSceneMode_TryOn":"Seleccionar automáticamente la mejor escena según la ropa.","Message_LoadSceneFailedRetry_TryOn":"Error de carga. Por favor, inténtalo de nuevo más tarde.","Text_OptionalCustomSceneDescription_TryOn":"Describe tu escena (opcional)","Placeholder_CustomSceneDescription_TryOn":"Proporciona detalles, por ejemplo, calles doradas de otoño, suave luz del atardecer, un modelo apoyado contra un árbol…","Message_PleaseSelectOrDescribeScene_TryOn":"Selecciona o ingresa una descripción de escena","Placeholder_SearchProduct_Record":"Buscar por nombre de producto o palabras clave","Title_RecentSearches":"Historial","Button_Clear":"Borrar","Title_ShootingScene_TryOn":"Configuración de la escena","Button_Charged_Continue":"Recarga completada","Title_SplitImagePlugin":"Superposición de imágenes","Description_SplitImagePlugin":"Detectar elementos de la imagen y separarlos en capas editables.","Tip_SplitImageLoading":"Procesando…","Tip_SplitImageFail":"Error al procesar. Intenta de nuevo.","Brand_SquareSync_ToastPartial":"No se pudo importar algunos datos de Square","Brand_SquareSync_ToastSuccess":"Tus datos de Square están listos","Brand_SquareSync_Failed":"Error al extraer datos de Square","Brand_SquareSync_Button":"Importar desde Square","Title_Format":"Formato","Message_CancelManagedTaskSuccessRefunded_Record":"Tarea cancelada. Se reembolsaron los créditos a tu cuenta.","Text_AspectRatio_Common":"Proporción","Text_Country_Common":"País/Región","Text_Language_Common":"Idioma","Text_Platform_Common":"Plataforma","Option_Korea_Market":"Corea del Sur","Option_Korean_Language":"Coreano","Title_AgentLibRecentBrainOn":"Inteligencia de agentes activada","Desc_AgentLibRecentRecipesSidebar":"Se agregaron tus preajustes a los Recursos del Agente. Úsalos para aplicar al instante el estilo de tu marca en todos tus diseños.","Title_CreateBatchRecipe":"Crear preajuste","Tips_Not_Files":"Sin archivos","Message_PleaseEnterProductHighlights":"Inserta las características destacadas de tu producto","Message_UploadProductImageRequired":"Sube al menos una imagen del producto","Tips_Agent_Teams_Mode":"Ideal para flujos de trabajo sofisticados que requieren múltiples funciones de IA.","Tips_Agent_Teams_Mode_Actived":"El modo Equipo de agentes coordina a los agentes de IA en todas las fases, desde la estrategia hasta la producción final.","Tip_SocialBrief_MissingImages":"Faltan las imágenes obligatorias en {count} publicaciones. Añádelas para continuar.","Tips_Agent_Teams_Mode_Active_Zawa":"Equipo de agentes está listo: investigación y creación de contenidos en piloto automático. Dime qué necesitas.","Tip_AiGeneratedContent":"El contenido generado por IA puede contener errores.","Button_ContinueUpload":"Continuar","Button_GenerateNow":"Generar","Button_ReplaceClothes":"Reemplazar","Desc_ReplaceClothesMultiUpload":"Cambia todo el atuendo simultáneamente","FileName_MyClothes":"Subido","Message_SelectReplaceClothes":"Selecciona las imágenes de tu vestimenta","Message_UploadClothesFailed":"La carga de la imagen falló, por favor intenta de nuevo.","Message_UploadClothesSizeLimit":"Sube imágenes de ropa de hasta 10 MB","Text_MoreActionEmpty":"Configurar acciones","Tip_UploadClothesFormat":"Suelta o carga ${0} imágenes hasta ${1}.","Title_ReplaceClothes":"Reemplazar ropa","Title_TryOnAccessoryMatch":"Añade accesorios de forma inteligente para crear una imagen distintiva de marca","Title_TryOnMultiPose":"Crea catálogos de moda con poses naturales y realistas","Title_TryOnOutfitMix":"Crea conjuntos completos combinando prendas","Title_TryOnSceneSwitch":"Cambia fondos que se adapten a cualquier ambiente o estilo","Title_TryOnAIRecommend":"Recomendaciones de IA","Text_SocialBrief_Generating":"Generación en curso. Espera por favor.","Tag_New":"Nuevo","Title_Designer":"Diseñador","Button_Blank_Canva":"Diseñador","Tool_AiViralImageRemix":"Remix de imágenes","Title_ViralVideoReplace":"Reedición de video","Title_SocialMedia_Tools":"Herramientas creativas para redes sociales","Title_HotTags":"Tendencias","Tip_LogoNotRecognized":"Logo no encontrado","Tip_LogoNotRecognized_Eraser":"Logo no encontrado. Desliza el dedo para seleccionar el área que deseas eliminar.","Placeholder_RemoveGrassDebris":"Eliminar los residuos del césped","Placeholder_RemoveGroundShadow":"Eliminar las sombras del suelo","Placeholder_RemoveRedClothesPerson":"Eliminar a la persona vestida de rojo","Placeholder_DescribeRemovalPart":"Escribe lo que quieras eliminar, por ejemplo: ${0}","Modal_LeavePageTitle":"Estás a punto de salir de esta página","Modal_OpenRoboNeoNewTab":"¿Abrir RoboNeo en una nueva pestaña?","Button_ReplicateVideo":"Reedita este video","Button_RemixImage":"Reedita esta imagen","Message_ContentProcessFailed_Text":"Error al procesar. Intenta con otras palabras.","Message_ContentProcessFailed_Image":"No se puede procesar esta imagen. Prueba con otra.","Text_ProductImageOptionalUploadTip_Clone":"Agrega una foto del producto si quieres que se incluya en el resultado","Option_EcommerceProductImage_Clone":"Imagen de producto para e-commerce","Option_ApparelEcommerceImage_Clone":"Imagen de e-commerce de ropa","Option_SocialGraphicImage_Clone":"Publicación para redes sociales","Option_MarketingPoster_Clone":"Poster para marketing","Option_CreativePoster_Clone":"Poster creativo","Option_ReferenceImageSize_Clone":"Relación de aspecto","Option_Instagram_Platform":"Instagram","Home_Tools_Title":"Potencia tu contenido en redes sociales con nuestro avanzado kit de herramientas","Home_Tools_Tab_SocialCreative":"Creatividad en redes sociales","Home_Tools_SeeAllImageTools":"Ve todas las herramientas de imagen","Home_Tools_SeeAllSocialCreative":"Ve todas las herramientas de contenido para redes sociales","Home_Tools_ImageObjectRemover":"Eliminador de objetos en imágenes","Home_Tools_TextToVideo":"Texto a video","Home_Tools_FoodPhotography":"Fotografía de alimentos","Home_Tools_FlyerGenerator":"Generador de flyers","Home_Tools_MenuGenerator":"Generador de menús","Home_Tools_PosterGenerator":"Generador de posters","Home_Tools_MockupGenerator":"Generador de maquetas","Home_Tools_ImageExtender":"Extensor de imagen","Home_Tools_ImageToVideo":"Imagen a video","title_upgrade2GetMoreCredits":"Actualiza para obtener más créditos.","tip_insufficientCredits":"Créditos insuficientes. Recarga para obtener más.","tip_insufficientCredits_upgrade":"Créditos insuficientes. Suscríbete para obtener más.","Title_DownloadPromotion_ViralVideo":"¿Quieres más videos como este?","Subtitle_DownloadPromotion_ViralVideo":"Hazte Pro para crear más videos.","Tag_DownloadPromotionOffer_ViralVideo":"Oferta limitada","Title_DownloadPromotionCard_ViralVideo":"Sigue creando con Pro","Text_DownloadPromotionPrice_ViralVideo":"${0}/mes","Text_DownloadPromotionBenefitViralVideo_ViralVideo":"Generador de videos de producto/Remix de video (hasta ${0} videos/mes)","Text_DownloadPromotionBenefitNanoBanana_ViralVideo":"Creaciones ilimitadas con Nano Banana Pro","Text_DownloadPromotionBenefitImageEnhance_ViralVideo":"Eliminación de IA ilimitada y mejora de calidad","Button_DownloadPromotionGetPro_ViralVideo":"Obtén Pro con ${0} de descuento","Button_DownloadPromotionLater_ViralVideo":"No, gracias","Tag_NewUserLimitedFree":"Oferta limitada","Text_FirstImageCreditDiscount":"${0} créditos por la primera imagen. ${2} créditos por cada ${1} imágenes adicionales.","Tag_NewUser_FirstImageLimitedFree":"Oferta limitada","Tag_FirstImageFree":"1 prueba gratuita","Title_OtherSettings":"Otros ajustes","Title_GenerateListing":"Generar texto del anuncio","Button_GenerateListing":"Generar texto del anuncio","Message_Copied":"Copiado","Text_Generating_Listing":"Generando…","Text_GenerateFailed_Listing":"Error al generar","Button_Translate":"Traducir","Title_ListingCopy":"Texto del anuncio","Message_NoTaskForListing":"No se encontró ninguna tarea de generación de anuncios.","Message_RenameSuccess":"Modificado","Message_RenameFailedRetry":"Error al modificar. Por favor, inténtalo de nuevo.","Title_RegenerateDirection":"Generación de edición","Placeholder_RegeneratePrompt":"Dejar en blanco para regenerar o agregar instrucciones para editar el resultado (opcional). Por ejemplo: \\"Mover el producto a la izquierda\\" o \\"Cambiar el fondo a gris claro\\".","Title_TrialLimitReached_ViralVideo":"Video gratuito utilizado","Subtitle_TrialLimitReached_ViralVideo":"Tu prueba gratuita puede generar 1 video. Pasa a Pro para generar más.","Button_UpgradeNow":"Actualizar ahora","Text_WPS_NavVipEntrance":"Comprar","Text_WPS_Only":"(WPS only)","Text_WPS_Credits_Card_Tip":"Designkit has a separate subscription system and is not included in standard WPS memberships.","Text_WPS_Welcome_Modal_Pricing":"Designkit Subscription","Text_WPS_Welcome_Modal_Pricing_Description":"Diseño con IA es proporcionado por un socio externo de WPS y requiere una compra por separado.","Text_WPS_Welcome_Modal_Meidou":"Primer inicio de sesión","Text_WPS_Welcome_Modal_Meidou_Description":"WPS Members get 50 free credits to try it out! No extra charges will apply to your account.","Text_WPS_Welcome_Modal_Vip":"Subscription Bonus","Text_WPS_Welcome_Modal_Vip_Description":"Compra un plan de Diseño con IA y obtén la Membresía Súper de WPS por la misma duración, por tiempo limitado.","Text_WPS_Welcome_Modal_Title":"Create with Designkit","Text_WPS_Welcome_Modal_Agreement":"By continuing, you have read and agree to the terms above.","Button_Generate_ImageListingSet":"Listing Images & Copy","Tip_GenerateListing":"Generate platform-ready visuals and copy for your selected marketplace.","Text_SelectedCount":"${0} seleccionado(s)","RoboNeo_Web_input_default_content":"Chatear con RoboNeo","RoboNeo_Web_chatbox_maximum":"Límite de chat alcanzado","RoboNeo_Web_chatbox_maximum_text":"Límite de chat alcanzado. Crea una nueva tarea.","RoboNeo_Web_chatbox_new_task":"Nuevo proyecto","RoboNeo_Web_history_share_text":"Compartir","RoboNeo_Web_history_delete_text":"Eliminar","RoboNeo_Web_history_delete_hint_text":"Nota","RoboNeo_Web_history_delete_main_text":"El proyecto se eliminará permanentemente. ¿Deseas continuar?","RoboNeo_Web_history_delete_hint_confirm":"Eliminar","RoboNeo_Web_history_delete_hint_cancel":"Cancelar","RoboNeo_Web_studio_download":"Descargar","RoboNeo_Web_toast_share_text":"Compartir este chat","RoboNeo_Web_toast_share_main_text":"Cualquiera con el enlace del chat puede ver tu historial de chat","RoboNeo_Web_toast_share_copy":"Copiar enlace","RoboNeo_Web_toast_cancel":"Cancelar","RoboNeo_Web_toast_confirm":"Confirmar","RoboNeo_Web_studio_changing_toast":"No quedan usos gratuitos hoy, se restablecerán a medianoche. También puedes darle \\"ciberzanahorias\\" a Neo para continuar.","RoboNeo_Web_studio_changing_toast2":"No quedan usos gratuitos hoy.","RoboNeo_Web_new_studio":"Nuevo chat","RoboNeo_Web_sidebar_close":"Contraer","RoboNeo_Web_history_text":"Historial","RoboNeo_Web_sidebar_open":"Expandir","RoboNeo_Web_upload_warning_text":"No se pueden subir fotos y videos al mismo tiempo.","RoboNeo_Web_upload_format_text":"Formatos de imagen compatibles: JPG, PNG y JPEG. Formatos de video compatibles: MP4 y MOV.","RoboNeo_Web_upload_fail_text":"Error de carga","RoboNeo_Web_upload_image_maximum":"Puedes subir hasta {max_num} imágenes","RoboNeo_Web_upload_video_size_maximum":"Los videos que superen los {max_size} MB no son compatibles.","RoboNeo_Web_upload_image_size_maximum":"Las imágenes que superen los {max_size} MB no son compatibles.","RoboNeo_Web_upload_video_maximum":"Puedes subir hasta {max_num} videos","RoboNeo_Web_history_dafult_text":"No se encontró historial, chatea ahora.","RoboNeo_Web_upload_content_warning_text":"Los archivos con contenido potencialmente inapropiado no serán importados.","RoboNeo_Web_chat_send_fail":"Envío fallido, por favor, inténtalo de nuevo más tarde.","RoboNeo_Web_network_fail":"Error de conexión o tiempo de espera agotado, por favor inténtalo de nuevo.","RoboNeo_Web_studio_layer_fail":"Error al dividir capas.","RoboNeo_Web_studio_layer_success":"Completado","RoboNeo_Web_network_error":"Error de red","RoboNeo_Web_delete_success":"Eliminado","RoboNeo_Web_delete_fail":"Error al borrar","RoboNeo_Web_copy_success":"Copiado","RoboNeo_Web_file_uploading":"Cargando {num} archivos","RoboNeo_Web_file_upload_fail":"Error al cargar {num} archivos","RoboNeo_Web_file_upload_single_fail":"Error al subir 1 archivo","RoboNeo_Web_file_uploading_single":"Subiendo 1 archivo","RoboNeo_Web_upload_video_maximum_one":"Puedes subir hasta 1 video","RoboNeo_Web_sharepage_wanna_try":"Probar ahora","RoboNeo_Web_sharepage_load_to_end":"Ir a Resultados","RoboNeo_Web_studio_loading_text":"Cargando lienzo...","RoboNeo_Web_chatbox_add_image":"Añadir imágenes","RoboNeo_Web_chatbox_add_video":"Añadir video","RoboNeo_Web_image_editor_max":"Máximo 10 MB con 4096 px en el lado más largo","RoboNeo_Web_unlimited_pass_expired":"El Pase ilimitado ha expirado. Ahora estás utilizando los usos gratuitos disponibles.","RoboNeo_Web_studio_ai_image_successful":"UHD de IA: completado","RoboNeo_Web_studio_ai_image_failed":"UHD de IA: fallido","RoboNeo_Web_studio_cutout_successful":"Recorte exitoso","RoboNeo_Web_studio_cutout_failed":"Recorte fallido","RoboNeo_Web_studio_ai_edit_failed":"Edición con IA - fallida","RoboNeo_Web_studio_ai_edit_successful":"Edición con IA: completada","RoboNeo_Web_AI_generated":"Contenido generado por IA","RoboNeo_Web_loading":"Cargando","RoboNeo_Web_view_creative_process":"Ver proceso creativo","RoboNeo_Web_try_now":"Probar ahora","RoboNeo_web_extender_successful":"Ampliador con IA: completado","RoboNeo_web_extender_failed":"Ampliador con IA: fallido","RoboNeo_web_eliminate_successful":"Eliminación con IA: completada","RoboNeo_web_eliminate_failed":"Eliminación con IA: fallida","roboneo_web_continue":"Continuar","roboneo_web_video":"Video","roboneo_web_HTML":"HTML","roboneo_web_shared_error_message":"Este chat no se puede compartir, intenta iniciar uno nuevo.","roboneo_web_open_the_APP_experience":"Probar en la aplicación","roboneo_web_AI_generated_logo":"Este contenido generado por IA es solo de referencia.","roboneo_web_change_word_success":"Reemplazar texto: completado","roboneo_web_change_word_fail":"Reemplazar texto: fallido","roboneo_web_canvas_loading_failed":"Error al cargar el lienzo","roboneo_web_export_failed":"Error en la exportación","roboneo_web_export_tips2":"Solo admite exportar una imagen (hasta {width} px*{height} px).","roboneo_web_new_topic":"Nuevo chat","roboneo_web_waiting_reply":"Esperando respuesta","roboneo_web_file_saving_preferences":"Preferencia de archivo","roboneo_web_includes_AI_watermark":"Incluir marcas de agua con IA","roboneo_web_no_remind":"No mostrar de nuevo","roboneo_web_agree_continue":"Aceptar y continuar","roboneo_web_watermark_protocol":"Puedes elegir guardar las imágenes con o sin marcas de agua de \\"Generado con IA\\". Elegir guardar sin la marca de agua significa que aceptas: 1. No usar RoboNeoAI para crear, publicar o difundir información falsa. 2. Asegurar el cumplimiento de la ley e indicar claramente que dicho contenido fue generado con IA al usarlo o compartirlo.","roboneo_web_rectangle":"Cuadrado","roboneo_web_circle":"Redondo","roboneo_web_arrow":"Flecha","roboneo_web_image_fusion_success":"Completado","roboneo_web_image_fusion_failure":"Error","roboneo_chat_resources_num_limit_tips":"Puedes agregar hasta {img_num} videos y {video_num} imágenes.","RoboNeo_Web_export_confirm_tip_popup_title":"Opción para exportar con o sin una marca de agua de «Generado por IA».","RoboNeo_Web_export_confirm_tip_popup_btn":"Veo","Tip_UploadImagesFormat_Batch":"Arrastra o haz clic para cargar imágenes JPEG/JPG/PNG de hasta ${0} MB. Se admiten hasta ${1} imágenes.","Text_SelectedModulesCount_Batch":"${0} elementos seleccionados","Tip_DefaultFollowGlobal_Batch":"Si no se modifica, sigue la configuración global por defecto.","Label_ModuleSelection_Batch":"Selección de módulo","Label_SelectRequiredModules_Batch":"Escoge los módulos que necesitas","Title_Dialog_Invite2":"Invita amigos y gana días Pro y créditos","Desc_Dialog_Invite2":"Comparte el enlace con tus amigos o publícalo en redes sociales. Cuando un amigo se registre con tu enlace, ambos recibirán <strong>${0} días de Pro + ${1} créditos</strong>; si tu amigo se suscribe <strong>dentro de ${2} días</strong>, ambos obtendrán hasta <strong>${3}</strong> créditos adicionales.","SubTitle_Rewards1_Invite2":"Días Pro obtenidos","SubTitle_Rewards2_Invite2":"Créditos obtenidos","SubTitle_Rewards3_Invite2":"Amigos invitados","Text_Rule1_Invite2":"Cuando un amigo se registre con tu enlace, ambos recibirán <strong>${0} días de Pro + ${1} créditos</strong>.","Text_Rule2_Invite_zawa":"Si tu amigo <strong>se suscribe dentro de ${0} días</strong>, ambos recibirán créditos extra (<strong>Plus +${1}, Pro +${2}, Max +${3}</strong>). Cada amigo puede obtener este bono una sola vez, según su primer plan activo.","Text_Rule3_Invite2":"Los días Pro de regalo se agregan a tu periodo de suscripción: si ya tienes una suscripción activa, se extenderá tu fecha de vencimiento y siempre recibirás los beneficios del nivel más alto disponibles actualmente.","Text_Rule4_Invite2":"Los créditos se agregan a tu saldo, <strong>son válidos por 30 días</strong> y se pueden usar para la generación rápida con todos los modelos de Agente de IA.","Text_Rule5_Invite2":"Las suscripciones no son reembolsables una vez que se hayan usado los beneficios del plan o se hayan consumido los créditos de bonificación; las recompensas gratuitas no se pueden revertir una vez utilizadas.","Text_Rule6_Invite2":"No se otorgarán recompensas a cuentas existentes, autoinvitaciones, cuentas duplicadas o actividad fraudulenta; ${0} se reserva el derecho de ajustar la promoción y recuperar recompensas de cuentas con actividad irregular.","Title1_Invited_Invite2":"Un amigo te invitó a unirte a ${0}. Obtén ${1} días de Pro + ${2} créditos","Text_DaysBadge_Invite":"${0} día(s)","Title_Reward_Registered":"Prueba Pro gratis por ${0} días","Title_Reward_Invite":"Obtén ${0} días gratis de Pro, más ${1} créditos","Desc_Reward_Invite":"Obtén Pro gratis por ${0} días y herramientas de IA ilimitadas","Button_StartCreate_Invite":"Comienza a editar","Text_InviteMore_Invite":"Invita a tus amigos para obtener más días Pro y créditos","Title_WelcomeOnboarding":"¡Te damos la bienvenida a Zawa!","Title_ContentIntentOnboarding":"¿Cuál es tu objetivo principal al crear contenido?","Text_ReferralCreditsOnboarding":"Te registraste por recomendación, así que agregaremos automáticamente <>${0} créditos</> a tu cuenta.","Option_ProductVideoOnboarding":"Videos para mi producto","Option_SocialPostOnboarding":"Publicaciones en redes sociales","Option_LogoBrandOnboarding":"Crea logotipos y marcas","Button_MaybeLaterOnboarding":"Más tarde","Title_FirstVideoOnboarding":"Crea tu primer video gratis","Desc_FirstVideoOnboarding":"Comienza con una foto de producto o imagen de referencia y genera un video listo para publicar en Instagram.","Title_FirstSocialPostOnboarding":"Crea gratis tu primera publicación para redes sociales","Desc_FirstSocialPostOnboarding":"Sube una foto o describe lo que necesitas para obtener un conjunto de publicaciones para redes sociales con acabado profesional y listas para publicar.","Title_FirstLogoBrandOnboarding":"Crea tu primer logotipo o marca gratis","Desc_FirstLogoBrandOnboarding":"Describe tu marca y obtén rápidamente un logo profesional y un concepto visual.","Text_TryFreeProOnboarding":"<>Prueba Zawa Pro gratis por 3 días</>, sin tarjeta bancaria ni pago requerido.","Text_FreeVideoOnboarding":"<>Obtén 1 generación de video gratis</>. No se requiere tarjeta bancaria ni pago.","Text_FreeImagesOnboarding":"<>Obtén 4 generaciones de imágenes gratis</>, no requiere tarjeta de crédito ni pago.","SubTitle_Invited_Invite_zawa":"Tu amigo te invita a probar Zawa, un Agente de IA dedicado al diseño de marca. Crea fácilmente logotipos, identidad visual, pósters, menús, recursos para redes sociales y videos de marca. Regístrate ahora: tú y tu amigo recibirán una membresía Pro de ${0} días y ${1} créditos. Si te suscribes dentro de ${2} días, también recibirás créditos adicionales: Plus +${3} créditos, Pro +${4} créditos, Max +${5} créditos.","SubTitle_Invited_Invite_dk":"Tu amigo te invitó a probar Designkit, un Agente de IA enfocado en diseño comercial. Crea fácilmente imágenes de productos, páginas de detalles, pósteres promocionales, banners para e-commerce, recursos para redes sociales y videos de productos. Regístrate ahora para obtener ${0} días de membresía Pro y ${1} créditos para ti y tu amigo. Suscríbete dentro de ${2} días para obtener recompensas extra: ${3} créditos extra para Basic y ${4} créditos extra para Pro.","Text_Rule2_Invite_dk":"Cuando un amigo <strong>se suscriba en un plazo de ${0} días</strong>, ambos obtendrán créditos adicionales (<strong>Basic +${1}, Pro +${2}</strong>). Una recompensa por amigo, según el primer plan activo.","Tool_AIVideoGenerator":"Generación de videos con IA","Tool_AIVideoAdMaker":"Creación de anuncios de video de IA","Tool_AIVideoEditor":"Editor de video con IA","Title_AIWatermark":"Marca de agua con IA","Title_FileSavePreference":"Preferencias de guardado de archivos","Label_IncludeAIWatermark":"Incluye marca de agua de IA","Button_ConfirmDownload":"Confirmar descarga","Button_AgreeAndContinue":"Aceptar y continuar","Text_DontRemindAgain":"No me avisen de nuevo","Button_DownloadApp":"Descarga la app","Title_DownloadAppForMoreFeatures":"Descarga la app para acceder a funciones más avanzadas","Tip_Download7DaysFreeTrial":"Descarga para iniciar una prueba gratuita de 7 días","Message_LoginExpiredRelogin":"Error de inicio de sesión. Vuelve a iniciar sesión.","Title_BindPhone":"Vincular número de teléfono","Tip_BindPhoneForCollaboration":"Enlaza tu número telefónico para colaborar con otros en tiempo real.","Tip_OnlyPSDSupported":"Solo se admiten archivos PSD","Button_OpenPSD":"Abrir PSD","Desc_AIDisclaimer":"Antes de usar este servicio, debes entender que el contenido generado por IA se basa en el aprendizaje profundo de la inteligencia artificial a partir de grandes conjuntos de datos, y que cierta información puede contener fallas, ser poco razonable o causar incomodidad. Por lo tanto, Meitu no ofrece garantías sobre la precisión, integridad o funcionalidad del contenido generado por algoritmos, y no asume ninguna responsabilidad legal, incluida la relacionada con la infracción de derechos de terceros. Además, dado que el servicio de diseño con IA genera contenido relacionado con base en el texto que ingresas, eres responsable de tomar decisiones razonables respecto a la información que ingresas y al contenido generado. Debes asegurarte de usar este servicio y las obras generadas por IA que produce de conformidad con la ley, de no infringir los derechos de autor, marcas comerciales u otros derechos legales de terceros, y de no usar las obras generadas para ningún fin ilegal. Si tu uso indebido causa daños a los derechos o intereses de cualquier tercero, asumirás la responsabilidad legal correspondiente de conformidad con la ley.","Text_Disclaimer":"Descargo de responsabilidad","Message_ConnectFailed":"Error de conexión: ${0}","Placeholder_SelectFont":"Seleccionar fuente","Message_MaxImageUploadSize":"Solo admite imágenes de hasta ${0} x ${1}","Title_StorageFull":"Tu almacenamiento está lleno","Title_StorageFullPleaseClean":"El almacenamiento está lleno. Libera espacio.","Desc_StorageFull":"El almacenamiento de ${0} está lleno. Elimina algo de contenido ${1}; de lo contrario, podrían perderse los registros de edición anteriores.","Desc_StorageFullAigc":"Tu almacenamiento de ${0} está lleno. Este contenido generado se <strong>guardará temporalmente durante 7 días</strong>. Elimina algo de contenido ${1}, o tu historial de creación podría desaparecer.","Text_Free":"Gratis","Text_OrUpgradeMember":"O actualiza tu membresía","Text_UnlockMoreStorage":"Desbloquear más espacio de almacenamiento","Text_FilesSavedForever":"Los archivos se pueden guardar indefinidamente.","Button_UpgradeMember":"Actualizar","Button_CleanSpace":"Limpiar","Title_FileExpiringSoon":"Tu archivo está a punto de expirar","Desc_FileExpireAutoClean":"Los archivos se borrarán automáticamente cuando caduquen. Administra tus creaciones a tiempo.","Button_OrganizeFiles":"Organizar archivos","Title_RemainingDownloads":"Descargas restantes","Text_PriorityConsumeExpiring":"Usar primero las descargas por vencer","Text_PermanentValid":"Sin vencimiento","Text_Sheet":"imagen(es)","Text_ExpireInDays":"Expira en ${0} días","Text_ConsumeTiming":"Descargas:","Tip_CutoutConsumeRule1":"Cuando descargues imágenes recortadas en el editor de recorte, se descontará el número correspondiente de descargas.","Tip_CutoutConsumeRule2":"2. Las descargas repetidas de imágenes que no se hayan reprocesado ni recortado no se descontarán de tu conteo de descargas.","Text_InviteSuccessReward":"Te invitaron con éxito. Únete a Meitu Posters para reclamar tu recompensa.","Desc_DesignKitIntro":"Meitu Designer, la herramienta esencial de diseño con IA para vendedores de comercio electrónico. Desde colecciones de imágenes de productos y de modelos hasta generación de videos con opción de compra, diseño de pósters y edición de fotos, ayuda a los usuarios a crear un conjunto completo de recursos para comercio electrónico en un solo lugar con IA.","Title_TeamMeidouShared":"Los créditos de equipo están disponibles para todos los miembros","Desc_PersonalMeidouTransfer":"Para transferir créditos personales a un equipo, contacta a servicio al cliente.","Button_SwitchTeamRecharge":"Cambia de equipo y recarga","Button_CreateTeamRecharge":"Crear un equipo y recargar","Title_SubscribeSuccess":"Suscripción exitosa","Text_MeidouRechargedTo":"Los créditos se agregaron a","Button_GoToTeam":"Ir al equipo","Text_OnePayMultiShare":"Recarga una vez y comparte entre varias cuentas","Text_InviteMembersShareMeidou":"Invitar a miembros para compartir créditos","Menu_SwitchPersonalTeam":"Cambiar entre personal/equipo","Menu_TeamManagement":"Administración del equipo","Menu_InviteFriendsEarnCash":"Invita a tus amigos y gana dinero","Text_Personal":"Personal","Text_PersonalDesigner":"Diseñador individual","Text_EnterpriseSwitch":"Cambiar a Enterprise","Button_Recharge":"Completar","Text_Detail":"Detalles","Tip_DesignKitIndependentPlan":"Meitu Design Studio tiene sus propios planes de suscripción y no comparte beneficios con la membresía de WPS.","Text_MeidouWpsOnly":"Créditos (Solo WPS)","Text_SheetCount":"Cantidad de recortes","Desc_ExchangeConfirm":"¿Seguro que quieres canjear ${0} créditos de recorte por ${1} días de membresía?","Message_LoadOrderFailed":"No se pudieron cargar los datos de la orden","Message_ExchangeSuccess":"Canjeado con éxito","Message_ExchangeFailed":"Error al canjear","Text_NoOrderRecords":"No se encontraron registros de pedidos","Text_OrderDate":"Fecha de la orden:","Text_VipExchangeRule1":"El recorte es ilimitado durante tu suscripción y no usará créditos.","Text_VipExchangeRule2":"2. Los créditos de pago para Recorte se pueden canjear por una suscripción.","Text_VipExchangeLocation":"· Ubicación de canje: Toca la foto de perfil -> Cantidad de fotos.","Text_VipExchangeNoExchange":"·Si decides no canjearlo, puedes seguir usando tu membresía. El periodo de validez se mantendrá sin cambios.","Text_VipExchangeGiftSheets":"·Los créditos de bonificación de tu membresía no pueden usarse para obtener una membresía y se pueden usar antes de que expiren.","Text_VipExchangeRule3":"3. La membresía ya no incluye créditos gratuitos","Text_BackToPrevious":"Anterior","Title_WpsPay":"WPS Pay","Text_CloseModal":"Cerrar","Text_FavoriteDesignKit":"Agregar Meitu Design Studio a favoritos","Button_Visit":"Acceso","Desc_VisitChinaSite_Cutout":"¿Quieres visitar el sitio de Meitu Cutout en China? Haz clic en Visitar para ir al sitio de China.","Desc_VisitChinaSite":"¿Quieres visitar el sitio de Meitu DesignRoom China? Haz clic en [Visit] para continuar.","Desc_VisitingGlobalSite_Cutout":"Estás visitando Designkit Cutout (sitio global de Meitu Cutout). Si estás en China, visita el sitio de China.","Desc_VisitingGlobalSite":"Estás visitando Designkit, el sitio global de Meitu Design Studio. Usuarios en China, visiten el sitio de China.","Button_StayCurrent":"Quedarme aquí","Button_BackToChinaSite":"Volver al sitio de China","Title_DownloadWork":"Descargar","Label_WorkType":"Tipo","Button_Downloading":"Descargando...","Tip_UploadImageForBetterResult":"Después de subir una imagen, ingresa instrucciones de edición claras para obtener mejores resultados.","Label_SceneElement":"Elementos de escena","Placeholder_SceneElementDesc":"Edita elementos o sujetos de la imagen con una indicación de texto. Por ejemplo: Reemplaza el XX de la imagen con el XX que subí.","Label_MainTitle":"Título principal","Label_SubTitle":"Subtítulo","Label_Copywriting":"Redacción","Tip_ModifyBeforeGenerate":"Edita la imagen y el texto antes de generar","Button_ReEdit":"Volver a editar","Message_MaxUploadImages":"Puedes subir hasta ${0} imágenes","Text_CompletedPercent":"(${0}% completado)","Text_PreviewImage":"Vista previa","Text_EnterCanvasEdit":"Editar en Lienzo","Title_GenerateSame":"Crear","Text_ConfirmLeaveGenerating":"Generando. ¿Seguro que quieres salir?","Text_BuildingVisualScheme":"Creando diseño visual...","Text_OptimizingLayout":"Optimizando el diseño y la jerarquía de la información...","Text_FineTuningFont":"Ajustando la fuente y el espacio...","Message_GenerateSuccessCost":"¡Generación exitosa! Se usaron ${0} créditos","Title_ConfirmDelete":"Confirmar borrado","Text_DeleteFontWarning":"Después de eliminarla, todos los miembros del equipo ya no podrán usar esta fuente.","Text_AppliedWillReplace":"El registro de creación/estilo de fuente aplicado se reemplazará automáticamente por","Text_DefaultReplaceFontName":"Alibaba-PuHuiTi-R","Text_Deleting":"Eliminando...","Message_DeleteSuccess":"¡Eliminado exitosamente!","Text_NoMore":"No hay más contenido...","Text_NoFonts":"Aún no hay fuentes","Button_UploadFont":"Subir fuente","Message_FontFormatInvalid":"El archivo de fuente ${0} tiene un formato no válido","Title_AuthConfirm":"Confirmación de autorización","Text_FontAuthConfirm":"Para las fuentes que agregues por tu cuenta, asegúrate de contar con la autorización necesaria del titular de los derechos de autor y/o de los titulares de derechos conexos.","Text_DuplicateFontsConfirm":"Las siguientes fuentes podrían ser idénticas. Confirma.","Text_Uploaded":"Foto cargada","Button_ConfirmUpload":"Confirmar subida","Text_FontsCannotUpload":"No se pudieron subir las siguientes fuentes","Button_ReUpload":"Subir de nuevo","Message_MaxFontUpload":"Puedes subir hasta 20 archivos de fuente a la vez","Message_UploadSuccess":"Cargado","Text_FontUploading":"Cargando fuentes...","Tip_FontUsageRight":"Recordatorio: Asegúrate de tener derecho a usar la fuente y una licencia comercial.","Title_FriendlyTip":"Recordatorio","Text_TemplateMigrated":"Las plantillas de la Biblioteca de plantillas se movieron a Proyectos. Ve a Proyectos para ver las plantillas del equipo.","Button_GoNow":"Entrar ahora","Tab_FontLib":"Biblioteca de fuentes","Tip_SwitchIdentityHint":"Toca tu foto de perfil en la esquina superior derecha para cambiar entre los perfiles Personal y Equipo.","Text_IdentityResourcesIndependent":"Los recursos de diseño (como el historial de edición) se mantienen separados por identidad","Text_IdentitySwitched":"Cuenta cambiada","Text_DefaultTeamName":"Equipo de ${0}","Message_FillTeamInfo":"Completa toda la información del equipo","Message_TeamNameMaxLength":"Escribe un nombre de equipo o empresa (hasta 20 caracteres)","Title_CreateTeam":"Crear equipo","Label_TeamName":"Nombre del equipo","Placeholder_TeamName":"Escribe un nombre para el equipo","Button_FreeCreate":"Crea gratis","Tip_TeamNameEditable":"Puedes cambiar el nombre del equipo en cualquier momento","Text_EnjoySvipRights":"Disfruta de las ventajas SVIP","Text_TeamPermissionMgmt":"Gestión de permisos del equipo","Text_MemberFolderCollab":"Colaboración en carpetas de miembros","Text_TeamExpired":"Este equipo ha expirado","Text_RenewToUse":"Renueva o actualiza para seguir usándolo.","Text_VipTeamRights":"Ventajas del equipo VIP","Text_ViewDetailRights":"Ver detalles de los beneficios","Button_SwitchPersonal":"Cambiar a Personal","Text_Frozen":"Tu cuenta ha sido congelada.","Text_MemberOverLimit":"Límite de miembros excedido","Text_ContactOwner":"Contacta al propietario del equipo para seguir usando esto.","Text_TeamNoSupport":"Esta función aún no está disponible para cuentas de equipo o empresariales.","Text_SwitchToPersonalHint":"Cambia a Personal si es necesario","Button_SwitchToPersonal":"Cambiar a Personal","Text_FeatureNotAvailable":"Esta función no está disponible actualmente.","Text_ReloginPersonal":"Vuelve a iniciar sesión con una cuenta personal para usar esta función.","Button_BackHome":"Inicio","Text_PersonalEdition":"Personal","Text_TeamEdition":"Equipo","Text_EnterpriseEdition":"Plan empresarial","Text_FreeEdition":"Gratis","Text_RemovedFromTeam":"Has sido eliminado del equipo","Text_RejoinTeamHint":"Volver a unirte al equipo","Text_ContactOwnerToInvite":"Contacta al propietario o administrador para que envíe una invitación","Button_SwitchOtherIdentity":"Cambiar a otra cuenta","Button_FreeCreateTeam":"Crear un equipo gratis","Text_SelectIdentity":"Seleccionar rol de la cuenta","Text_SelectTeamIdentity":"Selecciona un rol de equipo","Text_EditingSaveLocation":"Si hay una edición en curso, tus registros de edición/generación se guardarán en el espacio de ${0}.","Text_CreateNewTeamFree":"Crea un equipo nuevo gratis","Text_MemberCount":"${0} clientes","Text_SavedToHelloDigitalAsset":"Guardado en HelloRF Digital Assets","Text_Admin":"Administrador","Text_Member":"Miembro","Title_FreeMemberLimit":"El plan gratuito admite hasta ${0} miembros","Title_SeatInsufficient":"No hay suficientes puestos de membresía","Button_UpgradeTeam":"Actualizar a Team","Button_AddSeat":"Añadir puestos","Text_UpgradeForMoreSeats":"Actualiza a la membresía de equipo para aumentar el límite de puestos","Text_AddSeatToInvite":"Agrega más puestos para invitar a más miembros.","Title_InviteMember":"Invitar","Text_InviteSeatRemaining_Free":"Puedes invitar a ${0} miembros más a unirse al equipo sin costo","Text_InviteSeatRemaining":"Puedes invitar a ${0} miembros más a unirse al equipo","Text_ShareDesignAssets":"Comparte proyectos de diseño y elementos en equipo","Text_ShareVipAndCredits":"Comparte tu membresía y créditos de generación con IA","Text_InvitedUserPermission":"Permisos del usuario invitado:","Text_NoInvitePermission":"Solo los propietarios o administradores del equipo pueden invitar a otras personas. Aún no tienes permiso para invitar personas al equipo.","Text_RemainingCount":"Restante: <span>${0}</span>","Button_RedeemMemberDays":"Canjea una suscripción de <span>${0}</span> días","Desc_InviteReward_DesignKit":"Únete a Meitu DesignKit ahora y obtén un total de <strong>80 créditos</strong> para generar y editar imágenes. También recibirás un descuento en la suscripción, con <strong>hasta ¥22 de descuento.</strong>","Text_ClickTopRight":"Haz clic en la <span class=\\"primary\\">esquina superior derecha</span> del sitio web","Option_SetEditable":"Establecer como editable","Option_SetViewable":"Establecer como visible","Option_Reject":"Rechazar","Message_BindSuccessPermissionAdjusted":"Vinculado con éxito. Permisos actualizados","Message_ModifyFailedBindPhone":"Error de actualización. Vincula un número de teléfono y vuelve a intentarlo.","Text_AskersApplyAccess":"Acceso solicitado por ${0} y ${1} personas más","Text_PersonalUser":"Usuarios personales","Text_ApplyAccess":"Solicitar acceso","Option_Viewable":"Ver","Option_Editable":"Editar","Option_Manageable":"Manejable","Text_Invited":"Invitado","Text_NoSearchResult":"Sin resultados","Title_AddCollaborator":"Añadir colaborador","Placeholder_AddCollaboratorByName":"Ingresa el nombre de un miembro para agregar colaboradores","Title_Recommend":"Recomendado","Text_PeopleCount":"${0} clientes","Message_BindSuccessCollaboratorAdded":"Vinculado con éxito. Colaborador agregado","Message_AddFailedChangePermissionOrBindPhone":"No se pudo agregar. Cambia el permiso a \\"Puede ver\\" o enlaza tu número telefónico y vuelve a intentarlo.","Message_SelectAtLeastOneCollaborator":"¡Selecciona al menos un colaborador!","Message_ShareSuccess":"Compartido exitosamente!","Tip_AddCollaboratorDirectAccess":"Una vez agregados, podrán acceder directamente desde \\"Compartido conmigo\\" sin un enlace.","Text_TotalPeople":"${0} Personas","Option_Remove":"Eliminar","Tip_PermissionChangedToEdit":"El permiso actual de este colaborador cambió a Editar","Tip_AnyoneWithLinkCanEdit":"Porque cualquier persona con el enlace puede editar","Tip_TeamMemberWithLinkCanEdit":"Porque los miembros del equipo con el enlace pueden editar.","Title_CollaboratorManage":"Administración de colaboradores","Tag_OutsideTeam":"Fuera del equipo","Title_RemoveKeepTeamMembers":"Una vez que se elimine, solo los colaboradores que estén actualmente en el equipo podrán seguir accediendo.","Title_RemoveOnlySelfAccess":"Una vez eliminado, solo tú podrás acceder a él.","Option_OnlyCollaborators":"Solo para colaboradores","Option_OnlySelf":"Solo yo","Text_OthersNeedApply":"(Otros deben solicitar acceso)","Option_PermissionUnchanged":"Permisos sin cambios","Option_TeamMembers":"Miembros del equipo","Text_TeamMembersViaLink":"Miembros del equipo por enlace","Option_Anyone":"Cualquiera","Text_AnyoneViaLink":"Cualquier persona con el enlace","Text_UntitledDesign":"Diseño sin nombre","Message_BindSuccessLinkCopied":"Vinculado con éxito. Enlace para compartir copiado","Message_ShareFailedChangePermissionOrBindPhone":"No se pudo compartir. Cambia el permiso a \\"Puede ver\\" o vincula un número telefónico para compartir.","Text_LinkUpdating":"Actualizando enlace...","Tip_FolderShareTeamOnly":"Las carpetas solo se pueden compartir con miembros del equipo.","Text_CollaboratorCount":"Colaboradores: ${0}","Button_Manage":"Administrar","Tooltip_PartialPermissionChanged":"Cambiaron los permisos de algunos colaboradores","Tip_FolderLinkVisitorBecomeMember":"Los usuarios que accedan a la carpeta mediante el enlace se convertirán automáticamente en miembros de tu equipo.","Tip_OnlyTeamMembersCanAccess":"Actualmente, solo los miembros del equipo pueden acceder a esto","Tip_InviteUserNotInTeam":"Si el usuario con el que quieres compartir aún no se ha unido al equipo, por favor","Button_InviteMember":"Invitar","Text_ShareLinkView":"${0}#Compartí ${1}. Toca para ver","Text_ShareLinkJoin":"${0} te invita a unirte a ${1}. Toca para unirte.","Text_ShareLinkApplyVisit":"${0}#Solicito acceso a ${1}. Toca para procesar la solicitud.","Text_ShareLinkApplyEdit":"${0}#Solicité editar [${1}]. Toca para procesar la solicitud.","Option_7Days":"7 días","Option_30Days":"30 días","Option_Permanent":"Permanente","Text_Slogan_DesignKit":"Una herramienta imprescindible para profesionales del comercio electrónico","Button_RemoveNonTeamCollaborator":"Eliminar colaboradores externos","Button_RemoveNonPersonalCollaborator":"Eliminar colaboradores no individuales","Text_freePlan_Zawa":"Free","Text_standardPlan_Zawa":"Plus","Text_proPlan_Zawa":"PRO","Text_maxPlan_Zawa":"Máx.","Tool_IDPhoto":"Foto de identificación","Tool_PortraitPhoto":"Fotos de perfil","Tool_ImageBatchProcess":"Procesamiento de imágenes por lotes","Tool_AiShoes":"Modelo de calzado","Tool_AiCopywriting":"Redacción con IA","Tool_AiPoster":"Póster IA","Tool_OnlineDesign":"Diseño en línea","Tool_ClothesDewrinkle":"Eliminar arrugas de la ropa","Tool_PortraitBackground":"Fondo","Tool_ViralVideo":"Generador de videos de producto","Tool_AiPosterNote":"Notas de imagen y texto con IA","Title_WholeProductClone_DomesticCloneCase":"Reutilizar conjunto completo de productos","Title_ApparelClone_DomesticCloneCase":"Reutiliza outfits fácilmente","Title_PosterCoverClone_DomesticCloneCase":"Reutilizar portada del póster","Prompt_PosterThemeChange_DomesticCloneCase":"Instrucciones para recrear: Cambiar a un póster con temática de ciudad","Title_SocialGraphicsClone_DomesticCloneCase":"Reutilización de publicaciones en redes sociales con un toque","Prompt_SocialThemeChange_DomesticCloneCase":"Instrucciones para recrear: Cambiar a una publicación de imagen y texto sobre viajes a Xiamen","Title_CloneType_LeftPanelClone":"Tipo de reutilización","Text_CloneReferenceUploadLimitTip_Clone":"Agrega hasta ${0} imágenes: cada referencia genera 1 resultado.","Option_MatchStyle_Clone":"Igualar estilo","Option_MatchReference_Clone":"Igualar referencia","Message_ClaimFailed":"Este beneficio no se puede solicitar en este momento. Por favor, inténtalo de nuevo más tarde.","Message_RedeemFailed":"No se pudo canjear. Inténtalo de nuevo más tarde.","Button_UpgradeTeamVip":"Actualizar a membresía de equipo","Message_SystemError":"Algo salió mal. Inténtalo de nuevo más tarde.","Label_AgentTeam":"Equipos","Desc_AgentTeamBanner":"Entra al modo Equipos de agentes de IA, donde los expertos se agrupan automáticamente para encargarse de toda la planificación y el diseño visual con una sola instrucción.","Text_SearchResultCount":"Resultados de búsqueda · ${0} resultados","Button_ExitAdmin":"Salir de Gestión","Text_InviteReward":"Beneficios por invitación","Button_More":"Más","Text_TeamExpiredTip":"Este equipo ha caducado. Solo puedes ver y mover elementos dentro del equipo. Renueva o actualiza tu plan para seguir usando todas las funciones.","Text_TeamFrozenTip":"Este equipo superó el límite de miembros. Tu cuenta ha sido suspendida. Contacta al propietario del equipo para seguir usándola.","Desc_ImageEdit":"Importa una imagen y empieza a editar","Desc_ViralVideo":"Genera varios tipos de videos virales de forma masiva con un solo clic","Desc_ProductImageSet":"Genera un conjunto completo de imágenes de producto para e-commerce con un solo clic","Title_RecommendTools":"Herramientas recomendadas","Button_CloseVideoPreview":"Desactivar vista previa de video","Label_PromptDesc":"Descripción del prompt","Tab_Preview":"Efectos","Tab_Report":"Reporte de análisis","Button_Preview":"Vista previa","Button_PrevPage":"Anterior","Button_NextPage":"Siguiente","Text_LoadingHard":"Cargando...","Button_ReplicateOne":"Recrear con IA","Text_EmptyContent":"No se encontraron elementos","Text_Today":"Hoy","Text_Tomorrow":"Mañana","Text_Yesterday":"Ayer","Text_DaysLater":"${0} día(s) después","Text_DaysAgo":"Hace ${0} días","Desc_CreateDesign":"Empezar con un lienzo en blanco","Title_ClaimSuccess":"Reclamado","Text_VipExpiry":"Vigencia VIP:","Title_ClaimFailed":"Error al solicitar","Button_GoDesign":"Diseñar ahora","Title_ClientDownload":"Descargar cliente","Desc_DesignKitApp":"Sincroniza tu historial de creaciones entre tu teléfono y computadora para diseñar con eficiencia cuando y donde quieras.","Title_MeituXiuxiuPC":"Meitu para PC","Desc_MeituXiuxiuPC1":"Un editor de fotos para la vida diaria y el trabajo","Desc_MeituXiuxiuPC2":"¡Y herramientas de diseño fáciles de usar!","Button_DownloadNow":"Descargar ahora","Text_Pending":"En espera de pago","Text_MoreFunctions":"Múltiples formatos","Text_NoMessages":"No se encontraron mensajes","Tab_SystemMessage":"Mensajes del sistema","Tab_Notification":"Notificación","Button_MarkAllRead":"Marcar todo como leído","Label_Folder":"Carpeta","Label_Record":"Registros de edición","Label_Template":"Plantillas","Text_RequestAccess":"Solicitar acceso","Text_EditViewDownload":"(Editar, Ver, Descargar)","Text_ViewDownloadOnly":"(Solo para ver y descargar)","Text_TeamRenewSuccess":"Tu membresía de equipo se renovó con éxito.","Text_TeamRenewExpiredTip":"Renueva ahora para desbloquear acceso ilimitado a plantillas comerciales empresariales, elementos y funciones exclusivas para todo el equipo.","Label_SystemNotice":"Notificación del sistema","Label_PromptTutorial":"Tutorial de prompts","Label_BrandSpec":"Directrices de marca","Label_ContactBusiness":"Contactar al equipo de ventas","Text_ScanConsultant":"Escanea para contactar a un asesor especializado para equipos","Tab_Project":"Proyecto","Placeholder_SearchProject":"Ingresa el nombre de un proyecto o palabras clave","Placeholder_SearchRecipe":"Ingresa el nombre de la plantilla o modelo","Placeholder_SearchTemplate":"Ingresa palabras clave de la plantilla o el nombre de la función","Title_HotTools":"Herramientas populares","Title_HotTemplates":"Plantillas populares","Title_PosterTemplate":"Plantillas de diseño gráfico","Text_NotFoundTemplate":"¿No encuentras una plantilla que te guste? Haz clic aquí","Button_Feedback":"Comentarios","Button_ViewAllTemplates":"Ver todas las plantillas","Tooltip_OpenNewTab":"Abrir en nueva pestaña","Button_BookDemo":"Programar una demostración","Title_ApplyTeamDemo":"Solicitar una demostración para equipos","Desc_ContactWithinOneDay":"Después de enviar tu información, nos pondremos en contacto contigo en un plazo de 1 día hábil.","Title_LeaveContactInfo":"Ingresa tus datos de contacto para que podamos brindarte mejor soporte 1 a 1.","Title_FreeTeamVipSurvey":"Completa los datos de tu equipo para obtener una membresía de equipo gratis por 7 días","Label_SingleUser":"Uso individual","Text_MemberCountRange":"${0}~${1} clientes","Text_MemberCountRangeDash":"${0}-${1} Personas","Text_MemberCountOrMore":"${0}+ personas","Label_TemplateReuse":"Sube y reutiliza plantillas","Label_MultiCollaboration":"Edición colaborativa","Label_EnterpriseLicense":"Licencias comerciales empresariales","Label_SharedCredits":"Créditos y recortes compartidos por el equipo","Label_BrandManagement":"Gestión de especificaciones de marca","Label_YourName":"Tu nombre","Message_PleaseEnterName":"Indica tu nombre","Label_YourPhone":"Tu número de teléfono celular","Message_PleaseEnterPhone":"Ingresa tu número celular o fijo","Message_PleaseEnterValidPhone":"Ingresa un número de celular válido.","Label_CompanyName":"Nombre de la empresa","Message_PleaseEnterCompanyName":"Inserta el nombre de tu empresa","Placeholder_EnterCompanyName":"Inserta el nombre de tu empresa","Label_ProductUsers":"Número de personas que usan el producto","Message_PleaseSelectProductUsers":"Selecciona el número de personas que usarán el producto","Label_TeamCapabilitiesInterest":"¿Qué funciones de Pósters para equipos te interesa más conocer?","Text_MultiSelectParen":"(Varias opciones)","Message_PleaseSelectCapabilities":"Selecciona las funciones de Meitu Design Studio sobre las que quieres saber más","Placeholder_TeamCapabilities":"Protección comercial de derechos de autor, Beneficios compartidos para varios usuarios, Gestión de activos digitales, Colaboración en equipo, Otros","Button_Submit":"Enviar","Desc_ManagerWillContact":"Tu gerente de cuenta asignado se pondrá en contacto contigo en un plazo de 1 a 2 días hábiles. Asegúrate de estar disponible por teléfono.","Title_ScanToInvoice":"Escanea el código QR con el navegador de tu celular para obtener una factura","Text_InvoiceOrderScope":"Usa este enlace para solicitar una factura de tus pedidos de Meitu Design Studio.","Text_TransferInvoiceContact":"Para pedidos de transferencia bancaria corporativa, haz clic en Contact en la esquina inferior derecha para solicitar la emisión.","Desc_MenuProjectGuide1":"[Mi espacio] y [Compartido conmigo]","Desc_MenuProjectGuide2":"Ahora todo está organizado en Proyectos","Text_SetPrefix":"Establecer como","Text_TodayWithTime":"Hoy ${0}","Text_YesterdayWithTime":"Ayer ${0}","Format_MonthDay":"M D","Format_YearMonthDay":"D/M/AAAA","Text_MultiPage":"Varias páginas","Text_PageCount":"${0} páginas","Text_ViewOnly":"Solo lectura","Text_NoPermission":"Sin acceso","Button_JumpToStorage":"Omitir a la ubicación de almacenamiento","Label_PageUnit":"Página","Label_JumpTo":"Inténtalo ahora","Text_TotalDataCount":"${0} elementos","Title_RelateRecommend":"Recomendado","Title_HotSearch":"Búsquedas populares","Title_LatestMaterial":"Elementos más recientes","Title_TopicList":"Temas tendencia","Title_ArticleList":"Artículos populares","Title_ToolList":"Herramientas populares","Text_AccountOnePerson":"Cuenta: 1 persona","Text_AccountTenMin":"Cuentas: mínimo 10 usuarios","Text_LetsTalk":"Chateemos","Text_NewUserExperience":"Experiencia para nuevos usuarios","Text_Buy12Months":"Comprar 12 meses","Text_LinkExpired":"Este enlace no está disponible.","Text_ContactAdminToJoin":"Contacta al administrador para unirte","Desc_JoinOrgCollaboration":"Únete a la organización y empieza a colaborar eficientemente con tu equipo","Button_AcceptInvite":"Aceptar invitación","Title_ConfirmNickname":"Confirma tu alias para el equipo","Placeholder_NameWithin20":"Escribe un nombre de hasta 20 caracteres","Desc_NicknameHelp":"Tu alias ayuda a tus colegas a encontrarte más fácilmente.","Title_TeamVipExpired":"La membresía del equipo expiró","Title_TeamSeatsInsufficient":"No hay suficientes cupos de Membresía de equipo","Button_SeatAssignment":"Asignación de asiento","Text_MemberSeatCount":"Miembros/Puestos:","Text_FreeSeatsFrozen":"Se han suspendido los miembros que superan el límite de puestos gratuitos","Desc_RenewTeamForAll":"Para mantener el acceso de todos los miembros, renueva tu suscripción de equipo.","Text_SeatsExceededFrozen":"Los miembros que exceden el límite de puestos se suspendieron.","Desc_AddSeatsForAll":"Para habilitar el acceso para todos, compra licencias adicionales de Membresía de equipo.","Title_TeamToolUnsupported":"Esta herramienta no está disponible en Posters Team Edition.","Desc_SwitchPersonalToUse":"Para usar esta herramienta, cambia a la versión Personal.","Label_RegularTemplate":"Plantillas estándar","Label_Suite":"Configurar","Label_Filter":"Filtrar","Label_Sort":"Ordenar","Label_Scene":"Escenario","Label_Materials":"Materiales","Label_Purpose":"Usar","Label_Industry":"Industria","Label_Color":"Color","Label_Format":"Diseño","Label_Category":"Categoría","DesignKit":"美图设计室","Placeholder_SearchTemplateMobile":"Buscar plantillas","Label_DesignType":"Tipo de diseño","Label_TemplatePurpose":"Propósito de la plantilla","Label_TemplateStyle":"Estilo de plantilla","Label_TemplateColor":"Colores de plantilla","Label_ApplicableIndustry":"Industrias aplicables","Label_TemplateSize":"Tamaño de plantilla","Label_UsageThreshold":"Los principiantes pueden usar","Label_TemplateNumber":"Número de plantilla","Desc_ScrollViewAllPages":"Desplázate hacia arriba o abajo para ver todas las páginas","Title_SimilarPosterRecommend":"Recomendaciones de pósters similares","Button_EditCurrentTemplate":"Editar plantilla actual","Button_EditAllTemplates":"Editar todas las plantillas","Button_EditNow":"Editar ahora","Title_RecordUpgrade":"¡Nuevas actualizaciones disponibles!","Desc_RecordUpgrade1":"Incluye todas las plantillas de pósteres y los registros de edición de fotos de esta cuenta. Cambia sin problemas de editar fotos a diseñar pósteres.","Desc_RecordUpgrade2":"Pasa sin esfuerzo de editar imágenes a diseñar pósteres.","Footer_AboutUs":"Sobre nosotros","Footer_JoinUs":"Únete a nosotros","Footer_ContributeCenter":"Centro de Colaboradores","Title_HomeAgentTeam":"Equipos de agentes de IA - Diseño para empresas que se ve increíble y genera resultados","Title_HomeChat":"Dime qué te gustaría crear.","Nav_Home":"Página de inicio","Title_BrandManagement":"Gestión de marca","Nav_HelpDesign":"Diseñar por mí","Title_OrgInfo":"Información de la organización","Title_MemberManage":"Administración de miembros","Title_DataDashboard":"Panel de datos","Title_CommercialAuth":"Uso comercial sin preocupaciones","Title_OrderInvoice":"Factura de la orden","Title_TeamCollaboration":"Colaboración en equipo","Title_CopyrightGallery":"Galería de fotos con derechos de autor","Title_DownloadCenter":"Centro de descargas","Nav_TodayRecommend":"Recomendado hoy","Nav_HotCalendar":"Fiestas","Nav_InspirationFormula":"Plantillas de inspiración","Nav_OneClickSame":"Derivados","Title_PosterTemplateNav":"Plantillas de póster","Message_NetworkError":"Error de red. No se puede conectar al servidor.","Text_Downloading":"Descargando recursos","Text_DownloadResourceFailed":"Error al descargar recursos","Title_DesignKitScanLogin":"美图设计室 Escanea para iniciar sesión","Desc_ScanGuideLogin":"Ve a Yo y toca \\"Escanear\\" en la parte superior derecha para iniciar sesión","Message_AlreadyFullVip":"Ya tienes todos los beneficios de la membresía. No necesitas comprar.","Message_ImageSizeExceeded":"Se ha excedido el límite de tamaño de la imagen.","Text_NotLoggedIn":"No conectado","Button_CreateBrandSpec":"Crear especificaciones","Title_BrandAdvQuestion":"¿Sigues pidiéndole a tu equipo el logo, las fuentes y los valores de color de la marca?","Desc_BrandAdv1":"Logotipo de ajuste predeterminado, valores de color de marca, estilo de texto, biblioteca de fuentes","Desc_BrandAdv2":"Configura los lineamientos visuales para distintas marcas o proyectos.","Desc_BrandAdv3":"Los miembros del equipo de distintos departamentos pueden agregar y aplicar especificaciones rápidamente en el editor","Button_UpgradeTeamForBrand":"Actualiza a la membresía de equipo para usar las guías de marca ahora","Title_ConfirmDeleteBrandGroup":"¿Eliminar este conjunto de estándares?","Text_DeleteBrandNoAffect":"Los registros de edición aplicados no se verán afectados.","Button_CreateBrandStandard":"Crear especificaciones de marca","Title_DeleteHint":"Borrar imagen","Text_DeleteIrreversible":"Una vez borrado, no se puede recuperar. Procede con precaución.","Label_General":"General","Label_ColorCard":"Carta de colores","Label_TextStyle":"Estilo de texto","Message_SavePrevStyle":"Guardar estilo anterior","Message_SavePrevColorCard":"Guardar la carta de colores anterior","Message_SavePrevElement":"Guarda primero el elemento anterior.","Button_NewColorCard":"Crear sombra","Button_NewStyle":"Crear estilo","Message_NameWithinN":"Escribe un nombre (hasta ${0} caracteres)","Message_ColorBlockLimit":"Cada paleta de colores admite hasta ${0} muestras de color","Message_PleaseSelectFont":"Selecciona una fuente","Message_PleaseSelectFontSize":"Selecciona un tamaño de fuente","Placeholder_FontSize":"Tamaño de fuente","Label_Bold":"Negrita","Label_Italic":"Cursiva","Text_FontSizeUnit":"N.º ${0}","Text_Claiming":"Obteniendo...","Button_ClaimFreeBenefit":"Obtén beneficios gratis","Message_MissingExchangeCode":"Falta el código de canje","Message_SwitchToPersonalFirst":"Cambia a Personal primero","Desc_ClaimBenefitSuccess":"Ya canjeaste este beneficio. ¡Ve a Meitu Posters y empieza a crear!","Message_ClaimNewUserOnly":"Este beneficio gratuito solo está disponible para usuarios nuevos que se registran por primera vez.","Text_AiDesignTagline":"Diseño con IA al alcance de tu mano","Text_FreeBenefitLimited":"Obtén beneficios gratis por tiempo limitado","Text_ExchangeSceneFeatures":"Pósters comerciales · Imagen principal de e-commerce · Eliminación con IA · Recorte con IA","Text_LimitedNewUserOnly":"Oferta por tiempo limitado, solo para usuarios nuevos","Text_SearchWithKeyword":"Buscar \\"${0}\\"","Text_HelpEmptyHint":"Aún no hay contenido. Xiaomei agregará más pronto.","Placeholder_HelpSearch":"¿Qué te gustaría saber?","Button_Search":"Buscar","Message_SelectImageForTranslation":"Selecciona una imagen antes de usar Traducción de imágenes.","Text_InviteCopyPrefix":"# Deja de perder tiempo con imágenes para e-commerce. Regístrate en Meitu Designer y recibe créditos gratis al instante. Sets de producto, páginas de detalle, videos promocionales y más, todo generado con un clic. Haz clic en el enlace para empezar a crear.","Label_DistributionAgreement":"Acuerdo del servicio de distribución de Meitu Design Studio","Label_DistributionConduct":"Código de conducta sobre comisiones del servicio de afiliados de Meitu Design Studio","Alt_InviteFriendIcon":"Ícono de Invitar amigos","Alt_BothGetBeanIcon":"Ícono de Obtener créditos para ambos","Text_BothGetBean":"Ambos obtienen créditos","Alt_FriendFirstOrderIcon":"Ícono de primera orden completada de amigo","Text_FriendFirstOrder":"Un amigo completa su primera orden","Alt_RedPacketIcon":"Icono de paquete rojo recibido","Text_RedPacketArrived":"Paquete rojo recibido","Desc_InviteRule1":"1. Cuando un amigo que invites se registre con éxito, ambos recibirán 40 créditos. Úsalos para generar imágenes o editar fotos. Válido por un mes.","Desc_InviteRule2":"2. Puedes invitar hasta 15 amigos.","Desc_InviteRule3":"3. Gana cashback cuando un amigo se suscriba. Cálculo de la recompensa: Monto de la recompensa = monto real pagado × tasa de recompensa (por ejemplo, si un amigo compra una suscripción anual con renovación automática, puedes obtener una recompensa en efectivo de 196 × 15% = 29.4 USD). Las recompensas pueden ajustarse durante eventos especiales o promociones; prevalecerá el monto real acreditado.","Desc_InviteRule4":"4. Si se han usado créditos del plan o créditos de bonificación, la compra no se puede cancelar, reembolsar ni cambiar.","Desc_InviteRule5":"5. Los usuarios que ya tengan una cuenta registrada, se recomienden a sí mismos, creen cuentas duplicadas o participen en actividades fraudulentas no podrán recibir recompensas.","Desc_InviteRule6":"6. Meitu Design Studio se reserva el derecho de ajustar la campaña y revocar las recompensas de cuentas anómalas.","Message_SwitchToPersonal":"Cambiar a Personal","Message_GetInviteLinkFailed":"No se pudo obtener el enlace de invitación.","Message_InviteLinkRetry":"No se pudo obtener el enlace de invitación. Inténtalo de nuevo más tarde.","Message_CopySuccess":"¡Copiado!","Message_CopyFailedManual":"Error de copia. Copia el enlace manualmente.","Text_LoginForInviteLink":"Inicia sesión primero para obtener el enlace de invitación","Text_SwitchPersonalForInviteLink":"Cambia a tu perfil personal para obtener el enlace de invitación","Alt_InviteRewardTitle":"Invita amigos para obtener créditos y suscríbete para recibir cashback","Alt_InviteHeroVisual":"Imagen principal de reembolso por invitar amigos","Button_CopyInviteLink":"Copia el enlace de invitación.","Alt_ActivityRules":"Reglas de la actividad","Desc_InviteRewardSummary":"Invita a tus amigos a registrarse: tú y tu amigo recibirán 40 créditos cada uno. Puedes ganar hasta 600 créditos. Tu amigo también obtiene un descuento por tiempo limitado en una suscripción de 7 días. Si tu amigo se suscribe a la membresía de Meitu Design Studio durante la promoción, recibirás un reembolso.","Text_CommissionRate15":"¡Comisión de hasta 15%!","Text_DetailRules":"Reglas de detalles","Alt_CashoutTutorial":"Guía de rescisión","Desc_InviteDetailAppPath":"Ve a la app Meitu Design Studio > Yo > Invita y gana > Cartera de ganancias para ver los detalles de tu invitación.","Desc_InviteDetailAppPathShort":"Ve a la app Meitu Design Studio > Yo > Invita y gana > Monedero de ganancias para ver los detalles de la invitación.","Desc_InviteSettlementCycle":"Ciclo de liquidación: Los pedidos de suscripción se liquidan un mes después de la fecha del pedido. Este periodo de un mes es el periodo de enfriamiento para reembolsos. Los pedidos reembolsados no se pueden retirar durante este periodo. Después del periodo de enfriamiento, se puede retirar la participación en los ingresos de los pedidos correspondientes.","Button_LoginToGet":"Inicia sesión para obtener","Button_ClaimNow":"Reclamar ahora","Title_SameStyleReplicate":"Recrea este look 🌟","Text_PageNotFound":"Página no encontrada","Label_PricingPlan":"Precios","Title_ChooseMembershipPlan":"Elige el plan de membresía ideal para ti","Tab_RenewalYear":"Renovación anual","Tab_RenewalMonth":"Suscripción mensual continua","Tab_SingleYear":"Compra anual","Tab_SingleMonth":"Compra de 1 mes","Text_MeidouPerMonth":"${0} créditos al mes","Title_PersonalVipOnly":"Esta suscripción solo está disponible para cuentas personales. ¿Cambiar a Personal?","Button_Switch":"Cambiar","Text_ComingSoon":"Próximamente","Button_SubscribeNow":"Suscríbete ahora","Text_MostPopular":"Con más likes","Text_Trial7DaysPerYear":"Prueba 7 días (${0}/año)","Label_Year":"año","Text_StartingFrom":"Empezar","Label_DesignRecord":"Diseño","Label_AgentRecord":"Registro de agente","Button_ViewMore":"Ver más","Placeholder_PleaseEnterContent":"Ingresa el contenido","Text_InviteLinkExpired":"Este enlace no está disponible.","Text_RegenerateInviteLink":"Contacta a tu administrador para regenerar el enlace de invitación.","Text_JoinedSuccess":"Te uniste correctamente","Text_UseTeamOnPc":"Visita ${0} en tu computadora para crear con tu equipo","Button_CopyUrl":"Copiar URL","Text_InviteYouToJoin":"\\"${0}\\" te invita a unirte","Button_JoinNow":"Únete ahora","Title_TemplateCenter":"Centro de plantillas","Text_NoSuchTemplate":"Aún no hay plantillas de este tipo. Agregaremos más pronto.","Title_DesignKitHome":"Página de inicio de Pósters","Label_Tags":"Etiqueta","Button_DownloadAppToEdit":"Descarga la app Diseño X para editar","Title_DesignKitTeam":"Diseño X ${0}","Desc_TeamLandingQuestion":"Los diseños dependen por completo de los diseñadores. ¿Cómo mejorar la eficiencia de diseño del equipo?","Button_UseNow":"Usar ahora","Text_ViewTeamIntro":"Ver resumen completo del equipo","Button_ViewPricing":"Ver precios","Button_EnterTeamNow":"Entrar ahora","Title_EnterpriseSolution":"Más información sobre soluciones empresariales","Desc_EnterpriseContactForm":"Completa el formulario y el equipo de Meitu Posters te contactará en un plazo de 1 a 3 días hábiles.","Message_CompanyNameMaxLength":"El nombre de la empresa debe tener 100 caracteres o menos.","Label_Position":"Cargo","Message_PleaseEnterPosition":"Inserta tu puesto actual en esta empresa","Placeholder_EnterPhone":"Ingresar número telefónico","Placeholder_EnterPosition":"Inserta tu puesto actual en esta empresa","Label_ExpectedUsers":"Usuarios estimados","Title_TeamMaterialEasier":"Crea activos de equipo más fácilmente","Label_CommercialTemplate":"Elige cualquier plantilla comercial","Desc_CommercialTemplate":"Las empresas autorizadas pueden editar y publicar una amplia variedad de plantillas y elementos para uso comercial sin preocupaciones.","Label_BatchDesignSpeed":"Acelera el diseño por lotes","Desc_BatchDesignSpeed":"El recorte por lotes, las plantillas y la producción automatizada de imágenes te ahorran muchísimo tiempo.","Label_VisualStandard":"Especificaciones visuales unificadas","Desc_VisualStandardWork":"Predefine paletas de colores, estilos de fuente y otros lineamientos para garantizar un estilo de diseño de marca consistente.","Desc_VisualStandardHome":"Predefine paletas de colores, estilos de texto y otros lineamientos (con soporte para subir fuentes) para mantener diseños consistentes.","Title_TeamCollabEfficient":"Diseño colaborativo más eficiente","Label_TeamSharedResource":"Recursos compartidos del equipo","Desc_TeamSharedResource":"Comparte carpetas por departamento o proyecto con un clic y crea rápidamente una biblioteca de recursos de diseño.","Label_FlexiblePermission":"Configuración flexible de permisos","Desc_FlexiblePermission":"Establece permisos de forma flexible para cada archivo y evita que se filtren los recursos de diseño.","Label_TemplateQuickReuse":"Reutiliza plantillas rápidamente","Desc_TemplateQuickReuse":"Sube archivos PSD a la biblioteca de plantillas para que todo tu equipo pueda reutilizarlos rápidamente. No más esperas por archivos.","Title_TeamManageEasier":"Administra miembros y activos con facilidad","Label_TeamDataReview":"Revisión de datos del equipo","Desc_TeamDataReview":"Revisa periódicamente la actividad de creación de los miembros en el panel de administración y ajusta los puestos del equipo según sea necesario.","Label_MemberRoleManage":"Administración de roles de miembros","Desc_MemberRoleManage":"Configura administradores del equipo, administra cambios de miembros y gestiona transferencias de activos.","Tag_ConvenientCreate":"Creación fácil","Desc_FreeEditionAudience":"Disponible para particulares y equipos","Desc_FreeTemplateMaterial":"Plantillas/Elementos gratuitos","Desc_PartialFreeTools":"Herramientas inteligentes (algunas gratis)","Button_FreeExperience":"Prueba gratuita","Tag_QualityContent":"Contenido de alta calidad","Desc_PersonalEditionAudience":"Para comerciantes individuales, diseñadores o creadores independientes","Desc_IncludesFreeBenefits":"Incluye beneficios del plan gratuito","Desc_PaidTemplateMaterial":"Plantillas/Elementos Premium","Desc_PersonalCommercialAuth":"Licencia comercial personal","Desc_Meidou330PerMonth":"330 créditos/mes (Para herramientas de generación con IA)","Tag_EfficientCollab":"Colaboración efectiva","Desc_TeamEditionAudience":"Para pequeñas empresas o equipos freelance que necesitan colaboración en equipo","Desc_IncludesProBenefits":"Incluye beneficios Pro (excepto Foto de identificación)","Desc_EnterpriseAuthOne":"Licencia comercial*1","Desc_BrandSpecBrief":"Guía de marca (Logotipo/Carta de colores/Fuentes)","Desc_PsdTemplateUpload":"Subir plantilla PSD","Desc_TeamDataAnalysis":"Análisis de datos del equipo","Desc_TeamResourceShare":"Compartir recursos creativos del equipo","Desc_SharedPermissionManage":"Gestión de permisos compartidos","Desc_SeatsMeidouPerMonth":"Asientos * 330 créditos/mes (para funciones de generación de IA)","Title_MarketingCostControl":"Costos de marketing más fáciles de controlar para tu empresa","Label_AiPhotoCostDown":"Reduce costos con fotografía de producto con IA","Desc_AiPhotoCostDown":"AI Product Image y AI Model Try-On te ayudan a crear fotos pulidas sin esfuerzo, sin necesidad de montar un estudio ni contratar modelos, asegurando que tus resultados nunca parezcan \\"limitados por el presupuesto\\".","Label_AiEditEfficiency":"Retoque de IA","Desc_AiEditEfficiency":"Realiza ajustes de fotos, corrección de color y retoque de productos con un solo clic para mantener el ritmo de los lanzamientos de productos y reducir los costos de retoque manual.","Label_SmartVideoCreate":"Creación de videos con IA","Desc_SmartVideoCreate":"Imagen a video y Video comercial 3D reducen la barrera de creación, para que las promociones en video ya no se vean limitadas por ciclos de edición largos y altos costos de modelado.","Text_TeamAuthSubLabel":"(La membresía de equipo incluye una licencia comercial empresarial)","Title_MoreOptions":"Más opciones","Title_FreeImageCreate":"Crea imágenes gratis","Desc_FreeTemplateSlashMaterial":"Plantillas/Elementos gratuitos","Desc_PartialFreeSmartTools":"Algunas herramientas de IA gratis","Title_IncludesPersonalPlus":"Incluye todos los beneficios de Personal, además de:","Desc_EnterpriseBizAuthOne":"Licencia comercial para empresas (1 entidad)","Desc_TeamAssetShare":"Compartir recursos del equipo","Desc_BrandSpecFull":"Guía de marca (Logo/Carta de colores/Estilo del Texto)","Desc_MemberAccountHandover":"Gestión de cuentas de miembros y entrega de activos durante la baja","Desc_TeamUsageAnalytics":"Análisis de datos de uso del equipo","Desc_MonthlyMeidouShared":"Obtén ${0} créditos al mes, compartidos entre varias cuentas","Title_IncludesTeamPlus":"Incluye todos los beneficios del equipo, más:","Desc_EnterpriseBizAuthThree":"Licencias comerciales empresariales (3 entidades)","Desc_CustomBrandNav":"Barra de navegación de marca empresarial personalizada","Desc_SsoAccess":"Integración de SSO","Desc_MonthlyMeidou20000":"20,000+ créditos gratuitos al mes, compartidos entre varias cuentas","Title_OpenClawApi":"Integración de API de OpenClaw","Desc_OpenClawApi":"Accede a las capacidades de procesamiento de imágenes con IA de X-Design y administra tu token de API y saldo de créditos.","Title_OpenClawApiShort":"API de OpenClaw","Desc_OpenClawMobile":"Administra tu token de API y saldo de créditos","Title_QuickStart":"Inicio rápido","Desc_OpenClawQuickStart":"Después de completar el despliegue de OpenClaw, envía el siguiente comando a Lobster para instalar automáticamente todos los paquetes de habilidades:","Button_CopyInstallConfig":"Copiar configuración de instalación","Text_SeeTutorial":"Ver tutorial detallado","Text_DesignkitSkillsDoc":"Documentación de designkit-skills","Title_VersionChangelog":"Actualizar a la nueva versión","Text_NoChangelog":"Sin historial de actualizaciones","Message_InstallCmdCopied":"Instrucciones de instalación y Token copiado","Title_ApiToken":"Token de API (AK)","Desc_ApiToken":"Usa el token para autenticar solicitudes de API. Haz clic en \\"Reemplazar\\" para generar un token nuevo (el token anterior dejará de ser válido de inmediato).","Button_CopyToken":"Copiar token","Button_Reset":"Más","Button_ResetToken":"Más token","Text_PleaseLoginFirst":"Inicia sesión primero.","Text_PleaseLoginDash":"Inicia sesión primero","Title_ResetToken":"Cambiar token","Desc_ResetTokenWarning":"Una vez reemplazado, el token anterior dejará de ser válido de inmediato y cualquier llamada a la API en curso podría fallar. ¿Continuar?","Message_TokenReset":"Restablecer token","Message_TokenCopied":"Token copiado","Desc_OpenClawMeidou":"Los créditos son la unidad de facturación para las llamadas a la API de OpenClaw. Si el saldo es insuficiente, la solicitud de la API fallará.","Label_CurrentBalance":"Saldo actual","Button_BuyMeidou":"Comprar créditos","Button_ConsumptionRecords":"Historial de gastos","Title_OpenClawFeatures":"Introducción a la función OpenClaw","Desc_OpenClawFeatures":"Las funciones de IA de X-Design ya están disponibles a través de OpenClaw. Después de la autenticación de AK, puedes usar directamente las siguientes funciones; se cobran en créditos y tienen reembolso automático en caso de error.","Desc_OpenClawProductImageSet":"Sube imágenes de productos y la IA generará automáticamente un conjunto de imágenes de producto que cumplen con los estándares de múltiples plataformas de comercio electrónico y generan altas tasas de conversión, satisfaciendo todas las necesidades de imágenes para la publicación de productos.","Desc_OpenClawSmartCutout":"Con tecnología de IA de Meitu, detecta con precisión el sujeto y elimina automáticamente el fondo; funciona con retratos, productos y más situaciones.","Desc_OpenClawEnhanceClarity":"La reparación de calidad de imagen con IA restaura imágenes borrosas o de baja calidad a calidad HD con detalles mejorados.","Button_ConfirmReset":"Confirmar","Message_MeidouQuotaMinZero":"Ingresa una cantidad de créditos de 0 o más","Message_MeidouQuotaRange":"Ingresa una cantidad de créditos de 0 a ${0}","Message_AssignSuccess":"¡Asignado con éxito!","Message_SelectAssignableMember":"Selecciona miembros para asignar cuotas de créditos","Message_NameLength1To20":"Escribe un nombre de 1 a 20 caracteres","Placeholder_EnterQuota":"Ingresa créditos","Text_Unlimited":"Ilimitado","Text_Unassigned":"Sin asignar","Label_MemberName":"Nombre del miembro","Text_Me":"Yo","Text_Deactivated":"Cerrar sesión","Text_OverQuotaFrozen":"Congelado por exceder el límite","Label_PhoneNumber":"Número de móvil","Label_Role":"Rol","Text_Owner":"Propietario","Label_QuotaLimit":"Límite de crédito disponible","Message_SelectMemberCount":"Selecciona ${0} miembros","Text_SelectedMemberCount":"${0} seleccionados","Text_RemainingSeats":"Asientos restantes:","Button_ConfirmAssign":"Confirmar asignación","Button_BatchSetQuota":"Límite de ajustes por lotes","Title_ChangeRole":"Cambiar personaje","Button_RemoveMember":"Eliminar miembro","Text_PartialMemberFrozenTip":"Algunos miembros están sobrecongelados. Inténtalo de nuevo.","Text_Or":"O","Button_RenewMembership":"Renovar","Label_RemainingMeidou":"Créditos restantes","Desc_MemberQuotaTip":"Consejo: Los créditos configurados para los miembros son el límite de uso. La disponibilidad real depende de los créditos restantes del equipo.","Text_MemberEmpty":"No hay miembros","Message_DataLoadFailed":"No se pudieron cargar los datos","Title_BatchAssignMeidou":"Distribuye los créditos equitativamente entre los ${0} miembros seleccionados","Label_AssignCount":"Clientes asignados","Label_TotalConsumption":"Consumo total","Title_ConfirmTransferAssets":"¿Transferir activos?","Message_TransferAssetsSuccess":"Los recursos se transfirieron correctamente del miembro saliente. Ve a revisarlos.","Label_MySpace":"Mi espacio","Message_RemoveMemberProgress":"Miembro eliminado exitosamente. Ve a consultar el progreso de la transferencia de activos.","Message_RemoveMemberSuccess":"Miembro eliminado con éxito","Title_RemoveMember":"Eliminar miembro","Text_RemovingStep1":"Eliminando...","Text_AssetHandleStep2":"2. Activos creados por este miembro","Option_TransferToUser":"Transferir a otro usuario","Text_TransferableAssets":"Activos transferibles","Text_DeletedAssets":"Recursos eliminados","Desc_RemovedAssetFolder":"Carpetas/registros de edición creados (incluidos los recursos no compartidos)","Desc_RemovedAssetTemplate":"Plantillas/elementos subidos (incluidos los recursos no compartidos)","Desc_RemovedAssetAiRecord":"Historial/Favoritos de conjuntos de IA","Text_SelectAssetReceiver":"3. Selecciona el miembro que recibirá el recurso","Desc_RejoinAssetRecovery":"Si este miembro vuelve a unirse dentro de 30 días, los recursos anteriores volverán a aparecer en su espacio personal.","Desc_RejoinAssetExpire":"Después de 30 días, se eliminará permanentemente y no se podrá recuperar.","Button_ConfirmRemove":"Eliminar","Text_Last7Days":"Últimos 7 días","Text_Last30Days":"Últimos 30 días","Text_Last90Days":"Últimos 90 días","Text_MemberActiveCount":"Miembros activos","Text_NewAssetCount":"Nuevos activos","Title_TeamOverview":"Resumen del equipo","Title_ActiveMembers":"Miembros activos","Desc_ActiveMembers":"Número de miembros que iniciaron sesión dentro del intervalo de tiempo especificado","Label_PersonUnit":"Personas","Label_TotalCount":"Total","Title_AiToolGeneration":"Generaciones con herramientas de IA","Desc_AiToolGeneration":"Total de generaciones realizadas por todos los miembros con las herramientas de IA de la plataforma dentro del periodo especificado","Label_TimesUnit":"Veces","Label_Accumulative":"Total","Title_TotalAssetDownload":"Descargas totales de recursos","Desc_TotalAssetDownload":"Total de descargas de todos los miembros en la plataforma durante el periodo especificado","Label_CopyUnit":"Informes","Nav_MySpace":"Mi espacio","Nav_ShareWithMe":"Contenido compartido","Nav_SpaceManage":"Gestión de almacenamiento","Nav_AssetHandover":"Retirar activos","Label_Text":"Texto","Label_Group":"Combinación","Label_Table":"Hoja","Label_Chart":"Gráfico","Label_AiProductShoot":"Fotografía comercial con IA","Label_AiProductDesign":"Diseño de producto IA","Label_SameStyleReplicate":"Recrear","Button_CreateFolder":"Crear carpeta","Button_NewFolder":"Nueva carpeta","Button_UploadFile":"Subir","Button_UploadFolder":"Subir carpeta","Button_UploadTemplate":"Subir plantilla","Menu_Rename":"Cambiar el nombre","Button_UseTemplate":"Usar","Button_CopyToTeam":"Copiar al equipo","Text_MoveToMySpace":"Trasladar a Mi espacio","Button_ExportContent":"Exportar","Button_Deselect":"Borrar selección","Text_SelectAllWithCount":"Seleccionar todo (${0} seleccionados)","Message_PartialFileCannot":"Algunos de los archivos que seleccionaste no se pueden ${0}","Text_NoSearchResultYet":"No se han encontrado resultados","Text_SearchNoMatch":"No se han encontrado resultados","Text_EmptyGoCreate":"Aún no hay contenido. ¡Crea algo ahora!","Text_EmptyGoAction":"Aún no hay contenido. Ve a ${0}.","Text_ActionCreate":"Crear","Desc_OrganizeWorks":"Organiza proyectos personales o de equipo de forma eficiente","Message_EnterName":"Inserta un nombre de ${0}","Message_EnterNameWithin20":"Escribe un nombre ${0} de hasta 20 caracteres","Message_OperationSuccess":"¡Operación realizada con éxito!","Message_EnterFolderName":"¡Ingresa un nombre de carpeta!","Message_EnterFolderNameWithin20":"Ingresa un nombre de carpeta de hasta 20 caracteres","Text_CopyTo":"Copiar a","Text_CopyingMayTakeMinutes":"Copiando... Esto puede tardar unos minutos.","Button_GoTeamView":"Ver en el equipo","Message_BrowserNoUploadFolder":"Este navegador no admite la carga de carpetas.","Title_MoveAfterMySpace":"Después de moverlo, estará en Mi espacio","Desc_MixSortAfterMove":"Mezclado con otros activos por fecha de actualización","Message_HandoverFailed":"Falló la transferencia","Message_CreateSuccessExclaim":"¡Creado!","Message_NoFilePermission":"No tienes permiso para realizar esta acción en este archivo.","Title_ConfirmDeleteRecord":"¿Borrar los siguientes registros?","Title_ConfirmUnfavorite":"Si lo quitas de Favoritos, se perderá el registro de este resultado de diseño. ¿Seguro?","Title_ConfirmDeleteGenerate":"Si lo borras, se perderán los resultados generados. ¿Seguro que quieres borrarlo?","Text_To":"A","Text_FileOperating":"En el archivo ${0}...","Message_OperateSuccess":"Se fijó ${0}","Text_CurrentDir":"Directorio actual","Text_OperateDir":"Menú de acciones","Text_Creating":"Creando","Text_NoContent":"Sin contenido","Title_CancelUploadConfirm":"Las cargas siguen en curso. ¿Cancelar todas las cargas en curso?","Button_CancelUpload":"Salir","Message_MaxUploadFiles":"Puedes subir hasta 500 archivos a la vez.","Message_PersonalUploadLimit":"Las cuentas personales permiten subir hasta 20 archivos a la vez. Para subir más de 20 archivos, crea un equipo.","Title_PsdToTemplate":"Sube un PSD para convertirlo directamente en una plantilla de equipo","Desc_TemplateEditOnly":"Solo tú puedes editar la plantilla. Los demás miembros solo pueden duplicarla y no pueden cambiar la plantilla original.","Link_WhatIsTemplate":"¿Qué son las plantillas?","Button_ConvertTemplate":"Convertir en plantilla","Button_UploadOnly":"Solo cargar","Text_WaitUpload":"En espera de carga","Text_Transferring":"Transfiriendo...","Text_AllUploadComplete":"Se completaron todas las subidas","Text_FilesUploadFailed":"Error al subir ${0} archivos","Text_UploadingProgress":"Subiendo... (${0}/${1})","Button_StartAll":"Empezar todo","Button_PauseAll":"Pausar todo","Button_CollapseDetail":"Contraer detalles","Button_ExpandDetail":"Expandir detalles","Text_FailDetail":"Detalles del error","Text_SharedFolderToYou":"Compartió una carpeta contigo","Desc_ClickJoinTeam":"Toca para ver y unirte automáticamente a este equipo","Text_SeatInsufficientFolder":"No hay suficientes puestos. No puedes unirte al equipo para acceder a esta carpeta.","Title_FolderTeamShareOnly":"Las carpetas solo se pueden compartir dentro de un equipo","Button_SwitchTeamCopyFolder":"Cambiar de equipo y copiar carpeta","Button_CreateTeamCopyFolder":"Crear equipo y copiar carpeta","Message_FolderCopiedToTeam":"Se creó correctamente. La carpeta se copió a tu equipo.","Text_UsedSpace":"Usado:","Text_StorageSpace":"Espacio de almacenamiento:","Text_UsedSpaceLabel":"Espacio usado","Text_UnlockSpace":"Desbloquea ${0} de almacenamiento adicional","Button_UpgradeToMember":"Actualiza a membresía","Button_UpgradePremium":"Actualizar a Premium","Desc_SpaceFullUpgrade":"El almacenamiento está lleno. Actualiza para obtener más almacenamiento.","Desc_SpaceFullContactAdmin":"El almacenamiento está lleno. Contacta al administrador.","Desc_SpaceFullClean":"El almacenamiento está lleno. Libera espacio ahora.","Desc_SpaceLowUpgrade":"Queda menos del 10 % de almacenamiento. Mejora tu plan para obtener más almacenamiento.","Desc_SpaceLowContactAdmin":"Queda menos del 10% de espacio de almacenamiento. Contacta a tu administrador.","Desc_SpaceLowClean":"Queda menos del 10 % de espacio de almacenamiento. Libera espacio lo antes posible.","Desc_VipExpiredRenew":"Tus beneficios de membresía han expirado. Renueva ahora.","Desc_VipSoonExpireRenew":"Tu membresía está por vencer. Recuerda renovarla.","Desc_SpaceNormal":"Este espacio está disponible. Puedes seguir guardando tus creaciones.","Text_CountUnit":"${0}","Text_SoonExpire":"Vence pronto ${0}","Text_Expired":"Expirado ${0}","Text_FileStatus":"Estado del archivo: ${0}. Organízalo pronto.","Desc_TopBannerFilesExpire":"Algunos de tus archivos están por alcanzar su límite de almacenamiento. Administra tus archivos ahora o mejora tu suscripción para conservarlos de forma permanente.","Desc_TopBannerSpaceLow":"Queda menos del 10% de tu espacio de almacenamiento. Actualiza tu suscripción para obtener más almacenamiento.","Desc_TopBannerSpaceUrgent":"El almacenamiento está casi lleno y algunos proyectos expirarán pronto. Actualiza tu suscripción para obtener más espacio y conserva tus proyectos para siempre.","Desc_TopBannerSpaceLowPremium":"Queda menos del 10% de tu almacenamiento. Actualiza a Premium para obtener más almacenamiento.","Desc_TopBannerVipSoonExpire":"Tu membresía está por vencer. Renueva a tiempo para evitar que tu historial de edición expire y se elimine.","Desc_TopBannerVipExpired":"Tu membresía ha expirado. Renueva ahora para no perder espacio de almacenamiento ni el historial de edición.","Desc_TopBannerSpaceLowClean":"Queda menos del 10 % de tu almacenamiento. Libera espacio ahora.","Desc_TopBannerVipSoonExpireNoPeriod":"Tu membresía está por vencer. Si no renuevas a tiempo, podría eliminarse tu historial de edición. Renueva cuanto antes.","Text_AssetHandovering":"Transfiriendo activos...","Text_TransferringStatus":"Transfiriendo","Text_ResignationTime":"Fecha de renuncia:","Desc_AssetHandoverTip":"Los registros de generación en los activos de miembros que se han ido no se pueden editar. Otros activos no admiten mover ni cargar. Si es necesario, mueve los activos a Mi espacio primero.","Message_SelectFileLimit":"Selecciona hasta ${0} archivos","Text_ExpandVersionComparison":"Comparación de la función Ampliar entre versiones","Text_CollapseVersionComparison":"Contraer comparación de funciones de la versión","Text_VersionComparisonToggle":"Comparación de funciones de la versión ${0}","Text_Consult":"Recomendaciones","Text_PricePerMonthWithSymbol":"¥${0}/mes","Title_RightsComparison":"Comparar beneficios","Text_Trial7Days":"Prueba de 7 días","Text_UsingNow":"En uso","Text_ConsultBusiness":"Contactar a ventas","Title_PriceComparison":"Comparación de precios","Text_StandardMember":"Estándar Premium","Text_EnterpriseMember":"Premium empresarial","Text_BeansPerMonth":"${0} créditos al mes","Text_BeansPerMonthFrom":"Desde ${0} créditos al mes","Text_WanBeansPerMonthFrom":"Desde ${0} mil créditos/mes","Text_SheetsPerMonth":"${0} imágenes/mes","Text_SheetsPerMonthFrom":"Desde ${0} fotos/mes","Text_WanSheetsPerMonthFrom":"Desde ${0} mil imágenes/mes","Desc_FeatureOnlyNote":"${0}<span style=\\"color: #d0d2d6\\">(Solo esta función)</span>","Text_PersonalCommercial":"Uso comercial personal","Text_EnterpriseCommercialEntities":"Entidad de licencia comercial empresarial*${0}","Text_PurchasableSeparately":"Disponible como compra por separado","Desc_MeidouAiQuota":"Créditos (Asignación para generación con IA)","Label_AiAgentImageEdit":"Agente de IA: edición de fotos","Label_AiAgentImageGen":"Agente de IA: Generación de imágenes","Label_AiAgentEcommerce_ImageSet":"Agente IA: Set de imágenes de comercio electrónico","Label_PortraitBgReplace":"Cambiar fondo","Label_AiPartialRedraw":"Modificar con IA","Label_AiImageGen":"Generación con IA","Label_AiFloralText":"Caligrafía con IA","Label_LivePpt":"PPT en vivo","Label_AiSizeExtend":"Expandir Tamaño con IA","Label_BatchTemplate":"Plantillas por lotes","Label_CreateCustomSize":"Crear diseño de tamaño personalizado","Label_EditLocalImage":"Editar imágenes locales","Label_ExportJpgPng":"Exportar diseño/imagen como JPG/PNG","Label_FreeTemplate":"Plantillas gratis","Label_FreeFont":"Fuentes gratis","Label_FreeAsset":"Elementos gratuitos","Label_PaidTemplate":"Plantilla de pago","Label_PaidFont":"Fuentes de pago","Label_PaidAsset":"Contenido Premium","Label_RealtimeMultiEdit":"Edición colaborativa en tiempo real","Label_ShareDesignRecord":"Registros de edición compartida","Label_ShareElements":"Compartir elementos (Imágenes/Texto/Tablas)","Label_ShareTemplate":"Compartir plantilla","Label_ShareFolder":"Compartir carpeta","Label_SharePermission":"Gestión de permisos para compartir","Label_RecordToTemplate":"Convertir historial de edición en plantilla","Label_EnterpriseBrandNav":"Barra de navegación de marca empresarial","Label_Sso":"Inicio de sesión único (SSO)","Label_ModelCustomization":"Personalización del modelo","Label_SceneCustomization":"Personalización de escena","Label_OnlineAiSupport":"Servicio al cliente inteligente en línea","Label_OnlineManualGuide":"Manual en línea","Label_OperationGuide":"Guía del usuario","Label_CustomerImSupport":"Soporte de grupo de mensajería instantánea para clientes","Label_DedicatedCsm":"Servicio dedicado de éxito del cliente","Label_TechPriorityResponse":"Respuesta del servicio técnico prioritario","Label_TrainingSession":"Entrenamiento dedicado","Label_OffboardAssetTransfer":"Entrega de activos por renuncia","Label_MemberPurchaseLimit":"Restricciones de compra para miembros","Label_MemberActivity":"Actividad del miembro","Label_MemberDesignActivity":"Actividad de edición de miembros","Label_MemberAiActivity":"Estado de generación con IA del miembro","Title_ContentDesign":"Diseño de contenido","Title_MultiCollaboration":"Colaboración entre varias personas","Title_VisualManagement":"Gestión visual","Title_OrgManagement":"Gestión de la organización","Title_DataStatistics":"Estadísticas","Title_ExclusiveCustomization":"Personalización exclusiva","Title_ServiceGuarantee":"Garantía de servicio","Title_EnterpriseAuthConfirm":"Confirme la información de la licencia comercial empresarial","Text_ConfirmAuthInfoTip":"Confirma la siguiente información de autorización. No podrás cambiarla después de enviarla.","Label_Name":"Nombre","Label_UnifiedSocialCreditCode":"Identificador unificado de crédito social","Label_IdCardNumber":"N.º de documento de identidad","Label_ContactPhone":"Número de móvil","Title_AuthSuccess":"Autorización exitosa","Text_AuthSubjectFilled":"Entidad de autorización completada con éxito","Button_BackAdmin":"Volver al backend","Button_DownloadAuthBook":"Carta de autorización de descarga","Title_EnterpriseAuthFill":"Inserta la información de licencia comercial empresarial","Label_AuthType":"Tipo de autorización","Text_Enterprise":"Empresarial","Message_EnterCompanyNameWithin30":"Inserta el nombre de tu empresa (hasta 30 caracteres)","Message_PleaseEnterNameShort":"Indica tu nombre","Message_Max30Chars":"Máximo 30 caracteres","Message_EnterCompanyName":"Inserta el nombre de tu empresa","Message_EnterUnifiedSocialCreditCode":"Ingresa el identificador unificado de crédito social","Message_EnterIdCardNumber":"Ingresa el N.º de documento de identidad","Message_InvalidUnifiedSocialCreditCode":"El formato del Identificador Unificado de Crédito Social es incorrecto.","Message_InvalidIdCardNumber":"El formato del N.º de documento de identidad no es válido.","Message_EnterPhoneNumber":"Ingresa tu número de teléfono","Message_InvalidPhoneNumber":"El formato del número telefónico es incorrecto.","Placeholder_PhoneExample":"Ejemplo: 0592-12345678 / 13912345678","Desc_AuthInfoBindTip":"Una vez enviada, la información anterior quedará enlazada y no se podrá cambiar a menos que compres una entidad comercial autorizada adicional.","Desc_AuthInfoRiskTip":"Si no proporcionas la información anterior de forma precisa y completa, es posible que no puedas presentar pruebas válidas en caso de riesgos de derechos de autor y que no recibas protección de uso comercial por parte de la plataforma Meitu Design Studio.","Desc_AuthSingleSubjectTip":"La Licencia de uso comercial sin preocupaciones se otorga a una sola entidad y se limita al uso por parte de la entidad autorizada que la adquirió y vinculó. Está prohibido compartirla o transferirla.","Text_OfflineOrderScanBusiness":"Para pedidos offline, escanea el código para contactar a Ventas y solicitar una carta de autorización","Label_AuthSubjectInfo":"Información de la entidad autorizada","Text_NotFilledYet":"Aún no se ha completado","Text_ServiceValidity":"Plazo del servicio","Text_AuthInactive":"Inactivo","Text_AuthActive":"Activo","Text_AuthExpired":"Expirado","Text_AuthNotStarted":"No iniciado","Text_OfflineOrder":"Órdenes en tienda","Label_RelatedOrder":"Orden relacionada","Button_ContactSupport":"Contacto","Button_Fill":"Ingresar","Title_MemberCommercialAuthBook":"Licencia comercial para miembros","Button_PurchaseAuthSubject":"Añadir entidad autorizada","Desc_PurchaseAuthSubjectScan":"Para comprar entidades autorizadas adicionales, escanea el código QR para contactar a nuestro equipo de ventas","Label_AuthTime":"Periodo de licencia","Label_AuthStatus":"Estado de autorización","Text_OrderCancelled":"Cancelado","Text_OrderPaid":"De paga","Text_OrderRefunded":"Reembolsado","Text_TeamVipProductName":"Membresía del equipo ${0}","Text_CutoutCountProductName":"Recortes restantes: ${0}","Text_MemberMeidouProductName":"Créditos de miembro: ${0}","Message_CancelSuccess":"Cancelado","Message_CancelFailed":"No se pudo cancelar","Title_ConfirmCancel":"Confirmar cancelación","Text_CancelOrderTip":"Después de cancelar tu pedido, puedes hacer un nuevo pedido para comprar el servicio.","Button_IssueInvoice":"Factura","Text_NoOrders":"Aún no hay órdenes","Label_ProductInfo":"Información del producto","Label_Quantity":"Cantidad","Label_OrderTotal":"Total","Label_OrderStatus":"Estado de la orden","Text_OrderNoPrefix":"Número de pedido: ${0}","Text_PayBeforeDeadline":"Completa el pago antes de ${0}. Los pagos fuera de plazo se cancelarán automáticamente.","Button_CancelOrder":"Cancelación de pedidos","Button_PayNow":"Pagar ahora","Title_TransferAmount":"Cantidad a transferir","Desc_TransferAmountMatch":"El monto de la transferencia debe coincidir con el monto de la orden actual.","Desc_TransferUniqueCode":"2. Cada pedido tiene un código de pago único. Este código solo es válido para este pedido. No pagues más de una vez.","Desc_TransferAutoActivate":"3. Tu membresía se activará automáticamente dentro de los 30 minutos posteriores a que la transferencia se realice correctamente. Completa el pago cuanto antes.","Title_ReceiveAccountInfo":"Información de cuenta","Label_AccountName":"Nombre de la cuenta","Label_BankAccount":"Cuenta bancaria","Label_IssueBank":"Nombre del banco","Label_RemittanceCode":"Código de remesa","Text_CopyRemittanceInfo":"Copiar información de remesa","Message_CopiedToClipboard":"Copiar al portapapeles","Text_CopyRemittanceTemplate":"Nombre de la cuenta: ${0}\\nCuenta bancaria: ${1}\\nNombre del banco: ${2}\\n  Código de remesa: ${3}","Label_MemberSeats":"Miembros/Puestos","Label_RemainingSheets":"Créditos restantes","Label_EnterpriseAuthSubject":"Entidad de licenciamiento comercial para empresas","Button_Purchase":"Comprar","Message_EditSuccessExclaim":"¡Cambio realizado con éxito!","Text_InactiveSeats":"Puestos pendientes ${0}","Text_ExpiredDays":"Expirado hace ${0} días","Text_ExpireOn":"Expira el ${0}","Label_OrgId":"ID de la organización","Label_CreatedAt":"Creado el:","Title_ContactInfo":"Información de contacto","Desc_ContactExpectation":"Nos encantaría conectar contigo 🤝 y ayudar a tu equipo a sacarle más provecho a Posters.","Text_ContactFor1v1":"Completa esto para recibir servicio VIP personalizado.","Label_ContactPerson":"Lentes de contacto","Label_ContactMethod":"Información de contacto","Text_MemberActivity":"Actividades de los miembros","Label_LastOnlineTime":"Fecha de lanzamiento más reciente","Label_ActiveDays":"Días activos","Title_GenerationCount":"Generaciones","Label_PosterImageEdit":"Edición de pósteres/imágenes","Alt_Avatar":"Avatar","Label_ProductPortrait":"Producto/Retrato","Label_TryOnFaceSwapRecolor":"Probar/Cambiar cara/Color","Text_MemberActivityExport":"Actividades de los miembros.xls","Title_IncludesFreePlus":"Incluye todos los beneficios gratuitos y además:","Title_IncludesStandardPlus":"Incluye todas las ventajas de la membresía Standard, además de:","Title_IncludesTeamMemberPlus":"Incluye todas las ventajas de la Membresía de equipo, y además:","Text_AccountLimitOne":"Límite de cuenta: 1 usuario","Text_PaidTemplateMaterial":"Plantillas/elementos Premium","Text_FreeTemplateMaterial":"Plantillas/elementos gratis","Desc_SmartToolsBundle":"Recorte inteligente/Eliminación con IA/Mejora y otras herramientas inteligentes","Desc_MeidouMonthlyUsage":"Los créditos mensuales se pueden usar para:","Desc_AgentProductSuite":"Agente de IA: Conjuntos de imágenes de producto, páginas de detalles, videos y más","Desc_AiShootSuite":"Fotografía comercial con IA: Imágenes de producto IA, fondos para retratos, modelos de IA y más","Desc_AiDesignSuite":"Diseño con IA: Logotipo con IA, PPT en vivo, Gráfico con IA y más","Text_TeamSeatsFromPrice":"10 usuarios / Desde ¥15,000","Desc_BulkMeidouOneTime":"Gran bono de créditos por única vez, compartido entre varias cuentas","Label_OneMonth":"1 mes","Label_ThreeMonths":"3 meses","Label_TwelveMonths":"12 meses","Text_EnterpriseCommercialLicensed":"Autorizado para uso comercial empresarial","Button_BuyTeamEdition":"Comprar Equipo","Title_ChooseByCommercialAuth":"Elegir por licencia comercial","Label_LicenseTarget":"Parte autorizada:","Desc_PersonalLicenseTarget":"La entidad comercial es una persona física y el beneficiario también es una persona física.","Label_LicenseScope":"Ámbito de aplicación:","Desc_PersonalLicenseScope":"Uso personal de oficina (PPT, reportes), sitios web personales, uso promocional de tiendas en línea registradas como persona física, redes sociales personales, cuentas oficiales de WeChat, creación personal de videos cortos, etc.","Title_EnterpriseCommercialAuth":"Licencias comerciales para empresas","Desc_EnterpriseLicenseTarget":"Personas morales y organizaciones no constituidas como persona moral, incluidas empresas, negocios de propiedad individual, organizaciones administrativas y grupos sociales.","Desc_EnterpriseLicenseScope":"Gestiona sitios web, cuentas oficiales, miniprogramas, imágenes de productos/páginas de detalles de comercio electrónico, feeds de redes sociales, anuncios en línea y catálogos de productos en línea.","Tip_PersonalLicenseWarning":"Nota: Usar una licencia comercial personal con fines empresariales se considera una infracción.","Alt_ContactServiceQrcode":"Código QR para contactar a soporte","Text_ScanContactManager":"Escanea el código QR para contactar al gerente de cuenta","Button_LearnQuote":"Ver precios detallados","Title_PricingPartners":"Clientes de distintas industrias usan Meitu Design Studio","Title_FaqSectionPricing":"Preguntas frecuentes","Title_FaqCommercialUse":"¿Puedo usarlo con fines comerciales después de suscribirme?","Desc_FaqCommercialUse":"La membresía personal (SVIP) es solo para uso comercial individual. Las membresías de equipo/empresa pueden utilizarse para uso comercial empresarial. Compra el plan de membresía que se ajuste a tu caso de uso comercial.","Title_FaqInvoice":"¿Cómo puedo obtener una factura?","Desc_FaqInvoicePersonal":"Factura de IVA de membresía individual: Abre el sitio web de Meitu Design Studio, inicia sesión en tu cuenta de membresía, haz clic en tu foto de perfil en la esquina superior derecha, haz clic en Renovar membresía, luego haz clic en Quiero una factura en la esquina inferior derecha de la ventana emergente y escanea el código QR con WeChat para obtener una factura.<br/>","Desc_FaqInvoiceTeam":"Factura regular de membresía de equipo: Ve al panel de administración del equipo, selecciona Factura de pedido, elige el pedido a facturar, haz clic en Factura, escanea el código QR y completa la información correspondiente.<br/>","Desc_FaqInvoiceSpecial":"Factura especial de IVA: Contacta al servicio al cliente en línea mediante Consulta en línea.<br/>","Title_FaqDeviceLimit":"¿En cuántos dispositivos se puede usar una cuenta de suscripción?","Desc_FaqDeviceLimit":"MTid es una cuenta personal. Para proteger la seguridad de tu cuenta y la privacidad de tus creaciones, <span style=\\"color: #fff; font-weight: bold;\\">cada cuenta de membresía solo puede iniciar sesión en una computadora a la vez</span> y no admite el inicio de sesión simultáneo en varias computadoras.<br/>Si necesitas iniciar sesión en varios dispositivos al mismo tiempo, te recomendamos adquirir la <span style=\\"color: #fff; font-weight: bold;\\">Membresía de Equipo/Empresa de Meitu Design Studio</span> para activar varios asientos y asignar cuentas para el inicio de sesión.","Title_FaqUpgradeTeam":"¿Cómo actualizo mi membresía individual a una Membresía de equipo?","Desc_FaqUpgradeTeam":"Debido a que las suscripciones de Equipo e Individual tienen precios diferentes, para actualizar a una suscripción de Equipo, primero compra el plan de Equipo y luego contacta al soporte en línea para migrar los créditos de tu cuenta personal y procesar el saldo restante de la suscripción. Puedes copiar los recursos de tu cuenta individual al equipo por ti mismo.","Title_FaqMeidou":"¿Qué son los créditos y cómo los compro?","Desc_FaqMeidou":"Además de las funciones gratuitas y de miembros, Meitu Designer también ofrece funciones de IA que requieren Créditos para usarse, como Imagen de Producto IA, Modelo IA y Flatlay. Una vez que los Créditos incluidos con tu membresía se agoten, puedes comprar más por separado. Accede a la página de compra desde la esquina superior derecha de cualquier función de IA. Enlace: <a target=\\"_blank\\" style=\\"color: #66A8FF\\" href=\\"https://www.designkit.cn/product-shoot-editor/?from=home\\">https://www.designkit.cn/product-shoot-editor/?from=home</a>","Message_PermissionAlreadyRejected":"Solicitud de permiso rechazada","Message_PermissionAlreadyProcessed":"Esta solicitud de permiso se ha procesado","Text_TeamRenewRemainingPrefix":"La membresía de tu equipo solo tiene","Text_UnitDay":"días","Text_SharedItemToYou":"Compartió un/a ${0}【${1}】 contigo.","Label_AccountColon":"Número de cuenta:","Text_PriceYuanPerPersonPerMonth":"¥${0}/persona/mes","Text_OrTry":"O prueba","Title_DesignKitApp":"美图设计室 APP","Title_OpenClawGuide":"Manual de OpenClaw","Label_AllColors":"Todos los colores","Alt_TemplateImage":"Imagen de plantilla","Text_NestedTemplateSuiteCount":"Establecer plantillas para ${0} imágenes","roboneo_agent_queue_tier_fast":"Rápido","roboneo_agent_queue_tier_relax":"Relax","roboneo_agent_queue_tier_change_failed":"Error al cambiar, inténtalo de nuevo.","Label_ImageProcessing":"Procesamiento de imágenes","Tool_ProductRetouching":"Retoque de producto","Message_SelectImageBefore_ImageTranslation":"Selecciona una imagen antes de usar Traducción de imágenes.","Message_SelectImageBefore_Expand":"Selecciona una imagen antes de usar Ampliación del fondo con IA.","Label_AiCreation":"Generación con IA","Tool_AiImageText":"Imagen y texto con IA","Label_DefaultModel":"Modelo por defecto","Desc_AgentMode_Advanced":"Consumo de créditos de IA 3x Genera varios resultados para promoción 3x","Desc_AgentMode_Normal":"Ideal para creaciones simples del día a día y para ahorrar potencia de procesamiento","Desc_AgentMode_FlagshipAi":"·Modo de IA insignia","Desc_AgentMode_MultilingualText":"·Coincidencia precisa de texto multilingüe","Desc_AgentMode_ProductFidelity":"· 95% de precisión en la restauración de productos","Desc_AgentMode_ComplexScene":"·Capacidades de procesamiento para escenarios complejos","Tool_AIVideoAgent":"Agente de video con IA","Tool_UGCVideoMaker":"Creador de videos UGC","Tool_MarketingVideoMaker":"Creador de videos de marketing","Tool_PromoVideoMaker":"Creador de videos promocionales","Tool_ExplainerVideoMaker":"Creador de videos explicativos","Tool_BeforeAfterVideoMaker":"Creador de videos de antes y después","roboneo_agent_queue_tier_upgrade_title":"Acceso ilimitado a Relax","roboneo_agent_queue_tier_upgrade_desc":"Beneficios de la membresía ${0}. Generado en modo Relax, sin créditos necesarios.","roboneo_agent_queue_tier_upgrade_primary":"Actualizar a Pro","roboneo_agent_queue_tier_upgrade_secondary":"Usar modo rápido","Label_PageIndex":"Página ${0}","Title_PPTTask":"Tarea de PPT","Button_ReplicateNow":"Reutilizar ahora","Label_ImageIndex":"Figura ${0}","Button_Cases_ViralVideo":"Ejemplo","Message_ImageReviewFailedRetry_Batch":"No se pudo revisar la imagen. Inténtalo de nuevo más tarde.","Message_ImageReviewRejected_Batch":"Imagen rechazada","Text_PageRange":"Página ${0}~${1}","Text_AllPagesRange":"Todas las páginas (1~${0})","Text_AllPages":"Todas las páginas","Text_SelectedPages":"Página seleccionada (${0})","Text_NoPageSelected":"Ninguna página seleccionada","Title_InsertDocument":"Insertar documento","Title_SelectPages":"Seleccionar página","Button_Insert":"Insertar","Message_ProductInfoReviewRejected_Batch":"Se rechazó el texto del punto destacado. Vuelve a completarlo.","Tool_VideoBackgroundRemover":"Eliminador de fondo de video","Title_StayUpdated_Designkit":"Mantente al día con Designkit","Title_StayUpdated_Zawa":"Mantente al día con Zawa","Desc_WebPushPrompt":"Entérate antes que nadie de nuevas herramientas de IA, actualizaciones de funciones y contenido en tendencia.","Button_NotNow":"Ahora no","Button_TurnOn":"Activar","Placeholder_Enter":"Ingresa ${0}","Placeholder_Select":"Selecciona ${0}","Label_AiMarketingVideo":"Video promocional de producto con IA","Title_ImageProcessing":"Procesar imagen","Title_AiDesign":"Diseño con IA","Label_Ecommerce":"Comercio electrónico","Label_SocialMedia":"Redes sociales","Label_WechatMarketing":"Marketing de WeChat","Label_OfficialAccount":"Cuenta oficial","Label_OfficeEducation":"Administración y oficina/Educación","Label_LifeEntertainment":"Estilo de vida y entretenimiento","Title_DesignScene":"Escenarios de diseño","Label_MarketingSales":"Marketing y ventas","Label_Promotion":"Promoción","Label_Greeting":"Saludos y bendiciones","Label_CommunicationSharing":"Compartir y conectar","Label_LifeScience":"Consejos de estilo de vida","Label_Recruitment":"Contratación","Title_UsagePromotion":"Uso con fines de marketing","Label_FoodBeverage":"Gastronomía y Gourmet","Label_ApparelBags":"Ropa, zapatos y bolsas","Label_EducationTraining":"Educación y capacitación","Label_BeautySkincare":"Belleza y cuidado de la piel","Title_IndustryResource":"Recursos de la industria","Text_FirstDiscountBadge_ViralVideo":"Descuento en el primer video","Title_ManagedBatchTip":"Duerme un poco. Tus imágenes estarán listas cuando despiertes.","Tag_ManagedBatchDiscount":"${0}% de descuento por lotes","Desc_ManagedBatchTip":"Genera imágenes en lote con ${0}% de descuento. Despierta con todo listo.","Title_Resize":"Cambiar tamaño","Title_SocialContentCreation":"Contenido social","Title_BatchResize":"Cambiar tamaño por lotes","Title_ImageRecolor":"Recolorear imagen","Title_BatchRetouch":"Retoque por lotes","OnlineConsultation":"Consulta en línea","PayAmount":"Pagar ¥${0}","PriceBreakdown":"¥${0} × ${1} licencias × ${2} meses","ScanToPay":"Escanea para pagar con ${0}","PaymentAgreementHint":"Al pagar, aceptas","MeidouRechargeAgreement":"Acuerdo de recarga de créditos","DesignStudioServiceAgreement":"Acuerdo del Servicio de suscripción de Meitu Design Studio","CommercialLicenseAgreement":"Licencia comercial","CutoutQuotaNotice":"Aviso de créditos de recorte adicionales","RenewalMemberNote":"Si compraste una membresía con renovación automática:","AutoDeliveryOnPurchase":"Después de la compra, se agregará automáticamente a tu cuenta actual.","NonRenewalMemberNote":"Si compras una suscripción sin renovación:","AutoDeliveryOnTransaction":"Una vez completada la transacción, se agregará automáticamente a tu cuenta actual.","CutoutQuotaLabel":"Créditos de recorte:","CutoutQuotaDesc":"La cantidad de recortes gratuitos se basa en la cantidad adicional indicada en la página de detalles del producto de la membresía que compraste.","CutoutQuotaExpiryLabel":"Vigencia de los créditos de recorte:","CutoutQuotaExpiryDesc":"Sujeto al período de uso indicado en la página del pedido","TrialAddressLabel":"Enlace de experiencia:","ServiceNotice":"Aviso de servicio","AutoRenewNote1":"1. Después de activar este servicio, tu membresía se renovará automáticamente en las 24 horas previas a su vencimiento. Una vez renovada, tu membresía se extenderá por el periodo correspondiente;","AutoRenewNote2":"2. La cuota de renovación se deducirá de tu cuenta de pago vinculada;","AutoRenewNote3":"3. Puedes cancelar la renovación automática en cualquier momento. Una vez cancelada, tu suscripción ya no se renovará automáticamente;","AutoRenewNote4":"4. Cómo cancelar:","AutoRenewNote5":"5. Si tienes alguna otra pregunta, llama a servicio al cliente al 4000093360","Label_WeChat":"WeChat","Label_Alipay":"Alipay","Label_BatchTrialCount":"Usos gratuitos de procesamiento por lotes","Desc_WindowsOnly":"Solo app de escritorio para Windows","Label_MemberFeature":"Funciones VIP","Label_MemberAsset":"Elementos VIP","Label_MemberEffect":"Efectos VIP","Label_NoAds":"Sin anuncios","Label_NoPoster":"Sin Meitu Pictorial","Label_EffectFilter":"Filtros especiales","Label_Enhance":"Mejorar","Label_FaceRemodel":"Remodelar","Label_SkinAdjust":"Piel","Label_HeadAdjust":"Ajuste de cabeza","Label_HeightShape":"Forma del cuerpo","Label_Border":"Cuadro","Label_RechargeMeidou":"Recargar créditos","Text_InsufficientBenefits":"No tienes beneficios suficientes. Contacta a tu asesor asignado: ${0} ${1}","Text_OnlinePurchaseDisabled":"Las compras en línea no son compatibles con esta versión. Si lo necesitas, contacta a tu administrador.","Desc_ProtectMemberExperience":"Para garantizar una buena experiencia con tu membresía,","Desc_BindPhoneFirst":"Vincula primero tu número telefónico principal.","Button_GoToBind":"Vincular ahora","Text_AlreadyActiveMember":"Ya te suscribiste a la membresía el ${0}","Text_ContactServicePrefix":"Si tienes preguntas,","Label_ServicePhone":"Línea de atención al cliente","Text_ServiceTime":"Horario de atención al cliente: 9:00 a. m. - 9:00 p. m.","Text_LargeOrderContact":"Para pedidos grandes o pagos fallidos, escanea el código QR para contactar a ventas y recibir ayuda.","Text_ConsultEnterprise":"Consulta sobre uso comercial para empresas","Message_CreateFail":"No se pudo crear. Inténtalo de nuevo más tarde.","Title_TransferReminder":"Recordatorio de transferencia","Text_ViewOrderProgress":"Puedes dar seguimiento a este pedido más tarde en Panel de administración > Pedidos y facturas.","Title_PendingTransfer":"Pedido con transferencia en curso","Text_HasPendingTransfer":"Tienes un pedido con transferencia bancaria empresarial en curso. ¿Quieres verlo?","Button_CancelAndCreate":"Cancelar y crear nuevo pedido","Button_ViewTransferOrder":"Ver pedido con transferencia en curso","Text_CancelOrderNote1":"Después de cancelar el pedido, puedes crear uno nuevo,","Text_CancelOrderNote2":"Sin embargo, se cerrará el pedido con transferencia en curso.","Button_ConfirmCancelCreate":"Confirmar cancelación y crear","Link_ViewBenefitDetail":"Ver detalles de beneficios >","Label_RedeemCode":"Código de canje","Message_RedeemSuccess":"¡Canjeado correctamente!","Message_RedeemVipSuccess_DesignKit":"¡Canjeaste correctamente tu membresía VIP de Meitu Design Studio!","Message_RedeemSvipSuccess_MeituXiuXiu":"¡Canjeaste correctamente tu membresía SVIP de Meitu!","Placeholder_EnterInviteCode":"Ingresar código de invitación","Placeholder_EnterRedeemCode":"Ingresar código de canje","Title_CodeCenter":"Centro de cupones","Desc_SelectCodeType":"Selecciona el tipo de código para verificarlo y canjearlo","Title_InviteCodeDesc":"Instrucciones del código de invitación","Title_RedeemCodeDesc":"Instrucciones del código de canje","Text_InviteCodeIntro":"Ingresa el código de invitación exclusivo que recibiste en redes sociales u otros canales:","Text_InviteCodeBenefit1":"Descuento exclusivo del canal en la suscripción con beneficios gratuitos por tiempo limitado","Text_InviteCodeBenefit2":"Cada código de invitación solo se puede usar una vez","Text_InviteCodeBenefit3":"No se puede combinar con otras promociones","Text_RedeemCodeIntro":"Usa un código de canje de membresía obtenido en canales oficiales:","Text_RedeemCodeBenefit1":"Inicia sesión en tu cuenta e ingresa el código de canje para canjearlo","Text_RedeemCodeBenefit2":"Después de canjearlo, obtendrás los beneficios y servicios de suscripción correspondientes","Text_RedeemCodeBenefit3":"Usa el código de canje antes de que venza. Los códigos vencidos no son válidos y no son reembolsables.","Text_InvoiceLink":"Este enlace se puede usar para emitir facturas de ${0} pedidos","Text_InvoiceOtherBusiness":"Para facturas de otros servicios de Meitu, sigue la cuenta oficial de Servicio de Pago Meitu","Desc_ConsumeSoonExpiredMeidou":"Usar primero los créditos próximos a vencer","Link_MeidouIntro":"Acerca de los créditos >","Text_NoMeidouGoToBuy":"No tienes créditos. Comprar ahora","Text_ThankYouSupport":"Gracias por tu apoyo. Seguiremos ofreciéndote nuevos servicios.","Text_PurchaseBatchSuccess_MeituXiuXiu":"Has comprado créditos de procesamiento por lotes de Meitu.","Text_PurchaseCutoutSuccess":"Has comprado descargas de MeituCutout.","Label_BoundAccount":"Cuenta vinculada:","Text_PurchaseCount":"Cantidad a comprar: ${0}","Label_TeamMemberExpiry":"Membresía del equipo válida hasta:","Label_ProMemberExpiry":"Membresía premium válida hasta:","Label_StandardMemberExpiry":"Membresía estándar válida hasta:","Text_PurchaseSeatCount":"Puestos comprados: ${0}","Button_GotItCountdown":"Entendido (${0} s)","Text_Trial":"Probar ${0}","Text_OriginalPrice":"Precio original ${0}","Text_PerSheet":"/imagen","Text_PerPersonPerMonth":"/persona/mes","Text_FreeTrialDays":"Prueba gratuita de ${0} días","Text_FreeTrialMonths":"Prueba gratuita de ${0} meses","Text_FreeTrialQuarters":"Prueba gratuita de ${0} trimestres","Text_FreeTrialYears":"Prueba gratuita de ${0} año","Text_ScanToBuy":"Escanea con ${0} para comprar","Text_ScanToActivate":"Escanea con ${0} para activar","Text_AlsoSupportWechatBuy":"(O escanea con WeChat)","Text_AlsoSupportWechatActivate":"(O escanea con WeChat)","Text_ServiceAgreement_DesignKit":"Política de suscripción de Meitu Design Studio","Text_ServiceAgreement_MeituXiuXiu":"Política de suscripción de Meitu SVIP","Text_ServiceAgreement_Meidou":"Acuerdo de recarga de créditos","Text_ServiceAgreement_Cutout":"Acuerdo de servicio de Recorte","Text_ServiceAgreement_BatchMeituXiuXiu":"Acuerdo de servicio de procesamiento por lotes de Meitu","Button_ClickLogin":"Iniciar sesión","Text_CheckAgreementFirst":"Primero marca la casilla para aceptar.","Text_LoadError":"No se pudo cargar","Button_ClickRefresh":"Toca para actualizar","Label_Pay":"Pagar:","Text_ExtendAfterPurchase":"Después de la compra, se extiende hasta: ${0}","Button_Agree":"Aceptar","Title_ThankYouSubscription":"¡Gracias por suscribirte!","Text_MemberServiceAgreement":"Servicio VIP","Title_PayFail":"Pago fallido","Button_RepayNow":"Intentar de nuevo","Desc_OneYearValidTeam":"Válido por 1 año. Solo se puede usar con tu equipo actual.","Text_SharedMeidouPrompt":"Para compartir créditos con más de 5 personas,","Button_ActivateTeamMember":"Suscríbete a la membresía de equipo","Text_SeatPurchaseEffect":"Los asientos adicionales entran en vigor de inmediato y expiran el ${0} (misma fecha de vencimiento que la orden de membresía de equipo activa).","Label_Gift":"Bono","Text_FirstMonthMeidouGift":"Suscríbete para recibir ${0} créditos el primer mes y ${1} créditos cada mes después. Válidos durante el mes en curso.","Text_MonthlyMeidouGift":"Se otorgan mensualmente y son válidos durante el mes en curso","Desc_TeamOnlyCutout":"Los créditos de descarga comprados solo se pueden usar con tu equipo actual.","Text_DownloadDeductRule":"Cada descarga de imagen completada usa 1 crédito de descarga.","Text_CutoutAdjustRule":"Ajusta tu recorte cuantas veces quieras. Las descargas solo se descuentan al descargar.","Text_UnlimitedCutout":"Recortes ilimitados mientras tu suscripción esté activa","Text_ValidityThreeMonths":"Vigencia: 3 meses","Text_ValidityOneYear":"Vigencia: 1 año","Title_VipLimitedOffer":"Oferta especial VIP","Text_TeamSeatRequirement":"Tu equipo actual tiene ${0} miembros. Compra el número correspondiente de plazas.","Text_TeamMemberSeatMinimum":"La membresía de equipo comienza a partir de ${0} plazas","Text_MeidouGiftPerMonth":"Créditos extra: ${0}/mes","Label_SeatCount":"Plazas","Text_SeatOrderEffect":"Las nuevas plazas del pedido entrarán en vigor a partir de ${0}. Para agregar plazas de inmediato,","Button_ActivateMemberUnlimited":"Suscríbete para tener acceso ilimitado","Button_BuyMember":"Suscríbete","Button_BuyCount":"Cantidad de compra","Text_BatchRemainingCount":"Imágenes restantes para edición por lotes: ${0}","Label_RemainingCutout":"Recortes restantes:","Text_RemainingMeidouCount":"Quedan ${0} créditos","Text_TeamMemberExpiry":"La membresía de equipo expira el ${0}","Text_BoundPhoneAccount":"(Cuenta vinculada: ${0})","Button_ClickLoginRegister":"Toca para iniciar sesión (incluye registro)","Text_LoginToBuyMember":"Inicia sesión para suscribirte y mantener seguras tus creaciones VIP.","Text_LoginToBuy":"Inicia sesión para comprar","Button_CorporateTransfer":"Transferencia bancaria corporativa","Button_ApplyInvoice":"Factura","Button_InviteOrRedeemCode":"Activar con código de invitación/canje","Button_RedeemCodeActivate":"Activar con código de canje","Text_MarchPromo":"Promoción de e-commerce de marzo: Doble de créditos en tu primera recarga","Button_BackToBuy":"Volver a la compra","Label_EstimatedConsumption":"Consumo estimado:","Text_ValidOneYear":"Válido por 1 año","Text_PerMonth":"/mes","Desc_Monthly330Meidou":"330 créditos gratis al mes (válidos durante el mes en curso), para usar en:","Text_UnitPrice1000":"Solo ¥0.0532 por crédito","Text_Capacity1000":"Genera aproximadamente 500 imágenes o 66 videos","Text_SingleImageLow1000":"Desde ¥0.176 por imagen","Text_SingleVideoLow1000":"Desde ¥1.320 por video (5s)","Text_SingleImageYearly1000":"Desde ¥0.106 por imagen","Text_SingleVideoYearly1000":"Desde ¥0.798 por video (5s)","Text_UnitPrice1800":"Solo ¥0.0462 por crédito","Text_Capacity1800":"Genera aproximadamente 900 imágenes o 120 videos","Text_SingleImageLow1800":"Desde ¥0.164 por imagen","Text_SingleVideoLow1800":"Desde ¥1.233 por video (5 s)","Text_SingleImageYearly1800":"Desde ¥0.092 por imagen","Text_SingleVideoYearly1800":"Desde ¥0.693 por video (5 s)","Text_UnitPrice3600":"Solo ¥0.0437 por crédito","Text_Capacity3600":"Genera aproximadamente 1,800 imágenes o 240 videos","Text_SingleImageLow3600":"Desde ¥0.154 por imagen","Text_SingleVideoLow3600":"Desde ¥1.158 por video (5 s)","Text_SingleImageYearly3600":"Desde ¥0.087 por imagen","Text_SingleVideoYearly3600":"Desde ¥0.656 por video (5 s)","Text_UnitPrice7500":"Solo ¥0.0410 por crédito","Text_Capacity7500":"Genera aproximadamente 3,750 imágenes o 500 videos","Text_SingleImageLow7500":"Desde ¥0.138 por imagen","Text_SingleVideoLow7500":"Desde ¥1.037 por video (5 s)","Text_SingleImageYearly7500":"Desde ¥0.082 por imagen","Text_SingleVideoYearly7500":"Desde ¥0.615 por video (5 s)","Desc_IncludesStandardAll":"Incluye todos los beneficios de Estándar, además de:","Desc_MonthlyMeidou":"${0} créditos incluidos al mes (válidos durante el mes en curso), para usar en:","Text_FewCredits":"Créditos limitados","Label_BasicPlan":"Versión básica","Text_TrialMeidouGift":"120 créditos incluidos con la prueba, válidos por 7 días","Text_Monthly330MeidouBenefit":"Suscríbete y obtén 330 créditos cada mes, válidos durante el mes en curso.","Label_LimitedPrivilege":"Beneficios por tiempo limitado","Text_SeedancePrivilege":"Generación lenta gratis e ilimitada con Seedance 2.0 y acceso anticipado a nuevas funciones","Label_MeidouPrefix":"Créditos:","Text_LoginToBuyMemberShort":"Inicia sesión para comprar una membresía","Text_TeamMinimumSeat":"Tu equipo tiene actualmente ${0} miembros. Debes comprar al menos ${0} puestos.","Message_AbnormalSubscriptionNoSeat":"No se pueden agregar puestos a membresías de equipo con un estado de suscripción irregular.","Text_TeamMemberExpires":"Tu membresía de equipo expirará el ${0}.","Text_ProMemberExpires":"Tu membresía Premium expirará el ${0}.","Text_BasicMemberExpires":"Tu membresía Basic expirará el ${0}.","Text_SvipMemberExpires_MeituXiuXiu":"Tu SVIP expirará el ${0}.","Text_ActivateVip_DesignKit":"Suscríbete a Meitu Design Studio VIP para disfrutar de las ventajas de miembro","Text_UpgradeToSvip_MeituXiuXiu":"Ya estás suscrito a Meitu VIP. Actualiza a SVIP para disfrutar de los servicios de diseño en distintos dispositivos.","Text_ActivateTeamMember_DesignKit":"Suscríbete a la membresía de equipo para desbloquear beneficios VIP de X-Design y funciones de colaboración en equipo","Text_ActivateMember":"Suscríbete para disfrutar de muchos beneficios de miembro","Text_ActivateMember_MeituXiuXiu":"Suscríbete para disfrutar de las ventajas de Meitu VIP, SVIP y la membresía de escritorio de Meitu","Text_ExpiredDays_Team":"Expiró hace ${0} días. Compra ahora para recuperar el acceso.","Text_VipExpiredDays_DesignKit":"Tu VIP expiró hace ${0} días. ¡Te damos la bienvenida de nuevo!","Text_VipExpiredDays_MeituXiuXiu":"Tu SVIP de Meitu expiró hace ${0} días. ¡Te damos la bienvenida de nuevo!","Text_ValidDays":"Válido por ${0} días","Text_ValidWeeks":"Válido por ${0} semanas","Text_ValidMonths":"Válido por ${0} meses","Text_ValidQuarters":"Válido por ${0} trimestres","Text_ValidYears":"Válido por ${0} años","Text_CountdownDays":"${0} días ${1}","Label_Week":"Semana","Label_Quarter":"Trimestre","Desc_BatchCutoutConsumption":"Después de usar Recorte, descargar y guardar 1 imagen consume ${0} créditos. Otras funciones consumen ${1} créditos.","Text_TieredSeatBilling":"La membresía incluye ${0} puestos. Los usuarios adicionales que superen ${1} se cobran a ${2}/año/persona.","Text_PerYearPerPerson":"/año/persona","Text_BoundAccountPrefix":"(Cuenta vinculada:","Text_BoundAccountSuffix":")","Title_GlobalSettingsMobile_Batch":"Configuración global","Tip_ApplyToAllTasksBelowMobile_Batch":"Aplicar a todas las tareas siguientes","Tip_UploadImagesFormatMobile_Batch":"Haz clic para cargar imágenes JPEG/JPG/PNG de hasta ${0} MB. Se admiten hasta ${1} imágenes.","Title_EcommerceTools":"Herramientas de comercio electrónico","Title_MoreVideoTools":"Más funciones de edición de videos","Text_AppMessageNotification_Batch":"Recibirás un mensaje en la app cuando la tarea finalice.","Tool_ProductDemoVideoMaker":"Creador de demos de producto","Tool_Video360Maker":"Generador de videos 360°","Tool_UnboxingVideoMaker":"Generador de videos de unboxing","Tool_FashionVideoMaker":"Generador de videos de moda","Tool_CommercialVideoMaker":"Creador de videos comerciales","Tag_Cover":"Portada","Option_ExportLayered_Psd":"Exportación por capas","Option_ExportFlat_Psd":"Exportar sin capas","Message_NoExportableLayer":"No hay capas exportables seleccionadas","Message_UnsupportedLayerForPsd":"Este tipo de capa no admite la exportación a PSD.","Message_VideoLayerPsdBlocked":"Contiene capas de video. No se puede exportar como PSD.","Message_ExportUnitsOverLimit":"La selección supera los ${0} elementos para exportar","Message_LayerSplitRightDenied":"Beneficios de no separar capas","AiTemplate_Desc":"Ingresa un tema para el póster o describe tus ediciones. La IA recreará esta plantilla y generará un póster con un solo clic.","AiTemplate_Upload":"Carga de elementos","AiTemplate_Upload_Desc":"Haz clic para subir imágenes de recursos y reemplazar imágenes de productos, modelos, códigos QR y más.","AiTemplate_Prompt":"Tema del póster/Detalles de edición","AiTemplate_Prompt_Placeholder":"Ingresa un tema de póster o describe lo que deseas editar. Por ejemplo: Cambia el tema a \'Humedad del Equinoccio de Otoño\'; reemplaza el XX en la imagen por el XX que subí.","AiTemplate_Generate":"Generar póster","Text_OpenClawInstallCmd":"Ayúdame a instalar ${0}","Text_SupportLinkImport":"Admite la importación de enlaces","Text_ModifyLogoPrompt":"Ayúdame a modificar este logo","Text_ModifyImagePrompt":"Ayúdame a modificar esta imagen","Title_UserCenter":"Centro personal","Button_Login":"Iniciar sesión","Button_Signup":"Registrarse","Title_FreeBackgroundRemoverOnline":"Eliminador de fondos gratuito en línea","Title_RemoveThe":"Elimina el fondo de las imágenes de forma instantánea y automática con Designkit de forma gratuita. No se requieren conocimientos de diseño.","Title_NoPic":"¿No tienes una imagen a mano? Prueba con una de estas","Title_IndustryLeading":"Líder en calidad de recorte de imágenes","Title_GlobalRunner":"Subcampeón mundial en la competencia CVPR 2024. Investigación innovadora publicada en AAAI y CVPR.","Title_FastAnd":"Eliminación de fondos rápida e impecable","Title_SImplyUpload":"Sube tu foto y Designkit se encargará del resto, desde la detección del sujeto hasta la eliminación del fondo, sin pasos complejos ni curva de aprendizaje.","Title_FineTune":"Ajusta tus imágenes como un profesional","Titel_Whether":"Ya se trate de cabello suave, bordes de telas o sombras, Designkit conserva los detalles que más importan. Además, puedes ajustar con precisión los bordes y las esquinas para lograr un acabado pulido y totalmente profesional.","Title_FlawlessStamp":"Procesamiento impecable de sellos y firmas","Title_RemoveDull":"Elimina fondos apagados y descoloridos de firmas y sellos. Designkit identifica los detalles de cada elemento y los prepara para cualquier diseño: con fondo sólido o PNG transparente.","Title_PerfecCutouts":"Recortes perfectos para cada tipo de uso","Title_GetFlawless":"Logra una eliminación de fondo impecable para cualquier tipo de imagen.","Button_ECommerco":"E-commerce","Button_Portraits":"Retratos","Button_Pets":"Mascotas","Button_LogoSignaure":"Logotipos y firmas","Title_HowTo":"¿Cómo elimino el fondo de las imágenes?","Title_UploadYour":"Sube tu imagen","Title_ChooseAn":"Elige una imagen de tu dispositivo en formato JPEG, PNG o WEBP.","Title_AIRemoves":"La IA elimina el fondo","Title_AiEditor":"La herramienta de edición con IA identifica el sujeto y elimina el fondo.","Title_EditOrExport":"Edita o exporta","Title_DownloadOr":"Descarga o utiliza el editor de fotos integrado para editar la imagen.","Title_FrequentlyAskedQuestions":"Preguntas frecuentes","Title_IsThis":"¿Es esta herramienta gratuita?","Answer_IsThis":"Sí, el Eliminador de fondos de Designkit es una herramienta gratuita para eliminar fondos de imágenes.","Title_CanIChange":"¿Puedo cambiar el fondo después de hacer el recorte?","Title_WhichImage":"¿Qué formatos de imagen son compatibles para el recorte?","Title_CanIManually":"¿Puedo ajustar manualmente los resultados si no son precisos?","Answer_CanIchange":"Sí, después de completar el recorte, puedes seleccionar directamente un color sólido, un degradado o agregar una imagen personalizada como nuevo fondo usando Designkit. La operación es simple, flexible y totalmente personalizable.","Answer_WhichImage":"Designkit admite formatos populares como JPG, PNG y WEBP para la carga de archivos. También puedes exportar el recorte final como un PNG transparente para integrarlo sin problemas en tus otros proyectos de diseño.","Answer_CanIManually":"Absolutamente. Si los bordes no son perfectos después del reconocimiento automático, puedes usar el editor incorporado para refinarlos manualmente y ajustarlos a tus requisitos.","Button_Reupload":"Volver a subir","Button_Download":"Descargar","Button_Edit_Refine":"Refinar","Button_Edit_Backgrounds":"Fondos","Button_Edit_Crop":"Recortar","Button_Edit_Edges":"Bordes","Button_Edit_Filter":"Filtros","Pop_Download_Freetip":"Gratis","Pop_Download_UHD":"Resolución completa","Pop_Download_preview":"Vista previa","Guid_More_ColorPanel":"Todo","Button_Remove_ColorPanel":"Eliminar","Button_Upload_ColorPanel":"Subir","Size_Original_SizePanel":"Tamaño original","Button_Upload_Batch":"Carga por lotes","Desc_Upload":"Haz clic o arrastra para subir, pegar archivos.","SubTitle_Header1_Home":"Generador de imagen de producto con IA","SubTitle_Header2_Home":"Generador de posters con IA","SubTitle_Header3_Home":"Generador de video de producto con IA","SubTitle_Header4_Home":"Generador de fotografía de producto con IA","SubTitle_Header5_Home":"Diseño visual de sitios web con IA","SubTitle_Header6_Home":"Prueba virtual","SubTitle_Header7_Home":"Diseño de páginas de detalle de producto con IA","SubTitle_Header8_Home":"Editor de fotos con IA","SubTitle_Header9_Home":"Mejorador de imagen","SubTitle_Header10_Home":"Eliminador de objetos","SubTitle_Header11_Home":"Eliminador de fondos con IA","SubTitle_Header12_Home":"Generador de fondos con IA","SubTitle_Header13_Home":"Redimensionador de imágenes","SubTitle_Header14_Home":"Agregar texto a la imagen","SubTitle_Header15_Home":"Generador de imágenes con IA","SubTitle_Header16_Home":"Editor de fotos por lotes","Size_ToEdge":"Al borde","Pop_Download_UHD_LimitTip":"Limit time · ${0}","Before_Text":"Antes","After_Text":"Después","Button_OpenVipFreeDownloadPsd":"Suscríbete para descargar PSD gratis","Text_LogoSlogan_DesignKit":"Haz que el diseño comercial luzca increíble y dé resultados","LogoDesign_ModeTitle":"Elige lo que deseas generar","LogoDesign_ModeFast":"Logotipo rápido","LogoDesign_ModeFastDesc":"Generación rápida, solo información esencial.","LogoDesign_ModePro":"Logotipo y diseño visual","LogoDesign_ModeProDesc":"Conceptos estratégicos y vista previa en escenas reales.","LogoDesign_Essentials":"Información de la marca","LogoDesign_BrandNamePlaceholder":"Nombre de la marca (Obligatorio)","LogoDesign_IndustryPlaceholder":"Industria (Obligatorio)","LogoDesign_Description":"Descripción","LogoDesign_DescriptionPlaceholder":"Describe la historia de tu marca, eslogan, público objetivo o elementos específicos que quieras en tu logotipo...","LogoDesign_MoreSettings":"Ajustes","LogoDesign_LogoType":"Tipo de logotipo","LogoDesign_StyleCount":"Estilo y cantidad","LogoDesign_Model":"Modelo de generación de imágenes","LogoDesign_BrandColors":"Colores de la marca","LogoDesign_AutoColor":"Color automático","LogoDesign_DragUpload":"Arrastra o haz clic para subir","LogoDesign_DragUploadHint":"Se admiten los formatos PNG, JPG y WEBP. Sube una imagen nítida.","LogoDesign_UploadingImage":"Subiendo...","LogoDesign_ReplaceImage":"Cambiar imagen","LogoDesign_ReferenceDimensions":"Tamaño de referencia","LogoDesign_GenerateLogos":"Generar logotipo","LogoDesign_GenerateExpressLogos":"Generar 8 logotipos","LogoDesign_GenerateConcepts":"Generar propuestas de concepto","LogoDesign_Processing":"Generando...","LogoDesign_StrategyTitle":"Selecciona una dirección","LogoDesign_StrategyDesc":"Selecciona una dirección estratégica antes de generar el logotipo final.","LogoDesign_RegenerateStrategies":"Probar otra estrategia","LogoDesign_SelectStrategy":"Elige una estrategia","LogoDesign_GenerationHistory":"Historial de generaciones","LogoDesign_NoHistory":"Aún no hay historial de generaciones.","LogoDesign_EditInAgent":"Editar en Agent","LogoDesign_GenerateMockups":"Generar mockup","LogoDesign_SelectMockupType":"Selecciona el tipo de mockup","LogoDesign_VoteLike":"Me gusta","LogoDesign_VoteDislike":"No me gusta","LogoDesign_HeroTitlePro":"Identidad visual de marca profesional.","LogoDesign_HeroDescPro":"Desde conceptos centrales hasta aplicaciones en múltiples escenarios, crea un sistema de marca unificado.","LogoDesign_HeroTitleExpress":"Solución de logotipo con IA","LogoDesign_HeroDescExpress":"Descubre 8 estilos visuales diferentes en una sola generación.","LogoDesign_Items":"Proyecto","LogoDesign_UntitledBrand":"Marca sin título","LogoDesign_NoStrategy":"No se ha seleccionado una estrategia","LogoDesign_StrategyBadge":"Opción","LogoDesign_Inspiration":"Inspiración","LogoDesign_MockupGridPlaceholder":"Escenas de colección de mockups generadas por IA","LogoDesign_ValidationBrand":"Ingresa el nombre de la marca","LogoDesign_ValidationIndustry":"Selecciona o ingresa un sector","LogoDesign_ValidationStrategy":"Selecciona primero una estrategia.","LogoDesign_ValidationMockup":"Selecciona al menos un tipo de mockup","LogoDesign_Style_Minimalist":"Minimalista","LogoDesign_Style_Vintage":"Retro","LogoDesign_Style_Geometric":"Geometría","LogoDesign_Style_Abstract":"Abstracto","LogoDesign_Style_HandDrawn":"Pintado a mano","LogoDesign_Style_Luxury":"Lujo","LogoDesign_Style_Tech":"High-tech","LogoDesign_Style_Nature":"Diario","LogoDesign_LogoType_IconText":"Ícono + texto","LogoDesign_LogoType_TextOnly":"Solo texto","LogoDesign_LogoType_IconOnly":"Solo ícono","LogoDesign_LogoType_Lettermark":"Logotipo de letra","LogoDesign_LogoType_Emblem":"Logotipo de medalla","LogoDesign_LogoType_Mascot":"Mascota","LogoDesign_MockupType_BusinessCard":"Tarjeta de visita","LogoDesign_MockupType_Signage":"Letrero de tienda","LogoDesign_MockupType_Packaging":"Postproducción","LogoDesign_MockupType_Shirt":"Camiseta","LogoDesign_MockupType_ToteBag":"Bolsa tote","LogoDesign_MockupType_Sticker":"Calcomanías","LogoDesign_MockupType_OfficeSupplies":"Artículos de oficina","LogoDesign_MockupType_AppIcon":"Ícono de la app","LogoDesign_AddColor":"Agregar color","LogoDesign_ReferenceDimension_Graphics":"Gráficos","roboneo_agent_queue_tier_fast_description":"Genera al instante. Los créditos se cobran por generación.","roboneo_agent_queue_tier_relax_description":"Generación gratuita ilimitada a una velocidad un poco más lenta. No se usan créditos.","roboneo_agent_queue_tier_relax_locked_description":"Beneficio de ${0} — generar gratis sin créditos.","roboneo_agent_queue_tier_upgrade_unlock":"Actualiza para desbloquear","Button_UpgradeForFree":"Actualizar gratis","Label_Teams":"Equipos","Title_AiModelAccess_Pricing":"Acceso a modelos de IA","Text_LimitedAiModels_Pricing":"Modelos limitados de video e imagen","Label_GptImage2_Pricing":"GPT Image 2.0","Label_NanoBananaPro_Pricing":"Nano Banana Pro","Label_NanoBanana2_Pricing":"Nano Banana 2","Label_GeminiOmniFlash_Pricing":"Gemini omni Flash","Label_Seedance2Mini_Pricing":"Seedance2.0 Mini","Label_Seedance2Fast_Pricing":"Seedance 2.0 Fast","Label_Kling26_Pricing":"Kling 2.6","Label_Veo31_Pricing":"Veo 3.1","Label_Sora2_Pricing":"Sora 2","Label_Midjourney_Pricing":"Midjourney","Label_Seedance25ComingSoon_Pricing":"Seedance 2.5 (Próximamente)","Label_Seedream50Pro_Pricing":"Seedream 5.0 Pro","Label_NanoBanana_Pricing":"Nano Banana","Label_Seedream40_Pricing":"Seedream 4.0","Label_SeedEdit30_Pricing":"SeedEdit 3.0","Tab_VideoObjectRemover":"Eliminación de video","Text_WholeProductGuide_DomesticCloneCase":"Sube una imagen de un producto más vendido como referencia y recrea fácilmente el mismo estilo","Text_ApparelGuide_DomesticCloneCase":"Sube una imagen de moda en tendencia como referencia y recrea el look fácilmente","Text_PosterCoverGuide_DomesticCloneCase":"Sube una imagen de póster en tendencia como referencia y recrea el estilo fácilmente","Text_SocialGraphicsGuide_DomesticCloneCase":"Sube una imagen en tendencia de redes sociales como referencia y recrea el look fácilmente.","TaskName_WholeProductClone_DomesticCloneCase":"Vaso térmico verde menta con estampado de gatos","TaskName_ApparelClone_DomesticCloneCase":"Camisa floral para niña con cuello Peter Pan","TaskName_PosterCoverClone_DomesticCloneCase":"Póster de guía gastronómica de Shunde","TaskName_SocialGraphicsClone_DomesticCloneCase":"Guía de viaje de Jingdezhen","Label_SwitchToPage":"Cambiar a la página ${0}","File_Mention_Upload_Text":"Añadir desde el dispositivo","File_Mention_Empty_Text":"Aún no has subido nada.","Empty_Agent_Canvas_Text":"Lienzo de IA","Empty_Agent_Canvas_Description":"Genera con IA. Creatividad sin límites.","Label_Height":"Altura","Label_Width":"Ancho","Agent_Guide_Placeholder_Title":"Empieza ahora, crea libremente","Agent_Guide_Placeholder_Agent_Title":"Agente de chat","Agent_Guide_Placeholder_Agent_Subtitle":"Crear desde cero","Agent_Guide_Placeholder_Upload_Subtitle":"Editar imagen existente","Label_Text_Then":"Luego","Meta_Title_LogoDesign":"Diseño profesional de logotipos simplificado con Zawa AI","Title_AppEnhancer":"Mejora de video con IA","Desc_AppEnhancer":"Mejora a 4K HD con un clic y aumenta la calidad y la velocidad de fotogramas.","Title_AppWatermarkRemover":"Eliminador de marcas de agua y subtítulos de video","Desc_AppWatermarkRemover":"Elimina rápidamente marcas de agua y logotipos de videos.","Title_AppBackgroundRemover":"Eliminador de fondos de video","Desc_AppBackgroundRemover":"Elimina fondos de video con un solo clic, sin registrarte.","Title_VideoDemos":"Prueba estos videos","Button_DownloadPreview":"Descargar vista previa de 5 segundos","Text_PreviewDownloading":"Descargando video de 5 segundos...","Title_PreviewVideo":"Video de vista previa de 5 segundos","Title_FullVideo":"Video completo","Button_DownloadFull":"Descargar video completo","Text_FullDownloading":"Descargando video completo...","Tip_FullVideoReady":"Tu video completo está listo para descargarse.","Tip_Processing":"El procesamiento puede tardar un poco. No actualices la página. Vuelve más tarde.","Tip_ProcessComplete":"Procesamiento completo. Toca para guardar el video en tu teléfono.","Tag_Purchased":"Comprado","Text_Uploading":"Subiendo...","Message_ProcessFailed":"Error al procesar el video.","Button_UploadVideo":"Subir video","Text_SupportFormat":"Formatos compatibles: ${0}","Button_UploadNew":"+ Subir nuevo video","Message_ProcessFailedRetry":"Error al procesar el video. Comprueba tu conexión de red e inténtalo de nuevo.","Tip_MaxProcessNum":"Se pueden procesar hasta ${0} videos a la vez. Inténtalo de nuevo más tarde.","Tip_MaxUploadNum":"Puedes subir hasta ${0} archivos de video a la vez.","Message_VideoLoadFailed":"No se pudo cargar el video","Tip_VideoResolutionLimit":"No se admiten videos con resolución superior a 4K.","Tip_VideoDurationLimit":"El video supera el límite. Debe durar menos de 20 minutos.","Tip_VideoSizeLimit":"El video es demasiado grande. Sube un video de menos de ${0} MB.","Tip_VideoFormatLimit":"Formatos de video compatibles: ${0}. Sube un video en un formato compatible.","Tip_Done":"Listo","Text_IsProMember":"Eres miembro Pro.","Text_SubscribeToUnlock":"Suscríbete para desbloquear.","Button_Enhance":"Empezar a mejorar","Button_Remove":"Empezar","Text_Enhancing":"Mejorando...","Text_EnhancingFull":"Mejorando el video completo...","Text_Removing":"Eliminando...","Text_RemovingFull":"Eliminando del video completo...","Text_RemovingSelectedArea":"Eliminando el área seleccionada...","Tag_Enhanced":"Mejorado","Tag_Removed":"Eliminado","Tag_Preview":"Vista previa de 5 segundos","Label_SelectResolution":"Seleccionar resolución","Message_DownloadFailed":"No se pudo descargar. Verifica la conexión a Internet e intenta nuevamente.","Message_DownloadFailedRetry":"Descarga fallida. Intenta descargar de nuevo.","Tab_Smart":"Detección inteligente","Tab_Watermark":"Marca de agua","Tab_Subtitle":"Subtítulos","Tab_Manual":"Manual","Label_BoxItem":"Selecciona el área que quieres eliminar","Tip_ClearManualBoxOnSwitch":"Cambiar de modo borrará la selección","Label_Multiplier":"${0}x","Label_Resolution1K":"1K","Label_Resolution2K":"2K","Label_Resolution4K":"4K","Title_ConfirmVideoRights":"Confirma que tienes derecho a usar este video.","Desc_ConfirmVideoRights":"No subas ni importes contenido que no sea tuyo o que no estés legalmente autorizado a usar. Al hacer clic en \\"Confirmar\\", confirmas que eres propietario de este contenido y que ninguno de los siguientes casos infringirá derechos de terceros ni violará las leyes aplicables: (i) El contenido en sí; (ii) Tu uso de nuestros servicios; o (iii) Nuestro uso del contenido para proporcionar los servicios que solicitaste.","Button_Import":"Importar","Title_ImportVideoLink":"Importa el enlace de tu video","Label_ConfirmContentPermission":"Al subir el enlace, confirmo que este contenido me pertenece.","Placeholder_VideoLink_WatermarkRemover":"Ingresa un enlace de video para eliminar la marca de agua...","Placeholder_VideoLink_SocialPlatforms":"Compatible con enlaces de TikTok, IG, YouTube y Facebook","Placeholder_VideoLink_SocialPlatforms_Domestic":"Compatible con enlaces de Douyin, Kuaishou, Xiaohongshu y TikTok","Tip_InvalidLink":"Importa un enlace válido","Tip_LinkImportFailed":"Error al importar. Inténtalo de nuevo.","Text_FileFromLink":"Archivo vinculado ${0}","Text_LinkImporting":"Importando ${0}%","Button_Batch":"Lotes","Button_Link":"Enlace","Title_MobileBatchUnsupported":"El procesamiento por lotes aún no es compatible en dispositivos móviles.","Text_VisitOnDesktop":"Abrir en una computadora:","Button_CopyAddress":"Copiar","Text_UploadDropPasteClick":"Arrastra y suelta, pega o haz clic para subir","Text_UploadDropPasteClick_Support":"Admite .mp4, .mov y m4v","Tips_UploadMaxVideoCountLimit":"Sube hasta ${0} archivos de video","Title_AILogoDesign":"Diseño de logotipo con IA","Title_AILogoPreview":"Diseño de logotipo con IA","Message_IndustryLoadFailed":"No se pudieron cargar los datos de la industria","Message_LogoResultPartialFailed":"No se pudieron recuperar algunos resultados de generación de logotipos","Label_LogoGenerateMode":"Modo de generación de logotipos","Tab_GeneralMode":"Modo general","Desc_StrongerLogoModel":"Impulsado por un modelo más potente para crear logotipos de mayor calidad","Button_CloseTip":"Descartar consejo","Label_LogoName":"Nombre del logotipo","Label_LogoSlogan":"Subtítulo/Eslogan","Label_Optional":"Opcional","Placeholder_LogoDescription":"Describe el tono de la marca, las palabras clave de estilo, los casos de uso, etc.","Title_AIServiceStatement":"Declaración del servicio de IA","Label_LogoCreateGuide":"Guía de creación de logotipos","Title_StartCreateLogo":"Empieza a crear tu logotipo","Desc_CreateLogoSchemes":"Ingresa la información de la marca a la izquierda para generar ${0} opciones seleccionadas","Text_FillBrandInfo":"Ingresa la información de la marca","Text_SelectGenerateMode":"Selecciona el modo de generación","Text_GetLogoScheme":"Generar diseños de logotipo","Label_AILogoPreview":"Vista previa ampliada del logotipo con IA","Button_ClosePreview":"Desactivar vista previa","Label_AILogoLarge":"Imagen grande de logotipo generado por IA","Button_PreviousLogo":"Ver logotipo anterior","Button_NextLogo":"Ver siguiente logotipo","Button_ScrollThumbnailsLeft":"Desplazar miniaturas a la izquierda","Label_LogoPreviewList":"Lista de vista previa de logotipos","Button_SwitchLogo":"Cambiar a este logotipo","Button_ScrollThumbnailsRight":"Desplazar miniaturas a la derecha","Message_LogoDownloadFailed":"Error al descargar el logotipo. Inténtalo de nuevo más tarde.","Label_LogoGenerateResult":"Resultados de logotipos","Title_GenerateResult":"Resultados:","Button_WatermarkPreference":"Configurar ajustes de marca de agua para descargas","Button_SelectLogo":"Seleccionar este logotipo","Text_LogoGenerating":"Generando logotipo...","Message_LogoGenerateFailedRetry":"Error al generar. Inténtalo de nuevo.","Label_AIGeneratedLogo":"Logotipo generado por IA","Button_EditLogo":"Editar este logotipo","Button_DownloadLogo":"Descargar este logotipo","Button_PreviewLogo":"Previsualizar este logotipo","Message_RecordLoadFailed":"No se pudieron cargar los registros de generación","Message_MoreRecordsLoadFailed":"No se pudieron cargar más registros","Message_LogoBatchDownloadFailed":"Error al descargar logos en lote. Inténtalo de nuevo más tarde.","Label_RecordLoading":"Cargando historial...","Label_LogoRecords":"Historial de logotipos","Label_GenerateMode":"Modo de generación","Text_GenerateTime":"Tiempo de generación: ${0}","Button_ZoomLogo":"Ver logotipo en pantalla completa","Text_NoMoreRecords":"No hay más registros","Message_GenerateTaskSubmitted":"Tarea de generación enviada","Message_LogoGenerateFailed":"Error al generar el logotipo. Inténtalo de nuevo más tarde.","Button_QuickGenerate":"Generación rápida","Label_GenerateViral_ViralVideo":"Generar viral","Label_ReplicateViral_ViralVideo":"Replicar viral","Message_SelectMarket_ViralVideo":"Por favor selecciona un mercado objetivo","Message_SelectLanguage_ViralVideo":"Por favor selecciona el idioma del video","Message_SelectRatio_ViralVideo":"Por favor selecciona la relación de la plataforma","Message_FillScript_ViralVideo":"Por favor completa el guión personalizado","Message_SetScriptCount_ViralVideo":"Por favor configura la cantidad de generación del guión personalizado","Message_SelectViralType_ViralVideo":"Por favor selecciona al menos un tipo viral","Message_MaxViralTypes_ViralVideo":"El total de tipos virales no puede superar ${0}","Message_InputTaskTitle_ViralVideo":"Por favor ingresa el título de la tarea","Message_FillSellingPoints_ViralVideo":"Por favor completa la descripción de puntos de venta","Message_ProductImageShortEdgeLimit_ViralVideo":"Sube una imagen cuyo lado más corto sea mayor de 300px","Message_ProductImageAspectRatioSuggestion_ViralVideo":"Se recomienda subir una imagen 16:9, 9:16 o 1:1","Message_UploadRefVideo_ViralVideo":"Por favor sube el video de referencia","Message_TaskCancelled_ViralVideo":"Tarea cancelada","Text_GenerateTaskTitle_ViralVideo":"Generar tarea viral ${0}","Text_ReplicateTaskTitle_ViralVideo":"Replicar tarea viral ${0}","Text_TaskCopyTitle_ViralVideo":"${0}-Copia","Message_FetchConfigFailed_ViralVideo":"Error al obtener la configuración de inicialización viral","Title_VideoResult_ViralVideo":"Resultado de video","Text_AiGenerating_ViralVideo":"IA generando...","Text_CheckingSellingPoints_ViralVideo":"Comprobando contenido...","Label_EmailNotify_ViralVideo":"Notificarme por email cuando esté listo","Title_LinkEmail_ViralVideo":"Vincula una dirección de email","Text_LinkEmailDesc_ViralVideo":"Tu cuenta aún no tiene una dirección de email. Vincula una en el Centro de cuentas y vuelve para activar las notificaciones por email.","Text_LinkEmailRedirect_ViralVideo":"Se te redirigirá al Centro de cuentas para completar la vinculación y verificación del email.","Button_GoToAccountCenter_ViralVideo":"Ir al Centro de cuentas","Title_EmailNotifyConfirm_ViralVideo":"¿Recibir notificaciones por email?","Text_EmailNotifyConfirm_ViralVideo":"Te avisaremos en ${0} cuando tus videos estén listos.","Message_EmailLinked_ViralVideo":"Email vinculado. Activa las notificaciones si quieres recibir un aviso cuando este video esté listo.","Message_EmailNotifyOff_ViralVideo":"Notificaciones por email desactivadas","Message_EmailNotifyOn_ViralVideo":"Notificaciones por email activadas","Text_NoHistory_ViralVideo":"Sin registros de historial","Text_MobileGuideGenerate_ViralVideo":"Sube imágenes de producto y puntos de venta para crear rápidamente videos virales listos para promoción.","Text_MobileGuideReplicate_ViralVideo":"Sube imágenes de producto y un video de referencia para replicar el ritmo y estilo visual de un video viral.","Label_DKGenerateViralMobileGuideNavTitle_ViralVideo":"Generar viral","Label_DKGenerateViralMobileGuideTitle_ViralVideo":"Generar viral","Text_DKGenerateViralMobileGuideSubtitle_ViralVideo":"Sube imágenes de producto y puntos de venta para crear rápidamente videos virales listos para promoción.","Label_DKReplicateViralMobileGuideNavTitle_ViralVideo":"Replicar viral","Label_DKReplicateViralMobileGuideTitle_ViralVideo":"Replicar viral","Text_DKReplicateViralMobileGuideSubtitle_ViralVideo":"Sube imágenes de producto y un video de referencia para replicar el ritmo y estilo visual de un video viral.","Label_ZawaGenerateViralMobileGuideNavTitle_ViralVideo":"Generar viral","Label_ZawaGenerateViralMobileGuideTitle_ViralVideo":"Generar viral","Text_ZawaGenerateViralMobileGuideSubtitle_ViralVideo":"Sube imágenes de producto y puntos de venta para crear rápidamente videos virales listos para promoción.","Label_ZawaReplicateViralMobileGuideNavTitle_ViralVideo":"Replicar viral","Label_ZawaReplicateViralMobileGuideTitle_ViralVideo":"Replicar viral","Text_ZawaReplicateViralMobileGuideSubtitle_ViralVideo":"Sube imágenes de producto y un video de referencia para replicar el ritmo y estilo visual de un video viral.","Button_ConfirmGenerate_ViralVideo":"Confirmar generación","Button_Close_ViralVideo":"Cerrar","Button_Previous_ViralVideo":"Anterior","Button_Next_ViralVideo":"Siguiente","Message_CreateTaskFailed_ViralVideo":"Error al crear la tarea, por favor intenta más tarde","Message_RefreshFailed_ViralVideo":"Error al actualizar, por favor intenta más tarde","Message_VideoFormatLimit_ViralVideo":"El video de referencia actualmente solo admite mp4 / mpeg / mov / avi / flv / mpg / webm","Message_ReferenceVideoSizeLimit_ViralVideo":"El tamaño del video de referencia no puede superar ${0}MB","Message_UploadRefVideoFirst_ViralVideo":"La replicación viral requiere subir un video de referencia primero","Message_FillProductInfo_ViralVideo":"Por favor completa los puntos de venta del producto","Message_SelectVideoType_ViralVideo":"Por favor selecciona el tipo de video y la cantidad","Button_Disabled_ViralVideo":"Desactivar","Text_LoadingCreator_ViralVideo":"Cargando mis creadores…","Text_NoCreatorYet_ViralVideo":"Aún no hay imagen de creador, intenta subir una","Text_TotalCount_ViralVideo":"(Total ${0})","Text_Submitting_ViralVideo":"Enviando...","Text_LoadingConfig_ViralVideo":"Cargando configuración…","Button_Decrease_ViralVideo":"Disminuir","Button_Increase_ViralVideo":"Aumentar","Title_NightHosted_ViralVideo":"Alojamiento nocturno","Message_CreatorGenSuccess_ViralVideo":"Creador generado con éxito","Button_ContinueNewTask_ViralVideo":"Continuar nueva tarea","Text_CustomScriptCount_ViralVideo":"Guión personalizado × ${0}","Text_ViralTypeCount_ViralVideo":"Tipos virales × ${0}","Text_FissionCount_ViralVideo":"Fisión viral × ${0}","Text_AiModelEnabled_ViralVideo":"Modelo IA activado","Label_ModelTab_ViralVideo":"Pestaña de modelos","Label_ModelParams_ViralVideo":"Parámetros del modelo","Text_ParamsAdjusted_ViralVideo":"Parámetros ajustados por separado","Text_NoSellingPoints_ViralVideo":"Descripción de puntos de venta no completada","Message_FillSellingPointsPlease_ViralVideo":"Por favor añade la descripción de puntos de venta","Message_ThanksForFeedback_ViralVideo":"¡Gracias por tus comentarios!","Title_AdditionalFeedback_ViralVideo":"Comentarios adicionales","Placeholder_FeedbackBetter_ViralVideo":"¿Qué podría mejorar?","Button_SubmitFeedback_ViralVideo":"Enviar comentarios","Button_LikeFeedback_ViralVideo":"Me gusta","Button_DislikeFeedback_ViralVideo":"No me gusta","Text_ProductImageCount_ViralVideo":"${0} imagen(es) de producto","Text_RefVideoCount_ViralVideo":"${0} video(s) de referencia","Text_FollowGlobal_ViralVideo":"Siguiendo configuración global","Message_BatchSubmitSuccess_ViralVideo":"Tareas por lotes de video viral enviadas con éxito, total ${0}","Message_BatchSubmitFailed_ViralVideo":"Error al enviar el lote de videos virales, por favor intenta más tarde","Text_MaxSelectionTip_ViralVideo":"Se pueden seleccionar hasta ${0} tipos de video a la vez","Text_DeselectItem_ViralVideo":"Deseleccionar ${0}","Text_SelectItem_ViralVideo":"Seleccionar ${0}","Tab_CustomCreatorSection_ViralVideo":"Creador personalizado","Tab_MyCreatorSection_ViralVideo":"Mi creador","Tab_PersonalAssets_ViralVideo":"Recursos personales","Tab_OfficialRecommendation_ViralVideo":"Recomendaciones oficiales","Title_CustomCreatorSection_ViralVideo":"Personalizar creador exclusivo","Text_InProgress_ViralVideo":"Generando...","Text_NothingToDownload_ViralVideo":"No hay resultados descargables en este momento","Text_ResultNotReady_ViralVideo":"El resultado actual aún no está disponible para descargar","Text_PreparingDownload_ViralVideo":"Preparando descarga...","Text_PreDownloaded_ViralVideo":"Procesamiento completado. Toca para guardar el video en tu teléfono.","Message_RedoSubmitted_ViralVideo":"Rehacer enviado","Message_RedoFailed_ViralVideo":"Error al rehacer, por favor intenta más tarde","Text_CancelHostedConfirm_ViralVideo":"Después de cancelar el alojamiento, los resultados que se están generando actualmente se detendrán.","Button_Later_ViralVideo":"Más tarde","Message_HostedCancelled_ViralVideo":"Alojamiento cancelado","Text_BatchFailed_ViralVideo":"Los resultados del lote actual no se han devuelto, puedes regenerarlos más tarde.","Title_ViralTypeConfig_ViralVideo":"Configuración de tipos virales (Total ${0})","Title_ReplicateConfig_ViralVideo":"Configuración de replicación","Label_ReplicateCount_ViralVideo":"Cantidad de replicaciones","Label_StylePreference_ViralVideo":"Preferencia de estilo","Placeholder_StylePreference_ViralVideo":"Puedes especificar preferencias como ritmo, estado de ánimo, lenguaje de cámara, atmósfera de paleta de colores, etc.","Label_SupplementNote_ViralVideo":"Notas adicionales","Placeholder_SupplementNote_ViralVideo":"Añade estructuras que no quieres cambiar, tomas que deben conservarse, requisitos especiales de puntos de venta, etc.","Text_FourthSection_ViralVideo":"4. Cantidad de fisión","Message_RequestFailed_ViralVideo":"Error en la solicitud","Message_PromptOptimizeFailed_ViralVideo":"Error al optimizar el indicador, por favor intenta más tarde","Message_ModelImageFailed_ViralVideo":"Error al generar imagen del modelo, por favor intenta más tarde","Desc_BatchGenerateViral_ViralVideo":"Sube imágenes de producto en lote, configura los puntos de venta y genera tareas de video viral.","Desc_BatchReplicateViral_ViralVideo":"Sube imágenes de producto en lote y añade videos de referencia para cada tarea para replicar contenido viral.","Text_RecordRetentionTip_ViralVideo":"Los registros de generación se conservan solo 2 meses. Descárgalos y guárdalos lo antes posible para evitar pérdidas.","Message_PromptOptimizeEmpty_ViralVideo":"El resultado de la optimización del indicador está vacío","Message_CompleteModelInfo_ViralVideo":"Por favor completa la información del modelo primero","Message_ModelGenFailed_ViralVideo":"Error al generar el modelo, por favor intenta más tarde","Text_VideoFormatSupport_ViralVideo":"El video de referencia actualmente solo admite formatos mp4 / mpeg / mov / avi / flv / mpg / webm / wmv / 3gpp","Message_UnsupportedVideoFiltered_ViralVideo":"Algunos formatos de video no son compatibles y se han filtrado automáticamente","Message_FreeTrialOneVideoOnly_ViralVideo":"La prueba gratuita solo cubre 1 video. Actualiza a Pro para generar más.","Button_AddToMyCreator_ViralVideo":"Añadir a mis creadores","Button_ResetGlobal_ViralVideo":"Restablecer a global","Button_TaskLevelCustomCreator_ViralVideo":"Creador personalizado de nivel de tarea","Button_TaskLevelReplicateModel_ViralVideo":"Modelo de réplica de nivel de tarea","Label_ModelReference_ViralVideo":"Imagen de referencia del modelo","Placeholder_CreatorStyle_ViralVideo":"Añade requisitos de personalidad del creador, estilo de habla, presencia en cámara, etc.","Text_CreatorDisabledTip_ViralVideo":"Cuando la configuración del creador no está activada, el sistema generará usando el estilo general predeterminado en cámara.","Text_GenerateViralResult_ViralVideo":"Generar resultados virales","Text_OverrideCount_ViralVideo":"Anular ${0} elemento(s)","Text_ReplicateViralResult_ViralVideo":"Resultados de replicación viral","Text_SavedCreatorProfiles_ViralVideo":"Configuraciones de creador guardadas, se pueden rellenar con un clic.","Label_GenerateScheme_ViralVideo":"Plan de generación viral ${0}","Label_ReplicateScheme_ViralVideo":"Plan de replicación viral ${0}","Text_VideoResult_ViralVideo":"Resultado de video","Button_ContinueGenerate_ViralVideo":"Continuar generando","Desc_CreatorImageEmptyHint_ViralVideo":"Las imágenes de creador generadas aparecerán aquí para reutilizarse directamente en esta página.","Text_ItemCountUnit_ViralVideo":"${0} elementos","Text_CreditAmount_ViralVideo":"${0} créditos","Text_TotalItems_ViralVideo":"Total: ${0}","Text_SelectedVideoTypeCount_ViralVideo":"${0} tipos de video seleccionados","Text_FirstVideoDiscountBadge_ViralVideo":"Descuento en el primer video","Text_DesignKitFirstDiscountVipBadge_ViralVideo":"50% de descuento en el 1.º","Text_DesignKitFirstDiscountTryBadge_ViralVideo":"Prueba por $1.99","Text_FreeVideoBadge_ViralVideo":"${0} videos gratis","Text_FirstDiscountPrice_ViralVideo":"Genera el primer video por solo ${0} créditos (precio original ${1} créditos)","Text_UpgradeProDiscount_ViralVideo":"Sube a Pro y obtén 25% de descuento","Text_EnjoyedProDiscount_ViralVideo":"25% de descuento aplicado","Text_BatchFeatureRequiresMembership_ViralVideo":"La generación por lotes requiere membresía","Text_OpenProGenerationDiscount_ViralVideo":"Suscríbete a Pro y obtén un 25% de descuento en generación","Text_EnjoyedProGenerationDiscount_ViralVideo":"Descuento de generación Pro del 25% aplicado","Button_OpenProOrMembership_ViralVideo":"Suscribirse a Pro / Membresía","Text_MemberExclusiveBadge_ViralVideo":"Solo miembros","Text_VipFunctionLimitedTimeOpen_ViralVideo":"Funciones VIP disponibles por tiempo limitado","Title_NetworkDisconnected_ViralVideo":"Conexión de red interrumpida","Text_NetworkDisconnectedRefresh_ViralVideo":"La tarea seguirá generándose en segundo plano y no se perderá. Revisa la conexión y actualiza la página para ver el progreso más reciente.","Button_RefreshPage_ViralVideo":"Actualizar página","Message_NetworkDisconnectedRetry_ViralVideo":"Sin conexión de red. Revisa la conexión e inténtalo de nuevo.","Tip_InvalidLink_ViralVideo":"Ingrese un enlace de video válido","Title_GenerateParams_ViralVideo":"Parámetros de generación","Label_PreviewMarket_ViralVideo":"Mercado objetivo:","Label_PreviewLanguage_ViralVideo":"Idioma objetivo:","Label_PreviewAspectRatio_ViralVideo":"Relación de aspecto:","Label_PreviewScriptType_ViralVideo":"Tipo de guion:","Label_PreviewProductInfo_ViralVideo":"Puntos de venta del producto:","Text_GeneratingBrowserTitle_ViralVideo":"⏳ Generando... | ${0}","Text_SimplePreviewSwipeGuide_ViralVideo":"Desliza hacia arriba para ver más","Button_UploadImageReplicate_ViralVideo":"Subir imagen para replicar","Label_PlayVideo_ViralVideo":"Reproducir video","Label_NoWatermark_ViralVideo":"Sin marca de agua","Tool_LosslessUpscale":"Escalador de imágenes","Tool_AiRecolor":"Recolorear imagen con IA","Tool_AiPhotoEditorTitle":"Editor de fotos con IA","Message_ZipOnlyOne":"Solo puedes subir un archivo comprimido a la vez","Message_ZipSizeLimit":"El tamaño del archivo comprimido no puede superar los ${0} MB","Message_ZipExtractFailed":"Error al analizar el archivo comprimido ${0}","Message_ZipNoUploadableFiles":"${0} No se encontraron archivos que se puedan subir en este paquete comprimido","Message_ZipAlreadyUploaded":"Todos los archivos de ${0} ya se subieron. Se omitieron las cargas duplicadas.","Title_VideoWatermark":"Tu video contiene una marca de agua","Desc_VideoWatermark":"Los videos exportados durante la prueba incluirán una marca de agua de ${0}. Actualiza a Premium para descargar videos sin marca de agua.","Button_RemoveWatermark":"Eliminar marca de agua","Button_DownloadAnyway":"Descargar de todos modos","Message_DownloadFailedTryAgain":"Error de descarga. Inténtalo de nuevo.","MenuItem_ProductRestore":"Restauración de producto","Title_ProductRestore":"Restauración de producto","Desc_ProductRestore":"Sube una imagen original para corregir la distorsión del producto","Tip_ProductRestoreUpload":"Elige una imagen con un ángulo y una orientación similares al resultado actual. El producto debe verse claro y completo.","Button_StartProductRestore":"Empezar restauración","Message_ProductRestoreUploadLimit":"Carga una imagen en formato JPEG, JPG, PNG o HEIC, de hasta 10 MB.","Message_ProductRestoreUploadFailed":"No se pudo cargar la imagen de restauración del producto. Intenta de nuevo.","Message_VideoDownloadingInBackground":"Descargando en segundo plano. Puedes seguir usando ${0}","Button_AdjustParameters":"Ajustar configuración","Text_WPS_Welcome_Modal_Meidou_Description1":"Miembros premium: bono único de 50 créditos","Text_WPS_Welcome_Modal_Meidou_Description2":"Miembros no Premium: Bono único de 25 créditos","Text_WPS_Meidou_Rules":"Reglas de uso de créditos","Text_WPS_Meidou_Details":"Detalles de uso de créditos","Button_ImportLink":"Importar enlace","Tip_ProductImagesUpload":"Sube más ángulos del producto para obtener mejores resultados","Button_EditSkill":"Habilidades de edición","Title_CategorySkills":"Habilidades de ${0}","Button_AllSkills":"Todas las habilidades","Text_NoSkills":"No hay habilidades disponibles","Aria_ScrollLeft":"Desplazar hacia la izquierda","Aria_ScrollRight":"Desplazar a la derecha","Message_CompleteRequired":"Completa los campos obligatorios","Button_InsertToDesc":"Añadir a la descripción","Aria_ExpandOptions":"Opciones de expansión","Message_FileUploadFailedRetry":"Error al cargar el archivo. Intenta de nuevo.","Button_UploadImageVideo":"Subir imágenes/videos","Aria_DeleteFile":"Eliminar archivos","Aria_PauseVideo":"Pausar video","Aria_SwitchToSlide":"Cambiar a imagen ${0}","Tip_PleaseFill":"Completa ${0}","Tool_ImageToVideoGenerator":"Generador de videos a partir de imágenes","Tool_TextToVideoGenerator":"Generador de texto a video","Tool_TikTokVideoGenerator":"Generador de videos para TikTok","Tool_InstagramVideoGenerator":"Generador de videos para Instagram","Tool_YouTubeVideoGenerator":"Generador de videos de YouTube","Tool_YouTubeShortsGenerator":"Generador de YouTube Shorts"}');
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/x-design-locales-next/id.json
const x_design_locales_next_id_namespaceObject = JSON.parse('{"Tab_Design":"Desain","Button_Send":"Kirim","Input_Describe_Workspace":"Tuliskan deskripsi gambar dan aku akan membuatnya","Tab_AgentCase":"Kasus agen","Tab_RecentCreations":"Terbaru","Tag_Hot":"Hits","Tag_BrandDesign":"Desain Merek","Tag_Logo":"Logo","Tag_Posters":"Poster","Tab_Agent":"Agen","Tool_AiPhotoEditor":"Editor Foto","Button_Upload":"Unggah","Tool_Designer":"Poster","Title_AiTool":"Alat AI","Tool_ImageBackgroundRemover":"AI Penghapus Background","Tool_AiBackgroundGenerator":"AI Background","Tool_ImageEnhancer":"Penyempurna Foto","Tool_AiObjectsRemover":"Penghapus Objek","Tool_AiModelMannequin":"AI Model - Manekin","Tool_AiModelFlatlay":"AI Model - Flatlay","Tool_AiImageRecolor":"AI Mewarnai Foto","Tool_AiImageExtender":"AI Perluas Gambar","Tool_ImageUpscaler":"AI Zoom Foto","Tool_AiLogo":"Pembuat Logo","Button_BlankCanvas":"Buat","Sidebar_Create":"Beranda","Sidebar_Tools":"Alat AI","Sidebar_Batch":"Editor Massal","Sidebar_MyDesigns":"Desain Saya","Sidebar_Inspire":"Berikan Inspirasi","Sidebar_Brand":"Kit Merek","Sidebar_PackUp":"Tutup bar samping","Tag_All":"Semua","Tag_Design":"Desain","Sidebar_Unfold":"Buka bar samping","Menu_Edit":"Edit","Menu_Download":"Unduh","Menu_Delete":"Hapus","Tab_RecentlyCreated":"Terbaru","Tab_GenerateRecords":"Kreasi","Menu_Total":"Total","Menu_Total_Explain_AgentCredits":"Hanya untuk Agen AI dan akan digunakan terlebih dahulu.","Menu_DueToday":"Kredit bonus harian","Menu_DueToday_Explain":"Berlaku satu hari hingga pukul 24.00.","Menu_Else_AgentCredits":"Kredit lainnya","Button_GoPro_GetMore":"Dapatkan lebih banyak kredit","Menu_Total_Explain_PaidCredits":"Untuk semua fitur dan berlaku selama periode keanggotaan.","Menu_Pro":"Kredit langganan","Menu_Pro_Explain":"Berlaku selama periode keanggotaan.","Menu_Else":"Kredit lainnya","Menu_Else_Explain_PaidCredits":"Kredit dari sumber lain. Setiap jenis mungkin memiliki masa berlaku sendiri.","Menu_Else_Explain_AgentCredits":"Kredit dari sumber lain. Berlaku untuk jangka waktu lebih lama.","Menu_UsageDetail":"Detail penggunaan","Menu_Total_Explain_SuspendCredits":"Tidak tersedia hingga keanggotaan kembali aktif.","Tab_Invite":"Undang","Menu_InviteReward":"Hadiah Undang Teman","Tab_Reward":"Hadiah","Title_AgentCreditForRewards":"Hadiah kredit agen:","Table_Time":"Waktu","Table_Invitee":"Undangan","Title_ShareWithFriends":"Bagikan dengan teman","Title_ShareWithFriends_ExplainOne":"<span style=\\"color:#616266;\\">Undang teman dan kalian berdua akan menerima </span><span style=\\"color:#2D990C;\\">${0} Kredit Agen!</span>","Title_InvitationLink":"Bagikan tautan ini dengan teman","Button_Copy":"Salin","Title_Tips":"Tips","Title_Tips_ExplainOne":"1. Kredit Agen hanya dapat digunakan untuk mengakses fitur Agen AI. Kredit hadiah berlaku selama dua tahun.","Title_Tips_ExplainTwo":"2. Teman baru akan menerima hadiah setelah pendaftaran berhasil. Jika ada pertanyaan, silakan hubungi tim dukungan kami.","Title_GetRewarded":"Undangan berhasil!","Title_GetRewarded_Explain":"Kredit hanya dapat digunakan untuk fitur Agen AI dan berlaku selama dua tahun.","Button_Ok":"Mengerti","Title_FailedToReceiveReward":"Operasi gagal","Title_FailedToReceiveReward_Explain":"Jika ada pertanyaan, silakan hubungi tim dukungan kami.","Tool_AiBackgroundGenrator":"AI Background","Title_YouCannotUseYourOwnLink":"Tautan pribadi tidak diizinkan","Table_AgentCredit":"Kredit Agen","Title_ShareWithFriends_ExplainTwo":"<span style=\\"color:#616266;\\">Undang maksimal </span><span style=\\"color:#2D990C;\\">${0} teman baru</span><span style=\\"color:#616266;\\"> dan dapatkan maksimal ${1} Kredit Agen!</span>","Button_Invite":"Undang","Menu_Title_Invite":"Ajak Teman","Text_Button_Invite":"Dapatkan Kredit","Title_Dialog_Invite":"Ajak Teman","Desc_Dialog_Invite":"Bagikan tautan dengan teman atau posting di media sosial. Ketika ada yang mendaftar setelah mengklik tautan tersebut, Anda dan teman tadi akan menerima ${0} kredit. Jika mereka berlangganan, maka masing-masing akan menerima hingga ${1} kredit lagi.","Detail_Dialog_Invite":"Detail","Text_Copy_Invite":"Salin tautan","Title_Rewards_Invite":"Hadiah","SubTitle_Rewards1_Invite":"Total kredit diperoleh","SubTitle_Rewards2_Invite":"Pengguna gratis dari referal","SubTitle_Rewards3_Invite":"Pengguna berbayar dari referal","Success_Copy_Invite":"Tautan disalin","Title1_Invited_Invite":"Anda diundang!","Text_Rule1_Invite":"Untuk setiap teman yang mendaftar menggunakan tautan tersebut, masing-masing akan mendapatkan <strong>${0} kredit</strong>.","Text_Rule2_Invite":"Jika teman berlangganan, masing-masing akan mendapatkan kredit tambahan (<strong>${0} untuk Plus, ${1} untuk Pro</strong>).","Text_Rule3_Invite":"Langganan yang telah dibeli tidak dapat direfund jika paket atau kredit yang diberikan telah digunakan. Selain itu, kredit gratis tidak dapat dikembalikan setelah digunakan.","Text_Rule4_Invite":"Setiap pengguna dapat mengundang maksimal ${0} teman.","Text_Rule5_Invite":"Hadiah tidak akan diberikan untuk referal yang sudah punya akun, referensi ke diri sendiri, akun ganda, atau aktivitas penipuan.","Text_Rule6_Invite":"${0} berhak menyesuaikan program dan mencabut hadiah dari akun yang teridentifikasi tidak wajar.","Text_Divider_Invite":"atau bagikan tautan","Title2_Invited_Invite":"Bergabunglah ke ${0} dan klaim hadiahnya","SubTitle1_Invited_Invite":"Seorang teman mengundangmu untuk mencoba agen Al merek profesional kami. Buat desain pemasaran merek berkualitas tinggi seperti logo, poster, menu, dan aset media sosial dengan mudah.","SubTitle2_Invited_Invite":"<strong>Daftar sekarang</strong> dan masing-masing akan <strong> mendapatkan ${0} kredit</strong>.<strong> Jika berlangganan,</strong> masing-masing akan mendapatkan kredit tambahan sesuai dengan paket yang dipilih (<strong>${1} kredit untuk Plus atau ${2} kredit untuk Pro</strong>). Daftar sekarang dan klaim hadiahnya.","Button_Invited_Invite":"Daftar dan klaim hadiahnya","Success_Invited_Invite":"Anda bergabung melalui referal dan mendapatkan ${0} kredit.","Error_Invited_Invite":"Anda sudah punya akun.","Text_Share_Invite":"Aku menggunakan ${0} untuk membuat logo, visual, dan video dengan cepat dan mudah. Daftar melalui tautan ini dan kita berdua akan mendapatkan bonus kredit.","Title_Share_Invite":"Bergabunglah ke ${0} dan dapatkan bonus kredit!","Share_Email_Invite":"Email","Text_Rule7_Invite":"Kamu bisa menggunakan kredit untuk Agen AI. Kredit akan kedaluwarsa setelah satu bulan.","Title_AgentCredits":"+50 Kredit Agen","Input_Models":"Model","Button_TryItNow":"Coba sekarang","Account_Pricing":"Harga","Account_Language":"Bahasa","Account_Language_English":"Inggris","Account_Language_Chinese":"Mandarin","Tips_Adding":"Memproses...","Tips_Loading":"Memuat...","Tips_Creating":"Memproses...","Tips_Downloading":"Mengunduh...","Tips_Sending":"Mengirim…","Tips_AddSuccess":"Berhasil ditambahkan","Tips_MakeSameError":"Tidak dapat membuat ulang","Tips_UnsupportedGradientColor":"Gradien tidak didukung","Tips_CanNotAdding":"Gagal ditambahkan","Tips_Uninitialized":"Gagal mengirim pesan","Tips_UploadFailed":"Gagal mengunggah. Harap coba lagi.","Tips_UploadMaxCountLimit":"Unggah maksimal ${n} ${type} file","Tips_UploadMaxFileSize":"Tidak dapat mengunggah file ${file}. Gunakan file maksimal ${n} MB.","Tips_UploadImageAndVideoLimit":"Bisa mengunggah 1 foto dan 1 video sekaligus","Tips_UnsupportedSvgFile":"File SVG tidak didukung","Tips_UnsupportedUploadFileFormats":"Format file ${files} tidak didukung","Tips_CanNotAddSameFileTips":"File sudah ada","Tips_TextMinLengthTips":"Masukkan maksimal ${n} karakter","Tips_TextMaxLengthTips":"Masukkan maksimal ${n} karakter. Setiap karakter Mandarin atau emoji dihitung sebagai 2.","Tips_AccessDenied":"Akses ditolak","Tips_CreateFailed":"Inisiasi obrolan gagal","Tips_Error":"Terjadi kesalahan","Tips_NotFound":"Obrolan tidak ada","Tips_RequestAgentModelListError":"Gagal meminta daftar model Agen","Desc_Ended":"Selesai","Button_PeopleUse_Agent":"${n} pengguna mencoba","Dropdown_AddToChat":"Tambah ke Obrolan","Dropdown_AddToBrandKit":"Tambah ke Kit Merek","Dropdown_SaveToBrandKit":"Simpan sebagai logo merek","Dropdown_SaveToBrandTemplate":"Simpan sebagai templat merek","Title_Design_Agent":"Desain","Title_MainColor":"Warna primer","Title_SecondaryColor":"Warna sekunder","Bitton_ViewTheBrandKit":"Klik untuk melihat kit merek","Dropdown_InportImages":"Impor foto","Title_Upgrade_Pro":"Upgrade","Desc_SubscribeToUnlock_Pro":"Berlangganan dan dapatkan lebih banyak!","Desc_RunOutOfFreeUses_Pro":"Penggunaan gratis sudah habis.","Desc_RunOutOfUsesForToday_Pro":"Penggunaan gratis untuk hari ini sudah habis. Silakan kembali lagi besok.","Desc_PurchaseCompleted_Pro":"Pembelian selesai","Desc_ContinueDesign_Pro":"Sekarang desain bisa dilanjutkan!","Button_UnlockNow":"Berlangganan","Tips_Copied":"Disalin!","Tips_Credit_Explain_Paid":"Apa itu kredit yang dibeli?","Title_Total_InactiveCredits":"Total kredit tidak aktif","Title_Total_PaidCredits":"Total kredit yang dibeli","Menu_SuspendCredits":"Kredit tidak aktif","Menu_Credits":"Kredit","Tab_RecentCreations_Agent":"Agen","Tab_RecentCreations_Design":"Alat Pintar","Menu_FunctionalPricing":"Harga Agen","Title_Total_AgentCredits":"Total - Kredit agen","Tips_Credit_Explain_Agent":"Apa itu Kredit agen?","Title_FeaturePricing":"Harga Agen","Tab_Category":"Kategori","Tab_TaskType":"Tugas","Tab_Consume":"Harga (Kredit)","Tab_ExampleContent":"Contoh","Tips_CreditExplain_Inactive":"Apa itu kredit tidak aktif?","langding_more_bg_remover":"Penghapus Background","langding_more_enhancer":"Penyempurna Foto","langding_more_objects_remover":"Penghapus Objek","langding_more_bg_generator":"AI Background","Title_More1_Home":"Penyempurna Foto","Title_More2_Home":"AI Penghapus Objek","Title_More3_Home":"AI Background","Title_More4_Home":"AI Penghapus Background","Title_More5_Home":"Alat Gambar Batch","Title_Home":"Agen AI Desain <span>E-Commerce</span>","Placeholder_Input_Home":"Tuliskan deskripsi gambar dan aku akan membuatnya.","Title_Card4_Home":"Visual untuk Amazon","Title_Card1_Home":"Gambar Coba Pakaian & Aksesori","Title_Card3_Home":"Gambar Halaman Detail Produk","Title_Card2_Home":"Generator Latar Belakang","Desc_Features1_Home":"AI secara otomatis mengekstrak fitur produk dan preferensi gaya untuk menentukan solusi desain yang ideal.","Desc_Features2_Home":"Cukup masukkan satu kalimat, dan AI akan menghasilkan koleksi foto untuk e-commerce, termasuk foto utama, visual pendukung, dan halaman detail produk lengkap.","Text_Btn_Home":"Mulai Gratis","Desc_Features3_Home":"Secara otomatis membuat visual platform yang disesuaikan untuk Amazon, Etsy, TEMU, eBay, dan lainnya, memastikan foto selalu dioptimalkan untuk menarik audiens yang tepat.","Desc_Features4_Home":"Cukup masukkan prompt, dan AI akan menyesuaikan bahasa, gaya, dan elemen budaya untuk menghasilkan versi lokal untuk setiap pasar target.","Desc_Features5_Home":"Simpan alur kerja desain sebagai templat yang dapat digunakan ulang, dan AI akan otomatis membuat foto untuk semua SKU secara massal.","Desc_Features6_Home":"Menghasilkan rangkaian visual yang lengkap dan konsisten untuk 10 atau 1.000 produk dengan cepat dan mudah.","Title_Qualification_Home":"Dipercaya oleh Lebih dari 5 Juta Online Seller!","Text_Btn_Qualification_Home":"Lihat Sertifikasi","Title_Carousel_Home":"Alat AI lainnya","Title_Footer_Home":"Agen AI Desain E-Commerce","Title_Footer1_Home":"Akun Media Sosial","Subtitle_Footer1_Home":"YouTube","Subtitle_Footer2_Home":"X","Subtitle_Footer3_Home":"Instagram","Subtitle_Footer4_Home":"TikTok","Title_Footer2_Home":"Bantuan & Hukum","Subtitle_Footer5_Home":"Ketentuan Layanan","Subtitle_Footer6_Home":"Kebijakan Privasi","Copyright_Footer_Home":"Hak Cipta ${0} Meitu, Inc.","Desc_Evaluation1_Home":"Aku suka Designkit! Hasil fotonya terkesan real dan alami, nyaman dan bernuansa Nordik, cocok untuk toko lilinku. Daftar produk jadi terlihat rapi dan penjualan meningkat. Sangat sepadan.","Job_Evaluation5_Home":"Seller TEMU di Meksiko","Job_Evaluation6_Home":"Spesialis operasional Amazon","Job_Evaluation12_Home":"Manajer toko dari toko Amazon di Indonesia dengan berbagai SKU","Job_Evaluation2_Home":"Penilik toko Amazon & Mercado Libre","Name_Evaluation12_Home":"Arif","Desc_Evaluation11_Home":"Gambar suasana lifestylenya terlihat sangat natural, mirip seperti hasil pemotretan profesional. Pelanggan saya sepertinya juga menyukainya, dan saya bahkan melihat pembelian makin meningkat.","Name_Evaluation11_Home":"Siti","Job_Evaluation10_Home":"Pemilik toko lintas batas di Lazada & Shopee (Indonesia)","Name_Evaluation10_Home":"Nina","Job_Evaluation3_Home":"Desainer E-commerce DTC","Job_Evaluation8_Home":"Pemilik toko Produk Outdoor Walmart di Amerika","Name_Evaluation8_Home":"Jason","Job_Evaluation9_Home":"Seller Mercado Libre di Argentina","Desc_Evaluation7_Home":"Foto produk hewan peliharaan yang dibuat AI itu sangat lucu! Kucing dan anjingnya terlihat proporsional dan alami. Selain itu, ukuran dan skalanya sesuai dengan persyaratan platform, jadi gambarnya bisa langsung digunakan.","Job_Evaluation7_Home":"Pemilik toko Mercado Libre di Brasil","Desc_Evaluation8_Home":"Foto berkemah untuk produk tenda saya terlihat sangat realistis. Pencahayaan dan sudutnya terasa natural, dan proporsinya tepat sekali. Benar-benar menghemat banyak waktu dibandingkan kalau memotret semuanya sendiri.","Name_Evaluation7_Home":"Thiago","Desc_Evaluation9_Home":"Alat ini sangat cepat, dan foto yang dihasilkan pada dasarnya bisa langsung diunggah ke Mercado Libre dan Amazon tanpa perlu penyesuaian tambahan.","Desc_Evaluation6_Home":"Dulu saya khawatir AI tidak bisa menampilkan tekstur kain, tetapi ternyata teksturnya hampir tidak berbeda dari aslinya. Pakaian rajutan terlihat seperti aslinya, bahan denim juga, dan bahkan memenuhi persyaratan foto untuk Amazon. Saya bisa meluncurkan produk baru jauh lebih cepat.","Name_Evaluation9_Home":"Lucas","Name_Evaluation6_Home":"Emma","Desc_Evaluation5_Home":"Foto produk yang dibuat AI sangat akurat. Panjang kabel dan bentuk konektornya tepat, bahkan sesuai dengan ketentuan TEMU. Sangat menghemat waktu dibandingkan kalau memotret sendiri.","Desc_Evaluation12_Home":"Hanya dengan satu prompt, saya mendapatkan grafis yang bisa digunakan secara instan, jauh lebih cepat daripada menunggu desainer. Jujur saja, ini sangat praktis.","Name_Evaluation3_Home":"Chloe","Name_Evaluation1_Home":"Sofia","Desc_Evaluation4_Home":"Tekstur metalik dan detail strukturalnya sangat jelas, sehingga membuat foto terlihat profesional. Saya bisa langsung menggunakannya tanpa perlu mengedit lagi.","Name_Evaluation4_Home":"Leon","Desc_Evaluation10_Home":"Pemrosesan massal sangat praktis. Saya bisa memproses puluhan SKU sekaligus, dan jauh lebih cepat daripada melakukannya secara manual.","Name_Evaluation2_Home":"Mariana","Desc_Evaluation3_Home":"Aku menjual pakaian, dan aku takut AI tidak bisa menampilkan warna atau tekstur kain dengan benar, tapi ternyata hasilnya luar biasa! Pose modelnya terlihat natural, dan pada dasarnya semua foto langsung siap digunakan.","Job_Evaluation1_Home":"Spesialis operasional toko SHEIN","Name_Evaluation5_Home":"Diego","Job_Evaluation11_Home":"Spesialis Operasional Amazon","Desc_Evaluation2_Home":"Alat ini sangat cepat, dan pada dasarnya hasil fotonya sudah siap diunggah ke Mercado Libre atau Amazon. Bahkan, alat ini bisa menyesuaikan latar belakang dan model dengan selera lokal, dan hasilnya terlihat sangat profesional.","Job_Evaluation4_Home":"Seller eBay di Jerman","Title_Evaluation_Home":"Kisah Pengguna","Title_Introduction_Home":"Desain AI premium yang meningkatkan penjualan lebih tinggi","Desc_Qualification_Home":"Penyedia Layanan Bersertifikasi SPN Amazon","Title_Seo_Home":"AI Pembuat Foto & Video Produk untuk E-commerce","Desc_Seo_Home":"Buat foto produk, poster, dan video secara instan untuk Amazon, TikTok, dan toko online lainnya dengan Agen AI Designkit. Mulai desain secara gratis sekarang!<br>","Keywords_Seo_Home":"Agen AI untuk E-commerce, Alat AI E-commerce, AI Pembuat Foto Produk, AI Pembuat Video Produk, AI Editor Foto Produk, AI Penghapus Background","Title_Features1_Home":"Dari satu permintaan menjadi satu rangkaian visual lengkap","Title_Features2_Home":"Lokalisasi sepenuhnya otomatis untuk menjual produk secara global di berbagai platform","Title_Features3_Home":"Buat foto otomatis dalam jumlah besar untuk beberapa SKU dan kalahkan para kompetitor!","Title_Designkit_Home":"Designkit","Tips_AboveTheFold2_Home":"Gulir untuk mengeksplorasi","Tips_Material1_Home":"Set foto daftar","Tips_Material2_Home":"Coba pakaian virtual","Tips_Material3_Home":"Konten A+","Tips_Material4_Home":"Pembuat background","Free_Button_Home":"Coba gratis","Title_Header1_Home":"Produk","Title_Header2_Home":"solusi","Title_Header3_Home":"Inspirasi","Title_Header4_Home":"Pelajari","Title_Header5_Home":"Harga","SecondTitle_Header1_Home":"AI Agen E-Commerce","SecondTitle_Header2_Home":"AI Alat Foto","SecondTitle_Header3_Home":"AI Alat Video","SecondTitle_Header4_Home":"Solusi Desain Amazon","SecondTitle_Header5_Home":"Solusi E-Commerce Media Sosial","SecondTitle_Header6_Home":"AI Pembuat Foto Produk","SecondTitle_Header7_Home":"AI Pembuat Model Fashion","SecondTitle_Header8_Home":"Ganti Warna Baju","SecondTitle_Header9_Home":"Pembuat Video Produk","SecondTitle_Header10_Home":"Alat AI","SecondTitle_Header11_Home":"AI Editor Foto","SecondTitle_Header12_Home":"AI Editor Foto Online","SecondTitle_Header13_Home":"Editor Foto Massal","SecondTitle_Header14_Home":"AI Editor Foto Massal","SecondTitle_Header15_Home":"Restorasi Foto Banyak","SecondTitle_Header16_Home":"Penghapus Watermark Massal","SecondTitle_Header17_Home":"Pembuat Background Massal","SecondTitle_Header18_Home":"Penghapus Background Massal","Title_Footer3_Home":"Alat Desain","Subtitle_Footer8_Home":"AI Editor Foto","Subtitle_Footer7_Home":"AI Ganti Background","Subtitle_Footer9_Home":"Background Transparan","Subtitle_Footer10_Home":"Ganti Warna Background","Subtitle_Footer11_Home":"Penghapus Watermark Foto","Subtitle_Footer12_Home":"Hapus Teks di Foto","Subtitle_Footer13_Home":"Tambah Stiker di Foto","Subtitle_Footer14_Home":"Tambah Watermark di Foto","Title_Footer4_Home":"Model Foto","Subtitle_Footer15_Home":"Nano Banana Pro (Gemini 3.0 Pro)","Title_Footer5_Home":"Unduh Gratis","Subtitle_Footer16_Home":"APP iOS","Subtitle_Footer17_Home":"APP Android","Title_Footer6_Home":"Follow Kami","Subtitle_Footer18_Home":"Kling 3.0","Subtitle_Footer19_Home":"Seedance 2.0","Title_Footer7_Home":"Model Video","Button_Export":"Unduh","Title_Layer":"Layer","InputNumber_Opacity":"Keburaman","Buttom_Comfirm":"Konfirmasi","Button_Share":"Bagikan","Button_Delete":"Hapus","Title_LoginPopup":"Login untuk memulai uji coba","SubTitle_LoginPopup":"Mulai berkarya dengan Zawa sekarang","Tip_ModalTitle":"Pengingat","TipContent_HistoryDelete":"Data yang telah dihapus tidak dapat dikembalikan. Konfirmasikan penghapusan?","Title_Logo":"Logo","Title_BrandKit":"Templat","Tab_BrandKit":"Kit Merek","Tab_UploadLocal":"Pilih dari album","Button_UploadImage":"Unggah Foto","Button_UploadProductImage":"Unggah Foto Produk","Button_UploadReferImage":"Unggah Referensi","Tip_ClickDragParseImage":"Unggah, seret, atau rekatkan foto di sini.","Tip_UploadMax":"Unggah file JPG, JPEG, atau PNG berukuran maks ${0} MB, maksimal N gambar.","Tooltip_SwitchBrandKit":"Ganti kit merek","Discribe_BrandKitSelect":"Pilih gaya merek sebagai referensi untuk desain ini.","Title_Models":"Model","Switch_Auto":"Otomatis","Tab_Image":"Foto","Tab_Video":"Video","MenuItem_AddToBrandLogo":"Simpan sebagai logo merek","MenuItem_AddToBrandTemplate":"Simpan sebagai templat merek","Button_ExportImage":"Impor foto","Button_ExportMedia":"Impor video","Button_ExportFromBrandkit":"Impor dari Kit Merek","Dropdown_AddFromBrandkit":"Tambahkan dari Kit Merek","Placeholder_ChatInput":"Mari mulai!","MenuItem_AiChange":"AI Pengeditan","MenuItem_AiExpend":"AI Perluas","MenuItem_AiHD":"AI Kejernihan","MenuItem_Eliminate":"AI Penghapus","MenuItem_SplitLayers":"Pisahkan Layer","MenuItem_Cutout":"Penghapus BG","MenuItem_ChangeText":"Edit Teks","MenuItem_Crop":"Ukuran Gambar","MenuItem_AddToChat":"Tambah ke Obrolan","MenuItem_AddToBrand":"Tambah ke Kit Merek","Tooltip_Layer":"Layer","Tooltip_Grab":"Alat tangan","Tooltip_Select":"Pilih","Tooltip_Redo":"Ulangi","Tooltip_Undo":"Batalkan","Tooltip_Add":"Tambah","Tooltip_ShowAll":"Tampilkan semua","Tip_UploadType":"Format file tidak didukung","Tip_UploadSize":"Hanya mendukung file berukuran maks ${0} MB","Tip_UploadWH":"Pastikan setiap gambar tidak lebih dari ${0}×${1} piksel","Tip_UploadTypeTranslate":"Gagal mengubah format file","Tip_UploadFail":"Unggahan gagal","Tooltip_AddText":"Tambah teks","Text_AddDefault":"Ini adalah teks contoh.","Tooltip_OverflowImageSize":"Ubah ukuran gambar sehingga maks ${0} piksel","Placeholder_ImageFusion":"Jelaskan bagaimana foto tersebut harus digabungkan","Button_ImageFusion":"Gabungkan","Button_Cancel":"Batal","Button_AiChange":"Edit","Placeholder_AiChange":"Jelaskan apa yang ingin diubah","Button_Eliminate":"Penghapus","Label_OriginSize":"Original","Label_CropRadio":"Rasio aspek","Button_Free":"Bebas","Button_Origin":"Original","Button_Crop":"Pangkas","Placeholder_ChangeText":"Masukkan teks. Contoh: Halo","Button_ChangeText":"Konfirmasi","InputNumber_PanSize":"Ukuran kuas","Label_TargetSize":"Target","Tooltip_ImageFusion":"${0}-${1} gambar bisa digabungkan","Title_Workspace":"AI Agent Anda\\nUntuk Konten Sosial","Button_Pro":"Dapatkan Pro Gratis","Title_NanoPro":"🍌🍌Nano Banana Pro kini tersedia di Zawa.","Dropdown_AdvancedFeatures_Title":"Fitur Lanjutan","Dropdown_AdvancedFeatures_Conent":"Akses penuh ke semua alat yang didukung AI untuk meningkatkan efisiensi.","Dropdown_MassiveContent_Title":"Konten Lengkap","Dropdown_MassiveContent_Content":"Akses premium sepuasnya ke templat dan jajaran aset stok Plus.","Dropdown_CommercialRights_Title":"Hak Komersial","Dropdown_CommercialRights_Content":"Gunakan kreasi pribadi dengan percaya diri, didukung oleh jaminan perlindungan hak cipta.","Popup_SubscribeIntl_Desc":"Dapatkan manfaat maksimal dari Zawa dengan Pro","Popup_SubscribeIntl_Desc1":"Lebih banyak berkreasi dengan kredit","Popup_SubscribeIntl_Detail":"Lihat detail paket & Bantuan","Popup_StripeCheckout":"Checkout Stripe","Popup_LiveSupport":"Dukungan langsung","Popup_CancelAnytime":"Bisa dibatalkan sewaktu-waktu","Menu_Language":"Bahasa","Menu_ManageSubscription":"Kelola Langganan","Menu_TermsPolices":"Ketentuan dan Kebijakan","Menu_ManageSubscriptions":"Kelola Langganan","Menu_ReferralLink":"Tautan Referral","Menu_BenefitsUpgraded":"Manfaat","Menu_TermsPolicies":"Ketentuan dan Kebijakan","Menu_AccountManagement":"Akun","Title_ReferralCode":"Kode Referral","Title_ReferralLink":"Tautan Referral","Desc_NoActiveSubscription":"Tidak ada langganan aktif","Button_ClickToSubscibe":"Klik di sini untuk berlangganan","Title_SubscriptionCancel":"Langganan telah dibatalkan","Title_SeeYou":"Sedih sekali Anda pergi...😭","Desc_NextBillingDate":"Perpanjangan pada","Desc_EstimatedAmount":"Estimasi total","Button_CancelSubscription":"Batalkan langganan","Button_StaySubscribed":"Tetap berlangganan","Title_ReasonCancelling":"Harap pilih alasan pembatalan:","Desc_BenefitsContinue":"Anda masih bisa menikmati manfaat keanggotaan hingga akhir periode langganan.","Desc_GiftedCredits":"Setelah langganan berakhir, kredit yang diberikan","Desc_SeeYou":"Terima kasih telah memilih kami. Kami sedih melihat Anda pergi.","Desc_NoNoreCharges":"Anda tidak akan lagi ditagih biaya, dan keanggotaan akan tetap aktif hingga","Desc_MayBeRevoked":"dapat ditarik kembali.","Desc_CancelingNoRefund":"Pembatalan <span>tidak termasuk refund<span>. Untuk pertanyaan terkait refund, silakan hubungi layanan dukungan online.","Button_ClearSelection":"Batal pilih","Button_Confirm":"Konfirmasi","Message_Processing":"Memproses...","Title_Opacity":"Keburaman","Button_ExpandImage":"Perluasan","Button_ExpandRadio":"Rasio aspek","Title_NoDesigns":"Belum ada desain.","Title_NoGenerations":"Belum membuat apa pun.","Desc_NoDesigns":"Desain Anda akan ditampilkan di sini.","Desc_NoGenerations":"Pemrosesan akan ditampilkan di sini.","Title_DeleteDesign":"Hapus desain ini","Popup_DeleteDesign":"Yakin ingin menghapus desain ini secara permanen? Tindakan ini tidak dapat dibatalkan.","Message_SaveFail":"Gagal menyimpan","Title_Pricing":"Pilih Paket yang Tepat","Title_Tags1_Pricing":"Bulanan","Text_Discount_Pricing":"Diskon ${0}","Title_Tags2_Pricing":"Tahunan","Title_Plan1_Pricing":"Bebas","Current_Plan_Pricing":"Paket saat ini","Title_Instruction1_Pricing":"Dapatkan 20 kredit untuk login perdana","Title_Instruction2_Pricing":"Buat maksimal 20 foto dengan Agen AI","Title_Instruction3_Pricing":"Buat maksimal 10 foto dengan AI Background","Title_Rights1_Pricing":"Penghapusan background atau objek terbatas","Title_Rights3_Pricing":"Penyempurnaan gambar HD terbatas","Title_Plan2_Pricing":"Paket Dasar","Month_Plan_Pricing":"bulan","Title_Button1_Pricing":"Berlangganan","Title_Instruction4_Pricing":"500 kredit/bln","Title_Instruction5_Pricing":"Buat maksimal 500 foto dengan Agen AI","Title_Instruction6_Pricing":"Buat maksimal 250 foto dengan AI Background","Title_Plan3_Pricing":"Paket Pro","Desc_Plan_Pricing":"Uji coba gratis 7 hari. Lalu ${0}/tahun.","Title_Button2_Pricing":"Uji coba gratis 7 hari","Title_Instruction7_Pricing":"1.500 kredit/bln","Title_Instruction8_Pricing":"Buat maksimal 1.500 foto dengan Agen AI","Title_Instruction9_Pricing":"Buat maksimal 750 foto dengan AI Background","Title_Rights4_Pricing":"Penghapusan background atau objek sepuasnya","Title_Rights5_Pricing":"Gunakan fitur AI penghapus sepuasnya","Title_Rights6_Pricing":"Penyempurnaan gambar UHD sepuasnya","Title_Rights7_Pricing":"Alat pemrosesan massal","Title_Best_Pricing":"Dipilih oleh 90% pengguna","Title_AllFeatures_Pricing":"Bandingkan Paket Gratis dan Berbayar","Desc_AllFeatures_Pricing":"Beli Premium untuk membuat desain menakjubkan dengan mudah menggunakan alat AI canggih","Month_AllFeatures_Pricing":"bulan","Title_Features1_Pricing":"Agen AI","SubTitle_Features1_Pricing":"Pengeditan Gambar","SubTitle_Features15_Pricing":"Buat maks ${0} gambar","SubTitle_Features16_Pricing":"Buat maks ${0} gambar/bln","SubTitle_Features2_Pricing":"Pembuatan Gambar","SubTitle_Features3_Pricing":"Pembuatan Gambar E-commerce","SubTitle_Features4_Pricing":"Pembuatan Poster","Title_Features2_Pricing":"AI Alat Foto","SubTitle_Features5_Pricing":"AI Penghapus Background","SubTitle_Features17_Pricing":"Penggunaan terbatas","SubTitle_Features19_Pricing":"Penggunaan sepuasnya","SubTitle_Features6_Pricing":"AI Penghapus Objek","SubTitle_Features7_Pricing":"Penyempurna Foto","SubTitle_Features18_Pricing":"Penggunaan terbatas (HD)","SubTitle_Features20_Pricing":"Penggunaan sepuasnya (HD/UHD)","SubTitle_Features8_Pricing":"AI Zoom Foto","SubTitle_Features9_Pricing":"AI Perluas Gambar","SubTitle_Features10_Pricing":"AI Background","Title_Features3_Pricing":"Fitur Desain Lainnya","SubTitle_Features11_Pricing":"Fitur dan Templat Lanjutan","SubTitle_Features12_Pricing":"Hapus Watermark","SubTitle_Features13_Pricing":"AI Alat Foto Massal","SubTitle_Features14_Pricing":"Fitur Desain Dasar","Title_Credits_Pricing":"Kredit habis? Kami siap membantu.","Desc_Credits_Pricing":"Pembelian satu kali, tanpa harus berlangganan.","TransactionPrice_Credits_Pricing":"Harga: ${0}","Credit_Credits_Pricing":"Kredit","Popular_Credits_Pricing":"Terpopuler","Buy_Credits_Pricing":"Beli Sekarang","Title_FAQ_Pricing":"Tanya-Jawab","Title_Button4_Pricing":"Upgrade sekarang untuk uji coba gratis 7 hari","SubTitle_FAQ1_Pricing":"Apa itu kredit?","Content_FAQ1_Pricing":"Kredit digunakan untuk mengakses alat AI. Jumlah kredit yang dibutuhkan bervariasi tergantung jenis alatnya.","Content_FAQ2_Pricing":"Kredit yang dibeli berlaku selama satu tahun.","Content_FAQ3_Pricing":"Kredit keanggotaan berlaku selama periode keanggotaan.","SubTitle_FAQ2_Pricing":"Bagaimana cara membatalkan langganan dan bagaimana dengan kredit saya setelah pembatalan?","Content_FAQ4_Pricing":"Setelah membatalkan langganan,","Content_FAQ5_Pricing":"Kredit keanggotaan Anda akan tetap berlaku hingga masa keanggotaan berakhir. Kredit yang dibeli secara terpisah tidak akan terpengaruh.","Content_FAQ6_Pricing":"Jika Anda perlu membatalkan langganan, silakan ikuti langkah-langkah di bawah ini setidaknya 24 jam sebelum siklus penagihan berikutnya dimulai:","Content_FAQ7_Pricing":"1. Buka Designkit dan login.","Content_FAQ8_Pricing":"2. Masuk ke jendela pop-up langganan.","Content_FAQ9_Pricing":"3. Pilih \\"Kelola Langganan\\".","Content_FAQ10_Pricing":"4. Pilih paket saat ini dan klik \\"Batalkan Langganan\\".","Content_FAQ11_Pricing":"Langganan akan tetap aktif hingga akhir siklus penagihan saat ini. Jika Anda tidak dapat membatalkannya, harap ambil tangkapan layar dan segera hubungi dukungan online kami.","SubTitle_FAQ3_Pricing":"Apakah ada kebijakan refund?","Content_FAQ12_Pricing":"1. Garansi Uang Kembali 7 Hari:","SubTitle_FAQ4_Pricing":"Bagaimana cara mengupgrade atau mendowngrade langganan?","Content_FAQ25_Pricing":"1. Upgrade: Anda bisa langsung berlangganan ke paket yang lebih tinggi, dan akan berlaku segera. Langganan lama akan dibatalkan, dan sisa saldo yang ada akan direfund.","SubTitle_FAQ5_Pricing":"Apakah akan ada salinan invoice?","Content_FAQ27_Pricing":"Ada! Setelah pembayaran berhasil, Anda akan menerima email dari layanan penyedia pembayaran yang berisi invoice elektronik. Jika Anda tidak menerima email invoice, silakan hubungi tim dukungan kami.","SubTitle_FAQ6_Pricing":"Apa saja metode pembayaran yang didukung?","Content_FAQ28_Pricing":"Kami menggunakan Stripe untuk mengelola pembayaran dan langganan. Kami menerima semua kartu kredit utama, PayPal, dan Google Pay.","SubTitle_FAQ7_Pricing":"Bagaimana cara menghubungi dukungan?","Content_FAQ29_Pricing":"Email: support@designkit.com. Waktu respons: 3-10 hari kerja.","Content_FAQ13_Pricing":"Jika Anda membeli langganan dan belum menggunakannya dalam 7 hari, Anda mungkin memenuhi syarat untuk refund penuh.","Content_FAQ14_Pricing":"Jika Anda membeli kredit, Anda mungkin berhak mendapatkan refund untuk kredit yang tidak digunakan dalam waktu 7 hari.","Content_FAQ15_Pricing":"2. Ketidakpuasan terhadap Layanan","Content_FAQ16_Pricing":"Jika Anda tidak puas dengan hasilnya, silakan hubungi tim dukungan online kami. Kami mungkin memberikan kompensasi atau refund bergantung pada situasinya.","Content_FAQ17_Pricing":"3. Pembelian via Google Play atau App Store","Content_FAQ18_Pricing":"Jika Anda berlangganan melalui Google Play Store atau App Store, Anda perlu mengajukan refund langsung dari Google atau Apple.","Content_FAQ19_Pricing":"Catatan Penting:","Content_FAQ20_Pricing":"Kebijakan refund ini tidak berlaku untuk pengguna API. Jika Anda menggunakan API kami, silakan hubungi kami untuk kelayakan refund.","Content_FAQ21_Pricing":"Kami berhak menolak refund dalam kasus penyalahgunaan atau pelanggaran terhadap ketentuan kami.","Content_FAQ22_Pricing":"Refund dapat memerlukan beberapa hari kerja untuk diproses, tergantung metode pembayaran Anda.","Content_FAQ23_Pricing":"Kami dapat memperbarui kebijakan refund dari waktu ke waktu. Harap periksa secara berkala untuk melihat adanya perubahan.","Content_FAQ24_Pricing":"Untuk bantuan lebih lanjut, silakan hubungi tim dukungan kami.","Content_FAQ26_Pricing":"2. Downgrade: Pertama, batalkan langganan saat ini. Setelah periode penagihan selesai, silakan berlangganan paket baru.","Content_Modal_Pricing":"Terima kasih atas dukungan Anda! Bersiaplah untuk mengasah kreativitas Anda.","Tip_Modal_Pricing":"Tips: Jika keanggotaan Anda belum muncul, silakan muat ulang halaman.","Title_Modal_Pricing":"Berhasil dibeli","Title_Rights2_Pricing":"Penggunaan terbatas fitur AI Penghapus","Title_Button3_Pricing":"Manfaat yang tersedia","Title_Button5_Pricing":"Upgrade","Tool_ImageBgRemover":"Penghapus Background","Tool_AiBgGenerator":"AI Background","Tool_AiLogoGenerator":"Pembuat Logo","Tool_FootwearModel":"Model Alas Kaki","Tool_ImageTranslation":"Penerjemah Gambar","Tool_BatchImageBgRemover":"Penghapus Background Massal","Tool_BatchImageEnhancer":"Penyempurna Foto Banyak","Tool_BatchAiObjectsRemover":"Penghapus Objek Massal","Tool_VideoEnhancer":"Penyempurna Video","Tool_VideoBgRemover":"Penghapus Background Video","Tool_VideoWatermarkRemover":"Penghapus Watermark Video","Title_Models_Dropdown":"Model","Tips_Uninitialized_Chat":"Gagal mengirim pesan","Dropdown_AddImage":"Tambah foto","Action_SeeAll":"Lihat semua","Desc_Seedream":"Pembuatan gambar yang realistis dan detail.","Dropdown_AddVideo":"Tambah video","Tips_NotFound_Chat":"Obrolan tidak ada","Desc_Seedance":"Pembuatan video yang realistis dan ekspresif.","Dropdown_SupportedFormatFile":"Mendukung file Word, Excel, Teks, dan PDF.","Dropdown_Example_Option":"Contoh","Dropdown_NoReference_Option":"Tidak ada referensi tersedia","Menu_AgentCredits":"Kredit Agen","Desc_SeedEdit":"Pengeditan foto yang presisi dan natural.","Dropdown_BrandKit_Title":"Kit Merek","Desc_GeminiNanoBanana":"Pembuatan gambar yang cepat, dapat diedit, dan konsisten.","Dropdown_Models_Title":"Model","Dropdown_AddDocument":"Tambah dokumen","Dropdown_BrandKit_Desc":"Pilih gaya merek sebagai referensi untuk desain ini.","Desc_MidjourneyVideo":"Pembuatan video yang kreatif dan artistik.","Desc_MidjourneyImage":"Pembuatan gambar yang artistik dan imajinatif.","Dropdown_SaveAsBrandTemplate":"Simpan sebagai templat merek","Dropdown_SaveAsBrandLogo":"Simpan sebagai logo merek","BatchProcessTable_ImageType":"Jenis gambar","BatchProcessTable_PictureRequirement":"Detail desain","BatchProcessTable_CopywritingRequirements":"Deskripsi produk","BatchProcessTable_Proportion":"Rasio aspek","BatchProcessTable_Actions":"Tindakan","BatchProcessTable_AddOneRow":"Tambah","BatchProcessList_DeleteError":"Gagal menghapus","BatchProcessList_SurePrompt":"Hapus panduan ini?","BatchProcessList_SurePrompt_SureText":"Konfirmasi","BatchProcessList_SurePrompt_CancelText":"Batal","BatchProcessList_EmptyText":"Kosong","EditBatchProcess_NameLimitTip":"Masukkan nama (maksimal 10 karakter)","EditBatchProcess_Tip":"Perubahan pada panduan akan memengaruhi hasil yang dibuat.","EditBatchProcess_Start":"Mulai dengan panduan","EditBatchProcess_GenerateTip":"Unggah foto produk dan desain akan dibuat berdasarkan panduan yang diberikan.","Text_AdvanceSetting":"Ahli","Text_MainImage":"Gambar utama","Text_ProductAgentUploadGuide1":"1. Unggah beberapa foto dari berbagai sudut untuk sebuah produk agar AI bisa menangkap detail produk dengan lebih baik.","Text_ProductAgentUploadGuide2":"2. Maksimal 10 foto. Foto pertama akan digunakan sebagai referensi utama, jadi harap pilih angle yang terbaik.","Text_Optional":"(Opsional)","Tip_ClickDragImageWithSize":"Unggah foto format JPEG, JPG, atau PNG berukuran maks ${0} MB.","Button_AddReferenceImage":"Unggah Referensi","Title_ReferenceImage":"Referensi","Input_Placeholder":"Harap pilih","Radio_ReferenceColor":"Warna referensi","Radio_ReferenceLayout":"Layout referensi","Tag_FirstImage":"Gambar pertama","Tag_FirstImageNoPartial":"Gambar pertama parsial","Tag_Blur":"Blur","Tag_Jigsaw":"Kolase","Button_Understood":"Mengerti","Text_ReferenceImageIndex":"Gambar ${0} sebagai referensi","Text_ReferenceDimensions":"Gnakan ${0} dari referensi","Tag_Cropped":"Dipangkas","Tag_Underexposed":"Kurang terang","Tag_Blurry":"Blur","SelectOption_ColorPalette":"Palet Warna","SelectOption_Layout":"Layout","SelectOption_Fonts":"Fon","SelectOption_Style":"Gaya","SelectOption_ShapeElements":"Elemen Bentuk","Text_SocialMediaAgentUploadGuide":"Unggah produk unggulan terlebih dahulu. Pastikan foto jelas dan lengkap.","Video_SR_Success":"Memperjelas video","Video_Desubtitle_Success":"Menghapus subtitle","Video_Dewatermark_Success":"Menghapus watermark","Video_Process_Failed":"Pemrosesan gagal. Kredit akan dikembalikan ke akun.","Video_SR":"AI Penjernih","Video_Dewatermark":"Hapus Watermark","Video_Desubtitle":"Hapus Subtitle","Video_Task_Price_Estimate":"Diperlukan ${0} kredit","Video_SR_Start":"Sedang mempertajam... ${0} kredit akan digunakan.","Video_Dewatermark_Start":"Menghapus watermark... ${0} kredit akan digunakan.","Video_Desubtitle_Start":"Menghapus subtitle... ${0} kredit akan digunakan.","Video_Desubtitle_Start_VIP":"Menghapus subtitle...","Video_Dewatermark_Start_VIP":"Menghapus watermark...","Video_SR_Start_VIP":"Sedang mempertajam...","Text_Help_Center":"Pusat Bantuan","Title_Request":"Obrolan","Button_Continue":"Lanjutkan","Button_EditContent":"Edit pesan","Title_ChooseImageType":"Pilih jenis gambar yang dihasilkan (Beberapa opsi)","Button_BatchGenerate":"Dikonfirmasi. Jalankan templat sekarang.","Text_ChatCancelStatus":"Tugas dihentikan","Text_ChatRespondedStatus":"Pemrosesan tugas","BatchProcess_SaveSuccessTip":"Kit alur kerja Anda disimpan di sini.","Button_GotIt":"Mengerti","Title_Congrats":"Selamat","SubTitle_BrandCreate":"Kit merek perdana telah dibuat, saatnya mengeksplorasi potensinya!","Button_CheckUse":"Lihat sekarang","Chat_Prompt_Brand":"Buat poster promo","Tooltip_UseBrand":"Ganti atau tambahkan kit merek di sini!","Tooltip_PosterBrand":"Ketuk untuk membuat poster pertama berdasarkan kit merek","Popup_CreateBrand":"Buat merek dari awal","Desc_CreateBrand":"Buat logo yang menarik dan original dengan Agen AI kami.","Popup_UploadBrand":"Unggah informasi merek","Desc_UploadBrand":"Unggah info dan Zawa akan mempertahankan konsistensi setiap desain.","Title_BrandEntry":"Dapatkan personalisasi sistem merek sekarang","Desc_BrandEntry":"AI juga bisa menjadi penata gaya. Jawab beberapa pertanyaan dan dapatkan sistem merek lengkap sesuai visi Anda.","Tooltip_UseBrand_Agent":"Setelah kit merek diterapkan, desain akan secara otomatis mengacu pada logo, palet warna, dan gaya secara keseluruhan.","Tooltip_PosterBrand_Agent":"Siap mendesain dengan kit merek Anda sendiri","BatchProcess_createText":"Kit Alur Kerja","Label_NormalMode":"Dasar:","Label_AdvancedMode":"Lanjutan:","Text_NormalMode":"Dasar","Text_AdvancedMode":"Lanjutan","BatchProcess_DefaultPrompt":"Buat Gambar","Title_CreateBrand":"Tidak punya merek?","Title_UploadBrand":"Sudah punya logo?","Button_CreateBrand":"Buat merek","BatchProcess_EditContent":"Edit konten","BatchProcess_PleaseSelect":"Pilih kit alur kerja","BatchProcess_SelectTip":"Semua gambar yang diunggah akan diproses secara massal menggunakan kit alur kerja yang dipilih.","BatchProcess_ListEmptyTip":"Simpan kit alur kerja setelah dibuat untuk langsung membuat set serupa secara massal.","BatchProcess_Tip":"Kit Alur Kerja","BatchProcess_Generate":"Gunakan sekarang","BatchProcess_Save":"Simpan","BatchProcess_GeneratingFormula":"Membuat kit alur kerja...","BatchProcess_GenerateCancel":"Batal","BatchProcess_WorkFlowCreateError":"Gagal Membuat","ProductInfo_PleaseUploadImage":"Unggah foto produk","BatchProcess_IntelligenceGenerate":"Buat kit alur kerja","BatchProcess_CreateWorkflow":"Buat","BatchProcess_Formula":"Kit Alur Kerja","BatchProcess_WorkFlowSaveSuccess":"Kit alur kerja disimpan","ProductInfo_ImageSizeLimit":"Mendukung gambar maks ${0} MB","ProductInfo_ImageUpload":"Tambah foto produk","ProductInfo_UploadDemo":"Foto contoh","ProductInfo_ECPlatform":"Platform","ProductInfo_PleaseSelect":"Harap pilih","ProductInfo_InputCustomize":"Kustom","ProductInfo_CountryAndLanguage":"Wilayah/bahasa target","ProductInfo_Name":"Nama produk","ProductInfo_Desc":"Detail produk (Fitur/Ukuran/Skenario penggunaan)","ProductInfo_DescPlaceholder":"Masukkan informasi produk termasuk fitur, ukuran, skenario penggunaan, target audiens, dan lain-lain.","ProductInfo_NamePrompt":"Nama produk adalah ${0};","ProductInfo_ECPlatformPrompt":"Platform target adalah ${0};","ProductInfo_CountryAndLanguagePrompt":"Bahasanya adalah ${0};","ProductInfo_DescPrompt":"Detail produk adalah ${0}.","ProductInfo_PleaseInput":"Masukkan","Button_UnlockPro":"Dapatkan Pro","Button_UpgradeToPro":"Upgrade ke Pro","Button_RenewNow":"Perpanjang Sekarang","AgentEmpty_CaseUseBtn":"Gunakan","AgentEmpty_CaseRefreshBtn":"Segarkan","MenuItem_Effect":"Efek","MenuItem_Shadow":"Bayangan","MenuItem_Stroke":"Coretan","Title_ChangeText":"Ganti Teks","Button_Logout":"Logout","Message_ExtractText":"Mengekstrak teks","Message_ExtractTextError":"Gagal mengekstrak teks. Coba lagi.","Tip_CreditConsume":"Pemrosesan ini menggunakan ${0} kredit","Tip_EstimatedTime":"Siap dalam ${0} menit","BatchProcess_SaveSuccessTip_GotIt":"Mengerti","BatchProcess_SaveSuccessTip_Title":"Menggunakan Kit Alur Kerja","BatchProcess_SaveSuccessTip_Desc":"Kit alur kerja Anda disimpan di sini. Pilih salah satu kit untuk membuat gambar dengan cepat menggunakan templat yang disimpan.","BatchProcess_tutorial":"Tutorial","Text_HandTool":"Alat tangan","Text_Function":"Fungsi","Text_WindowsSystem":"Sistem Windows","Text_MacSystem":"Sistem Mac","Menu_KeyboardShortcuts":"Pintasan","Title_KeyboardShortcuts":"Pintasan","Text_Undo":"Batalkan","Text_MouseLeft":"Tombol mouse kiri","Text_Redo":"Ulangi","Text_Delete":"Hapus","Text_Cut":"Potong","Text_Copy":"Salin","Text_Paste":"Tempel","Text_PasteFixed":"Tempel di tempat","Text_CreateCopy":"Buat salinan","Text_SelectAll":"Pilih semua","Text_SelectMultiple":"Pilih banyak","Text_Group":"Grup","Text_Ungroup":"Pisahkan","Text_LockLayer":"Kunci","Text_Save":"Simpan","Text_Move":"Pindahkan","Text_MoveWithCombinedKeys":"Gerak cepat","Text_TouchEditFastMode":"Tunjuk untuk Mengedit Cepat","Text_Pan":"Geser Horizontal","Title_Canvas":"Kanvas","Title_Edit":"Edit","Title_Elements":"Elemen","Title_Tools":"Alat","Title_Blogs":"Blog","Text_NewText":"Teks baru","Text_NewLine":"Baris baru","Text_NewRectangle":"Kotak baru","Text_NewCircle":"Lingkaran baru","Text_ExitFullScreen":"Keluar layar penuh","Text_MoveUpOneLayer":"Majukan","Text_MoveDownOneLayer":"Mundurkan","Text_Top":"Letakkan di depan","Text_Bottom":"Letakkan di belakang","Text_CanvasZoom":"Perbesar/Perkecil","Text_ToggleReferenceLine":"Tampilkan/sembunyikan panduan","Text_ToggleRulerBar":"Tampilkan/sembunyikan penggaris","Text_ArrowKey":"Tombol panah","Text_CanvasShowAll":"Tampilkan semua kanvas","Title_Unsupported_Multilayer":"Fitur ini hanya berfungsi pada satu layer.","Btn_CreateBatchProcessFormula":"Buat","Button_Hide_Otherlayers":"Pertahankan layer pertama dan lanjutkan","Button_Merge_Alllayers":"Gabungkan semua layer dan lanjutkan","Checkbox_Disable_Remind":"Jangan tampilkan lagi","Button_Tool":"Alat","Button_Custom_Ratio":"Kustom","Label_Spacing":"Jarak","Button_Download_Whole":"Ekspor sebagai Gambar","Button_Download_Layer":"Ekspor Menurut Layer","Button_Origin_Ratio":"Original","Text_TouchEdit_Title":"Tunjuk untuk Mengedit","Text_TouchEdit_Description":"Tunjuk objek dan jelaskan perubahan yang diinginkan. Foto akan diedit persis sesuai prompt.","Tooltip_TouchEdit_Max_Count":"Bisa menunjuk maksimal ${0} area","Tooltip_TouchEdit_Usage":"Pintasan Tunjuk untuk Mengedit: ${0} + klik","Text_TouchEdit_Recognition_Custom":"Kustom","Text_TouchEdit_Recognition_Title1":"Deteksi dan kenali","Text_TouchEdit_Recognition_Title2":"Target tidak ditemukan. Masukkan nama objek.","Text_TouchEdit_Name":"Tunjuk untuk Mengedit","Btn_LoginToViewBatchProcess":"Login untuk melihat kit alur kerja","Btn_Login":"Login","Menu_Main_Beautify":"Sempurnakan","Text_Model_Pricing":"Harga Model","Text_Pro_discount":"Paket Pro: Pembuatan Video Setengah Harga","Text_TemplatePrompt":"Mari awali dengan inspirasi","Text_Hi":"Hai, ${0}!","Text_Account_Popup_Left":"Gunakan asisten AI desain khusus untuk e-commerce. Dirancang untuk para profesional yang menginginkan peluncuran lebih cepat, presentasi yang lebih kuat, dan profit yang lebih tinggi.","Text_PleaseWaitImageUploaded":"Lanjutkan setelah unggahan selesai","Menu_Redeem_Rights":"Tukarkan","Text_Redeem_Now":"Tukarkan Sekarang","Text_Redeem_Placeholder":"Masukkan kode penukaran, huruf besar dan kecil harus benar","Text_Redeem_Success":"Penukaran berhasil","Text_Redeem_Use":"Tukarkan kode","Tooltip_BrandAutoUse":"Kit merek baru telah diterapkan!","Redeem_Redeem_Note":"Catatan: \\nSilakan login dan masukkan kode penukaran.\\nSetelah penukaran berhasil, selamat menikmati manfaat dan layanan terkait.\\nGunakan kode penukaran selama masih berlaku. Kode yang telah kedaluwarsa akan dibatalkan dan tidak dapat direfund.\\nHarap simpan kode. Kami tidak bertanggung jawab jika kode hilang, bocor, atau digunakan tanpa izin. \\nKode ini tidak dapat dijual kembali atau ditransfer kepada orang lain, tidak dapat ditukar dengan uang tunai, dan tidak bisa digunakan untuk faktur.","Tooltip_Color_Fill":"Warna","Tootip_StartPoint":"Mulai","Tootip_ChangePoint":"Ganti","Tootip_EndPoint":"Selesai","Sidebar_NewDesign":"Obrolan baru","Retouch_Filter_Clear":"Bening","Retouch_Filter_Enhance":"Nyata","Retouch_Filter_Dehaze":"Hilangkan Kabut","Retouch_Filter_Texture":"Tekstur","Retouch_Filter_Nature":"Natural","Retouch_Filter_Fade":"Pudar","Modal_Button_Known":"OK","Modal_Button_GotIt":"Terima","Modal_Button_Later":"Lain kali","Text_Appeal_Confirm":"Ya","Text_Vip_Open":"Berlangganan","Text_Appeal_ReGenerate":"Hasil editan tidak memenuhi syarat untuk ditinjau.","Text_Appeal_Left":"Sisa percobaan bulan ini\\n<i>${0}</i>/${1}","Text_Appeal_Refunded":"Kredit telah dikembalikan ke akun.","MenuItem_Appeal":"Tinjauan Hasil","Tooltip_Downloading":"Mengunduh...","Tooltip_Download_Video":"Unduh video secara terpisah, satu per satu.","Tooltip_Download_NoneSelected":"Pilih konten yang ingin diunduh","Text_AI_Thinking":"AI sedang bekerja...","Text_Server_Busy":"Server sedang sibuk. Harap coba lagi nanti.","Text_Prompt_Help_Placeholder":"Ketikkan kata kunci, saya akan mengubahnya menjadi prompt yang siap digunakan.","Text_Prompt_Helping":"Sedang memproses... Harap tunggu.","Button_Retry":"Coba lagi","Button_Rewrite":"Coba lagi","Button_Start_Prompt_Help":"Mulai menulis","Title_Prompt_Helper":"AI Penulis","Menu_Text_Subscriptions":"Langganan","Menu_View_Subscriptions":"Lihat Langganan","Text_Download_XdesignApp":"Unduh aplikasi <span>Zawa</span> untuk menggunakan fitur","Text_Free_Trial":"Unduh Uji Coba Gratis 7 Hari","Text_Install_App":"Instal Aplikasi","Text_Scan_Download":"Pindai untuk mengunduh","Text_Download_the":"Unduh di","Text_Available_On":"Tersedia di","Desc_ExpireDate":"Berakhir pada:","DownloadApp_Title_Widgets":"Unduh aplikasi ${0} untuk menggunakan fitur","DownloadApp_SubTitle_Widgets":"Unduh Uji Coba Gratis ${0} Hari","InstallApp_Title_Widgets":"Instal Aplikasi","InstallApp_Desc_Widgets":"Pindai untuk mengunduh","AppStore_Desc_Widgets":"Unduh di App Store","GooglePlay_Desc_Widgets":"Tersedia di","Text_Tips_GetFree":"Kamu punya 1 kesempatan gratis","Text_AgentLib":"Aset","Tip_ModelSetSaveSuccess":"Gambar model telah disimpan! Ketuk untuk menggunakannya.","Text_BatchProcess":"Kit Alur Kerja","Button_Add":"Tambah","Tab_Recent":"Terakhir disimpan","Tab_Models":"Model Saya","Prompt_Model":"Gambar ${0} adalah model saya","Tip_SaveSuccess":"Disimpan","Text_ModelsLogin":"Login untuk melihat model","Loading_CheckFace":"Mendeteksi wajah...","Name_InitialModelName":"Model Saya","EmptyTip_ModelList":"Belum ada model. Mari buat model!","Text_UploadModel":"Unggah model","Text_Model":"Model","Tips_UnsupportedFormat":"Format file tidak didukung","Tips_InputModelName":"Masukkan nama","Tips_UploadModelImage":"Unggah gambar model","Title_CreateModel":"Buat model","Text_ModelName":"Nama","Placeholder_Input":"Masukkan","Text_UploadModelHint":"Klik untuk mengunggah atau letakkan gambar di sini<br>JPEG/JPG/PNG/HEIC/SVG","Button_SubmitUpload":"Unggah","Tips_NameLengthLimit":"Masukkan nama (maksimal ${0} karakter)","Tips_DeleteFailed":"Gagal menghapus","Title_ConfirmDeleteModel":"Hapus model ini?","Tips_CreateSuccess":"Model dibuat","Tab_BatchTemplate":"Kit Alur Kerja","Tab_MyModel":"Model Saya","Placeholder_InputContent":"Masukkan konten","Title_ChooseSceneType_VideoGenerateCard":"Pilih jenis konten dan struktur storyboard:","Button_ConfirmGenerate_VideoGenerateCard":"Mulai membuat video","Title_ShotType_VideoGenerateModal":"Jenis storyboard","Title_ShotRequirement_VideoGenerateModal":"Deskripsi storyboard","Title_Duration_VideoGenerateModal":"Durasi","Btn_AddOneTableRow":"Tambah","Label_Gender_ModelModal":"Gender","Label_Appearance_ModelModal":"Penampilan","Label_AgeGroup_ModelModal":"Kelompok usia","Label_Persona_ModelModal":"Peran","Label_BodyType_ModelModal":"Bentuk tubuh","Tips_GenerateModelFailed_ModelModal":"Gagal membuat. Harap coba lagi nanti.","Tips_NetworkError_ModelModal":"Kesalahan jaringan. Coba lagi nanti.","Tab_CustomModel_ModelModal":"Kustom","Tab_OfficialModel_ModelModal":"Resmi","Tab_UploadModel_ModelModal":"Unggah","Text_ModelPreview_ModelModal":"Pratinjau","Button_Generating_ModelModal":"Memproses...","Button_Regenerate_ModelModal":"Coba lagi","Button_Generate_ModelModal":"Buat","Button_Saving_ModelModal":"Menyimpan...","Button_SaveAndUse_ModelModal":"Simpan dan gunakan","Button_CreateNewModel_AgentLibList":"Model baru","Message_NotFilled_RequiredField":"Informasi ${0} wajib diisi","Title_ChooseSceneType2_VideoGenerateCard":"Pilih struktur storyboard","Title_ContentType_VideoGenerateCard":"Jenis konten","Title_StoryboardStructure_VideoGenerateCard":"Struktur storyboard","Text_Offical":"Resmi","Title_AboveTheFold_Main_HomeV2":"Buat setiap <br />foto produk <span>yang siap jual</span>","Title_Designkit_Slogan":"Buat foto produk yang siap jual","Button_StartFree_HomeV2":"Mulai Gratis","Title_AboveTheFoldMobile_Main_HomeV2":"Buat setiap produk <br /><span>yang siap jual</span>","SubTitle_AboveTheFoldMobile_HomeV2":"Dari pengeditan foto profesional hingga pembuatan daftar otomatis, semua yang kamu butuhkan ada di sini.","Text_TopBanner_HomeV2":"Seedance 2.0 segera hadir dengan akses unlimited","Title_ModuleCard_HomeV2":"Pertama, Hasilkan Aset Juara","SubTitle_ModuleCard_HomeV2":"Tiada lagi kanvas kosong. Gunakan Intelligent Creative Suite Agen AI kami untuk membuat rangkaian <br /> daftar lengkap, video dinamis, coba virtual, dan adaptasi global dalam hitungan detik.","Title_Faq_Q1_HomeV2":"Apakah tersedia uji coba gratis?","Text_Faq_A1_HomeV2":"Benar! Pengguna baru menerima 20 kredit gratis secara instan saat mendaftar. Selain itu, dapatkan 10 kredit gratis setiap hari dengan cara login. Pengguna bisa menguji semua fitur inti, termasuk pembuatan foto dan video, sebelum membeli paket berbayar.","Title_Faq_Q2_HomeV2":"Apakah hasil fotonya mematuhi pedoman Amazon/Shopify?","Text_Faq_A2_HOMEV2":"Jelas dong. Untuk foto produk unggulan, AI kami membuat background putih (RGB 255,255,255) yang diwajibkan oleh Amazon dan Shopify. Untuk foto lifestyle dan media sosial, AI ini memastikan dimensi yang sempurna dan kualitas resolusi tinggi agar produk memenuhi syarat dan tetap profesional.","Title_Faq_Q3_HomeV2":"Bisakah aset yang dihasilkan digunakan untuk tujuan komersial?","Text_Faq_A3_HomeV2":"Bisa. Semua foto dan video yang dibuat menggunakan paket berbayar 100% bebas royalti dan aman untuk penggunaan komersial. Pengguna berhak menggunakan aset ini di toko online Shopify, Amazon, iklan media sosial, dan kanal pemasaran lainnya tanpa batasan.","Title_Faq_Q4_HomeV2":"Bagaimana cara kerja pemrosesan dan pengeditan massal?","Text_Faq_A4_HomeV2":"Pemrosesan massal sudah terintegrasi dalam setiap fitur Designkit. Cukup unggah beberapa foto langsung ke workspace. Baik untuk membuat background lifestyle baru, menghapus background asli, menghapus objek yang menganggu, atau meningkatkan resolusi, terapkan tindakan yang dipilih ke seluruh foto dengan mudah. Ini memastikan aset yang konsisten untuk toko online sekaligus menghemat banyak waktu dibandingkan editing manual.","Title_Faq_Q5_HomeV2":"Apa saja format file yang didukung?","Text_Faq_A5_HomeV2":"Output video tersedia dalam format MP4, yang dioptimalkan untuk media sosial dan situs web e-commerce.","Title_Questions_Main_HomeV2":"Tanya-Jawab","Title_Scale_Main_HomeV2":"Siap Berkembang?","SubTitle_Scale_HomeV2":"Bergabunglah dengan 10.000+ seller yang mengotomatiskan alur kerja desain dengan Designkit.","Title_Evaluation_HomeV2":"Luncurkan Lebih Cepat & Jual Lebih Banyak","SubTitle_Evaluation_HomeV2":"Percepat waktu produksi hingga 90%. Dapatkan daftar yang terverifikasi tayang di Amazon dan Shopify lebih awal dibandingkan kompetitor.","Tab_Module_ProductImage_HomeV2":"AI Foto Produk","Desc_Module_ProductImage_HomeV2":"Ubah satu foto pemasok menjadi rangkaian daftar lengkap secara instan. Buat foto produk unggulan dengan background putih, foto lifestyle, dan infografis, sambil memproses ratusan SKU secara massal dengan mudah dan fitur terjemahan teks secara otomatis untuk pasar global.","Tip_Module_ProductImage_HomeV2":"Buat set daftar Amazon untuk headphone warna pink.","Tab_Module_ModelImage_HomeV2":"AI Model Fashion","Desc_Module_ModelImage_HomeV2":"Tidak punya model? Tidak masalah. Visualisasikan pakaian pada berbagai model buatan AI untuk meningkatkan rasio klik-tayang tanpa harus menjadwalkan sesi pemotretan mahal.","Tip_Module_ModelImage_HomeV2":"Pajang setelan kuning-hijau ini pada model wanita berusia 25 tahun.","Tab_Module_Video_HomeV2":"AI Video Produk","Desc_Module_Video_HomeV2":"Realisasikan produk. Buat tampilan produk yang dinamis, buat video penjelasan AI yang menarik, dan iklan yang menghasilkan konversi tinggi hanya dari sebuah teks atau satu foto. Tingkatkan minat dan dorong penjualan di berbagai platform e-commerce dan media sosial.","Tip_Module_Video_HomeV2":"Buat video produk untuk vas biru ini.","Tab_Module_DetailPage_HomeV2":"AI Halaman Detail Produk","Desc_Module_DetailPage_HomeV2":"Buat konten premium A+ dan banner promosi keren untuk toko online dalam beberapa menit saja, tanpa memerlukan keterampilan desain. Ubah foto produk dasar menjadi layout yang sangat menarik, dan dapatkan daftar produk unik yang berbeda dari kompetitor.","Tip_Module_DetailPage_HomeV2":"Buat halaman detail produk untuk sofa oranye ini.","Tab_Module_Photography_HomeV2":"AI Fotografi Produk","Desc_Module_Photography_HomeV2":"Buang foto stok umum. Pajang produk dengan pengaturan khusus sesuai merek dan selera pasar di Indonesia.","Tip_Module_Photography_HomeV2":"Buat background fotografi untuk parfum ini.","Title_Module_SecondTitle_HomeV2":"Sempurnakan Detailnya dengan AI yang Presisi","SubTitle_Module_SecondSubTitle_HomeV2":"Aset sudah dibuat? Sekarang sempurnakan. Gunakan AI Editor Foto kami untuk menghapus background, memoles kekurangan, dan meningkatkan resolusi foto secara massal.","Text_Upload_HomeV2":"Unggah","Text_TopBannerMobile_HomeV2":"Seedance 2.0 segera hadir","Text_Prompt1_HomeV2":"Buat set foto daftar lengkap Amazon.","Text_Prompt2_HomeV2":"Buat model yang mengenakan pakaian ini.","Text_Prompt3_HomeV2":"Buat video pemasaran produk.","Text_Prompt4_HomeV2":"Buat halaman detail produk Konten A+.","Text_Prompt5_HomeV2":"Buat background yang sesuai untuk foto produk.","Desc_Evaluation1_HomeV2":"Super cepat! Foto langsung siap diunggah ke Mercado Libre dan Amazon. Background dan model foto menyesuaikan selera lokal. Hasilnya benar-benar profesional.","Desc_Evaluation2_HomeV2":"Aku suka Designkit! Hasil fotonya terkesan nyata dan natural, nyaman dan bernuansa Nordik, cocok untuk toko lilinku. Daftar produk jadi terlihat rapi dan penjualan meningkat. Sangat sepadan.","Desc_Evaluation3_HomeV2":"Aku menjual pakaian dan khawatir foto AI tidak bisa menampilkan teksturnya dengan benar. Tapi Designkit top banget! Warnanya sempurna, pose modelnya terlihat natural, dan fotonya langsung siap dipakai.","Header_products_socialMediaPostGenerator":"Pembuat Postingan Media Sosial","Pricing_Seedance_UnlockLimited":"Dapatkan Akses Unlimited","Pricing_Seedance_SeedanceV1":"<span>Seedance 2.0</span> Akses Lebih Awal","Pricing_Seedance_SeedanceDesc":"Jadilah yang pertama membuktikan kecanggihan Seedance 2.0. Berlangganan salah satu paket Pro sekarang juga dan dapatkan akses unlimited eksklusif ke model AI generasi baru.","Pricing_Seedance_Monthly":"Bonus Paket Bulanan","Pricing_Seedance_DaysUnLimit":"7 Hari <span>Unlimited</span>","Pricing_Seedance_SeedanceV2":"Akses Seedance 2.0","Pricing_Seedance_BestValue":"PROMO TERBAIK","Pricing_Seedance_Yearly":"Bonus Paket Tahunan","Pricing_Seedance_MonthUnLimit":"1 Bulan <span>Unlimited</span>","Title_AIBrand_Tools":"Alat AI Branding","Title_AISocialMediaPosts":"Postingan Media Sosial","Title_AILogoMaker":"Pembuat Logo","Option_Child_Age":"Anak","Option_Infant_Age":"Bayi","Option_MiddleAged_Age":"Dewasa","Option_Senior_Age":"Lansia","Option_Teen_Age":"Remaja","Option_YoungAdult_Age":"Dewasa muda","Button_GenerateImages_DetailPageAction":"Buat","Text_GenerateImagesCount_DetailPageAction":"(${0} foto)","Text_GenerateImagesCount_DetailPageAction1":"(${0} foto)","Option_MercadoLivre_Platform":"Mercado Livre","Option_Etsy_Platform":"Etsy","Option_Walmart_Platform":"Walmart","Option_eBay_Platform":"eBay","Option_Poshmark_Platform":"Poshmark","Button_GeneratePlan_DetailPageAction":"Buat Desain Halaman Produk","Option_AdvancedMobile_DetailPageMode":"Premium A+ (Seluler)","Option_AdvancedWeb_DetailPageMode":"Premium A+ (Web)","Option_Standard_DetailPageMode":"Standar A+","Option_Accessories_DetailSection":"Aksesori/ Hadiah","Option_ServiceSupport_DetailSection":"Garansi","Option_BeforeAfter_DetailSection":"Sebelum & Sesudah","Option_BrandStory_DetailSection":"Kisah Merek","Option_KeyHighlights_DetailSection":"Sorotan Produk","Option_CraftProcess_DetailSection":"Tampilan Detail","Option_HeroVisual_DetailSection":"Foto Utama","Option_Composition_DetailSection":"Komponen","Option_MultiAngle_DetailSection":"Multisudut","Option_DetailCloseups_DetailSection":"Detail Produk","Option_SceneMood_DetailSection":"Gaya Hidup/Suasana Hati","Option_SeriesShowcase_DetailSection":"Seri Produk","Option_SizeCapacity_DetailSection":"Dimensi","Option_Specifications_DetailSection":"Lembar Spesifikasi","Option_UsageScenario_DetailSection":"Skenario Penggunaan","Option_UsageTips_DetailSection":"Panduan Penggunaan","Paragraph_ServicePolicy_DetailSection":"Kebijakan garansi, retur, dan penukaran","Paragraph_BeforeAfter_DetailSection":"Hasil sebelum dan sesudah penggunaan","Paragraph_BrandConcept_DetailSection":"Konsep dan nilai merek","Paragraph_CoreValue_DetailSection":"Menunjukkan nilai inti","Paragraph_CraftProcess_DetailSection":"Dari ilustrasi menjadi kenyataan","Paragraph_Differentiators_DetailSection":"Sorotan manfaat utama","Paragraph_Composition_DetailSection":"Bahan dan komponen yang digunakan dalam produk","Paragraph_MaterialAndCraft_DetailSection":"Sorotan bahan dan proses","Paragraph_MultiAngleAppearance_DetailSection":"Produk dilihat dari berbagai sudut","Paragraph_MultiOptionDisplay_DetailSection":"Variasi warna atau SKU","Paragraph_IncludedItems_DetailSection":"Semua sudah termasuk dalam paket","Paragraph_DetailData_DetailSection":"Detail spesifikasi","Paragraph_RealUsageScene_DetailSection":"Referensi penggunaan di kehidupan nyata","Paragraph_Specifications_DetailSection":"Panduan ukuran singkat","Paragraph_UsageNotes_DetailSection":"Catatan penggunaan dan pencegahan","Paragraph_UsageScenario_DetailSection":"Produk dalam konteks","Title_Nav_DetailPage":"Konten A+","Title_ImageSet_DetailPage":"Set Foto Detail Produk A+","Input_TaskName_Batch":"Masukkan nama tugas","Paragraph_FullAssetSetDescription_Batch":"Termasuk satu set lengkap aset pemasaran seperti foto utama, foto skenario penggunaan, dan foto dengan background putih yang dapat digunakan di berbagai platform.","Paragraph_LongFormVisualDescription_Batch":"Membuat storytelling visual untuk foto produk format panjang, halaman detail produk, dan foto perbandingan.","Message_JsonGenerated_Batch":"Formulir diverifikasi. JSON dibuat.","Message_JsonCopied_Batch":"JSON disalin.","Message_IncompleteRequiredFields_Batch":"Kolom wajib belum diisi. Silakan lengkapi formulir sebelum dikirim.","Message_PleaseUploadSourceImage_Batch":"Unggah foto produk.","Message_PleaseCompleteStrategySettings_Batch":"Selesaikan konfigurasi strategi","Message_TaskValidationFailed_Batch":"Tinjau dan selesaikan tugas yang belum diverifikasi.","Message_CopyJsonFailed_Batch":"Gagal menyalin. Harap periksa JSON di dasbor.","Message_PleaseEnterTitle_Batch":"Masukkan judul.","Message_PleaseEnterKeyHighlights_Batch":"Masukkan sorotan produk","Message_PleaseGenerateJsonFirst_Batch":"Silakan kirim untuk membuat JSON.","Title_DetailPage_Batch":"Halaman Produk A+","Title_DetailTask_Batch":"Tugas A+ ${0}","Title_IndependentParameters_Batch":"Konfigurasikan secara terpisah","Title_ImageSet_Batch":"Set Foto Ecommerce","Title_ItemTask_Batch":"Tugas Produk","Option_Curvy_BodyType":"Gemuk","Option_Muscular_BodyType":"Kekar","Option_PlusSize_BodyType":"Padat berisi","Option_Slim_BodyType":"Langsing","Option_Standard_BodyType":"Rata-rata","Button_Reset_Common":"Reset","Button_Back_Common":"Kembali","Button_Collapse_Common":"Susutkan","Button_Expand_Common":"Perluas","Button_Generate_Common":"Buat","Button_PreviousStep_Common":"Batalkan","Button_RemoveFavorite_Common":"Batalkan favorit","Button_StartNow_Common":"Coba sekarang","Paragraph_ExitWarning_Common":"Data akan hilang jika Anda keluar.","Paragraph_Content1_VirtualModelDisclaimer":"2. Harap dipahami bagaimana karakteristik dari konten yang dihasilkan AI. Konten yang dihasilkan AI dibuat berdasarkan algoritma dan pembelajaran data, dan hasilnya bisa bervariasi. Tampilan wajah yang dihasilkan oleh AI mungkin berbeda dari aset asli yang diberikan, dan mungkin ada ketidaksempurnaan serta hasil yang kurang memuaskan. Platform kami tidak menjamin keakuratan, kualitas visual, atau kecocokan dari konten yang dihasilkan.","Paragraph_Content2_VirtualModelDisclaimer":"3. Harap mengonfirmasi tanggung jawab pengguna. Anda bertanggung jawab atas foto berisi wajah dan konten yang dihasilkan. Anda harus memastikan bahwa penggunaan Anda tidak melanggar hak hukum pihak ketiga, termasuk, tetapi tidak terbatas pada hak publikasi, privasi, dan reputasi, serta bahwa penggunaannya mematuhi semua hukum dan peraturan yang berlaku. Anda tidak boleh menggunakan konten yang dihasilkan untuk tujuan yang melanggar hukum, melanggar hak orang lain (seperti pencemaran nama baik atau penipuan), atau melanggar ketertiban umum dan norma kesusilaan atau martabat orang lain.","Paragraph_Content3_VirtualModelDisclaimer":"Harap konfirmasikan bahwa Anda sepenuhnya memahami dan menyetujui ketentuan di atas sebelum mengunggah.","Title_Notice_VirtualModelDisclaimer":"Sebelum menggunakan fitur AI Foto Produk Coba Virtual, harap baca dan pahami berikut ini:","Message_FailedRetry_Download":"Gagal mengunduh. Harap coba lagi nanti.","Message_Failed_Download":"Pengunduhan gagal.","Message_Success_Download":"Pengunduhan selesai.","Message_NoImagesAvailable_Download":"Gambar tidak tersedia.","Option_Asian_Ethnicity":"Asia","Option_Black_Ethnicity":"Afrika","Option_Chinese_Ethnicity":"Tiongkok","Option_Latino_Ethnicity":"Hispanik atau Latino","Option_MiddleEastern_Ethnicity":"Timur Tengah","Option_SoutheastAsian_Ethnicity":"Asia Tenggara","Option_White_Ethnicity":"Putih","Option_Female_Gender":"Wanita","Option_Male_Gender":"Pria","FormLabel_Ethnicity_Common":"Ras dan Etnis","FormLabel_OriginalImage_Common":"Original","FormLabel_OutputLanguage_Common":"Bahasa","FormLabel_TargetMarket_Common":"Pasar","FormLabel_TargetPlatform_Common":"Platform","Option_German_Language":"Jerman","Option_Japanese_Language":"Jepang","Option_None_Language":"Tidak ada","Option_Portuguese_Language":"Portugis","Option_PortugueseBr_Language":"Portugis (Brasil)","Option_Russian_Language":"Rusia","Option_Spanish_Language":"Spanyol","Option_SpanishMX_Language":"Spanyol (Meksiko)","Option_Thai_Language":"Thailand","Option_Brazil_Market":"Brasil","Option_China_Market":"Tiongkok","Option_Europe_Market":"Eropa","Option_Germany_Market":"Jerman","Option_Japan_Market":"Jepang","Option_Russia_Market":"Rusia","Option_SoutheastAsia_Market":"Asia Tenggara","Option_Spain_Market":"Spanyol","Option_UnitedStates_Market":"Amerika Serikat","Message_MaxLimit_DetailSectionSelection":"Pilih maksimal ${0} bagian","Option_FollowGlobalSettings_Common":"Gunakan pengaturan global","Text_MaxTasks_Batch":"Tambahkan maksimal ${0} tugas","Text_MinTasks_Batch":"Pertahankan setidaknya satu tugas","Text_MaxImagesPerTask_Batch":"Unggah maksimal ${0} foto per tugas","Text_SupportedImageFormats_Batch":"Format gambar yang didukung: JPG, JPEG, PNG, HEIC, dan WebP.","Input_AppearanceDetailsExample_TryOn":"Misalnya: kulit gelap, poni lurus menutupi dahi, tahi lalat di dekat sudut mata...","Input_SourceInfoGuide_Batch":"Untuk hasil yang lebih akurat, harap cantumkan informasi berikut:\\n1. Nama produk\\n2. Sorotan produk\\n3. Audiens target\\n4. Skenario penggunaan yang dimaksud\\n5. Detail spesifikasi","Tooltip_OutputStyleConsistent_Clone":"Jika diaktifkan, semua foto warna dan gaya yang dihasilkan akan konsisten. Jika dinonaktifkan, setiap foto mengikuti gaya dari foto referensi.","Option_AlibabaInternational_Platform":"Alibaba","Option_AliExpress_Platform":"AliExpress","Option_Amazon_Platform":"Amazon","Option_Douyin_Platform":"TikTok","Option_DouyinEcommerce_Platform":"TikTok","Option_IndependentSite_Platform":"Shopify","Option_Indonesian_Language":"Bahasa Indonesia","Option_JD_Platform":"JD.com","Option_Pinduoduo_Platform":"Pinduoduo","Option_Taobao_Platform":"Taobao","Option_TaobaoTmall1688_Platform":"Taobao, Tmall, 1688","Button_Generate_ImageSet":"Buat Set Foto","Title_Nav_ImageSet":"Gambar Daftar","Message_GenerateFailedRetry_ImageSet":"Gagal memproses. Harap coba lagi.","Message_PleaseSelectStyleFirst_ImageSet":"Pilih gaya terlebih dahulu.","Message_CreateTaskFailed_ImageSet":"Gagal membuat tugas","Title_StyleAnalysis_ImageSet":"Analisis gaya tren","Option_TrafficMaximization_TitleStrategy":"Maksimalkan traffic","Option_ConversionPriority_TitleStrategy":"Utamakan konversi","Option_SceneImmersion_TitleStrategy":"Adegan imersif","Text_ExtractingVisualAttributes_TitleGenerationStatus":"Mengekstrak fitur utama dari aset...","Text_AnalyzingKeyHighlights_TitleGenerationStatus":"Membuat kata kunci dengan konversi tinggi berdasarkan sorotan produk...","Text_MatchingSeoStrategy_TitleGenerationStatus":"Menyesuaikan strategi SEO terbaik...","Text_GeneratingOptions_TitleGenerationStatus":"Membuat keterangan dari perspektif yang berbeda...","Message_TaskFailedWithStatus_TitleGeneration":"Tugas gagal (status: ${0}): ${1}","Message_TaskTimedOut_TitleGeneration":"Permintaan melewati batas waktu. Silakan coba lagi.","Message_GenerateFailed_TitleGeneration":"Gagal membuat judul. Silakan coba lagi.","Message_QueryResultFailed_TitleGeneration":"Gagal mengambil tugas","Paragraph_Content_VirtualModelConsent":"1. Otorisasi hak potret: Fitur ini menggunakan foto wajah yang diunggahuntuk membuat model wajah virtual menggunakan AI. Harap pastikan bahwa Anda memiliki hak atas foto yang diunggah atau telah memperoleh persetujuan tertulis yang sah dan jelas dari pemegang hak, untuk menggunakan potret tersebut dan konten yang dihasilkan untuk tujuan ini. Jika foto berisi anak di bawah umur, persetujuan dari wali mereka yang sah diperlukan.","Button_ConfirmTextChange_TextEdit":"Perbarui","Input_ModifyText_TextEdit":"Edit Keterangan","Message_NoImagesAvailable_ResultDownload":"Tidak ada foto yang tersedia untuk diunduh","Message_Failed_TextRecognition":"Gagal mengenali teks","Text_Generating_ResultStatus":"Memproses...","Option_CustomColor_SceneSetting":"Kustom","Option_UseOriginalBackground_SceneSetting":"Gunakan background original","Text_InsufficientCredits_Common":"Koin tidak cukup","Button_LoadMore_Common":"Muat Lainnya","Text_ImageUploadLimit_Common":"Unggah maksimal ${0} foto","Text_AnalyzingTrend_Common":"Menganalisis teks pada ${0}","Text_ChineseOutputProOnly_Common":"Pemrosesan teks Mandarin hanya tersedia di Pro. Teks telah dihapus dari hasil saat ini.","Text_SourceImageUploadLimit_Common":"Unggah maksimal ${0} foto","Text_WritingInProgress_AiWriting":"Memproses...","Text_DeepThinking_AiWriting":"Berpikir...","Text_ThinkingProcess_AiWriting":"Proses Berpikir:","Text_ImageSelectionLimit_Common":"Pilih maksimal ${0} foto","Message_RegenerationSubmitted_Regeneration":"Pembuatan ulang telah dikirim. Harap segarkan untuk melihat hasilnya nanti.","Button_MoreEditOptions_ResultEditor":"Lainnya","FormLabel_DetailSection_DetailPage":"Bagian Detail Produk","Message_GeneratePlanFailed_DetailPagePlan":"Gagal membuat rencana","Message_PlanGenerationFailed_DetailPagePlan":"Gagal membuat rencana","Text_PlanUnavailable_DetailPagePlan":"Tidak ada rencana yang tersedia","Message_SourceImageMissing_Common":"Foto produk tidak ada","Message_GenerationFailed_Common":"Pemrosesan gagal","Paragraph_ConfirmDiscardChanges_Common":"Perubahan akan hilang jika Anda kembali. Yakin ingin kembali?","Message_ProcessFailed_Common":"Gagal","Text_GeneratingEllipsis_Common":"Memproses...","Text_StyleGenerationInProgress_ImageSet":"Membuat gaya trending...","Message_FavoriteAdded_Common":"Ditambahkan ke Favorit","Message_FavoriteRemoved_Common":"Dihapus dari Favorit","Text_LoadingPlain_Common":"Memuat","Text_MultiSelectAvailable_Common":"Pilih banyak","Text_NoData_Common":"Tidak ada data tersedia","Text_NoDataAvailable_Common":"Tidak ada data","Text_NoMoreResults_Common":"Tidak ada konten lainnya","Message_PleaseEnterKeyHighlights_DetailPage":"Masukkan sorotan produk","Message_PleaseSelectAiModel_TryOn":"Pilih model AI","Message_SelectSectionMin_DetailPage":"Pilih minimal ${0} bagian","Message_SelectScenePoseMin_TryOn":"Pilih minimal ${0} pose dan postur","Message_PleaseSelectBaseModel_TryOn":"Pilih model dasar","Message_PleaseSelectCustomModel_TryOn":"Pilih model kustom","Message_PleaseSelectModel_TryOn":"Pilih model terlebih dulu","Message_PleaseSelectSection_DetailPage":"Pilih bagian","Message_SelectUploadCustomModel_TryOn":"Pilih atau unggah gambar model","Message_PleaseSelectScene_TryOn":"Pilih skenario","Message_PleaseSelectStrategy_DetailPage":"Pilih strategi","Message_PleaseUploadGarmentImage_TryOn":"Unggah foto pakaian","Message_UploadGarmentFile_TryOn":"Unggah foto pakaian","Message_PleaseUploadSourceImage_Common":"Unggah foto produk terlebih dulu","Message_PleaseUploadItemImage_Common":"Unggah foto produk","Message_UploadItemFirst_Common":"Unggah foto produk terlebih dulu","Message_RegenerateFailedWithReason_Regeneration":"Gagal membuat ulang:","Message_SelectResultImages_Result":"Pilih foto dengan hasil yang dibuat","Text_ReleaseToRefresh_Common":"Lepas untuk menyegarkan","Message_TextRecognitionFormatInvalid_TextRecognition":"Format tidak valid terdeteksi","Message_TextRecognitionParseFailed_TextRecognition":"Gagal memparsing hasil pengenalan","Message_TextRecognitionTaskFailed_TextRecognition":"Gagal mengenali teks","Message_QueryTaskStatusFailed_TextRecognition":"Gagal mengambil status tugas","Message_SubmitTaskFailed_TextRecognition":"Gagal mengirim tugas pengenalan teks","Text_RegenerationProcessing_Regeneration":"Permintaan pembuatan ulang telah dikirim. Sedang memproses...","Message_RegenerateFailedRetry_Regeneration":"Gagal membuat ulang. Harap coba lagi nanti.","Message_OpenEditorFailed_ResultEditor":"Gagal membuka editor","Message_RegenerateFailed_Regeneration":"Gagal membuat ulang","Message_RefreshFailedRetry_Common":"Gagal menyegarkan. Silakan coba lagi.","Message_UploadGarmentSelectModel_TryOn":"Unggah foto pakaian dan pilih model","Message_PollingTimedOut_Common":"Waktu kueri habis","Title_KeyHighlights_DetailPage":"Sorotan Produk","Title_FullStrategyGuide_DetailPage":"Panduan Strategi & Desain Lengkap","Title_IncludedSections_DetailPage":"Bagian","Title_IncludedSectionsMultiple_DetailPage":"Bagian (Pilih beberapa)","Title_ModelSelection_TryOn":"Pilih Model","Title_SectionContent_DetailPage":"Konten Bagian","Title_SectionStrategyGuide_DetailPage":"Panduan Strategi & Desain Bagian","Title_OutputAspectRatio_Common":"Rasio Aspek","Title_OutputSpecification_Common":"Spesifikasi","Title_SelectModel_TryOn":"Pilih model","Title_SelectScene_TryOn":"Pilih adegan","Title_StrategySettings_DetailPage":"Strategi","Title_UploadAssets_Common":"Unggah","Button_GenerateBaseModel_TryOn":"Buat model dasar","Button_GenerateRecommendedScenes_TryOn":"Buat adegan yang direkomendasikan","Button_GenerateSceneImages_TryOn":"Buat (${0} foto)","Text_GeneratingBaseModel_TryOn":"Membuat model dasar...","Option_CloseUp_Framing":"Close-up","Option_FullBody_Framing":"Seluruh badan","Option_HalfBody_Framing":"Separuh badan","Option_ThreeQuarter_Framing":"3/4","Title_Hero_TryOn":"AI Coba Online","Option_Ai_TryOnModelMode":"Buatan AI","Title_Nav_TryOn":"Coba Online","Option_Back_Perspective":"Kembali","Option_Front_Perspective":"Depan","Option_Side_Perspective":"Samping","Option_ThreeQuarterSide_Perspective":"Tampak 3/4","Input_AppearanceDetailsHint_TryOn":"Detail penampilan: kulit kecokelatan, poni lurus menutupi dahi, tahi lalat di dekat sudut mata…","Message_SaveToAlbumSuccess_Common":"Disimpan ke album","Text_GeneratingSceneImages_TryOn":"Membuat foto adegan...","Message_RefreshFailed_Common":"Gagal menyegarkan","Message_FailedRefunded_Generation":"AI desain gagal. Kredit telah direfund.","Title_BaseModelImage_TryOn":"Gambar Model Dasar","Title_CustomModel_TryOn":"Model Kustom","Paragraph_Intro_TryOn":"Unggah foto pakaian dan sesuaikan model untuk menghasilkan berbagai adegan dan pose.","Title_UploadGarmentImage_TryOn":"Gambar Pakaian","Tips_UploadFailedPure":"Gagal mengunggah","Tips_Uploading":"Mengunggah...","Text_UploadNewModel":"Model baru","Text_AllBackgrounds":"Semua Background","Text_DefaultTemplateScene":"Default","Text_ColorScene":"Warna","Text_SameProductMax_Common":"Maksimal ${0} foto per produk","Text_Max_Common":"Tambahkan hingga ${0} gambar — setiap referensi menghasilkan 1 output.","Button_Generate_ImageClone":"Mulai Buat","Button_RefreshStyle_Common":"Segarkan","Button_Favorite_Common":"Favorit","Text_PreviewLargeImage":"Pratinjau lengkap","Text_BaseImage":"Tolok ukur","Button_BatchDownload_Common":"Unduh massal","Button_BatchEdit_Common":"Edit massal","Button_BatchWatermark_Common":"Tambahkan watermark","Text_GeneratedResults":"Hasil","Button_DownloadAllImages_Common":"Unduh semua","Text_NoGeneratedResults":"Belum ada hasil","Text_SameProductMax_TryOn":"Pakaian lengkap atau foto sebuah item dari beberapa sudut, maksimal ${0} foto.","Title_AdvancedImageGenerationModel":"Model Foto Premium","Text_SupportChineseOutput_Common":"Mendukung output bahasa Mandarin dan detail dengan estetika serta kontrol kreatif yang lebih baik.","Text_SelectMultipleModules_DetailPage":"Pilih beberapa bagian untuk membuat halaman detail produk lengkap","Button_CollapseAll_Common":"Semua","Label_AppearanceDetails_TryOn":"Details Penampilan (Opsional)","Text_WaitingForGeneration_TryOn":"Pemrosesan ditunda","Title_SmartTitleAI_ProductTitle":"Buat Headline Viral","Message_ResultMissing_TitleGeneration":"${0} hasil yang dibuat AI tidak ada","Message_InvalidJSONFormat_TitleGeneration":"Hasil yang dikembalikan tidak valid","Message_InvalidJSONFormat_TitleGeneration1":"Format JSON yang dikembalikan tidak valid","Text_AutoGeneratedTitleScheme_ProductTitle":"Berikut adalah judul yang dibuat secara otomatis berdasarkan produk Anda","Text_SelectBestTitle_ProductTitle":"Pilih judul yang menarik dan klik untuk menyalin","Button_Copy_Common":"Salin","Message_PleaseUploadImage_Common":"Silakan unggah gambar terlebih dahulu","Text_DeepThinking1_AiWriting":"DeepSeek sedang bekerja...","Button_Rewrite1":"Coba lagi","Text_TotalImages_Common":"Jumlah: ${0}","Text_EditText_ResultEditor":"Edit teks","Text_NoTextRecognition_ResultEditor":"Teks tidak terdeteksi","Text_PreviewLongImage_ResultGroup":"Pratinjau foto panjang","Text_LimitFree":"Promo Kilat","Text_UploadSameProductTip1":"1. Unggah foto asli produk yang sama dari beberapa sudut agar AI dapat membuat ulang detail produk dengan lebih akurat","Text_UploadSameProductTip2":"2. Mendukung hingga ${0} gambar. Gambar pertama akan digunakan sebagai referensi utama, jadi pilih yang tampilannya paling lengkap.","Text_UploadProductImage_APlusCase":"Unggah foto produk","Text_GenerateEcommerceLongImage_APlusCase":"Buat foto panjang","Text_MultiPlatform_APlusCase":"Mematuhi berbagai standar platform e-commerce","Text_MainImage_ProductCase":"01 Foto Header (Background Putih/Standar)","Text_SceneDisplay_ProductCase":"02 Skenario Penggunaan","Text_ModelSceneImage_ProductCase":"03 Gambar Model","Text_DetailDescription_ProductCase":"04 Detail","Text_FeatureExplanation_ProductCase":"05 Sorotan Produk","Text_UploadProductImage_ProductCase":"Unggah foto produk dan AI akan langsung membuat set foto yang memiliki konversi tinggi <span>dan sesuai dengan standar berbagai platform e-commerce</span>.","Text_UploadGarmentImage_TryOn":"Unggah foto pakaian dan buat model kustom untuk langsung menghasilkan berbagai adegan dan pose.","Text_UploadProductImage_DetailPage":"Unggah foto produk dan AI akan langsung membuat halaman detail produk profesional <span>yang sesuai dengan berbagai standar platform e-commerce</span>.","Title_DetailPage_ProductCase":"A+/Halaman Detail Produk","Option_Temu_Platform":"Temu","Option_TikTokShop_Platform":"TikTok Shop","Option_TikTok_Platform":"TikTok","Option_Ozon_Platform":"OZON","Option_Shopee_Platform":"Shopee","Option_SHEIN_Platform":"SHEIN","Login_Zawa_Title":"Login dan dapatkan uji coba gratis","Login_DK_Title":"Buat desain keren secara Gratis","Login_Zawa_Des":"Mulai berkarya dengan Zawa sekarang","Login_DK_Des":"Daftar atau login untuk terus mendesain. Mulai sekarang!","Tab_Module_ProductImage_TryOn_MultiMix":"Padukan beberapa pakaian menjadi satu gaya","Tab_Module_ProductImage_TryOn_SingleHero":"Dari satu pakaian menjadi tampilan lengkap","Tab_Module_ProductImage_TryOn_Accessories":"Gaya aksesori yang sempurna","Text_ShowAdvancedModelTip":"Tampilkan tips model premium","Text_HideAdvancedModelTip":"Sembunyikan tips model premium","Text_DeepSeekR1HelpWrite":"Bantu saya menulis (DeepSeek R1)","Message_PollingMaxAttempts_Common":"Percobaan sudah melebihi maksimum ${0}","Title_StandardEdition":"Standar","Text_FastAndEfficient_Common":"Cepat dan Efisien","Text_PremiumEdition":"Premium","Text_QualityAndDetailEnhancement_Common":"Kualitas dan Detail Ditingkatkan","Text_PremiumEngineActivated":"<strong>Mesin premium diaktifkan:</strong> Mendukung output bahasa Mandarin dan detail dengan estetika serta kontrol kreatif yang lebih baik.","Text_EditBrand_DropTitle1":"Seret dan lepaskan file JPG, PNG, arau WEBP di sini,","Text_EditBrand_DropTitle2":"atau <>cari</> di komputer.","Text_BaseToolbar_AlignTop":"Rata Atas","Text_BaseToolbar_AlignBottom":"Rata Bawah","Text_LayerSort":"Urutkan","Text_BaseToolbar_AlignCenter":"Tengah","Text_Attr_Strong":"Tebal","Text_GeneratingPlan_DetailPagePlan":"Membuat rencana...","Text_PlanGenerationFailed_ReTry":"Gagal membuat rencana. Harap coba lagi nanti.","Button_StartAnalyze_ProductCase":"Mari Mulai","Message_SubmitSuccessTip_Batch":"Dikirim","Button_ClickAnalyze_ProductCase":"Analisis gaya bestseller","Button_StartAnalyzing_ProductCase":"Menganalisis","Title_ModelImage":"Model","Text_Cookie_Title":"Yang pertama, cookie 🍪","Text_Cookie_Content":"Kami ingin menggunakan cookie di situs web ini untuk memastikan keamanan, kinerja yang efisien, dan optimalisasi layanan. Untuk mempelajari lebih lanjut tentang bagaimana kami menggunakan cookie, silakan klik","Text_Cookie_LearnMore":"Detail","Button_Cookie_Manage":"Kelola Cookie","Button_Cookie_Accept":"Setuju","Text_CookieModal_Title1":"Pengaturan Cookie","Text_CookieModal_Desc1":"Cookie adalah file teks kecil yang disimpan situs web di perangkat untuk membantu kami mengingat preferensi Anda, melacak lalu lintas situs web, dan meningkatkan layanan kami. Privasi Anda penting bagi kami, dan kami ingin Anda mengontrol data Anda. Di sini, Anda dapat menyesuaikan preferensi cookie untuk mengoptimalkan pengalaman browsing Anda. Harap dicatat bahwa mengubah pengaturan cookie dapat memengaruhi fungsionalitas dan layanan situs web kami.","Text_CookieModal_Title2":"Cookie Penting","Text_CookieModal_Desc2":"Cookie ini penting untuk fungsionalitas, keamanan, dan kinerja inti situs web. Tanpa cookie ini, fitur utama dan langkah keamanan Zawa tidak akan berfungsi dengan baik, dan dapat berdampak negatif pada pengalaman Anda.","Text_CookieModal_Title3":"Cookie Opsional","Text_CookieModal_Desc3":"Cookie ini membantu kami memahami jumlah pengguna Zawa, dari mana mereka berasal, dan bagaimana mereka menggunakan situs web. Jika Anda memilih untuk menonaktifkan cookie ini, kami tidak akan dapat mengumpulkan kritik dan saran untuk meningkatkan Zawa atau memberikan layanan yang lebih baik untuk Anda dan pengguna lainnya.","Button_CookieModal_Save":"Simpan","Text_CookieModal":"Selalu Aktif","Text_Agent_Chat_DK":"Masukkan ide di sini…","Text_Agent_Chat_XD":"Ingin mendesain apa","Radio_Color":"Palet","Radio_Layout":"Layout","Radio_Reference":"${0}","Radio_Posture":"Pose","Radio_Background":"Background","Language_Banner_Message":"Ingin berganti ke ${0}?","Language_Banner_Change":"Ya","Language_Banner_Other":"Bahasa lainnya","Title_ItemTaskWithIndex_Batch":"Tugas Produk ${0}","Title_DetailTaskPrefix_Batch":"Tugas A+","Text_CopiedTaskTitle_Batch":"${0} (Salin)","Message_SelectSectionMin_Batch":"Pilih minimal satu bagian.","Title_GlobalBatchSettings_Batch":"Pengaturan global (Terapkan ke tugas berikut)","Text_Parameters_Batch":"Parameter","Text_Modules_Batch":"Bagian","Title_KeyHighlights_Batch":"Sorotan Produk","Text_ModulesFollowGlobal_Batch":"Bagian - Gunakan Pengaturan Global","Title_SelectManagedBusinessType_Batch":"Pilih Jenis Tugas","Button_SubmitTask_Batch":"Kirim","Text_NewTaskCurrentCount_Batch":"Buat Tugas","Title_NotificationSettings_Batch":"Pemberitahuan","Title_ManagedMode_Batch":"Penjadwal","Button_SaveSettings_Batch":"Simpan pengaturan","Button_SaveAndContinueSubmit_Batch":"Simpan & kirim","Message_PhoneFormatInvalid_Batch":"Masukkan 11 angka nomor telepon yang valid.","Message_VerificationCodeSent_Batch":"Kode verifikasi dikirim. Kode ini berlaku selama 5 menit.","Message_VerificationCodeSendFailed_Batch":"Gagal mengirim. Harap coba lagi nanti.","Message_PleaseEnterCode_Batch":"Masukkan kode verifikasi.","Message_GetCodeFirst_Batch":"Dapatkan kode verifikasi terlebih dahulu.","Message_VerificationCodeExpired_Batch":"Kode verifikasi kedaluwarsa. Ajukan kode baru.","Message_SaveNotificationSettingsFailed_Batch":"Gagal menyimpan pengaturan pemberitahuan. Harap coba lagi nanti.","Text_WebMessageNotification_Batch":"Anda akan diberi tahu melalui pesan Web saat tugas selesai.","Title_AppPushRecommended_Batch":"Pemberitahuan Aplikasi (Disarankan)","Paragraph_AppPushDesc_Batch":"Lacak progres dan lihat hasil di ponsel secara real time. Simpan desain dalam genggaman dan jangan lewatkan kesempatan yang datang.","Text_AppDownloadQrCode_Batch":"Pindai untuk mengunduh aplikasi","Title_SmsNotification_Batch":"Pemberitahuan SMS","Placeholder_Phone11Digits_Batch":"11 angka nomor telepon","Placeholder_VerificationCode5Min_Batch":"Kode verifikasi","Text_SendingEllipsis_Batch":"Mengirim...","Text_RetryAfterSeconds_Batch":"Coba lagi dalam ${0} dtk","Button_GetVerificationCode_Batch":"Kirim Kode","Message_SubmitSuccess_Batch":"Dikirim","Message_SubmitFailedRetry_Batch":"Gagal mengirim. Harap coba lagi nanti.","Message_FormValidationPassed_Batch":"Konten valid","Message_CompleteNotificationSettingsFirst_Batch":"Harap atur pemberitahuan sebelum mengirim tugas.","Paragraph_CancelManagedTaskWarning_Record":"Tugas yang dijadwalkan akan dihapus permanen jika Anda membatalkannya sekarang.","Button_ConfirmCancel_Record":"Tetap batalkan","Message_CancelManagedTaskFailed_Record":"Gagal membatalkan. Harap coba lagi nanti.","Text_WaitingManagedGeneration_Batch":"Menjadwalkan tugas...","Text_WaitingManagedSubmit_Batch":"Mengantre","Message_NoExtendableImages_Result":"Gambar tidak tersedia","Text_IntelligentMultiSizeAdaptation_Result":"Ubah ukuran gambar agar pas dengan setiap layar","Button_IntelligentResize_Result":"Ubah Ukuran Pintar","Option_CustomSize_DetailPageMode":"Kustom","Title_AdvancedAPlus_DetailPageMode":"Premium A+","Title_ManagedModeLaunched_Batch":"Penjadwal siap membantu!","Text_ManagedModeSlogan_Batch":"Bekerja semalaman agar desain siap di pagi hari.","Title_BatchProduction_Batch":"Pemrosesan Massal","Paragraph_BatchProductionDesc_Batch":"Jalankan maksimal ${0} tugas bersamaan dan tingkatkan produktivitas dengan ${1}×.","Title_AiIntelligentExtraction_Batch":"AI Analisis","Paragraph_AiIntelligentExtractionDesc_Batch":"Menganalisis gambar dan otomatis membuat sorotan produk yang menghasilkan konversi tinggi.","Title_SaveCost20_Batch":"Hemat ${0}% kredit","Paragraph_SaveCost20Desc_Batch":"Anda dapat menjadwalkan tugas di malam hari dan menikmati penggunaan kredit dengan diskon.","重写":"Unduh Massal","Brand_AutoExtract_Button":"Ekstraktor Palet","Brand_AutoExtract_Success":"Palet diekstrak","Brand_AutoExtract_Failure":"Gagal mengekstrak palet. Harap coba lagi.","Brand_AutoExtract_Unavailable":"Tidak dapat mengekstrak palet warna.","Brand_AutoExtract_ConfirmTitle":"Ekstrak palet warna dari logo?","Title_ImageSetConfig_ImageSet":"Desain Daftar","Title_DefaultConfig_ImageSet":"AI Desain","Desc_DefaultConfig_ImageSet":"AI menganalisis gambar produk dan mencocokkan set gambar listing terbaik","Title_CustomConfig_ImageSet":"Desain Kustom","Desc_CustomConfig_ImageSet":"Sesuaikan jumlah gambar untuk setiap jenis. Pilih minimal ${0} gambar.","Label_WhiteBackground_ImageSet":"Gambar Background Putih","Desc_WhiteBackground_ImageSet":"Pamerkan produk dari berbagai sudut dengan background putih.","Label_Scene_ImageSet":"Adegan Gaya Hidup","Desc_Scene_ImageSet":"Tampilkan produk dalam skenario kehidupan nyata.","Label_SellingPoint_ImageSet":"Sorotan Produk","Desc_SellingPoint_ImageSet":"Tekankan fitur utama yang akan membuat produk diminati.","Label_Other_ImageSet":"Lainnya","Desc_Other_ImageSet":"Konten disortir otomatis untuk produk Anda, termasuk perbandingan, spesifikasi, dan aspek lainnya.","Tip_MinTotal_ImageSet":"Minimal ${0} gambar","Text_ManagedBatchEntry_Header":"Penjadwal","Option_Coupang_Platform":"Coupang","Option_Wayfair_Platform":"Wayfair","Button_Credit_Plan":"Paket Kredit","Text_Higher_Plan":"Sudah Paket Tinggi","Text_Try_Free":"Coba Sekarang hanya $0","Text_Plus_Plan":"Paket Plus","Text_Pro_Plan":"Paket Pro","Button_Generate_Short_Common":"Buat","Message_DuplicateTaskSubmitConfirm_Common":"Hasil sudah dibuat dengan pengaturan ini. Buat lagi?","Text_CreditUnit_Common":"Kredit","Text_NewUserDiscountDesc_Product":"${0} kredit untuk daftar pertama. ${2} kredit untuk setiap ${1} daftar tambahan.","Text_NewUserLimitedTag_Product":"Diskon Pengguna Baru","Text_OriginalPrice_Product":"Original: ${0} kredit","Tip_MaxTotal_ImageSet":"Maksimal ${0} gambar","Text_AddDocumentTips":"Mendukung file Word, Excel, Text, PDF dan Markdown","Tab_SolidColor":"Warna Solid","Tab_Gradient":"Gradien","Title_PresetGradient":"Preset","Title_PresetSolidColor":"Preset","Title_RecentlyUsed":"Baru saja digunakan","Title_Patterns":"Pola","Title_NoFill":"Tidak ada","Description_Brand_Reference":"Unggah poster atau aset seni favorit dan Zawa akan menggunakan gaya tersebut untuk membuat desain sesuai selera Anda.","Text_Generating":"Memproses...","Text_ChartSending":"Mengirim","Text_PeopleUnSupport":"Belum mendukung mode potret","Button_CancelManagedBatch_ResultGroup":"Batalkan tugas","Button_DownloadZip_ResultGroup":"Unduh ZIP","Button_DownloadLongImage_ResultGroup":"Unduh kombinasi","Text_ManagedTaskDispatchedCannotCancel_ResultGroup":"Tugas yang dikirim tidak dapat dibatalkan","Button_GlobalAiWriting_Batch":"AI Penulisan","Text_StandardModel_DistributionBatch":"Model Standar (Daftar Massal)","Text_StandardModelDescription_Batch":"Ideal untuk SKU dengan volume tinggi guna memaksimalkan jangkauan pasar.","Text_AdvancedModel_PremiumBatch":"Model Lanjutan (Daftar Tertarget)","Text_AdvancedModelDescription_Batch":"Gambar berkualitas premium yang ideal untuk profitabilitas berbasis presisi.","Message_MinSubmitTasks_Batch":"Kirimkan minimal ${0} tugas.","Message_OverwriteSellingPointsConfirm_Batch":"Bagian sorotan produk telah diisi dalam ${0} tugas. Bagaimana Anda ingin menerapkan hasil AI penulisan?","Button_OverwriteAll_Batch":"Ganti semua","Button_FillEmptyOnly_Batch":"Tidak lengkap saja","Message_NoEmptySellingPointsToFill_Batch":"Sorotan produk untuk semua tugas sudah selesai.","Message_AiWritingFailedRetry_Batch":"AI penulisan gagal. Harap coba lagi nanti.","Button_NewTask_Common":"Tugas baru","Message_Generating_Time":"Tugas akan berjalan semalaman (${0}-${1}). Cek lagi besok untuk melihat hasilnya.","Title_Total_Credits":"Total kredit","Text_Used_AllFeatures":"Berlaku untuk semua fitur","Daily_Present_Credits":"Gunakan kredit hari ini","Daily_Credits_Desc":"Klaim setiap hari. Berlaku sampai penghujung hari.","Text_Inactive":"Tidak aktif","Text_Inactive_Monthly":"${0} kredit akan kedaluwarsa dalam 30 hari ke depan","TITLE_GUIDE_CUTOUT_LITE":"Stempel atau logo terdeteksi","GUIDE_DESC_CUTOUT_LITE":"Gunakan Potong Stempel/Logo untuk pemotongan yang presisi","GUIDE_ACTION_CUTOUT_LITE":"Potong Stempel/Logo","TITLE_CUTOUT_LITE":"Potong Stempel/Logo","TIP_CUTOUT_LITE":"Memotong stempel atau logo secara akurat","PROCESSING_CUTOUT_LITE":"Membuat gambar...","AFTER_CUTOUT_LITE":"Hasil","Button_Previous":"Sebelumnya","Button_Next":"Selanjutnya","Button_Skip":"Lewati","Button_Apply":"Terapkan","Text_AgentExpert":"Ahli","Message_PleaseEnterLinkOrAsin_Clone":"Masukkan tautan atau ASIN","Message_LinkAnalyzeFailed_Clone":"Analisis tautan gagal","Message_UploadProductImageFirst_Clone":"Unggah foto produk terlebih dahulu","Message_ProductImageThumbGenerateFailed_Clone":"Gagal membuat thumbnail. Unggah lagi.","Message_UploadProductImageFirst_ProductCase":"Unggah gambar referensi atau tempelkan tautan produk","Message_ReferenceImageThumbGenerateFailed_Clone":"Gagal membuat thumbnail. Unggah lagi.","Title_ReferenceSource_Clone":"Referensi","Option_LinkAsin_Clone":"Tautan","Input_PasteProductLinkOrAsin_Clone":"Rekatkan tautan Amazon","Button_Parsing_Clone":"Menganalisis...","Button_Parse_Clone":"Analisis","Text_SupportAmazonTiktokLinks_Clone":"Mendukung tautan Amazon dan TikTok","Text_Cloning_ResultStatus":"Memproses...","Input_CloneRequirementOptional_Clone":"Persyaratan (Opsional)","Title_ProductOriginalImage_Clone":"Foto Produk","Title_CloneLevel_Clone":"Replikasi Gaya","Option_CompositionReference_Clone":"Cocokkan Gaya","Desc_CompositionReference_Clone":"Membuat adegan baru yang terinspirasi dari nuansa dan gaya referensimu.","Option_HighFidelityClone_Clone":"Pencocokan Referensi","Desc_HighFidelityClone_Clone":"Membuat ulang referensi Anda dengan sangat mirip, hanya produk dan teks yang diganti.","Label_OutputStyleConsistent_Clone":"Gaya Konsisten","Title_SupplementaryNotesOptional_Clone":"Instruksi tambahan (Opsional)","Input_SupplementaryNotesExample_Clone":"Contoh: Buat salinan produk dalam bahasa Inggris, pertahankan model yang sama, dan ganti hanya produknya.","Title_HotClone_Welcome":"Remix Gambar","Text_HotCloneDescription_Welcome":"Referensi viral Anda + foto produk Anda = gambar viral Anda sendiri","Text_DefaultTaskName_Clone":"Strategi Kloning Foto","Label_ProductImage_CloneCase":"Foto Produk","Label_ReferenceComposition_CloneCase":"Cocokkan Gaya","Label_HighFidelityClone_CloneCase":"Pencocokan Referensi","Tag_AiSmartMatch_ImageSet":"AI pencocokan pintar","Title_Date":"Tanggal","Title_Topic":"Tema","Button_Replace":"Ganti","Title_SingleCloneRequirement_Clone":"Persyaratan Individu","Text_UploadedReferenceImagesTip_Clone":"Persyaratan individu untuk setiap gambar referensi. Pengaturan default akan diterapkan jika persyaratan tidak ditentukan.","Label_ReferenceImageIndex_Clone":"Gambar referensi ${0}","Option_Mexico_Market":"Meksiko","Text_ParsingReferenceImages_Clone":"Menganalisis...","Text_ParseReferenceImagesSuccess_Clone":"Analisis selesai. ${0} gambar referensi diperoleh.","Text_Renew_Restore":"Kredit akan dipulihkan setelah langganan diperpanjang.","Title_UsageNotice_Clone":"Panduan Penggunaan","Text_UsageNoticeDescription_Clone":"Pastikan bahwa Anda memiliki hak resmi untuk menggunakan konten dari tautan ini. Hasil yang dibuat didasarkan pada analisis gaya AI dan hanya untuk referensi kreatif.","Label_ReadAndAgreeUsageNotice_Clone":"Saya menerima ketentuan di atas","Label_DoNotShowAgain_Clone":"Jangan tampilkan lagi","Text_InterceptModal":"Izinkan jendela pop-up untuk Designkit.","Text_InterceptModal_ThirdStep":"Klik \\"Selesai\\" untuk mulai menggunakan Designkit.","Text_InterceptModal_Desc":"Izinkan Designkit membuka beberapa jendela di browser.","Brand_StatusPopup_ProcessingTitle":"Zawa sedang mempelajari gaya merek Anda...","Brand_StatusPopup_FailedTitle":"Gagal mengekstrak data dari Square. Coba lagi nanti.","Brand_StatusPopup_Retry":"Coba lagi","SecondTitle_Header19_Home":"Kloning Iklan Video","SquareBrandGuide_BrandKitCreatedTip":"Kit merek Anda telah dibuat berdasarkan data Square","SquareBrandGuide_DefaultPrompt":"Desain poster produk untuk promosi di media sosial","SquareBrandGuide_SendTip":"Klik Kirim untuk memulai!","Paragraph_BatchProductionDescUnlimited_Batch":"Menangani beberapa tugas sekaligus, sehingga mempersingkat waktu proyek.","Menu_ViewDetail":"Detail","Menu_CopyFullText":"Salin","Tip_CopiedToClipboard":"Disalin ke clipboard","Tip_CopyFailed":"Gagal menyalin","Menu_DownloadImage":"Unduh","Tip_NoImage":"Tidak ada gambar","Tip_DownloadStarted":"Sedang mengunduh","Menu_CopyText":"Salin","Tip_NoTextToCopy":"Teks tidak tersedia","Message_LinkImageFetchFailed_Clone":"Tidak dapat memuat gambar dari tautan ini. Coba tautan lain atau unggah langsung gambar.","Tab_Chat":"Obrolan","Tab_Files":"File","Button_Create_New_Chat":"Obrolan baru","Tip_Agent_Team_Chat_Shared":"Melihat versi hanya-baca","Title_ViralVideoMaker":"AI Pembuat Video Viral","Title_ProductVideoMaker":"Pembuat Video Produk","designkit_agent_watermark_protocol":"Foto bisa disimpan dengan atau tanpa watermark \\"Hasil AI\\". Jika menyimpan tanpa watermark, Anda setuju untuk: 1. Tidak menggunakan Agen AI Zawa untuk membuat, menerbitkan, atau menyebarkan informasi palsu. 2. Mematuhi hukum yang berlaku dan memberi label dengan jelas konten yang dihasilkan AI saat menggunakan atau membagikannya.","Text_Document":"File","Button_BrandAssets_UploadDevice":"Unggah dari Perangkat","Button_SocialBrief_Complete":"Deskripsi lengkap","Button_SocialBrief_Edit":"Edit deskripsi","Button_SocialBrief_Generate":"Dibuat berdasarkan deskripsi","Description_BrandAssets":"Informasi merek membantu kami memberikan hasil yang lebih relevan.","Name_BrandAssets":"Aset Merek","Placeholder_BrandAssets_Link":"misalnya, tautan Instagram atau Google Maps.","Text_BrandAssets_KitImported":"Impor dari Kit Merek","Text_BrandAssets_LinkEntry":"Masukkan tautan Anda","Text_SocialResult_Post":"Posting","Title_SocialBrief":"Deskripsi","Toast_BrandAssets_DuplicateSkipped":"Foto duplikat dilewati","Toast_BrandAssets_EmptyAssets":"Kit merek tidak ditemukan","Toast_BrandAssets_InvalidUrl":"Masukkan tautan yang valid","Toast_BrandAssets_LoadAssetsFailed":"Gagal memperoleh aset merek","Toast_BrandAssets_LoadKitsFailed":"Gagal memperoleh kit merek","Toast_BrandAssets_PartialReadFailed":"Beberapa foto tidak dapat dimuat","Toast_BrandAssets_ReadFailed":"Foto tidak dapat dimuat","Toast_BrandAssets_SaveFailed":"Gagal menyimpan aset merek","Toast_BrandAssets_UploadFailed":"Beberapa informasi aset merek gagal diunggah. Silakan coba lagi.","Title_AgentDesignPreference":"Personalisasikan Agen Gaya AI Anda","Desc_AgentLibWorkflowUnify":"Simpan model dan gaya tanda tangan untuk pembuatan yang lebih cepat dan konsisten di setiap alur kerja.","Button_ViewAgentGuide":"Instruksi","Desc_BatchRecipeRetain":"Simpan pengaturan gambar dan komposisi adegan sebagai preset yang dapat digunakan kembali dan dapat diterapkan langsung pada proyek mendatang.","Button_NewBatchRecipe":"Buat preset","Desc_CustomModelUpload":"Unggah gambar model dan gunakan kembali di berbagai pemrosesan untuk membangun identitas merek yang konsisten.","Button_NewExclusiveModel":"Buat model","Text_AiRecommend_TryOn":"Rekomendasi Pose Pintar","Desc_AiRecommendSceneMode_TryOn":"Otomatis memilih adegan terbaik berdasarkan pakaian.","Message_LoadSceneFailedRetry_TryOn":"Gagal memuat. Silakan coba lagi nanti.","Text_OptionalCustomSceneDescription_TryOn":"Deskripsikan Adegan (Opsional)","Placeholder_CustomSceneDescription_TryOn":"Berikan detail, misalnya, jalan-jalan di musim gugur yang keemasan, cahaya matahari terbenam yang lembut, seorang model bersandar di pohon…","Message_PleaseSelectOrDescribeScene_TryOn":"Pilih atau masukkan deskripsi adegan","Placeholder_SearchProduct_Record":"Cari berdasarkan nama produk atau kata kunci","Title_RecentSearches":"Riwayat","Button_Clear":"Hapus","Title_ShootingScene_TryOn":"Pengaturan Adegan","Button_Charged_Continue":"Isi ulang selesai","Title_SplitImagePlugin":"Layering Gambar","Description_SplitImagePlugin":"Mendeteksi elemen gambar dan memisahkannya dalam layer yang dapat diedit.","Tip_SplitImageLoading":"Memproses ...","Tip_SplitImageFail":"Pemrosesan gagal. Harap coba lagi.","Brand_SquareSync_ToastPartial":"Beberapa data Square tidak bisa diimpor","Brand_SquareSync_ToastSuccess":"Data Square sudah siap","Brand_SquareSync_Failed":"Gagal mengekstrak data dari Square","Brand_SquareSync_Button":"Impor dari Square","Title_Format":"Format","Message_CancelManagedTaskSuccessRefunded_Record":"Tugas dibatalkan. Kredit telah dikembalikan ke akun.","Text_AspectRatio_Common":"Rasio","Text_Country_Common":"Negara/Wilayah","Text_Language_Common":"Bahasa","Text_Platform_Common":"Platform","Option_Korea_Market":"Korea Selatan","Option_Korean_Language":"Korea","Title_AgentLibRecentBrainOn":"Kecerdasan agen diaktifkan","Desc_AgentLibRecentRecipesSidebar":"Preset ditambahkan ke Aset Agen. Gunakan untuk langsung menerapkan gaya merek Anda di seluruh desain.","Title_CreateBatchRecipe":"Buat preset","Tips_Not_Files":"Tidak ada file","Message_PleaseEnterProductHighlights":"Masukkan sorotan produk Anda","Message_UploadProductImageRequired":"Unggah setidaknya satu gambar produk","Tips_Agent_Teams_Mode":"Cocok untuk alur kerja canggih yang memerlukan berbagai kemampuan AI.","Tips_Agent_Teams_Mode_Actived":"Mode Tim Agen mengoordinasikan agen AI di setiap tahap, dari strategi hingga produksi akhir.","Tip_SocialBrief_MissingImages":"{count} postingan tidak berisi gambar yang diperlukan. Tambahkan gambar untuk melanjutkan.","Tips_Agent_Teams_Mode_Active_Zawa":"Tim Agen sudah siap — penelitian dan pembuatan konten otomatis. Beri tahu apa yang Anda butuhkan.","Tip_AiGeneratedContent":"Konten yang dihasilkan AI mungkin mengandung kesalahan.","Button_ContinueUpload":"Lanjutkan","Button_GenerateNow":"Buat","Button_ReplaceClothes":"Ganti","Desc_ReplaceClothesMultiUpload":"Ganti seluruh pakaian sekaligus","FileName_MyClothes":"Diunggah","Message_SelectReplaceClothes":"Pilih gambar pakaian","Message_UploadClothesFailed":"Gagal mengunggah gambar, silakan coba lagi.","Message_UploadClothesSizeLimit":"Unggah gambar pakaian maks 10 MB","Text_MoreActionEmpty":"Atur tindakan","Tip_UploadClothesFormat":"Lepas atau unggah ${0} gambar maks ${1}.","Title_ReplaceClothes":"Ganti pakaian","Title_TryOnAccessoryMatch":"Tambahkan aksesori pintar untuk tampilan merek khas","Title_TryOnMultiPose":"Buat lookbook dengan pose model yang natural dan realistis","Title_TryOnOutfitMix":"Buat pakaian lengkap dengan padu-padan item","Title_TryOnSceneSwitch":"Ganti background sesuai suasana atau gaya kampanye","Title_TryOnAIRecommend":"Rekomendasi AI","Text_SocialBrief_Generating":"Sedang memproses. Harap tunggu.","Tag_New":"Baru","Title_Designer":"Desainer","Button_Blank_Canva":"Desainer","Tool_AiViralImageRemix":"Remix Gambar","Title_ViralVideoReplace":"Remix Video","Title_SocialMedia_Tools":"Alat Kreatif Sosial","Title_HotTags":"Trending","Tip_LogoNotRecognized":"Logo tidak ditemukan","Tip_LogoNotRecognized_Eraser":"Logo tidak ditemukan. Usap untuk memilih area yang ingin dihapus.","Placeholder_RemoveGrassDebris":"Hilangkan sampah di rumput","Placeholder_RemoveGroundShadow":"Hilangkan bayangan di tanah","Placeholder_RemoveRedClothesPerson":"Hilangkan orang berbaju merah","Placeholder_DescribeRemovalPart":"Tulis apa yang ingin dihapus, contohnya: ${0}","Modal_LeavePageTitle":"Anda akan keluar dari halaman ini","Modal_OpenRoboNeoNewTab":"Buka RoboNeo di tab baru?","Button_ReplicateVideo":"Remix video ini","Button_RemixImage":"Replikasi Gambar","Message_ContentProcessFailed_Text":"Gagal memproses. Coba kata lain.","Message_ContentProcessFailed_Image":"Gambar ini tidak dapat diproses. Coba gambar lain.","Text_ProductImageOptionalUploadTip_Clone":"Tambahkan foto produk jika ingin disertakan dalam hasil","Option_EcommerceProductImage_Clone":"Foto Produk E-commerce","Option_ApparelEcommerceImage_Clone":"Gambar E-commerce Pakaian","Option_SocialGraphicImage_Clone":"Postingan Media Sosial","Option_MarketingPoster_Clone":"Poster Pemasaran","Option_CreativePoster_Clone":"Poster Kreatif","Option_ReferenceImageSize_Clone":"Rasio Aspek","Option_Instagram_Platform":"Instagram","Home_Tools_Title":"Maksimalkan konten media sosial dengan jajaran alat yang efektif","Home_Tools_Tab_SocialCreative":"Kreatif Sosial","Home_Tools_SeeAllImageTools":"Lihat semua alat foto","Home_Tools_SeeAllSocialCreative":"Lihat semua alat konten sosial","Home_Tools_ImageObjectRemover":"Penghapus Objek Foto","Home_Tools_TextToVideo":"Teks Ke Video","Home_Tools_FoodPhotography":"Fotografi Makanan","Home_Tools_FlyerGenerator":"Pembuat Flyer","Home_Tools_MenuGenerator":"Pembuat Menu","Home_Tools_PosterGenerator":"Pembuat Poster","Home_Tools_MockupGenerator":"Pembuat Maket","Home_Tools_ImageExtender":"Perluas Foto","Home_Tools_ImageToVideo":"Foto ke Video","title_upgrade2GetMoreCredits":"Upgrade untuk lebih banyak kredit.","tip_insufficientCredits":"Kredit tidak cukup. Silakan isi ulang.","tip_insufficientCredits_upgrade":"Kredit tidak cukup. Silakan berlangganan.","Title_DownloadPromotion_ViralVideo":"Mau lebih banyak video seperti ini?","Subtitle_DownloadPromotion_ViralVideo":"Upgrade ke Pro untuk membuat lebih banyak video.","Tag_DownloadPromotionOffer_ViralVideo":"Periode promo terbatas","Title_DownloadPromotionCard_ViralVideo":"Terus brekreasi dengan Pro","Text_DownloadPromotionPrice_ViralVideo":"${0}/bln","Text_DownloadPromotionBenefitViralVideo_ViralVideo":"Generator Video Produk/Remix Video (hingga ${0} video/bulan)","Text_DownloadPromotionBenefitNanoBanana_ViralVideo":"Kreasi Nano Banana Pro Unlimited","Text_DownloadPromotionBenefitImageEnhance_ViralVideo":"AI penghapus & restorasi kualitas unlimited","Button_DownloadPromotionGetPro_ViralVideo":"Beli Pro dengan diskon ${0}","Button_DownloadPromotionLater_ViralVideo":"Tidak, terima kasih","Tag_NewUserLimitedFree":"Periode penawaran terbatas","Text_FirstImageCreditDiscount":"${0} kredit untuk foto pertama. ${2} kredit untuk setiap ${1} foto tambahan.","Tag_NewUser_FirstImageLimitedFree":"Periode promo terbatas","Tag_FirstImageFree":"1 Uji Coba Gratis","Title_OtherSettings":"Pengaturan Lainnya","Title_GenerateListing":"Buat salinan daftar","Button_GenerateListing":"Buat salinan daftar","Message_Copied":"Disalin","Text_Generating_Listing":"Memproses...","Text_GenerateFailed_Listing":"Gagal membuat","Button_Translate":"Terjemahkan","Title_ListingCopy":"Salinan Daftar","Message_NoTaskForListing":"Tugas pembuatan daftar tidak ditemukan.","Message_RenameSuccess":"Diubah","Message_RenameFailedRetry":"Gagal mengubah. Harap coba lagi.","Title_RegenerateDirection":"Edit Pembuatan","Placeholder_RegeneratePrompt":"Kosongkan untuk membuat ulang atau tambahkan instruksi untuk mengedit hasil (opsional). Misalnya, \\"Geser produk ke kiri\\" atau \\"Ubah background jadi abu-abu terang\\".","Title_TrialLimitReached_ViralVideo":"Video Gratis Digunakan","Subtitle_TrialLimitReached_ViralVideo":"Uji coba gratis dapat membuat 1 video. Upgrade ke Pro untuk membuat lebih banyak.","Button_UpgradeNow":"Upgrade Sekarang","Text_WPS_NavVipEntrance":"Beli","Text_WPS_Only":"(WPS only)","Text_WPS_Credits_Card_Tip":"Designkit has a separate subscription system and is not included in standard WPS memberships.","Text_WPS_Welcome_Modal_Pricing":"Designkit Subscription","Text_WPS_Welcome_Modal_Pricing_Description":"Desain AI disediakan oleh partner WPS pihak ketiga dan memerlukan pembelian terpisah.","Text_WPS_Welcome_Modal_Meidou":"Login Perdana","Text_WPS_Welcome_Modal_Meidou_Description":"WPS Members get 50 free credits to try it out! No extra charges will apply to your account.","Text_WPS_Welcome_Modal_Vip":"Subscription Bonus","Text_WPS_Welcome_Modal_Vip_Description":"Beli paket AI Design dan dapatkan WPS Super Membership dengan durasi yang sama, waktu terbatas.","Text_WPS_Welcome_Modal_Title":"Create with Designkit","Text_WPS_Welcome_Modal_Agreement":"By continuing, you have read and agree to the terms above.","Button_Generate_ImageListingSet":"Listing Images & Copy","Tip_GenerateListing":"Generate platform-ready visuals and copy for your selected marketplace.","Text_SelectedCount":"${0} dipilih","RoboNeo_Web_input_default_content":"Mengobrol dengan RoboNeo","RoboNeo_Web_chatbox_maximum":"Obrolan sudah maksimal","RoboNeo_Web_chatbox_maximum_text":"Obrolan sudah maksimal. Buat tugas baru untuk melanjutkan.","RoboNeo_Web_chatbox_new_task":"Proyek baru","RoboNeo_Web_history_share_text":"Bagikan","RoboNeo_Web_history_delete_text":"Hapus","RoboNeo_Web_history_delete_hint_text":"Catatan","RoboNeo_Web_history_delete_main_text":"Proyek akan dihapus permanen. Lanjutkan?","RoboNeo_Web_history_delete_hint_confirm":"Hapus","RoboNeo_Web_history_delete_hint_cancel":"Batal","RoboNeo_Web_studio_download":"Unduh","RoboNeo_Web_toast_share_text":"Bagikan obrolan ini","RoboNeo_Web_toast_share_main_text":"Orang yang punya tautan obrolan dapat melihat riwayat obrolan","RoboNeo_Web_toast_share_copy":"Salin tautan","RoboNeo_Web_toast_cancel":"Batal","RoboNeo_Web_toast_confirm":"Konfirmasi","RoboNeo_Web_studio_changing_toast":"Tidak ada penggunaan gratis tersisa untuk hari ini. Penggunaan akan diatur ulang pada tengah malam. Berikan \\"Cyber Carrots\\" pada Neo untuk melanjutkan.","RoboNeo_Web_studio_changing_toast2":"Tidak ada penggunaan gratis tersisa hari ini.","RoboNeo_Web_new_studio":"Obrolan baru","RoboNeo_Web_sidebar_close":"Susutkan","RoboNeo_Web_history_text":"Riwayat","RoboNeo_Web_sidebar_open":"Perluas","RoboNeo_Web_upload_warning_text":"Tidak dapat mengunggah foto dan video sekaligus.","RoboNeo_Web_upload_format_text":"Mendukung format gambar: JPG, PNG, dan JPEG. Mendukung format video: MP4 dan MOV.","RoboNeo_Web_upload_fail_text":"Unggahan gagal","RoboNeo_Web_upload_image_maximum":"Pengguna bisa mengunggah maksimal {max_num} foto","RoboNeo_Web_upload_video_size_maximum":"Tidak mendukung video berukuran lebih dari {max_size} MB.","RoboNeo_Web_upload_image_size_maximum":"Tidak mendukung foto berukuran lebih dari {max_size} MB.","RoboNeo_Web_upload_video_maximum":"Pengguna bisa mengunggah maksimal {max_num} video","RoboNeo_Web_history_dafult_text":"Tidak ada riwayat, mulai obrolan sekarang.","RoboNeo_Web_upload_content_warning_text":"File dengan konten yang diduga tidak pantas tidak akan diimpor.","RoboNeo_Web_chat_send_fail":"Pengiriman gagal, harap coba lagi nanti.","RoboNeo_Web_network_fail":"Koneksi gagal atau waktu habis, harap coba lagi.","RoboNeo_Web_studio_layer_fail":"Gagal memisahkan layer.","RoboNeo_Web_studio_layer_success":"Selesai","RoboNeo_Web_network_error":"Kesalahan jaringan","RoboNeo_Web_delete_success":"Dihapus","RoboNeo_Web_delete_fail":"Gagal menghapus","RoboNeo_Web_copy_success":"Disalin","RoboNeo_Web_file_uploading":"Mengunggah {num} file","RoboNeo_Web_file_upload_fail":"Kesalahan mengunggah {num} file","RoboNeo_Web_file_upload_single_fail":"Kesalahan mengunggah 1 file","RoboNeo_Web_file_uploading_single":"Mengunggah 1 file","RoboNeo_Web_upload_video_maximum_one":"Pengguna bisa mengunggah maksimal 1 video","RoboNeo_Web_sharepage_wanna_try":"Coba Sekarang","RoboNeo_Web_sharepage_load_to_end":"Buka Hasil","RoboNeo_Web_studio_loading_text":"Memuat kanvas...","RoboNeo_Web_chatbox_add_image":"Tambah foto","RoboNeo_Web_chatbox_add_video":"Tambahkan video","RoboNeo_Web_image_editor_max":"Maks 10 MB dengan 4096 px pada sisi terpanjang","RoboNeo_Web_unlimited_pass_expired":"Voucher Unlimited telah berakhir. Sekarang memanfaatkan penggunaan gratis yang tersedia.","RoboNeo_Web_studio_ai_image_successful":"AI UHD - selesai","RoboNeo_Web_studio_ai_image_failed":"AI UHD - gagal","RoboNeo_Web_studio_cutout_successful":"Berhasil dipotong","RoboNeo_Web_studio_cutout_failed":"Gagal dipotong","RoboNeo_Web_studio_ai_edit_failed":"AI Pengeditan - gagal","RoboNeo_Web_studio_ai_edit_successful":"AI Pengeditan - selesai","RoboNeo_Web_AI_generated":"Konten dibuat oleh AI","RoboNeo_Web_loading":"Memuat","RoboNeo_Web_view_creative_process":"Lihat Proses Kreatif","RoboNeo_Web_try_now":"Coba Sekarang","RoboNeo_web_extender_successful":"AI Perluasan - selesai","RoboNeo_web_extender_failed":"AI Perluasan - gagal","RoboNeo_web_eliminate_successful":"AI Penghapus - selesai","RoboNeo_web_eliminate_failed":"AI Penghapus - gagal","roboneo_web_continue":"Lanjutkan","roboneo_web_video":"Video","roboneo_web_HTML":"Halaman web","roboneo_web_shared_error_message":"Obrolan ini tidak dapat dibagikan, coba mulai obrolan baru.","roboneo_web_open_the_APP_experience":"Coba di aplikasi","roboneo_web_AI_generated_logo":"Konten yang dibuat oleh AI ini hanya sebagai referensi.","roboneo_web_change_word_success":"Ganti Teks - selesai","roboneo_web_change_word_fail":"Ganti Teks - gagal","roboneo_web_canvas_loading_failed":"Gagal memuat kanvas","roboneo_web_export_failed":"Ekspor gagal","roboneo_web_export_tips2":"Ekspor hanya mendukung satu foto (maks {width}px*{height}px).","roboneo_web_new_topic":"Obrolan baru","roboneo_web_waiting_reply":"Menunggu respons","roboneo_web_file_saving_preferences":"Preferensi file","roboneo_web_includes_AI_watermark":"Cantumkan watermark AI","roboneo_web_no_remind":"Jangan tampilkan lagi","roboneo_web_agree_continue":"Setujui dan lanjutkan","roboneo_web_watermark_protocol":"Pengguna bisa memilih untuk menyimpan foto dengan atau tanpa watermark \\"Buatan AI\\". Dengan menyimpan tanpa watermark, berarti pengguna setuju untuk: 1. Tidak menggunakan RoboNeoAI untuk membuat, memublikasikan, atau menyebarkan informasi palsu. 2. Memastikan kepatuhan terhadap hukum dan dengan jelas menunjukkan bahwa konten tersebut dibuat oleh AI saat digunakan atau dibagikan.","roboneo_web_rectangle":"Persegi","roboneo_web_circle":"Bulat","roboneo_web_arrow":"Panah","roboneo_web_image_fusion_success":"Selesai","roboneo_web_image_fusion_failure":"Gagal","roboneo_chat_resources_num_limit_tips":"Pengguna dapat menambahkan maksimal {img_num} video dan {video_num} foto.","RoboNeo_Web_export_confirm_tip_popup_title":"Opsi untuk mengekspor dengan atau tanpa tanda air “AI Generated”.","RoboNeo_Web_export_confirm_tip_popup_btn":"Jadi begitu","Tip_UploadImagesFormat_Batch":"Seret atau klik untuk mengunggah gambar JPEG/JPG/PNG berukuran hingga ${0} MB. Mendukung hingga ${1} gambar.","Text_SelectedModulesCount_Batch":"${0} item dipilih","Tip_DefaultFollowGlobal_Batch":"Jika tidak diubah, default-nya global","Label_ModuleSelection_Batch":"Pemilihan Modul","Label_SelectRequiredModules_Batch":"Pilih modul yang Anda butuhkan","Title_Dialog_Invite2":"Undang teman, dapatkan hari Pro dan kredit","Desc_Dialog_Invite2":"Bagikan tautan ke teman atau di media sosial. Saat teman mendaftar melalui tautan Anda, kalian berdua mendapatkan <strong>${0} hari Pro + ${1} kredit</strong>. Jika teman Anda berlangganan <strong>dalam ${2} hari</strong>, kalian berdua bisa mendapatkan hingga <strong>${3}</strong> kredit ekstra.","SubTitle_Rewards1_Invite2":"Hari Pro Diperoleh","SubTitle_Rewards2_Invite2":"Kredit yang diperoleh","SubTitle_Rewards3_Invite2":"Teman yang diundang","Text_Rule1_Invite2":"Saat teman mendaftar melalui tautan Anda, kalian berdua mendapatkan <strong>${0} hari Pro + ${1} kredit</strong>.","Text_Rule2_Invite_zawa":"Jika teman <strong>berlangganan dalam ${0} hari</strong>, Anda berdua akan mendapatkan kredit bonus (<strong>Plus +${1}, Pro +${2}, Max +${3}</strong>). Bonus ini diberikan satu kali per teman, berdasarkan paket aktif pertama.","Text_Rule3_Invite2":"Hari Pro hadiah ditambahkan ke durasi langganan Anda. Jika Anda sudah berlangganan, masa berlaku Anda akan diperpanjang, dan Anda akan selalu mendapatkan manfaat tingkat tertinggi yang tersedia.","Text_Rule4_Invite2":"Kredit ditambahkan ke saldo Anda, <strong>berlaku selama 30 hari</strong>, dan dapat digunakan untuk pembuatan cepat di semua model Agen AI.","Text_Rule5_Invite2":"Langganan tidak dapat dikembalikan dananya setelah manfaat paket atau kredit bonus digunakan; hadiah gratis tidak dapat dibatalkan setelah digunakan.","Text_Rule6_Invite2":"Hadiah tidak akan diberikan untuk akun yang sudah ada, undangan ke diri sendiri, akun duplikat, atau aktivitas penipuan; ${0} berhak menyesuaikan kampanye dan menarik kembali hadiah dari akun yang mencurigakan.","Title1_Invited_Invite2":"Seorang teman mengundang Anda untuk bergabung ke ${0}. Dapatkan Pro selama ${1} hari + ${2} kredit","Text_DaysBadge_Invite":"${0} Hari","Title_Reward_Registered":"Coba Pro gratis selama ${0} hari","Title_Reward_Invite":"Dapatkan Pro gratis selama ${0} hari, plus ${1} kredit","Desc_Reward_Invite":"Dapatkan Pro gratis selama ${0} hari, dengan alat pintar tanpa batas","Button_StartCreate_Invite":"Mulai pengeditan","Text_InviteMore_Invite":"Undang teman untuk mendapatkan lebih banyak hari Pro dan kredit","Title_WelcomeOnboarding":"Selamat datang di Zawa!","Title_ContentIntentOnboarding":"Apa tujuan utama Anda membuat konten?","Text_ReferralCreditsOnboarding":"Anda mendaftar melalui referral, jadi kami akan otomatis menambahkan <>${0} kredit</> ke akun Anda.","Option_ProductVideoOnboarding":"Video untuk produk saya","Option_SocialPostOnboarding":"Postingan Media Sosial","Option_LogoBrandOnboarding":"Buat logo dan merek","Button_MaybeLaterOnboarding":"Nanti","Title_FirstVideoOnboarding":"Buat video pertamamamu","Desc_FirstVideoOnboarding":"Mulai dengan gambar produk atau referensi untuk membuat video yang siap diposting di Instagram.","Title_FirstSocialPostOnboarding":"Buat postingan media sosial pertama Anda gratis","Desc_FirstSocialPostOnboarding":"Unggah foto atau jelaskan kebutuhan Anda untuk mendapatkan kumpulan postingan media sosial yang rapi dan siap dipublikasikan.","Title_FirstLogoBrandOnboarding":"Buat logo atau merek pertama Anda gratis","Desc_FirstLogoBrandOnboarding":"Jelaskan merek Anda dan dapatkan serangkaian proposal logo profesional serta konsep visual dengan cepat.","Text_TryFreeProOnboarding":"<>Uji coba gratis Zawa Pro 3 hari</> — tanpa kartu kredit atau pembayaran.","Text_FreeVideoOnboarding":"<>Dapatkan 1 kali pembuatan video gratis</>, tanpa kartu kredit atau pembayaran.","Text_FreeImagesOnboarding":"<>Dapatkan 4 kali pembuatan gambar gratis</>, tanpa perlu kartu kredit atau pembayaran.","SubTitle_Invited_Invite_zawa":"Seorang teman mengundang Anda untuk mencoba Zawa, Agen AI yang berfokus pada desain merek. Buat logo, VI, poster, menu, aset media sosial, dan video merek dengan mudah. Daftar sekarang, dan Anda serta teman Anda akan mendapatkan keanggotaan Pro selama ${0} hari plus ${1} kredit. Jika berlangganan dalam ${2} hari, Anda juga akan menerima kredit bonus: Plus mendapatkan tambahan ${3} kredit, Pro mendapatkan tambahan ${4} kredit, dan Max mendapatkan tambahan ${5} kredit.","SubTitle_Invited_Invite_dk":"Seorang teman mengundang Anda untuk mencoba Designkit, Agen AI yang berfokus pada desain komersial. Buat gambar produk, halaman detail, poster promo, banner e-commerce, aset media sosial, dan video produk dengan mudah. Daftar sekarang, dan Anda serta teman Anda masing-masing akan mendapatkan keanggotaan Pro selama ${0} hari dan ${1} kredit. Berlangganan dalam ${2} hari untuk hadiah ekstra: Basic mendapatkan ${3} kredit ekstra, Pro mendapatkan ${4} kredit ekstra.","Text_Rule2_Invite_dk":"Jika teman <strong>berlangganan dalam ${0} hari</strong>, kalian berdua akan mendapatkan kredit tambahan (<strong>Basic +${1}, Pro +${2}</strong>). Setiap teman hanya bisa mendapatkan hadiah ini sekali, berdasarkan paket aktif pertama mereka.","Tool_AIVideoGenerator":"Pembuatan Video AI","Tool_AIVideoAdMaker":"Pembuatan Iklan Video AI","Tool_AIVideoEditor":"Editor Video AI","Title_AIWatermark":"Watermark AI","Title_FileSavePreference":"Preferensi Penyimpanan File","Label_IncludeAIWatermark":"Termasuk Watermark AI","Button_ConfirmDownload":"Konfirmasikan unduhan","Button_AgreeAndContinue":"Setujui dan mulai gunakan","Text_DontRemindAgain":"Jangan beri tahu saya lagi.","Button_DownloadApp":"Unduh Aplikasi","Title_DownloadAppForMoreFeatures":"Unduh Aplikasi untuk mengakses lebih banyak fitur lanjutan","Tip_Download7DaysFreeTrial":"Unduh untuk memulai uji coba gratis 7 hari","Message_LoginExpiredRelogin":"Kesalahan login. Silakan login lagi.","Title_BindPhone":"Hubungkan nomor telepon","Tip_BindPhoneForCollaboration":"Tautkan nomor telepon Anda untuk berkolaborasi dengan orang lain secara real time.","Tip_OnlyPSDSupported":"Hanya mendukung file PSD","Button_OpenPSD":"Buka PSD","Desc_AIDisclaimer":"Sebelum menggunakan layanan ini, Anda harus memahami bahwa konten yang dihasilkan AI didasarkan pada pembelajaran mendalam AI dari kumpulan data besar, dan beberapa informasi mungkin mengandung kekurangan, tidak masuk akal, atau menimbulkan ketidaknyamanan. Oleh karena itu, Meitu tidak memberikan jaminan apa pun terkait keakuratan, kelengkapan, atau fungsionalitas konten yang dihasilkan oleh algoritme, dan tidak bertanggung jawab secara hukum, termasuk atas pelanggaran hak pihak ketiga. Selain itu, karena layanan desain AI menghasilkan konten terkait berdasarkan teks yang Anda masukkan, Anda bertanggung jawab untuk membuat pilihan yang wajar mengenai informasi yang Anda masukkan dan konten yang dihasilkan. Anda harus memastikan bahwa Anda menggunakan layanan ini dan karya yang dihasilkan AI sesuai dengan hukum, tidak melanggar hak cipta, merek dagang, atau hak hukum lainnya dari pihak ketiga mana pun, dan tidak menggunakan karya yang dihasilkan untuk tujuan ilegal apa pun. Jika penggunaan Anda yang tidak tepat menyebabkan kerusakan pada hak atau kepentingan pihak ketiga mana pun, Anda akan menanggung tanggung jawab hukum yang sesuai sesuai dengan hukum.","Text_Disclaimer":"Penafian","Message_ConnectFailed":"Koneksi gagal: ${0}","Placeholder_SelectFont":"Pilih Font","Message_MaxImageUploadSize":"Hanya mendukung gambar hingga ${0} x ${1}","Title_StorageFull":"Penyimpanan Anda penuh","Title_StorageFullPleaseClean":"Penyimpanan penuh. Kosongkan ruang.","Desc_StorageFull":"Penyimpanan ${0} Anda penuh. Hapus beberapa konten ${1}, atau riwayat edit sebelumnya mungkin hilang.","Desc_StorageFullAigc":"Penyimpanan ${0} Anda penuh. Konten yang dibuat ini akan <strong>disimpan sementara selama 7 hari</strong>. Hapus beberapa konten ${1}, atau riwayat kreasi Anda mungkin hilang.","Text_Free":"Gratis","Text_OrUpgradeMember":"Atau tingkatkan keanggotaan Anda","Text_UnlockMoreStorage":"Buka lebih banyak ruang penyimpanan","Text_FilesSavedForever":"File dapat disimpan tanpa batas waktu.","Button_UpgradeMember":"Tingkatkan","Button_CleanSpace":"Bersihkan","Title_FileExpiringSoon":"File Anda akan segera berakhir","Desc_FileExpireAutoClean":"File akan dibersihkan secara otomatis setelah kedaluwarsa. Kelola kreasi Anda segera.","Button_OrganizeFiles":"Kelola File","Title_RemainingDownloads":"Unduhan tersisa","Text_PriorityConsumeExpiring":"Gunakan unduhan yang akan kedaluwarsa terlebih dahulu","Text_PermanentValid":"Valid permanen","Text_Sheet":"gambar","Text_ExpireInDays":"Berakhir dalam ${0} hari","Text_ConsumeTiming":"Unduhan:","Tip_CutoutConsumeRule1":"Saat Anda mengunduh gambar hasil pemotongan di editor pemotongan, jumlah unduhan yang sesuai akan dikurangi.","Tip_CutoutConsumeRule2":"2. Unduhan berulang untuk gambar yang belum diproses ulang atau dipotong tidak akan dikurangkan dari jumlah unduhan Anda.","Text_InviteSuccessReward":"Anda telah berhasil diundang. Bergabunglah dengan Meitu Designer untuk mengklaim hadiah Anda.","Desc_DesignKitIntro":"Meitu Designer, alat desain AI andalan untuk penjual e-commerce. Mulai dari set gambar produk dan set gambar model hingga pembuatan video shoppable, desain poster, dan pengeditan foto, alat ini membantu pengguna membuat rangkaian lengkap aset e-commerce di satu tempat dengan AI.","Title_TeamMeidouShared":"Kredit tim tersedia untuk semua anggota","Desc_PersonalMeidouTransfer":"Untuk mentransfer kredit pribadi ke tim, hubungi layanan pelanggan.","Button_SwitchTeamRecharge":"Beralih tim dan isi ulang","Button_CreateTeamRecharge":"Buat Tim Dan Isi Ulang","Title_SubscribeSuccess":"Langganan berhasil","Text_MeidouRechargedTo":"Kredit telah ditambahkan ke","Button_GoToTeam":"Buka Tim","Text_OnePayMultiShare":"Isi Ulang Sekali, Bagikan ke Beberapa Akun","Text_InviteMembersShareMeidou":"Undang anggota untuk berbagi kredit","Menu_SwitchPersonalTeam":"Beralih Pribadi/Tim","Menu_TeamManagement":"Manajemen Tim","Menu_InviteFriendsEarnCash":"Undang teman untuk mendapatkan uang tunai","Text_Personal":"Pribadi","Text_PersonalDesigner":"Desainer Individu","Text_EnterpriseSwitch":"Beralih ke Enterprise","Button_Recharge":"Isi ulang","Text_Detail":"Detail","Tip_DesignKitIndependentPlan":"Meitu Design Studio memiliki paket langganan sendiri dan tidak berbagi manfaat dengan keanggotaan WPS.","Text_MeidouWpsOnly":"Kredit (Khusus WPS)","Text_SheetCount":"Jumlah potongan","Desc_ExchangeConfirm":"Yakin ingin menukarkan ${0} kredit cutout untuk keanggotaan selama ${1} hari?","Message_LoadOrderFailed":"Gagal memuat data pesanan","Message_ExchangeSuccess":"Berhasil ditukar","Message_ExchangeFailed":"Penukaran gagal","Text_NoOrderRecords":"Tidak ditemukan catatan pesanan","Text_OrderDate":"Tanggal Pemesanan:","Text_VipExchangeRule1":"1. Pemotongan tidak terbatas selama masa langganan Anda dan tidak akan menggunakan kredit apa pun.","Text_VipExchangeRule2":"2. Kredit Paid Cutout dapat ditukarkan dengan langganan.","Text_VipExchangeLocation":"· Lokasi penukaran: Ketuk foto profil -> Jumlah foto.","Text_VipExchangeNoExchange":"·Jika Anda memilih untuk tidak menukarkannya, Anda tetap dapat menggunakan keanggotaan Anda. Masa berlaku akan tetap sama.","Text_VipExchangeGiftSheets":"·Kredit bonus dari keanggotaan Anda tidak dapat digunakan untuk menebus keanggotaan dan dapat digunakan sebelum masa berlakunya berakhir.","Text_VipExchangeRule3":"3. Keanggotaan tidak lagi mencakup kredit gratis","Text_BackToPrevious":"Sebelumnya","Title_WpsPay":"WPS Pay","Text_CloseModal":"Tutup","Text_FavoriteDesignKit":"Tambahkan Meitu Design Studio ke bookmark","Button_Visit":"Akses","Desc_VisitChinaSite_Cutout":"Ingin mengunjungi situs Meitu Cutout China? Klik Kunjungi untuk membuka situs China.","Desc_VisitChinaSite":"Ingin mengunjungi situs Meitu DesignRoom China? Klik [Visit] untuk melanjutkan.","Desc_VisitingGlobalSite_Cutout":"Anda sedang mengunjungi Designkit Cutout (Situs global Meitu Cutout). Pengguna di Tiongkok, silakan kunjungi situs Tiongkok.","Desc_VisitingGlobalSite":"Anda sedang mengunjungi Designkit, situs global Meitu Design Studio. Untuk pengguna di Tiongkok, kunjungi situs Tiongkok.","Button_StayCurrent":"Tetap di Sini","Button_BackToChinaSite":"Kembali ke situs Tiongkok","Title_DownloadWork":"Unduh","Label_WorkType":"Tipe","Button_Downloading":"Mengunduh...","Tip_UploadImageForBetterResult":"Setelah mengunggah gambar, masukkan instruksi pengeditan yang jelas untuk hasil yang lebih baik.","Label_SceneElement":"Elemen adegan","Placeholder_SceneElementDesc":"Edit elemen atau subjek gambar dengan prompt teks. Contoh: Ganti XX dalam gambar dengan XX yang saya unggah.","Label_MainTitle":"Judul utama","Label_SubTitle":"Subtitel","Label_Copywriting":"Copywriting","Tip_ModifyBeforeGenerate":"Edit gambar dan teks sebelum dibuat","Button_ReEdit":"Edit Ulang","Message_MaxUploadImages":"Anda dapat mengunggah hingga ${0} gambar","Text_CompletedPercent":"(${0}% Selesai)","Text_PreviewImage":"Pratinjau","Text_EnterCanvasEdit":"Edit di Kanvas","Title_GenerateSame":"Buat","Text_ConfirmLeaveGenerating":"Sedang membuat. Yakin ingin keluar?","Text_BuildingVisualScheme":"Membuat Desain Visual...","Text_OptimizingLayout":"Mengoptimalkan tata letak dan hierarki informasi...","Text_FineTuningFont":"Menyempurnakan fon dan jarak...","Message_GenerateSuccessCost":"Berhasil dibuat! ${0} kredit digunakan","Title_ConfirmDelete":"Konfirmasi Hapus","Text_DeleteFontWarning":"Setelah dihapus, semua anggota tim tidak akan dapat menggunakan font ini lagi.","Text_AppliedWillReplace":"Catatan kreasi/gaya font yang diterapkan akan otomatis diganti dengan","Text_DefaultReplaceFontName":"Alibaba-PuHuiTi-R","Text_Deleting":"Menghapus...","Message_DeleteSuccess":"Berhasil dihapus!","Text_NoMore":"Tidak ada konten lainnya...","Text_NoFonts":"Belum ada font","Button_UploadFont":"Unggah Font","Message_FontFormatInvalid":"File font ${0} memiliki format yang tidak valid","Title_AuthConfirm":"Konfirmasi Izin","Text_FontAuthConfirm":"Untuk font yang Anda tambahkan sendiri, pastikan Anda memiliki otorisasi yang diperlukan dari pemilik hak cipta dan/atau pemegang hak terkait.","Text_DuplicateFontsConfirm":"Fon berikut mungkin sama. Harap konfirmasi.","Text_Uploaded":"Foto diunggah","Button_ConfirmUpload":"Konfirmasi unggahan","Text_FontsCannotUpload":"Tidak dapat mengunggah font berikut","Button_ReUpload":"Unggah lagi","Message_MaxFontUpload":"Anda dapat mengunggah hingga 20 file font sekaligus","Message_UploadSuccess":"Diunggah","Text_FontUploading":"Mengunggah font...","Tip_FontUsageRight":"Pengingat: Pastikan Anda memiliki hak untuk menggunakan font tersebut dan lisensi komersial.","Title_FriendlyTip":"Pengingat","Text_TemplateMigrated":"Templat dari Pustaka Templat telah dipindahkan ke Proyek. Buka Proyek untuk melihat templat tim.","Button_GoNow":"Masukkan Sekarang","Tab_FontLib":"Pustaka Font","Tip_SwitchIdentityHint":"Ketuk foto profil Anda di sudut kanan atas untuk beralih antara profil Pribadi dan Tim.","Text_IdentityResourcesIndependent":"Sumber daya desain (seperti Riwayat Edit) disimpan terpisah untuk setiap identitas","Text_IdentitySwitched":"Akun berhasil dialihkan","Text_DefaultTeamName":"Tim ${0}","Message_FillTeamInfo":"Lengkapi semua informasi tim","Message_TeamNameMaxLength":"Masukkan nama tim atau perusahaan (maksimal 20 karakter)","Title_CreateTeam":"Buat Tim","Label_TeamName":"Nama Tim","Placeholder_TeamName":"Masukkan nama tim","Button_FreeCreate":"Buat Gratis","Tip_TeamNameEditable":"Nama tim dapat diubah kapan saja","Text_EnjoySvipRights":"Nikmati manfaat SVIP","Text_TeamPermissionMgmt":"Pengelolaan Izin Tim","Text_MemberFolderCollab":"Kolaborasi Folder Anggota","Text_TeamExpired":"Tim ini telah berakhir","Text_RenewToUse":"Perpanjang atau perbarui untuk terus menggunakannya.","Text_VipTeamRights":"Manfaat Tim VIP","Text_ViewDetailRights":"Lihat Detail Manfaat","Button_SwitchPersonal":"Beralih ke Personal","Text_Frozen":"Akun Anda telah dibekukan.","Text_MemberOverLimit":"Batas anggota terlampaui","Text_ContactOwner":"Hubungi pemilik tim untuk terus menggunakan ini.","Text_TeamNoSupport":"Fitur ini belum tersedia untuk akun tim/bisnis.","Text_SwitchToPersonalHint":"Ganti ke Personal jika perlu","Button_SwitchToPersonal":"Beralih ke Pribadi","Text_FeatureNotAvailable":"Fitur ini saat ini tidak tersedia.","Text_ReloginPersonal":"Login lagi dengan akun pribadi untuk menggunakan fitur ini.","Button_BackHome":"Beranda","Text_PersonalEdition":"Pribadi","Text_TeamEdition":"Tim","Text_EnterpriseEdition":"Paket Enterprise","Text_FreeEdition":"Gratis","Text_RemovedFromTeam":"Anda telah dihapus dari tim","Text_RejoinTeamHint":"Untuk Bergabung Kembali Dengan Tim","Text_ContactOwnerToInvite":"Hubungi pemilik/admin untuk mengirim undangan","Button_SwitchOtherIdentity":"Beralih ke akun lain","Button_FreeCreateTeam":"Buat Tim Gratis","Text_SelectIdentity":"Pilih Peran Akun","Text_SelectTeamIdentity":"Pilih peran tim","Text_EditingSaveLocation":"Jika pengeditan sedang berlangsung, catatan pengeditan/pembuatan Anda akan disimpan ke ruang ${0}.","Text_CreateNewTeamFree":"Buat Tim Baru Gratis","Text_MemberCount":"${0} Pelanggan","Text_SavedToHelloDigitalAsset":"Disimpan ke HelloRF Digital Assets","Text_Admin":"Administrator","Text_Member":"Anggota","Title_FreeMemberLimit":"Paket gratis mendukung hingga ${0} anggota","Title_SeatInsufficient":"Slot Keanggotaan Tidak Cukup","Button_UpgradeTeam":"Upgrade ke Tim","Button_AddSeat":"Tambah Kursi","Text_UpgradeForMoreSeats":"Upgrade ke Keanggotaan Tim untuk menambah batas jumlah anggota","Text_AddSeatToInvite":"Tambahkan lebih banyak slot untuk mengundang lebih banyak anggota.","Title_InviteMember":"Undang","Text_InviteSeatRemaining_Free":"Anda dapat mengundang ${0} anggota lagi untuk bergabung dengan tim secara gratis","Text_InviteSeatRemaining":"Anda dapat mengundang ${0} anggota lagi untuk bergabung dengan tim","Text_ShareDesignAssets":"Bagikan karya desain dan elemen bersama","Text_ShareVipAndCredits":"Bagikan kredit keanggotaan dan kredit pembuatan AI Anda","Text_InvitedUserPermission":"Izin Pengguna yang Diundang:","Text_NoInvitePermission":"Hanya pemilik tim atau admin yang dapat mengundang orang lain. Anda belum memiliki izin untuk mengundang orang ke tim.","Text_RemainingCount":"Tersisa: <span>${0}</span>","Button_RedeemMemberDays":"Tukarkan keanggotaan <span>${0}</span> hari","Desc_InviteReward_DesignKit":"Gabung ke Meitu DesignKit sekarang dan dapatkan total <strong>80 kredit</strong> untuk pembuatan dan pengeditan gambar. Anda juga akan mendapatkan diskon langganan <strong>hingga ¥22.</strong>","Text_ClickTopRight":"Klik <span class=\\"primary\\">pojok kanan atas</span> situs web","Option_SetEditable":"Jadikan dapat diedit","Option_SetViewable":"Atur agar dapat dilihat","Option_Reject":"Tolak","Message_BindSuccessPermissionAdjusted":"Berhasil dihubungkan. Izin diperbarui","Message_ModifyFailedBindPhone":"Gagal memperbarui. Tautkan nomor telepon, lalu coba lagi.","Text_AskersApplyAccess":"Akses diminta oleh ${0} dan ${1} lainnya","Text_PersonalUser":"Pengguna pribadi","Text_ApplyAccess":"Minta Akses","Option_Viewable":"Lihat","Option_Editable":"Edit","Option_Manageable":"Dapat dikelola","Text_Invited":"Diundang","Text_NoSearchResult":"Tidak ada hasil","Title_AddCollaborator":"Tambah Kolaborator","Placeholder_AddCollaboratorByName":"Masukkan nama anggota untuk menambahkan kolaborator","Title_Recommend":"Disarankan","Text_PeopleCount":"${0} pelanggan","Message_BindSuccessCollaboratorAdded":"Berhasil dihubungkan. Kolaborator ditambahkan","Message_AddFailedChangePermissionOrBindPhone":"Gagal menambahkan. Ubah izin menjadi \\"Dapat melihat\\" atau tautkan nomor telepon Anda, lalu coba lagi.","Message_SelectAtLeastOneCollaborator":"Pilih setidaknya satu kolaborator!","Message_ShareSuccess":"Berhasil dibagikan!","Tip_AddCollaboratorDirectAccess":"Setelah ditambahkan, mereka dapat mengaksesnya langsung dari \\"Dibagikan Kepada Saya\\" tanpa tautan.","Text_TotalPeople":"${0} Orang","Option_Remove":"Hapus","Tip_PermissionChangedToEdit":"Izin aktual kolaborator ini telah diubah menjadi Edit","Tip_AnyoneWithLinkCanEdit":"Karena siapa pun yang memiliki tautan dapat mengedit","Tip_TeamMemberWithLinkCanEdit":"Karena anggota tim yang memiliki tautan dapat mengedit.","Title_CollaboratorManage":"Manajemen Kolaborator","Tag_OutsideTeam":"Di luar tim","Title_RemoveKeepTeamMembers":"Setelah dihapus, hanya kolaborator yang saat ini berada dalam tim yang dapat terus mengaksesnya.","Title_RemoveOnlySelfAccess":"Setelah dihapus, hanya Anda yang dapat mengaksesnya.","Option_OnlyCollaborators":"Khusus kolaborator","Option_OnlySelf":"Hanya Saya","Text_OthersNeedApply":"(Orang lain perlu meminta akses)","Option_PermissionUnchanged":"Izin tidak berubah","Option_TeamMembers":"Anggota Tim","Text_TeamMembersViaLink":"Anggota tim melalui tautan","Option_Anyone":"Siapa pun","Text_AnyoneViaLink":"Siapa pun yang memiliki tautan","Text_UntitledDesign":"Desain tanpa nama","Message_BindSuccessLinkCopied":"Berhasil dihubungkan. Tautan berbagi disalin","Message_ShareFailedChangePermissionOrBindPhone":"Gagal membagikan. Ubah izin menjadi \\"Dapat Melihat\\" atau tautkan nomor telepon untuk membagikan.","Text_LinkUpdating":"Memperbarui tautan...","Tip_FolderShareTeamOnly":"Folder hanya dapat dibagikan dengan anggota tim.","Text_CollaboratorCount":"Kolaborator: ${0}","Button_Manage":"Kelola","Tooltip_PartialPermissionChanged":"Izin beberapa kolaborator telah berubah","Tip_FolderLinkVisitorBecomeMember":"Pengguna yang mengakses folder melalui tautan akan otomatis menjadi anggota tim Anda.","Tip_OnlyTeamMembersCanAccess":"Saat ini, hanya anggota tim yang dapat mengakses ini","Tip_InviteUserNotInTeam":"Jika pengguna yang ingin Anda ajak berbagi belum bergabung dengan tim, silakan","Button_InviteMember":"Undang","Text_ShareLinkView":"${0}#Saya membagikan ${1}. Ketuk untuk melihat","Text_ShareLinkJoin":"${0} mengundang Anda untuk bergabung dengan ${1}. Ketuk untuk bergabung.","Text_ShareLinkApplyVisit":"${0}#Saya meminta akses ke ${1}. Ketuk untuk memproses permohonan.","Text_ShareLinkApplyEdit":"${0}#Saya telah meminta untuk mengedit [${1}]. Ketuk untuk memproses permintaan.","Option_7Days":"7 hari","Option_30Days":"30 hari","Option_Permanent":"Permanen","Text_Slogan_DesignKit":"Alat Wajib untuk Profesional E-commerce","Button_RemoveNonTeamCollaborator":"Hapus Kolaborator Eksternal","Button_RemoveNonPersonalCollaborator":"Hapus kolaborator non-individu","Text_freePlan_Zawa":"Free","Text_standardPlan_Zawa":"Plus","Text_proPlan_Zawa":"Pro","Text_maxPlan_Zawa":"Maks","Tool_IDPhoto":"Foto Identitas Diri","Tool_PortraitPhoto":"Foto Profil","Tool_ImageBatchProcess":"Pemrosesan Gambar Batch","Tool_AiShoes":"Model Alas Kaki","Tool_AiCopywriting":"Copywriting AI","Tool_AiPoster":"Poster AI","Tool_OnlineDesign":"Desain Online","Tool_ClothesDewrinkle":"Hapus Kerutan Pakaian","Tool_PortraitBackground":"Latar","Tool_ViralVideo":"Pembuat Video Produk","Tool_AiPosterNote":"Catatan Gambar & Teks AI","Title_WholeProductClone_DomesticCloneCase":"Gunakan kembali seluruh set produk","Title_ApparelClone_DomesticCloneCase":"Gunakan kembali pakaian dengan mudah","Title_PosterCoverClone_DomesticCloneCase":"Gunakan Kembali Sampul Poster","Prompt_PosterThemeChange_DomesticCloneCase":"Instruksi buat ulang: Ubah menjadi poster bertema kota","Title_SocialGraphicsClone_DomesticCloneCase":"Gunakan Ulang Postingan Media Sosial Sekali Ketuk","Prompt_SocialThemeChange_DomesticCloneCase":"Instruksi buat ulang: Ubah menjadi postingan gambar dan teks bertema wisata Xiamen","Title_CloneType_LeftPanelClone":"Tipe Penggunaan Ulang","Text_CloneReferenceUploadLimitTip_Clone":"Tambahkan hingga ${0} gambar — setiap referensi menghasilkan 1 hasil.","Option_MatchStyle_Clone":"Cocokkan Gaya","Option_MatchReference_Clone":"Pencocokan Referensi","Message_ClaimFailed":"Manfaat ini tidak dapat diklaim saat ini. Coba lagi nanti.","Message_RedeemFailed":"Penukaran gagal. Coba lagi nanti.","Button_UpgradeTeamVip":"Upgrade ke Keanggotaan Tim","Message_SystemError":"Terjadi kesalahan. Coba lagi nanti.","Label_AgentTeam":"Tim","Desc_AgentTeamBanner":"Masuk ke mode AI Agent Teams, tempat para ahli otomatis berkolaborasi untuk menangani perencanaan menyeluruh dan desain visual dengan satu prompt.","Text_SearchResultCount":"Hasil pencarian · ${0} hasil","Button_ExitAdmin":"Manajemen Keluar","Text_InviteReward":"Manfaat Undangan","Button_More":"Lainnya","Text_TeamExpiredTip":"Tim ini sudah berakhir. Anda hanya dapat melihat dan memindahkan item di dalam tim. Perpanjang atau upgrade untuk terus menggunakan semua fitur.","Text_TeamFrozenTip":"Tim ini telah melampaui batas anggota. Akun Anda telah dibekukan. Hubungi pemilik tim untuk terus menggunakannya.","Desc_ImageEdit":"Impor gambar dan mulai mengedit","Desc_ViralVideo":"Buat berbagai jenis video viral secara massal dengan sekali klik","Desc_ProductImageSet":"Buat satu set lengkap gambar produk e-commerce dalam sekali klik","Title_RecommendTools":"Rekomendasi Tools","Button_CloseVideoPreview":"Nonaktifkan pratinjau video","Label_PromptDesc":"Deskripsi Prompt","Tab_Preview":"Efek","Tab_Report":"Laporan Analisis","Button_Preview":"Pratinjau","Button_PrevPage":"Sebelumnya","Button_NextPage":"Berikutnya","Text_LoadingHard":"Memuat...","Button_ReplicateOne":"Buat Ulang dengan AI","Text_EmptyContent":"Tidak ada item ditemukan","Text_Today":"Hari ini","Text_Tomorrow":"Besok","Text_Yesterday":"Kemarin","Text_DaysLater":"${0} hari lagi","Text_DaysAgo":"${0} hari lalu","Desc_CreateDesign":"Mulai dengan kanvas kosong","Title_ClaimSuccess":"Diklaim","Text_VipExpiry":"Masa Berlaku VIP:","Title_ClaimFailed":"Gagal mengklaim","Button_GoDesign":"Desain Sekarang","Title_ClientDownload":"Unduh Klien","Desc_DesignKitApp":"Sinkronkan riwayat kreasi di ponsel dan komputer untuk mendesain dengan efisien kapan saja, di mana saja","Title_MeituXiuxiuPC":"Meitu PC","Desc_MeituXiuxiuPC1":"Editor Foto untuk kebutuhan sehari-hari dan pekerjaan","Desc_MeituXiuxiuPC2":"Dan alat desain yang mudah digunakan!","Button_DownloadNow":"Unduh sekarang","Text_Pending":"Menunggu Pembayaran","Text_MoreFunctions":"Format multipel","Text_NoMessages":"Tidak ada pesan ditemukan","Tab_SystemMessage":"Pesan sistem","Tab_Notification":"Notifikasi","Button_MarkAllRead":"Tandai semua sebagai telah dibaca","Label_Folder":"Folder","Label_Record":"Catatan Pengeditan","Label_Template":"Templat","Text_RequestAccess":"Minta Akses","Text_EditViewDownload":"(Edit, Lihat, Unduh)","Text_ViewDownloadOnly":"(Hanya lihat dan unduh)","Text_TeamRenewSuccess":"Keanggotaan Tim Anda berhasil diperpanjang","Text_TeamRenewExpiredTip":"Perpanjang sekarang untuk mendapatkan akses tak terbatas ke templat komersial perusahaan, elemen, dan fitur eksklusif untuk seluruh tim.","Label_SystemNotice":"Pemberitahuan Sistem","Label_PromptTutorial":"Tutorial Prompt","Label_BrandSpec":"Panduan Merek","Label_ContactBusiness":"Hubungi Sales","Text_ScanConsultant":"Pindai untuk menghubungi konsultan tim khusus","Tab_Project":"Proyek","Placeholder_SearchProject":"Masukkan nama proyek atau kata kunci","Placeholder_SearchRecipe":"Masukkan nama templat atau model","Placeholder_SearchTemplate":"Masukkan kata kunci templat atau nama fitur","Title_HotTools":"Alat yang sedang tren","Title_HotTemplates":"Templat tren","Title_PosterTemplate":"Templat desain grafis","Text_NotFoundTemplate":"Tidak menemukan Templat yang Anda suka? Klik di sini","Button_Feedback":"Masukan","Button_ViewAllTemplates":"Lihat semua templat","Tooltip_OpenNewTab":"Buka di Tab Baru","Button_BookDemo":"Jadwalkan Demo","Title_ApplyTeamDemo":"Minta Demo Tim","Desc_ContactWithinOneDay":"Setelah Anda mengirimkan informasi Anda, kami akan menghubungi Anda dalam 1 hari kerja.","Title_LeaveContactInfo":"Tinggalkan informasi kontak Anda agar kami dapat memberikan dukungan 1v1 yang lebih baik.","Title_FreeTeamVipSurvey":"Isi detail tim Anda untuk mendapatkan Keanggotaan Tim gratis 7 hari","Label_SingleUser":"Hanya untuk satu orang","Text_MemberCountRange":"${0}~${1} pelanggan","Text_MemberCountRangeDash":"${0}-${1} Orang","Text_MemberCountOrMore":"${0}+ Orang","Label_TemplateReuse":"Unggah dan gunakan kembali templat","Label_MultiCollaboration":"Pengeditan kolaboratif","Label_EnterpriseLicense":"Lisensi Komersial Perusahaan","Label_SharedCredits":"Kredit dan potongan bersama tim","Label_BrandManagement":"Manajemen Spesifikasi Merek","Label_YourName":"Nama Anda","Message_PleaseEnterName":"Masukkan nama Anda","Label_YourPhone":"Nomor Ponsel Anda","Message_PleaseEnterPhone":"Masukkan nomor ponsel atau telepon rumah Anda","Message_PleaseEnterValidPhone":"Masukkan nomor ponsel yang valid","Label_CompanyName":"Nama Perusahaan","Message_PleaseEnterCompanyName":"Masukkan nama perusahaan Anda","Placeholder_EnterCompanyName":"Masukkan nama perusahaan Anda","Label_ProductUsers":"Jumlah orang yang menggunakan produk","Message_PleaseSelectProductUsers":"Pilih jumlah orang yang akan menggunakan produk ini","Label_TeamCapabilitiesInterest":"Fitur Tim Poster mana yang paling ingin Anda pelajari?","Text_MultiSelectParen":"(Boleh pilih lebih dari satu)","Message_PleaseSelectCapabilities":"Pilih fitur Meitu Design Studio yang ingin Anda pelajari lebih lanjut","Placeholder_TeamCapabilities":"Perlindungan Hak Cipta Komersial, Manfaat Bersama untuk Beberapa Pengguna, Manajemen Aset Digital, Kolaborasi Tim, Lainnya","Button_Submit":"Kirimkan","Desc_ManagerWillContact":"Manajer akun khusus Anda akan menghubungi Anda dalam 1–2 hari kerja. Pastikan Anda dapat dihubungi melalui telepon.","Title_ScanToInvoice":"Pindai Kode QR dengan browser ponsel Anda untuk mendapatkan invoice","Text_InvoiceOrderScope":"Gunakan tautan ini untuk meminta Invoice untuk pesanan Meitu Design Studio.","Text_TransferInvoiceContact":"Untuk pesanan transfer bank perusahaan, klik Kontak di pojok kanan bawah untuk mengajukan penerbitan.","Desc_MenuProjectGuide1":"[Ruang saya] dan [Dibagikan kepada saya]","Desc_MenuProjectGuide2":"Semuanya kini diatur dalam Proyek","Text_SetPrefix":"Tetapkan sebagai","Text_TodayWithTime":"Hari ini ${0}","Text_YesterdayWithTime":"Kemarin ${0}","Format_MonthDay":"M D","Format_YearMonthDay":"D/M/YYYY","Text_MultiPage":"Halaman Multipel","Text_PageCount":"${0} Halaman","Text_ViewOnly":"Hanya Lihat","Text_NoPermission":"Tidak ada akses","Button_JumpToStorage":"Lewati ke lokasi penyimpanan","Label_PageUnit":"Halaman","Label_JumpTo":"Cobalah sekarang","Text_TotalDataCount":"${0} item","Title_RelateRecommend":"Disarankan","Title_HotSearch":"Pencarian populer","Title_LatestMaterial":"Elemen terakhir","Title_TopicList":"Topik Panas","Title_ArticleList":"Artikel Populer","Title_ToolList":"Alat populer","Text_AccountOnePerson":"Akun: 1 Orang","Text_AccountTenMin":"Akun: Minimal 10 pengguna","Text_LetsTalk":"Mari Mengobrol","Text_NewUserExperience":"Pengalaman Pengguna Baru","Text_Buy12Months":"Beli 12 Bulan","Text_LinkExpired":"Tautan ini tidak tersedia.","Text_ContactAdminToJoin":"Hubungi administrator untuk bergabung","Desc_JoinOrgCollaboration":"Bergabunglah dengan organisasi dan mulai berkolaborasi secara efisien dengan tim Anda","Button_AcceptInvite":"Terima undangan","Title_ConfirmNickname":"Konfirmasi nama panggilan Anda untuk tim","Placeholder_NameWithin20":"Masukkan nama dalam 20 karakter","Desc_NicknameHelp":"Nama panggilan Anda membantu rekan kerja menemukan Anda dengan lebih mudah.","Title_TeamVipExpired":"Keanggotaan tim sudah berakhir.","Title_TeamSeatsInsufficient":"Slot Keanggotaan Tim tidak cukup","Button_SeatAssignment":"Penetapan Kursi","Text_MemberSeatCount":"Anggota/Kursi:","Text_FreeSeatsFrozen":"Anggota yang melebihi batas kursi gratis telah dibekukan","Desc_RenewTeamForAll":"Agar semua anggota tetap memiliki akses, perpanjang Keanggotaan Tim Anda.","Text_SeatsExceededFrozen":"Anggota yang melebihi batas kuota telah dibekukan.","Desc_AddSeatsForAll":"Untuk memberi akses kepada semua orang, beli slot Keanggotaan Tim tambahan.","Title_TeamToolUnsupported":"Alat ini tidak didukung di Posters Team Edition.","Desc_SwitchPersonalToUse":"Untuk menggunakan alat ini, beralih ke versi Personal.","Label_RegularTemplate":"Templat Standar","Label_Suite":"Tetapkan","Label_Filter":"Filter","Label_Sort":"Urutkan","Label_Scene":"Skenario","Label_Materials":"Material","Label_Purpose":"Gunakan","Label_Industry":"Industri","Label_Color":"Warna","Label_Format":"Tata Letak","Label_Category":"Kategori","DesignKit":"美图设计室","Placeholder_SearchTemplateMobile":"Cari templat","Label_DesignType":"Jenis Desain","Label_TemplatePurpose":"Tujuan Templat","Label_TemplateStyle":"Gaya Templat","Label_TemplateColor":"Warna Templat","Label_ApplicableIndustry":"Industri yang Sesuai","Label_TemplateSize":"Ukuran templat","Label_UsageThreshold":"Pemula dapat menggunakan","Label_TemplateNumber":"Nomor Templat","Desc_ScrollViewAllPages":"Gulir ke atas atau ke bawah untuk melihat semua halaman","Title_SimilarPosterRecommend":"Rekomendasi poster serupa","Button_EditCurrentTemplate":"Edit templat saat ini","Button_EditAllTemplates":"Edit Semua Templat","Button_EditNow":"Edit sekarang","Title_RecordUpgrade":"Pembaruan baru tersedia!","Desc_RecordUpgrade1":"Mencakup semua templat poster dan riwayat pengeditan foto di akun ini. Beralih dengan mulus dari mengedit foto ke mendesain poster.","Desc_RecordUpgrade2":"Beralih dengan mulus dari mengedit gambar ke mendesain poster.","Footer_AboutUs":"Tentang kami","Footer_JoinUs":"Bergabung dengan Kami","Footer_ContributeCenter":"Pusat Kontributor","Title_HomeAgentTeam":"Tim Agen AI - Desain Bisnis Yang Menarik dan Memberikan Hasil","Title_HomeChat":"Beri tahu saya apa yang ingin Anda buat.","Nav_Home":"Beranda","Title_BrandManagement":"Manajemen Merek","Nav_HelpDesign":"Desain untuk saya","Title_OrgInfo":"Informasi Organisasi","Title_MemberManage":"Manajemen Anggota","Title_DataDashboard":"Dasbor Data","Title_CommercialAuth":"Penggunaan Komersial Bebas Khawatir","Title_OrderInvoice":"Invoice Pesanan","Title_TeamCollaboration":"Kolaborasi Tim","Title_CopyrightGallery":"Hak Cipta Galeri Foto","Title_DownloadCenter":"Pusat Unduhan","Nav_TodayRecommend":"Disarankan Hari Ini","Nav_HotCalendar":"Festival","Nav_InspirationFormula":"Templat Inspirasi","Nav_OneClickSame":"Turunan","Title_PosterTemplateNav":"Templat Poster","Message_NetworkError":"Kesalahan jaringan, tidak dapat terhubung ke server.","Text_Downloading":"Mengunduh sumber daya","Text_DownloadResourceFailed":"Gagal mengunduh sumber daya.","Title_DesignKitScanLogin":"美图设计室 Pindai untuk masuk","Desc_ScanGuideLogin":"Buka Saya, lalu ketuk \\"Pindai\\" di kanan atas untuk masuk","Message_AlreadyFullVip":"Anda sudah memiliki semua manfaat keanggotaan. Tidak perlu membeli.","Message_ImageSizeExceeded":"Ukuran gambar melebihi batas","Text_NotLoggedIn":"Tidak masuk","Button_CreateBrandSpec":"Buat Spesifikasi","Title_BrandAdvQuestion":"Masih meminta LOGO, font, dan nilai warna merek dari rekan kerja?","Desc_BrandAdv1":"Logo Preset Desainer, Nilai Warna Merek, Gaya Teks, Pustaka Font","Desc_BrandAdv2":"Konfigurasikan panduan visual untuk berbagai merek atau proyek.","Desc_BrandAdv3":"Anggota tim lintas departemen dapat dengan cepat menambahkan dan menerapkan spesifikasi di editor","Button_UpgradeTeamForBrand":"Upgrade ke Keanggotaan Tim untuk menggunakan panduan merek sekarang","Title_ConfirmDeleteBrandGroup":"Hapus kumpulan standar ini?","Text_DeleteBrandNoAffect":"Riwayat edit yang telah diterapkan tidak akan terpengaruh.","Button_CreateBrandStandard":"Buat Spesifikasi Merek","Title_DeleteHint":"Hapus gambar","Text_DeleteIrreversible":"Setelah dihapus, tidak dapat dipulihkan. Lanjutkan dengan hati-hati.","Label_General":"Umum","Label_ColorCard":"Kartu Warna","Label_TextStyle":"Gaya Teks","Message_SavePrevStyle":"Simpan gaya sebelumnya","Message_SavePrevColorCard":"Simpan kartu warna sebelumnya","Message_SavePrevElement":"Simpan elemen sebelumnya terlebih dahulu.","Button_NewColorCard":"Buat Nuansa","Button_NewStyle":"Buat Gaya","Message_NameWithinN":"Masukkan nama (maks. ${0} karakter)","Message_ColorBlockLimit":"Setiap palet warna mendukung hingga ${0} contoh warna","Message_PleaseSelectFont":"Harap pilih font","Message_PleaseSelectFontSize":"Pilih ukuran fon","Placeholder_FontSize":"Ukuran Teks","Label_Bold":"Tebal","Label_Italic":"Miring","Text_FontSizeUnit":"No. ${0}","Text_Claiming":"Mengklaim...","Button_ClaimFreeBenefit":"Klaim Manfaat Gratis","Message_MissingExchangeCode":"Kode Penukaran Belum Diisi","Message_SwitchToPersonalFirst":"Beralih ke Personal terlebih dahulu","Desc_ClaimBenefitSuccess":"Anda telah mengklaim manfaat ini. Buka Meitu Posters dan mulai berkreasi!","Message_ClaimNewUserOnly":"Manfaat gratis ini hanya tersedia untuk pengguna baru yang mendaftar untuk pertama kalinya.","Text_AiDesignTagline":"Desain AI dalam genggaman Anda","Text_FreeBenefitLimited":"Klaim manfaat gratis untuk waktu terbatas","Text_ExchangeSceneFeatures":"Poster Komersial · Gambar e-commerce utama · Penghapusan AI · Cutout AI","Text_LimitedNewUserOnly":"Penawaran waktu terbatas, khusus pengguna baru","Text_SearchWithKeyword":"Cari \\"${0}\\"","Text_HelpEmptyHint":"Belum ada konten. Xiaomei akan segera menambahkan konten lainnya.","Placeholder_HelpSearch":"Apa yang ingin Anda ketahui?","Button_Search":"Cari","Message_SelectImageForTranslation":"Pilih gambar sebelum menggunakan Terjemahan Gambar.","Text_InviteCopyPrefix":"# Jangan buang waktu lagi pada gambar e-commerce! Daftar Meitu Designer dan dapatkan kredit gratis secara instan. Set produk, halaman detail, video promosi, dan lainnya — semua dibuat dengan satu klik. Klik tautan untuk mulai berkreasi!","Label_DistributionAgreement":"Perjanjian Layanan Distribusi Meitu Desain Studio","Label_DistributionConduct":"Kode Etik Komisi Layanan Afiliasi Meitu Design Studio","Alt_InviteFriendIcon":"Ikon undang teman","Alt_BothGetBeanIcon":"Ikon Dapatkan Kredit Keduanya","Text_BothGetBean":"Keduanya Mendapatkan Kredit","Alt_FriendFirstOrderIcon":"Ikon pesanan pertama teman selesai","Text_FriendFirstOrder":"Teman menyelesaikan pesanan pertama","Alt_RedPacketIcon":"Ikon Red Packet Diterima","Text_RedPacketArrived":"Red Packet diterima","Desc_InviteRule1":"Saat teman yang Anda undang berhasil mendaftar, Anda berdua akan mendapatkan 40 kredit. Gunakan untuk pembuatan gambar atau pengeditan foto. Berlaku selama satu bulan.","Desc_InviteRule2":"2. Anda dapat mengundang hingga 15 teman.","Desc_InviteRule3":"3. Dapatkan cashback saat teman berlangganan. Perhitungan reward: Jumlah reward = jumlah pembayaran aktual × tingkat reward (misalnya, jika teman membeli langganan tahunan dengan perpanjangan otomatis, Anda bisa mendapatkan reward tunai 196 × 15% = 29.4 USD). Reward dapat disesuaikan selama acara khusus atau promosi; jumlah yang benar-benar dikreditkan yang berlaku.","Desc_InviteRule4":"4. Jika Kredit dari paket atau Kredit bonus apa pun telah digunakan, pembelian tidak dapat dibatalkan, direfund, atau ditukarkan.","Desc_InviteRule5":"5. Pengguna yang sudah memiliki akun terdaftar, mereferensikan diri sendiri, membuat akun duplikat, atau melakukan aktivitas penipuan tidak memenuhi syarat untuk mendapatkan hadiah.","Desc_InviteRule6":"6. Meitu Design Studio berhak menyesuaikan kampanye dan mencabut hadiah dari akun yang tidak normal.","Message_SwitchToPersonal":"Beralih ke Personal","Message_GetInviteLinkFailed":"Gagal mendapatkan tautan undangan.","Message_InviteLinkRetry":"Gagal mendapatkan tautan undangan. Coba lagi nanti.","Message_CopySuccess":"Disalin!","Message_CopyFailedManual":"Penyalinan gagal. Salin tautan secara manual.","Text_LoginForInviteLink":"Masuk terlebih dahulu untuk mendapatkan tautan undangan","Text_SwitchPersonalForInviteLink":"Beralih ke profil pribadi Anda untuk mendapatkan tautan undangan","Alt_InviteRewardTitle":"Undang teman untuk mendapatkan kredit, dan berlangganan untuk mendapatkan cashback","Alt_InviteHeroVisual":"Visual Utama Cashback Undang Teman","Button_CopyInviteLink":"Salin tautan undangan.","Alt_ActivityRules":"Aturan Aktivitas","Desc_InviteRewardSummary":"Undang teman untuk mendaftar—Anda dan teman Anda masing-masing mendapatkan 40 kredit. Anda bisa memperoleh hingga 600 kredit. Teman Anda juga mendapatkan diskon langganan 7 hari untuk waktu terbatas. Jika teman Anda berlangganan keanggotaan Meitu Design Studio selama promo, Anda akan menerima cashback.","Text_CommissionRate15":"Tingkat komisi hingga 15%!","Text_DetailRules":"Aturan Detail","Alt_CashoutTutorial":"Guide Untuk Mengundurkan Diri","Desc_InviteDetailAppPath":"Buka Aplikasi Meitu Design Studio > Saya > Undang & Dapatkan > Dompet Penghasilan untuk melihat detail undangan Anda.","Desc_InviteDetailAppPathShort":"Buka Aplikasi Meitu Design Studio > Saya > Undang & Dapatkan > Dompet Penghasilan untuk melihat detail undangan.","Desc_InviteSettlementCycle":"Siklus penyelesaian: Pesanan langganan diselesaikan satu bulan setelah tanggal pesanan. Periode satu bulan ini adalah masa cooling-off pengembalian dana. Pesanan yang telah dikembalikan dananya tidak dapat ditarik selama periode ini. Setelah masa cooling-off berakhir, bagi hasil pendapatan untuk pesanan terkait dapat ditarik.","Button_LoginToGet":"Masuk untuk mendapatkan","Button_ClaimNow":"Klaim Sekarang","Title_SameStyleReplicate":"Buat ulang tampilan ini 🌟","Text_PageNotFound":"Halaman tidak ditemukan","Label_PricingPlan":"Harga","Title_ChooseMembershipPlan":"Pilih paket keanggotaan yang sesuai untuk Anda","Tab_RenewalYear":"Perpanjangan Tahunan","Tab_RenewalMonth":"Langganan Bulanan Kontinu","Tab_SingleYear":"Pembelian tahunan","Tab_SingleMonth":"Pembelian Satu Bulan","Text_MeidouPerMonth":"${0} kredit/bulan","Title_PersonalVipOnly":"Langganan ini hanya tersedia untuk akun Pribadi. Beralih ke Pribadi?","Button_Switch":"Beralih","Text_ComingSoon":"Segera hadir","Button_SubscribeNow":"Berlangganan Sekarang","Text_MostPopular":"Paling Disukai","Text_Trial7DaysPerYear":"Coba 7 hari (${0}/tahun)","Label_Year":"tahun","Text_StartingFrom":"Mulai","Label_DesignRecord":"Desain","Label_AgentRecord":"Catatan Agen","Button_ViewMore":"Lihat lainnya","Placeholder_PleaseEnterContent":"Masukkan konten","Text_InviteLinkExpired":"Tautan ini tidak tersedia.","Text_RegenerateInviteLink":"Hubungi admin Anda untuk membuat ulang tautan undangan.","Text_JoinedSuccess":"Anda berhasil bergabung","Text_UseTeamOnPc":"Kunjungi ${0} di komputer Anda untuk membuat bersama tim Anda","Button_CopyUrl":"Salin URL","Text_InviteYouToJoin":"\\"${0}\\" mengundang Anda untuk bergabung","Button_JoinNow":"Gabung sekarang","Title_TemplateCenter":"Pusat Templat","Text_NoSuchTemplate":"Belum ada templat jenis ini. Kami akan segera menambahkan lebih banyak.","Title_DesignKitHome":"Beranda Poster","Label_Tags":"Label","Button_DownloadAppToEdit":"Unduh Aplikasi X-Desain untuk mengedit","Title_DesignKitTeam":"X-Desain ${0}","Desc_TeamLandingQuestion":"Desain sepenuhnya bergantung pada desainer. Bagaimana cara meningkatkan efisiensi desain tim?","Button_UseNow":"Gunakan Sekarang","Text_ViewTeamIntro":"Lihat Ikhtisar Tim Lengkap","Button_ViewPricing":"Lihat harga","Button_EnterTeamNow":"Masukkan Sekarang","Title_EnterpriseSolution":"Pelajari Lebih Lanjut Tentang Solusi Perusahaan","Desc_EnterpriseContactForm":"Isi formulir, dan tim Meitu Designer akan menghubungi Anda dalam 1-3 hari kerja.","Message_CompanyNameMaxLength":"Nama perusahaan tidak boleh lebih dari 100 karakter.","Label_Position":"Jabatan","Message_PleaseEnterPosition":"Masukkan posisi Anda saat ini di perusahaan ini","Placeholder_EnterPhone":"Masukkan nomor telepon","Placeholder_EnterPosition":"Masukkan jabatan Anda saat ini di perusahaan ini","Label_ExpectedUsers":"Estimasi Pengguna","Title_TeamMaterialEasier":"Buat Aset Tim Dengan Lebih Mudah","Label_CommercialTemplate":"Pilih templat komersial apa pun","Desc_CommercialTemplate":"Bisnis yang terotorisasi dapat mengedit dan menerbitkan berbagai templat dan elemen untuk penggunaan komersial tanpa khawatir.","Label_BatchDesignSpeed":"Percepat Desain Massal","Desc_BatchDesignSpeed":"Batch Cutout, Templat, dan produksi gambar otomatis menghemat banyak waktu Anda.","Label_VisualStandard":"Spesifikasi Visual Terpadu","Desc_VisualStandardWork":"Palet warna preset, gaya font, dan panduan lainnya untuk memastikan gaya desain merek yang konsisten.","Desc_VisualStandardHome":"Palet warna preset, gaya teks, dan panduan lainnya (dengan dukungan unggah fon) untuk menjaga desain tetap konsisten.","Title_TeamCollabEfficient":"Desain kolaboratif yang lebih efisien","Label_TeamSharedResource":"Sumber Daya Bersama Tim","Desc_TeamSharedResource":"Bagikan folder menurut departemen atau proyek dengan sekali klik, lalu buat pustaka aset desain dengan cepat.","Label_FlexiblePermission":"Pengaturan izin fleksibel","Desc_FlexiblePermission":"Tetapkan izin secara fleksibel untuk setiap file agar aset desain tidak bocor.","Label_TemplateQuickReuse":"Gunakan Kembali Templat Dengan Cepat","Desc_TemplateQuickReuse":"Unggah PSD ke pustaka templat agar dapat digunakan ulang dengan cepat oleh seluruh tim Anda. Tidak perlu lagi menunggu file.","Title_TeamManageEasier":"Kelola anggota dan aset dengan mudah","Label_TeamDataReview":"Tinjauan Data Tim","Desc_TeamDataReview":"Tinjau aktivitas kreasi anggota secara berkala di backend dan sesuaikan kursi tim sesuai kebutuhan.","Label_MemberRoleManage":"Manajemen Peran Anggota","Desc_MemberRoleManage":"Tetapkan administrator tim, kelola perubahan anggota, dan tangani serah terima aset.","Tag_ConvenientCreate":"Pembuatan Mudah","Desc_FreeEditionAudience":"Tersedia untuk individu dan tim","Desc_FreeTemplateMaterial":"Templat/Elemen Gratis","Desc_PartialFreeTools":"Alat Pintar (Sebagian Gratis)","Button_FreeExperience":"Uji Coba Gratis","Tag_QualityContent":"Konten berkualitas tinggi","Desc_PersonalEditionAudience":"Untuk pelaku usaha individu, desainer, atau kreator independen","Desc_IncludesFreeBenefits":"Termasuk manfaat paket gratis","Desc_PaidTemplateMaterial":"Templat/Elemen Premium","Desc_PersonalCommercialAuth":"Lisensi Komersial Pribadi","Desc_Meidou330PerMonth":"330 Kredit/Bulan (Untuk Alat Generasi AI)","Tag_EfficientCollab":"Kolaborasi Efektif","Desc_TeamEditionAudience":"Untuk bisnis kecil atau tim freelance yang membutuhkan kolaborasi tim","Desc_IncludesProBenefits":"Termasuk manfaat Pro (tidak termasuk Foto ID)","Desc_EnterpriseAuthOne":"Lisensi komersial*1","Desc_BrandSpecBrief":"Panduan Merek (Logo/Kartu Warna/Font)","Desc_PsdTemplateUpload":"Unggah Templat PSD","Desc_TeamDataAnalysis":"Analisis Data Tim","Desc_TeamResourceShare":"Berbagi Sumber Daya Kreatif Tim","Desc_SharedPermissionManage":"Pengelolaan Izin Bersama","Desc_SeatsMeidouPerMonth":"Kursi * 330 kredit/bulan (untuk fitur pembuatan AI)","Title_MarketingCostControl":"Biaya pemasaran yang lebih terkendali untuk perusahaan Anda","Label_AiPhotoCostDown":"Pangkas Biaya Dengan Fotografi Produk AI","Desc_AiPhotoCostDown":"Gambar Produk AI dan Coba Model AI membantu Anda membuat foto yang profesional dengan mudah, tanpa perlu menyiapkan studio atau menyewa model, sehingga hasilnya tidak terlihat \\"beranggaran terbatas.\\"","Label_AiEditEfficiency":"AI retouch","Desc_AiEditEfficiency":"Selesaikan penyesuaian foto, koreksi warna, dan retouch produk dalam sekali klik untuk mengikuti peluncuran produk dan mengurangi biaya retouch manual.","Label_SmartVideoCreate":"Pembuatan Video AI","Desc_SmartVideoCreate":"Gambar ke Video dan Video Komersial 3D mempermudah proses pembuatan, sehingga promosi video tidak lagi terkendala proses pengeditan yang panjang dan biaya pemodelan yang tinggi.","Text_TeamAuthSubLabel":"(Keanggotaan Tim mencakup lisensi komersial perusahaan)","Title_MoreOptions":"Opsi Lainnya","Title_FreeImageCreate":"Buat gambar gratis","Desc_FreeTemplateSlashMaterial":"Templat/Elemen Gratis","Desc_PartialFreeSmartTools":"Beberapa alat AI gratis","Title_IncludesPersonalPlus":"Mencakup semua manfaat Personal, ditambah:","Desc_EnterpriseBizAuthOne":"Lisensi Komersial Perusahaan (1 Entitas)","Desc_TeamAssetShare":"Berbagi Aset Tim","Desc_BrandSpecFull":"Panduan Merek (Logo/Kartu Warna/Gaya Teks)","Desc_MemberAccountHandover":"Manajemen Akun Anggota dan Serah Terima Aset Saat Offboarding","Desc_TeamUsageAnalytics":"Analisis data penggunaan tim","Desc_MonthlyMeidouShared":"Dapatkan ${0} kredit setiap bulan, dapat digunakan bersama di beberapa akun","Title_IncludesTeamPlus":"Mencakup semua manfaat Team, ditambah:","Desc_EnterpriseBizAuthThree":"Lisensi Komersial Perusahaan (3 Entitas)","Desc_CustomBrandNav":"Bilah navigasi merek perusahaan kustom","Desc_SsoAccess":"Integrasi SSO","Desc_MonthlyMeidou20000":"20.000+ kredit gratis per bulan, dibagikan ke beberapa akun","Title_OpenClawApi":"Integrasi API OpenClaw","Desc_OpenClawApi":"Akses kemampuan pemrosesan gambar X-Design AI dan kelola token API serta saldo kredit Anda.","Title_OpenClawApiShort":"OpenClaw API","Desc_OpenClawMobile":"Kelola token API dan saldo kredit Anda","Title_QuickStart":"Mulai Cepat","Desc_OpenClawQuickStart":"Setelah menyelesaikan penerapan OpenClaw, kirim perintah berikut ke Lobster untuk menginstal semua paket skill secara otomatis:","Button_CopyInstallConfig":"Salin Konfigurasi Instalasi","Text_SeeTutorial":"Lihat tutorial lengkap","Text_DesignkitSkillsDoc":"Dokumentasi designkit-skills","Title_VersionChangelog":"Perbarui ke Versi Baru","Text_NoChangelog":"Tidak ada riwayat pembaruan","Message_InstallCmdCopied":"Petunjuk instalasi dan Token disalin","Title_ApiToken":"Token API (AK)","Desc_ApiToken":"Gunakan Token untuk autentikasi permintaan API. Klik \\"Ganti\\" untuk membuat Token baru (Token lama langsung tidak berlaku).","Button_CopyToken":"Salin token","Button_Reset":"Lainnya","Button_ResetToken":"Lebih Banyak Token","Text_PleaseLoginFirst":"Harap login terlebih dahulu.","Text_PleaseLoginDash":"Login terlebih dahulu","Title_ResetToken":"Ubah Token","Desc_ResetTokenWarning":"Setelah diganti, token lama akan langsung menjadi tidak valid, dan panggilan API yang sedang berlangsung dapat gagal. Lanjutkan?","Message_TokenReset":"Atur ulang token","Message_TokenCopied":"Token disalin","Desc_OpenClawMeidou":"Kredit adalah unit penagihan untuk panggilan API OpenClaw. Jika saldo tidak cukup, permintaan API akan gagal.","Label_CurrentBalance":"Saldo saat ini","Button_BuyMeidou":"Beli kredit","Button_ConsumptionRecords":"Riwayat pengeluaran","Title_OpenClawFeatures":"Pengenalan Fitur OpenClaw","Desc_OpenClawFeatures":"Kemampuan AI X-Design kini tersedia melalui OpenClaw. Setelah autentikasi AK, Anda dapat langsung menggunakan kemampuan berikut, ditagih berdasarkan kredit, dengan pengembalian dana otomatis jika gagal.","Desc_OpenClawProductImageSet":"Unggah gambar produk, dan AI akan otomatis membuat serangkaian gambar produk yang sesuai dengan standar berbagai platform e-commerce dan mendorong tingkat konversi tinggi, untuk memenuhi semua kebutuhan gambar listing produk.","Desc_OpenClawSmartCutout":"Didukung oleh Meitu AI, fitur ini mendeteksi subjek Anda secara akurat dan otomatis menghapus latar belakang, mendukung potret, produk, dan berbagai skenario lainnya.","Desc_OpenClawEnhanceClarity":"Perbaikan Kualitas Gambar AI memulihkan gambar buram atau berkualitas rendah menjadi kualitas HD dengan detail yang ditingkatkan.","Button_ConfirmReset":"Konfirmasi","Message_MeidouQuotaMinZero":"Masukkan jumlah kredit 0 atau lebih","Message_MeidouQuotaRange":"Masukkan jumlah kredit dari 0 hingga ${0}","Message_AssignSuccess":"Berhasil ditetapkan!","Message_SelectAssignableMember":"Pilih anggota untuk menetapkan kuota kredit","Message_NameLength1To20":"Masukkan nama dengan 1-20 karakter","Placeholder_EnterQuota":"Masukkan kredit","Text_Unlimited":"Tak terbatas","Text_Unassigned":"Belum ditetapkan","Label_MemberName":"Nama Anggota","Text_Me":"Aku","Text_Deactivated":"Logout","Text_OverQuotaFrozen":"Dibekukan karena melebihi batas","Label_PhoneNumber":"Nomor telepon","Label_Role":"Peran","Text_Owner":"Pemilik","Label_QuotaLimit":"Batas Kredit Tersedia","Message_SelectMemberCount":"Harap pilih ${0} anggota","Text_SelectedMemberCount":"${0} dipilih","Text_RemainingSeats":"Kursi tersisa:","Button_ConfirmAssign":"Konfirmasi Alokasi","Button_BatchSetQuota":"Batas Pengaturan Massal","Title_ChangeRole":"Ubah Karakter","Button_RemoveMember":"Hapus anggota","Text_PartialMemberFrozenTip":"Beberapa anggota mengalami over-frozen. Coba lagi","Text_Or":"Atau","Button_RenewMembership":"Perpanjang","Label_RemainingMeidou":"Sisa kredit","Desc_MemberQuotaTip":"Tips: Kredit yang ditetapkan untuk anggota adalah batas penggunaan. Jumlah yang dapat digunakan bergantung pada sisa Kredit tim.","Text_MemberEmpty":"Tidak ada anggota","Message_DataLoadFailed":"Gagal memuat data","Title_BatchAssignMeidou":"Bagikan kredit secara merata kepada ${0} anggota yang dipilih","Label_AssignCount":"Pelanggan yang Ditugaskan","Label_TotalConsumption":"Total Penggunaan","Title_ConfirmTransferAssets":"Transfer aset?","Message_TransferAssetsSuccess":"Aset berhasil ditransfer dari anggota yang keluar. Periksa sekarang.","Label_MySpace":"Ruang Saya","Message_RemoveMemberProgress":"Anggota berhasil dihapus. Periksa progres transfer aset.","Message_RemoveMemberSuccess":"Anggota berhasil dihapus","Title_RemoveMember":"Hapus anggota","Text_RemovingStep1":"Menghapus...","Text_AssetHandleStep2":"2. Aset yang dibuat oleh anggota ini","Option_TransferToUser":"Transfer ke pengguna lain","Text_TransferableAssets":"Aset yang Dapat Ditransfer","Text_DeletedAssets":"Aset Terhapus","Desc_RemovedAssetFolder":"Folder/catatan pengeditan yang dibuat (termasuk sumber daya yang belum dibagikan)","Desc_RemovedAssetTemplate":"Templat/Elemen yang diunggah (termasuk aset yang tidak dibagikan)","Desc_RemovedAssetAiRecord":"Riwayat/Favorit Set AI","Text_SelectAssetReceiver":"3. Pilih Anggota Penerima Aset","Desc_RejoinAssetRecovery":"Jika anggota ini bergabung kembali dalam 30 hari, aset di atas akan muncul kembali di ruang pribadi mereka.","Desc_RejoinAssetExpire":"Setelah 30 hari, ini akan dihapus permanen dan tidak dapat dipulihkan.","Button_ConfirmRemove":"Hapus","Text_Last7Days":"7 hari terakhir","Text_Last30Days":"30 hari terakhir","Text_Last90Days":"90 Hari Terakhir","Text_MemberActiveCount":"Anggota Aktif","Text_NewAssetCount":"Aset Baru","Title_TeamOverview":"Ikhtisar Tim","Title_ActiveMembers":"Anggota aktif","Desc_ActiveMembers":"Jumlah anggota yang masuk dalam rentang waktu yang ditentukan","Label_PersonUnit":"Orang","Label_TotalCount":"Total","Title_AiToolGeneration":"Generasi Alat AI","Desc_AiToolGeneration":"Total pembuatan oleh semua anggota menggunakan alat AI platform dalam rentang waktu yang ditentukan","Label_TimesUnit":"Kali","Label_Accumulative":"Total","Title_TotalAssetDownload":"Total Unduhan Aset","Desc_TotalAssetDownload":"Total unduhan oleh semua anggota di platform dalam rentang waktu yang ditentukan","Label_CopyUnit":"Laporan","Nav_MySpace":"Ruang saya","Nav_ShareWithMe":"Konten yang Dibagikan","Nav_SpaceManage":"Manajemen Penyimpanan","Nav_AssetHandover":"Aset Offboarding","Label_Text":"Teks","Label_Group":"Kombinasi","Label_Table":"Sheet","Label_Chart":"Grafik","Label_AiProductShoot":"Fotografi Komersial AI","Label_AiProductDesign":"Desain Produk AI","Label_SameStyleReplicate":"Buat lagi","Button_CreateFolder":"Buat folder","Button_NewFolder":"Folder baru","Button_UploadFile":"Unggah","Button_UploadFolder":"Unggah folder","Button_UploadTemplate":"Unggah Templat","Menu_Rename":"Ganti nama","Button_UseTemplate":"Gunakan","Button_CopyToTeam":"Salin ke Tim","Text_MoveToMySpace":"Pindahkan ke ruang saya","Button_ExportContent":"Ekspor","Button_Deselect":"Hapus pilihan","Text_SelectAllWithCount":"Pilih Semua (${0} dipilih)","Message_PartialFileCannot":"Beberapa file yang Anda pilih tidak dapat ${0}","Text_NoSearchResultYet":"Hasil tidak ditemukan","Text_SearchNoMatch":"Hasil tidak ditemukan","Text_EmptyGoCreate":"Belum ada konten. Buat sekarang!","Text_EmptyGoAction":"Belum ada konten. Buka ${0}.","Text_ActionCreate":"Buat","Desc_OrganizeWorks":"Kelola proyek pribadi atau tim secara efisien","Message_EnterName":"Masukkan nama ${0}","Message_EnterNameWithin20":"Masukkan nama ${0} dalam 20 karakter","Message_OperationSuccess":"Operasi berhasil!","Message_EnterFolderName":"Harap masukkan nama folder!","Message_EnterFolderNameWithin20":"Masukkan nama folder maksimal 20 karakter","Text_CopyTo":"Salin ke","Text_CopyingMayTakeMinutes":"Menyalin... Ini mungkin memerlukan beberapa menit.","Button_GoTeamView":"Lihat di Tim","Message_BrowserNoUploadFolder":"Unggahan folder tidak didukung di browser ini.","Title_MoveAfterMySpace":"Setelah dipindahkan, item akan berada di Ruang Saya","Desc_MixSortAfterMove":"Dicampur dengan aset lain berdasarkan waktu pembaruan","Message_HandoverFailed":"Handoff gagal","Message_CreateSuccessExclaim":"Berhasil dibuat!","Message_NoFilePermission":"Anda tidak memiliki izin untuk melakukan tindakan ini pada file ini.","Title_ConfirmDeleteRecord":"Hapus catatan berikut?","Title_ConfirmUnfavorite":"Jika dihapus dari Favorit, catatan hasil desain ini akan hilang. Yakin?","Title_ConfirmDeleteGenerate":"Setelah dihapus, hasil yang dibuat akan hilang. Yakin ingin menghapusnya?","Text_To":"Sampai","Text_FileOperating":"Dalam file ${0}...","Message_OperateSuccess":"${0} disematkan","Text_CurrentDir":"Direktori saat ini","Text_OperateDir":"Menu Action","Text_Creating":"Membuat","Text_NoContent":"Tidak ada konten","Title_CancelUploadConfirm":"Unggahan masih berlangsung. Batalkan semua unggahan yang sedang berlangsung?","Button_CancelUpload":"Keluar","Message_MaxUploadFiles":"Anda dapat mengunggah hingga 500 file sekaligus","Message_PersonalUploadLimit":"Akun pribadi dapat mengunggah hingga 20 file sekaligus. Untuk mengunggah lebih dari 20 file, buat tim.","Title_PsdToTemplate":"Unggah PSD untuk langsung mengubahnya menjadi templat tim","Desc_TemplateEditOnly":"Hanya Anda yang dapat mengedit Templat. Anggota lain hanya dapat menduplikasinya dan tidak dapat mengubah Templat asli.","Link_WhatIsTemplate":"Apa Itu Templat","Button_ConvertTemplate":"Ubah menjadi templat","Button_UploadOnly":"Unggah saja","Text_WaitUpload":"Menunggu untuk diunggah","Text_Transferring":"Mentransfer...","Text_AllUploadComplete":"Semua unggahan selesai","Text_FilesUploadFailed":"Gagal mengunggah ${0} file","Text_UploadingProgress":"Mengunggah... (${0}/${1})","Button_StartAll":"Mulai semua","Button_PauseAll":"Jeda Semua","Button_CollapseDetail":"Perkecil Detail","Button_ExpandDetail":"Perluas rincian","Text_FailDetail":"Detail kegagalan","Text_SharedFolderToYou":"Membagikan folder dengan Anda","Desc_ClickJoinTeam":"Ketuk untuk melihat dan otomatis bergabung dengan tim ini","Text_SeatInsufficientFolder":"Slot tidak cukup. Anda tidak dapat bergabung ke tim untuk mengakses folder ini.","Title_FolderTeamShareOnly":"Folder hanya dapat dibagikan dalam tim","Button_SwitchTeamCopyFolder":"Beralih tim dan salin folder","Button_CreateTeamCopyFolder":"Buat Tim dan Salin Folder","Message_FolderCopiedToTeam":"Berhasil dibuat. Folder telah disalin ke tim Anda.","Text_UsedSpace":"Digunakan:","Text_StorageSpace":"Ruang penyimpanan:","Text_UsedSpaceLabel":"Ruang yang digunakan","Text_UnlockSpace":"Buka ${0} penyimpanan ekstra","Button_UpgradeToMember":"Upgrade ke Keanggotaan","Button_UpgradePremium":"Upgrade ke Premium","Desc_SpaceFullUpgrade":"Penyimpanan penuh. Tingkatkan untuk mendapatkan lebih banyak penyimpanan.","Desc_SpaceFullContactAdmin":"Penyimpanan penuh. Hubungi administrator.","Desc_SpaceFullClean":"Penyimpanan penuh. Kosongkan ruang sekarang.","Desc_SpaceLowUpgrade":"Sisa penyimpanan kurang dari 10%. Tingkatkan untuk mendapatkan lebih banyak penyimpanan.","Desc_SpaceLowContactAdmin":"Ruang penyimpanan tersisa kurang dari 10%. Hubungi administrator Anda.","Desc_SpaceLowClean":"Ruang penyimpanan tersisa kurang dari 10%. Kosongkan ruang penyimpanan sesegera mungkin.","Desc_VipExpiredRenew":"Manfaat keanggotaan Anda telah berakhir. Perpanjang sekarang.","Desc_VipSoonExpireRenew":"Keanggotaan Anda akan segera berakhir. Jangan lupa perpanjang.","Desc_SpaceNormal":"Ruang ini tersedia. Anda dapat terus menyimpan kreasi Anda.","Text_CountUnit":"${0}","Text_SoonExpire":"Segera berakhir ${0}","Text_Expired":"Kedaluwarsa ${0}","Text_FileStatus":"Status file: ${0}. Segera kelola.","Desc_TopBannerFilesExpire":"Beberapa file Anda hampir mencapai batas penyimpanan. Kelola file sekarang, atau tingkatkan langganan untuk menyimpannya secara permanen.","Desc_TopBannerSpaceLow":"Sisa ruang penyimpanan Anda kurang dari 10%. Upgrade paket Anda untuk mendapatkan lebih banyak penyimpanan.","Desc_TopBannerSpaceUrgent":"Ruang penyimpanan hampir habis, dan beberapa proyek akan segera kedaluwarsa. Upgrade langganan Anda untuk mendapatkan lebih banyak ruang penyimpanan dan menyimpan proyek Anda selamanya.","Desc_TopBannerSpaceLowPremium":"Sisa penyimpanan Anda kurang dari 10%. Upgrade ke Premium untuk mendapatkan lebih banyak penyimpanan.","Desc_TopBannerVipSoonExpire":"Keanggotaan Anda akan segera berakhir. Perpanjang tepat waktu agar riwayat edit Anda tidak kedaluwarsa dan dihapus.","Desc_TopBannerVipExpired":"Keanggotaan Anda telah berakhir. Perpanjang sekarang agar tidak kehilangan ruang penyimpanan atau riwayat pengeditan.","Desc_TopBannerSpaceLowClean":"Sisa penyimpanan Anda kurang dari 10%. Kosongkan ruang sekarang.","Desc_TopBannerVipSoonExpireNoPeriod":"Keanggotaan Anda akan segera berakhir. Jika tidak diperpanjang tepat waktu, riwayat edit Anda dapat dihapus. Segera perpanjang.","Text_AssetHandovering":"Mentransfer aset...","Text_TransferringStatus":"Sedang Mentransfer","Text_ResignationTime":"Tanggal pengunduran diri:","Desc_AssetHandoverTip":"Catatan pembuatan dalam aset anggota yang telah keluar tidak dapat diedit. Aset lainnya tidak mendukung pemindahan atau pengunggahan. Jika diperlukan, pindahkan aset ke Ruang Saya terlebih dahulu.","Message_SelectFileLimit":"Pilih maksimal ${0} file","Text_ExpandVersionComparison":"Perluas Perbandingan Fitur Di Berbagai Versi","Text_CollapseVersionComparison":"Perkecil Perbandingan Fitur Versi","Text_VersionComparisonToggle":"Perbandingan Fitur Versi ${0}","Text_Consult":"Saran","Text_PricePerMonthWithSymbol":"¥${0}/bulan","Title_RightsComparison":"Bandingkan Manfaat","Text_Trial7Days":"Uji Coba 7 Hari","Text_UsingNow":"Sedang digunakan","Text_ConsultBusiness":"Hubungi Tim Penjualan","Title_PriceComparison":"Perbandingan Harga","Text_StandardMember":"Standar Premium","Text_EnterpriseMember":"Premium Enterprise","Text_BeansPerMonth":"${0} kredit/bulan","Text_BeansPerMonthFrom":"Mulai dari ${0} kredit/bulan","Text_WanBeansPerMonthFrom":"Mulai dari ${0}k kredit/bln","Text_SheetsPerMonth":"${0} gambar/bulan","Text_SheetsPerMonthFrom":"Mulai dari ${0} foto/bulan","Text_WanSheetsPerMonthFrom":"Mulai dari ${0}K gambar/bulan","Desc_FeatureOnlyNote":"${0}<span style=\\"color: #d0d2d6\\">(Hanya fitur ini)</span>","Text_PersonalCommercial":"Penggunaan Komersial Pribadi","Text_EnterpriseCommercialEntities":"Entitas Lisensi Komersial Perusahaan*${0}","Text_PurchasableSeparately":"Tersedia sebagai pembelian terpisah","Desc_MeidouAiQuota":"Kredit (Kuota Generasi AI)","Label_AiAgentImageEdit":"Agen AI: Edit Foto","Label_AiAgentImageGen":"Agen AI: Pembuatan Gambar","Label_AiAgentEcommerce_ImageSet":"Agen AI: Set Gambar E-commerce","Label_PortraitBgReplace":"Ubah latar","Label_AiPartialRedraw":"Modifikasi AI","Label_AiImageGen":"Generasi AI","Label_AiFloralText":"Kaligrafi AI","Label_LivePpt":"PPT Langsung","Label_AiSizeExtend":"Perluas Ukuran dengan AI","Label_BatchTemplate":"Templat Massal","Label_CreateCustomSize":"Buat desain ukuran kustom","Label_EditLocalImage":"Edit Gambar Lokal","Label_ExportJpgPng":"Ekspor desain/gambar sebagai JPG/PNG","Label_FreeTemplate":"Templat Gratis","Label_FreeFont":"Font Gratis","Label_FreeAsset":"Elemen gratis","Label_PaidTemplate":"Templat Berbayar","Label_PaidFont":"Font berbayar","Label_PaidAsset":"Konten premium","Label_RealtimeMultiEdit":"Pengeditan bersama real-time","Label_ShareDesignRecord":"Bagikan catatan pengeditan","Label_ShareElements":"Bagikan Elemen (Gambar/Teks/Tabel)","Label_ShareTemplate":"Bagikan Templat","Label_ShareFolder":"Bagikan Folder","Label_SharePermission":"Pengelolaan Izin Berbagi","Label_RecordToTemplate":"Ubah riwayat edit menjadi templat","Label_EnterpriseBrandNav":"Bilah Navigasi Merek Perusahaan","Label_Sso":"Single Sign-On (SSO)","Label_ModelCustomization":"Kustomisasi model","Label_SceneCustomization":"Kustomisasi pemandangan","Label_OnlineAiSupport":"Layanan Pelanggan Pintar Online","Label_OnlineManualGuide":"Manual Online","Label_OperationGuide":"Panduan Pengguna","Label_CustomerImSupport":"Dukungan Grup IM Pelanggan","Label_DedicatedCsm":"Layanan Customer Success Khusus","Label_TechPriorityResponse":"Respons layanan teknis prioritas","Label_TrainingSession":"Pelatihan Khusus","Label_OffboardAssetTransfer":"Serah Terima Aset Pengunduran Diri","Label_MemberPurchaseLimit":"Pembatasan Pembelian Anggota","Label_MemberActivity":"Kegiatan Anggota","Label_MemberDesignActivity":"Aktivitas Pengeditan Anggota","Label_MemberAiActivity":"Status AI Generasi Anggota","Title_ContentDesign":"Desain konten","Title_MultiCollaboration":"Kolaborasi banyak orang","Title_VisualManagement":"Manajemen Visual","Title_OrgManagement":"Manajemen Organisasi","Title_DataStatistics":"Statistik","Title_ExclusiveCustomization":"Kustomisasi Eksklusif","Title_ServiceGuarantee":"Jaminan Layanan","Title_EnterpriseAuthConfirm":"Konfirmasi Informasi Lisensi Komersial Perusahaan","Text_ConfirmAuthInfoTip":"Konfirmasi informasi izin berikut. Informasi ini tidak dapat diubah setelah dikirim.","Label_Name":"Nama","Label_UnifiedSocialCreditCode":"Pengidentifikasi Kredit Sosial Terpadu","Label_IdCardNumber":"No. Kartu Identitas","Label_ContactPhone":"Nomor telepon","Title_AuthSuccess":"Otorisasi berhasil","Text_AuthSubjectFilled":"Entitas otorisasi berhasil diselesaikan","Button_BackAdmin":"Kembali ke backend","Button_DownloadAuthBook":"Unduh Surat Otorisasi","Title_EnterpriseAuthFill":"Masukkan Informasi Lisensi Komersial Perusahaan","Label_AuthType":"Jenis Otorisasi","Text_Enterprise":"Perusahaan","Message_EnterCompanyNameWithin30":"Masukkan nama perusahaan Anda (maksimal 30 karakter)","Message_PleaseEnterNameShort":"Masukkan nama Anda","Message_Max30Chars":"Anda dapat memasukkan maksimal 30 karakter","Message_EnterCompanyName":"Masukkan nama perusahaan Anda","Message_EnterUnifiedSocialCreditCode":"Masukkan Nomor Identifikasi Kredit Sosial Terpadu","Message_EnterIdCardNumber":"Masukkan No. Kartu Identitas","Message_InvalidUnifiedSocialCreditCode":"Format Pengidentifikasi Kredit Sosial Terpadu tidak valid.","Message_InvalidIdCardNumber":"Format No. Kartu Identitas tidak valid.","Message_EnterPhoneNumber":"Masukkan nomor telepon Anda","Message_InvalidPhoneNumber":"Format nomor telepon tidak valid.","Placeholder_PhoneExample":"Contoh: 0592-12345678 / 13912345678","Desc_AuthInfoBindTip":"Setelah dikirim, informasi di atas akan ditautkan dan tidak dapat diubah kecuali Anda membeli entitas komersial terotorisasi tambahan.","Desc_AuthInfoRiskTip":"Jika Anda tidak memberikan informasi di atas secara akurat dan lengkap, Anda mungkin tidak dapat memberikan bukti yang sah jika terjadi risiko hak cipta dan mungkin tidak menerima perlindungan penggunaan komersial dari platform Meitu Design Studio.","Desc_AuthSingleSubjectTip":"Lisensi Penggunaan Komersial Bebas Khawatir diberikan kepada satu entitas dan hanya dapat digunakan oleh pihak berwenang yang membeli dan mengaitkannya. Berbagi atau mengalihkan lisensi ini dilarang.","Text_OfflineOrderScanBusiness":"Untuk pesanan offline, pindai kode untuk menghubungi Sales dan meminta surat otorisasi","Label_AuthSubjectInfo":"Informasi Entitas yang Diizinkan","Text_NotFilledYet":"Belum diisi","Text_ServiceValidity":"Ketentuan Layanan","Text_AuthInactive":"Tidak aktif","Text_AuthActive":"Aktif","Text_AuthExpired":"Kedaluwarsa","Text_AuthNotStarted":"Belum dimulai","Text_OfflineOrder":"Pesanan di Toko","Label_RelatedOrder":"Urutan Terkait","Button_ContactSupport":"Kontak","Button_Fill":"Masukkan","Title_MemberCommercialAuthBook":"Lisensi Komersial Anggota","Button_PurchaseAuthSubject":"Tambah entitas yang diizinkan","Desc_PurchaseAuthSubjectScan":"Untuk membeli entitas terotorisasi tambahan, pindai Kode QR untuk menghubungi tim penjualan kami.","Label_AuthTime":"Periode Lisensi","Label_AuthStatus":"Status Otorisasi","Text_OrderCancelled":"Dibatalkan","Text_OrderPaid":"Berbayar","Text_OrderRefunded":"Dikembalikan","Text_TeamVipProductName":"Keanggotaan Tim ${0}","Text_CutoutCountProductName":"Jumlah potongan tersisa ${0}","Text_MemberMeidouProductName":"Kredit keanggotaan: ${0}","Message_CancelSuccess":"Dibatalkan","Message_CancelFailed":"Gagal membatalkan","Title_ConfirmCancel":"Konfirmasi Pembatalan","Text_CancelOrderTip":"Setelah membatalkan pesanan, Anda dapat membuat pesanan baru untuk membeli layanan ini.","Button_IssueInvoice":"Invoice","Text_NoOrders":"Belum ada pesanan","Label_ProductInfo":"Informasi Produk","Label_Quantity":"Jumlah","Label_OrderTotal":"Total","Label_OrderStatus":"Status Pesanan","Text_OrderNoPrefix":"Nomor Pesanan: ${0}","Text_PayBeforeDeadline":"Selesaikan pembayaran paling lambat ${0}. Pembayaran yang terlambat akan dibatalkan otomatis.","Button_CancelOrder":"Membatalkan Pesanan","Button_PayNow":"Bayar sekarang","Title_TransferAmount":"Jumlah Transfer","Desc_TransferAmountMatch":"Jumlah transfer harus sesuai dengan jumlah pesanan saat ini.","Desc_TransferUniqueCode":"2. Setiap pesanan memiliki kode pembayaran unik. Kode ini hanya berlaku untuk pesanan ini. Jangan membayar lebih dari sekali.","Desc_TransferAutoActivate":"3. Keanggotaan Anda akan diaktifkan secara otomatis dalam 30 menit setelah transfer berhasil. Selesaikan pembayaran segera.","Title_ReceiveAccountInfo":"Informasi Akun","Label_AccountName":"Nama akun","Label_BankAccount":"Rekening Bank","Label_IssueBank":"Nama bank","Label_RemittanceCode":"Kode remitansi","Text_CopyRemittanceInfo":"Salin Informasi Remitansi","Message_CopiedToClipboard":"Salin ke papan klip","Text_CopyRemittanceTemplate":"Nama Rekening: ${0}\\nNomor Rekening: ${1}\\nNama Bank: ${2}\\n  Kode Remitansi: ${3}","Label_MemberSeats":"Anggota/Kursi","Label_RemainingSheets":"Sisa kredit","Label_EnterpriseAuthSubject":"Entitas Lisensi Komersial Perusahaan","Button_Purchase":"Beli","Message_EditSuccessExclaim":"Berhasil diubah!","Text_InactiveSeats":"Kursi Tertunda ${0}","Text_ExpiredDays":"Berakhir ${0} hari yang lalu","Text_ExpireOn":"Berakhir pada ${0}","Label_OrgId":"ID Organisasi","Label_CreatedAt":"Dibuat pada:","Title_ContactInfo":"Informasi kontak","Desc_ContactExpectation":"Kami ingin terhubung dengan Anda 🤝 dan membantu tim Anda memaksimalkan Posters.","Text_ContactFor1v1":"Isi formulir ini untuk mendapatkan layanan VIP personal.","Label_ContactPerson":"Lensa kontak","Label_ContactMethod":"Informasi kontak","Text_MemberActivity":"Kegiatan Anggota","Label_LastOnlineTime":"Waktu rilis terbaru","Label_ActiveDays":"Hari aktif","Title_GenerationCount":"Pemrosesan","Label_PosterImageEdit":"Pengeditan Poster/Foto","Alt_Avatar":"Avatar","Label_ProductPortrait":"Produk/Potret","Label_TryOnFaceSwapRecolor":"Coba/Ganti Wajah/Warna","Text_MemberActivityExport":"Kegiatan Anggota.xls","Title_IncludesFreePlus":"Termasuk semua manfaat Gratis, plus:","Title_IncludesStandardPlus":"Termasuk semua manfaat keanggotaan Standard, ditambah:","Title_IncludesTeamMemberPlus":"Mencakup semua manfaat Keanggotaan Tim, ditambah:","Text_AccountLimitOne":"Batas akun: 1 pengguna","Text_PaidTemplateMaterial":"Templat/Elemen Premium","Text_FreeTemplateMaterial":"Templat/Elemen Gratis","Desc_SmartToolsBundle":"Potong Pintar/Penghapus AI/Tingkatkan, dan alat pintar lainnya","Desc_MeidouMonthlyUsage":"Kredit bulanan dapat digunakan untuk:","Desc_AgentProductSuite":"Agen AI: Set gambar produk, halaman detail, video, dan lainnya","Desc_AiShootSuite":"Fotografi Komersial AI: Gambar Produk AI, Latar Belakang Potret, Model AI, dan Lainnya","Desc_AiDesignSuite":"Desain AI: Logo AI, PPT Live, Grafis AI, dan lainnya","Text_TeamSeatsFromPrice":"10 Kursi / Mulai dari ¥15.000","Desc_BulkMeidouOneTime":"Bonus kredit besar satu kali, dibagikan ke beberapa akun","Label_OneMonth":"1 Bulan","Label_ThreeMonths":"3 bulan","Label_TwelveMonths":"12 Bulan","Text_EnterpriseCommercialLicensed":"Diizinkan untuk penggunaan komersial perusahaan","Button_BuyTeamEdition":"Beli Tim","Title_ChooseByCommercialAuth":"Pilih berdasarkan lisensi komersial","Label_LicenseTarget":"Pihak Terotorisasi:","Desc_PersonalLicenseTarget":"Entitas bisnis adalah orang perseorangan, dan penerima manfaat juga merupakan orang perseorangan.","Label_LicenseScope":"Cakupan Penerapan:","Desc_PersonalLicenseScope":"Penggunaan kantor pribadi (PPT, laporan), situs web pribadi, penggunaan promosi untuk toko online yang terdaftar atas nama entitas pribadi, media sosial pribadi, Akun Resmi WeChat, pembuatan video pendek pribadi, dll.","Title_EnterpriseCommercialAuth":"Lisensi Komersial Perusahaan","Desc_EnterpriseLicenseTarget":"Badan hukum dan organisasi yang tidak berbadan hukum, termasuk perusahaan, usaha milik perseorangan, organisasi administratif, dan kelompok sosial.","Desc_EnterpriseLicenseScope":"Kelola situs web, akun resmi, program mini, gambar produk e-commerce/halaman detail, feed media sosial, iklan online, dan katalog produk online.","Tip_PersonalLicenseWarning":"Catatan: Menggunakan lisensi komersial pribadi untuk tujuan bisnis dianggap sebagai pelanggaran.","Alt_ContactServiceQrcode":"Kode QR Hubungi Dukungan","Text_ScanContactManager":"Pindai kode QR untuk menghubungi manajer akun","Button_LearnQuote":"Lihat Rincian Harga","Title_PricingPartners":"Pelanggan dari berbagai industri menggunakan Meitu Design Studio","Title_FaqSectionPricing":"Tanya-Jawab","Title_FaqCommercialUse":"Dapatkah saya menggunakannya secara komersial setelah berlangganan?","Desc_FaqCommercialUse":"Keanggotaan pribadi (SVIP) hanya untuk penggunaan komersial individu. Keanggotaan Tim/Perusahaan dapat digunakan untuk keperluan komersial bisnis. Beli paket keanggotaan yang sesuai dengan kebutuhan penggunaan komersial Anda.","Title_FaqInvoice":"Bagaimana cara mendapatkan invoice?","Desc_FaqInvoicePersonal":"Invoice PPN keanggotaan individu: Buka situs web Meitu Design Studio, masuk ke akun keanggotaan Anda, klik foto profil di kanan atas, klik Perpanjang Keanggotaan, lalu klik Saya Ingin Invoice di kanan bawah pop-up dan pindai kode QR dengan WeChat untuk mendapatkan invoice.<br/>","Desc_FaqInvoiceTeam":"Invoice Reguler Keanggotaan Tim: Buka dasbor manajemen tim, pilih Invoice Pesanan - pilih pesanan yang akan dibuat Invoice - klik Invoice - pindai kode QR untuk mengisi informasi terkait.<br/>","Desc_FaqInvoiceSpecial":"Invoice PPN Khusus: Hubungi layanan pelanggan online melalui Konsultasi Online.<br/>","Title_FaqDeviceLimit":"Berapa banyak perangkat yang dapat menggunakan satu akun keanggotaan?","Desc_FaqDeviceLimit":"MTid adalah akun pribadi. Untuk melindungi keamanan akun dan privasi kreasi Anda, <span style=\\"color: #fff; font-weight: bold;\\">setiap akun keanggotaan hanya dapat masuk di satu komputer dalam satu waktu</span> dan tidak mendukung login bersamaan di beberapa komputer.<br/>Jika Anda perlu masuk di beberapa perangkat secara bersamaan, kami sarankan untuk membeli <span style=\\"color: #fff; font-weight: bold;\\">Keanggotaan Tim/Perusahaan Meitu Design Studio</span> untuk mengaktifkan beberapa kursi dan menetapkan akun untuk login.","Title_FaqUpgradeTeam":"Bagaimana cara upgrade dari keanggotaan individu ke Keanggotaan Tim?","Desc_FaqUpgradeTeam":"Karena harga langganan Tim dan Individu berbeda, untuk meningkatkan ke langganan Tim, beli paket Tim terlebih dahulu, lalu hubungi dukungan online untuk memigrasi kredit akun pribadi Anda dan memproses sisa saldo langganan. Anda dapat menyalin aset dari akun individu ke tim sendiri.","Title_FaqMeidou":"Apa itu Kredit dan bagaimana cara membelinya?","Desc_FaqMeidou":"Selain fitur gratis dan anggota, Meitu Designer juga menawarkan fungsi AI yang memerlukan Kredit untuk digunakan, seperti AI Product Image, AI Model, dan Flatlay. Setelah Kredit yang disertakan dengan keanggotaan Anda habis, Anda dapat membeli lebih banyak secara terpisah. Akses halaman pembelian dari sudut kanan atas fungsi AI mana pun. Tautan: <a target=\\"_blank\\" style=\\"color: #66A8FF\\" href=\\"https://www.designkit.cn/product-shoot-editor/?from=home\\">https://www.designkit.cn/product-shoot-editor/?from=home</a>","Message_PermissionAlreadyRejected":"Permintaan izin ditolak","Message_PermissionAlreadyProcessed":"Permintaan izin ini telah diproses","Text_TeamRenewRemainingPrefix":"Keanggotaan tim Anda hanya","Text_UnitDay":"hari","Text_SharedItemToYou":"Membagikan ${0}【${1}】 dengan Anda.","Label_AccountColon":"Nomor akun:","Text_PriceYuanPerPersonPerMonth":"¥${0}/orang/bulan","Text_OrTry":"Atau coba","Title_DesignKitApp":"美图设计室 APP","Title_OpenClawGuide":"Manual OpenClaw","Label_AllColors":"Semua Warna","Alt_TemplateImage":"Gambar Templat","Text_NestedTemplateSuiteCount":"Atur Templat untuk ${0} gambar","roboneo_agent_queue_tier_fast":"Cepat","roboneo_agent_queue_tier_relax":"Rileks","roboneo_agent_queue_tier_change_failed":"Gagal beralih, harap coba lagi.","Label_ImageProcessing":"Pemrosesan Gambar","Tool_ProductRetouching":"Produk retouch","Message_SelectImageBefore_ImageTranslation":"Pilih gambar sebelum menggunakan Terjemahan Gambar.","Message_SelectImageBefore_Expand":"Pilih gambar sebelum menggunakan Perluasan Latar Belakang AI.","Label_AiCreation":"Generasi AI","Tool_AiImageText":"Gambar & Teks AI","Label_DefaultModel":"Model Default","Desc_AgentMode_Advanced":"Penggunaan kredit AI 3x Hasilkan beragam hasil untuk promosi 3x","Desc_AgentMode_Normal":"Ideal untuk kreasi harian sederhana dan menghemat daya komputasi","Desc_AgentMode_FlagshipAi":"·Mode AI Unggulan","Desc_AgentMode_MultilingualText":"·Pencocokan Teks Multibahasa yang Presisi","Desc_AgentMode_ProductFidelity":"· Akurasi restorasi produk 95%","Desc_AgentMode_ComplexScene":"·Kemampuan pemrosesan skenario kompleks","Tool_AIVideoAgent":"Agen Video AI","Tool_UGCVideoMaker":"Pembuat Video UGC","Tool_MarketingVideoMaker":"Pembuat Video Pemasaran","Tool_PromoVideoMaker":"Pembuat Video Promo","Tool_ExplainerVideoMaker":"Pembuat Video Penjelasan","Tool_BeforeAfterVideoMaker":"Pembuat Video Sebelum & Sesudah","roboneo_agent_queue_tier_upgrade_title":"Akses Tanpa Batas ke Relax","roboneo_agent_queue_tier_upgrade_desc":"${0} Manfaat Keanggotaan. Dibuat dalam mode Relax tanpa perlu kredit.","roboneo_agent_queue_tier_upgrade_primary":"Upgrade ke Pro","roboneo_agent_queue_tier_upgrade_secondary":"Gunakan Mode Cepat","Label_PageIndex":"Halaman ${0}","Title_PPTTask":"Tugas PPT","Button_ReplicateNow":"Gunakan Ulang Sekarang","Label_ImageIndex":"Perawakan ${0}","Button_Cases_ViralVideo":"Contoh","Message_ImageReviewFailedRetry_Batch":"Peninjauan gambar gagal. Coba lagi nanti.","Message_ImageReviewRejected_Batch":"Gambar ditolak","Text_PageRange":"Halaman ${0}~${1}","Text_AllPagesRange":"Semua halaman (1~${0})","Text_AllPages":"Semua halaman","Text_SelectedPages":"Halaman yang dipilih (${0})","Text_NoPageSelected":"Tidak ada halaman yang dipilih","Title_InsertDocument":"Sisipkan Dokumen","Title_SelectPages":"Pilih halaman","Button_Insert":"Masukkan","Message_ProductInfoReviewRejected_Batch":"Teks poin keunggulan ditolak. Isi kembali.","Tool_VideoBackgroundRemover":"Penghapus Latar Belakang Video","Title_StayUpdated_Designkit":"Dapatkan info terbaru dari Designkit","Title_StayUpdated_Zawa":"Dapatkan info terbaru dari Zawa","Desc_WebPushPrompt":"Jadilah yang pertama mengetahui alat AI baru, pembaruan fitur, dan konten yang sedang tren.","Button_NotNow":"Lain Kali","Button_TurnOn":"Aktifkan","Placeholder_Enter":"Masukkan ${0}","Placeholder_Select":"Pilih ${0}","Label_AiMarketingVideo":"Video Promo Produk AI","Title_ImageProcessing":"Proses gambar","Title_AiDesign":"Desain AI","Label_Ecommerce":"E-Commerce","Label_SocialMedia":"Media Sosial","Label_WechatMarketing":"Pemasaran WeChat","Label_OfficialAccount":"Akun Resmi","Label_OfficeEducation":"Admin & Kantor/Pendidikan","Label_LifeEntertainment":"Gaya Hidup & Hiburan","Title_DesignScene":"Skenario Desain","Label_MarketingSales":"Pemasaran dan Penjualan","Label_Promotion":"Promosi","Label_Greeting":"Salam & Berkat","Label_CommunicationSharing":"Bagikan dan Terhubung","Label_LifeScience":"Tips Gaya Hidup","Label_Recruitment":"Perekrutan","Title_UsagePromotion":"Penggunaan untuk Pemasaran","Label_FoodBeverage":"Bersantap dan Hidangan","Label_ApparelBags":"Pakaian, Sepatu, dan Tas","Label_EducationTraining":"Pendidikan dan pelatihan","Label_BeautySkincare":"Kecantikan & Perawatan Kulit","Title_IndustryResource":"Sumber daya industri","Text_FirstDiscountBadge_ViralVideo":"Diskon video pertama","Title_ManagedBatchTip":"Tidurlah dulu. Gambar Anda akan siap saat bangun.","Tag_ManagedBatchDiscount":"Diskon Batch ${0}%","Desc_ManagedBatchTip":"Buat gambar secara massal dengan diskon ${0}%. Bangun tidur, semuanya sudah selesai.","Title_Resize":"Ubah Ukuran","Title_SocialContentCreation":"Alat Konten Media Sosial","Title_BatchResize":"Ubah Ukuran Massal","Title_ImageRecolor":"Ubah Warna Gambar","Title_BatchRetouch":"Retouch Massal","OnlineConsultation":"Konsultasi Online","PayAmount":"Bayar ¥${0}","PriceBreakdown":"¥${0} × ${1} kursi × ${2} bulan","ScanToPay":"Pindai untuk membayar dengan ${0}","PaymentAgreementHint":"Dengan membayar, Anda menyetujui","MeidouRechargeAgreement":"Perjanjian Isi Ulang Kredit","DesignStudioServiceAgreement":"Perjanjian Layanan Langganan Meitu Design Studio","CommercialLicenseAgreement":"Lisensi Komersial","CutoutQuotaNotice":"Pemberitahuan Bonus Kredit Cutout","RenewalMemberNote":"Jika Anda membeli keanggotaan perpanjangan otomatis:","AutoDeliveryOnPurchase":"Setelah pembelian, akan otomatis ditambahkan ke akun Anda saat ini.","NonRenewalMemberNote":"Jika Anda membeli langganan tanpa perpanjangan otomatis:","AutoDeliveryOnTransaction":"Setelah transaksi berhasil, akan otomatis ditambahkan ke akun Anda saat ini.","CutoutQuotaLabel":"Kredit Potong:","CutoutQuotaDesc":"Jumlah potongan gratis mengacu pada jumlah bonus yang tertera di halaman detail produk keanggotaan yang Anda beli.","CutoutQuotaExpiryLabel":"Masa berlaku kredit cutout:","CutoutQuotaExpiryDesc":"Mengacu pada masa berlaku yang ditampilkan di halaman pesanan","TrialAddressLabel":"Tautan uji coba:","ServiceNotice":"Pemberitahuan Layanan","AutoRenewNote1":"1. Setelah layanan ini diaktifkan, keanggotaan Anda akan diperpanjang otomatis dalam 24 jam sebelum masa berlaku berakhir. Setelah diperpanjang, masa keanggotaan Anda akan diperpanjang sesuai periode terkait;","AutoRenewNote2":"2. Biaya perpanjangan akan dipotong dari rekening pembayaran yang Anda hubungkan;","AutoRenewNote3":"3. Anda dapat membatalkan perpanjangan otomatis kapan saja. Setelah dibatalkan, langganan Anda tidak akan diperpanjang secara otomatis;","AutoRenewNote4":"4. Cara membatalkan:","AutoRenewNote5":"5. Untuk pertanyaan lain, hubungi layanan pelanggan di 4000093360","Label_WeChat":"WeChat","Label_Alipay":"Alipay","Label_BatchTrialCount":"Penggunaan pemrosesan bets gratis","Desc_WindowsOnly":"Hanya untuk Aplikasi desktop Windows","Label_MemberFeature":"Fitur VIP","Label_MemberAsset":"Elemen VIP","Label_MemberEffect":"Efek VIP","Label_NoAds":"Tanpa iklan","Label_NoPoster":"Tidak ada Meitu Pictorial","Label_EffectFilter":"Filter Spesial","Label_Enhance":"Tingkatkan","Label_FaceRemodel":"Bentuk ulang","Label_SkinAdjust":"Kulit","Label_HeadAdjust":"Penyesuaian kepala","Label_HeightShape":"Bentuk Tubuh","Label_Border":"Frame","Label_RechargeMeidou":"Isi ulang kredit","Text_InsufficientBenefits":"Manfaat tidak mencukupi. Hubungi konsultan khusus Anda: ${0} ${1}","Text_OnlinePurchaseDisabled":"Pembelian online tidak didukung di versi ini. Hubungi administrator Anda jika diperlukan.","Desc_ProtectMemberExperience":"Untuk memastikan pengalaman keanggotaan Anda,","Desc_BindPhoneFirst":"Tautkan nomor telepon utama Anda terlebih dahulu.","Button_GoToBind":"Hubungkan Sekarang","Text_AlreadyActiveMember":"Anda sudah berlangganan keanggotaan di ${0}","Text_ContactServicePrefix":"Jika ada pertanyaan, silakan","Label_ServicePhone":"Hotline Layanan Pelanggan","Text_ServiceTime":"Jam Layanan Pelanggan: 09.00–21.00","Text_LargeOrderContact":"Untuk pesanan besar atau pembayaran gagal, pindai kode QR untuk menghubungi tim sales.","Text_ConsultEnterprise":"Konsultasi Penggunaan Komersial Perusahaan","Message_CreateFail":"Gagal membuat. Coba lagi nanti.","Title_TransferReminder":"Pengingat Transfer","Text_ViewOrderProgress":"Anda dapat melacak pesanan ini nanti di Dasbor Admin > Pesanan & Faktur.","Title_PendingTransfer":"Pesanan transfer sedang diproses","Text_HasPendingTransfer":"Anda memiliki pesanan transfer bank perusahaan yang sedang diproses. Lihat sekarang?","Button_CancelAndCreate":"Batalkan dan buat pesanan baru","Button_ViewTransferOrder":"Lihat Pesanan Transfer yang Sedang Diproses","Text_CancelOrderNote1":"Setelah membatalkan pesanan, Anda dapat membuat pesanan baru,","Text_CancelOrderNote2":"Namun, pesanan dengan transfer yang sedang diproses akan ditutup.","Button_ConfirmCancelCreate":"Konfirmasi pembatalan dan buat pesanan baru","Link_ViewBenefitDetail":"Lihat detail manfaat >","Label_RedeemCode":"Kode Penukaran","Message_RedeemSuccess":"Penukaran berhasil!","Message_RedeemVipSuccess_DesignKit":"Anda berhasil menukarkan keanggotaan VIP Meitu Design Studio!","Message_RedeemSvipSuccess_MeituXiuXiu":"Anda berhasil menukarkan keanggotaan Meitu SVIP!","Placeholder_EnterInviteCode":"Masukkan Kode Undangan","Placeholder_EnterRedeemCode":"Masukkan Kode Penukaran","Title_CodeCenter":"Pusat Kupon","Desc_SelectCodeType":"Pilih jenis kode untuk verifikasi dan penukaran","Title_InviteCodeDesc":"Petunjuk Kode Undangan","Title_RedeemCodeDesc":"Petunjuk Kode Penukaran","Text_InviteCodeIntro":"Masukkan kode undangan eksklusif yang Anda terima dari media sosial atau saluran lainnya:","Text_InviteCodeBenefit1":"Diskon langganan saluran eksklusif dengan benefit gratis untuk waktu terbatas","Text_InviteCodeBenefit2":"Setiap kode undangan hanya dapat digunakan satu kali","Text_InviteCodeBenefit3":"Tidak dapat digabungkan dengan promosi lainnya","Text_RedeemCodeIntro":"Gunakan kode penukaran keanggotaan yang diperoleh dari saluran resmi:","Text_RedeemCodeBenefit1":"Login ke akun Anda dan masukkan kode penukaran untuk menukarkannya","Text_RedeemCodeBenefit2":"Setelah ditukarkan, Anda akan mendapatkan manfaat dan layanan langganan yang sesuai","Text_RedeemCodeBenefit3":"Gunakan kode penukaran sebelum kedaluwarsa. Kode yang sudah kedaluwarsa tidak valid dan tidak dapat dikembalikan dananya.","Text_InvoiceLink":"Tautan ini dapat digunakan untuk menerbitkan invoice untuk ${0} pesanan","Text_InvoiceOtherBusiness":"Untuk invoice layanan Meitu lainnya, ikuti akun resmi Meitu Payment Service","Desc_ConsumeSoonExpiredMeidou":"Gunakan Kredit yang akan kedaluwarsa terlebih dahulu","Link_MeidouIntro":"Tentang Kredit","Text_NoMeidouGoToBuy":"Kredit habis. Beli sekarang!","Text_ThankYouSupport":"Terima kasih atas dukungan Anda. Kami akan terus menghadirkan layanan baru.","Text_PurchaseBatchSuccess_MeituXiuXiu":"Anda telah membeli kredit pemrosesan massal Meitu.","Text_PurchaseCutoutSuccess":"Anda telah membeli unduhan MeituPotong.","Label_BoundAccount":"Akun tertaut:","Text_PurchaseCount":"Jumlah pembelian: ${0}","Label_TeamMemberExpiry":"Keanggotaan Tim berlaku hingga:","Label_ProMemberExpiry":"Keanggotaan Premium Berlaku Hingga:","Label_StandardMemberExpiry":"Keanggotaan Standar berlaku hingga:","Text_PurchaseSeatCount":"Seat yang dibeli: ${0}","Button_GotItCountdown":"Paham (${0} detik)","Text_Trial":"Coba ${0}","Text_OriginalPrice":"Harga Asli ${0}","Text_PerSheet":"/gambar","Text_PerPersonPerMonth":"/orang/bulan","Text_FreeTrialDays":"Uji Coba Gratis ${0} Hari","Text_FreeTrialMonths":"Uji coba gratis ${0} bulan","Text_FreeTrialQuarters":"Uji Coba Gratis ${0} Kuartal","Text_FreeTrialYears":"Uji Coba Gratis ${0} Tahun","Text_ScanToBuy":"Pindai dengan ${0} untuk membeli","Text_ScanToActivate":"Pindai dengan ${0} untuk mengaktifkan","Text_AlsoSupportWechatBuy":"(Atau pindai dengan WeChat)","Text_AlsoSupportWechatActivate":"(Atau pindai dengan WeChat)","Text_ServiceAgreement_DesignKit":"Kebijakan Langganan Meitu Design Studio","Text_ServiceAgreement_MeituXiuXiu":"Kebijakan Langganan Meitu SVIP","Text_ServiceAgreement_Meidou":"Perjanjian Isi Ulang Kredit","Text_ServiceAgreement_Cutout":"Perjanjian Layanan Potong","Text_ServiceAgreement_BatchMeituXiuXiu":"Perjanjian Layanan Pemrosesan Bets Meitu","Button_ClickLogin":"Login","Text_CheckAgreementFirst":"Centang kotak untuk menyetujui terlebih dahulu.","Text_LoadError":"Gagal memuat","Button_ClickRefresh":"Ketuk untuk menyegarkan","Label_Pay":"Bayar","Text_ExtendAfterPurchase":"Setelah pembelian, diperpanjang hingga: ${0}","Button_Agree":"Setuju","Title_ThankYouSubscription":"Terima kasih telah berlangganan!","Text_MemberServiceAgreement":"Layanan VIP","Title_PayFail":"Pembayaran gagal","Button_RepayNow":"Coba lagi","Desc_OneYearValidTeam":"Berlaku selama 1 tahun. Hanya dapat digunakan dengan tim Anda saat ini.","Text_SharedMeidouPrompt":"Untuk berbagi kredit dengan lebih dari 5 orang, silakan","Button_ActivateTeamMember":"Berlangganan Keanggotaan Tim","Text_SeatPurchaseEffect":"Seat tambahan langsung berlaku dan berakhir pada ${0} (tanggal berakhir yang sama dengan pesanan keanggotaan tim aktif)","Label_Gift":"Bonus","Text_FirstMonthMeidouGift":"Berlangganan untuk mendapatkan ${0} kredit pada bulan pertama dan ${1} kredit setiap bulan setelahnya. Berlaku untuk bulan berjalan.","Text_MonthlyMeidouGift":"Diberikan setiap bulan, berlaku untuk bulan berjalan","Desc_TeamOnlyCutout":"Kredit unduhan yang dibeli hanya dapat digunakan dengan tim Anda saat ini.","Text_DownloadDeductRule":"Setiap unduhan gambar yang berhasil menggunakan 1 kredit unduhan.","Text_CutoutAdjustRule":"Sesuaikan hasil pemotongan sesering yang Anda mau. Kredit unduhan hanya dikurangi saat Anda mengunduh.","Text_UnlimitedCutout":"Pemotongan tanpa batas selama keanggotaan Anda aktif","Text_ValidityThreeMonths":"Masa berlaku: 3 bulan","Text_ValidityOneYear":"Masa berlaku: 1 tahun","Title_VipLimitedOffer":"Penawaran istimewa VIP","Text_TeamSeatRequirement":"Tim Anda saat ini memiliki ${0} anggota. Beli jumlah kursi yang sesuai.","Text_TeamMemberSeatMinimum":"Keanggotaan tim mulai dari ${0} kursi","Text_MeidouGiftPerMonth":"Kredit bonus: ${0}/bulan","Label_SeatCount":"Kursi","Text_SeatOrderEffect":"Kursi pesanan baru akan berlaku pada ${0}. Untuk menambahkan kursi segera, silakan","Button_ActivateMemberUnlimited":"Berlangganan untuk akses tak terbatas","Button_BuyMember":"Langganan","Button_BuyCount":"Jumlah pembelian","Text_BatchRemainingCount":"Gambar batch tersisa: ${0}","Label_RemainingCutout":"Sisa potongan:","Text_RemainingMeidouCount":"Sisa kredit: ${0}","Text_TeamMemberExpiry":"Keanggotaan tim berakhir pada ${0}","Text_BoundPhoneAccount":"(Akun tertaut: ${0})","Button_ClickLoginRegister":"Ketuk untuk login (Termasuk pendaftaran)","Text_LoginToBuyMember":"Login untuk berlangganan dan menyimpan kreasi VIP Anda dengan aman.","Text_LoginToBuy":"Login untuk membeli","Button_CorporateTransfer":"Transfer Bank Perusahaan","Button_ApplyInvoice":"Invoice","Button_InviteOrRedeemCode":"Aktifkan dengan kode undangan/penukaran","Button_RedeemCodeActivate":"Aktifkan dengan kode penukaran","Text_MarchPromo":"Promo E-Commerce Maret: Kredit Ganda untuk Isi Ulang Pertama Anda","Button_BackToBuy":"Kembali ke pembelian","Label_EstimatedConsumption":"Estimasi penggunaan:","Text_ValidOneYear":"Berlaku selama 1 tahun","Text_PerMonth":"/bulan","Desc_Monthly330Meidou":"330 kredit gratis per bulan (berlaku untuk bulan berjalan), dapat digunakan untuk:","Text_UnitPrice1000":"Hanya ¥0.0532/kredit","Text_Capacity1000":"Dapat menghasilkan sekitar 500 gambar atau 66 video","Text_SingleImageLow1000":"Mulai dari ¥0.176 per gambar","Text_SingleVideoLow1000":"Mulai dari ¥1.320 per video (5 dtk)","Text_SingleImageYearly1000":"Mulai dari ¥0.106 per gambar","Text_SingleVideoYearly1000":"Mulai dari ¥0.798 per video (5 dtk)","Text_UnitPrice1800":"Hanya ¥0.0462/kredit","Text_Capacity1800":"Dapat menghasilkan sekitar 900 gambar atau 120 video","Text_SingleImageLow1800":"Mulai dari ¥0.164 per gambar","Text_SingleVideoLow1800":"Mulai dari ¥1.233 per video (5 dtk)","Text_SingleImageYearly1800":"Mulai dari ¥0.092 per gambar","Text_SingleVideoYearly1800":"Mulai dari ¥0.693 per video (5 dtk)","Text_UnitPrice3600":"Hanya ¥0,0437 per kredit","Text_Capacity3600":"Buat sekitar 1.800 gambar atau 240 video","Text_SingleImageLow3600":"Mulai dari ¥0.154 per gambar","Text_SingleVideoLow3600":"Mulai dari ¥1,158 per video (5 dtk)","Text_SingleImageYearly3600":"Mulai dari ¥0.087 per gambar","Text_SingleVideoYearly3600":"Mulai dari ¥0.656 per video (5 dtk)","Text_UnitPrice7500":"Hanya ¥0,0410 per kredit","Text_Capacity7500":"Buat sekitar 3.750 gambar atau 500 video","Text_SingleImageLow7500":"Mulai dari ¥0.138 per gambar","Text_SingleVideoLow7500":"Mulai dari ¥1,037 per video (5 dtk)","Text_SingleImageYearly7500":"Mulai dari ¥0,082 per gambar","Text_SingleVideoYearly7500":"Mulai dari ¥0,615 per video (5 dtk)","Desc_IncludesStandardAll":"Mencakup semua manfaat Standard, plus:","Desc_MonthlyMeidou":"${0} Kredit disertakan setiap bulan (berlaku untuk bulan berjalan), dapat digunakan untuk:","Text_FewCredits":"Kredit terbatas","Label_BasicPlan":"Versi Dasar","Text_TrialMeidouGift":"120 kredit disertakan dalam uji coba, berlaku selama 7 hari","Text_Monthly330MeidouBenefit":"Berlangganan untuk mendapatkan 330 kredit setiap bulan, berlaku untuk bulan berjalan.","Label_LimitedPrivilege":"Benefit Terbatas Waktu","Text_SeedancePrivilege":"Pembuatan lambat gratis tanpa batas dengan Seedance 2.0 dan akses awal ke fitur baru","Label_MeidouPrefix":"Kredit:","Text_LoginToBuyMemberShort":"Login untuk membeli keanggotaan","Text_TeamMinimumSeat":"Tim Anda saat ini memiliki ${0} anggota. Anda perlu membeli setidaknya ${0} slot.","Message_AbnormalSubscriptionNoSeat":"Tidak dapat menambahkan slot untuk keanggotaan tim dengan status langganan yang tidak normal.","Text_TeamMemberExpires":"Keanggotaan tim Anda akan berakhir pada ${0}.","Text_ProMemberExpires":"Keanggotaan Premium Anda akan berakhir pada ${0}.","Text_BasicMemberExpires":"Keanggotaan Basic Anda akan berakhir pada ${0}.","Text_SvipMemberExpires_MeituXiuXiu":"SVIP Anda akan berakhir pada ${0}.","Text_ActivateVip_DesignKit":"Berlangganan Meitu Design Studio VIP untuk menikmati manfaat keanggotaan","Text_UpgradeToSvip_MeituXiuXiu":"Anda sudah berlangganan Meitu VIP. Tingkatkan ke SVIP untuk menikmati layanan desain di berbagai perangkat.","Text_ActivateTeamMember_DesignKit":"Berlangganan Keanggotaan Tim untuk mendapatkan manfaat VIP X-Design dan fitur kolaborasi tim","Text_ActivateMember":"Berlangganan untuk menikmati banyak manfaat keanggotaan","Text_ActivateMember_MeituXiuXiu":"Berlangganan untuk menikmati manfaat Meitu VIP, SVIP, dan keanggotaan desktop Meitu","Text_ExpiredDays_Team":"Berakhir ${0} hari yang lalu. Beli sekarang untuk memulihkan akses.","Text_VipExpiredDays_DesignKit":"VIP Anda berakhir ${0} hari yang lalu. Selamat datang kembali!","Text_VipExpiredDays_MeituXiuXiu":"Meitu SVIP Anda berakhir ${0} hari yang lalu. Selamat datang kembali.","Text_ValidDays":"Berlaku selama ${0} hari","Text_ValidWeeks":"Berlaku selama ${0} minggu","Text_ValidMonths":"Berlaku selama ${0} bulan","Text_ValidQuarters":"Berlaku selama ${0} triwulan","Text_ValidYears":"Berlaku selama ${0} tahun","Text_CountdownDays":"${0} hari ${1}","Label_Week":"Minggu","Label_Quarter":"Triwulan","Desc_BatchCutoutConsumption":"Setelah menggunakan fitur Pemotongan, mengunduh dan menyimpan 1 gambar akan menggunakan ${0} kredit. Fitur lain menggunakan ${1} kredit.","Text_TieredSeatBilling":"Keanggotaan mencakup ${0} slot pengguna. Pengguna tambahan di atas ${1} dikenakan biaya ${2}/tahun/orang.","Text_PerYearPerPerson":"/tahun/orang","Text_BoundAccountPrefix":"(Akun tertaut:","Text_BoundAccountSuffix":")","Title_GlobalSettingsMobile_Batch":"Pengaturan Global","Tip_ApplyToAllTasksBelowMobile_Batch":"Terapkan ke semua tugas di bawah ini","Tip_UploadImagesFormatMobile_Batch":"Klik untuk mengunggah gambar JPEG/JPG/PNG hingga ${0} MB. Mendukung hingga ${1} gambar.","Title_EcommerceTools":"Alat E-Commerce","Title_MoreVideoTools":"Fitur Video Editing Lainnya","Text_AppMessageNotification_Batch":"Anda akan menerima pesan dalam aplikasi saat tugas selesai.","Tool_ProductDemoVideoMaker":"Pembuat Demo Produk","Tool_Video360Maker":"Pembuat Video 360","Tool_UnboxingVideoMaker":"Pembuat Video Unboxing","Tool_FashionVideoMaker":"Pembuat Video Mode","Tool_CommercialVideoMaker":"Pembuat Video Komersial","Tag_Cover":"Sampul","Option_ExportLayered_Psd":"Ekspor Berlapis","Option_ExportFlat_Psd":"Ekspor tanpa layer","Message_NoExportableLayer":"Tidak ada layer yang dapat diekspor yang dipilih","Message_UnsupportedLayerForPsd":"Jenis lapisan ini tidak mendukung ekspor PSD.","Message_VideoLayerPsdBlocked":"Berisi layer video. Tidak dapat mengekspor PSD.","Message_ExportUnitsOverLimit":"Pilihan melebihi ${0} item ekspor","Message_LayerSplitRightDenied":"Tidak Ada Manfaat Pemisahan Lapisan","AiTemplate_Desc":"Masukkan tema poster atau jelaskan editan Anda. AI akan membuat ulang Templat ini dan menghasilkan poster dengan sekali klik.","AiTemplate_Upload":"Unggah Elemen","AiTemplate_Upload_Desc":"Klik untuk mengunggah gambar elemen guna mengganti gambar produk, model, kode QR, dan lainnya.","AiTemplate_Prompt":"Tema Poster/Detail Pengeditan","AiTemplate_Prompt_Placeholder":"Masukkan tema poster atau jelaskan yang ingin Anda edit. Contoh: Ubah tema menjadi \'Autumn Equinox Moisture\'; ganti XX pada gambar dengan XX yang saya unggah.","AiTemplate_Generate":"Buat Poster","Text_OpenClawInstallCmd":"Bantu saya menginstal ${0}","Text_SupportLinkImport":"Mendukung impor tautan","Text_ModifyLogoPrompt":"Tolong bantu saya mengubah logo ini","Text_ModifyImagePrompt":"Tolong bantu saya mengubah gambar ini","Title_UserCenter":"Pusat Personal","Button_Login":"Login","Button_Signup":"Daftar","Title_FreeBackgroundRemoverOnline":"Penghapus Background Online Gratis","Title_RemoveThe":"Hapus gratis background foto secara instan dan otomatis dengan Designkit. Tidak perlu keterampilan desain apa pun.","Title_NoPic":"Tidak punya foto? Coba salah satu dari ini","Title_IndustryLeading":"Kualitas Pemotongan Foto Terbaik","Title_GlobalRunner":"Runner-up dalam kompetisi global CVPR 2024. Penelitian terobosan dipublikasikan di AAAI dan CVPR.","Title_FastAnd":"Penghapus Background yang Cepat dan Akurat","Title_SImplyUpload":"Unggah foto ke Designkit, subjek akan dideteksi lalu dihapus background-nya, tanpa langkah yang rumit, tidak perlu belajar.","Title_FineTune":"Sempurnakan Foto Seperti Editor Profesional","Titel_Whether":"Designkit mempertahankan detail halus yang paling penting, seperti helaian rambut, tepi kain, atau bayangan. Pengguna juga dapat menyempurnakan tepi dan sudut untuk akurasi yang lebih tinggi guna mencapai hasil akhir yang rapi dan profesional.","Title_FlawlessStamp":"Pemrosesan Stempel dan Tanda Tangan","Title_RemoveDull":"Hapus background yang blur pada tanda tangan dan stempel. Designkit mampu mengidentifikasi detail setiap subjek dan menyiapkannya untuk berbagai tata letak, seperti background solid atau PNG transparan.","Title_PerfecCutouts":"Hasil Potongan Sempurna untuk Berbagai Kegunaan","Title_GetFlawless":"Penghapus background yang sempurna untuk segala jenis gambar.","Button_ECommerco":"E-Commerce","Button_Portraits":"Potret","Button_Pets":"Hewan Piaraan","Button_LogoSignaure":"Logo & Tanda Tangan","Title_HowTo":"Bagaimana cara menghapus background foto?","Title_UploadYour":"Unggah foto","Title_ChooseAn":"Pilih foto dari perangkat, dalam format JPEG, PNG, atau WEBP.","Title_AIRemoves":"Al akan menghapus background","Title_AiEditor":"Al editor akan mengidentifikasi subjek dan menghapus background.","Title_EditOrExport":"Edit atau ekspor","Title_DownloadOr":"Unduh atau gunakan editor foto untuk mengedit gambar.","Title_FrequentlyAskedQuestions":"Tanya-Jawab","Title_IsThis":"Apakah alat ini gratis?","Answer_IsThis":"Ya, Penghapus Background Foto dari Designkit adalah alat gratis untuk menghapus background gambar.","Title_CanIChange":"Bisakah mengubah background setelah pemotongan selesai?","Title_WhichImage":"Format foto apa saja yang mendukung pemotongan?","Title_CanIManually":"Bisakah mengedit secara manual jika hasilnya tidak akurat?","Answer_CanIchange":"Ya, setelah pemotongan selesai, kamu bisa langsung memilih warna solid, gradasi, atau menambahkan gambar kustom sebagai background baru menggunakan Designkit. Praktis, fleksibel, dan dapat disesuaikan.","Answer_WhichImage":"Designkit mendukung format populer seperti JPG, PNG, dan WEBP untuk diunggah. Ekspor hasil pemotongan sebagai PNG transparan agar dapat diintegrasikan dengan mulus ke proyek desain lainnya.","Answer_CanIManually":"Tentu bisa. Jika bagian tepi tidak sempurna setelah deteksi otomatis, gunakan editor manual untuk memperbaikinya agar sesuai dengan kebutuhan.","Button_Reupload":"Unggah ulang","Button_Download":"Unduh","Button_Edit_Refine":"Sempurnakan","Button_Edit_Backgrounds":"Background","Button_Edit_Crop":"Pangkas","Button_Edit_Edges":"Tepi","Button_Edit_Filter":"Filter","Pop_Download_Freetip":"Bebas","Pop_Download_UHD":"Resolusi Penuh","Pop_Download_preview":"Pratinjau","Guid_More_ColorPanel":"Semua","Button_Remove_ColorPanel":"Hapus","Button_Upload_ColorPanel":"Unggah","Size_Original_SizePanel":"Ukuran asli","Button_Upload_Batch":"Unggah Massal","Desc_Upload":"Klik atau jatuhkan untuk mengunggah, tempelkan file.","SubTitle_Header1_Home":"AI Pembuat Gambar Daftar Produk","SubTitle_Header2_Home":"AI Pembuat Poster","SubTitle_Header3_Home":"AI Pembuat Video Produk","SubTitle_Header4_Home":"AI Pembuat Foto Produk","SubTitle_Header5_Home":"AI Desain Visual Website","SubTitle_Header6_Home":"Coba Pakaian Virtual","SubTitle_Header7_Home":"AI Desain Halaman Detail Produk","SubTitle_Header8_Home":"AI Editor Foto","SubTitle_Header9_Home":"Penyempurna Foto","SubTitle_Header10_Home":"Penghapus Objek","SubTitle_Header11_Home":"AI Penghapus Background","SubTitle_Header12_Home":"AI Background","SubTitle_Header13_Home":"Resize Foto","SubTitle_Header14_Home":"Tambah Teks ke Gambar","SubTitle_Header15_Home":"AI Pembuat Foto","SubTitle_Header16_Home":"Editor Foto Massal","Size_ToEdge":"Ke Edge","Pop_Download_UHD_LimitTip":"Batas waktu · ${0}","Before_Text":"Sebelum","After_Text":"Sesudah","Button_OpenVipFreeDownloadPsd":"Berlangganan untuk mengunduh PSD gratis","Text_LogoSlogan_DesignKit":"Buat desain komersial terlihat menarik dan memberikan hasil","LogoDesign_ModeTitle":"Pilih apa yang ingin Anda buat","LogoDesign_ModeFast":"Logo Cepat","LogoDesign_ModeFastDesc":"Generasi cepat, hanya info inti.","LogoDesign_ModePro":"Logo & Desain Visual","LogoDesign_ModeProDesc":"Konsep Strategi & Pratinjau Adegan Nyata.","LogoDesign_Essentials":"Informasi merek","LogoDesign_BrandNamePlaceholder":"Nama Merek (Wajib diisi)","LogoDesign_IndustryPlaceholder":"Industri (Wajib diisi)","LogoDesign_Description":"Deskripsi","LogoDesign_DescriptionPlaceholder":"Jelaskan kisah merek, slogan, audiens target, atau elemen spesifik yang Anda inginkan dalam logo...","LogoDesign_MoreSettings":"Pengaturan","LogoDesign_LogoType":"Jenis Logo","LogoDesign_StyleCount":"Gaya & Jumlah","LogoDesign_Model":"Model pembuatan gambar","LogoDesign_BrandColors":"Warna Merek","LogoDesign_AutoColor":"Warna Otomatis","LogoDesign_DragUpload":"Seret atau klik untuk mengunggah","LogoDesign_DragUploadHint":"Format PNG, JPG, dan WEBP didukung. Unggah satu gambar yang jelas.","LogoDesign_UploadingImage":"Mengunggah...","LogoDesign_ReplaceImage":"Ubah gambar","LogoDesign_ReferenceDimensions":"Ukuran Referensi","LogoDesign_GenerateLogos":"Buat Logo","LogoDesign_GenerateExpressLogos":"Hasilkan 8 logo","LogoDesign_GenerateConcepts":"Buat Proposal Konsep","LogoDesign_Processing":"Memproses...","LogoDesign_StrategyTitle":"Pilih Arah","LogoDesign_StrategyDesc":"Silakan pilih arah strategi sebelum menghasilkan logo akhir.","LogoDesign_RegenerateStrategies":"Coba strategi lain","LogoDesign_SelectStrategy":"Pilih Strategi","LogoDesign_GenerationHistory":"Riwayat Pembuatan","LogoDesign_NoHistory":"Belum ada riwayat pembuatan.","LogoDesign_EditInAgent":"Edit di Agent","LogoDesign_GenerateMockups":"Buat Mockup","LogoDesign_SelectMockupType":"Pilih jenis mockup","LogoDesign_VoteLike":"Suka","LogoDesign_VoteDislike":"Tidak suka","LogoDesign_HeroTitlePro":"Identitas visual merek profesional.","LogoDesign_HeroDescPro":"Dari konsep inti hingga penerapan di berbagai skenario, bangun sistem merek yang terpadu.","LogoDesign_HeroTitleExpress":"Solusi Logo AI","LogoDesign_HeroDescExpress":"Jelajahi 8 gaya visual berbeda dalam satu kali pembuatan.","LogoDesign_Items":"Proyek","LogoDesign_UntitledBrand":"Merek Tanpa Judul","LogoDesign_NoStrategy":"Belum Ada Strategi Dipilih","LogoDesign_StrategyBadge":"Opsi","LogoDesign_Inspiration":"Inspirasi","LogoDesign_MockupGridPlaceholder":"Kumpulan scene mockup buatan AI","LogoDesign_ValidationBrand":"Masukkan nama merek","LogoDesign_ValidationIndustry":"Pilih atau masukkan industri","LogoDesign_ValidationStrategy":"Pilih strategi terlebih dahulu.","LogoDesign_ValidationMockup":"Pilih setidaknya satu jenis mockup","LogoDesign_Style_Minimalist":"Minimal","LogoDesign_Style_Vintage":"Retro","LogoDesign_Style_Geometric":"Geometri","LogoDesign_Style_Abstract":"Abstrak","LogoDesign_Style_HandDrawn":"Lukisan tangan","LogoDesign_Style_Luxury":"Mewah","LogoDesign_Style_Tech":"Teknologi Tinggi","LogoDesign_Style_Nature":"Harian","LogoDesign_LogoType_IconText":"Ikon + Teks","LogoDesign_LogoType_TextOnly":"Hanya Teks","LogoDesign_LogoType_IconOnly":"Hanya Ikon","LogoDesign_LogoType_Lettermark":"Logo Huruf","LogoDesign_LogoType_Emblem":"Logo Lencana","LogoDesign_LogoType_Mascot":"Maskot","LogoDesign_MockupType_BusinessCard":"Kartu nama","LogoDesign_MockupType_Signage":"Papan Nama Toko","LogoDesign_MockupType_Packaging":"Pascaproduksi","LogoDesign_MockupType_Shirt":"Kaos","LogoDesign_MockupType_ToteBag":"Tas Tote","LogoDesign_MockupType_Sticker":"Stiker","LogoDesign_MockupType_OfficeSupplies":"Perlengkapan Kantor","LogoDesign_MockupType_AppIcon":"Ikon Aplikasi","LogoDesign_AddColor":"Tambah Warna","LogoDesign_ReferenceDimension_Graphics":"Grafis","roboneo_agent_queue_tier_fast_description":"Buat instan. Kredit dikenakan untuk setiap pembuatan.","roboneo_agent_queue_tier_relax_description":"Pembuatan gratis tanpa batas dengan kecepatan sedikit lebih lambat. Kredit tidak digunakan.","roboneo_agent_queue_tier_relax_locked_description":"Manfaat ${0} — buat gratis tanpa kredit.","roboneo_agent_queue_tier_upgrade_unlock":"Tingkatkan untuk membuka","Button_UpgradeForFree":"Upgrade Gratis","Label_Teams":"Tim","Title_AiModelAccess_Pricing":"Akses AI Model","Text_LimitedAiModels_Pricing":"Model Video dan Gambar Terbatas","Label_GptImage2_Pricing":"GPT Image 2.0","Label_NanoBananaPro_Pricing":"Nano Banana Pro","Label_NanoBanana2_Pricing":"Nano Banana 2","Label_GeminiOmniFlash_Pricing":"Gemini omni Flash","Label_Seedance2Mini_Pricing":"Seedance2.0 Mini","Label_Seedance2Fast_Pricing":"Seedance 2.0 Fast","Label_Kling26_Pricing":"Kling 2.6","Label_Veo31_Pricing":"Veo 3.1","Label_Sora2_Pricing":"Sora 2","Label_Midjourney_Pricing":"Midjourney","Label_Seedance25ComingSoon_Pricing":"Seedance 2.5 (Segera hadir)","Label_Seedream50Pro_Pricing":"Seedream 5.0 Pro","Label_NanoBanana_Pricing":"Nano Banana","Label_Seedream40_Pricing":"Seedream 4.0","Label_SeedEdit30_Pricing":"SeedEdit 3.0","Tab_VideoObjectRemover":"Penghapusan video","Text_WholeProductGuide_DomesticCloneCase":"Unggah gambar produk terlaris sebagai referensi dan buat ulang gaya yang sama dengan mudah","Text_ApparelGuide_DomesticCloneCase":"Unggah gambar fashion yang sedang tren sebagai referensi dan buat ulang tampilannya dengan mudah","Text_PosterCoverGuide_DomesticCloneCase":"Unggah gambar poster tren sebagai referensi dan buat ulang tampilannya dengan mudah","Text_SocialGraphicsGuide_DomesticCloneCase":"Unggah gambar media sosial yang sedang tren sebagai referensi dan buat ulang tampilannya dengan mudah.","TaskName_WholeProductClone_DomesticCloneCase":"Tumbler Insulasi Hijau Mint Bermotif Kucing","TaskName_ApparelClone_DomesticCloneCase":"Kemeja anak perempuan motif bunga kerah Peter Pan","TaskName_PosterCoverClone_DomesticCloneCase":"Poster Panduan Kuliner Shunde","TaskName_SocialGraphicsClone_DomesticCloneCase":"Panduan Wisata Jingdezhen","Label_SwitchToPage":"Beralih ke halaman ${0}","File_Mention_Upload_Text":"Tambah dari Perangkat","File_Mention_Empty_Text":"Anda belum mengunggah apa pun.","Empty_Agent_Canvas_Text":"Kanvas AI","Empty_Agent_Canvas_Description":"Buat dengan AI. Kreativitas tanpa batas.","Label_Height":"Tinggi","Label_Width":"Lebar","Agent_Guide_Placeholder_Title":"Mulai Sekarang, Berkreasi Bebas","Agent_Guide_Placeholder_Agent_Title":"Agen Obrolan","Agent_Guide_Placeholder_Agent_Subtitle":"Buat dari Awal","Agent_Guide_Placeholder_Upload_Subtitle":"Edit Gambar yang Ada","Label_Text_Then":"Lalu","Meta_Title_LogoDesign":"Desain Logo Profesional Jadi Mudah dengan Zawa AI","Title_AppEnhancer":"Peningkatan Video AI","Desc_AppEnhancer":"Tingkatkan ke 4K HD dalam satu klik, dengan peningkatan kualitas dan frame rate.","Title_AppWatermarkRemover":"Penghapus Watermark & Subtitle Video","Desc_AppWatermarkRemover":"Hapus watermark dan logo dari video dengan cepat.","Title_AppBackgroundRemover":"Penghapus Latar Belakang Video","Desc_AppBackgroundRemover":"Hapus latar belakang video dengan sekali klik, tanpa perlu daftar.","Title_VideoDemos":"Coba Video Ini","Button_DownloadPreview":"Unduh Pratinjau 5 Detik","Text_PreviewDownloading":"Mengunduh video 5 detik...","Title_PreviewVideo":"Video Pratinjau 5 Detik","Title_FullVideo":"Video Lengkap","Button_DownloadFull":"Unduh video lengkap","Text_FullDownloading":"Mengunduh video lengkap...","Tip_FullVideoReady":"Video lengkap Anda siap diunduh.","Tip_Processing":"Pemrosesan mungkin perlu beberapa saat. Jangan muat ulang halaman. Cek lagi nanti.","Tip_ProcessComplete":"Pemrosesan selesai. Ketuk untuk menyimpan video ke ponsel Anda.","Tag_Purchased":"Dibeli","Text_Uploading":"Mengunggah...","Message_ProcessFailed":"Pemrosesan video gagal.","Button_UploadVideo":"Unggah Video","Text_SupportFormat":"Format yang didukung: ${0}","Button_UploadNew":"+ Unggah Video Baru","Message_ProcessFailedRetry":"Pemrosesan video gagal. Periksa koneksi jaringan Anda dan coba lagi.","Tip_MaxProcessNum":"Maksimal ${0} video dapat diproses sekaligus. Coba lagi nanti.","Tip_MaxUploadNum":"Anda dapat mengunggah maksimal ${0} file video sekaligus.","Message_VideoLoadFailed":"Gagal memuat video","Tip_VideoResolutionLimit":"Video dengan resolusi lebih tinggi dari 4K tidak didukung.","Tip_VideoDurationLimit":"Durasi video melebihi batas. Pastikan durasinya kurang dari 20 menit.","Tip_VideoSizeLimit":"Video terlalu besar. Unggah video di bawah ${0} MB.","Tip_VideoFormatLimit":"Format video yang didukung: ${0}. Unggah video dalam format yang didukung.","Tip_Done":"Selesai","Text_IsProMember":"Anda adalah anggota Pro.","Text_SubscribeToUnlock":"Berlangganan untuk membuka akses.","Button_Enhance":"Mulai Tingkatkan","Button_Remove":"Mulai","Text_Enhancing":"Meningkatkan...","Text_EnhancingFull":"Meningkatkan kualitas seluruh video...","Text_Removing":"Menghapus...","Text_RemovingFull":"Menghapus dari seluruh video...","Text_RemovingSelectedArea":"Menghapus area yang dipilih...","Tag_Enhanced":"Ditingkatkan","Tag_Removed":"Dihapus","Tag_Preview":"Pratinjau 5 Detik","Label_SelectResolution":"Pilih Resolusi","Message_DownloadFailed":"Gagal mengunduh. Periksa koneksi internet dan coba lagi.","Message_DownloadFailedRetry":"Gagal mengunduh. Coba unduh lagi.","Tab_Smart":"Pengenalan Pintar","Tab_Watermark":"Watermark","Tab_Subtitle":"Subtitel","Tab_Manual":"Manual","Label_BoxItem":"Pilih area yang ingin dihapus","Tip_ClearManualBoxOnSwitch":"Beralih mode akan menghapus pilihan","Label_Multiplier":"${0}x","Label_Resolution1K":"1K","Label_Resolution2K":"2K","Label_Resolution4K":"4K","Title_ConfirmVideoRights":"Konfirmasikan bahwa Anda berhak menggunakan video ini.","Desc_ConfirmVideoRights":"Jangan mengunggah atau mengimpor konten apa pun yang bukan milik Anda atau tidak secara sah diizinkan untuk Anda gunakan. Dengan mengeklik \\"Konfirmasi\\", Anda mengonfirmasi bahwa Anda memiliki konten ini dan bahwa hal-hal berikut tidak akan melanggar hak pihak ketiga atau hukum yang berlaku: (i) Konten itu sendiri; (ii) Penggunaan Anda atas layanan kami; atau (iii) Penggunaan konten oleh kami untuk menyediakan layanan yang Anda minta.","Button_Import":"Impor","Title_ImportVideoLink":"Impor tautan video Anda","Label_ConfirmContentPermission":"Dengan mengunggah tautan, saya mengonfirmasi bahwa saya memiliki konten ini.","Placeholder_VideoLink_WatermarkRemover":"Masukkan tautan video untuk menghapus watermark...","Placeholder_VideoLink_SocialPlatforms":"Mendukung tautan TikTok, IG, YouTube, dan Facebook","Placeholder_VideoLink_SocialPlatforms_Domestic":"Mendukung tautan Douyin, Kuaishou, Xiaohongshu, dan TikTok","Tip_InvalidLink":"Impor tautan yang valid","Tip_LinkImportFailed":"Impor gagal. Coba lagi.","Text_FileFromLink":"File tertaut ${0}","Text_LinkImporting":"Mengimpor ${0}%","Button_Batch":"Batch","Button_Link":"Tautan","Title_MobileBatchUnsupported":"Pemrosesan batch belum didukung di perangkat seluler","Text_VisitOnDesktop":"Buka di komputer:","Button_CopyAddress":"Salin","Text_UploadDropPasteClick":"Seret dan lepas, tempel, atau klik untuk mengunggah","Text_UploadDropPasteClick_Support":"Mendukung .mp4, .mov, dan m4v","Tips_UploadMaxVideoCountLimit":"Unggah hingga ${0} file video","Title_AILogoDesign":"Desain Logo AI","Title_AILogoPreview":"Desain Logo AI","Message_IndustryLoadFailed":"Gagal memuat data industri","Message_LogoResultPartialFailed":"Gagal mengambil beberapa hasil pembuatan Logo","Label_LogoGenerateMode":"Mode Pembuatan Logo","Tab_GeneralMode":"Mode Umum","Desc_StrongerLogoModel":"Didukung oleh model yang lebih canggih untuk logo berkualitas lebih tinggi","Button_CloseTip":"Tutup Saran","Label_LogoName":"Nama Logo","Label_LogoSlogan":"Subtitel/Slogan","Label_Optional":"Opsional","Placeholder_LogoDescription":"Jelaskan nuansa merek, kata kunci gaya, kasus penggunaan, dll.","Title_AIServiceStatement":"Pernyataan Layanan AI","Label_LogoCreateGuide":"Panduan pembuatan logo","Title_StartCreateLogo":"Mulai Membuat Logo Anda","Desc_CreateLogoSchemes":"Masukkan informasi merek di sebelah kiri untuk menghasilkan ${0} opsi pilihan","Text_FillBrandInfo":"Masukkan Info Merek","Text_SelectGenerateMode":"Pilih Mode Pembuatan","Text_GetLogoScheme":"Dapatkan Desain Logo","Label_AILogoPreview":"Pratinjau Logo AI yang Diperbesar","Button_ClosePreview":"Nonaktifkan Pratinjau","Label_AILogoLarge":"Gambar Logo AI Berukuran Besar","Button_PreviousLogo":"Lihat Logo Sebelumnya","Button_NextLogo":"Lihat Logo Berikutnya","Button_ScrollThumbnailsLeft":"Gulir Thumbnail ke Kiri","Label_LogoPreviewList":"Daftar Pratinjau Logo","Button_SwitchLogo":"Ganti ke Logo Ini","Button_ScrollThumbnailsRight":"Gulir Thumbnail ke Kanan","Message_LogoDownloadFailed":"Gagal mengunduh Logo. Coba lagi nanti.","Label_LogoGenerateResult":"Hasil Logo","Title_GenerateResult":"Hasil:","Button_WatermarkPreference":"Atur Preferensi Watermark Unduhan","Button_SelectLogo":"Pilih Logo Ini","Text_LogoGenerating":"Membuat logo...","Message_LogoGenerateFailedRetry":"Gagal membuat. Harap coba lagi.","Label_AIGeneratedLogo":"Logo Buatan AI","Button_EditLogo":"Edit Logo Ini","Button_DownloadLogo":"Unduh Logo Ini","Button_PreviewLogo":"Pratinjau Logo Ini","Message_RecordLoadFailed":"Gagal memuat riwayat pembuatan","Message_MoreRecordsLoadFailed":"Gagal memuat lebih banyak catatan","Message_LogoBatchDownloadFailed":"Gagal mengunduh Logo secara massal. Coba lagi nanti.","Label_RecordLoading":"Memuat riwayat...","Label_LogoRecords":"Riwayat Logo","Label_GenerateMode":"Mode Pembuatan","Text_GenerateTime":"Waktu pembuatan: ${0}","Button_ZoomLogo":"Lihat Logo dalam Layar Penuh","Text_NoMoreRecords":"Tidak ada riwayat lainnya","Message_GenerateTaskSubmitted":"Tugas pembuatan telah dikirim","Message_LogoGenerateFailed":"Pembuatan Logo gagal. Coba lagi nanti.","Button_QuickGenerate":"Buat Cepat","Label_GenerateViral_ViralVideo":"Buat Viral","Label_ReplicateViral_ViralVideo":"Replikasi Viral","Message_SelectMarket_ViralVideo":"Harap pilih pasar target","Message_SelectLanguage_ViralVideo":"Harap pilih bahasa video","Message_SelectRatio_ViralVideo":"Harap pilih rasio platform","Message_FillScript_ViralVideo":"Harap isi skrip kustom","Message_SetScriptCount_ViralVideo":"Harap atur jumlah pembuatan skrip kustom","Message_SelectViralType_ViralVideo":"Harap pilih setidaknya satu jenis viral","Message_MaxViralTypes_ViralVideo":"Total jenis viral tidak boleh melebihi ${0}","Message_InputTaskTitle_ViralVideo":"Harap masukkan judul tugas","Message_FillSellingPoints_ViralVideo":"Harap isi deskripsi poin jual","Message_ProductImageShortEdgeLimit_ViralVideo":"Harap unggah gambar dengan sisi terpendek lebih dari 300px","Message_ProductImageAspectRatioSuggestion_ViralVideo":"Disarankan mengunggah gambar 16:9, 9:16, atau 1:1","Message_UploadRefVideo_ViralVideo":"Harap unggah video referensi","Message_TaskCancelled_ViralVideo":"Tugas dibatalkan","Text_GenerateTaskTitle_ViralVideo":"Buat Tugas Viral ${0}","Text_ReplicateTaskTitle_ViralVideo":"Replikasi Tugas Viral ${0}","Text_TaskCopyTitle_ViralVideo":"${0}-Salinan","Message_FetchConfigFailed_ViralVideo":"Gagal mengambil konfigurasi inisialisasi viral","Title_VideoResult_ViralVideo":"Hasil Video","Text_AiGenerating_ViralVideo":"AI sedang menghasilkan...","Text_CheckingSellingPoints_ViralVideo":"Memeriksa konten...","Label_EmailNotify_ViralVideo":"Beri tahu saya lewat email saat siap","Title_LinkEmail_ViralVideo":"Tautkan alamat email","Text_LinkEmailDesc_ViralVideo":"Akun Anda belum memiliki alamat email. Tautkan email di Pusat Akun, lalu kembali untuk mengaktifkan notifikasi email.","Text_LinkEmailRedirect_ViralVideo":"Anda akan dialihkan ke Pusat Akun untuk menyelesaikan penautan dan verifikasi email.","Button_GoToAccountCenter_ViralVideo":"Buka Pusat Akun","Title_EmailNotifyConfirm_ViralVideo":"Dapatkan notifikasi email?","Text_EmailNotifyConfirm_ViralVideo":"Kami akan memberi tahu ${0} saat video Anda siap.","Message_EmailLinked_ViralVideo":"Email tertaut. Aktifkan notifikasi jika Anda ingin diberi tahu saat video ini siap.","Message_EmailNotifyOff_ViralVideo":"Notifikasi email dimatikan","Message_EmailNotifyOn_ViralVideo":"Notifikasi email diaktifkan","Text_NoHistory_ViralVideo":"Tidak ada riwayat","Text_MobileGuideGenerate_ViralVideo":"Unggah gambar produk dan poin penjualan untuk membuat video viral promosi dengan cepat.","Text_MobileGuideReplicate_ViralVideo":"Unggah gambar produk dan video referensi untuk meniru ritme serta gaya visual video viral.","Label_DKGenerateViralMobileGuideNavTitle_ViralVideo":"Buat Viral","Label_DKGenerateViralMobileGuideTitle_ViralVideo":"Buat Viral","Text_DKGenerateViralMobileGuideSubtitle_ViralVideo":"Unggah gambar produk dan poin penjualan untuk membuat video viral promosi dengan cepat.","Label_DKReplicateViralMobileGuideNavTitle_ViralVideo":"Replikasi Viral","Label_DKReplicateViralMobileGuideTitle_ViralVideo":"Replikasi Viral","Text_DKReplicateViralMobileGuideSubtitle_ViralVideo":"Unggah gambar produk dan video referensi untuk meniru ritme serta gaya visual video viral.","Label_ZawaGenerateViralMobileGuideNavTitle_ViralVideo":"Buat Viral","Label_ZawaGenerateViralMobileGuideTitle_ViralVideo":"Buat Viral","Text_ZawaGenerateViralMobileGuideSubtitle_ViralVideo":"Unggah gambar produk dan poin penjualan untuk membuat video viral promosi dengan cepat.","Label_ZawaReplicateViralMobileGuideNavTitle_ViralVideo":"Replikasi Viral","Label_ZawaReplicateViralMobileGuideTitle_ViralVideo":"Replikasi Viral","Text_ZawaReplicateViralMobileGuideSubtitle_ViralVideo":"Unggah gambar produk dan video referensi untuk meniru ritme serta gaya visual video viral.","Button_ConfirmGenerate_ViralVideo":"Konfirmasi Buat","Button_Close_ViralVideo":"Tutup","Button_Previous_ViralVideo":"Sebelumnya","Button_Next_ViralVideo":"Berikutnya","Message_CreateTaskFailed_ViralVideo":"Gagal membuat tugas, coba lagi nanti","Message_RefreshFailed_ViralVideo":"Gagal memuat ulang, coba lagi nanti","Message_VideoFormatLimit_ViralVideo":"Video referensi saat ini hanya mendukung mp4 / mpeg / mov / avi / flv / mpg / webm","Message_ReferenceVideoSizeLimit_ViralVideo":"Ukuran video referensi tidak boleh melebihi ${0}MB","Message_UploadRefVideoFirst_ViralVideo":"Replikasi viral memerlukan upload video referensi terlebih dahulu","Message_FillProductInfo_ViralVideo":"Harap isi poin jual produk","Message_SelectVideoType_ViralVideo":"Harap pilih jenis video dan jumlah","Button_Disabled_ViralVideo":"Nonaktifkan","Text_LoadingCreator_ViralVideo":"Memuat kreator saya…","Text_NoCreatorYet_ViralVideo":"Belum ada gambar kreator, coba unggah satu","Text_TotalCount_ViralVideo":"(Total ${0})","Text_Submitting_ViralVideo":"Mengirim...","Text_LoadingConfig_ViralVideo":"Memuat konfigurasi…","Button_Decrease_ViralVideo":"Kurangi","Button_Increase_ViralVideo":"Tambah","Title_NightHosted_ViralVideo":"Tuan Rumah Malam","Message_CreatorGenSuccess_ViralVideo":"Kreator berhasil dibuat","Button_ContinueNewTask_ViralVideo":"Lanjut Tugas Baru","Text_CustomScriptCount_ViralVideo":"Skrip Kustom × ${0}","Text_ViralTypeCount_ViralVideo":"Jenis Viral × ${0}","Text_FissionCount_ViralVideo":"Fisi Viral × ${0}","Text_AiModelEnabled_ViralVideo":"Model AI Diaktifkan","Label_ModelTab_ViralVideo":"Tab Model","Label_ModelParams_ViralVideo":"Parameter Model","Text_ParamsAdjusted_ViralVideo":"Parameter disesuaikan secara terpisah","Text_NoSellingPoints_ViralVideo":"Deskripsi poin jual belum diisi","Message_FillSellingPointsPlease_ViralVideo":"Harap tambahkan deskripsi poin jual","Message_ThanksForFeedback_ViralVideo":"Terima kasih atas masukan Anda!","Title_AdditionalFeedback_ViralVideo":"Masukan tambahan","Placeholder_FeedbackBetter_ViralVideo":"Apa yang bisa ditingkatkan?","Button_SubmitFeedback_ViralVideo":"Kirim masukan","Button_LikeFeedback_ViralVideo":"Suka","Button_DislikeFeedback_ViralVideo":"Tidak suka","Text_ProductImageCount_ViralVideo":"${0} Gambar Produk","Text_RefVideoCount_ViralVideo":"${0} Video Referensi","Text_FollowGlobal_ViralVideo":"Mengikuti pengaturan global","Message_BatchSubmitSuccess_ViralVideo":"Tugas batch video viral berhasil dikirim, total ${0}","Message_BatchSubmitFailed_ViralVideo":"Pengiriman batch video viral gagal, coba lagi nanti","Text_MaxSelectionTip_ViralVideo":"Maksimal ${0} jenis video dapat dipilih sekaligus","Text_DeselectItem_ViralVideo":"Batalkan pilihan ${0}","Text_SelectItem_ViralVideo":"Pilih ${0}","Tab_CustomCreatorSection_ViralVideo":"Kreator Kustom","Tab_MyCreatorSection_ViralVideo":"Kreator Saya","Tab_PersonalAssets_ViralVideo":"Aset Pribadi","Tab_OfficialRecommendation_ViralVideo":"Rekomendasi Resmi","Title_CustomCreatorSection_ViralVideo":"Kustomisasi Kreator Eksklusif","Text_InProgress_ViralVideo":"Sedang dibuat...","Text_NothingToDownload_ViralVideo":"Tidak ada hasil yang dapat diunduh saat ini","Text_ResultNotReady_ViralVideo":"Hasil saat ini belum tersedia untuk diunduh","Text_PreparingDownload_ViralVideo":"Menyiapkan unduhan...","Text_PreDownloaded_ViralVideo":"Pemrosesan selesai. Ketuk untuk menyimpan video ke ponsel Anda.","Message_RedoSubmitted_ViralVideo":"Ulangi telah dikirim","Message_RedoFailed_ViralVideo":"Gagal mengulangi, coba lagi nanti","Text_CancelHostedConfirm_ViralVideo":"Setelah membatalkan hosting, hasil yang sedang dibuat saat ini akan berhenti.","Button_Later_ViralVideo":"Nanti","Message_HostedCancelled_ViralVideo":"Hosting dibatalkan","Text_BatchFailed_ViralVideo":"Hasil batch saat ini tidak dikembalikan, Anda dapat membuat ulang nanti.","Title_ViralTypeConfig_ViralVideo":"Konfigurasi Jenis Viral (Total ${0})","Title_ReplicateConfig_ViralVideo":"Konfigurasi Replikasi","Label_ReplicateCount_ViralVideo":"Jumlah Replikasi","Label_StylePreference_ViralVideo":"Preferensi Gaya","Placeholder_StylePreference_ViralVideo":"Anda dapat menentukan preferensi seperti ritme, suasana hati, bahasa kamera, atmosfer palet warna, dll.","Label_SupplementNote_ViralVideo":"Catatan Tambahan","Placeholder_SupplementNote_ViralVideo":"Tambahkan struktur yang tidak ingin diubah, shot yang harus dipertahankan, persyaratan poin jual khusus, dll.","Text_FourthSection_ViralVideo":"4. Jumlah Fisi","Message_RequestFailed_ViralVideo":"Permintaan gagal","Message_PromptOptimizeFailed_ViralVideo":"Gagal mengoptimalkan prompt, coba lagi nanti","Message_ModelImageFailed_ViralVideo":"Gagal menghasilkan gambar model, coba lagi nanti","Desc_BatchGenerateViral_ViralVideo":"Unggah gambar produk secara batch, konfigurasi poin jual dan buat tugas video viral.","Desc_BatchReplicateViral_ViralVideo":"Unggah gambar produk secara batch dan tambahkan video referensi untuk setiap tugas guna mereplikasi konten viral.","Text_RecordRetentionTip_ViralVideo":"Catatan pembuatan hanya disimpan selama 2 bulan. Harap unduh dan simpan sesegera mungkin agar tidak hilang.","Message_PromptOptimizeEmpty_ViralVideo":"Hasil optimasi prompt kosong","Message_CompleteModelInfo_ViralVideo":"Harap lengkapi informasi model terlebih dahulu","Message_ModelGenFailed_ViralVideo":"Gagal membuat model, coba lagi nanti","Text_VideoFormatSupport_ViralVideo":"Video referensi saat ini hanya mendukung format mp4 / mpeg / mov / avi / flv / mpg / webm / wmv / 3gpp","Message_UnsupportedVideoFiltered_ViralVideo":"Beberapa format video tidak didukung dan telah difilter secara otomatis","Message_FreeTrialOneVideoOnly_ViralVideo":"Uji coba gratis hanya mencakup 1 video. Upgrade ke Pro untuk membuat lebih banyak.","Button_AddToMyCreator_ViralVideo":"Tambahkan ke Kreator Saya","Button_ResetGlobal_ViralVideo":"Reset ke Global","Button_TaskLevelCustomCreator_ViralVideo":"Kreator Kustom Tingkat Tugas","Button_TaskLevelReplicateModel_ViralVideo":"Model Replikasi Tingkat Tugas","Label_ModelReference_ViralVideo":"Gambar Referensi Model","Placeholder_CreatorStyle_ViralVideo":"Tambahkan persyaratan persona kreator, gaya berbicara, kehadiran kamera, dll.","Text_CreatorDisabledTip_ViralVideo":"Saat konfigurasi kreator tidak diaktifkan, sistem akan menghasilkan menggunakan gaya tampil kamera umum default.","Text_GenerateViralResult_ViralVideo":"Hasilkan Viral","Text_OverrideCount_ViralVideo":"Timpa ${0} item","Text_ReplicateViralResult_ViralVideo":"Hasil Replikasi Viral","Text_SavedCreatorProfiles_ViralVideo":"Konfigurasi kreator yang tersimpan, dapat diisi dengan satu klik.","Label_GenerateScheme_ViralVideo":"Rencana Pembuatan Viral ${0}","Label_ReplicateScheme_ViralVideo":"Rencana Replikasi Viral ${0}","Text_VideoResult_ViralVideo":"Hasil Video","Button_ContinueGenerate_ViralVideo":"Lanjutkan Pembuatan","Desc_CreatorImageEmptyHint_ViralVideo":"Gambar kreator yang dihasilkan akan muncul di sini untuk digunakan ulang langsung di halaman ini.","Text_ItemCountUnit_ViralVideo":"${0} item","Text_CreditAmount_ViralVideo":"${0} kredit","Text_TotalItems_ViralVideo":"Total: ${0}","Text_SelectedVideoTypeCount_ViralVideo":"${0} jenis video dipilih","Text_FirstVideoDiscountBadge_ViralVideo":"Diskon video pertama","Text_DesignKitFirstDiscountVipBadge_ViralVideo":"Diskon 50% untuk yang pertama","Text_DesignKitFirstDiscountTryBadge_ViralVideo":"Coba seharga $1.99","Text_FreeVideoBadge_ViralVideo":"${0} video gratis","Text_FirstDiscountPrice_ViralVideo":"Buat video pertama hanya ${0} kredit (harga asli ${1} kredit)","Text_UpgradeProDiscount_ViralVideo":"Upgrade ke Pro dan hemat 25%","Text_EnjoyedProDiscount_ViralVideo":"Diskon member 25% diterapkan","Text_BatchFeatureRequiresMembership_ViralVideo":"Pembuatan massal memerlukan keanggotaan","Text_OpenProGenerationDiscount_ViralVideo":"Berlangganan Pro untuk diskon pembuatan 25%","Text_EnjoyedProGenerationDiscount_ViralVideo":"Diskon pembuatan Pro 25% diterapkan","Button_OpenProOrMembership_ViralVideo":"Berlangganan Pro / Keanggotaan","Text_MemberExclusiveBadge_ViralVideo":"Khusus member","Text_VipFunctionLimitedTimeOpen_ViralVideo":"Fitur VIP tersedia untuk waktu terbatas","Title_NetworkDisconnected_ViralVideo":"Koneksi jaringan terputus","Text_NetworkDisconnectedRefresh_ViralVideo":"Tugas masih dibuat di latar belakang dan tidak akan hilang. Periksa jaringan lalu muat ulang halaman untuk melihat progres terbaru.","Button_RefreshPage_ViralVideo":"Muat ulang halaman","Message_NetworkDisconnectedRetry_ViralVideo":"Jaringan terputus. Periksa jaringan lalu coba lagi.","Tip_InvalidLink_ViralVideo":"Masukkan tautan video yang valid","Title_GenerateParams_ViralVideo":"Parameter pembuatan","Label_PreviewMarket_ViralVideo":"Pasar target:","Label_PreviewLanguage_ViralVideo":"Bahasa target:","Label_PreviewAspectRatio_ViralVideo":"Rasio video:","Label_PreviewScriptType_ViralVideo":"Jenis skrip:","Label_PreviewProductInfo_ViralVideo":"Info keunggulan produk:","Text_GeneratingBrowserTitle_ViralVideo":"⏳ Sedang dibuat... | ${0}","Text_SimplePreviewSwipeGuide_ViralVideo":"Geser ke atas untuk melihat lebih banyak","Button_UploadImageReplicate_ViralVideo":"Unggah gambar untuk replikasi","Label_PlayVideo_ViralVideo":"Putar video","Label_NoWatermark_ViralVideo":"Tanpa Watermark","Tool_LosslessUpscale":"Peningkat Resolusi Gambar","Tool_AiRecolor":"Ubah Warna Gambar AI","Tool_AiPhotoEditorTitle":"Editor Foto AI","Message_ZipOnlyOne":"Anda hanya dapat mengunggah satu arsip dalam satu waktu","Message_ZipSizeLimit":"Ukuran file terkompresi tidak boleh melebihi ${0} MB","Message_ZipExtractFailed":"Gagal mengurai arsip ${0}","Message_ZipNoUploadableFiles":"${0} Tidak ada file yang dapat diunggah dalam paket terkompresi ini","Message_ZipAlreadyUploaded":"Semua file dalam ${0} sudah diunggah. Unggahan duplikat dilewati.","Title_VideoWatermark":"Video Anda berisi watermark","Desc_VideoWatermark":"Video yang diekspor selama masa uji coba akan menyertakan watermark ${0}. Upgrade ke Premium untuk mengunduh video tanpa watermark.","Button_RemoveWatermark":"Hapus Watermark","Button_DownloadAnyway":"Tetap Unduh","Message_DownloadFailedTryAgain":"Unduhan gagal. Coba lagi.","MenuItem_ProductRestore":"Pemulihan Produk","Title_ProductRestore":"Pemulihan Produk","Desc_ProductRestore":"Unggah gambar asli untuk memperbaiki distorsi produk","Tip_ProductRestoreUpload":"Pilih gambar dengan sudut dan orientasi yang mirip dengan hasil saat ini. Produk harus jelas dan terlihat sepenuhnya.","Button_StartProductRestore":"Mulai Pemulihan","Message_ProductRestoreUploadLimit":"Unggah gambar dalam format JPEG, JPG, PNG, atau HEIC, maksimal 10 MB.","Message_ProductRestoreUploadFailed":"Gagal mengunggah gambar pemulihan produk. Coba lagi.","Message_VideoDownloadingInBackground":"Pengunduhan berjalan di latar belakang. Anda tetap dapat menggunakan ${0}","Button_AdjustParameters":"Sesuaikan Pengaturan","Text_WPS_Welcome_Modal_Meidou_Description1":"Anggota Premium: Bonus satu kali 50 kredit","Text_WPS_Welcome_Modal_Meidou_Description2":"Anggota Non-Premium: Bonus satu kali 25 kredit","Text_WPS_Meidou_Rules":"Aturan Penggunaan Kredit","Text_WPS_Meidou_Details":"Detail Penggunaan Kredit","Button_ImportLink":"Impor Tautan","Tip_ProductImagesUpload":"Unggah lebih banyak sudut produk untuk hasil yang lebih baik","Button_EditSkill":"Keterampilan Mengedit","Title_CategorySkills":"Keahlian ${0}","Button_AllSkills":"Semua Keahlian","Text_NoSkills":"Tidak ada skill yang tersedia","Aria_ScrollLeft":"Gulir ke kiri","Aria_ScrollRight":"Gulir ke kanan","Message_CompleteRequired":"Lengkapi bidang yang wajib diisi","Button_InsertToDesc":"Tambahkan ke Deskripsi","Aria_ExpandOptions":"Opsi Perluas","Message_FileUploadFailedRetry":"Gagal mengunggah file. Silakan coba lagi.","Button_UploadImageVideo":"Unggah foto/video","Aria_DeleteFile":"Hapus file","Aria_PauseVideo":"Jeda Video","Aria_SwitchToSlide":"Beralih ke gambar ${0}","Tip_PleaseFill":"Harap isi ${0}","Tool_ImageToVideoGenerator":"Generator Gambar ke Video","Tool_TextToVideoGenerator":"Generator Teks ke Video","Tool_TikTokVideoGenerator":"Generator Video TikTok","Tool_InstagramVideoGenerator":"Generator Video Instagram","Tool_YouTubeVideoGenerator":"Generator Video YouTube","Tool_YouTubeShortsGenerator":"Generator YouTube Shorts"}');
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/x-design-locales-next/it.json
const x_design_locales_next_it_namespaceObject = JSON.parse('{"Tab_Design":"Design","Button_Send":"Invia","Input_Describe_Workspace":"Descrivi la tua immagine e la creerò per te","Tab_AgentCase":"Caso Agent","Tab_RecentCreations":"Recenti","Tag_Hot":"Di tendenza","Tag_BrandDesign":"Design del brand","Tag_Logo":"Loghi","Tag_Posters":"Poster","Tab_Agent":"Agent","Tool_AiPhotoEditor":"Editor immagini","Button_Upload":"Carica","Tool_Designer":"Designer","Title_AiTool":"Strumenti AI","Tool_ImageBackgroundRemover":"Rimozione sfondo AI","Tool_AiBackgroundGenerator":"Generatore di sfondi AI","Tool_ImageEnhancer":"Migliora immagine","Tool_AiObjectsRemover":"Rimozione oggetti","Tool_AiModelMannequin":"Modello AI - Manichino","Tool_AiModelFlatlay":"Modello AI - Flat lay","Tool_AiImageRecolor":"Ricolorazione immagine AI","Tool_AiImageExtender":"Espansione immagine AI","Tool_ImageUpscaler":"Upscaler immagini AI","Tool_AiLogo":"Generatore di loghi","Button_BlankCanvas":"Crea","Sidebar_Create":"Home","Sidebar_Tools":"Strumenti AI","Sidebar_Batch":"Editor in blocco","Sidebar_MyDesigns":"I miei progetti","Sidebar_Inspire":"Ispirami","Sidebar_Brand":"Kit del brand","Sidebar_PackUp":"Chiudi la barra laterale","Tag_All":"Tutto","Tag_Design":"Design","Sidebar_Unfold":"Apri la barra laterale","Menu_Edit":"Modifica","Menu_Download":"Scarica","Menu_Delete":"Elimina","Tab_RecentlyCreated":"Recenti","Tab_GenerateRecords":"Creazioni","Menu_Total":"Totale","Menu_Total_Explain_AgentCredits":"Solo per AI Agent e verrà usato per primo.","Menu_DueToday":"Crediti bonus giornalieri","Menu_DueToday_Explain":"Valido fino a fine giornata.","Menu_Else_AgentCredits":"Altri crediti","Button_GoPro_GetMore":"Ottieni più crediti","Menu_Total_Explain_PaidCredits":"Utilizzabili per tutte le funzionalità e validi per tutta la durata dell\'abbonamento.","Menu_Pro":"Crediti dell\'abbonamento","Menu_Pro_Explain":"Valido per tutta la durata dell’abbonamento.","Menu_Else":"Altri crediti","Menu_Else_Explain_PaidCredits":"Crediti da altre fonti. Ogni tipo può avere una scadenza propria.","Menu_Else_Explain_AgentCredits":"Crediti da altre fonti. Validità più lunga.","Menu_UsageDetail":"Dettagli di utilizzo","Menu_Total_Explain_SuspendCredits":"Non disponibile finché il tuo abbonamento non viene riattivato.","Tab_Invite":"Invita","Menu_InviteReward":"Ricompensa per invito amici","Tab_Reward":"Ricompense","Title_AgentCreditForRewards":"Premi in crediti Agent:","Table_Time":"Ora","Table_Invitee":"Invitato","Title_ShareWithFriends":"Condividi con i tuoi amici","Title_ShareWithFriends_ExplainOne":"<span style=\\"color:#616266;\\">Invita un amico e riceverete entrambi </span><span style=\\"color:#2D990C;\\">${0} crediti Agent!</span>","Title_InvitationLink":"Condividi questo link con i tuoi amici","Button_Copy":"Copia","Title_Tips":"Consigli","Title_Tips_ExplainOne":"1. I Crediti Agent possono essere usati solo per accedere alle funzionalità di AI Agent. I crediti premio sono validi per due anni.","Title_Tips_ExplainTwo":"2. I nuovi amici riceveranno un premio dopo la registrazione. In caso di domande, contatta il nostro team di assistenza.","Title_GetRewarded":"Invito riuscito!","Title_GetRewarded_Explain":"I crediti possono essere usati solo per le funzionalità di AI Agent e sono validi per due anni.","Button_Ok":"Ho capito","Title_FailedToReceiveReward":"Operazione fallita","Title_FailedToReceiveReward_Explain":"In caso di domande, contatta il nostro team di assistenza.","Tool_AiBackgroundGenrator":"Generatore di sfondi AI","Title_YouCannotUseYourOwnLink":"I link privati non sono consentiti","Table_AgentCredit":"Crediti Agent","Title_ShareWithFriends_ExplainTwo":"<span style=\\"color:#616266;\\">Puoi invitare fino a </span><span style=\\"color:#2D990C;\\">${0} nuovi amici</span><span style=\\"color:#616266;\\"> e ottenere fino a ${1} crediti Agent!</span>","Button_Invite":"Invita","Menu_Title_Invite":"Invita un amico","Text_Button_Invite":"Guadagna crediti","Title_Dialog_Invite":"Invita un amico","Desc_Dialog_Invite":"Condividi il tuo link con gli amici o sui social media. Quando un amico si registra tramite il tuo link, riceverete entrambi ${0} crediti. Se sottoscrive un abbonamento, riceverete ciascuno fino a ${1} crediti extra.","Detail_Dialog_Invite":"Dettagli","Text_Copy_Invite":"Copia link","Title_Rewards_Invite":"Ricompense","SubTitle_Rewards1_Invite":"Totale crediti guadagnati","SubTitle_Rewards2_Invite":"Utenti gratuiti invitati","SubTitle_Rewards3_Invite":"Utenti paganti invitati","Success_Copy_Invite":"Link copiato","Title1_Invited_Invite":"Hai ricevuto un invito!","Text_Rule1_Invite":"Per ogni amico che si registra usando il tuo link, riceverete entrambi <strong>${0} crediti</strong>.","Text_Rule2_Invite":"Se il tuo amico si abbona, riceverete entrambi crediti extra (<strong>${0} per Plus, ${1} per Pro</strong>).","Text_Rule3_Invite":"Gli abbonamenti acquistati non possono essere rimborsati se il piano è stato utilizzato o se sono stati spesi eventuali crediti concessi. Inoltre, i crediti gratuiti non possono essere revocati una volta utilizzati.","Text_Rule4_Invite":"Ogni utente può invitare fino a ${0} amici.","Text_Rule5_Invite":"Non vengono concessi premi per inviti relativi ad account già esistenti, auto-inviti, account duplicati o attività fraudolente.","Text_Rule6_Invite":"${0} si riserva il diritto di modificare il programma e revocare i premi degli account con attività anomale.","Text_Divider_Invite":"Oppure condividi il link","Title2_Invited_Invite":"Unisciti a ${0} e riscuoti i tuoi premi","SubTitle1_Invited_Invite":"Un amico ti ha invitato a provare il nostro AI Agent professionale per brand. Crea facilmente design di marketing di alta qualità, come loghi, poster, menu e contenuti per i social media.","SubTitle2_Invited_Invite":"<strong>Iscriviti ora</strong> e sia tu che il tuo amico riceverete <strong>${0} crediti</strong>.<strong> Se ti abboni,</strong> riceverete entrambi crediti aggiuntivi in base al piano scelto (<strong>${1} crediti con Plus o ${2} crediti con Pro</strong>). Iscriviti ora per richiedere le tue ricompense.","Button_Invited_Invite":"Registrati per ottenere le tue ricompense","Success_Invited_Invite":"Ti sei registrato tramite un invito e hai ricevuto ${0} crediti.","Error_Invited_Invite":"Hai già un account.","Text_Share_Invite":"Uso ${0} per creare loghi, grafiche e video in pochissimo tempo. Iscriviti con il mio link e riceveremo entrambi crediti bonus.","Title_Share_Invite":"Unisciti a ${0} e guadagnate crediti insieme!","Share_Email_Invite":"E-mail","Text_Rule7_Invite":"Puoi usare i crediti per AI Agent. I crediti scadono dopo un mese.","Title_AgentCredits":"+50 Crediti Agent","Input_Models":"Modello","Button_TryItNow":"Provalo subito","Account_Pricing":"Prezzi","Account_Language":"Lingua","Account_Language_English":"Inglese","Account_Language_Chinese":"Cinese","Tips_Adding":"Elaborazione in corso...","Tips_Loading":"Caricamento...","Tips_Creating":"Elaborazione in corso...","Tips_Downloading":"Download in corso…","Tips_Sending":"Invio in corso…","Tips_AddSuccess":"Aggiunto con successo","Tips_MakeSameError":"Impossibile ricreare","Tips_UnsupportedGradientColor":"I gradienti non sono supportati","Tips_CanNotAdding":"Impossibile aggiungere","Tips_Uninitialized":"Impossibile inviare i messaggi","Tips_UploadFailed":"Caricamento non riuscito. Riprova.","Tips_UploadMaxCountLimit":"Carica fino a ${n} file ${type}","Tips_UploadMaxFileSize":"Impossibile caricare il file ${file}. Usa un file fino a ${n} MB.","Tips_UploadImageAndVideoLimit":"Puoi caricare 1 immagine e 1 video contemporaneamente","Tips_UnsupportedSvgFile":"I file SVG non sono supportati","Tips_UnsupportedUploadFileFormats":"Il formato del file ${files} non è supportato","Tips_CanNotAddSameFileTips":"Questo file esiste già.","Tips_TextMinLengthTips":"Inserisci almeno ${n} caratteri","Tips_TextMaxLengthTips":"Inserisci fino a ${n} caratteri. Ogni carattere cinese o emoji conta come 2.","Tips_AccessDenied":"Accesso negato","Tips_CreateFailed":"Impossibile avviare la chat","Tips_Error":"Si è verificato un errore","Tips_NotFound":"La chat non esiste.","Tips_RequestAgentModelListError":"Impossibile recuperare l\'elenco dei modelli dell\'Agent","Desc_Ended":"Fine","Button_PeopleUse_Agent":"Provato da ${n} utenti","Dropdown_AddToChat":"Aggiungi alla chat","Dropdown_AddToBrandKit":"Aggiungi al Kit del brand","Dropdown_SaveToBrandKit":"Salva come logo del brand","Dropdown_SaveToBrandTemplate":"Salva come modello del brand","Title_Design_Agent":"Design","Title_MainColor":"Colore principale","Title_SecondaryColor":"Colore secondario","Bitton_ViewTheBrandKit":"Fai clic per visualizzare il kit del brand","Dropdown_InportImages":"Importa immagini","Title_Upgrade_Pro":"Effettua l\'upgrade","Desc_SubscribeToUnlock_Pro":"Abbonati per sbloccare di più!","Desc_RunOutOfFreeUses_Pro":"Hai esaurito gli utilizzi gratuiti.","Desc_RunOutOfUsesForToday_Pro":"Hai esaurito gli utilizzi gratuiti per oggi. Torna domani.","Desc_PurchaseCompleted_Pro":"Acquisto completato","Desc_ContinueDesign_Pro":"Ora puoi continuare il tuo progetto!","Button_UnlockNow":"Abbonati","Tips_Copied":"Copiato!","Tips_Credit_Explain_Paid":"Cosa sono i crediti acquistati?","Title_Total_InactiveCredits":"Totale crediti inattivi","Title_Total_PaidCredits":"Totale crediti acquistati","Menu_SuspendCredits":"Crediti inattivi","Menu_Credits":"Crediti","Tab_RecentCreations_Agent":"Agent","Tab_RecentCreations_Design":"Strumenti smart","Menu_FunctionalPricing":"Prezzi di Agent","Title_Total_AgentCredits":"Totale - Crediti Agent","Tips_Credit_Explain_Agent":"Cosa sono i Crediti Agent?","Title_FeaturePricing":"Prezzi Agent","Tab_Category":"Categoria","Tab_TaskType":"Attività","Tab_Consume":"Prezzo (crediti)","Tab_ExampleContent":"Esempi","Tips_CreditExplain_Inactive":"Cosa sono i crediti inattivi?","langding_more_bg_remover":"Rimozione sfondo","langding_more_enhancer":"Migliora immagine","langding_more_objects_remover":"Rimozione oggetti con AI","langding_more_bg_generator":"Generatore di sfondi AI","Title_More1_Home":"Migliora immagine","Title_More2_Home":"Rimozione oggetti AI","Title_More3_Home":"Generatore di sfondi AI","Title_More4_Home":"Rimozione sfondo AI","Title_More5_Home":"Strumenti per immagini in gruppo","Title_Home":"Il tuo agente AI per il design <span>e-commerce</span>","Placeholder_Input_Home":"Descrivi la tua immagine e la creerò per te.","Title_Card4_Home":"Immagini per Amazon","Title_Card1_Home":"Immagini di prova virtuale per abbigliamento & accessori","Title_Card3_Home":"Immagini della pagina dettagli prodotto","Title_Card2_Home":"Generatore di sfondi","Desc_Features1_Home":"L\'IA estrae automaticamente le caratteristiche del prodotto e le preferenze di stile per individuare le soluzioni di design ideali.","Desc_Features2_Home":"Inserisci una sola frase e l\'AI genererà un set completo di immagini e-commerce, inclusi immagine principale, visual di supporto e una scheda prodotto completa.","Text_Btn_Home":"Inizia gratuitamente","Desc_Features3_Home":"Crea automaticamente contenuti visivi pronti per ogni piattaforma, pensati per Amazon, Etsy, TEMU, eBay e molto altro, con immagini sempre ottimizzate per attirare il pubblico giusto.","Desc_Features4_Home":"Inserisci la tua richiesta e l’AI adatterà lingua, stile, tono ed elementi culturali per creare versioni localizzate per ogni mercato di destinazione.","Desc_Features5_Home":"Salva il tuo flusso di lavoro di design come modello riutilizzabile e lascia che l\'IA generi automaticamente immagini in blocco per tutti i tuoi SKU.","Desc_Features6_Home":"Che tu stia lavorando su 10 prodotti o su 1.000, puoi creare rapidamente un set visivo completo e coerente con la massima semplicità.","Title_Qualification_Home":"Scelto da oltre 5 milioni di venditori e-commerce!","Text_Btn_Qualification_Home":"Visualizza certificazione","Title_Carousel_Home":"Altri strumenti AI","Title_Footer_Home":"Il tuo agente IA per il design e-commerce","Title_Footer1_Home":"Account social media","Subtitle_Footer1_Home":"YouTube","Subtitle_Footer2_Home":"X","Subtitle_Footer3_Home":"Instagram","Subtitle_Footer4_Home":"TikTok","Title_Footer2_Home":"Aiuto e informazioni legali","Subtitle_Footer5_Home":"Termini di servizio","Subtitle_Footer6_Home":"Informativa sulla privacy","Copyright_Footer_Home":"Copyright ${0} Meitu, Inc.","Desc_Evaluation1_Home":"Adoro Designkit! Le immagini lifestyle generate con l’IA sono naturali: accoglienti e in stile nordico, perfette per il mio negozio di candele. Le mie inserzioni hanno un aspetto più curato e le vendite sono aumentate. Ne vale la pena.","Job_Evaluation5_Home":"Venditore TEMU in Messico","Job_Evaluation6_Home":"Specialista operativo Amazon","Job_Evaluation12_Home":"Responsabile di un negozio Amazon multi-SKU in Indonesia","Job_Evaluation2_Home":"Titolare di uno store Amazon e Mercado Libre","Name_Evaluation12_Home":"Arif","Desc_Evaluation11_Home":"Le immagini con scene lifestyle sembrano davvero naturali, quasi come scattate da un professionista. Anche i miei clienti sembrano apprezzarle e ho notato un reale aumento dei tassi di conversione.","Name_Evaluation11_Home":"Siti","Job_Evaluation10_Home":"Titolare di negozio cross-border su Lazada e Shopee (Indonesia)","Name_Evaluation10_Home":"Nina","Job_Evaluation3_Home":"Designer e-commerce DTC","Job_Evaluation8_Home":"Proprietario di un negozio Walmart di prodotti per esterni negli Stati Uniti","Name_Evaluation8_Home":"Jason","Job_Evaluation9_Home":"Venditore su Mercado Libre in Argentina","Desc_Evaluation7_Home":"Le scene per prodotti per animali generate dall\'AI sono davvero adorabili! Gatti e cani hanno proporzioni perfette e un aspetto naturale. Inoltre, dimensioni e scala rispettano i requisiti delle piattaforme, quindi le immagini sono subito pronte all\'uso.","Job_Evaluation7_Home":"Proprietario di un negozio su Mercado Libre in Brasile","Desc_Evaluation8_Home":"Le scene da campeggio per le mie tende sembrano davvero realistiche. Luci e angolazioni risultano naturali, e le proporzioni sono perfette. Mi fa risparmiare tantissimo tempo rispetto a fotografare tutto da solo.","Name_Evaluation7_Home":"Thiago","Desc_Evaluation9_Home":"Lo strumento è davvero veloce e le immagini che genera si possono praticamente caricare direttamente su Mercado Libre e Amazon senza ulteriori ritocchi.","Desc_Evaluation6_Home":"Prima temevo che l\'AI rovinasse le texture dei tessuti, invece quasi non si distinguono dall\'originale. La maglieria sembra davvero maglieria, il denim resta denim e le immagini rispettano persino i requisiti di Amazon. Lanciare nuovi prodotti è diventato molto più veloce.","Name_Evaluation9_Home":"Lucas","Name_Evaluation6_Home":"Emma","Desc_Evaluation5_Home":"Le immagini dei prodotti generate dall\'AI sono davvero accurate. La lunghezza del cavo e le forme dei connettori sono perfette e rispettano anche lo stile di TEMU. Fa risparmiare tantissimo tempo rispetto a scattare le foto personalmente.","Desc_Evaluation12_Home":"Con un solo prompt ottengo subito grafiche pronte all’uso, molto più rapidamente che aspettare un designer. È davvero comodissimo.","Name_Evaluation3_Home":"Chloe","Name_Evaluation1_Home":"Sofia","Desc_Evaluation4_Home":"Le texture metalliche e i dettagli strutturali sono davvero nitidi, rendendo le immagini professionali. Posso usarle subito senza modifiche.","Name_Evaluation4_Home":"Leon","Desc_Evaluation10_Home":"La generazione in batch è comodissima. Posso elaborare decine di SKU in una volta sola, ed è molto più veloce che fare tutto manualmente come prima.","Name_Evaluation2_Home":"Mariana","Desc_Evaluation3_Home":"Vendo abbigliamento e temevo che l\'AI potesse alterare i colori o le texture dei tessuti, ma in realtà ha fatto un ottimo lavoro! Le pose dei modelli sembrano naturali e le immagini sono praticamente pronte all\'uso.","Job_Evaluation1_Home":"Specialista operations dello store SHEIN","Name_Evaluation5_Home":"Diego","Job_Evaluation11_Home":"Specialista operations Amazon","Desc_Evaluation2_Home":"Lo strumento è velocissimo e le immagini sono praticamente pronte da caricare su Mercado Libre o Amazon. Adatta persino sfondi e modelli ai gusti locali, con risultati davvero professionali.","Job_Evaluation4_Home":"Venditore eBay in Germania","Title_Evaluation_Home":"Le loro storie","Title_Introduction_Home":"Design AI premium che fa crescere le vendite","Desc_Qualification_Home":"Fornitore di servizi certificato Amazon SPN","Title_Seo_Home":"Generatore AI di immagini e video prodotto per e-commerce","Desc_Seo_Home":"Genera istantaneamente immagini di prodotto, poster e video per Amazon, TikTok e molti altri negozi online con l\'Agente AI di Designkit. Inizia a progettare gratis oggi stesso!<br>","Keywords_Seo_Home":"Agente AI per E-commerce, Strumenti AI per E-commerce, Generatore AI di Immagini Prodotto, Generatore AI di Video Prodotto, Editor AI di Foto Prodotto, Rimozione Sfondo AI","Title_Features1_Home":"Da una sola richiesta a un set completo di contenuti visivi","Title_Features2_Home":"Localizzazione completamente automatizzata per vendere i tuoi prodotti a livello globale su più piattaforme","Title_Features3_Home":"Genera automaticamente immagini in blocco per più SKU e arriva sul mercato prima dei concorrenti!","Title_Designkit_Home":"Designkit","Tips_AboveTheFold2_Home":"Scorri per esplorare","Tips_Material1_Home":"Set di immagini per inserzione","Tips_Material2_Home":"Prova virtuale","Tips_Material3_Home":"Contenuto A+","Tips_Material4_Home":"Generatore di sfondi","Free_Button_Home":"Prova gratis","Title_Header1_Home":"Prodotto","Title_Header2_Home":"Soluzione","Title_Header3_Home":"Ispirazione","Title_Header4_Home":"Impara","Title_Header5_Home":"Prezzi","SecondTitle_Header1_Home":"Agente AI per e-commerce","SecondTitle_Header2_Home":"Strumenti AI per immagini","SecondTitle_Header3_Home":"Strumenti AI per video","SecondTitle_Header4_Home":"Soluzione di design per Amazon","SecondTitle_Header5_Home":"Soluzione e-commerce per social media","SecondTitle_Header6_Home":"Generatore di immagini prodotto AI","SecondTitle_Header7_Home":"Generatore di modelli AI per la moda","SecondTitle_Header8_Home":"Cambia colore dei vestiti","SecondTitle_Header9_Home":"Generatore di video per prodotti","SecondTitle_Header10_Home":"Strumenti AI","SecondTitle_Header11_Home":"Editor di foto AI","SecondTitle_Header12_Home":"Editor di foto AI online","SecondTitle_Header13_Home":"Editor di foto in blocco","SecondTitle_Header14_Home":"Editor di foto AI in blocco","SecondTitle_Header15_Home":"Ottimizzatore immagini in batch","SecondTitle_Header16_Home":"Rimozione filigrana in batch","SecondTitle_Header17_Home":"Generatore di sfondi in batch","SecondTitle_Header18_Home":"Rimozione dello sfondo in gruppo","Title_Footer3_Home":"Strumenti di design","Subtitle_Footer8_Home":"Editor di foto AI","Subtitle_Footer7_Home":"Cambia sfondo AI","Subtitle_Footer9_Home":"Sfondo trasparente","Subtitle_Footer10_Home":"Cambia colore dello sfondo","Subtitle_Footer11_Home":"Rimozione filigrana da immagini","Subtitle_Footer12_Home":"Rimuovi testo dall\'immagine","Subtitle_Footer13_Home":"Aggiungi adesivi alle foto","Subtitle_Footer14_Home":"Aggiungi una filigrana alle foto","Title_Footer4_Home":"Modelli di immagini","Subtitle_Footer15_Home":"Nano Banana Pro (Gemini 3.0 Pro)","Title_Footer5_Home":"Scarica gratuitamente","Subtitle_Footer16_Home":"App iOS","Subtitle_Footer17_Home":"App Android","Title_Footer6_Home":"Seguici","Subtitle_Footer18_Home":"Kling 3.0","Subtitle_Footer19_Home":"Seedance 2.0","Title_Footer7_Home":"Modelli video","Button_Export":"Scarica","Title_Layer":"Livelli","InputNumber_Opacity":"Opacità","Buttom_Comfirm":"Conferma","Button_Share":"Condividi","Button_Delete":"Elimina","Title_LoginPopup":"Accedi per iniziare la prova","SubTitle_LoginPopup":"Inizia a creare con Zawa oggi","Tip_ModalTitle":"Attenzione","TipContent_HistoryDelete":"Una volta eliminato, questo record non potrà essere ripristinato. Confermi l\'eliminazione?","Title_Logo":"Logo","Title_BrandKit":"Template","Tab_BrandKit":"Kit della marca","Tab_UploadLocal":"Seleziona dall\'album","Button_UploadImage":"Carica immagini","Button_UploadProductImage":"Carica immagine prodotto","Button_UploadReferImage":"Carica riferimenti","Tip_ClickDragParseImage":"Carica, trascina o incolla qui le immagini.","Tip_UploadMax":"Carica file JPG, JPEG o PNG fino a ${0} MB, per un massimo di N immagini.","Tooltip_SwitchBrandKit":"Cambia kit di marca","Discribe_BrandKitSelect":"Seleziona uno stile del brand come riferimento per questo design.","Title_Models":"Modelli","Switch_Auto":"Auto","Tab_Image":"Immagine","Tab_Video":"Video","MenuItem_AddToBrandLogo":"Salva come logo del brand","MenuItem_AddToBrandTemplate":"Salva come modello del brand","Button_ExportImage":"Importa immagini","Button_ExportMedia":"Importa video","Button_ExportFromBrandkit":"Importa dal Brand Kit","Dropdown_AddFromBrandkit":"Aggiungi dal Kit del brand","Placeholder_ChatInput":"Iniziamo!","MenuItem_AiChange":"Modifica dell\'IA","MenuItem_AiExpend":"Estensione AI","MenuItem_AiHD":"Chiarezza AI","MenuItem_Eliminate":"Rimozione AI","MenuItem_SplitLayers":"Dividi livelli","MenuItem_Cutout":"Rimuovi sfondo","MenuItem_ChangeText":"Modifica testo","MenuItem_Crop":"Dimensione immagine","MenuItem_AddToChat":"Aggiungi alla chat","MenuItem_AddToBrand":"Aggiungi al Brand Kit","Tooltip_Layer":"Livelli","Tooltip_Grab":"Strumento mano","Tooltip_Select":"Seleziona","Tooltip_Redo":"Rifare","Tooltip_Undo":"Annulla","Tooltip_Add":"Aggiungi","Tooltip_ShowAll":"Mostra tutto","Tip_UploadType":"Formato file non supportato","Tip_UploadSize":"Sono supportati solo file fino a ${0} MB.","Tip_UploadWH":"Assicurati che ogni immagine non superi ${0}×${1} pixel","Tip_UploadTypeTranslate":"Impossibile modificare il formato del file","Tip_UploadFail":"Caricamento non riuscito","Tooltip_AddText":"Aggiungi testo","Text_AddDefault":"Questo è un testo di esempio.","Tooltip_OverflowImageSize":"Ridimensiona l\'immagine entro ${0} pixel","Placeholder_ImageFusion":"Dimmi come vuoi fondere le immagini","Button_ImageFusion":"Miscela","Button_Cancel":"Annulla","Button_AiChange":"Modifica","Placeholder_AiChange":"Dimmi cosa vuoi modificare","Button_Eliminate":"Gomma","Label_OriginSize":"Originale","Label_CropRadio":"Proporzioni","Button_Free":"Gratuito","Button_Origin":"Originale","Button_Crop":"Ritaglia","Placeholder_ChangeText":"Inserisci il testo. Esempio: Ciao","Button_ChangeText":"Conferma","InputNumber_PanSize":"Dimensione del pennello","Label_TargetSize":"Target","Tooltip_ImageFusion":"Puoi fondere da ${0} a ${1} immagini","Title_Workspace":"Il tuo agente IA\\nper contenuti social","Button_Pro":"Ottieni Pro gratis","Title_NanoPro":"🍌🍌Nano Banana Pro è ora disponibile su Zawa.","Dropdown_AdvancedFeatures_Title":"Funzioni avanzate","Dropdown_AdvancedFeatures_Conent":"Accesso completo a tutti gli strumenti con IA per lavorare in modo più efficiente.","Dropdown_MassiveContent_Title":"Ampia gamma di contenuti","Dropdown_MassiveContent_Content":"Accesso illimitato a template premium e a una vasta gamma di risorse stock Plus.","Dropdown_CommercialRights_Title":"Diritti commerciali","Dropdown_CommercialRights_Content":"Usa le tue creazioni personali in tutta sicurezza, con protezione del copyright garantita.","Popup_SubscribeIntl_Desc":"Ottieni il massimo da Zawa con Pro","Popup_SubscribeIntl_Desc1":"Sblocca altre creazioni con i crediti","Popup_SubscribeIntl_Detail":"Visualizza i dettagli del piano e l’aiuto","Popup_StripeCheckout":"Checkout Stripe","Popup_LiveSupport":"Assistenza live","Popup_CancelAnytime":"Annullabile in qualsiasi momento","Menu_Language":"Lingua","Menu_ManageSubscription":"Gestisci gli abbonamenti","Menu_TermsPolices":"Termini e informative","Menu_ManageSubscriptions":"Gestisci gli abbonamenti","Menu_ReferralLink":"Link di invito","Menu_BenefitsUpgraded":"Vantaggi","Menu_TermsPolicies":"Termini e informative","Menu_AccountManagement":"Account","Title_ReferralCode":"Codice di invito","Title_ReferralLink":"Link di invito","Desc_NoActiveSubscription":"Nessun abbonamento attivo","Button_ClickToSubscibe":"Clicca qui per abbonarti","Title_SubscriptionCancel":"Il tuo abbonamento è stato annullato","Title_SeeYou":"Ci dispiace vederti andare via...😭","Desc_NextBillingDate":"Si rinnova il","Desc_EstimatedAmount":"Totale stimato","Button_CancelSubscription":"Annulla abbonamento","Button_StaySubscribed":"Mantieni l\'abbonamento","Title_ReasonCancelling":"Seleziona un motivo per l\'annullamento:","Desc_BenefitsContinue":"Potrai comunque usufruire dei vantaggi dell\'abbonamento fino alla scadenza.","Desc_GiftedCredits":"Dopo la scadenza dell\'abbonamento, i crediti omaggio","Desc_SeeYou":"Grazie per averci scelto. Ci dispiace vederti andare via.","Desc_NoNoreCharges":"Non ti verrà addebitato alcun costo e il tuo abbonamento resterà attivo fino al","Desc_MayBeRevoked":"Potrebbero essere revocati.","Desc_CancelingNoRefund":"La cancellazione <span>non include un rimborso<span>. Per richieste di rimborso, contatta l\'assistenza online.","Button_ClearSelection":"Deseleziona","Button_Confirm":"Conferma","Message_Processing":"Elaborazione in corso...","Title_Opacity":"Opacità","Button_ExpandImage":"Estensore di immagini","Button_ExpandRadio":"Proporzioni","Title_NoDesigns":"Ancora nessun design.","Title_NoGenerations":"Ancora nessuna generazione.","Desc_NoDesigns":"I tuoi progetti appariranno qui.","Desc_NoGenerations":"Le tue generazioni appariranno qui.","Title_DeleteDesign":"Elimina questo design","Popup_DeleteDesign":"Vuoi eliminare definitivamente questo progetto? Questa azione non può essere annullata.","Message_SaveFail":"Impossibile salvare","Title_Pricing":"Scegli il piano giusto per te","Title_Tags1_Pricing":"Mensile","Text_Discount_Pricing":"${0} di sconto","Title_Tags2_Pricing":"Annuale","Title_Plan1_Pricing":"Gratuito","Current_Plan_Pricing":"Piano attuale","Title_Instruction1_Pricing":"Ottieni 20 crediti al primo accesso","Title_Instruction2_Pricing":"Genera fino a 20 immagini con AI Agent","Title_Instruction3_Pricing":"Genera fino a 10 immagini con il Generatore di sfondi AI","Title_Rights1_Pricing":"Rimozione limitata di sfondi o oggetti","Title_Rights3_Pricing":"Ottimizzazione HD delle immagini limitata","Title_Plan2_Pricing":"Piano Base","Month_Plan_Pricing":"Mese","Title_Button1_Pricing":"Abbonati","Title_Instruction4_Pricing":"500 crediti/mese","Title_Instruction5_Pricing":"Genera fino a 500 immagini con AI Agent","Title_Instruction6_Pricing":"Genera fino a 250 immagini con il Generatore di sfondi AI","Title_Plan3_Pricing":"Piano Pro","Desc_Plan_Pricing":"Prova gratuita di 7 giorni. Poi ${0}/anno.","Title_Button2_Pricing":"Prova gratuita di 7 giorni","Title_Instruction7_Pricing":"1.500 crediti/mese","Title_Instruction8_Pricing":"Genera fino a 1.500 immagini con AI Agent","Title_Instruction9_Pricing":"Genera fino a 750 immagini con il Generatore di sfondi AI","Title_Rights4_Pricing":"Rimozione illimitata di sfondi o oggetti","Title_Rights5_Pricing":"Uso illimitato della funzione Rimozione AI","Title_Rights6_Pricing":"Ottimizzazione illimitata delle immagini Ultra HD","Title_Rights7_Pricing":"Strumenti di elaborazione in gruppo","Title_Best_Pricing":"Scelto dal 90% degli utenti","Title_AllFeatures_Pricing":"Confronta i piani gratuiti e a pagamento","Desc_AllFeatures_Pricing":"Sblocca Premium per creare design straordinari senza sforzo con strumenti IA avanzati","Month_AllFeatures_Pricing":"Mese","Title_Features1_Pricing":"AI Agent","SubTitle_Features1_Pricing":"Modifica immagini","SubTitle_Features15_Pricing":"Genera fino a ${0} immagini","SubTitle_Features16_Pricing":"Genera fino a ${0} immagini/mese","SubTitle_Features2_Pricing":"Generazione di immagini","SubTitle_Features3_Pricing":"Generazione di immagini per e-commerce","SubTitle_Features4_Pricing":"Generazione di poster","Title_Features2_Pricing":"Strumenti AI per immagini","SubTitle_Features5_Pricing":"Rimozione sfondo AI","SubTitle_Features17_Pricing":"Uso limitato","SubTitle_Features19_Pricing":"Uso illimitato","SubTitle_Features6_Pricing":"Rimozione oggetti AI","SubTitle_Features7_Pricing":"Ottimizzatore immagini","SubTitle_Features18_Pricing":"Utilizzo limitato (HD)","SubTitle_Features20_Pricing":"Uso illimitato (HD/UHD)","SubTitle_Features8_Pricing":"Upscaler immagini AI","SubTitle_Features9_Pricing":"Estensione immagine AI","SubTitle_Features10_Pricing":"Generatore di sfondi AI","Title_Features3_Pricing":"Altre funzionalità di design","SubTitle_Features11_Pricing":"Funzioni avanzate e template","SubTitle_Features12_Pricing":"Rimuovi filigrana","SubTitle_Features13_Pricing":"Strumenti AI per immagini in blocco","SubTitle_Features14_Pricing":"Funzioni di design di base","Title_Credits_Pricing":"A corto di crediti? Ci pensiamo noi.","Desc_Credits_Pricing":"Acquisto una tantum, senza abbonamento.","TransactionPrice_Credits_Pricing":"Prezzo: ${0}","Credit_Credits_Pricing":"Crediti","Popular_Credits_Pricing":"Più popolare","Buy_Credits_Pricing":"Acquista ora","Title_FAQ_Pricing":"DOMANDE FREQUENTI","Title_Button4_Pricing":"Aggiorna ora per una prova gratuita di 7 giorni","SubTitle_FAQ1_Pricing":"Cosa sono i crediti?","Content_FAQ1_Pricing":"I crediti ti consentono di continuare ad accedere agli strumenti AI. Il numero di crediti necessari varia in base allo strumento specifico.","Content_FAQ2_Pricing":"I crediti acquistati sono validi per un anno.","Content_FAQ3_Pricing":"I crediti dell\'abbonamento sono validi per tutta la durata dell\'abbonamento.","SubTitle_FAQ2_Pricing":"Come posso annullare l\'abbonamento e cosa succede ai miei crediti dopo l\'annullamento?","Content_FAQ4_Pricing":"Dopo aver annullato l\'abbonamento,","Content_FAQ5_Pricing":"I crediti inclusi nell’abbonamento resteranno validi fino alla scadenza dell’abbonamento. Eventuali crediti acquistati separatamente non subiranno modifiche.","Content_FAQ6_Pricing":"Se devi annullare l\'abbonamento, segui i passaggi qui sotto almeno 24 ore prima dell\'inizio del prossimo ciclo di fatturazione:","Content_FAQ7_Pricing":"Vai su Designkit e accedi.","Content_FAQ8_Pricing":"2. Apri la finestra pop-up dell’abbonamento.","Content_FAQ9_Pricing":"3. Seleziona \\"Gestisci gli abbonamenti\\".","Content_FAQ10_Pricing":"4. Seleziona il tuo piano attuale e fai clic su \\"Annulla abbonamento\\".","Content_FAQ11_Pricing":"Il tuo abbonamento resterà attivo fino alla fine del ciclo di fatturazione corrente. Se non riesci ad annullarlo, fai uno screenshot e contatta il nostro supporto online il prima possibile.","SubTitle_FAQ3_Pricing":"Qual è la politica di rimborso?","Content_FAQ12_Pricing":"1. Garanzia di rimborso entro 7 giorni:","SubTitle_FAQ4_Pricing":"Come posso passare a un piano superiore o inferiore?","Content_FAQ25_Pricing":"1. Upgrade: Puoi semplicemente abbonarti a un piano di livello superiore, che verrà attivato immediatamente. Il tuo abbonamento precedente sarà annullato e l\'eventuale saldo residuo verrà rimborsato.","SubTitle_FAQ5_Pricing":"Posso ottenere una copia della mia fattura?","Content_FAQ27_Pricing":"Sì! Dopo il pagamento, riceverai un\'e-mail dal provider di pagamento con la fattura elettronica. Se non ricevi la fattura, contatta il nostro team di supporto.","SubTitle_FAQ6_Pricing":"Quali metodi di pagamento supportate?","Content_FAQ28_Pricing":"Utilizziamo Stripe per gestire pagamenti e abbonamenti. Accettiamo tutte le principali carte di credito, PayPal e Google Pay.","SubTitle_FAQ7_Pricing":"Come posso contattare l\'assistenza?","Content_FAQ29_Pricing":"E-mail: support@designkit.com. Tempo di risposta: 3-10 giorni lavorativi.","Content_FAQ13_Pricing":"Se hai acquistato un abbonamento e non lo hai utilizzato entro 7 giorni, potresti avere diritto a un rimborso completo.","Content_FAQ14_Pricing":"Se hai acquistato crediti, potresti avere diritto a un rimborso per eventuali crediti non utilizzati entro 7 giorni.","Content_FAQ15_Pricing":"2. Insoddisfazione per il servizio","Content_FAQ16_Pricing":"Se non sei soddisfatto dei risultati, contatta il nostro team di assistenza online. In base alle circostanze, potremmo offrire un indennizzo o un rimborso.","Content_FAQ17_Pricing":"3. Acquisti tramite Google Play o App Store","Content_FAQ18_Pricing":"Se hai sottoscritto l\'abbonamento tramite Google Play Store o App Store, devi richiedere il rimborso direttamente a Google o Apple.","Content_FAQ19_Pricing":"Note importanti:","Content_FAQ20_Pricing":"La presente politica di rimborso non si applica agli utenti API. Se utilizzi la nostra API, contattaci per verificare l\'idoneità al rimborso.","Content_FAQ21_Pricing":"Ci riserviamo il diritto di rifiutare i rimborsi in caso di uso improprio, abuso o violazione dei nostri termini.","Content_FAQ22_Pricing":"L\'elaborazione dei rimborsi può richiedere diversi giorni lavorativi, a seconda del metodo di pagamento.","Content_FAQ23_Pricing":"Potremmo aggiornare periodicamente la presente politica di rimborso. Ti invitiamo a consultarla regolarmente per eventuali modifiche.","Content_FAQ24_Pricing":"Per ulteriore assistenza, contatta il nostro team di assistenza.","Content_FAQ26_Pricing":"2. Passaggio a un piano inferiore: Annulla prima l\'abbonamento attuale. Al termine del periodo di fatturazione corrente, sottoscrivi un nuovo piano.","Content_Modal_Pricing":"Grazie per il tuo supporto! Preparati a portare la tua creatività al livello successivo.","Tip_Modal_Pricing":"Suggerimento: Se il tuo abbonamento non viene ancora visualizzato, aggiorna la pagina.","Title_Modal_Pricing":"Acquisto riuscito","Title_Rights2_Pricing":"Uso limitato della funzione Rimozione AI","Title_Button3_Pricing":"Vantaggi disponibili","Title_Button5_Pricing":"Aggiorna","Tool_ImageBgRemover":"Rimozione sfondo","Tool_AiBgGenerator":"Generatore di sfondi AI","Tool_AiLogoGenerator":"Generatore di loghi","Tool_FootwearModel":"Modello di calzature","Tool_ImageTranslation":"Traduzione immagini","Tool_BatchImageBgRemover":"Rimozione sfondo immagini in batch","Tool_BatchImageEnhancer":"Miglioramento immagini in gruppo","Tool_BatchAiObjectsRemover":"Rimozione oggetti in batch","Tool_VideoEnhancer":"Ottimizzatore video AI","Tool_VideoBgRemover":"Rimozione sfondo video","Tool_VideoWatermarkRemover":"Rimozione filigrana video","Title_Models_Dropdown":"Modelli","Tips_Uninitialized_Chat":"Impossibile inviare i messaggi","Dropdown_AddImage":"Aggiungi immagine","Action_SeeAll":"Vedi tutto","Desc_Seedream":"Creazione di immagini realistiche e dettagliate.","Dropdown_AddVideo":"Aggiungi video","Tips_NotFound_Chat":"La chat non esiste.","Desc_Seedance":"Creazione di video realistici ed espressivi.","Dropdown_SupportedFormatFile":"Supporta file Word, Excel, di testo e PDF.","Dropdown_Example_Option":"Esempio","Dropdown_NoReference_Option":"Nessun riferimento disponibile","Menu_AgentCredits":"Crediti Agent","Desc_SeedEdit":"Modifica delle immagini precisa e naturale.","Dropdown_BrandKit_Title":"Kit del Marchio","Desc_GeminiNanoBanana":"Generazione di immagini rapida, modificabile e coerente.","Dropdown_Models_Title":"Modelli","Dropdown_AddDocument":"Aggiungi documento","Dropdown_BrandKit_Desc":"Seleziona uno stile del brand come riferimento per questo design.","Desc_MidjourneyVideo":"Generazione video creativa e artistica.","Desc_MidjourneyImage":"Generazione di immagini artistiche e fantasiose.","Dropdown_SaveAsBrandTemplate":"Salva come modello del brand","Dropdown_SaveAsBrandLogo":"Salva come logo del brand","BatchProcessTable_ImageType":"Tipo di immagine","BatchProcessTable_PictureRequirement":"Dettagli del design","BatchProcessTable_CopywritingRequirements":"Descrizione del prodotto","BatchProcessTable_Proportion":"Proporzioni","BatchProcessTable_Actions":"Azione","BatchProcessTable_AddOneRow":"Aggiungi","BatchProcessList_DeleteError":"Eliminazione non riuscita","BatchProcessList_SurePrompt":"Eliminare questa linea guida?","BatchProcessList_SurePrompt_SureText":"Conferma","BatchProcessList_SurePrompt_CancelText":"Annulla","BatchProcessList_EmptyText":"Vuoto","EditBatchProcess_NameLimitTip":"Inserisci un nome (max 10 caratteri)","EditBatchProcess_Tip":"Qualsiasi modifica alle linee guida influirà sui risultati generati.","EditBatchProcess_Start":"Inizia con una linea guida","EditBatchProcess_GenerateTip":"Carica le immagini del tuo prodotto e i design verranno generati in base alle linee guida.","Text_AdvanceSetting":"Esperto","Text_MainImage":"Immagine principale","Text_ProductAgentUploadGuide1":"1. Carica più immagini dello stesso prodotto da diverse angolazioni per aiutare l\'AI a cogliere meglio i dettagli del prodotto.","Text_ProductAgentUploadGuide2":"2. Fino a 10 immagini. La prima immagine verrà usata come riferimento principale, quindi scegli l\'angolazione migliore.","Text_Optional":"(Facoltativo)","Tip_ClickDragImageWithSize":"Carica o trascina immagini JPEG, JPG o PNG fino a ${0} MB.","Button_AddReferenceImage":"Carica","Title_ReferenceImage":"Riferimento","Input_Placeholder":"Seleziona","Radio_ReferenceColor":"Colore di riferimento","Radio_ReferenceLayout":"Layout di riferimento","Tag_FirstImage":"Prima immagine","Tag_FirstImageNoPartial":"Prima immagine parziale","Tag_Blur":"Sfocata","Tag_Jigsaw":"Collage","Button_Understood":"Ho capito","Text_ReferenceImageIndex":"L\'immagine ${0} è solo di riferimento","Text_ReferenceDimensions":"Usa ${0} del riferimento","Tag_Cropped":"Ritagliata","Tag_Underexposed":"Sottoesposta","Tag_Blurry":"Sfocata","SelectOption_ColorPalette":"Palette colori","SelectOption_Layout":"Layout","SelectOption_Fonts":"Caratteri","SelectOption_Style":"Stile","SelectOption_ShapeElements":"Elementi di forma","Text_SocialMediaAgentUploadGuide":"Carica prima il prodotto in evidenza. Assicurati che l\'immagine sia chiara e completa.","Video_SR_Success":"Nitidezza del video migliorata","Video_Desubtitle_Success":"Sottotitoli rimossi","Video_Dewatermark_Success":"Filigrana rimossa","Video_Process_Failed":"Elaborazione non riuscita. I crediti saranno riaccreditati sul tuo account.","Video_SR":"Chiarezza AI","Video_Dewatermark":"Rimuovi filigrana","Video_Desubtitle":"Rimuovi sottotitoli","Video_Task_Price_Estimate":"Richiesti ${0} crediti","Video_SR_Start":"Miglioramento della nitidezza... Verranno usati ${0} crediti.","Video_Dewatermark_Start":"Rimozione filigrane... Verranno usati ${0} crediti.","Video_Desubtitle_Start":"Rimozione dei sottotitoli... Verranno utilizzati ${0} crediti.","Video_Desubtitle_Start_VIP":"Rimozione dei sottotitoli...","Video_Dewatermark_Start_VIP":"Rimozione filigrane...","Video_SR_Start_VIP":"Miglioramento della chiarezza...","Text_Help_Center":"Centro assistenza","Title_Request":"Chat","Button_Continue":"Continua","Button_EditContent":"Modifica messaggio","Title_ChooseImageType":"Seleziona il tipo di immagine generata (Opzioni multiple)","Button_BatchGenerate":"Confermato. Esegui subito il modello.","Text_ChatCancelStatus":"Attività terminata","Text_ChatRespondedStatus":"Elaborazione attività in corso","BatchProcess_SaveSuccessTip":"I tuoi kit di workflow vengono salvati qui.","Button_GotIt":"Ho capito","Title_Congrats":"Congratulazioni!","SubTitle_BrandCreate":"Hai creato il tuo primo kit del brand: è il momento di scoprirne il potenziale!","Button_CheckUse":"Dai un\'occhiata ora","Chat_Prompt_Brand":"Crea un poster promozionale","Tooltip_UseBrand":"Qui puoi cambiare o aggiungere il tuo kit del brand!","Tooltip_PosterBrand":"Tocca per creare il tuo primo poster con il tuo kit del brand","Popup_CreateBrand":"Crea un brand da zero","Desc_CreateBrand":"Crea loghi originali e straordinari con il nostro Agente IA.","Popup_UploadBrand":"Carica le informazioni del tuo brand","Desc_UploadBrand":"Caricalo e Zawa manterrà ogni design coerente.","Title_BrandEntry":"Ottieni subito un sistema di brand su misura","Desc_BrandEntry":"Lascia che la nostra IA sia la tua consulente di stile. Rispondi a poche domande e ricevi un sistema di brand completo, su misura per la tua visione.","Tooltip_UseBrand_Agent":"Una volta applicato il kit del brand, il progetto userà automaticamente logo, palette colori e stile generale.","Tooltip_PosterBrand_Agent":"È tutto pronto per creare con il tuo kit del brand","BatchProcess_createText":"Kit per workflow","Label_NormalMode":"Base:","Label_AdvancedMode":"Avanzato:","Text_NormalMode":"Base","Text_AdvancedMode":"Avanzata","BatchProcess_DefaultPrompt":"Genera immagini","Title_CreateBrand":"Non hai un brand?","Title_UploadBrand":"Hai già un logo?","Button_CreateBrand":"Crea un brand","BatchProcess_EditContent":"Modifica contenuto","BatchProcess_PleaseSelect":"Seleziona un kit di workflow","BatchProcess_SelectTip":"Tutte le immagini caricate verranno generate in batch usando il kit di workflow selezionato.","BatchProcess_ListEmptyTip":"Salva il kit di workflow dopo la generazione per creare subito set simili in batch.","BatchProcess_Tip":"Kit workflow","BatchProcess_Generate":"Usalo ora","BatchProcess_Save":"Salva","BatchProcess_GeneratingFormula":"Generazione del kit del workflow...","BatchProcess_GenerateCancel":"Annulla","BatchProcess_WorkFlowCreateError":"Creazione non riuscita","ProductInfo_PleaseUploadImage":"Carica immagini dei prodotti","BatchProcess_IntelligenceGenerate":"Crea kit di workflow","BatchProcess_CreateWorkflow":"Crea","BatchProcess_Formula":"Kit workflow","BatchProcess_WorkFlowSaveSuccess":"Kit del workflow salvato","ProductInfo_ImageSizeLimit":"Sono supportate immagini fino a ${0} MB","ProductInfo_ImageUpload":"Aggiungi immagine prodotto","ProductInfo_UploadDemo":"Foto di esempio","ProductInfo_ECPlatform":"Piattaforma","ProductInfo_PleaseSelect":"Seleziona","ProductInfo_InputCustomize":"Personalizzato","ProductInfo_CountryAndLanguage":"Regione/lingua di destinazione","ProductInfo_Name":"Nome del prodotto","ProductInfo_Desc":"Dettagli del prodotto (Caratteristiche/Dimensioni/Scenari d\'uso)","ProductInfo_DescPlaceholder":"Inserisci le informazioni sul prodotto, come caratteristiche, dimensioni, scenari d\'uso, pubblico di riferimento, ecc.","ProductInfo_NamePrompt":"Il nome del prodotto è ${0};","ProductInfo_ECPlatformPrompt":"La piattaforma di destinazione è ${0};","ProductInfo_CountryAndLanguagePrompt":"La lingua è ${0};","ProductInfo_DescPrompt":"I dettagli del prodotto sono ${0}.","ProductInfo_PleaseInput":"Inserisci","Button_UnlockPro":"Sblocca Pro","Button_UpgradeToPro":"Passa a Pro","Button_RenewNow":"Rinnova ora","AgentEmpty_CaseUseBtn":"Utilizza","AgentEmpty_CaseRefreshBtn":"Ricarica","MenuItem_Effect":"Effetti","MenuItem_Shadow":"Ombre","MenuItem_Stroke":"Contorno","Title_ChangeText":"Sostituisci testo","Button_Logout":"Esci","Message_ExtractText":"Estrazione del testo","Message_ExtractTextError":"Impossibile estrarre il testo. Riprova.","Tip_CreditConsume":"Questa generazione usa ${0} crediti","Tip_EstimatedTime":"Pronto tra circa ${0} minuti","BatchProcess_SaveSuccessTip_GotIt":"Ho capito","BatchProcess_SaveSuccessTip_Title":"Utilizzo dei kit di workflow","BatchProcess_SaveSuccessTip_Desc":"I tuoi kit di workflow vengono salvati qui. Scegline uno per generare rapidamente immagini usando i modelli salvati.","BatchProcess_tutorial":"Tutorial","Text_HandTool":"Strumento mano","Text_Function":"Funzione","Text_WindowsSystem":"Sistema Windows","Text_MacSystem":"Sistema Mac","Menu_KeyboardShortcuts":"Scorciatoie","Title_KeyboardShortcuts":"Scorciatoie da tastiera","Text_Undo":"Annulla","Text_MouseLeft":"Pulsante sinistro del mouse","Text_Redo":"Ripeti","Text_Delete":"Elimina","Text_Cut":"Taglia","Text_Copy":"Copia","Text_Paste":"Incolla","Text_PasteFixed":"Incolla in posizione","Text_CreateCopy":"Crea una copia","Text_SelectAll":"Seleziona tutto","Text_SelectMultiple":"Selezione multipla","Text_Group":"Raggruppa","Text_Ungroup":"Separa","Text_LockLayer":"Blocca","Text_Save":"Salva","Text_Move":"Sposta","Text_MoveWithCombinedKeys":"Spostamento rapido","Text_TouchEditFastMode":"Modifica rapida con puntatore","Text_Pan":"Panoramica","Title_Canvas":"Tela","Title_Edit":"Modifica","Title_Elements":"Elementi","Title_Tools":"Strumenti","Title_Blogs":"Blog","Text_NewText":"Nuovo testo","Text_NewLine":"Nuova linea","Text_NewRectangle":"Nuovo rettangolo","Text_NewCircle":"Nuovo cerchio","Text_ExitFullScreen":"Esci da schermo intero","Text_MoveUpOneLayer":"Porta avanti","Text_MoveDownOneLayer":"Manda indietro","Text_Top":"Porta in primo piano","Text_Bottom":"Porta in fondo","Text_CanvasZoom":"Aumenta zoom/Riduci zoom","Text_ToggleReferenceLine":"Mostra/nascondi guide","Text_ToggleRulerBar":"Mostra/nascondi righelli","Text_ArrowKey":"Tasti freccia","Text_CanvasShowAll":"Mostra tutta la tela","Title_Unsupported_Multilayer":"Questa funzione è disponibile solo per un singolo livello.","Btn_CreateBatchProcessFormula":"Crea","Button_Hide_Otherlayers":"Mantieni il primo livello e continua","Button_Merge_Alllayers":"Unisci tutti i livelli e continua","Checkbox_Disable_Remind":"Non mostrare più","Button_Tool":"Strumenti","Button_Custom_Ratio":"Personalizzato","Label_Spacing":"Spaziatura","Button_Download_Whole":"Esporta come immagine","Button_Download_Layer":"Esporta per livello","Button_Origin_Ratio":"Originale","Text_TouchEdit_Title":"Indica e modifica","Text_TouchEdit_Description":"Indica un oggetto e descrivi le modifiche. L\'immagine verrà modificata esattamente come indicato.","Tooltip_TouchEdit_Max_Count":"Puoi indicare fino a ${0} aree","Tooltip_TouchEdit_Usage":"Scorciatoia Indica e modifica: ${0} + clic","Text_TouchEdit_Recognition_Custom":"Personalizzato","Text_TouchEdit_Recognition_Title1":"Rileva e riconosci","Text_TouchEdit_Recognition_Title2":"Nessun oggetto trovato. Inserisci il nome dell\'oggetto.","Text_TouchEdit_Name":"Indica cosa modificare","Btn_LoginToViewBatchProcess":"Accedi per visualizzare il kit workflow","Btn_Login":"Accedi","Menu_Main_Beautify":"Rifinisci","Text_Model_Pricing":"Prezzi del modello","Text_Pro_discount":"Piano Pro: generazione video a metà prezzo","Text_TemplatePrompt":"Iniziamo dalle ispirazioni","Text_Hi":"Ciao, ${0}!","Text_Account_Popup_Left":"Scopri il tuo assistente AI per il design dedicato all\'e-commerce. Pensato per professionisti che desiderano lanci più rapidi, presentazioni di maggiore impatto e una maggiore redditività.","Text_PleaseWaitImageUploaded":"Procedi al termine del caricamento","Menu_Redeem_Rights":"Riscatta","Text_Redeem_Now":"Riscatta ora","Text_Redeem_Placeholder":"Inserisci il codice di riscatto, rispettando maiuscole e minuscole","Text_Redeem_Success":"Riscattato con successo!","Text_Redeem_Use":"Riscatta il tuo codice","Tooltip_BrandAutoUse":"Il tuo nuovo kit del brand è stato applicato!","Redeem_Redeem_Note":"Nota: \\nEffettua l\'accesso e inserisci il codice di riscatto.\\nUna volta completato il riscatto, potrai usufruire dei vantaggi e dei servizi corrispondenti.\\nUsa il codice di riscatto entro il periodo di validità. I codici scaduti non saranno più validi e non sono rimborsabili.\\nCustodisci il tuo codice. Non siamo responsabili di codici smarriti, divulgati o usati in modo errato. \\nQuesto codice non può essere rivenduto o trasferito, non può essere convertito in denaro e non dà diritto all\'emissione di fattura.","Tooltip_Color_Fill":"Colore","Tootip_StartPoint":"Inizio","Tootip_ChangePoint":"Cambia","Tootip_EndPoint":"Fine","Sidebar_NewDesign":"Nuova chat","Retouch_Filter_Clear":"Cancella","Retouch_Filter_Enhance":"Vivido","Retouch_Filter_Dehaze":"Rimuovi foschia","Retouch_Filter_Texture":"Texture","Retouch_Filter_Nature":"Naturale","Retouch_Filter_Fade":"Dissolvenza","Modal_Button_Known":"OK","Modal_Button_GotIt":"Accetto","Modal_Button_Later":"Più tardi","Text_Appeal_Confirm":"Sì","Text_Vip_Open":"Abbonati","Text_Appeal_ReGenerate":"I risultati modificati non possono essere inviati per la revisione.","Text_Appeal_Left":"Tentativi rimasti questo mese\\n<i>${0}</i>/${1}","Text_Appeal_Refunded":"I crediti sono stati riaccreditati sul tuo account.","MenuItem_Appeal":"Revisione del risultato","Tooltip_Downloading":"Download in corso…","Tooltip_Download_Video":"Scarica i video separatamente, uno alla volta.","Tooltip_Download_NoneSelected":"Seleziona il contenuto che vuoi scaricare.","Text_AI_Thinking":"L\'AI ci sta lavorando...","Text_Server_Busy":"Il server è occupato. Riprova più tardi.","Text_Prompt_Help_Placeholder":"Digita le parole chiave e le trasformerò in un prompt pronto all\'uso.","Text_Prompt_Helping":"Elaborazione in corso... Attendi.","Button_Retry":"Riprova","Button_Rewrite":"Riprova","Button_Start_Prompt_Help":"Inizia a scrivere","Title_Prompt_Helper":"Scrittura AI","Menu_Text_Subscriptions":"Abbonamenti","Menu_View_Subscriptions":"Visualizza gli abbonamenti","Text_Download_XdesignApp":"Scarica l\'app <span>Zawa</span> per usare le funzioni","Text_Free_Trial":"Scarica per una prova gratuita di 7 giorni","Text_Install_App":"Installa l\'app","Text_Scan_Download":"Scansiona per scaricare","Text_Download_the":"Scarica su","Text_Available_On":"Disponibile su","Desc_ExpireDate":"Scade il","DownloadApp_Title_Widgets":"Scarica l\'app ${0} per usare le funzionalità","DownloadApp_SubTitle_Widgets":"Scarica per una prova gratuita di ${0} giorni","InstallApp_Title_Widgets":"Installa l’app","InstallApp_Desc_Widgets":"Scansiona per scaricare","AppStore_Desc_Widgets":"Scarica su App Store","GooglePlay_Desc_Widgets":"Disponibile su Google Play","Text_Tips_GetFree":"Hai ricevuto un utilizzo gratuito","Text_AgentLib":"Risorse","Tip_ModelSetSaveSuccess":"Immagine del modello salvata! Tocca per usarla.","Text_BatchProcess":"Kit workflow","Button_Add":"Aggiungi","Tab_Recent":"Salvati di recente","Tab_Models":"I miei modelli","Prompt_Model":"L\'immagine ${0} è il mio modello","Tip_SaveSuccess":"Salvato","Text_ModelsLogin":"Accedi per visualizzare i tuoi modelli","Loading_CheckFace":"Rilevamento del volto...","Name_InitialModelName":"Libreria dei modelli","EmptyTip_ModelList":"Ancora nessun modello. Creiamone uno!","Text_UploadModel":"Carica modello","Text_Model":"Modello","Tips_UnsupportedFormat":"Formato file non supportato","Tips_InputModelName":"Inserisci un nome","Tips_UploadModelImage":"Carica immagini del modello","Title_CreateModel":"Crea il tuo modello","Text_ModelName":"Nome","Placeholder_Input":"Inserisci","Text_UploadModelHint":"Tocca per caricare o trascina qui le immagini\\nJPEG/JPG/PNG/HEIC/SVG","Button_SubmitUpload":"Carica","Tips_NameLengthLimit":"Inserisci un nome (fino a ${0} caratteri)","Tips_DeleteFailed":"Eliminazione non riuscita","Title_ConfirmDeleteModel":"Eliminare questo modello?","Tips_CreateSuccess":"Modello creato","Tab_BatchTemplate":"Kit Workflow","Tab_MyModel":"I miei modelli","Placeholder_InputContent":"Inserisci il contenuto","Title_ChooseSceneType_VideoGenerateCard":"Seleziona un tipo di contenuto e una struttura storyboard:","Button_ConfirmGenerate_VideoGenerateCard":"Avvia generazione video","Title_ShotType_VideoGenerateModal":"Tipo di storyboard","Title_ShotRequirement_VideoGenerateModal":"Descrizione dello storyboard","Title_Duration_VideoGenerateModal":"Durata","Btn_AddOneTableRow":"Aggiungi","Label_Gender_ModelModal":"Genere","Label_Appearance_ModelModal":"Aspetto","Label_AgeGroup_ModelModal":"Fascia d\'età","Label_Persona_ModelModal":"Ruolo","Label_BodyType_ModelModal":"Tipo di corporatura","Tips_GenerateModelFailed_ModelModal":"Generazione non riuscita. Riprova più tardi.","Tips_NetworkError_ModelModal":"Errore di rete. Riprova più tardi.","Tab_CustomModel_ModelModal":"Personalizzato","Tab_OfficialModel_ModelModal":"Ufficiale","Tab_UploadModel_ModelModal":"Carica","Text_ModelPreview_ModelModal":"Anteprima","Button_Generating_ModelModal":"Generazione in corso...","Button_Regenerate_ModelModal":"Riprova","Button_Generate_ModelModal":"Genera","Button_Saving_ModelModal":"Salvataggio…","Button_SaveAndUse_ModelModal":"Salva e usa","Button_CreateNewModel_AgentLibList":"Nuovo modello","Message_NotFilled_RequiredField":"Le informazioni su ${0} sono obbligatorie","Title_ChooseSceneType2_VideoGenerateCard":"Seleziona una struttura dello storyboard","Title_ContentType_VideoGenerateCard":"Tipo di contenuto","Title_StoryboardStructure_VideoGenerateCard":"Struttura dello storyboard","Text_Offical":"Ufficiale","Title_AboveTheFold_Main_HomeV2":"Rendi ogni immagine del prodotto <br /> <span>pronta per la vendita</span>","Title_Designkit_Slogan":"Rendi ogni immagine di prodotto pronta per la vendita","Button_StartFree_HomeV2":"Inizia gratuitamente","Title_AboveTheFoldMobile_Main_HomeV2":"Rendi ogni prodotto <br /><span>pronto per la vendita</span>","SubTitle_AboveTheFoldMobile_HomeV2":"Dalla modifica fotografica professionale alla generazione automatica di listing, tutto ciò di cui hai bisogno in un unico posto.","Text_TopBanner_HomeV2":"Seedance 2.0 è in arrivo con accesso illimitato","Title_ModuleCard_HomeV2":"Per prima cosa, genera asset vincenti","SubTitle_ModuleCard_HomeV2":"Basta tele vuote. Usa la nostra Suite Creativa Intelligente di Agenti AI per generare in secondi interi stack di inserzioni, <br /> video dinamici, prove virtuali e adattamenti globali.","Title_Faq_Q1_HomeV2":"Offrite una prova gratuita?","Text_Faq_A1_HomeV2":"Sì! I nuovi utenti ricevono subito 20 Crediti gratuiti al momento della registrazione. Inoltre, puoi ottenere 10 Crediti gratuiti ogni giorno semplicemente effettuando l’accesso. Così puoi continuare a provare tutte le funzionalità principali, inclusa la generazione di immagini e video, prima di passare a un piano a pagamento.","Title_Faq_Q2_HomeV2":"Le immagini sono conformi alle linee guida di Amazon/Shopify?","Text_Faq_A2_HOMEV2":"Assolutamente. Per le foto principali, la nostra IA genera rigorosamente sfondi bianco puro (RGB 255,255,255) come richiesto da Amazon e Shopify. Per le immagini lifestyle e per i social media, garantisce dimensioni perfette e alta risoluzione, mantenendo le tue inserzioni completamente conformi e professionali.","Title_Faq_Q3_HomeV2":"Posso usare le risorse generate per scopi commerciali?","Text_Faq_A3_HomeV2":"Sì. Tutte le immagini e i video generati con i nostri piani a pagamento sono al 100% esenti da royalty e completamente autorizzati per uso commerciale. Detieni i diritti di utilizzo di questi asset nel tuo negozio Shopify, nei listing Amazon, negli annunci sui social media e in qualsiasi altro canale di marketing, senza limitazioni.","Title_Faq_Q4_HomeV2":"Come funzionano la generazione e la modifica in batch?","Text_Faq_A4_HomeV2":"L’elaborazione in batch è integrata nativamente in ogni funzione di Designkit. Ti basta caricare più immagini direttamente nell’area di lavoro. Che tu stia generando nuovi sfondi lifestyle, rimuovendo gli sfondi originali, eliminando oggetti indesiderati o aumentando la risoluzione, puoi applicare l’azione scelta all’intero lotto con un solo clic. Così ottieni risorse perfettamente coerenti per il tuo store e risparmi ore di lavoro manuale.","Title_Faq_Q5_HomeV2":"Quali formati di file supportate?","Text_Faq_A5_HomeV2":"I video generati sono disponibili in formato MP4, ottimizzati per i social media e i siti e-commerce.","Title_Questions_Main_HomeV2":"Domande frequenti","Title_Scale_Main_HomeV2":"Pronto a crescere?","SubTitle_Scale_HomeV2":"Unisciti a oltre 10.000 venditori che automatizzano il loro flusso di lavoro di design con Designkit.","Title_Evaluation_HomeV2":"Finalmente, lancia più velocemente e vendi di più","SubTitle_Evaluation_HomeV2":"Riduci i tempi di produzione del 90%. Pubblica listing verificati su Amazon e Shopify prima della concorrenza.","Tab_Module_ProductImage_HomeV2":"Immagine prodotto AI","Desc_Module_ProductImage_HomeV2":"Trasforma una singola foto del fornitore in una suite completa di listing in un istante. Genera foto eroe su sfondo bianco, scene lifestyle e infografiche, mentre elabori in batch centinaia di SKU con facilità e traduci automaticamente i testi per i mercati globali.","Tip_Module_ProductImage_HomeV2":"Genera un set di contenuti per una scheda Amazon per le cuffie rosa.","Tab_Module_ModelImage_HomeV2":"Modello di moda AI","Desc_Module_ModelImage_HomeV2":"Nessun modello? Nessun problema. Visualizza i capi su diversi modelli AI per aumentare il tasso di clic, senza prenotare costosi servizi fotografici.","Tip_Module_ModelImage_HomeV2":"Mostra questo completo giallo e verde su una modella di 25 anni.","Tab_Module_Video_HomeV2":"Video del prodotto AI","Desc_Module_Video_HomeV2":"Dai vita ai tuoi prodotti. Genera vetrine dinamiche, video coinvolgenti con portavoce AI e annunci ad alto tasso di conversione partendo da un semplice prompt testuale o da una singola immagine. Cattura l\'attenzione e aumenta le vendite sulle piattaforme e-commerce e sui tuoi social media.","Tip_Module_Video_HomeV2":"Genera un video di prodotto per questo vaso blu.","Tab_Module_DetailPage_HomeV2":"Pagina dettaglio prodotto AI","Desc_Module_DetailPage_HomeV2":"Crea contenuti A+ premium e banner promozionali perfetti per il tuo store online in pochi minuti, senza competenze di design. Trasforma semplici foto prodotto in layout coinvolgenti e differenzia facilmente le tue inserzioni dalla concorrenza.","Tip_Module_DetailPage_HomeV2":"Genera una pagina di dettaglio prodotto per il divano arancione.","Tab_Module_Photography_HomeV2":"Fotografia di prodotto AI","Desc_Module_Photography_HomeV2":"Dimentica le foto stock generiche. Inserisci i tuoi prodotti in ambientazioni uniche e in linea con il brand, pensate per i mercati USA e UE.","Tip_Module_Photography_HomeV2":"Genera uno sfondo fotografico per questo profumo.","Title_Module_SecondTitle_HomeV2":"Poi, perfeziona i dettagli con la precisione dell’AI","SubTitle_Module_SecondSubTitle_HomeV2":"Contenuti generati? Ora perfezionali. Usa il nostro Editor foto AI per rimuovere gli sfondi, correggere i difetti e aumentare in blocco la risoluzione delle immagini a bassa risoluzione.","Text_Upload_HomeV2":"Carica","Text_TopBannerMobile_HomeV2":"Seedance 2.0 arriverà presto","Text_Prompt1_HomeV2":"Genera un set completo di immagini per la scheda prodotto Amazon.","Text_Prompt2_HomeV2":"Genera un modello che indossa questo outfit.","Text_Prompt3_HomeV2":"Genera un video promozionale del prodotto.","Text_Prompt4_HomeV2":"Genera una pagina dettagli prodotto con Contenuto A+.","Text_Prompt5_HomeV2":"Genera sfondi adatti per le foto prodotto.","Desc_Evaluation1_HomeV2":"Velocissimo! Le immagini sono pronte all’istante per Mercado Libre e Amazon. Adatta sfondi e modelli ai gusti locali alla perfezione. Risultati davvero professionali.","Desc_Evaluation2_HomeV2":"Adoro Designkit! Le immagini lifestyle con AI sono naturali, accoglienti e in stile nordico: perfette per il mio negozio di candele. Le mie inserzioni hanno un aspetto curato e le vendite sono aumentate. Ne vale la pena.","Desc_Evaluation3_HomeV2":"Vendo abbigliamento e temevo che l’AI rovinasse le texture. Designkit ha fatto centro! I colori sono perfetti, le pose dei modelli sembrano naturali e le immagini sono subito pronte.","Header_products_socialMediaPostGenerator":"Generatore di post per social media","Pricing_Seedance_UnlockLimited":"Sblocca l\'accesso illimitato","Pricing_Seedance_SeedanceV1":"Accesso anticipato a <span>Seedance 2.0</span>","Pricing_Seedance_SeedanceDesc":"Scopri per primo la potenza di Seedance 2.0. Abbonati ora a qualsiasi piano Pro e ottieni accesso illimitato esclusivo al nostro modello AI di nuova generazione.","Pricing_Seedance_Monthly":"Bonus del piano mensile","Pricing_Seedance_DaysUnLimit":"7 giorni <span>illimitati</span>","Pricing_Seedance_SeedanceV2":"Accesso a Seedance 2.0","Pricing_Seedance_BestValue":"Miglior offerta","Pricing_Seedance_Yearly":"Bonus del piano annuale","Pricing_Seedance_MonthUnLimit":"1 mese di accesso <span>illimitato</span>","Title_AIBrand_Tools":"Strumenti AI per il branding","Title_AISocialMediaPosts":"Post sui social media","Title_AILogoMaker":"Generatore di loghi AI","Option_Child_Age":"Bambino","Option_Infant_Age":"Bebè","Option_MiddleAged_Age":"Adulto","Option_Senior_Age":"Anziano","Option_Teen_Age":"Adolescente","Option_YoungAdult_Age":"Giovane adulto","Button_GenerateImages_DetailPageAction":"Genera","Text_GenerateImagesCount_DetailPageAction":"(${0} immagini)","Text_GenerateImagesCount_DetailPageAction1":"(${0} immagine)","Option_MercadoLivre_Platform":"Mercado Livre","Option_Etsy_Platform":"Etsy","Option_Walmart_Platform":"Walmart","Option_eBay_Platform":"eBay","Option_Poshmark_Platform":"Poshmark","Button_GeneratePlan_DetailPageAction":"Crea il design della pagina prodotto","Option_AdvancedMobile_DetailPageMode":"A+ Premium (mobile)","Option_AdvancedWeb_DetailPageMode":"A+ Premium (Web)","Option_Standard_DetailPageMode":"Standard A+","Option_Accessories_DetailSection":"Accessori/Regali","Option_ServiceSupport_DetailSection":"Garanzia","Option_BeforeAfter_DetailSection":"Prima e dopo","Option_BrandStory_DetailSection":"Storia della marca","Option_KeyHighlights_DetailSection":"Punti di forza del prodotto","Option_CraftProcess_DetailSection":"Vista esplosa","Option_HeroVisual_DetailSection":"Visual principale","Option_Composition_DetailSection":"Componenti","Option_MultiAngle_DetailSection":"Più angolazioni","Option_DetailCloseups_DetailSection":"Dettagli prodotto","Option_SceneMood_DetailSection":"Stile di vita/Atmosfera","Option_SeriesShowcase_DetailSection":"Serie di prodotti","Option_SizeCapacity_DetailSection":"Dimensioni","Option_Specifications_DetailSection":"Scheda tecnica","Option_UsageScenario_DetailSection":"Casi d\'uso","Option_UsageTips_DetailSection":"Linee guida per l\'uso","Paragraph_ServicePolicy_DetailSection":"Politica su garanzia, resi e cambi","Paragraph_BeforeAfter_DetailSection":"Risultati prima e dopo l\'uso","Paragraph_BrandConcept_DetailSection":"Concetti e valori del brand","Paragraph_CoreValue_DetailSection":"Valori fondamentali in evidenza","Paragraph_CraftProcess_DetailSection":"Dal disegno alla realtà","Paragraph_Differentiators_DetailSection":"Vantaggi chiave in evidenza","Paragraph_Composition_DetailSection":"Materiali e componenti utilizzati nel prodotto","Paragraph_MaterialAndCraft_DetailSection":"Materiali e lavorazione in evidenza","Paragraph_MultiAngleAppearance_DetailSection":"Visualizzazione del prodotto da diverse angolazioni","Paragraph_MultiOptionDisplay_DetailSection":"Più colori o SKU","Paragraph_IncludedItems_DetailSection":"Tutto incluso nel pacchetto","Paragraph_DetailData_DetailSection":"Specifiche dettagliate","Paragraph_RealUsageScene_DetailSection":"Esempi di utilizzo reale","Paragraph_Specifications_DetailSection":"Guida alle dimensioni a colpo d’occhio","Paragraph_UsageNotes_DetailSection":"Note d\'uso e precauzioni","Paragraph_UsageScenario_DetailSection":"Prodotto contestualizzato","Title_Nav_DetailPage":"Contenuto A+","Title_ImageSet_DetailPage":"Set di immagini dettaglio prodotto A+","Input_TaskName_Batch":"Inserisci il nome dell\'attività","Paragraph_FullAssetSetDescription_Batch":"Include un set completo di materiali di marketing, come immagini principali, immagini d’uso e immagini su sfondo bianco, utilizzabili su più piattaforme.","Paragraph_LongFormVisualDescription_Batch":"Crea storytelling visivo per immagini prodotto in formato lungo, pagine dettaglio prodotto A+ e immagini comparative.","Message_JsonGenerated_Batch":"Modulo verificato. JSON generato.","Message_JsonCopied_Batch":"JSON copiato.","Message_IncompleteRequiredFields_Batch":"Campi obbligatori mancanti. Completa il modulo per inviare.","Message_PleaseUploadSourceImage_Batch":"Carica le immagini del prodotto.","Message_PleaseCompleteStrategySettings_Batch":"Completa la configurazione della strategia","Message_TaskValidationFailed_Batch":"Controlla e completa le attività non verificate.","Message_CopyJsonFailed_Batch":"Copia non riuscita. Controlla il JSON nella dashboard.","Message_PleaseEnterTitle_Batch":"Inserisci un titolo.","Message_PleaseEnterKeyHighlights_Batch":"Inserisci i punti di forza del prodotto","Message_PleaseGenerateJsonFirst_Batch":"Invia per generare il JSON.","Title_DetailPage_Batch":"Pagina prodotto A+","Title_DetailTask_Batch":"Attività A+ ${0}","Title_IndependentParameters_Batch":"Configura singolarmente","Title_ImageSet_Batch":"Set di immagini e-commerce","Title_ItemTask_Batch":"Attività prodotto","Option_Curvy_BodyType":"Formosa","Option_Muscular_BodyType":"Muscoloso","Option_PlusSize_BodyType":"Formosa","Option_Slim_BodyType":"Snello","Option_Standard_BodyType":"Normale","Button_Reset_Common":"Reimposta","Button_Back_Common":"Indietro","Button_Collapse_Common":"Riduci","Button_Expand_Common":"Espandi","Button_Generate_Common":"Genera","Button_PreviousStep_Common":"Annulla","Button_RemoveFavorite_Common":"Rimuovi dai preferiti","Button_StartNow_Common":"Prova adesso","Paragraph_ExitWarning_Common":"I dati andranno persi se esci.","Paragraph_Content1_VirtualModelDisclaimer":"2. È importante comprendere cosa aspettarsi dai contenuti generati dall\'AI. I contenuti generati dall\'AI sono prodotti sulla base di algoritmi e apprendimento dai dati, pertanto i risultati possono variare. L\'aspetto del volto generato dall\'AI può differire dalle risorse originali fornite e possono verificarsi imperfezioni o risultati non soddisfacenti. La nostra piattaforma non garantisce l\'accuratezza, la qualità visiva o l\'idoneità dei contenuti generati.","Paragraph_Content2_VirtualModelDisclaimer":"3. Riconoscimento delle responsabilità dell\'utente. Sei responsabile delle immagini contenenti volti e del contenuto generato. Devi garantire che il tuo utilizzo non violi i diritti legali di terzi, inclusi ma non limitati ai diritti di pubblicità, privacy e reputazione, e che sia conforme a tutte le leggi e i regolamenti applicabili. Non utilizzare il contenuto generato per scopi illeciti, lesivi (come diffamazione o frode) o in violazione dell\'ordine pubblico, della morale o della dignità altrui.","Paragraph_Content3_VirtualModelDisclaimer":"Prima di caricare, conferma di aver compreso e accettato integralmente i termini sopra indicati.","Title_Notice_VirtualModelDisclaimer":"Prima di usare la funzione Immagine prodotto AI - Prova virtuale, leggi e assicurati di comprendere quanto segue:","Message_FailedRetry_Download":"Download fallito. Riprova più tardi.","Message_Failed_Download":"Download fallito.","Message_Success_Download":"Download completato.","Message_NoImagesAvailable_Download":"Nessuna immagine disponibile.","Option_Asian_Ethnicity":"Asiatico","Option_Black_Ethnicity":"Africano","Option_Chinese_Ethnicity":"Cinese","Option_Latino_Ethnicity":"Ispanico o latinoamericano","Option_MiddleEastern_Ethnicity":"Mediorientale","Option_SoutheastAsian_Ethnicity":"Sud-est asiatico","Option_White_Ethnicity":"Bianco","Option_Female_Gender":"Donna","Option_Male_Gender":"Maschio","FormLabel_Ethnicity_Common":"Razza ed etnia","FormLabel_OriginalImage_Common":"Originale","FormLabel_OutputLanguage_Common":"Lingua","FormLabel_TargetMarket_Common":"Mercato","FormLabel_TargetPlatform_Common":"Piattaforma","Option_German_Language":"Tedesco","Option_Japanese_Language":"Giapponese","Option_None_Language":"Nessun testo","Option_Portuguese_Language":"Portoghese","Option_PortugueseBr_Language":"Portoghese (Brasile)","Option_Russian_Language":"Russo","Option_Spanish_Language":"Spagnolo","Option_SpanishMX_Language":"Spagnolo (Messico)","Option_Thai_Language":"Tailandese","Option_Brazil_Market":"Brasile","Option_China_Market":"Cina","Option_Europe_Market":"Europa","Option_Germany_Market":"Germania","Option_Japan_Market":"Giappone","Option_Russia_Market":"Russia","Option_SoutheastAsia_Market":"Asia sud-orientale","Option_Spain_Market":"Spagna","Option_UnitedStates_Market":"Stati Uniti","Message_MaxLimit_DetailSectionSelection":"Seleziona fino a ${0} sezioni","Option_FollowGlobalSettings_Common":"Usa le impostazioni globali","Text_MaxTasks_Batch":"Aggiungi fino a ${0} attività","Text_MinTasks_Batch":"Mantieni almeno un\'attività","Text_MaxImagesPerTask_Batch":"Carica fino a ${0} immagini per attività","Text_SupportedImageFormats_Batch":"Formati immagine supportati: JPG, JPEG, PNG, HEIC e WebP.","Input_AppearanceDetailsExample_TryOn":"Ad esempio: pelle abbronzata, frangia dritta, un neo vicino all’angolo dell’occhio...","Input_SourceInfoGuide_Batch":"Per risultati più accurati, includi le seguenti informazioni:\\n1. Nome del prodotto\\n2. Punti di forza del prodotto\\n3. Pubblico di riferimento\\n4. Casi d\'uso previsti\\n5. Specifiche dettagliate","Tooltip_OutputStyleConsistent_Clone":"Attivandola, tutte le immagini generate manterranno colori e stile coerenti. Disattivandola, ogni immagine seguirà lo stile della propria immagine di riferimento.","Option_AlibabaInternational_Platform":"Alibaba","Option_AliExpress_Platform":"AliExpress","Option_Amazon_Platform":"Amazon","Option_Douyin_Platform":"TikTok","Option_DouyinEcommerce_Platform":"TikTok","Option_IndependentSite_Platform":"Shopify","Option_Indonesian_Language":"Indonesiano","Option_JD_Platform":"JD.com","Option_Pinduoduo_Platform":"Pinduoduo","Option_Taobao_Platform":"Taobao","Option_TaobaoTmall1688_Platform":"Taobao, Tmall, 1688","Button_Generate_ImageSet":"Genera set di immagini","Title_Nav_ImageSet":"Immagini dell\'inserzione","Message_GenerateFailedRetry_ImageSet":"Generazione non riuscita. Riprova.","Message_PleaseSelectStyleFirst_ImageSet":"Prima seleziona uno stile.","Message_CreateTaskFailed_ImageSet":"Impossibile creare l\'attività","Title_StyleAnalysis_ImageSet":"Analisi degli stili di tendenza","Option_TrafficMaximization_TitleStrategy":"Massimizza il traffico","Option_ConversionPriority_TitleStrategy":"Priorità alla conversione","Option_SceneImmersion_TitleStrategy":"Scene immersive","Text_ExtractingVisualAttributes_TitleGenerationStatus":"Estrazione delle caratteristiche principali dalle risorse...","Text_AnalyzingKeyHighlights_TitleGenerationStatus":"Generazione di parole chiave ad alta conversione in base ai punti di forza del prodotto...","Text_MatchingSeoStrategy_TitleGenerationStatus":"Selezione delle migliori strategie SEO...","Text_GeneratingOptions_TitleGenerationStatus":"Generazione di più didascalie da diverse prospettive...","Message_TaskFailedWithStatus_TitleGeneration":"Attività non riuscita (stato: ${0}): ${1}","Message_TaskTimedOut_TitleGeneration":"La richiesta è scaduta. Riprova.","Message_GenerateFailed_TitleGeneration":"Generazione del titolo fallita. Riprova.","Message_QueryResultFailed_TitleGeneration":"Impossibile recuperare l\'attività","Paragraph_Content_VirtualModelConsent":"1. Autorizzazione per i diritti di immagine: Questa funzione utilizza le immagini con volti che carichi per generare volti di modelli virtuali tramite AI. Devi assicurarti di disporre dei diritti di immagine sulle immagini caricate o di aver ottenuto il consenso scritto esplicito e valido dal titolare dei diritti per utilizzare i relativi ritratti a questo scopo e per qualsiasi contenuto generato. Se l’immagine contiene un minore, è necessario il consenso del suo tutore legale.","Button_ConfirmTextChange_TextEdit":"Aggiornamento","Input_ModifyText_TextEdit":"Modifica sottotitoli","Message_NoImagesAvailable_ResultDownload":"Nessuna immagine disponibile per il download","Message_Failed_TextRecognition":"Impossibile riconoscere il testo","Text_Generating_ResultStatus":"Generazione in corso...","Option_CustomColor_SceneSetting":"Personalizzato","Option_UseOriginalBackground_SceneSetting":"Usa sfondo originale","Text_InsufficientCredits_Common":"Monete insufficienti","Button_LoadMore_Common":"Carica altro","Text_ImageUploadLimit_Common":"Carica fino a ${0} immagini","Text_AnalyzingTrend_Common":"Analisi delle tendenze su ${0}","Text_ChineseOutputProOnly_Common":"La generazione di testo in cinese è disponibile solo con Pro. Il testo è stato rimosso dal risultato corrente.","Text_SourceImageUploadLimit_Common":"Carica fino a ${0} immagini","Text_WritingInProgress_AiWriting":"Elaborazione in corso...","Text_DeepThinking_AiWriting":"Ragionamento approfondito...","Text_ThinkingProcess_AiWriting":"Processo di pensiero:","Text_ImageSelectionLimit_Common":"Seleziona fino a ${0} immagini","Message_RegenerationSubmitted_Regeneration":"Rigenerazione inviata. Aggiorna più tardi per visualizzare i risultati.","Button_MoreEditOptions_ResultEditor":"Altro","FormLabel_DetailSection_DetailPage":"Sezione dettagli prodotto","Message_GeneratePlanFailed_DetailPagePlan":"Impossibile generare il piano","Message_PlanGenerationFailed_DetailPagePlan":"Impossibile generare il piano","Text_PlanUnavailable_DetailPagePlan":"Nessun piano disponibile","Message_SourceImageMissing_Common":"Immagine del prodotto mancante","Message_GenerationFailed_Common":"Generazione fallita","Paragraph_ConfirmDiscardChanges_Common":"Se torni indietro, le modifiche andranno perse. Vuoi davvero tornare indietro?","Message_ProcessFailed_Common":"Non riuscita","Text_GeneratingEllipsis_Common":"Generazione in corso...","Text_StyleGenerationInProgress_ImageSet":"Generazione degli stili di tendenza...","Message_FavoriteAdded_Common":"Aggiunto ai preferiti","Message_FavoriteRemoved_Common":"Rimosso dai preferiti","Text_LoadingPlain_Common":"Caricamento","Text_MultiSelectAvailable_Common":"Seleziona più elementi","Text_NoData_Common":"Nessun dato disponibile","Text_NoDataAvailable_Common":"Nessun dato","Text_NoMoreResults_Common":"Nessun altro contenuto","Message_PleaseEnterKeyHighlights_DetailPage":"Inserisci i punti di forza del prodotto","Message_PleaseSelectAiModel_TryOn":"Seleziona un modello AI","Message_SelectSectionMin_DetailPage":"Seleziona almeno ${0} sezioni","Message_SelectScenePoseMin_TryOn":"Seleziona almeno ${0} scene e pose","Message_PleaseSelectBaseModel_TryOn":"Seleziona un modello base","Message_PleaseSelectCustomModel_TryOn":"Seleziona un modello personalizzato","Message_PleaseSelectModel_TryOn":"Seleziona prima un modello.","Message_PleaseSelectSection_DetailPage":"Seleziona una sezione","Message_SelectUploadCustomModel_TryOn":"Seleziona o carica un\'immagine del modello","Message_PleaseSelectScene_TryOn":"Seleziona uno scenario","Message_PleaseSelectStrategy_DetailPage":"Seleziona una strategia","Message_PleaseUploadGarmentImage_TryOn":"Carica un\'immagine del capo","Message_UploadGarmentFile_TryOn":"Carica un\'immagine del capo","Message_PleaseUploadSourceImage_Common":"Carica prima le immagini del prodotto","Message_PleaseUploadItemImage_Common":"Carica un\'immagine del prodotto","Message_UploadItemFirst_Common":"Carica prima le immagini del prodotto","Message_RegenerateFailedWithReason_Regeneration":"Impossibile rigenerare:","Message_SelectResultImages_Result":"Seleziona un\'immagine con risultati generati","Text_ReleaseToRefresh_Common":"Rilascia per aggiornare","Message_TextRecognitionFormatInvalid_TextRecognition":"Formato non valido riconosciuto","Message_TextRecognitionParseFailed_TextRecognition":"Impossibile analizzare i risultati del riconoscimento","Message_TextRecognitionTaskFailed_TextRecognition":"Impossibile riconoscere il testo","Message_QueryTaskStatusFailed_TextRecognition":"Impossibile recuperare lo stato dell\'attività","Message_SubmitTaskFailed_TextRecognition":"Impossibile inviare l\'attività di riconoscimento del testo","Text_RegenerationProcessing_Regeneration":"Richiesta di rigenerazione inviata. Elaborazione in corso...","Message_RegenerateFailedRetry_Regeneration":"Rigenerazione non riuscita. Riprova più tardi.","Message_OpenEditorFailed_ResultEditor":"Impossibile aprire l\'editor","Message_RegenerateFailed_Regeneration":"Impossibile rigenerare","Message_RefreshFailedRetry_Common":"Aggiornamento non riuscito. Riprova.","Message_UploadGarmentSelectModel_TryOn":"Carica un\'immagine del capo e seleziona un modello","Message_PollingTimedOut_Common":"Timeout della query","Title_KeyHighlights_DetailPage":"Punti salienti del prodotto","Title_FullStrategyGuide_DetailPage":"Linee guida complete per strategia e design","Title_IncludedSections_DetailPage":"Sezioni","Title_IncludedSectionsMultiple_DetailPage":"Sezioni (Selezione multipla)","Title_ModelSelection_TryOn":"Seleziona modello","Title_SectionContent_DetailPage":"Contenuto della sezione","Title_SectionStrategyGuide_DetailPage":"Strategia della sezione e linee guida di design","Title_OutputAspectRatio_Common":"Proporzioni","Title_OutputSpecification_Common":"Specifiche","Title_SelectModel_TryOn":"Seleziona modello","Title_SelectScene_TryOn":"Seleziona una scena","Title_StrategySettings_DetailPage":"Strategia","Title_UploadAssets_Common":"Carica","Button_GenerateBaseModel_TryOn":"Genera modello base","Button_GenerateRecommendedScenes_TryOn":"Genera scena consigliata","Button_GenerateSceneImages_TryOn":"Genera (${0} immagini)","Text_GeneratingBaseModel_TryOn":"Generazione del modello base...","Option_CloseUp_Framing":"Primo piano","Option_FullBody_Framing":"Figura intera","Option_HalfBody_Framing":"Mezzo busto","Option_ThreeQuarter_Framing":"3/4","Title_Hero_TryOn":"Prova virtuale AI","Option_Ai_TryOnModelMode":"Generato dall\'AI","Title_Nav_TryOn":"Prova virtuale","Option_Back_Perspective":"Indietro","Option_Front_Perspective":"Fronte","Option_Side_Perspective":"Laterale","Option_ThreeQuarterSide_Perspective":"Vista a 3/4","Input_AppearanceDetailsHint_TryOn":"Dettagli dell\'aspetto: pelle abbronzata, frangia dritta, un neo vicino all\'angolo dell\'occhio…","Message_SaveToAlbumSuccess_Common":"Salvato nell\'album","Text_GeneratingSceneImages_TryOn":"Generazione delle immagini della scena...","Message_RefreshFailed_Common":"Impossibile aggiornare","Message_FailedRefunded_Generation":"Design IA non riuscito. I crediti sono stati rimborsati.","Title_BaseModelImage_TryOn":"Immagine base del modello","Title_CustomModel_TryOn":"Modello personalizzato","Paragraph_Intro_TryOn":"Carica un\'immagine del capo e personalizza il modello per generare diverse scene e pose.","Title_UploadGarmentImage_TryOn":"Immagine del capo","Tips_UploadFailedPure":"Caricamento non riuscito","Tips_Uploading":"Caricamento...","Text_UploadNewModel":"Nuovo modello","Text_AllBackgrounds":"Tutti gli sfondi","Text_DefaultTemplateScene":"Predefinito","Text_ColorScene":"Colori","Text_SameProductMax_Common":"Fino a ${0} immagini per prodotto","Text_Max_Common":"Fino a ${0} immagini","Button_Generate_ImageClone":"Inizia a generare","Button_RefreshStyle_Common":"Ricarica","Button_Favorite_Common":"Preferito","Text_PreviewLargeImage":"Anteprima completa","Text_BaseImage":"Benchmark","Button_BatchDownload_Common":"Download in gruppo","Button_BatchEdit_Common":"Modifica in gruppo","Button_BatchWatermark_Common":"Aggiungi filigrana","Text_GeneratedResults":"Risultati","Button_DownloadAllImages_Common":"Scarica tutto","Text_NoGeneratedResults":"Ancora nessun risultato","Text_SameProductMax_TryOn":"Un outfit completo o più angolazioni dello stesso articolo, fino a ${0} immagini.","Title_AdvancedImageGenerationModel":"Modello per immagini Premium","Text_SupportChineseOutput_Common":"Supporta l\'output in cinese e offre dettagli estetici migliori e un maggiore controllo creativo.","Text_SelectMultipleModules_DetailPage":"Seleziona più sezioni per generare una pagina prodotto completa","Button_CollapseAll_Common":"Tutto","Label_AppearanceDetails_TryOn":"Dettagli sull\'aspetto (facoltativo)","Text_WaitingForGeneration_TryOn":"Generazione in attesa","Title_SmartTitleAI_ProductTitle":"Genera titoli virali","Message_ResultMissing_TitleGeneration":"${0} mancante nei risultati generati dall\'IA","Message_InvalidJSONFormat_TitleGeneration":"Risultato restituito non valido","Message_InvalidJSONFormat_TitleGeneration1":"Formato JSON restituito non valido","Text_AutoGeneratedTitleScheme_ProductTitle":"Ecco i titoli generati automaticamente in base al tuo prodotto","Text_SelectBestTitle_ProductTitle":"Scegli un titolo efficace e fai clic per copiarlo","Button_Copy_Common":"Copia","Message_PleaseUploadImage_Common":"Carica prima un\'immagine","Text_DeepThinking1_AiWriting":"DeepSeek ci sta lavorando...","Button_Rewrite1":"Riprova","Text_TotalImages_Common":"Conteggio: ${0}","Text_EditText_ResultEditor":"Modifica testo","Text_NoTextRecognition_ResultEditor":"Nessun testo rilevato","Text_PreviewLongImage_ResultGroup":"Anteprima immagine lunga","Text_LimitFree":"Offerta flash","Text_UploadSameProductTip1":"1. Carica immagini originali dello stesso prodotto da diverse angolazioni per aiutare l\'AI a ricreare i dettagli del prodotto con maggiore precisione","Text_UploadSameProductTip2":"2. Sono supportate fino a ${0} immagini. La prima immagine verrà usata come riferimento principale, quindi scegli quella con l\'inquadratura più completa.","Text_UploadProductImage_APlusCase":"Carica l\'immagine del prodotto","Text_GenerateEcommerceLongImage_APlusCase":"Genera immagine lunga","Text_MultiPlatform_APlusCase":"Conforme agli standard di diverse piattaforme e-commerce","Text_MainImage_ProductCase":"01 Immagine di intestazione (Sfondo bianco/Standard)","Text_SceneDisplay_ProductCase":"02 Scenari d\'uso","Text_ModelSceneImage_ProductCase":"03 Foto del modello","Text_DetailDescription_ProductCase":"04 Dettagli","Text_FeatureExplanation_ProductCase":"05 Punti di forza del prodotto","Text_UploadProductImage_ProductCase":"Carica le immagini del prodotto e l\'AI genererà all\'istante set di immagini ad alta conversione <span>conformi agli standard di più piattaforme e-commerce</span>.","Text_UploadGarmentImage_TryOn":"Carica immagini di abbigliamento e crea il tuo modello personalizzato per generare all\'istante più scene e pose.","Text_UploadProductImage_DetailPage":"Carica immagini prodotto e l\'AI genererà subito una pagina prodotto professionale <span>conforme agli standard di più piattaforme e-commerce</span>.","Title_DetailPage_ProductCase":"A+/Pagina Dettagli Prodotto","Option_Temu_Platform":"Temu","Option_TikTokShop_Platform":"TikTok Shop","Option_TikTok_Platform":"TikTok","Option_Ozon_Platform":"OZON","Option_Shopee_Platform":"Shopee","Option_SHEIN_Platform":"SHEIN","Login_Zawa_Title":"Accedi per sbloccare la tua prova gratuita","Login_DK_Title":"Crea design straordinari gratis","Login_Zawa_Des":"Inizia a creare con Zawa oggi","Login_DK_Des":"Registrati o accedi per continuare a creare. Inizia ora!","Tab_Module_ProductImage_TryOn_MultiMix":"Abbina i capi in un Outfit","Tab_Module_ProductImage_TryOn_SingleHero":"Da un solo capo a un look completo","Tab_Module_ProductImage_TryOn_Accessories":"Accessori abbinati alla perfezione","Text_ShowAdvancedModelTip":"Mostra suggerimenti per il modello premium","Text_HideAdvancedModelTip":"Nascondi i suggerimenti del modello premium","Text_DeepSeekR1HelpWrite":"Aiutami a scrivere (DeepSeek R1)","Message_PollingMaxAttempts_Common":"Numero massimo di tentativi superato ${0}","Title_StandardEdition":"Standard","Text_FastAndEfficient_Common":"Veloce ed efficiente","Text_PremiumEdition":"Premium","Text_QualityAndDetailEnhancement_Common":"Qualità e dettagli migliorati","Text_PremiumEngineActivated":"<strong>Motore premium attivato:</strong> Supporta l\'output in cinese e offre dettagli estetici migliori e un maggiore controllo creativo.","Text_EditBrand_DropTitle1":"Trascina qui i file JPG, PNG o WEBP,","Text_EditBrand_DropTitle2":"Oppure <>sfoglia</> dal computer.","Text_BaseToolbar_AlignTop":"Allinea in alto","Text_BaseToolbar_AlignBottom":"Allinea in basso","Text_LayerSort":"Ordine","Text_BaseToolbar_AlignCenter":"Centro","Text_Attr_Strong":"Grassetto","Text_GeneratingPlan_DetailPagePlan":"Generazione del piano in corso...","Text_PlanGenerationFailed_ReTry":"Impossibile generare il piano. Riprova più tardi.","Button_StartAnalyze_ProductCase":"Iniziamo","Message_SubmitSuccessTip_Batch":"Inviato","Button_ClickAnalyze_ProductCase":"Analizza gli stili bestseller","Button_StartAnalyzing_ProductCase":"Analisi in corso","Title_ModelImage":"Modello","Text_Cookie_Title":"Prima di tutto, i cookie 🍪","Text_Cookie_Content":"Vorremmo utilizzare i cookie su questo sito web per garantire sicurezza, prestazioni efficienti e ottimizzazione del servizio. Per saperne di più su come utilizziamo i cookie, fai clic su","Text_Cookie_LearnMore":"Dettagli","Button_Cookie_Manage":"Gestisci i cookie","Button_Cookie_Accept":"Accetta","Text_CookieModal_Title1":"Impostazioni dei cookie","Text_CookieModal_Desc1":"I cookie sono piccoli file di testo che i siti web memorizzano sul tuo dispositivo per aiutarci a ricordare le tue preferenze, monitorare il traffico del sito e migliorare i nostri servizi. La tua privacy è importante per noi e vogliamo che tu abbia il controllo dei tuoi dati. Qui puoi personalizzare le preferenze relative ai cookie per ottimizzare la tua esperienza di navigazione. Tieni presente che la modifica delle impostazioni dei cookie potrebbe influire sulle funzionalità e sui servizi del nostro sito web.","Text_CookieModal_Title2":"Cookie necessari","Text_CookieModal_Desc2":"Questi cookie sono essenziali per la funzionalità, la sicurezza e le prestazioni principali del sito web. Senza di essi, le funzioni chiave e le misure di sicurezza di Zawa non funzioneranno correttamente, con possibili effetti negativi sulla tua esperienza.","Text_CookieModal_Title3":"Cookie facoltativi","Text_CookieModal_Desc3":"Questi cookie ci aiutano a capire quanti utenti usano Zawa, da dove provengono e come utilizzano il sito web. Se scegli di disattivarli, non potremo raccogliere feedback per migliorare Zawa o offrire servizi migliori a te e agli altri utenti.","Button_CookieModal_Save":"Salva","Text_CookieModal":"Sempre attivi","Text_Agent_Chat_DK":"Scrivi la tua idea…","Text_Agent_Chat_XD":"Cosa vorresti creare?","Radio_Color":"Palette","Radio_Layout":"Layout","Radio_Reference":"${0}","Radio_Posture":"Posa","Radio_Background":"Sfondo","Language_Banner_Message":"Vuoi passare a ${0}?","Language_Banner_Change":"Sì","Language_Banner_Other":"Altre lingue","Title_ItemTaskWithIndex_Batch":"Attività prodotto ${0}","Title_DetailTaskPrefix_Batch":"Attività A+","Text_CopiedTaskTitle_Batch":"${0} (Copia)","Message_SelectSectionMin_Batch":"Seleziona almeno una sezione.","Title_GlobalBatchSettings_Batch":"Impostazioni globali (Si applicano alle seguenti attività)","Text_Parameters_Batch":"Parametri","Text_Modules_Batch":"Sezioni","Title_KeyHighlights_Batch":"Punti salienti del prodotto","Text_ModulesFollowGlobal_Batch":"Sezioni - Usa impostazioni globali","Title_SelectManagedBusinessType_Batch":"Seleziona il tipo di attività","Button_SubmitTask_Batch":"Inviare","Text_NewTaskCurrentCount_Batch":"Crea attività","Title_NotificationSettings_Batch":"Notifiche","Title_ManagedMode_Batch":"Pianificatore","Button_SaveSettings_Batch":"Salva le impostazioni","Button_SaveAndContinueSubmit_Batch":"Salva e invia","Message_PhoneFormatInvalid_Batch":"Inserisci un numero di telefono valido di 11 cifre.","Message_VerificationCodeSent_Batch":"Codice di verifica inviato. Il codice è valido per 5 minuti.","Message_VerificationCodeSendFailed_Batch":"Invio non riuscito. Riprova più tardi.","Message_PleaseEnterCode_Batch":"Inserisci il codice di verifica.","Message_GetCodeFirst_Batch":"Ottieni prima un codice di verifica.","Message_VerificationCodeExpired_Batch":"Il codice di verifica è scaduto. Richiedine uno nuovo.","Message_SaveNotificationSettingsFailed_Batch":"Impossibile salvare le impostazioni delle notifiche. Riprova più tardi.","Text_WebMessageNotification_Batch":"Riceverai una notifica nei messaggi Web al completamento dell\'attività.","Title_AppPushRecommended_Batch":"Notifiche dell’app (Consigliate)","Paragraph_AppPushDesc_Batch":"Segui l\'avanzamento e visualizza i risultati sul telefono in tempo reale. Tieni i tuoi progetti sempre a portata di mano e non perdere nessuna opportunità.","Text_AppDownloadQrCode_Batch":"Scansiona per scaricare l\'app","Title_SmsNotification_Batch":"Notifiche SMS","Placeholder_Phone11Digits_Batch":"Un numero di telefono di 11 cifre","Placeholder_VerificationCode5Min_Batch":"Codice di verifica","Text_SendingEllipsis_Batch":"Invio in corso...","Text_RetryAfterSeconds_Batch":"Riprova tra ${0}s","Button_GetVerificationCode_Batch":"Invia codice","Message_SubmitSuccess_Batch":"Inviato","Message_SubmitFailedRetry_Batch":"Impossibile inviare, riprova più tardi.","Message_FormValidationPassed_Batch":"Contenuto valido","Message_CompleteNotificationSettingsFirst_Batch":"Configura le notifiche prima di inviare l’attività.","Paragraph_CancelManagedTaskWarning_Record":"Se annulli ora, l\'attività programmata verrà rimossa definitivamente.","Button_ConfirmCancel_Record":"Annulla comunque","Message_CancelManagedTaskFailed_Record":"Impossibile annullare. Riprova più tardi.","Text_WaitingManagedGeneration_Batch":"Programmazione attività...","Text_WaitingManagedSubmit_Batch":"In coda","Message_NoExtendableImages_Result":"Nessuna immagine disponibile","Text_IntelligentMultiSizeAdaptation_Result":"Ridimensiona le immagini in modo intelligente per adattarle a ogni schermo","Button_IntelligentResize_Result":"Ridimensiona smart","Option_CustomSize_DetailPageMode":"Personalizzato","Title_AdvancedAPlus_DetailPageMode":"Premium A+","Title_ManagedModeLaunched_Batch":"Il pianificatore è pronto ad aiutarti!","Text_ManagedModeSlogan_Batch":"Lavora durante la notte per avere i tuoi design pronti al risveglio.","Title_BatchProduction_Batch":"Generazione in gruppo","Paragraph_BatchProductionDesc_Batch":"Esegue fino a ${0} attività contemporaneamente e aumenta la produttività di ${1}×.","Title_AiIntelligentExtraction_Batch":"Analisi AI","Paragraph_AiIntelligentExtractionDesc_Batch":"Analizza le tue immagini e genera automaticamente punti di forza del prodotto ad alta conversione.","Title_SaveCost20_Batch":"Risparmia il ${0}% sui crediti","Paragraph_SaveCost20Desc_Batch":"Puoi programmare le attività di notte e usare i crediti a tariffa scontata.","重写":"Download in gruppo","Brand_AutoExtract_Button":"Estrattore palette","Brand_AutoExtract_Success":"Palette estratta","Brand_AutoExtract_Failure":"Impossibile estrarre la palette colori. Riprova.","Brand_AutoExtract_Unavailable":"Impossibile estrarre la palette colori.","Brand_AutoExtract_ConfirmTitle":"Estrarre la palette colori dal logo?","Title_ImageSetConfig_ImageSet":"Design del listing","Title_DefaultConfig_ImageSet":"Design AI","Desc_DefaultConfig_ImageSet":"L\'AI analizza le immagini del prodotto e abbina il set di immagini per il listing più adatto","Title_CustomConfig_ImageSet":"Design personalizzato","Desc_CustomConfig_ImageSet":"Regola il numero di immagini per ogni tipo. Seleziona almeno ${0} immagini.","Label_WhiteBackground_ImageSet":"Immagini con sfondo bianco","Desc_WhiteBackground_ImageSet":"Mostra il tuo prodotto da più angolazioni su sfondo bianco.","Label_Scene_ImageSet":"Scene di lifestyle","Desc_Scene_ImageSet":"Mostra il tuo prodotto in contesti reali.","Label_SellingPoint_ImageSet":"Punti salienti del prodotto","Desc_SellingPoint_ImageSet":"Metti in risalto le caratteristiche chiave che distinguono il tuo prodotto.","Label_Other_ImageSet":"Altro","Desc_Other_ImageSet":"Contenuti selezionati automaticamente per il tuo prodotto, con confronti, specifiche e altro.","Tip_MinTotal_ImageSet":"Almeno ${0} immagini","Text_ManagedBatchEntry_Header":"Pianificatore","Option_Coupang_Platform":"Coupang","Option_Wayfair_Platform":"Wayfair","Button_Credit_Plan":"Piano crediti","Text_Higher_Plan":"Hai già un piano superiore","Text_Try_Free":"Prova ora a $0","Text_Plus_Plan":"Piano Plus","Text_Pro_Plan":"Piano Pro","Button_Generate_Short_Common":"Genera","Message_DuplicateTaskSubmitConfirm_Common":"Risultati già generati con queste impostazioni. Generare di nuovo?","Text_CreditUnit_Common":"Crediti","Text_NewUserDiscountDesc_Product":"${0} crediti per la prima inserzione. ${2} crediti per ogni gruppo di ${1} inserzioni aggiuntive.","Text_NewUserLimitedTag_Product":"Sconto per nuovi utenti","Text_OriginalPrice_Product":"Originale: ${0} crediti","Tip_MaxTotal_ImageSet":"Fino a ${0} immagini","Text_AddDocumentTips":"Sono supportati file Word, Excel, testo, PDF e Markdown","Tab_SolidColor":"Colore solido","Tab_Gradient":"Gradiente","Title_PresetGradient":"Predefiniti","Title_PresetSolidColor":"Preset","Title_RecentlyUsed":"Utilizzato di recente","Title_Patterns":"Schema","Title_NoFill":"Nessuno","Description_Brand_Reference":"Carica i tuoi poster o asset artistici preferiti e Zawa userà lo stile per creare design su misura per i tuoi gusti.","Text_Generating":"Generazione in corso...","Text_ChartSending":"Invio in corso","Text_PeopleUnSupport":"La modalità ritratto non è ancora supportata.","Button_CancelManagedBatch_ResultGroup":"Annulla attività","Button_DownloadZip_ResultGroup":"Scarica ZIP","Button_DownloadLongImage_ResultGroup":"Scarica file combinato","Text_ManagedTaskDispatchedCannotCancel_ResultGroup":"L\'attività inviata non può essere annullata.","Button_GlobalAiWriting_Batch":"Scrittura AI","Text_StandardModel_DistributionBatch":"Modello standard (Pubblicazione in blocco)","Text_StandardModelDescription_Batch":"Ideale per SKU ad alto volume, per massimizzare la copertura del mercato.","Text_AdvancedModel_PremiumBatch":"Modello avanzato (inserzione mirata)","Text_AdvancedModelDescription_Batch":"Immagini di qualità premium, ideali per una redditività orientata alla precisione.","Message_MinSubmitTasks_Batch":"Invia almeno ${0} attività.","Message_OverwriteSellingPointsConfirm_Batch":"La sezione dei punti di forza del prodotto è già compilata in ${0} attività. Come vuoi applicare i risultati della scrittura AI?","Button_OverwriteAll_Batch":"Sostituisci tutto","Button_FillEmptyOnly_Batch":"Solo incompleti","Message_NoEmptySellingPointsToFill_Batch":"I punti di forza dei prodotti sono già completi per tutte le attività.","Message_AiWritingFailedRetry_Batch":"Scrittura con IA non riuscita. Riprova più tardi.","Button_NewTask_Common":"Nuova attività","Message_Generating_Time":"Le tue attività verranno eseguite durante la notte (${0}-${1}). Torna domani per controllare i risultati.","Title_Total_Credits":"Crediti totali","Text_Used_AllFeatures":"Applicabile a tutte le funzionalità","Daily_Present_Credits":"Crediti utilizzabili oggi","Daily_Credits_Desc":"Riscatta ogni giorno. Valido fino a fine giornata.","Text_Inactive":"Inattivo","Text_Inactive_Monthly":"Nei prossimi 30 giorni scadranno ${0} crediti","TITLE_GUIDE_CUTOUT_LITE":"Timbri o loghi rilevati","GUIDE_DESC_CUTOUT_LITE":"Usa Ritaglio timbro/logo per un ritaglio preciso","GUIDE_ACTION_CUTOUT_LITE":"Ritaglio timbro/logo","TITLE_CUTOUT_LITE":"Ritaglia timbro/logo","TIP_CUTOUT_LITE":"Ritagli precisi di timbri o loghi","PROCESSING_CUTOUT_LITE":"Generazione immagini...","AFTER_CUTOUT_LITE":"Risultati","Button_Previous":"Indietro","Button_Next":"Avanti","Button_Skip":"Salta","Button_Apply":"Applica","Text_AgentExpert":"Esperto","Message_PleaseEnterLinkOrAsin_Clone":"Inserisci un link o un ASIN","Message_LinkAnalyzeFailed_Clone":"Analisi del link non riuscita","Message_UploadProductImageFirst_Clone":"Carica prima le immagini del prodotto","Message_ProductImageThumbGenerateFailed_Clone":"Generazione della miniatura non riuscita. Carica di nuovo.","Message_UploadProductImageFirst_ProductCase":"Carica un\'immagine di riferimento o incolla un link del prodotto","Message_ReferenceImageThumbGenerateFailed_Clone":"Generazione della miniatura non riuscita. Carica di nuovo.","Title_ReferenceSource_Clone":"Riferimento","Option_LinkAsin_Clone":"Link","Input_PasteProductLinkOrAsin_Clone":"Incolla il link Amazon","Button_Parsing_Clone":"Analisi in corso...","Button_Parse_Clone":"Analizza","Text_SupportAmazonTiktokLinks_Clone":"Sono supportati i link di Amazon e TikTok","Text_Cloning_ResultStatus":"Elaborazione in corso...","Input_CloneRequirementOptional_Clone":"Requisiti (facoltativo)","Title_ProductOriginalImage_Clone":"Immagine prodotto","Title_CloneLevel_Clone":"Stile di replica","Option_CompositionReference_Clone":"Stile","Desc_CompositionReference_Clone":"Crea una nuova scena ispirata all\'atmosfera e allo stile del tuo riferimento.","Option_HighFidelityClone_Clone":"Alta fedeltà","Desc_HighFidelityClone_Clone":"Ricrea fedelmente il riferimento, sostituendo solo prodotto e testo.","Label_OutputStyleConsistent_Clone":"Stile coerente","Title_SupplementaryNotesOptional_Clone":"Istruzioni aggiuntive (facoltative)","Input_SupplementaryNotesExample_Clone":"Esempio: Genera un testo per il prodotto in inglese, mantieni lo stesso modello e sostituisci solo il prodotto.","Title_HotClone_Welcome":"Remix immagine","Text_HotCloneDescription_Welcome":"Il tuo riferimento virale + la tua immagine del prodotto = la tua immagine virale","Text_DefaultTaskName_Clone":"Strategia di replica dell\'immagine","Label_ProductImage_CloneCase":"Immagine del prodotto","Label_ReferenceComposition_CloneCase":"Riferimento stile","Label_HighFidelityClone_CloneCase":"Alta fedeltà","Tag_AiSmartMatch_ImageSet":"Abbinamento intelligente AI","Title_Date":"Data","Title_Topic":"Tema","Button_Replace":"Sostituisci","Title_SingleCloneRequirement_Clone":"Requisiti specifici","Text_UploadedReferenceImagesTip_Clone":"Requisiti individuali per ogni immagine di riferimento. Se non vengono specificati requisiti, verranno applicate le impostazioni predefinite.","Label_ReferenceImageIndex_Clone":"Immagine di riferimento ${0}","Option_Mexico_Market":"Messico","Text_ParsingReferenceImages_Clone":"Analisi in corso...","Text_ParseReferenceImagesSuccess_Clone":"Analisi completata. ${0} immagini di riferimento acquisite.","Text_Renew_Restore":"I Crediti verranno ripristinati al rinnovo dell\'abbonamento.","Title_UsageNotice_Clone":"Guida utente","Text_UsageNoticeDescription_Clone":"Conferma di avere il diritto legale di utilizzare il contenuto di questo link. I risultati generati si basano sull\'analisi dello stile tramite AI e sono solo a scopo di riferimento creativo.","Label_ReadAndAgreeUsageNotice_Clone":"Accetto i termini sopra indicati","Label_DoNotShowAgain_Clone":"Non mostrare più","Text_InterceptModal":"Consenti le finestre pop-up per Designkit.","Text_InterceptModal_ThirdStep":"Fai clic su \\"Fine\\" per iniziare a usare Designkit.","Text_InterceptModal_Desc":"Autorizza Designkit ad aprire più finestre nel browser.","Brand_StatusPopup_ProcessingTitle":"Zawa sta imparando lo stile del tuo brand...","Brand_StatusPopup_FailedTitle":"Impossibile estrarre i dati da Square. Riprova più tardi.","Brand_StatusPopup_Retry":"Riprova","SecondTitle_Header19_Home":"Clona annunci video","SquareBrandGuide_BrandKitCreatedTip":"Il tuo kit del brand è stato creato in base ai dati di Square","SquareBrandGuide_DefaultPrompt":"Crea un poster di prodotto per la promozione sui social media","SquareBrandGuide_SendTip":"Fai clic su Invia per iniziare!","Paragraph_BatchProductionDescUnlimited_Batch":"Gestisce più attività contemporaneamente, riducendo drasticamente i tempi dei tuoi progetti.","Menu_ViewDetail":"Dettagli","Menu_CopyFullText":"Copia","Tip_CopiedToClipboard":"Copiato negli appunti","Tip_CopyFailed":"Copia non riuscita","Menu_DownloadImage":"Scarica","Tip_NoImage":"Nessuna immagine","Tip_DownloadStarted":"Download in corso","Menu_CopyText":"Copia","Tip_NoTextToCopy":"Nessun testo disponibile","Message_LinkImageFetchFailed_Clone":"Non siamo riusciti a caricare le immagini da questo link. Prova con un altro link o carica direttamente le immagini.","Tab_Chat":"Chat","Tab_Files":"File","Button_Create_New_Chat":"Nuova chat","Tip_Agent_Team_Chat_Shared":"Visualizzazione della versione di sola lettura","Title_ViralVideoMaker":"Generatore AI di video virali","Title_ProductVideoMaker":"Generatore di video per prodotti","designkit_agent_watermark_protocol":"Puoi scegliere di salvare le immagini con o senza il watermark \\"AI result\\". Salvando senza watermark, accetti di: 1. Non utilizzare Zawa AI Agent per creare, pubblicare o diffondere informazioni false. 2. Rispettare le leggi applicabili ed etichettare chiaramente i contenuti generati dall\'IA quando li usi o condividi.","Text_Document":"File","Button_BrandAssets_UploadDevice":"Carica dal dispositivo","Button_SocialBrief_Complete":"Completa il brief","Button_SocialBrief_Edit":"Modifica brief","Button_SocialBrief_Generate":"Genera in base al brief","Description_BrandAssets":"Le informazioni sul tuo brand ci aiutano a offrirti risultati più pertinenti.","Name_BrandAssets":"Risorse del brand","Placeholder_BrandAssets_Link":"Ad esempio, link di Instagram o Google Maps.","Text_BrandAssets_KitImported":"Importa dal kit del brand","Text_BrandAssets_LinkEntry":"Inserisci il tuo link","Text_SocialResult_Post":"Post","Title_SocialBrief":"Brief","Toast_BrandAssets_DuplicateSkipped":"Immagini duplicate ignorate","Toast_BrandAssets_EmptyAssets":"Nessun kit del brand trovato","Toast_BrandAssets_InvalidUrl":"Inserisci un link valido","Toast_BrandAssets_LoadAssetsFailed":"Impossibile ottenere gli asset del brand","Toast_BrandAssets_LoadKitsFailed":"Impossibile ottenere i kit del brand","Toast_BrandAssets_PartialReadFailed":"Impossibile caricare alcune immagini","Toast_BrandAssets_ReadFailed":"Impossibile caricare le immagini","Toast_BrandAssets_SaveFailed":"Impossibile salvare gli asset del brand","Toast_BrandAssets_UploadFailed":"Impossibile caricare alcune informazioni sulle risorse del brand. Riprova.","Title_AgentDesignPreference":"Personalizza il tuo Agent di stile AI","Desc_AgentLibWorkflowUnify":"Salva i tuoi modelli e stili distintivi per creare contenuti più rapidamente e in modo più coerente in ogni flusso di lavoro.","Button_ViewAgentGuide":"Istruzioni","Desc_BatchRecipeRetain":"Salva le impostazioni dell’immagine e le composizioni della scena come preset riutilizzabili da applicare subito ai progetti futuri.","Button_NewBatchRecipe":"Crea preset","Desc_CustomModelUpload":"Carica le immagini dei tuoi modelli e riutilizzale in più generazioni per creare un\'identità di brand coerente.","Button_NewExclusiveModel":"Crea modello","Text_AiRecommend_TryOn":"Consigli smart per le scene","Desc_AiRecommendSceneMode_TryOn":"Seleziona automaticamente la scena migliore in base all\'abbigliamento.","Message_LoadSceneFailedRetry_TryOn":"Caricamento non riuscito. Riprova più tardi.","Text_OptionalCustomSceneDescription_TryOn":"Descrivi la scena (facoltativo)","Placeholder_CustomSceneDescription_TryOn":"Aggiungi dettagli, ad es. strade autunnali dorate, luce soffusa del tramonto, un modello appoggiato a un albero…","Message_PleaseSelectOrDescribeScene_TryOn":"Seleziona o inserisci una descrizione della scena","Placeholder_SearchProduct_Record":"Cerca per nome del prodotto o parole chiave","Title_RecentSearches":"Cronologia","Button_Clear":"Cancella","Title_ShootingScene_TryOn":"Impostazioni scena","Button_Charged_Continue":"Ricarica completata","Title_SplitImagePlugin":"Suddivisione in livelli dell\'immagine","Description_SplitImagePlugin":"Rileva gli elementi dell\'immagine e separali in livelli modificabili.","Tip_SplitImageLoading":"Elaborazione in corso...","Tip_SplitImageFail":"Elaborazione non riuscita. Riprovare.","Brand_SquareSync_ToastPartial":"Impossibile importare alcuni dati di Square","Brand_SquareSync_ToastSuccess":"I dati di Quadrato sono pronti","Brand_SquareSync_Failed":"Estrazione dei dati da Square non riuscita.","Brand_SquareSync_Button":"Importa da Square","Title_Format":"Formato","Message_CancelManagedTaskSuccessRefunded_Record":"Attività annullata. I crediti sono stati riaccreditati sul tuo account.","Text_AspectRatio_Common":"Proporzioni","Text_Country_Common":"Paese/Regione","Text_Language_Common":"Lingua","Text_Platform_Common":"Piattaforma","Option_Korea_Market":"Corea del Sud","Option_Korean_Language":"Coreano","Title_AgentLibRecentBrainOn":"Intelligenza dell\'Agent attivata","Desc_AgentLibRecentRecipesSidebar":"I tuoi preset vengono aggiunti ad Agent Assets. Usali per applicare subito lo stile del tuo brand a tutti i design.","Title_CreateBatchRecipe":"Crea preset","Tips_Not_Files":"Nessun file","Message_PleaseEnterProductHighlights":"Inserisci i punti di forza del prodotto","Message_UploadProductImageRequired":"Carica almeno un\'immagine del prodotto","Tips_Agent_Teams_Mode":"Ideale per flussi di lavoro sofisticati che richiedono più funzionalità AI.","Tips_Agent_Teams_Mode_Actived":"La modalità Agent Team coordina gli agenti AI in ogni fase, dalla strategia alla produzione finale.","Tip_SocialBrief_MissingImages":"Mancano le immagini obbligatorie in {count} post. Aggiungile per continuare.","Tips_Agent_Teams_Mode_Active_Zawa":"Agent Team è pronto: ricerca e creazione di contenuti con il pilota automatico. Dimmi di cosa hai bisogno.","Tip_AiGeneratedContent":"I contenuti generati dall\'intelligenza artificiale possono contenere errori.","Button_ContinueUpload":"Continua","Button_GenerateNow":"Genera","Button_ReplaceClothes":"Sostituzione","Desc_ReplaceClothesMultiUpload":"Cambia l\'intero outfit in una volta sola","FileName_MyClothes":"Caricato","Message_SelectReplaceClothes":"Seleziona le immagini dei tuoi capi","Message_UploadClothesFailed":"Caricamento dell\'immagine non riuscito, riprova.","Message_UploadClothesSizeLimit":"Carica immagini di abbigliamento fino a 10 MB","Text_MoreActionEmpty":"Configura azioni","Tip_UploadClothesFormat":"Trascina o carica ${0} immagini fino a ${1}.","Title_ReplaceClothes":"Sostituisci abbigliamento","Title_TryOnAccessoryMatch":"Aggiungi accessori smart per creare un look distintivo del brand","Title_TryOnMultiPose":"Crea lookbook con pose dei modelli naturali e realistiche","Title_TryOnOutfitMix":"Crea outfit completi abbinando capi diversi","Title_TryOnSceneSwitch":"Cambia gli sfondi per adattarli a qualsiasi mood o stile di campagna","Title_TryOnAIRecommend":"Consigli AI","Text_SocialBrief_Generating":"Generazione in corso. Attendi.","Tag_New":"Nuovo","Title_Designer":"Designer","Button_Blank_Canva":"Designer","Tool_AiViralImageRemix":"Remix immagine","Title_ViralVideoReplace":"Remix video","Title_SocialMedia_Tools":"Strumenti creativi per i social","Title_HotTags":"Di tendenza","Tip_LogoNotRecognized":"Logo non trovato","Tip_LogoNotRecognized_Eraser":"Logo non trovato. Passa il dito per selezionare l\'area che vuoi rimuovere.","Placeholder_RemoveGrassDebris":"Rimuovi gli elementi di disturbo dall\'erba","Placeholder_RemoveGroundShadow":"Rimuovi le ombre sul terreno","Placeholder_RemoveRedClothesPerson":"Rimuovi la persona vestita di rosso","Placeholder_DescribeRemovalPart":"Inserisci ciò che vuoi rimuovere, ad esempio: ${0}","Modal_LeavePageTitle":"Stai per lasciare questa pagina","Modal_OpenRoboNeoNewTab":"Aprire RoboNeo in una nuova scheda?","Button_ReplicateVideo":"Remixa questo video","Button_RemixImage":"Remixa questa immagine","Message_ContentProcessFailed_Text":"Elaborazione non riuscita. Prova con altre parole.","Message_ContentProcessFailed_Image":"Questa immagine non può essere elaborata. Provane un\'altra.","Text_ProductImageOptionalUploadTip_Clone":"Aggiungi una foto del prodotto se vuoi includerla nel risultato","Option_EcommerceProductImage_Clone":"Immagine del prodotto e-commerce","Option_ApparelEcommerceImage_Clone":"Immagine per e-commerce di abbigliamento","Option_SocialGraphicImage_Clone":"Post sui social media","Option_MarketingPoster_Clone":"Poster promozionale","Option_CreativePoster_Clone":"Poster creativo","Option_ReferenceImageSize_Clone":"Rapporto immagine di riferimento","Option_Instagram_Platform":"Instagram","Home_Tools_Title":"Dai una marcia in più ai tuoi contenuti social con il nostro potente set di strumenti","Home_Tools_Tab_SocialCreative":"Creatività social","Home_Tools_SeeAllImageTools":"Vedi tutti gli strumenti per immagini","Home_Tools_SeeAllSocialCreative":"Vedi tutti gli strumenti per contenuti social","Home_Tools_ImageObjectRemover":"Rimozione oggetti dalle immagini","Home_Tools_TextToVideo":"Testo in video","Home_Tools_FoodPhotography":"Fotografia di cibo","Home_Tools_FlyerGenerator":"Generatore di volantini","Home_Tools_MenuGenerator":"Generatore di menu","Home_Tools_PosterGenerator":"Generatore di poster","Home_Tools_MockupGenerator":"Generatore di mockup","Home_Tools_ImageExtender":"Estendi immagine","Home_Tools_ImageToVideo":"Da immagine a video","title_upgrade2GetMoreCredits":"Effettua l\'upgrade per ottenere più crediti.","tip_insufficientCredits":"Crediti insufficienti. Ricarica per averne altri.","tip_insufficientCredits_upgrade":"Crediti insufficienti. Abbonati per ottenerne altri.","Title_DownloadPromotion_ViralVideo":"Vuoi altri video come questo?","Subtitle_DownloadPromotion_ViralVideo":"Passa a Pro per creare più video.","Tag_DownloadPromotionOffer_ViralVideo":"Offerta a tempo limitato","Title_DownloadPromotionCard_ViralVideo":"Continua a creare con Pro","Text_DownloadPromotionPrice_ViralVideo":"${0}/mese","Text_DownloadPromotionBenefitViralVideo_ViralVideo":"Generatore di video prodotto/Video Remix (fino a ${0} video/mese)","Text_DownloadPromotionBenefitNanoBanana_ViralVideo":"Creazioni Nano Banana Pro illimitate","Text_DownloadPromotionBenefitImageEnhance_ViralVideo":"Rimozione AI e miglioramento della qualità illimitati","Button_DownloadPromotionGetPro_ViralVideo":"Ottieni Pro con ${0} di sconto","Button_DownloadPromotionLater_ViralVideo":"No, grazie","Tag_NewUserLimitedFree":"Offerta a tempo limitato","Text_FirstImageCreditDiscount":"${0} crediti per la prima immagine. ${2} crediti per ogni ${1} immagini aggiuntive.","Tag_NewUser_FirstImageLimitedFree":"Offerta a tempo limitato","Tag_FirstImageFree":"1 prova gratuita","Title_OtherSettings":"Altre impostazioni","Title_GenerateListing":"Genera testo dell\'inserzione","Button_GenerateListing":"Genera testo per inserzione","Message_Copied":"Copiato","Text_Generating_Listing":"Generazione in corso...","Text_GenerateFailed_Listing":"Impossibile generare","Button_Translate":"Traduci","Title_ListingCopy":"Testo del listing","Message_NoTaskForListing":"Nessuna attività di generazione dell\'inserzione trovata.","Message_RenameSuccess":"Modificato","Message_RenameFailedRetry":"Impossibile modificare. Riprova.","Title_RegenerateDirection":"Generazione di modifiche","Placeholder_RegeneratePrompt":"Lascia vuoto per rigenerare oppure aggiungi istruzioni per modificare il risultato (facoltativo). Ad es. \\"Sposta il prodotto a sinistra\\" o \\"Cambia lo sfondo in grigio chiaro\\".","Title_TrialLimitReached_ViralVideo":"Video gratuito utilizzato","Subtitle_TrialLimitReached_ViralVideo":"Con la prova gratuita puoi generare 1 video. Passa a Pro per generarne altri.","Button_UpgradeNow":"Fai l\'upgrade ora","Text_WPS_NavVipEntrance":"Acquista","Text_WPS_Only":"(Solo WPS)","Text_WPS_Credits_Card_Tip":"Designkit dispone di un sistema di abbonamento separato e non è incluso negli abbonamenti WPS standard.","Text_WPS_Welcome_Modal_Pricing":"Abbonamento Designkit","Text_WPS_Welcome_Modal_Pricing_Description":"AI Design è fornito da un partner WPS di terze parti e richiede un acquisto separato.","Text_WPS_Welcome_Modal_Meidou":"Primo accesso","Text_WPS_Welcome_Modal_Meidou_Description":"Gli abbonati WPS ricevono 50 crediti gratis per provarlo! Non verranno addebitati costi aggiuntivi al tuo account.","Text_WPS_Welcome_Modal_Vip":"Bonus abbonamento","Text_WPS_Welcome_Modal_Vip_Description":"Acquista un piano AI Design e ottieni WPS Super Membership per la stessa durata, per un periodo di tempo limitato.","Text_WPS_Welcome_Modal_Title":"Crea con Designkit","Text_WPS_Welcome_Modal_Agreement":"Continuando, dichiari di aver letto e accetti i termini sopra indicati.","Button_Generate_ImageListingSet":"Immagini e testi dell\'inserzione","Tip_GenerateListing":"Genera contenuti visivi e testi pronti per il marketplace selezionato.","Text_SelectedCount":"${0} selezionati","RoboNeo_Web_input_default_content":"Chatta con RoboNeo","RoboNeo_Web_chatbox_maximum":"Limite della chat raggiunto","RoboNeo_Web_chatbox_maximum_text":"Limite della chat raggiunto. Crea una nuova attività.","RoboNeo_Web_chatbox_new_task":"Nuovo progetto","RoboNeo_Web_history_share_text":"Condividi","RoboNeo_Web_history_delete_text":"Elimina","RoboNeo_Web_history_delete_hint_text":"Nota","RoboNeo_Web_history_delete_main_text":"Il progetto verrà eliminato definitivamente. Continuare?","RoboNeo_Web_history_delete_hint_confirm":"Elimina","RoboNeo_Web_history_delete_hint_cancel":"Annulla","RoboNeo_Web_studio_download":"Scarica","RoboNeo_Web_toast_share_text":"Condividi questa chat","RoboNeo_Web_toast_share_main_text":"Chiunque abbia il link della chat può visualizzare la cronologia della chat","RoboNeo_Web_toast_share_copy":"Copia link","RoboNeo_Web_toast_cancel":"Annulla","RoboNeo_Web_toast_confirm":"Conferma","RoboNeo_Web_studio_changing_toast":"Non hai più utilizzi gratuiti per oggi. Si ripristineranno entro mezzanotte. Puoi anche nutrire Neo con \\"Cyber Carrots\\" per continuare.","RoboNeo_Web_studio_changing_toast2":"Nessun utilizzo gratuito rimasto per oggi.","RoboNeo_Web_new_studio":"Nuova chat","RoboNeo_Web_sidebar_close":"Riduci","RoboNeo_Web_history_text":"Cronologia","RoboNeo_Web_sidebar_open":"Espandi","RoboNeo_Web_upload_warning_text":"Non è possibile caricare immagini e video contemporaneamente.","RoboNeo_Web_upload_format_text":"Formati immagine supportati: JPG, PNG e JPEG. Formati video supportati: MP4 e MOV.","RoboNeo_Web_upload_fail_text":"Caricamento non riuscito","RoboNeo_Web_upload_image_maximum":"Puoi caricare fino a {max_num} immagini","RoboNeo_Web_upload_video_size_maximum":"I video superiori a {max_size} MB non sono supportati.","RoboNeo_Web_upload_image_size_maximum":"Le immagini superiori a {max_size} MB non sono supportate.","RoboNeo_Web_upload_video_maximum":"Puoi caricare fino a {max_num} video","RoboNeo_Web_history_dafult_text":"Nessuna cronologia trovata. Chatta ora.","RoboNeo_Web_upload_content_warning_text":"I file con contenuti potenzialmente inappropriati non verranno importati.","RoboNeo_Web_chat_send_fail":"Invio non riuscito, riprova più tardi.","RoboNeo_Web_network_fail":"Connessione non riuscita o tempo scaduto. Riprova.","RoboNeo_Web_studio_layer_fail":"Impossibile dividere i livelli.","RoboNeo_Web_studio_layer_success":"Completato","RoboNeo_Web_network_error":"Errore di rete","RoboNeo_Web_delete_success":"Eliminato","RoboNeo_Web_delete_fail":"Impossibile eliminare","RoboNeo_Web_copy_success":"Copiato","RoboNeo_Web_file_uploading":"Caricamento di {num} file in corso","RoboNeo_Web_file_upload_fail":"Errore durante il caricamento di {num} file","RoboNeo_Web_file_upload_single_fail":"Errore durante il caricamento di 1 file","RoboNeo_Web_file_uploading_single":"Caricamento di 1 file","RoboNeo_Web_upload_video_maximum_one":"Puoi caricare fino a 1 video","RoboNeo_Web_sharepage_wanna_try":"Prova adesso","RoboNeo_Web_sharepage_load_to_end":"Vai ai risultati","RoboNeo_Web_studio_loading_text":"Caricamento della tela...","RoboNeo_Web_chatbox_add_image":"Aggiungi immagini","RoboNeo_Web_chatbox_add_video":"Aggiungi video","RoboNeo_Web_image_editor_max":"Max 10 MB e 4096 px sul lato più lungo","RoboNeo_Web_unlimited_pass_expired":"Pass illimitato scaduto. Ora stai usando gli utilizzi gratuiti disponibili.","RoboNeo_Web_studio_ai_image_successful":"UHD AI - Completato","RoboNeo_Web_studio_ai_image_failed":"UHD AI - Non riuscito","RoboNeo_Web_studio_cutout_successful":"Ritaglio riuscito","RoboNeo_Web_studio_cutout_failed":"Ritaglio fallito.","RoboNeo_Web_studio_ai_edit_failed":"Modifica dell\'IA non riuscita","RoboNeo_Web_studio_ai_edit_successful":"Modifica AI - completata","RoboNeo_Web_AI_generated":"Contenuto generato dall\'AI","RoboNeo_Web_loading":"Caricamento","RoboNeo_Web_view_creative_process":"Visualizza il processo creativo","RoboNeo_Web_try_now":"Prova adesso","RoboNeo_web_extender_successful":"Estensione AI - completata","RoboNeo_web_extender_failed":"Estensione AI - Non riuscita","RoboNeo_web_eliminate_successful":"Rimozione AI - completata","RoboNeo_web_eliminate_failed":"Rimozione AI non riuscita","roboneo_web_continue":"Continua","roboneo_web_video":"Video","roboneo_web_HTML":"HTML","roboneo_web_shared_error_message":"Questa chat non può essere condivisa. Prova ad avviarne una nuova.","roboneo_web_open_the_APP_experience":"Prova nell\'app","roboneo_web_AI_generated_logo":"Questo contenuto generato dall\'AI è solo a scopo di riferimento.","roboneo_web_change_word_success":"Sostituzione testo - completata","roboneo_web_change_word_fail":"Sostituzione testo non riuscita","roboneo_web_canvas_loading_failed":"Caricamento della tela non riuscito","roboneo_web_export_failed":"Esportazione non riuscita","roboneo_web_export_tips2":"Supporta l’esportazione di una sola immagine (fino a {width}px*{height}px).","roboneo_web_new_topic":"Nuova chat","roboneo_web_waiting_reply":"In attesa di risposta","roboneo_web_file_saving_preferences":"Preferenza file","roboneo_web_includes_AI_watermark":"Includi filigrane AI","roboneo_web_no_remind":"Non mostrare più","roboneo_web_agree_continue":"Accetta e continua","roboneo_web_watermark_protocol":"Puoi scegliere di salvare le immagini con o senza watermark \\"Risultato AI\\". Scegliendo di salvarle senza watermark, accetti di: 1. Non usare RoboNeoAI per creare, pubblicare o diffondere informazioni false. 2. Rispettare le leggi e indicare chiaramente tali contenuti come generati dall\'AI quando li usi o li condividi.","roboneo_web_rectangle":"Quadrato","roboneo_web_circle":"Cerchio","roboneo_web_arrow":"Freccia","roboneo_web_image_fusion_success":"Completato","roboneo_web_image_fusion_failure":"Non riuscita","roboneo_chat_resources_num_limit_tips":"Puoi aggiungere fino a {img_num} video e {video_num} immagini.","RoboNeo_Web_export_confirm_tip_popup_title":"Puoi scegliere se esportare con una filigrana \\"Generato dall\'IA\\".","RoboNeo_Web_export_confirm_tip_popup_btn":"Ho capito.","Tip_UploadImagesFormat_Batch":"Trascina o fai clic per caricare immagini JPEG/JPG/PNG fino a ${0} MB. Sono supportate fino a ${1} immagini.","Text_SelectedModulesCount_Batch":"${0} elementi selezionati","Tip_DefaultFollowGlobal_Batch":"Se non viene modificato, usa le impostazioni globali predefinite","Label_ModuleSelection_Batch":"Selezione dei moduli","Label_SelectRequiredModules_Batch":"Scegli i moduli necessari","Title_Dialog_Invite2":"Invita amici, ottieni giorni Pro e crediti","Desc_Dialog_Invite2":"Condividi il link con gli amici o pubblicalo sui social media. Quando un amico si registra tramite il tuo link, ricevete entrambi <strong>${0} giorni di Pro + ${1} crediti</strong>; se il tuo amico si abbona <strong>entro ${2} giorni</strong>, ricevete entrambi fino a <strong>${3}</strong> crediti extra.","SubTitle_Rewards1_Invite2":"Giorni Pro ottenuti","SubTitle_Rewards2_Invite2":"Crediti guadagnati","SubTitle_Rewards3_Invite2":"Amici invitati","Text_Rule1_Invite2":"Quando un amico si iscrive tramite il tuo link, ricevete entrambi <strong>${0} giorni di Pro + ${1} crediti</strong>.","Text_Rule2_Invite_zawa":"Se il tuo amico <strong>si abbona entro ${0} giorni</strong>, riceverete entrambi crediti extra (<strong>Plus +${1}, Pro +${2}, Max +${3}</strong>). Ogni amico può ottenere questo bonus una sola volta, in base al suo primo piano attivo.","Text_Rule3_Invite2":"I giorni Pro in regalo vengono aggiunti al periodo del tuo abbonamento: se hai già un abbonamento attivo, la data di scadenza verrà estesa e riceverai sempre i vantaggi del livello più alto attualmente disponibile.","Text_Rule4_Invite2":"I crediti vengono aggiunti al tuo saldo, <strong>validi per 30 giorni</strong>, e possono essere usati per la generazione rapida con tutti i modelli di AI Agent.","Text_Rule5_Invite2":"Gli abbonamenti non sono rimborsabili una volta utilizzati i vantaggi del piano o consumati i crediti bonus; le ricompense gratuite non possono essere annullate una volta utilizzate.","Text_Rule6_Invite2":"I premi non verranno assegnati ad account esistenti, auto-inviti, account duplicati o attività fraudolente; ${0} si riserva il diritto di modificare la promozione e revocare i premi dagli account con attività irregolari.","Title1_Invited_Invite2":"Un amico ti ha invitato a unirti a ${0}. Ottieni ${1} giorni di Pro + ${2} crediti","Text_DaysBadge_Invite":"${0} giorno/i","Title_Reward_Registered":"Prova Pro gratis per ${0} giorni","Title_Reward_Invite":"Ottieni ${0} giorni di Pro gratis e ${1} crediti","Desc_Reward_Invite":"Ottieni Pro gratis per ${0} giorni e Strumenti AI illimitati","Button_StartCreate_Invite":"Inizia a modificare","Text_InviteMore_Invite":"Invita gli amici e ottieni più giorni Pro e crediti","Title_WelcomeOnboarding":"Benvenuto su Zawa!","Title_ContentIntentOnboarding":"Qual è il tuo obiettivo principale nella creazione di contenuti?","Text_ReferralCreditsOnboarding":"Ti sei registrato tramite un invito, quindi aggiungeremo automaticamente <>${0} crediti</> al tuo account.","Option_ProductVideoOnboarding":"Video per il mio prodotto","Option_SocialPostOnboarding":"Post sui social media","Option_LogoBrandOnboarding":"Crea loghi e brand","Button_MaybeLaterOnboarding":"Più tardi","Title_FirstVideoOnboarding":"Crea gratis il tuo primo video","Desc_FirstVideoOnboarding":"Parti da una foto del prodotto o da un\'immagine di riferimento e genera un video pronto da pubblicare su Instagram.","Title_FirstSocialPostOnboarding":"Crea gratis il tuo primo post social","Desc_FirstSocialPostOnboarding":"Carica una foto o descrivi ciò che ti serve per ottenere una serie di post social curati e pronti da pubblicare.","Title_FirstLogoBrandOnboarding":"Crea gratis il tuo primo logo o brand","Desc_FirstLogoBrandOnboarding":"Descrivi il tuo brand e ottieni rapidamente un logo professionale e un concept visivo.","Text_TryFreeProOnboarding":"<>Prova Zawa Pro gratis per 3 giorni</>, senza carta di credito né pagamento.","Text_FreeVideoOnboarding":"<>Ottieni 1 generazione video gratuita</>. Non serve una carta di credito né alcun pagamento.","Text_FreeImagesOnboarding":"<>Ottieni 4 generazioni di immagini gratuite</>, senza carta di credito né pagamento.","SubTitle_Invited_Invite_zawa":"Il tuo amico ti invita a provare Zawa, un agente AI dedicato al brand design. Crea facilmente loghi, identità visiva, poster, menu, contenuti per social media e video del brand. Iscriviti ora: sia tu che il tuo amico riceverete una membership Pro di ${0} giorni e ${1} crediti. Se ti abboni entro ${2} giorni, riceverai anche crediti bonus: Plus +${3} crediti, Pro +${4} crediti, Max +${5} crediti.","SubTitle_Invited_Invite_dk":"Il tuo amico ti ha invitato a provare Designkit, un agente AI dedicato al design commerciale. Crea facilmente immagini prodotto, pagine di dettaglio, poster promozionali, banner e-commerce, contenuti per i social media e video prodotto. Registrati ora: tu e il tuo amico riceverete ${0} giorni di abbonamento Pro e ${1} crediti. Abbonati entro ${2} giorni per ottenere premi extra: ${3} crediti bonus con Basic e ${4} crediti bonus con Pro.","Text_Rule2_Invite_dk":"Quando un amico <strong>si abbona entro ${0} giorni</strong>, ricevete entrambi crediti extra (<strong>Basic +${1}, Pro +${2}</strong>). Una ricompensa per amico, in base al primo piano attivo.","Tool_AIVideoGenerator":"Generazione video AI","Tool_AIVideoAdMaker":"Creazione di annunci video AI","Tool_AIVideoEditor":"Editor video AI","Title_AIWatermark":"Filigrana AI","Title_FileSavePreference":"Preferenze di salvataggio file","Label_IncludeAIWatermark":"Include filigrana AI","Button_ConfirmDownload":"Conferma download","Button_AgreeAndContinue":"Accetta e continua","Text_DontRemindAgain":"Non inviarmi più notifiche.","Button_DownloadApp":"Scarica l\'app","Title_DownloadAppForMoreFeatures":"Scarica l\'app per accedere a funzionalità più avanzate","Tip_Download7DaysFreeTrial":"Scarica per iniziare una prova gratuita di 7 giorni","Message_LoginExpiredRelogin":"Errore di accesso. Accedi di nuovo.","Title_BindPhone":"Associa il numero di telefono","Tip_BindPhoneForCollaboration":"Collega il tuo numero di telefono per collaborare con gli altri in tempo reale.","Tip_OnlyPSDSupported":"Sono supportati solo i file PSD","Button_OpenPSD":"Apri PSD","Desc_AIDisclaimer":"Prima di utilizzare questo servizio, l\'utente deve comprendere che i contenuti generati dall\'intelligenza artificiale si basano sull\'apprendimento profondo dell\'intelligenza artificiale da grandi set di dati e che alcune informazioni potrebbero contenere difetti, risultare irragionevoli o causare disagio. Pertanto, Meitu non fornisce alcuna garanzia in merito all\'accuratezza, alla completezza o alla funzionalità dei contenuti generati dagli algoritmi e non si assume alcuna responsabilità legale, inclusa quella per la violazione di diritti di terzi. Inoltre, poiché il servizio di progettazione AI genera contenuti correlati in base al testo inserito dall\'utente, l\'utente è responsabile di effettuare scelte ragionevoli in merito alle informazioni inserite e ai contenuti generati. L\'utente deve assicurarsi di utilizzare questo servizio e le opere generate dall\'AI da esso prodotte in conformità alla legge, di non violare copyright, marchi o altri diritti legali di terzi e di non utilizzare le opere generate per scopi illegali. Se l\'uso improprio da parte dell\'utente causa danni a diritti o interessi di terzi, l\'utente si assumerà la corrispondente responsabilità legale ai sensi di legge.","Text_Disclaimer":"Esonero di responsabilità","Message_ConnectFailed":"Connessione fallita: ${0}","Placeholder_SelectFont":"Seleziona il font","Message_MaxImageUploadSize":"Sono supportate solo immagini fino a ${0} x ${1}","Title_StorageFull":"Il tuo spazio di archiviazione è pieno","Title_StorageFullPleaseClean":"Lo spazio di archiviazione è pieno. Libera spazio.","Desc_StorageFull":"Il tuo spazio di archiviazione ${0} è pieno. Elimina alcuni contenuti ${1}, altrimenti la cronologia delle modifiche precedente potrebbe andare persa.","Desc_StorageFullAigc":"Il tuo spazio di archiviazione ${0} è pieno. Questo contenuto generato verrà <strong>conservato temporaneamente per 7 giorni</strong>. Elimina alcuni contenuti ${1}, altrimenti la cronologia delle creazioni potrebbe scomparire.","Text_Free":"Gratuito","Text_OrUpgradeMember":"Oppure aggiorna il tuo abbonamento","Text_UnlockMoreStorage":"Sblocca più spazio di archiviazione","Text_FilesSavedForever":"I file possono essere salvati a tempo indeterminato.","Button_UpgradeMember":"Upgrade","Button_CleanSpace":"Pulisci","Title_FileExpiringSoon":"Il tuo file sta per scadere","Desc_FileExpireAutoClean":"I file verranno eliminati automaticamente dopo la scadenza. Gestisci le tue creazioni per tempo.","Button_OrganizeFiles":"Organizza i file","Title_RemainingDownloads":"Download rimanenti","Text_PriorityConsumeExpiring":"Usa prima i download in scadenza","Text_PermanentValid":"Validità permanente","Text_Sheet":"immagine/i","Text_ExpireInDays":"Scade tra ${0} giorni","Text_ConsumeTiming":"Download:","Tip_CutoutConsumeRule1":"Quando scarichi immagini ritagliate nell\'editor di ritaglio, verrà detratto il numero di download corrispondente.","Tip_CutoutConsumeRule2":"2. Le immagini già scaricate, se non vengono rielaborate o scontornate, possono essere scaricate di nuovo senza scalare il numero di download disponibili.","Text_InviteSuccessReward":"Invito ricevuto con successo. Unisciti a Meitu Posters per ottenere la tua ricompensa.","Desc_DesignKitIntro":"Meitu Designer, lo strumento di design AI essenziale per i venditori e-commerce. Dai set di immagini prodotto e immagini con modelli alla generazione di video shoppable, design di poster e fotoritocco, aiuta gli utenti a creare con l’AI un set completo di risorse e-commerce in un unico posto.","Title_TeamMeidouShared":"I crediti del team sono disponibili per tutti i membri","Desc_PersonalMeidouTransfer":"Per trasferire i crediti personali a un team, contatta il servizio clienti.","Button_SwitchTeamRecharge":"Cambia team e ricarica","Button_CreateTeamRecharge":"Crea un team e ricarica","Title_SubscribeSuccess":"Abbonamento riuscito","Text_MeidouRechargedTo":"I crediti sono stati aggiunti a","Button_GoToTeam":"Vai al team","Text_OnePayMultiShare":"Ricarica una volta, condividi tra più account","Text_InviteMembersShareMeidou":"Invita i membri a condividere i crediti","Menu_SwitchPersonalTeam":"Cambia account personale/team","Menu_TeamManagement":"Gestione del team","Menu_InviteFriendsEarnCash":"Invita gli amici e guadagna denaro","Text_Personal":"Personale","Text_PersonalDesigner":"Designer individuale","Text_EnterpriseSwitch":"Passa a Enterprise","Button_Recharge":"Ricarica","Text_Detail":"Dettagli","Tip_DesignKitIndependentPlan":"Meitu Design Studio ha piani di abbonamento propri e non condivide i vantaggi con l’abbonamento WPS.","Text_MeidouWpsOnly":"Crediti (Solo WPS)","Text_SheetCount":"Numero di ritagli","Desc_ExchangeConfirm":"Vuoi davvero convertire ${0} crediti per lo scontorno in ${1} giorni di abbonamento?","Message_LoadOrderFailed":"Impossibile caricare i dati dell\'ordine","Message_ExchangeSuccess":"Riscattato con successo","Message_ExchangeFailed":"Impossibile riscattare","Text_NoOrderRecords":"Nessun ordine trovato","Text_OrderDate":"Data ordine:","Text_VipExchangeRule1":"1. Durante l\'abbonamento, gli scontorni sono illimitati e non consumano crediti.","Text_VipExchangeRule2":"2. I crediti a pagamento per il ritaglio possono essere convertiti in un abbonamento.","Text_VipExchangeLocation":"· Dove riscattare: Tocca l\'immagine del profilo -> Numero di foto.","Text_VipExchangeNoExchange":"·Se scegli di non effettuare il riscatto, puoi continuare a usare il tuo abbonamento. Il periodo di validità resterà invariato.","Text_VipExchangeGiftSheets":"·I crediti bonus del tuo abbonamento non possono essere usati per riscattare un abbonamento e sono utilizzabili fino alla scadenza.","Text_VipExchangeRule3":"3. L\'abbonamento non include più crediti gratis","Text_BackToPrevious":"Indietro","Title_WpsPay":"WPS Pay","Text_CloseModal":"Chiudi","Text_FavoriteDesignKit":"Aggiungi Meitu Design Studio ai preferiti","Button_Visit":"Accedi","Desc_VisitChinaSite_Cutout":"Vuoi visitare il sito cinese di Meitu Cutout? Clicca su Visita per accedere al sito cinese.","Desc_VisitChinaSite":"Vuoi visitare il sito cinese di Meitu DesignRoom? Fai clic su [Visita] per continuare.","Desc_VisitingGlobalSite_Cutout":"Stai visitando Designkit Cutout (sito globale di Meitu Cutout). Gli utenti in Cina possono visitare il sito cinese.","Desc_VisitingGlobalSite":"Stai visitando Designkit, il sito globale di Meitu Design Studio. Se ti trovi in Cina, visita il sito cinese.","Button_StayCurrent":"Resta qui","Button_BackToChinaSite":"Torna al sito cinese","Title_DownloadWork":"Scarica","Label_WorkType":"Tipo","Button_Downloading":"Download in corso...","Tip_UploadImageForBetterResult":"Dopo aver caricato un\'immagine, inserisci istruzioni di modifica chiare per ottenere risultati migliori.","Label_SceneElement":"Elementi della scena","Placeholder_SceneElementDesc":"Modifica elementi o soggetti dell\'immagine con un prompt di testo. Esempio: Sostituisci XX nell\'immagine con XX che ho caricato.","Label_MainTitle":"Titolo principale","Label_SubTitle":"Sottotitolo","Label_Copywriting":"Copywriting","Tip_ModifyBeforeGenerate":"Modifica l\'immagine e il testo prima di generare","Button_ReEdit":"Modifica di nuovo","Message_MaxUploadImages":"Puoi caricare fino a ${0} immagini","Text_CompletedPercent":"(${0}% completato)","Text_PreviewImage":"Anteprima","Text_EnterCanvasEdit":"Modifica nella tela","Title_GenerateSame":"Crea","Text_ConfirmLeaveGenerating":"Generazione in corso. Vuoi davvero uscire?","Text_BuildingVisualScheme":"Creazione del design visivo in corso...","Text_OptimizingLayout":"Ottimizzazione del layout e della gerarchia delle informazioni...","Text_FineTuningFont":"Ottimizzazione di font e spaziatura...","Message_GenerateSuccessCost":"Generazione riuscita! Crediti usati: ${0}","Title_ConfirmDelete":"Conferma eliminazione","Text_DeleteFontWarning":"Dopo l\'eliminazione, tutti i membri del team non potranno più applicare questo font.","Text_AppliedWillReplace":"Lo stile del font applicato nel record di creazione verrà sostituito automaticamente con","Text_DefaultReplaceFontName":"Alibaba-PuHuiTi-R","Text_Deleting":"Eliminazione...","Message_DeleteSuccess":"Eliminato correttamente!","Text_NoMore":"Nessun altro contenuto...","Text_NoFonts":"Ancora nessun font","Button_UploadFont":"Carica font","Message_FontFormatInvalid":"Il file del font ${0} ha un formato non valido","Title_AuthConfirm":"Conferma dell\'autorizzazione","Text_FontAuthConfirm":"Per i caratteri che aggiungi personalmente, assicurati di disporre dell\'autorizzazione necessaria da parte del titolare del copyright e/o dei relativi aventi diritto.","Text_DuplicateFontsConfirm":"I seguenti caratteri potrebbero essere identici. Conferma.","Text_Uploaded":"Foto caricata","Button_ConfirmUpload":"Conferma upload","Text_FontsCannotUpload":"Impossibile caricare i seguenti font","Button_ReUpload":"Carica di nuovo","Message_MaxFontUpload":"Puoi caricare fino a 20 file di font alla volta","Message_UploadSuccess":"Caricato","Text_FontUploading":"Caricamento dei caratteri...","Tip_FontUsageRight":"Attenzione: Assicurati di disporre dei diritti per utilizzare il carattere e di una licenza commerciale.","Title_FriendlyTip":"Promemoria amichevole","Text_TemplateMigrated":"I modelli della Libreria dei modelli sono stati spostati in Progetti. Vai a Progetti per visualizzare i modelli del team.","Button_GoNow":"Entra ora","Tab_FontLib":"Libreria dei caratteri","Tip_SwitchIdentityHint":"Tocca la tua immagine del profilo nell\'angolo in alto a destra per passare dal profilo Personale a quello Team.","Text_IdentityResourcesIndependent":"Le risorse di design (come la cronologia delle modifiche) sono separate per ogni identità","Text_IdentitySwitched":"Account cambiato","Text_DefaultTeamName":"Team di ${0}","Message_FillTeamInfo":"Inserisci tutte le informazioni del team","Message_TeamNameMaxLength":"Inserisci il nome del team o dell\'azienda (max 20 caratteri)","Title_CreateTeam":"Crea un team","Label_TeamName":"Nome del team","Placeholder_TeamName":"Inserisci il nome del team","Button_FreeCreate":"Crea gratis","Tip_TeamNameEditable":"Il nome del team può essere cambiato in qualsiasi momento","Text_EnjoySvipRights":"Usufruisci dei vantaggi SVIP","Text_TeamPermissionMgmt":"Gestione autorizzazioni del team","Text_MemberFolderCollab":"Collaborazione sulle cartelle dei membri","Text_TeamExpired":"Il team è scaduto","Text_RenewToUse":"Rinnova o aggiorna per continuare a usarlo.","Text_VipTeamRights":"Vantaggi VIP del team","Text_ViewDetailRights":"Visualizza i dettagli dei vantaggi","Button_SwitchPersonal":"Passa al profilo personale","Text_Frozen":"Il tuo account è stato sospeso.","Text_MemberOverLimit":"Limite membri superato","Text_ContactOwner":"Contatta il proprietario del team per continuare a usarlo.","Text_TeamNoSupport":"Questa funzione non è ancora disponibile per gli account team/aziendali.","Text_SwitchToPersonalHint":"Passa a Personale se necessario","Button_SwitchToPersonal":"Passa alla versione personale","Text_FeatureNotAvailable":"Questa funzione non è al momento disponibile.","Text_ReloginPersonal":"Accedi di nuovo con un account personale per usare questa funzione.","Button_BackHome":"Casa","Text_PersonalEdition":"Personale","Text_TeamEdition":"Team","Text_EnterpriseEdition":"Piano Enterprise","Text_FreeEdition":"Gratuito","Text_RemovedFromTeam":"Sei stato rimosso dal team","Text_RejoinTeamHint":"Per rientrare nel team","Text_ContactOwnerToInvite":"Contatta il proprietario o l\'amministratore per ricevere un invito","Button_SwitchOtherIdentity":"Passa a un altro account","Button_FreeCreateTeam":"Crea un team gratuitamente","Text_SelectIdentity":"Seleziona ruolo account","Text_SelectTeamIdentity":"Seleziona un ruolo del team","Text_EditingSaveLocation":"Se è in corso una modifica, i tuoi record di modifica/generazione verranno salvati nello spazio di ${0}.","Text_CreateNewTeamFree":"Crea gratis un nuovo team","Text_MemberCount":"${0} clienti","Text_SavedToHelloDigitalAsset":"Salvato in HelloRF Digital Assets","Text_Admin":"Amministratore","Text_Member":"Membro","Title_FreeMemberLimit":"Il piano gratuito supporta fino a ${0} membri","Title_SeatInsufficient":"Posti dell’abbonamento insufficienti","Button_UpgradeTeam":"Passa a Team","Button_AddSeat":"Aggiungi postazioni","Text_UpgradeForMoreSeats":"Passa all\'abbonamento Team per aumentare il limite di posti","Text_AddSeatToInvite":"Aggiungi altre postazioni per invitare più membri.","Title_InviteMember":"Invita","Text_InviteSeatRemaining_Free":"Puoi invitare gratis altri ${0} membri a unirsi al team","Text_InviteSeatRemaining":"Puoi invitare altri ${0} membri a unirsi al team","Text_ShareDesignAssets":"Condividi progetti ed elementi di design","Text_ShareVipAndCredits":"Condividi il tuo abbonamento e i crediti per la generazione AI","Text_InvitedUserPermission":"Autorizzazioni dell\'utente invitato:","Text_NoInvitePermission":"Solo i proprietari o gli amministratori del team possono invitare altre persone. Non hai ancora l\'autorizzazione per invitare persone nel team.","Text_RemainingCount":"Rimanenti: <span>${0}</span>","Button_RedeemMemberDays":"Riscatta un abbonamento di <span>${0}</span> giorni","Desc_InviteReward_DesignKit":"Iscriviti subito a Meitu DesignKit e ottieni un totale di <strong>80 crediti</strong> per la generazione e la modifica di immagini. Riceverai anche uno sconto sull\'abbonamento, con <strong>fino a ¥22 di sconto.</strong>","Text_ClickTopRight":"Fai clic sull\'<span class=\\"primary\\">angolo in alto a destra</span> del sito web","Option_SetEditable":"Imposta come modificabile","Option_SetViewable":"Imposta come visualizzabile","Option_Reject":"Rifiuta","Message_BindSuccessPermissionAdjusted":"Collegamento riuscito. Autorizzazioni aggiornate","Message_ModifyFailedBindPhone":"Aggiornamento non riuscito. Associa un numero di telefono, poi riprova.","Text_AskersApplyAccess":"Accesso richiesto da ${0} e altre ${1} persone","Text_PersonalUser":"Utenti personali","Text_ApplyAccess":"Richiedi accesso","Option_Viewable":"Visualizza","Option_Editable":"Modifica","Option_Manageable":"Gestibile","Text_Invited":"Invitato","Text_NoSearchResult":"Nessun risultato","Title_AddCollaborator":"Aggiungi collaboratore","Placeholder_AddCollaboratorByName":"Inserisci il nome di un membro per aggiungere collaboratori","Title_Recommend":"Consigliato","Text_PeopleCount":"${0} clienti","Message_BindSuccessCollaboratorAdded":"Collegamento riuscito. Collaboratore aggiunto","Message_AddFailedChangePermissionOrBindPhone":"Impossibile aggiungere. Modifica l\'autorizzazione in \\"Può visualizzare\\" o collega il tuo numero di telefono, quindi riprova.","Message_SelectAtLeastOneCollaborator":"Seleziona almeno un collaboratore!","Message_ShareSuccess":"Condiviso con successo!","Tip_AddCollaboratorDirectAccess":"Una volta aggiunti, potranno accedervi direttamente da \\"Condivisi con me\\" senza link.","Text_TotalPeople":"${0} persone","Option_Remove":"Rimuovi","Tip_PermissionChangedToEdit":"L\'autorizzazione effettiva di questo collaboratore è stata modificata in Può modificare","Tip_AnyoneWithLinkCanEdit":"Perché chiunque abbia il link può modificare","Tip_TeamMemberWithLinkCanEdit":"Perché i membri del team con il link possono modificarlo.","Title_CollaboratorManage":"Gestione collaboratori","Tag_OutsideTeam":"Fuori dal team","Title_RemoveKeepTeamMembers":"Dopo la rimozione, solo i collaboratori attualmente nel team potranno continuare ad accedervi.","Title_RemoveOnlySelfAccess":"Dopo la rimozione, solo tu potrai accedervi.","Option_OnlyCollaborators":"Solo collaboratori","Option_OnlySelf":"Solo io","Text_OthersNeedApply":"(Gli altri devono richiedere l\'accesso)","Option_PermissionUnchanged":"Autorizzazioni invariate","Option_TeamMembers":"Membri del team","Text_TeamMembersViaLink":"Membri del team tramite link","Option_Anyone":"Chiunque","Text_AnyoneViaLink":"Chiunque abbia il link","Text_UntitledDesign":"Design senza nome","Message_BindSuccessLinkCopied":"Collegamento riuscito. Link di condivisione copiato","Message_ShareFailedChangePermissionOrBindPhone":"Condivisione non riuscita. Imposta l\'autorizzazione su \\"Può visualizzare\\" o collega un numero di telefono per condividere.","Text_LinkUpdating":"Aggiornamento del link...","Tip_FolderShareTeamOnly":"Le cartelle possono essere condivise solo con i membri del team.","Text_CollaboratorCount":"Collaboratori: ${0}","Button_Manage":"Gestisci","Tooltip_PartialPermissionChanged":"Le autorizzazioni di alcuni collaboratori sono state modificate","Tip_FolderLinkVisitorBecomeMember":"Gli utenti che accedono alla cartella tramite il link diventeranno automaticamente membri del tuo team.","Tip_OnlyTeamMembersCanAccess":"Al momento, solo i membri del team possono accedervi","Tip_InviteUserNotInTeam":"Se l\'utente con cui vuoi condividere non si è ancora unito al team,","Button_InviteMember":"Invita","Text_ShareLinkView":"${0}#Ho condiviso ${1}. Tocca per visualizzare","Text_ShareLinkJoin":"${0} ti invita a unirti a ${1}. Tocca per partecipare.","Text_ShareLinkApplyVisit":"${0}#Richiedo l\'accesso a ${1}. Tocca per gestire la richiesta.","Text_ShareLinkApplyEdit":"${0}#Ho richiesto di modificare [${1}]. Tocca per gestire la richiesta.","Option_7Days":"7 giorni","Option_30Days":"30 giorni","Option_Permanent":"Permanente","Text_Slogan_DesignKit":"Uno strumento indispensabile per professionisti dell\'e-commerce","Button_RemoveNonTeamCollaborator":"Rimuovi collaboratori esterni","Button_RemoveNonPersonalCollaborator":"Rimuovi i collaboratori non individuali","Text_freePlan_Zawa":"Gratuito","Text_standardPlan_Zawa":"Plus","Text_proPlan_Zawa":"Pro","Text_maxPlan_Zawa":"Max","Tool_IDPhoto":"Foto d\'identità","Tool_PortraitPhoto":"Foto del profilo","Tool_ImageBatchProcess":"Elaborazione immagini in gruppo","Tool_AiShoes":"Modello per calzature","Tool_AiCopywriting":"Copywriting AI","Tool_AiPoster":"Poster AI","Tool_OnlineDesign":"Design online","Tool_ClothesDewrinkle":"Rimuovi le pieghe dai vestiti","Tool_PortraitBackground":"Sfondo","Tool_ViralVideo":"Generatore di video prodotto","Tool_AiPosterNote":"Note con immagini e testo AI","Title_WholeProductClone_DomesticCloneCase":"Riutilizza l\'intero set di prodotti","Title_ApparelClone_DomesticCloneCase":"Riutilizza gli outfit con facilità","Title_PosterCoverClone_DomesticCloneCase":"Riutilizza la copertina del poster","Prompt_PosterThemeChange_DomesticCloneCase":"Istruzioni per ricreare: Trasforma in un poster a tema città","Title_SocialGraphicsClone_DomesticCloneCase":"Riutilizzo di post social con un tocco","Prompt_SocialThemeChange_DomesticCloneCase":"Istruzioni per ricreare: Converti in un post con immagini e testo a tema viaggio a Xiamen","Title_CloneType_LeftPanelClone":"Tipo di riutilizzo","Text_CloneReferenceUploadLimitTip_Clone":"Aggiungi fino a ${0} immagini: ogni riferimento genera 1 risultato.","Option_MatchStyle_Clone":"Abbina stile","Option_MatchReference_Clone":"Abbina al riferimento","Message_ClaimFailed":"Al momento non puoi riscattare questo vantaggio. Riprova più tardi.","Message_RedeemFailed":"Riscatto non riuscito. Riprova più tardi.","Button_UpgradeTeamVip":"Passa all\'abbonamento Team","Message_SystemError":"Qualcosa è andato storto. Riprova più tardi.","Label_AgentTeam":"Team","Desc_AgentTeamBanner":"Entra in modalità Team di AI Agent, dove gli esperti fanno squadra automaticamente per gestire l’intera pianificazione e il design visivo con un solo prompt.","Text_SearchResultCount":"Risultati di ricerca · ${0} risultati","Button_ExitAdmin":"Esci dalla gestione","Text_InviteReward":"Vantaggi dell\'invito","Button_More":"Altro","Text_TeamExpiredTip":"Questo team è scaduto. Puoi solo visualizzare e spostare gli elementi all\'interno del team. Rinnova o effettua l\'upgrade per continuare a usare tutte le funzionalità.","Text_TeamFrozenTip":"Questo team ha superato il limite di membri. Il tuo account è stato sospeso. Contatta il proprietario del team per continuare a usarlo.","Desc_ImageEdit":"Importa un\'immagine e inizia a modificarla","Desc_ViralVideo":"Genera in blocco diversi tipi di video virali con un solo clic","Desc_ProductImageSet":"Genera un set completo di immagini prodotto per e-commerce con un clic","Title_RecommendTools":"Strumenti consigliati","Button_CloseVideoPreview":"Disattiva anteprima video","Label_PromptDesc":"Descrizione del prompt","Tab_Preview":"Effetto","Tab_Report":"Report di analisi","Button_Preview":"Anteprima","Button_PrevPage":"Indietro","Button_NextPage":"Successivo","Text_LoadingHard":"Caricamento...","Button_ReplicateOne":"Ricrea con AI","Text_EmptyContent":"Nessun elemento trovato","Text_Today":"Oggi","Text_Tomorrow":"Domani","Text_Yesterday":"Ieri","Text_DaysLater":"Tra ${0} giorno/i","Text_DaysAgo":"${0} giorni fa","Desc_CreateDesign":"Inizia con una tela vuota","Title_ClaimSuccess":"Richiesto","Text_VipExpiry":"Validità VIP:","Title_ClaimFailed":"Impossibile riscattare","Button_GoDesign":"Crea ora","Title_ClientDownload":"Download del client","Desc_DesignKitApp":"Sincronizza la cronologia delle creazioni tra telefono e computer per progettare in modo efficiente, sempre e ovunque","Title_MeituXiuxiuPC":"Meitu PC","Desc_MeituXiuxiuPC1":"Un editor fotografico per la vita quotidiana e il lavoro","Desc_MeituXiuxiuPC2":"E strumenti di design facili da usare!","Button_DownloadNow":"Scarica ora","Text_Pending":"In attesa di pagamento","Text_MoreFunctions":"Formati multipli","Text_NoMessages":"Nessun messaggio trovato","Tab_SystemMessage":"Messaggi di sistema","Tab_Notification":"Notifiche","Button_MarkAllRead":"Segna tutto come letto","Label_Folder":"Cartella","Label_Record":"Cronologia modifiche","Label_Template":"Template","Text_RequestAccess":"Richiedi l\'accesso","Text_EditViewDownload":"(Modifica, Visualizza, Scarica)","Text_ViewDownloadOnly":"(Solo visualizzazione e download)","Text_TeamRenewSuccess":"Il tuo abbonamento Team è stato rinnovato correttamente","Text_TeamRenewExpiredTip":"Rinnova ora per sbloccare l’accesso illimitato a template commerciali aziendali, elementi e funzionalità esclusive per tutto il team.","Label_SystemNotice":"Notifica di sistema","Label_PromptTutorial":"Tutorial sui prompt","Label_BrandSpec":"Linee guida del brand","Label_ContactBusiness":"Contatta il reparto vendite","Text_ScanConsultant":"Scansiona per contattare un consulente dedicato al team","Tab_Project":"Progetto","Placeholder_SearchProject":"Inserisci il nome di un progetto o parole chiave","Placeholder_SearchRecipe":"Inserisci il nome del template o del modello","Placeholder_SearchTemplate":"Inserisci parole chiave del template o il nome della funzione","Title_HotTools":"Strumenti di tendenza","Title_HotTemplates":"Template di tendenza","Title_PosterTemplate":"Template di design grafico","Text_NotFoundTemplate":"Non trovi un template che ti piace? Clicca qui","Button_Feedback":"Feedback","Button_ViewAllTemplates":"Visualizza tutti i template","Tooltip_OpenNewTab":"Apri in una nuova scheda","Button_BookDemo":"Prenota una demo","Title_ApplyTeamDemo":"Richiedi una demo per il team","Desc_ContactWithinOneDay":"Dopo l\'invio delle tue informazioni, ti contatteremo entro 1 giorno lavorativo.","Title_LeaveContactInfo":"Lascia i tuoi dati di contatto per ricevere un supporto 1:1 migliore.","Title_FreeTeamVipSurvey":"Inserisci i dati del tuo team per ottenere 7 giorni gratis di abbonamento Team","Label_SingleUser":"Uso individuale","Text_MemberCountRange":"${0}~${1} clienti","Text_MemberCountRangeDash":"${0}-${1} persone","Text_MemberCountOrMore":"${0}+ persone","Label_TemplateReuse":"Carica e riutilizza i template","Label_MultiCollaboration":"Modifica collaborativa","Label_EnterpriseLicense":"Licenza commerciale Enterprise","Label_SharedCredits":"Crediti e ritagli condivisi dal team","Label_BrandManagement":"Gestione delle specifiche del brand","Label_YourName":"Il tuo nome","Message_PleaseEnterName":"Inserisci il tuo nome","Label_YourPhone":"Il tuo numero di cellulare","Message_PleaseEnterPhone":"Inserisci il tuo numero di cellulare o fisso","Message_PleaseEnterValidPhone":"Inserisci un numero di cellulare valido","Label_CompanyName":"Nome dell\'azienda","Message_PleaseEnterCompanyName":"Inserisci il nome della tua azienda","Placeholder_EnterCompanyName":"Inserisci il nome della tua azienda","Label_ProductUsers":"Numero di persone che useranno il prodotto","Message_PleaseSelectProductUsers":"Seleziona il numero di persone che useranno il prodotto","Label_TeamCapabilitiesInterest":"Quali funzionalità di Posters Team ti interessano di più?","Text_MultiSelectParen":"(Scelta multipla)","Message_PleaseSelectCapabilities":"Seleziona le funzionalità di Meitu Design Studio che vuoi conoscere meglio","Placeholder_TeamCapabilities":"Protezione del copyright commerciale, Vantaggi condivisi per più utenti, Gestione delle risorse digitali, Collaborazione in team, Altro","Button_Submit":"Invia","Desc_ManagerWillContact":"Il tuo account manager dedicato ti contatterà entro 1–2 giorni lavorativi. Assicurati di essere reperibile al telefono.","Title_ScanToInvoice":"Scansiona il codice QR con il browser del tuo smartphone per ottenere una fattura","Text_InvoiceOrderScope":"Usa questo link per richiedere una fattura per gli ordini di Meitu Design Studio.","Text_TransferInvoiceContact":"Per gli ordini aziendali pagati tramite bonifico bancario, fai clic su Contatta nell’angolo in basso a destra per richiedere l’emissione.","Desc_MenuProjectGuide1":"[Il mio spazio] e [Condivisi con me]","Desc_MenuProjectGuide2":"Ora tutto è organizzato in Progetti","Text_SetPrefix":"Imposta come","Text_TodayWithTime":"Oggi ${0}","Text_YesterdayWithTime":"Ieri ${0}","Format_MonthDay":"D M","Format_YearMonthDay":"D/M/YYYY","Text_MultiPage":"Pagine multiple","Text_PageCount":"${0} pagine","Text_ViewOnly":"Solo visualizzazione","Text_NoPermission":"Nessun accesso","Button_JumpToStorage":"Vai alla posizione di archiviazione","Label_PageUnit":"Pagina","Label_JumpTo":"Prova adesso","Text_TotalDataCount":"${0} elementi","Title_RelateRecommend":"Consigliato","Title_HotSearch":"Ricerche popolari","Title_LatestMaterial":"Elementi più recenti","Title_TopicList":"Argomenti popolari","Title_ArticleList":"Articoli popolari","Title_ToolList":"Strumenti popolari","Text_AccountOnePerson":"Account: 1 persona","Text_AccountTenMin":"Account: minimo 10 utenti","Text_LetsTalk":"Iniziamo a chattare","Text_NewUserExperience":"Esperienza per nuovi utenti","Text_Buy12Months":"Acquista 12 mesi","Text_LinkExpired":"Questo link non è disponibile","Text_ContactAdminToJoin":"Contatta l\'amministratore per unirti","Desc_JoinOrgCollaboration":"Unisciti all\'organizzazione e inizia a collaborare in modo efficiente con il tuo team","Button_AcceptInvite":"Accetta l\'invito","Title_ConfirmNickname":"Conferma il tuo nickname per il team","Placeholder_NameWithin20":"Inserisci un nome di massimo 20 caratteri","Desc_NicknameHelp":"Il tuo soprannome aiuta i colleghi a trovarti più facilmente.","Title_TeamVipExpired":"Abbonamento del team scaduto","Title_TeamSeatsInsufficient":"Posti insufficienti per l\'abbonamento Team","Button_SeatAssignment":"Assegnazione postazioni","Text_MemberSeatCount":"Membri/Postazioni:","Text_FreeSeatsFrozen":"I membri oltre il limite di postazioni gratuite sono stati congelati","Desc_RenewTeamForAll":"Per mantenere l\'accesso per tutti i membri, rinnova il tuo abbonamento Team.","Text_SeatsExceededFrozen":"I membri che superano il limite di posti sono stati sospesi.","Desc_AddSeatsForAll":"Per consentire l\'accesso a tutti, acquista postazioni aggiuntive per l\'abbonamento Team.","Title_TeamToolUnsupported":"Questo strumento non è supportato in Posters Team Edition.","Desc_SwitchPersonalToUse":"Per usare questo strumento, passa alla versione personale.","Label_RegularTemplate":"Template standard","Label_Suite":"Imposta","Label_Filter":"Filtra","Label_Sort":"Ordine","Label_Scene":"Scenario","Label_Materials":"Materiali","Label_Purpose":"Utilizza","Label_Industry":"Settore","Label_Color":"Colore","Label_Format":"Layout","Label_Category":"Categoria","DesignKit":"Meitu Design Studio","Placeholder_SearchTemplateMobile":"Cerca template","Label_DesignType":"Tipo di design","Label_TemplatePurpose":"Scopo del template","Label_TemplateStyle":"Stile template","Label_TemplateColor":"Colori del template","Label_ApplicableIndustry":"Settori applicabili","Label_TemplateSize":"Dimensione del template","Label_UsageThreshold":"Adatto anche ai principianti","Label_TemplateNumber":"Numero template","Desc_ScrollViewAllPages":"Scorri verso l\'alto o verso il basso per vedere tutte le pagine","Title_SimilarPosterRecommend":"Poster simili consigliati","Button_EditCurrentTemplate":"Modifica il template corrente","Button_EditAllTemplates":"Modifica tutti i modelli","Button_EditNow":"Modifica ora","Title_RecordUpgrade":"Nuovi aggiornamenti disponibili!","Desc_RecordUpgrade1":"Include tutti i modelli di poster e la cronologia di modifica delle foto di questo account. Passa senza interruzioni dalla modifica delle foto alla creazione di poster.","Desc_RecordUpgrade2":"Passa senza interruzioni dalla modifica delle immagini alla creazione di poster.","Footer_AboutUs":"Chi siamo","Footer_JoinUs":"Unisciti a noi","Footer_ContributeCenter":"Centro contributori","Title_HomeAgentTeam":"Team di agenti AI - Design aziendale bello ed efficace","Title_HomeChat":"Dimmi cosa vorresti creare.","Nav_Home":"Home","Title_BrandManagement":"Gestione della marca","Nav_HelpDesign":"Crea per me","Title_OrgInfo":"Informazioni sull\'organizzazione","Title_MemberManage":"Gestione membri","Title_DataDashboard":"Dashboard dei dati","Title_CommercialAuth":"Uso commerciale senza pensieri","Title_OrderInvoice":"Fattura dell\'ordine","Title_TeamCollaboration":"Collaborazione in team","Title_CopyrightGallery":"Galleria foto con copyright","Title_DownloadCenter":"Centro download","Nav_TodayRecommend":"Consigliati oggi","Nav_HotCalendar":"Festival","Nav_InspirationFormula":"Template di ispirazione","Nav_OneClickSame":"Derivati","Title_PosterTemplateNav":"Template di poster","Message_NetworkError":"Errore di rete: impossibile connettersi al server.","Text_Downloading":"Download delle risorse in corso","Text_DownloadResourceFailed":"Impossibile scaricare le risorse","Title_DesignKitScanLogin":"Meitu Design Studio Scansiona per accedere","Desc_ScanGuideLogin":"Vai alla sezione Io e tocca \\"Scansiona\\" in alto a destra per accedere","Message_AlreadyFullVip":"Hai già tutti i vantaggi dell\'abbonamento. Non è necessario acquistare.","Message_ImageSizeExceeded":"Limite dimensione immagine superato","Text_NotLoggedIn":"Non è stato effettuato l\'accesso","Button_CreateBrandSpec":"Crea specifiche","Title_BrandAdvQuestion":"Chiedi ancora ai colleghi logo, font e valori dei colori del brand?","Desc_BrandAdv1":"Logo preimpostati dai designer, Codici colore del brand, Stile testo, Libreria caratteri","Desc_BrandAdv2":"Configura le linee guida visive per diversi brand o progetti.","Desc_BrandAdv3":"I membri del team di diversi reparti possono aggiungere e applicare rapidamente le specifiche nell’editor","Button_UpgradeTeamForBrand":"Passa all\'abbonamento Team per usare subito le linee guida del brand","Title_ConfirmDeleteBrandGroup":"Eliminare questo set di standard?","Text_DeleteBrandNoAffect":"La cronologia delle modifiche applicate non sarà interessata.","Button_CreateBrandStandard":"Crea linee guida del brand","Title_DeleteHint":"Elimina immagine","Text_DeleteIrreversible":"Una volta eliminato, non potrà essere recuperato. Procedi con cautela.","Label_General":"Generale","Label_ColorCard":"Scheda colore","Label_TextStyle":"Stile del testo","Message_SavePrevStyle":"Salva lo stile precedente","Message_SavePrevColorCard":"Salva prima la scheda colore precedente","Message_SavePrevElement":"Salva prima l\'elemento precedente.","Button_NewColorCard":"Crea tonalità","Button_NewStyle":"Crea stile","Message_NameWithinN":"Inserisci un nome (max ${0} caratteri)","Message_ColorBlockLimit":"Ogni palette di colori supporta fino a ${0} campioni colore","Message_PleaseSelectFont":"Seleziona un carattere","Message_PleaseSelectFontSize":"Seleziona una dimensione del carattere","Placeholder_FontSize":"Dimensione del testo","Label_Bold":"Grassetto","Label_Italic":"Corsivo","Text_FontSizeUnit":"N. ${0}","Text_Claiming":"Richiesta in corso...","Button_ClaimFreeBenefit":"Ottieni vantaggi gratuiti","Message_MissingExchangeCode":"Codice di riscatto mancante","Message_SwitchToPersonalFirst":"Passa prima a Personale","Desc_ClaimBenefitSuccess":"Hai già riscattato questo vantaggio. Vai su Meitu Posters e inizia a creare!","Message_ClaimNewUserOnly":"Questo vantaggio gratuito è disponibile solo per i nuovi utenti alla prima registrazione.","Text_AiDesignTagline":"Design IA a portata di mano","Text_FreeBenefitLimited":"Ottieni vantaggi gratuiti a tempo limitato","Text_ExchangeSceneFeatures":"Poster commerciali · Immagine principale e-commerce · Rimozione AI · Ritaglio AI","Text_LimitedNewUserOnly":"Offerta a tempo limitato, solo per nuovi utenti","Text_SearchWithKeyword":"Cerca \\"${0}\\"","Text_HelpEmptyHint":"Non ci sono ancora contenuti. Xiaomei ne aggiungerà altri presto.","Placeholder_HelpSearch":"Cosa vorresti sapere?","Button_Search":"Ricerca","Message_SelectImageForTranslation":"Seleziona un\'immagine prima di usare Traduzione immagine.","Text_InviteCopyPrefix":"# Non perdere più tempo con le immagini per e-commerce! Registrati a Meitu Designer e ricevi subito crediti gratuiti. Set di prodotti, pagine dettaglio, video promozionali e molto altro: genera tutto con un clic. Fai clic sul link per iniziare a creare!","Label_DistributionAgreement":"Accordo per il servizio di distribuzione di Meitu Design Studio","Label_DistributionConduct":"Codice di condotta sulle commissioni del servizio di affiliazione di Meitu Design Studio","Alt_InviteFriendIcon":"Icona per invitare gli amici","Alt_BothGetBeanIcon":"Icona crediti per entrambi","Text_BothGetBean":"Entrambi ricevono crediti","Alt_FriendFirstOrderIcon":"Icona del primo ordine completato dall\'amico","Text_FriendFirstOrder":"L’amico completa il primo ordine","Alt_RedPacketIcon":"Icona Red Packet ricevuto","Text_RedPacketArrived":"Pacchetto rosso ricevuto","Desc_InviteRule1":"1. Quando un amico che hai invitato si registra con successo, riceverete entrambi 40 Crediti. Usali per generare immagini o modificare foto. Validi per un mese.","Desc_InviteRule2":"2. Puoi invitare fino a 15 amici.","Desc_InviteRule3":"3. Ottieni cashback quando un amico si abbona. Calcolo della ricompensa: Importo della ricompensa = importo effettivamente pagato × percentuale della ricompensa (ad es., se un amico acquista un abbonamento annuale con rinnovo automatico, puoi ricevere una ricompensa in denaro di 196 × 15% = 29,4 USD). Le ricompense possono essere modificate durante eventi speciali o promozioni; farà fede l\'importo effettivamente accreditato.","Desc_InviteRule4":"4. Se i crediti del piano o eventuali crediti bonus sono stati utilizzati, l\'acquisto non può essere annullato, rimborsato o cambiato.","Desc_InviteRule5":"5. Gli utenti che hanno già un account registrato, si invitano da soli, creano account duplicati o svolgono attività fraudolente non avranno diritto alle ricompense.","Desc_InviteRule6":"6. Meitu Design Studio si riserva il diritto di modificare la campagna e revocare i premi dagli account anomali.","Message_SwitchToPersonal":"Passa al profilo personale","Message_GetInviteLinkFailed":"Impossibile ottenere il link di invito.","Message_InviteLinkRetry":"Impossibile ottenere il link di invito. Riprova più tardi.","Message_CopySuccess":"Copiato!","Message_CopyFailedManual":"Copia non riuscita. Copia il link manualmente.","Text_LoginForInviteLink":"Accedi prima per ottenere il link di invito","Text_SwitchPersonalForInviteLink":"Passa al tuo profilo personale per ottenere il link di invito","Alt_InviteRewardTitle":"Invita gli amici per ottenere crediti e abbonati per ricevere cashback","Alt_InviteHeroVisual":"Visual principale per il cashback Invita gli amici","Button_CopyInviteLink":"Copia il link di invito.","Alt_ActivityRules":"Regole dell\'attività","Desc_InviteRewardSummary":"Invita gli amici a registrarsi: tu e ogni amico riceverete 40 credit ciascuno. Puoi ottenere fino a 600 credit. Il tuo amico riceverà anche uno sconto a tempo limitato sull\'abbonamento di 7 giorni. Se il tuo amico si abbona a Meitu Design Studio durante la promozione, riceverai un cashback.","Text_CommissionRate15":"Commissione fino al 15%!","Text_DetailRules":"Regole dettagliate","Alt_CashoutTutorial":"Guida al prelievo","Desc_InviteDetailAppPath":"Vai nell\'app Meitu Design Studio > Io > Invita e guadagna > Portafoglio guadagni per visualizzare i dettagli dei tuoi inviti.","Desc_InviteDetailAppPathShort":"Vai all\'app Meitu Design Studio > Io > Invita e guadagna > Portafoglio guadagni per visualizzare i dettagli degli inviti.","Desc_InviteSettlementCycle":"Ciclo di liquidazione: Gli ordini di abbonamento vengono liquidati un mese dopo la data dell\'ordine. Questo periodo di un mese è il periodo di ripensamento per i rimborsi. Durante questo periodo, le commissioni degli ordini rimborsati non possono essere prelevate. Al termine del periodo di ripensamento, è possibile prelevare la quota di ricavi degli ordini corrispondenti.","Button_LoginToGet":"Accedi per ottenere","Button_ClaimNow":"Richiedi ora","Title_SameStyleReplicate":"Ricrea questo look 🌟","Text_PageNotFound":"Pagina non trovata","Label_PricingPlan":"Prezzi","Title_ChooseMembershipPlan":"Scegli il piano di abbonamento più adatto a te","Tab_RenewalYear":"Rinnovo annuale","Tab_RenewalMonth":"Abbonamento mensile con rinnovo automatico","Tab_SingleYear":"Acquisto annuale","Tab_SingleMonth":"Acquisto di 1 mese","Text_MeidouPerMonth":"${0} crediti/mese","Title_PersonalVipOnly":"Questo abbonamento è disponibile solo per gli account personali. Passare a Personale?","Button_Switch":"Cambia","Text_ComingSoon":"In arrivo","Button_SubscribeNow":"Abbonati ora","Text_MostPopular":"Con più like","Text_Trial7DaysPerYear":"Prova 7 giorni (${0}/anno)","Label_Year":"Anno","Text_StartingFrom":"Inizia","Label_DesignRecord":"Design","Label_AgentRecord":"Record agente","Button_ViewMore":"Visualizza di più","Placeholder_PleaseEnterContent":"Inserisci il contenuto","Text_InviteLinkExpired":"Questo link non è disponibile.","Text_RegenerateInviteLink":"Contatta il tuo amministratore per rigenerare il link di invito.","Text_JoinedSuccess":"Ti sei unito con successo","Text_UseTeamOnPc":"Visita ${0} dal computer per creare con il tuo team","Button_CopyUrl":"Copia URL","Text_InviteYouToJoin":"\\"${0}\\" ti invita a unirti","Button_JoinNow":"Unisciti ora","Title_TemplateCenter":"Centro modelli","Text_NoSuchTemplate":"Non ci sono ancora modelli di questo tipo. Ne aggiungeremo altri presto.","Title_DesignKitHome":"Homepage dei poster","Label_Tags":"Etichetta","Button_DownloadAppToEdit":"Scarica l\'app X-Design per modificare","Title_DesignKitTeam":"X-Design ${0}","Desc_TeamLandingQuestion":"I progetti dipendono interamente dai designer. Come migliorare l\'efficienza del team di design?","Button_UseNow":"Utilizza ora","Text_ViewTeamIntro":"Visualizza la panoramica completa del team","Button_ViewPricing":"Visualizza i prezzi","Button_EnterTeamNow":"Entra ora","Title_EnterpriseSolution":"Scopri di più sulle soluzioni aziendali","Desc_EnterpriseContactForm":"Compila il modulo e il team di Meitu Posters ti contatterà entro 1-3 giorni lavorativi.","Message_CompanyNameMaxLength":"Il nome dell\'azienda deve contenere al massimo 100 caratteri.","Label_Position":"Posizione lavorativa","Message_PleaseEnterPosition":"Inserisci il tuo ruolo attuale in questa azienda","Placeholder_EnterPhone":"Inserisci il numero di telefono","Placeholder_EnterPosition":"Inserisci il tuo ruolo attuale in questa azienda","Label_ExpectedUsers":"Utenti stimati","Title_TeamMaterialEasier":"Crea risorse del team più facilmente","Label_CommercialTemplate":"Scegli qualsiasi template commerciale","Desc_CommercialTemplate":"Le aziende autorizzate possono modificare e pubblicare un\'ampia gamma di template ed elementi per un uso commerciale senza pensieri.","Label_BatchDesignSpeed":"Accelera la progettazione in batch","Desc_BatchDesignSpeed":"Scontorno in gruppo, modelli e produzione automatica di immagini ti fanno risparmiare tantissimo tempo.","Label_VisualStandard":"Specifiche visive unificate","Desc_VisualStandardWork":"Palette colori preimpostate, stili di carattere e altre linee guida per garantire uno stile di design del brand coerente.","Desc_VisualStandardHome":"Palette di colori preimpostate, stili di testo e altre linee guida (con supporto per il caricamento dei font) per mantenere coerenti i progetti.","Title_TeamCollabEfficient":"Design collaborativo più efficiente","Label_TeamSharedResource":"Risorse condivise del team","Desc_TeamSharedResource":"Condividi cartelle per reparto o progetto con un clic e crea rapidamente una libreria di risorse di design.","Label_FlexiblePermission":"Impostazioni flessibili delle autorizzazioni","Desc_FlexiblePermission":"Imposta autorizzazioni flessibili per ogni file per evitare la divulgazione delle risorse di design.","Label_TemplateQuickReuse":"Riutilizzo rapido dei modelli","Desc_TemplateQuickReuse":"Carica i file PSD nella libreria dei template per riutilizzarli rapidamente in tutto il team. Niente più attese per i file.","Title_TeamManageEasier":"Gestisci facilmente membri e risorse","Label_TeamDataReview":"Analisi dei dati del team","Desc_TeamDataReview":"Controlla regolarmente l\'attività di creazione dei membri nel backend e modifica le postazioni del team in base alle esigenze.","Label_MemberRoleManage":"Gestione ruoli membri","Desc_MemberRoleManage":"Imposta gli amministratori del team, gestisci le modifiche ai membri e occupati del passaggio di consegne degli asset.","Tag_ConvenientCreate":"Creazione semplice","Desc_FreeEditionAudience":"Disponibile per utenti individuali e team","Desc_FreeTemplateMaterial":"Template/elementi gratuiti","Desc_PartialFreeTools":"Strumenti intelligenti (alcuni gratuiti)","Button_FreeExperience":"Prova gratuita","Tag_QualityContent":"Contenuti di alta qualità","Desc_PersonalEditionAudience":"Per commercianti individuali, designer o creator indipendenti","Desc_IncludesFreeBenefits":"Include i vantaggi del piano gratuito","Desc_PaidTemplateMaterial":"Template/Elementi premium","Desc_PersonalCommercialAuth":"Licenza commerciale personale","Desc_Meidou330PerMonth":"330 crediti/mese (per strumenti di generazione AI)","Tag_EfficientCollab":"Collaborazione efficace","Desc_TeamEditionAudience":"Per piccole imprese o team di freelance che hanno bisogno di collaborare","Desc_IncludesProBenefits":"Include i vantaggi Pro (esclusa la foto d\'identità)","Desc_EnterpriseAuthOne":"Licenza commerciale*1","Desc_BrandSpecBrief":"Linee guida del brand (Logo/Scheda colore/Caratteri)","Desc_PsdTemplateUpload":"Carica template PSD","Desc_TeamDataAnalysis":"Analisi dei dati del team","Desc_TeamResourceShare":"Condivisione delle risorse creative del team","Desc_SharedPermissionManage":"Gestione delle autorizzazioni condivise","Desc_SeatsMeidouPerMonth":"Posti * 330 crediti/mese (per le funzionalità di Generazione AI)","Title_MarketingCostControl":"Costi di marketing più controllabili per la tua azienda","Label_AiPhotoCostDown":"Riduci i costi con la fotografia di prodotto AI","Desc_AiPhotoCostDown":"Immagine prodotto AI e Prova virtuale modello AI ti aiutano a creare foto curate senza sforzo, senza bisogno di set in studio o di ingaggiare modelli, così i risultati non sembreranno mai \\"a budget ridotto\\".","Label_AiEditEfficiency":"Ritocco AI","Desc_AiEditEfficiency":"Completa le regolazioni delle foto, la correzione del colore e il ritocco dei prodotti con un clic, per stare al passo con i lanci dei prodotti e ridurre i costi del ritocco manuale.","Label_SmartVideoCreate":"Creazione video AI","Desc_SmartVideoCreate":"Da immagine a video e Video commerciali 3D abbassano la soglia di creazione, così i video promozionali non sono più frenati da lunghi tempi di montaggio e alti costi di modellazione.","Text_TeamAuthSubLabel":"(L\'abbonamento Team include una licenza commerciale aziendale)","Title_MoreOptions":"Altre opzioni","Title_FreeImageCreate":"Crea immagini gratis","Desc_FreeTemplateSlashMaterial":"Template/elementi gratuiti","Desc_PartialFreeSmartTools":"Alcuni strumenti AI gratuiti","Title_IncludesPersonalPlus":"Include tutti i vantaggi del piano Personale, più:","Desc_EnterpriseBizAuthOne":"Licenza commerciale aziendale (1 entità)","Desc_TeamAssetShare":"Condivisione delle risorse del team","Desc_BrandSpecFull":"Linee guida del brand (Logo/Scheda colore/Stile del testo)","Desc_MemberAccountHandover":"Gestione degli account dei membri e trasferimento delle risorse in offboarding","Desc_TeamUsageAnalytics":"Analisi dei dati di utilizzo del team","Desc_MonthlyMeidouShared":"Ottieni ${0} crediti al mese, condivisi tra più account","Title_IncludesTeamPlus":"Include tutti i vantaggi del Team, più:","Desc_EnterpriseBizAuthThree":"Licenza commerciale Enterprise (3 entità)","Desc_CustomBrandNav":"Barra di navigazione del brand aziendale personalizzata","Desc_SsoAccess":"Integrazione SSO","Desc_MonthlyMeidou20000":"Oltre 20.000 crediti gratis al mese, condivisi tra più account","Title_OpenClawApi":"Integrazione API OpenClaw","Desc_OpenClawApi":"Accedi alle funzionalità di elaborazione immagini AI di X-Design e gestisci il tuo token API e il saldo crediti.","Title_OpenClawApiShort":"API OpenClaw","Desc_OpenClawMobile":"Gestisci il tuo Token API e il saldo crediti","Title_QuickStart":"Avvio rapido","Desc_OpenClawQuickStart":"Dopo aver completato la distribuzione di OpenClaw, invia il seguente comando a Lobster per installare automaticamente tutti i pacchetti di skill:","Button_CopyInstallConfig":"Copia configurazione di installazione","Text_SeeTutorial":"Visualizza il tutorial dettagliato","Text_DesignkitSkillsDoc":"Documentazione di designkit-skills","Title_VersionChangelog":"Aggiorna alla nuova versione","Text_NoChangelog":"Nessuna cronologia degli aggiornamenti","Message_InstallCmdCopied":"Istruzioni di installazione e Token copiati","Title_ApiToken":"Token API (AK)","Desc_ApiToken":"Usa il Token per l\'autenticazione delle richieste API. Fai clic su \\"Sostituisci\\" per generare un nuovo Token (il vecchio Token diventerà subito non valido).","Button_CopyToken":"Copia token","Button_Reset":"Altro","Button_ResetToken":"Altri Token","Text_PleaseLoginFirst":"Accedi prima.","Text_PleaseLoginDash":"Accedi prima","Title_ResetToken":"Cambia token","Desc_ResetTokenWarning":"Una volta sostituito, il vecchio token diventerà immediatamente non valido e le chiamate API in corso potrebbero non riuscire. Continuare?","Message_TokenReset":"Reset del Token","Message_TokenCopied":"Token copiato","Desc_OpenClawMeidou":"I crediti sono l\'unità di fatturazione per le chiamate API OpenClaw. Se il saldo è insufficiente, la richiesta API non riuscirà.","Label_CurrentBalance":"Saldo attuale","Button_BuyMeidou":"Acquista crediti","Button_ConsumptionRecords":"Cronologia delle spese","Title_OpenClawFeatures":"Introduzione alle funzionalità di OpenClaw","Desc_OpenClawFeatures":"Le funzionalità AI di X-Design sono ora disponibili tramite OpenClaw. Dopo l\'autenticazione AK, puoi usare direttamente le seguenti funzionalità, con addebito in crediti e rimborso automatico in caso di errore.","Desc_OpenClawProductImageSet":"Carica le immagini del prodotto e l\'AI genererà automaticamente un set di immagini prodotto conformi agli standard di più piattaforme e-commerce, pensate per aumentare le conversioni e coprire tutte le esigenze visive per la pubblicazione del prodotto.","Desc_OpenClawSmartCutout":"Con tecnologia Meitu AI, rileva con precisione il soggetto e rimuove automaticamente lo sfondo, supportando ritratti, prodotti e molti altri scenari.","Desc_OpenClawEnhanceClarity":"Ripristino qualità immagini con IA trasforma immagini sfocate o di bassa qualità in HD, con dettagli migliorati.","Button_ConfirmReset":"Conferma","Message_MeidouQuotaMinZero":"Inserisci un importo di crediti pari o superiore a 0","Message_MeidouQuotaRange":"Inserisci un importo di crediti da 0 a ${0}","Message_AssignSuccess":"Assegnato con successo!","Message_SelectAssignableMember":"Seleziona i membri a cui assegnare quote di crediti","Message_NameLength1To20":"Inserisci un nome di 1-20 caratteri","Placeholder_EnterQuota":"Inserisci crediti","Text_Unlimited":"Illimitato","Text_Unassigned":"Non assegnato","Label_MemberName":"Nome membro","Text_Me":"Io","Text_Deactivated":"Disconnettersi","Text_OverQuotaFrozen":"Bloccato per superamento del limite","Label_PhoneNumber":"Numero di telefono","Label_Role":"Ruolo","Text_Owner":"Proprietario","Label_QuotaLimit":"Limite di crediti disponibile","Message_SelectMemberCount":"Seleziona ${0} membri","Text_SelectedMemberCount":"${0} selezionati","Text_RemainingSeats":"Posti rimanenti:","Button_ConfirmAssign":"Conferma allocazione","Button_BatchSetQuota":"Imposta limite in gruppo","Title_ChangeRole":"Cambia personaggio","Button_RemoveMember":"Rimuovi un membro","Text_PartialMemberFrozenTip":"Alcuni membri hanno crediti congelati in eccesso. Riprova","Text_Or":"Oppure","Button_RenewMembership":"Rinnova","Label_RemainingMeidou":"Crediti rimanenti","Desc_MemberQuotaTip":"Suggerimento: I crediti impostati per i membri rappresentano il limite di utilizzo. La disponibilità effettiva dipende dai crediti rimanenti del team.","Text_MemberEmpty":"Nessun membro","Message_DataLoadFailed":"Impossibile caricare i dati","Title_BatchAssignMeidou":"Distribuisci i crediti in modo uniforme tra i ${0} membri selezionati","Label_AssignCount":"Clienti assegnati","Label_TotalConsumption":"Consumo totale","Title_ConfirmTransferAssets":"Trasferire le risorse?","Message_TransferAssetsSuccess":"Risorse del membro uscente trasferite con successo. Vai a controllare.","Label_MySpace":"Il mio spazio","Message_RemoveMemberProgress":"Membro rimosso con successo. Controlla l’avanzamento del trasferimento delle risorse.","Message_RemoveMemberSuccess":"Membro rimosso con successo","Title_RemoveMember":"Rimuovi un membro","Text_RemovingStep1":"Rimozione...","Text_AssetHandleStep2":"2. Risorse create da questo membro","Option_TransferToUser":"Trasferisci a un altro utente","Text_TransferableAssets":"Risorse trasferibili","Text_DeletedAssets":"Risorse eliminate","Desc_RemovedAssetFolder":"Cartelle create/record di modifica (incluse le risorse non condivise)","Desc_RemovedAssetTemplate":"Template/elementi caricati (incluse le risorse non condivise)","Desc_RemovedAssetAiRecord":"Cronologia/Preferiti dei set IA","Text_SelectAssetReceiver":"3. Seleziona il membro che riceverà gli asset","Desc_RejoinAssetRecovery":"Se questo membro rientra entro 30 giorni, le risorse sopra indicate riappariranno nel suo spazio personale.","Desc_RejoinAssetExpire":"Dopo 30 giorni, verrà eliminato definitivamente e non potrà essere recuperato.","Button_ConfirmRemove":"Rimuovi","Text_Last7Days":"Ultimi 7 giorni","Text_Last30Days":"Ultimi 30 giorni","Text_Last90Days":"Ultimi 90 giorni","Text_MemberActiveCount":"Membri attivi","Text_NewAssetCount":"Nuove risorse","Title_TeamOverview":"Panoramica del team","Title_ActiveMembers":"Membri attivi","Desc_ActiveMembers":"Numero di membri che hanno effettuato l\'accesso nell\'intervallo di tempo specificato","Label_PersonUnit":"Persone","Label_TotalCount":"Totale","Title_AiToolGeneration":"Generazioni con strumenti AI","Desc_AiToolGeneration":"Numero totale di generazioni effettuate da tutti i membri con gli strumenti AI della piattaforma nell\'intervallo di tempo specificato","Label_TimesUnit":"Volte","Label_Accumulative":"Totale","Title_TotalAssetDownload":"Download totali degli asset","Desc_TotalAssetDownload":"Download totali effettuati da tutti i membri sulla piattaforma nell\'intervallo di tempo specificato","Label_CopyUnit":"Report","Nav_MySpace":"Il mio spazio","Nav_ShareWithMe":"Contenuti condivisi","Nav_SpaceManage":"Gestione archiviazione","Nav_AssetHandover":"Risorse di offboarding","Label_Text":"Testo","Label_Group":"Combinazione","Label_Table":"Foglio","Label_Chart":"Grafico","Label_AiProductShoot":"Fotografia commerciale AI","Label_AiProductDesign":"Design di prodotto AI","Label_SameStyleReplicate":"Ricrea","Button_CreateFolder":"Crea cartella","Button_NewFolder":"Nuova cartella","Button_UploadFile":"Carica","Button_UploadFolder":"Carica cartella","Button_UploadTemplate":"Carica template","Menu_Rename":"Rinomina","Button_UseTemplate":"Utilizza","Button_CopyToTeam":"Copia nel team","Text_MoveToMySpace":"Sposta nel mio spazio","Button_ExportContent":"Esporta","Button_Deselect":"Annulla selezione","Text_SelectAllWithCount":"Seleziona tutto (${0} selezionati)","Message_PartialFileCannot":"Alcuni dei file selezionati non possono essere ${0}","Text_NoSearchResultYet":"Nessun risultato trovato","Text_SearchNoMatch":"Nessun risultato trovato","Text_EmptyGoCreate":"Non ci sono ancora contenuti. Crea ora!","Text_EmptyGoAction":"Ancora nessun contenuto. Vai a ${0}.","Text_ActionCreate":"Crea","Desc_OrganizeWorks":"Organizza in modo efficiente i progetti personali o del team","Message_EnterName":"Inserisci un nome per ${0}","Message_EnterNameWithin20":"Inserisci un nome ${0} di massimo 20 caratteri","Message_OperationSuccess":"Operazione riuscita!","Message_EnterFolderName":"Inserisci il nome di una cartella!","Message_EnterFolderNameWithin20":"Inserisci il nome di una cartella, massimo 20 caratteri","Text_CopyTo":"Copia in","Text_CopyingMayTakeMinutes":"Copia in corso... Potrebbero volerci alcuni minuti.","Button_GoTeamView":"Visualizza nel team","Message_BrowserNoUploadFolder":"Il caricamento di cartelle non è supportato in questo browser.","Title_MoveAfterMySpace":"Dopo lo spostamento, si troverà nel Mio spazio","Desc_MixSortAfterMove":"Ordinati insieme alle altre risorse per data di aggiornamento","Message_HandoverFailed":"Handoff non riuscito","Message_CreateSuccessExclaim":"Creato!","Message_NoFilePermission":"Non disponi dell\'autorizzazione per eseguire questa azione su questo file.","Title_ConfirmDeleteRecord":"Eliminare i seguenti record?","Title_ConfirmUnfavorite":"Se lo rimuovi dai preferiti, il record di questo risultato di design andrà perso. Confermi?","Title_ConfirmDeleteGenerate":"Dopo l\'eliminazione, i risultati generati andranno persi. Vuoi davvero eliminarli?","Text_To":"A","Text_FileOperating":"Nel file ${0}...","Message_OperateSuccess":"${0} fissato in alto","Text_CurrentDir":"Directory corrente","Text_OperateDir":"Menu azioni","Text_Creating":"Creazione in corso","Text_NoContent":"Nessun contenuto","Title_CancelUploadConfirm":"I caricamenti sono ancora in corso. Annullare tutti i caricamenti in corso?","Button_CancelUpload":"Esci","Message_MaxUploadFiles":"Puoi caricare fino a 500 file alla volta","Message_PersonalUploadLimit":"Gli account personali consentono di caricare fino a 20 file alla volta. Per caricare più di 20 file, crea un team.","Title_PsdToTemplate":"Carica un PSD per convertirlo direttamente in un template del team","Desc_TemplateEditOnly":"Solo tu puoi modificare il template. Gli altri membri possono solo duplicarlo e non possono modificare il template originale.","Link_WhatIsTemplate":"Cosa sono i template","Button_ConvertTemplate":"Converti in template","Button_UploadOnly":"Solo caricamento","Text_WaitUpload":"In attesa di caricamento","Text_Transferring":"Trasferimento in corso...","Text_AllUploadComplete":"Tutti i caricamenti completati","Text_FilesUploadFailed":"Impossibile caricare ${0} file","Text_UploadingProgress":"Caricamento... (${0}/${1})","Button_StartAll":"Avvia tutto","Button_PauseAll":"Metti tutto in pausa","Button_CollapseDetail":"Riduci dettagli","Button_ExpandDetail":"Espandi i dettagli","Text_FailDetail":"Dettagli errore","Text_SharedFolderToYou":"Ha condiviso una cartella con te","Desc_ClickJoinTeam":"Tocca per visualizzare e unirti automaticamente a questo team","Text_SeatInsufficientFolder":"Posti insufficienti. Non puoi unirti al team per accedere a questa cartella.","Title_FolderTeamShareOnly":"Le cartelle possono essere condivise solo all\'interno di un team","Button_SwitchTeamCopyFolder":"Cambia team e copia la cartella","Button_CreateTeamCopyFolder":"Crea un team e copia la cartella","Message_FolderCopiedToTeam":"Creato con successo. La cartella è stata copiata nel tuo team.","Text_UsedSpace":"Utilizzato:","Text_StorageSpace":"Spazio di archiviazione:","Text_UsedSpaceLabel":"Spazio utilizzato","Text_UnlockSpace":"Sblocca ${0} di spazio di archiviazione extra","Button_UpgradeToMember":"Passa all\'abbonamento","Button_UpgradePremium":"Passa a Premium","Desc_SpaceFullUpgrade":"Spazio di archiviazione pieno. Effettua l’upgrade per ottenere più spazio.","Desc_SpaceFullContactAdmin":"Lo spazio di archiviazione è pieno. Contatta l\'amministratore.","Desc_SpaceFullClean":"Spazio di archiviazione pieno. Libera spazio ora.","Desc_SpaceLowUpgrade":"Resta meno del 10% di spazio di archiviazione. Fai l\'upgrade per ottenere più spazio.","Desc_SpaceLowContactAdmin":"Spazio di archiviazione residuo inferiore al 10%. Contatta l\'amministratore.","Desc_SpaceLowClean":"Rimane meno del 10% dello spazio di archiviazione. Libera spazio il prima possibile.","Desc_VipExpiredRenew":"I vantaggi del tuo abbonamento sono scaduti. Rinnova ora.","Desc_VipSoonExpireRenew":"Il tuo abbonamento sta per scadere. Ricordati di rinnovarlo.","Desc_SpaceNormal":"Lo spazio è disponibile. Puoi continuare a salvare le tue creazioni.","Text_CountUnit":"${0}","Text_SoonExpire":"In scadenza ${0}","Text_Expired":"Scaduti ${0}","Text_FileStatus":"Stato del file: ${0}. Gestiscilo al più presto.","Desc_TopBannerFilesExpire":"Alcuni dei tuoi file stanno per raggiungere il limite di archiviazione. Gestisci i file ora oppure aggiorna il tuo abbonamento per conservarli in modo permanente.","Desc_TopBannerSpaceLow":"È rimasto meno del 10% dello spazio di archiviazione. Aggiorna il piano per ottenere più spazio.","Desc_TopBannerSpaceUrgent":"Lo spazio di archiviazione sta per esaurirsi e alcuni progetti scadranno a breve. Aggiorna il tuo abbonamento per ottenere più spazio e conservare i tuoi progetti per sempre.","Desc_TopBannerSpaceLowPremium":"Resta meno del 10% dello spazio di archiviazione. Passa a Premium per avere più spazio.","Desc_TopBannerVipSoonExpire":"Il tuo abbonamento sta per scadere. Rinnova per tempo per evitare che la cronologia delle modifiche scada e venga eliminata.","Desc_TopBannerVipExpired":"Il tuo abbonamento è scaduto. Rinnova ora per evitare di perdere spazio di archiviazione o la cronologia delle modifiche.","Desc_TopBannerSpaceLowClean":"Resta meno del 10% del tuo spazio di archiviazione. Libera spazio ora.","Desc_TopBannerVipSoonExpireNoPeriod":"Il tuo abbonamento sta per scadere. Se non lo rinnovi in tempo, la cronologia delle modifiche potrebbe essere eliminata. Rinnova al più presto.","Text_AssetHandovering":"Trasferimento delle risorse...","Text_TransferringStatus":"Trasferimento in corso","Text_ResignationTime":"Data di dimissioni:","Desc_AssetHandoverTip":"I record di generazione nelle risorse dei membri che hanno lasciato il team non possono essere modificati. Le altre risorse non supportano lo spostamento né il caricamento. Se necessario, sposta prima le risorse nel Mio spazio.","Message_SelectFileLimit":"Seleziona fino a ${0} file","Text_ExpandVersionComparison":"Espandi il confronto delle funzionalità tra le versioni","Text_CollapseVersionComparison":"Comprimi il confronto delle funzionalità delle versioni","Text_VersionComparisonToggle":"Confronto delle funzionalità della versione ${0}","Text_Consult":"Consigli","Text_PricePerMonthWithSymbol":"¥${0}/mese","Title_RightsComparison":"Confronta i vantaggi","Text_Trial7Days":"Prova di 7 giorni","Text_UsingNow":"In uso","Text_ConsultBusiness":"Contatta il reparto vendite","Title_PriceComparison":"Confronto prezzi","Text_StandardMember":"Standard Premium","Text_EnterpriseMember":"Premium Enterprise","Text_BeansPerMonth":"${0} crediti/mese","Text_BeansPerMonthFrom":"Da ${0} crediti/mese","Text_WanBeansPerMonthFrom":"Da ${0}k crediti/mese","Text_SheetsPerMonth":"${0} immagini/mese","Text_SheetsPerMonthFrom":"Da ${0} foto/mese","Text_WanSheetsPerMonthFrom":"Da ${0}K immagini/mese","Desc_FeatureOnlyNote":"${0}<span style=\\"color: #d0d2d6\\">(Solo questa funzione)</span>","Text_PersonalCommercial":"Uso commerciale personale","Text_EnterpriseCommercialEntities":"Soggetto della licenza commerciale Enterprise*${0}","Text_PurchasableSeparately":"Disponibile come acquisto separato","Desc_MeidouAiQuota":"Crediti (quota per la Generazione AI)","Label_AiAgentImageEdit":"Agente AI: Modifica delle foto","Label_AiAgentImageGen":"AI Agent: Generazione immagini","Label_AiAgentEcommerce_ImageSet":"Agente AI: Set di immagini e-commerce","Label_PortraitBgReplace":"Cambia sfondo","Label_AiPartialRedraw":"Modifica AI","Label_AiImageGen":"Generazione AI","Label_AiFloralText":"Calligrafia AI","Label_LivePpt":"Live PPT","Label_AiSizeExtend":"Espansione AI","Label_BatchTemplate":"Template in blocco","Label_CreateCustomSize":"Crea un design con dimensioni personalizzate","Label_EditLocalImage":"Modifica immagini locali","Label_ExportJpgPng":"Esporta design/immagine come JPG/PNG","Label_FreeTemplate":"Template gratuiti","Label_FreeFont":"Caratteri gratuiti","Label_FreeAsset":"Elementi gratuiti","Label_PaidTemplate":"Template a pagamento","Label_PaidFont":"Caratteri a pagamento","Label_PaidAsset":"Contenuti Premium","Label_RealtimeMultiEdit":"Modifica collaborativa in tempo reale","Label_ShareDesignRecord":"Condividi la cronologia delle modifiche","Label_ShareElements":"Condividi elementi (immagini/testo/tabelle)","Label_ShareTemplate":"Condividi il modello","Label_ShareFolder":"Condividi cartella","Label_SharePermission":"Gestione delle autorizzazioni di condivisione","Label_RecordToTemplate":"Converti la cronologia delle modifiche in modello","Label_EnterpriseBrandNav":"Barra di navigazione del brand aziendale","Label_Sso":"Single Sign-On (SSO)","Label_ModelCustomization":"Personalizzazione del modello","Label_SceneCustomization":"Personalizzazione della scena","Label_OnlineAiSupport":"Servizio clienti smart online","Label_OnlineManualGuide":"Manuale online","Label_OperationGuide":"Guida utente","Label_CustomerImSupport":"Supporto tramite gruppo IM per clienti","Label_DedicatedCsm":"Servizio Customer Success dedicato","Label_TechPriorityResponse":"Risposta prioritaria del supporto tecnico","Label_TrainingSession":"Formazione dedicata","Label_OffboardAssetTransfer":"Passaggio di consegne degli asset in caso di dimissioni","Label_MemberPurchaseLimit":"Restrizioni di acquisto per i membri","Label_MemberActivity":"Attività dei membri","Label_MemberDesignActivity":"Attività di modifica dei membri","Label_MemberAiActivity":"Stato della generazione AI dei membri","Title_ContentDesign":"Design dei contenuti","Title_MultiCollaboration":"Collaborazione multiutente","Title_VisualManagement":"Gestione visiva","Title_OrgManagement":"Gestione dell’organizzazione","Title_DataStatistics":"Statistiche","Title_ExclusiveCustomization":"Personalizzazione esclusiva","Title_ServiceGuarantee":"Garanzia del servizio","Title_EnterpriseAuthConfirm":"Confermare le informazioni sulla licenza commerciale aziendale","Text_ConfirmAuthInfoTip":"Conferma le seguenti informazioni di autorizzazione. Non potranno essere modificate dopo l\'invio.","Label_Name":"Nome","Label_UnifiedSocialCreditCode":"Codice identificativo unificato di credito sociale","Label_IdCardNumber":"N. carta d\'identità","Label_ContactPhone":"Numero di telefono","Title_AuthSuccess":"Autorizzazione riuscita","Text_AuthSubjectFilled":"Dati del soggetto autorizzato completati con successo","Button_BackAdmin":"Torna al backend","Button_DownloadAuthBook":"Scarica lettera di autorizzazione","Title_EnterpriseAuthFill":"Inserisci le informazioni sulla licenza commerciale aziendale","Label_AuthType":"Tipo di autorizzazione","Text_Enterprise":"Aziendale","Message_EnterCompanyNameWithin30":"Inserisci il nome dell\'azienda (massimo 30 caratteri)","Message_PleaseEnterNameShort":"Inserisci il tuo nome","Message_Max30Chars":"Al massimo 30 caratteri","Message_EnterCompanyName":"Inserisci il nome dell’azienda","Message_EnterUnifiedSocialCreditCode":"Inserisci il codice unificato di credito sociale","Message_EnterIdCardNumber":"Inserisci il n. della carta d\'identità","Message_InvalidUnifiedSocialCreditCode":"Formato del codice unificato di credito sociale non valido.","Message_InvalidIdCardNumber":"Formato del numero di carta d\'identità non valido.","Message_EnterPhoneNumber":"Inserisci il tuo numero di telefono","Message_InvalidPhoneNumber":"Formato del numero di telefono non valido.","Placeholder_PhoneExample":"Esempio: 0592-12345678 / 13912345678","Desc_AuthInfoBindTip":"Una volta inviate, le informazioni sopra saranno associate e non potranno essere modificate, a meno che tu non acquisti un soggetto commerciale autorizzato aggiuntivo.","Desc_AuthInfoRiskTip":"Se non fornisci le informazioni sopra indicate in modo accurato e completo, potresti non essere in grado di fornire prove valide in caso di rischi legati al copyright e potresti non ricevere la protezione per l\'uso commerciale dalla piattaforma Meitu Design Studio.","Desc_AuthSingleSubjectTip":"La Licenza per uso commerciale senza pensieri viene concessa a un unico soggetto ed è limitata all\'uso da parte del soggetto autorizzato che l\'ha acquistata e associata. La condivisione o il trasferimento sono vietati.","Text_OfflineOrderScanBusiness":"Per gli ordini offline, scansiona il codice per contattare il reparto Vendite e richiedere una lettera di autorizzazione","Label_AuthSubjectInfo":"Informazioni sul soggetto autorizzato","Text_NotFilledYet":"Non ancora compilato","Text_ServiceValidity":"Periodo di servizio","Text_AuthInactive":"Non attivo","Text_AuthActive":"Attivo","Text_AuthExpired":"Scaduto","Text_AuthNotStarted":"Non iniziato","Text_OfflineOrder":"Ordini in negozio","Label_RelatedOrder":"Ordine correlato","Button_ContactSupport":"Contatto","Button_Fill":"Entra","Title_MemberCommercialAuthBook":"Licenza commerciale per abbonati","Button_PurchaseAuthSubject":"Aggiungi soggetto autorizzato","Desc_PurchaseAuthSubjectScan":"Per acquistare soggetti autorizzati aggiuntivi, scansiona il codice QR e contatta il nostro team commerciale","Label_AuthTime":"Periodo di licenza","Label_AuthStatus":"Stato autorizzazione","Text_OrderCancelled":"Annullato","Text_OrderPaid":"Pagato","Text_OrderRefunded":"Rimborsato","Text_TeamVipProductName":"Abbonamento team ${0}","Text_CutoutCountProductName":"Ritagli rimanenti ${0}","Text_MemberMeidouProductName":"Crediti Member: ${0}","Message_CancelSuccess":"Annullato","Message_CancelFailed":"Impossibile annullare","Title_ConfirmCancel":"Conferma annullamento","Text_CancelOrderTip":"Dopo aver annullato l\'ordine, puoi effettuare un nuovo ordine per acquistare il servizio.","Button_IssueInvoice":"Fattura","Text_NoOrders":"Ancora nessun ordine","Label_ProductInfo":"Informazioni sul prodotto","Label_Quantity":"Importo","Label_OrderTotal":"Totale","Label_OrderStatus":"Stato dell\'ordine","Text_OrderNoPrefix":"Numero ordine: ${0}","Text_PayBeforeDeadline":"Completa il pagamento entro ${0}. I pagamenti effettuati in ritardo verranno annullati automaticamente.","Button_CancelOrder":"Annullamento degli ordini","Button_PayNow":"Paga ora","Title_TransferAmount":"Importo del bonifico","Desc_TransferAmountMatch":"L\'importo del bonifico deve corrispondere all\'importo dell\'ordine corrente.","Desc_TransferUniqueCode":"2. Ogni ordine ha un codice di pagamento univoco. Questo codice è valido solo per questo ordine. Non pagare più di una volta.","Desc_TransferAutoActivate":"3. Il tuo abbonamento verrà attivato automaticamente entro 30 minuti dall\'esito positivo del bonifico. Completa il pagamento tempestivamente.","Title_ReceiveAccountInfo":"Informazioni account","Label_AccountName":"Nome dell\'account","Label_BankAccount":"Conto bancario","Label_IssueBank":"Nome della banca","Label_RemittanceCode":"Codice di bonifico","Text_CopyRemittanceInfo":"Copia informazioni per il bonifico","Message_CopiedToClipboard":"Copia negli Appunti","Text_CopyRemittanceTemplate":"Nome account: ${0}\\nConto bancario: ${1}\\nNome banca: ${2}\\n  Codice di bonifico: ${3}","Label_MemberSeats":"Membri/Posti","Label_RemainingSheets":"Crediti rimanenti","Label_EnterpriseAuthSubject":"Entità della licenza commerciale Enterprise","Button_Purchase":"Acquista","Message_EditSuccessExclaim":"Modificato con successo!","Text_InactiveSeats":"Posti in sospeso ${0}","Text_ExpiredDays":"Scaduto ${0} giorni fa","Text_ExpireOn":"Scade il ${0}","Label_OrgId":"ID organizzazione","Label_CreatedAt":"Creato il:","Title_ContactInfo":"Contatti","Desc_ContactExpectation":"Ci piacerebbe metterci in contatto con te 🤝 e aiutare il tuo team a sfruttare al meglio Posters.","Text_ContactFor1v1":"Compila questo modulo per ricevere un Servizio VIP personalizzato.","Label_ContactPerson":"Contatti","Label_ContactMethod":"Informazioni di contatto","Text_MemberActivity":"Attività dei membri","Label_LastOnlineTime":"Data e ora dell\'ultima release","Label_ActiveDays":"Giorni attivi","Title_GenerationCount":"Generazioni","Label_PosterImageEdit":"Modifica poster/immagini","Alt_Avatar":"Avatar","Label_ProductPortrait":"Prodotto/Ritratto","Label_TryOnFaceSwapRecolor":"Prova/Cambia volto/Colore","Text_MemberActivityExport":"Attività dei membri.xls","Title_IncludesFreePlus":"Include tutti i vantaggi del piano gratuito, più:","Title_IncludesStandardPlus":"Include tutti i vantaggi dell\'abbonamento Standard, più:","Title_IncludesTeamMemberPlus":"Include tutti i vantaggi dell\'abbonamento Team, più:","Text_AccountLimitOne":"Limite account: 1 utente","Text_PaidTemplateMaterial":"Template/Elementi premium","Text_FreeTemplateMaterial":"Template/elementi gratuiti","Desc_SmartToolsBundle":"Ritaglio smart/Rimozione AI/Miglioramento e altri strumenti smart","Desc_MeidouMonthlyUsage":"I crediti mensili possono essere usati per:","Desc_AgentProductSuite":"Agente AI: set di immagini prodotto, pagine di dettaglio, video e altro","Desc_AiShootSuite":"Fotografia commerciale AI: Immagini del prodotto AI, sfondi per ritratti, modelli AI e altro","Desc_AiDesignSuite":"Design IA: Logo IA, PPT live, Grafica IA e altro","Text_TeamSeatsFromPrice":"10 postazioni / Da ¥15.000","Desc_BulkMeidouOneTime":"Maxi bonus di crediti una tantum, condiviso tra più account","Label_OneMonth":"1 mese","Label_ThreeMonths":"3 mesi","Label_TwelveMonths":"12 mesi","Text_EnterpriseCommercialLicensed":"Autorizzato per uso commerciale aziendale","Button_BuyTeamEdition":"Acquista Team","Title_ChooseByCommercialAuth":"Scegli per licenza commerciale","Label_LicenseTarget":"Soggetto autorizzato:","Desc_PersonalLicenseTarget":"Il soggetto commerciale è una persona fisica e anche il beneficiario è una persona fisica.","Label_LicenseScope":"Ambito di applicazione:","Desc_PersonalLicenseScope":"Uso personale in ufficio (PPT, report), siti web personali, uso promozionale di negozi online registrati a nome di una persona fisica, social media personali, account ufficiali WeChat, creazione personale di video brevi, ecc.","Title_EnterpriseCommercialAuth":"Licenza commerciale per aziende","Desc_EnterpriseLicenseTarget":"Persone giuridiche e organizzazioni prive di personalità giuridica, incluse imprese, imprese individuali, enti amministrativi e associazioni.","Desc_EnterpriseLicenseScope":"Gestione di siti web, account ufficiali, mini-programmi, immagini prodotto/pagine di dettaglio e-commerce, feed social, annunci online e cataloghi prodotti online.","Tip_PersonalLicenseWarning":"Nota: L\'utilizzo di una licenza commerciale personale per scopi aziendali costituisce una violazione.","Alt_ContactServiceQrcode":"Codice QR per contattare l’assistenza","Text_ScanContactManager":"Inquadra il codice QR per contattare l\'account manager","Button_LearnQuote":"Visualizza i dettagli sui prezzi","Title_PricingPartners":"Clienti di diversi settori usano Meitu Design Studio","Title_FaqSectionPricing":"Domande frequenti","Title_FaqCommercialUse":"Posso usarlo per scopi commerciali dopo l’abbonamento?","Desc_FaqCommercialUse":"L\'abbonamento personale (SVIP) è destinato esclusivamente all\'uso commerciale individuale. Gli abbonamenti Team/Enterprise possono essere utilizzati per uso commerciale aziendale. Acquista il piano di abbonamento più adatto alle tue esigenze commerciali.","Title_FaqInvoice":"Come posso ottenere una fattura?","Desc_FaqInvoicePersonal":"Fattura IVA per abbonamento individuale: Apri il sito web di Meitu Design Studio, accedi al tuo account abbonato, fai clic sulla foto del profilo in alto a destra, fai clic su Rinnova abbonamento, quindi su Voglio una fattura in basso a destra nel pop-up e scansiona il codice QR con WeChat per ottenere la fattura.<br/>","Desc_FaqInvoiceTeam":"Fattura ordinaria per abbonamento Team: Vai alla dashboard di gestione del team, seleziona Fattura ordine - scegli l\'ordine per cui emettere fattura - fai clic su Fattura - scansiona il codice QR per inserire le informazioni richieste.<br/>","Desc_FaqInvoiceSpecial":"Fattura IVA speciale: Contatta l\'assistenza clienti tramite Consulenza online.<br/>","Title_FaqDeviceLimit":"Su quanti dispositivi si può usare un account con abbonamento?","Desc_FaqDeviceLimit":"MTid è un account personale. Per proteggere la sicurezza del tuo account e la privacy delle tue creazioni, <span style=\\"color: #fff; font-weight: bold;\\">ogni account membro può accedere solo da un computer alla volta</span> e non supporta l’accesso simultaneo da più computer.<br/>Se hai bisogno di accedere contemporaneamente da più dispositivi, ti consigliamo di acquistare l’<span style=\\"color: #fff; font-weight: bold;\\">Abbonamento Team/Enterprise di Meitu Design Studio</span> per attivare più postazioni e assegnare gli account per l’accesso.","Title_FaqUpgradeTeam":"Come posso passare da un abbonamento individuale a un abbonamento Team?","Desc_FaqUpgradeTeam":"Poiché gli abbonamenti Team e Individuale hanno prezzi diversi, per passare a un abbonamento Team acquista prima il piano Team, quindi contatta l\'assistenza online per trasferire i credit del tuo account personale e gestire l\'eventuale saldo residuo dell\'abbonamento. Puoi copiare autonomamente le risorse dal tuo account individuale al team.","Title_FaqMeidou":"Cosa sono i crediti e come posso acquistarli?","Desc_FaqMeidou":"Oltre alle funzioni gratuite e per i membri, Meitu Designer offre anche funzioni AI che richiedono Crediti, come AI Product Image, AI Model e Flatlay. Una volta esauriti i Crediti inclusi nell’abbonamento, puoi acquistarne altri separatamente. Apri la pagina di acquisto dall’angolo in alto a destra di qualsiasi funzione AI. Link: <a target=\\"_blank\\" style=\\"color: #66A8FF\\" href=\\"https://www.designkit.cn/product-shoot-editor/?from=home\\">https://www.designkit.cn/product-shoot-editor/?from=home</a>","Message_PermissionAlreadyRejected":"Richiesta di autorizzazione rifiutata","Message_PermissionAlreadyProcessed":"Questa richiesta di autorizzazione è stata elaborata","Text_TeamRenewRemainingPrefix":"Al tuo abbonamento team restano solo","Text_UnitDay":"giorni","Text_SharedItemToYou":"Ha condiviso ${0}【${1}】 con te.","Label_AccountColon":"Numero account:","Text_PriceYuanPerPersonPerMonth":"¥${0}/persona/mese","Text_OrTry":"Oppure prova","Title_DesignKitApp":"App Meitu Design Studio","Title_OpenClawGuide":"Manuale OpenClaw","Label_AllColors":"Tutti i colori","Alt_TemplateImage":"Immagine modello","Text_NestedTemplateSuiteCount":"Imposta ${0} immagini come template","roboneo_agent_queue_tier_fast":"Veloce","roboneo_agent_queue_tier_relax":"Relax","roboneo_agent_queue_tier_change_failed":"Impossibile cambiare, riprova.","Label_ImageProcessing":"Elaborazione immagine","Tool_ProductRetouching":"Ritocco prodotto","Message_SelectImageBefore_ImageTranslation":"Seleziona un\'immagine prima di usare Traduzione immagine.","Message_SelectImageBefore_Expand":"Seleziona un\'immagine prima di usare Espansione AI dello sfondo.","Label_AiCreation":"Generazione AI","Tool_AiImageText":"Immagine & testo AI","Label_DefaultModel":"Modello predefinito","Desc_AgentMode_Advanced":"Consumo di crediti AI 3x Genera diversi risultati promozionali 3x","Desc_AgentMode_Normal":"Ideale per creazioni quotidiane semplici e per risparmiare risorse di calcolo","Desc_AgentMode_FlagshipAi":"·Modalità AI di punta","Desc_AgentMode_MultilingualText":"·Corrispondenza testuale multilingue precisa","Desc_AgentMode_ProductFidelity":"· Accuratezza del 95% nel ripristino del prodotto","Desc_AgentMode_ComplexScene":"·Capacità di elaborazione di scenari complessi","Tool_AIVideoAgent":"Agente video AI","Tool_UGCVideoMaker":"Creatore di video UGC","Tool_MarketingVideoMaker":"Generatore di video marketing","Tool_PromoVideoMaker":"Generatore di video promozionali","Tool_ExplainerVideoMaker":"Generatore di video esplicativi","Tool_BeforeAfterVideoMaker":"Creatore di video prima e dopo","roboneo_agent_queue_tier_upgrade_title":"Accesso illimitato a Relax","roboneo_agent_queue_tier_upgrade_desc":"Vantaggi dell\'abbonamento ${0}. Generazione in modalità Relax senza crediti.","roboneo_agent_queue_tier_upgrade_primary":"Passa a Pro","roboneo_agent_queue_tier_upgrade_secondary":"Usa la modalità veloce","Label_PageIndex":"Pagina ${0}","Title_PPTTask":"Attività PPT","Button_ReplicateNow":"Riutilizza ora","Label_ImageIndex":"Figura ${0}","Button_Cases_ViralVideo":"Esempio","Message_ImageReviewFailedRetry_Batch":"Verifica dell\'immagine non riuscita. Riprova più tardi.","Message_ImageReviewRejected_Batch":"Immagine rifiutata","Text_PageRange":"Pagine ${0}~${1}","Text_AllPagesRange":"Tutte le pagine (1~${0})","Text_AllPages":"Tutte le pagine","Text_SelectedPages":"Pagina selezionata (${0})","Text_NoPageSelected":"Nessuna pagina selezionata","Title_InsertDocument":"Inserisci documento","Title_SelectPages":"Seleziona pagina","Button_Insert":"Inserisci","Message_ProductInfoReviewRejected_Batch":"Il testo del punto di forza non è stato approvato. Inseriscilo di nuovo.","Tool_VideoBackgroundRemover":"Rimozione sfondo video","Title_StayUpdated_Designkit":"Resta aggiornato su Designkit","Title_StayUpdated_Zawa":"Resta aggiornato su Zawa","Desc_WebPushPrompt":"Scopri per primo nuovi strumenti AI, aggiornamenti sulle funzionalità e contenuti di tendenza.","Button_NotNow":"Non adesso","Button_TurnOn":"Attiva","Placeholder_Enter":"Inserisci ${0}","Placeholder_Select":"Seleziona ${0}","Label_AiMarketingVideo":"Video promozionale del prodotto AI","Title_ImageProcessing":"Elabora immagine","Title_AiDesign":"Design AI","Label_Ecommerce":"E-commerce","Label_SocialMedia":"Social media","Label_WechatMarketing":"Marketing su WeChat","Label_OfficialAccount":"Account ufficiale","Label_OfficeEducation":"Amministrazione e ufficio/Istruzione","Label_LifeEntertainment":"Lifestyle e intrattenimento","Title_DesignScene":"Scenari di design","Label_MarketingSales":"Marketing e vendite","Label_Promotion":"Promozione","Label_Greeting":"Auguri e benedizioni","Label_CommunicationSharing":"Condividi e connettiti","Label_LifeScience":"Consigli lifestyle","Label_Recruitment":"Assunzioni","Title_UsagePromotion":"Uso per il marketing","Label_FoodBeverage":"Ristorazione e gourmet","Label_ApparelBags":"Abbigliamento, scarpe e borse","Label_EducationTraining":"Istruzione e formazione","Label_BeautySkincare":"Bellezza e cura della pelle","Title_IndustryResource":"Risorse di settore","Text_FirstDiscountBadge_ViralVideo":"Sconto sul primo video","Title_ManagedBatchTip":"Dormi pure. Le tue immagini saranno pronte al risveglio.","Tag_ManagedBatchDiscount":"Batch con ${0}% di sconto","Desc_ManagedBatchTip":"Genera immagini in blocco con il ${0}% di sconto. Al risveglio sarà tutto pronto.","Title_Resize":"Ridimensiona","Title_SocialContentCreation":"Strumenti per contenuti social","Title_BatchResize":"Ridimensiona in gruppo","Title_ImageRecolor":"Ricolora immagine","Title_BatchRetouch":"Ritocca in gruppo","OnlineConsultation":"Consulenza online","PayAmount":"Paga ¥${0}","PriceBreakdown":"¥${0} × ${1} postazioni × ${2} mesi","ScanToPay":"Scansiona per pagare con ${0}","PaymentAgreementHint":"Procedendo al pagamento, accetti","MeidouRechargeAgreement":"Accordo di ricarica crediti","DesignStudioServiceAgreement":"Contratto del Servizio in abbonamento di Meitu Design Studio","CommercialLicenseAgreement":"Licenza commerciale","CutoutQuotaNotice":"Avviso sui crediti bonus per lo scontorno","RenewalMemberNote":"Se hai acquistato un abbonamento con rinnovo automatico:","AutoDeliveryOnPurchase":"Dopo l\'acquisto, verrà aggiunto automaticamente al tuo account attuale.","NonRenewalMemberNote":"Se acquisti un abbonamento senza rinnovo automatico:","AutoDeliveryOnTransaction":"Una volta completata la transazione, verrà accreditato automaticamente sul tuo account attuale.","CutoutQuotaLabel":"Crediti per ritaglio:","CutoutQuotaDesc":"Il numero di ritagli gratuiti si basa sulla quantità bonus indicata nella pagina dei dettagli del prodotto dell\'abbonamento che hai acquistato.","CutoutQuotaExpiryLabel":"Periodo di validità dei crediti per lo scontorno:","CutoutQuotaExpiryDesc":"Fa fede il periodo di utilizzo indicato nella pagina dell\'ordine","TrialAddressLabel":"Link di prova:","ServiceNotice":"Avviso sul servizio","AutoRenewNote1":"1. Dopo l\'attivazione di questo servizio, il tuo abbonamento si rinnoverà automaticamente nelle 24 ore precedenti la scadenza. Una volta rinnovato, l\'abbonamento sarà prolungato per il periodo corrispondente;","AutoRenewNote2":"2. La quota di rinnovo verrà addebitata sul tuo conto di pagamento collegato;","AutoRenewNote3":"3. Puoi disattivare il rinnovo automatico in qualsiasi momento. Una volta disattivato, il tuo abbonamento non si rinnoverà più automaticamente;","AutoRenewNote4":"4. Come annullare:","AutoRenewNote5":"5. Per qualsiasi altra domanda, chiama il servizio clienti al 4000093360","Label_WeChat":"WeChat","Label_Alipay":"Alipay","Label_BatchTrialCount":"Utilizzi gratuiti dell\'elaborazione in gruppo","Desc_WindowsOnly":"Solo app desktop per Windows","Label_MemberFeature":"Funzioni VIP","Label_MemberAsset":"Elementi VIP","Label_MemberEffect":"Effetti VIP","Label_NoAds":"Senza pubblicità","Label_NoPoster":"Senza Meitu Pictorial","Label_EffectFilter":"Filtri speciali","Label_Enhance":"Migliora","Label_FaceRemodel":"Rimodellamento","Label_SkinAdjust":"Pelle","Label_HeadAdjust":"Regolazione della testa","Label_HeightShape":"Forma del corpo","Label_Border":"Cornice","Label_RechargeMeidou":"Ricarica crediti","Text_InsufficientBenefits":"Vantaggi insufficienti. Contatta il tuo consulente dedicato: ${0} ${1}","Text_OnlinePurchaseDisabled":"Gli acquisti online non sono supportati in questa versione. Se necessario, contatta l\'amministratore.","Desc_ProtectMemberExperience":"Per garantirti un\'esperienza ottimale con l\'abbonamento,","Desc_BindPhoneFirst":"Associa prima il tuo numero di telefono principale.","Button_GoToBind":"Collega ora","Text_AlreadyActiveMember":"Hai già attivato l\'abbonamento su ${0}","Text_ContactServicePrefix":"In caso di domande,","Label_ServicePhone":"Numero del servizio clienti","Text_ServiceTime":"Orari del servizio clienti: 9:00 - 21:00","Text_LargeOrderContact":"Per ordini di importo elevato o pagamenti non riusciti, scansiona il codice QR per contattare il team vendite e ricevere assistenza.","Text_ConsultEnterprise":"Richiesta per uso commerciale aziendale","Message_CreateFail":"Creazione non riuscita. Riprova più tardi.","Title_TransferReminder":"Promemoria per il bonifico","Text_ViewOrderProgress":"Potrai monitorare questo ordine più tardi in Dashboard amministratore > Ordini e fatture.","Title_PendingTransfer":"Ordine di bonifico in corso","Text_HasPendingTransfer":"Hai un ordine con bonifico bancario aziendale in corso. Vuoi visualizzarlo?","Button_CancelAndCreate":"Annulla e crea un nuovo ordine","Button_ViewTransferOrder":"Visualizza ordine di bonifico in corso","Text_CancelOrderNote1":"Dopo aver annullato l\'ordine, puoi crearne uno nuovo,","Text_CancelOrderNote2":"Tuttavia, l\'ordine con bonifico in corso verrà chiuso.","Button_ConfirmCancelCreate":"Conferma annullamento e crea","Link_ViewBenefitDetail":"Visualizza i dettagli dei vantaggi >","Label_RedeemCode":"Codice di riscatto","Message_RedeemSuccess":"Riscattato con successo!","Message_RedeemVipSuccess_DesignKit":"Hai riscattato con successo il tuo abbonamento VIP a Meitu Design Studio!","Message_RedeemSvipSuccess_MeituXiuXiu":"Hai riscattato con successo il tuo abbonamento Meitu SVIP!","Placeholder_EnterInviteCode":"Inserisci il codice invito","Placeholder_EnterRedeemCode":"Inserisci il codice di riscatto","Title_CodeCenter":"Centro coupon","Desc_SelectCodeType":"Seleziona il tipo di codice da verificare e riscattare","Title_InviteCodeDesc":"Istruzioni per il codice invito","Title_RedeemCodeDesc":"Istruzioni per il codice di riscatto","Text_InviteCodeIntro":"Inserisci il codice invito esclusivo ricevuto tramite social media o altri canali:","Text_InviteCodeBenefit1":"Sconto esclusivo sul canale di abbonamento con vantaggi gratuiti a tempo limitato","Text_InviteCodeBenefit2":"Ogni codice invito può essere utilizzato una sola volta","Text_InviteCodeBenefit3":"Non cumulabile con altre promozioni","Text_RedeemCodeIntro":"Usa un codice di riscatto dell\'abbonamento ottenuto dai canali ufficiali:","Text_RedeemCodeBenefit1":"Accedi al tuo account e inserisci il codice di riscatto per riscattarlo","Text_RedeemCodeBenefit2":"Dopo il riscatto, otterrai i relativi vantaggi e servizi dell\'abbonamento","Text_RedeemCodeBenefit3":"Usa il codice di riscatto prima della scadenza. I codici scaduti non sono validi e non danno diritto a rimborso.","Text_InvoiceLink":"Questo link può essere utilizzato per emettere fatture per ${0} ordini","Text_InvoiceOtherBusiness":"Per le fatture di altri servizi Meitu, segui l’account ufficiale Meitu Payment Service","Desc_ConsumeSoonExpiredMeidou":"Usa prima i crediti in scadenza","Link_MeidouIntro":"Informazioni sui crediti","Text_NoMeidouGoToBuy":"Crediti esauriti. Acquista ora!","Text_ThankYouSupport":"Grazie per il tuo supporto. Continueremo a offrirti nuovi servizi.","Text_PurchaseBatchSuccess_MeituXiuXiu":"Hai acquistato crediti per l\'elaborazione in batch di Meitu.","Text_PurchaseCutoutSuccess":"Hai acquistato i download di Meitu Ritaglio.","Label_BoundAccount":"Account collegato:","Text_PurchaseCount":"Quantità acquistata: ${0}","Label_TeamMemberExpiry":"Abbonamento team valido fino al:","Label_ProMemberExpiry":"Abbonamento Premium valido fino al:","Label_StandardMemberExpiry":"Abbonamento standard valido fino al:","Text_PurchaseSeatCount":"Posti acquistati: ${0}","Button_GotItCountdown":"Ho capito (${0}s)","Text_Trial":"Prova ${0}","Text_OriginalPrice":"Prezzo originale ${0}","Text_PerSheet":"/Immagine","Text_PerPersonPerMonth":"/persona/mese","Text_FreeTrialDays":"Prova gratuita di ${0} giorni","Text_FreeTrialMonths":"Prova gratuita di ${0} mesi","Text_FreeTrialQuarters":"${0} trimestre/i di prova gratuita","Text_FreeTrialYears":"Prova gratuita di ${0} anni","Text_ScanToBuy":"Scansiona con ${0} per acquistare","Text_ScanToActivate":"Scansiona con ${0} per attivare","Text_AlsoSupportWechatBuy":"(O scansiona con WeChat)","Text_AlsoSupportWechatActivate":"(o scansiona con WeChat)","Text_ServiceAgreement_DesignKit":"Politica di abbonamento di Meitu Design Studio","Text_ServiceAgreement_MeituXiuXiu":"Politica di abbonamento Meitu SVIP","Text_ServiceAgreement_Meidou":"Accordo per la ricarica dei crediti","Text_ServiceAgreement_Cutout":"Accordo sul servizio Ritaglia","Text_ServiceAgreement_BatchMeituXiuXiu":"Accordo di servizio per l\'elaborazione batch di Meitu","Button_ClickLogin":"Accedi","Text_CheckAgreementFirst":"Seleziona prima la casella per accettare.","Text_LoadError":"Impossibile caricare","Button_ClickRefresh":"Tocca per aggiornare","Label_Pay":"Paga","Text_ExtendAfterPurchase":"Dopo l\'acquisto, si estende fino al: ${0}","Button_Agree":"Accetto","Title_ThankYouSubscription":"Grazie per esserti abbonato!","Text_MemberServiceAgreement":"Servizio VIP","Title_PayFail":"Pagamento non riuscito","Button_RepayNow":"Riprova","Desc_OneYearValidTeam":"Valido per 1 anno. Utilizzabile solo con il team attuale.","Text_SharedMeidouPrompt":"Per condividere i crediti con più di 5 persone,","Button_ActivateTeamMember":"Abbonati al piano Team","Text_SeatPurchaseEffect":"I posti aggiuntivi sono attivi immediatamente e scadono il ${0} (stessa data di scadenza dell’abbonamento del team attivo)","Label_Gift":"Bonus","Text_FirstMonthMeidouGift":"Abbonati per ricevere ${0} crediti nel primo mese e ${1} crediti ogni mese successivo. Validi per il mese corrente.","Text_MonthlyMeidouGift":"Assegnati ogni mese, validi per il mese corrente","Desc_TeamOnlyCutout":"I crediti di download acquistati possono essere utilizzati solo con il team attuale.","Text_DownloadDeductRule":"Ogni download di immagine completato consuma 1 credito di download.","Text_CutoutAdjustRule":"Regola il ritaglio tutte le volte che vuoi. I download vengono scalati solo quando scarichi.","Text_UnlimitedCutout":"Ritagli illimitati finché l\'abbonamento è attivo","Text_ValidityThreeMonths":"Validità: 3 mesi","Text_ValidityOneYear":"Validità: 1 anno","Title_VipLimitedOffer":"Offerta speciale VIP","Text_TeamSeatRequirement":"Il tuo team attuale ha ${0} membri. Acquista il numero corrispondente di postazioni.","Text_TeamMemberSeatMinimum":"L\'abbonamento Team parte da ${0} postazioni","Text_MeidouGiftPerMonth":"Crediti bonus: ${0}/mese","Label_SeatCount":"Posti","Text_SeatOrderEffect":"Le postazioni del nuovo ordine entreranno in vigore il ${0}. Per aggiungere postazioni subito,","Button_ActivateMemberUnlimited":"Abbonati per l\'accesso illimitato","Button_BuyMember":"Abbonati","Button_BuyCount":"Quantità di acquisto","Text_BatchRemainingCount":"Immagini in gruppo rimanenti: ${0}","Label_RemainingCutout":"Scontorni rimanenti:","Text_RemainingMeidouCount":"${0} crediti rimasti","Text_TeamMemberExpiry":"L\'abbonamento del team scade il ${0}","Text_BoundPhoneAccount":"(Account collegato: ${0})","Button_ClickLoginRegister":"Tocca per accedere (registrazione inclusa)","Text_LoginToBuyMember":"Accedi per abbonarti e tenere al sicuro le tue creazioni VIP.","Text_LoginToBuy":"Accedi per acquistare","Button_CorporateTransfer":"Bonifico bancario aziendale","Button_ApplyInvoice":"Fattura","Button_InviteOrRedeemCode":"Attiva con codice di invito o di riscatto","Button_RedeemCodeActivate":"Attiva con codice di riscatto","Text_MarchPromo":"Offerta e-commerce di marzo: crediti doppi sulla prima ricarica","Button_BackToBuy":"Torna all\'acquisto","Label_EstimatedConsumption":"Consumo stimato:","Text_ValidOneYear":"Valido per 1 anno","Text_PerMonth":"/mese","Desc_Monthly330Meidou":"330 crediti gratis al mese (validi per il mese corrente), utilizzabili per:","Text_UnitPrice1000":"Solo ¥ 0,0532 per credito","Text_Capacity1000":"Genera circa 500 immagini o 66 video","Text_SingleImageLow1000":"A partire da ¥0,176 per immagine","Text_SingleVideoLow1000":"A partire da ¥1,320 per video (5 s)","Text_SingleImageYearly1000":"A partire da ¥0,106 per immagine","Text_SingleVideoYearly1000":"A partire da ¥0.798 per video (5s)","Text_UnitPrice1800":"Solo ¥0,0462 per credito","Text_Capacity1800":"Puoi generare circa 900 immagini o 120 video","Text_SingleImageLow1800":"A partire da ¥0,164 per immagine","Text_SingleVideoLow1800":"A partire da ¥1.233 per video (5 s)","Text_SingleImageYearly1800":"A partire da ¥0.092 per immagine","Text_SingleVideoYearly1800":"A partire da ¥0,693 per video (5 s)","Text_UnitPrice3600":"Solo ¥0.0437 per credito","Text_Capacity3600":"Genera circa 1.800 immagini o 240 video","Text_SingleImageLow3600":"A partire da ¥0,154 per immagine","Text_SingleVideoLow3600":"A partire da ¥1.158 per video (5 s)","Text_SingleImageYearly3600":"A partire da ¥0,087 per immagine","Text_SingleVideoYearly3600":"Da ¥0,656 per video (5 s)","Text_UnitPrice7500":"Solo ¥ 0,0410 per credito","Text_Capacity7500":"Genera circa 3.750 immagini o 500 video","Text_SingleImageLow7500":"A partire da ¥0,138 per immagine","Text_SingleVideoLow7500":"A partire da ¥1,037 per video (5 s)","Text_SingleImageYearly7500":"A partire da ¥0,082 per immagine","Text_SingleVideoYearly7500":"A partire da ¥0,615 per video (5 s)","Desc_IncludesStandardAll":"Include tutti i vantaggi del piano Standard, più:","Desc_MonthlyMeidou":"${0} crediti inclusi ogni mese (validi per il mese corrente), utilizzabili per:","Text_FewCredits":"Crediti limitati","Label_BasicPlan":"Versione base","Text_TrialMeidouGift":"120 crediti inclusi nella prova, validi per 7 giorni","Text_Monthly330MeidouBenefit":"Abbonati per ricevere 330 crediti ogni mese, validi per il mese corrente.","Label_LimitedPrivilege":"Vantaggi a tempo limitato","Text_SeedancePrivilege":"Generazione lenta gratuita illimitata con Seedance 2.0 e accesso anticipato alle nuove funzionalità","Label_MeidouPrefix":"Crediti:","Text_LoginToBuyMemberShort":"Accedi per acquistare un abbonamento","Text_TeamMinimumSeat":"Il tuo team ha attualmente ${0} membri. Devi acquistare almeno ${0} postazioni.","Message_AbnormalSubscriptionNoSeat":"Non è possibile aggiungere postazioni agli abbonamenti team con stato dell\'abbonamento anomalo.","Text_TeamMemberExpires":"L\'abbonamento del tuo team scadrà il ${0}.","Text_ProMemberExpires":"Il tuo abbonamento Premium scadrà il ${0}.","Text_BasicMemberExpires":"Il tuo abbonamento Basic scadrà il ${0}.","Text_SvipMemberExpires_MeituXiuXiu":"Il tuo SVIP scadrà il ${0}.","Text_ActivateVip_DesignKit":"Abbonati a Meitu Design Studio VIP per usufruire dei vantaggi riservati agli abbonati","Text_UpgradeToSvip_MeituXiuXiu":"Sei già abbonato a Meitu VIP. Passa a SVIP per usufruire dei servizi di design su più dispositivi.","Text_ActivateTeamMember_DesignKit":"Sottoscrivi l\'abbonamento Team per sbloccare i vantaggi VIP di X-Design e le funzionalità di collaborazione in team","Text_ActivateMember":"Abbonati per sbloccare tanti vantaggi esclusivi","Text_ActivateMember_MeituXiuXiu":"Abbonati per usufruire dei vantaggi Meitu VIP, SVIP e dell\'abbonamento Meitu desktop","Text_ExpiredDays_Team":"Scaduto ${0} giorni fa. Acquista ora per ripristinare l\'accesso.","Text_VipExpiredDays_DesignKit":"Il tuo abbonamento VIP è scaduto ${0} giorni fa. Bentornato!","Text_VipExpiredDays_MeituXiuXiu":"Il tuo Meitu SVIP è scaduto ${0} giorni fa. Bentornato.","Text_ValidDays":"Valido per ${0} giorni","Text_ValidWeeks":"Valido per ${0} settimane","Text_ValidMonths":"Valido per ${0} mesi","Text_ValidQuarters":"Valido per ${0} trimestri","Text_ValidYears":"Valido per ${0} anni","Text_CountdownDays":"${0} giorni ${1}","Label_Week":"Settimana","Label_Quarter":"Trimestre","Desc_BatchCutoutConsumption":"Dopo aver usato la funzione di ritaglio, scaricare e salvare 1 immagine consuma ${0} crediti. Le altre funzioni consumano ${1} crediti.","Text_TieredSeatBilling":"L\'abbonamento include ${0} postazioni. Gli utenti aggiuntivi oltre ${1} vengono fatturati a ${2}/anno/persona.","Text_PerYearPerPerson":"/anno/persona","Text_BoundAccountPrefix":"(Account collegato:","Text_BoundAccountSuffix":")","Title_GlobalSettingsMobile_Batch":"Impostazioni globali","Tip_ApplyToAllTasksBelowMobile_Batch":"Applica a tutte le attività seguenti","Tip_UploadImagesFormatMobile_Batch":"Fai clic per caricare immagini JPEG/JPG/PNG fino a ${0} MB. Sono supportate fino a ${1} immagini.","Title_EcommerceTools":"Strumenti per e-commerce","Title_MoreVideoTools":"Altre funzionalità di montaggio video","Text_AppMessageNotification_Batch":"Riceverai un messaggio in-app al termine dell\'attività.","Tool_ProductDemoVideoMaker":"Creatore di demo del prodotto","Tool_Video360Maker":"Generatore di video a 360°","Tool_UnboxingVideoMaker":"Generatore di video unboxing","Tool_FashionVideoMaker":"Creatore di video fashion","Tool_CommercialVideoMaker":"Generatore di video commerciali","Tag_Cover":"Copertina","Option_ExportLayered_Psd":"Esportazione a livelli","Option_ExportFlat_Psd":"Esporta senza livelli","Message_NoExportableLayer":"Nessun livello esportabile selezionato","Message_UnsupportedLayerForPsd":"Questo tipo di livello non supporta l\'esportazione in PSD.","Message_VideoLayerPsdBlocked":"Contiene livelli video. Impossibile esportare in PSD.","Message_ExportUnitsOverLimit":"La selezione supera ${0} elementi esportabili","Message_LayerSplitRightDenied":"Vantaggi senza suddivisione in livelli","AiTemplate_Desc":"Inserisci un tema per il poster o descrivi le modifiche. L\'AI ricreerà questo template e genererà un poster in un clic.","AiTemplate_Upload":"Carica elemento","AiTemplate_Upload_Desc":"Fai clic per caricare immagini degli elementi e sostituire immagini di prodotto, modelli, codici QR e altro.","AiTemplate_Prompt":"Tema del poster/Dettagli della modifica","AiTemplate_Prompt_Placeholder":"Inserisci un tema per il poster o descrivi cosa vuoi modificare. Ad esempio: cambia il tema in \'Idratazione dell\'equinozio d\'autunno\'; sostituisci l\'XX nell\'immagine con l\'XX che ho caricato.","AiTemplate_Generate":"Genera poster","Text_OpenClawInstallCmd":"Aiutami a installare ${0}","Text_SupportLinkImport":"Supporta l\'importazione di link","Text_ModifyLogoPrompt":"Aiutami a modificare questo logo","Text_ModifyImagePrompt":"Aiutami a modificare questa immagine","Title_UserCenter":"Area personale","Button_Login":"Accedi","Button_Signup":"Registrati","Title_FreeBackgroundRemoverOnline":"Rimuovi sfondo online gratis","Title_RemoveThe":"Con Designkit, rimuovi lo sfondo dalle immagini in modo istantaneo e automatico, gratis. Non servono competenze di design.","Title_NoPic":"Non hai una foto a portata di mano? Prova con una di queste","Title_IndustryLeading":"Leader nella qualità dello scontorno delle immagini","Title_GlobalRunner":"Secondo classificato a livello mondiale alla competizione CVPR 2024. Ricerca innovativa pubblicata su AAAI e CVPR.","Title_FastAnd":"Rimozione dello sfondo rapida e impeccabile","Title_SImplyUpload":"Carica la tua foto e Designkit penserà al resto: dal rilevamento del soggetto alla rimozione dello sfondo, senza passaggi complessi né curva di apprendimento.","Title_FineTune":"Perfeziona le tue immagini come un professionista","Titel_Whether":"Che si tratti di capelli soffici, bordi dei tessuti o ombre, Designkit preserva i dettagli più importanti. Puoi anche rifinire bordi e angoli con maggiore precisione per ottenere un risultato curato e professionale.","Title_FlawlessStamp":"Elaborazione di timbri e firme senza difetti","Title_RemoveDull":"Rimuovi gli sfondi spenti e sbiaditi da firme e timbri. Designkit identifica i dettagli di ogni soggetto e li prepara per qualsiasi layout: sfondo a tinta unita o PNG trasparente.","Title_PerfecCutouts":"Ritagli perfetti per ogni caso d\'uso","Title_GetFlawless":"Ottieni una rimozione dello sfondo impeccabile per qualsiasi tipo di immagine.","Button_ECommerco":"E-commerce","Button_Portraits":"Ritratti","Button_Pets":"Animali domestici","Button_LogoSignaure":"Logo e firma","Title_HowTo":"Come faccio a rimuovere lo sfondo dalle immagini?","Title_UploadYour":"Carica la tua immagine","Title_ChooseAn":"Scegli un\'immagine dal tuo dispositivo in formato JPEG, PNG o WEBP.","Title_AIRemoves":"L\'AI rimuove lo sfondo","Title_AiEditor":"Lo strumento di editing con IA identifica il soggetto e rimuove lo sfondo.","Title_EditOrExport":"Modifica o esporta","Title_DownloadOr":"Scarica l\'immagine oppure usa l\'editor di foto integrato per modificarla.","Title_FrequentlyAskedQuestions":"Domande frequenti","Title_IsThis":"Questo strumento è gratuito?","Answer_IsThis":"Sì, lo strumento Rimozione sfondo immagini di Designkit è gratuito e consente di rimuovere lo sfondo dalle immagini.","Title_CanIChange":"Posso cambiare lo sfondo dopo il ritaglio?","Title_WhichImage":"Quali formati immagine sono supportati per il ritaglio?","Title_CanIManually":"Posso regolare manualmente il risultato se non è preciso?","Answer_CanIchange":"Sì, una volta completato il ritaglio, con Designkit puoi scegliere direttamente un colore a tinta unita, una sfumatura oppure aggiungere un\'immagine personalizzata come nuovo sfondo. L\'operazione è semplice, flessibile e completamente personalizzabile.","Answer_WhichImage":"Designkit supporta formati comuni come JPG, PNG e WEBP per il caricamento. Puoi anche esportare il ritaglio finale come PNG trasparente, per integrarlo facilmente negli altri tuoi progetti di design.","Answer_CanIManually":"Assolutamente. Se i bordi non sono perfetti dopo il riconoscimento automatico, puoi usare l\'editor integrato per rifinirli manualmente in base alle tue esigenze.","Button_Reupload":"Nuovo caricamento","Button_Download":"Scarica","Button_Edit_Refine":"Rifinisci","Button_Edit_Backgrounds":"Sfondi","Button_Edit_Crop":"Ritaglia","Button_Edit_Edges":"Bordi","Button_Edit_Filter":"Filtri","Pop_Download_Freetip":"Gratuito","Pop_Download_UHD":"Risoluzione completa","Pop_Download_preview":"Anteprima","Guid_More_ColorPanel":"Tutto","Button_Remove_ColorPanel":"Rimuovi","Button_Upload_ColorPanel":"Carica","Size_Original_SizePanel":"Dimensione originale","Button_Upload_Batch":"Caricamento in blocco","Desc_Upload":"Fai clic o trascina qui per caricare, oppure incolla i file.","SubTitle_Header1_Home":"Generatore AI di immagini per schede prodotto","SubTitle_Header2_Home":"Generatore di poster AI","SubTitle_Header3_Home":"Generatore AI di video per prodotti","SubTitle_Header4_Home":"Generatore AI di fotografie di prodotto","SubTitle_Header5_Home":"Design visivo di siti web con IA","SubTitle_Header6_Home":"Prova virtuale","SubTitle_Header7_Home":"Design AI della pagina prodotto","SubTitle_Header8_Home":"Editor di foto AI","SubTitle_Header9_Home":"Miglioratore di immagini","SubTitle_Header10_Home":"Rimozione oggetti","SubTitle_Header11_Home":"Rimozione sfondo AI","SubTitle_Header12_Home":"Generatore di sfondi AI","SubTitle_Header13_Home":"Ridimensiona immagini","SubTitle_Header14_Home":"Aggiungi testo all\'immagine","SubTitle_Header15_Home":"Generatore di immagini AI","SubTitle_Header16_Home":"Editor di foto in gruppo","Size_ToEdge":"Al bordo","Pop_Download_UHD_LimitTip":"Tempo limitato · ${0}","Before_Text":"Prima","After_Text":"Dopo","Button_OpenVipFreeDownloadPsd":"Abbonati per scaricare PSD gratuitamente","Text_LogoSlogan_DesignKit":"Crea design commerciali belli da vedere e capaci di ottenere risultati","LogoDesign_ModeTitle":"Scegli cosa vuoi generare","LogoDesign_ModeFast":"Logo rapido","LogoDesign_ModeFastDesc":"Generazione rapida, solo informazioni essenziali.","LogoDesign_ModePro":"Logo e design visivo","LogoDesign_ModeProDesc":"Concept strategici e anteprima in contesto reale.","LogoDesign_Essentials":"Informazioni sulla marca","LogoDesign_BrandNamePlaceholder":"Nome del brand (obbligatorio)","LogoDesign_IndustryPlaceholder":"Settore (obbligatorio)","LogoDesign_Description":"Descrizione","LogoDesign_DescriptionPlaceholder":"Descrivi la storia del tuo brand, lo slogan, il pubblico di riferimento o gli elementi specifici che vuoi nel tuo logo...","LogoDesign_MoreSettings":"Impostazioni","LogoDesign_LogoType":"Tipo di logo","LogoDesign_StyleCount":"Stile & quantità","LogoDesign_Model":"Modello di generazione immagini","LogoDesign_BrandColors":"Colori del brand","LogoDesign_AutoColor":"Colore automatico","LogoDesign_DragUpload":"Trascina o fai clic per caricare","LogoDesign_DragUploadHint":"PNG, JPG e WEBP supportati. Carica un\'immagine nitida.","LogoDesign_UploadingImage":"Caricamento...","LogoDesign_ReplaceImage":"Cambia immagine","LogoDesign_ReferenceDimensions":"Dimensione di riferimento","LogoDesign_GenerateLogos":"Genera logo","LogoDesign_GenerateExpressLogos":"Genera 8 loghi","LogoDesign_GenerateConcepts":"Genera proposte di concept","LogoDesign_Processing":"Generazione in corso...","LogoDesign_StrategyTitle":"Scegli una direzione","LogoDesign_StrategyDesc":"Seleziona una direzione strategica prima di generare il logo finale.","LogoDesign_RegenerateStrategies":"Prova un\'altra strategia","LogoDesign_SelectStrategy":"Scegli una strategia","LogoDesign_GenerationHistory":"Cronologia delle generazioni","LogoDesign_NoHistory":"Ancora nessuna cronologia di generazione.","LogoDesign_EditInAgent":"Modifica in Agent","LogoDesign_GenerateMockups":"Genera mockup","LogoDesign_SelectMockupType":"Seleziona il tipo di mockup","LogoDesign_VoteLike":"Mi piace","LogoDesign_VoteDislike":"Non mi piace","LogoDesign_HeroTitlePro":"Identità visiva professionale del brand.","LogoDesign_HeroDescPro":"Dai concetti chiave alle applicazioni in più scenari, crea un sistema di brand unificato.","LogoDesign_HeroTitleExpress":"Soluzione per logo AI","LogoDesign_HeroDescExpress":"Esplora 8 diversi stili visivi in un\'unica generazione.","LogoDesign_Items":"Progetto","LogoDesign_UntitledBrand":"Marca senza titolo","LogoDesign_NoStrategy":"Nessuna strategia selezionata","LogoDesign_StrategyBadge":"Opzione","LogoDesign_Inspiration":"Ispirazione","LogoDesign_MockupGridPlaceholder":"Raccolta di scene mockup generate dall\'AI","LogoDesign_ValidationBrand":"Inserisci il nome del brand","LogoDesign_ValidationIndustry":"Seleziona o inserisci un settore","LogoDesign_ValidationStrategy":"Seleziona prima una strategia","LogoDesign_ValidationMockup":"Seleziona almeno un tipo di mockup","LogoDesign_Style_Minimalist":"Minimalista","LogoDesign_Style_Vintage":"Retrò","LogoDesign_Style_Geometric":"Geometria","LogoDesign_Style_Abstract":"Astratto","LogoDesign_Style_HandDrawn":"Dipinto a mano","LogoDesign_Style_Luxury":"Lussuoso","LogoDesign_Style_Tech":"High-tech","LogoDesign_Style_Nature":"Giornaliero","LogoDesign_LogoType_IconText":"Icona + testo","LogoDesign_LogoType_TextOnly":"Solo testo","LogoDesign_LogoType_IconOnly":"Solo icona","LogoDesign_LogoType_Lettermark":"Logo con lettera","LogoDesign_LogoType_Emblem":"Logo badge","LogoDesign_LogoType_Mascot":"Mascotte","LogoDesign_MockupType_BusinessCard":"Biglietto da visita","LogoDesign_MockupType_Signage":"Insegna del negozio","LogoDesign_MockupType_Packaging":"Post-produzione","LogoDesign_MockupType_Shirt":"Maglietta","LogoDesign_MockupType_ToteBag":"Borsa tote","LogoDesign_MockupType_Sticker":"Adesivi","LogoDesign_MockupType_OfficeSupplies":"Articoli per ufficio","LogoDesign_MockupType_AppIcon":"Icona dell\'app","LogoDesign_AddColor":"Aggiungi colore","LogoDesign_ReferenceDimension_Graphics":"Grafica","roboneo_agent_queue_tier_fast_description":"Genera subito. I crediti vengono addebitati per ogni generazione.","roboneo_agent_queue_tier_relax_description":"Generazione gratuita illimitata a una velocità leggermente inferiore. Nessun credito consumato.","roboneo_agent_queue_tier_relax_locked_description":"Un vantaggio di ${0} — generabile gratuitamente senza crediti.","roboneo_agent_queue_tier_upgrade_unlock":"Effettua l\'upgrade per sbloccare","Button_UpgradeForFree":"Effettua l\'upgrade gratis","Label_Teams":"Team","Title_AiModelAccess_Pricing":"Accesso al modello AI","Text_LimitedAiModels_Pricing":"Modelli video e immagine limitati","Label_GptImage2_Pricing":"GPT Image 2.0","Label_NanoBananaPro_Pricing":"Nano Banana Pro","Label_NanoBanana2_Pricing":"Nano Banana 2","Label_GeminiOmniFlash_Pricing":"Gemini omni Flash","Label_Seedance2Mini_Pricing":"Seedance2.0 Mini","Label_Seedance2Fast_Pricing":"Seedance 2.0 Fast","Label_Kling26_Pricing":"Kling 2.6","Label_Veo31_Pricing":"Veo 3.1","Label_Sora2_Pricing":"Sora 2","Label_Midjourney_Pricing":"Midjourney","Label_Seedance25ComingSoon_Pricing":"Seedance 2.5 (In arrivo)","Label_Seedream50Pro_Pricing":"Seedream 5.0 Pro","Label_NanoBanana_Pricing":"Nano Banana","Label_Seedream40_Pricing":"Seedream 4.0","Label_SeedEdit30_Pricing":"SeedEdit 3.0","Tab_VideoObjectRemover":"Rimozione video","Text_WholeProductGuide_DomesticCloneCase":"Carica l’immagine di un prodotto bestseller come riferimento e ricrea facilmente lo stesso stile","Text_ApparelGuide_DomesticCloneCase":"Carica un’immagine di moda di tendenza come riferimento e ricreane facilmente il look","Text_PosterCoverGuide_DomesticCloneCase":"Carica l’immagine di un poster di tendenza come riferimento e ricreane facilmente lo stile","Text_SocialGraphicsGuide_DomesticCloneCase":"Carica un\'immagine social di tendenza come riferimento e ricrea facilmente lo stile.","TaskName_WholeProductClone_DomesticCloneCase":"Bicchiere termico verde menta con motivo a gatti","TaskName_ApparelClone_DomesticCloneCase":"Camicia floreale da bambina con colletto Peter Pan","TaskName_PosterCoverClone_DomesticCloneCase":"Poster della guida gastronomica di Shunde","TaskName_SocialGraphicsClone_DomesticCloneCase":"Guida di viaggio a Jingdezhen","Label_SwitchToPage":"Passa alla pagina ${0}","File_Mention_Upload_Text":"Aggiungi dal dispositivo","File_Mention_Empty_Text":"Non hai ancora caricato nulla","Empty_Agent_Canvas_Text":"Tela IA","Empty_Agent_Canvas_Description":"Genera con l\'AI. Creatività senza limiti.","Label_Height":"Altezza","Label_Width":"Ampiezza","Agent_Guide_Placeholder_Title":"Inizia ora, crea liberamente","Agent_Guide_Placeholder_Agent_Title":"Agente di chat","Agent_Guide_Placeholder_Agent_Subtitle":"Crea da zero","Agent_Guide_Placeholder_Upload_Subtitle":"Modifica immagine esistente","Label_Text_Then":"Poi","Meta_Title_LogoDesign":"Design di loghi professionali semplificato con Zawa AI","Title_AppEnhancer":"Miglioramento video AI","Desc_AppEnhancer":"Migliora in 4K HD con un clic, con qualità e frame rate ottimizzati.","Title_AppWatermarkRemover":"Rimozione filigrane e sottotitoli dai video","Desc_AppWatermarkRemover":"Rimuovi rapidamente filigrane e loghi dai video.","Title_AppBackgroundRemover":"Rimozione dello sfondo dai video","Desc_AppBackgroundRemover":"Rimuovi gli sfondi dei video con un clic, senza registrazione.","Title_VideoDemos":"Prova questi video","Button_DownloadPreview":"Scarica l\'anteprima di 5 secondi","Text_PreviewDownloading":"Download del video di 5 secondi...","Title_PreviewVideo":"Video di anteprima di 5 secondi","Title_FullVideo":"Video completo","Button_DownloadFull":"Scarica il video completo","Text_FullDownloading":"Download del video completo...","Tip_FullVideoReady":"Il tuo video completo è pronto per il download.","Tip_Processing":"L\'elaborazione potrebbe richiedere del tempo. Non aggiornare la pagina. Ricontrolla più tardi.","Tip_ProcessComplete":"Elaborazione completata. Tocca per salvare il video sul telefono.","Tag_Purchased":"Acquistato","Text_Uploading":"Caricamento...","Message_ProcessFailed":"Elaborazione del video non riuscita.","Button_UploadVideo":"Carica video","Text_SupportFormat":"Formati supportati: ${0}","Button_UploadNew":"+ Carica nuovo video","Message_ProcessFailedRetry":"Elaborazione del video non riuscita. Controlla la connessione di rete e riprova.","Tip_MaxProcessNum":"È possibile elaborare fino a ${0} video alla volta. Riprova più tardi.","Tip_MaxUploadNum":"Puoi caricare fino a ${0} file video alla volta.","Message_VideoLoadFailed":"Impossibile caricare il video","Tip_VideoResolutionLimit":"I video con risoluzione superiore a 4K non sono supportati.","Tip_VideoDurationLimit":"Video oltre il limite. Mantienilo sotto i 20 minuti.","Tip_VideoSizeLimit":"Il video è troppo grande. Carica un video sotto ${0} MB.","Tip_VideoFormatLimit":"Formati video supportati: ${0}. Carica un video in un formato supportato.","Tip_Done":"Fatto","Text_IsProMember":"Sei un membro Pro.","Text_SubscribeToUnlock":"Abbonati per sbloccare.","Button_Enhance":"Avvia miglioramento","Button_Remove":"Avvia","Text_Enhancing":"Miglioramento...","Text_EnhancingFull":"Miglioramento dell\'intero video...","Text_Removing":"Rimozione...","Text_RemovingFull":"Rimozione dall\'intero video...","Text_RemovingSelectedArea":"Rimozione dell\'area selezionata...","Tag_Enhanced":"Migliorato","Tag_Removed":"Rimosso","Tag_Preview":"Anteprima di 5 secondi","Label_SelectResolution":"Seleziona la risoluzione","Message_DownloadFailed":"Download non riuscito. Controlla la connessione Internet e riprova.","Message_DownloadFailedRetry":"Download non riuscito. Riprova a scaricare.","Tab_Smart":"Riconoscimento intelligente","Tab_Watermark":"Watermark","Tab_Subtitle":"Sottotitoli","Tab_Manual":"Manuale","Label_BoxItem":"Seleziona l\'area da rimuovere","Tip_ClearManualBoxOnSwitch":"Cambiando modalità, la selezione verrà cancellata.","Label_Multiplier":"${0}x","Label_Resolution1K":"1K","Label_Resolution2K":"2K","Label_Resolution4K":"4K","Title_ConfirmVideoRights":"Conferma di avere il diritto di usare questo video.","Desc_ConfirmVideoRights":"Non caricare né importare contenuti di cui non sei titolare o che non sei legalmente autorizzato a utilizzare. Facendo clic su \\"Conferma\\", confermi di essere titolare di questo contenuto e che nessuno dei seguenti elementi violerà diritti di terzi o leggi applicabili: (i) Il contenuto stesso; (ii) Il tuo utilizzo dei nostri servizi; oppure (iii) Il nostro utilizzo del contenuto per fornire i servizi che hai richiesto.","Button_Import":"Importa","Title_ImportVideoLink":"Importa il link del tuo video","Label_ConfirmContentPermission":"Caricando il link, confermo di essere titolare di questo contenuto.","Placeholder_VideoLink_WatermarkRemover":"Inserisci un link al video per rimuovere la filigrana...","Placeholder_VideoLink_SocialPlatforms":"Supporta i link di TikTok, IG, YouTube e Facebook","Placeholder_VideoLink_SocialPlatforms_Domestic":"Supporta i link di Douyin, Kuaishou, Xiaohongshu e TikTok","Tip_InvalidLink":"Importa un link valido","Tip_LinkImportFailed":"Importazione non riuscita. Riprova.","Text_FileFromLink":"File collegato ${0}","Text_LinkImporting":"Importazione in corso: ${0}%","Button_Batch":"Gruppo","Button_Link":"Link","Title_MobileBatchUnsupported":"L\'elaborazione in batch non è ancora supportata su dispositivi mobili.","Text_VisitOnDesktop":"Apri su un computer:","Button_CopyAddress":"Copia","Text_UploadDropPasteClick":"Trascina e rilascia, incolla o fai clic per caricare","Text_UploadDropPasteClick_Support":"Supporta .mp4, .mov e m4v","Tips_UploadMaxVideoCountLimit":"Carica fino a ${0} file video","Title_AILogoDesign":"Design di logo IA","Title_AILogoPreview":"Design di logo IA","Message_IndustryLoadFailed":"Impossibile caricare i dati del settore","Message_LogoResultPartialFailed":"Impossibile recuperare alcuni risultati di generazione del logo.","Label_LogoGenerateMode":"Modalità di generazione logo","Tab_GeneralMode":"Modalità generale","Desc_StrongerLogoModel":"Basato su un modello più potente per loghi di qualità superiore","Button_CloseTip":"Chiudi consiglio","Label_LogoName":"Nome del logo","Label_LogoSlogan":"Sottotitolo/Slogan","Label_Optional":"Facoltativo","Placeholder_LogoDescription":"Descrivi il tono del brand, le parole chiave dello stile, i casi d’uso, ecc.","Title_AIServiceStatement":"Informativa sul servizio AI","Label_LogoCreateGuide":"Guida alla creazione del logo","Title_StartCreateLogo":"Inizia a creare il tuo logo","Desc_CreateLogoSchemes":"Inserisci le informazioni sul brand a sinistra per generare ${0} opzioni selezionate","Text_FillBrandInfo":"Inserisci le informazioni sul brand","Text_SelectGenerateMode":"Seleziona la modalità di generazione","Text_GetLogoScheme":"Ottieni design del logo","Label_AILogoPreview":"Anteprima ingrandita del logo AI","Button_ClosePreview":"Disattiva anteprima","Label_AILogoLarge":"Immagine grande del logo generata dall\'AI","Button_PreviousLogo":"Visualizza logo precedente","Button_NextLogo":"Visualizza logo successivo","Button_ScrollThumbnailsLeft":"Scorri le miniature verso sinistra","Label_LogoPreviewList":"Elenco anteprime logo","Button_SwitchLogo":"Passa a questo logo","Button_ScrollThumbnailsRight":"Scorri le miniature verso destra","Message_LogoDownloadFailed":"Download del logo non riuscito. Riprova più tardi.","Label_LogoGenerateResult":"Risultati logo","Title_GenerateResult":"Risultati:","Button_WatermarkPreference":"Imposta le preferenze della filigrana per il download","Button_SelectLogo":"Seleziona questo logo","Text_LogoGenerating":"Generazione del logo in corso...","Message_LogoGenerateFailedRetry":"Generazione non riuscita. Riprova.","Label_AIGeneratedLogo":"Logo generato dall\'IA","Button_EditLogo":"Modifica questo logo","Button_DownloadLogo":"Scarica questo logo","Button_PreviewLogo":"Anteprima di questo logo","Message_RecordLoadFailed":"Impossibile caricare la cronologia di generazione","Message_MoreRecordsLoadFailed":"Impossibile caricare altri record","Message_LogoBatchDownloadFailed":"Download multiplo dei Logo non riuscito. Riprova più tardi.","Label_RecordLoading":"Caricamento cronologia...","Label_LogoRecords":"Cronologia dei loghi","Label_GenerateMode":"Modalità di generazione","Text_GenerateTime":"Tempo di generazione: ${0}","Button_ZoomLogo":"Visualizza il logo a schermo intero","Text_NoMoreRecords":"Non ci sono altri record","Message_GenerateTaskSubmitted":"Attività di generazione inviata","Message_LogoGenerateFailed":"Generazione del logo non riuscita. Riprova più tardi.","Button_QuickGenerate":"Genera rapidamente","Label_GenerateViral_ViralVideo":"Genera video virale","Label_ReplicateViral_ViralVideo":"Replica video virale","Message_SelectMarket_ViralVideo":"Seleziona un mercato di destinazione","Message_SelectLanguage_ViralVideo":"Seleziona la lingua del video","Message_SelectRatio_ViralVideo":"Seleziona un formato","Message_FillScript_ViralVideo":"Compila lo script personalizzato","Message_SetScriptCount_ViralVideo":"Imposta il numero di script personalizzati da generare","Message_SelectViralType_ViralVideo":"Seleziona almeno un tipo virale","Message_MaxViralTypes_ViralVideo":"Il totale dei tipi virali non può superare ${0}","Message_InputTaskTitle_ViralVideo":"Inserisci un titolo per l\'attività","Message_FillSellingPoints_ViralVideo":"Compila la descrizione dei punti di forza","Message_ProductImageShortEdgeLimit_ViralVideo":"Carica un\'immagine con il lato corto maggiore di 300px","Message_ProductImageAspectRatioSuggestion_ViralVideo":"Consigliamo di caricare un\'immagine 16:9, 9:16 o 1:1","Message_UploadRefVideo_ViralVideo":"Carica un video di riferimento","Message_TaskCancelled_ViralVideo":"Attività annullata","Text_GenerateTaskTitle_ViralVideo":"Attività genera virale ${0}","Text_ReplicateTaskTitle_ViralVideo":"Attività replica virale ${0}","Text_TaskCopyTitle_ViralVideo":"${0}-Copia","Message_FetchConfigFailed_ViralVideo":"Impossibile caricare la configurazione iniziale del video virale","Title_VideoResult_ViralVideo":"Risultato video","Text_AiGenerating_ViralVideo":"L\'IA sta generando...","Text_CheckingSellingPoints_ViralVideo":"Controllo del contenuto...","Label_EmailNotify_ViralVideo":"Avvisami via email quando è pronto","Title_LinkEmail_ViralVideo":"Collega un indirizzo email","Text_LinkEmailDesc_ViralVideo":"Il tuo account non ha ancora un indirizzo email. Collegalo nel Centro account, poi torna qui per attivare le notifiche email.","Text_LinkEmailRedirect_ViralVideo":"Verrai reindirizzato al Centro account per completare il collegamento e la verifica dell\'email.","Button_GoToAccountCenter_ViralVideo":"Vai al Centro account","Title_EmailNotifyConfirm_ViralVideo":"Ricevere notifiche email?","Text_EmailNotifyConfirm_ViralVideo":"Avviseremo ${0} quando i tuoi video saranno pronti.","Message_EmailLinked_ViralVideo":"Email collegata. Attiva le notifiche se vuoi essere avvisato quando questo video è pronto.","Message_EmailNotifyOff_ViralVideo":"Notifiche email disattivate","Message_EmailNotifyOn_ViralVideo":"Notifiche email attivate","Text_NoHistory_ViralVideo":"Nessuna cronologia","Text_MobileGuideGenerate_ViralVideo":"Carica immagini del prodotto e punti di forza per creare rapidamente video virali promozionali.","Text_MobileGuideReplicate_ViralVideo":"Carica immagini del prodotto e un video di riferimento per replicare il ritmo e lo stile visivo di un video virale.","Label_DKGenerateViralMobileGuideNavTitle_ViralVideo":"Genera video virale","Label_DKGenerateViralMobileGuideTitle_ViralVideo":"Genera video virale","Text_DKGenerateViralMobileGuideSubtitle_ViralVideo":"Carica immagini del prodotto e punti di forza per creare rapidamente video virali promozionali.","Label_DKReplicateViralMobileGuideNavTitle_ViralVideo":"Replica video virale","Label_DKReplicateViralMobileGuideTitle_ViralVideo":"Replica video virale","Text_DKReplicateViralMobileGuideSubtitle_ViralVideo":"Carica immagini del prodotto e un video di riferimento per replicare il ritmo e lo stile visivo di un video virale.","Label_ZawaGenerateViralMobileGuideNavTitle_ViralVideo":"Generatore di video prodotto","Label_ZawaGenerateViralMobileGuideTitle_ViralVideo":"Generatore di video prodotto","Text_ZawaGenerateViralMobileGuideSubtitle_ViralVideo":"Carica immagini del prodotto e punti di forza per creare rapidamente video virali promozionali.","Label_ZawaReplicateViralMobileGuideNavTitle_ViralVideo":"Remix video","Label_ZawaReplicateViralMobileGuideTitle_ViralVideo":"Remix video","Text_ZawaReplicateViralMobileGuideSubtitle_ViralVideo":"Carica immagini del prodotto e un video di riferimento per replicare il ritmo e lo stile visivo di un video virale.","Button_ConfirmGenerate_ViralVideo":"Conferma e genera","Button_Close_ViralVideo":"Chiudi","Button_Previous_ViralVideo":"Precedente","Button_Next_ViralVideo":"Successivo","Message_CreateTaskFailed_ViralVideo":"Creazione dell\'attività non riuscita, riprova più tardi","Message_RefreshFailed_ViralVideo":"Aggiornamento non riuscito, riprova più tardi","Message_VideoFormatLimit_ViralVideo":"Il video di riferimento supporta attualmente solo mp4 / mpeg / mov / avi / flv / mpg / webm / wmv / 3gpp","Message_ReferenceVideoSizeLimit_ViralVideo":"La dimensione del video di riferimento non può superare ${0}MB","Message_UploadRefVideoFirst_ViralVideo":"La replica virale richiede prima il caricamento di un video di riferimento","Message_FillProductInfo_ViralVideo":"Compila i punti di forza del prodotto","Message_SelectVideoType_ViralVideo":"Seleziona tipo e quantità di video","Button_Disabled_ViralVideo":"Disattiva","Text_LoadingCreator_ViralVideo":"Caricamento dei miei creator...","Text_NoCreatorYet_ViralVideo":"Nessuna immagine creator, prova a caricarne una","Text_TotalCount_ViralVideo":"(Totale ${0})","Text_Submitting_ViralVideo":"Invio in corso...","Text_LoadingConfig_ViralVideo":"Caricamento configurazione...","Button_Decrease_ViralVideo":"Diminuisci","Button_Increase_ViralVideo":"Aumenta","Title_NightHosted_ViralVideo":"Hosting notturno","Message_CreatorGenSuccess_ViralVideo":"Creator generato con successo","Button_ContinueNewTask_ViralVideo":"Avvia una nuova attività","Text_CustomScriptCount_ViralVideo":"Script personalizzato × ${0}","Text_ViralTypeCount_ViralVideo":"Tipi virali × ${0}","Text_FissionCount_ViralVideo":"Variazioni virali × ${0}","Text_AiModelEnabled_ViralVideo":"Modello AI attivato","Label_ModelTab_ViralVideo":"Scheda modello","Label_ModelParams_ViralVideo":"Parametri modello","Text_ParamsAdjusted_ViralVideo":"Parametri personalizzati individualmente","Text_NoSellingPoints_ViralVideo":"Nessun punto di forza fornito","Message_FillSellingPointsPlease_ViralVideo":"Aggiungi una descrizione dei punti di forza","Message_ThanksForFeedback_ViralVideo":"Grazie per il feedback!","Title_AdditionalFeedback_ViralVideo":"Feedback aggiuntivo","Placeholder_FeedbackBetter_ViralVideo":"cosa potrebbe migliorare?","Button_SubmitFeedback_ViralVideo":"invia feedback","Button_LikeFeedback_ViralVideo":"Mi piace","Button_DislikeFeedback_ViralVideo":"Non mi piace","Text_ProductImageCount_ViralVideo":"${0} immagine/i prodotto","Text_RefVideoCount_ViralVideo":"${0} video di riferimento","Text_FollowGlobal_ViralVideo":"Segue le impostazioni globali","Message_BatchSubmitSuccess_ViralVideo":"Inviati con successo ${0} task di video virali","Message_BatchSubmitFailed_ViralVideo":"Invio batch video virali non riuscito, riprova più tardi","Text_MaxSelectionTip_ViralVideo":"Puoi selezionare fino a ${0} tipi di video alla volta","Text_DeselectItem_ViralVideo":"Deseleziona ${0}","Text_SelectItem_ViralVideo":"Seleziona ${0}","Tab_CustomCreatorSection_ViralVideo":"Creator personalizzato","Tab_MyCreatorSection_ViralVideo":"I miei creator","Tab_PersonalAssets_ViralVideo":"Asset personali","Tab_OfficialRecommendation_ViralVideo":"Scelte ufficiali","Title_CustomCreatorSection_ViralVideo":"Crea il tuo creator personalizzato","Text_InProgress_ViralVideo":"Generazione in corso...","Text_NothingToDownload_ViralVideo":"Nessun risultato scaricabile al momento","Text_ResultNotReady_ViralVideo":"Questo risultato non è ancora pronto per il download","Text_PreparingDownload_ViralVideo":"Preparazione del download...","Text_PreDownloaded_ViralVideo":"Elaborazione completata. Tocca per salvare il video sul telefono.","Message_RedoSubmitted_ViralVideo":"Richiesta di rifare inviata","Message_RedoFailed_ViralVideo":"Rifare non riuscito, riprova più tardi","Text_CancelHostedConfirm_ViralVideo":"Annullando l\'hosting si interromperà qualsiasi generazione in corso.","Button_Later_ViralVideo":"Più tardi","Message_HostedCancelled_ViralVideo":"Hosting annullato","Text_BatchFailed_ViralVideo":"Questo batch non ha restituito risultati — puoi rigenerare più tardi.","Title_ViralTypeConfig_ViralVideo":"Configurazione tipi virali (Totale ${0})","Title_ReplicateConfig_ViralVideo":"Configurazione replica","Label_ReplicateCount_ViralVideo":"Numero di repliche","Label_StylePreference_ViralVideo":"Preferenza di stile","Placeholder_StylePreference_ViralVideo":"Puoi specificare preferenze come ritmo, mood, linguaggio della camera, tono di colore, ecc.","Label_SupplementNote_ViralVideo":"Note aggiuntive","Placeholder_SupplementNote_ViralVideo":"Aggiungi strutture che non vuoi modificare, inquadrature da preservare, requisiti speciali sui punti di forza, ecc.","Text_FourthSection_ViralVideo":"4. Numero di variazioni","Message_RequestFailed_ViralVideo":"Richiesta non riuscita","Message_PromptOptimizeFailed_ViralVideo":"Ottimizzazione del prompt non riuscita, riprova più tardi","Message_ModelImageFailed_ViralVideo":"Generazione immagine modello non riuscita, riprova più tardi","Desc_BatchGenerateViral_ViralVideo":"Carica in batch le immagini del prodotto, configura i punti di forza e genera task di video virali.","Desc_BatchReplicateViral_ViralVideo":"Carica in batch le immagini del prodotto e aggiungi video di riferimento per ogni task per replicare contenuti virali.","Text_RecordRetentionTip_ViralVideo":"I record di generazione vengono conservati solo per 2 mesi. Scaricali e salvali al più presto per evitare perdite.","Message_PromptOptimizeEmpty_ViralVideo":"L\'ottimizzazione del prompt non ha restituito risultati","Message_CompleteModelInfo_ViralVideo":"Completa prima le informazioni del modello","Message_ModelGenFailed_ViralVideo":"Generazione del modello non riuscita, riprova più tardi","Text_VideoFormatSupport_ViralVideo":"Il video di riferimento supporta attualmente solo i formati mp4 / mpeg / mov / avi / flv / mpg / webm / wmv / 3gpp","Message_UnsupportedVideoFiltered_ViralVideo":"Alcuni formati video non sono supportati e sono stati filtrati","Message_FreeTrialOneVideoOnly_ViralVideo":"La prova gratuita copre solo 1 video. Passa a Pro per generarne di più.","Button_AddToMyCreator_ViralVideo":"Aggiungi ai miei creator","Button_ResetGlobal_ViralVideo":"Ripristina globale","Button_TaskLevelCustomCreator_ViralVideo":"Creator personalizzato a livello di task","Button_TaskLevelReplicateModel_ViralVideo":"Modello di replica a livello di task","Label_ModelReference_ViralVideo":"Immagine di riferimento del modello","Placeholder_CreatorStyle_ViralVideo":"Aggiungi persona del creator, stile di parlato, presenza in camera, ecc.","Text_CreatorDisabledTip_ViralVideo":"Se la configurazione del creator non è attiva, il sistema genererà con lo stile on-camera generico predefinito.","Text_GenerateViralResult_ViralVideo":"Risultati virali generati","Text_OverrideCount_ViralVideo":"Sovrascrivi ${0} elemento/i","Text_ReplicateViralResult_ViralVideo":"Risultati virali replicati","Text_SavedCreatorProfiles_ViralVideo":"Profili creator salvati — compila con un clic.","Label_GenerateScheme_ViralVideo":"Piano generazione virale ${0}","Label_ReplicateScheme_ViralVideo":"Piano replica virale ${0}","Text_VideoResult_ViralVideo":"Risultato video","Button_ContinueGenerate_ViralVideo":"Continua a generare","Desc_CreatorImageEmptyHint_ViralVideo":"Le immagini creator generate appariranno qui per il riutilizzo diretto in questa pagina.","Text_ItemCountUnit_ViralVideo":"${0} elementi","Text_CreditAmount_ViralVideo":"${0} crediti","Text_TotalItems_ViralVideo":"Totale: ${0}","Text_SelectedVideoTypeCount_ViralVideo":"${0} tipi di video selezionati","Text_FirstVideoDiscountBadge_ViralVideo":"Sconto primo video","Text_DesignKitFirstDiscountVipBadge_ViralVideo":"50% OFF sul 1°","Text_DesignKitFirstDiscountTryBadge_ViralVideo":"Prova a $1.99","Text_FreeVideoBadge_ViralVideo":"${0} video gratuito","Text_FirstDiscountPrice_ViralVideo":"Genera il primo video a soli ${0} crediti (originale ${1} crediti)","Text_UpgradeProDiscount_ViralVideo":"Passa a Pro per il 25% di sconto","Text_EnjoyedProDiscount_ViralVideo":"Sconto membro 25% applicato","Text_BatchFeatureRequiresMembership_ViralVideo":"La generazione batch richiede un abbonamento","Text_OpenProGenerationDiscount_ViralVideo":"Abbonati a Pro per il 25% di sconto sulla generazione","Text_EnjoyedProGenerationDiscount_ViralVideo":"Sconto Pro 25% sulla generazione applicato","Button_OpenProOrMembership_ViralVideo":"Abbonati a Pro / Membership","Text_MemberExclusiveBadge_ViralVideo":"Solo membri","Text_VipFunctionLimitedTimeOpen_ViralVideo":"Funzioni VIP disponibili per un periodo limitato","Title_NetworkDisconnected_ViralVideo":"Connessione di rete persa","Text_NetworkDisconnectedRefresh_ViralVideo":"La tua attività continua a generarsi in background e non andrà persa. Controlla la rete, poi aggiorna la pagina per vedere l\'ultimo avanzamento.","Button_RefreshPage_ViralVideo":"Aggiorna pagina","Message_NetworkDisconnectedRetry_ViralVideo":"Connessione di rete persa. Controlla la rete e riprova.","Tip_InvalidLink_ViralVideo":"Inserisci un link video valido","Title_GenerateParams_ViralVideo":"Parametri di generazione","Label_PreviewMarket_ViralVideo":"Mercato di destinazione:","Label_PreviewLanguage_ViralVideo":"Lingua di destinazione:","Label_PreviewAspectRatio_ViralVideo":"Formato:","Label_PreviewScriptType_ViralVideo":"Tipo di script:","Label_PreviewProductInfo_ViralVideo":"Punti di forza del prodotto:","Text_GeneratingBrowserTitle_ViralVideo":"⏳ Generazione... | ${0}","Text_SimplePreviewSwipeGuide_ViralVideo":"Scorri verso l\'alto per vedere di più","Button_UploadImageReplicate_ViralVideo":"Carica immagine per replicare","Label_PlayVideo_ViralVideo":"Riproduci video","Label_NoWatermark_ViralVideo":"Senza filigrana","Tool_LosslessUpscale":"Upscaler immagini","Tool_AiRecolor":"Ricolora immagine con AI","Tool_AiPhotoEditorTitle":"Editor foto AI","Message_ZipOnlyOne":"Puoi caricare un solo archivio alla volta","Message_ZipSizeLimit":"Le dimensioni del file compresso non possono superare ${0} MB","Message_ZipExtractFailed":"Impossibile analizzare l\'archivio ${0}","Message_ZipNoUploadableFiles":"${0} Nessun file caricabile trovato in questo archivio compresso","Message_ZipAlreadyUploaded":"Tutti i file in ${0} sono già stati caricati. I caricamenti duplicati sono stati ignorati.","Title_VideoWatermark":"Il tuo video contiene una filigrana","Desc_VideoWatermark":"I video esportati durante il periodo di prova includeranno una filigrana ${0}. Passa a Premium per scaricare video senza filigrana.","Button_RemoveWatermark":"Rimuovi filigrana","Button_DownloadAnyway":"Scarica comunque","Message_DownloadFailedTryAgain":"Download non riuscito. Riprova.","MenuItem_ProductRestore":"Ripristino prodotto","Title_ProductRestore":"Ripristino prodotto","Desc_ProductRestore":"Carica un\'immagine originale per correggere la distorsione del prodotto","Tip_ProductRestoreUpload":"Scegli un\'immagine con angolazione e orientamento simili al risultato attuale. Il prodotto deve essere nitido e completamente visibile.","Button_StartProductRestore":"Avvia il ripristino","Message_ProductRestoreUploadLimit":"Carica un\'immagine in formato JPEG, JPG, PNG o HEIC, di massimo 10 MB.","Message_ProductRestoreUploadFailed":"Impossibile caricare l\'immagine per il ripristino del prodotto. Riprova.","Message_VideoDownloadingInBackground":"Download in corso in background. Puoi continuare a usare ${0}","Button_AdjustParameters":"Regola le impostazioni","Text_WPS_Welcome_Modal_Meidou_Description1":"Membri Premium: bonus una tantum di 50 crediti","Text_WPS_Welcome_Modal_Meidou_Description2":"Utenti non Premium: bonus una tantum di 25 crediti","Text_WPS_Meidou_Rules":"Regole d\'uso dei crediti","Text_WPS_Meidou_Details":"Dettagli sull\'utilizzo dei crediti","Button_ImportLink":"Importa link","Tip_ProductImagesUpload":"Carica più foto del prodotto da diverse angolazioni per risultati migliori","Button_EditSkill":"Competenze di modifica","Title_CategorySkills":"Competenze ${0}","Button_AllSkills":"Tutte le skill","Text_NoSkills":"Nessuna skill disponibile","Aria_ScrollLeft":"Scorri verso sinistra","Aria_ScrollRight":"Scorri verso destra","Message_CompleteRequired":"Completa i campi obbligatori","Button_InsertToDesc":"Aggiungi alla descrizione","Aria_ExpandOptions":"Opzioni di espansione","Message_FileUploadFailedRetry":"Caricamento del file non riuscito. Riprova.","Button_UploadImageVideo":"Carica immagini/video","Aria_DeleteFile":"Elimina i file","Aria_PauseVideo":"Metti in pausa il video","Aria_SwitchToSlide":"Passa all\'immagine ${0}","Tip_PleaseFill":"Compila ${0}","Tool_ImageToVideoGenerator":"Generatore di video da immagini","Tool_TextToVideoGenerator":"Generatore di video da testo","Tool_TikTokVideoGenerator":"Generatore di video per TikTok","Tool_InstagramVideoGenerator":"Generatore di video per Instagram","Tool_YouTubeVideoGenerator":"Generatore di video YouTube","Tool_YouTubeShortsGenerator":"Generatore di YouTube Shorts"}');
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/x-design-locales-next/pt.json
const x_design_locales_next_pt_namespaceObject = JSON.parse('{"Tab_Design":"Design","Button_Send":"Enviar","Input_Describe_Workspace":"Descreva a sua ideia de imagem e vou criá-la para você","Tab_AgentCase":"Caso do agente","Tab_RecentCreations":"Recentes","Tag_Hot":"Tendência","Tag_BrandDesign":"Design de marca","Tag_Logo":"Logotipos","Tag_Posters":"Pôsteres","Tab_Agent":"Agente","Tool_AiPhotoEditor":"Editor de imagem","Button_Upload":"Carregar","Tool_Designer":"Designer","Title_AiTool":"Ferramentas de IA","Tool_ImageBackgroundRemover":"Removedor de fundo com IA","Tool_AiBackgroundGenerator":"Gerador de fundo com IA","Tool_ImageEnhancer":"Aprimorador de imagem","Tool_AiObjectsRemover":"Removedor de Objetos","Tool_AiModelMannequin":"Modelo de IA - Manequim","Tool_AiModelFlatlay":"Modelo de IA - Flatlay","Tool_AiImageRecolor":"Recolorir imagem com IA","Tool_AiImageExtender":"Extensor de imagem com IA","Tool_ImageUpscaler":"Ampliador de imagem com IA","Tool_AiLogo":"Gerador de Logo","Button_BlankCanvas":"Criar","Sidebar_Create":"Início","Sidebar_Tools":"Ferramentas de IA","Sidebar_Batch":"Editor em lote","Sidebar_MyDesigns":"Meus designs","Sidebar_Inspire":"Me inspire","Sidebar_Brand":"Kit de marca","Sidebar_PackUp":"Fechar barra lateral","Tag_All":"Tudo","Tag_Design":"Design","Sidebar_Unfold":"Abrir barra lateral","Menu_Edit":"Editar","Menu_Download":"Baixar","Menu_Delete":"Excluir","Tab_RecentlyCreated":"Recentes","Tab_GenerateRecords":"Criações","Menu_Total":"Total","Menu_Total_Explain_AgentCredits":"Apenas para o agente de IA e serão usados primeiro.","Menu_DueToday":"Créditos de bônus diários","Menu_DueToday_Explain":"Válidos até o final do dia.","Menu_Else_AgentCredits":"Outros créditos","Button_GoPro_GetMore":"Obtenha mais créditos","Menu_Total_Explain_PaidCredits":"Para todos os recursos e válidos durante o período de assinatura.","Menu_Pro":"Créditos de assinatura","Menu_Pro_Explain":"Válidos durante o período de assinatura.","Menu_Else":"Outros créditos","Menu_Else_Explain_PaidCredits":"Créditos obtidos de outras fontes. Cada tipo pode ter seu próprio prazo de validade.","Menu_Else_Explain_AgentCredits":"Créditos de outras fontes. Válidos por um período mais longo.","Menu_UsageDetail":"Detalhes de uso","Menu_Total_Explain_SuspendCredits":"Indisponíveis até que sua assinatura seja reativada.","Tab_Invite":"Convidar","Menu_InviteReward":"Recompensa por convidar amigos","Tab_Reward":"Recompensas","Title_AgentCreditForRewards":"Recompensas de Créditos de Agente:","Table_Time":"Hora","Table_Invitee":"Convidado","Title_ShareWithFriends":"Compartilhe com seus amigos","Title_ShareWithFriends_ExplainOne":"<span style=\\"color:#616266;\\">Convide um amigo e ambos receberão </span><span style=\\"color:#2D990C;\\">${0} Créditos de Agente!</span>","Title_InvitationLink":"Compartilhe este link com seus amigos","Button_Copy":"Copiar","Title_Tips":"Dicas","Title_Tips_ExplainOne":"1. Os Créditos de Agente só podem ser usados para acessar os recursos do Agente de IA. Créditos de recompensa são válidos por dois anos.","Title_Tips_ExplainTwo":"2. Novos amigos receberão uma recompensa após se registrarem com sucesso. Se você tiver alguma dúvida, entre em contato com nossa equipe de suporte.","Title_GetRewarded":"Convite bem-sucedido!","Title_GetRewarded_Explain":"Os créditos só podem ser usados para recursos do Agente de IA e são válidos por dois anos.","Button_Ok":"Entendi","Title_FailedToReceiveReward":"Falha na operação","Title_FailedToReceiveReward_Explain":"Se você tiver alguma dúvida, entre em contato com nossa equipe de suporte.","Tool_AiBackgroundGenrator":"Gerador de fundo com IA","Title_YouCannotUseYourOwnLink":"Links privados não são permitidos","Table_AgentCredit":"Créditos de Agente","Title_ShareWithFriends_ExplainTwo":"<span style=\\"color:#616266;\\">Você pode convidar até </span><span style=\\"color:#2D990C;\\">${0} novos amigos</span><span style=\\"color:#616266;\\"> e ganhar no máximo ${1} Créditos de Agente!</span>","Button_Invite":"Convidar","Menu_Title_Invite":"Indicar um amigo","Text_Button_Invite":"Ganhar créditos","Title_Dialog_Invite":"Indicar um amigo","Desc_Dialog_Invite":"Compartilhe seu link com amigos ou nas redes sociais. Quando alguém usar seu link para se inscrever, você e essa pessoa receberão ${0} créditos. Se ela assinar, vocês receberão até ${1} créditos extras.","Detail_Dialog_Invite":"Detalhes","Text_Copy_Invite":"Copiar link","Title_Rewards_Invite":"Recompensas","SubTitle_Rewards1_Invite":"Total de créditos ganhos","SubTitle_Rewards2_Invite":"Usuários não pagantes indicados","SubTitle_Rewards3_Invite":"Usuários pagantes indicados","Success_Copy_Invite":"Link copiado","Title1_Invited_Invite":"Você recebeu um convite!","Text_Rule1_Invite":"Para cada pessoa que assinar usando seu link, você e essa pessoa ganham <strong>${0} créditos</strong>.","Text_Rule2_Invite":"Se seu amigo assinar, cada um de vocês receberá créditos extras (<strong>${0} para o plano Plus, ${1} para o Pro</strong>).","Text_Rule3_Invite":"As assinaturas adquiridas não poderão ser reembolsadas se o plano tiver sido usado ou se algum crédito concedido tiver sido gasto. Além disso, créditos gratuitos não podem ser revogados depois de utilizados.","Text_Rule4_Invite":"Cada usuário pode convidar até ${0} amigos.","Text_Rule5_Invite":"Recompensas por indicações não são concedidas no caso de contas existentes, auto-indicações, contas duplicadas ou atividades fraudulentas.","Text_Rule6_Invite":"${0} se reserva o direito de ajustar o programa e revogar recompensas de contas anormais.","Text_Divider_Invite":"ou compartilhe o link","Title2_Invited_Invite":"Participe de ${0} e reivindique suas recompensas","SubTitle1_Invited_Invite":"Um amigo convidou você para experimentar nosso agente de IA profissional. Crie designs de marketing com alta qualidade para marcas, como logotipos, cartazes, cardápios e materiais de mídias sociais com facilidade.","SubTitle2_Invited_Invite":"<strong>Cadastre-se agora</strong> e você e seu amigo <strong>receberão ${0} créditos</strong>. <strong>Se você assinar,</strong> cada um receberá créditos adicionais de acordo com o plano escolhido: <strong>${1} créditos com o Plus ou ${2} créditos com o Pro</strong>. Cadastre-se agora para resgatar suas recompensas.","Button_Invited_Invite":"Inscreva-se para reivindicar suas recompensas","Success_Invited_Invite":"Você entrou por meio de uma indicação e recebeu ${0} créditos.","Error_Invited_Invite":"Você já tem uma conta.","Text_Share_Invite":"Tenho usado o ${0} para criar logotipos, visuais e vídeos de modo realmente muito rápido. Inscreva-se com meu link e nós dois receberemos créditos de bônus.","Title_Share_Invite":"Faça parte de ${0} e ganhem créditos juntos!","Share_Email_Invite":"E-mail","Text_Rule7_Invite":"Você pode usar os créditos com o Agente de IA. Eles expiram depois de um mês.","Title_AgentCredits":"+50 Créditos de Agente","Input_Models":"Modelo","Button_TryItNow":"Experimente agora","Account_Pricing":"Preços","Account_Language":"Idioma","Account_Language_English":"Inglês","Account_Language_Chinese":"Chinês","Tips_Adding":"Processando...","Tips_Loading":"Carregando...","Tips_Creating":"Processando...","Tips_Downloading":"Baixando...","Tips_Sending":"Enviando...","Tips_AddSuccess":"Adicionado com sucesso","Tips_MakeSameError":"Não é possível recriar","Tips_UnsupportedGradientColor":"Os gradientes não são suportados","Tips_CanNotAdding":"Falha ao adicionar","Tips_Uninitialized":"Falha ao enviar mensagens","Tips_UploadFailed":"Falha no carregamento. Por favor, tente novamente.","Tips_UploadMaxCountLimit":"Carregue até ${n} arquivo(s) ${type}","Tips_UploadMaxFileSize":"Não foi possível carregar o arquivo ${file}. Por favor, use um arquivo com tamanho máximo de ${n} MB.","Tips_UploadImageAndVideoLimit":"Você pode carregar 1 imagem e 1 vídeo ao mesmo tempo","Tips_UnsupportedSvgFile":"Arquivos SVG não são suportados","Tips_UnsupportedUploadFileFormats":"O formato do seu arquivo ${files} não é compatível","Tips_CanNotAddSameFileTips":"Este arquivo já existe","Tips_TextMinLengthTips":"Insira pelo menos ${n} caracteres","Tips_TextMaxLengthTips":"Insira até ${n} caracteres. Cada caractere chinês ou emoji conta como 2.","Tips_AccessDenied":"Acesso negado","Tips_CreateFailed":"Falha ao iniciar o chat","Tips_Error":"Ocorreu um erro","Tips_NotFound":"O chat não existe","Tips_RequestAgentModelListError":"Falha ao solicitar a lista de modelos do agente","Desc_Ended":"Fim","Button_PeopleUse_Agent":"${n} usuários experimentaram","Dropdown_AddToChat":"Adicionar ao chat","Dropdown_AddToBrandKit":"Adicionar ao kit de marca","Dropdown_SaveToBrandKit":"Salvar como logotipo de marca","Dropdown_SaveToBrandTemplate":"Salvar como modelo de marca","Title_Design_Agent":"Design","Title_MainColor":"Cor principal","Title_SecondaryColor":"Cor secundária","Bitton_ViewTheBrandKit":"Clique para ver o kit de marca","Dropdown_InportImages":"Importar imagens","Title_Upgrade_Pro":"Atualizar","Desc_SubscribeToUnlock_Pro":"Assine para desbloquear mais!","Desc_RunOutOfFreeUses_Pro":"Você esgotou suas utilizações gratuitas.","Desc_RunOutOfUsesForToday_Pro":"Você esgotou seus usos gratuitos de hoje. Volte amanhã.","Desc_PurchaseCompleted_Pro":"Compra concluída","Desc_ContinueDesign_Pro":"Agora você pode continuar seu projeto!","Button_UnlockNow":"Assinar","Tips_Copied":"Copiado!","Tips_Credit_Explain_Paid":"O que são créditos comprados?","Title_Total_InactiveCredits":"Total de créditos inativos","Title_Total_PaidCredits":"Créditos totais adquiridos","Menu_SuspendCredits":"Créditos inativos","Menu_Credits":"Créditos","Tab_RecentCreations_Agent":"Agente","Tab_RecentCreations_Design":"Ferramentas inteligentes","Menu_FunctionalPricing":"Preços do agente","Title_Total_AgentCredits":"Total - Créditos de Agente","Tips_Credit_Explain_Agent":"O que são Créditos de Agente?","Title_FeaturePricing":"Preços do agente","Tab_Category":"Categoria","Tab_TaskType":"Tarefa","Tab_Consume":"Preço (Créditos)","Tab_ExampleContent":"Exemplos","Tips_CreditExplain_Inactive":"O que são os créditos inativos?","langding_more_bg_remover":"Removedor de fundo","langding_more_enhancer":"Aprimorador de imagem","langding_more_objects_remover":"Removedor de Objetos","langding_more_bg_generator":"Gerador de fundo com IA","Title_More1_Home":"Aprimorador de imagem","Title_More2_Home":"Removedor de objeto com IA","Title_More3_Home":"Gerador de fundo com IA","Title_More4_Home":"Removedor de fundo com IA","Title_More5_Home":"Ferramentas para lotes de imagens","Title_Home":"Seu agente de design com IA para <span>e-commerce</span>","Placeholder_Input_Home":"Descreva sua imagem e vou criá-la para você.","Title_Card4_Home":"Elementos visuais para a Amazon","Title_Card1_Home":"Provador virtual de roupas e acessórios","Title_Card3_Home":"Imagens para a página de detalhes de produto","Title_Card2_Home":"Gerador de fundos","Desc_Features1_Home":"A IA extrai automaticamente as características do produto e as preferências de estilo para determinar as soluções ideais de design.","Desc_Features2_Home":"Basta inserir uma frase e a IA gerará uma coleção completa de imagens de e-commerce, incluindo a imagem principal, elementos visuais de apoio e uma página com detalhes completos sobre o produto.","Text_Btn_Home":"Comece gratuitamente","Desc_Features3_Home":"Crie automaticamente elementos personalizados prontos para plataformas como Amazon, Etsy, TEMU, eBay e muito mais, garantindo que as imagens sempre sejam otimizadas para atrair o público certo.","Desc_Features4_Home":"Basta inserir seu pedido, e a IA adaptará a linguagem, o estilo, o tom e os elementos culturais para produzir versões localizadas para cada mercado-alvo.","Desc_Features5_Home":"Salve o fluxo de trabalho do seu design como um modelo reutilizável, e deixe que a IA gere imagens em lote automaticamente para todas as SKUs.","Desc_Features6_Home":"Não faz diferença se você está trabalhando com 10 ou 1.000 produtos; gere rapidamente um conjunto visual completo e consistente com facilidade.","Title_Qualification_Home":"Mais de 5 milhões de vendedores de e-commerce confiam!","Text_Btn_Qualification_Home":"Exibir certificado","Title_Carousel_Home":"Mais ferramentas de IA","Title_Footer_Home":"Seu agente de design com IA para e-commerce","Title_Footer1_Home":"Conta de mídia social","Subtitle_Footer1_Home":"YouTube","Subtitle_Footer2_Home":"X","Subtitle_Footer3_Home":"Instagram","Subtitle_Footer4_Home":"TikTok","Title_Footer2_Home":"Ajuda e informações legais","Subtitle_Footer5_Home":"Termos de Serviço","Subtitle_Footer6_Home":"Política de Privacidade","Copyright_Footer_Home":"Copyright ${0} Meitu, Inc.","Desc_Evaluation1_Home":"Adoro Designkit! As imagens de estilo de vida da IA são naturais, e o estilo nórdico aconchegante é perfeito para a minha loja de velas. As minhas publicações têm um visual elegante e as vendas têm aumentado. Vale muito a pena.","Job_Evaluation5_Home":"Vendedor da TEMU no México","Job_Evaluation6_Home":"Especialista em operações da Amazon","Job_Evaluation12_Home":"Gerente de uma loja com várias SKUs na Amazon da Indonésia","Job_Evaluation2_Home":"Proprietário de loja na Amazon e no Mercado Libre","Name_Evaluation12_Home":"Arif","Desc_Evaluation11_Home":"As imagens de estilo de vida são bem naturais, parecendo até fotos tiradas por um profissional. Meus clientes também parecem adorá-las, e notei um aumento real nas vendas.","Name_Evaluation11_Home":"Siti","Job_Evaluation10_Home":"Proprietário de loja internacional na Lazada e na Shopee (Indonésia)","Name_Evaluation10_Home":"Nina","Job_Evaluation3_Home":"Designer de e-commerce DTC","Job_Evaluation8_Home":"Proprietário de loja de produtos para áreas externas do Walmart na América","Name_Evaluation8_Home":"Jason","Job_Evaluation9_Home":"Vendedor do Mercado Livre da Argentina","Desc_Evaluation7_Home":"As cenas de produtos para pets geradas por IA são muito fofas! Cães e gatos parecem perfeitamente proporcionais e naturais. Além disso, o tamanho e a escala das imagens se adaptam aos requisitos de cada plataforma, facilitando o uso imediato.","Job_Evaluation7_Home":"Proprietário de loja no Mercado Livre do Brasil","Desc_Evaluation8_Home":"As cenas de acampamento com as minhas barracas ficaram muito realistas. A iluminação e os ângulos parecem naturais, e as proporções estão perfeitas. Eu economizo tanto tempo por não precisar tirar as fotos!","Name_Evaluation7_Home":"Thiago","Desc_Evaluation9_Home":"A ferramenta é bem rápida, e as imagens que ela gera são enviadas diretamente ao Mercado Livre e à Amazon sem nenhum outro ajuste.","Desc_Evaluation6_Home":"Minha preocupação era que a IA estragasse as texturas dos tecidos, mas é difícil perceber qualquer diferença em comparação com o original. As malhas continuam parecendo malhas, o jeans parece jeans, e tudo atende aos requisitos de imagem da Amazon. Lançar novos produtos nunca foi tão fácil.","Name_Evaluation9_Home":"Lucas","Name_Evaluation6_Home":"Emma","Desc_Evaluation5_Home":"As imagens dos produtos geradas por IA são muito precisas. O comprimento dos cabos e os formatos dos conectores são perfeitos e seguem o estilo da TEMU. Eu economizo muito tempo agora que não preciso tirar as fotos.","Desc_Evaluation12_Home":"Com apenas um prompt, consigo gerar gráficos prontos para usar imediatamente, o que é muito mais rápido do que esperar por um designer. É realmente superprático.","Name_Evaluation3_Home":"Chloe","Name_Evaluation1_Home":"Sofia","Desc_Evaluation4_Home":"As texturas metálicas e os detalhes estruturais são muito nítidos e deixam as imagens ainda mais profissionais. Posso usar tudo imediatamente, sem fazer nenhuma edição.","Name_Evaluation4_Home":"Leon","Desc_Evaluation10_Home":"A geração em lote é muito útil. Posso processar dezenas de SKUs de uma vez; é muito mais rápido do que fazer tudo manualmente como fazia antes.","Name_Evaluation2_Home":"Mariana","Desc_Evaluation3_Home":"Eu vendo roupas e tinha medo que a IA estragasse as cores ou as texturas dos tecidos, mas tudo ficou ótimo! As poses das modelos são naturais e as imagens vêm basicamente prontas para uso imediato.","Job_Evaluation1_Home":"Especialista em operações de loja da SHEIN","Name_Evaluation5_Home":"Diego","Job_Evaluation11_Home":"Especialista em operações da Amazon","Desc_Evaluation2_Home":"A ferramenta é super-rápida, e as imagens já vêm praticamente prontas para serem enviadas ao Mercado Livre ou à Amazon. Ela até adapta os fundos e os modelos à cultura local, e os resultados têm um aspecto totalmente profissional.","Job_Evaluation4_Home":"Vendedor do eBay na Alemanha","Title_Evaluation_Home":"Suas histórias","Title_Introduction_Home":"Design premium com IA que gera mais vendas","Desc_Qualification_Home":"Provedor de Serviços certificado pela SPN da Amazon","Title_Seo_Home":"Gerador de imagens e vídeos de produtos com IA para e-commerce","Desc_Seo_Home":"Gere instantaneamente imagens, pôsteres e vídeos de produtos para a Amazon, o TikTok e muitas outras lojas online com o Agente de IA do Designkit. Comece hoje mesmo a criar designs sem custos!<br>","Keywords_Seo_Home":"Agente de IA para e-commerce, Ferramentas de IA para e-commerce, Gerador de imagens de produtos com IA, Gerador de vídeos de produtos com IA, Editor de fotos de produtos com IA, Removedor de fundos com IA","Title_Features1_Home":"De uma única solicitação a um conjunto completo de elementos visuais","Title_Features2_Home":"Localização totalmente automatizada para vender seus produtos globalmente em várias plataformas.","Title_Features3_Home":"Gere imagens em lote automaticamente para vários SKUs e supere a concorrência!","Title_Designkit_Home":"Designkit","Tips_AboveTheFold2_Home":"Role para explorar","Tips_Material1_Home":"Conjunto de imagens para venda","Tips_Material2_Home":"Provador virtual","Tips_Material3_Home":"Conteúdo A+","Tips_Material4_Home":"Gerador de fundos","Free_Button_Home":"Experimente gratuitamente","Title_Header1_Home":"Produto","Title_Header2_Home":"solução","Title_Header3_Home":"Inspiração","Title_Header4_Home":"Aprender","Title_Header5_Home":"Preços","SecondTitle_Header1_Home":"Agente de e-commerce com IA","SecondTitle_Header2_Home":"Ferramentas de imagem com IA","SecondTitle_Header3_Home":"Ferramentas de vídeo com IA","SecondTitle_Header4_Home":"Solução de design da Amazon","SecondTitle_Header5_Home":"Soluções de e-commerce para redes sociais","SecondTitle_Header6_Home":"Gerador de imagens de produtos com IA","SecondTitle_Header7_Home":"Gerador de modelos de moda com IA","SecondTitle_Header8_Home":"Modificador de cor de roupas","SecondTitle_Header9_Home":"Gerador de vídeos de produtos","SecondTitle_Header10_Home":"Ferramentas de IA","SecondTitle_Header11_Home":"Editor de fotos com IA","SecondTitle_Header12_Home":"Editor de fotos com IA online","SecondTitle_Header13_Home":"Editor de fotos em lote","SecondTitle_Header14_Home":"Editor de fotos com IA em lote","SecondTitle_Header15_Home":"Aprimorador de imagens em lote","SecondTitle_Header16_Home":"Removedor de marcas d\'água em lote","SecondTitle_Header17_Home":"Gerador de fundos em lote","SecondTitle_Header18_Home":"Removedor de fundo em lote","Title_Footer3_Home":"Ferramentas de design","Subtitle_Footer8_Home":"Editor de fotos com IA","Subtitle_Footer7_Home":"Alterador de fundo com IA","Subtitle_Footer9_Home":"Fundo transparente","Subtitle_Footer10_Home":"Alterar a cor do fundo","Subtitle_Footer11_Home":"Removedor de marcas d\'água em imagens","Subtitle_Footer12_Home":"Remover texto da imagem","Subtitle_Footer13_Home":"Adicione adesivos às fotos","Subtitle_Footer14_Home":"Adicionar marca d\'água às fotos","Title_Footer4_Home":"Modelos de imagem","Subtitle_Footer15_Home":"Nano Banana Pro (Gemini 3.0 Pro)","Title_Footer5_Home":"Baixe gratuitamente","Subtitle_Footer16_Home":"APP iOS","Subtitle_Footer17_Home":"APP Android","Title_Footer6_Home":"Siga-nos","Subtitle_Footer18_Home":"Kling 3.0","Subtitle_Footer19_Home":"Seedance 2.0","Title_Footer7_Home":"Modelos de vídeo","Button_Export":"Baixar","Title_Layer":"Camadas","InputNumber_Opacity":"Opacidade","Buttom_Comfirm":"Confirmar","Button_Share":"Compartilhar","Button_Delete":"Excluir","Title_LoginPopup":"Faça login para iniciar o período de teste","SubTitle_LoginPopup":"Comece a criar com o Zawa hoje","Tip_ModalTitle":"Lembrete","TipContent_HistoryDelete":"Depois de excluído, esse registro não poderá ser restaurado. Confirmar a exclusão?","Title_Logo":"Logotipo","Title_BrandKit":"Modelos","Tab_BrandKit":"Kit de marca","Tab_UploadLocal":"Escolher do álbum","Button_UploadImage":"Enviar imagens","Button_UploadProductImage":"Carregar imagem de produto","Button_UploadReferImage":"Enviar referências","Tip_ClickDragParseImage":"Carregue, solte ou cole imagens aqui.","Tip_UploadMax":"Carregue arquivos JPG, JPEG ou PNG de até ${0} MB, com um máximo de N imagens.","Tooltip_SwitchBrandKit":"Trocar kit de marca","Discribe_BrandKitSelect":"Selecione um estilo de marca como referência para este design.","Title_Models":"Modelos","Switch_Auto":"Auto","Tab_Image":"Imagem","Tab_Video":"Vídeo","MenuItem_AddToBrandLogo":"Salvar logo de marca","MenuItem_AddToBrandTemplate":"Salvar modelo de marca","Button_ExportImage":"Importar imagens","Button_ExportMedia":"Importar vídeos","Button_ExportFromBrandkit":"Importar do Kit de marca","Dropdown_AddFromBrandkit":"Adicionar do Kit de marca","Placeholder_ChatInput":"Vamos começar!","MenuItem_AiChange":"Edição com IA","MenuItem_AiExpend":"Extensor com IA","MenuItem_AiHD":"Nitidez com IA","MenuItem_Eliminate":"Remoção com IA","MenuItem_SplitLayers":"Camadas divididas","MenuItem_Cutout":"Removedor de fundo","MenuItem_ChangeText":"Editar texto","MenuItem_Crop":"Tamanho da imagem","MenuItem_AddToChat":"Adicionar ao chat","MenuItem_AddToBrand":"Adicionar ao kit de marca","Tooltip_Layer":"Camadas","Tooltip_Grab":"Ferramenta mão","Tooltip_Select":"Selecionar","Tooltip_Redo":"Refazer","Tooltip_Undo":"Desfazer","Tooltip_Add":"Adicionar","Tooltip_ShowAll":"Mostrar tudo","Tip_UploadType":"Formato de arquivo não suportado","Tip_UploadSize":"Apenas arquivos com até ${0} MB são suportados","Tip_UploadWH":"Certifique-se de que cada imagem não tenha mais de ${0}×${1} pixels","Tip_UploadTypeTranslate":"Não foi possível alterar o formato do arquivo","Tip_UploadFail":"O envio falhou","Tooltip_AddText":"Adicionar texto","Text_AddDefault":"Este texto é um exemplo.","Tooltip_OverflowImageSize":"Redimensione sua imagem para menos de ${0} pixels","Placeholder_ImageFusion":"Me diga como você gostaria que as imagens fossem mescladas","Button_ImageFusion":"Mesclar","Button_Cancel":"Cancelar","Button_AiChange":"Editar","Placeholder_AiChange":"Diga o que você quer mudar","Button_Eliminate":"Borracha","Label_OriginSize":"Original","Label_CropRadio":"Proporção","Button_Free":"Grátis","Button_Origin":"Original","Button_Crop":"Cortar","Placeholder_ChangeText":"Digite o texto. Exemplo: Olá","Button_ChangeText":"Confirmar","InputNumber_PanSize":"Tamanho do pincel","Label_TargetSize":"Alvo","Tooltip_ImageFusion":"Você pode mesclar de ${0} a ${1} imagens","Title_Workspace":"Seu Agente de IA\\npara Conteúdo em Redes Sociais","Button_Pro":"Obtenha o Pro gratuitamente","Title_NanoPro":"🍌🍌Agora, o Nano Banana Pro está disponível no Zawa.","Dropdown_AdvancedFeatures_Title":"Recursos avançados","Dropdown_AdvancedFeatures_Conent":"Acesso total a todas as ferramentas com tecnologia de IA para aumentar sua eficiência.","Dropdown_MassiveContent_Title":"Conteúdo extensivo","Dropdown_MassiveContent_Content":"Acesso ilimitado a modelos premium e a uma ampla gama de recursos Plus.","Dropdown_CommercialRights_Title":"Direitos comerciais","Dropdown_CommercialRights_Content":"Use suas criações pessoais com confiança, respaldadas pela proteção garantida de copyright.","Popup_SubscribeIntl_Desc":"Aproveite ao máximo o Zawa com a versão Pro","Popup_SubscribeIntl_Desc1":"Desbloqueie mais criações com créditos","Popup_SubscribeIntl_Detail":"Ver detalhes do plano e Ajuda","Popup_StripeCheckout":"Checkout com Stripe","Popup_LiveSupport":"Suporte ao vivo","Popup_CancelAnytime":"Cancele a qualquer momento","Menu_Language":"Idioma","Menu_ManageSubscription":"Gerenciar assinaturas","Menu_TermsPolices":"Termos e Políticas","Menu_ManageSubscriptions":"Gerenciar assinaturas","Menu_ReferralLink":"Link de referência","Menu_BenefitsUpgraded":"Benefícios","Menu_TermsPolicies":"Termos e Políticas","Menu_AccountManagement":"Conta","Title_ReferralCode":"Código de referência","Title_ReferralLink":"Link de referência","Desc_NoActiveSubscription":"Nenhuma assinatura ativa","Button_ClickToSubscibe":"Clique aqui para assinar","Title_SubscriptionCancel":"Sua assinatura foi cancelada","Title_SeeYou":"Lamentamos sua partida...😭","Desc_NextBillingDate":"Renova em","Desc_EstimatedAmount":"Total estimado","Button_CancelSubscription":"Cancelar assinatura","Button_StaySubscribed":"Manter assinatura","Title_ReasonCancelling":"Selecione um motivo para cancelar:","Desc_BenefitsContinue":"Você ainda pode aproveitar os benefícios da sua assinatura até ela terminar.","Desc_GiftedCredits":"Depois que a assinatura expirar, os créditos concedidos","Desc_SeeYou":"Agradecemos por estar conosco. Lamentamos sua partida.","Desc_NoNoreCharges":"Não haverá outra cobrança, e sua assinatura permanecerá ativa até","Desc_MayBeRevoked":"pode ser revogada.","Desc_CancelingNoRefund":"O cancelamento <span>não inclui reembolso</span>. Se você tiver dúvidas sobre reembolsos, entre em contato com o suporte online.","Button_ClearSelection":"Deselecionar","Button_Confirm":"Confirmar","Message_Processing":"Processando...","Title_Opacity":"Opacidade","Button_ExpandImage":"Extensor","Button_ExpandRadio":"Proporção","Title_NoDesigns":"Ainda não há designs.","Title_NoGenerations":"Ainda não há gerações.","Desc_NoDesigns":"Seus designs aparecerão aqui.","Desc_NoGenerations":"Suas gerações aparecerão aqui.","Title_DeleteDesign":"Excluir este design","Popup_DeleteDesign":"Você tem certeza de que deseja excluir este design permanentemente? Esta ação não pode ser desfeita.","Message_SaveFail":"Falha ao salvar","Title_Pricing":"Escolha o plano ideal para você","Title_Tags1_Pricing":"Mensal","Text_Discount_Pricing":"${0} de desconto","Title_Tags2_Pricing":"Anual","Title_Plan1_Pricing":"Gratuito","Current_Plan_Pricing":"Plano atual","Title_Instruction1_Pricing":"Ganhe 20 créditos pelo primeiro login","Title_Instruction2_Pricing":"Gere até 20 imagens com o Agente de IA","Title_Instruction3_Pricing":"Gere até 10 imagens com o Gerador de fundos com IA","Title_Rights1_Pricing":"Remoção limitada de fundos ou objetos","Title_Rights3_Pricing":"Aprimoramento limitado de imagens HD","Title_Plan2_Pricing":"Plano Básico","Month_Plan_Pricing":"mês","Title_Button1_Pricing":"Assinar","Title_Instruction4_Pricing":"500 créditos/mês","Title_Instruction5_Pricing":"Gere até 500 imagens com o Agente de IA","Title_Instruction6_Pricing":"Gere até 250 imagens com o Gerador de fundos com IA","Title_Plan3_Pricing":"Plano Profissional","Desc_Plan_Pricing":"Teste gratuito por 7 dias. Depois, ${0}/ano.","Title_Button2_Pricing":"Teste grátis de 7 dias","Title_Instruction7_Pricing":"1.500 créditos/mês","Title_Instruction8_Pricing":"Gere até 1.500 imagens com o Agente de IA","Title_Instruction9_Pricing":"Gere até 750 imagens com o Gerador de fundos com IA","Title_Rights4_Pricing":"Remoção ilimitada de fundos ou objetos","Title_Rights5_Pricing":"Uso ilimitado do recurso de remoção com IA","Title_Rights6_Pricing":"Aprimoramento ilimitado de imagens UHD","Title_Rights7_Pricing":"Ferramentas de processamento em lote","Title_Best_Pricing":"Escolhido por 90% dos usuários","Title_AllFeatures_Pricing":"Compare planos gratuitos e pagos","Desc_AllFeatures_Pricing":"Desbloqueie o Premium para criar designs impressionantes e sem esforço com ferramentas avançadas de IA","Month_AllFeatures_Pricing":"mês","Title_Features1_Pricing":"Agente de IA","SubTitle_Features1_Pricing":"Edição de imagens","SubTitle_Features15_Pricing":"Gere até ${0} imagens","SubTitle_Features16_Pricing":"Gere até ${0} imagens/mês","SubTitle_Features2_Pricing":"Geração de imagens","SubTitle_Features3_Pricing":"Geração de imagens para e-commerce","SubTitle_Features4_Pricing":"Geração de cartaz","Title_Features2_Pricing":"Ferramentas de imagem com IA","SubTitle_Features5_Pricing":"Removedor de fundo com IA","SubTitle_Features17_Pricing":"Uso limitado","SubTitle_Features19_Pricing":"Uso ilimitado","SubTitle_Features6_Pricing":"Removedor de objeto com IA","SubTitle_Features7_Pricing":"Aprimorador de imagem","SubTitle_Features18_Pricing":"Uso limitado (HD)","SubTitle_Features20_Pricing":"Uso ilimitado (HD/UHD)","SubTitle_Features8_Pricing":"Upscaler de imagem com IA","SubTitle_Features9_Pricing":"Extensor de imagem com IA","SubTitle_Features10_Pricing":"Gerador de fundo com IA","Title_Features3_Pricing":"Mais recursos de design","SubTitle_Features11_Pricing":"Recursos avançados e modelos","SubTitle_Features12_Pricing":"Remover marca d\'água","SubTitle_Features13_Pricing":"Ferramentas de imagens em lote com IA","SubTitle_Features14_Pricing":"Características básicas de design","Title_Credits_Pricing":"Está ficando sem créditos? Nós ajudamos você.","Desc_Credits_Pricing":"Compra única, sem necessidade de assinatura.","TransactionPrice_Credits_Pricing":"Preço: ${0}","Credit_Credits_Pricing":"Créditos","Popular_Credits_Pricing":"Mais popular","Buy_Credits_Pricing":"Comprar agora","Title_FAQ_Pricing":"Perguntas frequentes","Title_Button4_Pricing":"Atualize agora para obter um teste gratuito de 7 dias","SubTitle_FAQ1_Pricing":"O que são os créditos?","Content_FAQ1_Pricing":"Os créditos permitem que você continue acessando as ferramentas de IA. O número de créditos necessários varia de acordo com a ferramenta específica.","Content_FAQ2_Pricing":"Os créditos comprados são válidos por um ano.","Content_FAQ3_Pricing":"Os créditos de assinatura são válidos durante o período de duração da mesma.","SubTitle_FAQ2_Pricing":"Como cancelo minha assinatura e o que acontece com meus créditos após o cancelamento?","Content_FAQ4_Pricing":"Após cancelar sua assinatura,","Content_FAQ5_Pricing":"seus créditos de membro permanecerão válidos até ao fim do seu período de assinatura. Quaisquer créditos que tenha adquirido separadamente não serão afetados.","Content_FAQ6_Pricing":"Se você precisar cancelar sua assinatura, siga as etapas abaixo pelo menos 24 horas antes do início do próximo ciclo de cobrança:","Content_FAQ7_Pricing":"1. Acesse o Designkit e faça login.","Content_FAQ8_Pricing":"2. Abra a janela pop-up de assinatura.","Content_FAQ9_Pricing":"3. Selecione “Gerenciar assinaturas”.","Content_FAQ10_Pricing":"4. Selecione seu plano atual e clique em “Cancelar assinatura”.","Content_FAQ11_Pricing":"Sua assinatura permanecerá ativa até o fim do ciclo de faturamento atual. Se não conseguir cancelar, faça uma captura de tela e entre em contato com nosso suporte online o mais rápido possível.","SubTitle_FAQ3_Pricing":"Qual é a sua política de reembolso?","Content_FAQ12_Pricing":"1. Garantia de reembolso de 7 dias:","SubTitle_FAQ4_Pricing":"Como posso mudar o plano da minha assinatura?","Content_FAQ25_Pricing":"1. Upgrade: basta assinar um plano de nível superior, e ele entrará em vigor imediatamente. Sua assinatura antiga será cancelada e qualquer saldo restante será reembolsado.","SubTitle_FAQ5_Pricing":"Posso obter uma cópia da minha fatura?","Content_FAQ27_Pricing":"Sim! Após um pagamento bem-sucedido, você receberá um e-mail do provedor de pagamentos contendo uma fatura eletrônica. Se você não receber a fatura, entre em contato com nossa equipe de suporte.","SubTitle_FAQ6_Pricing":"Quais métodos de pagamento vocês aceitam?","Content_FAQ28_Pricing":"Utilizamos o Stripe para gerenciar pagamentos e assinaturas. Aceitamos todos os principais cartões de crédito, PayPal e Google Pay.","SubTitle_FAQ7_Pricing":"Como posso entrar em contato com o suporte?","Content_FAQ29_Pricing":"E-mail: support@designkit.com. Prazo de resposta: 3 a 10 dias úteis.","Content_FAQ13_Pricing":"Se você adquiriu assinaturas e não as utilizou dentro de 7 dias, poderá ter direito a um reembolso total.","Content_FAQ14_Pricing":"Se você comprou créditos, poderá ter direito a um reembolso por quaisquer créditos não utilizados dentro de 7 dias.","Content_FAQ15_Pricing":"2. Insatisfação com o serviço","Content_FAQ16_Pricing":"Se você não estiver satisfeito(a) com os resultados, entre em contato com nossa equipe de suporte online. Podemos oferecer uma compensação ou reembolso, dependendo das circunstâncias.","Content_FAQ17_Pricing":"3. Compras através do Google Play ou da App Store","Content_FAQ18_Pricing":"Se você assinou através da Google Play Store ou da App Store, você precisa solicitar um reembolso diretamente ao Google ou à Apple.","Content_FAQ19_Pricing":"Observações importantes:","Content_FAQ20_Pricing":"Esta política de reembolso não se aplica a usuários da API. Se você utiliza nossa API, entre em contato conosco para saber se tem direito a um reembolso.","Content_FAQ21_Pricing":"Nos reservamos o direito de recusar reembolsos em casos de uso indevido, abuso ou violação dos nossos termos.","Content_FAQ22_Pricing":"Reembolsos podem levar vários dias úteis para serem processados, dependendo do seu método de pagamento.","Content_FAQ23_Pricing":"Podemos atualizar esta política de reembolso periodicamente. Por favor, verifique-a regularmente para saber se houve alguma alteração.","Content_FAQ24_Pricing":"Para obter mais assistência, entre em contato com nossa equipe de suporte.","Content_FAQ26_Pricing":"2. Downgrade: primeiro, cancele sua assinatura atual. Quando o período de cobrança atual terminar, assine um novo plano de nível inferior.","Content_Modal_Pricing":"Agradecemos seu apoio! Prepare-se para levar sua criatividade a um novo nível.","Tip_Modal_Pricing":"Dicas: Se a sua assinatura ainda não parecer ativa, atualize a página.","Title_Modal_Pricing":"Compra realizada com sucesso","Title_Rights2_Pricing":"Uso limitado do recurso de remoção por IA","Title_Button3_Pricing":"Benefícios disponíveis","Title_Button5_Pricing":"Upgrade","Tool_ImageBgRemover":"Removedor de fundo","Tool_AiBgGenerator":"Gerador de fundo com IA","Tool_AiLogoGenerator":"Gerador de Logo","Tool_FootwearModel":"Modelo de calçado","Tool_ImageTranslation":"Tradução de imagem","Tool_BatchImageBgRemover":"Removedor de fundo em lote","Tool_BatchImageEnhancer":"Aprimorador de imagens em lote","Tool_BatchAiObjectsRemover":"Removedor de objetos em lote","Tool_VideoEnhancer":"Aprimorador de vídeo","Tool_VideoBgRemover":"Removedor de fundo de vídeo","Tool_VideoWatermarkRemover":"Removedor de marca d\'água de vídeo","Title_Models_Dropdown":"Modelos","Tips_Uninitialized_Chat":"Falha ao enviar mensagens","Dropdown_AddImage":"Adicionar imagem","Action_SeeAll":"Ver tudo","Desc_Seedream":"Geração de imagens realistas e detalhadas.","Dropdown_AddVideo":"Adicionar vídeo","Tips_NotFound_Chat":"O chat não existe","Desc_Seedance":"Criação de vídeos realistas e expressivos.","Dropdown_SupportedFormatFile":"Suporta arquivos do Word, Excel, PDF e de texto.","Dropdown_Example_Option":"Exemplo","Dropdown_NoReference_Option":"Sem referências disponíveis","Menu_AgentCredits":"Créditos de Agente","Desc_SeedEdit":"Edição precisa e natural de imagens.","Dropdown_BrandKit_Title":"Kit de marca","Desc_GeminiNanoBanana":"Geração rápida, editável e consistente de imagens.","Dropdown_Models_Title":"Modelos","Dropdown_AddDocument":"Adicionar documento","Dropdown_BrandKit_Desc":"Selecione um estilo de marca como referência para este design.","Desc_MidjourneyVideo":"Geração de vídeos artísticos e criativos.","Desc_MidjourneyImage":"Geração de imagens artísticas e criativas.","Dropdown_SaveAsBrandTemplate":"Salvar como modelo de marca","Dropdown_SaveAsBrandLogo":"Salvar como logotipo de marca","BatchProcessTable_ImageType":"Tipo de imagem","BatchProcessTable_PictureRequirement":"Detalhes do design","BatchProcessTable_CopywritingRequirements":"Descrição do produto","BatchProcessTable_Proportion":"Proporção","BatchProcessTable_Actions":"Ação","BatchProcessTable_AddOneRow":"Adicionar","BatchProcessList_DeleteError":"Falha ao excluir","BatchProcessList_SurePrompt":"Excluir esta diretriz?","BatchProcessList_SurePrompt_SureText":"Confirmar","BatchProcessList_SurePrompt_CancelText":"Cancelar","BatchProcessList_EmptyText":"Vazio","EditBatchProcess_NameLimitTip":"Insira um nome (até 10 caracteres)","EditBatchProcess_Tip":"As alterações feitas nas diretrizes afetarão os resultados gerados.","EditBatchProcess_Start":"Comece com uma diretriz","EditBatchProcess_GenerateTip":"Envie as imagens do seu produto, e os designs serão gerados com base nas diretrizes.","Text_AdvanceSetting":"Especialista","Text_MainImage":"Imagem principal","Text_ProductAgentUploadGuide1":"1. Carregue várias imagens do mesmo produto de diferentes ângulos para ajudar a IA a capturar melhor os detalhes do produto.","Text_ProductAgentUploadGuide2":"2. Até 10 imagens. A primeira imagem será usada como referência primária, portanto, escolha o melhor ângulo.","Text_Optional":"(Opcional)","Tip_ClickDragImageWithSize":"Carregue ou solte imagens JPEG, JPG ou PNG de até ${0} MB.","Button_AddReferenceImage":"Enviar referências","Title_ReferenceImage":"Referência","Input_Placeholder":"Selecione","Radio_ReferenceColor":"Cor de referência","Radio_ReferenceLayout":"Layout de referência","Tag_FirstImage":"Primeira imagem","Tag_FirstImageNoPartial":"Primeira imagem parcial","Tag_Blur":"Desfoque","Tag_Jigsaw":"Colagem","Button_Understood":"Entendi","Text_ReferenceImageIndex":"A imagem ${0} deve ser usada como referência","Text_ReferenceDimensions":"Usar ${0} da referência","Tag_Cropped":"Cortada","Tag_Underexposed":"Subexposta","Tag_Blurry":"Desfoque","SelectOption_ColorPalette":"Paleta de cores","SelectOption_Layout":"Layout","SelectOption_Fonts":"Fontes","SelectOption_Style":"Estilo","SelectOption_ShapeElements":"Elementos de forma","Text_SocialMediaAgentUploadGuide":"Carregue o produto em destaque primeiro. Verifique se a imagem está nítida e completa.","Video_SR_Success":"Nitidez de vídeo aprimorada","Video_Desubtitle_Success":"Legenda removida","Video_Dewatermark_Success":"Marca d\'água removida","Video_Process_Failed":"Falha no processamento. Os créditos serão reembolsados na sua conta.","Video_SR":"Nitidez com IA","Video_Dewatermark":"Remover a marca d\'água","Video_Desubtitle":"Remover legenda","Video_Task_Price_Estimate":"${0} créditos necessários","Video_SR_Start":"Aprimorando a nitidez... Serão usados ${0} créditos.","Video_Dewatermark_Start":"Removendo marcas d\'água... Serão usados ${0} créditos.","Video_Desubtitle_Start":"Removendo legendas... Serão usados ${0} créditos.","Video_Desubtitle_Start_VIP":"Removendo legendas...","Video_Dewatermark_Start_VIP":"Removendo marcas d\'água...","Video_SR_Start_VIP":"Aprimorando a nitidez...","Text_Help_Center":"Centro de ajuda","Title_Request":"Chat","Button_Continue":"Continuar","Button_EditContent":"Editar mensagem","Title_ChooseImageType":"Selecionar o tipo de imagem gerada (várias opções)","Button_BatchGenerate":"Confirmado. Execute o modelo agora.","Text_ChatCancelStatus":"Tarefa concluída","Text_ChatRespondedStatus":"Processamento de tarefas","BatchProcess_SaveSuccessTip":"Seus kits de fluxo de trabalho são salvos aqui.","Button_GotIt":"Entendi","Title_Congrats":"Parabéns","SubTitle_BrandCreate":"Você criou seu primeiro kit de marca. Chegou a hora de explorar seu potencial!","Button_CheckUse":"Confira agora mesmo","Chat_Prompt_Brand":"Crie um cartaz promocional","Tooltip_UseBrand":"Você pode trocar ou adicionar seu kit de marca aqui!","Tooltip_PosterBrand":"Toque para criar seu primeiro cartaz com base no kit da sua marca","Popup_CreateBrand":"Crie uma marca do zero","Desc_CreateBrand":"Crie logos originais incríveis com o nosso Agente de IA.","Popup_UploadBrand":"Carregue as informações da sua marca","Desc_UploadBrand":"Faça o upload, e o Zawa manterá todos os designs alinhados.","Title_BrandEntry":"Obtenha agora um projeto de identidade visual personalizado","Desc_BrandEntry":"Deixe que a nossa IA seja a sua especialista. Responda a algumas perguntas e receba um projeto de marca completo, personalizado de acordo com a sua visão.","Tooltip_UseBrand_Agent":"Uma vez aplicado o kit de marca, o design fará referência automática ao logo, à paleta de cores e ao estilo geral.","Tooltip_PosterBrand_Agent":"Você já pode começar a criar com seu kit de marca","BatchProcess_createText":"Kit de fluxo de trabalho","Label_NormalMode":"Básico:","Label_AdvancedMode":"Avançado:","Text_NormalMode":"Básico","Text_AdvancedMode":"Avançado","BatchProcess_DefaultPrompt":"Gerar imagens","Title_CreateBrand":"Não tem uma marca?","Title_UploadBrand":"Já tem um logotipo?","Button_CreateBrand":"Criar uma marca","BatchProcess_EditContent":"Editar conteúdo","BatchProcess_PleaseSelect":"Selecione um kit de fluxo de trabalho","BatchProcess_SelectTip":"Todas as imagens carregadas serão geradas em lote usando o kit de fluxo de trabalho selecionado.","BatchProcess_ListEmptyTip":"Salve o kit de fluxo de trabalho após a geração para criar instantaneamente conjuntos similares em lote.","BatchProcess_Tip":"Kit de fluxo de trabalho","BatchProcess_Generate":"Use agora","BatchProcess_Save":"Salvar","BatchProcess_GeneratingFormula":"Gerando kit de fluxo de trabalho...","BatchProcess_GenerateCancel":"Cancelar","BatchProcess_WorkFlowCreateError":"Falha na criação","ProductInfo_PleaseUploadImage":"Carregar imagens de produto","BatchProcess_IntelligenceGenerate":"Criar kit de fluxo de trabalho","BatchProcess_CreateWorkflow":"Criar","BatchProcess_Formula":"Kit de fluxo de trabalho","BatchProcess_WorkFlowSaveSuccess":"Kit de fluxo de trabalho salvo","ProductInfo_ImageSizeLimit":"Imagens com tamanho inferior a ${0} MB são suportadas","ProductInfo_ImageUpload":"Adicionar imagem do produto","ProductInfo_UploadDemo":"Fotos de exemplo","ProductInfo_ECPlatform":"Plataforma","ProductInfo_PleaseSelect":"Por favor, selecione","ProductInfo_InputCustomize":"Personalizado","ProductInfo_CountryAndLanguage":"Região/idioma-alvo","ProductInfo_Name":"Nome do produto","ProductInfo_Desc":"Detalhes do produto (características/tamanho/cenários de uso)","ProductInfo_DescPlaceholder":"Insira informações sobre o produto, incluindo características, tamanho, cenários de uso, público-alvo, etc.","ProductInfo_NamePrompt":"O nome do produto é ${0};","ProductInfo_ECPlatformPrompt":"A plataforma de destino é ${0};","ProductInfo_CountryAndLanguagePrompt":"O idioma é ${0};","ProductInfo_DescPrompt":"Os detalhes do produto são ${0}.","ProductInfo_PleaseInput":"Insira, por favor","Button_UnlockPro":"Desbloquear Pro","Button_UpgradeToPro":"Atualizar para Pro","Button_RenewNow":"Renovar agora","AgentEmpty_CaseUseBtn":"Usar","AgentEmpty_CaseRefreshBtn":"Atualizar","MenuItem_Effect":"Efeitos","MenuItem_Shadow":"Sombras","MenuItem_Stroke":"Contorno","Title_ChangeText":"Substituir texto","Button_Logout":"Sair","Message_ExtractText":"Extraindo texto","Message_ExtractTextError":"Falha ao extrair o texto. Tente novamente.","Tip_CreditConsume":"Essa geração usa ${0} créditos","Tip_EstimatedTime":"Pronto em cerca de ${0} minutos","BatchProcess_SaveSuccessTip_GotIt":"Entendi","BatchProcess_SaveSuccessTip_Title":"Usando kits de fluxo de trabalho","BatchProcess_SaveSuccessTip_Desc":"Seus kits de fluxo de trabalho são salvos aqui. Escolha uma opção para gerar imagens rapidamente utilizando os modelos salvos.","BatchProcess_tutorial":"Tutorial","Text_HandTool":"Ferramenta mão","Text_Function":"Função","Text_WindowsSystem":"Sistema Windows","Text_MacSystem":"Sistema Mac","Menu_KeyboardShortcuts":"Atalhos","Title_KeyboardShortcuts":"Atalhos","Text_Undo":"Desfazer","Text_MouseLeft":"Botão esquerdo do mouse","Text_Redo":"Refazer","Text_Delete":"Excluir","Text_Cut":"Cortar","Text_Copy":"Copiar","Text_Paste":"Colar","Text_PasteFixed":"Colar no lugar","Text_CreateCopy":"Criar uma cópia","Text_SelectAll":"Selecionar tudo","Text_SelectMultiple":"Multisseleção","Text_Group":"Grupo","Text_Ungroup":"Desagrupar","Text_LockLayer":"Travar","Text_Save":"Salvar","Text_Move":"Mover","Text_MoveWithCombinedKeys":"Movimento rápido","Text_TouchEditFastMode":"Edição rápida","Text_Pan":"Texto panorâmico","Title_Canvas":"Tela","Title_Edit":"Editar","Title_Elements":"Elementos","Title_Tools":"Ferramentas","Title_Blogs":"Blog","Text_NewText":"Novo texto","Text_NewLine":"Nova linha","Text_NewRectangle":"Novo retângulo","Text_NewCircle":"Novo círculo","Text_ExitFullScreen":"Sair da tela inteira","Text_MoveUpOneLayer":"Trazer para a frente","Text_MoveDownOneLayer":"Enviar para trás","Text_Top":"Trazer para frente","Text_Bottom":"Enviar para trás","Text_CanvasZoom":"Aumentar/Diminuir","Text_ToggleReferenceLine":"Mostrar/ocultar guias","Text_ToggleRulerBar":"Mostrar/ocultar réguas","Text_ArrowKey":"Teclas de seta","Text_CanvasShowAll":"Mostrar todas as telas","Title_Unsupported_Multilayer":"Esse recurso funciona com uma única camada apenas.","Btn_CreateBatchProcessFormula":"Criar","Button_Hide_Otherlayers":"Manter a primeira camada e continuar","Button_Merge_Alllayers":"Mesclar todas as camadas e continuar","Checkbox_Disable_Remind":"Não mostrar novamente","Button_Tool":"Ferramentas","Button_Custom_Ratio":"Personalizado","Label_Spacing":"Espaçamento","Button_Download_Whole":"Exportar como imagem","Button_Download_Layer":"Exportar por camada","Button_Origin_Ratio":"Original","Text_TouchEdit_Title":"Apontar para editar","Text_TouchEdit_Description":"Aponte para um objeto e descreva suas alterações. A imagem será editada exatamente como você especificar.","Tooltip_TouchEdit_Max_Count":"Você pode apontar para até ${0} áreas","Tooltip_TouchEdit_Usage":"Aponte para o atalho Editar: ${0} + clique","Text_TouchEdit_Recognition_Custom":"Personalizado","Text_TouchEdit_Recognition_Title1":"Detectar e reconhecer","Text_TouchEdit_Recognition_Title2":"Nenhum destino encontrado. Insira o nome do objeto.","Text_TouchEdit_Name":"Apontar para editar","Btn_LoginToViewBatchProcess":"Entre para visualizar o kit de fluxo de trabalho","Btn_Login":"Entrar","Menu_Main_Beautify":"Refinar","Text_Model_Pricing":"Preços de modelos","Text_Pro_discount":"Plano Pro: geração de vídeos pela metade do preço","Text_TemplatePrompt":"Vamos começar com inspirações","Text_Hi":"Olá, ${0}!","Text_Account_Popup_Left":"Conheça seu assistente de design dedicado com IA para e-commerce. Desenvolvido para profissionais que buscam lançamentos mais rápidos, apresentações mais sólidas e lucratividade mais alta.","Text_PleaseWaitImageUploaded":"Continue após a conclusão do carregamento","Menu_Redeem_Rights":"Resgatar","Text_Redeem_Now":"Resgatar agora","Text_Redeem_Placeholder":"Insira o código de resgate, diferenciando maiúsculas e minúsculas","Text_Redeem_Success":"Resgate bem-sucedido.","Text_Redeem_Use":"Resgatar seu código","Tooltip_BrandAutoUse":"Seu novo kit de marca foi aplicado.","Redeem_Redeem_Note":"Nota: \\nFaça login e digite o código de resgate.\\nApós a realização do resgate, você poderá aproveitar os benefícios e serviços correspondentes.\\nUse o código de resgate no período de validade. Códigos expirados serão invalidados e não são reembolsáveis.\\nProteja seu código. Não somos responsáveis por códigos perdidos, vazados ou usados incorretamente. \\nEsse código não poderá ser revendido ou transferido, nem trocado por dinheiro, e não é elegível para faturamento.","Tooltip_Color_Fill":"Cor","Tootip_StartPoint":"Iniciar","Tootip_ChangePoint":"Mudar","Tootip_EndPoint":"Fim","Sidebar_NewDesign":"Novo chat","Retouch_Filter_Clear":"Limpar","Retouch_Filter_Enhance":"Vívido","Retouch_Filter_Dehaze":"Desembaçar","Retouch_Filter_Texture":"Textura","Retouch_Filter_Nature":"Natural","Retouch_Filter_Fade":"Desvanecer","Modal_Button_Known":"OK","Modal_Button_GotIt":"Aceitar","Modal_Button_Later":"Mais tarde","Text_Appeal_Confirm":"Sim","Text_Vip_Open":"Assinar","Text_Appeal_ReGenerate":"Resultados editados não estão qualificados para revisão.","Text_Appeal_Left":"Tentativas restantes esse mês\\n<i>${0}</i>/${1}","Text_Appeal_Refunded":"Os créditos foram reembolsados na sua conta.","MenuItem_Appeal":"Revisão de resultado","Tooltip_Downloading":"Baixando...","Tooltip_Download_Video":"Baixe os vídeos separadamente, um de cada vez.","Tooltip_Download_NoneSelected":"Por favor, selecione o conteúdo que deseja baixar","Text_AI_Thinking":"A IA está trabalhando nisso.","Text_Server_Busy":"O servidor está ocupado. Por favor, tente novamente mais tarde.","Text_Prompt_Help_Placeholder":"Digite suas palavras-chave e eu as transformarei em um prompt pronto para uso.","Text_Prompt_Helping":"Processando... Por favor, aguarde.","Button_Retry":"Tentar de novo","Button_Rewrite":"Tente novamente","Button_Start_Prompt_Help":"Comece a escrever","Title_Prompt_Helper":"Redação com IA","Menu_Text_Subscriptions":"Assinaturas","Menu_View_Subscriptions":"Ver assinaturas","Text_Download_XdesignApp":"Baixe o aplicativo <span>Zawa</span> para usar os recursos","Text_Free_Trial":"Faça o download para um teste gratuito de 7 dias","Text_Install_App":"Instalar app","Text_Scan_Download":"Escaneie para baixar","Text_Download_the":"Baixar na","Text_Available_On":"Disponível em","Desc_ExpireDate":"Expira em:","DownloadApp_Title_Widgets":"Para usar os recursos, baixe o aplicativo ${0}","DownloadApp_SubTitle_Widgets":"Baixe para uma avaliação gratuita de ${0} dias","InstallApp_Title_Widgets":"Instalar app","InstallApp_Desc_Widgets":"Escaneie para baixar","AppStore_Desc_Widgets":"Baixe na App Store","GooglePlay_Desc_Widgets":"Baixe no Google Play","Text_Tips_GetFree":"Você ganhou um uso gratuito","Text_AgentLib":"Recursos","Tip_ModelSetSaveSuccess":"Sua imagem modelo foi salva! Toque para usá-la.","Text_BatchProcess":"Kit de fluxo de trabalho","Button_Add":"Adicionar","Tab_Recent":"Salvo recentemente","Tab_Models":"Meus modelos","Prompt_Model":"Imagem ${0} é o meu modelo","Tip_SaveSuccess":"Salvo","Text_ModelsLogin":"Faça login para visualizar seus modelos","Loading_CheckFace":"Detectando rosto...","Name_InitialModelName":"Sem nome","EmptyTip_ModelList":"Ainda não há nenhum modelo. Vamos criar um!","Text_UploadModel":"Carregar modelo","Text_Model":"Modelo","Tips_UnsupportedFormat":"Formato de arquivo não suportado","Tips_InputModelName":"Insira um nome","Tips_UploadModelImage":"Carregar imagens do modelo","Title_CreateModel":"Crie seu modelo","Text_ModelName":"Nome","Placeholder_Input":"Insira, por favor","Text_UploadModelHint":"Toque para fazer upload ou arraste imagens para aqui <br>JPEG/JPG/PNG/HEIC/SVG","Button_SubmitUpload":"Enviar","Tips_NameLengthLimit":"Insira um nome (até ${0} caracteres)","Tips_DeleteFailed":"Falha ao excluir","Title_ConfirmDeleteModel":"Excluir este modelo?","Tips_CreateSuccess":"Modelo criado","Tab_BatchTemplate":"Kit de fluxo de trabalho","Tab_MyModel":"Meus modelos","Placeholder_InputContent":"Inserir conteúdo","Title_ChooseSceneType_VideoGenerateCard":"Selecione um tipo de conteúdo e uma estrutura de storyboard:","Button_ConfirmGenerate_VideoGenerateCard":"Iniciar geração de vídeo","Title_ShotType_VideoGenerateModal":"Tipo de storyboard","Title_ShotRequirement_VideoGenerateModal":"Descrição de storyboard","Title_Duration_VideoGenerateModal":"Duração","Btn_AddOneTableRow":"Adicionar","Label_Gender_ModelModal":"Sexo","Label_Appearance_ModelModal":"Aparência","Label_AgeGroup_ModelModal":"Faixa etária","Label_Persona_ModelModal":"Função","Label_BodyType_ModelModal":"Tipo de corpo","Tips_GenerateModelFailed_ModelModal":"Falha na geração. Tente novamente mais tarde.","Tips_NetworkError_ModelModal":"Erro de rede. Tente novamente mais tarde.","Tab_CustomModel_ModelModal":"Personalizado","Tab_OfficialModel_ModelModal":"Oficial","Tab_UploadModel_ModelModal":"Carregar","Text_ModelPreview_ModelModal":"Prévia","Button_Generating_ModelModal":"Gerando...","Button_Regenerate_ModelModal":"Tente novamente","Button_Generate_ModelModal":"Gerar","Button_Saving_ModelModal":"Salvando...","Button_SaveAndUse_ModelModal":"Salvar e usar","Button_CreateNewModel_AgentLibList":"Novo modelo","Message_NotFilled_RequiredField":"${0} informações necessárias","Title_ChooseSceneType2_VideoGenerateCard":"Selecione a estrutura de storyboard","Title_ContentType_VideoGenerateCard":"Tipo de conteúdo","Title_StoryboardStructure_VideoGenerateCard":"Estrutura de storyboard","Text_Offical":"Oficial","Title_AboveTheFold_Main_HomeV2":"Crie <br />imagens perfeitas <span>para que seus produtos sejam vendidos!</span>","Title_Designkit_Slogan":"Crie imagens perfeitas para que seus produtos sejam vendidos!","Button_StartFree_HomeV2":"Comece grátis","Title_AboveTheFoldMobile_Main_HomeV2":"Deixe todos os seus produtos <br /><span>prontos para venda</span>","SubTitle_AboveTheFoldMobile_HomeV2":"Da edição profissional de fotos à geração automatizada de listas, tudo de que você precisa em um só lugar.","Text_TopBanner_HomeV2":"Seedance 2.0 estará disponível em breve com acesso ilimitado","Title_ModuleCard_HomeV2":"Primeiro, gere ativos vencedores","SubTitle_ModuleCard_HomeV2":"Chega de telas em branco. Use nossa Suíte Criativa Inteligente de Agentes de IA para gerar <br /> pilhas de listagens completas, vídeos dinâmicos, provadores virtuais e adaptações globais em segundos.","Title_Faq_Q1_HomeV2":"Vocês oferecem um período de teste gratuito?","Text_Faq_A1_HomeV2":"Sim! Novos usuários recebem 20 créditos gratuitos instantaneamente após o cadastro. Além disso, você pode resgatar 10 créditos gratuitos todos os dias ao fazer login. Isso permite que você teste continuamente todos os recursos principais, incluindo geração de imagens e vídeos, antes de atualizar para um plano pago.","Title_Faq_Q2_HomeV2":"As imagens estão em conformidade com as diretrizes da Amazon/Shopify?","Text_Faq_A2_HOMEV2":"Com certeza. Para fotos de produtos principais, nossa IA produz estritamente os fundos brancos puros (RGB 255,255,255) exigidos pela Amazon e pela Shopify. Para imagens de estilo de vida e mídias sociais, ela garante dimensões perfeitas e qualidade de alta resolução para manter suas listagens totalmente compatíveis e profissionais.","Title_Faq_Q3_HomeV2":"Posso usar os recursos gerados para fins comerciais?","Text_Faq_A3_HomeV2":"Sim. Todas as imagens e vídeos gerados em nossos planos pagos são 100% livres de royalties e totalmente liberados para uso comercial. Você detém os direitos de uso desses recursos em sua loja Shopify, listagens da Amazon, anúncios em mídias sociais e quaisquer outros canais de marketing sem restrições.","Title_Faq_Q4_HomeV2":"Como funciona a geração e edição em lote?","Text_Faq_A4_HomeV2":"O processamento em lote está integrado por padrão em todos os recursos do Designkit. Basta enviar várias imagens diretamente para a área de trabalho. Seja para criar novos planos de fundo de estilo de vida, remover planos de fundo originais, apagar objetos indesejados ou aumentar a resolução, você pode aplicar a ação escolhida a todo o lote com um único clique. Isso garante recursos perfeitamente consistentes para sua loja, além de economizar horas de trabalho manual.","Title_Faq_Q5_HomeV2":"Quais formatos de arquivo são compatíveis?","Text_Faq_A5_HomeV2":"As saídas de vídeo estão disponíveis no formato MP4, otimizadas para redes sociais e sites de e-commerce.","Title_Questions_Main_HomeV2":"Perguntas Frequentes","Title_Scale_Main_HomeV2":"Pronto para aumentar?","SubTitle_Scale_HomeV2":"Junte-se a mais de 10.000 vendedores que automatizam seu fluxo de trabalho de design com o Designkit.","Title_Evaluation_HomeV2":"Por fim, lance mais rápido e venda mais","SubTitle_Evaluation_HomeV2":"Reduza o tempo de produção em 90%. Obtenha listagens verificadas na Amazon e no Shopify antes dos seus concorrentes.","Tab_Module_ProductImage_HomeV2":"Imagem do produto com IA","Desc_Module_ProductImage_HomeV2":"Converta uma foto de um fornecedor em uma lista completa na hora. Gere imagens destacadas com fundo branco, cenas de estilo de vida e infográficos, ao mesmo tempo que processa em lote e sem esforço, centenas de SKUs e traduz automaticamente o texto para os mercados globais.","Tip_Module_ProductImage_HomeV2":"Crie um conjunto de listagens da Amazon para os fones de ouvido cor-de-rosa.","Tab_Module_ModelImage_HomeV2":"Modelo de moda com IA","Desc_Module_ModelImage_HomeV2":"Não tem modelos? Não há problema. Visualize roupas em diversos modelos de IA para aumentar as taxas de cliques sem precisar contratar sessões fotográficas caras.","Tip_Module_ModelImage_HomeV2":"Exiba este conjunto verde e amarelo em uma modelo de 25 anos.","Tab_Module_Video_HomeV2":"Vídeo de produto com IA","Desc_Module_Video_HomeV2":"Dê vida aos seus produtos. Crie apresentações dinâmicas, vídeos envolventes com narração de IA e anúncios de alta conversão a partir de um simples texto ou imagem. Chame a atenção e impulsione as vendas em plataformas de e-commerce e nas suas redes sociais.","Tip_Module_Video_HomeV2":"Crie um vídeo de produto para este vaso azul.","Tab_Module_DetailPage_HomeV2":"Página de detalhes do produto com IA","Desc_Module_DetailPage_HomeV2":"Crie conteúdo premium A+ e banners promocionais perfeitos para sua loja online em apenas alguns minutos e sem precisar de habilidades de design. Transforme fotos básicas de produtos em layouts altamente envolventes e diferencie suas listagens das dos concorrentes facilmente.","Tip_Module_DetailPage_HomeV2":"Gerar uma página de detalhes do produto para o sofá laranja.","Tab_Module_Photography_HomeV2":"Fotografias de produto com IA","Desc_Module_Photography_HomeV2":"Diga adeus às fotos genéricas dos bancos de imagens. Coloque seus produtos em ambientes únicos e alinhados com sua marca, que tenham impacto nos mercados dos EUA e da UE.","Tip_Module_Photography_HomeV2":"Crie um fundo fotográfico para este perfume.","Title_Module_SecondTitle_HomeV2":"Depois, detalhes perfeitos com a precisão da IA","SubTitle_Module_SecondSubTitle_HomeV2":"Recursos gerados? Agora aperfeiçoe-os. Use nosso Editor de fotos com IA para remover fundos, corrigir defeitos e melhorar imagens de baixa resolução em lote.","Text_Upload_HomeV2":"Carregar","Text_TopBannerMobile_HomeV2":"Seedance 2.0 estará disponível em breve","Text_Prompt1_HomeV2":"Gere um conjunto completo de imagens para listas da Amazon.","Text_Prompt2_HomeV2":"Gere um modelo usando essa roupa.","Text_Prompt3_HomeV2":"Gere um vídeo de marketing de produto.","Text_Prompt4_HomeV2":"Gere uma página de detalhes de produto de Conteúdo A+.","Text_Prompt5_HomeV2":"Gere fundos apropriados para imagens de produtos.","Desc_Evaluation1_HomeV2":"É superrápido! As imagens ficam prontas instantaneamente para o Mercado Livre e a Amazon. Os fundos e os modelos são adaptados às preferências locais com perfeição. Os resultados são 100% profissionais.","Desc_Evaluation2_HomeV2":"Adoro o Designkit! As imagens de IA para estilo de vida são naturais,agradáveis e nórdicas: perfeitas para minha loja de velas. Minhas listas ficam incríveis e as vendas aumentaram. Vale a pena.","Desc_Evaluation3_HomeV2":"Eu vendo roupas e achei que a IA estragaria as texturas. Mas o Designkit acertou muito! As cores estão perfeitas, as poses dos modelos estão naturais e as imagens ficam prontas bem rápido.","Header_products_socialMediaPostGenerator":"Gerador de publicações em redes sociais","Pricing_Seedance_UnlockLimited":"Desbloqueie acesso ilimitado","Pricing_Seedance_SeedanceV1":"<span>Seedance 2.0</span> Acesso antecipado","Pricing_Seedance_SeedanceDesc":"Seja o primeiro a experimentar o poder do Seedance 2.0. Assine agora qualquer plano Pro e receba acesso ilimitado e exclusivo ao nosso modelo de IA de última geração.","Pricing_Seedance_Monthly":"Bônus do Plano Mensal","Pricing_Seedance_DaysUnLimit":"7 dias <span>ilimitados</span>","Pricing_Seedance_SeedanceV2":"Acesso ao Seedance 2.0","Pricing_Seedance_BestValue":"MELHOR CUSTO-BENEFÍCIO","Pricing_Seedance_Yearly":"Bônus do Plano Anual","Pricing_Seedance_MonthUnLimit":"1 mês <span>Ilimitado</span>","Title_AIBrand_Tools":"Ferramentas de branding com IA","Title_AISocialMediaPosts":"Posts para redes sociais","Title_AILogoMaker":"Gerador de logo","Option_Child_Age":"Criança","Option_Infant_Age":"Bebê","Option_MiddleAged_Age":"Adulto","Option_Senior_Age":"Idoso","Option_Teen_Age":"Adolescente","Option_YoungAdult_Age":"Jovem adulto","Button_GenerateImages_DetailPageAction":"Gerar","Text_GenerateImagesCount_DetailPageAction":"(${0} imagens)","Text_GenerateImagesCount_DetailPageAction1":"(${0} imagem)","Option_MercadoLivre_Platform":"Mercado Livre","Option_Etsy_Platform":"Etsy","Option_Walmart_Platform":"Walmart","Option_eBay_Platform":"eBay","Option_Poshmark_Platform":"Poshmark","Button_GeneratePlan_DetailPageAction":"Criar design de página de produto","Option_AdvancedMobile_DetailPageMode":"Premium A+ (celular)","Option_AdvancedWeb_DetailPageMode":"Premium A+ (web)","Option_Standard_DetailPageMode":"Standard A+","Option_Accessories_DetailSection":"Acessórios/Presentes","Option_ServiceSupport_DetailSection":"Garantia","Option_BeforeAfter_DetailSection":"Antes e depois","Option_BrandStory_DetailSection":"História da marca","Option_KeyHighlights_DetailSection":"Destaques do produto","Option_CraftProcess_DetailSection":"Vista explodida","Option_HeroVisual_DetailSection":"Arte principal","Option_Composition_DetailSection":"Componentes","Option_MultiAngle_DetailSection":"Multiângulo","Option_DetailCloseups_DetailSection":"Detalhes do produto","Option_SceneMood_DetailSection":"Estilo de vida/vibe","Option_SeriesShowcase_DetailSection":"Série de produtos","Option_SizeCapacity_DetailSection":"Dimensões","Option_Specifications_DetailSection":"Ficha técnica","Option_UsageScenario_DetailSection":"Casos de uso","Option_UsageTips_DetailSection":"Diretrizes de uso","Paragraph_ServicePolicy_DetailSection":"Garantia, devoluções e política de troca","Paragraph_BeforeAfter_DetailSection":"Resultados antes e depois do uso","Paragraph_BrandConcept_DetailSection":"Conceitos e valores de marca","Paragraph_CoreValue_DetailSection":"Demonstração de valor principal","Paragraph_CraftProcess_DetailSection":"Do desenho à realidade","Paragraph_Differentiators_DetailSection":"Destaques de vantagens principais","Paragraph_Composition_DetailSection":"Materiais e componentes do produto","Paragraph_MaterialAndCraft_DetailSection":"Destaques de material e processo","Paragraph_MultiAngleAppearance_DetailSection":"Vistas do produto de ângulos diferentes","Paragraph_MultiOptionDisplay_DetailSection":"Várias cores ou SKUs","Paragraph_IncludedItems_DetailSection":"Tudo incluído no pacote","Paragraph_DetailData_DetailSection":"Especificações detalhadas","Paragraph_RealUsageScene_DetailSection":"Referências de uso reais","Paragraph_Specifications_DetailSection":"Guia de tamanhos em destaque","Paragraph_UsageNotes_DetailSection":"Notas de uso e precauções","Paragraph_UsageScenario_DetailSection":"Produto no contexto","Title_Nav_DetailPage":"Conterúdo A+","Title_ImageSet_DetailPage":"Conjunto de imagens de detalhes de produto A+","Input_TaskName_Batch":"Inserir nome da tarefa","Paragraph_FullAssetSetDescription_Batch":"Inclui um conjunto completo de materiais de marketing, como arte principal, imagens de caso de uso e imagens de fundo branco que podem ser usadas em várias plataformas.","Paragraph_LongFormVisualDescription_Batch":"Cria storytelling visual para imagens de produtos, páginas de detalhes de produtos A+ e imagens de comparação.","Message_JsonGenerated_Batch":"Formulário verificado. JSON gerado.","Message_JsonCopied_Batch":"JSON copiado.","Message_IncompleteRequiredFields_Batch":"Campos obrigatórios ausentes. Preencha o formulário para enviar.","Message_PleaseUploadSourceImage_Batch":"Carregue imagens de produto.","Message_PleaseCompleteStrategySettings_Batch":"Conclua a configuração de estratégia","Message_TaskValidationFailed_Batch":"Revise e conclua as tarefas não verificadas.","Message_CopyJsonFailed_Batch":"Falha ao copiar. Verifique o JSON no painel.","Message_PleaseEnterTitle_Batch":"Insira o título.","Message_PleaseEnterKeyHighlights_Batch":"Inserir destaques do produto","Message_PleaseGenerateJsonFirst_Batch":"Envie para gerar o JSON.","Title_DetailPage_Batch":"Página de produto A+","Title_DetailTask_Batch":"Tarefa A+ ${0}","Title_IndependentParameters_Batch":"Configurar separadamente","Title_ImageSet_Batch":"Conjunto de imagens para e-commerce","Title_ItemTask_Batch":"Tarefa de produto","Option_Curvy_BodyType":"Curvilíneo","Option_Muscular_BodyType":"Musculoso","Option_PlusSize_BodyType":"Corpulento","Option_Slim_BodyType":"Magro","Option_Standard_BodyType":"Normal","Button_Reset_Common":"Reiniciar","Button_Back_Common":"Voltar","Button_Collapse_Common":"Recolher","Button_Expand_Common":"Expandir","Button_Generate_Common":"Gerar","Button_PreviousStep_Common":"Desfazer","Button_RemoveFavorite_Common":"Desfavoritar","Button_StartNow_Common":"Experimente agora","Paragraph_ExitWarning_Common":"Os dados serão perdidos se você sair.","Paragraph_Content1_VirtualModelDisclaimer":"2. Entenda o que esperar do conteúdo gerado com IA. Esse tipo de conteúdo é produzido com base em algoritmos e aprendizado de dados, e os resultados podem variar. A aparência facial gerada por IA pode ficar diferente dos materiais originais fornecidos, podendo gerar imperfeições e resultados insatisfatórios. Nossa plataforma não garante a precisão, a qualidade visual ou a adequação do conteúdo gerado.","Paragraph_Content2_VirtualModelDisclaimer":"3. Confirme as responsabilidades do usuário. Você é responsável pelas imagens que contêm rostos e pelo conteúdo gerado. Você deve assegurar que seu uso não viole nenhum direito legal de terceiros, incluindo, sem limitação, direitos de publicidade, privacidade e reputação, e que ele ocorra em conformidade com todas as leis e regulamentos aplicáveis. Você não deve utilizar o conteúdo gerado nenhum fim que seja ilícito, ilegal (por exemplo, difamação ou fraude), ou que viole a ordem pública e a moral ou a dignidade de outras pessoas.","Paragraph_Content3_VirtualModelDisclaimer":"Confirme que você entende e aceita os termos acima antes de carregar.","Title_Notice_VirtualModelDisclaimer":"Antes de usar o recurso de Provedor virtual  de imagem de produto com IA, leia e entenda o seguinte:","Message_FailedRetry_Download":"Falha ao baixar. Tente de novo mais tarde.","Message_Failed_Download":"Falha ao baixar.","Message_Success_Download":"Download concluído.","Message_NoImagesAvailable_Download":"Nenhuma imagem disponível.","Option_Asian_Ethnicity":"Asiático","Option_Black_Ethnicity":"Africano","Option_Chinese_Ethnicity":"Chinês","Option_Latino_Ethnicity":"Hispânico ou latino","Option_MiddleEastern_Ethnicity":"Oriente Médio","Option_SoutheastAsian_Ethnicity":"Sudeste asiático","Option_White_Ethnicity":"Branco","Option_Female_Gender":"Feminino","Option_Male_Gender":"Masculino","FormLabel_Ethnicity_Common":"Raça e etnia","FormLabel_OriginalImage_Common":"Original","FormLabel_OutputLanguage_Common":"Idioma","FormLabel_TargetMarket_Common":"Mercado","FormLabel_TargetPlatform_Common":"Plataforma","Option_German_Language":"Alemão","Option_Japanese_Language":"Japonês","Option_None_Language":"Nenhum","Option_Portuguese_Language":"Português","Option_PortugueseBr_Language":"Português (Brasil)","Option_Russian_Language":"Russo","Option_Spanish_Language":"Espanhol","Option_SpanishMX_Language":"Espanhol (México)","Option_Thai_Language":"Tailandês","Option_Brazil_Market":"Brasil","Option_China_Market":"China","Option_Europe_Market":"Europa","Option_Germany_Market":"Alemanha","Option_Japan_Market":"Japão","Option_Russia_Market":"Rússia","Option_SoutheastAsia_Market":"Sudeste Asiático","Option_Spain_Market":"Espanha","Option_UnitedStates_Market":"EUA","Message_MaxLimit_DetailSectionSelection":"Selecione até ${0} seções","Option_FollowGlobalSettings_Common":"Usar configurações globais","Text_MaxTasks_Batch":"Adicione até ${0} tarefa(s)","Text_MinTasks_Batch":"Mantenha pelo menos uma tarefa","Text_MaxImagesPerTask_Batch":"Carregar até ${0} imagens por tarefa","Text_SupportedImageFormats_Batch":"Formatos de imagem com suporte: JPG, JPEG, PNG, HEIC e WebP.","Input_AppearanceDetailsExample_TryOn":"Por exemplo: pele morena, franja reta, um sinal bonito perto do canto do olho...","Input_SourceInfoGuide_Batch":"Para obter resultados mais precisos, inclua as seguintes informações:\\n1. Nome do produto\\n2. Principais destaques\\n3. Público-alvo\\n4. Casos de uso pretendidos\\n5. Especificações detalhadas","Tooltip_OutputStyleConsistent_Clone":"Ao ativar, todas as imagens geradas mantêm cores e estilo consistentes. Ao desativar, cada imagem segue o estilo da sua própria referência.","Option_AlibabaInternational_Platform":"Alibaba","Option_AliExpress_Platform":"AliExpress","Option_Amazon_Platform":"Amazon","Option_Douyin_Platform":"TikTok","Option_DouyinEcommerce_Platform":"TikTok","Option_IndependentSite_Platform":"Shopify","Option_Indonesian_Language":"Bahasa indonésio","Option_JD_Platform":"JD.com","Option_Pinduoduo_Platform":"Pinduoduo","Option_Taobao_Platform":"Taobao","Option_TaobaoTmall1688_Platform":"Taobao, Tmall, 1688","Button_Generate_ImageSet":"Gerar conjunto de imagens","Title_Nav_ImageSet":"Listando imagens","Message_GenerateFailedRetry_ImageSet":"Falha na geração, tente novamente.","Message_PleaseSelectStyleFirst_ImageSet":"Escolha um estilo primeiro.","Message_CreateTaskFailed_ImageSet":"Falha ao criar tarefa","Title_StyleAnalysis_ImageSet":"Análise de estilo de moda","Option_TrafficMaximization_TitleStrategy":"Maximizar tráfego","Option_ConversionPriority_TitleStrategy":"Conversão primeiro","Option_SceneImmersion_TitleStrategy":"Cenas imersivas","Text_ExtractingVisualAttributes_TitleGenerationStatus":"Extraindo os recursos principais dos ativos...","Text_AnalyzingKeyHighlights_TitleGenerationStatus":"Gerando palavras-chave de conversão alta com base nos destaques do produto...","Text_MatchingSeoStrategy_TitleGenerationStatus":"Associando as melhores estratégias de SEO...","Text_GeneratingOptions_TitleGenerationStatus":"Gerando várias legendas de perspectivas diferentes...","Message_TaskFailedWithStatus_TitleGeneration":"Falha na tarefa (status: ${0}): ${1}","Message_TaskTimedOut_TitleGeneration":"A solicitação expirou. Tente de novo.","Message_GenerateFailed_TitleGeneration":"Falha ao gerar título. Tente de novo.","Message_QueryResultFailed_TitleGeneration":"Falha ao recuperar tarefa","Paragraph_Content_VirtualModelConsent":"1. Autorização de direitos de retratos: esse recurso usa as imagens que você carrega contendo rostos para gerar faces de modelos virtuais usando IA. Você precisa assegurar que tem os direitos de retrato das imagens carregadas ou que adquiriu o consentimento explícito por escrito válido com o proprietário desses direitos para usar suas fotos para esse fim e qualquer conteúdo gerado. Se a imagem contiver um menor de idade, será necessário obter o consentimento de seu guardião legal.","Button_ConfirmTextChange_TextEdit":"Atualizar","Input_ModifyText_TextEdit":"Editar legendas","Message_NoImagesAvailable_ResultDownload":"Nenhuma imagem disponível para download","Message_Failed_TextRecognition":"Falha ao reconhecer texto","Text_Generating_ResultStatus":"Gerando...","Option_CustomColor_SceneSetting":"Personalizado","Option_UseOriginalBackground_SceneSetting":"Usar fundo original","Text_InsufficientCredits_Common":"Moedas insuficientes","Button_LoadMore_Common":"Carregar mais","Text_ImageUploadLimit_Common":"Carregue até ${0} imagens","Text_AnalyzingTrend_Common":"Analisando tendências em ${0}","Text_ChineseOutputProOnly_Common":"A geração de texto em chinês está disponível somente no Pro. O texto foi removido do resultado atual.","Text_SourceImageUploadLimit_Common":"Carregue até ${0} imagens","Text_WritingInProgress_AiWriting":"Processando...","Text_DeepThinking_AiWriting":"Pensando...","Text_ThinkingProcess_AiWriting":"Raciocínio:","Text_ImageSelectionLimit_Common":"Selecione até ${0} imagens","Message_RegenerationSubmitted_Regeneration":"Regeneração enviada. Atualize para visualizar os resultados depois.","Button_MoreEditOptions_ResultEditor":"Mais","FormLabel_DetailSection_DetailPage":"Seção de detalhes de produto","Message_GeneratePlanFailed_DetailPagePlan":"Falha ao gerar plano","Message_PlanGenerationFailed_DetailPagePlan":"Falha ao gerar plano","Text_PlanUnavailable_DetailPagePlan":"Nenhum plano disponível","Message_SourceImageMissing_Common":"Imagem de produto faltando","Message_GenerationFailed_Common":"Falha na geração","Paragraph_ConfirmDiscardChanges_Common":"Suas alterações serão perdidas se você voltar. Tem certeza de que deseja voltar?","Message_ProcessFailed_Common":"Falhou","Text_GeneratingEllipsis_Common":"Gerando...","Text_StyleGenerationInProgress_ImageSet":"Gerando estilos modernos...","Message_FavoriteAdded_Common":"Adicionado aos Favoritos","Message_FavoriteRemoved_Common":"Removido dos favoritos","Text_LoadingPlain_Common":"Carregando","Text_MultiSelectAvailable_Common":"Selecionar vários","Text_NoData_Common":"Sem dados disponíveis","Text_NoDataAvailable_Common":"Sem dados","Text_NoMoreResults_Common":"Não há mais conteúdo","Message_PleaseEnterKeyHighlights_DetailPage":"Inserir destaques do produto","Message_PleaseSelectAiModel_TryOn":"Selecione um modelo de IA","Message_SelectSectionMin_DetailPage":"Selecione pelo menos ${0} seções","Message_SelectScenePoseMin_TryOn":"Selecione pelo menos ${0} cenas e poses","Message_PleaseSelectBaseModel_TryOn":"Selecione um modelo básico","Message_PleaseSelectCustomModel_TryOn":"Selecione um modelo personalizado","Message_PleaseSelectModel_TryOn":"Selecione um modelo primeiro","Message_PleaseSelectSection_DetailPage":"Selecione uma seção","Message_SelectUploadCustomModel_TryOn":"Selecione ou carregue uma imagem de modelo","Message_PleaseSelectScene_TryOn":"Selecione um cenário","Message_PleaseSelectStrategy_DetailPage":"Selecione uma estratégia","Message_PleaseUploadGarmentImage_TryOn":"Carregue uma imagem de roupa","Message_UploadGarmentFile_TryOn":"Carregue uma imagem de roupa","Message_PleaseUploadSourceImage_Common":"Carregue imagens do produto primeiro","Message_PleaseUploadItemImage_Common":"Carregue uma imagem de produto","Message_UploadItemFirst_Common":"Carregue imagens do produto primeiro","Message_RegenerateFailedWithReason_Regeneration":"Falha ao regenerar:","Message_SelectResultImages_Result":"Selecione uma imagem com os resultados gerados","Text_ReleaseToRefresh_Common":"Liberar para atualizar","Message_TextRecognitionFormatInvalid_TextRecognition":"Formato inválido reconhecido","Message_TextRecognitionParseFailed_TextRecognition":"Falha ao analisar os resultados de reconhecimento","Message_TextRecognitionTaskFailed_TextRecognition":"Falha ao reconhecer texto","Message_QueryTaskStatusFailed_TextRecognition":"Falha ao recuperar o status da tarefa","Message_SubmitTaskFailed_TextRecognition":"Falha ao enviar a tarefa de reconhecimento de texto","Text_RegenerationProcessing_Regeneration":"Solicitação de regeneração enviada. Processando...","Message_RegenerateFailedRetry_Regeneration":"Falha ao regenerar. Tente de novo mais tarde.","Message_OpenEditorFailed_ResultEditor":"Falha ao abrir o editor","Message_RegenerateFailed_Regeneration":"Falha ao regenerar","Message_RefreshFailedRetry_Common":"Falha ao atualizar. Tente de novo.","Message_UploadGarmentSelectModel_TryOn":"Carregue uma imagem de roupa e selecione um modelo","Message_PollingTimedOut_Common":"A consulta expirou","Title_KeyHighlights_DetailPage":"Destaques do produto","Title_FullStrategyGuide_DetailPage":"Estratégia completa e diretrizes de design","Title_IncludedSections_DetailPage":"Seções","Title_IncludedSectionsMultiple_DetailPage":"Seções (selecione várias)","Title_ModelSelection_TryOn":"Selecionar modelo","Title_SectionContent_DetailPage":"Conteúdo da seção","Title_SectionStrategyGuide_DetailPage":"Estratégia da seção e diretrizes de design","Title_OutputAspectRatio_Common":"Proporção","Title_OutputSpecification_Common":"Especificações","Title_SelectModel_TryOn":"Selecionar modelo","Title_SelectScene_TryOn":"Selecionar uma cena","Title_StrategySettings_DetailPage":"Estratégia","Title_UploadAssets_Common":"Carregar","Button_GenerateBaseModel_TryOn":"Gerar modelo básico","Button_GenerateRecommendedScenes_TryOn":"Gerar cena recomendada","Button_GenerateSceneImages_TryOn":"Gerar (${0} imagens)","Text_GeneratingBaseModel_TryOn":"Gerando modelo básico...","Option_CloseUp_Framing":"Close-up","Option_FullBody_Framing":"Corpo inteiro","Option_HalfBody_Framing":"Meio corpo","Option_ThreeQuarter_Framing":"3/4","Title_Hero_TryOn":"Provador de IA","Option_Ai_TryOnModelMode":"Gerado por IA","Title_Nav_TryOn":"Provador","Option_Back_Perspective":"Traseira","Option_Front_Perspective":"Frontal","Option_Side_Perspective":"Lateral","Option_ThreeQuarterSide_Perspective":"Vista 3/4","Input_AppearanceDetailsHint_TryOn":"Detalhes da aparência: pele morena sfranja reta, um sinal bonito perto do canto do olho…","Message_SaveToAlbumSuccess_Common":"Salvo no álbum","Text_GeneratingSceneImages_TryOn":"Gerando imagens da cena","Message_RefreshFailed_Common":"Falha ao atualizar","Message_FailedRefunded_Generation":"Falha no design com IA. Os créditos foram reembolsados.","Title_BaseModelImage_TryOn":"Imagem de modelo básico","Title_CustomModel_TryOn":"Modelo personalizado","Paragraph_Intro_TryOn":"Carregue uma imagem de roupa e personalize seu modelo para gerar várias cenas e poses.","Title_UploadGarmentImage_TryOn":"Imagem de roupa","Tips_UploadFailedPure":"Falha ao carregar","Tips_Uploading":"Carregando…","Text_UploadNewModel":"Novo modelo","Text_AllBackgrounds":"Todos os fundos","Text_DefaultTemplateScene":"Padrão","Text_ColorScene":"Cores","Text_SameProductMax_Common":"Até ${0} imagem(ns) por produto","Text_Max_Common":"Adicione até ${0} imagens — cada referência gera 1 resultado.","Button_Generate_ImageClone":"Começar a gerar","Button_RefreshStyle_Common":"Atualizar","Button_Favorite_Common":"Favorito","Text_PreviewLargeImage":"Prévia completa","Text_BaseImage":"Marco","Button_BatchDownload_Common":"Download em lote","Button_BatchEdit_Common":"Editar lote","Button_BatchWatermark_Common":"Adicionar marca d\'água","Text_GeneratedResults":"Resultados","Button_DownloadAllImages_Common":"Baixar tudo","Text_NoGeneratedResults":"Ainda não há resultados","Text_SameProductMax_TryOn":"Um traje completp ou vários ângulos do mesmo item, até ${0} imagens.","Title_AdvancedImageGenerationModel":"Modelo de imagem premium","Text_SupportChineseOutput_Common":"Oferece suporte a saída em chinês e fornece detalhes estéticos melhores e maior controle criativo.","Text_SelectMultipleModules_DetailPage":"Selecione várias seções para gerar uma página de detalhes de produto completa","Button_CollapseAll_Common":"Tudo","Label_AppearanceDetails_TryOn":"Detalhes de aparência (opcional)","Text_WaitingForGeneration_TryOn":"Geração pendente","Title_SmartTitleAI_ProductTitle":"Gerar títulos virais","Message_ResultMissing_TitleGeneration":"${0} ausente nos resultados gerados com IA","Message_InvalidJSONFormat_TitleGeneration":"Resultado inválido retornado","Message_InvalidJSONFormat_TitleGeneration1":"Formato JSON inválido retornado","Text_AutoGeneratedTitleScheme_ProductTitle":"Aqui estão os títulos gerados automaticamente com base no seu produto","Text_SelectBestTitle_ProductTitle":"Escolha um título que venda e clique para copiar","Button_Copy_Common":"Copiar","Message_PleaseUploadImage_Common":"Por favor, carregue uma imagem primeiro","Text_DeepThinking1_AiWriting":"O DeepSeek está trabalhando nisso...","Button_Rewrite1":"Tentar de novo","Text_TotalImages_Common":"Contagem: ${0}","Text_EditText_ResultEditor":"Editar texto","Text_NoTextRecognition_ResultEditor":"Nenhum texto encontrado","Text_PreviewLongImage_ResultGroup":"Prévia de imagem longa","Text_LimitFree":"Oferta relâmpago","Text_UploadSameProductTip1":"1. Envie imagens originais do mesmo produto de vários ângulos para ajudar a IA a recriar os detalhes do produto com mais precisão","Text_UploadSameProductTip2":"2. Você pode enviar até ${0} imagens. A primeira será usada como referência principal, então escolha a que mostra a visão mais completa.","Text_UploadProductImage_APlusCase":"Carregar imagem de produto","Text_GenerateEcommerceLongImage_APlusCase":"Gerar imagem longa","Text_MultiPlatform_APlusCase":"Compatível com vários padrões de plataforma de e-commerce","Text_MainImage_ProductCase":"01 imagem de cabeçalho (fundo branco/padrão)","Text_SceneDisplay_ProductCase":"02 cenários de casos de uso","Text_ModelSceneImage_ProductCase":"03 Imagens de modelo","Text_DetailDescription_ProductCase":"04 Detalhes","Text_FeatureExplanation_ProductCase":"05 destaques do produto","Text_UploadProductImage_ProductCase":"Carregue imagens de produto, e a IA gerará instantaneamente conjuntos de imagens de alta conversão <span>compatíveis com vários padrões de plataforma de e-commerce</span>.","Text_UploadGarmentImage_TryOn":"Carregue imagens de roupas e crie seu modelo personalizado para gerar instantaneamente várias cenas e poses.","Text_UploadProductImage_DetailPage":"Carregue imagens de produto, e a IA gerará instantaneamente uma página de detalhes de produto profissional <span>compatível com vários padrões de plataforma de e-commerce</span>.","Title_DetailPage_ProductCase":"A+/Página de detalhes de produtos","Option_Temu_Platform":"Temu","Option_TikTokShop_Platform":"TikTok Shop","Option_TikTok_Platform":"TikTok","Option_Ozon_Platform":"OZON","Option_Shopee_Platform":"Shopee","Option_SHEIN_Platform":"SHEIN","Login_Zawa_Title":"Faça login para desbloquear seu teste gratuito","Login_DK_Title":"Crie designs deslumbrantes de graça","Login_Zawa_Des":"Comece a criar com o Zawa hoje mesmo","Login_DK_Des":"Crie uma conta ou faça login para continuar criando designs. Comece agora mesmo!","Tab_Module_ProductImage_TryOn_MultiMix":"Organize peças em uma roupa","Tab_Module_ProductImage_TryOn_SingleHero":"De uma peça a um look completo","Tab_Module_ProductImage_TryOn_Accessories":"Combinação perfeita de acessórios","Text_ShowAdvancedModelTip":"Mostrar dicas de modelo premium","Text_HideAdvancedModelTip":"Ocultar dicas de modelo premium","Text_DeepSeekR1HelpWrite":"Ajude-me a escrever (DeepSeek R1)","Message_PollingMaxAttempts_Common":"Máximo de tentativas excedido: ${0}","Title_StandardEdition":"Padrão","Text_FastAndEfficient_Common":"Rápido e eficiente","Text_PremiumEdition":"Premium","Text_QualityAndDetailEnhancement_Common":"Qualidade e detalhes aprimorados","Text_PremiumEngineActivated":"<strong>Mecanismo premium ativado:</strong> oferece suporte a saída em chinês e fornece detalhes estéticos melhores e maior controle criativo.","Text_EditBrand_DropTitle1":"Arraste e solte arquivos JPG, PNG ou WEBP aqui","Text_EditBrand_DropTitle2":"ou <>procure</> no seu computador.","Text_BaseToolbar_AlignTop":"Alinhamento superior","Text_BaseToolbar_AlignBottom":"Alinhamento inferior","Text_LayerSort":"Ordem","Text_BaseToolbar_AlignCenter":"Centro","Text_Attr_Strong":"Negrito","Text_GeneratingPlan_DetailPagePlan":"Gerando plano...","Text_PlanGenerationFailed_ReTry":"Falha ao gerar plano. Tente de novo mais tarde.","Button_StartAnalyze_ProductCase":"Vamos lá!","Message_SubmitSuccessTip_Batch":"Enviado","Button_ClickAnalyze_ProductCase":"Analisar estilos mais vendidos","Button_StartAnalyzing_ProductCase":"Analisando","Title_ModelImage":"Modelo","Text_Cookie_Title":"Primeiramente, os cookies 🍪","Text_Cookie_Content":"Gostaríamos de usar cookies neste site para garantir a segurança, bom desempenho e otimizar nossos serviços. Para saber mais sobre como usamos cookies, é só clicar em","Text_Cookie_LearnMore":"Detalhes","Button_Cookie_Manage":"Gerenciar cookies","Button_Cookie_Accept":"Aceitar","Text_CookieModal_Title1":"Configurações de cookies","Text_CookieModal_Desc1":"Cookies são pequenos arquivos de texto que os sites armazenam no seu dispositivo para nos ajudar a lembrar de suas preferências, acompanhar o tráfego do site e melhorar nossos serviços. Sua privacidade é importante para nós, e queremos que você tenha controle sobre seus dados. Aqui, você pode personalizar suas preferências de cookies para otimizar sua experiência de navegação. Lembre-se de que alterar as configurações de cookies pode afetar a funcionalidade e os serviços do nosso site.","Text_CookieModal_Title2":"Cookies necessários","Text_CookieModal_Desc2":"Esses cookies são essenciais para o funcionamento, a segurança e o desempenho do site. Sem eles, os principais recursos e medidas de segurança do Zawa podem não funcionar corretamente, o que pode afetar negativamente sua experiência.","Text_CookieModal_Title3":"Cookies opcionais","Text_CookieModal_Desc3":"Esses cookies nos ajudam a entender quantos usuários o Zawa tem, de onde eles vêm e como utilizam o site. Se você optar por desativá-los, não poderemos coletar informações para melhorar o Zawa e oferecer serviços melhores para você e outros usuários.","Button_CookieModal_Save":"Salvar","Text_CookieModal":"Sempre ativo","Text_Agent_Chat_DK":"Digite sua ideia...","Text_Agent_Chat_XD":"O que você gostaria de desenhar","Radio_Color":"Paleta","Radio_Layout":"Layout","Radio_Reference":"${0}","Radio_Posture":"Pose","Radio_Background":"Fundo","Language_Banner_Message":"Gostaria de trocar para ${0}?","Language_Banner_Change":"Sim","Language_Banner_Other":"Mais idiomas","Title_ItemTaskWithIndex_Batch":"Tarefa de produto ${0}","Title_DetailTaskPrefix_Batch":"Tarefa A+","Text_CopiedTaskTitle_Batch":"${0} (Cópia)","Message_SelectSectionMin_Batch":"Selecione ao menos uma seção.","Title_GlobalBatchSettings_Batch":"Configurações globais (Aplicar às tarefas seguintes)","Text_Parameters_Batch":"Parâmetros","Text_Modules_Batch":"Seções","Title_KeyHighlights_Batch":"Destaques do produto","Text_ModulesFollowGlobal_Batch":"Seções - Usar configurações globais","Title_SelectManagedBusinessType_Batch":"Selecione o tipo de tarefa","Button_SubmitTask_Batch":"Enviar","Text_NewTaskCurrentCount_Batch":"Criar tarefa","Title_NotificationSettings_Batch":"Notificações","Title_ManagedMode_Batch":"Agendador","Button_SaveSettings_Batch":"Salvar configurações","Button_SaveAndContinueSubmit_Batch":"Salvar e enviar","Message_PhoneFormatInvalid_Batch":"Insira um número de telefone válido, de 11 dígitos.","Message_VerificationCodeSent_Batch":"Código de verificação enviado. O código é válido por 5 minutos.","Message_VerificationCodeSendFailed_Batch":"Falha ao enviar. Tente novamente mais tarde.","Message_PleaseEnterCode_Batch":"Insira o código de verificação.","Message_GetCodeFirst_Batch":"Obtenha primeiro um código de verificação.","Message_VerificationCodeExpired_Batch":"O código de verificação expirou. Solicite um novo.","Message_SaveNotificationSettingsFailed_Batch":"Falha ao salvar as configurações de notificações. Tente mais tarde.","Text_WebMessageNotification_Batch":"Você receberá uma notificação nas mensagens da Web quando a tarefa for concluída.","Title_AppPushRecommended_Batch":"Notificações no app (Recomendado)","Paragraph_AppPushDesc_Batch":"Acompanhe o progresso e veja os resultados no seu celular em tempo real. Mantenha seus designs sempre à mão e não perca nenhuma oportunidade.","Text_AppDownloadQrCode_Batch":"Escaneie para baixar o app","Title_SmsNotification_Batch":"Notificações via SMS","Placeholder_Phone11Digits_Batch":"Número de telefone de 11 dígitos","Placeholder_VerificationCode5Min_Batch":"Código de verificação","Text_SendingEllipsis_Batch":"Enviando...","Text_RetryAfterSeconds_Batch":"Tente novamente em ${0} s","Button_GetVerificationCode_Batch":"Enviar código","Message_SubmitSuccess_Batch":"Enviado","Message_SubmitFailedRetry_Batch":"Falha ao enviar. Tente novamente mais tarde.","Message_FormValidationPassed_Batch":"Conteúdo válido","Message_CompleteNotificationSettingsFirst_Batch":"Por favor, configure as notificações antes de enviar a tarefa.","Paragraph_CancelManagedTaskWarning_Record":"Caso cancele agora, a tarefa agendada será removida permanentemente.","Button_ConfirmCancel_Record":"Cancelar mesmo assim","Message_CancelManagedTaskFailed_Record":"Falha ao cancelar. Tente novamente mais tarde.","Text_WaitingManagedGeneration_Batch":"Agendando tarefa...","Text_WaitingManagedSubmit_Batch":"Na fila","Message_NoExtendableImages_Result":"Nenhuma imagem disponível","Text_IntelligentMultiSizeAdaptation_Result":"Com o redimensionamento inteligente, suas imagens cabem em qualquer tela","Button_IntelligentResize_Result":"Redimensionamento inteligente","Option_CustomSize_DetailPageMode":"Personalizado","Title_AdvancedAPlus_DetailPageMode":"Premium A+","Title_ManagedModeLaunched_Batch":"Experimente o Agendador!","Text_ManagedModeSlogan_Batch":"Funciona durante a noite para que seus designs estejam prontos pela manhã.","Title_BatchProduction_Batch":"Geração por lote","Paragraph_BatchProductionDesc_Batch":"Executa até ${0} tarefas simultaneamente, aumentando sua produtividade em ${1}×.","Title_AiIntelligentExtraction_Batch":"Análise por IA","Paragraph_AiIntelligentExtractionDesc_Batch":"Analisa suas imagens e gera automaticamente destaques do produto com alto poder de conversão.","Title_SaveCost20_Batch":"Economize ${0}% em créditos","Paragraph_SaveCost20Desc_Batch":"Você pode agendar tarefas à noite e aproveitar descontos no uso de créditos.","重写":"Download em lote","Brand_AutoExtract_Button":"Extração de paleta","Brand_AutoExtract_Success":"Paleta extraída","Brand_AutoExtract_Failure":"Falha ao extrair a paleta de cores. Tente novamente.","Brand_AutoExtract_Unavailable":"Não é possível extrair a paleta de cores.","Brand_AutoExtract_ConfirmTitle":"Extrair a paleta de cores do logo?","Title_ImageSetConfig_ImageSet":"Design de anúncios","Title_DefaultConfig_ImageSet":"Design com IA","Desc_DefaultConfig_ImageSet":"A IA analisa as imagens do produto e seleciona o melhor conjunto de imagens para o anúncio","Title_CustomConfig_ImageSet":"Design personalizado","Desc_CustomConfig_ImageSet":"Ajuste o número de imagens para cada tipo. Selecione pelo menos ${0} imagens.","Label_WhiteBackground_ImageSet":"Imagens com fundo branco","Desc_WhiteBackground_ImageSet":"Apresente seu produto de vários ângulos com um fundo branco.","Label_Scene_ImageSet":"Cenas da vida","Desc_Scene_ImageSet":"Apresente seu produto em cenas realistas.","Label_SellingPoint_ImageSet":"Destaques do produto","Desc_SellingPoint_ImageSet":"Destaque as principais características que fazem seu produto se sobressair.","Label_Other_ImageSet":"Outros","Desc_Other_ImageSet":"Conteúdo selecionado automaticamente para seu produto, incluindo comparações e especificações, entre outros.","Tip_MinTotal_ImageSet":"Mínimo de ${0} imagens","Text_ManagedBatchEntry_Header":"Agendador","Option_Coupang_Platform":"Coupang","Option_Wayfair_Platform":"Wayfair","Button_Credit_Plan":"Plano de créditos","Text_Higher_Plan":"Já possui um plano superior","Text_Try_Free":"Experimente por $0","Text_Plus_Plan":"Plano Plus","Text_Pro_Plan":"Plano Profissional","Button_Generate_Short_Common":"Gerar","Message_DuplicateTaskSubmitConfirm_Common":"Já foram gerados resultados com essas configurações. Gerar novamente?","Text_CreditUnit_Common":"Créditos","Text_NewUserDiscountDesc_Product":"${0} créditos pelo primeiro anúncio. ${2} créditos por cada ${1} anúncios adicionais.","Text_NewUserLimitedTag_Product":"Desconto de novo usuário","Text_OriginalPrice_Product":"Original: ${0} créditos","Tip_MaxTotal_ImageSet":"Até ${0} imagens","Text_AddDocumentTips":"Compatível com arquivos Word, Excel, Text, PDF e Markdown","Tab_SolidColor":"Cor sólida","Tab_Gradient":"Degradê","Title_PresetGradient":"Predefinições","Title_PresetSolidColor":"Predefinições","Title_RecentlyUsed":"Usado recentemente","Title_Patterns":"Padrão","Title_NoFill":"Nada","Description_Brand_Reference":"Envie seus pôsteres ou artes favoritas e o Zawa usará aqueles estilos para criar designs sob medida para você.","Text_Generating":"Gerando...","Text_ChartSending":"Enviando","Text_PeopleUnSupport":"Ainda não há suporte para retrato","Button_CancelManagedBatch_ResultGroup":"Cancelar tarefa","Button_DownloadZip_ResultGroup":"Baixar ZIP","Button_DownloadLongImage_ResultGroup":"Baixar o arquivo combinado","Text_ManagedTaskDispatchedCannotCancel_ResultGroup":"A tarefa enviada não pode ser cancelada","Button_GlobalAiWriting_Batch":"Redação com IA","Text_StandardModel_DistributionBatch":"Modelo Padrão (Lista em massa)","Text_StandardModelDescription_Batch":"Ideal para SKUs de alto volume, a fim de maximizar o alcance no mercado.","Text_AdvancedModel_PremiumBatch":"Modelo Avançado (Listagem direcionada)","Text_AdvancedModelDescription_Batch":"Imagens de qualidade premium, ideais para gerar rentabilidade com alta precisão.","Message_MinSubmitTasks_Batch":"Envie pelo menos ${0} tarefas.","Message_OverwriteSellingPointsConfirm_Batch":"A seção de destaques do produto já contém ${0} tarefas. Como você gostaria de aplicar os resultados da redação com IA?","Button_OverwriteAll_Batch":"Substituir todos","Button_FillEmptyOnly_Batch":"Apenas os incompletos","Message_NoEmptySellingPointsToFill_Batch":"Os destaques do produto para todas as tarefas já estão completos.","Message_AiWritingFailedRetry_Batch":"A redação com IA falhou. Tente novamente mais tarde.","Button_NewTask_Common":"Nova tarefa","Message_Generating_Time":"Suas tarefas serão executadas durante a noite (${0}-${1}). Volte amanhã para verificar os resultados.","Title_Total_Credits":"Créditos totais","Text_Used_AllFeatures":"Aplicável a todos os recursos","Daily_Present_Credits":"Créditos para usar hoje","Daily_Credits_Desc":"Resgate diariamente. Válido até o final do dia.","Text_Inactive":"Inativos","Text_Inactive_Monthly":"${0} créditos expirarão nos próximos 30 dias","TITLE_GUIDE_CUTOUT_LITE":"Selos ou logotipos detectados","GUIDE_DESC_CUTOUT_LITE":"Use o recurso Recorte de selo/logotipo para um recorte preciso","GUIDE_ACTION_CUTOUT_LITE":"Recorte de selo/logotipo","TITLE_CUTOUT_LITE":"Recorte de selo/logotipo","TIP_CUTOUT_LITE":"Recortes de selos ou logotipos com precisão","PROCESSING_CUTOUT_LITE":"Gerando imagens...","AFTER_CUTOUT_LITE":"Resultados","Button_Previous":"Anterior","Button_Next":"Próximo","Button_Skip":"Pular","Button_Apply":"Aplicar","Text_AgentExpert":"Especialista","Message_PleaseEnterLinkOrAsin_Clone":"Insira um link ou ASIN","Message_LinkAnalyzeFailed_Clone":"A análise do link falhou","Message_UploadProductImageFirst_Clone":"Carregue imagens do produto primeiro","Message_ProductImageThumbGenerateFailed_Clone":"Falha ao gerar a miniatura. Envie novamente.","Message_UploadProductImageFirst_ProductCase":"Carregue uma imagem de referência ou cole o link de um produto","Message_ReferenceImageThumbGenerateFailed_Clone":"Falha ao gerar a miniatura. Envie novamente.","Title_ReferenceSource_Clone":"Referência","Option_LinkAsin_Clone":"Link","Input_PasteProductLinkOrAsin_Clone":"Colar link da Amazon","Button_Parsing_Clone":"Analisando...","Button_Parse_Clone":"Analisar","Text_SupportAmazonTiktokLinks_Clone":"Compatível com links da Amazon e do TikTok","Text_Cloning_ResultStatus":"Processando...","Input_CloneRequirementOptional_Clone":"Requisitos (Opcional)","Title_ProductOriginalImage_Clone":"Imagem de produto","Title_CloneLevel_Clone":"Estilo de replicação","Option_CompositionReference_Clone":"Combinar estilo","Desc_CompositionReference_Clone":"Cria uma nova cena inspirada no clima e no estilo da sua referência.","Option_HighFidelityClone_Clone":"Correspondência De Referência","Desc_HighFidelityClone_Clone":"Recria fielmente sua referência, alterando apenas o produto e o texto.","Label_OutputStyleConsistent_Clone":"Estilo consistente","Title_SupplementaryNotesOptional_Clone":"Instruções adicionais (Opcional)","Input_SupplementaryNotesExample_Clone":"Exemplo: Gere um texto publicitário em inglês, mantendo o mesmo modelo e substituindo apenas o produto.","Title_HotClone_Welcome":"Remix de imagens","Text_HotCloneDescription_Welcome":"Sua referência de sucesso + sua imagem de produto = sua própria imagem viral","Text_DefaultTaskName_Clone":"Estratégia de clonagem de imagem","Label_ProductImage_CloneCase":"Imagem de produto","Label_ReferenceComposition_CloneCase":"Combinar estilo","Label_HighFidelityClone_CloneCase":"Combinar com referência","Tag_AiSmartMatch_ImageSet":"Correspondência inteligente com IA","Title_Date":"Data","Title_Topic":"Tema","Button_Replace":"Substituir","Title_SingleCloneRequirement_Clone":"Requisitos individuais","Text_UploadedReferenceImagesTip_Clone":"Requisitos individuais para cada imagem de referência. Caso não sejam especificados, as configurações padrão serão aplicadas.","Label_ReferenceImageIndex_Clone":"Imagem de referência ${0}","Option_Mexico_Market":"México","Text_ParsingReferenceImages_Clone":"Analisando...","Text_ParseReferenceImagesSuccess_Clone":"Análise concluída. ${0} imagem(ns) de referência obtida(s).","Text_Renew_Restore":"Os créditos serão reativados assim que sua assinatura for renovada.","Title_UsageNotice_Clone":"Guia do usuário","Text_UsageNoticeDescription_Clone":"Confirme que você detém os direitos legais de uso do conteúdo deste link. Os resultados gerados são fruto de análise de estilo por IA e servem apenas como referência criativa.","Label_ReadAndAgreeUsageNotice_Clone":"Aceito os termos acima","Label_DoNotShowAgain_Clone":"Não mostrar novamente","Text_InterceptModal":"Permitir janelas pop-up para o Designkit.","Text_InterceptModal_ThirdStep":"Clique em “Concluído” para começar a usar o Designkit.","Text_InterceptModal_Desc":"Autorize o Designkit a abrir várias janelas no seu navegador.","Brand_StatusPopup_ProcessingTitle":"Zawa está estudando o estilo da sua marca...","Brand_StatusPopup_FailedTitle":"Falha ao extrair dados da Square. Tente novamente mais tarde.","Brand_StatusPopup_Retry":"Tentar novamente","SecondTitle_Header19_Home":"Clonar anúncios de vídeo","SquareBrandGuide_BrandKitCreatedTip":"Seu kit de marca foi criado com base nos dados da Square","SquareBrandGuide_DefaultPrompt":"Crie um pôster de produto para divulgação nas redes sociais","SquareBrandGuide_SendTip":"Clique em \\"Enviar\\" para começar!","Paragraph_BatchProductionDescUnlimited_Batch":"Realiza várias tarefas simultaneamente, reduzindo drasticamente os prazos dos seus projetos.","Menu_ViewDetail":"Detalhes","Menu_CopyFullText":"Copiar","Tip_CopiedToClipboard":"Copiado para a área de transferência","Tip_CopyFailed":"Falha ao copiar","Menu_DownloadImage":"Baixar","Tip_NoImage":"Sem imagens","Tip_DownloadStarted":"Download em andamento","Menu_CopyText":"Copiar","Tip_NoTextToCopy":"Não há texto disponível","Message_LinkImageFetchFailed_Clone":"Não foi possível carregar as imagens deste link. Tente um link diferente ou faça o upload das imagens.","Tab_Chat":"Chat","Tab_Files":"Arquivos","Button_Create_New_Chat":"Novo chat","Tip_Agent_Team_Chat_Shared":"Visualizando versão somente leitura","Title_ViralVideoMaker":"Gerador de Vídeos Virais com IA","Title_ProductVideoMaker":"Gerador de Vídeos de Produto","designkit_agent_watermark_protocol":"Você pode optar por salvar as imagens com ou sem a marca d\'água \\"Resultado de IA\\". Ao salvar sem essa marca d\'água, você concorda em: 1. Não usar o Agente de IA Zawa para criar, publicar ou distribuir informações falsas. 2. Seguir as leis aplicáveis e indicar claramente conteúdos gerados por IA ao utilizá-los ou compartilhá-los.","Text_Document":"Arquivo","Button_BrandAssets_UploadDevice":"Carregar do dispositivo","Button_SocialBrief_Complete":"Concluir briefing","Button_SocialBrief_Edit":"Editar briefing","Button_SocialBrief_Generate":"Gerar com base no briefing","Description_BrandAssets":"As informações da sua marca nos ajudam a fornecer resultados mais relevantes.","Name_BrandAssets":"Ativos de Marca","Placeholder_BrandAssets_Link":"por exemplo, links do Instagram ou do Google Maps.","Text_BrandAssets_KitImported":"Importar do Kit de marca","Text_BrandAssets_LinkEntry":"Insira seu link","Text_SocialResult_Post":"Postagem","Title_SocialBrief":"Briefing","Toast_BrandAssets_DuplicateSkipped":"Duplicar imagens ignoradas","Toast_BrandAssets_EmptyAssets":"Nenhuma imagem de kit de marca encontrada","Toast_BrandAssets_InvalidUrl":"Inserir um link válido","Toast_BrandAssets_LoadAssetsFailed":"Não foi possível obter os ativos de marca","Toast_BrandAssets_LoadKitsFailed":"Não foi possível obter os kits de marca","Toast_BrandAssets_PartialReadFailed":"Não foi possível carregar algumas imagens","Toast_BrandAssets_ReadFailed":"Não foi possível carregar as imagens","Toast_BrandAssets_SaveFailed":"Falha ao salvar os ativos de marca","Toast_BrandAssets_UploadFailed":"Não foi possível carregar algumas informações sobre os ativos da marca. Tente novamente.","Title_AgentDesignPreference":"Personalize seu agente de estilo de IA","Desc_AgentLibWorkflowUnify":"Salve seus modelos e estilos de assinatura para criações mais rápidas e consistentes em todos os fluxos de trabalho.","Button_ViewAgentGuide":"Instruções","Desc_BatchRecipeRetain":"Salve as configurações de imagem e as composições de cena como Predefinições reutilizáveis que você poderá aplicar instantaneamente a projetos futuros.","Button_NewBatchRecipe":"Criar predefinição","Desc_CustomModelUpload":"Carregue as imagens do seu modelo e reutilize-as em várias gerações para criar uma identidade de marca consistente.","Button_NewExclusiveModel":"Criar modelo","Text_AiRecommend_TryOn":"Recomendações inteligentes de cena","Desc_AiRecommendSceneMode_TryOn":"Selecione automaticamente a melhor cena com base no vestuário.","Message_LoadSceneFailedRetry_TryOn":"Falha ao carregar, tente de novo mais tarde.","Text_OptionalCustomSceneDescription_TryOn":"Descreva sua cena (opcional)","Placeholder_CustomSceneDescription_TryOn":"Forneça detalhes, por exemplo, ruas em um outono dourado, luz suave do pôr do sol, uma pessoa encostada em uma árvore…","Message_PleaseSelectOrDescribeScene_TryOn":"Selecione ou insira a descrição de uma cena","Placeholder_SearchProduct_Record":"Pesquisar por nome de produto ou palavras-chave","Title_RecentSearches":"Histórico","Button_Clear":"Limpar","Title_ShootingScene_TryOn":"Configurações de cena","Button_Charged_Continue":"Recarga completa","Title_SplitImagePlugin":"Disposição em camadas de imagem","Description_SplitImagePlugin":"Detectar elementos de imagem e separá-los em camadas editáveis.","Tip_SplitImageLoading":"Processando...","Tip_SplitImageFail":"Falha no processamento. Tente novamente.","Brand_SquareSync_ToastPartial":"Não foi possível importar alguns dados da Square","Brand_SquareSync_ToastSuccess":"Seus dados da Square estão prontos","Brand_SquareSync_Failed":"Falha ao extrair dados da Square","Brand_SquareSync_Button":"Importar da Square","Title_Format":"Formato","Message_CancelManagedTaskSuccessRefunded_Record":"Tarefa cancelada. Os créditos foram reembolsados em sua conta.","Text_AspectRatio_Common":"Proporção","Text_Country_Common":"País/região","Text_Language_Common":"Idioma","Text_Platform_Common":"Plataforma","Option_Korea_Market":"Coreia do Sul","Option_Korean_Language":"Coreano","Title_AgentLibRecentBrainOn":"Inteligência do agente ativada","Desc_AgentLibRecentRecipesSidebar":"Suas predefinições serão adicionadas aos Recursos do Agente. Use-as para aplicar instantaneamente o estilo da sua marca em todos os designs.","Title_CreateBatchRecipe":"Criar predefinição","Tips_Not_Files":"Sem arquivos","Message_PleaseEnterProductHighlights":"Inserir destaques do seu produto","Message_UploadProductImageRequired":"Carregue pelo menos uma imagem de produto","Tips_Agent_Teams_Mode":"Ideal para fluxos de trabalho sofisticados que exigem vários recursos de IA.","Tips_Agent_Teams_Mode_Actived":"O Modo de equipe de agentes coordena os agentes de IA em todos os estágios, da estratégia à produção final.","Tip_SocialBrief_MissingImages":"Faltam as imagens requeridas em {count} publicações. Adicione-as para continuar.","Tips_Agent_Teams_Mode_Active_Zawa":"A equipe de agentes está pronta: pesquisa e criação de conteúdo no piloto automático. É só me dizer do que você precisa.","Tip_AiGeneratedContent":"O conteúdo gerado com IA pode conter erros.","Button_ContinueUpload":"Continuar","Button_GenerateNow":"Gerar","Button_ReplaceClothes":"Substituir","Desc_ReplaceClothesMultiUpload":"Alterar toda a roupa ao mesmo tempo","FileName_MyClothes":"Carregado","Message_SelectReplaceClothes":"Selecionar suas imagens de roupas","Message_UploadClothesFailed":"Falha ao carregar imagem, tente de novo.","Message_UploadClothesSizeLimit":"Carregue imagens de roupas com até 10 MB","Text_MoreActionEmpty":"Configurar ações","Tip_UploadClothesFormat":"Solte ou carregue ${0} imagens com até ${1}.","Title_ReplaceClothes":"Substituir roupas","Title_TryOnAccessoryMatch":"Adicionar acessórios inteligentes para criar um look com marca de assinatura","Title_TryOnMultiPose":"Criar portfólios com poses de modelo realistas e naturais","Title_TryOnOutfitMix":"Criar trajes completos combinando itens","Title_TryOnSceneSwitch":"Alternar fundos para se ajustarem a qualquer vibe ou estilo de campanha","Title_TryOnAIRecommend":"Recomendações de IA","Text_SocialBrief_Generating":"Geração em andamento. Aguarde.","Tag_New":"Novo","Title_Designer":"Designer","Button_Blank_Canva":"Designer","Tool_AiViralImageRemix":"Remix de imagens","Title_ViralVideoReplace":"Remix de vídeo","Title_SocialMedia_Tools":"Ferramentas criativas para redes sociais","Title_HotTags":"Em alta","Tip_LogoNotRecognized":"Logotipo não encontrado","Tip_LogoNotRecognized_Eraser":"Logotipo não encontrado. Deslize para selecionar a área que deseja remover.","Placeholder_RemoveGrassDebris":"Remover bagunça da grama","Placeholder_RemoveGroundShadow":"Remover sombras do chão","Placeholder_RemoveRedClothesPerson":"Remover a pessoa de roupa vermelha","Placeholder_DescribeRemovalPart":"Especifique o que você deseja remover, por exemplo: ${0}","Modal_LeavePageTitle":"Você está prestes a sair desta página","Modal_OpenRoboNeoNewTab":"Abrir o RoboNeo em uma nova aba?","Button_ReplicateVideo":"Fazer remix deste vídeo","Button_RemixImage":"Remixe esta imagem","Message_ContentProcessFailed_Text":"Falha ao processar. Tente outras palavras.","Message_ContentProcessFailed_Image":"Não é possível processar essa imagem. Tente outra.","Text_ProductImageOptionalUploadTip_Clone":"Adicione uma foto do produto se quiser incluí-la no resultado","Option_EcommerceProductImage_Clone":"Imagem de produto para e-commerce","Option_ApparelEcommerceImage_Clone":"Imagem de e-commerce de moda","Option_SocialGraphicImage_Clone":"Post para redes sociais","Option_MarketingPoster_Clone":"Cartaz de marketing","Option_CreativePoster_Clone":"Cartaz criativo","Option_ReferenceImageSize_Clone":"Proporção","Option_Instagram_Platform":"Instagram","Home_Tools_Title":"Potencialize seu conteúdo nas redes sociais com nosso poderoso kit de ferramentas","Home_Tools_Tab_SocialCreative":"Criação para redes sociais","Home_Tools_SeeAllImageTools":"Ver todas as ferramentas de imagem","Home_Tools_SeeAllSocialCreative":"Ver todas as ferramentas de conteúdo social","Home_Tools_ImageObjectRemover":"Removedor de objetos da imagem","Home_Tools_TextToVideo":"Texto em vídeo","Home_Tools_FoodPhotography":"Fotografia de alimentos","Home_Tools_FlyerGenerator":"Gerador de panfletos","Home_Tools_MenuGenerator":"Gerador de cardápios","Home_Tools_PosterGenerator":"Gerador de cartazes","Home_Tools_MockupGenerator":"Gerador de maquetes","Home_Tools_ImageExtender":"Extensor de imagem","Home_Tools_ImageToVideo":"Imagem em vídeo","title_upgrade2GetMoreCredits":"Faça upgrade para obter mais créditos.","tip_insufficientCredits":"Créditos insuficientes. Recarregue para obter mais.","tip_insufficientCredits_upgrade":"Créditos insuficientes. Assine para obter mais.","Title_DownloadPromotion_ViralVideo":"Quer mais vídeos como este?","Subtitle_DownloadPromotion_ViralVideo":"Assine o Pro para criar mais vídeos.","Tag_DownloadPromotionOffer_ViralVideo":"Oferta por tempo limitado","Title_DownloadPromotionCard_ViralVideo":"Continue criando com o Pro","Text_DownloadPromotionPrice_ViralVideo":"${0}/mês","Text_DownloadPromotionBenefitViralVideo_ViralVideo":"Gerador de vídeos de produto/Remix de vídeo (até ${0} vídeos/mês)","Text_DownloadPromotionBenefitNanoBanana_ViralVideo":"Criações ilimitadas com o Nano Banana Pro","Text_DownloadPromotionBenefitImageEnhance_ViralVideo":"Remoção ilimitada e aprimoramento da qualidade com IA","Button_DownloadPromotionGetPro_ViralVideo":"Assine o Pro com ${0} de desconto","Button_DownloadPromotionLater_ViralVideo":"Não, obrigada(o).","Tag_NewUserLimitedFree":"Oferta por tempo limitado","Text_FirstImageCreditDiscount":"${0} créditos para a primeira imagem. ${2}créditos para cada ${1}imagens adicionais.","Tag_NewUser_FirstImageLimitedFree":"Oferta por tempo limitado","Tag_FirstImageFree":"1 Teste gratuito","Title_OtherSettings":"Outras configurações","Title_GenerateListing":"Gerar texto para o listing","Button_GenerateListing":"Gerar texto para o listing","Message_Copied":"Copiado","Text_Generating_Listing":"Gerando...","Text_GenerateFailed_Listing":"Falha ao gerar","Button_Translate":"Traduzir","Title_ListingCopy":"Texto do listing","Message_NoTaskForListing":"Não foi encontrada nenhuma tarefa de geração de listing.","Message_RenameSuccess":"Modificado","Message_RenameFailedRetry":"Falha na modificação. Tente novamente.","Title_RegenerateDirection":"Editar Geração","Placeholder_RegeneratePrompt":"Deixe em branco para regenerar ou adicione instruções para editar o resultado (opcional). Por exemplo: “Mova o produto para a esquerda” ou “Altere o fundo para cinza claro”.","Title_TrialLimitReached_ViralVideo":"Vídeo gratuito utilizado","Subtitle_TrialLimitReached_ViralVideo":"Sua versão de avaliação gratuita permite criar 1 vídeo. Faça o upgrade para a versão Pro para criar mais vídeos.","Button_UpgradeNow":"Fazer upgrade agora","Text_WPS_NavVipEntrance":"Comprar","Text_WPS_Only":"(WPS only)","Text_WPS_Credits_Card_Tip":"Designkit has a separate subscription system and is not included in standard WPS memberships.","Text_WPS_Welcome_Modal_Pricing":"Designkit Subscription","Text_WPS_Welcome_Modal_Pricing_Description":"O Design com IA é fornecido por um parceiro terceirizado do WPS e requer uma compra separada.","Text_WPS_Welcome_Modal_Meidou":"Primeiro login","Text_WPS_Welcome_Modal_Meidou_Description":"WPS Members get 50 free credits to try it out! No extra charges will apply to your account.","Text_WPS_Welcome_Modal_Vip":"Subscription Bonus","Text_WPS_Welcome_Modal_Vip_Description":"Adquira um plano de Design com IA e ganhe o WPS Super Membership pelo mesmo período, por tempo limitado.","Text_WPS_Welcome_Modal_Title":"Create with Designkit","Text_WPS_Welcome_Modal_Agreement":"By continuing, you have read and agree to the terms above.","Button_Generate_ImageListingSet":"Listing Images & Copy","Tip_GenerateListing":"Generate platform-ready visuals and copy for your selected marketplace.","Text_SelectedCount":"${0} selecionado(s)","RoboNeo_Web_input_default_content":"Chat com o RoboNeo","RoboNeo_Web_chatbox_maximum":"Limite de chat atingido","RoboNeo_Web_chatbox_maximum_text":"Limite de chat atingido. Crie uma nova tarefa.","RoboNeo_Web_chatbox_new_task":"Novo projeto","RoboNeo_Web_history_share_text":"Compartilhar","RoboNeo_Web_history_delete_text":"Excluir","RoboNeo_Web_history_delete_hint_text":"Atenção","RoboNeo_Web_history_delete_main_text":"O projeto será excluído permanentemente. Deseja continuar?","RoboNeo_Web_history_delete_hint_confirm":"Excluir","RoboNeo_Web_history_delete_hint_cancel":"Cancelar","RoboNeo_Web_studio_download":"Baixar","RoboNeo_Web_toast_share_text":"Compartilhar este chat","RoboNeo_Web_toast_share_main_text":"Qualquer pessoa com o link do chat pode visualizar seu histórico de conversas.","RoboNeo_Web_toast_share_copy":"Copiar link","RoboNeo_Web_toast_cancel":"Cancelar","RoboNeo_Web_toast_confirm":"Confirmar","RoboNeo_Web_studio_changing_toast":"Não há mais usos gratuitos disponíveis hoje. Serão reiniciados à meia-noite. Você também pode alimentar Neo com “Cyber Carrots” para continuar.","RoboNeo_Web_studio_changing_toast2":"Não há mais usos gratuitos disponíveis para hoje.","RoboNeo_Web_new_studio":"Novo chat","RoboNeo_Web_sidebar_close":"Recolher","RoboNeo_Web_history_text":"Histórico","RoboNeo_Web_sidebar_open":"Expandir","RoboNeo_Web_upload_warning_text":"Não é possível carregar fotos e vídeos ao mesmo tempo.","RoboNeo_Web_upload_format_text":"Formatos de imagem suportados: JPG, PNG e JPEG. \\nFormatos de vídeo suportados: MP4 e MOV.","RoboNeo_Web_upload_fail_text":"O envio falhou","RoboNeo_Web_upload_image_maximum":"Você pode carregar até {max_num} imagens","RoboNeo_Web_upload_video_size_maximum":"Vídeos maiores que {max_size} MB não são suportados.","RoboNeo_Web_upload_image_size_maximum":"Imagens acima de {max_size} MB não são suportadas.","RoboNeo_Web_upload_video_maximum":"Você pode enviar até {max_num} vídeos.","RoboNeo_Web_history_dafult_text":"Não foi encontrado nenhum histórico, converse agora.","RoboNeo_Web_upload_content_warning_text":"Arquivos com conteúdo potencialmente inadequado não serão importados.","RoboNeo_Web_chat_send_fail":"Falha no envio, tente novamente mais tarde.","RoboNeo_Web_network_fail":"Falha na conexão ou tempo limite esgotado. Por favor, ente novamente.","RoboNeo_Web_studio_layer_fail":"Falha ao dividir camadas.","RoboNeo_Web_studio_layer_success":"Concluído","RoboNeo_Web_network_error":"Erro de rede","RoboNeo_Web_delete_success":"Excluído","RoboNeo_Web_delete_fail":"Falha ao excluir","RoboNeo_Web_copy_success":"Copiado","RoboNeo_Web_file_uploading":"Carregando {num} arquivos","RoboNeo_Web_file_upload_fail":"Erro ao carregar {num} arquivos","RoboNeo_Web_file_upload_single_fail":"Erro ao carregar 1 arquivo","RoboNeo_Web_file_uploading_single":"Carregando 1 arquivo","RoboNeo_Web_upload_video_maximum_one":"Você pode carregar até 1 vídeo","RoboNeo_Web_sharepage_wanna_try":"Experimente Já","RoboNeo_Web_sharepage_load_to_end":"Ir para os resultados","RoboNeo_Web_studio_loading_text":"Carregando telas...","RoboNeo_Web_chatbox_add_image":"Adicionar imagens","RoboNeo_Web_chatbox_add_video":"Adicionar vídeo","RoboNeo_Web_image_editor_max":"Máximo de 10 MB com 4096 px no lado mais longo","RoboNeo_Web_unlimited_pass_expired":"O Passe Ilimitado expirou. Usar agora os usos gratuitos disponíveis.","RoboNeo_Web_studio_ai_image_successful":"AI UHD - concluído","RoboNeo_Web_studio_ai_image_failed":"AI UHD - falhou","RoboNeo_Web_studio_cutout_successful":"Recorte realizado com sucesso","RoboNeo_Web_studio_cutout_failed":"Falha no recorte","RoboNeo_Web_studio_ai_edit_failed":"Edição com IA - falhou","RoboNeo_Web_studio_ai_edit_successful":"Edição com IA - concluída","RoboNeo_Web_AI_generated":"Conteúdo gerado por IA","RoboNeo_Web_loading":"Carregando","RoboNeo_Web_view_creative_process":"Ver processo criativo","RoboNeo_Web_try_now":"Experimente Já","RoboNeo_web_extender_successful":"Extensão com IA - concluído","RoboNeo_web_extender_failed":"Extensão com IA - falhou","RoboNeo_web_eliminate_successful":"Remover com IA - concluído","RoboNeo_web_eliminate_failed":"Remover com IA - falhou","roboneo_web_continue":"Continuar","roboneo_web_video":"Vídeo","roboneo_web_HTML":"HTML","roboneo_web_shared_error_message":"Este chat não pode ser compartilhado. Tente iniciar um novo.","roboneo_web_open_the_APP_experience":"Experimente no aplicativo","roboneo_web_AI_generated_logo":"Este conteúdo gerado por IA é apenas para referência.","roboneo_web_change_word_success":"Substituir texto - concluído","roboneo_web_change_word_fail":"Substituir texto - falhou","roboneo_web_canvas_loading_failed":"Falha ao carregar a tela","roboneo_web_export_failed":"A exportação falhou","roboneo_web_export_tips2":"Suporta apenas a exportação de uma imagem (até {width}px*{height}px).","roboneo_web_new_topic":"Novo chat","roboneo_web_waiting_reply":"Aguardando resposta","roboneo_web_file_saving_preferences":"Preferências do arquivo","roboneo_web_includes_AI_watermark":"Incluir marcas d\'água de IA","roboneo_web_no_remind":"Não mostrar novamente","roboneo_web_agree_continue":"Aceitar e continuar","roboneo_web_watermark_protocol":"Você pode optar por salvar as imagens com ou sem marcas d\'água “Resultado da IA”. Ao optar por salvar sem a marca d\'água, você concorda em: 1. Não usar o RoboNeoAI para criar, publicar ou divulgar informações falsas. 2. Garantir a conformidade com a lei e indicar claramente que tal conteúdo foi gerado por IA ao usá-lo ou compartilhá-lo.","roboneo_web_rectangle":"Quadrado","roboneo_web_circle":"Redondos","roboneo_web_arrow":"Seta","roboneo_web_image_fusion_success":"Concluído","roboneo_web_image_fusion_failure":"Falhou","roboneo_chat_resources_num_limit_tips":"Pode adicionar até {img_num} vídeo e {video_num} imagens.","RoboNeo_Web_export_confirm_tip_popup_title":"You can choose whether to export with an \\"AI-generated\\" watermark.","RoboNeo_Web_export_confirm_tip_popup_btn":"Got it.","Tip_UploadImagesFormat_Batch":"Arraste ou clique para enviar imagens JPEG/JPG/PNG de até ${0} MB. Até ${1} imagens são compatíveis.","Text_SelectedModulesCount_Batch":"${0} itens selecionados","Tip_DefaultFollowGlobal_Batch":"Se não for alterado, seguirá as configurações globais por padrão.","Label_ModuleSelection_Batch":"Seleção de módulo","Label_SelectRequiredModules_Batch":"Escolha os módulos necessários","Title_Dialog_Invite2":"Convide amigos e ganhe dias Pro e créditos","Desc_Dialog_Invite2":"Compartilhe o link com amigos ou publique nas redes sociais. Quando um amigo se cadastrar pelo seu link, vocês dois recebem <strong>${0} dias de Pro + ${1} créditos</strong>; se seu amigo assinar <strong>em até ${2} dias</strong>, vocês dois ganham até <strong>${3}</strong> créditos adicionais.","SubTitle_Rewards1_Invite2":"Dias Pro ganhos","SubTitle_Rewards2_Invite2":"Créditos obtidos","SubTitle_Rewards3_Invite2":"Amigos convidados","Text_Rule1_Invite2":"Quando um amigo se cadastrar pelo seu link, vocês dois ganham <strong>${0} dias de Pro + ${1} créditos</strong>.","Text_Rule2_Invite_zawa":"Se seu amigo <strong>assinar em até ${0} dias</strong>, vocês dois receberão créditos extras (<strong>Plus +${1}, Pro +${2}, Max +${3}</strong>). Cada amigo pode ganhar este bônus uma vez, com base no primeiro plano ativo dele.","Text_Rule3_Invite2":"Os dias Pro recebidos de presente são adicionados ao seu período de assinatura: se você já tiver uma assinatura ativa, sua data de expiração será estendida, e você sempre receberá os benefícios de nível mais alto disponíveis no momento.","Text_Rule4_Invite2":"Os créditos são adicionados ao seu saldo, <strong>válidos por 30 dias</strong>, e podem ser usados para geração rápida com todos os modelos do Agente com IA.","Text_Rule5_Invite2":"As assinaturas não são reembolsáveis depois que os benefícios do plano forem usados ou os créditos bônus forem consumidos; recompensas gratuitas não podem ser revertidas depois de usadas.","Text_Rule6_Invite2":"As recompensas não serão emitidas para contas existentes, convites para si mesmo, contas duplicadas ou atividades fraudulentas; ${0} reserva-se o direito de ajustar a promoção e recuperar recompensas de contas com atividade irregular.","Title1_Invited_Invite2":"Um amigo convidou você para participar do ${0}. Ganhe ${1} dias de Pro + ${2} créditos","Text_DaysBadge_Invite":"${0} dia(s)","Title_Reward_Registered":"Teste o Pro grátis por ${0} dias","Title_Reward_Invite":"Ganhe ${0} dias de Pro grátis e mais ${1} créditos","Desc_Reward_Invite":"Ganhe ${0} dias grátis de Pro e ferramentas de IA ilimitadas","Button_StartCreate_Invite":"Começar a editar","Text_InviteMore_Invite":"Convide amigos para ganhar mais dias Pro e créditos","Title_WelcomeOnboarding":"Bem-vindo ao Zawa!","Title_ContentIntentOnboarding":"Qual é seu principal objetivo ao criar conteúdo?","Text_ReferralCreditsOnboarding":"Você se cadastrou por uma indicação, então adicionaremos automaticamente <>${0} créditos</> à sua conta.","Option_ProductVideoOnboarding":"Vídeos para meu produto","Option_SocialPostOnboarding":"Publicações em redes sociais","Option_LogoBrandOnboarding":"Crie logotipos e marcas","Button_MaybeLaterOnboarding":"Mais tarde","Title_FirstVideoOnboarding":"Crie seu primeiro vídeo gratuitamente","Desc_FirstVideoOnboarding":"Comece com uma foto de produto ou imagem de referência e gere um vídeo pronto para postar no Instagram.","Title_FirstSocialPostOnboarding":"Crie seu primeiro post para redes sociais gratuitamente","Desc_FirstSocialPostOnboarding":"Carregue uma foto ou descreva o que você precisa para receber um conjunto de publicações para redes sociais refinadas e prontas para publicar.","Title_FirstLogoBrandOnboarding":"Crie seu primeiro logotipo ou marca gratuitamente","Desc_FirstLogoBrandOnboarding":"Descreva sua marca e obtenha rapidamente um logotipo profissional e um conceito visual.","Text_TryFreeProOnboarding":"<>Experimente o Zawa Pro grátis por 3 dias</>, sem necessidade de cartão de crédito ou pagamento.","Text_FreeVideoOnboarding":"<>Ganhe 1 geração de vídeo grátis</>. Não é necessário cartão bancário nem pagamento.","Text_FreeImagesOnboarding":"<>Ganhe 4 gerações de imagem grátis</>, sem necessidade de cartão de crédito ou pagamento.","SubTitle_Invited_Invite_zawa":"Seu amigo convidou você para experimentar o Zawa, um Agente com IA dedicado ao design de marcas. Crie facilmente logotipos, identidade visual, pôsteres, cardápios, materiais para redes sociais e vídeos de marca. Cadastre-se agora — você e seu amigo ganharão uma assinatura Pro de ${0} dias e ${1} créditos. Se você assinar em até ${2} dias, também receberá créditos bônus: Plus +${3} créditos, Pro +${4} créditos, Max +${5} créditos.","SubTitle_Invited_Invite_dk":"Seu amigo convidou você para experimentar o Designkit, um agente de IA focado em design comercial. Crie facilmente imagens de produtos, páginas de detalhes, pôsteres promocionais, banners de e-commerce, materiais para redes sociais e vídeos de produtos. Cadastre-se agora para ganhar ${0} dias de assinatura Pro e ${1} créditos para você e seu amigo. Assine em até ${2} dias para receber recompensas extras: ${3} créditos bônus no Basic e ${4} créditos bônus no Pro.","Text_Rule2_Invite_dk":"Quando um amigo <strong>assinar em até ${0} dias</strong>, vocês dois ganham créditos extras (<strong>Basic +${1}, Pro +${2}</strong>). Uma recompensa por amigo, com base no primeiro plano ativo.","Tool_AIVideoGenerator":"Geração de vídeo por IA","Tool_AIVideoAdMaker":"Criação de anúncios em vídeo por IA","Tool_AIVideoEditor":"Editor de Vídeo com IA","Title_AIWatermark":"Marca d\'água com IA","Title_FileSavePreference":"Preferências de salvamento de arquivos","Label_IncludeAIWatermark":"Inclui marca d\'água de IA","Button_ConfirmDownload":"Confirmar download","Button_AgreeAndContinue":"Concordar e começar a utilizar","Text_DontRemindAgain":"Não avisar novamente","Button_DownloadApp":"Baixe o app","Title_DownloadAppForMoreFeatures":"Baixe o aplicativo para acessar recursos mais avançados","Tip_Download7DaysFreeTrial":"Baixe para iniciar um teste grátis de 7 dias","Message_LoginExpiredRelogin":"Erro de login. Faça login novamente.","Title_BindPhone":"Vincular número de telefone","Tip_BindPhoneForCollaboration":"Vincule seu número de telefone para colaborar com outras pessoas em tempo real.","Tip_OnlyPSDSupported":"Apenas arquivos PSD são suportados","Button_OpenPSD":"Abrir PSD","Desc_AIDisclaimer":"Antes de usar este serviço, você deve entender que o conteúdo gerado por IA se baseia no aprendizado profundo da inteligência artificial a partir de grandes conjuntos de dados, e algumas informações podem conter falhas, ser inadequadas ou causar desconforto. Portanto, a Meitu não oferece garantias quanto à precisão, integridade ou funcionalidade do conteúdo gerado por algoritmos e não assume qualquer responsabilidade legal, inclusive por violação de direitos de terceiros. Além disso, como o serviço de design por IA gera conteúdo relacionado com base no texto que você insere, você é responsável por fazer escolhas razoáveis quanto às informações inseridas e ao conteúdo gerado. Você deve garantir que usará este serviço e as obras geradas por IA produzidas por ele de acordo com a lei, sem infringir direitos autorais, marcas registradas ou outros direitos legais de terceiros, e sem usar as obras geradas para qualquer finalidade ilegal. Se o uso indevido causar danos a direitos ou interesses de terceiros, você assumirá a responsabilidade legal correspondente nos termos da lei.","Text_Disclaimer":"Aviso Legal","Message_ConnectFailed":"Falha na conexão: ${0}","Placeholder_SelectFont":"Selecionar Fonte","Message_MaxImageUploadSize":"Suporta apenas imagens de até ${0} x ${1}","Title_StorageFull":"Seu armazenamento está cheio","Title_StorageFullPleaseClean":"O armazenamento está cheio. Libere espaço.","Desc_StorageFull":"O armazenamento de ${0} está cheio. Exclua alguns conteúdos ${1}, ou o histórico de edições anteriores pode ser perdido.","Desc_StorageFullAigc":"Seu armazenamento de ${0} está cheio. Este conteúdo gerado será <strong>armazenado temporariamente por 7 dias</strong>. Exclua algum conteúdo ${1} ou seu histórico de criação poderá desaparecer.","Text_Free":"Grátis","Text_OrUpgradeMember":"Ou faça upgrade da sua assinatura","Text_UnlockMoreStorage":"Desbloquear mais espaço de armazenamento","Text_FilesSavedForever":"Os arquivos podem ser salvos por tempo indeterminado.","Button_UpgradeMember":"Fazer upgrade","Button_CleanSpace":"Limpar","Title_FileExpiringSoon":"Seu arquivo está prestes a expirar","Desc_FileExpireAutoClean":"Os arquivos serão apagados automaticamente após expirarem. Gerencie suas criações com antecedência.","Button_OrganizeFiles":"Organizar arquivos","Title_RemainingDownloads":"Downloads restantes","Text_PriorityConsumeExpiring":"Usar primeiro os downloads que expiram","Text_PermanentValid":"Válido permanentemente","Text_Sheet":"imagem(s)","Text_ExpireInDays":"Expira em ${0} dias","Text_ConsumeTiming":"Downloads:","Tip_CutoutConsumeRule1":"Ao baixar imagens recortadas no editor de recorte, deduziremos a quantidade correspondente de downloads.","Tip_CutoutConsumeRule2":"2. Downloads repetidos de imagens que não foram reprocessadas ou recortadas não serão descontados da sua contagem de downloads.","Text_InviteSuccessReward":"Você foi convidado com sucesso. Entre no Meitu Posters para resgatar sua recompensa.","Desc_DesignKitIntro":"Meitu Designer, a ferramenta essencial de design com IA para vendedores de e-commerce. De conjuntos de imagens de produtos e de modelos à geração de vídeos compráveis, design de pôsteres e edição de fotos, ela ajuda os usuários a criar um conjunto completo de materiais de e-commerce em um só lugar usando IA.","Title_TeamMeidouShared":"Os créditos da equipe estão disponíveis para todos os membros","Desc_PersonalMeidouTransfer":"Para transferir créditos pessoais para uma equipe, entre em contato com o atendimento ao cliente.","Button_SwitchTeamRecharge":"Alternar equipes e recarregar","Button_CreateTeamRecharge":"Criar uma equipe e recarregar","Title_SubscribeSuccess":"Assinatura realizada com sucesso","Text_MeidouRechargedTo":"Créditos foram adicionados a","Button_GoToTeam":"Ir para a equipe","Text_OnePayMultiShare":"Recarregue uma vez, compartilhe entre várias contas","Text_InviteMembersShareMeidou":"Convidar membros para compartilhar créditos","Menu_SwitchPersonalTeam":"Mudar entre pessoal/equipe","Menu_TeamManagement":"Gerenciamento de equipe","Menu_InviteFriendsEarnCash":"Convidar amigos para ganhar dinheiro","Text_Personal":"Pessoal","Text_PersonalDesigner":"Designer individual","Text_EnterpriseSwitch":"Mudar para Enterprise","Button_Recharge":"Recarregar","Text_Detail":"Detalhes","Tip_DesignKitIndependentPlan":"O Meitu Design Studio tem seus próprios planos de assinatura e não compartilha benefícios com a assinatura do WPS.","Text_MeidouWpsOnly":"Créditos (Apenas WPS)","Text_SheetCount":"Quantidade de recortes","Desc_ExchangeConfirm":"Tem certeza de que deseja trocar ${0} créditos de recorte por ${1} dias de assinatura?","Message_LoadOrderFailed":"Não foi possível carregar os dados do pedido","Message_ExchangeSuccess":"Resgatado com sucesso","Message_ExchangeFailed":"Falha ao resgatar","Text_NoOrderRecords":"Nenhum registro de pedido encontrado","Text_OrderDate":"Data do pedido:","Text_VipExchangeRule1":"O Recorte é ilimitado durante sua assinatura e não consome créditos.","Text_VipExchangeRule2":"2. Os créditos pagos do Recorte podem ser resgatados por uma assinatura.","Text_VipExchangeLocation":"· Local de resgate: Toque na foto do perfil -> Número de fotos.","Text_VipExchangeNoExchange":"·Se optar por não resgatar, você poderá continuar usando sua assinatura. O período de validade permanecerá inalterado.","Text_VipExchangeGiftSheets":"·Os créditos bônus da sua assinatura não podem ser usados para resgatar uma assinatura e podem ser usados antes de expirarem.","Text_VipExchangeRule3":"3. A assinatura não inclui mais créditos gratuitos","Text_BackToPrevious":"Anterior","Title_WpsPay":"WPS Pay","Text_CloseModal":"Fechar","Text_FavoriteDesignKit":"Adicionar Meitu Design Studio aos favoritos","Button_Visit":"Acesso","Desc_VisitChinaSite_Cutout":"Deseja visitar o site chinês do Meitu Cutout? Clique em Visitar para acessar o site da China.","Desc_VisitChinaSite":"Gostaria de visitar o site da Meitu DesignRoom China? Clique em [Visitar] para continuar.","Desc_VisitingGlobalSite_Cutout":"Você está visitando o Designkit Cutout (site global do Meitu Cutout). Usuários na China, acessem o site da China.","Desc_VisitingGlobalSite":"Você está visitando o Designkit, o site global do Meitu Design Studio. Usuários na China, visitem o site da China.","Button_StayCurrent":"Ficar aqui","Button_BackToChinaSite":"Voltar ao site da China","Title_DownloadWork":"Baixar","Label_WorkType":"Tipo","Button_Downloading":"Baixando...","Tip_UploadImageForBetterResult":"Depois de enviar uma imagem, insira instruções de edição claras para obter melhores resultados.","Label_SceneElement":"Elementos da cena","Placeholder_SceneElementDesc":"Edite elementos ou objetos da imagem com um comando de texto. Por exemplo: Substitua o XX na imagem pelo XX que eu enviei.","Label_MainTitle":"Título principal","Label_SubTitle":"Legenda","Label_Copywriting":"Copywriting","Tip_ModifyBeforeGenerate":"Edite a imagem e o texto antes de gerar","Button_ReEdit":"Reeditar","Message_MaxUploadImages":"Você pode enviar até ${0} imagens","Text_CompletedPercent":"(${0}% concluído)","Text_PreviewImage":"Prévia","Text_EnterCanvasEdit":"Editar no Canvas","Title_GenerateSame":"Criar","Text_ConfirmLeaveGenerating":"Gerando. Tem certeza de que deseja sair?","Text_BuildingVisualScheme":"Criando design visual...","Text_OptimizingLayout":"Otimizando layout e hierarquia das informações...","Text_FineTuningFont":"Ajustando fonte e espaçamento...","Message_GenerateSuccessCost":"Gerado com sucesso! Foram gastos ${0} créditos","Title_ConfirmDelete":"Confirmar exclusão","Text_DeleteFontWarning":"Após a exclusão, nenhum membro da equipe poderá mais aplicar esta fonte.","Text_AppliedWillReplace":"O registro de criação/estilo de fonte aplicado será substituído automaticamente por","Text_DefaultReplaceFontName":"Alibaba-PuHuiTi-R","Text_Deleting":"Excluindo...","Message_DeleteSuccess":"Excluído com sucesso!","Text_NoMore":"Não há mais conteúdo...","Text_NoFonts":"Ainda não há fontes","Button_UploadFont":"Enviar fonte","Message_FontFormatInvalid":"O arquivo de fonte ${0} está em um formato inválido","Title_AuthConfirm":"Confirmação de autorização","Text_FontAuthConfirm":"Para fontes que você adicionar por conta própria, certifique-se de ter a autorização necessária do proprietário dos direitos autorais e/ou dos titulares de direitos relacionados.","Text_DuplicateFontsConfirm":"As fontes a seguir podem ser idênticas. Confirme.","Text_Uploaded":"Foto enviada","Button_ConfirmUpload":"Confirmar envio","Text_FontsCannotUpload":"Não foi possível carregar as seguintes fontes","Button_ReUpload":"Carregar novamente","Message_MaxFontUpload":"Você pode enviar até 20 arquivos de fonte por vez","Message_UploadSuccess":"Carregado","Text_FontUploading":"Carregando fontes...","Tip_FontUsageRight":"Lembrete: Certifique-se de que você tem o direito de usar a fonte e uma licença comercial.","Title_FriendlyTip":"Lembrete","Text_TemplateMigrated":"Os modelos da Biblioteca de Modelos foram movidos para Projetos. Acesse Projetos para ver os modelos da equipe.","Button_GoNow":"Entrar agora","Tab_FontLib":"Biblioteca de Fontes","Tip_SwitchIdentityHint":"Toque na sua foto de perfil no canto superior direito para alternar entre os perfis Pessoal e Equipe.","Text_IdentityResourcesIndependent":"Os recursos de design (como Registros de edição) são mantidos separados para cada identidade","Text_IdentitySwitched":"Conta trocada","Text_DefaultTeamName":"Equipe de ${0}","Message_FillTeamInfo":"Preencha todas as informações da equipe","Message_TeamNameMaxLength":"Insira o nome da equipe ou da empresa (até 20 caracteres)","Title_CreateTeam":"Criar equipe","Label_TeamName":"Nome da equipe","Placeholder_TeamName":"Digite um nome de equipe","Button_FreeCreate":"Crie de graça","Tip_TeamNameEditable":"O nome da equipe pode ser alterado a qualquer momento","Text_EnjoySvipRights":"Aproveite os benefícios SVIP","Text_TeamPermissionMgmt":"Gerenciamento de permissões da equipe","Text_MemberFolderCollab":"Colaboração em pasta de membros","Text_TeamExpired":"Esta equipe expirou.","Text_RenewToUse":"Renove ou atualize para continuar usando.","Text_VipTeamRights":"Benefícios da equipe VIP","Text_ViewDetailRights":"Visualizar detalhes dos benefícios","Button_SwitchPersonal":"Mudar para Pessoal","Text_Frozen":"Sua conta foi congelada.","Text_MemberOverLimit":"Limite de membros excedido","Text_ContactOwner":"Entre em contato com o proprietário da equipe para continuar usando isto.","Text_TeamNoSupport":"Este recurso ainda não está disponível para contas de equipe/empresariais.","Text_SwitchToPersonalHint":"Alterne para Pessoal se necessário","Button_SwitchToPersonal":"Mudar para Pessoal","Text_FeatureNotAvailable":"Este recurso não está disponível no momento.","Text_ReloginPersonal":"Faça login novamente com uma conta pessoal para usar este recurso.","Button_BackHome":"Início","Text_PersonalEdition":"Pessoal","Text_TeamEdition":"Equipe","Text_EnterpriseEdition":"Plano empresarial","Text_FreeEdition":"Grátis","Text_RemovedFromTeam":"Você foi removido da equipe","Text_RejoinTeamHint":"Para voltar à equipe","Text_ContactOwnerToInvite":"Entre em contato com o proprietário/administrador para enviar um convite","Button_SwitchOtherIdentity":"Trocar para outra conta","Button_FreeCreateTeam":"Crie uma equipe grátis","Text_SelectIdentity":"Selecionar função da conta","Text_SelectTeamIdentity":"Selecione uma função da equipe","Text_EditingSaveLocation":"Se houver uma edição em andamento, seus registros de edição/geração serão salvos no espaço de ${0}.","Text_CreateNewTeamFree":"Crie uma nova equipe gratuitamente","Text_MemberCount":"${0} clientes","Text_SavedToHelloDigitalAsset":"Salvo em HelloRF Digital Assets","Text_Admin":"Administrador","Text_Member":"Membro","Title_FreeMemberLimit":"O plano gratuito oferece suporte a até ${0} membros","Title_SeatInsufficient":"Vagas de assinatura insuficientes","Button_UpgradeTeam":"Fazer upgrade para Equipe","Button_AddSeat":"Adicionar vagas","Text_UpgradeForMoreSeats":"Faça upgrade para a Assinatura de Equipe para aumentar o limite de vagas","Text_AddSeatToInvite":"Adicione mais licenças para convidar mais membros.","Title_InviteMember":"Convidar","Text_InviteSeatRemaining_Free":"Você pode convidar mais ${0} membros para participar da equipe gratuitamente","Text_InviteSeatRemaining":"Você pode convidar mais ${0} membros para participar da equipe","Text_ShareDesignAssets":"Compartilhe trabalhos de design e elementos em conjunto","Text_ShareVipAndCredits":"Compartilhe sua assinatura e seus créditos de geração de IA","Text_InvitedUserPermission":"Permissões do usuário convidado:","Text_NoInvitePermission":"Somente proprietários ou administradores da equipe podem convidar outras pessoas. Você ainda não tem permissão para convidar pessoas para a equipe.","Text_RemainingCount":"Restante: <span>${0}</span>","Button_RedeemMemberDays":"Resgatar adesão de <span>${0}</span> dias","Desc_InviteReward_DesignKit":"Assine o Meitu DesignKit agora e receba um total de <strong>80 créditos</strong> para geração e edição de imagens. Você também ganha um desconto na assinatura, com <strong>até ¥22 de desconto.</strong>","Text_ClickTopRight":"Clique no <span class=\\"primary\\">canto superior direito</span> do site","Option_SetEditable":"Definir como editável","Option_SetViewable":"Definir como visível","Option_Reject":"Rejeitar","Message_BindSuccessPermissionAdjusted":"Vinculado com sucesso. Permissões atualizadas","Message_ModifyFailedBindPhone":"Falha na atualização. Vincule um número de telefone e tente novamente.","Text_AskersApplyAccess":"Acesso solicitado por ${0} e mais ${1} pessoas","Text_PersonalUser":"Usuários pessoais","Text_ApplyAccess":"Solicitar acesso","Option_Viewable":"Visualizar","Option_Editable":"Editar","Option_Manageable":"Gerenciável","Text_Invited":"Convidado","Text_NoSearchResult":"Sem resultados","Title_AddCollaborator":"Adicionar colaborador","Placeholder_AddCollaboratorByName":"Insira o nome de um membro para adicionar colaboradores","Title_Recommend":"Recomendado","Text_PeopleCount":"${0} Clientes","Message_BindSuccessCollaboratorAdded":"Vinculado com sucesso. Colaborador adicionado","Message_AddFailedChangePermissionOrBindPhone":"Falha ao adicionar. Altere a permissão para \\"Pode visualizar\\" ou vincule seu número de telefone e tente novamente.","Message_SelectAtLeastOneCollaborator":"Selecione pelo menos um colaborador!","Message_ShareSuccess":"Compartilhado com sucesso!","Tip_AddCollaboratorDirectAccess":"Depois de adicionados, eles poderão acessá-lo diretamente em \\"Compartilhados comigo\\", sem precisar de um link.","Text_TotalPeople":"${0} Pessoas","Option_Remove":"Remover","Tip_PermissionChangedToEdit":"A permissão efetiva deste colaborador foi alterada para Editar","Tip_AnyoneWithLinkCanEdit":"Porque qualquer pessoa com o link pode editar","Tip_TeamMemberWithLinkCanEdit":"Porque os membros da equipe com o link podem editar.","Title_CollaboratorManage":"Gerenciamento de colaboradores","Tag_OutsideTeam":"Fora da equipe","Title_RemoveKeepTeamMembers":"Após a remoção, somente os colaboradores que atualmente fazem parte da equipe poderão continuar acessando.","Title_RemoveOnlySelfAccess":"Após a remoção, só você poderá acessá-lo.","Option_OnlyCollaborators":"Apenas colaboradores","Option_OnlySelf":"Só eu","Text_OthersNeedApply":"(Outras pessoas precisam solicitar acesso)","Option_PermissionUnchanged":"Permissões inalteradas","Option_TeamMembers":"Membros da equipe","Text_TeamMembersViaLink":"Membros da equipe via link","Option_Anyone":"Qualquer pessoa","Text_AnyoneViaLink":"Qualquer pessoa com o link","Text_UntitledDesign":"Design sem nome","Message_BindSuccessLinkCopied":"Vinculado com sucesso. Link de compartilhamento copiado","Message_ShareFailedChangePermissionOrBindPhone":"Falha ao compartilhar. Altere a permissão para \\"Pode visualizar\\" ou vincule um número de telefone para compartilhar.","Text_LinkUpdating":"Atualizando o link...","Tip_FolderShareTeamOnly":"As pastas só podem ser compartilhadas com membros da equipe.","Text_CollaboratorCount":"Colaboradores: ${0}","Button_Manage":"Gerenciar","Tooltip_PartialPermissionChanged":"As permissões de alguns colaboradores foram alteradas","Tip_FolderLinkVisitorBecomeMember":"Usuários que acessarem a pasta pelo link se tornarão automaticamente membros da sua equipe.","Tip_OnlyTeamMembersCanAccess":"No momento, apenas membros da equipe podem acessar isto","Tip_InviteUserNotInTeam":"Se o usuário com quem você quer compartilhar ainda não entrou na equipe, por favor","Button_InviteMember":"Convidar","Text_ShareLinkView":"${0}#Compartilhei ${1}. Toque para ver","Text_ShareLinkJoin":"${0} convidou você para entrar em ${1}. Toque para entrar.","Text_ShareLinkApplyVisit":"${0}#Solicito acesso a ${1}. Toque para processar a solicitação.","Text_ShareLinkApplyEdit":"${0}#Solicitei a edição de [${1}]. Toque para processar a solicitação.","Option_7Days":"7 dias","Option_30Days":"30 dias","Option_Permanent":"Permanente","Text_Slogan_DesignKit":"Ferramenta indispensável para profissionais de e-commerce","Button_RemoveNonTeamCollaborator":"Remover colaboradores externos","Button_RemoveNonPersonalCollaborator":"Remover colaboradores não individuais","Text_freePlan_Zawa":"Free","Text_standardPlan_Zawa":"Plus","Text_proPlan_Zawa":"PRO","Text_maxPlan_Zawa":"Máx.","Tool_IDPhoto":"Foto de identificação","Tool_PortraitPhoto":"Fotos de perfil","Tool_ImageBatchProcess":"Processamento de imagens em lote","Tool_AiShoes":"Modelo de Calçados","Tool_AiCopywriting":"Redação com IA","Tool_AiPoster":"Pôster com IA","Tool_OnlineDesign":"Design online","Tool_ClothesDewrinkle":"Remover rugas das roupas","Tool_PortraitBackground":"Fundo","Tool_ViralVideo":"Gerador de vídeos de produtos","Tool_AiPosterNote":"Notas de imagem e texto com IA","Title_WholeProductClone_DomesticCloneCase":"Reutilizar todo o conjunto de produtos","Title_ApparelClone_DomesticCloneCase":"Reutilize roupas com facilidade","Title_PosterCoverClone_DomesticCloneCase":"Reutilizar capa do pôster","Prompt_PosterThemeChange_DomesticCloneCase":"Instruções de recriação: Alterar para um pôster com tema de cidade","Title_SocialGraphicsClone_DomesticCloneCase":"Reutilização de posts para redes sociais com um toque","Prompt_SocialThemeChange_DomesticCloneCase":"Instruções de recriação: Alterar para um post de imagem e texto com tema de viagem para Xiamen","Title_CloneType_LeftPanelClone":"Tipo de reutilização","Text_CloneReferenceUploadLimitTip_Clone":"Adicione até ${0} imagens — cada referência gera 1 resultado.","Option_MatchStyle_Clone":"Combinar estilo","Option_MatchReference_Clone":"Corresponder à referência","Message_ClaimFailed":"Este benefício não pode ser resgatado agora. Tente novamente mais tarde.","Message_RedeemFailed":"Falha no resgate. Tente novamente mais tarde.","Button_UpgradeTeamVip":"Fazer upgrade para a assinatura de equipe","Message_SystemError":"Algo deu errado. Tente novamente mais tarde.","Label_AgentTeam":"Equipes","Desc_AgentTeamBanner":"Entre no modo Equipes de agentes de IA, em que especialistas se unem automaticamente para cuidar do planejamento completo e do design visual com um único prompt.","Text_SearchResultCount":"Resultados da pesquisa · ${0} resultados","Button_ExitAdmin":"Sair do gerenciamento","Text_InviteReward":"Benefícios do convite","Button_More":"Mais","Text_TeamExpiredTip":"Esta equipe expirou. Você só pode visualizar e mover itens dentro da equipe. Renove ou faça upgrade para continuar usando todos os recursos.","Text_TeamFrozenTip":"Esta equipe excedeu o limite de membros. Sua conta foi congelada. Entre em contato com o proprietário da equipe para continuar usando.","Desc_ImageEdit":"Importe uma imagem e comece a editar","Desc_ViralVideo":"Gere vários tipos de vídeos virais em massa com um clique","Desc_ProductImageSet":"Gere um conjunto completo de imagens de produtos para e-commerce com um clique","Title_RecommendTools":"Ferramentas recomendadas","Button_CloseVideoPreview":"Desativar prévia do vídeo","Label_PromptDesc":"Descrição do prompt","Tab_Preview":"Efeito","Tab_Report":"Relatório de análise","Button_Preview":"Prévia","Button_PrevPage":"Anterior","Button_NextPage":"Próximo","Text_LoadingHard":"Carregando...","Button_ReplicateOne":"Recriação por IA","Text_EmptyContent":"Nenhum item encontrado","Text_Today":"Hoje","Text_Tomorrow":"Amanhã","Text_Yesterday":"Ontem","Text_DaysLater":"${0} dia(s) depois","Text_DaysAgo":"${0} dias atrás","Desc_CreateDesign":"Começar com um Canvas em branco","Title_ClaimSuccess":"Reivindicado","Text_VipExpiry":"Validade VIP:","Title_ClaimFailed":"Falha ao reivindicar","Button_GoDesign":"Criar agora","Title_ClientDownload":"Baixar Cliente","Desc_DesignKitApp":"Sincronize o histórico de criações entre o celular e o computador para criar com eficiência a qualquer hora, em qualquer lugar","Title_MeituXiuxiuPC":"Meitu PC","Desc_MeituXiuxiuPC1":"Um editor de fotos para o dia a dia e o trabalho","Desc_MeituXiuxiuPC2":"E ferramentas de design fáceis de usar!","Button_DownloadNow":"Baixe agora","Text_Pending":"Aguardando pagamento","Text_MoreFunctions":"Múltiplos formatos","Text_NoMessages":"Nenhuma mensagem encontrada","Tab_SystemMessage":"Mensagens do sistema","Tab_Notification":"Notificação","Button_MarkAllRead":"Marcar tudo como lido","Label_Folder":"Pasta","Label_Record":"Registros de edição","Label_Template":"Modelos","Text_RequestAccess":"Solicitar acesso","Text_EditViewDownload":"(Editar, Visualizar, Baixar)","Text_ViewDownloadOnly":"(Somente visualização e download)","Text_TeamRenewSuccess":"Sua assinatura de equipe foi renovada com sucesso.","Text_TeamRenewExpiredTip":"Renove agora para desbloquear acesso ilimitado a modelos comerciais empresariais, elementos e recursos exclusivos para toda a equipe.","Label_SystemNotice":"Notificação do sistema","Label_PromptTutorial":"Tutorial de prompts","Label_BrandSpec":"Diretrizes da marca","Label_ContactBusiness":"Entre em contato com a equipe de vendas","Text_ScanConsultant":"Escaneie para falar com um consultor dedicado para equipes","Tab_Project":"Projeto","Placeholder_SearchProject":"Insira um nome de projeto ou palavras-chave","Placeholder_SearchRecipe":"Insira o nome do template ou modelo","Placeholder_SearchTemplate":"Insira palavras-chave do modelo ou o nome do recurso","Title_HotTools":"Ferramentas em alta","Title_HotTemplates":"Modelos em tendência","Title_PosterTemplate":"Modelos de design gráfico","Text_NotFoundTemplate":"Não encontrou um modelo que você goste? Clique aqui","Button_Feedback":"Feedback","Button_ViewAllTemplates":"Visualizar todos os modelos","Tooltip_OpenNewTab":"Abrir em nova guia","Button_BookDemo":"Agendar uma demonstração","Title_ApplyTeamDemo":"Solicite uma demonstração para equipes","Desc_ContactWithinOneDay":"Após enviar suas informações, entraremos em contato em até 1 dia útil.","Title_LeaveContactInfo":"Deixe suas informações de contato para que possamos oferecer um suporte 1v1 melhor.","Title_FreeTeamVipSurvey":"Preencha os dados da sua equipe para ganhar uma Assinatura de Equipe grátis por 7 dias","Label_SingleUser":"Uso individual","Text_MemberCountRange":"${0}~${1} Clientes","Text_MemberCountRangeDash":"${0}-${1} Pessoas","Text_MemberCountOrMore":"${0}+ pessoas","Label_TemplateReuse":"Carregue e reutilize modelos","Label_MultiCollaboration":"Edição colaborativa","Label_EnterpriseLicense":"Licenciamento comercial empresarial","Label_SharedCredits":"Créditos e recortes compartilhados pela equipe","Label_BrandManagement":"Gerenciamento de especificações da marca","Label_YourName":"Seu Nome","Message_PleaseEnterName":"Insira seu nome","Label_YourPhone":"Seu número de celular","Message_PleaseEnterPhone":"Insira seu número de celular ou telefone fixo","Message_PleaseEnterValidPhone":"Insira um número de celular válido","Label_CompanyName":"Nome da empresa","Message_PleaseEnterCompanyName":"Insira o nome de sua empresa","Placeholder_EnterCompanyName":"Insira o nome de sua empresa","Label_ProductUsers":"Número de pessoas usando o produto","Message_PleaseSelectProductUsers":"Selecione o número de pessoas que usarão o produto","Label_TeamCapabilitiesInterest":"Sobre quais recursos do Pôsteres para equipes você mais gostaria de saber?","Text_MultiSelectParen":"(Múltipla escolha)","Message_PleaseSelectCapabilities":"Selecione os recursos do Meitu Design Studio sobre os quais você quer saber mais","Placeholder_TeamCapabilities":"Proteção de direitos autorais comerciais, Benefícios compartilhados para vários usuários, Gerenciamento de ativos digitais, Colaboração em equipe, Outros","Button_Submit":"Enviar","Desc_ManagerWillContact":"Seu gerente de conta dedicado entrará em contato com você em até 1–2 dias úteis. Certifique-se de estar acessível por telefone.","Title_ScanToInvoice":"Escaneie o código QR com o navegador do seu celular para obter uma fatura","Text_InvoiceOrderScope":"Use este link para solicitar uma fatura dos pedidos do Meitu Design Studio.","Text_TransferInvoiceContact":"Para pedidos de transferência bancária corporativa, clique em Contato no canto inferior direito para solicitar a emissão.","Desc_MenuProjectGuide1":"[Meu Espaço] e [Compartilhados comigo]","Desc_MenuProjectGuide2":"Tudo agora está organizado em Projetos","Text_SetPrefix":"Definir como","Text_TodayWithTime":"Hoje ${0}","Text_YesterdayWithTime":"Ontem ${0}","Format_MonthDay":"D M","Format_YearMonthDay":"M/D/AAAA","Text_MultiPage":"Várias páginas","Text_PageCount":"${0} páginas","Text_ViewOnly":"Somente visualização","Text_NoPermission":"Sem acesso","Button_JumpToStorage":"Saltar para o local de armazenamento","Label_PageUnit":"Página","Label_JumpTo":"Experimente agora","Text_TotalDataCount":"${0} itens","Title_RelateRecommend":"Recomendado","Title_HotSearch":"Pesquisas populares","Title_LatestMaterial":"Elementos mais recentes","Title_TopicList":"Tópicos populares","Title_ArticleList":"Artigos populares","Title_ToolList":"Ferramentas Populares","Text_AccountOnePerson":"Conta: 1 pessoa","Text_AccountTenMin":"Contas: Mínimo de 10 usuários","Text_LetsTalk":"Vamos conversar","Text_NewUserExperience":"Nova experiência do usuário","Text_Buy12Months":"Comprar 12 meses","Text_LinkExpired":"Este link não está disponível","Text_ContactAdminToJoin":"Contate o administrador para participar","Desc_JoinOrgCollaboration":"Faça parte da organização e comece a colaborar de forma eficiente com sua equipe","Button_AcceptInvite":"Aceitar convite","Title_ConfirmNickname":"Confirme seu apelido na equipe","Placeholder_NameWithin20":"Insira um nome com até 20 caracteres","Desc_NicknameHelp":"Seu apelido ajuda seus colegas a encontrar você com mais facilidade.","Title_TeamVipExpired":"A assinatura da equipe expirou","Title_TeamSeatsInsufficient":"Não há vagas de associação à equipe suficientes","Button_SeatAssignment":"Atribuição de vaga","Text_MemberSeatCount":"Membros/Vagas:","Text_FreeSeatsFrozen":"Membros além do limite de vagas gratuitas foram congelados","Desc_RenewTeamForAll":"Para manter o acesso de todos os membros, renove sua assinatura da equipe.","Text_SeatsExceededFrozen":"Membros acima do limite de vagas foram congelados.","Desc_AddSeatsForAll":"Para habilitar o acesso de todos, compre licenças adicionais da Assinatura de Equipe.","Title_TeamToolUnsupported":"Esta ferramenta não é suportada na Posters Team Edition.","Desc_SwitchPersonalToUse":"Para usar esta ferramenta, mude para a versão Pessoal.","Label_RegularTemplate":"Modelos padrão","Label_Suite":"Definir","Label_Filter":"Filtro","Label_Sort":"Ordem","Label_Scene":"Cenário","Label_Materials":"Materiais","Label_Purpose":"Usar","Label_Industry":"Indústria","Label_Color":"Cor","Label_Format":"Layout","Label_Category":"Categoria","DesignKit":"美图设计室","Placeholder_SearchTemplateMobile":"Pesquisar modelos","Label_DesignType":"Tipo de design","Label_TemplatePurpose":"Finalidade do modelo","Label_TemplateStyle":"Estilo do modelo","Label_TemplateColor":"Cores do modelo","Label_ApplicableIndustry":"Indústrias aplicáveis","Label_TemplateSize":"Tamanho do modelo","Label_UsageThreshold":"Iniciantes podem usar","Label_TemplateNumber":"Número do modelo","Desc_ScrollViewAllPages":"Role para cima ou para baixo para ver todas as páginas","Title_SimilarPosterRecommend":"Recomendações de pôsteres semelhantes","Button_EditCurrentTemplate":"Editar modelo atual","Button_EditAllTemplates":"Editar todos os modelos","Button_EditNow":"Edite agora","Title_RecordUpgrade":"Novas atualizações disponíveis!","Desc_RecordUpgrade1":"Inclui todos os modelos de pôsteres e o histórico de edição de fotos desta conta. Alterne facilmente da edição de fotos para a criação de pôsteres.","Desc_RecordUpgrade2":"Alterne facilmente da edição de imagens para a criação de pôsteres.","Footer_AboutUs":"Sobre nós","Footer_JoinUs":"Junte-se a nós","Footer_ContributeCenter":"Centro do Contribuidor","Title_HomeAgentTeam":"Equipes de agentes de IA - Design para negócios que impressiona e gera resultados","Title_HomeChat":"Diga o que você gostaria de criar.","Nav_Home":"Página inicial","Title_BrandManagement":"Gestão de Marcas","Nav_HelpDesign":"Design para mim","Title_OrgInfo":"Informações da organização","Title_MemberManage":"Gerenciamento de membros","Title_DataDashboard":"Painel de dados","Title_CommercialAuth":"Uso comercial sem preocupações","Title_OrderInvoice":"Fatura do pedido","Title_TeamCollaboration":"Colaboração em equipe","Title_CopyrightGallery":"Galeria de fotos com direitos autorais","Title_DownloadCenter":"Central de Downloads","Nav_TodayRecommend":"Recomendado hoje","Nav_HotCalendar":"Festivais","Nav_InspirationFormula":"Modelos de inspiração","Nav_OneClickSame":"Derivados","Title_PosterTemplateNav":"Modelos de pôster","Message_NetworkError":"Erro de rede. Não é possível conectar-se ao servidor.","Text_Downloading":"Baixando recursos","Text_DownloadResourceFailed":"Falha ao baixar recursos","Title_DesignKitScanLogin":"美图设计室 Escaneie para fazer login","Desc_ScanGuideLogin":"Vá para \\"Eu\\" e toque em \\"Escanear\\" no canto superior direito para fazer login","Message_AlreadyFullVip":"Você já tem todos os benefícios de associação. Não é necessário comprar.","Message_ImageSizeExceeded":"O limite de tamanho da imagem foi excedido","Text_NotLoggedIn":"Não fez login","Button_CreateBrandSpec":"Criar especificações","Title_BrandAdvQuestion":"Ainda pede aos colegas o logo, as fontes e os valores das cores da marca?","Desc_BrandAdv1":"Logo predefinido do designer, Valores de cores da marca, Estilo de texto, Biblioteca de fontes","Desc_BrandAdv2":"Configure diretrizes visuais para diferentes marcas ou projetos.","Desc_BrandAdv3":"Membros da equipe de diferentes departamentos podem adicionar e aplicar especificações rapidamente no editor","Button_UpgradeTeamForBrand":"Faça upgrade para a Assinatura de Equipe e use as diretrizes da marca agora","Title_ConfirmDeleteBrandGroup":"Excluir este conjunto de padrões?","Text_DeleteBrandNoAffect":"Os registros de edição aplicados não serão afetados.","Button_CreateBrandStandard":"Criar especificações da marca","Title_DeleteHint":"Excluir imagem","Text_DeleteIrreversible":"Depois de excluído, não poderá ser recuperado. Prossiga com cuidado.","Label_General":"Geral","Label_ColorCard":"Cartão de cores","Label_TextStyle":"Estilo de texto","Message_SavePrevStyle":"Salvar estilo anterior","Message_SavePrevColorCard":"Salvar o cartão de cores anterior","Message_SavePrevElement":"Salve o elemento anterior primeiro.","Button_NewColorCard":"Criar tom","Button_NewStyle":"Criar estilo","Message_NameWithinN":"Insira um nome (até ${0} caracteres)","Message_ColorBlockLimit":"Cada paleta de cores suporta até ${0} amostras de cor","Message_PleaseSelectFont":"Selecione uma fonte","Message_PleaseSelectFontSize":"Selecione um tamanho de fonte","Placeholder_FontSize":"Tamanho do texto","Label_Bold":"Ousado","Label_Italic":"Itálico","Text_FontSizeUnit":"Nº ${0}","Text_Claiming":"Reivindicando...","Button_ClaimFreeBenefit":"Resgatar benefícios gratuitos","Message_MissingExchangeCode":"Código de resgate ausente","Message_SwitchToPersonalFirst":"Alterne para Pessoal primeiro","Desc_ClaimBenefitSuccess":"Você já resgatou este benefício. Vá para o Meitu Posters e comece a criar!","Message_ClaimNewUserOnly":"Este benefício gratuito está disponível apenas para novos usuários que se cadastram pela primeira vez.","Text_AiDesignTagline":"Design com IA ao seu alcance","Text_FreeBenefitLimited":"Resgate benefícios grátis por tempo limitado","Text_ExchangeSceneFeatures":"Pôsteres comerciais · Imagem principal de e-commerce · Remoção com IA · Recorte com IA","Text_LimitedNewUserOnly":"Oferta por tempo limitado, somente para novos usuários","Text_SearchWithKeyword":"Pesquisar \\"${0}\\"","Text_HelpEmptyHint":"Ainda não há conteúdo. Xiaomei vai adicionar mais em breve.","Placeholder_HelpSearch":"O que você gostaria de saber?","Button_Search":"Pesquisar","Message_SelectImageForTranslation":"Selecione uma imagem antes de usar a Tradução de Imagem.","Text_InviteCopyPrefix":"# Pare de perder tempo com imagens para e-commerce! Cadastre-se no Meitu Designer e ganhe créditos grátis na hora. Conjuntos de produtos, páginas de detalhes, vídeos promocionais e muito mais — tudo gerado com um clique. Clique no link para começar a criar!","Label_DistributionAgreement":"Contrato de Serviço de Distribuição do Meitu Design Studio","Label_DistributionConduct":"Código de Conduta sobre Comissões do Serviço de Afiliados do Meitu Design Studio","Alt_InviteFriendIcon":"Ícone de convidar amigos","Alt_BothGetBeanIcon":"Ícone de Obter Créditos","Text_BothGetBean":"Ambos recebem créditos","Alt_FriendFirstOrderIcon":"Ícone de primeiro pedido concluído do amigo","Text_FriendFirstOrder":"Amigo conclui o primeiro pedido","Alt_RedPacketIcon":"Ícone de pacote vermelho recebido","Text_RedPacketArrived":"Pacote vermelho recebido","Desc_InviteRule1":"Quando um amigo convidado por você se cadastrar com sucesso, vocês dois ganharão 40 créditos. Use-os para gerar imagens ou editar fotos. Válido por um mês.","Desc_InviteRule2":"2. Você pode convidar até 15 amigos.","Desc_InviteRule3":"3. Ganhe cashback quando um amigo assinar. Cálculo da recompensa: Valor da recompensa = valor efetivamente pago × taxa de recompensa (por exemplo, se um amigo comprar uma assinatura anual com renovação automática, você pode receber 196 × 15% = 29,4 USD em recompensa em dinheiro). As recompensas podem ser ajustadas durante eventos especiais ou promoções; o valor efetivamente creditado prevalecerá.","Desc_InviteRule4":"4. Se os Créditos do plano ou quaisquer Créditos bônus tiverem sido usados, a compra não poderá ser cancelada, reembolsada ou trocada.","Desc_InviteRule5":"5. Usuários que já tenham uma conta registrada, indiquem a si mesmos, criem contas duplicadas ou se envolvam em atividades fraudulentas não serão elegíveis para recompensas.","Desc_InviteRule6":"6. O Meitu Design Studio reserva-se o direito de ajustar a campanha e revogar recompensas de contas anormais.","Message_SwitchToPersonal":"Mudar para Pessoal","Message_GetInviteLinkFailed":"Falha ao obter o link de convite.","Message_InviteLinkRetry":"Falha ao obter o link de convite. Tente novamente mais tarde.","Message_CopySuccess":"Copiado!","Message_CopyFailedManual":"Falha ao copiar. Copie o link manualmente.","Text_LoginForInviteLink":"Faça login primeiro para obter o link de convite","Text_SwitchPersonalForInviteLink":"Mude para seu perfil pessoal para obter o link de convite","Alt_InviteRewardTitle":"Convide amigos para ganhar créditos e assine para receber cashback","Alt_InviteHeroVisual":"Visual Principal do Cashback de Convite de Amigos","Button_CopyInviteLink":"Copie o link de convite.","Alt_ActivityRules":"Regras da Atividade","Desc_InviteRewardSummary":"Convide amigos para se inscreverem — você e seu amigo recebem 40 créditos cada. Você pode ganhar até 600 créditos. Seu amigo também recebe um desconto de assinatura por 7 dias, por tempo limitado. Se seu amigo assinar a assinatura do Meitu Design Studio durante a promoção, você receberá cashback.","Text_CommissionRate15":"Taxa de comissão de até 15%!","Text_DetailRules":"Regras de Detalhes","Alt_CashoutTutorial":"Guia de rescisão","Desc_InviteDetailAppPath":"Acesse o app Meitu Design Studio > Eu > Convide e ganhe > Carteira de ganhos para ver os detalhes do seu convite.","Desc_InviteDetailAppPathShort":"Acesse o app Meitu Design Studio > Eu > Convide e ganhe > Carteira de ganhos para ver os detalhes do convite.","Desc_InviteSettlementCycle":"Ciclo de liquidação: os pedidos de assinatura são liquidados um mês após a data do pedido. Esse período de um mês é o período de carência para reembolso. Pedidos reembolsados não podem ser sacados durante esse período. Após o período de carência, a participação na receita dos pedidos correspondentes pode ser sacada.","Button_LoginToGet":"Faça login para obter","Button_ClaimNow":"Reivindique agora","Title_SameStyleReplicate":"Recrie este visual 🌟","Text_PageNotFound":"Página não encontrada","Label_PricingPlan":"Preços","Title_ChooseMembershipPlan":"Escolha o plano de assinatura ideal para você","Tab_RenewalYear":"Renovação anual","Tab_RenewalMonth":"Assinatura mensal recorrente","Tab_SingleYear":"Compra anual","Tab_SingleMonth":"Compra de um mês","Text_MeidouPerMonth":"${0} créditos/mês","Title_PersonalVipOnly":"Esta assinatura está disponível apenas para contas pessoais. Mudar para uma conta pessoal?","Button_Switch":"Mudar","Text_ComingSoon":"Brevemente","Button_SubscribeNow":"Assine agora","Text_MostPopular":"Mais curtidos","Text_Trial7DaysPerYear":"Experimente por 7 dias (${0}/ano)","Label_Year":"Ano","Text_StartingFrom":"Iniciar","Label_DesignRecord":"Design","Label_AgentRecord":"Registro do Corretor","Button_ViewMore":"Visualizar mais","Placeholder_PleaseEnterContent":"Insira o conteúdo","Text_InviteLinkExpired":"Este link não está disponível.","Text_RegenerateInviteLink":"Entre em contato com o administrador para gerar novamente o link de convite.","Text_JoinedSuccess":"Você entrou com sucesso","Text_UseTeamOnPc":"Acesse ${0} no seu computador para criar com sua equipe","Button_CopyUrl":"Copiar URL","Text_InviteYouToJoin":"\\"${0}\\" convida você para participar","Button_JoinNow":"Assine agora","Title_TemplateCenter":"Central de modelos","Text_NoSuchTemplate":"Ainda não há modelos deste tipo. Adicionaremos mais em breve.","Title_DesignKitHome":"Página inicial de pôsteres","Label_Tags":"Etiqueta","Button_DownloadAppToEdit":"Baixe o aplicativo X-Desenho para editar","Title_DesignKitTeam":"X-Desenho ${0}","Desc_TeamLandingQuestion":"Os designs dependem totalmente dos designers. Como melhorar a eficiência de design da equipe?","Button_UseNow":"Utilize agora","Text_ViewTeamIntro":"Visualizar visão geral completa da equipe","Button_ViewPricing":"Ver preços","Button_EnterTeamNow":"Entrar agora","Title_EnterpriseSolution":"Saiba Mais Sobre Soluções Empresariais","Desc_EnterpriseContactForm":"Preencha o formulário, e a equipe do Meitu Posters entrará em contato com você em 1 a 3 dias úteis.","Message_CompanyNameMaxLength":"O nome da empresa deve ter 100 caracteres ou menos.","Label_Position":"Cargo","Message_PleaseEnterPosition":"Insira seu cargo atual nesta empresa","Placeholder_EnterPhone":"Insira o número de telefone","Placeholder_EnterPosition":"Insira seu cargo atual nesta empresa","Label_ExpectedUsers":"Usuários Estimados","Title_TeamMaterialEasier":"Crie ativos da equipe com mais facilidade","Label_CommercialTemplate":"Escolha qualquer modelo comercial","Desc_CommercialTemplate":"Empresas autorizadas podem editar e publicar uma ampla variedade de modelos e elementos para uso comercial sem preocupações.","Label_BatchDesignSpeed":"Acelere o design em lote","Desc_BatchDesignSpeed":"Recorte em lote, modelos e produção automatizada de imagens economizam muito tempo.","Label_VisualStandard":"Especificações visuais unificadas","Desc_VisualStandardWork":"Paletas de cores predefinidas, estilos de fonte e outras diretrizes para garantir um estilo de design de marca consistente.","Desc_VisualStandardHome":"Predefina paletas de cores, estilos de texto e outras diretrizes (com suporte a upload de fontes) para manter a consistência dos designs.","Title_TeamCollabEfficient":"Design colaborativo mais eficiente","Label_TeamSharedResource":"Recursos compartilhados da equipe","Desc_TeamSharedResource":"Compartilhe pastas por departamento ou projeto com um clique e crie rapidamente uma biblioteca de ativos de design.","Label_FlexiblePermission":"Configurações de permissão flexíveis","Desc_FlexiblePermission":"Defina permissões de forma flexível para cada arquivo e evite o vazamento de ativos de design.","Label_TemplateQuickReuse":"Reutilizar modelos rapidamente","Desc_TemplateQuickReuse":"Faça upload de PSDs para a biblioteca de modelos e reutilize rapidamente em toda a sua equipe. Chega de esperar por arquivos.","Title_TeamManageEasier":"Gerencie membros e recursos com facilidade","Label_TeamDataReview":"Revisão dos dados da equipe","Desc_TeamDataReview":"Revise regularmente a atividade de criação dos membros no backend e ajuste as vagas da equipe conforme necessário.","Label_MemberRoleManage":"Gerenciamento de funções de membros","Desc_MemberRoleManage":"Defina administradores da equipe, gerencie alterações de membros e cuide da transferência de recursos.","Tag_ConvenientCreate":"Criação fácil","Desc_FreeEditionAudience":"Disponível para indivíduos e equipes","Desc_FreeTemplateMaterial":"Modelos/Elementos gratuitos","Desc_PartialFreeTools":"Ferramentas inteligentes (algumas gratuitas)","Button_FreeExperience":"Teste grátis","Tag_QualityContent":"Conteúdo de alta qualidade","Desc_PersonalEditionAudience":"Para comerciantes individuais, designers ou criadores independentes","Desc_IncludesFreeBenefits":"Inclui os benefícios do plano gratuito","Desc_PaidTemplateMaterial":"Modelos/Elementos Premium","Desc_PersonalCommercialAuth":"Licença Comercial Pessoal","Desc_Meidou330PerMonth":"330 Créditos/mês (Para ferramentas de geração por IA)","Tag_EfficientCollab":"Colaboração eficaz","Desc_TeamEditionAudience":"Para pequenas empresas ou equipes freelance que precisam colaborar em equipe","Desc_IncludesProBenefits":"Inclui benefícios Pro (exceto foto de identificação)","Desc_EnterpriseAuthOne":"Licenciamento comercial*1","Desc_BrandSpecBrief":"Diretrizes da Marca (Logo/Cartela de Cores/Fontes)","Desc_PsdTemplateUpload":"Carregar modelo PSD","Desc_TeamDataAnalysis":"Análise de dados da equipe","Desc_TeamResourceShare":"Compartilhamento de recursos criativos da equipe","Desc_SharedPermissionManage":"Gerenciamento de permissões compartilhadas","Desc_SeatsMeidouPerMonth":"Assentos * 330 créditos/mês (para recursos de geração por IA)","Title_MarketingCostControl":"Mais controle sobre os custos de marketing da sua empresa","Label_AiPhotoCostDown":"Reduza custos com fotografia de produtos com IA","Desc_AiPhotoCostDown":"Imagem de produto com IA e Prova em modelo com IA ajudam você a criar fotos refinadas facilmente, sem precisar de estúdios ou contratar modelos, garantindo que seus resultados nunca pareçam \\"limitados pelo orçamento\\".","Label_AiEditEfficiency":"Retoque por IA","Desc_AiEditEfficiency":"Faça ajustes completos nas fotos, correção de cores e retoque de produtos com um clique para acompanhar os lançamentos de produtos e reduzir os custos de retoque manual.","Label_SmartVideoCreate":"Criação de vídeo com IA","Desc_SmartVideoCreate":"Imagem para Vídeo e Vídeo Comercial em 3D reduzem as barreiras de criação, para que as promoções em vídeo não sejam mais limitadas por longos ciclos de edição e altos custos de modelagem.","Text_TeamAuthSubLabel":"(A Assinatura de equipe inclui uma licença comercial empresarial)","Title_MoreOptions":"Mais opções","Title_FreeImageCreate":"Crie imagens de graça","Desc_FreeTemplateSlashMaterial":"Modelos/Elementos gratuitos","Desc_PartialFreeSmartTools":"Algumas ferramentas com IA gratuitas","Title_IncludesPersonalPlus":"Inclui todos os benefícios do Personal, além de:","Desc_EnterpriseBizAuthOne":"Licença Comercial Empresarial (1 Entidade)","Desc_TeamAssetShare":"Compartilhamento de ativos da equipe","Desc_BrandSpecFull":"Diretrizes da marca (Logo/Cartão de cores/Estilo de texto)","Desc_MemberAccountHandover":"Gestão de Contas de Membro e Transferência de Ativos ao Sair","Desc_TeamUsageAnalytics":"Análise de dados de uso da equipe","Desc_MonthlyMeidouShared":"Receba ${0} créditos por mês, compartilhados entre várias contas","Title_IncludesTeamPlus":"Inclui todos os benefícios do Team, além de:","Desc_EnterpriseBizAuthThree":"Licenciamento comercial empresarial (3 entidades)","Desc_CustomBrandNav":"Barra de navegação da marca empresarial personalizada","Desc_SsoAccess":"Integração com SSO","Desc_MonthlyMeidou20000":"Mais de 20.000 créditos gratuitos por mês, compartilhados entre várias contas","Title_OpenClawApi":"Integração com a API OpenClaw","Desc_OpenClawApi":"Acesse os recursos de processamento de imagens com IA do X-Design e gerencie seu token de API e saldo de créditos.","Title_OpenClawApiShort":"API OpenClaw","Desc_OpenClawMobile":"Gerencie seu token de API e saldo de créditos","Title_QuickStart":"Início rápido","Desc_OpenClawQuickStart":"Após concluir a implantação do OpenClaw, envie o seguinte comando para o Lobster para instalar automaticamente todos os pacotes de habilidades:","Button_CopyInstallConfig":"Copiar configuração de instalação","Text_SeeTutorial":"Ver tutorial detalhado","Text_DesignkitSkillsDoc":"Documentação do designkit-skills","Title_VersionChangelog":"Atualizar para a nova versão","Text_NoChangelog":"Sem histórico de atualizações","Message_InstallCmdCopied":"Instruções de instalação e token copiado","Title_ApiToken":"Token de API (AK)","Desc_ApiToken":"Use o token para autenticar solicitações da API. Clique em \\"Substituir\\" para gerar um novo token (o token antigo será invalidado imediatamente).","Button_CopyToken":"Copiar token","Button_Reset":"Mais","Button_ResetToken":"Mais tokens","Text_PleaseLoginFirst":"Faça login primeiro.","Text_PleaseLoginDash":"Faça login primeiro","Title_ResetToken":"Alterar token","Desc_ResetTokenWarning":"Após a substituição, o token antigo será invalidado imediatamente, e qualquer chamada de API em andamento poderá falhar. Continuar?","Message_TokenReset":"Redefinir token","Message_TokenCopied":"Token copiado","Desc_OpenClawMeidou":"Créditos são a unidade de cobrança para chamadas à API do OpenClaw. Se o saldo for insuficiente, a solicitação da API falhará.","Label_CurrentBalance":"Saldo atual","Button_BuyMeidou":"Comprar créditos","Button_ConsumptionRecords":"Histórico de gastos","Title_OpenClawFeatures":"Introdução ao recurso OpenClaw","Desc_OpenClawFeatures":"Os recursos de IA do X-Design agora estão disponíveis via OpenClaw. Após a autenticação AK, você pode usar diretamente os seguintes recursos, cobrados em créditos, com reembolso automático em caso de falha.","Desc_OpenClawProductImageSet":"Envie imagens do produto, e a IA gerará automaticamente um conjunto de imagens do produto que atende aos padrões de várias plataformas de e-commerce e impulsiona altas taxas de conversão, cobrindo todas as necessidades de imagem para a listagem do produto.","Desc_OpenClawSmartCutout":"Com tecnologia de IA da Meitu, detecta com precisão o elemento principal e remove o fundo automaticamente, com suporte a retratos, produtos e muitos outros cenários.","Desc_OpenClawEnhanceClarity":"A Reparação de qualidade de imagem com IA restaura imagens desfocadas ou de baixa qualidade em HD, com detalhes aprimorados.","Button_ConfirmReset":"Confirmar","Message_MeidouQuotaMinZero":"Insira uma quantidade de créditos igual ou maior que 0","Message_MeidouQuotaRange":"Insira uma quantidade de créditos de 0 a ${0}","Message_AssignSuccess":"Atribuído com sucesso!","Message_SelectAssignableMember":"Selecione membros para atribuir cotas de crédito","Message_NameLength1To20":"Insira um nome com 1 a 20 caracteres","Placeholder_EnterQuota":"Inserir créditos","Text_Unlimited":"Ilimitado","Text_Unassigned":"Não atribuído","Label_MemberName":"Nome do membro","Text_Me":"Eu","Text_Deactivated":"Sair","Text_OverQuotaFrozen":"Congelado por exceder o limite","Label_PhoneNumber":"Número de telefone","Label_Role":"Função","Text_Owner":"Proprietário","Label_QuotaLimit":"Limite de crédito disponível","Message_SelectMemberCount":"Selecione ${0} membros","Text_SelectedMemberCount":"${0} selecionado","Text_RemainingSeats":"Assentos restantes:","Button_ConfirmAssign":"Confirmar alocação","Button_BatchSetQuota":"Limite das configurações em lote","Title_ChangeRole":"Alterar personagem","Button_RemoveMember":"Remover membro","Text_PartialMemberFrozenTip":"Alguns membros estão congelados demais. Tente novamente.","Text_Or":"Ou","Button_RenewMembership":"Renovar","Label_RemainingMeidou":"Créditos restantes","Desc_MemberQuotaTip":"Dica: Os créditos definidos para membros são o limite de uso. A disponibilidade real depende dos créditos restantes da equipe.","Text_MemberEmpty":"Nenhum membro","Message_DataLoadFailed":"Falha ao carregar os dados","Title_BatchAssignMeidou":"Distribua os créditos igualmente entre os ${0} membros selecionados","Label_AssignCount":"Clientes atribuídos","Label_TotalConsumption":"Consumo total","Title_ConfirmTransferAssets":"Transferir recursos?","Message_TransferAssetsSuccess":"Ativos transferidos com sucesso do membro que saiu. Confira.","Label_MySpace":"Meu Espaço","Message_RemoveMemberProgress":"Membro removido com sucesso. Confira o progresso da transferência de ativos.","Message_RemoveMemberSuccess":"Membro removido com sucesso","Title_RemoveMember":"Remover membro","Text_RemovingStep1":"Removendo...","Text_AssetHandleStep2":"2. Ativos criados por este membro","Option_TransferToUser":"Transferir para outro usuário","Text_TransferableAssets":"Recursos transferíveis","Text_DeletedAssets":"Recursos excluídos","Desc_RemovedAssetFolder":"Pastas/registros de edição criados (incluindo recursos não compartilhados)","Desc_RemovedAssetTemplate":"Modelos/elementos carregados (incluindo recursos não compartilhados)","Desc_RemovedAssetAiRecord":"Histórico/Favoritos de conjuntos de IA","Text_SelectAssetReceiver":"3. Selecione o membro que receberá o ativo","Desc_RejoinAssetRecovery":"Se este membro voltar em até 30 dias, os ativos acima reaparecerão no espaço pessoal dele.","Desc_RejoinAssetExpire":"Após 30 dias, ele será excluído permanentemente e não poderá ser recuperado.","Button_ConfirmRemove":"Remover","Text_Last7Days":"Últimos 7 dias","Text_Last30Days":"Últimos 30 dias","Text_Last90Days":"Últimos 90 dias","Text_MemberActiveCount":"Membros ativos","Text_NewAssetCount":"Novos recursos","Title_TeamOverview":"Visão geral da equipe","Title_ActiveMembers":"Membros ativos","Desc_ActiveMembers":"Número de membros que fizeram login no intervalo de tempo especificado","Label_PersonUnit":"Pessoas","Label_TotalCount":"Total","Title_AiToolGeneration":"Gerações de ferramentas com IA","Desc_AiToolGeneration":"Total de gerações feitas por todos os membros usando as ferramentas de IA da plataforma no período especificado","Label_TimesUnit":"Vezes","Label_Accumulative":"Total","Title_TotalAssetDownload":"Total de downloads de recursos","Desc_TotalAssetDownload":"Total de downloads feitos por todos os membros na plataforma dentro do período especificado","Label_CopyUnit":"Relatórios","Nav_MySpace":"Meu Espaço","Nav_ShareWithMe":"Conteúdo compartilhado","Nav_SpaceManage":"Gerenciamento de armazenamento","Nav_AssetHandover":"Recursos de offboarding","Label_Text":"Texto","Label_Group":"Combinação","Label_Table":"Folha","Label_Chart":"Gráfico","Label_AiProductShoot":"Fotografia comercial com IA","Label_AiProductDesign":"Design de produto por IA","Label_SameStyleReplicate":"Recriar","Button_CreateFolder":"Criar pasta","Button_NewFolder":"Nova pasta","Button_UploadFile":"Enviar","Button_UploadFolder":"Enviar pasta","Button_UploadTemplate":"Carregar modelo","Menu_Rename":"Renomear","Button_UseTemplate":"Usar","Button_CopyToTeam":"Copiar para a equipe","Text_MoveToMySpace":"Mover para Meu Espaço","Button_ExportContent":"Exportar","Button_Deselect":"Limpar seleção","Text_SelectAllWithCount":"Selecionar todos (${0} selecionados)","Message_PartialFileCannot":"Alguns dos arquivos selecionados não podem ser ${0}","Text_NoSearchResultYet":"Nenhum resultado encontrado","Text_SearchNoMatch":"Nenhum resultado encontrado","Text_EmptyGoCreate":"Ainda não há conteúdo. Crie agora!","Text_EmptyGoAction":"Ainda não há conteúdo. Acesse ${0}.","Text_ActionCreate":"Criar","Desc_OrganizeWorks":"Organize projetos pessoais ou de equipe com eficiência","Message_EnterName":"Digite um nome para ${0}","Message_EnterNameWithin20":"Insira um nome de ${0} com até 20 caracteres","Message_OperationSuccess":"Operação realizada com sucesso!","Message_EnterFolderName":"Insira um nome de pasta!","Message_EnterFolderNameWithin20":"Insira um nome de pasta com até 20 caracteres","Text_CopyTo":"Copiar para","Text_CopyingMayTakeMinutes":"Copiando... Isso pode levar alguns minutos.","Button_GoTeamView":"Visualizar na equipe","Message_BrowserNoUploadFolder":"O upload de pastas não é compatível com este navegador.","Title_MoveAfterMySpace":"Depois de mover, ficará em Meu Espaço","Desc_MixSortAfterMove":"Combinado com outros recursos por data de atualização","Message_HandoverFailed":"Falha na transferência","Message_CreateSuccessExclaim":"Criado!","Message_NoFilePermission":"Você não tem permissão para realizar esta ação neste arquivo.","Title_ConfirmDeleteRecord":"Excluir os registros a seguir?","Title_ConfirmUnfavorite":"Se você remover dos favoritos, o registro deste resultado de design será perdido. Tem certeza?","Title_ConfirmDeleteGenerate":"Após a exclusão, os resultados gerados serão perdidos. Tem certeza de que deseja excluir isto?","Text_To":"Para","Text_FileOperating":"No arquivo ${0}...","Message_OperateSuccess":"${0} fixado","Text_CurrentDir":"Diretório atual","Text_OperateDir":"Menu de Ações","Text_Creating":"Criando","Text_NoContent":"Sem conteúdo","Title_CancelUploadConfirm":"Os carregamentos ainda estão em andamento. Cancelar todos os carregamentos em andamento?","Button_CancelUpload":"Sair","Message_MaxUploadFiles":"Você pode enviar até 500 arquivos por vez.","Message_PersonalUploadLimit":"Contas pessoais permitem enviar até 20 arquivos por vez. Para enviar mais de 20 arquivos, crie uma equipe.","Title_PsdToTemplate":"Carregue um PSD para convertê-lo diretamente em um modelo de equipe","Desc_TemplateEditOnly":"Só você pode editar o modelo. Outros membros só podem duplicá-lo e não podem alterar o modelo original.","Link_WhatIsTemplate":"O que são modelos","Button_ConvertTemplate":"Converter em modelo","Button_UploadOnly":"Somente upload","Text_WaitUpload":"Aguardando upload","Text_Transferring":"Transferindo...","Text_AllUploadComplete":"Todos os carregamentos foram concluídos","Text_FilesUploadFailed":"Falha ao carregar ${0} arquivos","Text_UploadingProgress":"Carregando... (${0}/${1})","Button_StartAll":"Iniciar tudo","Button_PauseAll":"Pausar tudo","Button_CollapseDetail":"Recolher detalhes","Button_ExpandDetail":"Expandir detalhes","Text_FailDetail":"Detalhes da falha","Text_SharedFolderToYou":"Compartilhou uma pasta com você","Desc_ClickJoinTeam":"Toque para ver e entrar automaticamente nesta equipe","Text_SeatInsufficientFolder":"Não há vagas suficientes. Você não pode entrar na equipe para acessar esta pasta.","Title_FolderTeamShareOnly":"As pastas só podem ser compartilhadas dentro de uma equipe","Button_SwitchTeamCopyFolder":"Trocar de equipe e copiar pasta","Button_CreateTeamCopyFolder":"Criar equipe e copiar pasta","Message_FolderCopiedToTeam":"Criado com sucesso. A pasta foi copiada para sua equipe.","Text_UsedSpace":"Usado:","Text_StorageSpace":"Espaço de armazenamento:","Text_UsedSpaceLabel":"Espaço usado","Text_UnlockSpace":"Desbloqueie ${0} de armazenamento extra","Button_UpgradeToMember":"Fazer upgrade para assinatura","Button_UpgradePremium":"Faça upgrade para Premium","Desc_SpaceFullUpgrade":"O armazenamento está cheio. Faça upgrade para ter mais armazenamento.","Desc_SpaceFullContactAdmin":"O armazenamento está cheio. Entre em contato com o administrador.","Desc_SpaceFullClean":"O armazenamento está cheio. Libere espaço agora.","Desc_SpaceLowUpgrade":"Menos de 10% de armazenamento restante. Faça upgrade para ter mais armazenamento.","Desc_SpaceLowContactAdmin":"Menos de 10% de espaço de armazenamento restante. Entre em contato com o administrador.","Desc_SpaceLowClean":"Resta menos de 10% de espaço de armazenamento. Libere espaço o quanto antes.","Desc_VipExpiredRenew":"Seus benefícios da assinatura expiraram. Renove agora.","Desc_VipSoonExpireRenew":"Sua assinatura está prestes a expirar. Lembre-se de renovar.","Desc_SpaceNormal":"Este espaço está disponível. Você pode continuar salvando suas criações.","Text_CountUnit":"${0}","Text_SoonExpire":"Expira em breve ${0}","Text_Expired":"Expirou ${0}","Text_FileStatus":"Status do arquivo: ${0}. Organize-o em breve.","Desc_TopBannerFilesExpire":"Alguns dos seus arquivos estão prestes a atingir o limite de armazenamento. Gerencie seus arquivos agora ou faça upgrade da sua assinatura para mantê-los permanentemente.","Desc_TopBannerSpaceLow":"Resta menos de 10% do seu espaço de armazenamento. Atualize seu plano para obter mais armazenamento.","Desc_TopBannerSpaceUrgent":"O armazenamento está ficando baixo e alguns projetos expirarão em breve. Faça upgrade da sua assinatura para ter mais armazenamento e manter seus projetos para sempre.","Desc_TopBannerSpaceLowPremium":"Resta menos de 10% do seu armazenamento. Faça upgrade para o Premium para ter mais armazenamento.","Desc_TopBannerVipSoonExpire":"Sua assinatura está prestes a expirar. Renove a tempo para evitar que seu histórico de edições expire e seja excluído.","Desc_TopBannerVipExpired":"Sua assinatura expirou. Renove agora para evitar perder espaço de armazenamento ou histórico de edição.","Desc_TopBannerSpaceLowClean":"Resta menos de 10% do seu armazenamento. Libere espaço agora.","Desc_TopBannerVipSoonExpireNoPeriod":"Sua assinatura está prestes a expirar. Se você não renovar a tempo, seus registros de edição poderão ser excluídos. Renove o quanto antes.","Text_AssetHandovering":"Transferindo recursos...","Text_TransferringStatus":"Transferindo","Text_ResignationTime":"Data de desligamento:","Desc_AssetHandoverTip":"Registros de geração nos ativos de membros que saíram não podem ser editados. Outros ativos não permitem mover nem fazer upload. Se necessário, mova os ativos para Meu Espaço primeiro.","Message_SelectFileLimit":"Selecione até ${0} arquivos","Text_ExpandVersionComparison":"Comparação do recurso Expandir entre versões","Text_CollapseVersionComparison":"Comparação de recursos da versão Decorar","Text_VersionComparisonToggle":"Comparação de recursos da versão ${0}","Text_Consult":"Sugestões","Text_PricePerMonthWithSymbol":"¥${0}/mês","Title_RightsComparison":"Comparar benefícios","Text_Trial7Days":"Teste de 7 dias","Text_UsingNow":"Em uso","Text_ConsultBusiness":"Entre em contato com a equipe de vendas","Title_PriceComparison":"Comparação de preços","Text_StandardMember":"Premium Padrão","Text_EnterpriseMember":"Premium Empresarial","Text_BeansPerMonth":"${0} créditos/mês","Text_BeansPerMonthFrom":"A partir de ${0} créditos/mês","Text_WanBeansPerMonthFrom":"A partir de ${0}k créditos/mês","Text_SheetsPerMonth":"${0} imagens/mês","Text_SheetsPerMonthFrom":"A partir de ${0} fotos/mês","Text_WanSheetsPerMonthFrom":"A partir de ${0} mil imagens/mês","Desc_FeatureOnlyNote":"${0}<span style=\\"color: #d0d2d6\\">(Apenas este recurso)</span>","Text_PersonalCommercial":"Uso Pessoal e Comercial","Text_EnterpriseCommercialEntities":"Entidade de Licenciamento Comercial Empresarial*${0}","Text_PurchasableSeparately":"Disponível como compra separada","Desc_MeidouAiQuota":"Créditos (Cota de geração por IA)","Label_AiAgentImageEdit":"Agente de IA: Edição de fotos","Label_AiAgentImageGen":"Agente de IA: Geração de Imagens","Label_AiAgentEcommerce_ImageSet":"Agente de IA: Conjunto de imagens para e-commerce","Label_PortraitBgReplace":"Alterar o fundo","Label_AiPartialRedraw":"Modificar com IA","Label_AiImageGen":"Geração com IA","Label_AiFloralText":"Caligrafia com IA","Label_LivePpt":"Live PPT","Label_AiSizeExtend":"Expansão de tamanho com IA","Label_BatchTemplate":"Modelos em lote","Label_CreateCustomSize":"Crie um design em tamanho personalizado","Label_EditLocalImage":"Editar imagens locais","Label_ExportJpgPng":"Exportar design/imagem como JPG/PNG","Label_FreeTemplate":"Modelos gratuitos","Label_FreeFont":"Fontes gratuitas","Label_FreeAsset":"Elementos gratuitos","Label_PaidTemplate":"Modelo pago","Label_PaidFont":"Fontes pagas","Label_PaidAsset":"Conteúdo premium","Label_RealtimeMultiEdit":"Edição colaborativa em tempo real","Label_ShareDesignRecord":"Registros de edição compartilhada","Label_ShareElements":"Compartilhar elementos (Imagens/Texto/Tabelas)","Label_ShareTemplate":"Compartilhar modelo","Label_ShareFolder":"Compartilhar pasta","Label_SharePermission":"Gerenciamento de permissões de compartilhamento","Label_RecordToTemplate":"Converter registros de edição em modelo","Label_EnterpriseBrandNav":"Barra de navegação da marca empresarial","Label_Sso":"Login único (SSO)","Label_ModelCustomization":"Personalização do modelo","Label_SceneCustomization":"Personalização da cena","Label_OnlineAiSupport":"Atendimento ao Cliente Inteligente Online","Label_OnlineManualGuide":"Manual online","Label_OperationGuide":"Guia do usuário","Label_CustomerImSupport":"Suporte ao cliente por grupo de mensagens instantâneas","Label_DedicatedCsm":"Serviço dedicado de sucesso do cliente","Label_TechPriorityResponse":"Resposta do Atendimento Técnico Prioritário","Label_TrainingSession":"Treinamento dedicado","Label_OffboardAssetTransfer":"Transferência de recursos por desligamento","Label_MemberPurchaseLimit":"Restrições de compra para membros","Label_MemberActivity":"Atividade para membros","Label_MemberDesignActivity":"Atividade de edição do membro","Label_MemberAiActivity":"Status de Geração com IA do Membro","Title_ContentDesign":"Design de conteúdo","Title_MultiCollaboration":"Colaboração com várias pessoas","Title_VisualManagement":"Gerenciamento visual","Title_OrgManagement":"Gerenciamento da organização","Title_DataStatistics":"Estatísticas","Title_ExclusiveCustomization":"Personalização exclusiva","Title_ServiceGuarantee":"Garantia de Serviço","Title_EnterpriseAuthConfirm":"Confirmar informações da licença comercial empresarial","Text_ConfirmAuthInfoTip":"Confirme as seguintes informações de autorização. Elas não poderão ser alteradas após o envio.","Label_Name":"Nome","Label_UnifiedSocialCreditCode":"Identificador Unificado de Crédito Social","Label_IdCardNumber":"Número do cartão de identificação","Label_ContactPhone":"Número de telefone","Title_AuthSuccess":"Autorização bem-sucedida","Text_AuthSubjectFilled":"Entidade de autorização concluída com sucesso","Button_BackAdmin":"Voltar ao back-end","Button_DownloadAuthBook":"Baixar carta de autorização","Title_EnterpriseAuthFill":"Insira as informações de licenciamento comercial empresarial","Label_AuthType":"Tipo de autorização","Text_Enterprise":"Empresarial","Message_EnterCompanyNameWithin30":"Insira o nome da sua empresa (até 30 caracteres)","Message_PleaseEnterNameShort":"Insira seu nome","Message_Max30Chars":"Máximo de 30 caracteres","Message_EnterCompanyName":"Insira o nome de sua empresa","Message_EnterUnifiedSocialCreditCode":"Insira o Identificador de Crédito Social Unificado","Message_EnterIdCardNumber":"Insira o número do cartão de identificação","Message_InvalidUnifiedSocialCreditCode":"Formato inválido do Identificador de Crédito Social Unificado.","Message_InvalidIdCardNumber":"Formato inválido do número do cartão de identificação.","Message_EnterPhoneNumber":"Insira seu número de telefone","Message_InvalidPhoneNumber":"Formato de número de telefone inválido.","Placeholder_PhoneExample":"Exemplo: 0592-12345678 / 13912345678","Desc_AuthInfoBindTip":"Após o envio, as informações acima serão vinculadas e não poderão ser alteradas, a menos que você compre uma entidade comercial autorizada adicional.","Desc_AuthInfoRiskTip":"Se você não fornecer as informações acima de forma precisa e completa, talvez não consiga apresentar comprovação válida em caso de riscos de direitos autorais e poderá não receber proteção de uso comercial da plataforma Meitu Design Studio.","Desc_AuthSingleSubjectTip":"A Licença de Uso Comercial Sem Preocupações é concedida a uma única entidade e limitada ao uso pela parte autorizada que a comprou e vinculou. O compartilhamento ou a transferência são proibidos.","Text_OfflineOrderScanBusiness":"Para pedidos offline, escaneie o código para entrar em contato com a equipe de Vendas e solicitar uma carta de autorização","Label_AuthSubjectInfo":"Informações da entidade autorizada","Text_NotFilledYet":"Ainda não preenchido","Text_ServiceValidity":"Termo de Serviço","Text_AuthInactive":"Inativo","Text_AuthActive":"Ativo","Text_AuthExpired":"Expirou","Text_AuthNotStarted":"Não começou","Text_OfflineOrder":"Pedidos na loja","Label_RelatedOrder":"Pedido relacionado","Button_ContactSupport":"Contato","Button_Fill":"Entrar","Title_MemberCommercialAuthBook":"Licença comercial para membros","Button_PurchaseAuthSubject":"Adicionar entidade autorizada","Desc_PurchaseAuthSubjectScan":"Para adquirir entidades autorizadas adicionais, escaneie o código QR para entrar em contato com nossa equipe de vendas","Label_AuthTime":"Período de Licenciamento","Label_AuthStatus":"Status da autorização","Text_OrderCancelled":"Cancelado","Text_OrderPaid":"Pago","Text_OrderRefunded":"Reembolsado","Text_TeamVipProductName":"Assinatura da equipe ${0}","Text_CutoutCountProductName":"Recortes restantes: ${0}","Text_MemberMeidouProductName":"Créditos de assinatura: ${0}","Message_CancelSuccess":"Cancelado","Message_CancelFailed":"Falha ao cancelar","Title_ConfirmCancel":"Confirmar cancelamento","Text_CancelOrderTip":"Após cancelar seu pedido, você pode fazer um novo pedido para comprar o serviço.","Button_IssueInvoice":"Fatura","Text_NoOrders":"Ainda não há pedidos","Label_ProductInfo":"Informações do produto","Label_Quantity":"Quantidade","Label_OrderTotal":"Total","Label_OrderStatus":"Status do pedido","Text_OrderNoPrefix":"Número do pedido: ${0}","Text_PayBeforeDeadline":"Conclua o pagamento até ${0}. Pagamentos em atraso serão cancelados automaticamente.","Button_CancelOrder":"Cancelamento de pedidos","Button_PayNow":"Pagar agora","Title_TransferAmount":"Valor da transferência","Desc_TransferAmountMatch":"O valor da transferência deve corresponder ao valor do pedido atual.","Desc_TransferUniqueCode":"2. Cada pedido tem um código de pagamento único. Este código é válido apenas para este pedido. Não pague mais de uma vez.","Desc_TransferAutoActivate":"3. Sua assinatura será ativada automaticamente em até 30 minutos após a transferência ser concluída. Conclua o pagamento o quanto antes.","Title_ReceiveAccountInfo":"Dados da Conta","Label_AccountName":"Nome da conta","Label_BankAccount":"Conta bancária","Label_IssueBank":"Nome do banco","Label_RemittanceCode":"Código de remessa","Text_CopyRemittanceInfo":"Copiar informações de remessa","Message_CopiedToClipboard":"Copiar para a área de transferência","Text_CopyRemittanceTemplate":"Nome da Conta: ${0}\\nConta Bancária: ${1}\\nNome do Banco: ${2}\\n  Código de Remessa: ${3}","Label_MemberSeats":"Membros/Assentos","Label_RemainingSheets":"Créditos restantes","Label_EnterpriseAuthSubject":"Entidade de licenciamento comercial empresarial","Button_Purchase":"Compra","Message_EditSuccessExclaim":"Alterado com sucesso!","Text_InactiveSeats":"Vagas pendentes ${0}","Text_ExpiredDays":"Expirou há ${0} dia(s)","Text_ExpireOn":"Expira em ${0}","Label_OrgId":"ID da organização","Label_CreatedAt":"Criado em:","Title_ContactInfo":"Informações de Contato","Desc_ContactExpectation":"Adoraríamos nos conectar com você 🤝 e ajudar sua equipe a aproveitar melhor o Posters.","Text_ContactFor1v1":"Preencha isto para receber atendimento VIP individual.","Label_ContactPerson":"Lentes de contato","Label_ContactMethod":"Informações de Contato","Text_MemberActivity":"Atividades para membros","Label_LastOnlineTime":"Data de lançamento mais recente","Label_ActiveDays":"Dias ativos","Title_GenerationCount":"Gerações","Label_PosterImageEdit":"Edição de pôster/imagem","Alt_Avatar":"Avatar","Label_ProductPortrait":"Produto/Retrato","Label_TryOnFaceSwapRecolor":"Experimentar/Trocar rosto/Cor","Text_MemberActivityExport":"Atividades para membros.xls","Title_IncludesFreePlus":"Inclui todos os benefícios do plano gratuito, além de:","Title_IncludesStandardPlus":"Inclui todos os benefícios da assinatura Standard, além de:","Title_IncludesTeamMemberPlus":"Inclui todos os benefícios da Assinatura de Equipe, além de:","Text_AccountLimitOne":"Limite da conta: 1 usuário","Text_PaidTemplateMaterial":"Modelos/Elementos Premium","Text_FreeTemplateMaterial":"Modelos/Elementos gratuitos","Desc_SmartToolsBundle":"Recorte inteligente/Remoção com IA/Aprimorar e outras ferramentas inteligentes","Desc_MeidouMonthlyUsage":"Os créditos mensais podem ser usados para:","Desc_AgentProductSuite":"Agente com IA: Conjuntos de imagens de produtos, páginas de detalhes, vídeos e muito mais","Desc_AiShootSuite":"Fotografia comercial com IA: Imagens do produto por IA, fundos para retratos, modelos com IA e muito mais","Desc_AiDesignSuite":"Design com IA: Logotipo com IA, PPT ao vivo, Gráfico com IA e muito mais","Text_TeamSeatsFromPrice":"10 Licenças / A partir de ¥15.000","Desc_BulkMeidouOneTime":"Bônus único de muitos créditos, compartilhado entre várias contas","Label_OneMonth":"1 mês","Label_ThreeMonths":"3 meses","Label_TwelveMonths":"12 meses","Text_EnterpriseCommercialLicensed":"Autorizado para uso comercial empresarial","Button_BuyTeamEdition":"Comprar Plano de Equipe","Title_ChooseByCommercialAuth":"Escolha por licenciamento comercial","Label_LicenseTarget":"Parte autorizada:","Desc_PersonalLicenseTarget":"A entidade comercial é uma pessoa física, e o beneficiário também é uma pessoa física.","Label_LicenseScope":"Âmbito do aplicativo:","Desc_PersonalLicenseScope":"Uso pessoal em escritório (PPT, relatórios), sites pessoais, uso promocional de lojas virtuais registradas como pessoa física, redes sociais pessoais, Contas Oficiais do WeChat, criação pessoal de vídeos curtos etc.","Title_EnterpriseCommercialAuth":"Licenciamento Comercial Empresarial","Desc_EnterpriseLicenseTarget":"Pessoas jurídicas e organizações não constituídas em pessoa jurídica, incluindo empresas, empresas individuais, organizações administrativas e grupos sociais.","Desc_EnterpriseLicenseScope":"Gerencie sites, contas oficiais, miniprogramas, imagens de produtos/páginas de detalhes de e-commerce, feeds de redes sociais, anúncios online e catálogos de produtos online.","Tip_PersonalLicenseWarning":"Observação: Usar uma licença comercial pessoal para fins comerciais é considerado uma infração.","Alt_ContactServiceQrcode":"Código QR para contato com o suporte","Text_ScanContactManager":"Escaneie o código QR para entrar em contato com o gerente de contas","Button_LearnQuote":"Visualizar preços detalhados","Title_PricingPartners":"Clientes de diversos setores usam o Meitu Design Studio","Title_FaqSectionPricing":"Perguntas frequentes","Title_FaqCommercialUse":"Posso usá-lo para fins comerciais após assinar?","Desc_FaqCommercialUse":"A assinatura pessoal (SVIP) é apenas para uso comercial individual. Assinaturas de Equipe/Empresa podem ser usadas para uso comercial empresarial. Compre o plano de assinatura que corresponde ao seu caso de uso comercial.","Title_FaqInvoice":"Como faço para obter uma fatura?","Desc_FaqInvoicePersonal":"Fatura com IVA da assinatura individual: Abra o site do Meitu Design Studio, faça login na sua conta de membro, clique na sua foto de perfil no canto superior direito, clique em Renovar assinatura, depois clique em Quero uma fatura no canto inferior direito do pop-up e escaneie o código QR com o WeChat para obter uma fatura.<br/>","Desc_FaqInvoiceTeam":"Fatura regular da assinatura da equipe: Acesse o painel de gerenciamento da equipe, selecione Fatura do pedido - escolha o pedido para faturar - clique em Fatura - escaneie o código QR para preencher as informações relevantes.<br/>","Desc_FaqInvoiceSpecial":"Nota fiscal especial de IVA: Entre em contato com o atendimento ao cliente online pela Consulta online.<br/>","Title_FaqDeviceLimit":"Em quantos dispositivos uma conta de assinatura pode ser usada?","Desc_FaqDeviceLimit":"O MTid é uma conta pessoal. Para proteger a segurança da sua conta e a privacidade da criação, <span style=\\"color: #fff; font-weight: bold;\\">cada conta de assinatura só pode estar logada em um computador por vez</span> e não oferece suporte a login simultâneo em vários computadores.<br/>Se você precisar fazer login em vários dispositivos ao mesmo tempo, recomendamos adquirir a <span style=\\"color: #fff; font-weight: bold;\\">Assinatura de Equipe/Empresarial do Meitu Design Studio</span> para ativar múltiplos assentos e atribuir contas para login.","Title_FaqUpgradeTeam":"Como faço upgrade de uma assinatura individual para uma Assinatura de Equipe?","Desc_FaqUpgradeTeam":"Como as assinaturas Team e Individual têm preços diferentes, para fazer upgrade para uma assinatura Team, adquira o plano Team primeiro e entre em contato com o suporte online para migrar os créditos da sua conta pessoal e processar o saldo restante da assinatura. Você mesmo pode copiar os ativos da sua conta individual para a equipe.","Title_FaqMeidou":"O que são os créditos e como faço para comprá-los?","Desc_FaqMeidou":"Além dos recursos gratuitos e para membros, o Meitu Designer também oferece funções de IA que exigem Créditos para uso, como AI Product Image, AI Model e Flatlay. Quando os Créditos incluídos na sua assinatura forem usados, você pode comprar mais separadamente. Acesse a página de compra no canto superior direito de qualquer função de IA. Link: <a target=\\"_blank\\" style=\\"color: #66A8FF\\" href=\\"https://www.designkit.cn/product-shoot-editor/?from=home\\">https://www.designkit.cn/product-shoot-editor/?from=home</a>","Message_PermissionAlreadyRejected":"Solicitação de permissão rejeitada","Message_PermissionAlreadyProcessed":"Esta solicitação de permissão foi processada","Text_TeamRenewRemainingPrefix":"Sua assinatura da equipe tem apenas","Text_UnitDay":"dias","Text_SharedItemToYou":"Compartilhou um ${0}【${1}】 com você.","Label_AccountColon":"Número da conta:","Text_PriceYuanPerPersonPerMonth":"¥${0}/pessoa/mês","Text_OrTry":"Ou tente","Title_DesignKitApp":"美图设计室 APP","Title_OpenClawGuide":"Manual do OpenClaw","Label_AllColors":"Todas as cores","Alt_TemplateImage":"Imagem do modelo","Text_NestedTemplateSuiteCount":"Definir modelos para ${0} imagens","roboneo_agent_queue_tier_fast":"Rápido","roboneo_agent_queue_tier_relax":"Relaxar","roboneo_agent_queue_tier_change_failed":"Não foi possível alternar. Tente novamente.","Label_ImageProcessing":"Processamento de Imagem","Tool_ProductRetouching":"Retoque de produto","Message_SelectImageBefore_ImageTranslation":"Selecione uma imagem antes de usar a Tradução de Imagem.","Message_SelectImageBefore_Expand":"Selecione uma imagem antes de usar a Expansão de fundo com IA.","Label_AiCreation":"Geração com IA","Tool_AiImageText":"Imagem e texto por IA","Label_DefaultModel":"Modelo padrão","Desc_AgentMode_Advanced":"Consumo de créditos de IA 3x Gere uma variedade de resultados para promoção 3x","Desc_AgentMode_Normal":"Ideal para criações simples do dia a dia e para economizar recursos de processamento","Desc_AgentMode_FlagshipAi":"·Modo de IA carro-chefe","Desc_AgentMode_MultilingualText":"·Correspondência precisa de texto multilíngue","Desc_AgentMode_ProductFidelity":"· Restauração de produto com 95% de precisão","Desc_AgentMode_ComplexScene":"·Capacidades de processamento de cenários complexos","Tool_AIVideoAgent":"Agente de Vídeo com IA","Tool_UGCVideoMaker":"Criador de vídeos UGC","Tool_MarketingVideoMaker":"Criador de vídeos de marketing","Tool_PromoVideoMaker":"Criador de vídeos promocionais","Tool_ExplainerVideoMaker":"Criador de vídeos explicativos","Tool_BeforeAfterVideoMaker":"Criador de vídeos de antes e depois","roboneo_agent_queue_tier_upgrade_title":"Acesso ilimitado ao Relaxar","roboneo_agent_queue_tier_upgrade_desc":"Benefícios da assinatura ${0}. Gerado no modo Relax, sem precisar de créditos.","roboneo_agent_queue_tier_upgrade_primary":"Faça upgrade para Pro","roboneo_agent_queue_tier_upgrade_secondary":"Use o modo rápido","Label_PageIndex":"Página ${0}","Title_PPTTask":"Tarefa de PPT","Button_ReplicateNow":"Reutilizar agora","Label_ImageIndex":"Figura ${0}","Button_Cases_ViralVideo":"Exemplo","Message_ImageReviewFailedRetry_Batch":"Falha na análise da imagem. Tente novamente mais tarde.","Message_ImageReviewRejected_Batch":"Imagem rejeitada","Text_PageRange":"Página ${0}~${1}","Text_AllPagesRange":"Todas as páginas (1~${0})","Text_AllPages":"Todas as páginas","Text_SelectedPages":"Página selecionada (${0})","Text_NoPageSelected":"Nenhuma página selecionada","Title_InsertDocument":"Inserir documento","Title_SelectPages":"Selecionar página","Button_Insert":"Inserir","Message_ProductInfoReviewRejected_Batch":"Texto do destaque rejeitado. Preencha novamente.","Tool_VideoBackgroundRemover":"Removedor de fundo de vídeo","Title_StayUpdated_Designkit":"Fique por dentro das novidades do Designkit","Title_StayUpdated_Zawa":"Mantenha-se atualizado com o Zawa","Desc_WebPushPrompt":"Saiba em primeira mão sobre novas ferramentas de IA, atualizações de recursos e conteúdos em alta.","Button_NotNow":"Agora não","Button_TurnOn":"Ativar","Placeholder_Enter":"Insira ${0}","Placeholder_Select":"Selecione ${0}","Label_AiMarketingVideo":"Vídeo promocional de produto com IA","Title_ImageProcessing":"Processar imagem","Title_AiDesign":"Design com IA","Label_Ecommerce":"E-commerce","Label_SocialMedia":"Redes sociais","Label_WechatMarketing":"Marketing no WeChat","Label_OfficialAccount":"Conta oficial","Label_OfficeEducation":"Administração e escritório/Educação","Label_LifeEntertainment":"Estilo de vida e Entretenimento","Title_DesignScene":"Cenários de Design","Label_MarketingSales":"Marketing e vendas","Label_Promotion":"Promoção","Label_Greeting":"Saudações e bênçãos","Label_CommunicationSharing":"Compartilhar e conectar","Label_LifeScience":"Dicas de estilo de vida","Label_Recruitment":"Seleção","Title_UsagePromotion":"Uso para marketing","Label_FoodBeverage":"Gastronomia e Gourmet","Label_ApparelBags":"Roupas, sapatos e bolsas","Label_EducationTraining":"Educação e treinamento","Label_BeautySkincare":"Beleza e Cuidados com a pele","Title_IndustryResource":"Recursos da indústria","Text_FirstDiscountBadge_ViralVideo":"Desconto no primeiro vídeo","Title_ManagedBatchTip":"Vá dormir um pouco. Suas imagens estarão prontas quando você acordar.","Tag_ManagedBatchDiscount":"Desconto de ${0}% em lote","Desc_ManagedBatchTip":"Gere imagens em lote com ${0}% de desconto. Acorde com tudo pronto.","Title_Resize":"Redimensionar","Title_SocialContentCreation":"Conteúdo social","Title_BatchResize":"Redimensionar em lote","Title_ImageRecolor":"Recoloração de imagens","Title_BatchRetouch":"Retoque em lote","OnlineConsultation":"Consulta online","PayAmount":"Pagar ¥${0}","PriceBreakdown":"¥${0} × ${1} licenças × ${2} meses","ScanToPay":"Escaneie para pagar com ${0}","PaymentAgreementHint":"Ao pagar, você concorda com","MeidouRechargeAgreement":"Contrato de Recarga de Créditos","DesignStudioServiceAgreement":"Contrato de Serviço de Assinatura do Meitu Design Studio","CommercialLicenseAgreement":"Licença Comercial","CutoutQuotaNotice":"Aviso sobre créditos bônus de recorte","RenewalMemberNote":"Se você comprou uma assinatura com renovação automática:","AutoDeliveryOnPurchase":"Após a compra, será adicionado automaticamente à sua conta atual.","NonRenewalMemberNote":"Se você comprar uma assinatura sem renovação automática:","AutoDeliveryOnTransaction":"Após a transação ser concluída, será adicionado automaticamente à sua conta atual.","CutoutQuotaLabel":"Créditos de recorte:","CutoutQuotaDesc":"A quantidade de créditos de recorte gratuitos é baseada no bônus informado na página de detalhes da assinatura que você comprou.","CutoutQuotaExpiryLabel":"Período de validade dos créditos de recorte:","CutoutQuotaExpiryDesc":"Conforme o período de uso exibido na página do pedido","TrialAddressLabel":"Link da experiência:","ServiceNotice":"Aviso de Serviço","AutoRenewNote1":"1. Após ativar este serviço, sua assinatura será renovada automaticamente nas 24 horas anteriores ao vencimento. Após a renovação, sua assinatura será estendida pelo período correspondente;","AutoRenewNote2":"2. Sua taxa de renovação será deduzida da sua conta de pagamento vinculada;","AutoRenewNote3":"3. Você pode cancelar a renovação automática a qualquer momento. Após o cancelamento, sua assinatura não será mais renovada automaticamente;","AutoRenewNote4":"4. Como cancelar:","AutoRenewNote5":"5. Para outras dúvidas, fale com o suporte ao cliente pelo telefone 4000093360","Label_WeChat":"WeChat","Label_Alipay":"Alipay","Label_BatchTrialCount":"Usos gratuitos de processamento em lote","Desc_WindowsOnly":"Apenas no aplicativo para desktop Windows","Label_MemberFeature":"Recursos VIP","Label_MemberAsset":"Elementos VIP","Label_MemberEffect":"Efeitos VIP","Label_NoAds":"Sem anúncios","Label_NoPoster":"Sem Meitu Pictorial","Label_EffectFilter":"Filtros especiais","Label_Enhance":"Melhorar","Label_FaceRemodel":"Remodelar","Label_SkinAdjust":"Pele","Label_HeadAdjust":"Ajuste de cabeça","Label_HeightShape":"Forma do corpo","Label_Border":"Moldura","Label_RechargeMeidou":"Recarregar Créditos","Text_InsufficientBenefits":"Benefícios insuficientes. Entre em contato com seu consultor dedicado: ${0} ${1}","Text_OnlinePurchaseDisabled":"Compras online não são aceitas nesta versão. Entre em contato com o administrador se necessário.","Desc_ProtectMemberExperience":"Para garantir sua experiência de assinatura,","Desc_BindPhoneFirst":"Primeiro, vincule seu número de telefone principal.","Button_GoToBind":"Vincular agora","Text_AlreadyActiveMember":"Você já fez a assinatura em ${0}","Text_ContactServicePrefix":"Se tiver alguma dúvida,","Label_ServicePhone":"Telefone do Atendimento ao Cliente","Text_ServiceTime":"Horário de atendimento: 9h às 21h","Text_LargeOrderContact":"Para pedidos grandes ou pagamentos com falha, escaneie o código QR para entrar em contato com a equipe de vendas e receber ajuda.","Text_ConsultEnterprise":"Consulta de uso comercial empresarial","Message_CreateFail":"Falha na criação. Tente novamente mais tarde.","Title_TransferReminder":"Lembrete de transferência","Text_ViewOrderProgress":"Você poderá acompanhar este pedido depois em Painel de Administração > Pedidos e Faturas.","Title_PendingTransfer":"Pedido de transferência em andamento","Text_HasPendingTransfer":"Você tem um pedido de transferência bancária empresarial em andamento. Deseja visualizá-lo?","Button_CancelAndCreate":"Cancelar e criar novo pedido","Button_ViewTransferOrder":"Ver pedido de transferência em andamento","Text_CancelOrderNote1":"Após cancelar o pedido, você poderá criar um novo,","Text_CancelOrderNote2":"No entanto, o pedido com uma transferência em andamento será encerrado.","Button_ConfirmCancelCreate":"Confirmar cancelamento e criar","Link_ViewBenefitDetail":"Visualizar detalhes do benefício >","Label_RedeemCode":"Código de resgate","Message_RedeemSuccess":"Resgatado com sucesso!","Message_RedeemVipSuccess_DesignKit":"Você resgatou sua assinatura VIP do Meitu Design Studio com sucesso!","Message_RedeemSvipSuccess_MeituXiuXiu":"Você resgatou sua assinatura Meitu SVIP com sucesso!","Placeholder_EnterInviteCode":"Insira o código de convite","Placeholder_EnterRedeemCode":"Insira o código de resgate","Title_CodeCenter":"Central de Cupons","Desc_SelectCodeType":"Selecione o tipo de código para verificar e resgatar","Title_InviteCodeDesc":"Instruções do código de convite","Title_RedeemCodeDesc":"Instruções do código de resgate","Text_InviteCodeIntro":"Insira o código de convite exclusivo que você recebeu nas redes sociais ou em outros canais:","Text_InviteCodeBenefit1":"Desconto de assinatura exclusivo do canal, com benefícios grátis por tempo limitado","Text_InviteCodeBenefit2":"Cada código de convite só pode ser usado uma vez.","Text_InviteCodeBenefit3":"Não pode ser combinado com outras promoções","Text_RedeemCodeIntro":"Use um código de resgate de assinatura obtido em canais oficiais:","Text_RedeemCodeBenefit1":"Faça login na sua conta e insira seu código de resgate para resgatar","Text_RedeemCodeBenefit2":"Após o resgate, você terá acesso aos benefícios e serviços de assinatura correspondentes","Text_RedeemCodeBenefit3":"Use o código de resgate antes que expire. Códigos expirados são inválidos e não reembolsáveis.","Text_InvoiceLink":"Este link pode ser usado para emitir faturas de ${0} pedidos","Text_InvoiceOtherBusiness":"Para faturas de outros serviços Meitu, siga a conta oficial do Serviço de Pagamento Meitu","Desc_ConsumeSoonExpiredMeidou":"Usar primeiro os créditos que expiram antes","Link_MeidouIntro":"Sobre os créditos","Text_NoMeidouGoToBuy":"Sem créditos. Compre agora!","Text_ThankYouSupport":"Obrigado pelo seu apoio. Continuaremos trazendo novos serviços para você.","Text_PurchaseBatchSuccess_MeituXiuXiu":"Você comprou créditos de processamento em lote da Meitu.","Text_PurchaseCutoutSuccess":"Você comprou downloads do Recorte do Meitu.","Label_BoundAccount":"Conta vinculada:","Text_PurchaseCount":"Quantidade da compra: ${0}","Label_TeamMemberExpiry":"Assinatura da equipe válida até:","Label_ProMemberExpiry":"Assinatura Premium válida até:","Label_StandardMemberExpiry":"Assinatura Standard válida até:","Text_PurchaseSeatCount":"Assentos comprados: ${0}","Button_GotItCountdown":"Entendi (${0}s)","Text_Trial":"Experimente ${0}","Text_OriginalPrice":"Preço Original ${0}","Text_PerSheet":"/imagem","Text_PerPersonPerMonth":"/Pessoa/Mês","Text_FreeTrialDays":"Teste grátis de ${0} dias","Text_FreeTrialMonths":"Teste grátis de ${0} mês","Text_FreeTrialQuarters":"Teste grátis de ${0} trimestres","Text_FreeTrialYears":"Teste grátis de ${0} ano","Text_ScanToBuy":"Escaneie com ${0} para comprar","Text_ScanToActivate":"Escaneie com ${0} para ativar","Text_AlsoSupportWechatBuy":"(Ou escaneie com o WeChat)","Text_AlsoSupportWechatActivate":"(Ou escaneie com o WeChat)","Text_ServiceAgreement_DesignKit":"Política de Assinatura do Meitu Design Studio","Text_ServiceAgreement_MeituXiuXiu":"Política de Assinatura do Meitu SVIP","Text_ServiceAgreement_Meidou":"Contrato de Recarga de Créditos","Text_ServiceAgreement_Cutout":"Contrato de Serviço de Recorte","Text_ServiceAgreement_BatchMeituXiuXiu":"Contrato de Serviço de Processamento em Lote do Meitu","Button_ClickLogin":"Entrar","Text_CheckAgreementFirst":"Primeiro, marque a caixa para concordar.","Text_LoadError":"Falha ao carregar","Button_ClickRefresh":"Toque para atualizar","Label_Pay":"Pagar:","Text_ExtendAfterPurchase":"Após a compra, a validade será estendida até: ${0}","Button_Agree":"Concordo","Title_ThankYouSubscription":"Obrigado por assinar!","Text_MemberServiceAgreement":"Serviço VIP","Title_PayFail":"Falha no pagamento","Button_RepayNow":"Tente novamente","Desc_OneYearValidTeam":"Válido por 1 ano. Só pode ser usado com sua equipe atual.","Text_SharedMeidouPrompt":"Para compartilhar créditos com mais de 5 pessoas,","Button_ActivateTeamMember":"Assinar plano de equipe","Text_SeatPurchaseEffect":"As vagas adicionais entram em vigor imediatamente e expiram em ${0} (na mesma data de expiração da assinatura de equipe ativa)","Label_Gift":"Bônus","Text_FirstMonthMeidouGift":"Assine para receber ${0} créditos no primeiro mês e ${1} créditos por mês depois disso. Válidos no mês atual.","Text_MonthlyMeidouGift":"Concedido mensalmente, válido no mês atual","Desc_TeamOnlyCutout":"Os créditos de download comprados só podem ser usados com sua equipe atual.","Text_DownloadDeductRule":"Cada download de imagem concluído consome 1 crédito de download.","Text_CutoutAdjustRule":"Ajuste seu recorte quantas vezes quiser. Os créditos de download só são descontados ao baixar.","Text_UnlimitedCutout":"Recortes ilimitados enquanto sua assinatura estiver ativa","Text_ValidityThreeMonths":"Validade: 3 meses","Text_ValidityOneYear":"Validade: 1 ano","Title_VipLimitedOffer":"Oferta especial VIP","Text_TeamSeatRequirement":"Sua equipe atual tem ${0} membros. Compre o número correspondente de assentos.","Text_TeamMemberSeatMinimum":"A assinatura de equipe começa a partir de ${0} assentos","Text_MeidouGiftPerMonth":"Créditos bônus: ${0}/mês","Label_SeatCount":"Assentos","Text_SeatOrderEffect":"Os assentos do novo pedido entrarão em vigor em ${0}. Para adicionar assentos imediatamente,","Button_ActivateMemberUnlimited":"Assine para ter acesso ilimitado","Button_BuyMember":"Assinar","Button_BuyCount":"Quantidade da compra","Text_BatchRemainingCount":"Imagens em lote restantes: ${0}","Label_RemainingCutout":"Recortes restantes:","Text_RemainingMeidouCount":"Restam ${0} créditos","Text_TeamMemberExpiry":"A assinatura da equipe expira em ${0}","Text_BoundPhoneAccount":"(Conta vinculada: ${0})","Button_ClickLoginRegister":"Toque para fazer login (inclui cadastro)","Text_LoginToBuyMember":"Faça login para assinar e manter suas criações VIP em segurança.","Text_LoginToBuy":"Faça login para comprar","Button_CorporateTransfer":"Transferência bancária corporativa","Button_ApplyInvoice":"Fatura","Button_InviteOrRedeemCode":"Ativar com código de convite/resgate","Button_RedeemCodeActivate":"Ativar com código de resgate","Text_MarchPromo":"Promoção de e-commerce de março: créditos em dobro na sua primeira recarga","Button_BackToBuy":"Voltar para a compra","Label_EstimatedConsumption":"Consumo estimado:","Text_ValidOneYear":"Válido por 1 ano","Text_PerMonth":"/mês","Desc_Monthly330Meidou":"330 créditos grátis mensais (válidos no mês atual), para usar em:","Text_UnitPrice1000":"Apenas ¥0,0532 por crédito","Text_Capacity1000":"Gere aproximadamente 500 imagens ou 66 vídeos","Text_SingleImageLow1000":"A partir de ¥0,176 por imagem","Text_SingleVideoLow1000":"A partir de ¥1,320 por vídeo (5 s)","Text_SingleImageYearly1000":"A partir de ¥0,106 por imagem","Text_SingleVideoYearly1000":"A partir de ¥0,798 por vídeo (5 s)","Text_UnitPrice1800":"Apenas ¥0,0462 por crédito","Text_Capacity1800":"Gere aproximadamente 900 imagens ou 120 vídeos","Text_SingleImageLow1800":"A partir de ¥0,164 por imagem","Text_SingleVideoLow1800":"A partir de ¥1,233 por vídeo (5 s)","Text_SingleImageYearly1800":"A partir de ¥0,092 por imagem","Text_SingleVideoYearly1800":"A partir de ¥0,693 por vídeo (5 s)","Text_UnitPrice3600":"Apenas ¥0,0437 por crédito","Text_Capacity3600":"Gere aproximadamente 1.800 imagens ou 240 vídeos","Text_SingleImageLow3600":"A partir de ¥0,154 por imagem","Text_SingleVideoLow3600":"A partir de ¥1,158 por vídeo (5 s)","Text_SingleImageYearly3600":"A partir de ¥0,087 por imagem","Text_SingleVideoYearly3600":"A partir de ¥0,656 por vídeo (5 s)","Text_UnitPrice7500":"Apenas ¥0,0410 por crédito","Text_Capacity7500":"Gere aproximadamente 3.750 imagens ou 500 vídeos","Text_SingleImageLow7500":"A partir de ¥0,138 por imagem","Text_SingleVideoLow7500":"A partir de ¥1,037 por vídeo (5 s)","Text_SingleImageYearly7500":"A partir de ¥0,082 por imagem","Text_SingleVideoYearly7500":"A partir de ¥0,615 por vídeo (5 s)","Desc_IncludesStandardAll":"Inclui todos os benefícios do Standard, além de:","Desc_MonthlyMeidou":"${0} créditos incluídos por mês (válidos no mês atual), utilizáveis para:","Text_FewCredits":"Créditos limitados","Label_BasicPlan":"Versão básica","Text_TrialMeidouGift":"120 créditos incluídos no teste grátis, válidos por 7 dias","Text_Monthly330MeidouBenefit":"Assine para receber 330 créditos por mês, válidos no mês atual.","Label_LimitedPrivilege":"Benefícios por tempo limitado","Text_SeedancePrivilege":"Geração lenta gratuita ilimitada com Seedance 2.0 e acesso antecipado a novos recursos","Label_MeidouPrefix":"Créditos:","Text_LoginToBuyMemberShort":"Faça login para comprar uma assinatura","Text_TeamMinimumSeat":"Sua equipe tem ${0} membros no momento. Você precisa comprar pelo menos ${0} licenças.","Message_AbnormalSubscriptionNoSeat":"Não é possível adicionar licenças a assinaturas de equipe com status de assinatura irregular.","Text_TeamMemberExpires":"Sua assinatura de equipe expirará em ${0}.","Text_ProMemberExpires":"Sua assinatura Premium expirará em ${0}.","Text_BasicMemberExpires":"Sua assinatura Basic expirará em ${0}.","Text_SvipMemberExpires_MeituXiuXiu":"Seu SVIP expirará em ${0}.","Text_ActivateVip_DesignKit":"Assine o VIP do Meitu Design Studio para aproveitar os benefícios de membro","Text_UpgradeToSvip_MeituXiuXiu":"Você já assina o Meitu VIP. Faça upgrade para o SVIP para aproveitar os serviços de design em diferentes dispositivos.","Text_ActivateTeamMember_DesignKit":"Assine a Assinatura de equipe para desbloquear os benefícios VIP do X-Design e recursos de colaboração em equipe","Text_ActivateMember":"Assine para aproveitar diversos benefícios de assinatura","Text_ActivateMember_MeituXiuXiu":"Assine para aproveitar os benefícios do Meitu VIP, do SVIP e da assinatura Meitu para desktop","Text_ExpiredDays_Team":"Expirou há ${0} dias. Compre agora para recuperar o acesso.","Text_VipExpiredDays_DesignKit":"Seu VIP expirou há ${0} dias. Boas-vindas de volta!","Text_VipExpiredDays_MeituXiuXiu":"Seu SVIP do Meitu expirou há ${0} dias. Boas-vindas de volta.","Text_ValidDays":"Válido por ${0} dias","Text_ValidWeeks":"Válido por ${0} semanas","Text_ValidMonths":"Válido por ${0} meses","Text_ValidQuarters":"Válido por ${0} trimestres","Text_ValidYears":"Válido por ${0} anos","Text_CountdownDays":"${0} dias ${1}","Label_Week":"Semana","Label_Quarter":"Trimestre","Desc_BatchCutoutConsumption":"Após usar o Recorte, baixar e salvar 1 imagem consome ${0} créditos. Outros recursos consomem ${1} créditos.","Text_TieredSeatBilling":"A assinatura inclui ${0} licenças. Usuários adicionais além de ${1} são cobrados a ${2}/ano/pessoa.","Text_PerYearPerPerson":"/ano/pessoa","Text_BoundAccountPrefix":"(Conta vinculada:","Text_BoundAccountSuffix":")","Title_GlobalSettingsMobile_Batch":"Configurações globais","Tip_ApplyToAllTasksBelowMobile_Batch":"Aplicar a todas as tarefas abaixo","Tip_UploadImagesFormatMobile_Batch":"Clique para enviar imagens JPEG/JPG/PNG de até ${0} MB. São aceitas até ${1} imagens.","Title_EcommerceTools":"Ferramentas de e-commerce","Title_MoreVideoTools":"Mais recursos de edição de vídeo","Text_AppMessageNotification_Batch":"Você receberá uma mensagem no app quando a tarefa for concluída.","Tool_ProductDemoVideoMaker":"Criador de demonstrações de produto","Tool_Video360Maker":"Gerador de vídeos em 360°","Tool_UnboxingVideoMaker":"Criador de vídeos de unboxing","Tool_FashionVideoMaker":"Criador de vídeos de moda","Tool_CommercialVideoMaker":"Criador de vídeos comerciais","Tag_Cover":"Capa","Option_ExportLayered_Psd":"Exportação em camadas","Option_ExportFlat_Psd":"Exportar sem camadas","Message_NoExportableLayer":"Nenhuma camada exportável selecionada","Message_UnsupportedLayerForPsd":"Este tipo de camada não é compatível com exportação em PSD.","Message_VideoLayerPsdBlocked":"Contém camadas de vídeo. Não é possível exportar PSD.","Message_ExportUnitsOverLimit":"A seleção excede ${0} itens de exportação","Message_LayerSplitRightDenied":"Benefícios sem separação de camadas","AiTemplate_Desc":"Insira um tema para o pôster ou descreva suas edições. A IA recriará este modelo e gerará um pôster com um clique.","AiTemplate_Upload":"Upload de elementos","AiTemplate_Upload_Desc":"Clique para enviar imagens de elementos e substituir imagens de produtos, modelos, códigos QR e muito mais.","AiTemplate_Prompt":"Tema do pôster/Detalhes da edição","AiTemplate_Prompt_Placeholder":"Insira um tema de pôster ou descreva o que deseja editar. Por exemplo: altere o tema para \'Umidade do Equinócio de Outono\'; substitua o XX na imagem pelo XX que enviei.","AiTemplate_Generate":"Gerar cartaz","Text_OpenClawInstallCmd":"Ajude-me a instalar ${0}","Text_SupportLinkImport":"Suporta a importação de links.","Text_ModifyLogoPrompt":"Ajude-me a modificar este logo","Text_ModifyImagePrompt":"Ajude-me a modificar esta imagem","Title_UserCenter":"Central pessoal","Button_Login":"Entrar","Button_Signup":"Criar conta","Title_FreeBackgroundRemoverOnline":"Removedor de fundo online gratuito","Title_RemoveThe":"Remova o fundo de imagens instantaneamente e automaticamente com Designkit. Além de ser grátis, não exige conhecimento de design.","Title_NoPic":"Não tem fotos? Experimente uma dessas.","Title_IndustryLeading":"Líder de qualidade em recortes de imagens","Title_GlobalRunner":"Vice-campeão mundial na competição CVPR 2024. Pesquisa inovadora publicada na AAAI e na CVPR.","Title_FastAnd":"Remoção de fundo rápida e perfeita","Title_SImplyUpload":"Carregue sua foto e o Designkit cuida do resto, da detecção do elemento principal à remoção do fundo, sem aprendizado ou etapas complicadas.","Title_FineTune":"Refine suas imagens com qualidade profissional","Titel_Whether":"Seja cabelo delicado, bordas de tecido ou sombras, o Designkit preserva os detalhes finos que realmente fazem a diferença. Você também pode ajustar com precisão as bordas e os cantos para obter um acabamento polido e profissional.","Title_FlawlessStamp":"Processamento impecável de carimbos e assinaturas","Title_RemoveDull":"Remova fundos desbotados e sem contraste de assinaturas e carimbos. Designkit detecta os detalhes de cada elemento e os prepara para qualquer layout, em PNG transparente ou com fundo sólido.","Title_PerfecCutouts":"Recortes perfeitos para qualquer finalidade","Title_GetFlawless":"Remova o fundo de qualquer tipo de imagem com perfeição.","Button_ECommerco":"E-commerce","Button_Portraits":"Retratos","Button_Pets":"Animais de estimação","Button_LogoSignaure":"Logotipo e assinatura","Title_HowTo":"Como faço para remover o fundo de uma imagem?","Title_UploadYour":"Carregue a sua imagem","Title_ChooseAn":"Escolha no seu aparelho uma imagem em JPEG, PNG, ou WEBP.","Title_AIRemoves":"A IA remove o fundo","Title_AiEditor":"A ferramenta de edição com IA identifica o elemento principal e remove o fundo.","Title_EditOrExport":"Edite ou exporte","Title_DownloadOr":"Baixe sua imagem ou use o editor integrado para editá-la.","Title_FrequentlyAskedQuestions":"Perguntas Frequentes","Title_IsThis":"Essa ferramenta é grátis?","Answer_IsThis":"Sim, o removedor de fundo de imagens do Designkit é uma ferramenta gratuita para remoção de fundos.","Title_CanIChange":"Posso mudar o fundo de uma imagem após fazer o recorte?","Title_WhichImage":"Quais formatos de imagem podem ser usados para o recorte?","Title_CanIManually":"Posso ajustar manualmente um resultado impreciso?","Answer_CanIchange":"Sim, quando o recorte é finalizado, você pode selecionar diretamente uma cor sólida ou gradiente, ou adicionar uma imagem personalizada como novo fundo utilizando Designkit. Esta é uma operação simples, flexível e totalmente personalizável.","Answer_WhichImage":"Designkit aceita o carregamento de formatos populares como JPG, PNG e WEBP. Também é possível exportar o recorte final como PNG transparente para integrá-lo facilmente aos seus outros projetos de design.","Answer_CanIManually":"Com certeza. Caso as bordas não fiquem perfeitas após o reconhecimento automático, você poderá usar o editor integrado para refiná-las manualmente como desejar.","Button_Reupload":"Carregar novamente","Button_Download":"Baixar","Button_Edit_Refine":"Refinar","Button_Edit_Backgrounds":"Fundos","Button_Edit_Crop":"Cortar","Button_Edit_Edges":"Bordas","Button_Edit_Filter":"Filtros","Pop_Download_Freetip":"Livre","Pop_Download_UHD":"Resolução máxima","Pop_Download_preview":"Pré-visualizar","Guid_More_ColorPanel":"Todas","Button_Remove_ColorPanel":"Remover","Button_Upload_ColorPanel":"Carregar","Size_Original_SizePanel":"Tamanho original","Button_Upload_Batch":"Carregamento em Lote","Desc_Upload":"Clique ou arraste para carregar ou cole arquivos.","SubTitle_Header1_Home":"Gerador com IA p/catálogo","SubTitle_Header2_Home":"Gerador de cartazes com IA","SubTitle_Header3_Home":"Gerador de vídeos de produtos com IA","SubTitle_Header4_Home":"Gerador de fotos de produtos com IA","SubTitle_Header5_Home":"Design visual de sites com IA","SubTitle_Header6_Home":"Provador virtual","SubTitle_Header7_Home":"Design de páginas detalhadas de produtos com IA","SubTitle_Header8_Home":"Editor de fotos com IA","SubTitle_Header9_Home":"Aprimorador de imagens","SubTitle_Header10_Home":"Removedor de objetos","SubTitle_Header11_Home":"Removedor de fundo com IA","SubTitle_Header12_Home":"Gerador de fundo com IA","SubTitle_Header13_Home":"Redimensionador de imagens","SubTitle_Header14_Home":"Adicionar texto à imagem","SubTitle_Header15_Home":"Gerador de Imagens com IA","SubTitle_Header16_Home":"Editor de fotos em lote","Size_ToEdge":"Até a borda","Pop_Download_UHD_LimitTip":"Tempo limite · ${0}","Before_Text":"Antes","After_Text":"Depois","Button_OpenVipFreeDownloadPsd":"Assine para baixar PSD gratuitamente","Text_LogoSlogan_DesignKit":"Crie designs comerciais incríveis que geram resultados","LogoDesign_ModeTitle":"Escolha o que você quer gerar","LogoDesign_ModeFast":"Logo rápido","LogoDesign_ModeFastDesc":"Geração rápida, apenas informações essenciais.","LogoDesign_ModePro":"Design de Logo e Visual","LogoDesign_ModeProDesc":"Conceitos de Estratégia e Pré-visualização em Cenário Real","LogoDesign_Essentials":"Informações da marca","LogoDesign_BrandNamePlaceholder":"Nome da marca (Obrigatório)","LogoDesign_IndustryPlaceholder":"Indústria (Obrigatório)","LogoDesign_Description":"Descrição","LogoDesign_DescriptionPlaceholder":"Descreva a história da sua marca, slogan, público-alvo ou elementos específicos que você quer no seu logotipo...","LogoDesign_MoreSettings":"Configurações","LogoDesign_LogoType":"Tipo de logo","LogoDesign_StyleCount":"Estilo e quantidade","LogoDesign_Model":"Modelo de geração de imagens","LogoDesign_BrandColors":"Cores da marca","LogoDesign_AutoColor":"Cor automática","LogoDesign_DragUpload":"Arraste ou clique para enviar","LogoDesign_DragUploadHint":"Formatos PNG, JPG e WEBP são compatíveis. Envie uma imagem nítida.","LogoDesign_UploadingImage":"Carregando...","LogoDesign_ReplaceImage":"Alterar imagem","LogoDesign_ReferenceDimensions":"Tamanho de referência","LogoDesign_GenerateLogos":"Gerar logotipo","LogoDesign_GenerateExpressLogos":"Gerar 8 logotipos","LogoDesign_GenerateConcepts":"Gerar propostas de conceito","LogoDesign_Processing":"Gerando...","LogoDesign_StrategyTitle":"Escolha uma direção","LogoDesign_StrategyDesc":"Selecione uma direção estratégica antes de gerar o logotipo final.","LogoDesign_RegenerateStrategies":"Tentar outra estratégia","LogoDesign_SelectStrategy":"Escolha uma estratégia","LogoDesign_GenerationHistory":"Histórico de Geração","LogoDesign_NoHistory":"Ainda não há histórico de geração.","LogoDesign_EditInAgent":"Editar no Agent","LogoDesign_GenerateMockups":"Gerar mockup","LogoDesign_SelectMockupType":"Selecione o tipo de mockup","LogoDesign_VoteLike":"Curtir","LogoDesign_VoteDislike":"Não gostei","LogoDesign_HeroTitlePro":"Identidade visual profissional de marca.","LogoDesign_HeroDescPro":"De conceitos centrais a aplicações em múltiplos cenários, crie um sistema de marca unificado.","LogoDesign_HeroTitleExpress":"Solução de logo com IA","LogoDesign_HeroDescExpress":"Explore 8 estilos visuais diferentes em uma única geração.","LogoDesign_Items":"Projeto","LogoDesign_UntitledBrand":"Marca sem título","LogoDesign_NoStrategy":"Nenhuma estratégia selecionada","LogoDesign_StrategyBadge":"Opção","LogoDesign_Inspiration":"Inspiração","LogoDesign_MockupGridPlaceholder":"Cenas de coleção de mockups geradas por IA","LogoDesign_ValidationBrand":"Insira um nome de marca","LogoDesign_ValidationIndustry":"Selecione ou insira um setor","LogoDesign_ValidationStrategy":"Selecione uma estratégia primeiro.","LogoDesign_ValidationMockup":"Selecione pelo menos um tipo de mockup","LogoDesign_Style_Minimalist":"Minimalista","LogoDesign_Style_Vintage":"Retrô","LogoDesign_Style_Geometric":"Geometria","LogoDesign_Style_Abstract":"Abstrato","LogoDesign_Style_HandDrawn":"Pintado à mão","LogoDesign_Style_Luxury":"Luxo","LogoDesign_Style_Tech":"High-tech","LogoDesign_Style_Nature":"Diário","LogoDesign_LogoType_IconText":"Ícone + Texto","LogoDesign_LogoType_TextOnly":"Apenas texto","LogoDesign_LogoType_IconOnly":"Apenas ícone","LogoDesign_LogoType_Lettermark":"Logo de letra","LogoDesign_LogoType_Emblem":"Logo em distintivo","LogoDesign_LogoType_Mascot":"Mascote","LogoDesign_MockupType_BusinessCard":"Cartão de visita","LogoDesign_MockupType_Signage":"Letreiro da loja","LogoDesign_MockupType_Packaging":"Pós-produção","LogoDesign_MockupType_Shirt":"Camiseta","LogoDesign_MockupType_ToteBag":"Bolsa tote","LogoDesign_MockupType_Sticker":"Adesivos","LogoDesign_MockupType_OfficeSupplies":"Materiais de escritório","LogoDesign_MockupType_AppIcon":"Ícone do aplicativo","LogoDesign_AddColor":"Adicionar cor","LogoDesign_ReferenceDimension_Graphics":"Gráficos","roboneo_agent_queue_tier_fast_description":"Gere instantaneamente. Os créditos são cobrados por geração.","roboneo_agent_queue_tier_relax_description":"Geração gratuita ilimitada, com velocidade um pouco menor. Sem usar créditos.","roboneo_agent_queue_tier_relax_locked_description":"Benefício do ${0} — Gere gratuitamente sem usar créditos.","roboneo_agent_queue_tier_upgrade_unlock":"Fazer upgrade para desbloquear","Button_UpgradeForFree":"Fazer upgrade gratuitamente","Label_Teams":"Equipes","Title_AiModelAccess_Pricing":"Acesso ao modelo por IA","Text_LimitedAiModels_Pricing":"Modelos de vídeo e imagem limitados","Label_GptImage2_Pricing":"GPT Image 2.0","Label_NanoBananaPro_Pricing":"Nano Banana Pro","Label_NanoBanana2_Pricing":"Nano Banana 2","Label_GeminiOmniFlash_Pricing":"Gemini omni Flash","Label_Seedance2Mini_Pricing":"Seedance2.0 Mini","Label_Seedance2Fast_Pricing":"Seedance 2.0 Fast","Label_Kling26_Pricing":"Kling 2.6","Label_Veo31_Pricing":"Veo 3.1","Label_Sora2_Pricing":"Sora 2","Label_Midjourney_Pricing":"Midjourney","Label_Seedance25ComingSoon_Pricing":"Seedance 2.5 (Em breve)","Label_Seedream50Pro_Pricing":"Seedream 5.0 Pro","Label_NanoBanana_Pricing":"Nano Banana","Label_Seedream40_Pricing":"Seedream 4.0","Label_SeedEdit30_Pricing":"SeedEdit 3.0","Tab_VideoObjectRemover":"Remoção em vídeo","Text_WholeProductGuide_DomesticCloneCase":"Envie uma imagem de produto mais vendido como referência e recrie facilmente o mesmo estilo","Text_ApparelGuide_DomesticCloneCase":"Envie uma imagem de moda em alta como referência e recrie o look com facilidade","Text_PosterCoverGuide_DomesticCloneCase":"Carregue uma imagem de pôster em alta como referência e recrie o visual facilmente","Text_SocialGraphicsGuide_DomesticCloneCase":"Carregue uma imagem em alta nas redes sociais como referência e recrie o visual com facilidade.","TaskName_WholeProductClone_DomesticCloneCase":"Copo térmico verde-menta com estampa de gatos","TaskName_ApparelClone_DomesticCloneCase":"Camisa floral com gola Peter Pan para meninas","TaskName_PosterCoverClone_DomesticCloneCase":"Pôster de guia gastronômico de Shunde","TaskName_SocialGraphicsClone_DomesticCloneCase":"Guia de viagem de Jingdezhen","Label_SwitchToPage":"Mudar para a página ${0}","File_Mention_Upload_Text":"Adicionar do dispositivo","File_Mention_Empty_Text":"Você ainda não enviou nada","Empty_Agent_Canvas_Text":"Canvas com IA","Empty_Agent_Canvas_Description":"Gere com IA. Criatividade sem limites.","Label_Height":"Altura","Label_Width":"Largura","Agent_Guide_Placeholder_Title":"Comece agora, crie livremente","Agent_Guide_Placeholder_Agent_Title":"Agente de chat","Agent_Guide_Placeholder_Agent_Subtitle":"Criar do zero","Agent_Guide_Placeholder_Upload_Subtitle":"Editar imagem existente","Label_Text_Then":"Depois","Meta_Title_LogoDesign":"Design profissional de logotipos simplificado com o Zawa AI","Title_AppEnhancer":"Aprimoramento de vídeo por IA","Desc_AppEnhancer":"Aprimore para 4K HD com um clique, com mais qualidade e taxa de quadros.","Title_AppWatermarkRemover":"Removedor de marcas d\'água e legendas de vídeo","Desc_AppWatermarkRemover":"Remova rapidamente marcas d\'água e logotipos de vídeos.","Title_AppBackgroundRemover":"Removedor de fundo de vídeo","Desc_AppBackgroundRemover":"Remova fundos de vídeos com um clique, sem precisar se cadastrar.","Title_VideoDemos":"Experimente estes vídeos","Button_DownloadPreview":"Baixar prévia de 5 segundos","Text_PreviewDownloading":"Baixando vídeo de 5 segundos...","Title_PreviewVideo":"Vídeo de prévia de 5 segundos","Title_FullVideo":"Vídeo completo","Button_DownloadFull":"Baixar vídeo completo","Text_FullDownloading":"Baixando vídeo completo...","Tip_FullVideoReady":"Seu vídeo completo está pronto para download.","Tip_Processing":"O processamento pode levar algum tempo. Não atualize a página. Volte mais tarde.","Tip_ProcessComplete":"Processamento concluído. Toque para salvar o vídeo no seu celular.","Tag_Purchased":"Comprado","Text_Uploading":"Carregando...","Message_ProcessFailed":"Falha ao processar o vídeo.","Button_UploadVideo":"Enviar vídeo","Text_SupportFormat":"Formatos compatíveis: ${0}","Button_UploadNew":"+ Enviar novo vídeo","Message_ProcessFailedRetry":"Falha ao processar o vídeo. Verifique sua conexão de rede e tente novamente.","Tip_MaxProcessNum":"Até ${0} vídeos podem ser processados de uma vez. Tente novamente mais tarde.","Tip_MaxUploadNum":"Você pode enviar até ${0} arquivos de vídeo por vez.","Message_VideoLoadFailed":"Falha ao carregar o vídeo","Tip_VideoResolutionLimit":"Vídeos com resolução superior a 4K não são compatíveis.","Tip_VideoDurationLimit":"O vídeo excede o limite. Mantenha a duração abaixo de 20 minutos.","Tip_VideoSizeLimit":"O vídeo é muito grande. Envie um vídeo com menos de ${0} MB.","Tip_VideoFormatLimit":"Formatos de vídeo compatíveis: ${0}. Envie um vídeo em um formato compatível.","Tip_Done":"Concluído","Text_IsProMember":"Você é assinante PRO.","Text_SubscribeToUnlock":"Assine para desbloquear.","Button_Enhance":"Começar a aprimorar","Button_Remove":"Iniciar","Text_Enhancing":"Aprimorando...","Text_EnhancingFull":"Aprimorando o vídeo completo...","Text_Removing":"Removendo...","Text_RemovingFull":"Removendo do vídeo completo...","Text_RemovingSelectedArea":"Removendo a área selecionada...","Tag_Enhanced":"Melhorado","Tag_Removed":"Removido","Tag_Preview":"Pré-visualização de 5 segundos","Label_SelectResolution":"Selecionar Resolução","Message_DownloadFailed":"Falha ao baixar. Verifique sua conexão com a Internet e tente novamente.","Message_DownloadFailedRetry":"Falha ao baixar. Tente baixar novamente.","Tab_Smart":"Reconhecimento inteligente","Tab_Watermark":"Marca d\'água","Tab_Subtitle":"Legendas","Tab_Manual":"Manual","Label_BoxItem":"Selecione a área que deseja remover","Tip_ClearManualBoxOnSwitch":"Mudar de modo limpará a seleção","Label_Multiplier":"${0}x","Label_Resolution1K":"1K","Label_Resolution2K":"2K","Label_Resolution4K":"4K","Title_ConfirmVideoRights":"Confirme que você tem o direito de usar este vídeo.","Desc_ConfirmVideoRights":"Não faça upload ou importe nenhum conteúdo que você não possua ou não esteja legalmente autorizado a usar. Ao clicar em \\"Confirmar\\", você confirma que possui este conteúdo e que nenhum dos itens a seguir infringirá direitos de terceiros ou violará as leis aplicáveis: (i) O conteúdo em si; (ii) Seu uso dos nossos serviços; ou (iii) Nosso uso do conteúdo para fornecer os serviços solicitados por você.","Button_Import":"Importar","Title_ImportVideoLink":"Importe o link do seu vídeo","Label_ConfirmContentPermission":"Ao enviar o link, confirmo que sou proprietário deste conteúdo.","Placeholder_VideoLink_WatermarkRemover":"Insira um link de vídeo para remover a marca d\'água...","Placeholder_VideoLink_SocialPlatforms":"Compatível com links do TikTok, IG, YouTube e Facebook","Placeholder_VideoLink_SocialPlatforms_Domestic":"Compatível com links do Douyin, Kuaishou, Xiaohongshu e TikTok","Tip_InvalidLink":"Importe um link válido","Tip_LinkImportFailed":"Falha ao importar. Tente novamente.","Text_FileFromLink":"Arquivo vinculado ${0}","Text_LinkImporting":"Importando ${0}%","Button_Batch":"Lote","Button_Link":"Link","Title_MobileBatchUnsupported":"O processamento em lote ainda não é compatível com dispositivos móveis.","Text_VisitOnDesktop":"Abra em um computador:","Button_CopyAddress":"Copiar","Text_UploadDropPasteClick":"Arraste e solte, cole ou clique para enviar","Text_UploadDropPasteClick_Support":"Compatível com .mp4, .mov e m4v","Tips_UploadMaxVideoCountLimit":"Envie até ${0} arquivos de vídeo","Title_AILogoDesign":"Design de Logo com IA","Title_AILogoPreview":"Design de Logo com IA","Message_IndustryLoadFailed":"Falha ao carregar os dados do setor","Message_LogoResultPartialFailed":"Falha ao recuperar alguns resultados de geração de logo","Label_LogoGenerateMode":"Modo de geração de logo","Tab_GeneralMode":"Modo Geral","Desc_StrongerLogoModel":"Com tecnologia de um modelo mais poderoso para criar logos de maior qualidade","Button_CloseTip":"Dispensar dica","Label_LogoName":"Nome do logo","Label_LogoSlogan":"Subtítulo/Slogan","Label_Optional":"Opcional","Placeholder_LogoDescription":"Descreva o tom da marca, palavras-chave de estilo, casos de uso etc.","Title_AIServiceStatement":"Declaração de Serviço de IA","Label_LogoCreateGuide":"Guia de criação de logo","Title_StartCreateLogo":"Comece a criar seu logotipo","Desc_CreateLogoSchemes":"Insira as informações da marca à esquerda para gerar ${0} opções selecionadas","Text_FillBrandInfo":"Insira as informações da marca","Text_SelectGenerateMode":"Selecione o modo de geração","Text_GetLogoScheme":"Gerar designs de Logo","Label_AILogoPreview":"Pré-visualização ampliada do logo por IA","Button_ClosePreview":"Desativar pré-visualização","Label_AILogoLarge":"Imagem grande de logo gerada por IA","Button_PreviousLogo":"Ver Logo anterior","Button_NextLogo":"Ver próximo Logo","Button_ScrollThumbnailsLeft":"Rolar miniaturas para a esquerda","Label_LogoPreviewList":"Lista de pré-visualizações de Logos","Button_SwitchLogo":"Trocar para este Logo","Button_ScrollThumbnailsRight":"Rolar miniaturas para a direita","Message_LogoDownloadFailed":"Falha ao baixar o Logo. Tente novamente mais tarde.","Label_LogoGenerateResult":"Resultados de Logo","Title_GenerateResult":"Resultados:","Button_WatermarkPreference":"Definir preferências de marca d\'água para download","Button_SelectLogo":"Selecionar este logotipo","Text_LogoGenerating":"Gerando logo...","Message_LogoGenerateFailedRetry":"Falha na geração. Tente novamente.","Label_AIGeneratedLogo":"Logo gerado por IA","Button_EditLogo":"Editar este logotipo","Button_DownloadLogo":"Baixar este logotipo","Button_PreviewLogo":"Pré-visualizar este Logo","Message_RecordLoadFailed":"Falha ao carregar o histórico de geração","Message_MoreRecordsLoadFailed":"Falha ao carregar mais registros","Message_LogoBatchDownloadFailed":"Falha ao baixar logos em lote. Tente novamente mais tarde.","Label_RecordLoading":"Carregando histórico...","Label_LogoRecords":"Histórico de logos","Label_GenerateMode":"Modo de geração","Text_GenerateTime":"Data/hora da geração: ${0}","Button_ZoomLogo":"Ver Logo em tela cheia","Text_NoMoreRecords":"Não há mais registros","Message_GenerateTaskSubmitted":"Tarefa de geração enviada","Message_LogoGenerateFailed":"Falha ao gerar o logo. Tente novamente mais tarde.","Button_QuickGenerate":"Gerar rápido","Label_GenerateViral_ViralVideo":"Gerar viral","Label_ReplicateViral_ViralVideo":"Replicar viral","Message_SelectMarket_ViralVideo":"Por favor, selecione um mercado alvo","Message_SelectLanguage_ViralVideo":"Por favor, selecione o idioma do vídeo","Message_SelectRatio_ViralVideo":"Por favor, selecione a proporção da plataforma","Message_FillScript_ViralVideo":"Por favor, preencha o script personalizado","Message_SetScriptCount_ViralVideo":"Por favor, defina a quantidade de geração do script personalizado","Message_SelectViralType_ViralVideo":"Por favor, selecione pelo menos um tipo viral","Message_MaxViralTypes_ViralVideo":"O total de tipos virais não pode exceder ${0}","Message_InputTaskTitle_ViralVideo":"Por favor, insira o título da tarefa","Message_FillSellingPoints_ViralVideo":"Por favor, preencha a descrição dos pontos de venda","Message_ProductImageShortEdgeLimit_ViralVideo":"Envie uma imagem com o lado menor superior a 300px","Message_ProductImageAspectRatioSuggestion_ViralVideo":"Recomendamos enviar uma imagem 16:9, 9:16 ou 1:1","Message_UploadRefVideo_ViralVideo":"Por favor, envie o vídeo de referência","Message_TaskCancelled_ViralVideo":"Tarefa cancelada","Text_GenerateTaskTitle_ViralVideo":"Gerar tarefa viral ${0}","Text_ReplicateTaskTitle_ViralVideo":"Replicar tarefa viral ${0}","Text_TaskCopyTitle_ViralVideo":"${0}-Cópia","Message_FetchConfigFailed_ViralVideo":"Falha ao obter configuração de inicialização viral","Title_VideoResult_ViralVideo":"Resultado do vídeo","Text_AiGenerating_ViralVideo":"IA gerando...","Text_CheckingSellingPoints_ViralVideo":"Verificando conteúdo...","Label_EmailNotify_ViralVideo":"Notifique-me por e-mail quando estiver pronto","Title_LinkEmail_ViralVideo":"Vincule um endereço de e-mail","Text_LinkEmailDesc_ViralVideo":"Sua conta ainda não tem um endereço de e-mail. Vincule um na Central da conta e volte para ativar as notificações por e-mail.","Text_LinkEmailRedirect_ViralVideo":"Você será redirecionado para a Central da conta para concluir a vinculação e verificação do e-mail.","Button_GoToAccountCenter_ViralVideo":"Ir para a Central da conta","Title_EmailNotifyConfirm_ViralVideo":"Receber notificações por e-mail?","Text_EmailNotifyConfirm_ViralVideo":"Avisaremos ${0} quando seus vídeos estiverem prontos.","Message_EmailLinked_ViralVideo":"E-mail vinculado. Ative as notificações se quiser ser avisado quando este vídeo estiver pronto.","Message_EmailNotifyOff_ViralVideo":"Notificações por e-mail desativadas","Message_EmailNotifyOn_ViralVideo":"Notificações por e-mail ativadas","Text_NoHistory_ViralVideo":"Sem registros de histórico","Text_MobileGuideGenerate_ViralVideo":"Envie imagens do produto e pontos de venda para criar rapidamente vídeos virais para promoção.","Text_MobileGuideReplicate_ViralVideo":"Envie imagens do produto e um vídeo de referência para replicar o ritmo e o estilo visual de um vídeo viral.","Label_DKGenerateViralMobileGuideNavTitle_ViralVideo":"Gerar viral","Label_DKGenerateViralMobileGuideTitle_ViralVideo":"Gerar viral","Text_DKGenerateViralMobileGuideSubtitle_ViralVideo":"Envie imagens do produto e pontos de venda para criar rapidamente vídeos virais para promoção.","Label_DKReplicateViralMobileGuideNavTitle_ViralVideo":"Replicar viral","Label_DKReplicateViralMobileGuideTitle_ViralVideo":"Replicar viral","Text_DKReplicateViralMobileGuideSubtitle_ViralVideo":"Envie imagens do produto e um vídeo de referência para replicar o ritmo e o estilo visual de um vídeo viral.","Label_ZawaGenerateViralMobileGuideNavTitle_ViralVideo":"Gerar viral","Label_ZawaGenerateViralMobileGuideTitle_ViralVideo":"Gerar viral","Text_ZawaGenerateViralMobileGuideSubtitle_ViralVideo":"Envie imagens do produto e pontos de venda para criar rapidamente vídeos virais para promoção.","Label_ZawaReplicateViralMobileGuideNavTitle_ViralVideo":"Replicar viral","Label_ZawaReplicateViralMobileGuideTitle_ViralVideo":"Replicar viral","Text_ZawaReplicateViralMobileGuideSubtitle_ViralVideo":"Envie imagens do produto e um vídeo de referência para replicar o ritmo e o estilo visual de um vídeo viral.","Button_ConfirmGenerate_ViralVideo":"Confirmar geração","Button_Close_ViralVideo":"Fechar","Button_Previous_ViralVideo":"Anterior","Button_Next_ViralVideo":"Próximo","Message_CreateTaskFailed_ViralVideo":"Falha ao criar tarefa, tente novamente mais tarde","Message_RefreshFailed_ViralVideo":"Falha ao atualizar, tente novamente mais tarde","Message_VideoFormatLimit_ViralVideo":"O vídeo de referência atualmente suporta apenas mp4 / mpeg / mov / avi / flv / mpg / webm","Message_ReferenceVideoSizeLimit_ViralVideo":"O tamanho do vídeo de referência não pode exceder ${0}MB","Message_UploadRefVideoFirst_ViralVideo":"A replicação viral requer enviar um vídeo de referência primeiro","Message_FillProductInfo_ViralVideo":"Por favor, preencha os pontos de venda do produto","Message_SelectVideoType_ViralVideo":"Por favor, selecione o tipo de vídeo e a quantidade","Button_Disabled_ViralVideo":"Desativar","Text_LoadingCreator_ViralVideo":"Carregando meus criadores…","Text_NoCreatorYet_ViralVideo":"Ainda não há imagem de criador, tente enviar uma","Text_TotalCount_ViralVideo":"(Total ${0})","Text_Submitting_ViralVideo":"Enviando...","Text_LoadingConfig_ViralVideo":"Carregando configuração…","Button_Decrease_ViralVideo":"Diminuir","Button_Increase_ViralVideo":"Aumentar","Title_NightHosted_ViralVideo":"Hospedado noturno","Message_CreatorGenSuccess_ViralVideo":"Criador gerado com sucesso","Button_ContinueNewTask_ViralVideo":"Continuar nova tarefa","Text_CustomScriptCount_ViralVideo":"Script personalizado × ${0}","Text_ViralTypeCount_ViralVideo":"Tipos virais × ${0}","Text_FissionCount_ViralVideo":"Fissão viral × ${0}","Text_AiModelEnabled_ViralVideo":"Modelo de IA ativado","Label_ModelTab_ViralVideo":"Aba de modelos","Label_ModelParams_ViralVideo":"Parâmetros do modelo","Text_ParamsAdjusted_ViralVideo":"Parâmetros ajustados separadamente","Text_NoSellingPoints_ViralVideo":"Descrição de pontos de venda não preenchida","Message_FillSellingPointsPlease_ViralVideo":"Por favor, adicione a descrição dos pontos de venda","Message_ThanksForFeedback_ViralVideo":"Obrigado pelo feedback!","Title_AdditionalFeedback_ViralVideo":"Feedback adicional","Placeholder_FeedbackBetter_ViralVideo":"O que poderia ser melhor?","Button_SubmitFeedback_ViralVideo":"Enviar feedback","Button_LikeFeedback_ViralVideo":"Curtir","Button_DislikeFeedback_ViralVideo":"Não curtir","Text_ProductImageCount_ViralVideo":"${0} imagem(ns) de produto","Text_RefVideoCount_ViralVideo":"${0} vídeo(s) de referência","Text_FollowGlobal_ViralVideo":"Seguindo configurações globais","Message_BatchSubmitSuccess_ViralVideo":"Tarefas em lote de vídeo viral enviadas com sucesso, total ${0}","Message_BatchSubmitFailed_ViralVideo":"Falha no envio em lote de vídeos virais, tente novamente mais tarde","Text_MaxSelectionTip_ViralVideo":"Até ${0} tipos de vídeo podem ser selecionados por vez","Text_DeselectItem_ViralVideo":"Desmarcar ${0}","Text_SelectItem_ViralVideo":"Selecionar ${0}","Tab_CustomCreatorSection_ViralVideo":"Criador personalizado","Tab_MyCreatorSection_ViralVideo":"Meu criador","Tab_PersonalAssets_ViralVideo":"Recursos pessoais","Tab_OfficialRecommendation_ViralVideo":"Recomendações oficiais","Title_CustomCreatorSection_ViralVideo":"Personalizar criador exclusivo","Text_InProgress_ViralVideo":"Gerando...","Text_NothingToDownload_ViralVideo":"Nenhum resultado disponível para download no momento","Text_ResultNotReady_ViralVideo":"O resultado atual ainda não está disponível para download","Text_PreparingDownload_ViralVideo":"Preparando download...","Text_PreDownloaded_ViralVideo":"Processamento concluído. Toque para salvar o vídeo no seu telefone.","Message_RedoSubmitted_ViralVideo":"Refazer enviado","Message_RedoFailed_ViralVideo":"Falha ao refazer, tente novamente mais tarde","Text_CancelHostedConfirm_ViralVideo":"Após cancelar a hospedagem, os resultados que estão sendo gerados atualmente serão interrompidos.","Button_Later_ViralVideo":"Mais tarde","Message_HostedCancelled_ViralVideo":"Hospedagem cancelada","Text_BatchFailed_ViralVideo":"Os resultados do lote atual não foram retornados, você pode regenerar mais tarde.","Title_ViralTypeConfig_ViralVideo":"Configuração de tipos virais (Total ${0})","Title_ReplicateConfig_ViralVideo":"Configuração de replicação","Label_ReplicateCount_ViralVideo":"Quantidade de replicações","Label_StylePreference_ViralVideo":"Preferência de estilo","Placeholder_StylePreference_ViralVideo":"Você pode especificar preferências como ritmo, humor, linguagem de câmera, atmosfera da paleta de cores, etc.","Label_SupplementNote_ViralVideo":"Notas adicionais","Placeholder_SupplementNote_ViralVideo":"Adicione estruturas que não deseja alterar, planos que devem ser preservados, requisitos especiais de pontos de venda, etc.","Text_FourthSection_ViralVideo":"4. Quantidade de fissão","Message_RequestFailed_ViralVideo":"Falha na solicitação","Message_PromptOptimizeFailed_ViralVideo":"Falha na otimização do prompt, tente novamente mais tarde","Message_ModelImageFailed_ViralVideo":"Falha ao gerar imagem do modelo, tente novamente mais tarde","Desc_BatchGenerateViral_ViralVideo":"Faça upload em lote de imagens de produto, configure pontos de venda e gere tarefas de vídeo viral.","Desc_BatchReplicateViral_ViralVideo":"Faça upload em lote de imagens de produto e adicione vídeos de referência para cada tarefa para replicar conteúdo viral.","Text_RecordRetentionTip_ViralVideo":"Os registros de geração são mantidos por apenas 2 meses. Por favor, baixe e salve-os o quanto antes para evitar perda.","Message_PromptOptimizeEmpty_ViralVideo":"O resultado da otimização do prompt está vazio","Message_CompleteModelInfo_ViralVideo":"Por favor, complete as informações do modelo primeiro","Message_ModelGenFailed_ViralVideo":"Falha ao gerar modelo, tente novamente mais tarde","Text_VideoFormatSupport_ViralVideo":"O vídeo de referência atualmente suporta apenas os formatos mp4 / mpeg / mov / avi / flv / mpg / webm / wmv / 3gpp","Message_UnsupportedVideoFiltered_ViralVideo":"Alguns formatos de vídeo não são suportados e foram filtrados automaticamente","Message_FreeTrialOneVideoOnly_ViralVideo":"O teste grátis cobre apenas 1 vídeo. Faça upgrade para o Pro para gerar mais.","Button_AddToMyCreator_ViralVideo":"Adicionar ao meu criador","Button_ResetGlobal_ViralVideo":"Redefinir para global","Button_TaskLevelCustomCreator_ViralVideo":"Criador personalizado de nível de tarefa","Button_TaskLevelReplicateModel_ViralVideo":"Modelo de réplica de nível de tarefa","Label_ModelReference_ViralVideo":"Imagem de referência do modelo","Placeholder_CreatorStyle_ViralVideo":"Adicione requisitos de personalidade do criador, estilo de fala, presença em câmera, etc.","Text_CreatorDisabledTip_ViralVideo":"Quando a configuração do criador não está ativada, o sistema gerará usando o estilo geral padrão em câmera.","Text_GenerateViralResult_ViralVideo":"Gerar resultados virais","Text_OverrideCount_ViralVideo":"Substituir ${0} item(ns)","Text_ReplicateViralResult_ViralVideo":"Resultados de replicação viral","Text_SavedCreatorProfiles_ViralVideo":"Configurações de criador salvas, podem ser preenchidas com um clique.","Label_GenerateScheme_ViralVideo":"Plano de geração viral ${0}","Label_ReplicateScheme_ViralVideo":"Plano de replicação viral ${0}","Text_VideoResult_ViralVideo":"Resultado do vídeo","Button_ContinueGenerate_ViralVideo":"Continuar gerando","Desc_CreatorImageEmptyHint_ViralVideo":"As imagens de criador geradas aparecerão aqui para reutilização direta nesta página.","Text_ItemCountUnit_ViralVideo":"${0} itens","Text_CreditAmount_ViralVideo":"${0} créditos","Text_TotalItems_ViralVideo":"Total: ${0}","Text_SelectedVideoTypeCount_ViralVideo":"${0} tipos de vídeo selecionados","Text_FirstVideoDiscountBadge_ViralVideo":"Desconto no primeiro vídeo","Text_DesignKitFirstDiscountVipBadge_ViralVideo":"50% de desconto no 1º","Text_DesignKitFirstDiscountTryBadge_ViralVideo":"Teste por $1.99","Text_FreeVideoBadge_ViralVideo":"${0} vídeos grátis","Text_FirstDiscountPrice_ViralVideo":"Gere o primeiro vídeo por apenas ${0} créditos (preço original ${1} créditos)","Text_UpgradeProDiscount_ViralVideo":"Assine o Pro e ganhe 25% de desconto","Text_EnjoyedProDiscount_ViralVideo":"25% de desconto aplicado","Text_BatchFeatureRequiresMembership_ViralVideo":"A geração em lote requer assinatura","Text_OpenProGenerationDiscount_ViralVideo":"Assine o Pro e ganhe 25% de desconto na geração","Text_EnjoyedProGenerationDiscount_ViralVideo":"Desconto de geração de 25% do Pro aplicado","Button_OpenProOrMembership_ViralVideo":"Assinar Pro / Assinatura","Text_MemberExclusiveBadge_ViralVideo":"Exclusivo para membros","Text_VipFunctionLimitedTimeOpen_ViralVideo":"Recursos VIP disponíveis por tempo limitado","Title_NetworkDisconnected_ViralVideo":"A conexão de rede foi perdida","Text_NetworkDisconnectedRefresh_ViralVideo":"A tarefa ainda está sendo gerada em segundo plano e não será perdida. Verifique a conexão e atualize a página para ver o progresso mais recente.","Button_RefreshPage_ViralVideo":"Atualizar página","Message_NetworkDisconnectedRetry_ViralVideo":"A conexão de rede foi perdida. Verifique a conexão e tente novamente.","Tip_InvalidLink_ViralVideo":"Insira um link de vídeo válido","Title_GenerateParams_ViralVideo":"Parâmetros de geração","Label_PreviewMarket_ViralVideo":"Mercado-alvo:","Label_PreviewLanguage_ViralVideo":"Idioma de destino:","Label_PreviewAspectRatio_ViralVideo":"Proporção do vídeo:","Label_PreviewScriptType_ViralVideo":"Tipo de roteiro:","Label_PreviewProductInfo_ViralVideo":"Informações de venda do produto:","Text_GeneratingBrowserTitle_ViralVideo":"⏳ Gerando... | ${0}","Text_SimplePreviewSwipeGuide_ViralVideo":"Deslize para cima para ver mais","Button_UploadImageReplicate_ViralVideo":"Enviar imagem para replicar","Label_PlayVideo_ViralVideo":"Reproduzir vídeo","Label_NoWatermark_ViralVideo":"Sem marca d\'água","Tool_LosslessUpscale":"Ampliador de imagem","Tool_AiRecolor":"Recoloração de imagens com IA","Tool_AiPhotoEditorTitle":"Editor de Foto com IA","Message_ZipOnlyOne":"Você só pode enviar um arquivo compactado por vez","Message_ZipSizeLimit":"O tamanho do arquivo compactado não pode exceder ${0} MB","Message_ZipExtractFailed":"Não foi possível analisar o arquivo compactado ${0}","Message_ZipNoUploadableFiles":"${0} Nenhum arquivo disponível para upload foi encontrado neste pacote compactado","Message_ZipAlreadyUploaded":"Todos os arquivos em ${0} já foram enviados. Os uploads duplicados foram ignorados.","Title_VideoWatermark":"Seu vídeo contém uma marca d\'água","Desc_VideoWatermark":"Os vídeos exportados durante o teste terão a marca d\'água ${0}. Faça upgrade para o Premium para baixar vídeos sem marca d\'água.","Button_RemoveWatermark":"Remover a marca d\'água","Button_DownloadAnyway":"Baixar mesmo assim","Message_DownloadFailedTryAgain":"Falha ao baixar. Tente novamente.","MenuItem_ProductRestore":"Restauração de produto","Title_ProductRestore":"Restauração de produto","Desc_ProductRestore":"Envie uma imagem original para corrigir a distorção do produto","Tip_ProductRestoreUpload":"Escolha uma imagem com ângulo e orientação semelhantes ao resultado atual. O produto deve estar nítido e totalmente visível.","Button_StartProductRestore":"Iniciar restauração","Message_ProductRestoreUploadLimit":"Envie uma imagem nos formatos JPEG, JPG, PNG ou HEIC, com até 10 MB.","Message_ProductRestoreUploadFailed":"Falha ao carregar a imagem de restauração do produto. Tente novamente.","Message_VideoDownloadingInBackground":"Baixando em segundo plano. Você pode continuar usando ${0}","Button_AdjustParameters":"Ajustar configurações","Text_WPS_Welcome_Modal_Meidou_Description1":"Assinantes Premium: bônus único de 50 créditos","Text_WPS_Welcome_Modal_Meidou_Description2":"Membros sem Premium: Bônus único de 25 créditos","Text_WPS_Meidou_Rules":"Regras de uso de créditos","Text_WPS_Meidou_Details":"Detalhes do uso de créditos","Button_ImportLink":"Importar link","Tip_ProductImagesUpload":"Envie mais ângulos do produto para obter melhores resultados","Button_EditSkill":"Habilidades de edição","Title_CategorySkills":"${0} Habilidades","Button_AllSkills":"Todas as habilidades","Text_NoSkills":"Nenhuma habilidade disponível","Aria_ScrollLeft":"Role para a esquerda","Aria_ScrollRight":"Role para a direita","Message_CompleteRequired":"Preencha os campos obrigatórios","Button_InsertToDesc":"Adicionar à descrição","Aria_ExpandOptions":"Opções de expansão","Message_FileUploadFailedRetry":"Falha no upload do arquivo. Tente novamente.","Button_UploadImageVideo":"Enviar imagens/vídeos","Aria_DeleteFile":"Excluir arquivos","Aria_PauseVideo":"Pausar vídeo","Aria_SwitchToSlide":"Mudar para a imagem ${0}","Tip_PleaseFill":"Preencha ${0}","Tool_ImageToVideoGenerator":"Gerador de vídeos a partir de imagens","Tool_TextToVideoGenerator":"Gerador de vídeos a partir de texto","Tool_TikTokVideoGenerator":"Gerador de vídeos do TikTok","Tool_InstagramVideoGenerator":"Gerador de vídeos para Instagram","Tool_YouTubeVideoGenerator":"Gerador de vídeos do YouTube","Tool_YouTubeShortsGenerator":"Gerador de Shorts do YouTube"}');
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/x-design-locales-next/zh-Hans.json
const x_design_locales_next_zh_Hans_namespaceObject = JSON.parse('{"Tab_Design":"设计","Button_Send":"发送","Input_Describe_Workspace":"输入一句话AI帮你做图","Tab_AgentCase":"Agent 案例","Tab_RecentCreations":"最近打开","Tag_Hot":"热门","Tag_BrandDesign":"品牌设计","Tag_Logo":"Logo","Tag_Posters":"海报设计","Tab_Agent":"Agent","Tool_AiPhotoEditor":"图片编辑","Button_Upload":"上传","Tool_Designer":"创建设计","Title_AiTool":"AI工具","Tool_ImageBackgroundRemover":"智能抠图","Tool_AiBackgroundGenerator":"AI背景生成","Tool_ImageEnhancer":"变清晰","Tool_AiObjectsRemover":"AI消除","Tool_AiModelMannequin":"AI模特","Tool_AiModelFlatlay":"AI试衣","Tool_AiImageRecolor":"服装换色","Tool_AiImageExtender":"AI扩图","Tool_ImageUpscaler":"无损改尺寸","Tool_AiLogo":"AI Logo","Button_BlankCanvas":"创建画布","Sidebar_Create":"主页","Sidebar_Tools":"AI工具箱","Sidebar_Batch":"批处理","Sidebar_MyDesigns":"我的设计","Sidebar_Inspire":"灵感广场","Sidebar_Brand":"品牌库","Sidebar_PackUp":"收起菜单","Tag_All":"全部","Tag_Design":"设计","Sidebar_Unfold":"展开菜单","Menu_Edit":"编辑","Menu_Download":"下载","Menu_Delete":"删除","Tab_RecentlyCreated":"最近创作","Tab_GenerateRecords":"生成记录","Menu_Total":"合计","Menu_Total_Explain_AgentCredits":"仅可在AI Agent中使用，优先消耗","Menu_DueToday":"今日到期","Menu_DueToday_Explain":"每日会自动更新","Menu_Else_AgentCredits":"其他积分","Button_GoPro_GetMore":"获得更多积分","Menu_Total_Explain_PaidCredits":"会员阶段可以在所有功能里使用","Menu_Pro":"会员积分","Menu_Pro_Explain":"会员专属赠送，会员有效期内可用","Menu_Else":"其他积分","Menu_Else_Explain_PaidCredits":"其他来源获得，有效期视来源而定","Menu_Else_Explain_AgentCredits":"其他渠道获得，有效期更长","Menu_UsageDetail":"使用详情","Menu_Total_Explain_SuspendCredits":"已暂停使用重新激活会员后可使用","Tab_Invite":"邀请","Menu_InviteReward":"邀请好友奖励","Tab_Reward":"奖励","Title_AgentCreditForRewards":"奖励的Agent credit：","Table_Time":"时间","Table_Invitee":"被邀请者","Title_ShareWithFriends":"分享给您的朋友","Title_ShareWithFriends_ExplainOne":"<span style=\\"color:#616266;\\">每邀请1位新朋友，您和朋友都可以获得</span><span style=\\"color:#2D990C;\\">${0} 个Agent 积分</span>","Title_InvitationLink":"用此链接邀请","Button_Copy":"复制","Title_Tips":"提示：","Title_Tips_ExplainOne":"1.Agent 积分只能在 AI Agent中使用.邀请奖励的Agent积分有效期为两年.","Title_Tips_ExplainTwo":"2.新朋友需要注册成功后会发放奖励，如有问题，请联系支持团队.","Title_GetRewarded":"获得邀请奖励","Title_GetRewarded_Explain":"仅在AI Agent中使用,有效期为两年","Button_Ok":"好的","Title_FailedToReceiveReward":"获得奖励失败","Title_FailedToReceiveReward_Explain":"如有问题，请联系支持团队","Tool_AiBackgroundGenrator":"AI背景生成","Title_YouCannotUseYourOwnLink":"不能使用自己的邀请链接","Table_AgentCredit":"Agent 积分","Title_ShareWithFriends_ExplainTwo":"<span style=\\"color:#616266;\\">您最多可邀请</span><span style=\\"color:#2D990C;\\">${0}个新朋友 </span><span style=\\"color:#616266;\\">，即最高可获得${1}个Agent 积分</span>","Button_Invite":"邀请","Menu_Title_Invite":"邀请好友","Text_Button_Invite":"赚取积分","Title_Dialog_Invite":"邀请好友","Desc_Dialog_Invite":"在社交媒体或与朋友分享您的专属链接。当朋友通过您的链接注册时，双方均可获得 ${0} 积分。如果他们订阅了套餐，双方还将额外获得最高 ${1} 积分。","Detail_Dialog_Invite":"详情","Text_Copy_Invite":"复制链接","Title_Rewards_Invite":"奖励","SubTitle_Rewards1_Invite":"累计获得积分","SubTitle_Rewards2_Invite":"邀请免费用户","SubTitle_Rewards3_Invite":"邀请付费用户","Success_Copy_Invite":"链接已复制","Title1_Invited_Invite":"您已收到邀请！","Text_Rule1_Invite":"每邀请一位朋友使用您的链接注册，双方均可获得 <strong>${0} 积分</strong>。","Text_Rule2_Invite":"如果您的朋友订阅了套餐，双方均可获得额外积分（<strong>Plus 套餐 ${0} 积分，Pro 套餐 ${1} 积分</strong>）。","Text_Rule3_Invite":"如果订阅套餐内包含的权益已被使用，或赠送的积分已被消耗，购买的订阅将无法退款。同时，免费积分一旦使用也无法撤回。","Text_Rule4_Invite":"每个用户最多可邀请 ${0} 位朋友。","Text_Rule5_Invite":"奖励不适用于已有账号、自推荐、重复账号或涉嫌欺诈性活动的邀请。","Text_Rule6_Invite":"${0} 保留调整本计划及收回异常账号奖励的权利。","Text_Divider_Invite":"或分享链接","Title2_Invited_Invite":"加入 ${0} 领取您的奖励","SubTitle1_Invited_Invite":"一位朋友邀请您体验我们专业的品牌 AI Agent。轻松创建高质量的品牌营销设计，如 Logo、海报、菜单以及社交媒体素材。","SubTitle2_Invited_Invite":"<strong>立即注册</strong>，您和您的朋友都将<strong>获得 ${0} 积分</strong>。<strong> 如果您订阅了套餐，</strong>双方还将根据您选择的计划获得额外积分（<strong>Plus 套餐 ${1} 积分 或 Pro 套餐 ${2} 积分</strong>）。立即注册以领取您的奖励。","Button_Invited_Invite":"注册领取奖励","Success_Invited_Invite":"您通过邀请链接加入，已获得 ${0} 积分。","Error_Invited_Invite":"您已经拥有一个账号。","Text_Share_Invite":"我一直在使用 ${0} 快速创建 Logo、视觉图和视频。使用我的链接注册，我们都将获得奖励积分。","Title_Share_Invite":"加入 ${0}，一起赚取积分！","Share_Email_Invite":"邮箱","Text_Rule7_Invite":"您可将积分用于 AI Agent。积分的有效期为一个月。","Title_AgentCredits":"+50 Agent 积分","Input_Models":"模型","Button_TryItNow":"做同款","Account_Pricing":"会员套餐和价格","Account_Language":"语言","Account_Language_English":"英文","Account_Language_Chinese":"中文","Tips_Adding":"添加中...","Tips_Loading":"加载中...","Tips_Creating":"正在创建中...","Tips_Downloading":"正在下载中...","Tips_Sending":"正在发送中...","Tips_AddSuccess":"添加成功","Tips_MakeSameError":"系统不支持，无法做同款","Tips_UnsupportedGradientColor":"不支持渐变色","Tips_CanNotAdding":"无法添加","Tips_Uninitialized":"未初始化，无法发送","Tips_UploadFailed":"上传失败，请重试","Tips_UploadMaxCountLimit":"最多允许上传 ${n} 个${type}文件","Tips_UploadMaxFileSize":"无法上传 ${file}，最大允许上传 ${n}MB 的文件","Tips_UploadImageAndVideoLimit":"仅支持单张图片和视频混合上传哦～","Tips_UnsupportedSvgFile":"不支持 SVG 文件","Tips_UnsupportedUploadFileFormats":"不支持上传的文件格式 ${files}","Tips_CanNotAddSameFileTips":"已有相同文件存在，无法添加","Tips_TextMinLengthTips":"至少需要输入 ${n} 个字符","Tips_TextMaxLengthTips":"最多允许输入 ${n} 个字符，其中中文和 Emoji 算 2 个字符","Tips_AccessDenied":"没有权限访问","Tips_CreateFailed":"对话创建失败","Tips_Error":"出错啦！","Tips_NotFound":"对话不存在","Tips_RequestAgentModelListError":"Agent 模型列表获取失败","Desc_Ended":"结束","Button_PeopleUse_Agent":"${n} 人使用","Dropdown_AddToChat":"添加到聊天","Dropdown_AddToBrandKit":"添加到品牌","Dropdown_SaveToBrandKit":"保存为品牌 logo","Dropdown_SaveToBrandTemplate":"保存为品牌模板","Title_Design_Agent":"设计","Title_MainColor":"主色","Title_SecondaryColor":"辅助色","Bitton_ViewTheBrandKit":"点击查看品牌资产库","Dropdown_InportImages":"导入图片","Title_Upgrade_Pro":"升级计划","Desc_SubscribeToUnlock_Pro":"现在订阅解锁更多","Desc_RunOutOfFreeUses_Pro":"对不起，您已经没有免费的使用了","Desc_RunOutOfUsesForToday_Pro":"今天没有剩余的免费使用了，请明天再来","Desc_PurchaseCompleted_Pro":"购买成功","Desc_ContinueDesign_Pro":"准备就绪了，尽情使用吧","Button_UnlockNow":"立即解锁","Tips_Copied":"已复制！","Tips_Credit_Explain_Paid":"什么是付费积分","Title_Total_InactiveCredits":"合计 - 冻结积分","Title_Total_PaidCredits":"合计 - 付费积分","Menu_SuspendCredits":"冻结积分","Menu_Credits":"积分","Tab_RecentCreations_Agent":"Agent","Tab_RecentCreations_Design":"智能工具","Menu_FunctionalPricing":"Agent功能定价","Title_Total_AgentCredits":"合计 - Agent积分","Tips_Credit_Explain_Agent":"什么是Agent积分","Title_FeaturePricing":"Agent功能定价","Tab_Category":"大类","Tab_TaskType":"任务类型","Tab_Consume":"消耗美豆","Tab_ExampleContent":"内容举例","Tips_CreditExplain_Inactive":"什么是冻结积分","langding_more_bg_remover":"智能抠图","langding_more_enhancer":"变清晰","langding_more_objects_remover":"AI消除","langding_more_bg_generator":"AI背景生成","Title_More1_Home":"变清晰","Title_More2_Home":"智能消除","Title_More3_Home":"AI商品图","Title_More4_Home":"智能抠图","Title_More5_Home":"批量图像工具","Title_Home":"你的<span>电商</span>设计AI助手","Placeholder_Input_Home":"描述下你的想法，我会来帮你创作…","Title_Card4_Home":"一句话生成亚马逊套图","Title_Card1_Home":"服装首饰试穿套图生成","Title_Card3_Home":"商品详情图生成","Title_Card2_Home":"AI换背景","Desc_Features1_Home":"AI自动提炼品类特征与风格偏好，构思最合适的设计方案。","Desc_Features2_Home":"只需输入一句话，AI自动生成整套电商图片，从主图、副图到详情页一次搞定。","Text_Btn_Home":"免费开始","Desc_Features3_Home":"自动匹配 Amazon、Etsy、TEMU、eBay 等平台规范与流量偏好，生成符合各平台标准的专属视觉套组。","Desc_Features4_Home":"输入一句话即可可智能转换语言、模特、色调与文化视觉，自动生成多国家本地化版本。","Desc_Features5_Home":"作图流程可一键保存为配方并复用，AI自动批量生成所有SKU图片。","Desc_Features6_Home":"无论是10款还是1000款商品，都能一键完成整套视觉。","Title_Qualification_Home":"超500万电商卖家都在用","Text_Btn_Qualification_Home":"查看资质","Title_Carousel_Home":"更多AI工具","Title_Footer_Home":"你的电商设计助手","Title_Footer1_Home":"官方社媒","Subtitle_Footer1_Home":"YouTube","Subtitle_Footer2_Home":"X","Subtitle_Footer3_Home":"Instagram","Subtitle_Footer4_Home":"TikTok","Title_Footer2_Home":"支持与服务","Subtitle_Footer5_Home":"服务条款","Subtitle_Footer6_Home":"隐私政策","Copyright_Footer_Home":"版权 ${0} 美图（中国）有限公司","Desc_Evaluation1_Home":"我真的很喜欢 Designkit！AI 生成的生活方式图片看起来很自然——温馨、北欧风，非常适合我的香薰蜡烛店。我店铺的商品图变得更专业了，销售额也有所提升。总之物超所值。","Job_Evaluation5_Home":"TEMU 墨西哥卖家","Job_Evaluation6_Home":"亚马逊运营","Job_Evaluation12_Home":"Amazon 印尼多 SKU 店铺店长","Job_Evaluation2_Home":"亚马逊 & Mercado Libre 店主","Name_Evaluation12_Home":"Arif","Desc_Evaluation11_Home":"生成的生活方式场景图挺自然，看起来像拍出来的一样，客户也比较喜欢，转化率有提升。","Name_Evaluation11_Home":"Siti","Job_Evaluation10_Home":"Lazada & Shopee 印尼跨境店主","Name_Evaluation10_Home":"Nina","Job_Evaluation3_Home":"独立站 设计师","Job_Evaluation8_Home":"Walmart 美国户外店主","Name_Evaluation8_Home":"Jason","Job_Evaluation9_Home":"Mercado Libre 阿根廷卖家","Desc_Evaluation7_Home":"生成的宠物用品场景挺可爱的，猫狗比例自然，不会怪怪的。而且尺寸比例基本符合 ML 平台的要求，用起来挺方便的。","Job_Evaluation7_Home":"Mercado Livre 巴西店铺老板","Desc_Evaluation8_Home":"我卖帐篷，用它生成的露营场景挺真实，光线和角度都挺自然，比例也没问题。总体来说，比自己拍摄省了不少时间。","Name_Evaluation7_Home":"Thiago","Desc_Evaluation9_Home":"这个工具用起来挺快的，生成的图基本可以直接上传到美客多和亚马逊，不用再调来调去。","Desc_Evaluation6_Home":"我以前最担心 AI 会改掉衣服材质，但它几乎完全保持了原样。针织是针织，牛仔是牛仔，也符合亚马逊主图规范，新品上架效率提升了不少。","Name_Evaluation9_Home":"Lucas","Name_Evaluation6_Home":"Emma","Desc_Evaluation5_Home":"AI 做的产品图挺准的，数据线的长度、接口形状都保持得很好，还能适配 TEMU 的风格，整体上比自己拍图省事很多。","Desc_Evaluation12_Home":"只需要一句话就能生成可用素材，比以前等设计师出图快太多了，挺省心的。","Name_Evaluation3_Home":"Chloe","Name_Evaluation1_Home":"Sofia","Desc_Evaluation4_Home":"金属材质和结构细节都很清楚，整体感觉挺专业的，生成的图直接能用。","Name_Evaluation4_Home":"Leon","Desc_Evaluation10_Home":"批量生成很方便，几十个 SKU 一次性搞定，比以前自己做快多了。","Name_Evaluation2_Home":"Mariana","Desc_Evaluation3_Home":"我是卖服装的，原本担心 AI 会把颜色或布料质感弄得不真实，但结果非常出乎意料！模特姿势很自然，基本上出图就能立即上架使用了。","Job_Evaluation1_Home":"SHEIN 店铺运营","Name_Evaluation5_Home":"Diego","Job_Evaluation11_Home":"亚马逊运营专员","Desc_Evaluation2_Home":"这个工具非常快速，生成的图片几乎可以直接上传到 Mercado Libre 或 Amazon。它甚至会根据当地喜好调整背景和模特，效果非常专业。","Job_Evaluation4_Home":"eBay 德国卖家","Title_Evaluation_Home":"来自我们Designkit社区的故事","Title_Introduction_Home":"更高效、更专业的AI设计工具，助力你成为电商大卖","Desc_Qualification_Home":"亚马逊SPN认证服务商","Title_Seo_Home":"适用于电商的AI产品图像和视频生成器","Desc_Seo_Home":"使用 Designkit 的 AI 智能助手，即可立即为亚马逊、TikTok 等在线商店生成产品图片、海报和视频。立即开始免费设计！<br>","Keywords_Seo_Home":"电商AI代理、电商AI工具、AI产品图片生成器、AI产品视频生成器、AI产品照片编辑器、AI背景去除","Title_Features1_Home":"一句话即可做一整套电商物料图","Title_Features2_Home":"一句话卖全球，多平台多国家全自动本地化","Title_Features3_Home":"多SKU也可批量自动划出图，上新变得更高效","Title_Designkit_Home":"Designkit","Tips_AboveTheFold2_Home":"向下滚动探索","Tips_Material1_Home":"电商套图","Tips_Material2_Home":"服饰穿戴","Tips_Material3_Home":"A+ 详情页","Tips_Material4_Home":"商品换背景","Free_Button_Home":"免费试用","Title_Header1_Home":"功能","Title_Header2_Home":"解决方案","Title_Header3_Home":"灵感","Title_Header4_Home":"学习","Title_Header5_Home":"价格","SecondTitle_Header1_Home":"AI电商设计Agent","SecondTitle_Header2_Home":"AI图片工具","SecondTitle_Header3_Home":"AI视频工具","SecondTitle_Header4_Home":"亚马逊设计解决方案","SecondTitle_Header5_Home":"社媒电商解决方案","SecondTitle_Header6_Home":"AI 商品图生成器","SecondTitle_Header7_Home":"AI 服装模特生成器","SecondTitle_Header8_Home":"衣服换色","SecondTitle_Header9_Home":"商品视频生成器","SecondTitle_Header10_Home":"AI 工具","SecondTitle_Header11_Home":"AI 图片编辑器","SecondTitle_Header12_Home":"在线 AI 图片编辑器","SecondTitle_Header13_Home":"批量图片编辑器","SecondTitle_Header14_Home":"批量 AI 图片编辑器","SecondTitle_Header15_Home":"批量变清晰","SecondTitle_Header16_Home":"批量去水印","SecondTitle_Header17_Home":"批量换背景","SecondTitle_Header18_Home":"批量智能抠图","Title_Footer3_Home":"设计工具","Subtitle_Footer8_Home":"AI 图片编辑器","Subtitle_Footer7_Home":"AI 换背景","Subtitle_Footer9_Home":"透明背景","Subtitle_Footer10_Home":"更换背景颜色","Subtitle_Footer11_Home":"图片去水印","Subtitle_Footer12_Home":"移除图片文字","Subtitle_Footer13_Home":"照片加贴纸","Subtitle_Footer14_Home":"照片加水印","Title_Footer4_Home":"图片模型","Subtitle_Footer15_Home":"Nano Banana Pro (Gemini 3.0 Pro)","Title_Footer5_Home":"免费下载","Subtitle_Footer16_Home":"iOS APP","Subtitle_Footer17_Home":"Android APP","Title_Footer6_Home":"关注我们","Subtitle_Footer18_Home":"Kling 3.0","Subtitle_Footer19_Home":"Seedance 2.0","Title_Footer7_Home":"视频模型","Button_Export":"下载","Title_Layer":"图层","InputNumber_Opacity":"不透明度","Buttom_Comfirm":"确定","Button_Share":"分享","Button_Delete":"删除","Title_LoginPopup":"登录解锁免费试用","SubTitle_LoginPopup":"立即开始使用 Zawa 创作","Tip_ModalTitle":"提示","TipContent_HistoryDelete":"删除后，该记录将不可恢复，确认删除吗？","Title_Logo":"Logo","Title_BrandKit":"品牌模板","Tab_BrandKit":"品牌资产","Tab_UploadLocal":"本地上传","Button_UploadImage":"上传图片","Button_UploadProductImage":"上传产品图","Button_UploadReferImage":"上传参考图","Tip_ClickDragParseImage":"点击/拖拽/粘贴图片至此处","Tip_UploadMax":"支持上传${0}M以内JPG、JPEG、PNG，最多支持N张","Tooltip_SwitchBrandKit":"切换品牌库","Discribe_BrandKitSelect":"选择对应品牌后，本次会话将参考其品牌规范进行设计～","Title_Models":"模型","Switch_Auto":"自动","Tab_Image":"图片","Tab_Video":"视频","MenuItem_AddToBrandLogo":"添加为品牌Logo","MenuItem_AddToBrandTemplate":"添加为品牌模板","Button_ExportImage":"导入图片","Button_ExportMedia":"导入视频","Button_ExportFromBrandkit":"从资产库中导入","Dropdown_AddFromBrandkit":"从资产库中添加","Placeholder_ChatInput":"和我一起玩图吧～","MenuItem_AiChange":"AI改图","MenuItem_AiExpend":"AI扩图","MenuItem_AiHD":"AI超清","MenuItem_Eliminate":"AI无痕消除","MenuItem_SplitLayers":"拆分图层","MenuItem_Cutout":"抠图","MenuItem_ChangeText":"编辑文字","MenuItem_Crop":"调整尺寸","MenuItem_AddToChat":"添加到对话","MenuItem_AddToBrand":"添加到品牌库","Tooltip_Layer":"图层","Tooltip_Grab":"抓手","Tooltip_Select":"选择","Tooltip_Redo":"重做","Tooltip_Undo":"撤销","Tooltip_Add":"添加","Tooltip_ShowAll":"显示全部","Tip_UploadType":"文件格式不支持","Tip_UploadSize":"仅支持${0}MB以内的文件","Tip_UploadWH":"仅支持宽高均为${0} * ${1}以内的图片","Tip_UploadTypeTranslate":"文件格式转换错误","Tip_UploadFail":"文件上传失败","Tooltip_AddText":"添加文本","Text_AddDefault":"我是一段文本","Tooltip_OverflowImageSize":"请将图片缩放到${0}px以内","Placeholder_ImageFusion":"将融图灵感发送给我，我来帮你执行","Button_ImageFusion":"融图","Button_Cancel":"取消","Button_AiChange":"改图","Placeholder_AiChange":"将改图灵感发送给我，我来帮你执行","Button_Eliminate":"消除","Label_OriginSize":"原图尺寸","Label_CropRadio":"裁剪比例","Button_Free":"自由","Button_Origin":"原始","Button_Crop":"裁剪","Placeholder_ChangeText":"输入你想修改成的目标文案，如：你好","Button_ChangeText":"改字","InputNumber_PanSize":"笔刷大小","Label_TargetSize":"目标尺寸","Tooltip_ImageFusion":"支持${0}-${1}张图的快速融合","Title_Workspace":"你的社媒内容AI助手","Button_Pro":"免费体验Pro版本","Title_NanoPro":"🍌🍌Nano Banana Pro 现已上线 Zawa。","Dropdown_AdvancedFeatures_Title":"高级功能","Dropdown_AdvancedFeatures_Conent":"无限制访问所有 AI 驱动的工具，提升您的效率。","Dropdown_MassiveContent_Title":"海量素材","Dropdown_MassiveContent_Content":"无限制访问高级模板及海量 Plus 级素材库。","Dropdown_CommercialRights_Title":"商业版权","Dropdown_CommercialRights_Content":"安心使用您的个人创作，享有商用版权保护。","Popup_SubscribeIntl_Desc":"开通 Pro 获取 Zawa 最佳体验","Popup_SubscribeIntl_Desc1":"使用积分解锁更多创作权限","Popup_SubscribeIntl_Detail":"查看计划详情及帮助","Popup_StripeCheckout":"Stripe支付","Popup_LiveSupport":"在线客服","Popup_CancelAnytime":"随时取消","Menu_Language":"语言","Menu_ManageSubscription":"订阅管理","Menu_TermsPolices":"服务条款","Menu_ManageSubscriptions":"订阅管理","Menu_ReferralLink":"邀请链接","Menu_BenefitsUpgraded":"权益","Menu_TermsPolicies":"服务条款","Menu_AccountManagement":"账号管理","Title_ReferralCode":"邀请码","Title_ReferralLink":"邀请链接","Desc_NoActiveSubscription":"暂无有效订阅","Button_ClickToSubscibe":"点击订阅","Title_SubscriptionCancel":"您的订阅已取消","Title_SeeYou":"对于您的取消深表遗憾😭","Desc_NextBillingDate":"下一次续费将会在","Desc_EstimatedAmount":"预计扣费金额","Button_CancelSubscription":"取消订阅","Button_StaySubscribed":"继续订阅","Title_ReasonCancelling":"请选择取消订阅的原因：","Desc_BenefitsContinue":"您可以继续享受会员权益","Desc_GiftedCredits":"订阅到期后，赠送的积分","Desc_SeeYou":"感谢你一直以来的支持，我们很遗憾看到你离开。","Desc_NoNoreCharges":"你将不会再次被扣费，你的会员权益将继续有效，直至","Desc_MayBeRevoked":"将会被收回。","Desc_CancelingNoRefund":"取消订阅<span>不包含退款</span>。如需退款，请联系在线客服。","Button_ClearSelection":"清除选区","Button_Confirm":"确认","Message_Processing":"处理中...","Title_Opacity":"透明度","Button_ExpandImage":"扩图","Button_ExpandRadio":"扩图比例","Title_NoDesigns":"暂无设计","Title_NoGenerations":"暂无生成记录","Desc_NoDesigns":"您的设计将显示在此处。","Desc_NoGenerations":"您的生成记录将显示在此处。","Title_DeleteDesign":"删除此设计","Popup_DeleteDesign":"您确定要永久删除此设计吗？该操作无法撤销。","Message_SaveFail":"保存失败","Title_Pricing":"选择适合您的方案","Title_Tags1_Pricing":"按月","Text_Discount_Pricing":"${0}折","Title_Tags2_Pricing":"按年","Title_Plan1_Pricing":"免费","Current_Plan_Pricing":"当前计划","Title_Instruction1_Pricing":"首次登录赠送20积分","Title_Instruction2_Pricing":"使用AI Agent最多生成20张","Title_Instruction3_Pricing":"使用AI商品图最多生成10张","Title_Rights1_Pricing":"限次体验智能抠图","Title_Rights3_Pricing":"限次体验变清晰（高清）","Title_Plan2_Pricing":"基础会员","Month_Plan_Pricing":"月","Title_Button1_Pricing":"立即开通","Title_Instruction4_Pricing":"500积分/月","Title_Instruction5_Pricing":"使用AI Agent最多生成 500 张","Title_Instruction6_Pricing":"AI商品图：最多250张/月","Title_Plan3_Pricing":"高级会员","Desc_Plan_Pricing":"7天免费试用，到期后${0}/年续费","Title_Button2_Pricing":"7天免费试用","Title_Instruction7_Pricing":"1500积分/月","Title_Instruction8_Pricing":"使用AI Agent最多生成 1500 张","Title_Instruction9_Pricing":"AI商品图：最多750张/月","Title_Rights4_Pricing":"无限次使用智能抠图","Title_Rights5_Pricing":"无限次使用AI消除","Title_Rights6_Pricing":"无限次使用变清晰（超清）","Title_Rights7_Pricing":"批量编辑器","Title_Best_Pricing":"90%的人选择","Title_AllFeatures_Pricing":"对比所有方案","Desc_AllFeatures_Pricing":"使用基础会员/高级会员中的先进 AI 工具，轻松创作惊艳设计","Month_AllFeatures_Pricing":"月","Title_Features1_Pricing":"AI Agent","SubTitle_Features1_Pricing":"图片编辑","SubTitle_Features15_Pricing":"最多生成 ${0} 张","SubTitle_Features16_Pricing":"最多生成 ${0} 张/月","SubTitle_Features2_Pricing":"图片生成","SubTitle_Features3_Pricing":"电商套图生成","SubTitle_Features4_Pricing":"海报生成","Title_Features2_Pricing":"AI 图像处理","SubTitle_Features5_Pricing":"智能抠图","SubTitle_Features17_Pricing":"有限次","SubTitle_Features19_Pricing":"无限次","SubTitle_Features6_Pricing":"AI 消除","SubTitle_Features7_Pricing":"变清晰","SubTitle_Features18_Pricing":"有限次（高清）","SubTitle_Features20_Pricing":"无限次（高清/超清）","SubTitle_Features8_Pricing":"无损改尺寸","SubTitle_Features9_Pricing":"AI 扩图","SubTitle_Features10_Pricing":"AI 商品图","Title_Features3_Pricing":"更多设计功能","SubTitle_Features11_Pricing":"高级功能与模板","SubTitle_Features12_Pricing":"去水印下载","SubTitle_Features13_Pricing":"批量编辑器","SubTitle_Features14_Pricing":"基础编辑功能","Title_Credits_Pricing":"积分快用完了？ 我们帮你搞定","Desc_Credits_Pricing":"按需购买，一次性付费，无需订阅！","TransactionPrice_Credits_Pricing":"价格： ${0}","Credit_Credits_Pricing":"积分","Popular_Credits_Pricing":"最受欢迎","Buy_Credits_Pricing":"立即购买","Title_FAQ_Pricing":"常见问题","Title_Button4_Pricing":"7天免费试用/立即升级","SubTitle_FAQ1_Pricing":"什么是积分?","Content_FAQ1_Pricing":"积分可用于使用AI工具，不同AI工具需要消耗对应的积分","Content_FAQ2_Pricing":"单独购买的积分有效期为1年。","Content_FAQ3_Pricing":"购买会员赠送的积分当月有效。","SubTitle_FAQ2_Pricing":"如何取消订阅?取消后我的积分会怎样","Content_FAQ4_Pricing":"如果您取消订阅:","Content_FAQ5_Pricing":"-会员到期后您的积分也会随之到期，单独购买的积分不受影响。","Content_FAQ6_Pricing":"如需取消订阅，请至少在下一个账单周期开始前24 小时按照以下步骤操作:","Content_FAQ7_Pricing":"- 打开Designkit并登录。","Content_FAQ8_Pricing":"- 打开会员订阅弹窗。","Content_FAQ9_Pricing":"- 选择[管理订阅]。","Content_FAQ10_Pricing":"- 选择您的订阅选项，然后点击【取消订阅】。","Content_FAQ11_Pricing":"您的订阅将持续有效至当前计费周期结束。如果您无法取消订阅，请截图并尽快联系我们的在线客服。","SubTitle_FAQ3_Pricing":"你们的退款政策是什么？","Content_FAQ12_Pricing":"1. 7天退款保证:","SubTitle_FAQ4_Pricing":"如何升级或降级我的订阅？","Content_FAQ25_Pricing":"1. 升级:你可以直接订阅更高档位的会员套餐。新的套餐立即扣费和生效，旧的套餐将按比例退款并解约;","SubTitle_FAQ5_Pricing":"我可以要一份发票副本吗？","Content_FAQ27_Pricing":"是的!付款成功后，您将收到支付服务提供商发送的包含电子发票的电子邮件。如果您没有收到发票，请联系我们的客服团队。","SubTitle_FAQ6_Pricing":"你们支持那些支付方式？","Content_FAQ28_Pricing":"我们使用 Stripe 管理支付和订阅。我们接受所有主流信用卡、PayPal 和 Google Pay。","SubTitle_FAQ7_Pricing":"我该如何联系客服?","Content_FAQ29_Pricing":"请发送邮件至support@designkit.com，回复时间:3-10个工作日","Content_FAQ13_Pricing":"- 如果您购买了会员套餐但7天内未使用，您可能有资格获得全额退款。","Content_FAQ14_Pricing":"- 如果您购买了积分，您可以在7天内申请退还任何未使用的积分。","Content_FAQ15_Pricing":"2. 对服务不满意:","Content_FAQ16_Pricing":"- 如果您对结果不满意，请邮箱联系我们的线客服团队。我们将根据具体情况提供补偿或退款。","Content_FAQ17_Pricing":"3. 通过 Google Play 或 App Store 购买:","Content_FAQ18_Pricing":"- 如果您是通过 Google Play 商店或 App Store 订阅的，则需要直接向 Google 或 Apple 申请退款。","Content_FAQ19_Pricing":"重要提示:","Content_FAQ20_Pricing":"本退款政策不适用于API用户。如果您使用我们的API，请联系我们了解退款资格。","Content_FAQ21_Pricing":"对干滥用、误用或违反我们条款的情况，我们保留拒绝退款的权利。","Content_FAQ22_Pricing":"退款可能需要几个工作日才能处理完毕，具体取决于您的付款方式。","Content_FAQ23_Pricing":"我们可能会不时更新此退款政策。请定期查看以了解任何变更。","Content_FAQ24_Pricing":"如需进一步帮助，请联系我们的支持团队。","Content_FAQ26_Pricing":"2. 降级:您需要先取消当前的订阅，等账单周期结束后在订阅新的套餐。","Content_Modal_Pricing":"感谢您的支持！准备好将您的创造力提升到新的水平。","Tip_Modal_Pricing":"提示：如果您的会员状态未更新显示，请刷新页面。","Title_Modal_Pricing":"购买成功","Title_Rights2_Pricing":"限时体验AI消除","Title_Button3_Pricing":"已解锁权益","Title_Button5_Pricing":"立即升级","Tool_ImageBgRemover":"智能抠图","Tool_AiBgGenerator":"AI背景生成","Tool_AiLogoGenerator":"AI Logo","Tool_FootwearModel":"AI鞋模","Tool_ImageTranslation":"图片翻译","Tool_BatchImageBgRemover":"批量智能抠图","Tool_BatchImageEnhancer":"批量变清晰","Tool_BatchAiObjectsRemover":"批量AI消除","Tool_VideoEnhancer":"视频变清晰","Tool_VideoBgRemover":"视频抠图","Tool_VideoWatermarkRemover":"视频去水印","Title_Models_Dropdown":"模型","Tips_Uninitialized_Chat":"发送消息失败","Dropdown_AddImage":"添加图片","Action_SeeAll":"查看全部","Desc_Seedream":"生成真实细腻的图像。","Dropdown_AddVideo":"添加视频","Tips_NotFound_Chat":"对话不存在","Desc_Seedance":"生成逼真且具表现力的视频。","Dropdown_SupportedFormatFile":"支持 Word、Excel、TXT 和 PDF 格式文件。","Dropdown_Example_Option":"示例","Dropdown_NoReference_Option":"暂无参考","Menu_AgentCredits":"Agent 积分","Desc_SeedEdit":"精确自然的图像编辑。","Dropdown_BrandKit_Title":"品牌模板","Desc_GeminiNanoBanana":"快速、可编辑且风格一致的图像生成。","Dropdown_Models_Title":"模型","Dropdown_AddDocument":"添加文档","Dropdown_BrandKit_Desc":"选择品牌风格作为此次设计的参考。","Desc_MidjourneyVideo":"创意且具艺术感的视频生成。","Desc_MidjourneyImage":"艺术且富有想象力的图像生成。","Dropdown_SaveAsBrandTemplate":"保存为品牌模板","Dropdown_SaveAsBrandLogo":"保存为品牌Logo","BatchProcessTable_ImageType":"图片类型","BatchProcessTable_PictureRequirement":"画面需求","BatchProcessTable_CopywritingRequirements":"文案需求","BatchProcessTable_Proportion":"画图比例","BatchProcessTable_Actions":"操作","BatchProcessTable_AddOneRow":"新增一行","BatchProcessList_DeleteError":"删除失败","BatchProcessList_SurePrompt":"确认删除这个工作流吗？","BatchProcessList_SurePrompt_SureText":"确认","BatchProcessList_SurePrompt_CancelText":"取消","BatchProcessList_EmptyText":"空","EditBatchProcess_NameLimitTip":"请输入10字内的名称","EditBatchProcess_Tip":"修改下方表格内容，将影响工作流生成图片的结果","EditBatchProcess_Start":"从工作流开始","EditBatchProcess_GenerateTip":"上传商品图，将批量生成每个商品的工作流图片","Text_AdvanceSetting":"专家设置","Text_MainImage":"主图","Text_ProductAgentUploadGuide1":"1. 可上传同一商品的多视角原图，帮助 AI 更准确还原商品细节。","Text_ProductAgentUploadGuide2":"2. 最多支持 10 张图片，第一张将作为主图重点参考，建议选择角度最全的一张。","Text_Optional":"(可选）","Tip_ClickDragImageWithSize":"拖拽或点击上传JPEG/JPG/PNG，${0}M以内","Button_AddReferenceImage":"上传参考图","Title_ReferenceImage":"参考图","Input_Placeholder":"请选择","Radio_ReferenceColor":"参考配色","Radio_ReferenceLayout":"参考布局","Tag_FirstImage":"首张","Tag_FirstImageNoPartial":"首张非局部","Tag_Blur":"模糊","Tag_Jigsaw":"拼图","Button_Understood":"知道了","Text_ReferenceImageIndex":"第${0}张图为参考图","Text_ReferenceDimensions":"参考的维度是${0}","Tag_Cropped":"已裁剪","Tag_Underexposed":"曝光不足","Tag_Blurry":"模糊","SelectOption_ColorPalette":"调色板","SelectOption_Layout":"布局","SelectOption_Fonts":"字体","SelectOption_Style":"风格","SelectOption_ShapeElements":"形状元素","Text_SocialMediaAgentUploadGuide":"首先上传您的主推商品图，请确保图片清晰完整。","Video_SR_Success":"视频AI超清成功","Video_Desubtitle_Success":"视频去字幕成功","Video_Dewatermark_Success":"视频去水印成功","Video_Process_Failed":"处理失败，请重试！消耗的积分将会原路退回。","Video_SR":"AI超清","Video_Dewatermark":"去水印","Video_Desubtitle":"去字幕","Video_Task_Price_Estimate":"预计消耗${0}","Video_SR_Start":"开始AI超清，消耗${0}美豆","Video_Dewatermark_Start":"开始去水印，消耗${0}美豆","Video_Desubtitle_Start":"开始去字幕，消耗${0}美豆","Video_Desubtitle_Start_VIP":"开始去字幕","Video_Dewatermark_Start_VIP":"开始去水印","Video_SR_Start_VIP":"开始AI超清","Text_Help_Center":"帮助中心","Title_Request":"询问","Button_Continue":"继续","Button_EditContent":"编辑内容","Title_ChooseImageType":"请选择您希望生成的图片类型（可多选）:","Button_BatchGenerate":"已确认，开始执行电商套图批跑流程","Text_ChatCancelStatus":"任务中止","Text_ChatRespondedStatus":"任务执行","BatchProcess_SaveSuccessTip":"套图配方已保存至此处\\n可一键复用","Button_GotIt":"知道了","Title_Congrats":"恭喜","SubTitle_BrandCreate":"您已建立您的首个品牌模板——是时候探索它的潜力了","Button_CheckUse":"立即查看","Chat_Prompt_Brand":"生成促销海报","Tooltip_UseBrand":"您可以在此处切换或添加品牌模板！","Tooltip_PosterBrand":"点击这里，基于您的品牌模板生成第一张海报","Popup_CreateBrand":"从零开始创建品牌","Desc_CreateBrand":"使用我们的 AI Agent 创作令人惊艳的原创 Logo。","Popup_UploadBrand":"上传您的品牌信息","Desc_UploadBrand":"上传品牌信息，Zawa 将确保所有设计保持风格一致。","Title_BrandEntry":"立即获取专属品牌系统","Desc_BrandEntry":"让 AI 成为您的专属设计师。回答几个问题，即可获得符合您设想的完整品牌系统。","Tooltip_UseBrand_Agent":"应用品牌模板后，设计过程将自动参考品牌 Logo、调色板及整体风格。","Tooltip_PosterBrand_Agent":"您已经准备好使用品牌模板进行设计了","BatchProcess_createText":"套图配方","Label_NormalMode":"普通模式：","Label_AdvancedMode":"高级模式：","Text_NormalMode":"普通模式","Text_AdvancedMode":"高级模式","BatchProcess_DefaultPrompt":"帮我生成套图","Title_CreateBrand":"还没有品牌？","Title_UploadBrand":"已经有Logo？","Button_CreateBrand":"创建品牌","BatchProcess_EditContent":"编辑内容","BatchProcess_PleaseSelect":"请选择套图配方","BatchProcess_SelectTip":"选择后将按照选择的套图配方，对所有上传图片进行批量生成～","BatchProcess_ListEmptyTip":"生成套图后可保存配方，一键批量生成同类套图","BatchProcess_Tip":"套图配方","BatchProcess_Generate":"前往生成套图","BatchProcess_Save":"保存","BatchProcess_GeneratingFormula":"正在生成套图配方","BatchProcess_GenerateCancel":"取消","BatchProcess_WorkFlowCreateError":"创建失败","ProductInfo_PleaseUploadImage":"请上传商品图片","BatchProcess_IntelligenceGenerate":"智能生成套图配方表格","BatchProcess_CreateWorkflow":"创建工作流","BatchProcess_Formula":"套图配方","BatchProcess_WorkFlowSaveSuccess":"套图配方已保存成功","ProductInfo_ImageSizeLimit":"图片最大仅支持${0}M~","ProductInfo_ImageUpload":"上传商品图","ProductInfo_UploadDemo":"商品案例上传参考：","ProductInfo_ECPlatform":"电商平台","ProductInfo_PleaseSelect":"请选择","ProductInfo_InputCustomize":"自定义","ProductInfo_CountryAndLanguage":"销售国家/语言","ProductInfo_Name":"商品名称","ProductInfo_Desc":"商品详情（卖点/尺寸/场景）","ProductInfo_DescPlaceholder":"可输入商品相关详细信息，如商品卖点、尺寸规格、期望场景、适用人群等","ProductInfo_NamePrompt":"商品名称是${0}，","ProductInfo_ECPlatformPrompt":"电商平台是${0}，","ProductInfo_CountryAndLanguagePrompt":"国家语言是${0}，","ProductInfo_DescPrompt":"商品详情是${0}，","ProductInfo_PleaseInput":"请输入","Button_UnlockPro":"解锁Pro版本","Button_UpgradeToPro":"升级到Pro版本","Button_RenewNow":"立即续费","AgentEmpty_CaseUseBtn":"使用","AgentEmpty_CaseRefreshBtn":"换一批","MenuItem_Effect":"特效","MenuItem_Shadow":"阴影","MenuItem_Stroke":"描边","Title_ChangeText":"无痕改字","Button_Logout":"退出登录","Message_ExtractText":"提取文字中","Message_ExtractTextError":"文字提取失败，请重试","Tip_CreditConsume":"本次生成将消耗${0}美豆","Tip_EstimatedTime":"预计等待${0}分钟","BatchProcess_SaveSuccessTip_GotIt":"知道了","BatchProcess_SaveSuccessTip_Title":"套图配方指引","BatchProcess_SaveSuccessTip_Desc":"点击这里查看你保存的套图配方，一键复用可生成相似套图","BatchProcess_tutorial":"使用教程","Text_HandTool":"抓手","Text_Function":"功能","Text_WindowsSystem":"Windows系统","Text_MacSystem":"Mac系统","Menu_KeyboardShortcuts":"快捷键","Title_KeyboardShortcuts":"快捷键","Text_Undo":"撤销","Text_MouseLeft":"鼠标左键","Text_Redo":"重做","Text_Delete":"删除","Text_Cut":"剪切","Text_Copy":"复制","Text_Paste":"粘贴","Text_PasteFixed":"固定位置粘贴","Text_CreateCopy":"创建副本","Text_SelectAll":"全选","Text_SelectMultiple":"多选","Text_Group":"成组","Text_Ungroup":"解组","Text_LockLayer":"锁定图层","Text_Save":"保存","Text_Move":"移动","Text_MoveWithCombinedKeys":"快速移动","Text_TouchEditFastMode":"快速标注改图","Text_Pan":"平移","Title_Canvas":"画布","Title_Edit":"编辑","Title_Elements":"元素","Title_Tools":"工具","Title_Blogs":"Blog","Text_NewText":"新建文字","Text_NewLine":"新增直线","Text_NewRectangle":"新建矩形","Text_NewCircle":"新建圆形","Text_ExitFullScreen":"退出全屏","Text_MoveUpOneLayer":"上移一层","Text_MoveDownOneLayer":"下移一层","Text_Top":"置顶","Text_Bottom":"置底","Text_CanvasZoom":"画布缩放","Text_ToggleReferenceLine":"显示/隐藏参考线","Text_ToggleRulerBar":"显示/隐藏标尺","Text_ArrowKey":"方向键","Text_CanvasShowAll":"显示画布全部内容","Title_Unsupported_Multilayer":"该功能暂不支持多图层进入操作～","Btn_CreateBatchProcessFormula":"创建配方","Button_Hide_Otherlayers":"隐藏其他图层仅画布原图进入","Button_Merge_Alllayers":"合并所有图层进入","Checkbox_Disable_Remind":"不再提示","Button_Tool":"工具","Button_Custom_Ratio":"自定比例","Label_Spacing":"间距","Button_Download_Whole":"整图下载","Button_Download_Layer":"分层下载","Button_Origin_Ratio":"原比例","Text_TouchEdit_Title":"使用“标注改图”功能","Text_TouchEdit_Description":"精确指出想要修改的地方，让改图精确又便捷","Tooltip_TouchEdit_Max_Count":"最多只能添加${0}个标注","Tooltip_TouchEdit_Usage":"${0} + 点击，快捷标注改图","Text_TouchEdit_Recognition_Custom":"自定义","Text_TouchEdit_Recognition_Title1":"标注识别","Text_TouchEdit_Recognition_Title2":"未识别到物品，请填写","Text_TouchEdit_Name":"标注改图","Btn_LoginToViewBatchProcess":"请登录后查看套图配方","Btn_Login":"立即登录","Menu_Main_Beautify":"美化","Text_Model_Pricing":"模型定价","Text_Pro_discount":"Pro Plan 视频生成半价","Text_TemplatePrompt":"让我们从灵感开始","Text_Hi":"你好，${0}！","Text_Account_Popup_Left":"您值得信赖的电商设计助手 —— 让每一次产品发布都更快、更完美、更盈利。","Text_PleaseWaitImageUploaded":"请等待图片上传完成","Menu_Redeem_Rights":"兑换权益","Text_Redeem_Now":"立即兑换","Text_Redeem_Placeholder":"请输入兑换码，区分大小写","Text_Redeem_Success":"兑换成功！","Text_Redeem_Use":"使用兑换码","Tooltip_BrandAutoUse":"您的新品牌模板已应用！","Redeem_Redeem_Note":"兑换须知：\\n登录用户账号后，输入兑换码即可完成兑换\\n兑换成功后，即可享受对应的权益和服务\\n请在兑换码有效期内使用，过期作废，不可退款\\n请妥善保管，遗失、泄露、登错账号等不补\\n此卡严禁倒卖、转让，不可兑换现金，不支持开发票","Tooltip_Color_Fill":"颜色填充","Tootip_StartPoint":"起始端点","Tootip_ChangePoint":"交换端点","Tootip_EndPoint":"结束端点","Sidebar_NewDesign":"新建对话","Retouch_Filter_Clear":"清透","Retouch_Filter_Enhance":"增色","Retouch_Filter_Dehaze":"去雾","Retouch_Filter_Texture":"质感","Retouch_Filter_Nature":"自然","Retouch_Filter_Fade":"褪色","Modal_Button_Known":"我知道了","Modal_Button_GotIt":"收下","Modal_Button_Later":"再想想","Text_Appeal_Confirm":"确认申诉","Text_Vip_Open":"开通会员","Text_Appeal_ReGenerate":"当前生成结果已二次编辑，不支持效果申诉","Text_Appeal_Left":"本月剩余次数\\n<i>${0}</i>/${1}次","Text_Appeal_Refunded":"美豆已退回至您的美豆账号，请查收。","MenuItem_Appeal":"效果申诉","Tooltip_Downloading":"正在下载中...","Tooltip_Download_Video":"视频仅支持单个下载","Tooltip_Download_NoneSelected":"请先选中想下载的内容","Text_AI_Thinking":"AI 深度思考中...","Text_Server_Busy":"服务器繁忙，请稍后再试","Text_Prompt_Help_Placeholder":"请输入一些关键词，我会帮您扩写成完整的商业提示词","Text_Prompt_Helping":"正在帮写，请稍等...","Button_Retry":"重试","Button_Rewrite":"重写","Button_Start_Prompt_Help":"开始智能优化","Title_Prompt_Helper":"AI 帮写","Menu_Text_Subscriptions":"订阅","Menu_View_Subscriptions":"查看订阅","Text_Download_XdesignApp":"请下载 <span>Zawa</span> APP 以使用该功能","Text_Free_Trial":"下载获取 7 天免费试用","Text_Install_App":"安装 APP","Text_Scan_Download":"扫码下载","Text_Download_the":"下载平台","Text_Available_On":"支持平台","Desc_ExpireDate":"到期时间","DownloadApp_Title_Widgets":"请下载 ${0} APP 以使用该功能","DownloadApp_SubTitle_Widgets":"下载并享受 ${0} 天免费试用","InstallApp_Title_Widgets":"安装 APP","InstallApp_Desc_Widgets":"扫码下载","AppStore_Desc_Widgets":"在 App Store 下载","GooglePlay_Desc_Widgets":"在 Google Play 下载","Text_Tips_GetFree":"获得一次免费体验机会","Text_AgentLib":"资产库","Tip_ModelSetSaveSuccess":"模特已保存，可点击使用","Text_BatchProcess":"套图配方","Button_Add":"添加","Tab_Recent":"最近保存","Tab_Models":"我的模特","Prompt_Model":"第${0}张图是我的模特","Tip_SaveSuccess":"保存成功","Text_ModelsLogin":"请登录后查看模特库","Loading_CheckFace":"正在检测人脸…","Name_InitialModelName":"模特库","EmptyTip_ModelList":"暂未保存模特，快去创建吧～","Text_UploadModel":"上传我的模特","Text_Model":"模特","Tips_UnsupportedFormat":"不支持的文件格式","Tips_InputModelName":"请输入模特名称","Tips_UploadModelImage":"请上传模特图片","Title_CreateModel":"创建专属模特","Text_ModelName":"模特名称","Placeholder_Input":"请输入...","Text_UploadModelHint":"拖拽或点击模特照片上传JPEG/JPG/PNG/HEIC/SVG","Button_SubmitUpload":"立即上传","Tips_NameLengthLimit":"请输入${0}字内的名称","Tips_DeleteFailed":"删除失败","Title_ConfirmDeleteModel":"确认删除这个模特吗？","Tips_CreateSuccess":"创建成功","Tab_BatchTemplate":"套图模板","Tab_MyModel":"我的模特","Placeholder_InputContent":"输入内容","Title_ChooseSceneType_VideoGenerateCard":"请选择您希望生成的内容类型和分镜结构：","Button_ConfirmGenerate_VideoGenerateCard":"已确认，开始执行视频生成流程","Title_ShotType_VideoGenerateModal":"分镜类型","Title_ShotRequirement_VideoGenerateModal":"分镜描述","Title_Duration_VideoGenerateModal":"时长","Btn_AddOneTableRow":"新增一行","Label_Gender_ModelModal":"性别","Label_Appearance_ModelModal":"外观特征","Label_AgeGroup_ModelModal":"年龄段","Label_Persona_ModelModal":"人设","Label_BodyType_ModelModal":"体型","Tips_GenerateModelFailed_ModelModal":"生成失败，请稍后重试","Tips_NetworkError_ModelModal":"网络异常，请稍后重试","Tab_CustomModel_ModelModal":"定制模特","Tab_OfficialModel_ModelModal":"官方模特","Tab_UploadModel_ModelModal":"上传模特","Text_ModelPreview_ModelModal":"模特预览","Button_Generating_ModelModal":"生成中...","Button_Regenerate_ModelModal":"重新生成","Button_Generate_ModelModal":"生成","Button_Saving_ModelModal":"保存中...","Button_SaveAndUse_ModelModal":"保存并使用","Button_CreateNewModel_AgentLibList":"创建新模特","Message_NotFilled_RequiredField":"未填写${0}","Title_ChooseSceneType2_VideoGenerateCard":"请选择您希望生成的分镜结构：","Title_ContentType_VideoGenerateCard":"内容类型","Title_StoryboardStructure_VideoGenerateCard":"分镜结构","Text_Offical":"官方","Title_AboveTheFold_Main_HomeV2":"让每一张商品图 <br /> <span>更具卖货力</span>","Title_Designkit_Slogan":"让每张商品图都能促成销售","Button_StartFree_HomeV2":"免费开始","Title_AboveTheFoldMobile_Main_HomeV2":"让每一张商品图 <br /><span>更具卖货力</span>","SubTitle_AboveTheFoldMobile_HomeV2":"从专业的图片编辑到自动化的 Listing 生成，这里有您所需的一切。","Text_TopBanner_HomeV2":"Seedance 2.0 即将上线，敬请期待","Title_ModuleCard_HomeV2":"首先，生成高质量资产","SubTitle_ModuleCard_HomeV2":"告别空白画布。使用我们的一体化智能创意 AI Agent 矩阵，几秒内生成完整的 <br /> Listing 套图、动态视频、虚拟试衣以及全球本土化适配。","Title_Faq_Q1_HomeV2":"你们提供免费试用吗？","Text_Faq_A1_HomeV2":"是的！新用户注册即享 20 个免费积分。此外，每天登录还可领取 10 个免费积分。这让您在升级为付费计划之前，可持续体验包括图片和视频生成在内的所有核心功能。","Title_Faq_Q2_HomeV2":"图片符合Amazon/Shopify的规范吗？","Text_Faq_A2_HOMEV2":"完全符合。针对商品主图，我们的 AI 严格输出符合亚马逊和 Shopify 要求的纯白背景 (RGB 255,255,255)。对于生活场景图及社交媒体图片，它能确保完美的尺寸比例与高分辨率画质，让您的 Listing 完全合规且专业。","Title_Faq_Q3_HomeV2":"生成的资产可以用于商业用途吗？","Text_Faq_A3_HomeV2":"是的。在付费计划下生成的所有图片和视频均为 100% 免版税，并且已全面获得商业使用许可。您可以无限制地将这些资产应用于您的 Shopify 商店、亚马逊 Listing、社交媒体广告及任何其他营销渠道。","Title_Faq_Q4_HomeV2":"批量生成和编辑是如何工作的？","Text_Faq_A4_HomeV2":"Designkit 的各项功能原生支持批量处理。您只需将多张图片直接上传到工作区。无论您是生成新的生活方式背景、去除原始背景、消除多余对象还是提升分辨率，只需一键即可将所选操作应用于整个批次。这不仅能确保您的商店素材完美一致，还能为您节省数小时的人工处理时间。","Title_Faq_Q5_HomeV2":"支持哪些文件格式？","Text_Faq_A5_HomeV2":"视频导出支持为社交媒体和电商平台优化的 MP4 格式。","Title_Questions_Main_HomeV2":"常见问题","Title_Scale_Main_HomeV2":"准备好扩大规模了吗？","SubTitle_Scale_HomeV2":"加入超过 10,000 名卖家的行列，使用 Designkit 自动化您的设计工作流。","Title_Evaluation_HomeV2":"最终，更快地上线并获得更多销量","SubTitle_Evaluation_HomeV2":"削减 90% 的制作时间。抢先您的竞争对手，在亚马逊和 Shopify 上发布高转化率的 Listings。","Tab_Module_ProductImage_HomeV2":"AI商品套图","Desc_Module_ProductImage_HomeV2":"将一张供应商提供的照片瞬间转化为整套 Listing 素材。自动生成白底主图、生活场景图及信息图，并轻松批量处理成百上千个 SKU，同时自动翻译文本以适配全球市场。","Tip_Module_ProductImage_HomeV2":"为这款粉色耳机生成一套亚马逊 Listing 图片。","Tab_Module_ModelImage_HomeV2":"AI模特","Desc_Module_ModelImage_HomeV2":"没有模特？不是问题。在各种不同的 AI 模特身上展示您的服装，无需预定昂贵的实景拍摄，即可有效提升点击率。","Tip_Module_ModelImage_HomeV2":"让一位 25 岁的女性模特展示这套黄绿色西装。","Tab_Module_Video_HomeV2":"AI商品视频","Desc_Module_Video_HomeV2":"让产品生动起来。仅需一段文本或单张图片，即可生成动态产品展示视频、引人入胜的 AI 代言人视频及高转化广告，在各大电商平台及社交媒体上吸引眼球并推动销量。","Tip_Module_Video_HomeV2":"为这个蓝色花瓶生成一段商品展示视频。","Tab_Module_DetailPage_HomeV2":"AI商品详情页","Desc_Module_DetailPage_HomeV2":"无需设计技巧，几分钟内即可为您的网店创建高级 A+ 页面内容和无缝宣传海报。将基础商品图转化为极具吸引力的页面布局，轻松让您的 Listing 脱颖而出。","Tip_Module_DetailPage_HomeV2":"为这组橙色沙发生成一张商品详情长图。","Tab_Module_Photography_HomeV2":"AI商品图","Desc_Module_Photography_HomeV2":"抛弃千篇一律的素材库。将您的产品置于能与欧美市场产生共鸣、独具品牌调性的专属场景中。","Tip_Module_Photography_HomeV2":"为这款香水生成一张摄影背景图。","Title_Module_SecondTitle_HomeV2":"然后，通过AI进行精细修图","SubTitle_Module_SecondSubTitle_HomeV2":"资产已生成？现在让它们变得更完美。使用我们的 AI 图片编辑器批量去除背景、清理瑕疵，并对低清图片进行画质提升。","Text_Upload_HomeV2":"上传","Text_TopBannerMobile_HomeV2":"Seedance 2.0 即将上线","Text_Prompt1_HomeV2":"生成全套亚马逊listing图。","Text_Prompt2_HomeV2":"生成穿着这套衣服的模特。","Text_Prompt3_HomeV2":"生成商品营销视频。","Text_Prompt4_HomeV2":"生成A+内容商品详情页。","Text_Prompt5_HomeV2":"为商品图生成合适的背景。","Desc_Evaluation1_HomeV2":"速度极快！图片即可用于 Mercado Libre 和亚马逊。它能完美地根据当地审美调整背景和模特。生成的作品非常专业。","Desc_Evaluation2_HomeV2":"太喜欢 Designkit 了！AI 生成的生活场景图自然、温馨且充满北欧风——完美契合我的香薰蜡烛店铺。我的 Listing 看起来更精美了，销量也有所增长。非常值得！","Desc_Evaluation3_HomeV2":"我是卖服装的，原本担心 AI 会破坏材质质感。但 Designkit 完全搞定了！色彩完美还原，模特的姿势看着很自然，图片出炉就能直接用。","Header_products_socialMediaPostGenerator":"社媒海报生成器","Pricing_Seedance_UnlockLimited":"解锁无限制访问","Pricing_Seedance_SeedanceV1":"<span>Seedance 2.0</span> 抢先体验","Pricing_Seedance_SeedanceDesc":"成为首批体验 Seedance 2.0 强大功能的用户之一。现在订阅任意 Pro 计划，即可获得我们新一代 AI 模型的专属无限访问权限。","Pricing_Seedance_Monthly":"月度计划奖励","Pricing_Seedance_DaysUnLimit":"7 天 <span>无限畅用</span>","Pricing_Seedance_SeedanceV2":"访问 Seedance 2.0","Pricing_Seedance_BestValue":"最划算","Pricing_Seedance_Yearly":"年度计划奖励","Pricing_Seedance_MonthUnLimit":"1 个月 <span>无限畅用</span>","Title_AIBrand_Tools":"AI品牌工具","Title_AISocialMediaPosts":"社媒帖子","Title_AILogoMaker":"AI Logo生成器","Option_Child_Age":"儿童","Option_Infant_Age":"婴儿","Option_MiddleAged_Age":"中年","Option_Senior_Age":"老年","Option_Teen_Age":"青少年","Option_YoungAdult_Age":"青年","Button_GenerateImages_DetailPageAction":"生成详情图","Text_GenerateImagesCount_DetailPageAction":"（${0}张）","Text_GenerateImagesCount_DetailPageAction1":"（${0}张）","Option_MercadoLivre_Platform":"美客多","Option_Etsy_Platform":"Etsy","Option_Walmart_Platform":"沃尔玛","Option_eBay_Platform":"eBay","Option_Poshmark_Platform":"Poshmark","Button_GeneratePlan_DetailPageAction":"生成详情页策划方案","Option_AdvancedMobile_DetailPageMode":"高级A+（移动端）","Option_AdvancedWeb_DetailPageMode":"高级A+（Web端）","Option_Standard_DetailPageMode":"普通A+","Option_Accessories_DetailSection":"配件/赠品图","Option_ServiceSupport_DetailSection":"售后保障图","Option_BeforeAfter_DetailSection":"效果对比图","Option_BrandStory_DetailSection":"品牌故事图","Option_KeyHighlights_DetailSection":"核心卖点图","Option_CraftProcess_DetailSection":"工艺制作图","Option_HeroVisual_DetailSection":"首屏主视觉","Option_Composition_DetailSection":"商品成分图","Option_MultiAngle_DetailSection":"多角度图","Option_DetailCloseups_DetailSection":"商品细节图","Option_SceneMood_DetailSection":"场景氛围图","Option_SeriesShowcase_DetailSection":"系列展示图","Option_SizeCapacity_DetailSection":"尺寸/容量/尺码图","Option_Specifications_DetailSection":"详细规格/参数表","Option_UsageScenario_DetailSection":"使用场景图","Option_UsageTips_DetailSection":"使用建议图","Paragraph_ServicePolicy_DetailSection":"说明质保退换政策","Paragraph_BeforeAfter_DetailSection":"使用前后效果对比","Paragraph_BrandConcept_DetailSection":"传达品牌理念","Paragraph_CoreValue_DetailSection":"传递核心价值","Paragraph_CraftProcess_DetailSection":"展示工艺制作过程","Paragraph_Differentiators_DetailSection":"突出差点优势","Paragraph_Composition_DetailSection":"展示配方/材质/成分","Paragraph_MaterialAndCraft_DetailSection":"放大材质与工艺","Paragraph_MultiAngleAppearance_DetailSection":"多角度呈现外观","Paragraph_MultiOptionDisplay_DetailSection":"多色或多SKU展示","Paragraph_IncludedItems_DetailSection":"明确收货的所有物品","Paragraph_DetailData_DetailSection":"展示详细商品数据","Paragraph_RealUsageScene_DetailSection":"呈现真实使用场景","Paragraph_Specifications_DetailSection":"展示规格信息","Paragraph_UsageNotes_DetailSection":"商品使用的注意事项","Paragraph_UsageScenario_DetailSection":"展示使用场景","Title_Nav_DetailPage":"A+详情","Title_ImageSet_DetailPage":"A+详情套图","Input_TaskName_Batch":"输入任务名称","Paragraph_FullAssetSetDescription_Batch":"包含主图、场景图、白底图等全套营销素材，适合多平台铺货。","Paragraph_LongFormVisualDescription_Batch":"专注于商品长图、A+描述页及细节对比图的深度氛围渲染。","Message_JsonGenerated_Batch":"表单校验通过，已生成 JSON 数据","Message_JsonCopied_Batch":"JSON 已复制","Message_IncompleteRequiredFields_Batch":"该项表单有必填项未完成，请完善后再提交","Message_PleaseUploadSourceImage_Batch":"请上传商品图","Message_PleaseCompleteStrategySettings_Batch":"请完善策略配置","Message_TaskValidationFailed_Batch":"有任务项未通过校验，请先完善","Message_CopyJsonFailed_Batch":"复制失败，请在控制台查看 JSON","Message_PleaseEnterTitle_Batch":"请输入标题","Message_PleaseEnterKeyHighlights_Batch":"请输入卖点描述","Message_PleaseGenerateJsonFirst_Batch":"请先点击提交生成 JSON 数据","Title_DetailPage_Batch":"详情页A+","Title_DetailTask_Batch":"A+任务${0}","Title_IndependentParameters_Batch":"单独调整参数","Title_ImageSet_Batch":"电商爆款套图","Title_ItemTask_Batch":"商品任务","Option_Curvy_BodyType":"微胖","Option_Muscular_BodyType":"肌肉","Option_PlusSize_BodyType":"大码","Option_Slim_BodyType":"纤细","Option_Standard_BodyType":"标准","Button_Reset_Common":"重置","Button_Back_Common":"返回","Button_Collapse_Common":"收起","Button_Expand_Common":"展开","Button_Generate_Common":"去生成","Button_PreviousStep_Common":"上一步","Button_RemoveFavorite_Common":"取消收藏","Button_StartNow_Common":"立即体验","Paragraph_ExitWarning_Common":"返回后数据将要情况","Paragraph_Content1_VirtualModelDisclaimer":"2.生成内容特性理解：AI生成内容基于算法与数据学习，其结果存在不确定性。生成的面容可能与原肖像存在差异，且不排除出现瑕疵或不尽如人意的情形。平台对生成内容的准确性、美观度及适用性不作保证。","Paragraph_Content2_VirtualModelDisclaimer":"3.使用责任自担：您应对上传的人脸照片及生成内容负责，确保其使用不侵犯任何第三方的合法权益（包括但不限于肖像权、隐私权、名誉权等），并符合相关法律法规。禁止将生成内容用于任何违法、侵权（如诽谤、欺诈）、违背公序良俗或侵犯他人尊严的用途。","Paragraph_Content3_VirtualModelDisclaimer":"请谨慎上传，并确认您已充分理解并接受上述告知内容。","Title_Notice_VirtualModelDisclaimer":"在您使用“AI商品套图-服饰穿戴”功能前，请您仔细阅读并理解以下内容：","Message_FailedRetry_Download":"下载失败，请稍后重试","Message_Failed_Download":"下载失败","Message_Success_Download":"下载成功","Message_NoImagesAvailable_Download":"该分组暂无图片","Option_Asian_Ethnicity":"亚洲人","Option_Black_Ethnicity":"非裔","Option_Chinese_Ethnicity":"中国人","Option_Latino_Ethnicity":"拉丁裔","Option_MiddleEastern_Ethnicity":"中东人","Option_SoutheastAsian_Ethnicity":"东南亚人","Option_White_Ethnicity":"欧美白人","Option_Female_Gender":"女","Option_Male_Gender":"男","FormLabel_Ethnicity_Common":"人种","FormLabel_OriginalImage_Common":"原图","FormLabel_OutputLanguage_Common":"输出语言","FormLabel_TargetMarket_Common":"目标市场","FormLabel_TargetPlatform_Common":"目标平台","Option_German_Language":"德语","Option_Japanese_Language":"日语","Option_None_Language":"无文字","Option_Portuguese_Language":"葡萄牙语","Option_PortugueseBr_Language":"葡萄牙语（巴西）","Option_Russian_Language":"俄语","Option_Spanish_Language":"西语","Option_SpanishMX_Language":"西语（墨西哥）","Option_Thai_Language":"泰语","Option_Brazil_Market":"巴西","Option_China_Market":"中国","Option_Europe_Market":"欧洲","Option_Germany_Market":"德国","Option_Japan_Market":"日本","Option_Russia_Market":"俄罗斯","Option_SoutheastAsia_Market":"东南亚","Option_Spain_Market":"西班牙","Option_UnitedStates_Market":"美国","Message_MaxLimit_DetailSectionSelection":"最多可选${0}个模块","Option_FollowGlobalSettings_Common":"跟随全局","Text_MaxTasks_Batch":"最多添加${0}项任务","Text_MinTasks_Batch":"至少保留一个任务项","Text_MaxImagesPerTask_Batch":"单项最多上传${0}张图片","Text_SupportedImageFormats_Batch":"仅支持上传 jpg、jpeg、png、heic、webp 图片","Input_AppearanceDetailsExample_TryOn":"例如：小麦色皮肤、齐刘海、眼角有泪痣...","Input_SourceInfoGuide_Batch":"建议包含以下信息生成更精准：\\n1.产品名称\\n2.核心卖点\\n3.适用人群\\n4.期望场景\\n5.具体参数","Tooltip_OutputStyleConsistent_Clone":"开启后生成的多张图将保持统一的配色和调性，确保整套风格一致； 关闭则每张独立跟随各自参考图风格。","Option_AlibabaInternational_Platform":"阿里国际站","Option_AliExpress_Platform":"速卖通","Option_Amazon_Platform":"亚马逊","Option_Douyin_Platform":"抖音","Option_DouyinEcommerce_Platform":"抖音电商","Option_IndependentSite_Platform":"独立站","Option_Indonesian_Language":"印尼语","Option_JD_Platform":"京东","Option_Pinduoduo_Platform":"拼多多","Option_Taobao_Platform":"淘宝","Option_TaobaoTmall1688_Platform":"淘宝天猫1688","Button_Generate_ImageSet":"一键生成爆款套图","Title_Nav_ImageSet":"商品套图","Message_GenerateFailedRetry_ImageSet":"生成失败，请重试","Message_PleaseSelectStyleFirst_ImageSet":"请先选择爆款风格再生成！","Message_CreateTaskFailed_ImageSet":"创建任务失败","Title_StyleAnalysis_ImageSet":"爆款风格分析","Option_TrafficMaximization_TitleStrategy":"流量最大化","Option_ConversionPriority_TitleStrategy":"转化率优先","Option_SceneImmersion_TitleStrategy":"场景沉浸","Text_ExtractingVisualAttributes_TitleGenerationStatus":"正在提取当前视觉素材核心属性...","Text_AnalyzingKeyHighlights_TitleGenerationStatus":"正在结合核心卖点极速运算高转化词库...","Text_MatchingSeoStrategy_TitleGenerationStatus":"正在匹配平台 SEO 最优策略...","Text_GeneratingOptions_TitleGenerationStatus":"正在生成多维度标题方案...","Message_TaskFailedWithStatus_TitleGeneration":"任务执行失败 (status: ${0}): ${1}","Message_TaskTimedOut_TitleGeneration":"任务执行超时，请重试","Message_GenerateFailed_TitleGeneration":"标题生成失败，请重试","Message_QueryResultFailed_TitleGeneration":"查询任务结果失败","Paragraph_Content_VirtualModelConsent":"1.肖像权授权确认：本功能将使用您上传的人脸图像，通过人工智能技术生成虚拟模特面容。您必须确保：您是所上传人脸照片的肖像权人，或您已获得肖像权人的明确、有效的书面授权，允许您将其肖像用于本服务及生成作品的相关用途。若上传未成年人肖像，须已获得其监护人的同意。","Button_ConfirmTextChange_TextEdit":"确认改字","Input_ModifyText_TextEdit":"修改图片中的文字","Message_NoImagesAvailable_ResultDownload":"暂无可下载的图片","Message_Failed_TextRecognition":"文字识别失败","Text_Generating_ResultStatus":"AI生成中…","Option_CustomColor_SceneSetting":"自定义颜色","Option_UseOriginalBackground_SceneSetting":"使用原图背景","Text_InsufficientCredits_Common":"美豆不足","Button_LoadMore_Common":"加载更多","Text_ImageUploadLimit_Common":"最多上传${0}张图片","Text_AnalyzingTrend_Common":"正在分析 ${0} 趋势","Text_ChineseOutputProOnly_Common":"仅Pro版支持中文生成哦～已为你切换为无文字版本。","Text_SourceImageUploadLimit_Common":"最多上传${0}张图片","Text_WritingInProgress_AiWriting":"正在帮写请稍后...","Text_DeepThinking_AiWriting":"AI深度思考中…","Text_ThinkingProcess_AiWriting":"思考过程:","Text_ImageSelectionLimit_Common":"最多选择 ${0} 张图片","Message_RegenerationSubmitted_Regeneration":"提交成功，请稍后刷新查看结果","Button_MoreEditOptions_ResultEditor":"更多编辑","FormLabel_DetailSection_DetailPage":"详情页模块","Message_GeneratePlanFailed_DetailPagePlan":"生成策划方案失败","Message_PlanGenerationFailed_DetailPagePlan":"策划方案生成失败","Text_PlanUnavailable_DetailPagePlan":"没有策划方案","Message_SourceImageMissing_Common":"商品图片丢失","Message_GenerationFailed_Common":"生成失败","Paragraph_ConfirmDiscardChanges_Common":"返回后，已编辑的内容将会丢失，确认返回吗？","Message_ProcessFailed_Common":"处理失败","Text_GeneratingEllipsis_Common":"生成中…","Text_StyleGenerationInProgress_ImageSet":"爆款风格生成中…","Message_FavoriteAdded_Common":"收藏成功","Message_FavoriteRemoved_Common":"取消收藏成功","Text_LoadingPlain_Common":"加载中","Text_MultiSelectAvailable_Common":"可多选","Text_NoData_Common":"没有数据","Text_NoDataAvailable_Common":"暂无数据","Text_NoMoreResults_Common":"没有更多了","Message_PleaseEnterKeyHighlights_DetailPage":"请输入核心卖点","Message_PleaseSelectAiModel_TryOn":"请先选择ai模特","Message_SelectSectionMin_DetailPage":"请至少选择${0}个模块","Message_SelectScenePoseMin_TryOn":"请至少选择${0}个场景和姿势","Message_PleaseSelectBaseModel_TryOn":"请选择基准模特","Message_PleaseSelectCustomModel_TryOn":"请先选择自定义模特","Message_PleaseSelectModel_TryOn":"请先选择模特","Message_PleaseSelectSection_DetailPage":"请选择模块","Message_SelectUploadCustomModel_TryOn":"请先选择或上传自定义模特图","Message_PleaseSelectScene_TryOn":"请选择场景","Message_PleaseSelectStrategy_DetailPage":"请先选择策略","Message_PleaseUploadGarmentImage_TryOn":"请先上传服装图","Message_UploadGarmentFile_TryOn":"请先上传服装图片","Message_PleaseUploadSourceImage_Common":"请先上传商品图","Message_PleaseUploadItemImage_Common":"请上传产品图","Message_UploadItemFirst_Common":"请先上传产品图","Message_RegenerateFailedWithReason_Regeneration":"重新生成失败:","Message_SelectResultImages_Result":"请先选择具有结果图的图片","Text_ReleaseToRefresh_Common":"释放刷新","Message_TextRecognitionFormatInvalid_TextRecognition":"识别结果格式错误","Message_TextRecognitionParseFailed_TextRecognition":"解析识别结果失败","Message_TextRecognitionTaskFailed_TextRecognition":"文字识别任务失败","Message_QueryTaskStatusFailed_TextRecognition":"查询任务状态失败","Message_SubmitTaskFailed_TextRecognition":"提交文字识别任务失败","Text_RegenerationProcessing_Regeneration":"提交成功，正在处理中...","Message_RegenerateFailedRetry_Regeneration":"重新生成失败，请稍后重试","Message_OpenEditorFailed_ResultEditor":"跳转编辑失败","Message_RegenerateFailed_Regeneration":"重新生成失败","Message_RefreshFailedRetry_Common":"刷新失败，请重试","Message_UploadGarmentSelectModel_TryOn":"请先上传服装图，并选择模特","Message_PollingTimedOut_Common":"轮询超时","Title_KeyHighlights_DetailPage":"商品卖点&要求","Title_FullStrategyGuide_DetailPage":"全案策略与设计规范","Title_IncludedSections_DetailPage":"包含模块","Title_IncludedSectionsMultiple_DetailPage":"包含模块 (多选)","Title_ModelSelection_TryOn":"模型选择","Title_SectionContent_DetailPage":"模块内容","Title_SectionStrategyGuide_DetailPage":"模块策略与设计规范","Title_OutputAspectRatio_Common":"输出比例","Title_OutputSpecification_Common":"图片比例","Title_SelectModel_TryOn":"选择模特","Title_SelectScene_TryOn":"选择场景","Title_StrategySettings_DetailPage":"生成设置","Title_UploadAssets_Common":"商品原图","Button_GenerateBaseModel_TryOn":"生成基准模特","Button_GenerateRecommendedScenes_TryOn":"生成推荐场景","Button_GenerateSceneImages_TryOn":"生成场景图片（${0}张）","Text_GeneratingBaseModel_TryOn":"基准模特生成中…","Option_CloseUp_Framing":"特写","Option_FullBody_Framing":"全身","Option_HalfBody_Framing":"半身","Option_ThreeQuarter_Framing":"四分之三","Title_Hero_TryOn":"AI服饰穿戴","Option_Ai_TryOnModelMode":"AI 生成","Title_Nav_TryOn":"服饰穿戴","Option_Back_Perspective":"背面","Option_Front_Perspective":"正面","Option_Side_Perspective":"侧面","Option_ThreeQuarterSide_Perspective":"3/4侧","Input_AppearanceDetailsHint_TryOn":"外貌细节：小麦色皮肤、齐刘海、眼角有泪痣...","Message_SaveToAlbumSuccess_Common":"已保存到相册","Text_GeneratingSceneImages_TryOn":"正在生成场景图片...","Message_RefreshFailed_Common":"刷新失败","Message_FailedRefunded_Generation":"AI设计失败，美豆已退还","Title_BaseModelImage_TryOn":"基准模特图","Title_CustomModel_TryOn":"模特形象","Paragraph_Intro_TryOn":"上传服装图，定制专属模特，即可生成多种场景不同姿势套图。","Title_UploadGarmentImage_TryOn":"服装图片","Tips_UploadFailedPure":"上传失败","Tips_Uploading":"上传中","Text_UploadNewModel":"上传新模特","Text_AllBackgrounds":"所有背景","Text_DefaultTemplateScene":"默认模版场景","Text_ColorScene":"颜色场景","Text_SameProductMax_Common":"同一产品，最多${0}张。","Text_Max_Common":"最多${0}张","Button_Generate_ImageClone":"一键复刻爆款图","Button_RefreshStyle_Common":"换一批风格","Button_Favorite_Common":"收藏","Text_PreviewLargeImage":"预览大图","Text_BaseImage":"基准图","Button_BatchDownload_Common":"批量下载","Button_BatchEdit_Common":"批量编辑","Button_BatchWatermark_Common":"批量加水印","Text_GeneratedResults":"生成结果","Button_DownloadAllImages_Common":"下载全部图片","Text_NoGeneratedResults":"暂无生成结果","Text_SameProductMax_TryOn":"整套搭配或同一件服装不同角度图，最多${0}张。","Title_AdvancedImageGenerationModel":"高级生图模型","Text_SupportChineseOutput_Common":"支持中文输出；细节、审美、可控性增强。","Text_SelectMultipleModules_DetailPage":"可选择多个模块组合生成详情页","Button_CollapseAll_Common":"展开全部","Label_AppearanceDetails_TryOn":"外貌细节 (可选)","Text_WaitingForGeneration_TryOn":"等待生成","Title_SmartTitleAI_ProductTitle":"生成爆款标题","Message_ResultMissing_TitleGeneration":"AI 返回结果缺少 ${0}","Message_InvalidJSONFormat_TitleGeneration":"AI 返回结构不符合预期","Message_InvalidJSONFormat_TitleGeneration1":"AI 返回了无效的 JSON 格式","Text_AutoGeneratedTitleScheme_ProductTitle":"以下是基于您的产品自动生成的标题方案","Text_SelectBestTitle_ProductTitle":"选择最适合您渠道策略的标题，点击一键复制","Button_Copy_Common":"一键复制","Message_PleaseUploadImage_Common":"请先上传图片","Text_DeepThinking1_AiWriting":"DeepSeek深度思考中…","Button_Rewrite1":"重新帮写","Text_TotalImages_Common":"共${0}张","Text_EditText_ResultEditor":"编辑文字","Text_NoTextRecognition_ResultEditor":"未识别到文字","Text_PreviewLongImage_ResultGroup":"预览长图","Text_LimitFree":"限免","Text_UploadSameProductTip1":"1.可上传同一商品的多视角原图，帮助 AI 更准确还原商品细节。","Text_UploadSameProductTip2":"2.最多支持 ${0} 张图片，第一张将作为主图重点参考，建议选择角度最全的一张。","Text_UploadProductImage_APlusCase":"上传产品图","Text_GenerateEcommerceLongImage_APlusCase":"生成电商长图","Text_MultiPlatform_APlusCase":"符合多电商平台规范","Text_MainImage_ProductCase":"01 主图 (白底/合规)","Text_SceneDisplay_ProductCase":"02 场景展示","Text_ModelSceneImage_ProductCase":"03 模特场景图","Text_DetailDescription_ProductCase":"04 细节说明","Text_FeatureExplanation_ProductCase":"05 卖点详解","Text_UploadProductImage_ProductCase":"上传商品图，Al 即刻生成 <span>符合多电商平台规范</span> 的高转化率商品套图。","Text_UploadGarmentImage_TryOn":"上传服装，选定模特，同场景多姿势套图即刻生成。","Text_UploadProductImage_DetailPage":"上传商品图，AI 即刻生成 <span>符合多电商平台规范</span> 的专业详情页。","Title_DetailPage_ProductCase":"A+/详情页","Option_Temu_Platform":"Temu","Option_TikTokShop_Platform":"TikTok Shop","Option_TikTok_Platform":"TikTok","Option_Ozon_Platform":"OZON","Option_Shopee_Platform":"Shopee","Option_SHEIN_Platform":"SHEIN","Login_Zawa_Title":"登录解锁免费试用","Login_DK_Title":"免费创建令人眼前一亮的设计","Login_Zawa_Des":"立即开始使用 Zawa 创作","Login_DK_Des":"就现在！来注册或登录来继续你的设计","Tab_Module_ProductImage_TryOn_MultiMix":"多件混搭自动融合","Tab_Module_ProductImage_TryOn_SingleHero":"一件也能出大片","Tab_Module_ProductImage_TryOn_Accessories":"鞋帽饰品完美适配","Text_ShowAdvancedModelTip":"显示高级生图模型提示","Text_HideAdvancedModelTip":"隐藏高级生图模型提示","Text_DeepSeekR1HelpWrite":"DeepSeek R1 帮写","Message_PollingMaxAttempts_Common":"超过最大尝试次数${0}","Title_StandardEdition":"标准版","Text_FastAndEfficient_Common":"极速/省流","Text_PremiumEdition":"高级版","Text_QualityAndDetailEnhancement_Common":"画质/细节增强","Text_PremiumEngineActivated":"<strong>高级版引擎已激活：</strong> 支持中文输出，具备更强的细节审美与画面可控性。","Text_EditBrand_DropTitle1":"拖放 JPG、PNG、WEBP 文件","Text_EditBrand_DropTitle2":"或者从您的电脑<>浏览</>","Text_BaseToolbar_AlignTop":"顶部对齐","Text_BaseToolbar_AlignBottom":"底部对齐","Text_LayerSort":"图层排序","Text_BaseToolbar_AlignCenter":"居中对齐","Text_Attr_Strong":"加粗","Text_GeneratingPlan_DetailPagePlan":"策划方案生成中...","Text_PlanGenerationFailed_ReTry":"策划方案生成失败，请重试","Button_StartAnalyze_ProductCase":"开始分析","Message_SubmitSuccessTip_Batch":"提交成功，预计第二天8点可查看结果","Button_ClickAnalyze_ProductCase":"一键分析爆款风格","Button_StartAnalyzing_ProductCase":"分析中","Title_ModelImage":"模特图","Text_Cookie_Title":"首先，Cookie 🍪","Text_Cookie_Content":"我们希望在本网站上使用 Cookie，以确保网站的安全性、高效运行及服务优化。如需了解更多关于我们使用 Cookie 的信息，请点击","Text_Cookie_LearnMore":"了解详情","Button_Cookie_Manage":"管理 Cookie","Button_Cookie_Accept":"接受","Text_CookieModal_Title1":"Cookie 设置","Text_CookieModal_Desc1":"Cookie 是您访问的网站存储在您设备上的小型文本文件。它们有助于我们记住您的偏好、分析网站流量并改进我们的服务。您的隐私对我们很重要，我们希望您能掌控自己的数据。在此，您可以自定义 Cookie 偏好设置，以优化您的浏览体验。请注意：更改 Cookie 偏好设置可能会影响网站的功能以及我们为您提供的服务。","Text_CookieModal_Title2":"必要 Cookie","Text_CookieModal_Desc2":"这些 Cookie 对于网站的功能、安全及基本性能至关重要。若缺失这些 Cookie，Zawa 中的关键功能及安全防护措施将无法使用，从而影响您的使用体验。","Text_CookieModal_Title3":"可选 Cookie","Text_CookieModal_Desc3":"这些 Cookie 帮助我们了解 Zawa 的用户数量、用户来源及其使用模式。如果您选择禁用这些 Cookie，我们将无法获取改进 Zawa 所需的反馈，从而无法为您及所有用户提供更好的服务。","Button_CookieModal_Save":"保存偏好设置","Text_CookieModal":"始终启用","Text_Agent_Chat_DK":"向Designkit发送消息","Text_Agent_Chat_XD":"想让 Zawa 做什么","Radio_Color":"配色","Radio_Layout":"布局","Radio_Reference":"参考${0}","Radio_Posture":"姿势","Radio_Background":"背景","Language_Banner_Message":"是否切换为 ${0}","Language_Banner_Change":"更改语言","Language_Banner_Other":"其他语言","Title_ItemTaskWithIndex_Batch":"商品任务${0}","Title_DetailTaskPrefix_Batch":"A+任务","Text_CopiedTaskTitle_Batch":"${0}（复制）","Message_SelectSectionMin_Batch":"请至少选择一个模块","Title_GlobalBatchSettings_Batch":"全局批量设置（应用于下方所有任务）","Text_Parameters_Batch":"参数","Text_Modules_Batch":"模块","Title_KeyHighlights_Batch":"卖点描述","Text_ModulesFollowGlobal_Batch":"需要的模块-跟随全局","Title_SelectManagedBusinessType_Batch":"请选择托管业务类型：","Button_SubmitTask_Batch":"提交任务","Text_NewTaskCurrentCount_Batch":"新建任务","Title_NotificationSettings_Batch":"通知设置","Title_ManagedMode_Batch":"托管模式","Button_SaveSettings_Batch":"保存设置","Button_SaveAndContinueSubmit_Batch":"保存并继续提交","Message_PhoneFormatInvalid_Batch":"请输入正确的11位手机号","Message_VerificationCodeSent_Batch":"验证码发送成功，5分钟内有效","Message_VerificationCodeSendFailed_Batch":"验证码发送失败，请稍后重试","Message_PleaseEnterCode_Batch":"请输入验证码","Message_GetCodeFirst_Batch":"请先获取验证码","Message_VerificationCodeExpired_Batch":"验证码已过期，请重新获取","Message_SaveNotificationSettingsFailed_Batch":"保存通知设置失败，请稍后重试","Text_WebMessageNotification_Batch":"任务完成后，会在电脑端的消息中通知您。","Title_AppPushRecommended_Batch":"APP实时推送（强烈推荐）","Paragraph_AppPushDesc_Batch":"随时随地监控进度，生成成功即刻手机预览，抢先一步发布流量爆款，不错过任何流量高峰。","Text_AppDownloadQrCode_Batch":"APP下载二维码","Title_SmsNotification_Batch":"手机短信通知","Placeholder_Phone11Digits_Batch":"请输入手机11位号码","Placeholder_VerificationCode5Min_Batch":"请输入验证码","Text_SendingEllipsis_Batch":"发送中...","Text_RetryAfterSeconds_Batch":"${0}s后重试","Button_GetVerificationCode_Batch":"获取验证码","Message_SubmitSuccess_Batch":"提交成功","Message_SubmitFailedRetry_Batch":"提交失败，请稍后重试","Message_FormValidationPassed_Batch":"表单校验通过","Message_CompleteNotificationSettingsFirst_Batch":"请先完成通知设置，再继续提交任务","Paragraph_CancelManagedTaskWarning_Record":"取消后将停止当前托管任务，且无法恢复。","Button_ConfirmCancel_Record":"确认取消","Message_CancelManagedTaskFailed_Record":"取消托管失败，请稍后重试","Text_WaitingManagedGeneration_Batch":"等待托管生成","Text_WaitingManagedSubmit_Batch":"等待投递","Message_NoExtendableImages_Result":"暂无可延展的图片","Text_IntelligentMultiSizeAdaptation_Result":"智能适配多尺寸，满足多端展示需求","Button_IntelligentResize_Result":"智能改尺寸","Option_CustomSize_DetailPageMode":"自定义尺寸","Title_AdvancedAPlus_DetailPageMode":"高级A+","Title_ManagedModeLaunched_Batch":"批量托管上线啦！","Text_ManagedModeSlogan_Batch":"睡一觉，图就做好了！","Title_BatchProduction_Batch":"批量生产","Paragraph_BatchProductionDesc_Batch":"支持${0}个任务并行生成，效率提升${1}倍","Title_AiIntelligentExtraction_Batch":"AI智能提取","Paragraph_AiIntelligentExtractionDesc_Batch":"自动识别图片卖点，生成高转化销售卖点。","Title_SaveCost20_Batch":"成本立省${0}%","Paragraph_SaveCost20Desc_Batch":"调度夜间闲置算力，享受专属离线点数折扣。","重写":"批量下载","Brand_AutoExtract_Button":"智能取色","Brand_AutoExtract_Success":"智能取色成功","Brand_AutoExtract_Failure":"无法提取颜色，请重试","Brand_AutoExtract_Unavailable":"无法提取颜色","Brand_AutoExtract_ConfirmTitle":"是否从logo提取颜色","Title_ImageSetConfig_ImageSet":"套图结构配置","Title_DefaultConfig_ImageSet":"智能匹配","Desc_DefaultConfig_ImageSet":"AI智能分析商品图，匹配最佳Listing套图。","Title_CustomConfig_ImageSet":"自定义配置","Desc_CustomConfig_ImageSet":"可自由调整各类型图片数量，至少选择${0}张。","Label_WhiteBackground_ImageSet":"白底图","Desc_WhiteBackground_ImageSet":"白底主图，多角度呈现商品细节","Label_Scene_ImageSet":"场景图","Desc_Scene_ImageSet":"展示商品的生活使用场景和人物搭配","Label_SellingPoint_ImageSet":"卖点图","Desc_SellingPoint_ImageSet":"展示商品的核心卖点及细节特写","Label_Other_ImageSet":"其他","Desc_Other_ImageSet":"对比图、尺寸图等，根据商品智能匹配","Tip_MinTotal_ImageSet":"套图至少保留${0}张","Text_ManagedBatchEntry_Header":"批量托管","Option_Coupang_Platform":"Coupang","Option_Wayfair_Platform":"Wayfair","Button_Credit_Plan":"积分","Text_Higher_Plan":"已订阅更高级别方案","Text_Try_Free":"0元立即试用","Text_Plus_Plan":"Plus套餐","Text_Pro_Plan":"Pro套餐","Button_Generate_Short_Common":"生成","Message_DuplicateTaskSubmitConfirm_Common":"检测到与上次任务相同，是否重复生成？","Text_CreditUnit_Common":"美豆","Text_NewUserDiscountDesc_Product":"首套${0}美豆 其余${1}套${2}美豆","Text_NewUserLimitedTag_Product":"新客首套限时体验","Text_OriginalPrice_Product":"原价${0}美豆","Tip_MaxTotal_ImageSet":"套图最多${0}张","Text_AddDocumentTips":"支持 Word、Excel、Text、PDF、Markdown 格式文件","Tab_SolidColor":"纯色","Tab_Gradient":"渐变","Title_PresetGradient":"渐变预设","Title_PresetSolidColor":"纯色预设","Title_RecentlyUsed":"最近使用","Title_Patterns":"图案","Title_NoFill":"无填充","Description_Brand_Reference":"上传你的海报和喜欢的参考图——Zawa 会学习它们的风格，为你打造符合你审美的专属品牌物料","Text_Generating":"生成中","Text_ChartSending":"发送中","Text_PeopleUnSupport":"暂不支持人像","Button_CancelManagedBatch_ResultGroup":"取消任务","Button_DownloadZip_ResultGroup":"下载ZIP","Button_DownloadLongImage_ResultGroup":"下载长图","Text_ManagedTaskDispatchedCannotCancel_ResultGroup":"任务已投递成功，无法取消","Button_GlobalAiWriting_Batch":"全局AI帮写","Text_StandardModel_DistributionBatch":"普通模型（铺货）","Text_StandardModelDescription_Batch":"适合长尾SKU批量铺货","Text_AdvancedModel_PremiumBatch":"高级模型（精铺）","Text_AdvancedModelDescription_Batch":"图片质量高，细节真实，主推品首选","Message_MinSubmitTasks_Batch":"批量模式最少提交${0}个任务","Message_OverwriteSellingPointsConfirm_Batch":"当前有${0} 个任务已填写卖点，请确认是否覆盖重写？","Button_OverwriteAll_Batch":"全部覆盖","Button_FillEmptyOnly_Batch":"仅填写空白","Message_NoEmptySellingPointsToFill_Batch":"当前无空白卖点内容可填充","Message_AiWritingFailedRetry_Batch":"AI帮写失败，请稍后重试","Button_NewTask_Common":"新建任务","Message_Generating_Time":"将在夜间窗口（${0}-${1}）完成生成，可在第二天查看结果","Title_Total_Credits":"合计积分","Text_Used_AllFeatures":"所有功能均可使用","Daily_Present_Credits":"今日到期积分","Daily_Credits_Desc":"每天登录可领取，当日到期","Text_Inactive":"已冻结","Text_Inactive_Monthly":"近1个月即将到期${0}个积分","TITLE_GUIDE_CUTOUT_LITE":"检测到图片中含有印章/Logo","GUIDE_DESC_CUTOUT_LITE":"使用专属提取模式，精准提取印章或Logo元素","GUIDE_ACTION_CUTOUT_LITE":"一键抠印章/Logo","TITLE_CUTOUT_LITE":"一键抠印章/Logo","TIP_CUTOUT_LITE":"专属提取模式，精准提取印章或Logo元素","PROCESSING_CUTOUT_LITE":"正在生成图片","AFTER_CUTOUT_LITE":"结果图","Button_Previous":"上一步","Button_Next":"下一步","Button_Skip":"跳过","Button_Apply":"应用","Text_AgentExpert":"专家","Message_PleaseEnterLinkOrAsin_Clone":"请先输入链接或ASIN","Message_LinkAnalyzeFailed_Clone":"链接分析失败","Message_UploadProductImageFirst_Clone":"请先上传产品原图","Message_ProductImageThumbGenerateFailed_Clone":"产品原图缩略图生成失败，请重新上传","Message_UploadProductImageFirst_ProductCase":"请先上传参考图或粘贴商品链接","Message_ReferenceImageThumbGenerateFailed_Clone":"参考图缩略图生成失败，请重新上传","Title_ReferenceSource_Clone":"参考内容","Option_LinkAsin_Clone":"导入链接","Input_PasteProductLinkOrAsin_Clone":"粘贴商品链接","Button_Parsing_Clone":"解析中","Button_Parse_Clone":"解析","Text_SupportAmazonTiktokLinks_Clone":"支持Amazon、Tiktok链接。","Text_Cloning_ResultStatus":"复刻中...","Input_CloneRequirementOptional_Clone":"参考要求（选填）","Title_ProductOriginalImage_Clone":"产品原图","Title_CloneLevel_Clone":"复刻程度","Option_CompositionReference_Clone":"参考风格","Desc_CompositionReference_Clone":"参考整体风格和结构，自动调整色彩和重构场景。","Option_HighFidelityClone_Clone":"高度复刻","Desc_HighFidelityClone_Clone":"参照参考图视觉结构替换产品和文案，场景细节略有差异。","Label_OutputStyleConsistent_Clone":"输出风格保持一致","Title_SupplementaryNotesOptional_Clone":"统一复刻要求 (选填)","Input_SupplementaryNotesExample_Clone":"例如：文案统一用英文、模特保持完全不变、参考图不变只替换商品。","Title_HotClone_Welcome":"爆款图复刻","Text_HotCloneDescription_Welcome":"上传您想参考的爆款图，即刻生成同款。","Text_DefaultTaskName_Clone":"商品套图同款策略","Label_ProductImage_CloneCase":"产品图","Label_ReferenceComposition_CloneCase":"参考风格","Label_HighFidelityClone_CloneCase":"高度复刻","Tag_AiSmartMatch_ImageSet":"AI智能匹配","Title_Date":"日期","Title_Topic":"主题","Button_Replace":"替换","Title_SingleCloneRequirement_Clone":"单张参考要求","Text_UploadedReferenceImagesTip_Clone":"每张参考图可单独备注参考要求，不填默认处理。","Label_ReferenceImageIndex_Clone":"参考图${0}","Option_Mexico_Market":"墨西哥","Text_ParsingReferenceImages_Clone":"解析中...","Text_ParseReferenceImagesSuccess_Clone":"解析完成，得到${0}张参考图","Text_Renew_Restore":"续订会员后可恢复使用","Title_UsageNotice_Clone":"使用须知","Text_UsageNoticeDescription_Clone":"请确认您已获得该链接内容的合法使用权。生成结果基于 AI 风格分析，仅供创作参考。","Label_ReadAndAgreeUsageNotice_Clone":"我已阅读并同意以上须知","Label_DoNotShowAgain_Clone":"下次不再提示","Text_InterceptModal":"允许显示美图设计室弹出窗口","Text_InterceptModal_ThirdStep":"点击完成按钮，即可正常使用美图设计室的功能啦～","Text_InterceptModal_Desc":"你需要授权美图设计室在浏览器打开多个窗口。","Brand_StatusPopup_ProcessingTitle":"Zawa 正在学习你的品牌...","Brand_StatusPopup_FailedTitle":"Square 同步失败，请稍后重试","Brand_StatusPopup_Retry":"重试","SecondTitle_Header19_Home":"Clone Video Ads","SquareBrandGuide_BrandKitCreatedTip":"已经从square建立了您的品牌库","SquareBrandGuide_DefaultPrompt":"请帮我设计一个产品海报，用于社交媒体宣传","SquareBrandGuide_SendTip":"点击发送，即可启动设计！","Paragraph_BatchProductionDescUnlimited_Batch":"支持无限任务并行生成，效率直线飞升。","Menu_ViewDetail":"查看详情","Menu_CopyFullText":"复制全文","Tip_CopiedToClipboard":"已复制到剪贴板","Tip_CopyFailed":"复制失败","Menu_DownloadImage":"下载图片","Tip_NoImage":"暂无图片","Tip_DownloadStarted":"已开始下载","Menu_CopyText":"复制文案","Tip_NoTextToCopy":"暂无文案可复制","Message_LinkImageFetchFailed_Clone":"无法抓取该链接图片，请检查链接或直接上传参考图","Tab_Chat":"对话","Tab_Files":"文件","Button_Create_New_Chat":"创建新对话","Tip_Agent_Team_Chat_Shared":"你正在查看此案例的只读版本","Title_ViralVideoMaker":"AI 爆款视频生成","Title_ProductVideoMaker":"爆款视频","designkit_agent_watermark_protocol":"根据您的请求，您可选择“含AI水印（标识）”和“不含AI水印（标识）”的图片，如您选择“不含AI水印”的图片，表明您同意以下标识义务和责任：您不得利用基于美图设计室AI功能制作、发布、传播虚假信息。您在任何场景下使用、发布或传播利用基于美图设计室AI功能制作的内容时，应当符合法律法规的要求，并以显著方式标识。","Text_Document":"文档","Button_BrandAssets_UploadDevice":"从本地上传","Button_SocialBrief_Complete":"完善 Brief","Button_SocialBrief_Edit":"编辑 Brief","Button_SocialBrief_Generate":"根据 Brief 生成","Description_BrandAssets":"我们需要你的品牌信息，以生成更好的结果。","Name_BrandAssets":"品牌资产","Placeholder_BrandAssets_Link":"例如 Instagram、Google Maps 等链接","Text_BrandAssets_KitImported":"从品牌资产库导入","Text_BrandAssets_LinkEntry":"输入你的链接","Text_SocialResult_Post":"帖子","Title_SocialBrief":"Brief","Toast_BrandAssets_DuplicateSkipped":"已跳过重复图片文件","Toast_BrandAssets_EmptyAssets":"未找到品牌资产","Toast_BrandAssets_InvalidUrl":"请输入有效链接","Toast_BrandAssets_LoadAssetsFailed":"品牌资产加载失败","Toast_BrandAssets_LoadKitsFailed":"品牌资产库加载失败","Toast_BrandAssets_PartialReadFailed":"部分图片文件读取失败","Toast_BrandAssets_ReadFailed":"图片文件读取失败","Toast_BrandAssets_SaveFailed":"品牌资产保存失败","Toast_BrandAssets_UploadFailed":"部分资产上传失败，请重试。","Title_AgentDesignPreference":"让AI记住你的设计偏好","Desc_AgentLibWorkflowUnify":"沉淀你的定制模特与风格配方，用于Agent工作流中一键调用，实现设计的高度统一。","Button_ViewAgentGuide":"查看使用指南","Desc_BatchRecipeRetain":"保留图片类型与画面场景为配方，可直接引用并批量应用到新商品。","Button_NewBatchRecipe":"新建套图配方","Desc_CustomModelUpload":"上传自有模特照片，可在 Agent 生成中复用，打造专属模特形象。","Button_NewExclusiveModel":"新建专属模特","Text_AiRecommend_TryOn":"智能推荐场景","Desc_AiRecommendSceneMode_TryOn":"根据服装自动匹配最佳场景","Message_LoadSceneFailedRetry_TryOn":"场景加载失败，请稍后重试","Text_OptionalCustomSceneDescription_TryOn":"或自定义描述场景（可选）","Placeholder_CustomSceneDescription_TryOn":"描述你想要的场景：如秋季枫叶小径、暖色调午后阳光、模特倚靠树干…","Message_PleaseSelectOrDescribeScene_TryOn":"请选择场景或输入场景要求","Placeholder_SearchProduct_Record":"输入商品名称或关键词","Title_RecentSearches":"历史记录","Button_Clear":"清空","Title_ShootingScene_TryOn":"拍摄场景","Button_Charged_Continue":"已充值，请继续","Title_SplitImagePlugin":"图片分层","Description_SplitImagePlugin":"智能识别画面元素，快速完成图片分层。","Tip_SplitImageLoading":"分层中...","Tip_SplitImageFail":"图片分层失败，重新试试吧～","Brand_SquareSync_ToastPartial":"Square 部分同步完成","Brand_SquareSync_ToastSuccess":"Square 同步完成","Brand_SquareSync_Failed":"Square 同步失败","Brand_SquareSync_Button":"从 Square 同步","Title_Format":"格式","Message_CancelManagedTaskSuccessRefunded_Record":"任务取消成功，美豆已退还。","Text_AspectRatio_Common":"比例","Text_Country_Common":"国家","Text_Language_Common":"语言","Text_Platform_Common":"平台","Option_Korea_Market":"韩国","Option_Korean_Language":"韩语","Title_AgentLibRecentBrainOn":"Agent 创作大脑已启用","Desc_AgentLibRecentRecipesSidebar":"你保存的配方已同步至Agent侧边栏，支持一键调用以保持风格一致。","Title_CreateBatchRecipe":"创建套图配方","Tips_Not_Files":"暂无文件","Message_PleaseEnterProductHighlights":"请输入商品卖点&要求","Message_UploadProductImageRequired":"请上传至少一张产品图","Tips_Agent_Teams_Mode":"适合需要多步骤、调用多种能力的复杂任务","Tips_Agent_Teams_Mode_Actived":"进入 Agent Teams 模式，让AI专家自动组队，一句话搞定全套策划与视觉设计。","Tip_SocialBrief_MissingImages":"{count}帖子缺少必要的图片，请补充","Tips_Agent_Teams_Mode_Active_Zawa":"Agent Teams 已就绪，调研 + 内容生产全自动执行，说说你的需求","Tip_AiGeneratedContent":"内容由AI生成，请仔细甄别","Button_ContinueUpload":"继续上传","Button_GenerateNow":"立即生成","Button_ReplaceClothes":"替换服装","Desc_ReplaceClothesMultiUpload":"若为一套，可上传多张同时替换","FileName_MyClothes":"我的服装","Message_SelectReplaceClothes":"请选择要替换的服装图片","Message_UploadClothesFailed":"服装图片上传失败，请重试","Message_UploadClothesSizeLimit":"请上传 10M 内的服装图片","Text_MoreActionEmpty":"操作列表待配置","Tip_UploadClothesFormat":"拖拽或点击上传 ${0} 图片，${1}以内","Title_ReplaceClothes":"替换服装","Title_TryOnAccessoryMatch":"专属模特一键定制，多品类配饰随心搭。","Title_TryOnMultiPose":"同场景多姿势，一键解锁整套实拍图。","Title_TryOnOutfitMix":"多品类自由搭配，一键生成完整穿搭图。","Title_TryOnSceneSwitch":"多场景自由切换，轻松拍出大片氛围。","Title_TryOnAIRecommend":"AI推荐","Text_SocialBrief_Generating":"正在为你生成，请稍等片刻","Tag_New":"新功能","Title_Designer":"空白画布","Button_Blank_Canva":"空白画布","Tool_AiViralImageRemix":"爆款图复刻","Title_ViralVideoReplace":"爆款视频复刻","Title_SocialMedia_Tools":"社媒创作工具","Title_HotTags":"热门标签","Tip_LogoNotRecognized":"未识别到 Logo","Tip_LogoNotRecognized_Eraser":"未识别到 Logo，请尝试手动选择需要消除的区域。","Placeholder_RemoveGrassDebris":"消除草地上的杂物","Placeholder_RemoveGroundShadow":"消除地上的投影","Placeholder_RemoveRedClothesPerson":"消除红色衣服的人","Placeholder_DescribeRemovalPart":"请输入你要消除的部分，例如：${0}","Modal_LeavePageTitle":"即将离开当前页面","Modal_OpenRoboNeoNewTab":"是否在新标签页打开 RoboNeo？","Button_ReplicateVideo":"复刻视频","Button_RemixImage":"复刻图片","Message_ContentProcessFailed_Text":"内容处理失败，请换个词试试～","Message_ContentProcessFailed_Image":"该图片暂无法处理，请换一张图试试","Text_ProductImageOptionalUploadTip_Clone":"有商品需替换时上传，无商品可跳过","Option_EcommerceProductImage_Clone":"电商商品图","Option_ApparelEcommerceImage_Clone":"服饰电商图","Option_SocialGraphicImage_Clone":"社媒图文","Option_MarketingPoster_Clone":"营销海报","Option_CreativePoster_Clone":"创意海报","Option_ReferenceImageSize_Clone":"参考图比例","Option_Instagram_Platform":"Instagram","Home_Tools_Title":"强大工具加持，社媒内容轻松出彩","Home_Tools_Tab_SocialCreative":"社媒创意工具","Home_Tools_SeeAllImageTools":"查看所有图片工具","Home_Tools_SeeAllSocialCreative":"查看所有社媒创意工具","Home_Tools_ImageObjectRemover":"图片消除","Home_Tools_TextToVideo":"文生视频","Home_Tools_FoodPhotography":"美食摄影","Home_Tools_FlyerGenerator":"传单生成","Home_Tools_MenuGenerator":"菜单制作","Home_Tools_PosterGenerator":"海报生成","Home_Tools_MockupGenerator":"Mockup 生成","Home_Tools_ImageExtender":"扩图","Home_Tools_ImageToVideo":"图片转视频","title_upgrade2GetMoreCredits":"升级会员，每月获得更多美豆","tip_insufficientCredits":"您的美豆数不足，请充值","tip_insufficientCredits_upgrade":"您的美豆数不足，可开通会员送美豆","Title_DownloadPromotion_ViralVideo":"这样的视频，还想再做几条?","Subtitle_DownloadPromotion_ViralVideo":"开通 Pro，想做多少做多少","Tag_DownloadPromotionOffer_ViralVideo":"限时优惠","Title_DownloadPromotionCard_ViralVideo":"开通 Pro 继续创作","Text_DownloadPromotionPrice_ViralVideo":"${0}/月","Text_DownloadPromotionBenefitViralVideo_ViralVideo":"爆款视频生成，每月 ${0} 条","Text_DownloadPromotionBenefitNanoBanana_ViralVideo":"Nano Banana Pro 不限次生成","Text_DownloadPromotionBenefitImageEnhance_ViralVideo":"AI 消除、画质增强不限次","Button_DownloadPromotionGetPro_ViralVideo":"${0} 折扣开通 Pro","Button_DownloadPromotionLater_ViralVideo":"以后再说","Tag_NewUserLimitedFree":"新客首套限时免费","Text_FirstImageCreditDiscount":"首张${0}美豆 其余${1}张${2}美豆","Tag_NewUser_FirstImageLimitedFree":"新客首张限时免费","Tag_FirstImageFree":"首张免费","Title_OtherSettings":"附加功能","Title_GenerateListing":"商品上架文案生成","Button_GenerateListing":"生成商品上架文案","Message_Copied":"已复制","Text_Generating_Listing":"商品上架文案生成中…","Text_GenerateFailed_Listing":"Listing 生成失败","Button_Translate":"翻译","Title_ListingCopy":"商品上架文案","Message_NoTaskForListing":"暂无可用于生成 Listing 的任务","Message_RenameSuccess":"修改成功","Message_RenameFailedRetry":"修改失败，请重试","Title_RegenerateDirection":"输入微调方向（选填）","Placeholder_RegeneratePrompt":"输入调整要求（选填，空着将默认重绘）。如：商品向左移动一点，换成浅灰色背景...","Title_TrialLimitReached_ViralVideo":"免费视频已用完","Subtitle_TrialLimitReached_ViralVideo":"免费体验只能生成 1 条视频，升级 Pro 解锁更多！","Button_UpgradeNow":"立即升级","Text_WPS_NavVipEntrance":"购买权益","Text_WPS_Only":"(仅WPS可用)","Text_WPS_Credits_Card_Tip":"美图设计室拥有独立的付费套餐体系，不与WPS会员互通。","Text_WPS_Welcome_Modal_Pricing":"独立付费套餐体系","Text_WPS_Welcome_Modal_Pricing_Description":"AI 设计功能由 WPS 合作第三方提供，需单独付费","Text_WPS_Welcome_Modal_Meidou":"首次登录","Text_WPS_Welcome_Modal_Meidou_Description":"系统将为【WPS大会员】用户发放50美豆用于功能试用，不会产生WPS相关的额外扣费。","Text_WPS_Welcome_Modal_Vip":"购买即赠","Text_WPS_Welcome_Modal_Vip_Description":"购买AI设计套餐，限时赠等时长 WPS 超级会员。","Text_WPS_Welcome_Modal_Title":"欢迎体验美图设计室！","Text_WPS_Welcome_Modal_Agreement":"请您知悉以上规则，继续使用即表示您已了解并同意","Button_Generate_ImageListingSet":"一键生成套图与商品上架文案","Tip_GenerateListing":"根据所选平台规范，智能生成符合上架要求的商品文案","Text_SelectedCount":"已选择${0}张","RoboNeo_Web_input_default_content":"向RoboNeo发送消息","RoboNeo_Web_chatbox_maximum":"当前对话轮数已达上限","RoboNeo_Web_chatbox_maximum_text":"当前对话轮数已达上限，请新建任务以继续","RoboNeo_Web_chatbox_new_task":"新任务","RoboNeo_Web_history_share_text":"分享","RoboNeo_Web_history_delete_text":"删除","RoboNeo_Web_history_delete_hint_text":"提示","RoboNeo_Web_history_delete_main_text":"删除后，该记录将不可恢复，确认删除吗？","RoboNeo_Web_history_delete_hint_confirm":"删除","RoboNeo_Web_history_delete_hint_cancel":"取消","RoboNeo_Web_studio_download":"下载","RoboNeo_Web_toast_share_text":"分享当前对话","RoboNeo_Web_toast_share_main_text":"分享后任何有链接的人都可查看您的当前对话历史","RoboNeo_Web_toast_share_copy":"复制链接","RoboNeo_Web_toast_cancel":"取消","RoboNeo_Web_toast_confirm":"确认","RoboNeo_Web_studio_changing_toast":"今日Neo搬砖额度已用完，每天0点会自动刷新，或投喂「赛博萝卜」为Neo充满能量。","RoboNeo_Web_studio_changing_toast2":"今日Neo搬砖额度已用完","RoboNeo_Web_new_studio":"新会话","RoboNeo_Web_sidebar_close":"收起","RoboNeo_Web_history_text":"历史记录","RoboNeo_Web_sidebar_open":"展开","RoboNeo_Web_upload_warning_text":"不支持同时上传图片和视频","RoboNeo_Web_upload_format_text":"仅支持上传图片JPG、png、jpeg格式；视频 MP4、mov格式","RoboNeo_Web_upload_fail_text":"上传失败","RoboNeo_Web_upload_image_maximum":"最多支持上传{max_num}张图片","RoboNeo_Web_upload_video_size_maximum":"暂不支持{max_size}M以上视频","RoboNeo_Web_upload_image_size_maximum":"暂不支持{max_size}M以上图片","RoboNeo_Web_upload_video_maximum":"最多支持上传{max_num}个视频","RoboNeo_Web_history_dafult_text":"暂无历史记录，快来和我聊聊吧","RoboNeo_Web_upload_content_warning_text":"部分内容存在风险，暂不支持导入","RoboNeo_Web_chat_send_fail":"发送失败， 请稍后重试","RoboNeo_Web_network_fail":"连接失败或超时，请重试","RoboNeo_Web_studio_layer_fail":"图层拆分失败","RoboNeo_Web_studio_layer_success":"图层拆分成功","RoboNeo_Web_network_error":"网络错误","RoboNeo_Web_delete_success":"删除成功","RoboNeo_Web_delete_fail":"删除失败","RoboNeo_Web_copy_success":"复制成功","RoboNeo_Web_file_uploading":"{num}个文件上传中","RoboNeo_Web_file_upload_fail":"{num}个文件错误","RoboNeo_Web_file_upload_single_fail":"1个文件错误","RoboNeo_Web_file_uploading_single":"1个文件上传中","RoboNeo_Web_upload_video_maximum_one":"最多支持上传1个视频","RoboNeo_Web_sharepage_wanna_try":"我要试试","RoboNeo_Web_sharepage_load_to_end":"跳转至结果","RoboNeo_Web_studio_loading_text":"画布加载中","RoboNeo_Web_chatbox_add_image":"添加图片","RoboNeo_Web_chatbox_add_video":"添加视频","RoboNeo_Web_image_editor_max":"最大支持10M，最长边4096px","RoboNeo_Web_unlimited_pass_expired":"无限模式已结束，开始使用免费额度","RoboNeo_Web_studio_ai_image_successful":"AI超清成功","RoboNeo_Web_studio_ai_image_failed":"AI超清失败","RoboNeo_Web_studio_cutout_successful":"抠图成功","RoboNeo_Web_studio_cutout_failed":"抠图失败","RoboNeo_Web_studio_ai_edit_failed":"AI改图失败","RoboNeo_Web_studio_ai_edit_successful":"AI改图成功","RoboNeo_Web_AI_generated":"内容由AI生成","RoboNeo_Web_loading":"加载中","RoboNeo_Web_view_creative_process":"播放创作过程","RoboNeo_Web_try_now":"我要试试","RoboNeo_web_extender_successful":"AI扩图成功","RoboNeo_web_extender_failed":"AI扩图失败","RoboNeo_web_eliminate_successful":"AI消除成功","RoboNeo_web_eliminate_failed":"AI消除失败","roboneo_web_continue":"继续","roboneo_web_video":"视频","roboneo_web_HTML":"网页","roboneo_web_shared_error_message":"该对话暂不支持分享，试试创建新对话","roboneo_web_open_the_APP_experience":"打开APP体验","roboneo_web_AI_generated_logo":"内容由AI生成，仅供参考","roboneo_web_change_word_success":"改字成功","roboneo_web_change_word_fail":"改字失败","roboneo_web_canvas_loading_failed":"画布加载失败","roboneo_web_export_failed":"导出失败","roboneo_web_export_tips2":"仅支持导出单张小于{width}px*{height}px的图片","roboneo_web_new_topic":"开启新话题","roboneo_web_waiting_reply":"正在等待你的回复","roboneo_web_file_saving_preferences":"文件保存偏好","roboneo_web_includes_AI_watermark":"包含AI水印","roboneo_web_no_remind":"不再提醒","roboneo_web_agree_continue":"同意并继续","roboneo_web_watermark_protocol":"根据您的请求，您可选择“含AI水印（标识）”和“不含AI水印（标识）”的图片，如您选择“不含AI水印”的图片，表明您同意以下标识义务和责任：您不得利用基于RoboNeoAI功能制作、发布、传播虚假信息。您在任何场景下使用、发布或传播利用基于RoboNeoAI功能制作的内容时，应当符合法律法规的要求，并以显著方式标识。","roboneo_web_rectangle":"矩形","roboneo_web_circle":"圆形","roboneo_web_arrow":"箭头","roboneo_web_image_fusion_success":"融图成功","roboneo_web_image_fusion_failure":"融图失败","roboneo_chat_resources_num_limit_tips":"最多支持同时添加{img_num}张图和{video_num}个视频哦~","RoboNeo_Web_export_confirm_tip_popup_title":"可选择是否带“AI生成“水印导出","RoboNeo_Web_export_confirm_tip_popup_btn":"我知道了","Tip_UploadImagesFormat_Batch":"拖拽或点击上传JPEG/JPG/PNG图片，${0}M以内，支持${1}张","Text_SelectedModulesCount_Batch":"已选 ${0} 项","Tip_DefaultFollowGlobal_Batch":"不修改则默认跟随全局","Label_ModuleSelection_Batch":"模块选择","Label_SelectRequiredModules_Batch":"选择需要的模块","Title_Dialog_Invite2":"邀请好友,赢取 Pro 天数与积分","Desc_Dialog_Invite2":"把链接分享给好友或发到社媒。好友通过你的链接注册，双方各得 <strong>${0} 天 Pro + ${1} 积分</strong>；好友 <strong>${2} 天内订阅</strong>,双方再各得最多 <strong>${3}</strong> 额外积分。","SubTitle_Rewards1_Invite2":"已获 Pro 天数","SubTitle_Rewards2_Invite2":"已获积分","SubTitle_Rewards3_Invite2":"已邀好友数","Text_Rule1_Invite2":"好友通过你的链接注册，双方各得 <strong>${0} 天 Pro + ${1} 积分</strong>。","Text_Rule2_Invite_zawa":"好友 <strong>${0} 天内订阅</strong>，双方再各得额外积分（<strong>Plus +${1}、Pro +${2}、Max +${3}</strong>），每位好友仅发一次，按首次生效档位。","Text_Rule3_Invite2":"赠送的 Pro 天数按会员时长机制累加：已是会员则顺延到期日,始终享受当前最高等级权益。","Text_Rule4_Invite2":"积分计入余额、<strong>30 天内有效</strong>，可用于 AI Agent 全模型 Fast 生成。","Text_Rule5_Invite2":"已使用套餐或已消耗赠送积分的订阅不可退款；免费奖励一经使用不可撤回。","Text_Rule6_Invite2":"已有账号、自邀、重复账号或欺诈行为不发放奖励；${0} 有权调整活动并对异常账号收回奖励。","Title1_Invited_Invite2":"好友邀请你加入 ${0},领取 ${1} 天 Pro + ${2} 积分","Text_DaysBadge_Invite":"${0} 天","Title_Reward_Registered":"免费体验 ${0} 天 Pro","Title_Reward_Invite":"${0} 天免费 Pro，再送 ${1} 积分","Desc_Reward_Invite":"${0} 天免费 Pro，智能工具无限用","Button_StartCreate_Invite":"开始创作","Text_InviteMore_Invite":"邀请好友领取更多 Pro 天数与积分","Title_WelcomeOnboarding":"欢迎来到Zawa！","Title_ContentIntentOnboarding":"你内容创作的主要目的是什么？","Text_ReferralCreditsOnboarding":"你是通过推荐注册的，我们将自动为你的账户添加<>${0}个积分</>。","Option_ProductVideoOnboarding":"为我的产品制作视频","Option_SocialPostOnboarding":"社媒帖文","Option_LogoBrandOnboarding":"创建Logo和品牌","Button_MaybeLaterOnboarding":"以后","Title_FirstVideoOnboarding":"免费制作你的第一个视频","Desc_FirstVideoOnboarding":"从产品图或参考图开始，生成一个直接可以发布在ins上的视频。","Title_FirstSocialPostOnboarding":"免费制作你的第一篇社媒图文","Desc_FirstSocialPostOnboarding":"上传一张照片或描述您的需求，即可获得一套精美、随时可发布的社媒帖文。","Title_FirstLogoBrandOnboarding":"免费制作你的第一个Logo或品牌","Desc_FirstLogoBrandOnboarding":"描述您的品牌，快速获得一套专业Logo及视觉概念方案。","Text_TryFreeProOnboarding":"<>免费试用3天Zawa pro会员</>，无需绑定银行卡或付款。","Text_FreeVideoOnboarding":"<>获得1个免费视频生成机会</>，无需绑定银行卡或付款。","Text_FreeImagesOnboarding":"<>获得4张免费图片生成机会</>，无需绑定银行卡或付款。","SubTitle_Invited_Invite_zawa":"好友邀请你体验 Zawa，专注品牌设计的 AI Agent，轻松完成 Logo、VI、海报、菜单、社媒素材与品牌视频的创作，现在注册，你与好友均可获得 ${0} 天 Pro 会员，以及 ${1} 积分，若在 ${2} 天内开通订阅还可享额外奖励：Plus 加赠 ${3} 积分，Pro 加赠 ${4} 积分，Max 加赠 ${5} 积分。","SubTitle_Invited_Invite_dk":"好友邀请你体验 Designkit，专注商业设计的 AI Agent，轻松完成商品图、详情页、促销海报、电商 Banner、社媒素材与商品视频的创作，现在注册，你与好友均可获得 ${0} 天 Pro 会员，以及 ${1} 积分，若在 ${2} 天内开通订阅还可享额外奖励：Basic 加赠 ${3} 积分，Pro 加赠 ${4} 积分。","Text_Rule2_Invite_dk":"好友 <strong>${0} 天内订阅</strong>，双方再各得额外积分（<strong>Basic +${1}、Pro +${2}</strong>），每位好友仅发一次，按首次生效档位。","Tool_AIVideoGenerator":"AI视频生成","Tool_AIVideoAdMaker":"AI视频广告制作","Tool_AIVideoEditor":"AI视频编辑器","Title_AIWatermark":"AI水印","Title_FileSavePreference":"文件保存偏好","Label_IncludeAIWatermark":"包含AI水印","Button_ConfirmDownload":"确定下载","Button_AgreeAndContinue":"同意并继续","Text_DontRemindAgain":"不再提醒","Button_DownloadApp":"下载APP","Title_DownloadAppForMoreFeatures":"下载APP体验更多高级功能","Tip_Download7DaysFreeTrial":"下载获取7天免费试用","Message_LoginExpiredRelogin":"登录信息异常，请重新登录","Title_BindPhone":"绑定手机号","Tip_BindPhoneForCollaboration":"与他人实时协作请先绑定手机号～","Tip_OnlyPSDSupported":"仅支持psd格式文件","Button_OpenPSD":"打开PSD","Desc_AIDisclaimer":"使用本服务前您须理解，AI产出内容取决于人工智能对大数据的深度学习，不排除其中部分信息可能存在瑕疵、不合理或引发不快之处，故美图对通过算法生成内容的准确性、完整性和功能性等均不做任何保证，亦不承担包括侵犯第三人权利在内的任何法律责任；同时，因为AI设计服务依赖于您个人输入的文字信息生成相关内容，您需自行对输入信息及生成的内容进行理性选择；您须确保，依法使用本服务及其生成的AI作品，不侵犯任何第三方的版权、商标或其他合法权利，不得将生成的作品用于任何非法用途；如因您的不当使用行为导致任何第三方权益受损的，您将依法承担相应法律责任。","Text_Disclaimer":"免责声明","Message_ConnectFailed":"连接失败：${0}","Placeholder_SelectFont":"选择字体","Message_MaxImageUploadSize":"最大支持 ${0} x ${1} 的图片上传","Title_StorageFull":"您的存储空间已满","Title_StorageFullPleaseClean":"您的存储空间已满，请清理","Desc_StorageFull":"您的${0}存储空间已满，请删除部分内容${1}，否则过往作图记录可能会消失。","Desc_StorageFullAigc":"您的${0}储存空间已满，当前生成内容会<strong>临时储存7天</strong>，请删除部分内容${1}，否则作图记录可能会消失。","Text_Free":"免费","Text_OrUpgradeMember":"或升级会员","Text_UnlockMoreStorage":"解锁更多储存空间","Text_FilesSavedForever":"文件可无限期保存","Button_UpgradeMember":"升级会员","Button_CleanSpace":"清理空间","Title_FileExpiringSoon":"您的文件即将过期","Desc_FileExpireAutoClean":"文件过期后将会自动清理，请及时管理您的创作内容。","Button_OrganizeFiles":"整理文件","Title_RemainingDownloads":"剩余下载张数","Text_PriorityConsumeExpiring":"优先消耗临期张数","Text_PermanentValid":"永久有效","Text_Sheet":"张","Text_ExpireInDays":"${0}天后过期","Text_ConsumeTiming":"消耗张数时机：","Tip_CutoutConsumeRule1":"1、你在抠图编辑器内下载抠完的图片时，我们将根据下载图片张数进行计算扣除。","Tip_CutoutConsumeRule2":"2、未重新处理过的图片、未产生抠图的图片进行反复下载，将不会扣除张数。","Text_InviteSuccessReward":"您已被成功邀请，加入美图设计室领取奖励","Desc_DesignKitIntro":"美图设计室，电商人必备的AI设计工具。从商品套图、模特套图、带货视频生成到海报设计、修图改图，帮助用户一站式智能生成全套电商物料。","Title_TeamMeidouShared":"团队内的美豆可供所有成员使用","Desc_PersonalMeidouTransfer":"个人美豆若需转移至团队内请联系客服","Button_SwitchTeamRecharge":"切换团队并充值","Button_CreateTeamRecharge":"创建团队并充值","Title_SubscribeSuccess":"订阅成功","Text_MeidouRechargedTo":"美豆已充值到","Button_GoToTeam":"前往团队","Text_OnePayMultiShare":"一人充值多账号共享","Text_InviteMembersShareMeidou":"邀请成员共享美豆","Menu_SwitchPersonalTeam":"切换个人/团队","Menu_TeamManagement":"团队管理","Menu_InviteFriendsEarnCash":"邀好友赚现金","Text_Personal":"个人","Text_PersonalDesigner":"个人设计师","Text_EnterpriseSwitch":"企业切换","Button_Recharge":"充值","Text_Detail":"明细","Tip_DesignKitIndependentPlan":"美图设计室拥有独立的付费套餐体系，不与WPS会员互通","Text_MeidouWpsOnly":"美豆（仅WPS可用)","Text_SheetCount":"张数","Desc_ExchangeConfirm":"你确认用${0}张抠图张数兑换${1}天会员?","Message_LoadOrderFailed":"加载订单数据失败","Message_ExchangeSuccess":"兑换成功","Message_ExchangeFailed":"兑换失败","Text_NoOrderRecords":"暂无订单记录","Text_OrderDate":"订单日期：","Text_VipExchangeRule1":"1.会员期间使用抠图不再消耗张数，且无次数限制。","Text_VipExchangeRule2":"2.付费购买的抠图张数可以兑换成会员。","Text_VipExchangeLocation":"·兑换位置：点击头像->张数。","Text_VipExchangeNoExchange":"·若选择不兑换，可以继续使用，有效期不变。","Text_VipExchangeGiftSheets":"·会员赠送的张数不能兑换会员，在有效期到期前可使用。","Text_VipExchangeRule3":"3.会员不再赠送张数","Text_BackToPrevious":"返回上一页","Title_WpsPay":"WPS支付","Text_CloseModal":"关闭弹窗","Text_FavoriteDesignKit":"收藏美图设计室吧","Button_Visit":"访问","Desc_VisitChinaSite_Cutout":"您是否要访问美图抠图中国站点，点击【访问】后会跳转到中国站点","Desc_VisitChinaSite":"您是否要访问美图设计室中国站点，点击【访问】后会跳转到中国站点","Desc_VisitingGlobalSite_Cutout":"您正在访问Designkit Cutout（美图抠图全球化站点），中国用户请访问国内站。","Desc_VisitingGlobalSite":"您正在访问Designkit（美图设计室全球化站点），中国用户请访问国内站。","Button_StayCurrent":"留在当前","Button_BackToChinaSite":"返回国内站","Title_DownloadWork":"下载作品","Label_WorkType":"作品类型","Button_Downloading":"下载中...","Tip_UploadImageForBetterResult":"上传图片后，输入明确的修改指令生成效果会更佳哦","Label_SceneElement":"场景元素","Placeholder_SceneElementDesc":"支持修改图像元素或主体，请输入文字描述。如：请将图中的XX替换成我上传的XX。","Label_MainTitle":"主标题","Label_SubTitle":"副标题","Label_Copywriting":"文案","Tip_ModifyBeforeGenerate":"请先修改图文再进行生成","Button_ReEdit":"重新编辑","Message_MaxUploadImages":"最多只能上传${0}张图片","Text_CompletedPercent":"（已完成${0}%）","Text_PreviewImage":"预览图","Text_EnterCanvasEdit":"进入画布编辑","Title_GenerateSame":"生成同款","Text_ConfirmLeaveGenerating":"正在生成中，确认离开？","Text_BuildingVisualScheme":"正在搭建视觉方案","Text_OptimizingLayout":"正在优化排版与信息层级","Text_FineTuningFont":"正在精调字体与间距","Message_GenerateSuccessCost":"生成成功！消耗${0}美豆","Title_ConfirmDelete":"确认删除","Text_DeleteFontWarning":"删除后，团队内所有成员将无法继续应用该字体。","Text_AppliedWillReplace":"已应用的作图记录/字体样式将自动替换为","Text_DefaultReplaceFontName":"阿里巴巴普惠体-常规","Text_Deleting":"删除中...","Message_DeleteSuccess":"删除成功！","Text_NoMore":"没有更多了...","Text_NoFonts":"暂无字体","Button_UploadFont":"上传字体","Message_FontFormatInvalid":"字体文件 ${0} 格式不正确","Title_AuthConfirm":"授权确认","Text_FontAuthConfirm":"针对自行添加的字体，请您确认其已获得著作权人和/或邻接权利人的必要授权","Text_DuplicateFontsConfirm":"下列字体可能相同，请确认","Text_Uploaded":"已上传","Button_ConfirmUpload":"确认上传","Text_FontsCannotUpload":"下列字体无法上传","Button_ReUpload":"重新上传","Message_MaxFontUpload":"最多允许同时上传20个字体文件","Message_UploadSuccess":"上传成功","Text_FontUploading":"字体上传中...","Tip_FontUsageRight":"温馨提示：请确认自己拥有字体的使用权和商业授权噢~","Title_FriendlyTip":"温馨提示","Text_TemplateMigrated":"原【模板库】内的模板现已迁移至【项目】中，您可前往项目查看团队模板","Button_GoNow":"立即前往","Tab_FontLib":"字体库","Tip_SwitchIdentityHint":"点右上角头像可切换个人/团队身份哦","Text_IdentityResourcesIndependent":"不同身份的设计资源（如作图记录）相互独立","Text_IdentitySwitched":"您的身份已被切换","Text_DefaultTeamName":"${0}的团队","Message_FillTeamInfo":"请填写完整团队信息","Message_TeamNameMaxLength":"请填输入20字内的团队/企业名称","Title_CreateTeam":"创建团队","Label_TeamName":"团队名称","Placeholder_TeamName":"请输入团队名称","Button_FreeCreate":"免费创建","Tip_TeamNameEditable":"团队名称可随时修改","Text_EnjoySvipRights":"畅享SVIP权益","Text_TeamPermissionMgmt":"团队权限管理","Text_MemberFolderCollab":"成员文件夹协作","Text_TeamExpired":"当前团队已过期","Text_RenewToUse":"若需正常使用请续费升级","Text_VipTeamRights":"VIP团队版权益","Text_ViewDetailRights":"查看详细权益","Button_SwitchPersonal":"切换个人版","Text_Frozen":"你已被冻结","Text_MemberOverLimit":"当前成员数量超过上限","Text_ContactOwner":"若需正常使用请联系团队所有者","Text_TeamNoSupport":"团队/企业身份暂不支持该功能","Text_SwitchToPersonalHint":"若有需要可切换为个人身份","Button_SwitchToPersonal":"切换为个人","Text_FeatureNotAvailable":"该功能暂时无法开放~","Text_ReloginPersonal":"如需使用可以个人账号重新登录使用噢~","Button_BackHome":"返回首页","Text_PersonalEdition":"个人版","Text_TeamEdition":"团队版","Text_EnterpriseEdition":"企业版","Text_FreeEdition":"免费版","Text_RemovedFromTeam":"你已被移出团队","Text_RejoinTeamHint":"如需重新加入团队","Text_ContactOwnerToInvite":"请联系所有者/管理员发起邀请","Button_SwitchOtherIdentity":"切换其他身份","Button_FreeCreateTeam":"免费创建团队","Text_SelectIdentity":"选择身份","Text_SelectTeamIdentity":"选择团队身份","Text_EditingSaveLocation":"如正在编辑，作图/生成记录将保存在${0}的空间","Text_CreateNewTeamFree":"免费创建新团队","Text_MemberCount":"${0}人","Text_SavedToHelloDigitalAsset":"已为您保存至海洛数字资产","Text_Admin":"管理员","Text_Member":"成员","Title_FreeMemberLimit":"免费版最多支持${0}名成员","Title_SeatInsufficient":"会员席位不足","Button_UpgradeTeam":"升级团队版","Button_AddSeat":"加购席位","Text_UpgradeForMoreSeats":"若需提高席位上限可升级团队版","Text_AddSeatToInvite":"若需继续邀请成员请先加购席位","Title_InviteMember":"邀请成员","Text_InviteSeatRemaining_Free":"您还可以免费邀请 ${0}个 成员加入团队","Text_InviteSeatRemaining":"您还可以邀请 ${0}个 成员加入团队","Text_ShareDesignAssets":"一起分享设计成果和素材","Text_ShareVipAndCredits":"一起共享会员和AI生成额度（美豆）","Text_InvitedUserPermission":"受邀用户的权限：","Text_NoInvitePermission":"只有团队所有者/管理员可以邀请，您暂时没有权限邀请他人加入团队","Text_RemainingCount":"剩余 <span>${0}</span>张","Button_RedeemMemberDays":"兑换 <span>${0}</span>天会员","Desc_InviteReward_DesignKit":"现在加入美图设计室，您一共将获得<strong>80美豆</strong>，可用于图片的生成和处理。同时您将会获得订阅优惠，<strong>最高立减¥22。</strong>","Text_ClickTopRight":"点击网站<span class=\\"primary\\">右上角</span>","Option_SetEditable":"设为可编辑","Option_SetViewable":"设为可查看","Option_Reject":"拒绝","Message_BindSuccessPermissionAdjusted":"绑定成功，权限已调整","Message_ModifyFailedBindPhone":"修改失败，请绑定手机号后修改","Text_AskersApplyAccess":"${0} 等${1}人申请访问","Text_PersonalUser":"个人用户","Text_ApplyAccess":"申请访问","Option_Viewable":"可查看","Option_Editable":"可编辑","Option_Manageable":"可管理","Text_Invited":"已邀请","Text_NoSearchResult":"无搜索结果","Title_AddCollaborator":"添加协作者","Placeholder_AddCollaboratorByName":"输入成员名称添加协作者","Title_Recommend":"推荐","Text_PeopleCount":"${0}人","Message_BindSuccessCollaboratorAdded":"绑定成功，已添加协作者","Message_AddFailedChangePermissionOrBindPhone":"添加失败，请将权限修改为「可查看」或绑定手机号后添加","Message_SelectAtLeastOneCollaborator":"请选择至少一位协作者！","Message_ShareSuccess":"分享成功!","Tip_AddCollaboratorDirectAccess":"添加后，对方可直接在【与我分享】中访问，无需通过链接","Text_TotalPeople":"共${0}人","Option_Remove":"移除","Tip_PermissionChangedToEdit":"该协作者实际权限已变更为 可编辑","Tip_AnyoneWithLinkCanEdit":"因为任何人获得链接都可编辑","Tip_TeamMemberWithLinkCanEdit":"因为团队成员获得链接都可编辑","Title_CollaboratorManage":"协作者管理","Tag_OutsideTeam":"团队外","Title_RemoveKeepTeamMembers":"移除后，仅当前属于团队内的协作者可继续进入","Title_RemoveOnlySelfAccess":"移除后，仅自己可访问","Option_OnlyCollaborators":"仅协作者","Option_OnlySelf":"仅自己","Text_OthersNeedApply":"（其他人需申请访问）","Option_PermissionUnchanged":"权限不变","Option_TeamMembers":"团队内成员","Text_TeamMembersViaLink":"团队内成员通过链接","Option_Anyone":"任何人","Text_AnyoneViaLink":"任何人通过链接","Text_UntitledDesign":"未命名设计","Message_BindSuccessLinkCopied":"绑定成功，分享链接已复制","Message_ShareFailedChangePermissionOrBindPhone":"分享失败，请将权限修改为「可查看」或绑定手机号后分享","Text_LinkUpdating":"链接更新中...","Tip_FolderShareTeamOnly":"文件夹仅支持分享给团队内的成员","Text_CollaboratorCount":"协作者：${0}人","Button_Manage":"管理","Tooltip_PartialPermissionChanged":"部分协作者权限发生变动","Tip_FolderLinkVisitorBecomeMember":"通过链接访问文件夹的用户将自动成为你团队的成员","Tip_OnlyTeamMembersCanAccess":"当前设置了只有团队成员才可以访问","Tip_InviteUserNotInTeam":"若你想要分享的用户还未加入团队，请先","Button_InviteMember":"邀请成员","Text_ShareLinkView":"${0}#我分享了【${1}】，点击查看","Text_ShareLinkJoin":"${0}#我邀请你加入【${1}】，点击加入","Text_ShareLinkApplyVisit":"${0}#我请求访问【${1}】，点击处理申请","Text_ShareLinkApplyEdit":"${0}#我请求编辑【${1}】，点击处理申请","Option_7Days":"7天","Option_30Days":"30天","Option_Permanent":"永久","Text_Slogan_DesignKit":"电商人必备的AI设计工具","Button_RemoveNonTeamCollaborator":"移除团队以外协作者","Button_RemoveNonPersonalCollaborator":"移除个人以外协作者","Text_freePlan_Zawa":"Free","Text_standardPlan_Zawa":"Plus","Text_proPlan_Zawa":"Pro","Text_maxPlan_Zawa":"Max","Tool_IDPhoto":"证件照","Tool_PortraitPhoto":"形象照","Tool_ImageBatchProcess":"图片批处理","Tool_AiShoes":"AI试鞋","Tool_AiCopywriting":"AI文案","Tool_AiPoster":"AI海报","Tool_OnlineDesign":"在线设计","Tool_ClothesDewrinkle":"服装去皱","Tool_PortraitBackground":"人像背景","Tool_ViralVideo":"爆款视频","Tool_AiPosterNote":"AI图文笔记","Title_WholeProductClone_DomesticCloneCase":"整套商品图，批量复刻","Title_ApparelClone_DomesticCloneCase":"服饰上身效果，一键复刻","Title_PosterCoverClone_DomesticCloneCase":"海报封面，轻松复刻","Prompt_PosterThemeChange_DomesticCloneCase":"复刻要求：改成厦门主题海报","Title_SocialGraphicsClone_DomesticCloneCase":"社媒图文，快速复刻","Prompt_SocialThemeChange_DomesticCloneCase":"复刻要求：改成厦门攻略主题","Title_CloneType_LeftPanelClone":"复刻类型","Text_CloneReferenceUploadLimitTip_Clone":"最多${0}张","Option_MatchStyle_Clone":"参考风格","Option_MatchReference_Clone":"高度复刻","Message_ClaimFailed":"抱歉，当前权益不可领取，请稍后再试~","Message_RedeemFailed":"兑换失败，请稍后再试~","Button_UpgradeTeamVip":"升级团队版会员","Message_SystemError":"系统异常，请稍后再试~","Label_AgentTeam":"AI团队","Desc_AgentTeamBanner":"进入 AI团队 模式，各专家自动组队，一句话搞定全套策划与视觉设计。","Text_SearchResultCount":"搜索结果·共${0}条结果","Button_ExitAdmin":"退出管理","Text_InviteReward":"邀请有礼","Button_More":"更多","Text_TeamExpiredTip":"当前团队已过期，团队内仅支持浏览与移动操作，如需继续正常使用，请您续费升级～","Text_TeamFrozenTip":"当前团队成员超过上限，您已被冻结，若需正常使用请联系团队所有者","Desc_ImageEdit":"导入图片，即刻编辑","Desc_ViralVideo":"一键批量生成多类型爆款视频","Desc_ProductImageSet":"一键生成整套电商商品图","Title_RecommendTools":"推荐工具","Button_CloseVideoPreview":"关闭视频预览","Label_PromptDesc":"Prompt 描述","Tab_Preview":"效果图","Tab_Report":"分析报告","Button_Preview":"预览","Button_PrevPage":"上一页","Button_NextPage":"下一页","Text_LoadingHard":"玩命加载中...","Button_ReplicateOne":"AI复刻同款","Text_EmptyContent":"暂无内容","Text_Today":"今天","Text_Tomorrow":"明天","Text_Yesterday":"昨天","Text_DaysLater":"${0}天后","Text_DaysAgo":"${0}天前","Desc_CreateDesign":"从空白画布开始设计","Title_ClaimSuccess":"领取成功","Text_VipExpiry":"VIP有效期：","Title_ClaimFailed":"领取失败","Button_GoDesign":"立即去设计","Title_ClientDownload":"客户端下载","Desc_DesignKitApp":"手机/电脑 作图记录同步 随时随地开启高效设计","Title_MeituXiuxiuPC":"美图秀秀电脑版","Desc_MeituXiuxiuPC1":"生活办公都能用的图片编辑器","Desc_MeituXiuxiuPC2":"与设计工具，简单好上手！","Button_DownloadNow":"立即下载","Text_Pending":"待支付","Text_MoreFunctions":"更多功能","Text_NoMessages":"暂无消息","Tab_SystemMessage":"系统消息","Tab_Notification":"通知公告","Button_MarkAllRead":"全部标记为已读","Label_Folder":"文件夹","Label_Record":"作图记录","Label_Template":"模板","Text_RequestAccess":"请求访问","Text_EditViewDownload":"（编辑、查看、下载）","Text_ViewDownloadOnly":"（仅查看、下载）","Text_TeamRenewSuccess":"你的团队版会员续费成功","Text_TeamRenewExpiredTip":"立即续费，全员共享海量企业商用模板&素材与专属会员功能～","Label_SystemNotice":"系统通知","Label_PromptTutorial":"提示词教程","Label_BrandSpec":"品牌规范","Label_ContactBusiness":"联系商务","Text_ScanConsultant":"扫码咨询企业版商务","Tab_Project":"项目","Placeholder_SearchProject":"输入项目名称或关键词","Placeholder_SearchRecipe":"输入配方或模特名称","Placeholder_SearchTemplate":"输入模板关键词或功能名称","Title_HotTools":"热搜工具","Title_HotTemplates":"热搜模板","Title_PosterTemplate":"平面设计模板","Text_NotFoundTemplate":"没有找到心仪的模板？点此","Button_Feedback":"反馈","Button_ViewAllTemplates":"查看全部模板","Tooltip_OpenNewTab":"新标签页打开","Button_BookDemo":"预约演示","Title_ApplyTeamDemo":"申请团队版预约演示","Desc_ContactWithinOneDay":"提交信息后我们将在1个工作日内与您联系","Title_LeaveContactInfo":"请留下您的联系方式，方便我们为你进行更好的1v1服务","Title_FreeTeamVipSurvey":"填写您的团队情况，免费领取7天团队版会员","Label_SingleUser":"单人使用","Text_MemberCountRange":"${0}~${1}人","Text_MemberCountRangeDash":"${0}-${1}人","Text_MemberCountOrMore":"${0}人以上","Label_TemplateReuse":"模板上传复用","Label_MultiCollaboration":"多人共享协作","Label_EnterpriseLicense":"企业商用授权","Label_SharedCredits":"团队共用美豆和抠图张数","Label_BrandManagement":"品牌规范管理","Label_YourName":"您的姓名","Message_PleaseEnterName":"请输入您的姓名","Label_YourPhone":"您的手机号","Message_PleaseEnterPhone":"请填写您的手机号或固定电话","Message_PleaseEnterValidPhone":"请填写正确的手机号","Label_CompanyName":"企业名称","Message_PleaseEnterCompanyName":"请输入您所在的企业名称","Placeholder_EnterCompanyName":"请填写您所在的企业名称","Label_ProductUsers":"需要使用产品的人数","Message_PleaseSelectProductUsers":"请选择需要使用产品的人数","Label_TeamCapabilitiesInterest":"您最想了解设计室团队版的哪些能力","Text_MultiSelectParen":"（多选）","Message_PleaseSelectCapabilities":"请选择最想了解美图设计室的哪些能力","Placeholder_TeamCapabilities":"商用版权保障，多人共用利益，数字资产管理，团队协作，其他","Button_Submit":"提交","Desc_ManagerWillContact":"我们的专属团队客户经理将在1-2个工作日内与您取得联系，请您保持电话畅通～","Title_ScanToInvoice":"请使用手机浏览器扫码开票","Text_InvoiceOrderScope":"本链接可开具【美图设计室】的订单发票","Text_TransferInvoiceContact":"对公转账订单请右下角联系客服开具","Desc_MenuProjectGuide1":"【我的空间】和【与我分享】","Desc_MenuProjectGuide2":"现在都收纳进【项目】中了","Text_SetPrefix":"设为","Text_TodayWithTime":"今天 ${0}","Text_YesterdayWithTime":"昨天 ${0}","Format_MonthDay":"M月D日","Format_YearMonthDay":"YYYY年M月D日","Text_MultiPage":"多页面","Text_PageCount":"${0}页","Text_ViewOnly":"仅可查看","Text_NoPermission":"无权限","Button_JumpToStorage":"跳转到储存位置","Label_PageUnit":"页","Label_JumpTo":"前往","Text_TotalDataCount":"共${0}条数据","Title_RelateRecommend":"相关推荐","Title_HotSearch":"热门搜索","Title_LatestMaterial":"最新素材","Title_TopicList":"热门话题","Title_ArticleList":"热门文章","Title_ToolList":"热门工具","Text_AccountOnePerson":"账号： 1人","Text_AccountTenMin":"账号：10人起","Text_LetsTalk":"让我们聊聊","Text_NewUserExperience":"新用户体验","Text_Buy12Months":"按12个月购买","Text_LinkExpired":"此链接已失效","Text_ContactAdminToJoin":"若需加入请联系管理员","Desc_JoinOrgCollaboration":"加入组织，与您的伙伴开启高效协作","Button_AcceptInvite":"接受邀请","Title_ConfirmNickname":"请确认您在团队使用的昵称","Placeholder_NameWithin20":"请输入20字以内的名称","Desc_NicknameHelp":"昵称可以帮助你的同事更好地找到你哦～","Title_TeamVipExpired":"团队版会员过期","Title_TeamSeatsInsufficient":"团队版会员席位不足","Button_SeatAssignment":"席位分配","Text_MemberSeatCount":"成员数/席位数：","Text_FreeSeatsFrozen":"超出免费席位数量的成员均已被冻结","Desc_RenewTeamForAll":"若需全员正常使用，可续费团队版会员。","Text_SeatsExceededFrozen":"超出席位数量的成员均已被冻结","Desc_AddSeatsForAll":"若需全员正常使用，可加购团队版会员席位","Title_TeamToolUnsupported":"设计室团队版暂不支持使用此工具","Desc_SwitchPersonalToUse":"若需要使用该工具，您可以切换个人版进入","Label_RegularTemplate":"常规模板","Label_Suite":"套组","Label_Filter":"筛选","Label_Sort":"排序","Label_Scene":"场景","Label_Materials":"物料","Label_Purpose":"用途","Label_Industry":"行业","Label_Color":"颜色","Label_Format":"版式","Label_Category":"分类","DesignKit":"美图设计室","Placeholder_SearchTemplateMobile":"搜索模版","Label_DesignType":"设计类型","Label_TemplatePurpose":"模板用途","Label_TemplateStyle":"模板风格","Label_TemplateColor":"模板颜色","Label_ApplicableIndustry":"适用行业","Label_TemplateSize":"模板尺寸","Label_UsageThreshold":"使用门槛","Label_TemplateNumber":"模板编号","Desc_ScrollViewAllPages":"上下滚动鼠标查看全部页面","Title_SimilarPosterRecommend":"相似海报推荐","Button_EditCurrentTemplate":"编辑当前模板","Button_EditAllTemplates":"编辑全部模板","Button_EditNow":"立即编辑","Title_RecordUpgrade":"作图记录全新升级！","Desc_RecordUpgrade1":"包含该账号下所有的海报模板和图片编辑作图记录了哦～","Desc_RecordUpgrade2":"从编辑图片到设计海报，无缝切换～","Footer_AboutUs":"关于我们","Footer_JoinUs":"加入我们","Footer_ContributeCenter":"供稿中心","Title_HomeAgentTeam":"AI团队 - 让商业设计 好看又见效","Title_HomeChat":"和我聊聊，你想要创作什么？","Nav_Home":"首页","Title_BrandManagement":"品牌管理","Nav_HelpDesign":"帮我设计","Title_OrgInfo":"组织信息","Title_MemberManage":"成员管理","Title_DataDashboard":"数据看板","Title_CommercialAuth":"商用授权","Title_OrderInvoice":"订单发票","Title_TeamCollaboration":"团队协作","Title_CopyrightGallery":"版权图库","Title_DownloadCenter":"下载中心","Nav_TodayRecommend":"今日推荐","Nav_HotCalendar":"热点日历","Nav_InspirationFormula":"灵感配方","Nav_OneClickSame":"一键同款","Title_PosterTemplateNav":"海报模板","Message_NetworkError":"您的网络发生异常，无法连接服务器","Text_Downloading":"资源下载中","Text_DownloadResourceFailed":"资源下载失败","Title_DesignKitScanLogin":"美图设计室扫码登录","Desc_ScanGuideLogin":"使用我的-右上方\\"扫一扫\\"登录","Message_AlreadyFullVip":"您已经享受完整会员权益，无需购买","Message_ImageSizeExceeded":"图片尺寸超出限制","Text_NotLoggedIn":"还没登录哦","Button_CreateBrandSpec":"创建规范","Title_BrandAdvQuestion":"还在四处向同事询问LOGO、字体、品牌色值？","Desc_BrandAdv1":"设计师预设Logo、品牌色值、文字样式、字体库","Desc_BrandAdv2":"可针对不同品牌或项目，设置对应的视觉规范","Desc_BrandAdv3":"各部门同事在编辑器里快速添加、应用规范","Button_UpgradeTeamForBrand":"升级团队版，立即使用品牌规范","Title_ConfirmDeleteBrandGroup":"确定删除该组规范吗？","Text_DeleteBrandNoAffect":"已应用的作图记录不会受到影响","Button_CreateBrandStandard":"创建品牌规范","Title_DeleteHint":"删除提示","Text_DeleteIrreversible":"删除后将无法重新找回，请谨慎操作！","Label_General":"通用","Label_ColorCard":"色卡","Label_TextStyle":"文字样式","Message_SavePrevStyle":"请保存上个样式","Message_SavePrevColorCard":"请保存上个色卡","Message_SavePrevElement":"请先保存上个元素","Button_NewColorCard":"新建色卡","Button_NewStyle":"新建样式","Message_NameWithinN":"请输入${0}字以内的名称","Message_ColorBlockLimit":"每套色卡仅支持添加${0}个色块","Message_PleaseSelectFont":"请选择字体","Message_PleaseSelectFontSize":"请选择字号大小","Placeholder_FontSize":"字号","Label_Bold":"粗体","Label_Italic":"斜体","Text_FontSizeUnit":"${0}号","Text_Claiming":"领取中...","Button_ClaimFreeBenefit":"领取免费权益","Message_MissingExchangeCode":"缺少兑换码","Message_SwitchToPersonalFirst":"请先切换为个人身份","Desc_ClaimBenefitSuccess":"您已成功领取该权益，赶快去美图设计室开启你的创作吧！","Message_ClaimNewUserOnly":"该免费权益仅限首次注册的新用户领取","Text_AiDesignTagline":"AI设计 触手可及","Text_FreeBenefitLimited":"免费权益限时领取","Text_ExchangeSceneFeatures":"商用海报 · 电商主图 · AI消除 · 智能抠图","Text_LimitedNewUserOnly":"限时活动，仅限新用户","Text_SearchWithKeyword":"搜索“${0}”","Text_HelpEmptyHint":"暂无内容～小美会尽快补充～","Placeholder_HelpSearch":"你想了解什么","Button_Search":"搜索","Message_SelectImageForTranslation":"使用图片翻译前，请先选择一张图片~","Text_InviteCopyPrefix":"#别再费时做电商图了！美图设计室注册即得免费美豆，商品套图、做详情页、带货视频等全套物料一键生成！点击链接开启作图","Label_DistributionAgreement":"《美图设计室分销服务协议》","Label_DistributionConduct":"《美图设计室分销服务佣金行为规范》","Alt_InviteFriendIcon":"邀请好友图标","Alt_BothGetBeanIcon":"双方得美豆图标","Text_BothGetBean":"双方得美豆","Alt_FriendFirstOrderIcon":"好友完成首单图标","Text_FriendFirstOrder":"好友完成首单","Alt_RedPacketIcon":"红包到账图标","Text_RedPacketArrived":"红包到账","Desc_InviteRule1":"1、邀请好友成功注册，你和好友都将获得40美豆。可用于生图或图片处理，有效期为一个月。","Desc_InviteRule2":"2、最多可邀请15位好友。","Desc_InviteRule3":"3、好友订阅即返现，奖励计算方式：奖励金额=用户实际支付金额×奖励比例（例：好友购买连续包年会员您可获196×15%=29.4元的提现金额）。特殊活动或促销期间，所获奖励可能会有所调整，具体以实际到账金额为准。","Desc_InviteRule4":"4、若套餐或赠送的积分已使用，则无法撤销或退换。","Desc_InviteRule5":"5、已有注册账户、自我推荐、重复注册账户或存在欺诈行为的用户将无法获得奖励。","Desc_InviteRule6":"6、美图设计室保留调整活动并撤销异常账户奖励的权利。","Message_SwitchToPersonal":"请切到个人身份","Message_GetInviteLinkFailed":"获取邀请链接失败","Message_InviteLinkRetry":"邀请链接获取失败，请稍后重试","Message_CopySuccess":"复制成功！","Message_CopyFailedManual":"复制失败，请手动复制链接","Text_LoginForInviteLink":"请先登录获取邀请链接","Text_SwitchPersonalForInviteLink":"请切换个人身份获取邀请链接","Alt_InviteRewardTitle":"邀好友送美豆，订阅再返现","Alt_InviteHeroVisual":"邀请好友返现主视觉","Button_CopyInviteLink":"复制邀请链接","Alt_ActivityRules":"活动规则","Desc_InviteRewardSummary":"邀请好友注册，双方均可获得40美豆，你最多可获得600美豆。好友可获得限时7天的订阅立减优惠，若好友在活动期间内订阅美图设计室会员，你将获得现金返现，","Text_CommissionRate15":"佣金比例达15%！","Text_DetailRules":"明细规则","Alt_CashoutTutorial":"提现教程","Desc_InviteDetailAppPath":"你可进入【美图设计室】APP-【我的】-【邀请有礼】-【收益钱包】，查看邀请明细。","Desc_InviteDetailAppPathShort":"你可进入【美图设计室】APP-【我的】-【邀请有礼】-【收益钱包】，查看邀请明细","Desc_InviteSettlementCycle":"结算周期：售卖会员的订单，按下单时间+1月进行结算，+1月为退款冷静期，冷静期内退款订单将无法进行提现。过冷静期后，对应订单的分成可进行提现。","Button_LoginToGet":"登录获取","Button_ClaimNow":"立即领取","Title_SameStyleReplicate":"同款复刻 🌟","Text_PageNotFound":"Sorry，页面走丢啦","Label_PricingPlan":"套餐价格","Title_ChooseMembershipPlan":"选择适合你的会员套餐","Tab_RenewalYear":"连续包年","Tab_RenewalMonth":"连续包月","Tab_SingleYear":"单年购买","Tab_SingleMonth":"单月购买","Text_MeidouPerMonth":"${0}美豆/月","Title_PersonalVipOnly":"该会员仅支持个人身份购买，请确认是否切换至个人身份","Button_Switch":"切换","Text_ComingSoon":"即将上线","Button_SubscribeNow":"立即订阅","Text_MostPopular":"最受喜欢","Text_Trial7DaysPerYear":"试用7天(${0}/年)","Label_Year":"年","Text_StartingFrom":"起","Label_DesignRecord":"作图","Label_AgentRecord":"Agent记录","Button_ViewMore":"查看更多","Placeholder_PleaseEnterContent":"请输入内容","Text_InviteLinkExpired":"您访问的链接已失效","Text_RegenerateInviteLink":"请联系管理员重新生成邀请链接","Text_JoinedSuccess":"您已成功加入","Text_UseTeamOnPc":"电脑访问 ${0} 使用你的团队创作","Button_CopyUrl":"复制网址","Text_InviteYouToJoin":"\\"${0}\\"邀请您加入","Button_JoinNow":"立即加入","Title_TemplateCenter":"模板中心","Text_NoSuchTemplate":"暂无此类模板，小美会尽力补充～","Title_DesignKitHome":"设计室首页","Label_Tags":"标签","Button_DownloadAppToEdit":"下载美图设计室APP编辑","Title_DesignKitTeam":"美图设计室 ${0}","Desc_TeamLandingQuestion":"物料设计全靠设计师，如何提升团队设计效率？","Button_UseNow":"立即使用","Text_ViewTeamIntro":"查看团队版完整介绍","Button_ViewPricing":"查看定价","Button_EnterTeamNow":"立即进入团队","Title_EnterpriseSolution":"了解企业专属解决方案","Desc_EnterpriseContactForm":"请填写表单，美图设计室团队将于1-3个工作日内联系您","Message_CompanyNameMaxLength":"企业名称不能超过100个字","Label_Position":"职位","Message_PleaseEnterPosition":"请输入您当前在该企业的职位","Placeholder_EnterPhone":"请输入手机号码","Placeholder_EnterPosition":"请输入您当前在该企业的职位","Label_ExpectedUsers":"预计使用人数","Title_TeamMaterialEasier":"制作团队物料更简单","Label_CommercialTemplate":"商用模板任选","Desc_CommercialTemplate":"海量模板素材可编辑发布，授权企业主体商用无忧。","Label_BatchDesignSpeed":"批量设计提速","Desc_BatchDesignSpeed":"批量抠图、套板、流水线出图节省大量时间。","Label_VisualStandard":"视觉规范统一","Desc_VisualStandardWork":"预设色卡、字体样式等规范、保证品牌设计风格统一。","Desc_VisualStandardHome":"预设色卡、文字样式等规范（支持上传字体），保证设计风格统一。","Title_TeamCollabEfficient":"多人协同设计更高效","Label_TeamSharedResource":"团队共享资源","Desc_TeamSharedResource":"按照部门/项目一键共享文件夹，快速搭建设计资源库。","Label_FlexiblePermission":"权限灵活设置","Desc_FlexiblePermission":"每个文件都能灵活设置权限，避免设计资源外泄。","Label_TemplateQuickReuse":"模板快速复用","Desc_TemplateQuickReuse":"上传PSD至模板库，全组快速复用，不再苦等文件接收。","Title_TeamManageEasier":"管理成员与资产更轻松","Label_TeamDataReview":"团队数据复盘","Desc_TeamDataReview":"后台定期复盘成员创作情况，及时调整团队席位。","Label_MemberRoleManage":"成员角色管理","Desc_MemberRoleManage":"自主设置团队管理员，处理成员变动与资产交接。","Tag_ConvenientCreate":"便捷创作","Desc_FreeEditionAudience":"个人用户与团队用户皆可体验","Desc_FreeTemplateMaterial":"免费模版/素材","Desc_PartialFreeTools":"智能工具（部分免费）","Button_FreeExperience":"免费体验","Tag_QualityContent":"优质内容","Desc_PersonalEditionAudience":"面向个人商家、设计师或独立创作者","Desc_IncludesFreeBenefits":"包含免费版权益","Desc_PaidTemplateMaterial":"付费模板/素材","Desc_PersonalCommercialAuth":"个人商用授权","Desc_Meidou330PerMonth":"330美豆/月（用于AI生成类工具）","Tag_EfficientCollab":"高效协作","Desc_TeamEditionAudience":"面向需要组织协同的小型商家或自由团队","Desc_IncludesProBenefits":"包含专业版权益（证件照除外）","Desc_EnterpriseAuthOne":"企业商用授权*1","Desc_BrandSpecBrief":"品牌规范（logo/色卡/字体）","Desc_PsdTemplateUpload":"PSD模板上传","Desc_TeamDataAnalysis":"团队数据分析","Desc_TeamResourceShare":"团队创作资源共享","Desc_SharedPermissionManage":"共享权限管理","Desc_SeatsMeidouPerMonth":"席位数*330美豆/月（用于AI生成类功能）","Title_MarketingCostControl":"公司营销成本更可控","Label_AiPhotoCostDown":"AI商拍降本","Desc_AiPhotoCostDown":"AI商品图、AI模特试衣随手成片，无需搭棚布景，聘请模特，让成片效果摆脱“经费有限”。","Label_AiEditEfficiency":"AI修图增效","Desc_AiEditEfficiency":"照片调整、平面调色、产品精修一键完成，快速跟进产品上新，节省修图人工成本。","Label_SmartVideoCreate":"智能视频创作","Desc_SmartVideoCreate":"商品图转视频，3D商品视频降低创作门槛，让视频宣传不再受阻于漫长剪辑周期与巨额建模费用。","Text_TeamAuthSubLabel":"（团队版会员提供企业商用授权书）","Title_MoreOptions":"更多选择","Title_FreeImageCreate":"免费进行图片创作","Desc_FreeTemplateSlashMaterial":"免费模板/素材","Desc_PartialFreeSmartTools":"部分免费智能工具","Title_IncludesPersonalPlus":"包含个人版所有权益，外加：","Desc_EnterpriseBizAuthOne":"企业商业授权 (1家主体）","Desc_TeamAssetShare":"团队资产共享","Desc_BrandSpecFull":"品牌规范 (Logo/色卡/文字样式）","Desc_MemberAccountHandover":"成员账号管理与离职资产交接","Desc_TeamUsageAnalytics":"团队使用数据分析","Desc_MonthlyMeidouShared":"每月赠送${0}美豆，多账号共用","Title_IncludesTeamPlus":"包含团队版所有权益，外加：","Desc_EnterpriseBizAuthThree":"企业商业授权 (3家主体）","Desc_CustomBrandNav":"自定义企业品牌导航栏","Desc_SsoAccess":"SSO接入","Desc_MonthlyMeidou20000":"每月赠送20000+美豆，多账号共用","Title_OpenClawApi":"OpenClaw API 接入","Desc_OpenClawApi":"调用美图设计室 AI 图像处理能力，管理你的 API Token 与美豆余额。","Title_OpenClawApiShort":"OpenClaw API","Desc_OpenClawMobile":"管理你的 API Token 与美豆余额","Title_QuickStart":"快速开始","Desc_OpenClawQuickStart":"完成 OpenClaw 部署后，给龙虾发送以下指令，即可自动安装所有技能包：","Button_CopyInstallConfig":"一键复制安装配置","Text_SeeTutorial":"详细教程参考","Text_DesignkitSkillsDoc":"designkit-skills 文档","Title_VersionChangelog":"版本更新","Text_NoChangelog":"暂无更新记录","Message_InstallCmdCopied":"安装指令与 Token 已复制","Title_ApiToken":"API Token（AK）","Desc_ApiToken":"使用 Token 为 API 请求鉴权，点击「更换」生成新 Token（旧 Token 立即失效）。","Button_CopyToken":"复制 Token","Button_Reset":"更换","Button_ResetToken":"更换 Token","Text_PleaseLoginFirst":"请先登录","Text_PleaseLoginDash":"—— 请先登录 ——","Title_ResetToken":"更换 Token","Desc_ResetTokenWarning":"更换后旧 Token 将立即失效，正在进行中的 API 调用可能会失败，是否继续？","Message_TokenReset":"Token 已重置","Message_TokenCopied":"Token 已复制","Desc_OpenClawMeidou":"美豆是调用 OpenClaw API 的计费单位，余额不足时接口将返回失败。","Label_CurrentBalance":"当前余额","Button_BuyMeidou":"购买美豆","Button_ConsumptionRecords":"消费记录","Title_OpenClawFeatures":"OpenClaw 功能说明","Desc_OpenClawFeatures":"美图设计室 AI 能力已支持 OpenClaw 调用。通过 AK 认证后可直接调用以下能力，按美豆计费，失败自动退款。","Desc_OpenClawProductImageSet":"输入商品图片，AI 自动生成符合多电商平台规范并且高转化率的商品套图，满足商品上架环节所有图片需求。","Desc_OpenClawSmartCutout":"基于美图 AI 技术，精准识别图像主体，自动去除背景，支持人像、商品等多场景。","Desc_OpenClawEnhanceClarity":"AI 画质修复，将模糊或低画质图像还原为高清效果，提升细节表现力。","Button_ConfirmReset":"确认更换","Message_MeidouQuotaMinZero":"请输入大于等于0的美豆额度","Message_MeidouQuotaRange":"请输入0~${0}的美豆额度","Message_AssignSuccess":"分配成功！","Message_SelectAssignableMember":"请选择可分配美豆额度的成员","Message_NameLength1To20":"请输入1-20字的名称","Placeholder_EnterQuota":"请输入额度","Text_Unlimited":"无限制","Text_Unassigned":"未分配","Label_MemberName":"成员名称","Text_Me":"我","Text_Deactivated":"注销","Text_OverQuotaFrozen":"超额冻结","Label_PhoneNumber":"手机号","Label_Role":"角色","Text_Owner":"所有者","Label_QuotaLimit":"可用额度上限","Message_SelectMemberCount":"请选择${0}位成员","Text_SelectedMemberCount":"已选${0}人","Text_RemainingSeats":"剩余席位：","Button_ConfirmAssign":"确认分配","Button_BatchSetQuota":"批量设置上限","Title_ChangeRole":"更换角色","Button_RemoveMember":"移除成员","Text_PartialMemberFrozenTip":"部分成员超额冻结，可重新","Text_Or":"或","Button_RenewMembership":"续费会员","Label_RemainingMeidou":"剩余美豆","Desc_MemberQuotaTip":"提示：成员设定的额度为使用上限，实际可用受团队美豆余额限制","Text_MemberEmpty":"成员为空","Message_DataLoadFailed":"数据加载失败","Title_BatchAssignMeidou":"为选中的${0}名成员平均分配美豆","Label_AssignCount":"分配人数","Label_TotalConsumption":"总计消耗","Title_ConfirmTransferAssets":"确认转移资产？","Message_TransferAssetsSuccess":"离职成员资产转移成功，查收请前往","Label_MySpace":"我的空间","Message_RemoveMemberProgress":"成员移除成功，查看资产转移进度可前往","Message_RemoveMemberSuccess":"成员移除成功","Title_RemoveMember":"移除成员","Text_RemovingStep1":"1. 正在移除","Text_AssetHandleStep2":"2. 将该成员创建的资产","Option_TransferToUser":"转移给其他用户","Text_TransferableAssets":"可转移资产","Text_DeletedAssets":"被删除资产","Desc_RemovedAssetFolder":"创建的文件夹/作图记录（含未分享的资源）","Desc_RemovedAssetTemplate":"上传的模板/元素（含未分享的资源）","Desc_RemovedAssetAiRecord":"AI工具的生成记录/收藏","Text_SelectAssetReceiver":"3. 选择资产接收成员","Desc_RejoinAssetRecovery":"若该成员在30天内重新加入，上述资产将重新出现在该成员的个人空间。","Desc_RejoinAssetExpire":"超出30天将彻底删除，且无法找回","Button_ConfirmRemove":"确定移除","Text_Last7Days":"近7天","Text_Last30Days":"近30天","Text_Last90Days":"近90天","Text_MemberActiveCount":"成员活跃数","Text_NewAssetCount":"新增资产量","Title_TeamOverview":"团队概览","Title_ActiveMembers":"活跃成员数","Desc_ActiveMembers":"在指定时间范围内，登录过的成员数量","Label_PersonUnit":"人","Label_TotalCount":"共计","Title_AiToolGeneration":"AI工具生成次数","Desc_AiToolGeneration":"在指定时间范围内，所有成员在平台AI工具的总生成次数","Label_TimesUnit":"次","Label_Accumulative":"累计","Title_TotalAssetDownload":"总资产下载量","Desc_TotalAssetDownload":"在指定时间范围内，所有成员在平台内的总下载次数","Label_CopyUnit":"份","Nav_MySpace":"我的空间","Nav_ShareWithMe":"与我分享","Nav_SpaceManage":"空间管理","Nav_AssetHandover":"离职资产","Label_Text":"文字","Label_Group":"组合","Label_Table":"表格","Label_Chart":"图表","Label_AiProductShoot":"AI商拍","Label_AiProductDesign":"AI商品设计","Label_SameStyleReplicate":"同款复刻","Button_CreateFolder":"创建文件夹","Button_NewFolder":"新建文件夹","Button_UploadFile":"上传文件","Button_UploadFolder":"上传文件夹","Button_UploadTemplate":"上传模板","Menu_Rename":"重命名","Button_UseTemplate":"使用模板","Button_CopyToTeam":"复制到团队","Text_MoveToMySpace":"移动到我的空间","Button_ExportContent":"导出","Button_Deselect":"取消选择","Text_SelectAllWithCount":"全选（已选${0}条）","Message_PartialFileCannot":"您当前选择的文件有一部分无法${0}","Text_NoSearchResultYet":"暂无搜索结果","Text_SearchNoMatch":"没有搜到您要的内容","Text_EmptyGoCreate":"暂无内容，快去创建吧","Text_EmptyGoAction":"暂无内容，快去${0}吧","Text_ActionCreate":"创建","Desc_OrganizeWorks":"高效整理个人或团队作品","Message_EnterName":"请输入${0}名","Message_EnterNameWithin20":"请输入20字内的${0}名称","Message_OperationSuccess":"操作成功！","Message_EnterFolderName":"请输入文件夹名称！","Message_EnterFolderNameWithin20":"请输入20字内的文件夹名称","Text_CopyTo":"复制到","Text_CopyingMayTakeMinutes":"正在复制中，可能需要几分钟","Button_GoTeamView":"前往团队查看","Message_BrowserNoUploadFolder":"当前浏览器不支持上传文件夹","Title_MoveAfterMySpace":"移动后将在我的空间","Desc_MixSortAfterMove":"与其他资产按照更新顺序混合排列","Message_HandoverFailed":"交接失败","Message_CreateSuccessExclaim":"创建成功！","Message_NoFilePermission":"您没有该文件的操作权限","Title_ConfirmDeleteRecord":"是否删除以下记录？","Title_ConfirmUnfavorite":"取消收藏后，此次设计结果记录将会丢失，确定取消吗？","Title_ConfirmDeleteGenerate":"删除后，此次生成结果将会丢失，确定删除吗？","Text_To":"到","Text_FileOperating":"文件${0}中...","Message_OperateSuccess":"${0}成功","Text_CurrentDir":"当前目录","Text_OperateDir":"操作目录","Text_Creating":"创建中","Text_NoContent":"无内容","Title_CancelUploadConfirm":"上传尚未完成，要取消所有正在进行的上传吗？","Button_CancelUpload":"取消上传","Message_MaxUploadFiles":"最多支持单次上传500个文件","Message_PersonalUploadLimit":"个人仅支持单次上传20个文件，大于20个请创建团队","Title_PsdToTemplate":"PSD上传后可直接转化为团队模板","Desc_TemplateEditOnly":"模板只有你可以编辑，其他成员只能复制你的模板，无法改动原模板","Link_WhatIsTemplate":"什么是模板","Button_ConvertTemplate":"转为模板","Button_UploadOnly":"仅上传","Text_WaitUpload":"等待上传","Text_Transferring":"正在传输","Text_AllUploadComplete":"全部上传完成","Text_FilesUploadFailed":"${0}个文件上传失败","Text_UploadingProgress":"上传中（${0}/${1}）","Button_StartAll":"全部开始","Button_PauseAll":"全部暂停","Button_CollapseDetail":"收起详情","Button_ExpandDetail":"展开详情","Text_FailDetail":"失败详情","Text_SharedFolderToYou":"向你分享了文件夹","Desc_ClickJoinTeam":"点击查看自动加入该团队","Text_SeatInsufficientFolder":"席位不足，你无法加入团队访问该文件夹","Title_FolderTeamShareOnly":"文件夹仅支持在团队内分享","Button_SwitchTeamCopyFolder":"切换团队并复制文件夹","Button_CreateTeamCopyFolder":"创建团队并复制文件夹","Message_FolderCopiedToTeam":"创建成功，文件夹已为您复制到团队中","Text_UsedSpace":"当前已用：","Text_StorageSpace":"存储空间：","Text_UsedSpaceLabel":"已用的空间","Text_UnlockSpace":"解锁${0}超大空间","Button_UpgradeToMember":"升级到会员","Button_UpgradePremium":"升级到高级会员","Desc_SpaceFullUpgrade":"空间已满，建议升级获得更大存储空间","Desc_SpaceFullContactAdmin":"空间已满，请联系管理员处理","Desc_SpaceFullClean":"空间已满，请立刻清理存储空间","Desc_SpaceLowUpgrade":"剩余空间不足 10%，建议升级获得更大存储空间","Desc_SpaceLowContactAdmin":"剩余空间不足 10%，请联系管理员处理","Desc_SpaceLowClean":"剩余空间不足 10%，请尽快清理存储空间","Desc_VipExpiredRenew":"会员权益已到期，请及时续费","Desc_VipSoonExpireRenew":"会员即将到期，请留意续费","Desc_SpaceNormal":"当前空间状态正常，可继续保存创作内容","Text_CountUnit":"${0} 个","Text_SoonExpire":"即将过期 ${0}","Text_Expired":"已过期 ${0}","Text_FileStatus":"文件状态：${0}，请及时整理","Desc_TopBannerFilesExpire":"您有文件即将过存储期限，请及时管理您的文件，或可选择升级会员永久保留。","Desc_TopBannerSpaceLow":"您的空间仅剩不足10%，建议升级会员获得更大存储空间。","Desc_TopBannerSpaceUrgent":"空间告急，部分作品将过期。升级会员扩充容量，作品永久免删。","Desc_TopBannerSpaceLowPremium":"您的空间仅剩不足10%，建议升级高级会员获得更大存储空间。","Desc_TopBannerVipSoonExpire":"您的会员即将到期，未及时续费可能导致作图记录过期删除，请及时续费。","Desc_TopBannerVipExpired":"您的会员已过期，未及时续费可能导致存储空间不足或作图记录过期删除，请及时续费。","Desc_TopBannerSpaceLowClean":"您的空间仅剩不足10%，请立刻清理存储空间。","Desc_TopBannerVipSoonExpireNoPeriod":"您的会员即将到期，未及时续费可能导致作图记录过期删除，请及时续费","Text_AssetHandovering":"资产交接中...","Text_TransferringStatus":"转移中","Text_ResignationTime":"离职时间：","Desc_AssetHandoverTip":"离职成员资产中的生成记录不支持编辑，其他资产不支持移动与上传操作，如有需要请先将对应资产移动到我的空间","Message_SelectFileLimit":"最多选择${0}个文件","Text_ExpandVersionComparison":"展开各个版本功能对比","Text_CollapseVersionComparison":"收起各个版本功能对比","Text_VersionComparisonToggle":"${0}各个版本功能对比","Text_Consult":"咨询","Text_PricePerMonthWithSymbol":"¥${0}/月","Title_RightsComparison":"权益对比","Text_Trial7Days":"试用7天","Text_UsingNow":"正在使用","Text_ConsultBusiness":"咨询商务","Title_PriceComparison":"价格对比","Text_StandardMember":"标准会员","Text_EnterpriseMember":"企业会员","Text_BeansPerMonth":"${0}豆/月","Text_BeansPerMonthFrom":"${0}豆/月起","Text_WanBeansPerMonthFrom":"${0}万豆/月起","Text_SheetsPerMonth":"${0}张/月","Text_SheetsPerMonthFrom":"${0}张/月起","Text_WanSheetsPerMonthFrom":"${0}万张/月起","Desc_FeatureOnlyNote":"${0}<span style=\\"color: #d0d2d6\\">（仅用该功能）</span>","Text_PersonalCommercial":"个人商用","Text_EnterpriseCommercialEntities":"企业商用授权主体*${0}","Text_PurchasableSeparately":"可单独购买","Desc_MeidouAiQuota":"美豆（AI生成额度）","Label_AiAgentImageEdit":"AI Agent：图片编辑","Label_AiAgentImageGen":"AI Agent：图片生成","Label_AiAgentEcommerce_ImageSet":"AI Agent：电商套图","Label_PortraitBgReplace":"人像换背景","Label_AiPartialRedraw":"AI局部重绘","Label_AiImageGen":"AI生图","Label_AiFloralText":"AI花字","Label_LivePpt":"Live PPT","Label_AiSizeExtend":"AI 尺寸延展","Label_BatchTemplate":"批量套版","Label_CreateCustomSize":"创建自定义尺寸的设计","Label_EditLocalImage":"编辑本地图片","Label_ExportJpgPng":"将设计/图片导出为JPG/PNG","Label_FreeTemplate":"免费模板","Label_FreeFont":"免费字体","Label_FreeAsset":"免费素材","Label_PaidTemplate":"付费模板","Label_PaidFont":"付费字体","Label_PaidAsset":"付费素材","Label_RealtimeMultiEdit":"多人实时编辑","Label_ShareDesignRecord":"分享作图记录","Label_ShareElements":"分享元素（图片/文字/表格）","Label_ShareTemplate":"分享模板","Label_ShareFolder":"分享文件夹","Label_SharePermission":"分享权限管理","Label_RecordToTemplate":"作图记录转换为模板","Label_EnterpriseBrandNav":"企业品牌导航栏","Label_Sso":"单点登录（SSO）","Label_ModelCustomization":"模特定制","Label_SceneCustomization":"场景定制","Label_OnlineAiSupport":"在线智能客服","Label_OnlineManualGuide":"在线人工指南","Label_OperationGuide":"操作指南","Label_CustomerImSupport":"客户IM群支持","Label_DedicatedCsm":"专属客户成功服务","Label_TechPriorityResponse":"技术服务优先响应","Label_TrainingSession":"专场培训","Label_OffboardAssetTransfer":"离职资产交接","Label_MemberPurchaseLimit":"成员购买限制","Label_MemberActivity":"成员活跃情况","Label_MemberDesignActivity":"成员作图情况","Label_MemberAiActivity":"成员AI生成情况","Title_ContentDesign":"内容设计","Title_MultiCollaboration":"多人协同","Title_VisualManagement":"视觉管理","Title_OrgManagement":"组织管理","Title_DataStatistics":"数据统计","Title_ExclusiveCustomization":"专属定制","Title_ServiceGuarantee":"服务保障","Title_EnterpriseAuthConfirm":"企业商用授权信息确认","Text_ConfirmAuthInfoTip":"请确认下列授权信息，提交后将无法修改","Label_Name":"姓名","Label_UnifiedSocialCreditCode":"统一社会信用代码","Label_IdCardNumber":"身份证号","Label_ContactPhone":"联系电话","Title_AuthSuccess":"授权成功","Text_AuthSubjectFilled":"已成功填写授权主体","Button_BackAdmin":"返回后台","Button_DownloadAuthBook":"下载授权书","Title_EnterpriseAuthFill":"企业商用授权信息填写","Label_AuthType":"授权类型","Text_Enterprise":"企业","Message_EnterCompanyNameWithin30":"请输入企业名称（30字以内）","Message_PleaseEnterNameShort":"请输入姓名","Message_Max30Chars":"最多30字","Message_EnterCompanyName":"请输入企业名称","Message_EnterUnifiedSocialCreditCode":"请输入统一社会信用代码","Message_EnterIdCardNumber":"请输入身份证号","Message_InvalidUnifiedSocialCreditCode":"统一社会信用代码格式不正确","Message_InvalidIdCardNumber":"身份证号格式不正确","Message_EnterPhoneNumber":"请输入电话号码","Message_InvalidPhoneNumber":"电话号码格式不正确","Placeholder_PhoneExample":"例如：0592-12345678 / 13912345678","Desc_AuthInfoBindTip":"以上信息一经提交即完成绑定，无法更改，除非您另行加购商用被授权主体","Desc_AuthInfoRiskTip":"若您未准确、完整的填写上述信息，发生版权风险时可能因未能提供有效凭证，无法得到美图设计室平台的商用保障","Desc_AuthSingleSubjectTip":"商用授权书的授权为单一主体授权，仅限购买及绑定的被授权方自身使用，禁止共享或转让","Text_OfflineOrderScanBusiness":"线下订单请扫码联系商务申请授权书","Label_AuthSubjectInfo":"授权主体信息","Text_NotFilledYet":"暂未填写","Text_ServiceValidity":"服务有效期","Text_AuthInactive":"未生效","Text_AuthActive":"生效中","Text_AuthExpired":"已失效","Text_AuthNotStarted":"未开始","Text_OfflineOrder":"线下订单","Label_RelatedOrder":"关联订单","Button_ContactSupport":"联系客服","Button_Fill":"填写","Title_MemberCommercialAuthBook":"会员商用授权书","Button_PurchaseAuthSubject":"授权主体增购","Desc_PurchaseAuthSubjectScan":"若需加购授权主体，可扫码咨询商务","Label_AuthTime":"授权时间","Label_AuthStatus":"授权状态","Text_OrderCancelled":"已取消","Text_OrderPaid":"已支付","Text_OrderRefunded":"已退款","Text_TeamVipProductName":"团队版会员${0}","Text_CutoutCountProductName":"抠图张数${0}","Text_MemberMeidouProductName":"会员美豆${0}个","Message_CancelSuccess":"取消成功","Message_CancelFailed":"取消失败","Title_ConfirmCancel":"确定取消","Text_CancelOrderTip":"取消订单后您可以重新下单购买服务","Button_IssueInvoice":"开票","Text_NoOrders":"暂无订单","Label_ProductInfo":"商品信息","Label_Quantity":"数量","Label_OrderTotal":"总计","Label_OrderStatus":"订单状态","Text_OrderNoPrefix":"订单号：${0}","Text_PayBeforeDeadline":"请在 ${0} 前完成支付，超时支付将自动取消","Button_CancelOrder":"取消订单","Button_PayNow":"立即支付","Title_TransferAmount":"转账金额","Desc_TransferAmountMatch":"1. 转账金额与当前订单金额务必一致","Desc_TransferUniqueCode":"2.每笔订单对应唯一的付款码，该付款码仅本单有效，请勿重复付款","Desc_TransferAutoActivate":"3.转账成功半小时内，系统将自动为你开通会员服务，请及时完成付款","Title_ReceiveAccountInfo":"收款账户信息","Label_AccountName":"账户名称","Label_BankAccount":"银行账户","Label_IssueBank":"开户银行","Label_RemittanceCode":"汇款码","Text_CopyRemittanceInfo":"复制汇款信息","Message_CopiedToClipboard":"复制到粘贴板","Text_CopyRemittanceTemplate":"账户名称： ${0}\\n银行账户： ${1}\\n开户银行： ${2}\\n  汇款码： ${3}","Label_MemberSeats":"成员数/席位数","Label_RemainingSheets":"剩余张数","Label_EnterpriseAuthSubject":"企业商用授权主体","Button_Purchase":"购买","Message_EditSuccessExclaim":"修改成功！","Text_InactiveSeats":"未生效席位数${0}","Text_ExpiredDays":"已过期${0}天","Text_ExpireOn":"${0}到期","Label_OrgId":"组织ID","Label_CreatedAt":"创建时间","Title_ContactInfo":"联系方式","Desc_ContactExpectation":"我们期望与您建立联系🤝，帮助您的团队更好的使用设计室～","Text_ContactFor1v1":"填写后我们将为你提供1V1专属服务","Label_ContactPerson":"联系人","Label_ContactMethod":"联系方式","Text_MemberActivity":"成员活动","Label_LastOnlineTime":"最近上线时间","Label_ActiveDays":"活跃天数","Title_GenerationCount":"生成次数","Label_PosterImageEdit":"海报/图片编辑","Alt_Avatar":"头像","Label_ProductPortrait":"商品/人像","Label_TryOnFaceSwapRecolor":"试衣/换脸/换色","Text_MemberActivityExport":"成员活动.xls","Title_IncludesFreePlus":"包含免费版所有权益，外加：","Title_IncludesStandardPlus":"包含标准会员所有权益，外加：","Title_IncludesTeamMemberPlus":"包含团队会员所有权益，外加：","Text_AccountLimitOne":"账号数限额：1人","Text_PaidTemplateMaterial":"付费模版/素材","Text_FreeTemplateMaterial":"免费模版/素材","Desc_SmartToolsBundle":"智能抠图/AI消除/变清晰等智能工具","Desc_MeidouMonthlyUsage":"每月赠送美豆，可用于：","Desc_AgentProductSuite":"AI Agent：商品套图、详情页、视频等","Desc_AiShootSuite":"AI商拍：AI商品图、人像背景、AI模特等","Desc_AiDesignSuite":"AI设计：AI Logo、Live PPT、AI图文等","Text_TeamSeatsFromPrice":"10席位/¥15,000起","Desc_BulkMeidouOneTime":"大额美豆一次性赠送，多账号共用","Label_OneMonth":"1个月","Label_ThreeMonths":"3个月","Label_TwelveMonths":"12个月","Text_EnterpriseCommercialLicensed":"已授权企业商用","Button_BuyTeamEdition":"购买团队版","Title_ChooseByCommercialAuth":"根据商用授权选择","Label_LicenseTarget":"授权对象：","Desc_PersonalLicenseTarget":"以自然人为经营主体，同时受益主体也是自然人。","Label_LicenseScope":"适用范围：","Desc_PersonalLicenseScope":"个人办公用途（PPT、汇报）、个人网站、个人主体注册的网店宣传用途、个人自媒体、公众号用途、个人短视频创作用途等。","Title_EnterpriseCommercialAuth":"企业商用授权","Desc_EnterpriseLicenseTarget":"企业、个体工商户、行政组织、社会团体等法人及非法人组织。","Desc_EnterpriseLicenseScope":"组织经营网站、公众号、小程序、电商店铺主图/详情页、朋友圈、线上广告、线上产品手册等。","Tip_PersonalLicenseWarning":"注意：个人商用授权用于企业商用属于侵权行为","Alt_ContactServiceQrcode":"联系客服二维码","Text_ScanContactManager":"扫码联系客户经理","Button_LearnQuote":"了解详细报价","Title_PricingPartners":"各行客户都在美图设计室","Title_FaqSectionPricing":"常见问题解答","Title_FaqCommercialUse":"购买会员后是否可以商用？","Desc_FaqCommercialUse":"个人版会员（SVIP）仅能用于个人商用，团队版/企业版会员，可用于公司商用。请根据您的商用场景购买对应会员版本。","Title_FaqInvoice":"购买会员后如何开票？","Desc_FaqInvoicePersonal":"个人版会员普票：打开美图设计室官网，登录会员账号-点击右上角头像-点击续费会员-点击弹窗右下角【我要开票】-微信扫码开票；<br/>","Desc_FaqInvoiceTeam":"团队版会员普票：进入团队管理后台，选择订单发票-选择需要开票的订单-点击开票-扫描二维码填写相关信息即可；<br/>","Desc_FaqInvoiceSpecial":"专票：请通过在线咨询联系在线客服。<br/>","Title_FaqDeviceLimit":"会员账号可以登录几台设备？","Desc_FaqDeviceLimit":"美图账号属于私人账号，为保护您的账号安全及作图隐私，<span style=\\"color: #fff; font-weight: bold;\\">会员一个账号同一个时间仅限一台电脑设备登录</span>，不支持同时登录多台电脑。<br/>如果您需要多设备同时登录操作，建议购买<span style=\\"color: #fff; font-weight: bold;\\">美图设计室团队版/企业版会员</span>，开通多个席位分配账号进行登录～","Title_FaqUpgradeTeam":"个人会员如何升级为团队版会员？","Desc_FaqUpgradeTeam":"因团队版会员与个人版会员费用不同，如需升级为团队版会员，请下单团队版后，联系在线客服进行个人账户的美豆迁移与剩余会员款项处理，个人版账号下的资产可自行操作复制到团队内。","Title_FaqMeidou":"美豆是什么，如何购买？","Desc_FaqMeidou":"美图设计室功能除了免费功能和会员功能外，还有需要消耗美豆才可以生成的AI功能，如AI商品图、AI模特、AI试衣等，都需要消耗美豆进行生成；若会员赠送的美豆消耗完后，需要单独购买，可以在AI功能的右上角进入购买页面，页面指路：<a target=\\"_blank\\" style=\\"color: #66A8FF\\" href=\\"https://www.designkit.cn/product-shoot-editor/?from=home\\">https://www.designkit.cn/product-shoot-editor/?from=home</a>","Message_PermissionAlreadyRejected":"该权限申请已被拒绝","Message_PermissionAlreadyProcessed":"该权限申请已被处理","Text_TeamRenewRemainingPrefix":"您的团队版会员仅剩","Text_UnitDay":"天","Text_SharedItemToYou":"向你分享了一个${0}【${1}】","Label_AccountColon":"账号：","Text_PriceYuanPerPersonPerMonth":"¥${0}/人/月","Text_OrTry":"或试试","Title_DesignKitApp":"美图设计室 APP","Title_OpenClawGuide":"OpenClaw 使用指南","Label_AllColors":"全部颜色","Alt_TemplateImage":"模板图片","Text_NestedTemplateSuiteCount":"套组模板${0}张：","roboneo_agent_queue_tier_fast":"快速","roboneo_agent_queue_tier_relax":"畅享","roboneo_agent_queue_tier_change_failed":"切换失败，请重试","Label_ImageProcessing":"图像处理","Tool_ProductRetouching":"商品精修","Message_SelectImageBefore_ImageTranslation":"使用图片翻译功能前，请先选择一张图片~","Message_SelectImageBefore_Expand":"使用AI扩图前，请先选择一张图片~","Label_AiCreation":"AI创作","Tool_AiImageText":"AI图文","Label_DefaultModel":"默认模型","Desc_AgentMode_Advanced":"算力消耗3x 生成效果3x","Desc_AgentMode_Normal":"适合日常简单创作，节省算力","Desc_AgentMode_FlagshipAi":"·顶尖旗舰AI模式","Desc_AgentMode_MultilingualText":"·精准多语言文字匹配","Desc_AgentMode_ProductFidelity":"·商品还原度 95%","Desc_AgentMode_ComplexScene":"·复杂场景处理能力","Tool_AIVideoAgent":"AI视频智能Agent","Tool_UGCVideoMaker":"UGC视频生成器","Tool_MarketingVideoMaker":"营销视频生成器","Tool_PromoVideoMaker":"推广视频生成器","Tool_ExplainerVideoMaker":"说明视频生成器","Tool_BeforeAfterVideoMaker":"前后对比视频生成器","roboneo_agent_queue_tier_upgrade_title":"无限畅享 Relax","roboneo_agent_queue_tier_upgrade_desc":"${0} 会员权益。以 Relax 模式生成，无需消耗积分。","roboneo_agent_queue_tier_upgrade_primary":"升级至 Pro","roboneo_agent_queue_tier_upgrade_secondary":"使用 Fast 模式","Label_PageIndex":"第${0}页","Title_PPTTask":"PPT 任务","Button_ReplicateNow":"立即复刻","Label_ImageIndex":"图${0}","Button_Cases_ViralVideo":"案例","Message_ImageReviewFailedRetry_Batch":"图片审核失败，请稍后重试","Message_ImageReviewRejected_Batch":"图片审核不通过，请重新上传","Text_PageRange":"${0}~${1}页","Text_AllPagesRange":"所有页面（1~${0}页）","Text_AllPages":"所有页面","Text_SelectedPages":"所选页面 第(${0})","Text_NoPageSelected":"未选择页面","Title_InsertDocument":"插入文档","Title_SelectPages":"选择页面","Button_Insert":"插入","Message_ProductInfoReviewRejected_Batch":"卖点文案审核不通过，请重新填写","Tool_VideoBackgroundRemover":"视频去背景","Title_StayUpdated_Designkit":"及时了解 Designkit 最新动态","Title_StayUpdated_Zawa":"及时了解 Zawa 最新动态","Desc_WebPushPrompt":"第一时间了解新的 AI 工具、功能更新和热门内容。","Button_NotNow":"暂不","Button_TurnOn":"开启","Placeholder_Enter":"请输入${0}","Placeholder_Select":"请选择${0}","Label_AiMarketingVideo":"AI带货视频","Title_ImageProcessing":"图片处理","Title_AiDesign":"AI设计","Label_Ecommerce":"电商","Label_SocialMedia":"社交媒体","Label_WechatMarketing":"微信营销","Label_OfficialAccount":"公众号","Label_OfficeEducation":"行政办公/教育","Label_LifeEntertainment":"生活娱乐","Title_DesignScene":"设计场景","Label_MarketingSales":"营销带货","Label_Promotion":"宣传推广","Label_Greeting":"祝福问候","Label_CommunicationSharing":"交流分享","Label_LifeScience":"生活科普","Label_Recruitment":"招聘招募","Title_UsagePromotion":"用途推广","Label_FoodBeverage":"餐饮美食","Label_ApparelBags":"鞋服箱包","Label_EducationTraining":"教育培训","Label_BeautySkincare":"美妆护肤","Title_IndustryResource":"行业资源","Text_FirstDiscountBadge_ViralVideo":"首条视频优惠","Title_ManagedBatchTip":"睡一觉，图就好了","Tag_ManagedBatchDiscount":"批量${0}折","Desc_ManagedBatchTip":"批量${0}折生图，一觉醒来全搞定","Title_Resize":"调整尺寸","Title_SocialContentCreation":"社媒内容工具","Title_BatchResize":"批量改尺寸","Title_ImageRecolor":"图片换色","Title_BatchRetouch":"批量精修","OnlineConsultation":"在线咨询","PayAmount":"支付${0}元","PriceBreakdown":"¥${0} × ${1}席位 × ${2}个月","ScanToPay":"${0}扫码支付","PaymentAgreementHint":"支付即视为您已同意","MeidouRechargeAgreement":"《美豆充值协议》","DesignStudioServiceAgreement":"《美图设计室会员服务协议》","CommercialLicenseAgreement":"《商用授权书》","CutoutQuotaNotice":"抠图张数赠送须知","RenewalMemberNote":"如果您购买的是续期型会员：","AutoDeliveryOnPurchase":"购买成功后将自动下发到您的当前账号","NonRenewalMemberNote":"如果您购买的是非续期会员：","AutoDeliveryOnTransaction":"交易成功后将自动下发到您的当前账号","CutoutQuotaLabel":"抠图张数：","CutoutQuotaDesc":"以您实际购买的会员商品 在订购页上标记的赠送张数为准","CutoutQuotaExpiryLabel":"抠图张数使用期限：","CutoutQuotaExpiryDesc":"以订购页实际展示的使用期限说明为准","TrialAddressLabel":"体验地址：","ServiceNotice":"服务须知","AutoRenewNote1":"1.开通本服务后，将在会员到期前24小时内为您自动续费，续费成功会员自动延长对应周期时长；","AutoRenewNote2":"2.您的续期代扣费用将从您绑定的支付账号中扣除；","AutoRenewNote3":"3.您可随时取消自动续费服务，取消后将不再自动续费；","AutoRenewNote4":"4.取消续订指南：","AutoRenewNote5":"5.如有其他问题可拨打客服热线 4000093360","Label_WeChat":"微信","Label_Alipay":"支付宝","Label_BatchTrialCount":"批处理免费体验次数","Desc_WindowsOnly":"仅限Windows客户端版本","Label_MemberFeature":"会员功能","Label_MemberAsset":"会员素材","Label_MemberEffect":"会员特效","Label_NoAds":"无广告","Label_NoPoster":"无美图画报","Label_EffectFilter":"特效滤镜","Label_Enhance":"增强","Label_FaceRemodel":"面部重塑","Label_SkinAdjust":"皮肤调整","Label_HeadAdjust":"头部调整","Label_HeightShape":"增高塑形","Label_Border":"边框","Label_RechargeMeidou":"充值美豆","Text_InsufficientBenefits":"权益不足，请联系专属顾问：${0} ${1}","Text_OnlinePurchaseDisabled":"该版本不支持线上购买，如有需要请联系管理员","Desc_ProtectMemberExperience":"为了保障您的会员体验，","Desc_BindPhoneFirst":"请先绑定一个常用手机号~","Button_GoToBind":"前往绑定","Text_AlreadyActiveMember":"您已在${0}开通会员","Text_ContactServicePrefix":"如有疑问，请","Label_ServicePhone":"客服电话","Text_ServiceTime":"客服在线时间：9:00 ~ 21:00","Text_LargeOrderContact":"大额订单或支付失败请扫码联系商务处理","Text_ConsultEnterprise":"咨询企业商用","Message_CreateFail":"创建失败，请稍后再试~","Title_TransferReminder":"转账提醒","Text_ViewOrderProgress":"后续可在【管理后台-订单发票】中 查看该笔订单进展","Title_PendingTransfer":"存在转账中的订单","Text_HasPendingTransfer":"当前存在正在进行中的对公转账订单，是否查看？","Button_CancelAndCreate":"取消并创建新订单","Button_ViewTransferOrder":"查看转帐中订单","Text_CancelOrderNote1":"取消订单后您可以创建新的订单，","Text_CancelOrderNote2":"但当前转帐中的订单将关闭。","Button_ConfirmCancelCreate":"确认取消并创建","Link_ViewBenefitDetail":"查看详细权益 >","Label_RedeemCode":"兑换码","Message_RedeemSuccess":"兑换成功~","Message_RedeemVipSuccess_DesignKit":"您已成功兑换美图设计室VIP会员!","Message_RedeemSvipSuccess_MeituXiuXiu":"您已成功兑换美图秀秀SVIP会员!","Placeholder_EnterInviteCode":"请输入邀请码","Placeholder_EnterRedeemCode":"请输入兑换码","Title_CodeCenter":"优惠码中心","Desc_SelectCodeType":"选择您持有的码类型进行验证兑换","Title_InviteCodeDesc":"邀请码说明","Title_RedeemCodeDesc":"兑换码说明","Text_InviteCodeIntro":"用户输入从社交媒体等渠道获得的专属邀请码：","Text_InviteCodeBenefit1":"专属渠道的优惠订阅价格，获得权益限免次数","Text_InviteCodeBenefit2":"每个邀请码仅限使用一次","Text_InviteCodeBenefit3":"不可与其他优惠活动叠加使用","Text_RedeemCodeIntro":"使用从官方渠道获得的会员兑换码：","Text_RedeemCodeBenefit1":"登录账号后，输入兑换码即可完成兑换","Text_RedeemCodeBenefit2":"兑换成功后，可享受对应的会员权益和服务","Text_RedeemCodeBenefit3":"请在兑换码有效期内使用，过期作废，不可退款","Text_InvoiceLink":"本链接可开具【${0}】的订单发票","Text_InvoiceOtherBusiness":"如有其他美图业务的订单开票需求，请关注公众号【美图支付服务】","Desc_ConsumeSoonExpiredMeidou":"优先消耗临期美豆","Link_MeidouIntro":"美豆介绍 >","Text_NoMeidouGoToBuy":"没有美豆哦～请前往购买吧","Text_ThankYouSupport":"感谢您对我们的支持，我们将持续为您提供更多新的服务","Text_PurchaseBatchSuccess_MeituXiuXiu":"您已成功购买美图秀秀批处理张数","Text_PurchaseCutoutSuccess":"您已成功购买美图抠图·下载张数","Label_BoundAccount":"已绑定账号：","Text_PurchaseCount":"购买张数：${0}张，","Label_TeamMemberExpiry":"团队版会员有效期：","Label_ProMemberExpiry":"高级会员有效期：","Label_StandardMemberExpiry":"标准会员有效期：","Text_PurchaseSeatCount":"购买席位数：${0}位","Button_GotItCountdown":"我知道了（${0}s）","Text_Trial":"试用${0}","Text_OriginalPrice":"原价${0}","Text_PerSheet":"/张","Text_PerPersonPerMonth":"/人/月","Text_FreeTrialDays":"${0}天免费试用","Text_FreeTrialMonths":"${0}月免费试用","Text_FreeTrialQuarters":"${0}季免费试用","Text_FreeTrialYears":"${0}年免费试用","Text_ScanToBuy":"${0}扫码购买","Text_ScanToActivate":"${0}扫码开通","Text_AlsoSupportWechatBuy":"（同时支持微信扫码购买）","Text_AlsoSupportWechatActivate":"（同时支持微信扫码开通）","Text_ServiceAgreement_DesignKit":"美图设计室会员服务协议","Text_ServiceAgreement_MeituXiuXiu":"美图秀秀粉钻SVIP会员协议","Text_ServiceAgreement_Meidou":"美豆充值协议","Text_ServiceAgreement_Cutout":"抠图服务协议","Text_ServiceAgreement_BatchMeituXiuXiu":"美图秀秀批处理服务协议","Button_ClickLogin":"点击登录","Text_CheckAgreementFirst":"请先勾选同意","Text_LoadError":"加载异常","Button_ClickRefresh":"点击刷新","Label_Pay":"支付：","Text_ExtendAfterPurchase":"购买后延期至：${0}","Button_Agree":"同意","Title_ThankYouSubscription":"感谢您的订阅！","Text_MemberServiceAgreement":"《会员服务》","Title_PayFail":"支付失败","Button_RepayNow":"重新支付","Desc_OneYearValidTeam":"1年有效，仅支持在当前团队身份下使用","Text_SharedMeidouPrompt":"5人以上共享美豆请","Button_ActivateTeamMember":"开通团队版会员","Text_SeatPurchaseEffect":"加购席位立即生效，于${0}到期（与生效中的团队版会员订单同步到期）","Label_Gift":"赠","Text_FirstMonthMeidouGift":"开通会员首月赠送${0}美豆，次月开始每月赠送${1}美豆，月内有效。","Text_MonthlyMeidouGift":"每月赠送，月内有效","Desc_TeamOnlyCutout":"购买所得张数仅支持在当前团队身份下使用","Text_DownloadDeductRule":"每成功下载1张图，扣除1张下载张数","Text_CutoutAdjustRule":"支持反复调整抠图效果，不发生下载则不扣除张数","Text_UnlimitedCutout":"会员有效期内抠图没有次数限制","Text_ValidityThreeMonths":"有效期：3个月","Text_ValidityOneYear":"有效期：1年","Title_VipLimitedOffer":"VIP限时特惠","Text_TeamSeatRequirement":"当前团队已有${0}人，请购买相应的席位数","Text_TeamMemberSeatMinimum":"团队版会员${0}个席位起购","Text_MeidouGiftPerMonth":"赠送美豆：${0}豆/月","Label_SeatCount":"席位数","Text_SeatOrderEffect":"新订单的席位数将在${0}时生效，若需立即增加席位数，可直接","Button_ActivateMemberUnlimited":"开通会员不限量","Button_BuyMember":"购买会员","Button_BuyCount":"购买张数","Text_BatchRemainingCount":"批处理剩余张数：${0}","Label_RemainingCutout":"剩余抠图张数：","Text_RemainingMeidouCount":"美豆剩余${0}","Text_TeamMemberExpiry":"团队版会员将于${0}到期","Text_BoundPhoneAccount":"（已绑定账号： ${0}）","Button_ClickLoginRegister":"点击登录（登录即注册）","Text_LoginToBuyMember":"请登录后购买会员，以确保您的会员作品不会丢失","Text_LoginToBuy":"请登录后购买","Button_CorporateTransfer":"对公转账","Button_ApplyInvoice":"我要开票","Button_InviteOrRedeemCode":"邀请码/兑换码开通","Button_RedeemCodeActivate":"兑换码开通","Text_MarchPromo":"3月限时电商节，首充赠送双倍美豆","Button_BackToBuy":"返回购买","Label_EstimatedConsumption":"预估消耗：","Text_ValidOneYear":"有效期一年","Text_PerMonth":"/月","Desc_Monthly330Meidou":"每月赠送330美豆（月内有效）可用于：","Text_UnitPrice1000":"仅需¥0.0532/豆","Text_Capacity1000":"约可生成500张图或66个视频","Text_SingleImageLow1000":"单图低至¥0.176","Text_SingleVideoLow1000":"单视频(5s)低至¥1.320","Text_SingleImageYearly1000":"单图低至¥0.106","Text_SingleVideoYearly1000":"单视频(5s)低至¥0.798","Text_UnitPrice1800":"仅需¥0.0462/豆","Text_Capacity1800":"约可生成900张图或120个视频","Text_SingleImageLow1800":"单图低至¥0.164","Text_SingleVideoLow1800":"单视频(5s)低至¥1.233","Text_SingleImageYearly1800":"单图低至¥0.092","Text_SingleVideoYearly1800":"单视频(5s)低至¥0.693","Text_UnitPrice3600":"仅需¥0.0437/豆","Text_Capacity3600":"约可生成1800张图或240个视频","Text_SingleImageLow3600":"单图低至¥0.154","Text_SingleVideoLow3600":"单视频(5s)低至¥1.158","Text_SingleImageYearly3600":"单图低至¥0.087","Text_SingleVideoYearly3600":"单视频(5s)低至¥0.656","Text_UnitPrice7500":"仅需¥0.0410/豆","Text_Capacity7500":"约可生成3750张图或500个视频","Text_SingleImageLow7500":"单图低至¥0.138","Text_SingleVideoLow7500":"单视频(5s)低至¥1.037","Text_SingleImageYearly7500":"单图低至¥0.082","Text_SingleVideoYearly7500":"单视频(5s)低至¥0.615","Desc_IncludesStandardAll":"包含标准版所有权益，外加：","Desc_MonthlyMeidou":"每月赠送${0}美豆（月内有效）可用于：","Text_FewCredits":"少量积分","Label_BasicPlan":"基础版","Text_TrialMeidouGift":"试用期赠120美豆，7天有效","Text_Monthly330MeidouBenefit":"开通会员每月330美豆，月内有效","Label_LimitedPrivilege":"限时特权","Text_SeedancePrivilege":"Seedance 2.0 无限免费低速生成及新功能抢先体验","Label_MeidouPrefix":"美豆：","Text_LoginToBuyMemberShort":"请登录后购买会员","Text_TeamMinimumSeat":"当前团队已有${0}人，至少需要购买${0}个席位","Message_AbnormalSubscriptionNoSeat":"非正常订阅的团队会员不支持加购席位","Text_TeamMemberExpires":"您的团队版会员将于${0}到期","Text_ProMemberExpires":"您的高级会员将于${0}到期","Text_BasicMemberExpires":"您的基础会员将于${0}到期","Text_SvipMemberExpires_MeituXiuXiu":"您的粉钻SVIP将于${0}到期","Text_ActivateVip_DesignKit":"开通美图设计室VIP畅享会员服务","Text_UpgradeToSvip_MeituXiuXiu":"您已开通粉钻VIP，升级SVIP即可在多端畅享设计服务","Text_ActivateTeamMember_DesignKit":"开通团队版会员即可畅享美图设计室VIP权益与团队协作功能","Text_ActivateMember":"开通会员即可畅享超多会员服务","Text_ActivateMember_MeituXiuXiu":"开通会员即可畅享美图秀秀粉钻VIP、粉钻SVIP和美图秀秀桌面端会员服务","Text_ExpiredDays_Team":"已过期${0}天，购买后即可正恢复常使用","Text_VipExpiredDays_DesignKit":"您的VIP已过期${0}天，欢迎回来","Text_VipExpiredDays_MeituXiuXiu":"您的粉钻SVIP已过期${0}天，欢迎回来","Text_ValidDays":"${0}天有效","Text_ValidWeeks":"${0}周有效","Text_ValidMonths":"${0}月有效","Text_ValidQuarters":"${0}季有效","Text_ValidYears":"${0}年有效","Text_CountdownDays":"${0}天 ${1}","Label_Week":"周","Label_Quarter":"季","Desc_BatchCutoutConsumption":"使用抠图功能后完成1个图像下载保存，消耗${0}张，其余功能消耗${1}张","Text_TieredSeatBilling":"会员赠送${0}个席位，超出${1}人按${2}/年/人额外计费","Text_PerYearPerPerson":"/年/人","Text_BoundAccountPrefix":"（已绑定账号：","Text_BoundAccountSuffix":"）","Title_GlobalSettingsMobile_Batch":"全局设置","Tip_ApplyToAllTasksBelowMobile_Batch":"应用于下方所有任务","Tip_UploadImagesFormatMobile_Batch":"点击上传JPEG/JPG/PNG图片，${0}M以内，支持${1}张","Title_EcommerceTools":"电商工具","Title_MoreVideoTools":"更多视频处理功能","Text_AppMessageNotification_Batch":"任务完成后，会在APP端的消息中通知您。","Tool_ProductDemoVideoMaker":"产品演示视频生成器","Tool_Video360Maker":"360°旋转视频生成器","Tool_UnboxingVideoMaker":"开箱视频生成器","Tool_FashionVideoMaker":"时尚视频生成器","Tool_CommercialVideoMaker":"商业视频生成器","Tag_Cover":"封面","Option_ExportLayered_Psd":"分层导出","Option_ExportFlat_Psd":"不分层导出","Message_NoExportableLayer":"未选中可导出的图层","Message_UnsupportedLayerForPsd":"当前图层类型不支持导出 PSD","Message_VideoLayerPsdBlocked":"包含视频层，无法导出 PSD","Message_ExportUnitsOverLimit":"选中范围超过${0}个导出个体","Message_LayerSplitRightDenied":"无拆分图层权益","AiTemplate_Desc":"输入海报主题或描述修改内容，AI一键复刻该模板生成海报","AiTemplate_Upload":"素材上传","AiTemplate_Upload_Desc":"点击上传素材图，用于替换商品图、模特、二维码等。","AiTemplate_Prompt":"海报主题/修改内容","AiTemplate_Prompt_Placeholder":"请输入海报主题或描述想修改的内容。如：把主题换成\'秋分润燥\'；请将图中的XX替換成我上传的XX。","AiTemplate_Generate":"生成海报","Text_OpenClawInstallCmd":"帮我安装 ${0}","Text_SupportLinkImport":"支持链接导入","Text_ModifyLogoPrompt":"请帮我修改这个 Logo","Text_ModifyImagePrompt":"请帮我修改这张图片","Title_UserCenter":"个人中心","Button_Login":"登录","Button_Signup":"注册","Title_FreeBackgroundRemoverOnline":"免费在线背景消除工具","Title_RemoveThe":"使用 Designkit 免费即时自动去除图片背景，无需任何设计技能。","Title_NoPic":"手边没有图片？试试这些示例","Title_IndustryLeading":"行业领先的图像抠图质量","Title_GlobalRunner":"荣获 CVPR 2024 全球赛事亚军，相关突破性研究发表于 AAAI 和 CVPR。","Title_FastAnd":"快速精准的背景消除","Title_SImplyUpload":"上传照片，Designkit 将自动完成从主体识别到背景消除的全部工作，无需复杂操作，无需学习成本。","Title_FineTune":"专业级图像精修","Titel_Whether":"无论是柔软的发丝、面料边缘还是阴影，Designkit 都能保留最关键的细节。您还可以对边缘和角落进行精细调整，实现精致专业的效果。","Title_FlawlessStamp":"完美处理印章与签名","Title_RemoveDull":"去除签名和印章上暗淡模糊的背景。Designkit 能识别每个主体的细节，为任意版式做好准备——支持纯色背景或透明 PNG。","Title_PerfecCutouts":"适用于各类场景的完美抠图","Title_GetFlawless":"为任意类型图像实现完美背景消除。","Button_ECommerco":"电商","Button_Portraits":"人像","Button_Pets":"宠物","Button_LogoSignaure":"标志 & 签名","Title_HowTo":"如何去除图片背景？","Title_UploadYour":"上传您的图片","Title_ChooseAn":"从设备中选择 JPEG、PNG 或 WEBP 格式的图片。","Title_AIRemoves":"AI 自动消除背景","Title_AiEditor":"AI 编辑工具识别主体并消除背景。","Title_EditOrExport":"编辑或导出","Title_DownloadOr":"下载图片或使用内置图片编辑器进行编辑。","Title_FrequentlyAskedQuestions":"常见问题","Title_IsThis":"这个工具免费吗？","Answer_IsThis":"是的，Designkit 的图片背景消除工具是一款免费的背景去除工具。","Title_CanIChange":"抠图完成后可以更换背景吗？","Title_WhichImage":"抠图支持哪些图片格式？","Title_CanIManually":"如果结果不准确，可以手动调整吗？","Answer_CanIchange":"可以，抠图完成后，您可以使用 Designkit 直接选择纯色、渐变色，或添加自定义图片作为新背景。操作简单灵活，完全可自定义。","Answer_WhichImage":"Designkit 支持上传 JPG、PNG、WEBP 等常见格式。您也可以将最终抠图导出为透明 PNG，无缝融入其他设计项目。","Answer_CanIManually":"当然可以。如果自动识别后边缘不够完美，您可以使用内置编辑器手动精修，以满足您的需求。","Button_Reupload":"重新上传","Button_Download":"下载","Button_Edit_Refine":"精修","Button_Edit_Backgrounds":"背景","Button_Edit_Crop":"裁剪","Button_Edit_Edges":"边缘","Button_Edit_Filter":"滤镜","Pop_Download_Freetip":"免费","Pop_Download_UHD":"完整分辨率","Pop_Download_preview":"预览","Guid_More_ColorPanel":"全部","Button_Remove_ColorPanel":"移除","Button_Upload_ColorPanel":"上传","Size_Original_SizePanel":"原始尺寸","Button_Upload_Batch":"批量上传","Desc_Upload":"点击或拖拽上传，粘贴文件。","SubTitle_Header1_Home":"AI 商品上架图生成器","SubTitle_Header2_Home":"AI 海报生成器","SubTitle_Header3_Home":"AI 商品视频生成器","SubTitle_Header4_Home":"AI 商品摄影生成器","SubTitle_Header5_Home":"AI 网站视觉设计","SubTitle_Header6_Home":"虚拟试穿","SubTitle_Header7_Home":"AI 商品详情页设计","SubTitle_Header8_Home":"AI 图片编辑器","SubTitle_Header9_Home":"图像增强","SubTitle_Header10_Home":"物体消除","SubTitle_Header11_Home":"AI 背景消除","SubTitle_Header12_Home":"AI 背景生成器","SubTitle_Header13_Home":"图像尺寸调整","SubTitle_Header14_Home":"图片添加文字","SubTitle_Header15_Home":"AI 图像生成器","SubTitle_Header16_Home":"批量图片编辑器","Size_ToEdge":"延伸至边缘","Pop_Download_UHD_LimitTip":"限时 · ${0}","Before_Text":"处理前","After_Text":"处理后","Button_OpenVipFreeDownloadPsd":"开通会员免费下载 PSD","Text_LogoSlogan_DesignKit":"让商业设计 好看又见效","LogoDesign_ModeTitle":"选择你想生成的内容","LogoDesign_ModeFast":"快速 Logo","LogoDesign_ModeFastDesc":"快速生成，仅包含核心信息。","LogoDesign_ModePro":"Logo 与视觉方案","LogoDesign_ModeProDesc":"策略概念与真实场景预览。","LogoDesign_Essentials":"品牌信息","LogoDesign_BrandNamePlaceholder":"品牌名称（必填）","LogoDesign_IndustryPlaceholder":"行业（必填）","LogoDesign_Description":"描述","LogoDesign_DescriptionPlaceholder":"介绍你的品牌故事、口号、目标受众，或描述你希望 Logo 中包含的具体元素……","LogoDesign_MoreSettings":"更多设置","LogoDesign_LogoType":"Logo 类型","LogoDesign_StyleCount":"风格与数量","LogoDesign_Model":"图像生成模型","LogoDesign_BrandColors":"品牌颜色","LogoDesign_AutoColor":"自动配色","LogoDesign_DragUpload":"拖拽或点击上传","LogoDesign_DragUploadHint":"支持 PNG/JPG/WEBP，建议上传清晰的单张图片。","LogoDesign_UploadingImage":"上传中……","LogoDesign_ReplaceImage":"替换图片","LogoDesign_ReferenceDimensions":"参考尺寸","LogoDesign_GenerateLogos":"生成 Logo","LogoDesign_GenerateExpressLogos":"生成 8 个 Logo","LogoDesign_GenerateConcepts":"生成概念方案","LogoDesign_Processing":"生成中……","LogoDesign_StrategyTitle":"选择方向","LogoDesign_StrategyDesc":"生成最终 Logo 前，请先选择一个策略方向。","LogoDesign_RegenerateStrategies":"换一组策略方案","LogoDesign_SelectStrategy":"选择策略","LogoDesign_GenerationHistory":"生成历史","LogoDesign_NoHistory":"暂无生成历史。","LogoDesign_EditInAgent":"在 Agent 中编辑","LogoDesign_GenerateMockups":"生成样机","LogoDesign_SelectMockupType":"选择样机类型","LogoDesign_VoteLike":"喜欢","LogoDesign_VoteDislike":"不喜欢","LogoDesign_HeroTitlePro":"专业品牌视觉识别。","LogoDesign_HeroDescPro":"从核心概念到多场景应用，构建统一的品牌体系。","LogoDesign_HeroTitleExpress":"AI Logo 解决方案","LogoDesign_HeroDescExpress":"一次生成即可快速探索 8 种不同视觉风格。","LogoDesign_Items":"项","LogoDesign_UntitledBrand":"未命名品牌","LogoDesign_NoStrategy":"未选择策略","LogoDesign_StrategyBadge":"选项","LogoDesign_Inspiration":"灵感","LogoDesign_MockupGridPlaceholder":"AI 生成的样机合集场景","LogoDesign_ValidationBrand":"请输入品牌名称","LogoDesign_ValidationIndustry":"请选择或输入行业","LogoDesign_ValidationStrategy":"请先选择一个策略","LogoDesign_ValidationMockup":"请至少选择一种样机类型","LogoDesign_Style_Minimalist":"极简","LogoDesign_Style_Vintage":"复古","LogoDesign_Style_Geometric":"几何","LogoDesign_Style_Abstract":"抽象","LogoDesign_Style_HandDrawn":"手绘","LogoDesign_Style_Luxury":"奢华","LogoDesign_Style_Tech":"科技感","LogoDesign_Style_Nature":"自然","LogoDesign_LogoType_IconText":"图标 + 文字","LogoDesign_LogoType_TextOnly":"仅文字","LogoDesign_LogoType_IconOnly":"仅图标","LogoDesign_LogoType_Lettermark":"字母标志","LogoDesign_LogoType_Emblem":"徽章标志","LogoDesign_LogoType_Mascot":"吉祥物","LogoDesign_MockupType_BusinessCard":"名片","LogoDesign_MockupType_Signage":"招牌","LogoDesign_MockupType_Packaging":"包装","LogoDesign_MockupType_Shirt":"T 恤","LogoDesign_MockupType_ToteBag":"托特包","LogoDesign_MockupType_Sticker":"贴纸","LogoDesign_MockupType_OfficeSupplies":"办公用品","LogoDesign_MockupType_AppIcon":"应用图标","LogoDesign_AddColor":"添加颜色","LogoDesign_ReferenceDimension_Graphics":"图形","roboneo_agent_queue_tier_fast_description":"立即出图，按次消耗积分。","roboneo_agent_queue_tier_relax_description":"免费无限生成，速度稍慢，不消耗积分。","roboneo_agent_queue_tier_relax_locked_description":"${0} 专属权益，免费生成不消耗积分。","roboneo_agent_queue_tier_upgrade_unlock":"升级即可解锁","Button_UpgradeForFree":"免费升级","Label_Teams":"AI团队","Title_AiModelAccess_Pricing":"AI 模型访问","Text_LimitedAiModels_Pricing":"有限的视频和图像模型","Label_GptImage2_Pricing":"GPT Image 2.0","Label_NanoBananaPro_Pricing":"Nano Banana Pro","Label_NanoBanana2_Pricing":"Nano Banana 2","Label_GeminiOmniFlash_Pricing":"Gemini omni Flash","Label_Seedance2Mini_Pricing":"Seedance2.0 Mini","Label_Seedance2Fast_Pricing":"Seedance 2.0 Fast","Label_Kling26_Pricing":"Kling 2.6","Label_Veo31_Pricing":"Veo 3.1","Label_Sora2_Pricing":"Sora 2","Label_Midjourney_Pricing":"Midjourney","Label_Seedance25ComingSoon_Pricing":"Seedance 2.5 (Coming soon)","Label_Seedream50Pro_Pricing":"Seedream 5.0 pro","Label_NanoBanana_Pricing":"Nano Banana","Label_Seedream40_Pricing":"Seedream 4.0","Label_SeedEdit30_Pricing":"SeedEdit 3.0","Tab_VideoObjectRemover":"视频消除","Text_WholeProductGuide_DomesticCloneCase":"上传你想参考的商品爆款图，轻松复刻同款","Text_ApparelGuide_DomesticCloneCase":"上传你想参考的服饰爆款图，轻松复刻同款","Text_PosterCoverGuide_DomesticCloneCase":"上传你想参考的海报爆款图，轻松复刻同款","Text_SocialGraphicsGuide_DomesticCloneCase":"上传你想参考的社媒爆款图，轻松复刻同款","TaskName_WholeProductClone_DomesticCloneCase":"薄荷绿猫图案保温杯","TaskName_ApparelClone_DomesticCloneCase":"女童碎花娃娃领衬衫","TaskName_PosterCoverClone_DomesticCloneCase":"顺德美食攻略海报","TaskName_SocialGraphicsClone_DomesticCloneCase":"景德镇旅游攻略","Label_SwitchToPage":"切换到第${0}页","File_Mention_Upload_Text":"从本地添加","File_Mention_Empty_Text":"你还没有上传内容","Empty_Agent_Canvas_Text":"AI画布","Empty_Agent_Canvas_Description":"AI帮你生成，创意无限","Label_Height":"高度","Label_Width":"宽度","Agent_Guide_Placeholder_Title":"立即开始，自由创作～","Agent_Guide_Placeholder_Agent_Title":"对话Agent","Agent_Guide_Placeholder_Agent_Subtitle":"从0开始创作","Agent_Guide_Placeholder_Upload_Subtitle":"已有图片进行编辑","Label_Text_Then":"之后","Meta_Title_LogoDesign":"使用 Zawa AI 轻松完成专业 Logo 设计","Title_AppEnhancer":"AI 视频变清晰","Desc_AppEnhancer":"一键提升至 4K 高清，支持画质增强与帧率提升。","Title_AppWatermarkRemover":"视频去水印&字幕","Desc_AppWatermarkRemover":"快速去除视频水印和 Logo。","Title_AppBackgroundRemover":"视频背景移除","Desc_AppBackgroundRemover":"一键移除视频背景，无需注册。","Title_VideoDemos":"试试这些视频","Button_DownloadPreview":"下载 5 秒预览","Text_PreviewDownloading":"正在下载 5 秒视频...","Title_PreviewVideo":"5 秒预览视频","Title_FullVideo":"完整视频","Button_DownloadFull":"下载完整视频","Text_FullDownloading":"正在下载完整视频...","Tip_FullVideoReady":"完整视频已处理完成，可直接下载。","Tip_Processing":"处理可能需要一些时间，请不要刷新页面，稍后再查看。","Tip_ProcessComplete":"处理完成。点击将视频保存到手机。","Tag_Purchased":"已购买","Text_Uploading":"上传中...","Message_ProcessFailed":"视频处理失败。","Button_UploadVideo":"上传视频","Text_SupportFormat":"支持格式：${0}","Button_UploadNew":"+ 上传新视频","Message_ProcessFailedRetry":"视频处理失败，请检查网络后重试。","Tip_MaxProcessNum":"最多同时处理 ${0} 个视频，请稍后再试。","Tip_MaxUploadNum":"一次只能上传 ${0} 个视频文件。","Message_VideoLoadFailed":"视频加载失败","Tip_VideoResolutionLimit":"不支持分辨率超过 4K 的视频。","Tip_VideoDurationLimit":"视频超出限制，请保持在 20 分钟以内。","Tip_VideoSizeLimit":"上传的视频过大，请上传 ${0}MB 以内的视频。","Tip_VideoFormatLimit":"支持的视频格式为 ${0}，请上传正确格式的视频。","Tip_Done":"完成","Text_IsProMember":"您是 Pro 会员。","Text_SubscribeToUnlock":"订阅以解锁。","Button_Enhance":"开始变清晰","Button_Remove":"开始移除","Text_Enhancing":"增强中...","Text_EnhancingFull":"正在增强完整视频...","Text_Removing":"移除中...","Text_RemovingFull":"正在移除完整视频...","Text_RemovingSelectedArea":"正在去除选中区域…","Tag_Enhanced":"已增强","Tag_Removed":"已移除","Tag_Preview":"5 秒预览","Label_SelectResolution":"选择分辨率","Message_DownloadFailed":"下载失败，请检查网络后重试。","Message_DownloadFailedRetry":"下载失败，请重新下载。","Tab_Smart":"智能识别","Tab_Watermark":"水印","Tab_Subtitle":"字幕","Tab_Manual":"手动","Label_BoxItem":"框选要去除的区域","Tip_ClearManualBoxOnSwitch":"切换模式，选框将被清除","Label_Multiplier":"${0}x","Label_Resolution1K":"原画增强","Label_Resolution2K":"2k","Label_Resolution4K":"4k","Title_ConfirmVideoRights":"请确认您有权使用该视频。","Desc_ConfirmVideoRights":"请勿上传或导入任何您不拥有所有权、或未获合法授权使用的内容。点击“确认”即表示您确认该内容归您所有，且以下各项均不会侵犯任何第三方的权利或违反适用法律：(i) 内容本身；(ii) 您对我们服务的使用；或 (iii) 我们为提供您所请求的服务而对该内容的使用。","Button_Import":"导入","Title_ImportVideoLink":"导入您的视频链接","Label_ConfirmContentPermission":"上传链接即表示我确认自己拥有该内容的所有权。","Placeholder_VideoLink_WatermarkRemover":"输入需要去水印的视频链接…","Placeholder_VideoLink_SocialPlatforms":"支持 TikTok、IG、YouTube、Facebook 链接","Placeholder_VideoLink_SocialPlatforms_Domestic":"支持 抖音，快手，小红书，TikTok 链接","Tip_InvalidLink":"请导入有效的链接","Tip_LinkImportFailed":"导入失败，请重试","Text_FileFromLink":"链接文件 ${0}","Text_LinkImporting":"导入中 ${0}%","Button_Batch":"批量","Button_Link":"链接","Title_MobileBatchUnsupported":"移动端暂不支持批量","Text_VisitOnDesktop":"请在电脑上访问：","Button_CopyAddress":"复制地址","Text_UploadDropPasteClick":"拖放、粘贴或点击上传","Text_UploadDropPasteClick_Support":"支持 .mp4、.mov、m4v","Tips_UploadMaxVideoCountLimit":"最多允许上传 ${0} 个视频文件","Title_AILogoDesign":"AI LOGO设计","Title_AILogoPreview":"AI Logo设计","Message_IndustryLoadFailed":"行业数据加载失败","Message_LogoResultPartialFailed":"获取部分 Logo 生成结果失败","Label_LogoGenerateMode":"Logo 生成模式","Tab_GeneralMode":"通用模式","Desc_StrongerLogoModel":"更强模型驱动，Logo质量更高","Button_CloseTip":"关闭提示","Label_LogoName":"LOGO名称","Label_LogoSlogan":"副标题/口号","Label_Optional":"选填","Placeholder_LogoDescription":"描述品牌调性、风格关键词或使用场景等","Title_AIServiceStatement":"AI服务声明","Label_LogoCreateGuide":"Logo 创建说明","Title_StartCreateLogo":"开始创建你的 Logo","Desc_CreateLogoSchemes":"填写左侧品牌信息，生成${0}张精选方案","Text_FillBrandInfo":"填写品牌信息","Text_SelectGenerateMode":"选择生成模式","Text_GetLogoScheme":"获得 Logo 方案","Label_AILogoPreview":"AI Logo 放大预览","Button_ClosePreview":"关闭预览","Label_AILogoLarge":"AI 生成的 Logo 大图","Button_PreviousLogo":"查看上一个 Logo","Button_NextLogo":"查看下一个 Logo","Button_ScrollThumbnailsLeft":"向左滚动缩略图","Label_LogoPreviewList":"Logo 预览列表","Button_SwitchLogo":"切换到此 Logo","Button_ScrollThumbnailsRight":"向右滚动缩略图","Message_LogoDownloadFailed":"Logo 下载失败，请稍后重试","Label_LogoGenerateResult":"Logo 生成结果","Title_GenerateResult":"生成结果：","Button_WatermarkPreference":"设置下载水印偏好","Button_SelectLogo":"选择此 Logo","Text_LogoGenerating":"Logo 生成中...","Message_LogoGenerateFailedRetry":"生成失败，请重新生成","Label_AIGeneratedLogo":"AI 生成的 Logo","Button_EditLogo":"编辑此 Logo","Button_DownloadLogo":"下载此 Logo","Button_PreviewLogo":"预览此 Logo","Message_RecordLoadFailed":"生成记录加载失败","Message_MoreRecordsLoadFailed":"更多记录加载失败","Message_LogoBatchDownloadFailed":"Logo 批量下载失败，请稍后重试","Label_RecordLoading":"生成记录加载中","Label_LogoRecords":"Logo 生成记录","Label_GenerateMode":"生成模式","Text_GenerateTime":"生成时间：${0}","Button_ZoomLogo":"放大查看 Logo","Text_NoMoreRecords":"没有更多记录了","Message_GenerateTaskSubmitted":"生成任务已提交","Message_LogoGenerateFailed":"Logo 生成失败，请稍后重试","Button_QuickGenerate":"快速生成","Label_GenerateViral_ViralVideo":"生成爆款","Label_ReplicateViral_ViralVideo":"爆款复刻","Message_SelectMarket_ViralVideo":"请选择目标市场","Message_SelectLanguage_ViralVideo":"请选择视频语言","Message_SelectRatio_ViralVideo":"请选择平台比例","Message_FillScript_ViralVideo":"请填写自定义脚本","Message_SetScriptCount_ViralVideo":"请设置自定义脚本生成数量","Message_SelectViralType_ViralVideo":"请选择至少一种爆款类型","Message_MaxViralTypes_ViralVideo":"爆款类型总数量不能超过 ${0} 条","Message_InputTaskTitle_ViralVideo":"请输入任务标题","Message_FillSellingPoints_ViralVideo":"请填写卖点描述","Message_ProductImageShortEdgeLimit_ViralVideo":"请上传短边大于300px的图片","Message_ProductImageAspectRatioSuggestion_ViralVideo":"建议上传16:9，9:16或1:1的图片","Message_UploadRefVideo_ViralVideo":"请上传参考视频","Message_TaskCancelled_ViralVideo":"任务已取消","Text_GenerateTaskTitle_ViralVideo":"生成爆款任务${0}","Text_ReplicateTaskTitle_ViralVideo":"爆款复刻任务${0}","Text_TaskCopyTitle_ViralVideo":"${0}-副本","Message_FetchConfigFailed_ViralVideo":"获取爆款初始化配置失败","Title_VideoResult_ViralVideo":"视频结果","Text_AiGenerating_ViralVideo":"AI生成中...","Text_CheckingSellingPoints_ViralVideo":"内容检测中…","Label_EmailNotify_ViralVideo":"视频生成好后通过邮件通知我","Title_LinkEmail_ViralVideo":"绑定邮箱地址","Text_LinkEmailDesc_ViralVideo":"你的账号还没有绑定邮箱。请前往账号中心绑定邮箱，回来后即可开启邮件通知。","Text_LinkEmailRedirect_ViralVideo":"你将跳转至账号中心完成邮箱绑定和验证。","Button_GoToAccountCenter_ViralVideo":"前往账号中心","Title_EmailNotifyConfirm_ViralVideo":"开启邮件通知？","Text_EmailNotifyConfirm_ViralVideo":"视频生成好后，我们会通知 ${0}。","Message_EmailLinked_ViralVideo":"邮箱已绑定。如需在该视频生成好后收到通知，可手动开启邮件通知。","Message_EmailNotifyOff_ViralVideo":"邮件通知已关闭","Message_EmailNotifyOn_ViralVideo":"邮件通知已开启","Text_NoHistory_ViralVideo":"暂无历史记录","Text_MobileGuideGenerate_ViralVideo":"上传商品图和卖点，快速生成适合投放的爆款视频。","Text_MobileGuideReplicate_ViralVideo":"上传商品图和参考视频，一键复刻爆款节奏与画面风格。","Label_DKGenerateViralMobileGuideNavTitle_ViralVideo":"生成爆款","Label_DKGenerateViralMobileGuideTitle_ViralVideo":"生成爆款","Text_DKGenerateViralMobileGuideSubtitle_ViralVideo":"上传商品图和卖点，快速生成适合投放的爆款视频。","Label_DKReplicateViralMobileGuideNavTitle_ViralVideo":"爆款复刻","Label_DKReplicateViralMobileGuideTitle_ViralVideo":"爆款复刻","Text_DKReplicateViralMobileGuideSubtitle_ViralVideo":"上传商品图和参考视频，一键复刻爆款节奏与画面风格。","Label_ZawaGenerateViralMobileGuideNavTitle_ViralVideo":"生成爆款","Label_ZawaGenerateViralMobileGuideTitle_ViralVideo":"生成爆款","Text_ZawaGenerateViralMobileGuideSubtitle_ViralVideo":"上传商品图和卖点，快速生成适合投放的爆款视频。","Label_ZawaReplicateViralMobileGuideNavTitle_ViralVideo":"爆款复刻","Label_ZawaReplicateViralMobileGuideTitle_ViralVideo":"爆款复刻","Text_ZawaReplicateViralMobileGuideSubtitle_ViralVideo":"上传商品图和参考视频，一键复刻爆款节奏与画面风格。","Button_ConfirmGenerate_ViralVideo":"确认生成","Button_Close_ViralVideo":"关闭","Button_Previous_ViralVideo":"上一条","Button_Next_ViralVideo":"下一条","Message_CreateTaskFailed_ViralVideo":"创建任务失败，请稍后重试","Message_RefreshFailed_ViralVideo":"刷新失败，请稍后重试","Message_VideoFormatLimit_ViralVideo":"参考视频暂仅支持 mp4 / mpeg / mov / avi / flv / mpg / webm","Message_ReferenceVideoSizeLimit_ViralVideo":"参考视频大小不能超过 ${0}MB","Message_UploadRefVideoFirst_ViralVideo":"爆款复刻需要先上传参考视频","Message_FillProductInfo_ViralVideo":"请补充商品卖点","Message_SelectVideoType_ViralVideo":"请选择视频类型和数量","Button_Disabled_ViralVideo":"关闭","Text_LoadingCreator_ViralVideo":"正在加载我的达人…","Text_NoCreatorYet_ViralVideo":"还没有达人图，先上传一张试试","Text_TotalCount_ViralVideo":"（共 ${0} 条）","Text_Submitting_ViralVideo":"提交中...","Text_LoadingConfig_ViralVideo":"正在加载配置…","Button_Decrease_ViralVideo":"减少数量","Button_Increase_ViralVideo":"增加数量","Title_NightHosted_ViralVideo":"夜间托管","Message_CreatorGenSuccess_ViralVideo":"达人生成成功","Button_ContinueNewTask_ViralVideo":"继续新建任务","Text_CustomScriptCount_ViralVideo":"自定义脚本 × ${0}","Text_ViralTypeCount_ViralVideo":"爆款类型 × ${0}","Text_FissionCount_ViralVideo":"爆款裂变 × ${0}","Text_AiModelEnabled_ViralVideo":"AI 模特已开启","Label_ModelTab_ViralVideo":"模特页签","Label_ModelParams_ViralVideo":"模特参数","Text_ParamsAdjusted_ViralVideo":"已单独调整参数","Text_NoSellingPoints_ViralVideo":"未填写卖点描述","Message_FillSellingPointsPlease_ViralVideo":"请补充卖点描述","Message_ThanksForFeedback_ViralVideo":"感谢您的反馈！","Title_AdditionalFeedback_ViralVideo":"补充反馈","Placeholder_FeedbackBetter_ViralVideo":"哪里可以做得更好？","Button_SubmitFeedback_ViralVideo":"提交反馈","Button_LikeFeedback_ViralVideo":"点赞","Button_DislikeFeedback_ViralVideo":"点踩","Text_ProductImageCount_ViralVideo":"商品图 ${0} 张","Text_RefVideoCount_ViralVideo":"参考视频 ${0} 条","Text_FollowGlobal_ViralVideo":"当前跟随全局","Message_BatchSubmitSuccess_ViralVideo":"爆款视频批量任务提交成功，共 ${0} 条","Message_BatchSubmitFailed_ViralVideo":"爆款视频批量提交失败，请稍后重试","Text_MaxSelectionTip_ViralVideo":"单次最多支持选择${0}条视频类型","Text_DeselectItem_ViralVideo":"取消选择${0}","Text_SelectItem_ViralVideo":"选择${0}","Tab_CustomCreatorSection_ViralVideo":"定制达人","Tab_MyCreatorSection_ViralVideo":"我的达人","Tab_PersonalAssets_ViralVideo":"个人资产","Tab_OfficialRecommendation_ViralVideo":"官方推荐","Title_CustomCreatorSection_ViralVideo":"定制专属达人","Text_InProgress_ViralVideo":"正在生成中...","Text_NothingToDownload_ViralVideo":"当前暂无可下载结果","Text_ResultNotReady_ViralVideo":"当前结果还不可下载","Text_PreparingDownload_ViralVideo":"正在准备下载...","Text_PreDownloaded_ViralVideo":"处理完成，点击即可将视频保存到手机。","Message_RedoSubmitted_ViralVideo":"已提交重做","Message_RedoFailed_ViralVideo":"重做失败，请稍后重试","Text_CancelHostedConfirm_ViralVideo":"取消托管后，当前仍在生成中的结果会停止继续生成。","Button_Later_ViralVideo":"稍后再说","Message_HostedCancelled_ViralVideo":"已取消托管","Text_BatchFailed_ViralVideo":"当前批次结果未返回，你可以稍后重新生成。","Title_ViralTypeConfig_ViralVideo":"爆款类型配置（共 ${0} 个）","Title_ReplicateConfig_ViralVideo":"复刻配置","Label_ReplicateCount_ViralVideo":"复刻数量","Label_StylePreference_ViralVideo":"风格偏好","Placeholder_StylePreference_ViralVideo":"可填写节奏、情绪、镜头语言、配色氛围等偏好。","Label_SupplementNote_ViralVideo":"补充说明","Placeholder_SupplementNote_ViralVideo":"补充不希望变化的结构、必须保留的镜头、特殊卖点要求等。","Text_FourthSection_ViralVideo":"4、裂变数量","Message_RequestFailed_ViralVideo":"请求失败","Message_PromptOptimizeFailed_ViralVideo":"提示词优化失败，请稍后重试","Message_ModelImageFailed_ViralVideo":"模特生图失败，请稍后重试","Desc_BatchGenerateViral_ViralVideo":"批量上传商品图，统一配置卖点后生成爆款视频任务。","Desc_BatchReplicateViral_ViralVideo":"批量上传商品图，并为每个任务补充参考视频进行爆款复刻。","Text_RecordRetentionTip_ViralVideo":"生成记录仅保留2个月，请尽快下载保存，以免记录丢失。","Message_PromptOptimizeEmpty_ViralVideo":"提示词优化结果为空","Message_CompleteModelInfo_ViralVideo":"请先完善模特信息","Message_ModelGenFailed_ViralVideo":"模特生成失败，请稍后重试","Text_VideoFormatSupport_ViralVideo":"参考视频暂仅支持 mp4 / mpeg / mov / avi / flv / mpg / webm / wmv / 3gpp 格式","Message_UnsupportedVideoFiltered_ViralVideo":"部分视频格式暂不支持，已自动过滤","Message_FreeTrialOneVideoOnly_ViralVideo":"限免仅支持 1 条视频。升级至高级会员可生成更多。","Button_AddToMyCreator_ViralVideo":"加入我的达人","Button_ResetGlobal_ViralVideo":"恢复全局","Button_TaskLevelCustomCreator_ViralVideo":"任务级定制达人","Button_TaskLevelReplicateModel_ViralVideo":"任务级复刻模特","Label_ModelReference_ViralVideo":"模特参考图","Placeholder_CreatorStyle_ViralVideo":"补充达人气质、口播风格、镜头状态等要求。","Text_CreatorDisabledTip_ViralVideo":"未启用达人配置时，系统将按默认通用出镜风格生成。","Text_GenerateViralResult_ViralVideo":"生成爆款结果","Text_OverrideCount_ViralVideo":"覆盖 ${0} 项","Text_ReplicateViralResult_ViralVideo":"爆款复刻结果","Text_SavedCreatorProfiles_ViralVideo":"已保存的达人配置，可一键回填使用。","Label_GenerateScheme_ViralVideo":"生成爆款方案 ${0}","Label_ReplicateScheme_ViralVideo":"爆款复刻方案 ${0}","Text_VideoResult_ViralVideo":"视频结果","Button_ContinueGenerate_ViralVideo":"继续生成","Desc_CreatorImageEmptyHint_ViralVideo":"生成后的达人图会展示在这里，方便当前页面直接复用。","Text_ItemCountUnit_ViralVideo":"${0} 条","Text_CreditAmount_ViralVideo":"${0}美豆","Text_TotalItems_ViralVideo":"总计：${0}条","Text_SelectedVideoTypeCount_ViralVideo":"已选择${0}种视频类型","Text_FirstVideoDiscountBadge_ViralVideo":"首条折扣","Text_DesignKitFirstDiscountVipBadge_ViralVideo":"首条半价","Text_DesignKitFirstDiscountTryBadge_ViralVideo":"首条仅 $1.99","Text_FreeVideoBadge_ViralVideo":"${0}条免费视频","Text_FirstDiscountPrice_ViralVideo":"首条生成仅需${0}美豆（原价${1}美豆）","Text_UpgradeProDiscount_ViralVideo":"升级高级会员享7.5折","Text_EnjoyedProDiscount_ViralVideo":"已享会员7.5折优惠","Text_BatchFeatureRequiresMembership_ViralVideo":"批量功能需要开通会员使用","Text_OpenProGenerationDiscount_ViralVideo":"开通高级会员享7.5折","Text_EnjoyedProGenerationDiscount_ViralVideo":"已享高级会员生成7.5折","Button_OpenProOrMembership_ViralVideo":"开通高级会员/会员","Text_MemberExclusiveBadge_ViralVideo":"会员专属","Text_VipFunctionLimitedTimeOpen_ViralVideo":"会员功能限时开放","Title_NetworkDisconnected_ViralVideo":"网络链接已断开","Text_NetworkDisconnectedRefresh_ViralVideo":"任务仍在后台继续生成，不会丢失。请检查网络后刷新页面查看最新的进度","Button_RefreshPage_ViralVideo":"刷新页面","Message_NetworkDisconnectedRetry_ViralVideo":"网络已断开，请检查网络后重试","Tip_InvalidLink_ViralVideo":"请输入有效的视频链接","Title_GenerateParams_ViralVideo":"生成参数","Label_PreviewMarket_ViralVideo":"投放地区：","Label_PreviewLanguage_ViralVideo":"目标语言：","Label_PreviewAspectRatio_ViralVideo":"视频比例：","Label_PreviewScriptType_ViralVideo":"脚本类型：","Label_PreviewProductInfo_ViralVideo":"商品卖点信息：","Text_GeneratingBrowserTitle_ViralVideo":"⏳ 正在生成中... | ${0}","Text_SimplePreviewSwipeGuide_ViralVideo":"上滑可查看更多","Button_UploadImageReplicate_ViralVideo":"上传图片复刻","Label_PlayVideo_ViralVideo":"播放视频","Label_NoWatermark_ViralVideo":"无水印","Tool_LosslessUpscale":"无损放大","Tool_AiRecolor":"AI换色","Tool_AiPhotoEditorTitle":"AI图片编辑器","Message_ZipOnlyOne":"一次只能上传一个压缩包","Message_ZipSizeLimit":"压缩包大小不能超过 ${0}MB","Message_ZipExtractFailed":"压缩包 ${0} 解析失败","Message_ZipNoUploadableFiles":"${0} 该压缩包内没有可上传的文件","Message_ZipAlreadyUploaded":"${0} 该压缩包内的文件均已上传过，重复上传已被跳过","Title_VideoWatermark":"您的视频包含水印","Desc_VideoWatermark":"试用期间导出的视频将带有 ${0} 水印。升级会员即可下载无水印视频。","Button_RemoveWatermark":"去除水印","Button_DownloadAnyway":"仍然下载","Message_DownloadFailedTryAgain":"下载失败，请重试","MenuItem_ProductRestore":"商品还原","Title_ProductRestore":"商品还原","Desc_ProductRestore":"上传一张原图，还原商品变形","Tip_ProductRestoreUpload":"尽量选择角度、朝向接近当前结果图的图片，商品主体需清晰完整","Button_StartProductRestore":"开始还原","Message_ProductRestoreUploadLimit":"请上传 JPEG/JPG/PNG/HEIC 格式且不超过 10M 的图片","Message_ProductRestoreUploadFailed":"商品还原图片上传失败，请重试","Message_VideoDownloadingInBackground":"正在后台下载，你可以继续使用 ${0}","Button_AdjustParameters":"调整参数","Text_WPS_Welcome_Modal_Meidou_Description1":"大会员：一次性赠送50美豆","Text_WPS_Welcome_Modal_Meidou_Description2":"非大会员：一次性赠送25美豆","Text_WPS_Meidou_Rules":"美豆消耗规则","Text_WPS_Meidou_Details":"美豆消耗明细","Button_ImportLink":"导入链接","Tip_ProductImagesUpload":"上传更多产品角度，效果更佳","Button_EditSkill":"编辑技能","Title_CategorySkills":"${0}技能","Button_AllSkills":"全部技能","Text_NoSkills":"暂无技能","Aria_ScrollLeft":"向左滚动","Aria_ScrollRight":"向右滚动","Message_CompleteRequired":"请完善必填项","Button_InsertToDesc":"带入到描述","Aria_ExpandOptions":"展开选项","Message_FileUploadFailedRetry":"文件上传失败，请重试","Button_UploadImageVideo":"上传图片/视频","Aria_DeleteFile":"删除文件","Aria_PauseVideo":"暂停视频","Aria_SwitchToSlide":"切换到第 ${0} 张","Tip_PleaseFill":"请填写${0}","Tool_ImageToVideoGenerator":"图片生成视频","Tool_TextToVideoGenerator":"文本生成视频","Tool_TikTokVideoGenerator":"TikTok视频生成器","Tool_InstagramVideoGenerator":"Instagram视频生成器","Tool_YouTubeVideoGenerator":"YouTube视频生成器","Tool_YouTubeShortsGenerator":"YouTube Shorts视频生成器"}');
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-i18n/lib/index.js + 5 modules
var lib = __webpack_require__(73811);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/i18n/index.js














var LEGACY_CHUNK_KEY = "xDesignWidgets";
/**
 * 独立发包场景：内置 zh-Hans，保证无外部注入时可用。
 * 业务应用可只走 CDN 注入，不必在业务代码里再 import 语言包 JSON。
 */ var localeTextMap = {
    "zh-Hans": (0,lodash.merge)({}, x_design_locales_next_zh_Hans_namespaceObject, zh_Hans_namespaceObject),
    // TODO: 以下语言在全量上线后，可移除
    en: (0,lodash.merge)({}, x_design_locales_next_en_namespaceObject, en_namespaceObject),
    es: (0,lodash.merge)({}, x_design_locales_next_en_namespaceObject, x_design_locales_next_es_namespaceObject, en_namespaceObject, es_namespaceObject),
    pt: (0,lodash.merge)({}, x_design_locales_next_en_namespaceObject, x_design_locales_next_pt_namespaceObject, en_namespaceObject, pt_namespaceObject),
    id: (0,lodash.merge)({}, x_design_locales_next_en_namespaceObject, x_design_locales_next_id_namespaceObject, en_namespaceObject, id_namespaceObject),
    it: (0,lodash.merge)({}, x_design_locales_next_en_namespaceObject, x_design_locales_next_it_namespaceObject, en_namespaceObject, it_namespaceObject)
};
var SUPPORT_LOCALES = Object.keys(localeTextMap);
function mergeLocaleText(locale, fallback, nextLocaleMap, devNextOverrides, legacyLocaleMap) {
    localeTextMap[locale] = (0,lodash.merge)({}, fallback, nextLocaleMap, devNextOverrides, legacyLocaleMap);
}
// 浏览器环境外部注入多语言
if ( true && window.__LOCALE__) {
    var _localeTextMap$locale, _window$__LOCALE_TEXT, _window$__DEV_NEXT_LO, _window$__LOCALE_TEXT2, _window$__LOCALE_TEXT3;
    var locale = window.__LOCALE__;
    var fallback = (_localeTextMap$locale = localeTextMap[locale]) !== null && _localeTextMap$locale !== void 0 ? _localeTextMap$locale : localeTextMap["zh-Hans"];
    var nextLocaleMap = (_window$__LOCALE_TEXT = window.__LOCALE_TEXT_NEXT_MAP__) !== null && _window$__LOCALE_TEXT !== void 0 ? _window$__LOCALE_TEXT : {};
    var devNextOverrides = (_window$__DEV_NEXT_LO = window.__DEV_NEXT_LOCALE_OVERRIDES__) !== null && _window$__DEV_NEXT_LO !== void 0 ? _window$__DEV_NEXT_LO : {};
    var legacyLocaleMap = (_window$__LOCALE_TEXT2 = (_window$__LOCALE_TEXT3 = window.__LOCALE_TEXT_LEGACY_MAP__) === null || _window$__LOCALE_TEXT3 === void 0 ? void 0 : _window$__LOCALE_TEXT3[LEGACY_CHUNK_KEY]) !== null && _window$__LOCALE_TEXT2 !== void 0 ? _window$__LOCALE_TEXT2 : {};
    mergeLocaleText(locale, fallback, nextLocaleMap, devNextOverrides, legacyLocaleMap);
} else if (typeof globalThis !== "undefined") {
    // node.js 环境：__FULL_LOCALE_TEXT_MAP__ 已是 next + legacy 的全量结果
    // 开发态仅会注入一种语言，__DEV_NEXT_LOCALE_OVERRIDES__ 可直接覆盖到所有语言
    var localeGlobal = globalThis;
    var fullLocaleText = localeGlobal.__FULL_LOCALE_TEXT_MAP__;
    if (fullLocaleText) {
        var _localeGlobal$__DEV_N;
        var _devNextOverrides = (_localeGlobal$__DEV_N = localeGlobal.__DEV_NEXT_LOCALE_OVERRIDES__) !== null && _localeGlobal$__DEV_N !== void 0 ? _localeGlobal$__DEV_N : {};
        for(var _i = 0, _Object$keys = Object.keys(fullLocaleText); _i < _Object$keys.length; _i++){
            var _localeTextMap$_local;
            var loc = _Object$keys[_i];
            var _locale2 = loc;
            var _fallback = (_localeTextMap$_local = localeTextMap[_locale2]) !== null && _localeTextMap$_local !== void 0 ? _localeTextMap$_local : localeTextMap["zh-Hans"];
            mergeLocaleText(_locale2, _fallback, fullLocaleText[loc], _devNextOverrides, {});
        }
    }
}
var localStoreCache = {};
var initLocaleStore = function initLocaleStore(locale) {
    setLocale(locale);
};
var getLocaleStore = function getLocaleStore(_locale) {
    var locale = _locale || (0,lib/* getLocale */.Kd)() || "zh-Hans";
    var localeText = localeTextMap[locale];
    if (!localStoreCache[locale]) {
        localStoreCache[locale] = {
            locale: locale,
            $t: (0,lib/* createLocaleTextWithDevI18nKey */.s0)(localeText, LEGACY_CHUNK_KEY)
        };
    }
    return localStoreCache[locale];
};
var useLocaleStore = function useLocaleStore() {
    var locale = (0,lib/* useLocaleText */.og)();
    return getLocaleStore(locale);
};
/**
 * useLocaleStore 的别名，不再推荐使用
 */ var useLocale = useLocaleStore;


/***/ }),

/***/ 42889:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": () => (/* binding */ createLoading),
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81549);
/* harmony import */ var body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58509);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var rc_util_lib_React_render__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81725);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37457);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_4__);






var createLoading = function createLoading() {
    var Loading = function Loading(props) {
        var tip = props.tip, _props$allowClickMask = props.allowClickMask, allowClickMask = _props$allowClickMask === void 0 ? false : _props$allowClickMask, _props$allowScroll = props.allowScroll, allowScroll = _props$allowScroll === void 0 ? false : _props$allowScroll, className = props.className, style = props.style;
        (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
            if (allowScroll) {
                return;
            }
            (0,body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__/* .disableBodyScroll */ .Qp)(document.body, {
                reserveScrollBarGap: true
            });
            return function() {
                return (0,body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__/* .enableBodyScroll */ .tG)(document.body);
            };
        }, [
            allowScroll
        ]);
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("xdesign-loading", className),
            style: (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, style), {}, {
                minWidth: tip ? 100 : "auto"
            })
        }, allowClickMask ? null : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createElement("style", {
            dangerouslySetInnerHTML: {
                __html: "html, body {\n                          user-select: none;\n                          pointer-events: none;\n                      }"
            }
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
            className: "xdesign-loading__wrap"
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
            className: "xdesign-loading__content"
        })), tip ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
            className: "xdesign-loading__tip"
        }, tip) : null);
    };
    var el = null;
    var show = function show(options) {
        var _options$allowClickMa, _options$allowScroll;
        var tip = typeof options === "string" ? options : options === null || options === void 0 ? void 0 : options.tip;
        var allowClickMask = typeof options === "string" ? false : (_options$allowClickMa = options === null || options === void 0 ? void 0 : options.allowClickMask) !== null && _options$allowClickMa !== void 0 ? _options$allowClickMa : false;
        var allowScroll = typeof options === "string" ? false : (_options$allowScroll = options === null || options === void 0 ? void 0 : options.allowScroll) !== null && _options$allowScroll !== void 0 ? _options$allowScroll : false;
        if (!el) {
            el = document.createElement("div");
        }
        document.body.appendChild(el);
        (0,rc_util_lib_React_render__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createElement(Loading, {
            tip: tip,
            allowClickMask: allowClickMask,
            allowScroll: allowScroll
        }), el);
    };
    var hidden = function hidden() {
        if (el && el.parentNode) {
            (0,rc_util_lib_React_render__WEBPACK_IMPORTED_MODULE_2__/* .unmount */ .vE)(el);
            el.parentNode.removeChild(el);
            el = null;
        }
    };
    Loading.show = show;
    Loading.hidden = hidden;
    return Loading;
};
var Loading = createLoading();
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Loading);


/***/ }),

/***/ 34685:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F3": () => (/* binding */ modalLocalStorageKey),
/* harmony export */   "Tk": () => (/* binding */ bannerLocalStorageKey),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "rW": () => (/* binding */ modalDomesticLocalStorageKey)
/* harmony export */ });
// 定义功能路径的映射类型
// 功能路径映射表
var pathMappings = [
    {
        accessPath: "/",
        targetPath: "/",
        pageName: "home",
        project: "home"
    },
    // 官网
    {
        accessPath: "/tools",
        targetPath: "/tools",
        pageName: "404",
        project: "home"
    },
    // 工具页
    {
        accessPath: "/templates",
        targetPath: "/templates",
        pageName: "404",
        project: "home"
    },
    // 模版页
    {
        accessPath: "/space",
        targetPath: "/space",
        pageName: "404",
        project: "home"
    },
    // 我的空间
    {
        accessPath: "/share",
        targetPath: "/share",
        pageName: "404",
        project: "home"
    },
    // 与我分享
    {
        accessPath: "/editor",
        targetPath: "/editor",
        pageName: "tpbj",
        project: "tpbj"
    },
    // 图片编辑
    {
        accessPath: "/design",
        targetPath: "/design",
        pageName: "hbsj",
        project: "hbsj"
    },
    // 海报编辑
    {
        accessPath: "/aieraser",
        targetPath: "/aieraser",
        pageName: "znxc",
        project: "znxc"
    },
    // 消除
    {
        accessPath: "/quality",
        targetPath: "/quality",
        pageName: "hzxf",
        project: "hzxf"
    },
    // 变清晰
    {
        accessPath: "/upscale",
        targetPath: "/upscale",
        pageName: "upscale",
        project: "upscale"
    },
    // 无损改尺寸
    {
        accessPath: "/puzzle",
        targetPath: "/puzzle",
        pageName: "404",
        project: "pt"
    },
    // 拼图
    {
        accessPath: "/certified",
        targetPath: "/certified",
        pageName: "404",
        project: "zjzsj"
    },
    // 证件照
    {
        accessPath: "/logo-design",
        targetPath: "/logo-design",
        pageName: "ailogo",
        project: "ailogo"
    },
    // AI logo
    {
        accessPath: "/ppt",
        targetPath: "/ppt",
        pageName: "404",
        project: "home"
    },
    // LivePPT
    {
        accessPath: "/poster",
        targetPath: "/poster",
        pageName: "404",
        project: "aihb"
    },
    // AI海报
    {
        accessPath: "/copywriting",
        targetPath: "/copywriting",
        pageName: "404",
        project: "ai_copywriting_web"
    },
    // AI文案
    {
        accessPath: "/product-shoot",
        targetPath: "/product-shoot",
        pageName: "aispt",
        project: "aispt"
    },
    // AI商品图
    {
        accessPath: "/person-shoot",
        targetPath: "/person-shoot",
        pageName: "404",
        project: "personbg"
    },
    // 人像背景
    {
        accessPath: "/model",
        targetPath: "/model",
        pageName: "aimodel",
        project: "aimodel"
    },
    // AI模特
    {
        accessPath: "/clothes",
        targetPath: "/clothes",
        pageName: "404",
        project: "znhz"
    },
    // AI试衣
    {
        accessPath: "/recolor",
        targetPath: "/recolor",
        pageName: "ai_color_change",
        project: "ai_color_change"
    },
    // 服装换色
    {
        accessPath: "/rmwrinkle",
        targetPath: "/rmwrinkle",
        pageName: "404",
        project: "ai_rmwrinkle"
    },
    // 服装去皱
    // 海外项目现有网址
    {
        accessPath: "/ai-background-generator/edit",
        targetPath: "/product-shoot",
        pageName: "aispt",
        project: "aispt"
    },
    {
        accessPath: "/object-remover/edit",
        targetPath: "/aieraser",
        pageName: "znxc",
        project: "znxc"
    },
    {
        accessPath: "/image-upscaler/edit",
        targetPath: "/upscale",
        pageName: "upscale",
        project: "upscale"
    },
    {
        accessPath: "/image-enhancer/edit",
        targetPath: "/quality",
        pageName: "hzxf",
        project: "hzxf"
    },
    {
        accessPath: "/photo-editor/create",
        targetPath: "/editor",
        pageName: "tpbj",
        project: "tpbj"
    }
];
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (pathMappings);
var modalLocalStorageKey = "xdesign-widgets_overseasAccessModal";
var modalDomesticLocalStorageKey = "xdesign-widgets_overseasDomesticAccessModal";
var bannerLocalStorageKey = "xdesign-widgets_overseasAccessBanner";


/***/ }),

/***/ 50767:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": () => (/* binding */ getJumpQuery)
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29010);

var jumpQuery = undefined;
/**
 * 获取跳转参数，并删除跳转参数。
 * @param notRemoveJumpParams 传入 true 时，不会删除 URL 参数
 * @returns 跳转参数
 */ var getJumpQuery = function getJumpQuery(notRemoveJumpParams) {
    if (!jumpQuery) {
        jumpQuery = {
            original_referrer: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .getQueryParam */ .Ph)("referrer"),
            came_from: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .getQueryParam */ .Ph)("came_from")
        };
        !notRemoveJumpParams && (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .removeUrlParameterFromAddressBar */ .k4)([
            "referrer",
            "came_from"
        ]);
    }
    return jumpQuery;
};


/***/ }),

/***/ 29010:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gm": () => (/* binding */ getTargetsUrl),
/* harmony export */   "HJ": () => (/* binding */ rebuildForceTargetUrl),
/* harmony export */   "Ht": () => (/* binding */ setBannerShowTimer),
/* harmony export */   "Ph": () => (/* binding */ getQueryParam),
/* harmony export */   "U3": () => (/* binding */ canShow),
/* harmony export */   "_8": () => (/* binding */ setDataInStorage),
/* harmony export */   "cs": () => (/* binding */ canShowBanner),
/* harmony export */   "dI": () => (/* binding */ formatPath),
/* harmony export */   "g7": () => (/* binding */ trackPopupClick),
/* harmony export */   "k4": () => (/* binding */ removeUrlParameterFromAddressBar),
/* harmony export */   "sD": () => (/* binding */ getTargetPath),
/* harmony export */   "vt": () => (/* binding */ trackPopupShow)
/* harmony export */ });
/* unused harmony export getTargetData */
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69222);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47708);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84480);
/* harmony import */ var _utils_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20820);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34685);






/**
 * 获取指定localStorage key 是否存在
 */ var canShow = function canShow(key) {
    return localStorage.getItem(key) !== "true";
};
/**
 * 写入 localStorage
 */ var setDataInStorage = function setDataInStorage(key) {
    localStorage.setItem(key, "true");
};
/**
 * 写入 banner 唤醒时间
 */ var setBannerShowTimer = function setBannerShowTimer(key) {
    var expiredTime = new Date().getTime();
    localStorage.setItem(key, String(expiredTime));
};
/**
 * 判断 banner 是否还可以展示，过期时间 3 个月
 */ var canShowBanner = function canShowBanner(key) {
    var expiredTime = localStorage.getItem(key);
    if (!expiredTime) return true;
    // 3个月过期时间，如果 banner 唤醒时间 + 3 个月大于当前时间，则可以展示
    return Number(expiredTime) + 3 * 30 * 24 * 60 * 60 * 1000 > new Date().getTime();
};
var getTargetData = function getTargetData(currentPath) {
    return (0,lodash__WEBPACK_IMPORTED_MODULE_0__.find)(_constants__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, function(item) {
        return item.accessPath === currentPath || currentPath.startsWith(item.accessPath + "/");
    });
};
/**
 * 获取目标路径映射数据
 * @param currentPath
 * @returns
 */ var getTargetPath = function getTargetPath(currentPath) {
    var mapping = getTargetData(currentPath);
    return (mapping === null || mapping === void 0 ? void 0 : mapping.targetPath) || undefined;
};
var getServerJumpURL = function getServerJumpURL(url) {
    // HACK: webapi.designkit.com 当前仅在 designkit.com/v1/designkitcn/redirect 这个重定向到国内的场景下使用，它实际也是解析到国内的后端服务
    return "https://".concat((0,_utils_env__WEBPACK_IMPORTED_MODULE_2__/* .getEnvPrefix */ .HN)((0,_configProvider__WEBPACK_IMPORTED_MODULE_3__/* .getConfig */ .iE)().env), "webapi.designkit.com/v1/designkitcn/redirect?redirect_url=").concat(url, "&referrer=").concat(document.referrer);
};
/**
 * 获取跳转目标连接
 */ var getTargetsUrl = function getTargetsUrl(targetPath) {
    var _getConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_3__/* .getConfig */ .iE)(), env = _getConfig.env, appName = _getConfig.appName, isIntl = _getConfig.isIntl;
    var isDesignkit = appName === "designkit" && isIntl;
    // 避免和其他的 key 冲突
    var query = {
        came_from: isDesignkit ? "designkit" : "xdesign",
        referrer: document.referrer
    };
    var prefix = env === "release" ? "www" : env;
    var url = "https://".concat(prefix, ".designkit.cn").concat(targetPath, "?").concat((0,qs__WEBPACK_IMPORTED_MODULE_4__.stringify)(query));
    return getServerJumpURL(url);
};
/**
 * 获取跳转目标连接
 */ var rebuildForceTargetUrl = function rebuildForceTargetUrl(targetUrl) {
    var _getConfig2 = (0,_configProvider__WEBPACK_IMPORTED_MODULE_3__/* .getConfig */ .iE)(), appName = _getConfig2.appName, isIntl = _getConfig2.isIntl;
    var isDesignkit = appName === "designkit" && isIntl;
    var extraQuery = {
        came_from: isDesignkit ? "designkit" : "xdesign",
        referrer: document.referrer
    };
    var url = new URL(targetUrl);
    // 合并 query（不覆盖已有的同名参数）
    Object.entries(extraQuery).forEach(function(_ref) {
        var _ref2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, 2), key = _ref2[0], value = _ref2[1];
        if (value && !url.searchParams.has(key)) {
            url.searchParams.set(key, value);
        }
    });
    return getServerJumpURL(url.toString());
};
/**
 * 格式化path
 */ var formatPath = function formatPath(path) {
    // 小写
    var newPath = path.toLowerCase();
    // 去掉末尾的斜杠
    return path !== "/" && newPath.endsWith("/") ? newPath.slice(0, -1) : newPath;
};
/**
 * 弹窗曝光
 * @param track
 * @param pageName
 */ var trackPopupShow = function trackPopupShow(_ref3) {
    var track = _ref3.track, pageName = _ref3.pageName, isBanner = _ref3.isBanner, popupType = _ref3.popupType, popupName = _ref3.popupName;
    var targetData = getTargetData(formatPath(window.location.pathname));
    if (!targetData) return;
    track("design_popup_show", {
        page_name: pageName || targetData.pageName,
        popup_type: popupType || isBanner ? "redirect_banner" : "redirect",
        popup_name: popupName || "redirect_domestic"
    });
};
/**
 * 弹窗点击
 * @param track
 * @param isJump
 * @param pageName
 */ var trackPopupClick = function trackPopupClick(_ref4) {
    var track = _ref4.track, isJump = _ref4.isJump, pageName = _ref4.pageName, popupType = _ref4.popupType, popupName = _ref4.popupName, isBanner = _ref4.isBanner;
    var targetData = getTargetData(formatPath(window.location.pathname));
    if (!targetData) return;
    track("design_popup_click", {
        page_name: pageName || targetData.pageName,
        popup_type: popupType || isBanner ? "redirect_banner" : "redirect",
        popup_name: popupName || "redirect_domestic",
        click_type: isJump ? 1 : 0
    });
};
var removeUrlParameterFromAddressBar = function removeUrlParameterFromAddressBar(params) {
    var url = new URL(window.location.href);
    params.forEach(function(p) {
        url.searchParams.delete(p);
    });
    window.history.replaceState(window.history.state, "", url.toString());
};
var getQueryParam = function getQueryParam(key) {
    try {
        return new URLSearchParams(decodeURIComponent(window.location.search)).get(key) || "";
    } catch (e) {
        var reg = new RegExp("[?&]".concat(key, "=([^&]*)"));
        var search = decodeURIComponent(window.location.search);
        var match = search.match(reg);
        return (match ? match[1] : null) || "";
    }
};


/***/ }),

/***/ 43585:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JF": () => (/* binding */ initPageTypeCommonParams),
/* harmony export */   "q0": () => (/* binding */ getPageTypeByPath)
/* harmony export */ });
/* unused harmony exports PAGE_TYPE_HOME, PAGE_TYPE_LOCALE_PREFIXES, stripPageTypeLocalePrefix */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38389);

var PAGE_TYPE_HOME = "/";
var PAGE_TYPE_LOCALE_PREFIXES = [
    "en",
    "pt",
    "es",
    "id",
    "de",
    "th",
    "zh",
    "zh-hans",
    "zh-hant"
];
var isDynamicRoutePattern = function isDynamicRoutePattern(routePattern) {
    var patterns = Array.isArray(routePattern) ? routePattern : [
        routePattern
    ];
    return patterns.some(function(pattern) {
        return String(pattern || "").split("/").filter(Boolean).some(function(segment) {
            var normalized = segment.toLowerCase();
            if (normalized.startsWith(":locale") || normalized === "[locale]") {
                return false;
            }
            return normalized.startsWith(":") || /^\[.+\]$/.test(normalized);
        });
    });
};
function getCurrentPathname() {
    if (false) {}
    return window.location.pathname;
}
function normalizePathname() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getCurrentPathname();
    var pathname = String(path || "/").split(/[?#]/)[0] || "/";
    var normalized = pathname.startsWith("/") ? pathname : "/".concat(pathname);
    if (normalized.length > 1 && normalized.endsWith("/")) {
        return normalized.slice(0, -1);
    }
    return normalized;
}
function stripPageTypeLocalePrefix() {
    var _segments$;
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getCurrentPathname();
    var localePrefixes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PAGE_TYPE_LOCALE_PREFIXES;
    var pathname = normalizePathname(path);
    var segments = pathname.split("/").filter(Boolean);
    var firstSegment = (_segments$ = segments[0]) === null || _segments$ === void 0 ? void 0 : _segments$.toLowerCase();
    if (firstSegment && localePrefixes.map(function(prefix) {
        return prefix.toLowerCase();
    }).includes(firstSegment)) {
        return segments.length > 1 ? "/".concat(segments.slice(1).join("/")) : "/";
    }
    return pathname;
}
function getPageTypeByPath() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getCurrentPathname();
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var pathname = stripPageTypeLocalePrefix(path, options.localePrefixes);
    var pageType = pathname.replace(/^\//, "");
    if (pathname === "/") {
        return PAGE_TYPE_HOME;
    }
    if (isDynamicRoutePattern(options.routePattern)) {
        return pageType.split("/")[0] || PAGE_TYPE_HOME;
    }
    return pageType || PAGE_TYPE_HOME;
}
function getCurrentWindow() {
    if (false) {}
    return window;
}
function initPageTypeCommonParams() {
    var _currentWindow$addEve;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var currentWindow = options.window || getCurrentWindow();
    if (!currentWindow) {
        return function() {
            return undefined;
        };
    }
    var history = currentWindow.history;
    var paramName = options.paramName || "global_page_type";
    var getStatInstance = function getStatInstance() {
        return options.statInstance || currentWindow.mtstat;
    };
    var getConfiguredPageType = function getConfiguredPageType() {
        var pathname = currentWindow.location.pathname;
        if (options.pageType) {
            return options.pageType;
        }
        if (options.getPageType) {
            return options.getPageType(pathname);
        }
        return getPageTypeByPath(pathname, {
            localePrefixes: options.localePrefixes,
            routePattern: options.routePattern
        });
    };
    var syncPageType = function syncPageType() {
        var _getStatInstance, _getStatInstance$setC;
        (_getStatInstance = getStatInstance()) === null || _getStatInstance === void 0 || (_getStatInstance$setC = _getStatInstance.setCommonParams) === null || _getStatInstance$setC === void 0 || _getStatInstance$setC.call(_getStatInstance, (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, paramName, getConfiguredPageType()));
    };
    var originalPushState = history.pushState;
    var originalReplaceState = history.replaceState;
    var syncAfterHistoryChange = function syncAfterHistoryChange(callback) {
        var result = callback();
        syncPageType();
        return result;
    };
    history.pushState = function pushState() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return syncAfterHistoryChange(function() {
            return originalPushState.apply(_this, args);
        });
    };
    history.replaceState = function replaceState() {
        var _this2 = this;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++){
            args[_key2] = arguments[_key2];
        }
        return syncAfterHistoryChange(function() {
            return originalReplaceState.apply(_this2, args);
        });
    };
    (_currentWindow$addEve = currentWindow.addEventListener) === null || _currentWindow$addEve === void 0 || _currentWindow$addEve.call(currentWindow, "popstate", syncPageType);
    syncPageType();
    return function() {
        var _currentWindow$remove;
        history.pushState = originalPushState;
        history.replaceState = originalReplaceState;
        (_currentWindow$remove = currentWindow.removeEventListener) === null || _currentWindow$remove === void 0 || _currentWindow$remove.call(currentWindow, "popstate", syncPageType);
    };
}


/***/ }),

/***/ 93507:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CS": () => (/* binding */ fetchUserInfo),
/* harmony export */   "N1": () => (/* binding */ fetchEnterpriseConfigs),
/* harmony export */   "rm": () => (/* binding */ refreshUserRights),
/* harmony export */   "tH": () => (/* binding */ fetchAccessTokenByCode)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89255);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87406);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1225);



/**
 * Refresh user rights
 * @docs https://api-mock.meitu-int.com/project/2110/interface/api/139048
 */ var refreshUserRights = /*#__PURE__*/ function() {
    var _ref = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee() {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", (0,_utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
                        url: "/v1/websdk/activate",
                        method: "GET"
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function refreshUserRights() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch access token by code
 * @docs https://api-mock.meitu-int.com/project/2110/interface/api/139568
 * @param code - meitu account code
 * @returns
 */ var fetchAccessTokenByCode = /*#__PURE__*/ function() {
    var _ref2 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee2(code) {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    return _context2.abrupt("return", (0,_utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
                        method: "POST",
                        url: "/user/get_token_by_code",
                        params: {
                            code: code
                        },
                        hiddenMessage: true
                    }));
                case 1:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function fetchAccessTokenByCode(_x) {
        return _ref2.apply(this, arguments);
    };
}();
/**
 * Check login status (use `/user/info` api)
 * @docs https://api-mock.meitu-int.com/project/2110/interface/api/116813
 * @returns - login or not
 */ var fetchUserInfo = /*#__PURE__*/ function() {
    var _ref3 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee3() {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    return _context3.abrupt("return", (0,_utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
                        method: "GET",
                        url: "/user/info",
                        hiddenMessage: true
                    }));
                case 1:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function fetchUserInfo() {
        return _ref3.apply(this, arguments);
    };
}();
/**
 * 企业配置信息
 * @param oid
 * @docs https://api-mock.meitu-int.com/project/2110/interface/api/158452
 * @returns
 */ var fetchEnterpriseConfigs = /*#__PURE__*/ function() {
    var _ref4 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee4(oid) {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee4$(_context4) {
            while(1)switch(_context4.prev = _context4.next){
                case 0:
                    return _context4.abrupt("return", (0,_utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
                        method: "GET",
                        // url: '/v1/websdk/get_third_authorized_info',
                        url: "/enterprise/config",
                        params: {
                            oid: oid
                        },
                        hiddenMessage: true
                    }));
                case 1:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function fetchEnterpriseConfigs(_x2) {
        return _ref4.apply(this, arguments);
    };
}();


/***/ }),

/***/ 59901:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Op": () => (/* binding */ copyDirToMyTeamSpace),
  "tH": () => (/* binding */ createTeamApi),
  "bE": () => (/* binding */ fetchMemberPermission),
  "sN": () => (/* binding */ fetchTeamAdminInfo),
  "hc": () => (/* binding */ fetchTeamIdentityList),
  "Ay": () => (/* binding */ fetchTeamMemberInfo),
  "tc": () => (/* binding */ generateInvite),
  "lh": () => (/* binding */ handleDownloadRecord)
});

// UNUSED EXPORTS: fetchTeamMemberList

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(81549);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(73009);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 8 modules
var regeneratorRuntime = __webpack_require__(89255);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(87406);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/query-string/index.js + 4 modules
var query_string = __webpack_require__(28614);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/i18n/index.js + 12 modules
var i18n = __webpack_require__(32907);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/request.js + 1 modules
var utils_request = __webpack_require__(1225);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/share/api/index.js




/**
 * 分享给指定成员
 * @param param
 * @returns
 */ var createShareToMember = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee(_ref) {
        var uids, current_node, node_id, permissionMode, oid, formData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    uids = _ref.uids, current_node = _ref.current_node, node_id = _ref.node_id, permissionMode = _ref.permissionMode, oid = _ref.oid;
                    formData = new FormData();
                    formData.set("uids", uids.join(","));
                    if (oid) {
                        formData.set("oid", "".concat(oid));
                    }
                    formData.set("current_node", current_node);
                    formData.set("node_id", node_id);
                    formData.set("permission_mode", "".concat(permissionMode));
                    _context.next = 9;
                    return request.post("/yunpan/share/to_users", formData, {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    });
                case 9:
                    return _context.abrupt("return", _context.sent);
                case 10:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function createShareToMember(_x) {
        return _ref2.apply(this, arguments);
    };
}()));
var generateShortUrl = /*#__PURE__*/ function() {
    var _ref4 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee2(_ref3) {
        var path, parameter, formData, headers;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    path = _ref3.path, parameter = _ref3.parameter;
                    formData = new FormData();
                    formData.set("path", path);
                    formData.set("parameter", parameter);
                    headers = {
                        "Content-Type": "application/x-www-form-urlencoded"
                    };
                    _context2.next = 7;
                    return utils_request/* default.post */.ZP.post("/fs/generate_short_url", formData, {
                        headers: headers
                    });
                case 7:
                    return _context2.abrupt("return", _context2.sent);
                case 8:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function generateShortUrl(_x2) {
        return _ref4.apply(this, arguments);
    };
}();
/**
 * 管理员创建分享
 * @param node_id
 * @param current_node
 * @returns
 */ var createShareToOther = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee3(_ref5) {
        var _identity$ouid, _identity$oid;
        var current_node, node_id, oid, type, entrance, _ref5$isPersonalFolde, isPersonalFolderToTeamBiz, teamInfo, identity, formData, headers, res, parameter, _yield$generateShortU, short_url;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    current_node = _ref5.current_node, node_id = _ref5.node_id, oid = _ref5.oid, type = _ref5.type, entrance = _ref5.entrance, _ref5$isPersonalFolde = _ref5.isPersonalFolderToTeamBiz, isPersonalFolderToTeamBiz = _ref5$isPersonalFolde === void 0 ? false : _ref5$isPersonalFolde, teamInfo = _ref5.teamInfo;
                    identity = teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.list.find(function(item) {
                        return item.oid === (oid !== null && oid !== void 0 ? oid : teamInfo.identity.oid);
                    });
                    formData = new FormData();
                    if (current_node) {
                        formData.set("current_node", current_node);
                    }
                    formData.set("node_id", node_id);
                    headers = {
                        "Content-Type": "application/x-www-form-urlencoded"
                    };
                    if (typeof oid !== "undefined") {
                        headers["client-ogroupid"] = oid;
                        headers["client-oid"] = oid;
                    }
                    _context3.next = 9;
                    return request.post("/yunpan/share/to_other", formData, {
                        headers: headers
                    });
                case 9:
                    res = _context3.sent;
                    // 用于生成短链的query参数
                    parameter = "share_key=".concat(res.share_key, "&").concat(type === "folder" ? "current_node_type" : "editorType", "=").concat(type, "&trackMeta=").concat(encodeURIComponent(JSON.stringify({
                        uid: (_identity$ouid = identity === null || identity === void 0 ? void 0 : identity.ouid) !== null && _identity$ouid !== void 0 ? _identity$ouid : "unknown",
                        oid: (_identity$oid = identity === null || identity === void 0 ? void 0 : identity.oid) !== null && _identity$oid !== void 0 ? _identity$oid : "unknown",
                        entrance: entrance
                    })));
                    if (type !== "folder") {
                        parameter += "&from=share&channel=share";
                    }
                    _context3.next = 14;
                    return generateShortUrl({
                        path: isPersonalFolderToTeamBiz || type !== "folder" ? "design/share" : "share",
                        parameter: parameter
                    });
                case 14:
                    _yield$generateShortU = _context3.sent;
                    short_url = _yield$generateShortU.short_url;
                    return _context3.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
                        shortUrl: short_url
                    }));
                case 17:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function createShareToOther(_x3) {
        return _ref6.apply(this, arguments);
    };
}()));
/** 获取分享详情 */ /** 获取分享详情及短链 */ function fetchShareInfo(_x4) {
    return _fetchShareInfo.apply(this, arguments);
}
/**
 * 协作者列表
 * @param
 * @returns
 */ function _fetchShareInfo() {
    _fetchShareInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee7(arg) {
        var _identity$ouid2, _identity$oid2;
        var res, _ref12, type, entrance, teamInfo, identity, parameter, _yield$generateShortU2, short_url;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while(1)switch(_context7.prev = _context7.next){
                case 0:
                    _context7.next = 2;
                    return request.get("/yunpan/share/get_share_other", {
                        params: {
                            id: arg.shareOtherId
                        }
                    });
                case 2:
                    res = _context7.sent;
                    if (!(Object.keys(arg).length === 1 && Object.keys(arg)[0] === "shareOtherId")) {
                        _context7.next = 5;
                        break;
                    }
                    return _context7.abrupt("return", res);
                case 5:
                    _ref12 = arg, type = _ref12.type, entrance = _ref12.entrance, teamInfo = _ref12.teamInfo;
                    identity = teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.list.find(function(item) {
                        return item.oid === teamInfo.identity.oid;
                    }); // 用于生成短链的query参数
                    parameter = "share_key=".concat(res.share_key).concat(type === "folder" ? "" : "&editorType=".concat(type), "&trackMeta=").concat(encodeURIComponent(JSON.stringify({
                        uid: (_identity$ouid2 = identity === null || identity === void 0 ? void 0 : identity.ouid) !== null && _identity$ouid2 !== void 0 ? _identity$ouid2 : "unknown",
                        oid: (_identity$oid2 = identity === null || identity === void 0 ? void 0 : identity.oid) !== null && _identity$oid2 !== void 0 ? _identity$oid2 : "unknown",
                        entrance: entrance
                    })));
                    if (type !== "folder") {
                        parameter += "&from=share&channel=share";
                    }
                    _context7.next = 11;
                    return generateShortUrl({
                        path: type === "folder" ? "share" : "design/share",
                        parameter: parameter
                    });
                case 11:
                    _yield$generateShortU2 = _context7.sent;
                    short_url = _yield$generateShortU2.short_url;
                    return _context7.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
                        shortUrl: short_url
                    }));
                case 14:
                case "end":
                    return _context7.stop();
            }
        }, _callee7);
    }));
    return _fetchShareInfo.apply(this, arguments);
}
var fetchCollaborator = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee4(currentNode, nodeId) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while(1)switch(_context4.prev = _context4.next){
                case 0:
                    _context4.next = 2;
                    return request.get("/yunpan/share/collaborator?current_node=".concat(currentNode, "&node_id=").concat(nodeId));
                case 2:
                    return _context4.abrupt("return", _context4.sent);
                case 3:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function fetchCollaborator(_x5, _x6) {
        return _ref7.apply(this, arguments);
    };
}()));
/**
 * 设置协作者权限
 * @param param
 * @returns
 */ var setCollaboratorPermission = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee5(_ref8) {
        var nodeId, currentNode, permissionMode, uid, askPermissionId, formData;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while(1)switch(_context5.prev = _context5.next){
                case 0:
                    nodeId = _ref8.nodeId, currentNode = _ref8.currentNode, permissionMode = _ref8.permissionMode, uid = _ref8.uid, askPermissionId = _ref8.askPermissionId;
                    formData = new FormData();
                    formData.set("node_id", "".concat(nodeId));
                    formData.set("current_node", currentNode);
                    formData.set("uid", "".concat(uid));
                    formData.set("permission_mode", "".concat(permissionMode));
                    if (askPermissionId) {
                        formData.set("ask_permission_id", "".concat(askPermissionId));
                    }
                    _context5.next = 9;
                    return request.post("/yunpan/share/set_collaborator_permission", formData, {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    });
                case 9:
                    return _context5.abrupt("return", _context5.sent);
                case 10:
                case "end":
                    return _context5.stop();
            }
        }, _callee5);
    }));
    return function setCollaboratorPermission(_x7) {
        return _ref9.apply(this, arguments);
    };
}()));
/**
 * 设置分享的权限
 * @param param
 * @returns
 */ var setSharePermission = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee6(_ref10) {
        var current_node, node_id, permissionMode, userType, oid, formData, headers;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while(1)switch(_context6.prev = _context6.next){
                case 0:
                    current_node = _ref10.current_node, node_id = _ref10.node_id, permissionMode = _ref10.permissionMode, userType = _ref10.userType, oid = _ref10.oid;
                    formData = new FormData();
                    formData.set("current_node", current_node);
                    formData.set("node_id", node_id);
                    formData.set("permission_mode", "".concat(permissionMode));
                    formData.set("user_type", userType || "");
                    headers = {
                        "Content-Type": "application/x-www-form-urlencoded"
                    };
                    if (typeof oid !== "undefined") {
                        headers["client-ogroupid"] = oid;
                        headers["client-oid"] = oid;
                    }
                    _context6.next = 10;
                    return request.post("/yunpan/share/set_permission", formData, {
                        headers: headers
                    });
                case 10:
                    return _context6.abrupt("return", _context6.sent);
                case 11:
                case "end":
                    return _context6.stop();
            }
        }, _callee6);
    }));
    return function setSharePermission(_x8) {
        return _ref11.apply(this, arguments);
    };
}()));
/** 个人版移除所有人，团队版移除团队之外的人 */ var removeAllCollaborator = function removeAllCollaborator(data) {
    var formData = new FormData();
    formData.set("current_node", data.current_node);
    formData.set("node_id", "".concat(data.node_id));
    return request.post("/yunpan/share/remove_all_collaborator", formData, {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
};

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/api/index.js




var _excluded = [
    "teamInfo",
    "entrance"
];




// 多次请求合并成一次
var fetchTeamIdentityListResolveList = [];
/**
 * https://api-mock.meitu-int.com/project/2110/interface/api/145971
 * [团队]可选身份列表
 */ var fetchTeamIdentityList = function fetchTeamIdentityList() {
    return new Promise(function(resolve, reject) {
        fetchTeamIdentityListResolveList.push(resolve);
        if (fetchTeamIdentityListResolveList.length === 1) {
            utils_request/* default.get */.ZP.get("/enterprise/identity_list", {
                hiddenMessage: true
            }).then(function(data) {
                // 处理个人设计师显示昵称
                data.list.forEach(function(item) {
                    if (!item.oid) {
                        item.alias = (0,i18n/* getLocaleStore */.IK)().$t(function(v) {
                            return v.Text_PersonalDesigner;
                        });
                    }
                });
                for(var i = 0; i < fetchTeamIdentityListResolveList.length; i++){
                    var element = fetchTeamIdentityListResolveList[i];
                    element(data);
                }
                fetchTeamIdentityListResolveList.length = 0;
            // console.log(
            //   'fetchTeamIdentityList',
            //   fetchTeamIdentityListResolveList.length,
            // );
            }).catch(function(e) {
                fetchTeamIdentityListResolveList.length = 0;
                reject(e);
            });
        }
    });
};
var fetchTeamMemberInfoResolveList = [];
/**
 * https://api-mock.meitu-int.com/project/2110/interface/api/149033
 * [团队]获取我的成员信息
 */ var fetchTeamMemberInfo = /*#__PURE__*/ function() {
    var _ref = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", new Promise(function(resolve) {
                        fetchTeamMemberInfoResolveList.push(resolve);
                        if (fetchTeamMemberInfoResolveList.length === 1) {
                            utils_request/* default.get */.ZP.get("/enterprise/team/member_info", {
                                hiddenMessage: true
                            }).then(function(res) {
                                for(var i = 0; i < fetchTeamMemberInfoResolveList.length; i++){
                                    var element = fetchTeamMemberInfoResolveList[i];
                                    element(res);
                                }
                                fetchTeamMemberInfoResolveList.length = 0;
                            });
                        }
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function fetchTeamMemberInfo() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 团队信息
 * @returns
 */ var fetchTeamAdminInfo = /*#__PURE__*/ function() {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee2() {
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return utils_request/* default.get */.ZP.get("/enterprise/team/info", {});
                case 2:
                    return _context2.abrupt("return", _context2.sent);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function fetchTeamAdminInfo() {
        return _ref2.apply(this, arguments);
    };
}();
/**
 * [团队]获取我成员列表
 */ var fetchTeamMemberList = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return request.get("/enterprise/team/member_list", {
                        hiddenMessage: true
                    });
                case 2:
                    return _context3.abrupt("return", _context3.sent);
                case 3:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function fetchTeamMemberList() {
        return _ref3.apply(this, arguments);
    };
}()));
/**
 * [团队]创建团队 https://api-mock.meitu-int.com/project/2110/interface/api/145974
 * @param data
 * @returns
 */ var createTeamApi = /*#__PURE__*/ function() {
    var _ref4 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee4(data) {
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee4$(_context4) {
            while(1)switch(_context4.prev = _context4.next){
                case 0:
                    _context4.next = 2;
                    return utils_request/* default.post */.ZP.post("/enterprise/team/create", query_string["default"].stringify(data), {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    });
                case 2:
                    return _context4.abrupt("return", _context4.sent);
                case 3:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function createTeamApi(_x) {
        return _ref4.apply(this, arguments);
    };
}();
/** 复制个人版指定文件到团队版个人空间下 https://api-mock.meitu-int.com/project/2110/interface/api/163078 */ var copyDirToMyTeamSpace = /*#__PURE__*/ function() {
    var _ref6 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee5(_ref5) {
        var current_node, node_id, oid;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee5$(_context5) {
            while(1)switch(_context5.prev = _context5.next){
                case 0:
                    current_node = _ref5.current_node, node_id = _ref5.node_id, oid = _ref5.oid;
                    _context5.next = 3;
                    return utils_request/* default.post */.ZP.post("/yunpan/node/copy_to_my_space", query_string["default"].stringify({
                        current_node: current_node,
                        id: node_id
                    }), {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            "client-ogroupid": oid,
                            "client-oid": oid
                        }
                    });
                case 3:
                    return _context5.abrupt("return", _context5.sent);
                case 4:
                case "end":
                    return _context5.stop();
            }
        }, _callee5);
    }));
    return function copyDirToMyTeamSpace(_x2) {
        return _ref6.apply(this, arguments);
    };
}();
/**
 * [团队]生成邀请码 https://api-mock.meitu-int.com/project/2110/interface/api/146100
 * @returns
 */ var generateInvite = /*#__PURE__*/ function() {
    var _ref8 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee6(_ref7) {
        var _identity$ouid, _identity$oid;
        var teamInfo, entrance, data, res, identity, parameter, _yield$generateShortU, short_url;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee6$(_context6) {
            while(1)switch(_context6.prev = _context6.next){
                case 0:
                    teamInfo = _ref7.teamInfo, entrance = _ref7.entrance, data = (0,objectWithoutProperties/* default */.Z)(_ref7, _excluded);
                    _context6.next = 3;
                    return utils_request/* default.post */.ZP.post("/enterprise/team/generate_inviate_key", query_string["default"].stringify(data), {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    });
                case 3:
                    res = _context6.sent;
                    identity = teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.list.find(function(item) {
                        return item.oid === teamInfo.identity.oid;
                    });
                    parameter = "inviteKey=".concat(res.invite_key, "&channel=member_invite&trackMeta=").concat(encodeURIComponent(JSON.stringify({
                        uid: (_identity$ouid = identity === null || identity === void 0 ? void 0 : identity.ouid) !== null && _identity$ouid !== void 0 ? _identity$ouid : "unknown",
                        oid: (_identity$oid = identity === null || identity === void 0 ? void 0 : identity.oid) !== null && _identity$oid !== void 0 ? _identity$oid : "unknown",
                        entrance: entrance
                    })));
                    _context6.next = 8;
                    return generateShortUrl({
                        path: "",
                        parameter: parameter
                    });
                case 8:
                    _yield$generateShortU = _context6.sent;
                    short_url = _yield$generateShortU.short_url;
                    return _context6.abrupt("return", (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, res), {}, {
                        shortUrl: short_url
                    }));
                case 11:
                case "end":
                    return _context6.stop();
            }
        }, _callee6);
    }));
    return function generateInvite(_x3) {
        return _ref8.apply(this, arguments);
    };
}();
/**
 * 接口 [上报下载资源↗](/common/sensitive_check)
 * https://api-mock.meitu-int.com/project/2110/interface/api/175621
 */ var handleDownloadRecord = /*#__PURE__*/ function() {
    var _ref9 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee7(data) {
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee7$(_context7) {
            while(1)switch(_context7.prev = _context7.next){
                case 0:
                    _context7.next = 2;
                    return utils_request/* default.post */.ZP.post("/zhanku/download_record", query_string["default"].stringify(data), {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    });
                case 2:
                    return _context7.abrupt("return", _context7.sent);
                case 3:
                case "end":
                    return _context7.stop();
            }
        }, _callee7);
    }));
    return function handleDownloadRecord(_x4) {
        return _ref9.apply(this, arguments);
    };
}();
/**
 * [团队]获取我的权限
 * https://api-mock.meitu-int.com/project/2110/interface/api/146159
 */ var fetchMemberPermission = function fetchMemberPermission() {
    return utils_request/* default.get */.ZP.get("/enterprise/team/member_permissions", {
        hiddenMessage: true
    });
};


/***/ }),

/***/ 59249:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": () => (/* binding */ openCreateTeamModal)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(56369);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73009);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69222);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var rc_util_lib_React_render__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81725);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(15328);
/* harmony import */ var _ComUI_commonModal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(49143);
/* harmony import */ var _ComUI_message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77977);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84480);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32907);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72838);
/* harmony import */ var _ComUI_button__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26985);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9350);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38915);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_3__);



var _excluded = [
    "onClose"
];












var CreateTeamModal = function CreateTeamModal(_ref) {
    var _ref$project = _ref.project, project = _ref$project === void 0 ? "" : _ref$project, noSwitchIdentity = _ref.noSwitchIdentity, create_team_success_entrance = _ref.create_team_success_entrance, onCreatedComplete = _ref.onCreatedComplete, onClose = _ref.onClose, onTrack = _ref.onTrack;
    var _useLocaleStore = (0,_i18n__WEBPACK_IMPORTED_MODULE_4__/* .useLocaleStore */ .Ee)(), $t = _useLocaleStore.$t, locale = _useLocaleStore.locale;
    var _useConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_5__/* .useConfig */ .ZR)(), userInfo = _useConfig.userInfo;
    var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_useState, 2), teamName = _useState2[0], setTeamName = _useState2[1];
    var isPending = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(false);
    var BannerImage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (locale === "en") {
            return "https://xiuxiu-pro-new.meitudata.com/poster/505252b96d40d03b33529c242b918bb0.png";
        }
        return "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/teamInfo/create-modal-banner.png";
    }, [
        locale
    ]);
    var maxTeamNameLength = 21;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var _inputRef$current;
        setTeamName("");
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!userInfo.screen_name) return;
        setTeamName($t(function(v, _ref2) {
            var r = _ref2.r;
            return r(v.Text_DefaultTeamName, [
                userInfo.screen_name
            ]);
        }));
    }, [
        userInfo.screen_name
    ]);
    ;
    var createHandle = function createHandle() {
        if (!teamName) {
            return _ComUI_message__WEBPACK_IMPORTED_MODULE_7__/* ["default"].error */ .Z.error($t(function(v) {
                return v.Message_FillTeamInfo;
            }));
        }
        if (teamName.length >= maxTeamNameLength) {
            return _ComUI_message__WEBPACK_IMPORTED_MODULE_7__/* ["default"].error */ .Z.error($t(function(v) {
                return v.Message_TeamNameMaxLength;
            }));
        }
        if (isPending.current) return;
        isPending.current = true;
        (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .createTeam */ .Cm)({
            teamName: teamName
        }).then(function(res) {
            onTrack === null || onTrack === void 0 || onTrack("create_team_success", {
                entrance: create_team_success_entrance !== null && create_team_success_entrance !== void 0 ? create_team_success_entrance : "create_team_1",
                project: project,
                team_name: teamName,
                newcreate_oid: res.oid,
                newcreate_uid: res.ouid
            });
            onCreatedComplete === null || onCreatedComplete === void 0 || onCreatedComplete({
                group_id: res.groupId,
                oid: res.oid,
                ouid: res.ouid,
                team_name: res.teamName
            });
            _ComUI_message__WEBPACK_IMPORTED_MODULE_7__/* ["default"].success */ .Z.success($t(function(v) {
                return v.Tips_CreateSuccess;
            }));
            // 会员弹窗关闭时回调函数
            onClose === null || onClose === void 0 || onClose();
            if (!noSwitchIdentity) {
                (0,___WEBPACK_IMPORTED_MODULE_9__/* .changeIdentity */ .vv)({
                    ouid: res.ouid,
                    oid: res.oid,
                    groupId: res.groupId
                });
            }
        }).finally(function() {
            isPending.current = false;
            ;
        });
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_ComUI_commonModal__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        open: true,
        destroyOnClose: true,
        className: "Widget teamSpaceCreateModal"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        className: "teamSpaceCreateModal-inner"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        className: "close",
        onClick: onClose
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        fontSize: 14,
        name: "CrossBlack",
        color: "var(--content-system-tertiary)"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        className: "teamSpaceCreateModal-banner"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("img", {
        src: BannerImage,
        alt: ""
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        className: "teamSpaceCreateModal-form"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        className: "teamSpaceCreateModal-formTitle"
    }, $t(function(v) {
        return v.Title_CreateTeam;
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        className: "teamSpaceCreateModal-formLabel"
    }, $t(function(v) {
        return v.Label_TeamName;
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("teamSpaceCreateModal-input", {
            warn: teamName.length >= maxTeamNameLength
        })
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("input", {
        value: teamName,
        ref: inputRef,
        placeholder: $t(function(v) {
            return v.Placeholder_TeamName;
        }),
        type: "text",
        maxLength: maxTeamNameLength,
        onChange: function onChange(e) {
            setTeamName(e.target.value);
        }
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_ComUI_button__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        type: "primary",
        style: {
            marginTop: 32,
            height: 48,
            fontSize: 16
        },
        onClick: function onClick() {
            createHandle();
        }
    }, $t(function(v) {
        return v.Button_FreeCreate;
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("p", {
        className: "teamSpaceCreateModal-renameTip"
    }, $t(function(v) {
        return v.Tip_TeamNameEditable;
    })))));
};
CreateTeamModal.displayName = "CreateTeamModal";
var el = null;
CreateTeamModal.open = function(_ref3) {
    var _onClose = _ref3.onClose, restProps = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_ref3, _excluded);
    if (!el) {
        el = document.createElement("div");
    }
    document.body.appendChild(el);
    (0,rc_util_lib_React_render__WEBPACK_IMPORTED_MODULE_1__/* .render */ .sY)(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(CreateTeamModal, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, restProps, {
        onClose: function onClose() {
            if (el && el.parentNode) {
                (0,rc_util_lib_React_render__WEBPACK_IMPORTED_MODULE_1__/* .unmount */ .vE)(el);
                el.parentNode.removeChild(el);
                el = null;
            }
            _onClose === null || _onClose === void 0 || _onClose();
        }
    })), el);
};
var openCreateTeamModal = CreateTeamModal.open;


/***/ }),

/***/ 36204:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c7": () => (/* binding */ HIDE_EXPIRED_MODAL),
  "e1": () => (/* binding */ SHOW_EXPIRED_MODAL),
  "ZP": () => (/* binding */ teamInfo_expiredModal)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(81549);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(69222);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/saas-subscription-popup/dist/esm/types/enum.js
/**
 * 环境变量枚举
 */
var enum_EnvEnum = /*#__PURE__*/function (EnvEnum) {
  EnvEnum["LOCAL"] = "local";
  EnvEnum["PRE"] = "pre";
  EnvEnum["BETA"] = "beta";
  EnvEnum["RELEASE"] = "release";
  return EnvEnum;
}({});
/**
 * 主题色
 */
var ThemeEnum = /*#__PURE__*/function (ThemeEnum) {
  ThemeEnum["DARK"] = "dark";
  ThemeEnum["LIGHT"] = "light";
  return ThemeEnum;
}({});
/**
 * 事件名称枚举
 */
var enum_EventNameEnum = /*#__PURE__*/function (EventNameEnum) {
  EventNameEnum["SUCCESS"] = "success";
  EventNameEnum["FAIL"] = "fail";
  EventNameEnum["LOGININVALID"] = "login-invalid";
  EventNameEnum["CLOSE"] = "close";
  return EventNameEnum;
}({});
var enum_CloseFromEnum = /*#__PURE__*/function (CloseFromEnum) {
  CloseFromEnum["PAYSUCCESS"] = "pay-success";
  CloseFromEnum["UNLOGIN"] = "unLogin";
  CloseFromEnum["CLOSE"] = "close";
  return CloseFromEnum;
}({});
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/saas-subscription-popup/dist/esm/constants/index.js
/** H5 底部弹层断点（与窄屏自动适配一致） */
var H5_POPUP_MAX_WIDTH = 768;

/**
 * 订阅弹窗样式
 */
var constants_dialogCss = "\n  .saas-subscription-popup {\n    background-color: rgba(21, 20, 23, 0.75);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    z-index: 9999;\n  }\n\n  .saas-subscription-popup__inner {\n    width: 931px;\n    height: 588px;\n    border-radius: 12px;\n    background-color: #000;\n    position: relative;\n    overflow: hidden;\n  }\n\n  .saas-subscription-popup.dark .saas-subscription-popup__inner {\n    background-color: #000;\n  }\n\n  .saas-subscription-popup__inner iframe {\n    border-radius: 12px;\n    display: block;\n  }\n\n  .saas-subscription-popup__close {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    position: absolute;\n    right: 8px;\n    top: 8px;\n    transition: all 0.5s ease;\n    z-index: 1;\n  }\n\n  .saas-subscription-popup__close:hover {\n    transform: rotate(180deg);\n  }\n\n  /* PC \u77EE\u5C4F\uFF1A\u53EF\u6EDA\u52A8\u5C45\u4E2D\uFF08\u975E H5\uFF09 */\n  @media screen and (min-width: 769px) and (max-height: 620px) {\n    .saas-subscription-popup:not(.saas-subscription-popup--h5) {\n      display: block;\n      overflow: auto;\n      /* \u706B\u72D0\u7279\u5B9A\u6EDA\u52A8\u6761\u6837\u5F0F */\n      scrollbar-width: none;\n    }\n\n    .saas-subscription-popup:not(.saas-subscription-popup--h5)::-webkit-scrollbar {\n      display: none;\n    }\n\n    .saas-subscription-popup:not(.saas-subscription-popup--h5) .saas-subscription-popup__inner {\n      margin: 30px auto 0;\n    }\n  }\n\n  /* H5\uFF1A\u5E95\u90E8 Sheet\uFF0C\u4ECE\u4E0B\u5F80\u4E0A\u6ED1\u5165\uFF08\u7A84\u5C4F CSS \u6216\u79FB\u52A8\u7AEF UA \u6253\u6807\uFF09 */\n  @media screen and (max-width: ".concat(H5_POPUP_MAX_WIDTH, "px) {\n    .saas-subscription-popup {\n      align-items: flex-end;\n      justify-content: stretch;\n      opacity: 0;\n      transition: opacity 0.28s ease;\n    }\n\n    .saas-subscription-popup--open {\n      opacity: 1;\n    }\n\n    .saas-subscription-popup__inner {\n      width: 100% !important;\n      height: 550px !important;\n      max-height: 90vh !important;\n      margin: 0;\n      border-radius: 16px 16px 0 0;\n      padding-bottom: env(safe-area-inset-bottom, 0);\n      transform: translate3d(0, 100%, 0);\n      transition: transform 0.28s ease;\n    }\n\n    .saas-subscription-popup--open .saas-subscription-popup__inner {\n      transform: translate3d(0, 0, 0);\n    }\n\n    .saas-subscription-popup__inner iframe {\n      border-radius: 16px 16px 0 0;\n    }\n\n    .saas-subscription-popup__close {\n      display: block;\n      right: 8px;\n      top: 8px;\n      width: 18px;\n      height: 18px;\n      z-index: 2;\n    }\n  }\n\n  .saas-subscription-popup--h5 {\n    align-items: flex-end;\n    justify-content: stretch;\n    opacity: 0;\n    transition: opacity 0.28s ease;\n  }\n\n  .saas-subscription-popup--h5.saas-subscription-popup--open {\n    opacity: 1;\n  }\n\n  .saas-subscription-popup--h5 .saas-subscription-popup__inner {\n    width: 100% !important;\n    height: 550px !important;\n    max-height: 90vh !important;\n    margin: 0;\n    border-radius: 16px 16px 0 0;\n    padding-bottom: env(safe-area-inset-bottom, 0);\n    transform: translate3d(0, 100%, 0);\n    transition: transform 0.28s ease;\n  }\n\n  .saas-subscription-popup--h5.saas-subscription-popup--open .saas-subscription-popup__inner {\n    transform: translate3d(0, 0, 0);\n  }\n\n  .saas-subscription-popup--h5 .saas-subscription-popup__inner iframe {\n    border-radius: 16px 16px 0 0;\n  }\n\n  .saas-subscription-popup--h5 .saas-subscription-popup__close {\n    display: block;\n    right: 8px;\n    top: 8px;\n    width: 18px;\n    height: 18px;\n    z-index: 2;\n  }\n");

/**
 * 权益对比弹窗样式
 */
var popupCss = "\n  .vip-compare-modal {\n    background-color: var(--background-system-overlay-mask, rgba(0, 0, 0, 0.5));\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1000000001;\n  }\n\n  .vip-compare-modal * {\n    box-sizing: border-box;\n  }\n\n  .vip-compare-modal__inner {\n    width: 630px;\n    max-width: 100vw;\n    height: 565px;\n    max-height: 100vh;\n    padding: 16px 16px 20px;\n    border-radius: 12px;\n    background: var(--background-system-frame-floatpanel, #FFF);\n    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.08), 0px 24px 128px 0px rgba(0, 0, 0, 0.16);\n    display: flex;\n    flex-direction: column;\n  }\n\n  .vip-compare-modal__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .vip-compare-modal__title {\n    color: var(--content-system-primary, #1C1D1F);\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 22px;\n  }\n\n  .vip-compare-modal__close {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    transition: all 0.5s ease;\n  }\n\n  .vip-compare-modal__close:hover {\n    transform: rotate(180deg);\n  }\n\n  .vip-compare-modal__body {\n    flex: 1;\n    margin-top: 16px;\n    padding-right: 2px;\n    overflow-y: auto;\n  }\n\n  .vip-compare-modal__body-inner {\n    color: var(--content-web-primary, #17181A);\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    border-radius: 4px;\n    border: 1px solid var(--stroke-system-border-overlay, rgba(0, 0, 0, 0.08));\n    position: relative;\n  }\n\n  .vip-compare-modal__body::-webkit-scrollbar {\n    display: block;\n    -webkit-appearance: none;\n  }\n\n  .vip-compare-modal__body::-webkit-scrollbar:vertical {\n    width: 4px;\n  }\n\n  .vip-compare-modal__body::-webkit-scrollbar-thumb {\n    border-radius: 8px;\n    border: 4px solid rgba(0, 0, 0, 0.2);\n    background-color: rgba(0, 0, 0, 0.2);\n  }\n\n  .vip-compare-modal__body-header {\n    position: sticky;\n    top: 0;\n    background: var(--background-system-frame-floatpanel, #FFF);\n  }\n\n  .vip-compare-modal__thead {\n    height: 40px;\n    background: var(--background-system-selected, #E5F2FF);\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid var(--stroke-system-border-overlay, rgba(0, 0, 0, 0.08));\n  }\n\n  .vip-compare-modal__trow {\n    height: 40px;\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid var(--stroke-system-border-overlay, rgba(0, 0, 0, 0.08));\n  }\n\n  .vip-compare-modal__cell {\n    width: 145px;\n    padding: 10px;\n    text-align: center;\n  }\n\n  .vip-compare-modal__cell:nth-child(1) {\n    width: auto;\n    flex: 1;\n    text-align: left;\n  }\n\n  .vip-compare-modal__tbody .vip-compare-modal__trow:last-child {\n    border-bottom: none;\n  }\n\n  .vip-compare-modal__trow-title {\n    background: var(--background-web-secondary, rgba(0, 30, 89, 0.04));\n  }\n";

/**
 * 阻断弹窗样式
 */
var constants_retentionCss = "\n  .vip-retention-modal {\n    background-color: var(--background-system-overlay-mask, rgba(0, 0, 0, 0.5));\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1000000001;\n  }\n\n  .vip-retention-modal * {\n    box-sizing: border-box;\n  }\n\n  .vip-retention-modal__inner {\n    width: 300px;\n    height: 400px;\n    max-width: 100vw;\n    max-height: 100vh;\n    position: relative;\n  }\n\n  .vip-retention-modal__inner img {\n    width: 100%;\n  }\n\n  .vip-retention-modal__close {\n    width: 25px;\n    height: 25px;\n    cursor: pointer;\n    position: absolute;\n    right: 22px;\n    top: 22px;\n  }\n\n  .vip-retention-modal__btn {\n    width: 170px;\n    height: 45px;\n    cursor: pointer;\n    position: absolute;\n    left: 50%;\n    bottom: 33px;\n    transform: translateX(-50%);\n  }\n";

// 弹窗阻断次数缓存
var constants_SAAS_SUBSCRIPTION_POPUP_RETENTION_NUMBER = "saas-subscription-popup-retention-number";
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/saas-subscription-popup/dist/esm/utils/index.js

/**
 * 版本权益对比弹窗
 */
var utils_openVipComparePopup = function openVipComparePopup() {
  var dataSource = {
    内容服务: [["免费模版/PPT", true, true, true], ["免费字体", true, true, true], ["免费素材", true, true, true], ["付费模版/PPT", false, true, true], ["付费字体", false, true, true], ["付费素材", false, true, true], ["商用授权", false, "个人商用", "企业商用(1个主体)"]],
    创作工具: [["拼图", true, true, true], ["AI消除", false, true, true], ["AI尺寸延展", "限时免费", true, true], ["服装去皱", false, true, true], ["无损放大", false, true, true], ["变清晰", false, true, true]],
    多人协同: [["文件共享", true, true, true], ["文件夹共享", false, false, true], ["共享权限管理", false, false, true], ["品牌规范", false, false, true], ["模版库(PSD上传)", false, false, true]],
    团队管理: [["角色管理", false, false, true], ["数据看板", false, false, true], ["订单管理", false, false, true]],
    消耗品: [
    // ["智能抠图", false, "1200张/年", "100张*席位数/月"],
    ["会员美豆", false, "330个/月", "330个*席位数/月"]]
  };
  console.log(Object.keys(dataSource));
  var ele = document.createElement("div");
  ele.className = "vip-compare-modal";
  var strDom = "\n      <div class=\"vip-compare-modal__inner\">\n          <div class=\"vip-compare-modal__header\">\n              <span class=\"vip-compare-modal__title\">\u7248\u672C\u6743\u76CA\u8BF4\u660E</span>\n              <img class=\"vip-compare-modal__close\" src=\"https://public.static.meitudata.com/xiuxiu-pc/saas-subscription/close-icon.png\" alt=\"\">\n          </div>\n          <div class=\"vip-compare-modal__body\">\n            <div class=\"vip-compare-modal__body-inner\">\n              <div class=\"vip-compare-modal__body-header\">\n                  <div class=\"vip-compare-modal__thead\">\n                      <div class=\"vip-compare-modal__cell\">\u7248\u672C</div>\n                      <div class=\"vip-compare-modal__cell\">\u514D\u8D39\u7248</div>\n                      <div class=\"vip-compare-modal__cell\">\u4E2A\u4EBA\u7248VIP</div>\n                      <div class=\"vip-compare-modal__cell\">\u56E2\u961F\u7248VIP</div>\n                  </div>\n                  <div class=\"vip-compare-modal__trow\">\n                      <div class=\"vip-compare-modal__cell\">\u4EF7\u683C</div>\n                      <div class=\"vip-compare-modal__cell\">\xA50/\u5E74</div>\n                      <div class=\"vip-compare-modal__cell\">\xA5288/\u5E74</div>\n                      <div class=\"vip-compare-modal__cell\">\xA5318/\u5E74/\u4EBA</div>\n                  </div>\n                  <div class=\"vip-compare-modal__trow\">\n                      <div class=\"vip-compare-modal__cell\">\u9002\u7528\u4EBA\u6570</div>\n                      <div class=\"vip-compare-modal__cell\">1\u4EBA</div>\n                      <div class=\"vip-compare-modal__cell\">1\u4EBA</div>\n                      <div class=\"vip-compare-modal__cell\">\u591A\u4EBA</div>\n                  </div>\n              </div>\n              <div class=\"vip-compare-modal__tbody\">\n                  ";
  Object.keys(dataSource).forEach(function (key) {
    strDom += "\n          <div class=\"vip-compare-modal__trow\">\n              <div class=\"vip-compare-modal__cell vip-compare-modal__trow-title\">".concat(key, "</div>\n          </div>\n      ");
    dataSource[key].forEach(function (item) {
      strDom += "\n              <div class=\"vip-compare-modal__trow\">\n                  ";
      item.forEach(function (data) {
        if (typeof data === "string") {
          strDom += "\n                      <div class=\"vip-compare-modal__cell\">".concat(data, "</div>\n                  ");
        } else if (!!data) {
          strDom += "\n                      <div class=\"vip-compare-modal__cell\">\n                          <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\">\n                              <path d=\"M11.4018 2.21587C11.6968 2.50668 11.7001 2.98154 11.4093 3.2765L5.12216 9.6515C4.97783 9.79789 4.77975 9.87861 4.57421 9.87481C4.36868 9.87101 4.17372 9.78301 4.03491 9.63139L0.572068 5.86055C0.292363 5.55504 0.313286 5.08063 0.6188 4.80092C0.924313 4.52122 1.39873 4.54214 1.67843 4.84766L4.60823 8.03626L10.3412 2.22338C10.632 1.92842 11.1069 1.92506 11.4018 2.21587Z\" fill=\"#3388FF\"/>\n                          </svg>    \n                      </div>\n                  ";
        } else {
          strDom += "\n                      <div class=\"vip-compare-modal__cell\"></div>\n                  ";
        }
      });
      strDom += "\n              </div>\n          ";
    });
  });
  strDom += "\n              </div>\n          </div>\n        </div>\n      </div>\n    ";
  ele.innerHTML = strDom;
  document.body.appendChild(ele);

  // 创建样式
  var eleStyle = document.createElement("style");
  eleStyle.innerHTML = popupCss;
  document.head.appendChild(eleStyle);
  var eleClose = document.querySelector(".vip-compare-modal__close");
  if (eleClose) {
    eleClose.onclick = function () {
      document.body.removeChild(ele);
      document.head.removeChild(eleStyle);
    };
  }
};
// EXTERNAL MODULE: ./node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js
var bodyScrollLock_esm = __webpack_require__(58509);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/saas-subscription-popup/dist/esm/lib/index.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





/**
 * SDK 内部开发调试专用的 env 值（不对外暴露）
 * 命中时 iframe 会指向本地起的 /vip 页面，仅供 playground / SDK 开发人员使用
 * 业务侧不应使用也不在公开类型 `EnvType` / `EnvEnum` 中导出
 */
var DEBUG_ENV = "debug";
/** 窄屏或移动端 UA 视为 H5，弹窗走底部 Sheet */
var MOBILE_UA_RE = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i;
var isH5Viewport = function isH5Viewport() {
  if (typeof window === "undefined") return false;
  return MOBILE_UA_RE.test(window.navigator.userAgent || "");
};
var H5_SHEET_ANIMATION_MS = 280;
var lib_SaasSubscription = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function SaasSubscription(_params) {
    var _this = this;
    _classCallCheck(this, SaasSubscription);
    _defineProperty(this, "env", void 0);
    _defineProperty(this, "theme", void 0);
    _defineProperty(this, "commonParams", void 0);
    _defineProperty(this, "eventHandlers", {});
    _defineProperty(this, "shouldRetention", false);
    _defineProperty(this, "onTrack", void 0);
    _defineProperty(this, "messageData", void 0);
    /**
     * 弹窗元素
     */
    _defineProperty(this, "ele", null);
    /**
     * 弹窗元素
     */
    _defineProperty(this, "eleIframe", null);
    /**
     * 权益对比弹窗元素
     */
    _defineProperty(this, "elePopup", null);
    /**
     * 关闭按钮元素
     */
    _defineProperty(this, "eleClose", null);
    /**
     * H5 离场动画定时器，避免关闭过程中再次 open 被误删
     */
    _defineProperty(this, "closeAnimTimer", null);
    _defineProperty(this, "messageHandler", function (e) {
      var data = e.data || e.originalEvent && e.originalEvent.data;
      if (typeof data === "string" && /^[\[\{]/.test(data)) {
        data = JSON.parse(data);
      }

      // 关闭订阅弹窗通知
      if (data && data.action === "closeVipSubscribeDialog") {
        // 未登录
        if (data.data && data.data.needLogin) {
          var handler = _this.eventHandlers[EventNameEnum.LOGININVALID];
          if (handler) {
            handler();
          }
          _this.close(false, CloseFromEnum.UNLOGIN);
          return;
        }

        // 支付成功
        if (data.data && data.data.success) {
          var _handler = _this.eventHandlers[EventNameEnum.SUCCESS];
          if (_handler) {
            _handler();
          }
          _this.close(false, CloseFromEnum.PAYSUCCESS);
          return;
        }
        _this.close(false, CloseFromEnum.CLOSE);
      } else if (data && data.action === "changeCloseVipSubscribeDialogCloseIcon") {
        // 显示/隐藏弹窗关闭按钮
        if (data.data) {
          if (_this.eleClose) {
            var _data$data;
            _this.eleClose.style.visibility = (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.status ? "visible" : "hidden";
          }
        }
      } else if (data && data.action === "openVipComparePopup") {
        // 打开版本权益说明弹窗
        openVipComparePopup();
      } else if (data && data.action === "exchangeSuccess") {
        // 兑换成功，通知业务更新用户信息接口
        var _handler2 = _this.eventHandlers[EventNameEnum.SUCCESS];
        if (_handler2) {
          _handler2();
        }
      }
    });
    _defineProperty(this, "postMessageData", function () {
      var _this$eleIframe;
      if (_this.messageData && (_this$eleIframe = _this.eleIframe) !== null && _this$eleIframe !== void 0 && _this$eleIframe.contentWindow) {
        var targetOrigin = _this.getLatestUrl({}).replace(/\/vip?.+/, "");
        _this.eleIframe.contentWindow.postMessage(JSON.stringify({
          action: "setMessageData",
          data: _this.messageData
        }), targetOrigin);
      }
    });
    /**
     * 获取最新的订阅访问URL
     * @param customParams 自定义参数
     * @returns
     */
    _defineProperty(this, "getLatestUrl", function (customParams) {
      var params = Object.assign({}, _this.commonParams, customParams);
      var excludeKeys = ["task_id", "transferData", "trackData"];
      var queryString = Object.keys(params).filter(function (key) {
        return !excludeKeys.includes(key);
      }).reduce(function (str, key) {
        return str + "".concat(key, "=").concat(encodeURIComponent(params[key] || ""), "&");
      }, "");
      var preHost = "";
      if (
      // /\.meitu\.com/.test(window.location.host) ||
      /localhost/.test(window.location.host)) {
        // .meitu.com 域名，都统一走pc.meitu.com域名
        switch (_this.env) {
          case EnvEnum.PRE:
          case EnvEnum.LOCAL:
            preHost = "https://pre.designkit.cn";
            break;
          case EnvEnum.BETA:
            preHost = "https://beta.designkit.cn";
            break;
          case EnvEnum.RELEASE:
            preHost = "https://www.designkit.cn";
            break;
          default:
        }
      } else {
        // 非.meitu.com 域名，都统一走当前域名
        preHost = "".concat(window.location.protocol, "//").concat(window.location.host);
      }

      // 本地开发
      if (_this.env === EnvEnum.LOCAL) {
        preHost = "https://pre.designkit.cn";
      }

      // SDK 内部开发调试：iframe 指向本地 /vip 服务（不对外暴露）
      // 使用 window.location.origin 保证与 playground 同源，具体 /vip 开发服务地址由 Vite proxy 转发
      if (_this.env === DEBUG_ENV) {
        preHost = window.location.origin;
      }
      return "".concat(preHost, "/vip?theme=").concat(_this.theme, "&").concat(queryString);
    });
    /**
     * 更新弹窗大小
     */
    _defineProperty(this, "updateDialogSize", function (isOnlyShowScanUIPopup) {
      if (!_this.ele) return;
      var eleInner = _this.ele.querySelector(".saas-subscription-popup__inner");
      if (!eleInner) return;

      // H5 尺寸由 CSS 控制，不写死 PC 宽高
      if (isH5Viewport()) {
        eleInner.style.width = "";
        eleInner.style.height = "";
        return;
      }
      if (isOnlyShowScanUIPopup) {
        eleInner.style.width = "400px";
        eleInner.style.height = "430px";
      } else {
        // 恢复默认大小（通过移除内联样式，使用CSS默认值）
        eleInner.style.width = "";
        eleInner.style.height = "";
      }
    });
    /**
     * 创建弹窗容器
     */
    _defineProperty(this, "createDialog", function (isOnlyShowScanUIPopup) {
      // 创建容器
      var eleDialog = document.createElement("div");
      eleDialog.className = ["saas-subscription-popup", _this.theme, isH5Viewport() ? "saas-subscription-popup--h5" : ""].filter(Boolean).join(" ");
      var eleInner = document.createElement("div");
      eleInner.className = "saas-subscription-popup__inner";
      if (isOnlyShowScanUIPopup && !isH5Viewport()) {
        eleInner.style.width = "400px";
        eleInner.style.height = "430px";
      }

      // 创建关闭安按钮
      var eleClose = document.createElement("img");
      eleClose.className = "saas-subscription-popup__close";
      eleClose.src = "https://public.static.meitudata.com/x-design/subscription/close.png";
      eleClose.onclick = function () {
        var _window;
        // 重置为业务的uid
        // window.mtstat埋点login的uid值
        // 解决个人版打开团队版订阅弹窗场景，导致埋点的uid不对问题
        var uid = window.localStorage.getItem("uid");
        if (uid) (_window = window) === null || _window === void 0 || (_window = _window.mtstat) === null || _window === void 0 || _window.login(uid);
        _this.close();
      };

      // H5：点击蒙层关闭（点到面板本身不关）
      eleDialog.onclick = function (e) {
        if (!isH5Viewport()) return;
        if (e.target === eleDialog) {
          _this.close();
        }
      };

      // 创建iframe
      var iframe = document.createElement("iframe");
      iframe.style.width = "100%";
      iframe.style.height = "100%";
      iframe.style.border = "none";
      iframe.src = _this.getLatestUrl({});
      eleInner.appendChild(iframe);
      eleInner.appendChild(eleClose);
      eleDialog.appendChild(eleInner);

      // 创建样式
      var eleStyle = document.createElement("style");
      eleStyle.innerHTML = dialogCss;
      document.head.appendChild(eleStyle);
      _this.ele = eleDialog;
      _this.eleClose = eleClose;
      _this.eleIframe = iframe;
    });
    /**
     *
     * 阻断弹窗
     */
    _defineProperty(this, "createRetentionDialog", function () {
      var _this$onTrack3;
      var ele = document.createElement("div");
      ele.className = "vip-retention-modal";
      var strDom = "\n        <div class=\"vip-retention-modal__inner\">\n            <img src=\"https://public.static.meitudata.com/xiuxiu-pc/saas-subscription/retention-bg.png\" alt=\"\">\n            <div class=\"vip-retention-modal__close\"></div>\n            <div class=\"vip-retention-modal__btn\"></div>    \n        </div>\n        ";
      ele.innerHTML = strDom;
      document.body.appendChild(ele);

      // 创建样式
      var eleStyle = document.createElement("style");
      eleStyle.innerHTML = retentionCss;
      document.head.appendChild(eleStyle);
      var eleClose = document.querySelector(".vip-retention-modal__close");
      var eleBtn = document.querySelector(".vip-retention-modal__btn");
      if (eleClose) {
        eleClose.onclick = function () {
          var _this$onTrack;
          // 关闭阻断弹窗
          document.body.removeChild(ele);
          // 关闭订阅弹窗
          _this.close(false);
          (_this$onTrack = _this.onTrack) === null || _this$onTrack === void 0 || _this$onTrack.call(_this, "operations_popup_click", {
            func: "retention_popup",
            class: "close"
          });
        };
      }
      if (eleBtn) {
        eleBtn.onclick = function () {
          var _this$eleIframe2, _this$onTrack2;
          // 重置阻拦状态
          _this.shouldRetention = false;
          // 关闭阻断弹窗
          document.body.removeChild(ele);
          // 通知订阅弹窗展示会员购买场景
          (_this$eleIframe2 = _this.eleIframe) === null || _this$eleIframe2 === void 0 || (_this$eleIframe2 = _this$eleIframe2.contentWindow) === null || _this$eleIframe2 === void 0 || _this$eleIframe2.postMessage(JSON.stringify({
            action: "viewSubscription" // 查看购买会员商品组
          }), _this.getLatestUrl({}).replace(/\/vip?.+/, ""));
          (_this$onTrack2 = _this.onTrack) === null || _this$onTrack2 === void 0 || _this$onTrack2.call(_this, "operations_popup_click", {
            func: "retention_popup",
            class: "to_see"
          });
        };
      }
      (_this$onTrack3 = _this.onTrack) === null || _this$onTrack3 === void 0 || _this$onTrack3.call(_this, "operations_popup_show", {
        func: "retention_popup"
      });
    });
    this.env = _params.env || "release";
    this.theme = _params.theme || "light";
    this.commonParams = _params.commonParams || {};
    this.messageData = {
      transfer_data: _params.transferData || {},
      track_data: _params.trackData || {}
    };
  }

  /**
   * 监听事件
   *
   * @param eventName 事件名
   * @param handler 回调函数
   * @returns
   */
  _createClass(SaasSubscription, [{
    key: "on",
    value: function on(eventName, handler) {
      this.eventHandlers[eventName] = handler;
      return this;
    }

    /**
     * 打开弹窗
     * @param customParams 自定义参数
     * @returns
     */
  }, {
    key: "open",
    value: function open(customParams, otherParams) {
      var _this2 = this;
      this.shouldRetention = !!(otherParams !== null && otherParams !== void 0 && otherParams.shouldRetention);
      this.onTrack = otherParams === null || otherParams === void 0 ? void 0 : otherParams.onTrack;
      this.messageData = _objectSpread(_objectSpread({}, this.messageData), {}, {
        task_id: (customParams === null || customParams === void 0 ? void 0 : customParams.task_id) || "",
        transfer_data: _objectSpread(_objectSpread({}, this.messageData.transfer_data), customParams === null || customParams === void 0 ? void 0 : customParams.transferData),
        track_data: _objectSpread(_objectSpread({}, this.messageData.track_data), customParams === null || customParams === void 0 ? void 0 : customParams.trackData)
      });
      if (!this.ele) {
        this.createDialog(!!(customParams !== null && customParams !== void 0 && customParams.isOnlyShowScanUI));
      } else {
        // 弹窗已存在时，更新弹窗大小
        this.updateDialogSize(!!(customParams !== null && customParams !== void 0 && customParams.isOnlyShowScanUI));
      }
      if (this.eleIframe) {
        this.eleIframe.src = this.getLatestUrl(customParams);
        this.eleIframe.onload = function () {
          _this2.postMessageData();
        };
      }
      if (this.ele) {
        if (this.closeAnimTimer != null) {
          clearTimeout(this.closeAnimTimer);
          this.closeAnimTimer = null;
        }
        this.ele.classList.toggle("saas-subscription-popup--h5", isH5Viewport());
        document.body.appendChild(this.ele);
        disableBodyScroll(this.ele, {
          reserveScrollBarGap: true
        });
        // 下一帧再加 open，触发 H5 底部滑入动画
        requestAnimationFrame(function () {
          var _this2$ele;
          (_this2$ele = _this2.ele) === null || _this2$ele === void 0 || _this2$ele.classList.add("saas-subscription-popup--open");
        });
      }
      window.addEventListener("message", this.messageHandler, false);
      return this;
    }

    /**
     * 关闭弹窗
     * @returns
     */
  }, {
    key: "close",
    value: function close() {
      var _this3 = this;
      var shouldCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CloseFromEnum.CLOSE;
      var curDate = "".concat(new Date().getFullYear(), "-").concat(new Date().getMonth() + 1, "-").concat(new Date().getDate());
      var local = JSON.parse(window.localStorage.getItem(SAAS_SUBSCRIPTION_POPUP_RETENTION_NUMBER) || "{}");
      var localNum = local.date === curDate ? +(local.value || "0") : 0;
      if (shouldCheck && this.shouldRetention && localNum < 3) {
        window.localStorage.setItem(SAAS_SUBSCRIPTION_POPUP_RETENTION_NUMBER, JSON.stringify({
          date: curDate,
          value: localNum + 1
        }));
        this.createRetentionDialog();
        return;
      }
      var handler = this.eventHandlers[EventNameEnum.CLOSE];
      if (handler) {
        handler(from);
      }
      if (this.ele) {
        enableBodyScroll(this.ele);
        var ele = this.ele;
        var removeDialog = function removeDialog() {
          _this3.closeAnimTimer = null;
          if (ele.parentNode) {
            document.body.removeChild(ele);
          }
          ele.classList.remove("saas-subscription-popup--open");
        };
        if (this.closeAnimTimer != null) {
          clearTimeout(this.closeAnimTimer);
          this.closeAnimTimer = null;
        }

        // H5：先播离场动画再卸 DOM
        if (isH5Viewport() && ele.classList.contains("saas-subscription-popup--open")) {
          ele.classList.remove("saas-subscription-popup--open");
          this.closeAnimTimer = setTimeout(removeDialog, H5_SHEET_ANIMATION_MS);
        } else {
          removeDialog();
        }
      }
      if (typeof window.removeEventListener !== "undefined") {
        window.removeEventListener("message", this.messageHandler, false);
      }
      return this;
    }

    /**
     * 动态设置更新公共参数
     * @param params
     * @returns
     */
  }, {
    key: "setCommonParams",
    value: function setCommonParams(params) {
      if (params) {
        this.commonParams = Object.assign({}, this.commonParams, params);
      }
    }

    /**
     * 动态设置更新主题色
     * @param val
     * @returns
     */
  }, {
    key: "setTheme",
    value: function setTheme(val) {
      if (val) {
        this.theme = val;
        if (this.ele) this.ele.className = ["saas-subscription-popup", this.theme, isH5Viewport() ? "saas-subscription-popup--h5" : "", this.ele.classList.contains("saas-subscription-popup--open") ? "saas-subscription-popup--open" : ""].filter(Boolean).join(" ");
      }
    }
  }]);
  return SaasSubscription;
}()));
/* harmony default export */ const lib = ((/* unused pure expression or super */ null && (lib_SaasSubscription)));
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/saas-subscription-popup/dist/esm/index.js





/* harmony default export */ const esm = ((/* unused pure expression or super */ null && (SaasSubscription)));
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-icon-font/dist/IconFont.js + 2 modules
var IconFont = __webpack_require__(15328);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-identity/lib/index.js
var xdesign_identity_lib = __webpack_require__(99861);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/commonModal/index.js
var commonModal = __webpack_require__(49143);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/configProvider/index.js
var configProvider = __webpack_require__(84480);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/i18n/index.js + 12 modules
var i18n = __webpack_require__(32907);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/types/teamInfo.js
var teamInfo = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/eventBus.js
var eventBus = __webpack_require__(82001);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/uidKit.js
var uidKit = __webpack_require__(53421);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/index.js
var dist_teamInfo = __webpack_require__(72838);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/expiredModal/index.less
var expiredModal = __webpack_require__(76811);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/expiredModal/index.js















var vipConfig = [
    {
        iconName: "VipBold",
        textKey: "Text_EnjoySvipRights"
    },
    {
        iconName: "UserGroupBold",
        textKey: "Text_TeamPermissionMgmt"
    },
    {
        iconName: "FolderBold",
        textKey: "Text_MemberFolderCollab"
    }
];
var SHOW_EXPIRED_MODAL = "xdesign-widget-show-expired-modal";
var HIDE_EXPIRED_MODAL = "xdesign-widget-hide-expired-modal";
/**
 * 团队过期提示
 */ var ExpiredModal = function ExpiredModal(props) {
    var _useLocaleStore = (0,i18n/* useLocaleStore */.Ee)(), $t = _useLocaleStore.$t;
    var identityList = props.identityList;
    var showData = (0,react.useRef)({
        entrance: ""
    });
    var _useState = (0,react.useState)(false), _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
    var _useConfig = (0,configProvider/* useConfig */.ZR)(), isIntl = _useConfig.isIntl, theme = _useConfig.theme;
    var curTeamIdentity = (0,dist_teamInfo/* useCurrentTeamIdentity */.q5)();
    // https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/teamInfo/expired-modal-dark.png
    // https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/teamInfo/expired-modal-light.png
    // https://x-design-static-release.stariicloud.com/xdesign-widgets/expired-modal-light.png
    var domain = isIntl ? "https://x-design-static-release.stariicloud.com/xdesign-widgets/" : "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/teamInfo/";
    function getStatArgs() {
        return {
            popup_type: "expire",
            entrance: showData.current.entrance
        };
    }
    function popupClickTrack(className) {
        var _showData$current$onT, _showData$current;
        (_showData$current$onT = (_showData$current = showData.current).onTrack) === null || _showData$current$onT === void 0 || _showData$current$onT.call(_showData$current, "popup_click", (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, getStatArgs()), {}, {
            class: className
        }));
    }
    (0,react.useEffect)(function() {
        var onShowHandle = function onShowHandle(args) {
            if (args) {
                showData.current = args;
            }
            setOpen(true);
        };
        var onHideHandle = function onHideHandle() {
            setOpen(false);
        };
        eventBus/* default.addListener */.Z.addListener(SHOW_EXPIRED_MODAL, onShowHandle);
        eventBus/* default.addListener */.Z.addListener(HIDE_EXPIRED_MODAL, onHideHandle);
        return function() {
            eventBus/* default.removeListener */.Z.removeListener(SHOW_EXPIRED_MODAL, onShowHandle);
            eventBus/* default.removeListener */.Z.removeListener(HIDE_EXPIRED_MODAL, onHideHandle);
        };
    }, []);
    // 关闭
    var closeHandle = function closeHandle() {
        var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "cancel";
        setOpen(false);
        popupClickTrack(className);
    };
    // 确定
    var okHandle = function okHandle() {
        var _showData$current$onO, _showData$current2;
        setOpen(false);
        (_showData$current$onO = (_showData$current2 = showData.current).onOK) === null || _showData$current$onO === void 0 || _showData$current$onO.call(_showData$current2, "expire_popup");
        popupClickTrack("renew_now");
    };
    (0,react.useEffect)(function() {
        if (open) {
            var _showData$current$onT2, _showData$current3;
            ;
            (_showData$current$onT2 = (_showData$current3 = showData.current).onTrack) === null || _showData$current$onT2 === void 0 || _showData$current$onT2.call(_showData$current3, "popup_show", getStatArgs());
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ react.createElement(commonModal/* default */.Z, {
        destroyOnClose: true,
        open: open,
        zIndex: 1000000001 // 这么大是因为业务引导弹窗库的层级是1000000000
        ,
        className: "Widget-teamSpaceExpiredModal"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "Widget teamSpaceExpiredModal"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "close",
        onClick: function onClick() {
            var _showData$current$onC, _showData$current4;
            closeHandle();
            (_showData$current$onC = (_showData$current4 = showData.current).onClose) === null || _showData$current$onC === void 0 || _showData$current$onC.call(_showData$current4, showData.current.entrance);
        }
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        fontSize: 14,
        name: "CrossBlack",
        color: "var(--content-system-tertiary)"
    })), /*#__PURE__*/ react.createElement("div", {
        className: "tip"
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        fontSize: 54,
        name: "InfoCircleFill",
        color: "var(--content-system-info-icon-regular,#8cc0ff)"
    })), /*#__PURE__*/ react.createElement("div", {
        className: "title"
    }, $t(function(v) {
        return v.Text_TeamExpired;
    })), /*#__PURE__*/ react.createElement("div", {
        className: "description"
    }, $t(function(v) {
        return v.Text_RenewToUse;
    })), /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()("card", "card-".concat(theme)),
        style: {
            backgroundImage: "url(".concat("".concat(domain, "expired-bg-").concat(theme, ".png"), ")")
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: "header"
    }, $t(function(v) {
        return v.Text_VipTeamRights;
    }), /*#__PURE__*/ react.createElement("span", {
        onClick: function onClick() {
            utils_openVipComparePopup();
        // closeHandle('view');
        }
    }, $t(function(v) {
        return v.Text_ViewDetailRights;
    }), /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        fontSize: 12,
        name: "ChevronRightBold",
        color: "#35395D"
    }))), /*#__PURE__*/ react.createElement("div", {
        className: "body"
    }, vipConfig.map(function(item, key) {
        return /*#__PURE__*/ react.createElement("div", {
            className: "item",
            key: key
        }, /*#__PURE__*/ react.createElement("div", {
            className: "text"
        }, $t(function(v) {
            return v[item.textKey];
        })));
    }))), (0,dist_teamInfo/* getEnterpriseID */.DG)() ? null : /*#__PURE__*/ react.createElement("div", {
        className: "btns"
    }, /*#__PURE__*/ react.createElement("div", {
        className: (curTeamIdentity === null || curTeamIdentity === void 0 ? void 0 : curTeamIdentity.type) === teamInfo/* IdentityType.ENTERPRISE */.Mf.ENTERPRISE ? "ok" : "cancel",
        onClick: function onClick() {
            var info = identityList === null || identityList === void 0 ? void 0 : identityList.find(function(item) {
                return item.oid === 0;
            });
            if (info) {
                (0,uidKit/* setLocalUid */.Tc)(info.ouid);
            }
            // 标识一定要前置
            (0,dist_teamInfo/* changeIsSwitchIdentityInitiativeState */._U)(true);
            closeHandle();
            (0,xdesign_identity_lib/* setLocalIdentity */.kF)(0, 0);
        },
        style: {
            width: (curTeamIdentity === null || curTeamIdentity === void 0 ? void 0 : curTeamIdentity.type) === teamInfo/* IdentityType.ENTERPRISE */.Mf.ENTERPRISE ? "100%" : ""
        }
    }, $t(function(v) {
        return v.Button_SwitchPersonal;
    })), (curTeamIdentity === null || curTeamIdentity === void 0 ? void 0 : curTeamIdentity.type) === teamInfo/* IdentityType.ENTERPRISE */.Mf.ENTERPRISE ? null : /*#__PURE__*/ react.createElement("div", {
        className: "ok",
        onClick: okHandle
    }, $t(function(v) {
        return v.Button_RenewNow;
    })))));
};
/* harmony default export */ const teamInfo_expiredModal = (/*#__PURE__*/react.memo(ExpiredModal));


/***/ }),

/***/ 99606:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "hP": () => (/* binding */ SHOW_FREEZE_MODAL),
/* harmony export */   "sW": () => (/* binding */ HIDE_FREEZE_MODAL)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81549);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69222);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15328);
/* harmony import */ var _ComUI_commonModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49143);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32907);
/* harmony import */ var _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82001);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81852);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_1__);








var SHOW_FREEZE_MODAL = "xdesign-widget-show-freeze-modal";
var HIDE_FREEZE_MODAL = "xdesign-widget-hide-freeze-modal";
/**
 * 个人冻结
 */ var FreezeModal = function FreezeModal() {
    var _useLocaleStore = (0,_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useLocaleStore */ .Ee)(), $t = _useLocaleStore.$t;
    var showData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        entrance: ""
    });
    var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
    function getStatArgs() {
        return {
            popup_type: "freeze",
            entrance: showData.current.entrance
        };
    }
    function popupClickTrack(className) {
        var _showData$current$onT, _showData$current;
        (_showData$current$onT = (_showData$current = showData.current).onTrack) === null || _showData$current$onT === void 0 || _showData$current$onT.call(_showData$current, "popup_click", (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, getStatArgs()), {}, {
            class: className
        }));
    }
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var onShowHandle = function onShowHandle(args) {
            if (args) {
                showData.current = args;
            }
            setOpen(true);
        };
        var onHideHandle = function onHideHandle() {
            setOpen(false);
        };
        _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__/* ["default"].addListener */ .Z.addListener(SHOW_FREEZE_MODAL, onShowHandle);
        _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__/* ["default"].addListener */ .Z.addListener(HIDE_FREEZE_MODAL, onHideHandle);
        return function() {
            _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__/* ["default"].removeListener */ .Z.removeListener(SHOW_FREEZE_MODAL, onShowHandle);
            _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__/* ["default"].removeListener */ .Z.removeListener(HIDE_FREEZE_MODAL, onHideHandle);
        };
    }, []);
    // 关闭
    var closeHandle = function closeHandle() {
        var _showData$current$onC, _showData$current2;
        setOpen(false);
        popupClickTrack("cancel");
        (_showData$current$onC = (_showData$current2 = showData.current).onClose) === null || _showData$current$onC === void 0 || _showData$current$onC.call(_showData$current2, showData.current.entrance);
    };
    // 确定
    var okHandle = function okHandle() {
        var _showData$current$onO, _showData$current3;
        setOpen(false);
        popupClickTrack("cancel");
        (_showData$current$onO = (_showData$current3 = showData.current).onOK) === null || _showData$current$onO === void 0 || _showData$current$onO.call(_showData$current3, showData.current.entrance);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (open) {
            var _showData$current$onT2, _showData$current4;
            (_showData$current$onT2 = (_showData$current4 = showData.current).onTrack) === null || _showData$current$onT2 === void 0 || _showData$current$onT2.call(_showData$current4, "popup_show", getStatArgs());
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ComUI_commonModal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        destroyOnClose: true,
        open: open,
        zIndex: 1000000001 // 这么大是因为业务引导弹窗库的层级是1000000000
        ,
        className: "Widget-teamSpaceFreezeModal"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "Widget teamSpaceFreezeModal"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "close",
        onClick: closeHandle
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        fontSize: 14,
        name: "CrossBlack",
        color: "var(--content-system-tertiary, rgba(147, 149, 153, 100%))"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "tip"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        fontSize: 54,
        name: "InfoCircleFill",
        color: "var(--content-system-info-icon-regular, rgba(140, 192, 255, 100%))"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "title"
    }, $t(function(v) {
        return v.Text_Frozen;
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "description"
    }, $t(function(v) {
        return v.Text_MemberOverLimit;
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", null), $t(function(v) {
        return v.Text_ContactOwner;
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "btns"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "ok",
        onClick: okHandle
    }, $t(function(v) {
        return v.Modal_Button_Known;
    })))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(FreezeModal));


/***/ }),

/***/ 96853:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": () => (/* binding */ getTeamTagType)
/* harmony export */ });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var _teamTag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97505);


/** 获取团队标签 */ function getTeamTagType(oid, type) {
    if (oid === 0) return _teamTag__WEBPACK_IMPORTED_MODULE_0__/* .TeamTagType.personal */ .n.personal;
    if (type === _types__WEBPACK_IMPORTED_MODULE_1__/* .IdentityType.TEAM */ .Mf.TEAM) return _teamTag__WEBPACK_IMPORTED_MODULE_0__/* .TeamTagType.team */ .n.team;
    if (type === _types__WEBPACK_IMPORTED_MODULE_1__/* .IdentityType.ENTERPRISE */ .Mf.ENTERPRISE) return _teamTag__WEBPACK_IMPORTED_MODULE_0__/* .TeamTagType.enterprise */ .n.enterprise;
    return _teamTag__WEBPACK_IMPORTED_MODULE_0__/* .TeamTagType.free */ .n.free;
}


/***/ }),

/***/ 72838:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$v": () => (/* binding */ getIsSwitchIdentityInitiative),
/* harmony export */   "DG": () => (/* binding */ getEnterpriseID),
/* harmony export */   "Gl": () => (/* binding */ openTeamFreezePopup),
/* harmony export */   "I3": () => (/* binding */ closeTeamFreezePopup),
/* harmony export */   "Iu": () => (/* binding */ getTeamInfo),
/* harmony export */   "O$": () => (/* binding */ checkTeamHadBuyVip),
/* harmony export */   "P3": () => (/* binding */ enterpriseInit),
/* harmony export */   "Qn": () => (/* binding */ closeTeamExpiredPopup),
/* harmony export */   "SN": () => (/* binding */ findTeamIdentity),
/* harmony export */   "Uy": () => (/* binding */ CHANGE_TEAM_OID),
/* harmony export */   "VF": () => (/* binding */ getCurrentTeamIdentity),
/* harmony export */   "VT": () => (/* binding */ closeIdentitySwitchPopup),
/* harmony export */   "Yr": () => (/* binding */ useHasFetchTeamInfoState),
/* harmony export */   "Yt": () => (/* binding */ checkTeamIsEnterprise),
/* harmony export */   "_U": () => (/* binding */ changeIsSwitchIdentityInitiativeState),
/* harmony export */   "b6": () => (/* binding */ isFromZhanKu),
/* harmony export */   "bl": () => (/* binding */ clearTeamInfo),
/* harmony export */   "fM": () => (/* binding */ useTeamInfoState),
/* harmony export */   "gS": () => (/* binding */ checkUserHasSeat),
/* harmony export */   "gm": () => (/* binding */ getIdentityChangeListenerStatus),
/* harmony export */   "hU": () => (/* binding */ checkIsTeam),
/* harmony export */   "hf": () => (/* binding */ checkTeamMemberState),
/* harmony export */   "kA": () => (/* binding */ openTeamExpiredPopup),
/* harmony export */   "lz": () => (/* binding */ openIdentitySwitchPopupAfterLogin),
/* harmony export */   "mP": () => (/* binding */ checkMemberIsResigned),
/* harmony export */   "mR": () => (/* binding */ fetchTeamInfo),
/* harmony export */   "od": () => (/* binding */ openIdentitySwitchPopup),
/* harmony export */   "q5": () => (/* binding */ useCurrentTeamIdentity),
/* harmony export */   "rM": () => (/* binding */ checkTeamStatusIsFree),
/* harmony export */   "sr": () => (/* binding */ enableIdentityChangeListener),
/* harmony export */   "t2": () => (/* binding */ disableIdentityChangeListener),
/* harmony export */   "vn": () => (/* binding */ checkUserSeatIsFreeze),
/* harmony export */   "vv": () => (/* binding */ changeIdentity),
/* harmony export */   "zb": () => (/* binding */ checkTeamStatusIsVip)
/* harmony export */ });
/* unused harmony export __unsafeSetTeamInfoForDemo */
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69222);
/* harmony import */ var _babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89255);
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81549);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87406);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99861);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(84480);
/* harmony import */ var _utils_uidKit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53421);
/* harmony import */ var _types_teamInfo__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(8029);
/* harmony import */ var _utils_browserKit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6857);
/* harmony import */ var _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(82001);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59901);
/* harmony import */ var _expiredModal__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36204);
/* harmony import */ var _freezeModal__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(99606);
/* harmony import */ var _loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(29898);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9350);

















var teamInfoData = null;
// 标识是否该项目是否用户主动切换身份动作
var isSwitchIdentityInitiative = false;
/** 标识是否该项目是否用户主动切换身份动作 */ var getIsSwitchIdentityInitiative = function getIsSwitchIdentityInitiative() {
    return isSwitchIdentityInitiative;
};
// 用来控制业务是否开启身份变化监听回掉
var identityChangeListenerStatus = false;
/** 用来控制业务是否开启身份变化监听回掉 */ var getIdentityChangeListenerStatus = function getIdentityChangeListenerStatus() {
    return identityChangeListenerStatus;
};
var hasFetchTeamInfo = false;
// 刷新是否获取团队信息状态事件
var REFRESH_FETCH_TEAM_INFO_STATUS = "xdesign-widget-refresh-fetch-team-info-status";
// 刷新团队信息事件
var REFRESH_TEAM_INFO = "xdesign-widget-refresh-team-info";
// 团队身份变更事件
var CHANGE_TEAM_OID = "xdesign-widget-change-team-oid";
// 开启身份变化监听
var enableIdentityChangeListener = function enableIdentityChangeListener() {
    identityChangeListenerStatus = true;
};
// 关闭身份变化监听
var disableIdentityChangeListener = function disableIdentityChangeListener() {
    identityChangeListenerStatus = false;
};
var changeIsSwitchIdentityInitiativeState = function changeIsSwitchIdentityInitiativeState(val) {
    isSwitchIdentityInitiative = val;
};
// 定制企业sso授权相关逻辑初始化
var enterpriseInit = _utils__WEBPACK_IMPORTED_MODULE_3__/* .init */ .S1;
// 获取enterprise企业标识
var getEnterpriseID = function getEnterpriseID() {
    var enterpriseID = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get((0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEnterpriseIDKey */ .bo)()) || "";
    return enterpriseID;
};
// 是否来自站酷的团队
var isFromZhanKu = function isFromZhanKu() {
    var _getLocalIdentity;
    return !!((_getLocalIdentity = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)()) !== null && _getLocalIdentity !== void 0 && _getLocalIdentity.oid) && getEnterpriseID() === "zhanku";
};
/** 刷新团队信息 */ var fetchTeamInfo = /*#__PURE__*/ function() {
    var _ref = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().mark(function _callee() {
        var local, changeIdentity, _local3, userIdentity, identity, identityPersonal, teamMember, _local4;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    local = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)();
                    changeIdentity = false;
                    if (!local) {
                        (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .setLocalIdentity */ .kF)(0, 0, false);
                        local = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)();
                        changeIdentity = true;
                    }
                    ;
                    _context.prev = 4;
                    _context.next = 7;
                    return (0,_api__WEBPACK_IMPORTED_MODULE_6__/* .fetchTeamIdentityList */ .hc)();
                case 7:
                    userIdentity = _context.sent;
                    identity = userIdentity.list.find(function(v) {
                        var _local;
                        return v.oid === ((_local = local) === null || _local === void 0 ? void 0 : _local.oid) && !!v.groups.find(function(k) {
                            var _local2;
                            return k.id === ((_local2 = local) === null || _local2 === void 0 ? void 0 : _local2.groupId);
                        });
                    }); // 个人身份数据
                    identityPersonal = userIdentity.list.find(function(v) {
                        return v.oid === 0;
                    });
                    if (!((_local3 = local) !== null && _local3 !== void 0 && _local3.oid)) {
                        _context.next = 14;
                        break;
                    }
                    _context.next = 13;
                    return (0,_api__WEBPACK_IMPORTED_MODULE_6__/* .fetchTeamMemberInfo */ .Ay)();
                case 13:
                    teamMember = _context.sent;
                case 14:
                    // 离职身份需要停留在当前页面, 不做身份切换
                    if (!identity) {
                        identityPersonal && (0,_utils_uidKit__WEBPACK_IMPORTED_MODULE_7__/* .setLocalUid */ .Tc)(identityPersonal.ouid);
                        (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .setLocalIdentity */ .kF)(0, 0);
                        local = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)();
                        changeIdentity = true;
                    }
                    teamInfoData = {
                        identity: (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, local), userIdentity),
                        member: teamMember
                    };
                    _context.next = 28;
                    break;
                case 18:
                    _context.prev = 18;
                    _context.t0 = _context["catch"](4);
                    ;
                    // 页面跳转时, safari会中断请求, 并抛出异常, 这里不能将身份进行切换
                    if (!(0,_utils_browserKit__WEBPACK_IMPORTED_MODULE_9__/* .checkIsBeforeUnload */ .OF)()) {
                        _context.next = 23;
                        break;
                    }
                    return _context.abrupt("return");
                case 23:
                    teamInfoData = null;
                    ;
                    // 如果团队身份列表接口挂了，当前身份角色非本人的话，需要移除本地uid
                    ((_local4 = local) === null || _local4 === void 0 ? void 0 : _local4.oid) && (0,_utils_uidKit__WEBPACK_IMPORTED_MODULE_7__/* .removeLocalUid */ .Yz)();
                    (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .setMemoryIdentity */ .LW)(0, 0);
                    (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .setLocalIdentity */ .kF)(0, 0, false);
                case 28:
                    _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].emit */ .Z.emit(REFRESH_TEAM_INFO, teamInfoData);
                    _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].emit */ .Z.emit(REFRESH_FETCH_TEAM_INFO_STATUS);
                    hasFetchTeamInfo = true;
                    if (changeIdentity && teamInfoData && teamInfoData.identity.list.length >= 2) {
                        _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].emit */ .Z.emit(CHANGE_TEAM_OID);
                    }
                case 32:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                4,
                18
            ]
        ]);
    }));
    return function fetchTeamInfo() {
        return _ref.apply(this, arguments);
    };
}();
/** 获取团队信息 */ var getTeamInfo = function getTeamInfo() {
    return teamInfoData;
};
/**
 * 仅供仓库内部 demo / 测试使用，直接注入团队信息状态，避免依赖真实接口返回。
 */ var __unsafeSetTeamInfoForDemo = function __unsafeSetTeamInfoForDemo(data) {
    teamInfoData = data;
    hasFetchTeamInfo = true;
    if (data) {
        setLocalIdentity(data.identity.oid, data.identity.groupId, false);
        var currentIdentity = data.identity.list.find(function(item) {
            var _item$groups$;
            return item.oid === data.identity.oid && ((_item$groups$ = item.groups[0]) === null || _item$groups$ === void 0 ? void 0 : _item$groups$.id) === data.identity.groupId;
        });
        if (typeof (currentIdentity === null || currentIdentity === void 0 ? void 0 : currentIdentity.ouid) === "number") {
            setLocalUid(currentIdentity.ouid);
        }
    }
    eventBus.emit(REFRESH_TEAM_INFO, teamInfoData);
    eventBus.emit(REFRESH_FETCH_TEAM_INFO_STATUS);
};
/** 获取团队信息hook */ var useTeamInfoState = function useTeamInfoState() {
    var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(teamInfoData), _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_useState, 2), data = _useState2[0], setData = _useState2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var refreshHandle = function refreshHandle(e) {
            setData(e);
        };
        _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].addListener */ .Z.addListener(REFRESH_TEAM_INFO, refreshHandle);
        return function() {
            _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].removeListener */ .Z.removeListener(REFRESH_TEAM_INFO, refreshHandle);
        };
    }, []);
    return data;
};
// 是否请求过团队信息接口标识
var useHasFetchTeamInfoState = function useHasFetchTeamInfoState() {
    var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(hasFetchTeamInfo), _useState4 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_useState3, 2), status = _useState4[0], setStatus = _useState4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleFn = function handleFn() {
            setStatus(true);
            hasFetchTeamInfo = true;
        };
        _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].addListener */ .Z.addListener(REFRESH_FETCH_TEAM_INFO_STATUS, handleFn);
        return function() {
            _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].removeListener */ .Z.removeListener(REFRESH_FETCH_TEAM_INFO_STATUS, handleFn);
        };
    }, []);
    return status;
};
/** 查找指定的团队身份 */ function findTeamIdentity(oid, groupId, teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo) return null;
    return usedTeamInfo.identity.list.find(function(v) {
        return v.oid === oid && v.groups[0].id === groupId;
    });
}
/** 获取当前团队的身份信息 */ function useCurrentTeamIdentity() {
    var teamInfo = useTeamInfoState();
    if (!teamInfo) return null;
    return findTeamIdentity(teamInfo.identity.oid, teamInfo.identity.groupId);
}
/** 获取当前团队的身份信息 */ function getCurrentTeamIdentity(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo) return null;
    return findTeamIdentity(usedTeamInfo.identity.oid, usedTeamInfo.identity.groupId);
}
/** 打开团队过期弹窗 */ var openTeamExpiredPopup = function openTeamExpiredPopup(args) {
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].emit */ .Z.emit(_expiredModal__WEBPACK_IMPORTED_MODULE_12__/* .SHOW_EXPIRED_MODAL */ .e1, args);
};
/** 关闭团队过期弹窗 */ var closeTeamExpiredPopup = function closeTeamExpiredPopup() {
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].emit */ .Z.emit(_expiredModal__WEBPACK_IMPORTED_MODULE_12__/* .HIDE_EXPIRED_MODAL */ .c7);
};
/** 打开团队冻结弹窗 */ var openTeamFreezePopup = function openTeamFreezePopup(args) {
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].emit */ .Z.emit(_freezeModal__WEBPACK_IMPORTED_MODULE_13__/* .SHOW_FREEZE_MODAL */ .hP, args);
};
/** 关闭团队冻结弹窗 */ var closeTeamFreezePopup = function closeTeamFreezePopup() {
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].emit */ .Z.emit(_freezeModal__WEBPACK_IMPORTED_MODULE_13__/* .HIDE_FREEZE_MODAL */ .sW);
};
/** 打开身份切换弹窗 */ var openIdentitySwitchPopup = function openIdentitySwitchPopup(opts) {
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].emit */ .Z.emit(_loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_14__/* .SHOW_IDENTITY_SWITCH_MODAL */ .Mg, opts !== null && opts !== void 0 ? opts : {});
};
/** 关闭身份切换弹窗 */ var closeIdentitySwitchPopup = function closeIdentitySwitchPopup() {
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].emit */ .Z.emit(_loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_14__/* .HIDDEN_IDENTITY_SWITCH_MODAL */ .BM);
};
/** 检测当前成员是否已离职 */ var checkMemberIsResigned = function checkMemberIsResigned(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo || !usedTeamInfo.member) return null;
    return usedTeamInfo.member.job_status === 2;
};
/** 检测个人是否冻结 */ function checkUserSeatIsFreeze(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo || !usedTeamInfo.member) return null;
    return !checkMemberIsResigned(usedTeamInfo) && usedTeamInfo.member.seat_status === _types_teamInfo__WEBPACK_IMPORTED_MODULE_15__/* .TeamSeatStatus.Freeze */ .cc.Freeze;
}
/** 检测个人是否有席位 */ function checkUserHasSeat(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo || !usedTeamInfo.member) return null;
    return usedTeamInfo.member.has_seat && usedTeamInfo.member.seat_status === _types_teamInfo__WEBPACK_IMPORTED_MODULE_15__/* .TeamSeatStatus.Effect */ .cc.Effect;
}
var checkIsTeam = function checkIsTeam(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    return !!(usedTeamInfo !== null && usedTeamInfo !== void 0 && usedTeamInfo.identity.oid);
};
var checkTeamIsEnterprise = function checkTeamIsEnterprise(teamInfo) {
    var _getLocalIdentity2;
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo) return false;
    var oid = (_getLocalIdentity2 = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)()) === null || _getLocalIdentity2 === void 0 ? void 0 : _getLocalIdentity2.oid;
    if (!oid) return false;
    var identity = usedTeamInfo.identity.list.find(function(item) {
        return item.oid === oid;
    });
    return (identity === null || identity === void 0 ? void 0 : identity.type) === _types_teamInfo__WEBPACK_IMPORTED_MODULE_15__/* .IdentityType.ENTERPRISE */ .Mf.ENTERPRISE;
};
/** 检测团队状态是否为vip */ function checkTeamStatusIsVip(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo || !usedTeamInfo.member) return null;
    return usedTeamInfo.member.team.is_vip;
}
var checkTeamStatusIsFree = function checkTeamStatusIsFree(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    return checkIsTeam(usedTeamInfo) && !checkTeamStatusIsVip(usedTeamInfo) && !checkTeamIsEnterprise(usedTeamInfo);
};
var checkTeamHadBuyVip = function checkTeamHadBuyVip(teamInfo) {
    var _usedTeamInfo$member;
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    return checkIsTeam(usedTeamInfo) && !!(usedTeamInfo !== null && usedTeamInfo !== void 0 && (_usedTeamInfo$member = usedTeamInfo.member) !== null && _usedTeamInfo$member !== void 0 && _usedTeamInfo$member.team.had_buy);
};
/** 清空团队数据 */ function clearTeamInfo() {
    closeTeamExpiredPopup();
    closeTeamFreezePopup();
    teamInfoData = null;
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_10__/* ["default"].emit */ .Z.emit(REFRESH_TEAM_INFO, null);
    (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .removeLocalIdentity */ .mK)();
}
/** 切换个人/团队身份 */ var changeIdentity = function changeIdentity(identity) {
    var _teamInfo$identity$oi, _teamInfo$identity$gr;
    var teamInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getTeamInfo();
    var currentOid = (_teamInfo$identity$oi = teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.oid) !== null && _teamInfo$identity$oi !== void 0 ? _teamInfo$identity$oi : 0;
    var currentGroupId = (_teamInfo$identity$gr = teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.groupId) !== null && _teamInfo$identity$gr !== void 0 ? _teamInfo$identity$gr : 0;
    if (currentOid !== identity.oid || currentGroupId !== identity.groupId) {
        // 标识一定要前置
        changeIsSwitchIdentityInitiativeState(true);
    }
    (0,_utils_uidKit__WEBPACK_IMPORTED_MODULE_7__/* .setLocalUid */ .Tc)(identity.ouid);
    // 切换身份同步cookie
    (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .setLocalIdentity */ .kF)(identity.oid, identity.groupId);
};
/**
 * 登录后打开身份切换弹窗的相关逻辑
 * @param originUid 大账号登录后返回的uid
 * @param accessToken 大账号登录后返回的token
 * @returns
 */ var openIdentitySwitchPopupAfterLogin = /*#__PURE__*/ function() {
    var _ref2 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().mark(function _callee2(originUid, accessToken) {
        var _teamInfoData;
        var _getConfig, isIntl, isTeam, info, teamIdentity;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    _getConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_16__/* .getConfig */ .iE)(), isIntl = _getConfig.isIntl, isTeam = _getConfig.isTeam;
                    ;
                    // 海外或者非团队版不走以下逻辑
                    if (!(isIntl || !isTeam)) {
                        _context2.next = 4;
                        break;
                    }
                    return _context2.abrupt("return", true);
                case 4:
                    if (accessToken) window.localStorage.setItem("access_token", accessToken);
                    // 1、如果本地缓存团队身份对应的原始ID(origin_id)与当前登录账号的ID一致，则自动切换成缓存的身份且刷新页面；
                    // 2、如果本地无缓存团队身份，则唤起身份切换弹窗：
                    //    2.1、如果无团队，则自动走个人身份，无需唤起身份切换弹窗；
                    //    2.2、如果有团队，则唤起身份切换弹窗。
                    // 更新cookie中的origin_uid
                    (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .setLocalOriginUid */ .Nz)(originUid);
                    // 获取缓存中的最近身份信息
                    info = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalRecentIdentity */ .pB)();
                    if (!(info && info.originUid === originUid)) {
                        _context2.next = 13;
                        break;
                    }
                    // 最近登录的团队身份和当前账号匹配，直接切成最近登录的身份
                    changeIdentity({
                        oid: info.oid,
                        groupId: info.groupId,
                        ouid: info.ouid || 0
                    });
                    if (!info.oid) {
                        _context2.next = 12;
                        break;
                    }
                    window.location.reload();
                    return _context2.abrupt("return", false);
                case 12:
                    return _context2.abrupt("return", true);
                case 13:
                    (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .removeLocalRecentIdentity */ .tK)();
                    // 拉取团队数据接口
                    _context2.next = 16;
                    return fetchTeamInfo();
                case 16:
                    // 团队身份数据
                    teamIdentity = ((_teamInfoData = teamInfoData) === null || _teamInfoData === void 0 || (_teamInfoData = _teamInfoData.identity.list) === null || _teamInfoData === void 0 ? void 0 : _teamInfoData.filter(function(v) {
                        return v.oid;
                    })) || [];
                    if (teamIdentity.length) {
                        _context2.next = 19;
                        break;
                    }
                    return _context2.abrupt("return", true);
                case 19:
                    return _context2.abrupt("return", new Promise(function(resolve) {
                        openIdentitySwitchPopup({
                            showCloseBtn: false,
                            hideCreateBtn: true,
                            hideSelectedStatus: true,
                            onSwitchComplete: function onSwitchComplete(_ref3) {
                                var oid = _ref3.oid;
                                if (oid) {
                                    // 选择的是团队身份，则刷新页面
                                    window.location.reload();
                                    resolve(false);
                                } else {
                                    // 选择的是个人身份，则继续走业务
                                    resolve(true);
                                }
                            }
                        });
                    }));
                case 20:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function openIdentitySwitchPopupAfterLogin(_x, _x2) {
        return _ref2.apply(this, arguments);
    };
}();
var checkTeamMemberState = function checkTeamMemberState(_teamInfo) {
    var _teamInfo$identity$li, _teamInfo$identity$li2, _teamInfo$member$team, _teamInfo$member;
    var teamInfo = _teamInfo !== null && _teamInfo !== void 0 ? _teamInfo : getTeamInfo();
    var userCount = (_teamInfo$identity$li = teamInfo === null || teamInfo === void 0 || (_teamInfo$identity$li2 = teamInfo.identity.list.find(function(item) {
        var _getLocalIdentity3;
        return item.oid === ((_getLocalIdentity3 = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)()) === null || _getLocalIdentity3 === void 0 ? void 0 : _getLocalIdentity3.oid);
    })) === null || _teamInfo$identity$li2 === void 0 ? void 0 : _teamInfo$identity$li2.member_num) !== null && _teamInfo$identity$li !== void 0 ? _teamInfo$identity$li : 0;
    /** 可操作席位数 (当前成员数+剩余可邀请席位数) */ var operableNum = (_teamInfo$member$team = teamInfo === null || teamInfo === void 0 || (_teamInfo$member = teamInfo.member) === null || _teamInfo$member === void 0 ? void 0 : _teamInfo$member.team.member_detail.operable_num) !== null && _teamInfo$member$team !== void 0 ? _teamInfo$member$team : 0;
    return {
        isExcess: userCount > operableNum,
        hasSeat: userCount < operableNum
    };
};


/***/ }),

/***/ 84183:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15328);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84480);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32907);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71755);
/* harmony import */ var _userInfo_constants_inedx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72508);
/* harmony import */ var _identitySwitch_shared__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96853);
/* harmony import */ var _teamLogo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32943);
/* harmony import */ var _teamTag__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97505);
/* harmony import */ var _identityRow_less__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30464);
/* harmony import */ var _identityRow_less__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_identityRow_less__WEBPACK_IMPORTED_MODULE_2__);











// eslint-disable-next-line @typescript-eslint/no-unused-vars
var IdentityRow_CheckBox = function IdentityRow_CheckBox(_ref) {
    var isSelected = _ref.isSelected;
    return /*#__PURE__*/ React.createElement("div", {
        className: "IdentityRow_CheckBox",
        "data-active": isSelected
    });
};
var getStaticAssetSrc = function getStaticAssetSrc(asset) {
    return typeof asset === "string" ? asset : (asset === null || asset === void 0 ? void 0 : asset.src) || "";
};
var IdentityRow = function IdentityRow(_ref2) {
    var _identity$groups$, _identity$groups$2, _identity$groups$3;
    var identity = _ref2.identity, isSelected = _ref2.isSelected, onClick = _ref2.onClick, _ref2$selectedIcon = _ref2.selectedIcon, selectedIcon = _ref2$selectedIcon === void 0 ? "TickIcon" : _ref2$selectedIcon, _ref2$variant = _ref2.variant, variant = _ref2$variant === void 0 ? "default" : _ref2$variant;
    var _useLocaleStore = (0,_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useLocaleStore */ .Ee)(), $t = _useLocaleStore.$t;
    var _useConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_4__/* .useConfig */ .ZR)(), isIntl = _useConfig.isIntl;
    var teamType = (0,_identitySwitch_shared__WEBPACK_IMPORTED_MODULE_5__/* .getTeamTagType */ .N)(identity.oid, identity.type);
    var isDropdown = variant === "dropdown";
    // const Icon =
    //   selectedIcon === 'CheckBox'
    //     ? IdentityRow_CheckBox
    //     : selectedIcon === 'TickIcon'
    //     ? IdentityRow_TickIcon
    //     : selectedIcon;
    var Icon = function Icon(_ref3) {
        var active = _ref3.isSelected;
        return active ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            fontSize: 16,
            name: "CheckBold",
            color: isDropdown ? "var(--content-system-primary, #1C1D1F)" : "var(--content-system-link, #3388FF)"
        }) : null;
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("IdentityRow", {
            "IdentityRow-dropdown": isDropdown
        }),
        "data-identity-type": identity.type,
        "data-active": isSelected,
        onClick: onClick
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "IdentityRow-left"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "IdentityRow-avatar"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_teamLogo__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        src: identity.logo,
        size: "medium",
        name: identity.name,
        oid: identity.oid
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "IdentityRow-infoBox"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "IdentityRow-infoBox-top"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "IdentityRow-name"
    }, identity.alias || identity.name), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "IdentityRow-teamTag"
    }, ((_identity$groups$ = identity.groups[0]) === null || _identity$groups$ === void 0 ? void 0 : _identity$groups$.is_vip) && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("img", {
        src: identity.type === 0 ? isIntl ? ((_identity$groups$2 = identity.groups[0]) === null || _identity$groups$2 === void 0 ? void 0 : _identity$groups$2.vip_level) === _types__WEBPACK_IMPORTED_MODULE_8__/* .VipLevelIntl.Pro */ .Wi.Pro ? _userInfo_constants_inedx__WEBPACK_IMPORTED_MODULE_9__/* .userXdesignProVip */ .OY : _userInfo_constants_inedx__WEBPACK_IMPORTED_MODULE_9__/* .userXdesignPlusVip */ .ZB : ((_identity$groups$3 = identity.groups[0]) === null || _identity$groups$3 === void 0 ? void 0 : _identity$groups$3.vip_level) === _types__WEBPACK_IMPORTED_MODULE_8__/* .VipLevel.ProCn */ .Dv.ProCn ? _userInfo_constants_inedx__WEBPACK_IMPORTED_MODULE_9__/* .userPrpVip */ .PS : _userInfo_constants_inedx__WEBPACK_IMPORTED_MODULE_9__/* .userVip */ .g : getStaticAssetSrc(_userInfo_constants_inedx__WEBPACK_IMPORTED_MODULE_9__/* .teamVip */ .vD),
        style: identity.type === 0 ? {
            height: 16
        } : {
            width: 45,
            height: 14
        },
        alt: ""
    }))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "IdentityRow-detailInfo"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        name: teamType === _teamTag__WEBPACK_IMPORTED_MODULE_10__/* .TeamTagType.personal */ .n.personal ? "User" : "Enterprise",
        fontSize: 12
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
        className: "IdentityRow-memberNum"
    }, $t(function(v, _ref4) {
        var r = _ref4.r;
        return r(v.Text_MemberCount, [
            teamType === _teamTag__WEBPACK_IMPORTED_MODULE_10__/* .TeamTagType.personal */ .n.personal ? 1 : identity.member_num
        ]);
    }))))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "IdentityRow-selectedIcon"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Icon, {
        isSelected: isSelected
    })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (IdentityRow);


/***/ }),

/***/ 29898:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BM": () => (/* binding */ HIDDEN_IDENTITY_SWITCH_MODAL),
/* harmony export */   "Mg": () => (/* binding */ SHOW_IDENTITY_SWITCH_MODAL),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_custom_scrollbars_2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86658);
/* harmony import */ var _meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15328);
/* harmony import */ var _meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99861);
/* harmony import */ var _ComUI__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49143);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84480);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32907);
/* harmony import */ var _loading__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42889);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72838);
/* harmony import */ var _createModal__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59249);
/* harmony import */ var _identityRow__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(84183);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84379);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_3__);












// 展示身份切换弹窗事件
var SHOW_IDENTITY_SWITCH_MODAL = "xdesign-widget-show-identity-switch-modal";
// 隐藏身份切换弹窗事件
var HIDDEN_IDENTITY_SWITCH_MODAL = "xdesign-widget-hidden-identity-switch-modal";
/**
 * 登陆后身份选择
 */ var LoginIdentitySwitchModal = function LoginIdentitySwitchModal(_ref) {
    var _teamInfo$identity$li;
    var _ref$showCloseBtn = _ref.showCloseBtn, showCloseBtn = _ref$showCloseBtn === void 0 ? false : _ref$showCloseBtn, hideCreateBtn = _ref.hideCreateBtn, create_team_success_entrance = _ref.create_team_success_entrance, _ref$project = _ref.project, project = _ref$project === void 0 ? "" : _ref$project, _ref$noSwitchIdentity = _ref.noSwitchIdentity, noSwitchIdentity = _ref$noSwitchIdentity === void 0 ? false : _ref$noSwitchIdentity, _ref$filterIdentities = _ref.filterIdentities, filterIdentities = _ref$filterIdentities === void 0 ? function() {
        return true;
    } : _ref$filterIdentities, onSwitchComplete = _ref.onSwitchComplete, onClose = _ref.onClose, onTrack = _ref.onTrack, topTip = _ref.topTip, hideSelectedStatus = _ref.hideSelectedStatus;
    var _useLocaleStore = (0,_i18n__WEBPACK_IMPORTED_MODULE_4__/* .useLocaleStore */ .Ee)(), $t = _useLocaleStore.$t;
    var _useConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_5__/* .useConfig */ .ZR)(), loginIdentitySwitchModalConfig = _useConfig.loginIdentitySwitchModalConfig;
    var teamInfo = (0,___WEBPACK_IMPORTED_MODULE_6__/* .useTeamInfoState */ .fM)();
    // 关闭
    var handleConfirm = function handleConfirm(oid, groupId, ouid) {
        if (!teamInfo) return;
        onSwitchComplete === null || onSwitchComplete === void 0 || onSwitchComplete({
            oid: oid,
            groupId: groupId,
            ouid: ouid
        }, {
            isFromCreate: false
        });
        onClose === null || onClose === void 0 || onClose();
        if (!noSwitchIdentity) {
            (0,___WEBPACK_IMPORTED_MODULE_6__/* .changeIdentity */ .vv)({
                ouid: ouid,
                oid: oid,
                groupId: groupId
            });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (teamInfo) {
            _loading__WEBPACK_IMPORTED_MODULE_7__/* ["default"].hidden */ .Z.hidden();
        } else {
            _loading__WEBPACK_IMPORTED_MODULE_7__/* ["default"].show */ .Z.show($t(function(v) {
                return v.Tips_Loading;
            }));
        }
    }, [
        teamInfo
    ]);
    var displayIdentities = (_teamInfo$identity$li = teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.list.filter(filterIdentities)) !== null && _teamInfo$identity$li !== void 0 ? _teamInfo$identity$li : [];
    var personlIsShow = displayIdentities.some(function(it) {
        return it.type === 0;
    });
    if (!teamInfo) return null;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ComUI__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        destroyOnClose: true,
        open: true,
        zIndex: 1000000001 // 这么大是因为业务引导弹窗库的层级是1000000000
        ,
        className: "Widget-teamSpaceLoginIdentitySwitchModal"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "Widget teamSpaceLoginIdentitySwitchModal"
    }, showCloseBtn && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "close",
        onClick: ___WEBPACK_IMPORTED_MODULE_6__/* .closeIdentitySwitchPopup */ .VT
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        fontSize: 14,
        name: "CrossBlack",
        color: "var(--content-system-tertiary)"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "title"
    }, personlIsShow ? $t(function(v) {
        return v.Text_SelectIdentity;
    }) : $t(function(v) {
        return v.Text_SelectTeamIdentity;
    })), loginIdentitySwitchModalConfig.showEditorSaveTip && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "editing-save-tip"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        style: {
            marginRight: 4
        },
        name: "InfoCircleBoldFill",
        fontSize: 16,
        color: "var(--content-system-info-icon-regular, #8CC0FF)"
    }), topTip !== null && topTip !== void 0 ? topTip : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, $t(function(v, _ref2) {
        var _getLocalIdentity, _teamInfo$identity$li2, _teamInfo$identity$li3;
        var r = _ref2.r;
        return r(v.Text_EditingSaveLocation, [
            ((_getLocalIdentity = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)()) === null || _getLocalIdentity === void 0 ? void 0 : _getLocalIdentity.oid) === 0 ? $t(function(v) {
                return v.Text_PersonalDesigner;
            }) : (_teamInfo$identity$li2 = (_teamInfo$identity$li3 = teamInfo.identity.list.find(function(it) {
                var _getLocalIdentity2;
                return it.oid === ((_getLocalIdentity2 = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)()) === null || _getLocalIdentity2 === void 0 ? void 0 : _getLocalIdentity2.oid);
            })) === null || _teamInfo$identity$li3 === void 0 ? void 0 : _teamInfo$identity$li3.name) !== null && _teamInfo$identity$li2 !== void 0 ? _teamInfo$identity$li2 : ""
        ]);
    }))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "list",
        style: {
            height: teamInfo.identity.list.length > 3 ? 240 : teamInfo.identity.list.length * 74
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_custom_scrollbars_2__WEBPACK_IMPORTED_MODULE_1__/* .Scrollbars */ .$B, {
        className: "loginIdentitySwitchModal-scrollbars"
    }, displayIdentities.map(function(identity, key) {
        var _getLocalIdentity3;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
            key: key,
            style: {
                margin: "0 16px"
            }
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_identityRow__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            identity: identity,
            isSelected: !hideSelectedStatus && identity.oid === ((_getLocalIdentity3 = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)()) === null || _getLocalIdentity3 === void 0 ? void 0 : _getLocalIdentity3.oid),
            onClick: function onClick() {
                return handleConfirm(identity.oid, identity.groups[0].id, identity.ouid);
            }
        }));
    }))), !hideCreateBtn ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "team-create-box",
        onClick: function onClick() {
            (0,___WEBPACK_IMPORTED_MODULE_6__/* .closeIdentitySwitchPopup */ .VT)();
            (0,_createModal__WEBPACK_IMPORTED_MODULE_11__/* .openCreateTeamModal */ .l)({
                onTrack: onTrack,
                create_team_success_entrance: create_team_success_entrance,
                project: project,
                noSwitchIdentity: noSwitchIdentity,
                onCreatedComplete: function onCreatedComplete(data) {
                    return onSwitchComplete === null || onSwitchComplete === void 0 ? void 0 : onSwitchComplete({
                        oid: data.oid,
                        groupId: data.group_id,
                        ouid: data.ouid
                    }, {
                        isFromCreate: true
                    });
                }
            });
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "team-create-btn"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "team-create-icon"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        fontSize: 18,
        name: "PlusBlack",
        color: "var(--content-web-secondary)"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "team-create-text"
    }, $t(function(v) {
        return v.Text_CreateNewTeamFree;
    })))) : null));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(LoginIdentitySwitchModal));


/***/ }),

/***/ 32943:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45974);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_2__);



/**
 * 团队 logo
 */ var TeamLogo = function TeamLogo(_ref) {
    var size = _ref.size, src = _ref.src, name = _ref.name, grayscale = _ref.grayscale, oid = _ref.oid;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("Widget", "teamLogo", {
            grayscale: grayscale,
            "user-avatar": !oid
        }),
        "data-has-border": !!oid && !!src
    }, src ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("img", {
        src: src,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("img", size)
    }) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("name", size)
    }, name.substring(0, 1)));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(TeamLogo));


/***/ }),

/***/ 97505:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "n": () => (/* binding */ TeamTagType)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81549);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15328);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32907);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40198);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_2__);






var TeamTagType = /*#__PURE__*/ function(TeamTagType) {
    TeamTagType["personal"] = "personal";
    TeamTagType["team"] = "team";
    TeamTagType["enterprise"] = "enterprise";
    TeamTagType["free"] = "free";
    return TeamTagType;
}({});
/**
 * 团队 tag
 */ var TeamTag = function TeamTag(_ref) {
    var size = _ref.size, type = _ref.type, selectIcon = _ref.selectIcon, grayscale = _ref.grayscale, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, _onClick = _ref.onClick;
    var _useLocaleStore = (0,_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useLocaleStore */ .Ee)(), $t = _useLocaleStore.$t;
    var nameType = {
        personal: $t(function(v) {
            return v.Text_PersonalEdition;
        }),
        team: $t(function(v) {
            return v.Text_TeamEdition;
        }),
        enterprise: $t(function(v) {
            return v.Text_EnterpriseEdition;
        }),
        free: $t(function(v) {
            return v.Text_FreeEdition;
        })
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("Widget", "teamTag", type, size, {
            grayscale: grayscale,
            selectIcon: !!selectIcon
        }),
        style: (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, style),
        onClick: function onClick() {
            return _onClick === null || _onClick === void 0 ? void 0 : _onClick();
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
        className: "txt"
    }, nameType[type]), selectIcon ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
        style: {
            transform: "translate(1px, -50%) scale(".concat(8 / 12, ")"),
            position: "absolute",
            top: "50%"
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        fontSize: 12,
        name: "ChevronDownBlack"
    })) : null);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(TeamTag));


/***/ }),

/***/ 9350:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cm": () => (/* binding */ createTeam),
/* harmony export */   "S1": () => (/* binding */ init),
/* harmony export */   "W2": () => (/* binding */ getAccessTokenCookieKey),
/* harmony export */   "bo": () => (/* binding */ getEnterpriseIDKey),
/* harmony export */   "fZ": () => (/* binding */ handleReportDownloadResult),
/* harmony export */   "yf": () => (/* binding */ isSSO)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81549);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69222);
/* harmony import */ var _babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89255);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87406);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33641);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);
/* harmony import */ var _meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99861);
/* harmony import */ var _ComUI__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(77977);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84480);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(32907);
/* harmony import */ var _uploadManager_config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22386);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54345);
/* harmony import */ var _utils_uidKit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53421);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59901);
/* harmony import */ var _api_enterprise__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93507);















var getEnterpriseIDKey = function getEnterpriseIDKey() {
    return "enterprise_id".concat((0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getSuffix */ ._A)());
};
var getAccessTokenCookieKey = function getAccessTokenCookieKey() {
    return "access_token".concat((0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getSuffix */ ._A)());
};
// 是否走SSO授权登录方式
var isSSOLogin = false;
var isSSO = function isSSO() {
    return isSSOLogin;
};
var getEnterpriseSearchParams = function getEnterpriseSearchParams() {
    var _getIdentityFromCooki;
    var searchParams = new URLSearchParams(window.location.search);
    var localOid = (_getIdentityFromCooki = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_1__/* .getIdentityFromCookie */ .Rw)()) === null || _getIdentityFromCooki === void 0 ? void 0 : _getIdentityFromCooki.oid;
    return {
        code: searchParams.get("code"),
        organizationID: Number(searchParams.get("oid")) || localOid
    };
};
/**
 * Clear redundant url params
 * (remove some params from `meitu account`)
 * @param keys - keys to remove
 */ var clearURL = function clearURL(keys) {
    var searchParams = new URLSearchParams(window.location.search);
    var redundantKeys = [
        "op_type",
        "code",
        "platform",
        "client_from_sdk",
        "redirect_uri",
        "client_referer",
        "client_params"
    ];
    if (keys) {
        redundantKeys.push.apply(redundantKeys, (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(keys));
    }
    redundantKeys.forEach(function(key) {
        searchParams.delete(key);
    });
    // 构建新的查询字符串
    var newQueryString = searchParams.toString();
    // 获取当前 URL 的路径部分
    var path = window.location.pathname;
    // 更新 URL，不包括被移除的参数
    var newUrl = newQueryString ? "".concat(path, "?").concat(newQueryString) : path;
    window.history.replaceState(window.history.state, "", newUrl);
};
var checkLoginStatus = /*#__PURE__*/ function() {
    var _ref = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().mark(function _callee() {
        var _res$userInfo, res, uid;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0,_api_enterprise__WEBPACK_IMPORTED_MODULE_6__/* .fetchUserInfo */ .CS)();
                case 3:
                    res = _context.sent;
                    if (!(res !== null && res !== void 0 && (_res$userInfo = res.userInfo) !== null && _res$userInfo !== void 0 && _res$userInfo.id)) {
                        _context.next = 8;
                        break;
                    }
                    uid = res.userInfo.id; // 非个人版下，利用该接口同步最新ouid，用于埋点上报的uid的准确性
                    (0,_utils_uidKit__WEBPACK_IMPORTED_MODULE_7__/* .setLocalUid */ .Tc)(uid);
                    return _context.abrupt("return", true);
                case 8:
                    return _context.abrupt("return", false);
                case 11:
                    _context.prev = 11;
                    _context.t0 = _context["catch"](0);
                    return _context.abrupt("return", false);
                case 14:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function checkLoginStatus() {
        return _ref.apply(this, arguments);
    };
}();
var getEnterpriseConfigs = /*#__PURE__*/ function() {
    var _ref2 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().mark(function _callee2(oid) {
        var res;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0,_api_enterprise__WEBPACK_IMPORTED_MODULE_6__/* .fetchEnterpriseConfigs */ .N1)(oid);
                case 3:
                    res = _context2.sent;
                    return _context2.abrupt("return", {
                        enterpriseID: res.enterprise,
                        authPageURL: res.authorized_redirect_url
                    });
                case 7:
                    _context2.prev = 7;
                    _context2.t0 = _context2["catch"](0);
                    return _context2.abrupt("return", null);
                case 10:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function getEnterpriseConfigs(_x) {
        return _ref2.apply(this, arguments);
    };
}();
var init = /*#__PURE__*/ function() {
    var _ref3 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().mark(function _callee3() {
        var _getEnterpriseSearchP, code, organizationID, _getConfig, isWpsUser, obsConfig, TOKEN_KEY_COOKIE, tokenCookie, ENTERPRISE_ID, _tokenCookie, _yield$Promise$all, _yield$Promise$all2, isLogin, resObsCfg, resEnterpriseCfg, res, accessToken, _yield$Promise$all3, _yield$Promise$all4, _, _resObsCfg, _resEnterpriseCfg;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    _getEnterpriseSearchP = getEnterpriseSearchParams(), code = _getEnterpriseSearchP.code, organizationID = _getEnterpriseSearchP.organizationID;
                    _getConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .iE)(), isWpsUser = _getConfig.isWpsUser;
                    obsConfig = (0,_uploadManager_config__WEBPACK_IMPORTED_MODULE_9__/* .getDefaultObsConfig */ .L4)();
                    TOKEN_KEY_COOKIE = getAccessTokenCookieKey(); // Check whether it is enterprise client
                    if (!(!organizationID && !code)) {
                        _context3.next = 8;
                        break;
                    }
                    // 同步cookie中的token到缓存
                    tokenCookie = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(TOKEN_KEY_COOKIE) || "";
                    if (tokenCookie && !isWpsUser) {
                        window.localStorage.setItem("access_token", tokenCookie);
                    }
                    return _context3.abrupt("return", obsConfig);
                case 8:
                    ENTERPRISE_ID = getEnterpriseIDKey(); // 更新本地cookie
                    (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_1__/* .setLocalIdentity */ .kF)(Number(organizationID), Number(organizationID));
                    // 更内存身份
                    (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_1__/* .setMemoryIdentity */ .LW)(Number(organizationID), Number(organizationID));
                    // If no `code` url param, then checking login status
                    if (code) {
                        _context3.next = 34;
                        break;
                    }
                    // 同步cookie中的token到缓存
                    _tokenCookie = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(TOKEN_KEY_COOKIE) || "";
                    if (_tokenCookie && !isWpsUser) {
                        window.localStorage.setItem("access_token", _tokenCookie);
                    }
                    // check login status
                    _context3.prev = 14;
                    _context3.next = 17;
                    return Promise.all([
                        checkLoginStatus(),
                        (0,_uploadManager_config__WEBPACK_IMPORTED_MODULE_9__/* .getObsConfigAsync */ .UO)({
                            oid: organizationID
                        }),
                        getEnterpriseConfigs(organizationID)
                    ]);
                case 17:
                    _yield$Promise$all = _context3.sent;
                    _yield$Promise$all2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_yield$Promise$all, 3);
                    isLogin = _yield$Promise$all2[0];
                    resObsCfg = _yield$Promise$all2[1];
                    resEnterpriseCfg = _yield$Promise$all2[2];
                    if (resObsCfg !== null && resObsCfg !== void 0 && resObsCfg.app) {
                        obsConfig = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, obsConfig), resObsCfg);
                    }
                    isSSOLogin = !!(resEnterpriseCfg !== null && resEnterpriseCfg !== void 0 && resEnterpriseCfg.authPageURL);
                    if (!isLogin) {
                        // not login, then redirect to auth page
                        window.localStorage.removeItem("access_token");
                        js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove(TOKEN_KEY_COOKIE, {
                            domain: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getRootDomain */ .wf)()
                        });
                    }
                    if (resEnterpriseCfg !== null && resEnterpriseCfg !== void 0 && resEnterpriseCfg.enterpriseID) {
                        // 更新企业标识
                        js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(ENTERPRISE_ID, resEnterpriseCfg.enterpriseID, {
                            domain: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getRootDomain */ .wf)(),
                            expires: 36500 // 100年有效期
                        });
                    } else {
                        js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove(ENTERPRISE_ID, {
                            domain: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getRootDomain */ .wf)()
                        });
                    }
                    if (!isLogin && resEnterpriseCfg !== null && resEnterpriseCfg !== void 0 && resEnterpriseCfg.authPageURL) {
                        // 未登录，跳转去授权登录
                        window.open(resEnterpriseCfg.authPageURL, "_self");
                    }
                    clearURL([
                        "enterprise",
                        "oid"
                    ]);
                    return _context3.abrupt("return", obsConfig);
                case 31:
                    _context3.prev = 31;
                    _context3.t0 = _context3["catch"](14);
                    return _context3.abrupt("return", obsConfig);
                case 34:
                    _context3.prev = 34;
                    _context3.next = 37;
                    return (0,_api_enterprise__WEBPACK_IMPORTED_MODULE_6__/* .fetchAccessTokenByCode */ .tH)(code);
                case 37:
                    res = _context3.sent;
                    accessToken = res["access_token"];
                    if (accessToken) {
                        _context3.next = 41;
                        break;
                    }
                    throw new Error("Get access token failed.");
                case 41:
                    if (!isWpsUser) {
                        window.localStorage.setItem("access_token", accessToken);
                    }
                    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(TOKEN_KEY_COOKIE, accessToken, {
                        domain: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getRootDomain */ .wf)(),
                        expires: 36500 // 100年有效期
                    });
                    // refresh user rights
                    _context3.next = 45;
                    return Promise.all([
                        (0,_api_enterprise__WEBPACK_IMPORTED_MODULE_6__/* .refreshUserRights */ .rm)(),
                        (0,_uploadManager_config__WEBPACK_IMPORTED_MODULE_9__/* .getObsConfigAsync */ .UO)({
                            oid: organizationID
                        }),
                        getEnterpriseConfigs(organizationID)
                    ]);
                case 45:
                    _yield$Promise$all3 = _context3.sent;
                    _yield$Promise$all4 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_yield$Promise$all3, 3);
                    _ = _yield$Promise$all4[0];
                    _resObsCfg = _yield$Promise$all4[1];
                    _resEnterpriseCfg = _yield$Promise$all4[2];
                    if (_resObsCfg !== null && _resObsCfg !== void 0 && _resObsCfg.app) {
                        obsConfig.app = _resObsCfg === null || _resObsCfg === void 0 ? void 0 : _resObsCfg.app;
                    }
                    isSSOLogin = !!(_resEnterpriseCfg !== null && _resEnterpriseCfg !== void 0 && _resEnterpriseCfg.authPageURL);
                    if (_resEnterpriseCfg !== null && _resEnterpriseCfg !== void 0 && _resEnterpriseCfg.enterpriseID) {
                        // 更新企业标识
                        js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(ENTERPRISE_ID, _resEnterpriseCfg.enterpriseID, {
                            domain: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getRootDomain */ .wf)(),
                            expires: 36500 // 100年有效期
                        });
                    }
                    return _context3.abrupt("return", obsConfig);
                case 56:
                    _context3.prev = 56;
                    _context3.t1 = _context3["catch"](34);
                case 58:
                    _context3.prev = 58;
                    clearURL([
                        "enterprise",
                        "oid"
                    ]);
                    return _context3.finish(58);
                case 61:
                    return _context3.abrupt("return", obsConfig);
                case 62:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                14,
                31
            ],
            [
                34,
                56,
                58,
                61
            ]
        ]);
    }));
    return function init() {
        return _ref3.apply(this, arguments);
    };
}();
// 同步海洛下载结果
var handleReportDownloadResult = /*#__PURE__*/ function() {
    var _ref4 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().mark(function _callee4(blob, options) {
        var url, filesize, _yield$import, uploadFileToObs, file, res;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().wrap(function _callee4$(_context4) {
            while(1)switch(_context4.prev = _context4.next){
                case 0:
                    _context4.prev = 0;
                    url = "";
                    filesize = undefined;
                    if (!(typeof blob === "string" && /^https?:\/\//i.test(blob))) {
                        _context4.next = 7;
                        break;
                    }
                    url = blob;
                    _context4.next = 18;
                    break;
                case 7:
                    if (!(blob instanceof Blob)) {
                        _context4.next = 18;
                        break;
                    }
                    _context4.next = 10;
                    return Promise.all(/* import() */[__webpack_require__.e(8959), __webpack_require__.e(2079), __webpack_require__.e(7295), __webpack_require__.e(6631)]).then(__webpack_require__.bind(__webpack_require__, 3427));
                case 10:
                    _yield$import = _context4.sent;
                    uploadFileToObs = _yield$import.uploadFileToObs;
                    file = new File([
                        blob
                    ], "", {
                        type: blob.type
                    });
                    _context4.next = 15;
                    return uploadFileToObs(file, {
                        customMaatType: "image_tmp",
                        customSuffix: options === null || options === void 0 ? void 0 : options.extension
                    });
                case 15:
                    res = _context4.sent;
                    url = res.url;
                    filesize = blob.size;
                case 18:
                    _context4.next = 20;
                    return (0,_api__WEBPACK_IMPORTED_MODULE_12__/* .handleDownloadRecord */ .lh)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                        url: url,
                        filesize: filesize
                    }, options));
                case 20:
                    _ComUI__WEBPACK_IMPORTED_MODULE_13__/* ["default"].success */ .Z.success((0,_i18n__WEBPACK_IMPORTED_MODULE_14__/* .getLocaleStore */ .IK)().$t(function(v) {
                        return v.Text_SavedToHelloDigitalAsset;
                    }));
                    _context4.next = 26;
                    break;
                case 23:
                    _context4.prev = 23;
                    _context4.t0 = _context4["catch"](0);
                    ;
                case 26:
                case "end":
                    return _context4.stop();
            }
        }, _callee4, null, [
            [
                0,
                23
            ]
        ]);
    }));
    return function handleReportDownloadResult(_x2, _x3) {
        return _ref4.apply(this, arguments);
    };
}();
var createTeam = /*#__PURE__*/ function() {
    var _ref5 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().mark(function _callee5(params) {
        var _params$teamName;
        var _getConfig2, userInfo, res;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().wrap(function _callee5$(_context5) {
            while(1)switch(_context5.prev = _context5.next){
                case 0:
                    _getConfig2 = (0,_configProvider__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .iE)(), userInfo = _getConfig2.userInfo;
                    _context5.next = 3;
                    return (0,_api__WEBPACK_IMPORTED_MODULE_12__/* .createTeamApi */ .tH)({
                        name: (_params$teamName = params === null || params === void 0 ? void 0 : params.teamName) !== null && _params$teamName !== void 0 ? _params$teamName : (0,_i18n__WEBPACK_IMPORTED_MODULE_14__/* .getLocaleStore */ .IK)().$t(function(v, _ref6) {
                            var r = _ref6.r;
                            return r(v.Text_DefaultTeamName, [
                                userInfo.screen_name
                            ]);
                        }),
                        rebate_code: params === null || params === void 0 ? void 0 : params.rebateCode
                    });
                case 3:
                    res = _context5.sent;
                    return _context5.abrupt("return", {
                        groupId: res.group_id,
                        oid: res.oid,
                        ouid: res.ouid,
                        teamName: res.team_name
                    });
                case 5:
                case "end":
                    return _context5.stop();
            }
        }, _callee5);
    }));
    return function createTeam(_x4) {
        return _ref5.apply(this, arguments);
    };
}();


/***/ }),

/***/ 8029:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mf": () => (/* binding */ IdentityType),
/* harmony export */   "cc": () => (/* binding */ TeamSeatStatus),
/* harmony export */   "iJ": () => (/* binding */ TeamShareNodeType),
/* harmony export */   "xO": () => (/* binding */ TeamRoleType)
/* harmony export */ });
/* unused harmony exports CollaboratorPermissionType, TeamShareChangeType */
/** 协作者权限 */ var CollaboratorPermissionType = /*#__PURE__*/ function(CollaboratorPermissionType) {
    CollaboratorPermissionType[CollaboratorPermissionType["Views"] = 2] = "Views";
    CollaboratorPermissionType[CollaboratorPermissionType["Edit"] = 3] = "Edit";
    CollaboratorPermissionType[CollaboratorPermissionType["Manage"] = 4] = "Manage";
    CollaboratorPermissionType[CollaboratorPermissionType["Remove"] = 5] = "Remove";
    CollaboratorPermissionType[CollaboratorPermissionType["Reject"] = 6] = "Reject";
    CollaboratorPermissionType[CollaboratorPermissionType["Owner"] = 999999] = "Owner";
    return CollaboratorPermissionType;
}({});
// 身份类型，type: 0-个人版，1-团队版，2-企业版
var IdentityType = /*#__PURE__*/ function(IdentityType) {
    IdentityType[IdentityType["PERSONAL"] = 0] = "PERSONAL";
    IdentityType[IdentityType["TEAM"] = 1] = "TEAM";
    IdentityType[IdentityType["ENTERPRISE"] = 2] = "ENTERPRISE";
    return IdentityType;
}({});
/**
 * 团队身份
 */ /**
 * 团队信息
 */ /**
 * 团队席位状态
 */ /** 席位状态 */ var TeamSeatStatus = /*#__PURE__*/ function(TeamSeatStatus) {
    TeamSeatStatus[TeamSeatStatus["Unbound"] = 0] = "Unbound";
    TeamSeatStatus[TeamSeatStatus["Effect"] = 1] = "Effect";
    TeamSeatStatus[TeamSeatStatus["Pending"] = 2] = "Pending";
    TeamSeatStatus[TeamSeatStatus["Freeze"] = 10] = "Freeze";
    return TeamSeatStatus;
}({});
/**
 * 团队角色
 */ var TeamRoleType = /*#__PURE__*/ function(TeamRoleType) {
    TeamRoleType["owner"] = "owner";
    TeamRoleType["admin"] = "admin";
    TeamRoleType["member"] = "member";
    return TeamRoleType;
}({});
/**
 * 协作列表
 */ /**
 * 团队成员
 */ /**
 * 团队信息
 */ /**
 * 回调的type
 */ var TeamShareChangeType = /*#__PURE__*/ function(TeamShareChangeType) {
    TeamShareChangeType["USER_TYPE"] = "user_type";
    TeamShareChangeType["MODE"] = "mode";
    return TeamShareChangeType;
}({});
/**
 * 分享文件类型
 */ var TeamShareNodeType = /*#__PURE__*/ function(TeamShareNodeType) {
    TeamShareNodeType["RECORD"] = "RECORD";
    TeamShareNodeType["TEMPLATE"] = "TEMPLATE";
    TeamShareNodeType["FOLDER"] = "FOLDER";
    return TeamShareNodeType;
}({}); /**
 * 创建团队
 */  /**
 * [团队]生成邀请码
 */ 


/***/ }),

/***/ 71755:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dv": () => (/* binding */ VipLevel),
/* harmony export */   "FW": () => (/* binding */ UserType),
/* harmony export */   "Wi": () => (/* binding */ VipLevelIntl),
/* harmony export */   "dE": () => (/* binding */ ListKeyType)
/* harmony export */ });
/* unused harmony export BalanceListKeyType */
/**
 * 用户信息数据类型
 *
 * @see https://api-mock.meitu-int.com/project/2110/interface/api/116813
 */ // 国内会员等级枚举
var VipLevel = /*#__PURE__*/ function(VipLevel) {
    VipLevel[VipLevel["Basic"] = 1] = "Basic";
    VipLevel[VipLevel["Pro"] = 2] = "Pro";
    VipLevel[VipLevel["ProCn"] = 3] = "ProCn";
    return VipLevel;
}({});
// 海外会员等级枚举
var VipLevelIntl = /*#__PURE__*/ function(VipLevelIntl) {
    VipLevelIntl[VipLevelIntl["Basic"] = 1] = "Basic";
    VipLevelIntl[VipLevelIntl["Pro"] = 2] = "Pro";
    VipLevelIntl[VipLevelIntl["Max"] = 3] = "Max";
    return VipLevelIntl;
}({});
var ListKeyType = /*#__PURE__*/ function(ListKeyType) {
    ListKeyType["FEEDBACK"] = "feedBack";
    ListKeyType["BUSINESS"] = "business";
    ListKeyType["DOWNLOAD"] = "download";
    ListKeyType["CREDIT"] = "credit";
    ListKeyType["ManageSubscriptions"] = "manageSubscriptions";
    ListKeyType["Subscription"] = "subscription";
    ListKeyType["TermsPolicies"] = "termsPolicies";
    ListKeyType["Pricing"] = "pricing";
    ListKeyType["ChangeIdentity"] = "changeIdentity";
    ListKeyType["Compensation"] = "compensation";
    ListKeyType["Language"] = "language";
    ListKeyType["Redeem"] = "redeem";
    ListKeyType["Invite"] = "invite";
    ListKeyType["Account"] = "account";
    ListKeyType["DOWNLOAD_APP"] = "downloadApp";
    ListKeyType["TEAM_ADMIN"] = "teamAdmin";
    ListKeyType["InviteCn"] = "inviteCn";
    return ListKeyType;
}({});
var BalanceListKeyType = /*#__PURE__*/ function(BalanceListKeyType) {
    BalanceListKeyType["MEIDOU"] = "meidou";
    BalanceListKeyType["CUTOUT"] = "cutout";
    return BalanceListKeyType;
}({});
/**
 * 用户信息组件属性
 */ /**
 * 用户类型
 */ var UserType = /*#__PURE__*/ function(UserType) {
    UserType["PERSONAL"] = "personal";
    UserType["TEAM"] = "team";
    UserType["COMPANY"] = "company";
    return UserType;
}({});


/***/ }),

/***/ 22386:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L4": () => (/* binding */ getDefaultObsConfig),
/* harmony export */   "UO": () => (/* binding */ getObsConfigAsync),
/* harmony export */   "mg": () => (/* binding */ setUploadConfig),
/* harmony export */   "xJ": () => (/* binding */ UploadEnv),
/* harmony export */   "z$": () => (/* binding */ getSliceConfigAsync),
/* harmony export */   "zX": () => (/* binding */ getUploadConfig)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89255);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87406);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84480);
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41844);




var UploadEnv = /*#__PURE__*/ function(UploadEnv) {
    UploadEnv["Release"] = "Release";
    UploadEnv["Test"] = "Test";
    return UploadEnv;
}({});
var DEFAULT_PART_SIZE = 4 * 1024 * 1024;
var defaultConfig = {
    app: "xiuxiu-pro",
    env: UploadEnv.Release,
    type: "",
    partSize: DEFAULT_PART_SIZE
};
var setUploadConfig = function setUploadConfig(config) {
    Object.assign(defaultConfig, config);
};
var getUploadConfig = function getUploadConfig() {
    return defaultConfig;
};
var getDefaultObsConfig = function getDefaultObsConfig() {
    var _getConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)(), isIntl = _getConfig.isIntl, appName = _getConfig.appName;
    var obsConfig = {
        sig: false,
        // 是否需要加签
        app: isIntl && appName === "x-design" ? "x-design" : "xiuxiu-pro",
        // 默认非定制版的
        uploadOptions: {}
    };
    return obsConfig;
};
// 异步获取配置信息
var getObsConfigAsync = /*#__PURE__*/ function() {
    var _ref = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().mark(function _callee(params) {
        var obsConfig, resObsCfg;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    obsConfig = getDefaultObsConfig();
                    _context.prev = 1;
                    _context.next = 4;
                    return (0,_services__WEBPACK_IMPORTED_MODULE_3__/* .fetchObsConfig */ .gb)(params);
                case 4:
                    resObsCfg = _context.sent;
                    if (resObsCfg !== null && resObsCfg !== void 0 && resObsCfg.app) {
                        obsConfig.app = resObsCfg === null || resObsCfg === void 0 ? void 0 : resObsCfg.app;
                        obsConfig.sig = !!(resObsCfg !== null && resObsCfg !== void 0 && resObsCfg.sig);
                        // 上传配置信息
                        if (resObsCfg.config.partSize) obsConfig.uploadOptions.partSize = resObsCfg.config.partSize;
                        if (resObsCfg.config.concurrency) obsConfig.uploadOptions.maxConcurrent = resObsCfg.config.concurrency;
                    }
                    _context.next = 11;
                    break;
                case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](1);
                    ;
                case 11:
                    return _context.abrupt("return", obsConfig);
                case 12:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function getObsConfigAsync(_x) {
        return _ref.apply(this, arguments);
    };
}();
// 分片配置获取, 只获取一次
var sliceConfig;
var sliceConfigPromise = null;
var getSliceConfigAsync = /*#__PURE__*/ function() {
    var _ref2 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().mark(function _callee3() {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    if (!sliceConfig) {
                        _context3.next = 2;
                        break;
                    }
                    return _context3.abrupt("return", sliceConfig);
                case 2:
                    if (!sliceConfigPromise) {
                        _context3.next = 4;
                        break;
                    }
                    return _context3.abrupt("return", sliceConfigPromise);
                case 4:
                    // 创建新的 Promise 并缓存
                    sliceConfigPromise = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().mark(function _callee2() {
                        var _getConfig2, module_id, config, resObsCfg;
                        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().wrap(function _callee2$(_context2) {
                            while(1)switch(_context2.prev = _context2.next){
                                case 0:
                                    _getConfig2 = (0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)(), module_id = _getConfig2.module_id;
                                    config = {
                                        partSize: DEFAULT_PART_SIZE
                                    };
                                    _context2.prev = 2;
                                    _context2.next = 5;
                                    return (0,_services__WEBPACK_IMPORTED_MODULE_3__/* .fetchObsConfig */ .gb)({
                                        project: module_id
                                    });
                                case 5:
                                    resObsCfg = _context2.sent;
                                    if (resObsCfg.config.partSize) config.partSize = resObsCfg.config.partSize;
                                    if (resObsCfg.config.concurrency) config.maxConcurrent = resObsCfg.config.concurrency;
                                    _context2.next = 13;
                                    break;
                                case 10:
                                    _context2.prev = 10;
                                    _context2.t0 = _context2["catch"](2);
                                    ;
                                case 13:
                                    sliceConfig = config;
                                    sliceConfigPromise = null;
                                    return _context2.abrupt("return", config);
                                case 16:
                                case "end":
                                    return _context2.stop();
                            }
                        }, _callee2, null, [
                            [
                                2,
                                10
                            ]
                        ]);
                    }))();
                    return _context3.abrupt("return", sliceConfigPromise);
                case 6:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function getSliceConfigAsync() {
        return _ref2.apply(this, arguments);
    };
}();


/***/ }),

/***/ 41844:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E1": () => (/* binding */ fopCreate),
/* harmony export */   "TW": () => (/* binding */ fopQuery),
/* harmony export */   "gb": () => (/* binding */ fetchObsConfig)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89255);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87406);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84480);
/* harmony import */ var _utils_env__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20820);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1225);





var fopCreate = function fopCreate(data) {
    var _getConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)(), isIntl = _getConfig.isIntl, env = _getConfig.env, appName = _getConfig.appName;
    var requestConfig = {};
    // 由于海外 Preview 环境没有部署图片文件格式云转换服务，暂时改用 Beta 环境的
    if (isIntl && appName === "x-design") {
        if (env === "pre") {
            requestConfig.baseURL = _utils_env__WEBPACK_IMPORTED_MODULE_1__/* .webApiUrlStariiMap.beta */ .ZY.beta;
        }
    }
    return _utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .ZP.post("/v1/fop/create", data, requestConfig);
};
var fopQuery = function fopQuery(params) {
    var _getConfig2 = (0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)(), isIntl = _getConfig2.isIntl, env = _getConfig2.env, appName = _getConfig2.appName;
    var baseURL;
    // 由于海外 Preview 环境没有部署图片文件格式云转换服务，暂时改用 Beta 环境的
    if (isIntl && appName === "x-design") {
        if (env === "pre") {
            baseURL = _utils_env__WEBPACK_IMPORTED_MODULE_1__/* .webApiUrlStariiMap.beta */ .ZY.beta;
        }
    }
    return _utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .ZP.get("/v1/fop/query", {
        params: params,
        baseURL: baseURL
    });
};
/**
 * 获取obs app 配置
 * @docs https://api-mock.meitu-int.com/project/2110/interface/api/153151
 * @returns
 */ var fetchObsConfig = /*#__PURE__*/ function() {
    var _ref = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().mark(function _callee(params) {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", (0,_utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
                        method: "GET",
                        url: "/v1/obs_config/get_app",
                        params: params,
                        hiddenMessage: true
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function fetchObsConfig(_x) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 72508:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AB": () => (/* binding */ userPrpVipPc),
/* harmony export */   "C9": () => (/* binding */ userNotVipPc),
/* harmony export */   "CX": () => (/* binding */ CHANGE_IDENTITY_TIP_KEY),
/* harmony export */   "Do": () => (/* binding */ userIntlNotVip),
/* harmony export */   "Mv": () => (/* binding */ userNotVip),
/* harmony export */   "OY": () => (/* binding */ userXdesignProVip),
/* harmony export */   "PS": () => (/* binding */ userPrpVip),
/* harmony export */   "T8": () => (/* binding */ teamIntlVip),
/* harmony export */   "TZ": () => (/* binding */ userXdesignMaxVip),
/* harmony export */   "Um": () => (/* binding */ userProVipDk),
/* harmony export */   "V2": () => (/* binding */ userBasicVipDk),
/* harmony export */   "Vj": () => (/* binding */ teamIntlNotVip),
/* harmony export */   "ZB": () => (/* binding */ userXdesignPlusVip),
/* harmony export */   "ZF": () => (/* binding */ ChangeIdentityTipSourceEnum),
/* harmony export */   "g": () => (/* binding */ userVip),
/* harmony export */   "jU": () => (/* binding */ teamNotVip),
/* harmony export */   "pI": () => (/* binding */ userVipPc),
/* harmony export */   "vD": () => (/* binding */ teamVip)
/* harmony export */ });
/* unused harmony exports userXdesignBasic, changeIdentityTipInfo */
/**
 * ########### 权益图标 ###########
 */ // 国内版 团队vip
var teamVip = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/team-vip-20260601.png";
// 海外版 团队vip
var teamIntlVip = "https://x-design-static-release.stariicloud.com/xdesign-widgets/team-vip.png";
// 国内版 非团队vip
var teamNotVip = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/team-vip-not-20260601.png";
// 海外版 非团队vip
var teamIntlNotVip = "https://x-design-static-release.stariicloud.com/xdesign-widgets/team-vip-not.png";
// 国内版 个人vip（PC内嵌）
var userVipPc = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/vip-icon-20260601.png";
// 国内版 个人vip（web端）
var userVip = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/vip-icon-web-20260601.png";
// 海外版 个人 Basic
var userXdesignBasic = "https://x-design-static-release.stariicloud.com/xdesign-widgets/images/user-info/basic-icon.png";
// 国内版 个人pro_vip（web端）
var userPrpVip = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/pro-vip-icon-web-20260601.png";
// 国内版 个人pro_vip（pc端）
var userPrpVipPc = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/pro-vip-icon-pc.png";
// 海外版 个人vip
var userXdesignPlusVip = "https://x-design-static-release.stariicloud.com/xdesign-widgets/images/user-info/plus-icon.png";
var userXdesignProVip = "https://x-design-static-release.stariicloud.com/xdesign-widgets/images/user-info/pro-icon.png";
var userXdesignMaxVip = "https://x-design-static-release.stariicloud.com/xdesign-widgets/images/user-info/max-icon.png";
// 国内版 非个人vip（PC内嵌）
var userNotVipPc = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/not-vip-icon-20260601.png";
// 国内版 非个人vip（web端）
var userNotVip = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/not-vip-icon-web-20260601.png";
// 海外版 非个人vip
var userIntlNotVip = "https://x-design-static-release.stariicloud.com/xdesign-widgets/not-vip-pro-icon-intl.png";
// designkit 个人 Basic Vip
var userBasicVipDk = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/basic-vip-icon-dk.png";
// designkit 个人 Pro Vip
var userProVipDk = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/pro-vip-icon-dk.png";
// 身份切换引导提示缓存
var CHANGE_IDENTITY_TIP_KEY = "xdesign-widgets_change-identity-tip";
var ChangeIdentityTipSourceEnum = /*#__PURE__*/ function(ChangeIdentityTipSourceEnum) {
    ChangeIdentityTipSourceEnum["PROMOTION_MODAL"] = "promotionModal";
    ChangeIdentityTipSourceEnum["MEIDOU_PANEL"] = "meidouPanel";
    return ChangeIdentityTipSourceEnum;
}({});
// 记录强引导提示场景的相关状态
var changeIdentityTipInfo = {
    source: "",
    shouldShowTip: 0,
    hasShowTipMap: {
        promotionModal: 0,
        meidouPanel: 0
    }
};


/***/ }),

/***/ 6857:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G6": () => (/* binding */ isSafari),
/* harmony export */   "OF": () => (/* binding */ checkIsBeforeUnload),
/* harmony export */   "_Z": () => (/* binding */ registerStyleSheet),
/* harmony export */   "hJ": () => (/* binding */ isPad),
/* harmony export */   "uU": () => (/* binding */ copy2Clipboard)
/* harmony export */ });
var isSafari = function isSafari() {
    var ua = navigator.userAgent;
    return /Safari/.test(ua) && !/Chrome|Chromium/.test(ua) && navigator.vendor === "Apple Computer, Inc.";
};
var registerStyleSheet = function registerStyleSheet(styleCode, id) {
    var style = document.createElement("style");
    style.innerHTML = styleCode;
    if (id) {
        style.id = id;
    }
    document.body.appendChild(style);
    var remove = function remove() {
        document.body.removeChild(style);
    };
    return remove;
};
var copy2Clipboard = function copy2Clipboard(text) {
    return new Promise(function(resolve) {
        // safari的复制api不能在promise内部调用
        setTimeout(function() {
            navigator.clipboard.writeText(text).then(function() {
                return resolve({
                    success: true
                });
            }).catch(function(error) {
                ;
                resolve({
                    success: false,
                    error: error
                });
            });
        });
    });
};
/** 检查是否处于beforeunload的时机之后 (防止safari中断请求导致报错并继续执行catch逻辑) */ var checkIsBeforeUnload = function() {
    var isBeforeUnload = false;
    if (true) {
        window.addEventListener("beforeunload", function() {
            isBeforeUnload = true;
        });
    }
    return function() {
        return isBeforeUnload;
    };
}();
/**
 * 判断是否是平板设备（SSR 安全）
 */ var isPad = function isPad() {
    // SSR 环境（无 window/navigator/screen）
    if ( false || typeof navigator === "undefined" || typeof screen === "undefined") {
        return true; // SSR 下默认返回 true
    }
    var ua = navigator.userAgent.toLowerCase();
    var maxTouch = navigator.maxTouchPoints || 0;
    var dpr = window.devicePixelRatio || 1;
    var width = Math.min(window.screen.width, window.screen.height);
    // 1. iPad / iPadOS（iPadOS 13+ 会伪装成 Mac）
    if (/ipad/.test(ua) || /macintosh/.test(ua) && maxTouch > 1) {
        return true;
    }
    // 2. Android 平板（非手机）
    if (/android/.test(ua) && !/mobile/.test(ua)) {
        return true;
    }
    // 3. Windows / Linux / X11 平板（触屏设备）
    if ((/windows/.test(ua) || /linux/.test(ua) || /x11/.test(ua)) && maxTouch > 1) {
        // 增加 DPI 判断：一般平板 >= 1.5，触屏电脑多为 1.0~1.25
        var isHighDPI = dpr >= 1.5;
        // 宽度小于 1280 且高 DPI 视作平板，否则视作触屏电脑
        return width < 1280 && isHighDPI;
    }
    return false;
};


/***/ }),

/***/ 20820:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BD": () => (/* binding */ ENV_ENUM),
/* harmony export */   "G3": () => (/* binding */ getApiHost),
/* harmony export */   "HN": () => (/* binding */ getEnvPrefix),
/* harmony export */   "ZY": () => (/* binding */ webApiUrlStariiMap),
/* harmony export */   "n8": () => (/* binding */ getSubApiHost),
/* harmony export */   "p7": () => (/* binding */ getDomainName)
/* harmony export */ });
/* unused harmony exports webApiUrlDesignKitMap, getWebApiUrlMap, subApiUrlMap, subApiUrlStariiMap */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38389);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84480);


var ENV_ENUM = /*#__PURE__*/ function(ENV_ENUM) {
    ENV_ENUM["dev"] = "dev";
    ENV_ENUM["pre"] = "pre";
    ENV_ENUM["beta"] = "beta";
    ENV_ENUM["release"] = "release";
    return ENV_ENUM;
}({});
// 判断国际化产品域名后缀,
// 国内为 cn
// designkit 和海外为 com
var getDomainName = function getDomainName() {
    var _getConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)(), appName = _getConfig.appName, isIntl = _getConfig.isIntl;
    return appName === "designkit" && isIntl || isIntl ? "com" : "cn";
};
/**
 * DesignKit全球化api域名
 */ var webApiUrlDesignKitMap = (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, ENV_ENUM.dev, "https://pre.designkit.com/api"), ENV_ENUM.pre, "https://pre.designkit.com/api"), ENV_ENUM.beta, "https://beta.designkit.com/api"), ENV_ENUM.release, "https://www.designkit.com/api");
/**
 * 国内api域名
 */ var getWebApiUrlMap = function getWebApiUrlMap() {
    return (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, ENV_ENUM.dev, "https://prewebapi.designkit.cn"), ENV_ENUM.pre, "https://prewebapi.designkit.cn"), ENV_ENUM.beta, "https://betawebapi.designkit.cn"), ENV_ENUM.release, "https://webapi.designkit.cn");
};
/**
 * 海外api域名
 */ var webApiUrlStariiMap = (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, ENV_ENUM.dev, "https://pre.zawa.ai/api"), ENV_ENUM.pre, "https://pre.zawa.ai/api"), ENV_ENUM.beta, "https://beta.zawa.ai/api"), ENV_ENUM.release, "https://zawa.ai/api");
/**
 * 国内api域名
 */ var subApiUrlMap = (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, ENV_ENUM.dev, "https://pre-api-h5-sub.meitu.com"), ENV_ENUM.pre, "https://pre-api-h5-sub.meitu.com"), ENV_ENUM.beta, "https://beta-api-h5-sub.meitu.com"), ENV_ENUM.release, "https://api-h5-sub.meitu.com");
/**
 * 海外api域名
 */ var subApiUrlStariiMap = (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, ENV_ENUM.dev, "https://pre-api-h5-sub.starii.com"), ENV_ENUM.pre, "https://pre-api-h5-sub.starii.com"), ENV_ENUM.beta, "https://beta-api-h5-sub.starii.com"), ENV_ENUM.release, "https://api-h5-sub.starii.com");
var getEnvPrefix = function getEnvPrefix(env) {
    return env === "beta" ? "beta" : env === "release" ? "" : "pre";
};
var getApiHost = function getApiHost() {
    var _getConfig2 = (0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)(), isIntl = _getConfig2.isIntl, appName = _getConfig2.appName;
    if (isIntl && appName === "x-design") {
        return webApiUrlStariiMap[(0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().env];
    } else if (isIntl && appName === "designkit") {
        return webApiUrlDesignKitMap[(0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().env];
    }
    return getWebApiUrlMap()[(0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().env];
};
var getSubApiHost = function getSubApiHost() {
    var _getConfig3 = (0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)(), isIntl = _getConfig3.isIntl, appName = _getConfig3.appName;
    return isIntl && appName === "x-design" ? subApiUrlStariiMap[(0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().env] : subApiUrlMap[(0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().env];
};


/***/ }),

/***/ 82001:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17187);
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(events__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (new events__WEBPACK_IMPORTED_MODULE_0__.EventEmitter());


/***/ }),

/***/ 54345:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XF": () => (/* binding */ getClientLanguage),
/* harmony export */   "_A": () => (/* binding */ getSuffix),
/* harmony export */   "_v": () => (/* binding */ sleep),
/* harmony export */   "wf": () => (/* binding */ getRootDomain)
/* harmony export */ });
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84480);

function getRootDomain() {
    var hostname = window.location.hostname;
    // 分割域名为各个部分
    var parts = hostname.split(".").reverse();
    // 如果域名部分少于两个，直接返回
    if (parts.length < 2) {
        return hostname;
    }
    // 常见的二级顶级域名（ccTLDs）列表
    var commonTlds = [
        "co",
        "com",
        "org",
        "net",
        "gov",
        "edu",
        "mil"
    ];
    // 获取根域名
    var rootDomain = parts[1] + "." + parts[0];
    // 处理二级顶级域名情况
    if (commonTlds.includes(parts[1].toLowerCase()) && parts.length > 2) {
        rootDomain = parts[2] + "." + rootDomain;
    }
    return rootDomain;
}
var getSuffix = function getSuffix() {
    var _getConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)(), env = _getConfig.env;
    var suffix = "--".concat(env);
    if (env === _configProvider__WEBPACK_IMPORTED_MODULE_0__/* .ENV_ENUM.release */ .BD.release) {
        suffix = "";
    }
    return suffix;
};
/**
 * 获取服务端真正需要上报的语言值
 * @param locale 语言
 * @returns
 */ var getClientLanguage = function getClientLanguage(locale) {
    var fankuiLangMap = {
        cn: "zh-Hans",
        tw: "zh-Hant",
        en: "en",
        jp: "ja",
        kr: "ko",
        pt: "pt",
        es: "es",
        de: "de",
        id: "id",
        th: "th",
        fr: "fr",
        it: "it",
        vi: "vi",
        ja: "ja",
        ko: "ko",
        "zh-Hant": "zh-Hant",
        "zh-Hans": "zh-Hans"
    };
    return fankuiLangMap[locale] || "";
};
var sleep = function sleep(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
};


/***/ }),

/***/ 1225:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s6": () => (/* binding */ RESIGNED_CODE),
  "ZP": () => (/* binding */ utils_request),
  "hP": () => (/* binding */ getAccessToken),
  "Kj": () => (/* binding */ getCommonParams)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(81549);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 8 modules
var regeneratorRuntime = __webpack_require__(89255);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(87406);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 42 modules
var axios = __webpack_require__(5121);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-identity/lib/index.js
var lib = __webpack_require__(99861);
// EXTERNAL MODULE: ./node_modules/web-vitals/dist/web-vitals.js
var web_vitals = __webpack_require__(38085);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-utils/dist/index.es.js





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var LOCALSTORAGE_COUNTRYCODE_KEY = 'xdesign-utils__country-code';
var LOCALSTORAGE_IP_KEY = 'xdesign-utils__ip';
// 是否更新过本地国家码缓存
var hasUpdateLocalCountryCode = false;
// 正在请求状态
var fetchLoading = false;
var processingFetch = function () { };
var instanceFetch = null;
var getRequestUrl = function () {
    if (window.isIntl && window.deployApp === 'designkit') {
        return 'https://designkit-webapi.designkit.com';
    }
    return window.isIntl ? 'https://zawa.ai/api' : "https://webapi.designkit.cn";
};
var fetchRequest = function (timeout) { return __awaiter(void 0, void 0, void 0, function () {
    var defaultCode, res, data, ip, info, code;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                defaultCode = window.isIntl ? 'SG' : 'CN';
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                fetchLoading = true;
                return [4 /*yield*/, (0,axios/* default */.Z)("".concat(getRequestUrl(), "/common/ip_location"), {
                        params: { ts_random_id: (0,v4/* default */.Z)() },
                        timeout: timeout,
                    })];
            case 2:
                res = _b.sent();
                data = ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data) || {};
                ip = Object.keys(data)[0] || '';
                info = data[ip] || {};
                code = info === null || info === void 0 ? void 0 : info.nation_code;
                if (code) {
                    hasUpdateLocalCountryCode = true;
                    // 更新缓存
                    window.localStorage.setItem(LOCALSTORAGE_COUNTRYCODE_KEY, code);
                    window.localStorage.setItem(LOCALSTORAGE_IP_KEY, ip);
                }
                processingFetch(code || defaultCode);
                fetchLoading = false;
                return [3 /*break*/, 4];
            case 3:
                _b.sent();
                processingFetch(defaultCode);
                fetchLoading = false;
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
var handleGetCodeProcess = function (timeout) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                fetchRequest(timeout || 200);
                return [4 /*yield*/, new Promise(function (resolve) { return (processingFetch = resolve); })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * 获取云储存分摊埋点透传值
 * @param timeout ip_location接口超时时间
 * @returns
 */
var getCountryCode = function (timeout) { return __awaiter(void 0, void 0, void 0, function () {
    var country_code, country_code_local, _a;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                country_code_local = (_b = window === null || window === void 0 ? void 0 : window.localStorage) === null || _b === void 0 ? void 0 : _b.getItem(LOCALSTORAGE_COUNTRYCODE_KEY);
                if (!!country_code_local) return [3 /*break*/, 5];
                if (!instanceFetch) return [3 /*break*/, 2];
                return [4 /*yield*/, instanceFetch];
            case 1:
                _a = _c.sent();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, (instanceFetch = handleGetCodeProcess(timeout))];
            case 3:
                _a = _c.sent();
                _c.label = 4;
            case 4:
                // 处理并发情况
                country_code = _a;
                // 成功后释放实例
                instanceFetch = null;
                return [3 /*break*/, 6];
            case 5:
                country_code = country_code_local;
                _c.label = 6;
            case 6:
                // 如果还没请求过接口，异步更新本地缓存
                if (!hasUpdateLocalCountryCode && !fetchLoading) {
                    fetchRequest(3000);
                }
                return [2 /*return*/, country_code];
        }
    });
}); };
/**
 * 获取当前用户 IP 地址（同步，仅读取缓存）
 */
var getIpAddress = function () {
    var _a;
    return ((_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem(LOCALSTORAGE_IP_KEY)) || '';
};
/**
 * 获取当前用户 IP 地址（异步，无缓存时会等待请求完成）
 * @param timeout ip_location接口超时时间
 */
var getIpAddressAsync = function (timeout) { return __awaiter(void 0, void 0, void 0, function () {
    var ip_local;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                ip_local = (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem(LOCALSTORAGE_IP_KEY);
                if (ip_local) {
                    if (!hasUpdateLocalCountryCode && !fetchLoading) {
                        fetchRequest(3000);
                    }
                    return [2 /*return*/, ip_local];
                }
                return [4 /*yield*/, getCountryCode(timeout)];
            case 1:
                _c.sent();
                return [2 /*return*/, ((_b = window === null || window === void 0 ? void 0 : window.localStorage) === null || _b === void 0 ? void 0 : _b.getItem(LOCALSTORAGE_IP_KEY)) || ''];
        }
    });
}); };

/**
 * 获取云储存分摊埋点透传值
 * @param options
 * @returns
 */
var getMTCCClient = function (options) { return __awaiter(void 0, void 0, void 0, function () {
    var gid, functionInfo, positionInfo, isToB, virtualId, uid, osType, app_id, isIntl, isTeam, isPcPlatform, mediaType, resMediaType, biz_id, isWPSWeb, isWPSPc, payInfo, country_code, appId, bizType;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                gid = options.gid, functionInfo = options.functionInfo, positionInfo = options.positionInfo, isToB = options.isToB, virtualId = options.virtualId, uid = options.uid, osType = options.osType, app_id = options.app_id, isIntl = options.isIntl, isTeam = options.isTeam, isPcPlatform = options.isPcPlatform, mediaType = options.mediaType, resMediaType = options.resMediaType, biz_id = options.biz_id, isWPSWeb = options.isWPSWeb, isWPSPc = options.isWPSPc, payInfo = options.payInfo;
                return [4 /*yield*/, getCountryCode()];
            case 1:
                country_code = _a.sent();
                appId = '';
                if (app_id) {
                    // 业务自定义
                    appId = app_id;
                }
                else if (isPcPlatform) {
                    // pc内嵌下
                    appId = '8045';
                }
                else if (isIntl || window.isIntl) {
                    // designKit 全球化 / 海外 x-design
                    appId = window.deployApp === 'designkit' ? '227' : '2000010';
                }
                else {
                    // web国内
                    appId = '178';
                }
                bizType = '';
                if (isTeam) {
                    bizType = 'team';
                }
                else if (isToB) {
                    bizType = 'api';
                }
                else if (isWPSWeb) {
                    bizType = 'wps_web';
                }
                else if (isWPSPc) {
                    bizType = 'wps_pc';
                }
                return [2 /*return*/, btoa(JSON.stringify({
                        app_id: appId,
                        biz_id: biz_id || '',
                        os_type: osType,
                        country_code: country_code,
                        gnum: gid,
                        function: functionInfo,
                        position: positionInfo,
                        media_type: mediaType,
                        res_media_type: resMediaType,
                        ext_info: {
                            biz_type: bizType,
                            virtual_id: virtualId,
                            pay_info: payInfo || {},
                        },
                        uid: uid || '',
                    }))];
        }
    });
}); };

var num = 0;
var getDemo = function () {
    num++;
    return num;
};

/**
 * 初始化访问两个页面上报代码
 * @param callback
 */
var initViewMoreThan2Pages = function (callback) {
    var pageViewCount = Number(localStorage.getItem('gaPageViewCount'));
    pageViewCount++;
    if (pageViewCount === 3) {
        // 广告转化
        callback('conversion', {
            send_to: 'AW-871914325/YIzgCInN5ssZENW24Z8D',
        });
        // ga 事件
        callback('view_more_than_2_pages', {});
    }
    localStorage.setItem('gaPageViewCount', String(pageViewCount));
};
/**
 * 初始化访问超过1分钟页面上报代码
 * @param callback
 */
var initViewMoreThan1Min = function (callback) {
    var currentTotalTime = Number(localStorage.getItem('gaTotalTime')) || 0;
    var timer;
    if (currentTotalTime < 60) {
        var totalTime_1 = 0;
        timer = setInterval(function () {
            if (localStorage.getItem('gaTotalTime') != null) {
                totalTime_1 = Number(localStorage.getItem('gaTotalTime')) || 0;
                totalTime_1++;
                if (totalTime_1 > 60) {
                    clearInterval(timer);
                    return;
                }
                localStorage.setItem('gaTotalTime', String(totalTime_1));
                if (totalTime_1 == 60) {
                    // 广告转化
                    callback('conversion', {
                        send_to: 'AW-871914325/mF1GCIbN5ssZENW24Z8D',
                    });
                    //GA4
                    callback('view_more_than_1_min', {});
                }
            }
            else {
                totalTime_1 = 0;
                localStorage.setItem('gaTotalTime', String(totalTime_1));
            }
        }, 1000);
    }
};
/**
 * @description 轮询获取gtag 是否已经动态插入
 * @returns
 */
var checkGtagLoaded = function () {
    var count = 0;
    return new Promise(function (res, rej) {
        // 如果 gtag 未定义，轮询检查,超过1分钟直接暂停
        var interval = setInterval(function () {
            if (window.dataLayer && window.gtag) {
                clearInterval(interval);
                res(true);
            }
            count++;
            // 超过60秒 放弃轮询
            if (count > 30) {
                clearInterval(interval);
                rej({ message: 'not gtag' });
            }
        }, 2000); // 每2秒检查一次
    });
};
/**
 * @description 初始化基础分析
 * @param param
 */
var initBasicAnalysis = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var e_1;
    var hasViewMoreThan2Pages = _b.hasViewMoreThan2Pages, hasViewMoreThan1Min = _b.hasViewMoreThan1Min, callback = _b.callback;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 2, , 3]);
                return [4 /*yield*/, checkGtagLoaded()];
            case 1:
                _c.sent();
                hasViewMoreThan2Pages && initViewMoreThan2Pages(callback);
                hasViewMoreThan1Min && initViewMoreThan1Min(callback);
                return [3 /*break*/, 3];
            case 2:
                e_1 = _c.sent();
                console.log(e_1);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };

// 埋点文档 https://dayu.starii-rover.com/requirement/requirement?sso_code=7218504577643970560_1721025604
var DEFAULT_CONFIG = {
    debug_mode: true,
    traffic_type: 'internal',
};
/**
 * @description GAEventTracker 类 谷歌自定义事件埋点
 */
var GAEventTracker = /** @class */ (function () {
    function GAEventTracker() {
        this.entrance = null;
        this.isStopGa = false; // 默认收集 ga 自定义事件
        this.env = 'pre'; // 默认为pre环境
    }
    /**
     * @description 获取当前埋点入口
     * @returns
     */
    GAEventTracker.prototype.getEntrance = function () {
        return this.entrance;
    };
    /**
     * @description 设置当前埋点入口
     * @param newEntrance
     * @example
     *     比如用户在导航登录按钮点击之后需要设置当前埋点入口为 TopNav
     *     gaEventTracker.setEntrance('TopNav')
     */
    GAEventTracker.prototype.setEntrance = function (newEntrance) {
        this.entrance = newEntrance;
    };
    /**
     * @description 获取是否暂停ga 收集 状态
     * @returns
     */
    GAEventTracker.prototype.getIsStopGa = function () {
        return this.isStopGa;
    };
    /**
     * @description 设置是否暂停ga 收集
     * @param {boolean} bool     是否暂停
     * @example
     *     setStopGa(true)   // 停止收集
     *     setStopGa(false)  // 开始收集
     */
    GAEventTracker.prototype.setStopGa = function (bool) {
        this.isStopGa = bool;
    };
    /**
     * @description 设置配置
     * @param {"pre"|"beta"|"release"}  pre                          环境
     * @param {boolean} [isStopGa = false] isStopGa                  是否暂停ga 收集 默认为false
     * @example
     *     setConfig({env:'pre'}) // 设置环境为pre
     *     setConfig({env:'pre',isStopGa: true}) // 设置环境为pre,暂停ga 自定义事件收集
     */
    GAEventTracker.prototype.setConfig = function (config) {
        var _this = this;
        var env = config.env, _a = config.isStopGa, isStopGa = _a === void 0 ? false : _a, _b = config.hasViewMoreThan1Min, hasViewMoreThan1Min = _b === void 0 ? true : _b, _c = config.hasViewMoreThan2Pages, hasViewMoreThan2Pages = _c === void 0 ? true : _c;
        this.env = env;
        this.isStopGa = isStopGa;
        // 默认添加 网页浏览超过2页面 & 网页浏览超过1分钟 统计
        if (typeof window !== 'undefined') {
            initBasicAnalysis({
                hasViewMoreThan2Pages: hasViewMoreThan2Pages,
                hasViewMoreThan1Min: hasViewMoreThan1Min,
                callback: function (eventName, eventParams) {
                    _this.sendGaEvent(eventName, eventParams);
                },
            });
        }
    };
    /**
     * @description 获取当前环境
     * @returns
     */
    GAEventTracker.prototype.getEnv = function () {
        return this.env;
    };
    /**
     * @description 获取GAEventTracker实例
     * @returns
     */
    GAEventTracker.getInstance = function () {
        if (!GAEventTracker.instance) {
            GAEventTracker.instance = new GAEventTracker();
        }
        return GAEventTracker.instance;
    };
    /**
     * @description 发送GA事件
     * @param {string} eventName
     * @param {any} eventParams
     * @example
     *     目前之封装了注册|登录、购买成功的、保存成功的事件（都是基于 sendGaEvent 事件来的），如果其他事件需要发送，可以直接调用sendGaEvent方法
     */
    GAEventTracker.prototype.sendGaEvent = function (eventName, eventParams) {
        var _a;
        if (this.isStopGa) {
            // 暂停事件收集，直接退出
            return;
        }
        // 发送GA事件
        // debug_mode 模式打开可在谷歌分析后台debugview 里查看实时事件
        // traffic_type = internal 区分内部测试数据，beta|pre 环境都是内部测试数据，release 环境是正式数据
        if (window.dataLayer && window.gtag) {
            var params = eventParams;
            if (this.env !== 'release') {
                params = __assign(__assign({}, params), DEFAULT_CONFIG);
            }
            (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, 'event', eventName, params);
        }
    };
    /**
     * @description 发送登录/注册结果GA事件
     * @param {boolean} isRegister                          是否注册  MeituAccount里的 onLoginSuccess 第二个参数可以区分是否注册
     * @param {string|undefined} [platform='email']         平台（登录方式） MeituAccount里的 onLoginSuccess 第一个参数的platform属性 可以区分平台，
     * @param {string} pageName                             页面名称
     * @param {string|undefined} [entrance]                 入口名称
     * @example
     *     MeituAccount({
     *            ......
     *            onLoginSuccess: (result, isRegister) => {
     *                    //result.platform 是存在undefined 的情况的
     *                    const pageName = 'home'
     *                    const entrance = 'xxxxx' // 入口名称
     *                    gaEventTracker.sendLoginGaTrack(isRegister, result.platform, pageName, entrance)
     *            }
     *            ....
     *    })
     * @see MeituAccount 登录注册接口文档 https://f2er.meitu.com/account/api/account-alipay-mini-program/function/onLoginSuccess
     */
    GAEventTracker.prototype.sendLoginGaTrack = function (isRegister, platform, pageName, entrance) {
        if (platform === void 0) { platform = 'email'; }
        // ads转化代码
        if (isRegister) {
            this.sendGaEvent('conversion', {
                send_to: 'AW-871914325/fpXBCIPN5ssZENW24Z8D',
            });
        }
        this.sendGaEvent(isRegister ? 'register_result' : 'login_result', {
            page_name: pageName,
            method: platform,
            entrance: entrance || this.entrance || 'topnav',
        });
    };
    /**
     * @description 发送购买结果GA事件
     * @param {OrderTradeProgress[]} tradeProgress        订单交易数据
     * @param {boolean} isVip                             是否是会员
     * @param {string} funcSource                         功能来源
     * @param {string|undefined} [entrance]               入口名称
     * @example
     *    openSubscribePopup({
     *            ......
     *            onTradeFinish(tradeProgress) {
     *                const isVip = true // 假设是会员
     *                const funcSource = 'home' // 假设是首页
     *                const entrance = 'xxxxx' // 入口名称
     *                gaEventTracker.sendPurchaseGaTrack(tradeProgress, isVip, funcSource,entrance)
     *            }
     *            ......
     *    })
     * @see tradeProgress 交易接口文档 https://f2er.meitu.com/subscribe/api/subscribe-core/interface/OrderTradeProgressProduct
     */
    GAEventTracker.prototype.sendPurchaseGaTrack = function (tradeProgress, isVip, funcSource, entrance) {
        var _this = this;
        tradeProgress.forEach(function (v, i) {
            var _a = v.product, productId = _a.productId, moneyUnit = _a.moneyUnit, price = _a.price, isProbation = _a.isProbation, payChannel = v.payChannel, transactionId = v.transactionId;
            var gaData = {
                value: price,
                currency: moneyUnit,
                transaction_id: transactionId,
                user_type: isVip ? 1 : 0,
                item_id: productId,
                payment_type: payChannel,
                is_try: isProbation ? 0 : 1,
                func_source: funcSource,
                entrance: entrance || _this.entrance || 'topnav',
            };
            // ads转化代码
            _this.sendGaEvent('conversion', {
                send_to: 'AW-871914325/CMpSCIzN5ssZENW24Z8D',
            });
            // ga
            _this.sendGaEvent('purchase', gaData);
        });
    };
    /**
     * @description     发送保存成功GA事件
     * @param {string} from                               来源
     * @param {string} func                               功能名称
     * @example
     *      const from = 'home';// 假设是home, 可以调用 getFrom() 方法获取来源，如果有的话
     *      const func = 'create_now';// 假设是create_now
     *      sendSaveSuccessGaTrack(from, func)
     */
    GAEventTracker.prototype.sendSaveSuccessGaTrack = function (from, func) {
        if (func === void 0) { func = 'create_now'; }
        // 获取链接from参数
        this.sendGaEvent('save_success', {
            source: from || 'other',
            func: func,
        });
    };
    GAEventTracker.prototype.sendUploadClickGaTrack = function () {
        // 获取链接from参数
        this.sendGaEvent('upload_click', {});
    };
    return GAEventTracker;
}());
var gaEventTracker = GAEventTracker.getInstance();

/**
 * @description 弹窗弹出管理器，目前支持登录和下载 时机时主动弹出订阅弹窗
 */
var PopupManager = /** @class */ (function () {
    // 私有构造函数，防止外部实例化
    function PopupManager() {
        this.maxLoginPopupCount = 1;
        this.maxDownloadPopupCount = 1;
        this.state = {
            currentLoginPopupCount: 0,
            currentDownloadPopupCount: 0,
        };
        if (typeof window !== 'undefined') {
            // 仅在客户端环境中访问 localStorage
            var savedState = localStorage.getItem('popupState');
            if (savedState) {
                this.state = JSON.parse(savedState);
            }
            else {
                this.updateState();
            }
        }
    }
    // 获取单例实例
    PopupManager.getInstance = function () {
        if (!PopupManager.instance) {
            PopupManager.instance = new PopupManager();
        }
        return PopupManager.instance;
    };
    // 设置配置方法
    /**
   * @description 设置配置方法
   * @param config PopupConfig
   * @example
   *
   *      //项目初始化的时候
   *      setConfig({
   *        maxLoginPopupCount: 1, // 最大登录弹窗次数
            maxDownloadPopupCount: 1, // 最大下载弹窗次数
   *      })
   */
    PopupManager.prototype.setConfig = function (config) {
        var maxLoginPopupCount = config.maxLoginPopupCount, maxDownloadPopupCount = config.maxDownloadPopupCount;
        if (maxLoginPopupCount !== undefined) {
            this.maxLoginPopupCount = maxLoginPopupCount;
        }
        if (maxDownloadPopupCount !== undefined) {
            this.maxDownloadPopupCount = maxDownloadPopupCount;
        }
    };
    // 更新并保存状态到 localStorage
    PopupManager.prototype.updateState = function () {
        localStorage.setItem('popupState', JSON.stringify(this.state));
    };
    /**
   * @description 弹出处理方法
   * @param popupType
   * @param callback
   * @example
   *     在需要主动弹出订阅时调用
   *     popupManager.handlePopup("login", () => {
   *        // 弹出订阅窗口 逻辑，比如 (openVipModal 是业务方打开订阅窗口公共方法)
   *        openVipModal({
              entrance: xxxx,
              source: xxxx,
              trackEntrance: xxxxx,
            })
   *     })
   */
    PopupManager.prototype.handlePopup = function (popupType, callback) {
        if (popupType === 'login') {
            if (this.state.currentLoginPopupCount < this.maxLoginPopupCount) {
                this.state.currentLoginPopupCount++;
                this.updateState();
                callback();
            }
        }
        else if (popupType === 'download') {
            if (this.state.currentDownloadPopupCount < this.maxDownloadPopupCount) {
                this.state.currentDownloadPopupCount++;
                this.updateState();
                callback();
            }
        }
    };
    /**
     * @description 退出登录清空数据
     * @example
     *      //退出登录时调用
     *      popupManager.logout()
     */
    PopupManager.prototype.logout = function () {
        if (typeof window !== 'undefined') {
            localStorage.removeItem('popupState');
        }
        this.state = {
            currentLoginPopupCount: 0,
            currentDownloadPopupCount: 0,
        };
    };
    return PopupManager;
}());
var popupManager = PopupManager.getInstance();

var checkDebugConfig = function () {
    var localConfig = window.localStorage.getItem('performanceMonitor');
    if (!localConfig) {
        return false;
    }
    try {
        var debug_1 = JSON.parse(localConfig).debug;
        return !!debug_1;
    }
    catch (e) {
        return false;
    }
};
var prettyLog = function (title, text, rating) {
    var color = '#00a67d';
    if (rating === 'needs-improvement') {
        color = '#ffc92e';
    }
    if (rating === 'poor') {
        color = '#f22c3d';
    }
    console.log("%c ".concat(title, " %c ").concat(text, "ms %c"), "background:".concat(color, ";border:1px solid ").concat(color, "; padding: 1px; border-radius: 2px 0 0 2px; color: #fff;"), "border:1px solid ".concat(color, "; padding: 1px; border-radius: 0 2px 2px 0; color: ").concat(color, ";"), 'background:transparent');
};
var log = function (name, data) {
    if (!checkDebugConfig()) {
        return;
    }
    var arr = __spreadArray([], (0,lodash.map)(data, function (value, key) { return ({ key: key, value: value }); }), true);
    console.table(arr, ['key', 'value']);
    prettyLog(name, data.value || data.duration, data.rating);
};
/**
 * 获取当前网络信息
 * @returns 网络信息对象
 */
var getNetworkInfo = function () {
    var networkInfo = {};
    // 获取连接类型信息
    if (navigator.connection) {
        var connection = navigator.connection;
        networkInfo.effectiveType = connection.effectiveType || 'unknown'; // 有效网络类型：4g、3g、2g、slow-2g
        networkInfo.downlink = connection.downlink || 0; // 下行速度(Mbps)
        networkInfo.rtt = connection.rtt || 0; // 往返时间(ms)
        networkInfo.saveData = connection.saveData || false; // 是否启用省流量模式
        networkInfo.type = connection.type || 'unknown'; // 网络类型
    }
    // 获取在线状态
    networkInfo.online = navigator.onLine;
    return networkInfo;
};
/**
 * @description 上报埋点
 * @param data
 */
var handlerWebVitalsTrack = function (data) {
    var metric = data.metric, name = data.name, statTrack = data.statTrack, domInfo = data.domInfo;
    log(name, metric);
    statTrack('tech_metric_web_basic', {
        metric_type: name,
        duration: metric.value,
        score: metric.rating,
        //源数据
        metricData: metric,
        //是否登录, 首页和工作台访问需要区分是否登录
        isLogin: !!window.localStorage.getItem('uid'),
        // 网络情况数据
        networkInfo: getNetworkInfo(),
        // 元素信息
        domInfo: domInfo,
    });
};
/**
 *
 * @param url 获取url参数长度
 * @returns
 */
var getUrlParamsLength = function (url) {
    var queryIndex = url.indexOf('?');
    if (queryIndex === -1)
        return 0; // 没有参数
    return url.length - queryIndex - 1;
};
/**
 * 获取请求参数数据
 * @param response Axios响应对象
 * @returns POST请求返回data数据，GET请求返回params数据
 */
var getUrlParamsData = function (config) {
    var method = config.method;
    if ((method === null || method === void 0 ? void 0 : method.toUpperCase()) === 'POST') {
        return config.data;
    }
    else {
        return config.params;
    }
};
/**
 * 获取请求 status 对应的 code (埋点用), 2xx 都算成功
 * @param status 状态码
 * @returns number 1: 成功，0: 失败
 */
var getRequestSuccess = function (status) {
    return status >= 200 && status < 300 ? 1 : 0;
};
/**
 * @description 获取DOM元素的className
 * @param metric
 * @returns
 */
var getDomInfo = function (metric) {
    var className = '';
    var nodeName = '';
    var innerText = '';
    try {
        var entriesData = metric.entries;
        if (entriesData && entriesData[0]) {
            var target = entriesData[0].target;
            if (target) {
                if (target.className) {
                    className = target.className;
                }
                if (target.nodeName) {
                    nodeName = target.nodeName;
                }
                if (target.innerText) {
                    innerText = target.innerText;
                }
            }
        }
    }
    catch (e) {
        console.log(e);
    }
    return {
        className: className,
        nodeName: nodeName,
        innerText: innerText,
    };
};

/**
 * @description 性能监控与埋点工具箱
 * 提供Web性能监控和各类操作耗时统计的能力
 * @link 埋点文档: https://dayu.starii-rover.com/requirement/requirement?id=3096&appId=227&platformAgg=WEB&fullScreen=true
 * @link 需求文档：https://cf.meitu.com/confluence/pages/viewpage.action?pageId=549555498
 */
var performanceMonitor = {
    utils: {
        getUrlParamsData: getUrlParamsData,
        getUrlParamsLength: getUrlParamsLength,
    },
    setConfig: function (config) {
        window.localStorage.setItem('performanceMonitor', JSON.stringify(config));
    },
    /**
     * @description 监控并上报Web Vitals核心性能指标
     * 包括：TTFB, LCP, FCP, INP, CLS
     * @param statTrack 数据上报函数
     * @param sentry Sentry实例 （预留）
     */
    reportWebVitals: function (statTrack, sentry) {
        /**
         * @description 测量 TTFB (Time to First Byte)
         * 测量从请求开始到收到第一个字节的时间
         * 反映服务器响应速度
         * @example 如果 value 是 200，表示用了 200ms 接收到首字节
         */
        (0,web_vitals/* onTTFB */.mr)(function (metric) {
            handlerWebVitalsTrack({ metric: metric, name: 'TTFB', statTrack: statTrack });
        });
        /**
         * @description  LCP (Largest Contentful Paint)
         * 测量页面最大内容元素的渲染时间
         * 反映页面加载性能
         * @example 如果 value 是 2000，表示最大内容元素渲染了 2000ms
         */
        (0,web_vitals/* onLCP */.NO)(function (metric) {
            handlerWebVitalsTrack({ metric: metric, name: 'LCP', statTrack: statTrack });
        }, { reportAllChanges: true });
        /**
         * @description  FCP (First Contentful Paint)
         * 测量首次内容绘制时间
         * 反映用户首次看到实际内容的时间
         * @example 如果 value 是 1000，表示用户在 1 秒后看到第一个内容
         */
        (0,web_vitals/* onFCP */.a4)(function (metric) {
            handlerWebVitalsTrack({ metric: metric, name: 'FCP', statTrack: statTrack });
        });
        /**
         * @description  INP (Interaction to Next Paint)
         * 测量交互到下一次绘制的时间
         * 反映页面交互响应性能
         * @example 如果 value 是 200，表示用户交互后200ms内完成了视觉更新
         */
        (0,web_vitals/* onINP */.Yn)(function (metric) {
            handlerWebVitalsTrack({
                metric: metric,
                name: 'INP',
                statTrack: statTrack,
                domInfo: getDomInfo(metric),
            });
        }, { reportAllChanges: true });
        /**
         * @description  CLS (Cumulative Layout Shift)
         * 测量累积布局偏移
         * 反映页面视觉稳定性
         * @example 如果 value 是 0.1，表示页面的视觉稳定性较好，得分范围通常在 0-1 之间，越接近 0 越好
         */
        (0,web_vitals/* onCLS */.mw)(function (metric) {
            handlerWebVitalsTrack({ metric: metric, name: 'CLS', statTrack: statTrack });
        }, { reportAllChanges: true });
    },
    /**
     * @description 获取操作开始时间戳
     * 用于记录任意操作的开始时间，如API请求、资源下载、计算过程等
     * @example
     * const startTime = performanceMonitor.getStartTime();
     * @returns {number} 当前时间戳（performance.now()）
     */
    getStartTime: function () {
        return performance.now();
    },
    /**
     * @description 上报操作耗时[通用]
     * 计算并上报任意操作的耗时数据，如API请求、资源下载、计算过程等
     * @param data.startTime 操作开始时间戳
     * @param data.statTrack 数据上报函数
     * @param data.eventName 埋点事件名称
     * @param data.trackData 可选，附加数据
     * @param data.sentry Sentry实例 （预留）
     * @param callback 可选，回调函数，用于处理补充逻辑
     *
     * @example
     * // API请求耗时上报
     * performanceMonitor.reportTiming({
     *   startTime,
     *   statTrack,
     *   eventName: "api_request",
     *   trackData: { url: "/api/users", method: "GET" }
     * });
     *
     * // 资源加载耗时上报
     * performanceMonitor.reportTiming({
     *   startTime,
     *   statTrack,
     *   eventName: "resource_load",
     *   trackData: { type: "image", url: "https://example.com/image.png" }
     * });
     */
    reportTiming: function (data, callback) {
        var startTime = data.startTime, statTrack = data.statTrack, _a = data.eventName, eventName = _a === void 0 ? 'general_timing' : _a, _b = data.trackData, trackData = _b === void 0 ? {} : _b;
        var duration = performance.now() - startTime;
        log(eventName, __assign(__assign({}, trackData), { duration: duration }));
        statTrack(eventName, __assign(__assign({}, trackData), { duration: duration }));
        callback === null || callback === void 0 ? void 0 : callback();
    },
    /**
     * @description 上报Axios请求耗时
     * 计算并上报 Axios 请求的耗时数据
     * @param data.statTrack 数据上报函数
     * @param data.config Axios请求配置
     * @param data.status 响应状态码
     * @param data.sentry 可选 Sentry实例 （预留）
     * @param callback 可选，回调函数，用于处理补充逻辑
     * @example
     * @example
     * // 假设在Axios请求拦截器中记录了请求开始时间
     * axios.interceptors.request.use(config => {
     *   config.startTime = performance.now();  // 记录请求开始时间
     *   return config;
     * });
     *
     * // 在响应拦截器中计算并上报耗时
     * axios.interceptors.response.use(response => {
     *   const { startTime, statTrack } = response.config;   // 从请求配置中获取开始时间
     *   performanceMonitor.reportRequestTiming({
     *     statTrack,
     *     status: response.status,  // 响应状态码
     *     config: response.config  // 完整的请求配置
     *   });
     *   return response;  // 继续处理响应
     * })
     */
    reportRequestTiming: function (data, callback) {
        var config = data.config, statTrack = data.statTrack, status = data.status;
        if (!config)
            return;
        var startTime = config.startTime, method = config.method, url = config.url;
        if (!startTime || !url)
            return;
        this.reportTiming({
            startTime: startTime,
            statTrack: statTrack,
            eventName: 'tech_metric_api_request_result',
            trackData: {
                is_success: status !== undefined ? getRequestSuccess(status) : 0,
                api_endpoint: url,
                request_method: method ? method.toUpperCase() : undefined,
                request_params: getUrlParamsData(config),
                param_length: getUrlParamsLength(url),
            },
        }, callback);
    },
    /**
     * @description 监控DOM元素渲染时间
     * 使用MutationObserver监听特定DOM元素的变化，计算并上报渲染耗时
     * @param data.startTime 可选，开始时间戳
     * @param data.statTrack 数据上报函数
     * @param data.element 要监控的DOM元素引用（例如React的ref.current）
     * @param data.eventName 埋点事件名称
     * @param data.trackData 可选，额外上报数据
     * @param data.config 可选，MutationObserver配置
     * @param data.timeout 可选，监控超时时间(ms)，默认10000ms
     * @param data.waitForImages 可选，是否要等待src属性的图片加载完成，默认true [大部分都是图片列表，如果只是简单监听dom渲染可以直接设置为false]
     * @param data.sentry 可选 Sentry实例 （预留）
     * @param callback 可选，回调函数，用于处理补充逻辑
     *
     * @returns MutationObserver实例，可用于手动断开观察
     * @example
     * // 在React组件中使用
     * const contentRef = useRef(null);
     * useEffect(() => {
     *   // startTime 可选，reportRenderTime 方法里有做自动获取 startTime 处理
     *   const startTime = performanceMonitor.getStartTime();
     *   // 数据加载完成后监控DOM渲染
     *   performanceMonitor.reportRenderTime({
     *     startTime,
     *     element: contentRef.current,
     *     statTrack,
     *     eventName: "list_render",
     *     trackData: { itemsCount: items.length }
     *   });
     * }, [items]);
     */
    reportRenderTime: function (data, callback) {
        var _a = data.startTime, startTime = _a === void 0 ? this.getStartTime() : _a, statTrack = data.statTrack, element = data.element, eventName = data.eventName, _b = data.trackData, trackData = _b === void 0 ? {} : _b, _c = data.config, config = _c === void 0 ? {
            childList: true,
            subtree: true,
            attributes: true,
        } : _c, _d = data.timeout, timeout = _d === void 0 ? 10000 : _d, _e = data.waitForImages, waitForImages = _e === void 0 ? true : _e;
        if (!element) {
            console.warn('reportRenderTime：The element is null.');
            return null;
        }
        // 防止重复上报
        var hasReported = false;
        // 创建MutationObserver实例
        var observer = new MutationObserver(function (mutations) {
            if (hasReported)
                return;
            // 确保DOM渲染后再检查图片
            requestAnimationFrame(function () {
                if (waitForImages) {
                    // 获取容器内所有图片
                    var images_1 = element.querySelectorAll('img');
                    if (images_1.length === 0) {
                        // 没有图片，直接上报DOM渲染时间
                        reportTiming();
                        return;
                    }
                    // 检查所有图片是否已加载
                    var loadedCount_1 = 0;
                    var imageArray = Array.from(images_1);
                    // 已加载的图片计数
                    imageArray.forEach(function (img) {
                        if (img.complete) {
                            loadedCount_1++;
                        }
                        else {
                            // 为未加载完的图片添加事件监听
                            img.addEventListener('load', function () {
                                if (hasReported)
                                    return; // 先检查是否已上报
                                loadedCount_1++;
                                if (loadedCount_1 === images_1.length) {
                                    reportTiming();
                                }
                            });
                            // 处理图片加载失败情况
                            img.addEventListener('error', function () {
                                if (hasReported)
                                    return; // 先检查是否已上报
                                loadedCount_1++;
                                if (loadedCount_1 === images_1.length) {
                                    reportTiming();
                                }
                            });
                        }
                    });
                    // 如果所有图片已经加载完成，直接上报
                    if (loadedCount_1 === images_1.length && !hasReported) {
                        // 确保这里也检查hasReported
                        reportTiming();
                    }
                }
                else {
                    // 不等待图片加载，仅监控DOM变化
                    reportTiming();
                }
            });
        });
        // 上报时间的函数
        function reportTiming() {
            if (hasReported)
                return; // 即使被多次调用也不会重复上报
            var duration = performance.now() - startTime;
            log(eventName, __assign(__assign({}, trackData), { duration: duration }));
            statTrack(eventName, __assign(__assign({}, trackData), { duration: duration }));
            hasReported = true;
            observer.disconnect();
            callback === null || callback === void 0 ? void 0 : callback();
        }
        observer.observe(element, config);
        // 设置超时，防止无限等待
        setTimeout(function () {
            if (!hasReported) {
                var duration = -1;
                statTrack(eventName, __assign(__assign({}, trackData), { duration: duration }));
                observer.disconnect();
                callback === null || callback === void 0 ? void 0 : callback({ timeout: true });
            }
        }, timeout);
    },
};



// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/message/index.js
var message = __webpack_require__(77977);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/configProvider/index.js
var configProvider = __webpack_require__(84480);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/env.js
var env = __webpack_require__(20820);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/index.js
var utils = __webpack_require__(54345);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/i18n/index.js + 12 modules
var i18n = __webpack_require__(32907);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/index.js
var wps_utils = __webpack_require__(68626);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/request.js













var getCommonParams = /*#__PURE__*/ function() {
    var _ref = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
        var _getConfig$userInfo$e, _getConfig$userInfo;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    _context.t0 = (0,configProvider/* getConfig */.iE)().gid;
                    _context.t1 = (_getConfig$userInfo$e = (_getConfig$userInfo = (0,configProvider/* getConfig */.iE)().userInfo) === null || _getConfig$userInfo === void 0 ? void 0 : _getConfig$userInfo.education_role) !== null && _getConfig$userInfo$e !== void 0 ? _getConfig$userInfo$e : "";
                    _context.t2 = (0,configProvider/* getConfig */.iE)().client_id;
                    _context.t3 = (0,configProvider/* getConfig */.iE)().env === env/* ENV_ENUM.release */.BD.release ? 0 : 1;
                    _context.t4 = (0,utils/* getClientLanguage */.XF)((0,i18n/* getLocaleStore */.IK)().locale);
                    _context.next = 7;
                    return getCountryCode();
                case 7:
                    _context.t5 = _context.sent;
                    _context.t6 = (0,v4/* default */.Z)();
                    _context.t7 = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    _context.t8 = (0,configProvider/* getConfig */.iE)().channel;
                    return _context.abrupt("return", {
                        gid: _context.t0,
                        education_role: _context.t1,
                        client_id: _context.t2,
                        preview_mode: _context.t3,
                        client_language: _context.t4,
                        country_code: _context.t5,
                        ts_random_id: _context.t6,
                        client_timezone: _context.t7,
                        channel: _context.t8
                    });
                case 12:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function getCommonParams() {
        return _ref.apply(this, arguments);
    };
}();
var request = axios/* default.create */.Z.create({
    withCredentials: true
});
var getDefaultError = function getDefaultError() {
    var _getLocaleStore = (0,i18n/* getLocaleStore */.IK)(), $t = _getLocaleStore.$t;
    return {
        code: 1024,
        message: $t(function(v) {
            return v.utils.requestErrorText;
        })
    };
};
function getAccessToken() {
    var _getConfig = (0,configProvider/* getConfig */.iE)(), isWpsUser = _getConfig.isWpsUser;
    if (isWpsUser) {
        var wpsAccessToken = (0,wps_utils/* getWPSAccessToken */.wf)();
        return wpsAccessToken || "";
    }
    if (true) {
        return window.localStorage.getItem("access_token") || "";
    }
    return "";
}
/** 用户被团队移除的状态码 */ var RESIGNED_CODE = 402;
request.interceptors.request.use(/*#__PURE__*/ function() {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee2(config) {
        var _config$baseURL;
        var commonParams, customHeader;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    config.baseURL = (_config$baseURL = config.baseURL) !== null && _config$baseURL !== void 0 ? _config$baseURL : (0,env/* getApiHost */.G3)();
                    _context2.next = 3;
                    return getCommonParams();
                case 3:
                    commonParams = _context2.sent;
                    customHeader =  false ? 0 : (0,objectSpread2/* default */.Z)({
                        access_token: getAccessToken()
                    }, (0,lib/* getRequestIdentityHeader */.AW)());
                    config.headers = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, customHeader), config.headers.common), config.headers);
                    config.params = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, commonParams), config.params);
                    return _context2.abrupt("return", config);
                case 8:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function(_x) {
        return _ref2.apply(this, arguments);
    };
}(), function() {
    return Promise.reject(getDefaultError());
});
request.interceptors.response.use(/*#__PURE__*/ function() {
    var _ref3 = (0,asyncToGenerator/* default */.Z)(/*#__PURE__*/ (0,regeneratorRuntime/* default */.Z)().mark(function _callee3(response) {
        var _response$config, _response$data;
        var code, error_code, messageText, _response$config2;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    if (!((_response$config = response.config) !== null && _response$config !== void 0 && _response$config.directReturn)) {
                        _context3.next = 2;
                        break;
                    }
                    return _context3.abrupt("return", response.data);
                case 2:
                    code = response.data.code;
                    error_code = response.data.error_code;
                    messageText = response.data.message || getDefaultError().message;
                    if (!code) {
                        _context3.next = 8;
                        break;
                    }
                    !(response !== null && response !== void 0 && (_response$config2 = response.config) !== null && _response$config2 !== void 0 && _response$config2.hiddenMessage) && message/* default.error */.Z.error(messageText);
                    throw {
                        code: code,
                        message: messageText,
                        error_code: error_code
                    };
                case 8:
                    return _context3.abrupt("return", (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data);
                case 9:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function(_x2) {
        return _ref3.apply(this, arguments);
    };
}(), function(error) {
    var _error$response, _error$config;
    var data = (error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) || getDefaultError();
    var code = data.code;
    var error_code = data.error_code;
    var messageText = data.message;
    if (!(error !== null && error !== void 0 && (_error$config = error.config) !== null && _error$config !== void 0 && _error$config.hiddenMessage)) {
        message/* default.error */.Z.error(messageText);
    }
    return Promise.reject({
        code: code,
        message: messageText,
        error_code: error_code
    });
});
/* harmony default export */ const utils_request = (request);


/***/ }),

/***/ 29777:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": () => (/* binding */ getSessionRecentPages),
/* harmony export */   "z": () => (/* binding */ pushSessionRecentPage)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33641);

/**
 * @file 记录当前用户最近访问的页面（sessionStorage）
 */ var SESSION_RECENT_PAGES_KEY = "xdesign_recent_visited_pages";
var MAX_RECENT_PAGES = 10;
function readPages() {
    try {
        var raw = window.sessionStorage.getItem(SESSION_RECENT_PAGES_KEY);
        if (!raw) {
            return [];
        }
        var parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed.filter(function(item) {
            return typeof item === "string";
        }) : [];
    } catch (_unused) {
        return [];
    }
}
function writePages(pages) {
    try {
        window.sessionStorage.setItem(SESSION_RECENT_PAGES_KEY, JSON.stringify(pages));
    } catch (_unused2) {
    // sessionStorage 不可用或配额不足时静默失败
    }
}
/** 写入当前页（默认 location.href），置顶，去重，最多 10 条 */ function pushSessionRecentPage(url) {
    var pageUrl = url !== null && url !== void 0 ? url : window.location.href;
    if (!pageUrl) {
        return;
    }
    var next = [
        pageUrl
    ].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(readPages().filter(function(item) {
        return item !== pageUrl;
    }))).slice(0, MAX_RECENT_PAGES);
    writePages(next);
}
/** 读取最近访问列表（最新在前） */ function getSessionRecentPages() {
    return readPages().join(",") || "";
}


/***/ }),

/***/ 53421:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tc": () => (/* binding */ setLocalUid),
/* harmony export */   "Yz": () => (/* binding */ removeLocalUid),
/* harmony export */   "sw": () => (/* binding */ initLocalUid)
/* harmony export */ });
/* unused harmony export getLocalUid */
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54345);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84480);




var getUIDKey = function getUIDKey() {
    return "ouid".concat((0,___WEBPACK_IMPORTED_MODULE_1__/* .getSuffix */ ._A)());
};
/**
 * 海外版本不进行cookie存储
 */ /**
 * 初始化同步uid
 */ var initLocalUid = function initLocalUid() {
    var _getConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .iE)(), isIntl = _getConfig.isIntl;
    if (isIntl) return;
    var uid = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(getUIDKey());
    if (uid) {
        window.localStorage.setItem("uid", String(uid));
    } else {
        window.localStorage.removeItem("uid");
    }
};
/**
 * 更新本地uid缓存和cookie中的uid
 * @param uid
 */ var setLocalUid = function setLocalUid(uid) {
    if (!uid) return;
    var _getConfig2 = (0,_configProvider__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .iE)(), isIntl = _getConfig2.isIntl;
    if (!isIntl) {
        js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(getUIDKey(), String(uid), {
            domain: (0,___WEBPACK_IMPORTED_MODULE_1__/* .getRootDomain */ .wf)(),
            expires: 36500 // 100年有效期
        });
    }
    window.localStorage.setItem("uid", String(uid));
};
var getLocalUid = function getLocalUid() {
    var data = window.localStorage.getItem("uid");
    return data ? Number(data) : null;
};
/**
 * 移除本地uid缓存和cookie中的uid
 */ var removeLocalUid = function removeLocalUid() {
    var _getConfig3 = (0,_configProvider__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .iE)(), isIntl = _getConfig3.isIntl;
    if (!isIntl) {
        js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove(getUIDKey(), {
            domain: (0,___WEBPACK_IMPORTED_MODULE_1__/* .getRootDomain */ .wf)()
        });
    }
    window.localStorage.removeItem("uid");
};


/***/ }),

/***/ 25331:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": () => (/* binding */ useWpsAnchorIntercept)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98423);
/* harmony import */ var _utils_wpsNavDepth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51638);



/**
 * WPS 客户端内嵌时在 document capture 阶段拦截带 `href` 且 `target="_blank"` 的 `<a>` 左键点击，
 * 将其改为在当前页打开。
 *
 * - 修饰键（Ctrl / Meta / Shift / Alt）点击不拦截，保留系统行为。
 * - 带 `download` 属性、`javascript:` 的 `<a>` 不拦截。
 */ function useWpsAnchorIntercept() {
    var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!enabled || typeof document === "undefined") {
            return;
        }
        if (!(0,_utils_client__WEBPACK_IMPORTED_MODULE_1__/* .isFromWPSClient */ .Ku)()) {
            return;
        }
        var onClickCapture = function onClickCapture(event) {
            if (event.defaultPrevented) {
                return;
            }
            if (event.button !== 0) {
                return;
            }
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
                return;
            }
            var el = event.target;
            if (!el || !(el instanceof Element)) {
                return;
            }
            var anchor = el.closest("a[href]");
            if (!(anchor instanceof HTMLAnchorElement)) {
                return;
            }
            // 只拦截 target="_blank"（新窗口打开）的链接；当前页替换的不需要拦截
            if (anchor.getAttribute("target") !== "_blank") {
                return;
            }
            // 声明式下载：不劫持
            if (anchor.hasAttribute("download")) {
                return;
            }
            // 业务侧需要自行处理导航（如先上传图片再跳转），拦截器放行
            if (anchor.hasAttribute("data-wps-defer-navigate")) {
                return;
            }
            var rawHref = anchor.getAttribute("href");
            if (!rawHref || !rawHref.trim()) {
                return;
            }
            if (/^javascript:/i.test(rawHref.trim())) {
                return;
            }
            // WPS 场景：所有新开页面直接在当前页打开
            event.preventDefault();
            (0,_utils_wpsNavDepth__WEBPACK_IMPORTED_MODULE_2__/* .incrementWpsNavDepth */ .QB)();
            window.location.href = anchor.href;
        };
        document.addEventListener("click", onClickCapture, true);
        return function() {
            document.removeEventListener("click", onClickCapture, true);
        };
    }, [
        enabled
    ]);
}


/***/ }),

/***/ 173:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": () => (/* binding */ useWpsNavigationIntercept)
/* harmony export */ });
/* harmony import */ var _useWpsAnchorIntercept__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25331);
/* harmony import */ var _useWpsWindowOpenIntercept__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15314);


/**
 * WPS 客户端内嵌时同时注册 `window.open` 与 `<a href>` 的兜底拦截。
 * @param enabled 为 false 时两者均不注册
 */ function useWpsNavigationIntercept() {
    var enabledWindowOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var enabledAnchor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    (0,_useWpsWindowOpenIntercept__WEBPACK_IMPORTED_MODULE_0__/* .useWpsWindowOpenIntercept */ .y)(enabledWindowOpen);
    (0,_useWpsAnchorIntercept__WEBPACK_IMPORTED_MODULE_1__/* .useWpsAnchorIntercept */ .t)(enabledAnchor);
}


/***/ }),

/***/ 15314:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": () => (/* binding */ useWpsWindowOpenIntercept)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98423);
/* harmony import */ var _utils_wpsNavDepth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51638);



/**
 * WPS 客户端内嵌时劫持 `window.open`：将所有新开页面改为在当前页打开。
 * 非 WPS 环境不注册；卸载时恢复进入 effect 时的 `window.open`。
 *
 * @param enabled 为 false 时不注册（便于按路由开关）
 */ function useWpsWindowOpenIntercept() {
    var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!enabled || "object" === "undefined") {
            return;
        }
        if (!(0,_utils_client__WEBPACK_IMPORTED_MODULE_1__/* .isFromWPSClient */ .Ku)()) {
            return;
        }
        var previousOpen = window.open.bind(window);
        var patchedOpen = function patchedOpen() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var url = args[0], target = args[1];
            if (url === undefined || url === "") {
                return previousOpen.apply(window, args);
            }
            // _self/_parent/_top 本身就在当前页打开，走默认行为
            var normalizedTarget = typeof target === "string" ? target.toLowerCase() : "";
            if (normalizedTarget === "_self" || normalizedTarget === "_parent" || normalizedTarget === "_top") {
                return previousOpen.apply(window, args);
            }
            // WPS 场景：所有新开页面直接在当前页打开
            var urlStr = typeof url === "string" ? url : url.toString();
            (0,_utils_wpsNavDepth__WEBPACK_IMPORTED_MODULE_2__/* .incrementWpsNavDepth */ .QB)();
            window.location.href = urlStr;
            return null;
        };
        window.open = patchedOpen;
        return function() {
            window.open = previousOpen;
        };
    }, [
        enabled
    ]);
}


/***/ }),

/***/ 30947:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BL": () => (/* binding */ getWPSPayStatus),
/* harmony export */   "Jo": () => (/* binding */ wpsPreOrder),
/* harmony export */   "c3": () => (/* binding */ wpsOAuth2Login),
/* harmony export */   "xj": () => (/* binding */ getWPSUserInfo)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89255);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87406);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1225);



/**
 * WPS预下单
 * @return
 */ var wpsPreOrder = /*#__PURE__*/ function() {
    var _ref = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee(position, subscribe_type) {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    ;
                    _context.next = 3;
                    return (0,_utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("/v1/wps/pre_order", {
                        method: "post",
                        data: {
                            position: position,
                            type: subscribe_type === "meidou" ? 2 : 1
                        },
                        hiddenMessage: true
                    });
                case 3:
                    return _context.abrupt("return", _context.sent);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function wpsPreOrder(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 获取WPS绑定的用户信息
 * @return
 */ var getWPSUserInfo = /*#__PURE__*/ function() {
    var _ref2 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee2() {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return (0,_utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("/v1/wps/meitu_user_info", {
                        method: "get",
                        hiddenMessage: true
                    });
                case 2:
                    return _context2.abrupt("return", _context2.sent);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function getWPSUserInfo() {
        return _ref2.apply(this, arguments);
    };
}();
/**
 * 查询WPS支付状态
 * @return
 */ var getWPSPayStatus = /*#__PURE__*/ function() {
    var _ref3 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee3(billNo) {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return (0,_utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("/v1/wps/order_status", {
                        method: "get",
                        params: {
                            bill_no: billNo
                        },
                        hiddenMessage: true
                    });
                case 2:
                    return _context3.abrupt("return", _context3.sent);
                case 3:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function getWPSPayStatus(_x3) {
        return _ref3.apply(this, arguments);
    };
}();
/**
 * WPS OAuth2 登录
 * @return
 */ var wpsOAuth2Login = /*#__PURE__*/ function() {
    var _ref4 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee4(code) {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee4$(_context4) {
            while(1)switch(_context4.prev = _context4.next){
                case 0:
                    _context4.next = 2;
                    return (0,_utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("/v1/wps/oauth2_login", {
                        method: "post",
                        data: {
                            code: code
                        },
                        hiddenMessage: true
                    });
                case 2:
                    return _context4.abrupt("return", _context4.sent);
                case 3:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function wpsOAuth2Login(_x4) {
        return _ref4.apply(this, arguments);
    };
}();


/***/ }),

/***/ 98423:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$k": () => (/* binding */ isFromWPSClientOpenImageEdit),
/* harmony export */   "A": () => (/* binding */ createWPSClientPayOrder),
/* harmony export */   "De": () => (/* binding */ offLoginStatusChanged),
/* harmony export */   "Kp": () => (/* binding */ wpsClientIsLogin),
/* harmony export */   "Ku": () => (/* binding */ isFromWPSClient),
/* harmony export */   "MQ": () => (/* binding */ callWpsWebLoadFinish),
/* harmony export */   "UC": () => (/* binding */ isFromWPSClientOpenImage),
/* harmony export */   "XK": () => (/* binding */ getWPSClientUserInfo),
/* harmony export */   "ci": () => (/* binding */ buyMerchandiseByBillno),
/* harmony export */   "g4": () => (/* binding */ onWPSLoginStatusChanged),
/* harmony export */   "ix": () => (/* binding */ getWPSSelectImageBase64),
/* harmony export */   "tb": () => (/* binding */ callWpsClientLogin),
/* harmony export */   "uw": () => (/* binding */ waitWPSClientReady),
/* harmony export */   "vX": () => (/* binding */ getLaunchOptions),
/* harmony export */   "xv": () => (/* binding */ initWPSInsertImageListeners)
/* harmony export */ });
/* unused harmony exports disposeWPSInsertImageListeners, insertBase64ImageToWPS, closeClientWindow, isFromWPSClientOpenAgent, LaunchPayWindow */
/* harmony import */ var _babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89255);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87406);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84480);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30947);
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8382);
/* harmony import */ var _runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26860);
/* harmony import */ var _source__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58730);







/**
 * 文档内打开弹窗时调用的WPS客户端SDK接口
 * @param method WPS客户端SDK接口方法名
 * @param params WPS客户端SDK接口参数
 * @returns
 */ var callWps = function callWps(method, params) {
    ;
    return new Promise(function(resolve, reject) {
        var cbName = "__wps_cb_" + Date.now() + "_" + Math.floor(Math.random() * 100000);
        window[cbName] = function(res) {
            ;
            delete window[cbName];
            try {
                resolve(typeof res === "string" ? JSON.parse(res) : res);
            } catch (_unused) {
                resolve(res);
            }
        };
        var jsonin = JSON.stringify({
            method: method,
            params: params || {},
            callback: 'window["' + cbName + '"]'
        });
        window.cefQuery({
            request: 'fromJSAsynCall("' + jsonin + '")',
            persistent: false
        });
        if (method === "webLoadFinish") {
            // 这个方法没有回调
            return;
        }
        // 支付接口回调时间较长，设置为20分钟，其他接口设置为10秒
        var timeout = method === "buyMerchandiseByBillno" ? 20 * 60 * 1000 : 10000;
        setTimeout(function() {
            if (window[cbName]) {
                ;
                delete window[cbName];
                reject(new Error("timeout"));
            }
        }, timeout);
    });
};
/**
 * 前端页面初始化完成通知客户端移除加载页面，显示网页
 * 需要告知WPS，不然会超时，显示重试页面
 */ var callWpsWebLoadFinish = function callWpsWebLoadFinish() {
    if (!isFromWPSClientOpenImage()) return;
    callWps("webLoadFinish", {});
};
/**
 * 获取WPS客户端用户信息，获取授权
 * @returns GetUserInfoResult
 */ var getWPSClientUserInfo = /*#__PURE__*/ function() {
    var _ref = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee() {
        var res, p;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    if (!isFromWPSClientOpenImage()) {
                        _context.next = 7;
                        break;
                    }
                    ;
                    _context.next = 4;
                    return callWps("getOpenSdkCode", {
                        appid: _constant__WEBPACK_IMPORTED_MODULE_2__/* .appinfo.appid */ .hm.appid
                    });
                case 4:
                    res = _context.sent;
                    ;
                    return _context.abrupt("return", {
                        code: res.callstatus === "ok" ? 0 : 1,
                        login_code: res.code
                    });
                case 7:
                    p = new Promise(function(resolve) {
                        window.wps.getUserInfo({
                            complete: function complete(res) {
                                resolve(res);
                            }
                        });
                    });
                    return _context.abrupt("return", p);
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function getWPSClientUserInfo() {
        return _ref.apply(this, arguments);
    };
}();
var buyMerchandiseByBillno = /*#__PURE__*/ function() {
    var _ref2 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee2(billno) {
        var res, p;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    if (!isFromWPSClientOpenImage()) {
                        _context2.next = 7;
                        break;
                    }
                    ;
                    _context2.next = 4;
                    return callWps("buyMerchandiseByBillno", {
                        billNo: billno
                    });
                case 4:
                    res = _context2.sent;
                    ;
                    return _context2.abrupt("return", {
                        data: {
                            status: res.callstatus === "ok" ? true : false
                        }
                    });
                case 7:
                    p = new Promise(function(resolve) {
                        window.wps.buyMerchandiseByBillno({
                            billno: billno,
                            complete: function complete(res) {
                                resolve(res);
                            }
                        });
                    });
                    return _context2.abrupt("return", p);
                case 9:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function buyMerchandiseByBillno(_x) {
        return _ref2.apply(this, arguments);
    };
}();
var getLaunchOptions = /*#__PURE__*/ function() {
    var _ref3 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee3() {
        var res, p;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    if (!isFromWPSClientOpenImage()) {
                        _context3.next = 6;
                        break;
                    }
                    _context3.next = 3;
                    return callWps("getLaunchOptions", {});
                case 3:
                    res = _context3.sent;
                    ;
                    return _context3.abrupt("return", {
                        data: {
                            extraData: {
                                position: res.position
                            }
                        }
                    });
                case 6:
                    p = new Promise(function(resolve, reject) {
                        try {
                            window.wps.getLaunchOptions({
                                complete: function complete(res) {
                                    resolve(res);
                                }
                            });
                        } catch (e) {
                            reject(e);
                        }
                    });
                    return _context3.abrupt("return", p);
                case 8:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function getLaunchOptions() {
        return _ref3.apply(this, arguments);
    };
}();
/**
 * 监听WPS登录状态变化事件，登录状态变化时会触发回调函数，并通过`window.wps.isLogin`接口获取当前登录状态
 */ var onWPSLoginStatusChanged = function onWPSLoginStatusChanged(onLoginStatusChanged) {
    if (isFromWPSClientOpenImage()) {
        ;
        window.userStateChanged = function(data) {
            ;
            try {
                var res = JSON.parse(data);
                onLoginStatusChanged(!!(res !== null && res !== void 0 && res.is_login));
            } catch (e) {
                ;
            }
        };
        return;
    }
    window.wps.onLoginStatusChanged(function() {
        ;
        window.wps.isLogin({
            complete: function complete(res) {
                if (res.code === 0) {
                    onLoginStatusChanged(res.data.is_login);
                }
            }
        });
    });
};
/**
 * 唤起WPS自己的登录弹窗
 */ function callWpsClientLogin() {
    return _callWpsClientLogin.apply(this, arguments);
}
/**
 * 判断端内 WPS 是否已经登录
 */ function _callWpsClientLogin() {
    _callWpsClientLogin = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee4() {
        var res, p;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee4$(_context4) {
            while(1)switch(_context4.prev = _context4.next){
                case 0:
                    if (!isFromWPSClientOpenImage()) {
                        _context4.next = 7;
                        break;
                    }
                    ;
                    _context4.next = 4;
                    return callWps("common.account.login", {});
                case 4:
                    res = _context4.sent;
                    ;
                    return _context4.abrupt("return", res);
                case 7:
                    p = new Promise(function(resolve, reject) {
                        try {
                            window.wps.login({
                                complete: function complete(res) {
                                    resolve(res);
                                    ;
                                }
                            });
                        } catch (e) {
                            reject(e);
                        }
                    });
                    return _context4.abrupt("return", p);
                case 9:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return _callWpsClientLogin.apply(this, arguments);
}
function wpsClientIsLogin() {
    return _wpsClientIsLogin.apply(this, arguments);
}
/**
 * 通过 base64 起始字符（对应字节流 magic number）推断真实图片 MIME。
 *
 * - PNG  : 89 50 4E 47 \=\> "iVBORw0KGgo"
 * - JPEG : FF D8 FF    \=\> "/9j/"
 * - GIF  : 47 49 46 38 \=\> "R0lGOD"
 * - WebP : 52 49 46 46 ... 57 45 42 50 \=\> "UklGR" + 后续含 "WEBP"
 * - BMP  : 42 4D       \=\> "Qk"
 *
 * 未匹配时回退到 image/png（与历史行为一致）。
 */ function _wpsClientIsLogin() {
    _wpsClientIsLogin = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee5() {
        var res, p;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee5$(_context5) {
            while(1)switch(_context5.prev = _context5.next){
                case 0:
                    if (!isFromWPSClientOpenImage()) {
                        _context5.next = 8;
                        break;
                    }
                    _context5.next = 3;
                    return callWps("common.account.checkLoginState", {});
                case 3:
                    res = _context5.sent;
                    ;
                    if (!(res.callstatus === "ok")) {
                        _context5.next = 7;
                        break;
                    }
                    return _context5.abrupt("return", !!res.isLogined);
                case 7:
                    throw new Error("checkLoginState failed: ".concat(res.callstatus));
                case 8:
                    p = new Promise(function(resolve, reject) {
                        try {
                            window.wps.isLogin({
                                complete: function complete(res) {
                                    ;
                                    if (res.code === 0) {
                                        resolve(res.data.is_login);
                                    } else {
                                        reject(new Error("wps.isLogin failed: ".concat(res.code)));
                                    }
                                }
                            });
                        } catch (e) {
                            reject(e);
                        }
                    });
                    return _context5.abrupt("return", p);
                case 10:
                case "end":
                    return _context5.stop();
            }
        }, _callee5);
    }));
    return _wpsClientIsLogin.apply(this, arguments);
}
function detectImageMimeFromBase64(b64) {
    if (b64.startsWith("/9j/")) return "image/jpeg";
    if (b64.startsWith("iVBORw0KGgo")) return "image/png";
    if (b64.startsWith("R0lGOD")) return "image/gif";
    if (b64.startsWith("UklGR")) return "image/webp";
    if (b64.startsWith("Qk")) return "image/bmp";
    return "image/png";
}
/**
 * 将 WPS 端返回的 base64 归一化为标准 data URI，并同时给出推断的 MIME。
 *
 * WPS 端不同版本返回值可能是：
 * 1. 已经带 `data:image/xxx;base64,` 头的 data URI
 * 2. 纯 base64 编码字符串（没有头）
 *
 * 这里统一兜底，保证调用方拿到的永远是浏览器 / `<img>` / `base64ToFile`
 * 等通用工具能直接消费的标准 data URI，同时拿到对应的图片类型。
 */ function normalizeImageBase64ToDataUrl(raw) {
    if (!raw) return {
        base64: raw,
        mime: "image/png"
    };
    if (raw.startsWith("data:")) {
        var _match$;
        var match = raw.match(/^data:(image\/[a-z+.\-]+);base64,/i);
        return {
            base64: raw,
            mime: (_match$ = match === null || match === void 0 ? void 0 : match[1]) !== null && _match$ !== void 0 ? _match$ : "image/png"
        };
    }
    var mime = detectImageMimeFromBase64(raw);
    return {
        base64: "data:".concat(mime, ";base64,").concat(raw),
        mime: mime
    };
}
/**
 * 获取 WPS 端内选中的图片 base64 数据。
 *
 * 返回值：
 * - `base64`：标准的 `data:image/xxx;base64,...` 形式，业务侧无需再判断 / 拼接前缀
 * - `mime` ：图片 MIME（如 `image/png`、`image/jpeg`），未识别时回退 `image/png`
 * - `suffix`：图片后缀（如 `png`、`jpeg`），来源于 `mime`，方便用于文件名拼接
 */ function getWPSSelectImageBase64() {
    return _getWPSSelectImageBase.apply(this, arguments);
}
function _getWPSSelectImageBase() {
    _getWPSSelectImageBase = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee6() {
        var res, _mime$split$, _normalizeImageBase, base64, mime;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee6$(_context6) {
            while(1)switch(_context6.prev = _context6.next){
                case 0:
                    ;
                    _context6.next = 3;
                    return callWps("getCurSelectImg", {
                        url: ""
                    });
                case 3:
                    res = _context6.sent;
                    ;
                    if (!(res.callstatus === "ok")) {
                        _context6.next = 8;
                        break;
                    }
                    _normalizeImageBase = normalizeImageBase64ToDataUrl(res.result.imgbase64), base64 = _normalizeImageBase.base64, mime = _normalizeImageBase.mime;
                    return _context6.abrupt("return", {
                        base64: base64,
                        mime: mime,
                        suffix: (_mime$split$ = mime.split("/")[1]) !== null && _mime$split$ !== void 0 ? _mime$split$ : "png",
                        id: res.result.id
                    });
                case 8:
                    throw new Error("getCurSelectImg failed: ".concat(JSON.stringify(res)));
                case 9:
                case "end":
                    return _context6.stop();
            }
        }, _callee6);
    }));
    return _getWPSSelectImageBase.apply(this, arguments);
}
/** WPS 端「插入 base64 图片到文档」回调入参的最小约定字段 */ /** 当前正在等待 WPS 回调的那一次 insertBase64ImageToWPS 调用 */ var pendingInsertImage = null;
var insertImageListenersInited = false;
/**
 * 初始化「插入 base64 图片到 WPS 文档」所需的两个全局回调。
 *
 * - 幂等：重复调用无副作用。
 * - WPS 端约定的全局回调名是固定的：
 *   - window.insertimage_insertcomplete : 插入成功
 *   - window.insertimage_insertfailed   : 插入失败
 * - 必须在调用 {@link insertBase64ImageToWPS} 之前调用一次，
 */ function initWPSInsertImageListeners() {
    if (false) {}
    if (insertImageListenersInited) return;
    insertImageListenersInited = true;
    window.insertimage_insertcomplete = function(data) {
        ;
        var p = pendingInsertImage;
        pendingInsertImage = null;
        if (!p) return;
        try {
            var res = JSON.parse(data);
            if ((res === null || res === void 0 ? void 0 : res.callstatus) === "ok") {
                closeClientWindow();
                p.resolve();
            } else {
                p.reject(new Error("insertimage_insertcomplete with non-ok payload: ".concat(data)));
            }
        } catch (e) {
            ;
            p.reject(e instanceof Error ? e : new Error(String(e)));
        }
    };
    window.insertimage_insertfailed = function(data) {
        ;
        var p = pendingInsertImage;
        pendingInsertImage = null;
        if (!p) return;
        p.reject(new Error("insertimage_insertfailed: ".concat(data)));
    };
}
/**
 * 解绑「插入 base64 图片到 WPS 文档」的两个全局回调。
 * 一般情况下不需要主动调用；用于测试或离开 WPS 容器时显式清理。
 * 如果当前还有 pending 调用，会被以错误结束。
 */ function disposeWPSInsertImageListeners() {
    if (false) {}
    delete window.insertimage_insertcomplete;
    delete window.insertimage_insertfailed;
    insertImageListenersInited = false;
    if (pendingInsertImage) {
        pendingInsertImage.reject(new Error("WPS insert image listeners disposed"));
        pendingInsertImage = null;
    }
}
/**
 * 把图片 base64 数据返回给 WPS，让 WPS 把图片插入到当前文档。
 *
 * 成功 / 失败由 WPS 端通过两个全局回调回传，本方法封装为 Promise：
 * - 成功：resolve()
 * - 失败：reject(Error)
 *
 * 前置条件：必须先调用 {@link initWPSInsertImageListeners} 初始化全局回调，
 * 否则本方法会直接 reject，避免回调落空导致 Promise 永远 pending。
 *
 * 并发策略：同一时刻只允许一次未结束的插入调用。
 * 在上一次回调返回前再次发起调用，新调用会被立即 reject（busy 错误），
 * 老调用继续等待 WPS 回调。
 */ function insertBase64ImageToWPS(_x2) {
    return _insertBase64ImageToWPS.apply(this, arguments);
}
/**
 * 关闭登录状态监听
 */ function _insertBase64ImageToWPS() {
    _insertBase64ImageToWPS = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee7(params) {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while(1)switch(_context7.prev = _context7.next){
                case 0:
                    ;
                    if (insertImageListenersInited) {
                        _context7.next = 3;
                        break;
                    }
                    throw new Error("[insertBase64ImageToWPS] WPS insert image listeners are not initialized. " + "Call initWPSInsertImageListeners() once after WPS client is ready.");
                case 3:
                    return _context7.abrupt("return", new Promise(function(resolve, reject) {
                        if (pendingInsertImage) {
                            reject(new Error("[insertBase64ImageToWPS] busy: a previous insert call is still pending"));
                            return;
                        }
                        pendingInsertImage = {
                            resolve: resolve,
                            reject: reject
                        };
                        try {
                            var j = JSON.stringify({
                                method: "insertBase64ImageToDoc",
                                params: params
                            });
                            window.cefQuery({
                                request: 'fromJSAsynCall("' + j + '")',
                                persistent: false
                            });
                        } catch (e) {
                            pendingInsertImage = null;
                            reject(e instanceof Error ? e : new Error(String(e)));
                        }
                    }));
                case 4:
                case "end":
                    return _context7.stop();
            }
        }, _callee7);
    }));
    return _insertBase64ImageToWPS.apply(this, arguments);
}
function offLoginStatusChanged() {
    if (isFromWPSClientOpenImage()) {
        ;
        window.userStateChanged = null;
        return;
    }
    window.wps.offLoginStatusChanged();
}
/**
 * 关闭内嵌标签页
 */ function closeClientWindow() {
    return _closeClientWindow.apply(this, arguments);
}
/**
 * 判断是否来自WPS客户端渠道
 * @returns boolean
 */ function _closeClientWindow() {
    _closeClientWindow = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee8() {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee8$(_context8) {
            while(1)switch(_context8.prev = _context8.next){
                case 0:
                    callWps("closeWindow", {});
                case 1:
                case "end":
                    return _context8.stop();
            }
        }, _callee8);
    }));
    return _closeClientWindow.apply(this, arguments);
}
function isFromWPSClient() {
    return (0,_source__WEBPACK_IMPORTED_MODULE_3__/* .isFromWpsSource */ .Sl)("client");
}
/**
 * 判断是否来自端内携带图片打开
 * @returns boolean
 */ function isFromWPSClientOpenImage() {
    if (!isFromWPSClient()) return false;
    var queryParams = new URLSearchParams(window.location.search);
    return !!queryParams.get("wps_open") || false;
}
/**
 * 判断是否来自端内携带图片打开且二次编辑
 * @returns boolean
 */ function isFromWPSClientOpenImageEdit() {
    if (!isFromWPSClient()) return false;
    var queryParams = new URLSearchParams(window.location.search);
    var edit = !!queryParams.get("edit") || false;
    var open = !!queryParams.get("wps_open") || false;
    return edit && open;
}
/**
 * 判断是否来自 WPS 端内携带 agent 参数进入 agent 页面（URL 携带 wps_agent）
 * @returns boolean
 */ function isFromWPSClientOpenAgent() {
    if (!isFromWPSClient()) return false;
    var queryParams = new URLSearchParams(window.location.search);
    return !!queryParams.get("wps_agent") || false;
}
/**
 * 等待WPS客户端初始化完成
 * @returns boolean
 */ function waitWPSClientReady() {
    return _waitWPSClientReady.apply(this, arguments);
}
/**
 * 客户端预下单
 */ function _waitWPSClientReady() {
    _waitWPSClientReady = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee9() {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee9$(_context9) {
            while(1)switch(_context9.prev = _context9.next){
                case 0:
                    if (!(0,_runtime__WEBPACK_IMPORTED_MODULE_4__/* .isServerSide */ .s)()) {
                        _context9.next = 2;
                        break;
                    }
                    return _context9.abrupt("return", false);
                case 2:
                    if (!isFromWPSClientOpenImage()) {
                        _context9.next = 4;
                        break;
                    }
                    return _context9.abrupt("return", true);
                case 4:
                    if (window.wps) {
                        _context9.next = 6;
                        break;
                    }
                    return _context9.abrupt("return", new Promise(function(resolve) {
                        document.addEventListener("WpsofficeSDKReady", function() {
                            if (window.__wpsoffice_environment === "miniprogram") {
                                ;
                                resolve(true);
                            } else {
                                var _getConfig$reportErro, _getConfig;
                                ;
                                (_getConfig$reportErro = (_getConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_5__/* .getConfig */ .iE)()).reportError) === null || _getConfig$reportErro === void 0 || _getConfig$reportErro.call(_getConfig, new Error("wps-wpsClientReady-failed"), {
                                    scene: "wps-wpsClientReady-failed"
                                });
                                resolve(false);
                            }
                        }, false);
                    }));
                case 6:
                    return _context9.abrupt("return", true);
                case 7:
                case "end":
                    return _context9.stop();
            }
        }, _callee9);
    }));
    return _waitWPSClientReady.apply(this, arguments);
}
function createWPSClientPayOrder(_x3) {
    return _createWPSClientPayOrder.apply(this, arguments);
}
/**
 * 客户端调起支付弹窗
 */ function _createWPSClientPayOrder() {
    _createWPSClientPayOrder = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().mark(function _callee10(subscribeType) {
        var _options$data;
        var options, position;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().wrap(function _callee10$(_context10) {
            while(1)switch(_context10.prev = _context10.next){
                case 0:
                    _context10.next = 2;
                    return getLaunchOptions();
                case 2:
                    options = _context10.sent;
                    position = (options === null || options === void 0 || (_options$data = options.data) === null || _options$data === void 0 || (_options$data = _options$data.extraData) === null || _options$data === void 0 ? void 0 : _options$data.position) || "docertest";
                    _context10.next = 6;
                    return (0,_api__WEBPACK_IMPORTED_MODULE_6__/* .wpsPreOrder */ .Jo)(position, subscribeType);
                case 6:
                    return _context10.abrupt("return", _context10.sent);
                case 7:
                case "end":
                    return _context10.stop();
            }
        }, _callee10);
    }));
    return _createWPSClientPayOrder.apply(this, arguments);
}
function LaunchPayWindow(_x4) {
    return _LaunchPayWindow.apply(this, arguments);
}
function _LaunchPayWindow() {
    _LaunchPayWindow = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee11(subscribeType) {
        var data, res;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
            while(1)switch(_context11.prev = _context11.next){
                case 0:
                    _context11.next = 2;
                    return createWPSClientPayOrder(subscribeType);
                case 2:
                    data = _context11.sent;
                    _context11.next = 5;
                    return buyMerchandiseByBillno(data.bill_no);
                case 5:
                    res = _context11.sent;
                    ;
                    // 为true表示用户支付成功
                    return _context11.abrupt("return", {
                        status: res.data.status,
                        billNo: data.bill_no
                    });
                case 8:
                case "end":
                    return _context11.stop();
            }
        }, _callee11);
    }));
    return _LaunchPayWindow.apply(this, arguments);
}


/***/ }),

/***/ 8382:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$K": () => (/* binding */ WPS_LOGIN_SUCCESS),
/* harmony export */   "$m": () => (/* binding */ WPS_REDIRECT_QUERY_BLACKLIST),
/* harmony export */   "BO": () => (/* binding */ WPS_PAY_MODAL_LISTENER_EVENT_CLOSE),
/* harmony export */   "J$": () => (/* binding */ WPS_BIND_INFO_UPDATED),
/* harmony export */   "Om": () => (/* binding */ WPS_PAY_MODAL_LISTENER_EVENT_SUCCESS),
/* harmony export */   "RT": () => (/* binding */ WPS_PAY_MODAL_LISTENER_EVENT_SHOW),
/* harmony export */   "cb": () => (/* binding */ servers),
/* harmony export */   "hm": () => (/* binding */ appinfo),
/* harmony export */   "mX": () => (/* binding */ WPS_LOGOUT_EVENT)
/* harmony export */ });
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84480);
/* harmony import */ var _utils_env__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20820);


var appinfo = {
    get appid () {
        var isRelease = (0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().env === _utils_env__WEBPACK_IMPORTED_MODULE_1__/* .ENV_ENUM.release */ .BD.release;
        return isRelease ? "AK20260325HJNXLH" : "SX20260325UBKOSX";
    },
    scope: "user_info,vas",
    /** 设计室的登录授权回调地址 */ get authorizeURL () {
        var envPrefix = (0,_utils_env__WEBPACK_IMPORTED_MODULE_1__/* .getEnvPrefix */ .HN)((0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().env);
        return "https://".concat(envPrefix, "webapi.designkit.cn/v1/wps/oauth2_callback");
    },
    /** 登录授权成功后的回调地址，根据 wpsRedirectPath 拼接子路径 */ get redirectURL () {
        var config = (0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)();
        var envPrefix1 = (0,_utils_env__WEBPACK_IMPORTED_MODULE_1__/* .getEnvPrefix */ .HN)(config.env) || "www";
        var base = "https://".concat(envPrefix1, ".designkit.cn");
        return config.wpsRedirectPath ? "".concat(base, "/").concat(config.wpsRedirectPath) : base;
    }
};
/**
 * 构造 WPS 回跳 redirect_url 时，需要从当前页 query 中剔除的参数黑名单。
 * 这些参数要么是 OAuth 流程中间态，要么是内部已显式管理的字段，透传回去可能导致鉴权异常或参数冲突。
 */ var WPS_REDIRECT_QUERY_BLACKLIST = new Set([
    // 内部显式管理的字段（formatWPSOauth2AuthorizeUrl 会主动设置）
    "channel",
    "from_wps"
]);
var servers = {
    authorize: "https://openapi.wps.cn/oauthapi/v2/authorize",
    // web端授权
    webPay: "https://vip.wps.cn/vcl_svr/static/wpspay" // web端支付窗
};
/**
 * wps支付弹窗显示事件
 */ var WPS_PAY_MODAL_LISTENER_EVENT_SHOW = "xdesign-wps-pay-modal-listener-event-show";
/**
 * wps支付弹窗关闭事件
 */ var WPS_PAY_MODAL_LISTENER_EVENT_CLOSE = "xdesign-wps-pay-modal-listener-event-close";
/**
 * wps支付成功事件
 */ var WPS_PAY_MODAL_LISTENER_EVENT_SUCCESS = "xdesign-wps-pay-modal-listener-event-success";
/**
 * wps绑定信息更新事件（getWPSBindInfo 完成后触发，业务方可监听此事件刷新用户信息）
 */ var WPS_BIND_INFO_UPDATED = "xdesign-wps-bind-info-updated";
/**
 * WPS退出登录事件（端内监听到WPS退出时触发，业务方监听此事件清理本地登录状态，不刷新页面）
 */ var WPS_LOGOUT_EVENT = "xdesign-wps-logout";
/**
 * WPS 登录成功事件（端内 client 与 web 端统一）。
 *
 * 端内（client）：登录的最终收口点是 attemptWPSClientAuth —— 无论「已登录 WPS 直接授权」
 * 还是「未登录唤起原生登录框、用户登录后经 onLoginStatusChanged 触发授权」，都汇聚到这里，
 * 在美图授权换取 token 成功后触发。
 * web 端：wpsWebLogin 检测到已绑定 WPS（已有 access_token，即已是可用登录态）时触发。
 *
 * 接入方监听此事件即可统一处理两端的「登录成功」，无需区分 client / web。
 * 注意：以下场景不会触发本事件（约定为纯挂起静默 / 由页面重载恢复登录态）：
 *  - 端内用户取消 WPS 原生登录框（WPS 不下发任何信号）；
 *  - web 端未绑定时 redirectToWPS 跳转授权，回来后是页面重载经初始化恢复登录态，不经过此事件。
 */ var WPS_LOGIN_SUCCESS = "xdesign-wps-login-success";


/***/ }),

/***/ 68626:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$k": () => (/* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_1__.$k),
/* harmony export */   "JB": () => (/* binding */ getWPSBindInfo),
/* harmony export */   "JR": () => (/* binding */ resolveWpsLaunchRedirectUrl),
/* harmony export */   "Js": () => (/* reexport safe */ _web__WEBPACK_IMPORTED_MODULE_2__.Js),
/* harmony export */   "Ku": () => (/* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_1__.Ku),
/* harmony export */   "Kx": () => (/* reexport safe */ _track__WEBPACK_IMPORTED_MODULE_4__.Kx),
/* harmony export */   "LP": () => (/* reexport safe */ _track__WEBPACK_IMPORTED_MODULE_4__.LP),
/* harmony export */   "Mv": () => (/* binding */ wpsWebLogin),
/* harmony export */   "N0": () => (/* reexport safe */ _source__WEBPACK_IMPORTED_MODULE_3__.N0),
/* harmony export */   "UC": () => (/* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_1__.UC),
/* harmony export */   "_i": () => (/* reexport safe */ _source__WEBPACK_IMPORTED_MODULE_3__._i),
/* harmony export */   "cr": () => (/* binding */ wpsClientLogin),
/* harmony export */   "ix": () => (/* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_1__.ix),
/* harmony export */   "jJ": () => (/* binding */ wpsCheckLogin),
/* harmony export */   "ji": () => (/* binding */ isFromWPS),
/* harmony export */   "kS": () => (/* binding */ openWpsPayModal),
/* harmony export */   "wf": () => (/* binding */ getWPSAccessToken),
/* harmony export */   "zk": () => (/* binding */ wpsInit)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81549);
/* harmony import */ var _babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89255);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87406);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(84480);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(54345);
/* harmony import */ var _utils_env__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(20820);
/* harmony import */ var _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82001);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30947);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98423);
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8382);
/* harmony import */ var _runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26860);
/* harmony import */ var _source__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58730);
/* harmony import */ var _track__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4592);
/* harmony import */ var _web__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69839);



















var DEFAULT_WPS_PAY_POLL_INTERVAL = 1000;
var DEFAULT_WPS_PAY_POLL_TIMEOUT = 20 * 60 * 1000;
var WPS_CLIENT_PAY_STATUS_SYNC_TIMEOUT = 10 * 1000;
var wpsClientLoggedIn = false;
function emitWpsPaySuccess(result, trackParams) {
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__/* ["default"].emit */ .Z.emit(_constant__WEBPACK_IMPORTED_MODULE_6__/* .WPS_PAY_MODAL_LISTENER_EVENT_SUCCESS */ .Om, {
        result: result,
        trackParams: trackParams
    });
}
function pollWpsWebPayStatus(_x) {
    return _pollWpsWebPayStatus.apply(this, arguments);
}
/**
 * 调用设计室接口获取是否绑定了WPS
 */ function _pollWpsWebPayStatus() {
    _pollWpsWebPayStatus = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().mark(function _callee(billNo) {
        var _options$pollInterval, _options$pollTimeout;
        var options, pollInterval, pollTimeout, startTime, closed, handleClose, _options$shouldStop, _options$shouldStop2, result, _args = arguments;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                    pollInterval = (_options$pollInterval = options.pollInterval) !== null && _options$pollInterval !== void 0 ? _options$pollInterval : DEFAULT_WPS_PAY_POLL_INTERVAL;
                    pollTimeout = (_options$pollTimeout = options.pollTimeout) !== null && _options$pollTimeout !== void 0 ? _options$pollTimeout : DEFAULT_WPS_PAY_POLL_TIMEOUT;
                    startTime = Date.now();
                    closed = false;
                    handleClose = function handleClose() {
                        closed = true;
                    };
                    _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__/* ["default"].on */ .Z.on(_constant__WEBPACK_IMPORTED_MODULE_6__/* .WPS_PAY_MODAL_LISTENER_EVENT_CLOSE */ .BO, handleClose);
                    _context.prev = 7;
                case 8:
                    if (!(!closed && !((_options$shouldStop = options.shouldStop) !== null && _options$shouldStop !== void 0 && _options$shouldStop.call(options)) && Date.now() - startTime <= pollTimeout)) {
                        _context.next = 20;
                        break;
                    }
                    _context.next = 11;
                    return (0,_api__WEBPACK_IMPORTED_MODULE_9__/* .getWPSPayStatus */ .BL)(billNo);
                case 11:
                    result = _context.sent;
                    if (!result.status) {
                        _context.next = 14;
                        break;
                    }
                    return _context.abrupt("return", true);
                case 14:
                    if (!(closed || (_options$shouldStop2 = options.shouldStop) !== null && _options$shouldStop2 !== void 0 && _options$shouldStop2.call(options))) {
                        _context.next = 16;
                        break;
                    }
                    return _context.abrupt("break", 20);
                case 16:
                    _context.next = 18;
                    return (0,_utils__WEBPACK_IMPORTED_MODULE_10__/* .sleep */ ._v)(pollInterval);
                case 18:
                    _context.next = 8;
                    break;
                case 20:
                    return _context.abrupt("return", false);
                case 21:
                    _context.prev = 21;
                    _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__/* ["default"].off */ .Z.off(_constant__WEBPACK_IMPORTED_MODULE_6__/* .WPS_PAY_MODAL_LISTENER_EVENT_CLOSE */ .BO, handleClose);
                    return _context.finish(21);
                case 24:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                7,
                ,
                21,
                24
            ]
        ]);
    }));
    return _pollWpsWebPayStatus.apply(this, arguments);
}
function getWPSBindInfo() {
    return _getWPSBindInfo.apply(this, arguments);
}
/**
 * WPS web端登录授权流程
 */ function _getWPSBindInfo() {
    _getWPSBindInfo = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().mark(function _callee2() {
        var hasWPSUserInfo, wpsUserInfo;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    hasWPSUserInfo = false;
                    _context2.prev = 1;
                    _context2.next = 4;
                    return (0,_api__WEBPACK_IMPORTED_MODULE_9__/* .getWPSUserInfo */ .xj)();
                case 4:
                    wpsUserInfo = _context2.sent;
                    ;
                    hasWPSUserInfo = !!wpsUserInfo.access_token;
                    // 同步 open_id 到埋点公共参数；未绑定时下方 catch 会把它清空
                    (0,_track__WEBPACK_IMPORTED_MODULE_4__/* .setWpsTrackCommonParams */ .U4)({
                        open_id: wpsUserInfo.open_id || ""
                    });
                    _context2.next = 14;
                    break;
                case 10:
                    _context2.prev = 10;
                    _context2.t0 = _context2["catch"](1);
                    ;
                    (0,_track__WEBPACK_IMPORTED_MODULE_4__/* .setWpsTrackCommonParams */ .U4)({
                        open_id: ""
                    });
                case 14:
                    // 通知业务方刷新用户信息（该接口可能涉及赠送权益，需要业务方重新拉取最新用户数据）
                    _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__/* ["default"].emit */ .Z.emit(_constant__WEBPACK_IMPORTED_MODULE_6__/* .WPS_BIND_INFO_UPDATED */ .J$);
                    return _context2.abrupt("return", hasWPSUserInfo);
                case 16:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                1,
                10
            ]
        ]);
    }));
    return _getWPSBindInfo.apply(this, arguments);
}
function wpsWebLogin() {
    return _wpsWebLogin.apply(this, arguments);
}
function _wpsWebLogin() {
    _wpsWebLogin = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().mark(function _callee3() {
        var hasWPSUserInfo;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return getWPSBindInfo();
                case 2:
                    hasWPSUserInfo = _context3.sent;
                    if (hasWPSUserInfo) {
                        _context3.next = 6;
                        break;
                    }
                    // 未绑定WPS，跳转到WPS去授权登录
                    (0,_web__WEBPACK_IMPORTED_MODULE_2__/* .redirectToWPS */ .lS)();
                    return _context3.abrupt("return", false);
                case 6:
                    // web 端已绑定 WPS（已有 access_token）= 已是可用登录态，与端内授权成功统一发出登录成功事件，
                    // 接入方监听 WPS_LOGIN_SUCCESS 即可，无需区分 client / web。
                    _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__/* ["default"].emit */ .Z.emit(_constant__WEBPACK_IMPORTED_MODULE_6__/* .WPS_LOGIN_SUCCESS */ .$K);
                    return _context3.abrupt("return", true);
                case 8:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return _wpsWebLogin.apply(this, arguments);
}
function attemptWPSClientAuth() {
    return _attemptWPSClientAuth.apply(this, arguments);
}
/**
 * WPS端内登录授权流程
 */ function _attemptWPSClientAuth() {
    _attemptWPSClientAuth = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().mark(function _callee4() {
        var res;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().wrap(function _callee4$(_context4) {
            while(1)switch(_context4.prev = _context4.next){
                case 0:
                    _context4.next = 2;
                    return (0,_client__WEBPACK_IMPORTED_MODULE_1__/* .getWPSClientUserInfo */ .XK)();
                case 2:
                    res = _context4.sent;
                    if (!(res.code === 0)) {
                        _context4.next = 15;
                        break;
                    }
                    _context4.prev = 4;
                    _context4.next = 7;
                    return (0,_api__WEBPACK_IMPORTED_MODULE_9__/* .wpsOAuth2Login */ .c3)(res.login_code);
                case 7:
                    // 美图授权换取 token 成功 —— 端内登录的最终成功收口点，发出统一登录成功事件。
                    // login() 通过监听此事件桥接「真正登录成功」，成功后才继续 loadAccount/登录回调。
                    _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__/* ["default"].emit */ .Z.emit(_constant__WEBPACK_IMPORTED_MODULE_6__/* .WPS_LOGIN_SUCCESS */ .$K);
                    _context4.next = 13;
                    break;
                case 10:
                    _context4.prev = 10;
                    _context4.t0 = _context4["catch"](4);
                    ;
                case 13:
                    _context4.next = 17;
                    break;
                case 15:
                    ;
                    // 拒绝授权时，通知业务方同步退出登录状态（不刷新页面）
                    // 为了解决授权后，去个人中心取消授权再次进入页面的情况
                    _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__/* ["default"].emit */ .Z.emit(_constant__WEBPACK_IMPORTED_MODULE_6__/* .WPS_LOGOUT_EVENT */ .mX);
                case 17:
                case "end":
                    return _context4.stop();
            }
        }, _callee4, null, [
            [
                4,
                10
            ]
        ]);
    }));
    return _attemptWPSClientAuth.apply(this, arguments);
}
function wpsClientLogin() {
    return _wpsClientLogin.apply(this, arguments);
}
/**
 * 检查是否登录了WPS，否则进行授权登录
 * 客户端和web端流程不同
 * @return {boolean} 是否已完成 WPS 绑定校验
 */ function _wpsClientLogin() {
    _wpsClientLogin = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().mark(function _callee5() {
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().wrap(function _callee5$(_context5) {
            while(1)switch(_context5.prev = _context5.next){
                case 0:
                    _context5.next = 2;
                    return (0,_client__WEBPACK_IMPORTED_MODULE_1__/* .waitWPSClientReady */ .uw)();
                case 2:
                    if (wpsClientLoggedIn) {
                        _context5.next = 7;
                        break;
                    }
                    _context5.next = 5;
                    return (0,_client__WEBPACK_IMPORTED_MODULE_1__/* .callWpsClientLogin */ .tb)();
                case 5:
                    _context5.next = 9;
                    break;
                case 7:
                    _context5.next = 9;
                    return attemptWPSClientAuth();
                case 9:
                    // 更新权益
                    getWPSBindInfo();
                    return _context5.abrupt("return", true);
                case 11:
                case "end":
                    return _context5.stop();
            }
        }, _callee5);
    }));
    return _wpsClientLogin.apply(this, arguments);
}
function wpsCheckLogin() {
    return _wpsCheckLogin.apply(this, arguments);
}
function _wpsCheckLogin() {
    _wpsCheckLogin = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().mark(function _callee6() {
        var hasBindWPS;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().wrap(function _callee6$(_context6) {
            while(1)switch(_context6.prev = _context6.next){
                case 0:
                    hasBindWPS = false;
                    if (!(0,_client__WEBPACK_IMPORTED_MODULE_1__/* .isFromWPSClient */ .Ku)()) {
                        _context6.next = 5;
                        break;
                    }
                    _context6.next = 4;
                    return wpsClientLogin();
                case 4:
                    hasBindWPS = _context6.sent;
                case 5:
                    if (!(0,_web__WEBPACK_IMPORTED_MODULE_2__/* .isFromWPSWeb */ .Js)()) {
                        _context6.next = 9;
                        break;
                    }
                    _context6.next = 8;
                    return wpsWebLogin();
                case 8:
                    hasBindWPS = _context6.sent;
                case 9:
                    return _context6.abrupt("return", hasBindWPS);
                case 10:
                case "end":
                    return _context6.stop();
            }
        }, _callee6);
    }));
    return _wpsCheckLogin.apply(this, arguments);
}
function isFromWPS() {
    return (0,_web__WEBPACK_IMPORTED_MODULE_2__/* .isFromWPSWeb */ .Js)() || (0,_client__WEBPACK_IMPORTED_MODULE_1__/* .isFromWPSClient */ .Ku)();
}
/**
 * 打开WPS支付弹窗
 */ function openWpsPayModal(_x2) {
    return _openWpsPayModal.apply(this, arguments);
}
/**
 * 获取 WPS access token
 * @returns WPS access token
 */ function _openWpsPayModal() {
    _openWpsPayModal = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().mark(function _callee8(trackParams) {
        var options, stopPayStatusPolling, preOrder, billNo, payStatusPromise, payResult, status, pollStatus, result, _options$onSuccess, _yield$getWPSPayInfo, url, _billNo, _status, _result, _options$onSuccess2, _args8 = arguments;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().wrap(function _callee8$(_context8) {
            while(1)switch(_context8.prev = _context8.next){
                case 0:
                    options = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {};
                    ;
                    if (!(0,_client__WEBPACK_IMPORTED_MODULE_1__/* .isFromWPSClient */ .Ku)()) {
                        _context8.next = 25;
                        break;
                    }
                    stopPayStatusPolling = false;
                    _context8.next = 6;
                    return (0,_client__WEBPACK_IMPORTED_MODULE_1__/* .createWPSClientPayOrder */ .A)((trackParams === null || trackParams === void 0 ? void 0 : trackParams.subscribe_type) || "");
                case 6:
                    preOrder = _context8.sent;
                    billNo = preOrder.bill_no; // 内嵌不需要打开弹出，但是需要上报事件
                    _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__/* ["default"].emit */ .Z.emit(_constant__WEBPACK_IMPORTED_MODULE_6__/* .WPS_PAY_MODAL_LISTENER_EVENT_SHOW */ .RT, {
                        show: false,
                        url: "",
                        trackParams: trackParams
                    });
                    payStatusPromise = pollWpsWebPayStatus(billNo, (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, options), {}, {
                        shouldStop: function shouldStop() {
                            return stopPayStatusPolling;
                        }
                    }));
                    payStatusPromise.catch(function(error) {
                        ;
                    });
                    _context8.next = 13;
                    return (0,_client__WEBPACK_IMPORTED_MODULE_1__/* .buyMerchandiseByBillno */ .ci)(billNo);
                case 13:
                    payResult = _context8.sent;
                    status = payResult.data.status;
                    ;
                    // 客户端支付接口返回后，最多再给服务端 10 秒同步支付状态；若轮询已成功则立即返回。
                    _context8.t0 = Boolean;
                    _context8.next = 19;
                    return Promise.race([
                        payStatusPromise,
                        (0,_utils__WEBPACK_IMPORTED_MODULE_10__/* .sleep */ ._v)(WPS_CLIENT_PAY_STATUS_SYNC_TIMEOUT).then(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().mark(function _callee7() {
                            return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().wrap(function _callee7$(_context7) {
                                while(1)switch(_context7.prev = _context7.next){
                                    case 0:
                                        stopPayStatusPolling = true;
                                        return _context7.abrupt("return", payStatusPromise);
                                    case 2:
                                    case "end":
                                        return _context7.stop();
                                }
                            }, _callee7);
                        })))
                    ]);
                case 19:
                    _context8.t1 = _context8.sent;
                    pollStatus = (0, _context8.t0)(_context8.t1);
                    ;
                    result = {
                        status: pollStatus,
                        url: ""
                    };
                    if (pollStatus) {
                        emitWpsPaySuccess(result, trackParams);
                        (_options$onSuccess = options.onSuccess) === null || _options$onSuccess === void 0 || _options$onSuccess.call(options, result);
                    }
                    return _context8.abrupt("return", result);
                case 25:
                    if (!(0,_web__WEBPACK_IMPORTED_MODULE_2__/* .isFromWPSWeb */ .Js)()) {
                        _context8.next = 40;
                        break;
                    }
                    _context8.next = 28;
                    return (0,_web__WEBPACK_IMPORTED_MODULE_2__/* .getWPSPayInfo */ .WO)(trackParams.subscribe_type || "");
                case 28:
                    _yield$getWPSPayInfo = _context8.sent;
                    url = _yield$getWPSPayInfo.url;
                    _billNo = _yield$getWPSPayInfo.billNo;
                    if (url) {
                        _context8.next = 33;
                        break;
                    }
                    return _context8.abrupt("return", {
                        status: false,
                        url: "",
                        billNo: _billNo
                    });
                case 33:
                    _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__/* ["default"].emit */ .Z.emit(_constant__WEBPACK_IMPORTED_MODULE_6__/* .WPS_PAY_MODAL_LISTENER_EVENT_SHOW */ .RT, {
                        show: true,
                        url: url,
                        trackParams: trackParams
                    });
                    _context8.next = 36;
                    return pollWpsWebPayStatus(_billNo, options);
                case 36:
                    _status = _context8.sent;
                    _result = {
                        status: _status,
                        url: url,
                        billNo: _billNo
                    };
                    if (_result.status) {
                        emitWpsPaySuccess(_result, trackParams);
                        (_options$onSuccess2 = options.onSuccess) === null || _options$onSuccess2 === void 0 || _options$onSuccess2.call(options, _result);
                    }
                    return _context8.abrupt("return", _result);
                case 40:
                    return _context8.abrupt("return", {
                        status: false,
                        url: ""
                    });
                case 41:
                case "end":
                    return _context8.stop();
            }
        }, _callee8);
    }));
    return _openWpsPayModal.apply(this, arguments);
}
function getWPSAccessToken() {
    var envPrefix = (0,_utils_env__WEBPACK_IMPORTED_MODULE_12__/* .getEnvPrefix */ .HN)((0,_configProvider__WEBPACK_IMPORTED_MODULE_13__/* .getConfig */ .iE)().env);
    var cookieName = "__mt".concat(envPrefix ? "_".concat(envPrefix) : "", "_wps_access_token__");
    if ((0,_runtime__WEBPACK_IMPORTED_MODULE_14__/* .isServerSide */ .s)()) return "";
    return js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(cookieName);
}
/**
 * WPS 端内中间页专用：等待客户端就绪并读取 launchOptions 下发的 redirect_url。
 * 仅用于路由分发，不包含任何业务 / 登录 / 埋点初始化逻辑。
 * @param timeout - 兜底超时（毫秒），超时后返回默认路径，避免卡在 loading 页
 * @returns 目标相对路径（含 path 与 query）；未下发 redirect_url 时返回 '/'
 */ function resolveWpsLaunchRedirectUrl() {
    return _resolveWpsLaunchRedirectUrl.apply(this, arguments);
}
/**
 * WPS 相关初始化逻辑
 * web 进入页面就强制 wps 登录
 * 内嵌 每次进入时都弹出授权弹窗，允许关闭
 */ function _resolveWpsLaunchRedirectUrl() {
    _resolveWpsLaunchRedirectUrl = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().mark(function _callee10() {
        var timeout, DEFAULT_REDIRECT_URL, resolveFromClient, _args10 = arguments;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().wrap(function _callee10$(_context10) {
            while(1)switch(_context10.prev = _context10.next){
                case 0:
                    timeout = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : 3000;
                    DEFAULT_REDIRECT_URL = "/";
                    if (!(0,_runtime__WEBPACK_IMPORTED_MODULE_14__/* .isServerSide */ .s)()) {
                        _context10.next = 4;
                        break;
                    }
                    return _context10.abrupt("return", DEFAULT_REDIRECT_URL);
                case 4:
                    resolveFromClient = /*#__PURE__*/ function() {
                        var _ref2 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().mark(function _callee9() {
                            var _launchOptions$data;
                            var launchOptions;
                            return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().wrap(function _callee9$(_context9) {
                                while(1)switch(_context9.prev = _context9.next){
                                    case 0:
                                        _context9.next = 2;
                                        return (0,_client__WEBPACK_IMPORTED_MODULE_1__/* .waitWPSClientReady */ .uw)();
                                    case 2:
                                        _context9.next = 4;
                                        return (0,_client__WEBPACK_IMPORTED_MODULE_1__/* .getLaunchOptions */ .vX)();
                                    case 4:
                                        launchOptions = _context9.sent;
                                        return _context9.abrupt("return", (launchOptions === null || launchOptions === void 0 || (_launchOptions$data = launchOptions.data) === null || _launchOptions$data === void 0 || (_launchOptions$data = _launchOptions$data.extraData) === null || _launchOptions$data === void 0 ? void 0 : _launchOptions$data.redirect_url) || DEFAULT_REDIRECT_URL);
                                    case 6:
                                    case "end":
                                        return _context9.stop();
                                }
                            }, _callee9);
                        }));
                        return function resolveFromClient() {
                            return _ref2.apply(this, arguments);
                        };
                    }();
                    _context10.prev = 5;
                    _context10.next = 8;
                    return Promise.race([
                        resolveFromClient(),
                        (0,_utils__WEBPACK_IMPORTED_MODULE_10__/* .sleep */ ._v)(timeout).then(function() {
                            return DEFAULT_REDIRECT_URL;
                        })
                    ]);
                case 8:
                    return _context10.abrupt("return", _context10.sent);
                case 11:
                    _context10.prev = 11;
                    _context10.t0 = _context10["catch"](5);
                    ;
                    return _context10.abrupt("return", DEFAULT_REDIRECT_URL);
                case 15:
                case "end":
                    return _context10.stop();
            }
        }, _callee10, null, [
            [
                5,
                11
            ]
        ]);
    }));
    return _resolveWpsLaunchRedirectUrl.apply(this, arguments);
}
function wpsInit(_x3) {
    return _wpsInit.apply(this, arguments);
}
function _wpsInit() {
    _wpsInit = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().mark(function _callee12(options) {
        var client, queryParams, position, hasWPSUserInfo, _window, ua, _options$data, _options, _position;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().wrap(function _callee12$(_context12) {
            while(1)switch(_context12.prev = _context12.next){
                case 0:
                    (0,_source__WEBPACK_IMPORTED_MODULE_3__/* .syncWpsSourceParamsFromUrl */ ._i)();
                    // 初始化 WPS DW 埋点 SDK
                    (0,_track__WEBPACK_IMPORTED_MODULE_4__/* .loadWpsDwSdk */ .LP)();
                    if (options !== null && options !== void 0 && options.moduleId) {
                        (0,_track__WEBPACK_IMPORTED_MODULE_4__/* .setWpsTrackCommonParams */ .U4)({
                            module_id: options.moduleId
                        });
                    }
                    client = "web"; // web 端 position 来自 URL query，命中较早（不依赖 WPS 客户端就绪），先写入；
                    // 端内 position 在下方 waitWPSClientReady 后用 launchOptions 覆盖。
                    if (!(0,_runtime__WEBPACK_IMPORTED_MODULE_14__/* .isServerSide */ .s)() && (0,_web__WEBPACK_IMPORTED_MODULE_2__/* .isFromWPSWeb */ .Js)()) {
                        queryParams = new URLSearchParams(window.location.search);
                        position = queryParams.get("position") || "docertest";
                        (0,_track__WEBPACK_IMPORTED_MODULE_4__/* .setWpsTrackCommonParams */ .U4)({
                            position: position,
                            client: client
                        });
                    }
                    _context12.next = 7;
                    return getWPSBindInfo();
                case 7:
                    hasWPSUserInfo = _context12.sent;
                    if (!((0,_web__WEBPACK_IMPORTED_MODULE_2__/* .isFromWPSWeb */ .Js)() && !hasWPSUserInfo)) {
                        _context12.next = 11;
                        break;
                    }
                    // web 端未绑定WPS，跳转到WPS去授权登录
                    (0,_web__WEBPACK_IMPORTED_MODULE_2__/* .redirectToWPS */ .lS)();
                    return _context12.abrupt("return");
                case 11:
                    if (!(0,_client__WEBPACK_IMPORTED_MODULE_1__/* .isFromWPSClient */ .Ku)()) {
                        _context12.next = 50;
                        break;
                    }
                    _context12.next = 14;
                    return (0,_client__WEBPACK_IMPORTED_MODULE_1__/* .waitWPSClientReady */ .uw)();
                case 14:
                    client = "PC";
                    ua = (_window = window) === null || _window === void 0 || (_window = _window.navigator) === null || _window === void 0 ? void 0 : _window.userAgent;
                    if (ua !== null && ua !== void 0 && ua.includes("Mac") || ua !== null && ua !== void 0 && ua.includes("mac")) {
                        client = "Mac";
                    }
                    // 端内 position 来自 WPS 客户端 launchOptions，与 createWPSClientPayOrder 复用同一来源与 fallback。
                    _context12.prev = 17;
                    _context12.next = 20;
                    return (0,_client__WEBPACK_IMPORTED_MODULE_1__/* .getLaunchOptions */ .vX)();
                case 20:
                    _options = _context12.sent;
                    _position = (_options === null || _options === void 0 || (_options$data = _options.data) === null || _options$data === void 0 || (_options$data = _options$data.extraData) === null || _options$data === void 0 ? void 0 : _options$data.position) || "docertest";
                    (0,_track__WEBPACK_IMPORTED_MODULE_4__/* .setWpsTrackCommonParams */ .U4)({
                        position: _position,
                        client: client
                    });
                    _context12.next = 29;
                    break;
                case 25:
                    _context12.prev = 25;
                    _context12.t0 = _context12["catch"](17);
                    ;
                    (0,_track__WEBPACK_IMPORTED_MODULE_4__/* .setWpsTrackCommonParams */ .U4)({
                        position: "docertest",
                        client: client
                    });
                case 29:
                    if ((0,_client__WEBPACK_IMPORTED_MODULE_1__/* .isFromWPSClientOpenImage */ .UC)()) {
                        (0,_client__WEBPACK_IMPORTED_MODULE_1__/* .callWpsWebLoadFinish */ .MQ)();
                        (0,_client__WEBPACK_IMPORTED_MODULE_1__/* .initWPSInsertImageListeners */ .xv)();
                    }
                    // 注销事件监听
                    (0,_client__WEBPACK_IMPORTED_MODULE_1__/* .offLoginStatusChanged */ .De)();
                    // 监听WPS登录状态变化事件，登录状态变化时同步更新设计室登录状态
                    (0,_client__WEBPACK_IMPORTED_MODULE_1__/* .onWPSLoginStatusChanged */ .g4)(/*#__PURE__*/ function() {
                        var _ref3 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().mark(function _callee11(isLogin) {
                            return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().wrap(function _callee11$(_context11) {
                                while(1)switch(_context11.prev = _context11.next){
                                    case 0:
                                        wpsClientLoggedIn = isLogin;
                                        ;
                                        if (isLogin) {
                                            _context11.next = 7;
                                            break;
                                        }
                                        ;
                                        // 通知业务方同步退出登录状态（不刷新页面）
                                        _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__/* ["default"].emit */ .Z.emit(_constant__WEBPACK_IMPORTED_MODULE_6__/* .WPS_LOGOUT_EVENT */ .mX);
                                        _context11.next = 12;
                                        break;
                                    case 7:
                                        ;
                                        _context11.next = 10;
                                        return attemptWPSClientAuth();
                                    case 10:
                                        _context11.next = 12;
                                        return getWPSBindInfo();
                                    case 12:
                                    case "end":
                                        return _context11.stop();
                                }
                            }, _callee11);
                        }));
                        return function(_x4) {
                            return _ref3.apply(this, arguments);
                        };
                    }());
                    // 初始化时主动查询一次当前登录状态
                    _context12.prev = 32;
                    _context12.next = 35;
                    return (0,_client__WEBPACK_IMPORTED_MODULE_1__/* .wpsClientIsLogin */ .Kp)();
                case 35:
                    wpsClientLoggedIn = _context12.sent;
                    _context12.next = 41;
                    break;
                case 38:
                    _context12.prev = 38;
                    _context12.t1 = _context12["catch"](32);
                    ;
                case 41:
                    if (wpsClientLoggedIn) {
                        _context12.next = 46;
                        break;
                    }
                    _context12.next = 44;
                    return (0,_client__WEBPACK_IMPORTED_MODULE_1__/* .callWpsClientLogin */ .tb)();
                case 44:
                    _context12.next = 50;
                    break;
                case 46:
                    _context12.next = 48;
                    return attemptWPSClientAuth();
                case 48:
                    _context12.next = 50;
                    return getWPSBindInfo();
                case 50:
                case "end":
                    return _context12.stop();
            }
        }, _callee12, null, [
            [
                17,
                25
            ],
            [
                32,
                38
            ]
        ]);
    }));
    return _wpsInit.apply(this, arguments);
}


/***/ }),

/***/ 26860:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": () => (/* binding */ isServerSide)
/* harmony export */ });
var isServerSide = function isServerSide() {
    return  false || typeof document === "undefined";
};


/***/ }),

/***/ 58730:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N0": () => (/* binding */ appendWpsSourceParamsToUrl),
/* harmony export */   "Sl": () => (/* binding */ isFromWpsSource),
/* harmony export */   "_i": () => (/* binding */ syncWpsSourceParamsFromUrl)
/* harmony export */ });
/* unused harmony exports getWpsSourceParams, hasWpsSource */
/* harmony import */ var _babel_runtime_helpers_esm_createForOfIteratorHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33222);
/* harmony import */ var _runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26860);


var WPS_CHANNELS = new Set([
    "wps_web",
    "wps_pc"
]);
// WPS 来源需要在浏览器会话内跨 Tab 共享：同一浏览器窗口新开标签页也能识别来源。
// 使用不设 expires/max-age 的 session cookie，浏览器关闭时自动清除。
var WPS_SESSION_CHANNEL_KEY = "wps_channel";
var WPS_SESSION_SOURCE_KEY = "wps_from_wps";
// localStorage 复用与 cookie 相同的 key，作为客户端场景下更持久的来源标记。
var WPS_LS_CHANNEL_KEY = "wps_channel";
var WPS_LS_SOURCE_KEY = "wps_from_wps";
var ABSOLUTE_URL_PATTERN = /^(?:[a-z]+:)?\/\//i;
var setSessionCookie = function setSessionCookie(key, value) {
    if ((0,_runtime__WEBPACK_IMPORTED_MODULE_0__/* .isServerSide */ .s)()) return;
    document.cookie = "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value), ";path=/;SameSite=Lax");
};
var getSessionCookie = function getSessionCookie(key) {
    if ((0,_runtime__WEBPACK_IMPORTED_MODULE_0__/* .isServerSide */ .s)()) return null;
    var name = encodeURIComponent(key);
    var _iterator = (0,_babel_runtime_helpers_esm_createForOfIteratorHelper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(document.cookie.split(";")), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var cookie = _step.value;
            var trimmed = cookie.trim();
            if (trimmed.startsWith("".concat(name, "="))) {
                return decodeURIComponent(trimmed.substring(name.length + 1));
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return null;
};
var setLocalStorageItem = function setLocalStorageItem(key, value) {
    if ((0,_runtime__WEBPACK_IMPORTED_MODULE_0__/* .isServerSide */ .s)()) return;
    try {
        window.localStorage.setItem(key, value);
    } catch (_error) {
    // localStorage 可能被禁用（隐私模式 / 容器限制等），写入失败时忽略。
    }
};
var getLocalStorageItem = function getLocalStorageItem(key) {
    if ((0,_runtime__WEBPACK_IMPORTED_MODULE_0__/* .isServerSide */ .s)()) return null;
    try {
        return window.localStorage.getItem(key);
    } catch (_error) {
        return null;
    }
};
var emptyWpsSourceParams = function emptyWpsSourceParams() {
    return {
        channel: "",
        from_wps: ""
    };
};
var isValidWpsSource = function isValidWpsSource(fromWps) {
    return fromWps === "web" || fromWps === "client";
};
var isValidWpsSourceParams = function isValidWpsSourceParams(_ref) {
    var channel = _ref.channel, from_wps = _ref.from_wps;
    return WPS_CHANNELS.has(channel) && isValidWpsSource(from_wps);
};
// 是否运行在 WPS 客户端 webview 中（以 UA 为准，与 correctWpsSourceParams 的判断保持一致）。
// 仅客户端才允许读写 localStorage，web 来源严格保持会话级。
var isWpsClientUA = function isWpsClientUA() {
    var _window;
    if ((0,_runtime__WEBPACK_IMPORTED_MODULE_0__/* .isServerSide */ .s)()) return false;
    var ua = (_window = window) === null || _window === void 0 || (_window = _window.navigator) === null || _window === void 0 ? void 0 : _window.userAgent;
    return !!ua && ua.includes("WpsOfficeApp");
};
/**
 * 修正 WpsSourceParams
 * @param params WpsSourceParams
 * @returns WpsSourceParams
 */ var correctWpsSourceParams = function correctWpsSourceParams(params) {
    var _window2;
    if (!window) return params;
    var ua = (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.navigator) === null || _window2 === void 0 ? void 0 : _window2.userAgent;
    if (!ua) return params;
    // 如果 params 不合法，则直接返回
    if (!isValidWpsSourceParams(params)) return params;
    var isClient = ua.includes("WpsOfficeApp");
    // 判断是否需要修正
    if (isClient && params.channel === "wps_pc" && params.from_wps === "client") {
        return params;
    }
    if (!isClient && params.channel === "wps_web" && params.from_wps === "web") {
        return params;
    }
    var newParams = params;
    // 加入根据 ua 判断逻辑，对nextParams进行修正，如果 ua 包含WpsOfficeApp，就一定是端内，否则是web
    if (isClient) {
        newParams = {
            channel: "wps_pc",
            from_wps: "client"
        };
    } else {
        newParams = {
            channel: "wps_web",
            from_wps: "web"
        };
    }
    // url 链接修正
    var url = new URL(window.location.href);
    url.searchParams.set("channel", newParams.channel);
    url.searchParams.set("from_wps", newParams.from_wps);
    window.history.replaceState(window.history.state, "", url.toString());
    return newParams;
};
var normalizeWpsSourceParams = function normalizeWpsSourceParams(params) {
    var nextParams = {
        channel: params.channel || "",
        from_wps: params.from_wps || ""
    };
    nextParams = correctWpsSourceParams(nextParams);
    return isValidWpsSourceParams(nextParams) ? nextParams : emptyWpsSourceParams();
};
var getWpsSourceParamsFromSearch = function getWpsSourceParamsFromSearch(search) {
    var queryParams = new URLSearchParams(search);
    return normalizeWpsSourceParams({
        channel: queryParams.get("channel") || "",
        from_wps: queryParams.get("from_wps") || ""
    });
};
var getStoredWpsSourceParams = function getStoredWpsSourceParams() {
    if ((0,_runtime__WEBPACK_IMPORTED_MODULE_0__/* .isServerSide */ .s)()) {
        return emptyWpsSourceParams();
    }
    // 优先读取 session cookie。
    var cookieParams = normalizeWpsSourceParams({
        channel: getSessionCookie(WPS_SESSION_CHANNEL_KEY) || "",
        from_wps: getSessionCookie(WPS_SESSION_SOURCE_KEY) || ""
    });
    if (isValidWpsSourceParams(cookieParams)) {
        return cookieParams;
    }
    // localStorage 仅作为「客户端来源」的持久化兜底。
    // 注意：绝不能对 ls 数据调用 normalizeWpsSourceParams —— 其内部 correctWpsSourceParams 在
    // 「数据合法但与 UA 不符」时会执行 window.history.replaceState 改写 URL（带副作用）。
    // 否则普通浏览器中 ls 残留的 client 身份会被「修正」为 web 并静默写入 URL，
    // 进而被 getWpsSourceParams 当作合法 web 来源读出，造成 URL 污染与 web 身份复活，
    // 违反「web 来源必须保持会话级、绝不能从 ls 恢复」的规则。
    // 因此这里直接比对原始值：只有原始标识为 client 且当前 UA 确为 WPS 客户端时才采用。
    var lsParams = {
        channel: getLocalStorageItem(WPS_LS_CHANNEL_KEY) || "",
        from_wps: getLocalStorageItem(WPS_LS_SOURCE_KEY) || ""
    };
    if (isWpsClientUA() && isValidWpsSourceParams(lsParams) && lsParams.from_wps === "client") {
        return lsParams;
    }
    return emptyWpsSourceParams();
};
var serializeUrl = function serializeUrl(rawUrl, urlObject) {
    if (ABSOLUTE_URL_PATTERN.test(rawUrl)) {
        return urlObject.toString();
    }
    return "".concat(urlObject.pathname).concat(urlObject.search).concat(urlObject.hash);
};
/**
 * 读取当前生效的 WPS 来源。
 * 优先使用当前 URL 中的显式参数，其次回退到 session cookie，最后回退到 localStorage。
 * 这样既能支持外部回跳时的最新来源，也能覆盖站内 Link/a 未保留 query 的场景；
 * localStorage 仅服务于 WPS 客户端（cookie 不可靠场景），web 来源始终保持会话级。
 */ var getWpsSourceParams = function getWpsSourceParams() {
    if ((0,_runtime__WEBPACK_IMPORTED_MODULE_0__/* .isServerSide */ .s)()) {
        return emptyWpsSourceParams();
    }
    var urlParams = getWpsSourceParamsFromSearch(window.location.search);
    if (isValidWpsSourceParams(urlParams)) {
        return urlParams;
    }
    return getStoredWpsSourceParams();
};
/**
 * 将 URL 里的 WPS 来源同步到当前会话。
 * 首次从 WPS 进入站点时，query 是最可靠的来源标记；
 * 但后续站内切页、手写 a 标签或 react-router Link 往往不会持续保留这两个参数。
 * 因此需要在应用初始化时先把合法来源落到 session cookie，
 * 这样同一会话内继续跳转或刷新页面时，仍然可以识别为 WPS 场景。
 * 如果未来出现“不刷新页面、仅靠前端路由切换就带着 WPS query 进入当前 SPA”的场景，
 * 再考虑在路由变化时补充调用即可。
 */ var syncWpsSourceParamsFromUrl = function syncWpsSourceParamsFromUrl() {
    if ((0,_runtime__WEBPACK_IMPORTED_MODULE_0__/* .isServerSide */ .s)()) {
        return emptyWpsSourceParams();
    }
    var urlParams = getWpsSourceParamsFromSearch(window.location.search);
    if (isValidWpsSourceParams(urlParams)) {
        setSessionCookie(WPS_SESSION_CHANNEL_KEY, urlParams.channel);
        setSessionCookie(WPS_SESSION_SOURCE_KEY, urlParams.from_wps);
        // 仅客户端场景额外写入 localStorage：webview 内 cookie 可能被清理或不共享，
        // ls 作为更持久的来源标记。双重校验（来源为 client + UA 为 WpsOfficeApp），
        // 确保 web 场景绝不会把标识种到 ls（web 必须保持会话级）。
        if (urlParams.from_wps === "client" && isWpsClientUA()) {
            setLocalStorageItem(WPS_LS_CHANNEL_KEY, urlParams.channel);
            setLocalStorageItem(WPS_LS_SOURCE_KEY, urlParams.from_wps);
        }
        return urlParams;
    }
    return getStoredWpsSourceParams();
};
var isFromWpsSource = function isFromWpsSource(source) {
    var params = getWpsSourceParams();
    return WPS_CHANNELS.has(params.channel) && params.from_wps === source;
};
var hasWpsSource = function hasWpsSource() {
    var params = getWpsSourceParams();
    return isValidWpsSourceParams(params);
};
/**
 * 为目标 URL 补齐当前会话中的 WPS 来源。
 * 站内同 tab 页面可直接依赖 sessionStorage；
 * 但跨项目、跨域或新开页面时，对方拿不到当前 tab 的会话态，就需要把来源重新带回 URL。
 */ var appendWpsSourceParamsToUrl = function appendWpsSourceParamsToUrl(url) {
    if ((0,_runtime__WEBPACK_IMPORTED_MODULE_0__/* .isServerSide */ .s)() || !url) {
        return url;
    }
    var params = getWpsSourceParams();
    if (!isValidWpsSourceParams(params)) {
        return url;
    }
    var urlObject = new URL(url, window.location.href);
    urlObject.searchParams.set("channel", params.channel);
    urlObject.searchParams.set("from_wps", params.from_wps);
    return serializeUrl(url, urlObject);
};


/***/ }),

/***/ 4592:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LP": () => (/* binding */ loadWpsDwSdk),
  "U4": () => (/* binding */ setWpsTrackCommonParams),
  "Kx": () => (/* binding */ trackWpsEvent)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js
var createForOfIteratorHelper = __webpack_require__(33222);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(81549);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/configProvider/index.js
var configProvider = __webpack_require__(84480);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/env.js
var env = __webpack_require__(20820);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/constant.js
var constant = __webpack_require__(8382);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/runtime.js
var runtime = __webpack_require__(26860);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/trackWhitelist.js
/**
 * WPS 埋点事件白名单及允许上报的业务参数字段。
 * - 不在白名单中的事件不会上报
 * - 在白名单中的事件只保留对应的业务参数字段（公共参数由 buildPayload 自动合并）
 */ var WPS_EVENT_WHITELIST = {
    module_click: [
        "class"
    ],
    tool_ai_click: [
        "fun"
    ],
    home_lateral_click: [
        "class"
    ],
    aispt_enter: [
        "func_enter",
        "first_func"
    ],
    ai_create_show: [
        "func_enter",
        "first_func"
    ],
    aifit_enter: [
        "func_enter",
        "first_func"
    ],
    aieraser_enter: [
        "func_enter",
        "first_func"
    ],
    quality_enter: [
        "func_enter",
        "first_func"
    ],
    ai_poster_enter: [
        "func_enter",
        "first_func"
    ],
    ailogo_enter: [
        "func_enter",
        "first_func"
    ],
    ai_shoedesign_enter: [
        "func_enter",
        "first_func"
    ],
    aimodel_enter: [
        "func_enter",
        "first_func"
    ],
    upscale_enter: [
        "func_enter",
        "first_func"
    ],
    template_enter: [
        "func_enter",
        "first_func"
    ],
    tpbj_enter: [
        "func_enter",
        "first_func"
    ],
    pt_enter: [
        "func_enter",
        "first_func"
    ],
    zjzsj_enter: [
        "func_enter",
        "first_func"
    ],
    sp_page_enter: [
        "func_enter",
        "first_func"
    ],
    tools_page_enter: [
        "func_enter",
        "first_func"
    ],
    aitemplate_enter: [
        "func_enter",
        "first_func"
    ],
    page_start: [
        "func_enter",
        "first_func"
    ],
    kt_enter: [
        "func_enter",
        "first_func"
    ],
    aispt_download_success: [
        "func_enter",
        "first_func"
    ],
    aippt_download_success: [
        "func_enter",
        "first_func"
    ],
    aifit_download_succeed: [
        "func_enter",
        "first_func"
    ],
    aieraser_download_success: [
        "func_enter",
        "first_func"
    ],
    quality_download_success: [
        "func_enter",
        "first_func"
    ],
    aihb_download_success: [
        "func_enter",
        "first_func"
    ],
    ailogo_download_success: [
        "func_enter",
        "first_func"
    ],
    aishoedesign_download_success: [
        "func_enter",
        "first_func"
    ],
    upscale_download_success: [
        "func_enter",
        "first_func"
    ],
    aimodel_download_succeed: [
        "func_enter",
        "first_func"
    ],
    hb_download_backwindow_click: [
        "func_enter",
        "first_func"
    ],
    tpbj_download_succeed: [
        "func_enter",
        "first_func"
    ],
    pt_download_succeed: [
        "func_enter",
        "first_func"
    ],
    zjzsj_download_succeed: [
        "func_enter",
        "first_func"
    ],
    kt_download_succeed: [
        "func_enter",
        "first_func"
    ],
    sp_download_success: [
        "func_enter",
        "first_func"
    ],
    zjz_picture_save: [
        "func_enter",
        "first_func"
    ],
    tools_download_success: [
        "func_enter",
        "first_func"
    ],
    canvas_save_success: [
        "func_enter",
        "first_func"
    ],
    aitemplate_download_success: [
        "func_enter",
        "first_func"
    ],
    aispt_create_click: [
        "func_enter",
        "first_func"
    ],
    aieraser_subfunction_use: [
        "func_enter",
        "first_func"
    ],
    quality_subfunction_click: [
        "func_enter",
        "first_func"
    ],
    ai_create_click: [
        "func_enter",
        "first_func"
    ],
    aifit_create_click: [
        "func_enter",
        "first_func"
    ],
    aihb_create_click: [
        "func_enter",
        "first_func"
    ],
    upload_picture_succeed: [
        "func_enter",
        "first_func"
    ],
    ailogo_create_click: [
        "func_enter",
        "first_func"
    ],
    aishoedesign_start_click: [
        "func_enter",
        "first_func"
    ],
    upscale_click: [
        "func_enter",
        "first_func"
    ],
    aimodel_create_click: [
        "func_enter",
        "first_func"
    ],
    sp_create_click: [
        "func_enter",
        "first_func"
    ],
    tools_subfunction_use: [
        "func_enter",
        "first_func"
    ],
    tools_create_click: [
        "func_enter",
        "first_func"
    ],
    command_send_click: [
        "func_enter",
        "first_func"
    ],
    aitemplate_create_click: [
        "func_enter",
        "first_func"
    ]
};

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/track.js







var WPS_DW_SDK_URL = "https://titan-h5.meitu.com/x-design/design/dw-web.min.js";
/**
 * WPS 埋点公共参数。
 * - client: 客户端类型 1.web；2.PC；3.Mac；4.ios；5.Android
 * - app_id：根据环境动态决定，SDK 就绪时由内部写入
 * - open_id：拿到 WPS 绑定用户信息后由调用方写入；未绑定时为空字符串
 * - position：来源不同（端内来自 launchOptions，web 来自 URL query），由调用方写入
 * - module_id：业务模块标识，由各业务在 wpsInit 时传入
 */ var _dwSdkReady = false;
var _dwSdkLoading = false;
var _dwEventQueue = [];
var _commonParams = {
    client: "",
    app_id: "",
    open_id: "",
    position: "",
    module_id: ""
};
/**
 * 设置/更新 WPS 埋点公共参数。
 * 支持分批写入，便于 app_id / open_id / position 在各自就绪时机分别注入。
 * 对应字段缺失（拿不到 open_id、launchOptions 失败等）时，调用方应显式传空字符串而非 undefined。
 */ function setWpsTrackCommonParams(partial) {
    if (partial.client !== undefined) _commonParams.client = partial.client;
    if (partial.app_id !== undefined) _commonParams.app_id = partial.app_id;
    if (partial.open_id !== undefined) _commonParams.open_id = partial.open_id;
    if (partial.position !== undefined) _commonParams.position = partial.position;
    if (partial.module_id !== undefined) _commonParams.module_id = partial.module_id;
}
/**
 * 合并公共参数与业务参数，业务参数同名字段可覆盖公共参数。
 */ function buildPayload(data) {
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, _commonParams), data);
}
/**
 * 动态加载 WPS DW 埋点 SDK（CDN），加载完成前的事件进队列，加载后自动 flush
 */ function loadWpsDwSdk() {
    if ((0,runtime/* isServerSide */.s)()) return;
    if (_dwSdkReady || _dwSdkLoading) return;
    _dwSdkLoading = true;
    var script = document.createElement("script");
    script.src = WPS_DW_SDK_URL;
    script.onload = function() {
        var _window$dw;
        _dwSdkReady = true;
        _dwSdkLoading = false;
        ;
        (_window$dw = window.dw) === null || _window$dw === void 0 || _window$dw.setAppKey("cf2885b70b06f1d1");
        if ((0,configProvider/* getConfig */.iE)().env !== env/* ENV_ENUM.release */.BD.release) {
            var _window$dw2;
            (_window$dw2 = window.dw) === null || _window$dw2 === void 0 || _window$dw2.setDebug(true);
        }
        // app_id 来自当前环境配置，SDK 就绪时写入公共参数；
        // 此前进队列的事件在下方 flush 时会用到这个值。
        setWpsTrackCommonParams({
            app_id: constant/* appinfo.appid */.hm.appid
        });
        _dwEventQueue.forEach(function(_ref) {
            var _window$dw3;
            var eventName = _ref.eventName, data = _ref.data;
            (_window$dw3 = window.dw) === null || _window$dw3 === void 0 || _window$dw3.onEvent(eventName, buildPayload(data));
        });
        _dwEventQueue.length = 0;
    };
    script.onerror = function() {
        ;
        _dwSdkLoading = false;
    };
    document.head.appendChild(script);
}
function filterEventData(eventName, data) {
    var allowedKeys = WPS_EVENT_WHITELIST[eventName];
    if (!allowedKeys || !data) return undefined;
    var filtered = {};
    var _iterator = (0,createForOfIteratorHelper/* default */.Z)(allowedKeys), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            if (key in data) {
                filtered[key] = data[key];
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return Object.keys(filtered).length > 0 ? filtered : undefined;
}
function trackWpsEvent(eventName, data) {
    if (!(eventName in WPS_EVENT_WHITELIST)) return;
    var filteredData = filterEventData(eventName, data);
    if (_dwSdkReady) {
        var _window$dw4;
        (_window$dw4 = window.dw) === null || _window$dw4 === void 0 || _window$dw4.onEvent(eventName, buildPayload(filteredData));
    } else {
        // 入队时保留业务 data，flush 时再合并最新公共参数；
        // 这样队列期间 open_id / position 还没就绪时也不会丢业务字段。
        _dwEventQueue.push({
            eventName: eventName,
            data: filteredData
        });
    }
}


/***/ }),

/***/ 69839:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Js": () => (/* binding */ isFromWPSWeb),
/* harmony export */   "WO": () => (/* binding */ getWPSPayInfo),
/* harmony export */   "lS": () => (/* binding */ redirectToWPS)
/* harmony export */ });
/* unused harmony exports buildWpsRedirectURL, formatWPSOauth2AuthorizeUrl, getWPSPayUrl */
/* harmony import */ var _babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89255);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87406);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30947);
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8382);
/* harmony import */ var _runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26860);
/* harmony import */ var _source__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58730);






/**
 * 构造 WPS 登录授权成功后的回跳 URL。
 * 默认将当前页面的 query 参数透传到回跳地址，同时过滤黑名单中的参数，
 * 最后追加内部固定的 channel 和 from_wps 标识。
 */ function buildWpsRedirectURL() {
    var baseURL = new URL(_constant__WEBPACK_IMPORTED_MODULE_0__/* .appinfo.redirectURL */ .hm.redirectURL);
    // 服务端渲染时无 window.location，直接返回基础 URL + 固定参数
    if (!(0,_runtime__WEBPACK_IMPORTED_MODULE_1__/* .isServerSide */ .s)()) {
        var currentParams = new URLSearchParams(window.location.search);
        currentParams.forEach(function(value, key) {
            if (!_constant__WEBPACK_IMPORTED_MODULE_0__/* .WPS_REDIRECT_QUERY_BLACKLIST.has */ .$m.has(key)) {
                baseURL.searchParams.set(key, value);
            }
        });
    }
    // 内部固定参数最后设置，确保不被当前页 query 覆盖
    baseURL.searchParams.set("channel", "wps_web");
    baseURL.searchParams.set("from_wps", "web");
    return baseURL.toString();
}
/**
 * 格式化WPS授权登录URL
 * @return {string} WPS 授权登录链接
 */ function formatWPSOauth2AuthorizeUrl() {
    var redirect_url = buildWpsRedirectURL();
    var authorizeURL = new URL(_constant__WEBPACK_IMPORTED_MODULE_0__/* .appinfo.authorizeURL */ .hm.authorizeURL);
    var wpsAuthorizeURL = new URL(_constant__WEBPACK_IMPORTED_MODULE_0__/* .servers.authorize */ .cb.authorize);
    authorizeURL.searchParams.set("redirect_url", redirect_url);
    wpsAuthorizeURL.searchParams.set("response_type", "code");
    wpsAuthorizeURL.searchParams.set("appid", _constant__WEBPACK_IMPORTED_MODULE_0__/* .appinfo.appid */ .hm.appid);
    wpsAuthorizeURL.searchParams.set("autologin", "true");
    wpsAuthorizeURL.searchParams.set("redirect_uri", authorizeURL.toString());
    wpsAuthorizeURL.searchParams.set("scope", _constant__WEBPACK_IMPORTED_MODULE_0__/* .appinfo.scope */ .hm.scope);
    wpsAuthorizeURL.searchParams.set("state", "wps-redirect");
    return wpsAuthorizeURL.toString();
}
/**
 * 判断是否来自WPS web渠道
 * @return {boolean} 是否来自 WPS web 渠道
 */ function isFromWPSWeb() {
    return (0,_source__WEBPACK_IMPORTED_MODULE_2__/* .isFromWpsSource */ .Sl)("web");
}
/**
 * 跳转到WPS授权登录
 */ function redirectToWPS() {
    if ((0,_runtime__WEBPACK_IMPORTED_MODULE_1__/* .isServerSide */ .s)()) return;
    var authorizeUri = formatWPSOauth2AuthorizeUrl();
    window.location.replace(authorizeUri);
}
/**
 * 获取WPS支付弹窗信息
 */ function getWPSPayInfo(_x) {
    return _getWPSPayInfo.apply(this, arguments);
}
/**
 * 获取WPS支付弹窗URL
 */ function _getWPSPayInfo() {
    _getWPSPayInfo = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().mark(function _callee(subscribe_type) {
        var webPayUrl, billNo, queryParams, position, data;
        return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    webPayUrl = "";
                    billNo = "";
                    if (!(0,_runtime__WEBPACK_IMPORTED_MODULE_1__/* .isServerSide */ .s)()) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return", {
                        url: "",
                        billNo: ""
                    });
                case 4:
                    queryParams = new URLSearchParams(window.location.search);
                    position = queryParams.get("position") || "docertest";
                    _context.next = 8;
                    return (0,_api__WEBPACK_IMPORTED_MODULE_5__/* .wpsPreOrder */ .Jo)(position, subscribe_type);
                case 8:
                    data = _context.sent;
                    if (data.bill_no) {
                        billNo = data.bill_no;
                        // 将合作方的订单号拼接成完整的支付链接，并通过iframe打开
                        webPayUrl = "".concat(_constant__WEBPACK_IMPORTED_MODULE_0__/* .servers.webPay */ .cb.webPay, "?billno=").concat(data === null || data === void 0 ? void 0 : data.bill_no, "&platform=pc&isclient=false&hideclosebtn=1&is_large_size=true#/");
                    }
                    return _context.abrupt("return", {
                        url: webPayUrl,
                        billNo: billNo
                    });
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return _getWPSPayInfo.apply(this, arguments);
}
function getWPSPayUrl() {
    return _getWPSPayUrl.apply(this, arguments);
}
function _getWPSPayUrl() {
    _getWPSPayUrl = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee2() {
        var _yield$getWPSPayInfo, url;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return getWPSPayInfo();
                case 2:
                    _yield$getWPSPayInfo = _context2.sent;
                    url = _yield$getWPSPayInfo.url;
                    return _context2.abrupt("return", url);
                case 5:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return _getWPSPayUrl.apply(this, arguments);
}


/***/ }),

/***/ 51638:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QB": () => (/* binding */ incrementWpsNavDepth),
/* harmony export */   "d1": () => (/* binding */ decrementWpsNavDepth),
/* harmony export */   "ms": () => (/* binding */ getWpsNavDepth)
/* harmony export */ });
/* unused harmony export isNavigating */
var WPS_NAV_DEPTH_KEY = "__wps_nav_depth";
/**
 * 标记当前是否已经有一次跳转正在进行中。
 * 用于防止 anchor 拦截器和 window.open 拦截器在同一次点击中重复 +1。
 *
 * 原理：anchor 拦截器（capture 阶段）执行 location.href = url 后，
 * 同一宏任务内 React onClick 可能还会触发 window.open，
 * window.open 拦截器检测到此标记后跳过 increment。
 */ var _navigating = false;
function isNavigating() {
    return _navigating;
}
/**
 * 获取当前导航深度。
 * 首次访问时惰性初始化为 0。
 */ function getWpsNavDepth() {
    if (typeof sessionStorage === "undefined") return 0;
    var raw = sessionStorage.getItem(WPS_NAV_DEPTH_KEY);
    if (raw === null) {
        sessionStorage.setItem(WPS_NAV_DEPTH_KEY, "0");
        return 0;
    }
    return Number(raw) || 0;
}
/**
 * 导航深度 +1，在页面跳转前调用。
 * 同时设置 _navigating 标记，防止同一宏任务内重复 +1。
 */ function incrementWpsNavDepth() {
    if (typeof sessionStorage === "undefined") return;
    if (_navigating) return;
    _navigating = true;
    var depth = getWpsNavDepth();
    sessionStorage.setItem(WPS_NAV_DEPTH_KEY, String(depth + 1));
}
/**
 * 导航深度 -1（最小为 0），在后退时调用。
 */ function decrementWpsNavDepth() {
    if (typeof sessionStorage === "undefined") return;
    var depth = getWpsNavDepth();
    sessionStorage.setItem(WPS_NAV_DEPTH_KEY, String(Math.max(0, depth - 1)));
}


/***/ }),

/***/ 82289:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ query_string)
});

// NAMESPACE OBJECT: ./node_modules/query-string/base.js
var base_namespaceObject = {};
__webpack_require__.r(base_namespaceObject);
__webpack_require__.d(base_namespaceObject, {
  "exclude": () => (exclude),
  "extract": () => (extract),
  "parse": () => (parse),
  "parseUrl": () => (parseUrl),
  "pick": () => (pick),
  "stringify": () => (stringify),
  "stringifyUrl": () => (stringifyUrl)
});

;// CONCATENATED MODULE: ./node_modules/query-string/node_modules/decode-uri-component/index.js
const token = '%[a-f0-9]{2}';
const singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
const multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	const left = components.slice(0, split);
	const right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch {
		let tokens = input.match(singleMatcher) || [];

		for (let i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	const replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD',
	};

	let match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch {
			const result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	const entries = Object.keys(replaceMap);

	for (const key of entries) {
		// Replace all decoded components
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

function decodeUriComponent(encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
}

;// CONCATENATED MODULE: ./node_modules/query-string/node_modules/filter-obj/index.js
function includeKeys(object, predicate) {
	const result = {};

	if (Array.isArray(predicate)) {
		for (const key of predicate) {
			const descriptor = Object.getOwnPropertyDescriptor(object, key);
			if (descriptor?.enumerable) {
				Object.defineProperty(result, key, descriptor);
			}
		}
	} else {
		// `Reflect.ownKeys()` is required to retrieve symbol properties
		for (const key of Reflect.ownKeys(object)) {
			const descriptor = Object.getOwnPropertyDescriptor(object, key);
			if (descriptor.enumerable) {
				const value = object[key];
				if (predicate(key, value, object)) {
					Object.defineProperty(result, key, descriptor);
				}
			}
		}
	}

	return result;
}

function excludeKeys(object, predicate) {
	if (Array.isArray(predicate)) {
		const set = new Set(predicate);
		return includeKeys(object, key => !set.has(key));
	}

	return includeKeys(object, (key, value, object) => !predicate(key, value, object));
}

;// CONCATENATED MODULE: ./node_modules/query-string/node_modules/split-on-first/index.js
function splitOnFirst(string, separator) {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (string === '' || separator === '') {
		return [];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
}

;// CONCATENATED MODULE: ./node_modules/query-string/base.js



const isNullOrUndefined = (value)=>value === null || value === undefined;
// eslint-disable-next-line unicorn/prefer-code-point
const strictUriEncode = (string)=>encodeURIComponent(string).replaceAll(/[!'()*]/g, (x)=>"%".concat(x.charCodeAt(0).toString(16).toUpperCase()));
const encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            {
                return (key)=>(result, value)=>{
                        const index = result.length;
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") {
                            return result;
                        }
                        if (value === null) {
                            return [
                                ...result,
                                [
                                    encode(key, options),
                                    "[",
                                    index,
                                    "]"
                                ].join("")
                            ];
                        }
                        return [
                            ...result,
                            [
                                encode(key, options),
                                "[",
                                encode(index, options),
                                "]=",
                                encode(value, options)
                            ].join("")
                        ];
                    };
            }
        case "bracket":
            {
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") {
                            return result;
                        }
                        if (value === null) {
                            return [
                                ...result,
                                [
                                    encode(key, options),
                                    "[]"
                                ].join("")
                            ];
                        }
                        return [
                            ...result,
                            [
                                encode(key, options),
                                "[]=",
                                encode(value, options)
                            ].join("")
                        ];
                    };
            }
        case "colon-list-separator":
            {
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") {
                            return result;
                        }
                        if (value === null) {
                            return [
                                ...result,
                                [
                                    encode(key, options),
                                    ":list="
                                ].join("")
                            ];
                        }
                        return [
                            ...result,
                            [
                                encode(key, options),
                                ":list=",
                                encode(value, options)
                            ].join("")
                        ];
                    };
            }
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSeparator = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") {
                            return result;
                        }
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) {
                            return [
                                [
                                    encode(key, options),
                                    keyValueSeparator,
                                    encode(value, options)
                                ].join("")
                            ];
                        }
                        return [
                            [
                                result,
                                encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            {
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") {
                            return result;
                        }
                        if (value === null) {
                            return [
                                ...result,
                                encode(key, options)
                            ];
                        }
                        return [
                            ...result,
                            [
                                encode(key, options),
                                "=",
                                encode(value, options)
                            ].join("")
                        ];
                    };
            }
    }
}
function parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            {
                return (key, value, accumulator)=>{
                    result = /\[(\d*)]$/.exec(key);
                    key = key.replace(/\[\d*]$/, "");
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    }
                    if (accumulator[key] === undefined) {
                        accumulator[key] = {};
                    }
                    accumulator[key][result[1]] = value;
                };
            }
        case "bracket":
            {
                return (key, value, accumulator)=>{
                    result = /(\[])$/.exec(key);
                    key = key.replace(/\[]$/, "");
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    }
                    if (accumulator[key] === undefined) {
                        accumulator[key] = [
                            value
                        ];
                        return;
                    }
                    accumulator[key] = [
                        ...accumulator[key],
                        value
                    ];
                };
            }
        case "colon-list-separator":
            {
                return (key, value, accumulator)=>{
                    result = /(:list)$/.exec(key);
                    key = key.replace(/:list$/, "");
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    }
                    if (accumulator[key] === undefined) {
                        accumulator[key] = [
                            value
                        ];
                        return;
                    }
                    accumulator[key] = [
                        ...accumulator[key],
                        value
                    ];
                };
            }
        case "comma":
        case "separator":
            {
                return (key, value, accumulator)=>{
                    const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                    const isEncodedArray = typeof value === "string" && !isArray && base_decode(value, options).includes(options.arrayFormatSeparator);
                    value = isEncodedArray ? base_decode(value, options) : value;
                    const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>base_decode(item, options)) : value === null ? value : base_decode(value, options);
                    accumulator[key] = newValue;
                };
            }
        case "bracket-separator":
            {
                return (key, value, accumulator)=>{
                    const isArray = /(\[])$/.test(key);
                    key = key.replace(/\[]$/, "");
                    if (!isArray) {
                        accumulator[key] = value ? base_decode(value, options) : value;
                        return;
                    }
                    const arrayValue = value === null ? [] : base_decode(value, options).split(options.arrayFormatSeparator);
                    if (accumulator[key] === undefined) {
                        accumulator[key] = arrayValue;
                        return;
                    }
                    accumulator[key] = [
                        ...accumulator[key],
                        ...arrayValue
                    ];
                };
            }
        default:
            {
                return (key, value, accumulator)=>{
                    if (accumulator[key] === undefined) {
                        accumulator[key] = value;
                        return;
                    }
                    accumulator[key] = [
                        ...[
                            accumulator[key]
                        ].flat(),
                        value
                    ];
                };
            }
    }
}
function validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) {
        throw new TypeError("arrayFormatSeparator must be single character string");
    }
}
function encode(value, options) {
    if (options.encode) {
        return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
    }
    return value;
}
function base_decode(value, options) {
    if (options.decode) {
        return decodeUriComponent(value);
    }
    return value;
}
function keysSorter(input) {
    if (Array.isArray(input)) {
        return input.sort();
    }
    if (typeof input === "object") {
        return keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    }
    return input;
}
function removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) {
        input = input.slice(0, hashStart);
    }
    return input;
}
function getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) {
        hash = url.slice(hashStart);
    }
    return hash;
}
function parseValue(value, options, type) {
    if (type === "string" && typeof value === "string") {
        return value;
    }
    if (typeof type === "function" && typeof value === "string") {
        return type(value);
    }
    if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) {
        return value.toLowerCase() === "true";
    }
    if (type === "number" && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") {
        return Number(value);
    }
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") {
        return Number(value);
    }
    return value;
}
function extract(input) {
    input = removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) {
        return "";
    }
    return input.slice(queryStart + 1);
}
function parse(query, options) {
    options = {
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false,
        types: Object.create(null),
        ...options
    };
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = parserForArrayFormat(options);
    // Create an object with no prototype
    const returnValue = Object.create(null);
    if (typeof query !== "string") {
        return returnValue;
    }
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) {
        return returnValue;
    }
    for (const parameter of query.split("&")){
        if (parameter === "") {
            continue;
        }
        const parameter_ = options.decode ? parameter.replaceAll("+", " ") : parameter;
        let [key, value] = splitOnFirst(parameter_, "=");
        if (key === undefined) {
            key = parameter_;
        }
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : base_decode(value, options);
        formatter(base_decode(key, options), value, returnValue);
    }
    for (const [key1, value1] of Object.entries(returnValue)){
        if (typeof value1 === "object" && value1 !== null && options.types[key1] !== "string") {
            for (const [key2, value2] of Object.entries(value1)){
                const type = options.types[key1] ? options.types[key1].replace("[]", "") : undefined;
                value1[key2] = parseValue(value2, options, type);
            }
        } else if (typeof value1 === "object" && value1 !== null && options.types[key1] === "string") {
            returnValue[key1] = Object.values(value1).join(options.arrayFormatSeparator);
        } else {
            returnValue[key1] = parseValue(value1, options, options.types[key1]);
        }
    }
    if (options.sort === false) {
        return returnValue;
    }
    // TODO: Remove the use of `reduce`.
    // eslint-disable-next-line unicorn/no-array-reduce
    return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key)=>{
        const value = returnValue[key];
        result[key] = Boolean(value) && typeof value === "object" && !Array.isArray(value) ? keysSorter(value) : value;
        return result;
    }, Object.create(null));
}
function stringify(object, options) {
    if (!object) {
        return "";
    }
    options = {
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        ...options
    };
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = encoderForArrayFormat(options);
    const objectCopy = {};
    for (const [key, value] of Object.entries(object)){
        if (!shouldFilter(key)) {
            objectCopy[key] = value;
        }
    }
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) {
        keys.sort(options.sort);
    }
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) {
            return "";
        }
        if (value === null) {
            return encode(key, options);
        }
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") {
                return encode(key, options) + "[]";
            }
            return value.reduce(formatter(key), []).join("&");
        }
        return encode(key, options) + "=" + encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
}
function parseUrl(url, options) {
    var ref;
    options = {
        decode: true,
        ...options
    };
    let [url_, hash] = splitOnFirst(url, "#");
    if (url_ === undefined) {
        url_ = url;
    }
    var ref1;
    return {
        url: (ref1 = (ref = url_ === null || url_ === void 0 ? void 0 : url_.split("?")) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref1 !== void 0 ? ref1 : "",
        query: parse(extract(url), options),
        ...options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: base_decode(hash, options)
        } : {}
    };
}
function stringifyUrl(object, options) {
    options = {
        encode: true,
        strict: true,
        [encodeFragmentIdentifier]: true,
        ...options
    };
    const url = removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = extract(object.url);
    const query = {
        ...parse(queryFromUrl, {
            sort: false
        }),
        ...object.query
    };
    let queryString = stringify(query, options);
    queryString && (queryString = "?".concat(queryString));
    let hash = getHash(object.url);
    if (typeof object.fragmentIdentifier === "string") {
        const urlObjectForFragmentEncode = new URL(url);
        urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
        hash = options[encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : "#".concat(object.fragmentIdentifier);
    }
    return "".concat(url).concat(queryString).concat(hash);
}
function pick(input, filter, options) {
    options = {
        parseFragmentIdentifier: true,
        [encodeFragmentIdentifier]: false,
        ...options
    };
    const { url , query , fragmentIdentifier  } = parseUrl(input, options);
    return stringifyUrl({
        url,
        query: includeKeys(query, filter),
        fragmentIdentifier
    }, options);
}
function exclude(input, filter, options) {
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return pick(input, exclusionFilter, options);
}

;// CONCATENATED MODULE: ./node_modules/query-string/index.js

/* harmony default export */ const query_string = (base_namespaceObject);


/***/ }),

/***/ 84438:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ canUseDom)
/* harmony export */ });
function canUseDom() {
    return !!( true && window.document && window.document.createElement);
}


/***/ }),

/***/ 83930:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sh": () => (/* binding */ isDOM),
/* harmony export */   "ZP": () => (/* binding */ findDOMNode)
/* harmony export */ });
/* unused harmony export getDOM */
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71002);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);



function isDOM(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
/**
 * Retrieves a DOM node via a ref, and does not invoke `findDOMNode`.
 */ function getDOM(node) {
    if (node && (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(node) === "object" && isDOM(node.nativeElement)) {
        return node.nativeElement;
    }
    if (isDOM(node)) {
        return node;
    }
    return null;
}
/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */ function findDOMNode(node) {
    var domNode = getDOM(node);
    if (domNode) {
        return domNode;
    }
    if (node instanceof react__WEBPACK_IMPORTED_MODULE_0__.Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call(react_dom__WEBPACK_IMPORTED_MODULE_1__, node);
    }
    return null;
}


/***/ }),

/***/ 70551:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ isFragment)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);

var REACT_ELEMENT_TYPE_18 = Symbol.for("react.element");
var REACT_ELEMENT_TYPE_19 = Symbol.for("react.transitional.element");
var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
/**
 * Compatible with React 18 or 19 to check if node is a Fragment.
 */ function isFragment(object) {
    return(// Base object type
    object && (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(object) === "object" && // React Element type
    (object.$$typeof === REACT_ELEMENT_TYPE_18 || object.$$typeof === REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === REACT_FRAGMENT_TYPE);
}


/***/ }),

/***/ 83728:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useEvent)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useEvent(callback) {
    var fnRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    fnRef.current = callback;
    var memoFn = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}


/***/ }),

/***/ 88398:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "o": () => (/* binding */ useLayoutUpdateEffect)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Dom_canUseDom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84438);


/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var useInternalLayoutEffect =  true && (0,_Dom_canUseDom__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)() ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
var useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(true);
    useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var useLayoutUpdateEffect = function useLayoutUpdateEffect(callback, deps) {
    useLayoutEffect(function(firstMount) {
        if (!firstMount) {
            return callback();
        }
    }, deps);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useLayoutEffect);


/***/ }),

/***/ 79712:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useMemo)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useMemo(getValue, condition, shouldUpdate) {
    var cacheRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef({});
    if (!("value" in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}


/***/ }),

/***/ 27107:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useMergedState)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97685);
/* harmony import */ var _useEvent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83728);
/* harmony import */ var _useLayoutEffect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88398);
/* harmony import */ var _useState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21520);




/** We only think `undefined` is empty */ function hasValue(value) {
    return value !== undefined;
}
/**
 * Similar to `useState` but will use props value if provided.
 * Note that internal use rc-util `useState` hook.
 */ function useMergedState(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0,_useState__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        if (hasValue(value)) {
            return value;
        } else if (hasValue(defaultValue)) {
            return typeof defaultValue === "function" ? defaultValue() : defaultValue;
        } else {
            return typeof defaultStateValue === "function" ? defaultStateValue() : defaultStateValue;
        }
    }), _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0,_useEvent__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(onChange);
    var _useState3 = (0,_useState__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)([
        mergedValue
    ]), _useState4 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0,_useLayoutEffect__WEBPACK_IMPORTED_MODULE_1__/* .useLayoutUpdateEffect */ .o)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) {
            onChangeFn(innerValue, prev);
        }
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0,_useLayoutEffect__WEBPACK_IMPORTED_MODULE_1__/* .useLayoutUpdateEffect */ .o)(function() {
        if (!hasValue(value)) {
            setInnerValue(value);
        }
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0,_useEvent__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}


/***/ }),

/***/ 21520:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useSafeState)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97685);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * Same as React.useState but `setState` accept `ignoreDestroy` param to not to setState after destroyed.
 * We do not make this auto is to avoid real memory leak.
 * Developer should confirm it's safe to ignore themselves.
 */ function useSafeState(defaultValue) {
    var destroyRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
    var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(defaultValue), _React$useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) {
            return;
        }
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}


/***/ }),

/***/ 3886:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C8": () => (/* reexport safe */ _hooks_useMergedState__WEBPACK_IMPORTED_MODULE_1__.Z),
/* harmony export */   "zX": () => (/* reexport safe */ _hooks_useEvent__WEBPACK_IMPORTED_MODULE_0__.Z)
/* harmony export */ });
/* harmony import */ var _hooks_useEvent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83728);
/* harmony import */ var _hooks_useMergedState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27107);
/* harmony import */ var _ref__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73010);
/* harmony import */ var _utils_set__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81445);
/* harmony import */ var _warning__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15741);








/***/ }),

/***/ 52197:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var caf = function caf(num) {
    return clearTimeout(num);
};
if ( true && "requestAnimationFrame" in window) {
    raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var rafUUID = 0;
var rafIds = new Map();
function cleanup(id) {
    rafIds.delete(id);
}
var wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    rafUUID += 1;
    var id = rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
wrapperRaf.cancel = function(id) {
    var realId = rafIds.get(id);
    cleanup(id);
    return caf(realId);
};
if (false) {}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (wrapperRaf);


/***/ }),

/***/ 73010:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C4": () => (/* binding */ getNodeRef),
/* harmony export */   "Yr": () => (/* binding */ supportRef),
/* harmony export */   "mH": () => (/* binding */ fillRef),
/* harmony export */   "sQ": () => (/* binding */ composeRef),
/* harmony export */   "x1": () => (/* binding */ useComposeRef)
/* harmony export */ });
/* unused harmony export supportNodeRef */
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71002);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_is__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59864);
/* harmony import */ var _hooks_useMemo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79712);
/* harmony import */ var _React_isFragment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70551);





var fillRef = function fillRef(ref, node) {
    if (typeof ref === "function") {
        ref(node);
    } else if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ref) === "object" && ref && "current" in ref) {
        ref.current = node;
    }
};
/**
 * Merge refs into one ref function to support ref passing.
 */ var composeRef = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) {
        return refList[0];
    }
    return function(node) {
        refs.forEach(function(ref) {
            fillRef(ref, node);
        });
    };
};
var useComposeRef = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++){
        refs[_key2] = arguments[_key2];
    }
    return (0,_hooks_useMemo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return composeRef.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var supportRef = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) {
        return false;
    }
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if (isReactElement(nodeOrComponent) && nodeOrComponent.props.propertyIsEnumerable("ref")) {
        return true;
    }
    var type = (0,react_is__WEBPACK_IMPORTED_MODULE_1__.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === "function" && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== react_is__WEBPACK_IMPORTED_MODULE_1__.ForwardRef) {
        return false;
    }
    // Class component
    if (typeof nodeOrComponent === "function" && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== react_is__WEBPACK_IMPORTED_MODULE_1__.ForwardRef) {
        return false;
    }
    return true;
};
function isReactElement(node) {
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(node) && !(0,_React_isFragment__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(node);
}
var supportNodeRef = function supportNodeRef(node) {
    return isReactElement(node) && supportRef(node);
};
/**
 * In React 19. `ref` is not a property from node.
 * But a property from `props.ref`.
 * To check if `props.ref` exist or fallback to `ref`.
 */ var getNodeRef = function getNodeRef(node) {
    if (node && isReactElement(node)) {
        var ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable("ref") ? ele.props.ref : ele.ref;
    }
    return null;
};


/***/ }),

/***/ 11778:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ get)
/* harmony export */ });
function get(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) {
            return undefined;
        }
        current = current[path[i]];
    }
    return current;
}


/***/ }),

/***/ 81445:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": () => (/* binding */ merge),
/* harmony export */   "Z": () => (/* binding */ set)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71002);
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1413);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74902);
/* harmony import */ var _babel_runtime_helpers_esm_toArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84506);
/* harmony import */ var _get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11778);





function internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) {
        return value;
    }
    var _paths = (0,_babel_runtime_helpers_esm_toArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === "number") {
        clone = [];
    } else if (Array.isArray(entity)) {
        clone = (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(entity);
    } else {
        clone = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, entity);
    }
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) {
        delete clone[path][restPath[0]];
    } else {
        clone[path] = internalSet(clone[path], restPath, value, removeIfUndefined);
    }
    return clone;
}
function set(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0,_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(entity, paths.slice(0, -1))) {
        return entity;
    }
    return internalSet(entity, paths, value, removeIfUndefined);
}
function isObject(obj) {
    return (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(obj) === "object" && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var keys = typeof Reflect === "undefined" ? Object.keys : Reflect.ownKeys;
/**
 * Merge objects which will create
 */ function merge() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++){
        sources[_key] = arguments[_key];
    }
    var clone = createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0,_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || isObject(value)) {
                // Only add not loop obj
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0,_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(clone, path);
                    if (isArr) {
                        // Array will always be override
                        clone = set(clone, path, []);
                    } else if (!originValue || (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(originValue) !== "object") {
                        // Init container if not exist
                        clone = set(clone, path, createEmpty(value));
                    }
                    keys(value).forEach(function(key) {
                        internalMerge([].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else {
                clone = set(clone, path, value);
            }
        }
        internalMerge([]);
    });
    return clone;
}


/***/ }),

/***/ 15741:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kp": () => (/* binding */ warning),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony exports preMessage, note, resetWarned, call, warningOnce, noteOnce */
/* eslint-disable no-console */ var warned = {};
var preWarningFns = [];
/**
 * Pre warning enable you to parse content before console.error.
 * Modify to null will prevent warning.
 */ var preMessage = function preMessage(fn) {
    preWarningFns.push(fn);
};
/**
 * Warning if condition not match.
 * @param valid Condition
 * @param message Warning message
 * @example
 * ```js
 * warning(false, 'some error'); // print some error
 * warning(true, 'some error'); // print nothing
 * warning(1 === 2, 'some error'); // print some error
 * ```
 */ function warning(valid, message) {
    if (false) { var finalMessage; }
}
/** @see Similar to {@link warning} */ function note(valid, message) {
    if (false) { var finalMessage; }
}
function resetWarned() {
    warned = {};
}
function call(method, valid, message) {
    if (!valid && !warned[message]) {
        method(false, message);
        warned[message] = true;
    }
}
/** @see Same as {@link warning}, but only warn once for the same message */ function warningOnce(valid, message) {
    call(warning, valid, message);
}
/** @see Same as {@link warning}, but only warn once for the same message */ function noteOnce(valid, message) {
    call(note, valid, message);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (warningOnce);


/***/ }),

/***/ 81725:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;

var _interopRequireWildcard = (__webpack_require__(75263)["default"]);
var _interopRequireDefault = (__webpack_require__(64836)["default"]);
__webpack_unused_export__ = ({
    value: true
});
__webpack_unused_export__ = _r;
__webpack_unused_export__ = _u;
exports.sY = render;
exports.vE = unmount;
var _regeneratorRuntime2 = _interopRequireDefault(__webpack_require__(17061));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(17156));
var _typeof2 = _interopRequireDefault(__webpack_require__(18698));
var _objectSpread2 = _interopRequireDefault(__webpack_require__(42122));
var ReactDOM = _interopRequireWildcard(__webpack_require__(73935));
// Let compiler not to search module usage
var fullClone = (0, _objectSpread2.default)({}, ReactDOM);
var version = fullClone.version, reactRender = fullClone.render, unmountComponentAtNode = fullClone.unmountComponentAtNode;
var createRoot;
try {
    var mainVersion = Number((version || "").split(".")[0]);
    if (mainVersion >= 18) {
        createRoot = fullClone.createRoot;
    }
} catch (e) {
// Do nothing;
}
function toggleWarning(skip) {
    var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = fullClone.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && (0, _typeof2.default)(__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === "object") {
        __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
    }
}
var MARK = "__rc_react_root__";
// ========================== Render ==========================
function modernRender(node, container) {
    toggleWarning(true);
    var root = container[MARK] || createRoot(container);
    toggleWarning(false);
    root.render(node);
    container[MARK] = root;
}
function legacyRender(node, container) {
    reactRender(node, container);
}
/** @private Test usage. Not work in prod */ function _r(node, container) {
    if (false) {}
}
function render(node, container) {
    if (createRoot) {
        modernRender(node, container);
        return;
    }
    legacyRender(node, container);
}
// ========================= Unmount ==========================
function modernUnmount(_x) {
    return _modernUnmount.apply(this, arguments);
}
function _modernUnmount() {
    _modernUnmount = (0, _asyncToGenerator2.default)(/*#__PURE__*/ (0, _regeneratorRuntime2.default)().mark(function _callee(container) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", Promise.resolve().then(function() {
                        var _container$MARK;
                        (_container$MARK = container[MARK]) === null || _container$MARK === void 0 || _container$MARK.unmount();
                        delete container[MARK];
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return _modernUnmount.apply(this, arguments);
}
function legacyUnmount(container) {
    unmountComponentAtNode(container);
}
/** @private Test usage. Not work in prod */ function _u(container) {
    if (false) {}
}
function unmount(_x2) {
    return _unmount.apply(this, arguments);
}
function _unmount() {
    _unmount = (0, _asyncToGenerator2.default)(/*#__PURE__*/ (0, _regeneratorRuntime2.default)().mark(function _callee2(container) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    if (!(createRoot !== undefined)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", modernUnmount(container));
                case 2:
                    legacyUnmount(container);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return _unmount.apply(this, arguments);
}


/***/ }),

/***/ 52260:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ dist_createModalComponent)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/rc-util/lib/React/render.js
var React_render = __webpack_require__(81725);
;// CONCATENATED MODULE: ./node_modules/react-modal-open/dist/renderPromise.js


var renderPromise = function renderPromise(node, container) {
    return new Promise(function(resolve) {
        var Root = function Root(_ref) {
            var onMount = _ref.onMount, children = _ref.children;
            (0,react.useEffect)(function() {
                onMount();
            }, []);
            return /*#__PURE__*/ react.createElement(react.Fragment, null, children);
        };
        (0,React_render/* render */.sY)(/*#__PURE__*/ react.createElement(Root, {
            onMount: resolve
        }, node), container);
    });
};
/* harmony default export */ const dist_renderPromise = (renderPromise);

;// CONCATENATED MODULE: ./node_modules/react-modal-open/dist/createModalComponent.js
/* module decorator */ module = __webpack_require__.hmd(module);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
var _excluded = [
    "onClose"
];
function _regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    _regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var createRef = function createRef(v) {
    return {
        current: v
    };
};
/**
 * @example
 * // MyModal.tsx
 * const MyModal: React.FC<{ onClose?: () => void; }> = ({
 *   onClose,
 * }) => (
 *   <div>
 *     <button onClick={onClose}>close</button>
 *     MyModal
 *   </div>
 * );
 *
 * export const MyModalComponent = createModalComponent(MyModal);
 *
 * // App.tsx
 * import { MyModalComponent } from './MyModal';
 *
 * (async () => {
 *   const closeMyModal = await MyModalComponent.open();
 *   setTimeout(() => {
 *     closeMyModal();
 *   }, 3000);
 * })();
 */ function createModalComponent(Modal, cfg) {
    var singletonElRef = createRef(null);
    var ModalComponent = Modal;
    ModalComponent.open = /*#__PURE__*/ function() {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee2(props) {
            var elRef, _ref2, _onClose, restProps, rmModal, render, _module$hot;
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                while(1)switch(_context2.prev = _context2.next){
                    case 0:
                        elRef = cfg !== null && cfg !== void 0 && cfg.singleton ? singletonElRef : createRef(null);
                        _ref2 = props !== null && props !== void 0 ? props : {}, _onClose = _ref2.onClose, restProps = _objectWithoutProperties(_ref2, _excluded);
                        if (!elRef.current) {
                            elRef.current = document.createElement("div");
                        }
                        document.body.appendChild(elRef.current);
                        rmModal = function rmModal() {
                            if (elRef.current && elRef.current.parentNode) {
                                (0,React_render/* unmount */.vE)(elRef.current);
                                elRef.current.parentNode.removeChild(elRef.current);
                                elRef.current = null;
                            }
                        };
                        render = /*#__PURE__*/ function() {
                            var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
                                return _regeneratorRuntime().wrap(function _callee$(_context) {
                                    while(1)switch(_context.prev = _context.next){
                                        case 0:
                                            if (elRef.current) {
                                                _context.next = 2;
                                                break;
                                            }
                                            return _context.abrupt("return");
                                        case 2:
                                            _context.next = 4;
                                            return dist_renderPromise(/*#__PURE__*/ // @ts-ignore
                                            react.createElement(Modal, _extends({}, restProps, {
                                                onClose: function onClose() {
                                                    setTimeout(function() {
                                                        rmModal();
                                                    });
                                                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                                        args[_key] = arguments[_key];
                                                    }
                                                    return _onClose === null || _onClose === void 0 ? void 0 : _onClose.apply(void 0, args);
                                                }
                                            })), elRef.current);
                                        case 4:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee);
                            }));
                            return function render() {
                                return _ref3.apply(this, arguments);
                            };
                        }();
                        render();
                        try {
                            (_module$hot = module.hot) === null || _module$hot === void 0 ? void 0 : _module$hot.addStatusHandler(function(status) {
                                if (status === "idle") {
                                    render();
                                }
                            });
                        } catch (_unused) {
                        /* eslint no-empty:off */ }
                        return _context2.abrupt("return", rmModal);
                    case 9:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }));
        return function(_x) {
            return _ref.apply(this, arguments);
        };
    }();
    return ModalComponent;
}
/* harmony default export */ const dist_createModalComponent = (createModalComponent);


/***/ }),

/***/ 16178:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 23250:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 61824:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 37457:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 85236:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 38915:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 76811:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81852:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 30464:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 84379:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 45974:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 40198:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 83901:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 57894:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 26869:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5152:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(51149)


/***/ }),

/***/ 11163:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(30165)


/***/ }),

/***/ 70631:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(24654);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof __webpack_require__.g !== 'undefined' && obj === __webpack_require__.g)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 75:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34155);
// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map


/***/ }),

/***/ 87236:
/***/ ((module) => {

var div = null
var prefixes = [ 'Webkit', 'Moz', 'O', 'ms' ]

module.exports = function prefixStyle (prop) {
  // re-use a dummy div
  if (!div) {
    div = document.createElement('div')
  }

  var style = div.style

  // prop exists without prefix
  if (prop in style) {
    return prop
  }

  // borderRadius -> BorderRadius
  var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1)

  // find the vendor-prefixed prop
  for (var i = prefixes.length; i >= 0; i--) {
    var name = prefixes[i] + titleCase
    // e.g. WebkitBorderRadius or webkitBorderRadius
    if (name in style) {
      return name
    }
  }

  return false
}


/***/ }),

/***/ 34155:
/***/ ((module) => {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 92703:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ ((module) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 1798:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * Copyright (c) 2010,2011,2012,2013,2014 Morgan Roderick http://roderick.dk
 * License: MIT - http://mrgnrdrck.mit-license.org
 *
 * https://github.com/mroderick/PubSubJS
 */

(function (root, factory){
    'use strict';

    var PubSub = {};

    if (root.PubSub) {
        PubSub = root.PubSub;
        console.warn("PubSub already loaded, using existing version");
    } else {
        root.PubSub = PubSub;
        factory(PubSub);
    }
    // CommonJS and Node.js module support
    if (true){
        if (module !== undefined && module.exports) {
            exports = module.exports = PubSub; // Node.js specific `module.exports`
        }
        exports.PubSub = PubSub; // CommonJS module 1.1.1 spec
        module.exports = exports = PubSub; // CommonJS
    }
    // AMD support
    /* eslint-disable no-undef */
    else {}

}(( typeof window === 'object' && window ) || this || __webpack_require__.g, function (PubSub){
    'use strict';

    var messages = {},
        lastUid = -1,
        ALL_SUBSCRIBING_MSG = '*';

    function hasKeys(obj){
        var key;

        for (key in obj){
            if ( Object.prototype.hasOwnProperty.call(obj, key) ){
                return true;
            }
        }
        return false;
    }

    /**
     * Returns a function that throws the passed exception, for use as argument for setTimeout
     * @alias throwException
     * @function
     * @param { Object } ex An Error object
     */
    function throwException( ex ){
        return function reThrowException(){
            throw ex;
        };
    }

    function callSubscriberWithDelayedExceptions( subscriber, message, data ){
        try {
            subscriber( message, data );
        } catch( ex ){
            setTimeout( throwException( ex ), 0);
        }
    }

    function callSubscriberWithImmediateExceptions( subscriber, message, data ){
        subscriber( message, data );
    }

    function deliverMessage( originalMessage, matchedMessage, data, immediateExceptions ){
        var subscribers = messages[matchedMessage],
            callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions,
            s;

        if ( !Object.prototype.hasOwnProperty.call( messages, matchedMessage ) ) {
            return;
        }

        for (s in subscribers){
            if ( Object.prototype.hasOwnProperty.call(subscribers, s)){
                callSubscriber( subscribers[s], originalMessage, data );
            }
        }
    }

    function createDeliveryFunction( message, data, immediateExceptions ){
        return function deliverNamespaced(){
            var topic = String( message ),
                position = topic.lastIndexOf( '.' );

            // deliver the message as it is now
            deliverMessage(message, message, data, immediateExceptions);

            // trim the hierarchy and deliver message to each level
            while( position !== -1 ){
                topic = topic.substr( 0, position );
                position = topic.lastIndexOf('.');
                deliverMessage( message, topic, data, immediateExceptions );
            }

            deliverMessage(message, ALL_SUBSCRIBING_MSG, data, immediateExceptions);
        };
    }

    function hasDirectSubscribersFor( message ) {
        var topic = String( message ),
            found = Boolean(Object.prototype.hasOwnProperty.call( messages, topic ) && hasKeys(messages[topic]));

        return found;
    }

    function messageHasSubscribers( message ){
        var topic = String( message ),
            found = hasDirectSubscribersFor(topic) || hasDirectSubscribersFor(ALL_SUBSCRIBING_MSG),
            position = topic.lastIndexOf( '.' );

        while ( !found && position !== -1 ){
            topic = topic.substr( 0, position );
            position = topic.lastIndexOf( '.' );
            found = hasDirectSubscribersFor(topic);
        }

        return found;
    }

    function publish( message, data, sync, immediateExceptions ){
        message = (typeof message === 'symbol') ? message.toString() : message;

        var deliver = createDeliveryFunction( message, data, immediateExceptions ),
            hasSubscribers = messageHasSubscribers( message );

        if ( !hasSubscribers ){
            return false;
        }

        if ( sync === true ){
            deliver();
        } else {
            setTimeout( deliver, 0 );
        }
        return true;
    }

    /**
     * Publishes the message, passing the data to it's subscribers
     * @function
     * @alias publish
     * @param { String } message The message to publish
     * @param {} data The data to pass to subscribers
     * @return { Boolean }
     */
    PubSub.publish = function( message, data ){
        return publish( message, data, false, PubSub.immediateExceptions );
    };

    /**
     * Publishes the message synchronously, passing the data to it's subscribers
     * @function
     * @alias publishSync
     * @param { String } message The message to publish
     * @param {} data The data to pass to subscribers
     * @return { Boolean }
     */
    PubSub.publishSync = function( message, data ){
        return publish( message, data, true, PubSub.immediateExceptions );
    };

    /**
     * Subscribes the passed function to the passed message. Every returned token is unique and should be stored if you need to unsubscribe
     * @function
     * @alias subscribe
     * @param { String } message The message to subscribe to
     * @param { Function } func The function to call when a new message is published
     * @return { String }
     */
    PubSub.subscribe = function( message, func ){
        if ( typeof func !== 'function'){
            return false;
        }

        message = (typeof message === 'symbol') ? message.toString() : message;

        // message is not registered yet
        if ( !Object.prototype.hasOwnProperty.call( messages, message ) ){
            messages[message] = {};
        }

        // forcing token as String, to allow for future expansions without breaking usage
        // and allow for easy use as key names for the 'messages' object
        var token = 'uid_' + String(++lastUid);
        messages[message][token] = func;

        // return token for unsubscribing
        return token;
    };

    PubSub.subscribeAll = function( func ){
        return PubSub.subscribe(ALL_SUBSCRIBING_MSG, func);
    };

    /**
     * Subscribes the passed function to the passed message once
     * @function
     * @alias subscribeOnce
     * @param { String } message The message to subscribe to
     * @param { Function } func The function to call when a new message is published
     * @return { PubSub }
     */
    PubSub.subscribeOnce = function( message, func ){
        var token = PubSub.subscribe( message, function(){
            // before func apply, unsubscribe message
            PubSub.unsubscribe( token );
            func.apply( this, arguments );
        });
        return PubSub;
    };

    /**
     * Clears all subscriptions
     * @function
     * @public
     * @alias clearAllSubscriptions
     */
    PubSub.clearAllSubscriptions = function clearAllSubscriptions(){
        messages = {};
    };

    /**
     * Clear subscriptions by the topic
     * @function
     * @public
     * @alias clearAllSubscriptions
     * @return { int }
     */
    PubSub.clearSubscriptions = function clearSubscriptions(topic){
        var m;
        for (m in messages){
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0){
                delete messages[m];
            }
        }
    };

    /**
       Count subscriptions by the topic
     * @function
     * @public
     * @alias countSubscriptions
     * @return { Array }
    */
    PubSub.countSubscriptions = function countSubscriptions(topic){
        var m;
        // eslint-disable-next-line no-unused-vars
        var token;
        var count = 0;
        for (m in messages) {
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
                for (token in messages[m]) {
                    count++;
                }
                break;
            }
        }
        return count;
    };


    /**
       Gets subscriptions by the topic
     * @function
     * @public
     * @alias getSubscriptions
    */
    PubSub.getSubscriptions = function getSubscriptions(topic){
        var m;
        var list = [];
        for (m in messages){
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0){
                list.push(m);
            }
        }
        return list;
    };

    /**
     * Removes subscriptions
     *
     * - When passed a token, removes a specific subscription.
     *
	 * - When passed a function, removes all subscriptions for that function
     *
	 * - When passed a topic, removes all subscriptions for that topic (hierarchy)
     * @function
     * @public
     * @alias subscribeOnce
     * @param { String | Function } value A token, function or topic to unsubscribe from
     * @example // Unsubscribing with a token
     * var token = PubSub.subscribe('mytopic', myFunc);
     * PubSub.unsubscribe(token);
     * @example // Unsubscribing with a function
     * PubSub.unsubscribe(myFunc);
     * @example // Unsubscribing from a topic
     * PubSub.unsubscribe('mytopic');
     */
    PubSub.unsubscribe = function(value){
        var descendantTopicExists = function(topic) {
                var m;
                for ( m in messages ){
                    if ( Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0 ){
                        // a descendant of the topic exists:
                        return true;
                    }
                }

                return false;
            },
            isTopic    = typeof value === 'string' && ( Object.prototype.hasOwnProperty.call(messages, value) || descendantTopicExists(value) ),
            isToken    = !isTopic && typeof value === 'string',
            isFunction = typeof value === 'function',
            result = false,
            m, message, t;

        if (isTopic){
            PubSub.clearSubscriptions(value);
            return;
        }

        for ( m in messages ){
            if ( Object.prototype.hasOwnProperty.call( messages, m ) ){
                message = messages[m];

                if ( isToken && message[value] ){
                    delete message[value];
                    result = value;
                    // tokens are unique, so we can just stop here
                    break;
                }

                if (isFunction) {
                    for ( t in message ){
                        if (Object.prototype.hasOwnProperty.call(message, t) && message[t] === value){
                            delete message[t];
                            result = true;
                        }
                    }
                }
            }
        }

        return result;
    };
}));


/***/ }),

/***/ 55798:
/***/ ((module) => {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 80129:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var stringify = __webpack_require__(58261);
var parse = __webpack_require__(55235);
var formats = __webpack_require__(55798);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 55235:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(12769);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(String(val));
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        var existing = has.call(obj, key);
        if (existing && options.duplicates === 'combine') {
            obj[key] = utils.combine(obj[key], val);
        } else if (!existing || options.duplicates === 'last') {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                ? []
                : [].concat(leaf);
        } else {
            obj = options.plainObjects ? { __proto__: null } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, check strictDepth option for throw, else just add whatever is left

    if (segment) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? { __proto__: null } : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? { __proto__: null } : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 58261:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var getSideChannel = __webpack_require__(37478);
var utils = __webpack_require__(12769);
var formats = __webpack_require__(55798);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    filter: void undefined,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined'
            ? key.value
            : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = obj[key];

        if (options.skipNulls && value === null) {
            continue;
        }
        pushToArray(keys, stringify(
            value,
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 12769:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var formats = __webpack_require__(55798);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? { __proto__: null } : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object' && typeof source !== 'function') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if (
                (options && (options.plainObjects || options.allowPrototypes))
                || !has.call(Object.prototype, source)
            ) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 54087:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var now = __webpack_require__(75)
  , root = typeof window === 'undefined' ? __webpack_require__.g : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}


/***/ }),

/***/ 24557:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V4": () => (/* reexport */ CSSMotionList),
  "ZP": () => (/* binding */ rc_motion_es)
});

// UNUSED EXPORTS: Provider

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/findDOMNode.js
var findDOMNode = __webpack_require__(83930);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(73010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/context.js

var _excluded = (/* unused pure expression or super */ null && (["children"]));

var Context = /*#__PURE__*/react.createContext({});
function MotionProvider(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: props
  }, children);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(60136);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js
var createSuper = __webpack_require__(29388);
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/DomWrapper.js





var DomWrapper = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(DomWrapper, _React$Component);
  var _super = (0,createSuper/* default */.Z)(DomWrapper);
  function DomWrapper() {
    (0,classCallCheck/* default */.Z)(this, DomWrapper);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(DomWrapper, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return DomWrapper;
}(react.Component);
/* harmony default export */ const es_DomWrapper = (DomWrapper);
// EXTERNAL MODULE: ./node_modules/rc-util/es/index.js
var es = __webpack_require__(3886);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useState.js
var useState = __webpack_require__(21520);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useEvent.js
var useEvent = __webpack_require__(83728);
;// CONCATENATED MODULE: ./node_modules/rc-util/es/hooks/useSyncState.js



/**
 * Same as React.useState but will always get latest state.
 * This is useful when React merge multiple state updates into one.
 * e.g. onTransitionEnd trigger multiple event at once will be merged state update in React.
 */ function useSyncState(defaultValue) {
    var _React$useReducer = react.useReducer(function(x) {
        return x + 1;
    }, 0), _React$useReducer2 = (0,slicedToArray/* default */.Z)(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
    var currentValueRef = react.useRef(defaultValue);
    var getValue = (0,useEvent/* default */.Z)(function() {
        return currentValueRef.current;
    });
    var setValue = (0,useEvent/* default */.Z)(function(updater) {
        currentValueRef.current = typeof updater === "function" ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}

;// CONCATENATED MODULE: ./node_modules/rc-motion/es/interface.js
var STATUS_NONE = 'none';
var STATUS_APPEAR = 'appear';
var STATUS_ENTER = 'enter';
var STATUS_LEAVE = 'leave';
var STEP_NONE = 'none';
var STEP_PREPARE = 'prepare';
var STEP_START = 'start';
var STEP_ACTIVE = 'active';
var STEP_ACTIVATED = 'end';
/**
 * Used for disabled motion case.
 * Prepare stage will still work but start & active will be skipped.
 */
var STEP_PREPARED = 'prepared';
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/canUseDom.js
var canUseDom = __webpack_require__(84438);
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/util/motion.js


// ================= Transition =================
// Event wrapper. Copy from react source code
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};
  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
  prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
  prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
  prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
  return prefixes;
}
function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap('Animation', 'AnimationEnd'),
    transitionend: makePrefixMap('Transition', 'TransitionEnd')
  };
  if (domSupport) {
    if (!('AnimationEvent' in win)) {
      delete prefixes.animationend.animation;
    }
    if (!('TransitionEvent' in win)) {
      delete prefixes.transitionend.transition;
    }
  }
  return prefixes;
}
var vendorPrefixes = getVendorPrefixes((0,canUseDom/* default */.Z)(), typeof window !== 'undefined' ? window : {});
var style = {};
if ((0,canUseDom/* default */.Z)()) {
  var _document$createEleme = document.createElement('div');
  style = _document$createEleme.style;
}
var prefixedEventNames = {};
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }
  var prefixMap = vendorPrefixes[eventName];
  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;
    for (var i = 0; i < len; i += 1) {
      var styleProp = stylePropList[i];
      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }
  return '';
}
var internalAnimationEndName = getVendorPrefixedEventName('animationend');
var internalTransitionEndName = getVendorPrefixedEventName('transitionend');
var supportTransition = !!(internalAnimationEndName && internalTransitionEndName);
var animationEndName = internalAnimationEndName || 'animationend';
var transitionEndName = internalTransitionEndName || 'transitionend';
function getTransitionName(transitionName, transitionType) {
  if (!transitionName) return null;
  if ((0,esm_typeof/* default */.Z)(transitionName) === 'object') {
    var type = transitionType.replace(/-\w/g, function (match) {
      return match[1].toUpperCase();
    });
    return transitionName[type];
  }
  return "".concat(transitionName, "-").concat(transitionType);
}
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useDomMotionEvents.js



/* harmony default export */ const useDomMotionEvents = (function (onInternalMotionEnd) {
  var cacheElementRef = (0,react.useRef)();

  // Remove events
  function removeMotionEvents(element) {
    if (element) {
      element.removeEventListener(transitionEndName, onInternalMotionEnd);
      element.removeEventListener(animationEndName, onInternalMotionEnd);
    }
  }

  // Patch events
  function patchMotionEvents(element) {
    if (cacheElementRef.current && cacheElementRef.current !== element) {
      removeMotionEvents(cacheElementRef.current);
    }
    if (element && element !== cacheElementRef.current) {
      element.addEventListener(transitionEndName, onInternalMotionEnd);
      element.addEventListener(animationEndName, onInternalMotionEnd);

      // Save as cache in case dom removed trigger by `motionDeadline`
      cacheElementRef.current = element;
    }
  }

  // Clean up when removed
  react.useEffect(function () {
    return function () {
      removeMotionEvents(cacheElementRef.current);
    };
  }, []);
  return [patchMotionEvents, removeMotionEvents];
});
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useIsomorphicLayoutEffect.js



// It's safe to use `useLayoutEffect` but the warning is annoying
var useIsomorphicLayoutEffect = (0,canUseDom/* default */.Z)() ? react.useLayoutEffect : react.useEffect;
/* harmony default export */ const hooks_useIsomorphicLayoutEffect = (useIsomorphicLayoutEffect);
// EXTERNAL MODULE: ./node_modules/rc-util/es/raf.js
var raf = __webpack_require__(52197);
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useNextFrame.js


/* harmony default export */ const useNextFrame = (function () {
  var nextFrameRef = react.useRef(null);
  function cancelNextFrame() {
    raf/* default.cancel */.Z.cancel(nextFrameRef.current);
  }
  function nextFrame(callback) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    cancelNextFrame();
    var nextFrameId = (0,raf/* default */.Z)(function () {
      if (delay <= 1) {
        callback({
          isCanceled: function isCanceled() {
            return nextFrameId !== nextFrameRef.current;
          }
        });
      } else {
        nextFrame(callback, delay - 1);
      }
    });
    nextFrameRef.current = nextFrameId;
  }
  react.useEffect(function () {
    return function () {
      cancelNextFrame();
    };
  }, []);
  return [nextFrame, cancelNextFrame];
});
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useStepQueue.js






var FULL_STEP_QUEUE = [STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED];
var SIMPLE_STEP_QUEUE = [STEP_PREPARE, STEP_PREPARED];

/** Skip current step */
var SkipStep = false;
/** Current step should be update in */
var DoStep = true;
function isActive(step) {
  return step === STEP_ACTIVE || step === STEP_ACTIVATED;
}
/* harmony default export */ const useStepQueue = (function (status, prepareOnly, callback) {
  var _useState = (0,useState/* default */.Z)(STEP_NONE),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1];
  var _useNextFrame = useNextFrame(),
    _useNextFrame2 = (0,slicedToArray/* default */.Z)(_useNextFrame, 2),
    nextFrame = _useNextFrame2[0],
    cancelNextFrame = _useNextFrame2[1];
  function startQueue() {
    setStep(STEP_PREPARE, true);
  }
  var STEP_QUEUE = prepareOnly ? SIMPLE_STEP_QUEUE : FULL_STEP_QUEUE;
  hooks_useIsomorphicLayoutEffect(function () {
    if (step !== STEP_NONE && step !== STEP_ACTIVATED) {
      var index = STEP_QUEUE.indexOf(step);
      var nextStep = STEP_QUEUE[index + 1];
      var result = callback(step);
      if (result === SkipStep) {
        // Skip when no needed
        setStep(nextStep, true);
      } else if (nextStep) {
        // Do as frame for step update
        nextFrame(function (info) {
          function doNext() {
            // Skip since current queue is ood
            if (info.isCanceled()) return;
            setStep(nextStep, true);
          }
          if (result === true) {
            doNext();
          } else {
            // Only promise should be async
            Promise.resolve(result).then(doNext);
          }
        });
      }
    }
  }, [status, step]);
  react.useEffect(function () {
    return function () {
      cancelNextFrame();
    };
  }, []);
  return [startQueue, step];
});
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useStatus.js












function useStatus(supportMotion, visible, getElement, _ref) {
  var _ref$motionEnter = _ref.motionEnter,
    motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter,
    _ref$motionAppear = _ref.motionAppear,
    motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear,
    _ref$motionLeave = _ref.motionLeave,
    motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave,
    motionDeadline = _ref.motionDeadline,
    motionLeaveImmediately = _ref.motionLeaveImmediately,
    onAppearPrepare = _ref.onAppearPrepare,
    onEnterPrepare = _ref.onEnterPrepare,
    onLeavePrepare = _ref.onLeavePrepare,
    onAppearStart = _ref.onAppearStart,
    onEnterStart = _ref.onEnterStart,
    onLeaveStart = _ref.onLeaveStart,
    onAppearActive = _ref.onAppearActive,
    onEnterActive = _ref.onEnterActive,
    onLeaveActive = _ref.onLeaveActive,
    onAppearEnd = _ref.onAppearEnd,
    onEnterEnd = _ref.onEnterEnd,
    onLeaveEnd = _ref.onLeaveEnd,
    onVisibleChanged = _ref.onVisibleChanged;
  // Used for outer render usage to avoid `visible: false & status: none` to render nothing
  var _useState = (0,useState/* default */.Z)(),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    asyncVisible = _useState2[0],
    setAsyncVisible = _useState2[1];
  var _useSyncState = useSyncState(STATUS_NONE),
    _useSyncState2 = (0,slicedToArray/* default */.Z)(_useSyncState, 2),
    getStatus = _useSyncState2[0],
    setStatus = _useSyncState2[1];
  var _useState3 = (0,useState/* default */.Z)(null),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    style = _useState4[0],
    setStyle = _useState4[1];
  var currentStatus = getStatus();
  var mountedRef = (0,react.useRef)(false);
  var deadlineRef = (0,react.useRef)(null);

  // =========================== Dom Node ===========================
  function getDomElement() {
    return getElement();
  }

  // ========================== Motion End ==========================
  var activeRef = (0,react.useRef)(false);

  /**
   * Clean up status & style
   */
  function updateMotionEndStatus() {
    setStatus(STATUS_NONE);
    setStyle(null, true);
  }
  var onInternalMotionEnd = (0,es/* useEvent */.zX)(function (event) {
    var status = getStatus();
    // Do nothing since not in any transition status.
    // This may happen when `motionDeadline` trigger.
    if (status === STATUS_NONE) {
      return;
    }
    var element = getDomElement();
    if (event && !event.deadline && event.target !== element) {
      // event exists
      // not initiated by deadline
      // transitionEnd not fired by inner elements
      return;
    }
    var currentActive = activeRef.current;
    var canEnd;
    if (status === STATUS_APPEAR && currentActive) {
      canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
    } else if (status === STATUS_ENTER && currentActive) {
      canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
    } else if (status === STATUS_LEAVE && currentActive) {
      canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
    }

    // Only update status when `canEnd` and not destroyed
    if (currentActive && canEnd !== false) {
      updateMotionEndStatus();
    }
  });
  var _useDomMotionEvents = useDomMotionEvents(onInternalMotionEnd),
    _useDomMotionEvents2 = (0,slicedToArray/* default */.Z)(_useDomMotionEvents, 1),
    patchMotionEvents = _useDomMotionEvents2[0];

  // ============================= Step =============================
  var getEventHandlers = function getEventHandlers(targetStatus) {
    switch (targetStatus) {
      case STATUS_APPEAR:
        return (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, STEP_PREPARE, onAppearPrepare), STEP_START, onAppearStart), STEP_ACTIVE, onAppearActive);
      case STATUS_ENTER:
        return (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, STEP_PREPARE, onEnterPrepare), STEP_START, onEnterStart), STEP_ACTIVE, onEnterActive);
      case STATUS_LEAVE:
        return (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, STEP_PREPARE, onLeavePrepare), STEP_START, onLeaveStart), STEP_ACTIVE, onLeaveActive);
      default:
        return {};
    }
  };
  var eventHandlers = react.useMemo(function () {
    return getEventHandlers(currentStatus);
  }, [currentStatus]);
  var _useStepQueue = useStepQueue(currentStatus, !supportMotion, function (newStep) {
      // Only prepare step can be skip
      if (newStep === STEP_PREPARE) {
        var onPrepare = eventHandlers[STEP_PREPARE];
        if (!onPrepare) {
          return SkipStep;
        }
        return onPrepare(getDomElement());
      }

      // Rest step is sync update
      if (step in eventHandlers) {
        var _eventHandlers$step;
        setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
      }
      if (step === STEP_ACTIVE && currentStatus !== STATUS_NONE) {
        // Patch events when motion needed
        patchMotionEvents(getDomElement());
        if (motionDeadline > 0) {
          clearTimeout(deadlineRef.current);
          deadlineRef.current = setTimeout(function () {
            onInternalMotionEnd({
              deadline: true
            });
          }, motionDeadline);
        }
      }
      if (step === STEP_PREPARED) {
        updateMotionEndStatus();
      }
      return DoStep;
    }),
    _useStepQueue2 = (0,slicedToArray/* default */.Z)(_useStepQueue, 2),
    startStep = _useStepQueue2[0],
    step = _useStepQueue2[1];
  var active = isActive(step);
  activeRef.current = active;

  // ============================ Status ============================
  // Update with new status
  hooks_useIsomorphicLayoutEffect(function () {
    setAsyncVisible(visible);
    var isMounted = mountedRef.current;
    mountedRef.current = true;

    // if (!supportMotion) {
    //   return;
    // }

    var nextStatus;

    // Appear
    if (!isMounted && visible && motionAppear) {
      nextStatus = STATUS_APPEAR;
    }

    // Enter
    if (isMounted && visible && motionEnter) {
      nextStatus = STATUS_ENTER;
    }

    // Leave
    if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) {
      nextStatus = STATUS_LEAVE;
    }
    var nextEventHandlers = getEventHandlers(nextStatus);

    // Update to next status
    if (nextStatus && (supportMotion || nextEventHandlers[STEP_PREPARE])) {
      setStatus(nextStatus);
      startStep();
    } else {
      // Set back in case no motion but prev status has prepare step
      setStatus(STATUS_NONE);
    }
  }, [visible]);

  // ============================ Effect ============================
  // Reset when motion changed
  (0,react.useEffect)(function () {
    if (
    // Cancel appear
    currentStatus === STATUS_APPEAR && !motionAppear ||
    // Cancel enter
    currentStatus === STATUS_ENTER && !motionEnter ||
    // Cancel leave
    currentStatus === STATUS_LEAVE && !motionLeave) {
      setStatus(STATUS_NONE);
    }
  }, [motionAppear, motionEnter, motionLeave]);
  (0,react.useEffect)(function () {
    return function () {
      mountedRef.current = false;
      clearTimeout(deadlineRef.current);
    };
  }, []);

  // Trigger `onVisibleChanged`
  var firstMountChangeRef = react.useRef(false);
  (0,react.useEffect)(function () {
    // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
    if (asyncVisible) {
      firstMountChangeRef.current = true;
    }
    if (asyncVisible !== undefined && currentStatus === STATUS_NONE) {
      // Skip first render is invisible since it's nothing changed
      if (firstMountChangeRef.current || asyncVisible) {
        onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
      }
      firstMountChangeRef.current = true;
    }
  }, [asyncVisible, currentStatus]);

  // ============================ Styles ============================
  var mergedStyle = style;
  if (eventHandlers[STEP_PREPARE] && step === STEP_START) {
    mergedStyle = (0,objectSpread2/* default */.Z)({
      transition: 'none'
    }, mergedStyle);
  }
  return [currentStatus, step, mergedStyle, asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible];
}
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/CSSMotion.js




/* eslint-disable react/default-props-match-prop-types, react/no-multi-comp, react/prop-types */











/**
 * `transitionSupport` is used for none transition test case.
 * Default we use browser transition event support check.
 */
function genCSSMotion(config) {
  var transitionSupport = config;
  if ((0,esm_typeof/* default */.Z)(config) === 'object') {
    transitionSupport = config.transitionSupport;
  }
  function isSupportTransition(props, contextMotion) {
    return !!(props.motionName && transitionSupport && contextMotion !== false);
  }
  var CSSMotion = /*#__PURE__*/react.forwardRef(function (props, ref) {
    var _props$visible = props.visible,
      visible = _props$visible === void 0 ? true : _props$visible,
      _props$removeOnLeave = props.removeOnLeave,
      removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave,
      forceRender = props.forceRender,
      children = props.children,
      motionName = props.motionName,
      leavedClassName = props.leavedClassName,
      eventProps = props.eventProps;
    var _React$useContext = react.useContext(Context),
      contextMotion = _React$useContext.motion;
    var supportMotion = isSupportTransition(props, contextMotion);

    // Ref to the react node, it may be a HTMLElement
    var nodeRef = (0,react.useRef)();
    // Ref to the dom wrapper in case ref can not pass to HTMLElement
    var wrapperNodeRef = (0,react.useRef)();
    function getDomElement() {
      try {
        // Here we're avoiding call for findDOMNode since it's deprecated
        // in strict mode. We're calling it only when node ref is not
        // an instance of DOM HTMLElement. Otherwise use
        // findDOMNode as a final resort
        return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0,findDOMNode/* default */.ZP)(wrapperNodeRef.current);
      } catch (e) {
        // Only happen when `motionDeadline` trigger but element removed.
        return null;
      }
    }
    var _useStatus = useStatus(supportMotion, visible, getDomElement, props),
      _useStatus2 = (0,slicedToArray/* default */.Z)(_useStatus, 4),
      status = _useStatus2[0],
      statusStep = _useStatus2[1],
      statusStyle = _useStatus2[2],
      mergedVisible = _useStatus2[3];

    // Record whether content has rendered
    // Will return null for un-rendered even when `removeOnLeave={false}`
    var renderedRef = react.useRef(mergedVisible);
    if (mergedVisible) {
      renderedRef.current = true;
    }

    // ====================== Refs ======================
    var setNodeRef = react.useCallback(function (node) {
      nodeRef.current = node;
      (0,es_ref/* fillRef */.mH)(ref, node);
    }, [ref]);

    // ===================== Render =====================
    var motionChildren;
    var mergedProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, eventProps), {}, {
      visible: visible
    });
    if (!children) {
      // No children
      motionChildren = null;
    } else if (status === STATUS_NONE) {
      // Stable children
      if (mergedVisible) {
        motionChildren = children((0,objectSpread2/* default */.Z)({}, mergedProps), setNodeRef);
      } else if (!removeOnLeave && renderedRef.current && leavedClassName) {
        motionChildren = children((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, mergedProps), {}, {
          className: leavedClassName
        }), setNodeRef);
      } else if (forceRender || !removeOnLeave && !leavedClassName) {
        motionChildren = children((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, mergedProps), {}, {
          style: {
            display: 'none'
          }
        }), setNodeRef);
      } else {
        motionChildren = null;
      }
    } else {
      // In motion
      var statusSuffix;
      if (statusStep === STEP_PREPARE) {
        statusSuffix = 'prepare';
      } else if (isActive(statusStep)) {
        statusSuffix = 'active';
      } else if (statusStep === STEP_START) {
        statusSuffix = 'start';
      }
      var motionCls = getTransitionName(motionName, "".concat(status, "-").concat(statusSuffix));
      motionChildren = children((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, mergedProps), {}, {
        className: classnames_default()(getTransitionName(motionName, status), (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === 'string')),
        style: statusStyle
      }), setNodeRef);
    }

    // Auto inject ref if child node not have `ref` props
    if ( /*#__PURE__*/react.isValidElement(motionChildren) && (0,es_ref/* supportRef */.Yr)(motionChildren)) {
      var originNodeRef = (0,es_ref/* getNodeRef */.C4)(motionChildren);
      if (!originNodeRef) {
        motionChildren = /*#__PURE__*/react.cloneElement(motionChildren, {
          ref: setNodeRef
        });
      }
    }
    return /*#__PURE__*/react.createElement(es_DomWrapper, {
      ref: wrapperNodeRef
    }, motionChildren);
  });
  CSSMotion.displayName = 'CSSMotion';
  return CSSMotion;
}
/* harmony default export */ const es_CSSMotion = (genCSSMotion(supportTransition));
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/util/diff.js


var STATUS_ADD = 'add';
var STATUS_KEEP = 'keep';
var STATUS_REMOVE = 'remove';
var STATUS_REMOVED = 'removed';
function wrapKeyToObject(key) {
  var keyObj;
  if (key && (0,esm_typeof/* default */.Z)(key) === 'object' && 'key' in key) {
    keyObj = key;
  } else {
    keyObj = {
      key: key
    };
  }
  return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, keyObj), {}, {
    key: String(keyObj.key)
  });
}
function parseKeys() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return keys.map(wrapKeyToObject);
}
function diffKeys() {
  var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var list = [];
  var currentIndex = 0;
  var currentLen = currentKeys.length;
  var prevKeyObjects = parseKeys(prevKeys);
  var currentKeyObjects = parseKeys(currentKeys);

  // Check prev keys to insert or keep
  prevKeyObjects.forEach(function (keyObj) {
    var hit = false;
    for (var i = currentIndex; i < currentLen; i += 1) {
      var currentKeyObj = currentKeyObjects[i];
      if (currentKeyObj.key === keyObj.key) {
        // New added keys should add before current key
        if (currentIndex < i) {
          list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function (obj) {
            return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, obj), {}, {
              status: STATUS_ADD
            });
          }));
          currentIndex = i;
        }
        list.push((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, currentKeyObj), {}, {
          status: STATUS_KEEP
        }));
        currentIndex += 1;
        hit = true;
        break;
      }
    }

    // If not hit, it means key is removed
    if (!hit) {
      list.push((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, keyObj), {}, {
        status: STATUS_REMOVE
      }));
    }
  });

  // Add rest to the list
  if (currentIndex < currentLen) {
    list = list.concat(currentKeyObjects.slice(currentIndex).map(function (obj) {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, obj), {}, {
        status: STATUS_ADD
      });
    }));
  }

  /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */
  var keys = {};
  list.forEach(function (_ref) {
    var key = _ref.key;
    keys[key] = (keys[key] || 0) + 1;
  });
  var duplicatedKeys = Object.keys(keys).filter(function (key) {
    return keys[key] > 1;
  });
  duplicatedKeys.forEach(function (matchKey) {
    // Remove `STATUS_REMOVE` node.
    list = list.filter(function (_ref2) {
      var key = _ref2.key,
        status = _ref2.status;
      return key !== matchKey || status !== STATUS_REMOVE;
    });

    // Update `STATUS_ADD` to `STATUS_KEEP`
    list.forEach(function (node) {
      if (node.key === matchKey) {
        // eslint-disable-next-line no-param-reassign
        node.status = STATUS_KEEP;
      }
    });
  });
  return list;
}
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/CSSMotionList.js









var CSSMotionList_excluded = ["component", "children", "onVisibleChanged", "onAllRemoved"],
  _excluded2 = ["status"];
/* eslint react/prop-types: 0 */




var MOTION_PROP_NAMES = ['eventProps', 'visible', 'children', 'motionName', 'motionAppear', 'motionEnter', 'motionLeave', 'motionLeaveImmediately', 'motionDeadline', 'removeOnLeave', 'leavedClassName', 'onAppearPrepare', 'onAppearStart', 'onAppearActive', 'onAppearEnd', 'onEnterStart', 'onEnterActive', 'onEnterEnd', 'onLeaveStart', 'onLeaveActive', 'onLeaveEnd'];
/**
 * Generate a CSSMotionList component with config
 * @param transitionSupport No need since CSSMotionList no longer depends on transition support
 * @param CSSMotion CSSMotion component
 */
function genCSSMotionList(transitionSupport) {
  var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : es_CSSMotion;
  var CSSMotionList = /*#__PURE__*/function (_React$Component) {
    (0,inherits/* default */.Z)(CSSMotionList, _React$Component);
    var _super = (0,createSuper/* default */.Z)(CSSMotionList);
    function CSSMotionList() {
      var _this;
      (0,classCallCheck/* default */.Z)(this, CSSMotionList);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "state", {
        keyEntities: []
      });
      // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
      (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "removeKey", function (removeKey) {
        _this.setState(function (prevState) {
          var nextKeyEntities = prevState.keyEntities.map(function (entity) {
            if (entity.key !== removeKey) return entity;
            return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, entity), {}, {
              status: STATUS_REMOVED
            });
          });
          return {
            keyEntities: nextKeyEntities
          };
        }, function () {
          var keyEntities = _this.state.keyEntities;
          var restKeysCount = keyEntities.filter(function (_ref) {
            var status = _ref.status;
            return status !== STATUS_REMOVED;
          }).length;
          if (restKeysCount === 0 && _this.props.onAllRemoved) {
            _this.props.onAllRemoved();
          }
        });
      });
      return _this;
    }
    (0,createClass/* default */.Z)(CSSMotionList, [{
      key: "render",
      value: function render() {
        var _this2 = this;
        var keyEntities = this.state.keyEntities;
        var _this$props = this.props,
          component = _this$props.component,
          children = _this$props.children,
          _onVisibleChanged = _this$props.onVisibleChanged,
          onAllRemoved = _this$props.onAllRemoved,
          restProps = (0,objectWithoutProperties/* default */.Z)(_this$props, CSSMotionList_excluded);
        var Component = component || react.Fragment;
        var motionProps = {};
        MOTION_PROP_NAMES.forEach(function (prop) {
          motionProps[prop] = restProps[prop];
          delete restProps[prop];
        });
        delete restProps.keys;
        return /*#__PURE__*/react.createElement(Component, restProps, keyEntities.map(function (_ref2, index) {
          var status = _ref2.status,
            eventProps = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded2);
          var visible = status === STATUS_ADD || status === STATUS_KEEP;
          return /*#__PURE__*/react.createElement(CSSMotion, (0,esm_extends/* default */.Z)({}, motionProps, {
            key: eventProps.key,
            visible: visible,
            eventProps: eventProps,
            onVisibleChanged: function onVisibleChanged(changedVisible) {
              _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                key: eventProps.key
              });
              if (!changedVisible) {
                _this2.removeKey(eventProps.key);
              }
            }
          }), function (props, ref) {
            return children((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
              index: index
            }), ref);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref3, _ref4) {
        var keys = _ref3.keys;
        var keyEntities = _ref4.keyEntities;
        var parsedKeyObjects = parseKeys(keys);
        var mixedKeyEntities = diffKeys(keyEntities, parsedKeyObjects);
        return {
          keyEntities: mixedKeyEntities.filter(function (entity) {
            var prevEntity = keyEntities.find(function (_ref5) {
              var key = _ref5.key;
              return entity.key === key;
            });

            // Remove if already mark as removed
            if (prevEntity && prevEntity.status === STATUS_REMOVED && entity.status === STATUS_REMOVE) {
              return false;
            }
            return true;
          })
        };
      }
    }]);
    return CSSMotionList;
  }(react.Component);
  (0,defineProperty/* default */.Z)(CSSMotionList, "defaultProps", {
    component: 'div'
  });
  return CSSMotionList;
}
/* harmony default export */ const CSSMotionList = (genCSSMotionList(supportTransition));
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/index.js




/* harmony default export */ const rc_motion_es = (es_CSSMotion);

/***/ }),

/***/ 33485:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.renderViewDefault = renderViewDefault;
exports.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
exports.renderTrackVerticalDefault = renderTrackVerticalDefault;
exports.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
exports.renderThumbVerticalDefault = renderThumbVerticalDefault;

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint-disable react/prop-types */

function renderViewDefault(props) {
    return _react2["default"].createElement('div', props);
}

function renderTrackHorizontalDefault(_ref) {
    var style = _ref.style,
        props = _objectWithoutProperties(_ref, ['style']);

    var finalStyle = _extends({}, style, {
        right: 2,
        bottom: 2,
        left: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderTrackVerticalDefault(_ref2) {
    var style = _ref2.style,
        props = _objectWithoutProperties(_ref2, ['style']);

    var finalStyle = _extends({}, style, {
        right: 2,
        bottom: 2,
        top: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderThumbHorizontalDefault(_ref3) {
    var style = _ref3.style,
        props = _objectWithoutProperties(_ref3, ['style']);

    var finalStyle = _extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderThumbVerticalDefault(_ref4) {
    var style = _ref4.style,
        props = _objectWithoutProperties(_ref4, ['style']);

    var finalStyle = _extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

/***/ }),

/***/ 36164:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _raf2 = __webpack_require__(54087);

var _raf3 = _interopRequireDefault(_raf2);

var _domCss = __webpack_require__(53879);

var _domCss2 = _interopRequireDefault(_domCss);

var _react = __webpack_require__(67294);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isString = __webpack_require__(77928);

var _isString2 = _interopRequireDefault(_isString);

var _getScrollbarWidth = __webpack_require__(66445);

var _getScrollbarWidth2 = _interopRequireDefault(_getScrollbarWidth);

var _returnFalse = __webpack_require__(18309);

var _returnFalse2 = _interopRequireDefault(_returnFalse);

var _getInnerWidth = __webpack_require__(51608);

var _getInnerWidth2 = _interopRequireDefault(_getInnerWidth);

var _getInnerHeight = __webpack_require__(43840);

var _getInnerHeight2 = _interopRequireDefault(_getInnerHeight);

var _styles = __webpack_require__(58285);

var _defaultRenderElements = __webpack_require__(33485);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Scrollbars = function (_Component) {
    _inherits(Scrollbars, _Component);

    function Scrollbars(props) {
        var _ref;

        _classCallCheck(this, Scrollbars);

        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            rest[_key - 1] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [this, props].concat(rest)));

        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
        _this.getScrollTop = _this.getScrollTop.bind(_this);
        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
        _this.getClientWidth = _this.getClientWidth.bind(_this);
        _this.getClientHeight = _this.getClientHeight.bind(_this);
        _this.getValues = _this.getValues.bind(_this);
        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);

        _this.scrollLeft = _this.scrollLeft.bind(_this);
        _this.scrollTop = _this.scrollTop.bind(_this);
        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
        _this.scrollToTop = _this.scrollToTop.bind(_this);
        _this.scrollToRight = _this.scrollToRight.bind(_this);
        _this.scrollToBottom = _this.scrollToBottom.bind(_this);

        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleDrag = _this.handleDrag.bind(_this);
        _this.handleDragEnd = _this.handleDragEnd.bind(_this);

        _this.state = {
            didMountUniversal: false
        };
        return _this;
    }

    _createClass(Scrollbars, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.addListeners();
            this.update();
            this.componentDidMountUniversal();
        }
    }, {
        key: 'componentDidMountUniversal',
        value: function componentDidMountUniversal() {
            // eslint-disable-line react/sort-comp
            var universal = this.props.universal;

            if (!universal) return;
            this.setState({ didMountUniversal: true });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.update();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeListeners();
            (0, _raf2.cancel)(this.requestFrame);
            clearTimeout(this.hideTracksTimeout);
            clearInterval(this.detectScrollingInterval);
        }
    }, {
        key: 'getScrollLeft',
        value: function getScrollLeft() {
            if (!this.view) return 0;
            return this.view.scrollLeft;
        }
    }, {
        key: 'getScrollTop',
        value: function getScrollTop() {
            if (!this.view) return 0;
            return this.view.scrollTop;
        }
    }, {
        key: 'getScrollWidth',
        value: function getScrollWidth() {
            if (!this.view) return 0;
            return this.view.scrollWidth;
        }
    }, {
        key: 'getScrollHeight',
        value: function getScrollHeight() {
            if (!this.view) return 0;
            return this.view.scrollHeight;
        }
    }, {
        key: 'getClientWidth',
        value: function getClientWidth() {
            if (!this.view) return 0;
            return this.view.clientWidth;
        }
    }, {
        key: 'getClientHeight',
        value: function getClientHeight() {
            if (!this.view) return 0;
            return this.view.clientHeight;
        }
    }, {
        key: 'getValues',
        value: function getValues() {
            var _ref2 = this.view || {},
                _ref2$scrollLeft = _ref2.scrollLeft,
                scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
                _ref2$scrollTop = _ref2.scrollTop,
                scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop,
                _ref2$scrollWidth = _ref2.scrollWidth,
                scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth,
                _ref2$scrollHeight = _ref2.scrollHeight,
                scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight,
                _ref2$clientWidth = _ref2.clientWidth,
                clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth,
                _ref2$clientHeight = _ref2.clientHeight,
                clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;

            return {
                left: scrollLeft / (scrollWidth - clientWidth) || 0,
                top: scrollTop / (scrollHeight - clientHeight) || 0,
                scrollLeft: scrollLeft,
                scrollTop: scrollTop,
                scrollWidth: scrollWidth,
                scrollHeight: scrollHeight,
                clientWidth: clientWidth,
                clientHeight: clientHeight
            };
        }
    }, {
        key: 'getThumbHorizontalWidth',
        value: function getThumbHorizontalWidth() {
            var _props = this.props,
                thumbSize = _props.thumbSize,
                thumbMinSize = _props.thumbMinSize;
            var _view = this.view,
                scrollWidth = _view.scrollWidth,
                clientWidth = _view.clientWidth;

            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
            var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
            if (trackWidth <= width) return 0;
            if (thumbSize) return thumbSize;
            return Math.max(width, thumbMinSize);
        }
    }, {
        key: 'getThumbVerticalHeight',
        value: function getThumbVerticalHeight() {
            var _props2 = this.props,
                thumbSize = _props2.thumbSize,
                thumbMinSize = _props2.thumbMinSize;
            var _view2 = this.view,
                scrollHeight = _view2.scrollHeight,
                clientHeight = _view2.clientHeight;

            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
            var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
            if (trackHeight <= height) return 0;
            if (thumbSize) return thumbSize;
            return Math.max(height, thumbMinSize);
        }
    }, {
        key: 'getScrollLeftForOffset',
        value: function getScrollLeftForOffset(offset) {
            var _view3 = this.view,
                scrollWidth = _view3.scrollWidth,
                clientWidth = _view3.clientWidth;

            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
            var thumbWidth = this.getThumbHorizontalWidth();
            return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
        }
    }, {
        key: 'getScrollTopForOffset',
        value: function getScrollTopForOffset(offset) {
            var _view4 = this.view,
                scrollHeight = _view4.scrollHeight,
                clientHeight = _view4.clientHeight;

            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
            var thumbHeight = this.getThumbVerticalHeight();
            return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
        }
    }, {
        key: 'scrollLeft',
        value: function scrollLeft() {
            var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (!this.view) return;
            this.view.scrollLeft = left;
        }
    }, {
        key: 'scrollTop',
        value: function scrollTop() {
            var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (!this.view) return;
            this.view.scrollTop = top;
        }
    }, {
        key: 'scrollToLeft',
        value: function scrollToLeft() {
            if (!this.view) return;
            this.view.scrollLeft = 0;
        }
    }, {
        key: 'scrollToTop',
        value: function scrollToTop() {
            if (!this.view) return;
            this.view.scrollTop = 0;
        }
    }, {
        key: 'scrollToRight',
        value: function scrollToRight() {
            if (!this.view) return;
            this.view.scrollLeft = this.view.scrollWidth;
        }
    }, {
        key: 'scrollToBottom',
        value: function scrollToBottom() {
            if (!this.view) return;
            this.view.scrollTop = this.view.scrollHeight;
        }
    }, {
        key: 'addListeners',
        value: function addListeners() {
            /* istanbul ignore if */
            if (typeof document === 'undefined' || !this.view) return;
            var view = this.view,
                trackHorizontal = this.trackHorizontal,
                trackVertical = this.trackVertical,
                thumbHorizontal = this.thumbHorizontal,
                thumbVertical = this.thumbVertical;

            view.addEventListener('scroll', this.handleScroll);
            if (!(0, _getScrollbarWidth2["default"])()) return;
            trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
            trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
            trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
            trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
            trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
            trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
            thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
            thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
            window.addEventListener('resize', this.handleWindowResize);
        }
    }, {
        key: 'removeListeners',
        value: function removeListeners() {
            /* istanbul ignore if */
            if (typeof document === 'undefined' || !this.view) return;
            var view = this.view,
                trackHorizontal = this.trackHorizontal,
                trackVertical = this.trackVertical,
                thumbHorizontal = this.thumbHorizontal,
                thumbVertical = this.thumbVertical;

            view.removeEventListener('scroll', this.handleScroll);
            if (!(0, _getScrollbarWidth2["default"])()) return;
            trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
            trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
            trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
            trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
            trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
            trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
            thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
            thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
            window.removeEventListener('resize', this.handleWindowResize);
            // Possibly setup by `handleDragStart`
            this.teardownDragging();
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(event) {
            var _this2 = this;

            var _props3 = this.props,
                onScroll = _props3.onScroll,
                onScrollFrame = _props3.onScrollFrame;

            if (onScroll) onScroll(event);
            this.update(function (values) {
                var scrollLeft = values.scrollLeft,
                    scrollTop = values.scrollTop;

                _this2.viewScrollLeft = scrollLeft;
                _this2.viewScrollTop = scrollTop;
                if (onScrollFrame) onScrollFrame(values);
            });
            this.detectScrolling();
        }
    }, {
        key: 'handleScrollStart',
        value: function handleScrollStart() {
            var onScrollStart = this.props.onScrollStart;

            if (onScrollStart) onScrollStart();
            this.handleScrollStartAutoHide();
        }
    }, {
        key: 'handleScrollStartAutoHide',
        value: function handleScrollStartAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.showTracks();
        }
    }, {
        key: 'handleScrollStop',
        value: function handleScrollStop() {
            var onScrollStop = this.props.onScrollStop;

            if (onScrollStop) onScrollStop();
            this.handleScrollStopAutoHide();
        }
    }, {
        key: 'handleScrollStopAutoHide',
        value: function handleScrollStopAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'handleWindowResize',
        value: function handleWindowResize() {
            (0, _getScrollbarWidth2["default"])(false);
            this.forceUpdate();
        }
    }, {
        key: 'handleHorizontalTrackMouseDown',
        value: function handleHorizontalTrackMouseDown(event) {
            event.preventDefault();
            var target = event.target,
                clientX = event.clientX;

            var _target$getBoundingCl = target.getBoundingClientRect(),
                targetLeft = _target$getBoundingCl.left;

            var thumbWidth = this.getThumbHorizontalWidth();
            var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
            this.view.scrollLeft = this.getScrollLeftForOffset(offset);
        }
    }, {
        key: 'handleVerticalTrackMouseDown',
        value: function handleVerticalTrackMouseDown(event) {
            event.preventDefault();
            var target = event.target,
                clientY = event.clientY;

            var _target$getBoundingCl2 = target.getBoundingClientRect(),
                targetTop = _target$getBoundingCl2.top;

            var thumbHeight = this.getThumbVerticalHeight();
            var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
            this.view.scrollTop = this.getScrollTopForOffset(offset);
        }
    }, {
        key: 'handleHorizontalThumbMouseDown',
        value: function handleHorizontalThumbMouseDown(event) {
            event.preventDefault();
            this.handleDragStart(event);
            var target = event.target,
                clientX = event.clientX;
            var offsetWidth = target.offsetWidth;

            var _target$getBoundingCl3 = target.getBoundingClientRect(),
                left = _target$getBoundingCl3.left;

            this.prevPageX = offsetWidth - (clientX - left);
        }
    }, {
        key: 'handleVerticalThumbMouseDown',
        value: function handleVerticalThumbMouseDown(event) {
            event.preventDefault();
            this.handleDragStart(event);
            var target = event.target,
                clientY = event.clientY;
            var offsetHeight = target.offsetHeight;

            var _target$getBoundingCl4 = target.getBoundingClientRect(),
                top = _target$getBoundingCl4.top;

            this.prevPageY = offsetHeight - (clientY - top);
        }
    }, {
        key: 'setupDragging',
        value: function setupDragging() {
            (0, _domCss2["default"])(document.body, _styles.disableSelectStyle);
            document.addEventListener('mousemove', this.handleDrag);
            document.addEventListener('mouseup', this.handleDragEnd);
            document.onselectstart = _returnFalse2["default"];
        }
    }, {
        key: 'teardownDragging',
        value: function teardownDragging() {
            (0, _domCss2["default"])(document.body, _styles.disableSelectStyleReset);
            document.removeEventListener('mousemove', this.handleDrag);
            document.removeEventListener('mouseup', this.handleDragEnd);
            document.onselectstart = undefined;
        }
    }, {
        key: 'handleDragStart',
        value: function handleDragStart(event) {
            this.dragging = true;
            event.stopImmediatePropagation();
            this.setupDragging();
        }
    }, {
        key: 'handleDrag',
        value: function handleDrag(event) {
            if (this.prevPageX) {
                var clientX = event.clientX;

                var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(),
                    trackLeft = _trackHorizontal$getB.left;

                var thumbWidth = this.getThumbHorizontalWidth();
                var clickPosition = thumbWidth - this.prevPageX;
                var offset = -trackLeft + clientX - clickPosition;
                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
            }
            if (this.prevPageY) {
                var clientY = event.clientY;

                var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(),
                    trackTop = _trackVertical$getBou.top;

                var thumbHeight = this.getThumbVerticalHeight();
                var _clickPosition = thumbHeight - this.prevPageY;
                var _offset = -trackTop + clientY - _clickPosition;
                this.view.scrollTop = this.getScrollTopForOffset(_offset);
            }
            return false;
        }
    }, {
        key: 'handleDragEnd',
        value: function handleDragEnd() {
            this.dragging = false;
            this.prevPageX = this.prevPageY = 0;
            this.teardownDragging();
            this.handleDragEndAutoHide();
        }
    }, {
        key: 'handleDragEndAutoHide',
        value: function handleDragEndAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'handleTrackMouseEnter',
        value: function handleTrackMouseEnter() {
            this.trackMouseOver = true;
            this.handleTrackMouseEnterAutoHide();
        }
    }, {
        key: 'handleTrackMouseEnterAutoHide',
        value: function handleTrackMouseEnterAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.showTracks();
        }
    }, {
        key: 'handleTrackMouseLeave',
        value: function handleTrackMouseLeave() {
            this.trackMouseOver = false;
            this.handleTrackMouseLeaveAutoHide();
        }
    }, {
        key: 'handleTrackMouseLeaveAutoHide',
        value: function handleTrackMouseLeaveAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'showTracks',
        value: function showTracks() {
            clearTimeout(this.hideTracksTimeout);
            (0, _domCss2["default"])(this.trackHorizontal, { opacity: 1 });
            (0, _domCss2["default"])(this.trackVertical, { opacity: 1 });
        }
    }, {
        key: 'hideTracks',
        value: function hideTracks() {
            var _this3 = this;

            if (this.dragging) return;
            if (this.scrolling) return;
            if (this.trackMouseOver) return;
            var autoHideTimeout = this.props.autoHideTimeout;

            clearTimeout(this.hideTracksTimeout);
            this.hideTracksTimeout = setTimeout(function () {
                (0, _domCss2["default"])(_this3.trackHorizontal, { opacity: 0 });
                (0, _domCss2["default"])(_this3.trackVertical, { opacity: 0 });
            }, autoHideTimeout);
        }
    }, {
        key: 'detectScrolling',
        value: function detectScrolling() {
            var _this4 = this;

            if (this.scrolling) return;
            this.scrolling = true;
            this.handleScrollStart();
            this.detectScrollingInterval = setInterval(function () {
                if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
                    clearInterval(_this4.detectScrollingInterval);
                    _this4.scrolling = false;
                    _this4.handleScrollStop();
                }
                _this4.lastViewScrollLeft = _this4.viewScrollLeft;
                _this4.lastViewScrollTop = _this4.viewScrollTop;
            }, 100);
        }
    }, {
        key: 'raf',
        value: function raf(callback) {
            var _this5 = this;

            if (this.requestFrame) _raf3["default"].cancel(this.requestFrame);
            this.requestFrame = (0, _raf3["default"])(function () {
                _this5.requestFrame = undefined;
                callback();
            });
        }
    }, {
        key: 'update',
        value: function update(callback) {
            var _this6 = this;

            this.raf(function () {
                return _this6._update(callback);
            });
        }
    }, {
        key: '_update',
        value: function _update(callback) {
            var _props4 = this.props,
                onUpdate = _props4.onUpdate,
                hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;

            var values = this.getValues();
            if ((0, _getScrollbarWidth2["default"])()) {
                var scrollLeft = values.scrollLeft,
                    clientWidth = values.clientWidth,
                    scrollWidth = values.scrollWidth;

                var trackHorizontalWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
                var thumbHorizontalWidth = this.getThumbHorizontalWidth();
                var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
                var thumbHorizontalStyle = {
                    width: thumbHorizontalWidth,
                    transform: 'translateX(' + thumbHorizontalX + 'px)'
                };
                var scrollTop = values.scrollTop,
                    clientHeight = values.clientHeight,
                    scrollHeight = values.scrollHeight;

                var trackVerticalHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
                var thumbVerticalHeight = this.getThumbVerticalHeight();
                var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
                var thumbVerticalStyle = {
                    height: thumbVerticalHeight,
                    transform: 'translateY(' + thumbVerticalY + 'px)'
                };
                if (hideTracksWhenNotNeeded) {
                    var trackHorizontalStyle = {
                        visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
                    };
                    var trackVerticalStyle = {
                        visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
                    };
                    (0, _domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
                    (0, _domCss2["default"])(this.trackVertical, trackVerticalStyle);
                }
                (0, _domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
                (0, _domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
            }
            if (onUpdate) onUpdate(values);
            if (typeof callback !== 'function') return;
            callback(values);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            var scrollbarWidth = (0, _getScrollbarWidth2["default"])();
            /* eslint-disable no-unused-vars */

            var _props5 = this.props,
                onScroll = _props5.onScroll,
                onScrollFrame = _props5.onScrollFrame,
                onScrollStart = _props5.onScrollStart,
                onScrollStop = _props5.onScrollStop,
                onUpdate = _props5.onUpdate,
                renderView = _props5.renderView,
                renderTrackHorizontal = _props5.renderTrackHorizontal,
                renderTrackVertical = _props5.renderTrackVertical,
                renderThumbHorizontal = _props5.renderThumbHorizontal,
                renderThumbVertical = _props5.renderThumbVertical,
                tagName = _props5.tagName,
                hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded,
                autoHide = _props5.autoHide,
                autoHideTimeout = _props5.autoHideTimeout,
                autoHideDuration = _props5.autoHideDuration,
                thumbSize = _props5.thumbSize,
                thumbMinSize = _props5.thumbMinSize,
                universal = _props5.universal,
                autoHeight = _props5.autoHeight,
                autoHeightMin = _props5.autoHeightMin,
                autoHeightMax = _props5.autoHeightMax,
                style = _props5.style,
                children = _props5.children,
                props = _objectWithoutProperties(_props5, ['onScroll', 'onScrollFrame', 'onScrollStart', 'onScrollStop', 'onUpdate', 'renderView', 'renderTrackHorizontal', 'renderTrackVertical', 'renderThumbHorizontal', 'renderThumbVertical', 'tagName', 'hideTracksWhenNotNeeded', 'autoHide', 'autoHideTimeout', 'autoHideDuration', 'thumbSize', 'thumbMinSize', 'universal', 'autoHeight', 'autoHeightMin', 'autoHeightMax', 'style', 'children']);
            /* eslint-enable no-unused-vars */

            var didMountUniversal = this.state.didMountUniversal;


            var containerStyle = _extends({}, _styles.containerStyleDefault, autoHeight && _extends({}, _styles.containerStyleAutoHeight, {
                minHeight: autoHeightMin,
                maxHeight: autoHeightMax
            }), style);

            var viewStyle = _extends({}, _styles.viewStyleDefault, {
                // Hide scrollbars by setting a negative margin
                marginRight: scrollbarWidth ? -scrollbarWidth : 0,
                marginBottom: scrollbarWidth ? -scrollbarWidth : 0
            }, autoHeight && _extends({}, _styles.viewStyleAutoHeight, {
                // Add scrollbarWidth to autoHeight in order to compensate negative margins
                minHeight: (0, _isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
                maxHeight: (0, _isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
            }), autoHeight && universal && !didMountUniversal && {
                minHeight: autoHeightMin,
                maxHeight: autoHeightMax
            }, universal && !didMountUniversal && _styles.viewStyleUniversalInitial);

            var trackAutoHeightStyle = {
                transition: 'opacity ' + autoHideDuration + 'ms',
                opacity: 0
            };

            var trackHorizontalStyle = _extends({}, _styles.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                display: 'none'
            });

            var trackVerticalStyle = _extends({}, _styles.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                display: 'none'
            });

            return (0, _react.createElement)(tagName, _extends({}, props, { style: containerStyle, ref: function ref(_ref3) {
                    _this7.container = _ref3;
                } }), [(0, _react.cloneElement)(renderView({ style: viewStyle }), { key: 'view', ref: function ref(_ref4) {
                    _this7.view = _ref4;
                } }, children), (0, _react.cloneElement)(renderTrackHorizontal({ style: trackHorizontalStyle }), { key: 'trackHorizontal', ref: function ref(_ref5) {
                    _this7.trackHorizontal = _ref5;
                } }, (0, _react.cloneElement)(renderThumbHorizontal({ style: _styles.thumbHorizontalStyleDefault }), { ref: function ref(_ref6) {
                    _this7.thumbHorizontal = _ref6;
                } })), (0, _react.cloneElement)(renderTrackVertical({ style: trackVerticalStyle }), { key: 'trackVertical', ref: function ref(_ref7) {
                    _this7.trackVertical = _ref7;
                } }, (0, _react.cloneElement)(renderThumbVertical({ style: _styles.thumbVerticalStyleDefault }), { ref: function ref(_ref8) {
                    _this7.thumbVertical = _ref8;
                } }))]);
        }
    }]);

    return Scrollbars;
}(_react.Component);

exports["default"] = Scrollbars;


Scrollbars.propTypes = {
    onScroll: _propTypes2["default"].func,
    onScrollFrame: _propTypes2["default"].func,
    onScrollStart: _propTypes2["default"].func,
    onScrollStop: _propTypes2["default"].func,
    onUpdate: _propTypes2["default"].func,
    renderView: _propTypes2["default"].func,
    renderTrackHorizontal: _propTypes2["default"].func,
    renderTrackVertical: _propTypes2["default"].func,
    renderThumbHorizontal: _propTypes2["default"].func,
    renderThumbVertical: _propTypes2["default"].func,
    tagName: _propTypes2["default"].string,
    thumbSize: _propTypes2["default"].number,
    thumbMinSize: _propTypes2["default"].number,
    hideTracksWhenNotNeeded: _propTypes2["default"].bool,
    autoHide: _propTypes2["default"].bool,
    autoHideTimeout: _propTypes2["default"].number,
    autoHideDuration: _propTypes2["default"].number,
    autoHeight: _propTypes2["default"].bool,
    autoHeightMin: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
    autoHeightMax: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
    universal: _propTypes2["default"].bool,
    style: _propTypes2["default"].object,
    children: _propTypes2["default"].node
};

Scrollbars.defaultProps = {
    renderView: _defaultRenderElements.renderViewDefault,
    renderTrackHorizontal: _defaultRenderElements.renderTrackHorizontalDefault,
    renderTrackVertical: _defaultRenderElements.renderTrackVerticalDefault,
    renderThumbHorizontal: _defaultRenderElements.renderThumbHorizontalDefault,
    renderThumbVertical: _defaultRenderElements.renderThumbVerticalDefault,
    tagName: 'div',
    thumbMinSize: 30,
    hideTracksWhenNotNeeded: false,
    autoHide: false,
    autoHideTimeout: 1000,
    autoHideDuration: 200,
    autoHeight: false,
    autoHeightMin: 0,
    autoHeightMax: 200,
    universal: false
};

/***/ }),

/***/ 58285:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var containerStyleDefault = exports.containerStyleDefault = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%'
};

// Overrides containerStyleDefault properties
var containerStyleAutoHeight = exports.containerStyleAutoHeight = {
    height: 'auto'
};

var viewStyleDefault = exports.viewStyleDefault = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    WebkitOverflowScrolling: 'touch'
};

// Overrides viewStyleDefault properties
var viewStyleAutoHeight = exports.viewStyleAutoHeight = {
    position: 'relative',
    top: undefined,
    left: undefined,
    right: undefined,
    bottom: undefined
};

var viewStyleUniversalInitial = exports.viewStyleUniversalInitial = {
    overflow: 'hidden',
    marginRight: 0,
    marginBottom: 0
};

var trackHorizontalStyleDefault = exports.trackHorizontalStyleDefault = {
    position: 'absolute',
    height: 6
};

var trackVerticalStyleDefault = exports.trackVerticalStyleDefault = {
    position: 'absolute',
    width: 6
};

var thumbHorizontalStyleDefault = exports.thumbHorizontalStyleDefault = {
    position: 'relative',
    display: 'block',
    height: '100%'
};

var thumbVerticalStyleDefault = exports.thumbVerticalStyleDefault = {
    position: 'relative',
    display: 'block',
    width: '100%'
};

var disableSelectStyle = exports.disableSelectStyle = {
    userSelect: 'none'
};

var disableSelectStyleReset = exports.disableSelectStyleReset = {
    userSelect: ''
};

/***/ }),

/***/ 86658:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.$B = undefined;

var _Scrollbars = __webpack_require__(36164);

var _Scrollbars2 = _interopRequireDefault(_Scrollbars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports.ZP = _Scrollbars2["default"];
exports.$B = _Scrollbars2["default"];

/***/ }),

/***/ 43840:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = getInnerHeight;
function getInnerHeight(el) {
    var clientHeight = el.clientHeight;

    var _getComputedStyle = getComputedStyle(el),
        paddingTop = _getComputedStyle.paddingTop,
        paddingBottom = _getComputedStyle.paddingBottom;

    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}

/***/ }),

/***/ 51608:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = getInnerWidth;
function getInnerWidth(el) {
    var clientWidth = el.clientWidth;

    var _getComputedStyle = getComputedStyle(el),
        paddingLeft = _getComputedStyle.paddingLeft,
        paddingRight = _getComputedStyle.paddingRight;

    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}

/***/ }),

/***/ 66445:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = getScrollbarWidth;

var _domCss = __webpack_require__(53879);

var _domCss2 = _interopRequireDefault(_domCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var scrollbarWidth = false;

function getScrollbarWidth() {
    var cacheEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (cacheEnabled && scrollbarWidth !== false) return scrollbarWidth;
    /* istanbul ignore else */
    if (typeof document !== 'undefined') {
        var div = document.createElement('div');
        (0, _domCss2["default"])(div, {
            width: 100,
            height: 100,
            position: 'absolute',
            top: -9999,
            overflow: 'scroll',
            MsOverflowStyle: 'scrollbar'
        });
        document.body.appendChild(div);
        scrollbarWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    } else {
        scrollbarWidth = 0;
    }
    return scrollbarWidth || 0;
}

/***/ }),

/***/ 77928:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = isString;
function isString(maybe) {
    return typeof maybe === 'string';
}

/***/ }),

/***/ 18309:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = returnFalse;
function returnFalse() {
    return false;
}

/***/ }),

/***/ 69921:
/***/ ((__unused_webpack_module, exports) => {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}__webpack_unused_export__=h;__webpack_unused_export__=g;__webpack_unused_export__=b;exports.ForwardRef=l;__webpack_unused_export__=d;__webpack_unused_export__=q;__webpack_unused_export__=p;__webpack_unused_export__=c;__webpack_unused_export__=f;__webpack_unused_export__=e;__webpack_unused_export__=m;
__webpack_unused_export__=n;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return v(a)===h};__webpack_unused_export__=function(a){return v(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return v(a)===l};__webpack_unused_export__=function(a){return v(a)===d};__webpack_unused_export__=function(a){return v(a)===q};exports.isMemo=function(a){return v(a)===p};
__webpack_unused_export__=function(a){return v(a)===c};__webpack_unused_export__=function(a){return v(a)===f};__webpack_unused_export__=function(a){return v(a)===e};__webpack_unused_export__=function(a){return v(a)===m};__webpack_unused_export__=function(a){return v(a)===n};
__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};__webpack_unused_export__=v;


/***/ }),

/***/ 59864:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 35747:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var inspect = __webpack_require__(70631);

var $TypeError = __webpack_require__(14453);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('./list.d.ts').listGetNode} */
// eslint-disable-next-line consistent-return
var listGetNode = function (list, key, isDelete) {
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	// eslint-disable-next-line eqeqeq
	for (; (curr = prev.next) != null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			if (!isDelete) {
				// eslint-disable-next-line no-extra-parens
				curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
				list.next = curr; // eslint-disable-line no-param-reassign
			}
			return curr;
		}
	}
};

/** @type {import('./list.d.ts').listGet} */
var listGet = function (objects, key) {
	if (!objects) {
		return void undefined;
	}
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('./list.d.ts').listHas} */
var listHas = function (objects, key) {
	if (!objects) {
		return false;
	}
	return !!listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */
// eslint-disable-next-line consistent-return
var listDelete = function (objects, key) {
	if (objects) {
		return listGetNode(objects, key, true);
	}
};

/** @type {import('.')} */
module.exports = function getSideChannelList() {
	/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			var root = $o && $o.next;
			var deletedNode = listDelete($o, key);
			if (deletedNode && root && root === deletedNode) {
				$o = void undefined;
			}
			return !!deletedNode;
		},
		get: function (key) {
			return listGet($o, key);
		},
		has: function (key) {
			return listHas($o, key);
		},
		set: function (key, value) {
			if (!$o) {
				// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
				$o = {
					next: void undefined
				};
			}
			// eslint-disable-next-line no-extra-parens
			listSet(/** @type {NonNullable<typeof $o>} */ ($o), key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),

/***/ 23595:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(40210);
var callBound = __webpack_require__(17379);
var inspect = __webpack_require__(70631);

var $TypeError = __webpack_require__(14453);
var $Map = GetIntrinsic('%Map%', true);

/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
var $mapGet = callBound('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
var $mapSet = callBound('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapHas = callBound('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapDelete = callBound('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */
var $mapSize = callBound('Map.prototype.size', true);

/** @type {import('.')} */
module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
	/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {Map<K, V> | undefined} */ var $m;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			if ($m) {
				var result = $mapDelete($m, key);
				if ($mapSize($m) === 0) {
					$m = void undefined;
				}
				return result;
			}
			return false;
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($m) {
				return $mapGet($m, key);
			}
		},
		has: function (key) {
			if ($m) {
				return $mapHas($m, key);
			}
			return false;
		},
		set: function (key, value) {
			if (!$m) {
				// @ts-expect-error TS can't handle narrowing a variable inside a closure
				$m = new $Map();
			}
			$mapSet($m, key, value);
		}
	};

	// @ts-expect-error TODO: figure out why TS is erroring here
	return channel;
};


/***/ }),

/***/ 69034:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(40210);
var callBound = __webpack_require__(17379);
var inspect = __webpack_require__(70631);
var getSideChannelMap = __webpack_require__(23595);

var $TypeError = __webpack_require__(14453);
var $WeakMap = GetIntrinsic('%WeakMap%', true);

/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
var $weakMapGet = callBound('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
var $weakMapSet = callBound('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapHas = callBound('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapDelete = callBound('WeakMap.prototype.delete', true);

/** @type {import('.')} */
module.exports = $WeakMap
	? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
		/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */

		/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
		/** @type {Channel | undefined} */ var $m;

		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapDelete($wm, key);
					}
				} else if (getSideChannelMap) {
					if ($m) {
						return $m['delete'](key);
					}
				}
				return false;
			},
			get: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapGet($wm, key);
					}
				}
				return $m && $m.get(key);
			},
			has: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapHas($wm, key);
					}
				}
				return !!$m && $m.has(key);
			},
			set: function (key, value) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if (!$wm) {
						$wm = new $WeakMap();
					}
					$weakMapSet($wm, key, value);
				} else if (getSideChannelMap) {
					if (!$m) {
						$m = getSideChannelMap();
					}
					// eslint-disable-next-line no-extra-parens
					/** @type {NonNullable<typeof $m>} */ ($m).set(key, value);
				}
			}
		};

		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	}
	: getSideChannelMap;


/***/ }),

/***/ 37478:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var $TypeError = __webpack_require__(14453);
var inspect = __webpack_require__(70631);
var getSideChannelList = __webpack_require__(35747);
var getSideChannelMap = __webpack_require__(23595);
var getSideChannelWeakMap = __webpack_require__(69034);

var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @typedef {ReturnType<typeof getSideChannel>} Channel */

	/** @type {Channel | undefined} */ var $channelData;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			return !!$channelData && $channelData['delete'](key);
		},
		get: function (key) {
			return $channelData && $channelData.get(key);
		},
		has: function (key) {
			return !!$channelData && $channelData.has(key);
		},
		set: function (key, value) {
			if (!$channelData) {
				$channelData = makeChannel();
			}

			$channelData.set(key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),

/***/ 6189:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var space = __webpack_require__(7966)

/**
 * Export.
 */

module.exports = toCamelCase

/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */

function toCamelCase(string) {
  return space(string).replace(/\s(\w)/g, function (matches, letter) {
    return letter.toUpperCase()
  })
}


/***/ }),

/***/ 71788:
/***/ ((module) => {


/**
 * Export.
 */

module.exports = toNoCase

/**
 * Test whether a string is camel-case.
 */

var hasSpace = /\s/
var hasSeparator = /(_|-|\.|:)/
var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/

/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */

function toNoCase(string) {
  if (hasSpace.test(string)) return string.toLowerCase()
  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
  return string.toLowerCase()
}

/**
 * Separator splitter.
 */

var separatorSplitter = /[\W_]+(.|$)/g

/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function unseparate(string) {
  return string.replace(separatorSplitter, function (m, next) {
    return next ? ' ' + next : ''
  })
}

/**
 * Camelcase splitter.
 */

var camelSplitter = /(.)([A-Z]+)/g

/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function uncamelize(string) {
  return string.replace(camelSplitter, function (m, previous, uppers) {
    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
  })
}


/***/ }),

/***/ 7966:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var clean = __webpack_require__(71788)

/**
 * Export.
 */

module.exports = toSpaceCase

/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */

function toSpaceCase(string) {
  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
    return match ? ' ' + match : ''
  }).trim()
}


/***/ }),

/***/ 57632:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ esm_browser_v4)
});

;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ const esm_browser_native = ({
  randomUUID
});
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ const esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/* harmony default export */ const esm_browser_v4 = (v4);

/***/ }),

/***/ 24654:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 17156:
/***/ ((module) => {

function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 38416:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toPropertyKey = __webpack_require__(64062);
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 64836:
/***/ ((module) => {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 75263:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(18698)["default"]);
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 42122:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var defineProperty = __webpack_require__(38416);
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 17061:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(18698)["default"]);
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 95036:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(18698)["default"]);
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 64062:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(18698)["default"]);
var toPrimitive = __webpack_require__(95036);
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 18698:
/***/ ((module) => {

function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 93967:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 30907:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _arrayLikeToArray)
/* harmony export */ });
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}


/***/ }),

/***/ 83878:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _arrayWithHoles)
/* harmony export */ });
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}


/***/ }),

/***/ 97326:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _assertThisInitialized)
/* harmony export */ });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),

/***/ 15671:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _classCallCheck)
/* harmony export */ });
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


/***/ }),

/***/ 43144:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _createClass)
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}


/***/ }),

/***/ 29388:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _createSuper)
/* harmony export */ });
/* harmony import */ var _getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61120);
/* harmony import */ var _isNativeReflectConstruct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78814);
/* harmony import */ var _possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82963);



function _createSuper(t) {
  var r = (0,_isNativeReflectConstruct_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
  return function () {
    var e,
      o = (0,_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(t);
    if (r) {
      var s = (0,_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return (0,_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, e);
  };
}


/***/ }),

/***/ 4942:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _defineProperty)
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperty(e, r, t) {
  return (r = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),

/***/ 87462:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _extends)
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ 61120:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _getPrototypeOf)
/* harmony export */ });
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}


/***/ }),

/***/ 60136:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _inherits)
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(t, e);
}


/***/ }),

/***/ 78814:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _isNativeReflectConstruct)
/* harmony export */ });
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}


/***/ }),

/***/ 59199:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _iterableToArray)
/* harmony export */ });
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}


/***/ }),

/***/ 25267:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _nonIterableRest)
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 1413:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _objectSpread2)
/* harmony export */ });
/* harmony import */ var _defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0,_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}


/***/ }),

/***/ 45987:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _objectWithoutProperties)
/* harmony export */ });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63366);

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = (0,_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}


/***/ }),

/***/ 63366:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _objectWithoutPropertiesLoose)
/* harmony export */ });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),

/***/ 82963:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _possibleConstructorReturn)
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97326);


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == (0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(t);
}


/***/ }),

/***/ 89611:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _setPrototypeOf)
/* harmony export */ });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),

/***/ 97685:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ _slicedToArray)
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(83878);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(25267);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(r, e) {
  return (0,arrayWithHoles/* default */.Z)(r) || _iterableToArrayLimit(r, e) || (0,unsupportedIterableToArray/* default */.Z)(r, e) || (0,nonIterableRest/* default */.Z)();
}


/***/ }),

/***/ 84506:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _toArray)
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83878);
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59199);
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40181);
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25267);




function _toArray(r) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(r) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(r) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 74902:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ _toConsumableArray)
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(30907);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return (0,arrayLikeToArray/* default */.Z)(r);
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(59199);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || (0,iterableToArray/* default */.Z)(r) || (0,unsupportedIterableToArray/* default */.Z)(r) || _nonIterableSpread();
}


/***/ }),

/***/ 83997:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ toPropertyKey)
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != (0,esm_typeof/* default */.Z)(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != (0,esm_typeof/* default */.Z)(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == (0,esm_typeof/* default */.Z)(i) ? i : i + "";
}


/***/ }),

/***/ 71002:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _typeof)
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),

/***/ 40181:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _unsupportedIterableToArray)
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30907);

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a) : void 0;
  }
}


/***/ }),

/***/ 74038:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _arrayLikeToArray)
/* harmony export */ });
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}


/***/ }),

/***/ 35062:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _arrayWithHoles)
/* harmony export */ });
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}


/***/ }),

/***/ 87406:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _asyncToGenerator)
/* harmony export */ });
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}


/***/ }),

/***/ 19945:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _classCallCheck)
/* harmony export */ });
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


/***/ }),

/***/ 70072:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _createClass)
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70871);

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}


/***/ }),

/***/ 33222:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _createForOfIteratorHelper)
/* harmony export */ });
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63915);

function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}


/***/ }),

/***/ 38389:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _defineProperty)
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70871);

function _defineProperty(e, r, t) {
  return (r = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),

/***/ 56369:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _extends)
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ 20264:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _iterableToArray)
/* harmony export */ });
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}


/***/ }),

/***/ 28339:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _nonIterableRest)
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 81549:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _objectSpread2)
/* harmony export */ });
/* harmony import */ var _defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38389);

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0,_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}


/***/ }),

/***/ 73009:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ _objectWithoutProperties)
});

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}


/***/ }),

/***/ 89255:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ _regeneratorRuntime)
});

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/OverloadYield.js
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorDefine.js
function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine = function regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine(e, r, n, t);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regenerator.js

function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o, "Generator"), _regeneratorDefine(u, n, function () {
    return this;
  }), _regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorAsyncIterator.js


function AsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (_regeneratorDefine(AsyncIterator.prototype), _regeneratorDefine(AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), _regeneratorDefine(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorAsyncGen.js


function _regeneratorAsyncGen(r, e, t, o, n) {
  return new AsyncIterator(_regenerator().w(r, e, t, o), n || Promise);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorAsync.js

function _regeneratorAsync(n, e, r, t, o) {
  var a = _regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorKeys.js
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(80331);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js

function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable");
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js







function _regeneratorRuntime() {
  "use strict";

  var r = _regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    "throw": 1,
    "return": 2,
    "break": 3,
    "continue": 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        "catch": function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, _regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (_regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new _OverloadYield(r, e);
      },
      AsyncIterator: AsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}


/***/ }),

/***/ 69222:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ _slicedToArray)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(35062);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(63915);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(28339);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(r, e) {
  return (0,arrayWithHoles/* default */.Z)(r) || _iterableToArrayLimit(r, e) || (0,unsupportedIterableToArray/* default */.Z)(r, e) || (0,nonIterableRest/* default */.Z)();
}


/***/ }),

/***/ 33641:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ _toConsumableArray)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(74038);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return (0,arrayLikeToArray/* default */.Z)(r);
}

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(20264);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(63915);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || (0,iterableToArray/* default */.Z)(r) || (0,unsupportedIterableToArray/* default */.Z)(r) || _nonIterableSpread();
}


/***/ }),

/***/ 70871:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ toPropertyKey)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(80331);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != (0,esm_typeof/* default */.Z)(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != (0,esm_typeof/* default */.Z)(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == (0,esm_typeof/* default */.Z)(i) ? i : i + "";
}


/***/ }),

/***/ 80331:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _typeof)
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),

/***/ 63915:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _unsupportedIterableToArray)
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74038);

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a) : void 0;
  }
}


/***/ }),

/***/ 28614:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ query_string)
});

// NAMESPACE OBJECT: ./node_modules/@meitu/xdesign-widgets/node_modules/query-string/base.js
var base_namespaceObject = {};
__webpack_require__.r(base_namespaceObject);
__webpack_require__.d(base_namespaceObject, {
  "exclude": () => (exclude),
  "extract": () => (extract),
  "parse": () => (parse),
  "parseUrl": () => (parseUrl),
  "pick": () => (pick),
  "stringify": () => (stringify),
  "stringifyUrl": () => (stringifyUrl)
});

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/decode-uri-component/index.js
const token = '%[a-f0-9]{2}';
const singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
const multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	const left = components.slice(0, split);
	const right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch {
		let tokens = input.match(singleMatcher) || [];

		for (let i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	const replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD',
	};

	let match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch {
			const result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	const entries = Object.keys(replaceMap);

	for (const key of entries) {
		// Replace all decoded components
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

function decodeUriComponent(encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/split-on-first/index.js
function splitOnFirst(string, separator) {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (string === '' || separator === '') {
		return [];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/filter-obj/index.js
function includeKeys(object, predicate) {
	const result = {};

	if (Array.isArray(predicate)) {
		for (const key of predicate) {
			const descriptor = Object.getOwnPropertyDescriptor(object, key);
			if (descriptor?.enumerable) {
				Object.defineProperty(result, key, descriptor);
			}
		}
	} else {
		// `Reflect.ownKeys()` is required to retrieve symbol properties
		for (const key of Reflect.ownKeys(object)) {
			const descriptor = Object.getOwnPropertyDescriptor(object, key);
			if (descriptor.enumerable) {
				const value = object[key];
				if (predicate(key, value, object)) {
					Object.defineProperty(result, key, descriptor);
				}
			}
		}
	}

	return result;
}

function excludeKeys(object, predicate) {
	if (Array.isArray(predicate)) {
		const set = new Set(predicate);
		return includeKeys(object, key => !set.has(key));
	}

	return includeKeys(object, (key, value, object) => !predicate(key, value, object));
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/query-string/base.js




const isNullOrUndefined = value => value === null || value === undefined;

// eslint-disable-next-line unicorn/prefer-code-point
const strictUriEncode = string => encodeURIComponent(string).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);

const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index': {
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result, [encode(key, options), '[', index, ']'].join(''),
					];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join(''),
				];
			};
		}

		case 'bracket': {
			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result,
						[encode(key, options), '[]'].join(''),
					];
				}

				return [
					...result,
					[encode(key, options), '[]=', encode(value, options)].join(''),
				];
			};
		}

		case 'colon-list-separator': {
			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result,
						[encode(key, options), ':list='].join(''),
					];
				}

				return [
					...result,
					[encode(key, options), ':list=', encode(value, options)].join(''),
				];
			};
		}

		case 'comma':
		case 'separator':
		case 'bracket-separator': {
			const keyValueSep = options.arrayFormat === 'bracket-separator'
				? '[]='
				: '=';

			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				// Translate null to an empty string so that it doesn't serialize as 'null'
				value = value === null ? '' : value;

				if (result.length === 0) {
					return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};
		}

		default: {
			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result,
						encode(key, options),
					];
				}

				return [
					...result,
					[encode(key, options), '=', encode(value, options)].join(''),
				];
			};
		}
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index': {
			return (key, value, accumulator) => {
				result = /\[(\d*)]$/.exec(key);

				key = key.replace(/\[\d*]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};
		}

		case 'bracket': {
			return (key, value, accumulator) => {
				result = /(\[])$/.exec(key);
				key = key.replace(/\[]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [...accumulator[key], value];
			};
		}

		case 'colon-list-separator': {
			return (key, value, accumulator) => {
				result = /(:list)$/.exec(key);
				key = key.replace(/:list$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [...accumulator[key], value];
			};
		}

		case 'comma':
		case 'separator': {
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && base_decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? base_decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => base_decode(item, options)) : (value === null ? value : base_decode(value, options));
				accumulator[key] = newValue;
			};
		}

		case 'bracket-separator': {
			return (key, value, accumulator) => {
				const isArray = /(\[])$/.test(key);
				key = key.replace(/\[]$/, '');

				if (!isArray) {
					accumulator[key] = value ? base_decode(value, options) : value;
					return;
				}

				const arrayValue = value === null
					? []
					: value.split(options.arrayFormatSeparator).map(item => base_decode(item, options));

				if (accumulator[key] === undefined) {
					accumulator[key] = arrayValue;
					return;
				}

				accumulator[key] = [...accumulator[key], ...arrayValue];
			};
		}

		default: {
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [...[accumulator[key]].flat(), value];
			};
		}
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function base_decode(value, options) {
	if (options.decode) {
		return decodeUriComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parse(query, options) {
	options = {
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false,
		...options,
	};

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const returnValue = Object.create(null);

	if (typeof query !== 'string') {
		return returnValue;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return returnValue;
	}

	for (const parameter of query.split('&')) {
		if (parameter === '') {
			continue;
		}

		const parameter_ = options.decode ? parameter.replace(/\+/g, ' ') : parameter;

		let [key, value] = splitOnFirst(parameter_, '=');

		if (key === undefined) {
			key = parameter_;
		}

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : (['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : base_decode(value, options));
		formatter(base_decode(key, options), value, returnValue);
	}

	for (const [key, value] of Object.entries(returnValue)) {
		if (typeof value === 'object' && value !== null) {
			for (const [key2, value2] of Object.entries(value)) {
				value[key2] = parseValue(value2, options);
			}
		} else {
			returnValue[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return returnValue;
	}

	// TODO: Remove the use of `reduce`.
	// eslint-disable-next-line unicorn/no-array-reduce
	return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key) => {
		const value = returnValue[key];
		result[key] = Boolean(value) && typeof value === 'object' && !Array.isArray(value) ? keysSorter(value) : value;
		return result;
	}, Object.create(null));
}

function stringify(object, options) {
	if (!object) {
		return '';
	}

	options = {encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',', ...options};

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key]))
		|| (options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const [key, value] of Object.entries(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = value;
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
				return encode(key, options) + '[]';
			}

			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
}

function parseUrl(url, options) {
	options = {
		decode: true,
		...options,
	};

	let [url_, hash] = splitOnFirst(url, '#');

	if (url_ === undefined) {
		url_ = url;
	}

	return {
		url: url_?.split('?')?.[0] ?? '',
		query: parse(extract(url), options),
		...(options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: base_decode(hash, options)} : {}),
	};
}

function stringifyUrl(object, options) {
	options = {
		encode: true,
		strict: true,
		[encodeFragmentIdentifier]: true,
		...options,
	};

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = extract(object.url);

	const query = {
		...parse(queryFromUrl, {sort: false}),
		...object.query,
	};

	let queryString = stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		const urlObjectForFragmentEncode = new URL(url);
		urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
		hash = options[encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
	}

	return `${url}${queryString}${hash}`;
}

function pick(input, filter, options) {
	options = {
		parseFragmentIdentifier: true,
		[encodeFragmentIdentifier]: false,
		...options,
	};

	const {url, query, fragmentIdentifier} = parseUrl(input, options);

	return stringifyUrl({
		url,
		query: includeKeys(query, filter),
		fragmentIdentifier,
	}, options);
}

function exclude(input, filter, options) {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return pick(input, exclusionFilter, options);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/query-string/index.js


/* harmony default export */ const query_string = (base_namespaceObject);


/***/ }),

/***/ 5121:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ lib_axios)
});

// NAMESPACE OBJECT: ./node_modules/axios/lib/platform/common/utils.js
var common_utils_namespaceObject = {};
__webpack_require__.r(common_utils_namespaceObject);
__webpack_require__.d(common_utils_namespaceObject, {
  "hasBrowserEnv": () => (hasBrowserEnv),
  "hasStandardBrowserEnv": () => (hasStandardBrowserEnv),
  "hasStandardBrowserWebWorkerEnv": () => (hasStandardBrowserWebWorkerEnv)
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/bind.js


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/utils.js




// utils is a library of generic helper functions non-specific to axios

const {toString: utils_toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = utils_toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const utils_hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
}

const ALPHA = 'abcdefghijklmnopqrstuvwxyz'

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0]
  }

  return str;
}

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

/* harmony default export */ const utils = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: utils_hasOwnProperty,
  hasOwnProp: utils_hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosError.js




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const AxiosError_prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(AxiosError_prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(AxiosError_prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ const core_AxiosError = (AxiosError);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/null.js
// eslint-disable-next-line strict
/* harmony default export */ const helpers_null = (null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toFormData.js
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (helpers_null || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils.isSpecCompliantForm(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new core_AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        ((utils.isFileList(value) || utils.endsWith(key, '[]')) && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ const helpers_toFormData = (toFormData);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/AxiosURLSearchParams.js




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && helpers_toFormData(params, this, options);
}

const AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;

AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ const helpers_AxiosURLSearchParams = (AxiosURLSearchParams);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/buildURL.js





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function buildURL_encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || buildURL_encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ?
      params.toString() :
      new helpers_AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/InterceptorManager.js




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ const core_InterceptorManager = (InterceptorManager);

;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ const defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ const classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ const classes_FormData = (typeof FormData !== 'undefined' ? FormData : null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/Blob.js


/* harmony default export */ const classes_Blob = (typeof Blob !== 'undefined' ? Blob : null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/index.js




/* harmony default export */ const browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: classes_FormData,
    Blob: classes_Blob
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/common/utils.js
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = (
  (product) => {
    return hasBrowserEnv && ['ReactNative', 'NativeScript', 'NS'].indexOf(product) < 0
  })(typeof navigator !== 'undefined' && navigator.product);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();



;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/index.js



/* harmony default export */ const platform = ({
  ...common_utils_namespaceObject,
  ...browser
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toURLEncodedForm.js






function toURLEncodedForm(data, options) {
  return helpers_toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/formDataToJSON.js




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];

    if (name === '__proto__') return true;

    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};

    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ const helpers_formDataToJSON = (formDataToJSON);

;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/index.js










/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: defaults_transitional,

  adapter: ['xhr', 'http'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils.isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(helpers_formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return helpers_toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw core_AxiosError.from(e, core_AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

/* harmony default export */ const lib_defaults = (defaults);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseHeaders.js




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ const parseHeaders = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosHeaders.js





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils.isString(value)) return;

  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils.reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

utils.freezeMethods(AxiosHeaders);

/* harmony default export */ const core_AxiosHeaders = (AxiosHeaders);

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/transformData.js






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || lib_defaults;
  const context = response || config;
  const headers = core_AxiosHeaders.from(context.headers);
  let data = context.data;

  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CanceledError.js





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  core_AxiosError.call(this, message == null ? 'canceled' : message, core_AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, core_AxiosError, {
  __CANCEL__: true
});

/* harmony default export */ const cancel_CanceledError = (CanceledError);

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/settle.js




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new core_AxiosError(
      'Request failed with status code ' + response.status,
      [core_AxiosError.ERR_BAD_REQUEST, core_AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/cookies.js



/* harmony default export */ const cookies = (platform.hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      utils.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      utils.isString(path) && cookie.push('path=' + path);

      utils.isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  });


;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAbsoluteURL.js


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/combineURLs.js


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/buildFullPath.js





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isURLSameOrigin.js





/* harmony default export */ const isURLSameOrigin = (platform.hasStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })());

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/speedometer.js


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ const helpers_speedometer = (speedometer);

;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/xhr.js
















function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = helpers_speedometer(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ const xhr = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = core_AxiosHeaders.from(config.headers).normalize();
    let {responseType, withXSRFToken} = config;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    let contentType;

    if (utils.isFormData(requestData)) {
      if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
        requestHeaders.setContentType(false); // Let the browser set it
      } else if ((contentType = requestHeaders.getContentType()) !== false) {
        // fix semicolon duplication issue for ReactNative FormData implementation
        const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
        requestHeaders.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
      }
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = core_AxiosHeaders.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new core_AxiosError('Request aborted', core_AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || defaults_transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new core_AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? core_AxiosError.ETIMEDOUT : core_AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if(platform.hasStandardBrowserEnv) {
      withXSRFToken && utils.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));

      if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(fullPath))) {
        // Add xsrf header
        const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && cookies.read(config.xsrfCookieName);

        if (xsrfValue) {
          requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(fullPath);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new core_AxiosError('Unsupported protocol ' + protocol + ':', core_AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/adapters.js





const knownAdapters = {
  http: helpers_null,
  xhr: xhr
}

utils.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => utils.isFunction(adapter) || adapter === null || adapter === false;

/* harmony default export */ const adapters = ({
  getAdapter: (adapters) => {
    adapters = utils.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new core_AxiosError(`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new core_AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/dispatchRequest.js









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = core_AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || lib_defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = core_AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/mergeConfig.js





const headersToObject = (thing) => thing instanceof core_AxiosHeaders ? { ...thing } : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({caseless}, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/env/data.js
const VERSION = "1.6.8";
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/validator.js





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new core_AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        core_AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new core_AxiosError('options must be an object', core_AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new core_AxiosError('option ' + opt + ' must be ' + result, core_AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new core_AxiosError('Unknown option ' + opt, core_AxiosError.ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ const validator = ({
  assertOptions,
  validators
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/Axios.js











const Axios_validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy;

        Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : (dummy = new Error());

        // slice off the Error: ... line
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';

        if (!err.stack) {
          err.stack = stack;
          // match without the 2 top stack lines
        } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) {
          err.stack += '\n' + stack
        }
      }

      throw err;
    }
  }

  _request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        }
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: Axios_validators.function,
          serialize: Axios_validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils.merge(
      headers.common,
      headers[config.method]
    );

    headers && utils.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = core_AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ const core_Axios = (Axios);

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CancelToken.js




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ const cancel_CancelToken = (CancelToken);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/spread.js


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAxiosError.js




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/HttpStatusCode.js
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ const helpers_HttpStatusCode = (HttpStatusCode);

;// CONCATENATED MODULE: ./node_modules/axios/lib/axios.js




















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new core_Axios(defaultConfig);
  const instance = bind(core_Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, core_Axios.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(lib_defaults);

// Expose Axios class to allow class inheritance
axios.Axios = core_Axios;

// Expose Cancel & CancelToken
axios.CanceledError = cancel_CanceledError;
axios.CancelToken = cancel_CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = helpers_toFormData;

// Expose AxiosError class
axios.AxiosError = core_AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = core_AxiosHeaders;

axios.formToJSON = thing => helpers_formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = helpers_HttpStatusCode;

axios.default = axios;

// this module should only have a default export
/* harmony default export */ const lib_axios = (axios);


/***/ }),

/***/ 31955:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ api)
/* harmony export */ });
/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */




/***/ }),

/***/ 97582:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__addDisposableResource": () => (/* binding */ __addDisposableResource),
/* harmony export */   "__assign": () => (/* binding */ __assign),
/* harmony export */   "__asyncDelegator": () => (/* binding */ __asyncDelegator),
/* harmony export */   "__asyncGenerator": () => (/* binding */ __asyncGenerator),
/* harmony export */   "__asyncValues": () => (/* binding */ __asyncValues),
/* harmony export */   "__await": () => (/* binding */ __await),
/* harmony export */   "__awaiter": () => (/* binding */ __awaiter),
/* harmony export */   "__classPrivateFieldGet": () => (/* binding */ __classPrivateFieldGet),
/* harmony export */   "__classPrivateFieldIn": () => (/* binding */ __classPrivateFieldIn),
/* harmony export */   "__classPrivateFieldSet": () => (/* binding */ __classPrivateFieldSet),
/* harmony export */   "__createBinding": () => (/* binding */ __createBinding),
/* harmony export */   "__decorate": () => (/* binding */ __decorate),
/* harmony export */   "__disposeResources": () => (/* binding */ __disposeResources),
/* harmony export */   "__esDecorate": () => (/* binding */ __esDecorate),
/* harmony export */   "__exportStar": () => (/* binding */ __exportStar),
/* harmony export */   "__extends": () => (/* binding */ __extends),
/* harmony export */   "__generator": () => (/* binding */ __generator),
/* harmony export */   "__importDefault": () => (/* binding */ __importDefault),
/* harmony export */   "__importStar": () => (/* binding */ __importStar),
/* harmony export */   "__makeTemplateObject": () => (/* binding */ __makeTemplateObject),
/* harmony export */   "__metadata": () => (/* binding */ __metadata),
/* harmony export */   "__param": () => (/* binding */ __param),
/* harmony export */   "__propKey": () => (/* binding */ __propKey),
/* harmony export */   "__read": () => (/* binding */ __read),
/* harmony export */   "__rest": () => (/* binding */ __rest),
/* harmony export */   "__rewriteRelativeImportExtension": () => (/* binding */ __rewriteRelativeImportExtension),
/* harmony export */   "__runInitializers": () => (/* binding */ __runInitializers),
/* harmony export */   "__setFunctionName": () => (/* binding */ __setFunctionName),
/* harmony export */   "__spread": () => (/* binding */ __spread),
/* harmony export */   "__spreadArray": () => (/* binding */ __spreadArray),
/* harmony export */   "__spreadArrays": () => (/* binding */ __spreadArrays),
/* harmony export */   "__values": () => (/* binding */ __values),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function (o) {
    var ar = [];
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
      return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
          return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
      });
  }
  return path;
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension,
});


/***/ }),

/***/ 38085:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NO": () => (/* binding */ G),
/* harmony export */   "Yn": () => (/* binding */ j),
/* harmony export */   "a4": () => (/* binding */ S),
/* harmony export */   "mr": () => (/* binding */ Q),
/* harmony export */   "mw": () => (/* binding */ w)
/* harmony export */ });
/* unused harmony exports CLSThresholds, FCPThresholds, FIDThresholds, INPThresholds, LCPThresholds, TTFBThresholds, onFID */
var e,n,t,r,i,o=-1,a=function(e){addEventListener("pageshow",(function(n){n.persisted&&(o=n.timeStamp,e(n))}),!0)},c=function(){var e=self.performance&&performance.getEntriesByType&&performance.getEntriesByType("navigation")[0];if(e&&e.responseStart>0&&e.responseStart<performance.now())return e},u=function(){var e=c();return e&&e.activationStart||0},f=function(e,n){var t=c(),r="navigate";o>=0?r="back-forward-cache":t&&(document.prerendering||u()>0?r="prerender":document.wasDiscarded?r="restore":t.type&&(r=t.type.replace(/_/g,"-")));return{name:e,value:void 0===n?-1:n,rating:"good",delta:0,entries:[],id:"v4-".concat(Date.now(),"-").concat(Math.floor(8999999999999*Math.random())+1e12),navigationType:r}},s=function(e,n,t){try{if(PerformanceObserver.supportedEntryTypes.includes(e)){var r=new PerformanceObserver((function(e){Promise.resolve().then((function(){n(e.getEntries())}))}));return r.observe(Object.assign({type:e,buffered:!0},t||{})),r}}catch(e){}},d=function(e,n,t,r){var i,o;return function(a){n.value>=0&&(a||r)&&((o=n.value-(i||0))||void 0===i)&&(i=n.value,n.delta=o,n.rating=function(e,n){return e>n[1]?"poor":e>n[0]?"needs-improvement":"good"}(n.value,t),e(n))}},l=function(e){requestAnimationFrame((function(){return requestAnimationFrame((function(){return e()}))}))},p=function(e){document.addEventListener("visibilitychange",(function(){"hidden"===document.visibilityState&&e()}))},v=function(e){var n=!1;return function(){n||(e(),n=!0)}},m=-1,h=function(){return"hidden"!==document.visibilityState||document.prerendering?1/0:0},g=function(e){"hidden"===document.visibilityState&&m>-1&&(m="visibilitychange"===e.type?e.timeStamp:0,T())},y=function(){addEventListener("visibilitychange",g,!0),addEventListener("prerenderingchange",g,!0)},T=function(){removeEventListener("visibilitychange",g,!0),removeEventListener("prerenderingchange",g,!0)},E=function(){return m<0&&(m=h(),y(),a((function(){setTimeout((function(){m=h(),y()}),0)}))),{get firstHiddenTime(){return m}}},C=function(e){document.prerendering?addEventListener("prerenderingchange",(function(){return e()}),!0):e()},b=[1800,3e3],S=function(e,n){n=n||{},C((function(){var t,r=E(),i=f("FCP"),o=s("paint",(function(e){e.forEach((function(e){"first-contentful-paint"===e.name&&(o.disconnect(),e.startTime<r.firstHiddenTime&&(i.value=Math.max(e.startTime-u(),0),i.entries.push(e),t(!0)))}))}));o&&(t=d(e,i,b,n.reportAllChanges),a((function(r){i=f("FCP"),t=d(e,i,b,n.reportAllChanges),l((function(){i.value=performance.now()-r.timeStamp,t(!0)}))})))}))},L=[.1,.25],w=function(e,n){n=n||{},S(v((function(){var t,r=f("CLS",0),i=0,o=[],c=function(e){e.forEach((function(e){if(!e.hadRecentInput){var n=o[0],t=o[o.length-1];i&&e.startTime-t.startTime<1e3&&e.startTime-n.startTime<5e3?(i+=e.value,o.push(e)):(i=e.value,o=[e])}})),i>r.value&&(r.value=i,r.entries=o,t())},u=s("layout-shift",c);u&&(t=d(e,r,L,n.reportAllChanges),p((function(){c(u.takeRecords()),t(!0)})),a((function(){i=0,r=f("CLS",0),t=d(e,r,L,n.reportAllChanges),l((function(){return t()}))})),setTimeout(t,0))})))},A=0,I=1/0,P=0,M=function(e){e.forEach((function(e){e.interactionId&&(I=Math.min(I,e.interactionId),P=Math.max(P,e.interactionId),A=P?(P-I)/7+1:0)}))},k=function(){return e?A:performance.interactionCount||0},F=function(){"interactionCount"in performance||e||(e=s("event",M,{type:"event",buffered:!0,durationThreshold:0}))},D=[],x=new Map,R=0,B=function(){var e=Math.min(D.length-1,Math.floor((k()-R)/50));return D[e]},H=[],q=function(e){if(H.forEach((function(n){return n(e)})),e.interactionId||"first-input"===e.entryType){var n=D[D.length-1],t=x.get(e.interactionId);if(t||D.length<10||e.duration>n.latency){if(t)e.duration>t.latency?(t.entries=[e],t.latency=e.duration):e.duration===t.latency&&e.startTime===t.entries[0].startTime&&t.entries.push(e);else{var r={id:e.interactionId,latency:e.duration,entries:[e]};x.set(r.id,r),D.push(r)}D.sort((function(e,n){return n.latency-e.latency})),D.length>10&&D.splice(10).forEach((function(e){return x.delete(e.id)}))}}},O=function(e){var n=self.requestIdleCallback||self.setTimeout,t=-1;return e=v(e),"hidden"===document.visibilityState?e():(t=n(e),p(e)),t},N=[200,500],j=function(e,n){"PerformanceEventTiming"in self&&"interactionId"in PerformanceEventTiming.prototype&&(n=n||{},C((function(){var t;F();var r,i=f("INP"),o=function(e){O((function(){e.forEach(q);var n=B();n&&n.latency!==i.value&&(i.value=n.latency,i.entries=n.entries,r())}))},c=s("event",o,{durationThreshold:null!==(t=n.durationThreshold)&&void 0!==t?t:40});r=d(e,i,N,n.reportAllChanges),c&&(c.observe({type:"first-input",buffered:!0}),p((function(){o(c.takeRecords()),r(!0)})),a((function(){R=k(),D.length=0,x.clear(),i=f("INP"),r=d(e,i,N,n.reportAllChanges)})))})))},_=[2500,4e3],z={},G=function(e,n){n=n||{},C((function(){var t,r=E(),i=f("LCP"),o=function(e){n.reportAllChanges||(e=e.slice(-1)),e.forEach((function(e){e.startTime<r.firstHiddenTime&&(i.value=Math.max(e.startTime-u(),0),i.entries=[e],t())}))},c=s("largest-contentful-paint",o);if(c){t=d(e,i,_,n.reportAllChanges);var m=v((function(){z[i.id]||(o(c.takeRecords()),c.disconnect(),z[i.id]=!0,t(!0))}));["keydown","click"].forEach((function(e){addEventListener(e,(function(){return O(m)}),{once:!0,capture:!0})})),p(m),a((function(r){i=f("LCP"),t=d(e,i,_,n.reportAllChanges),l((function(){i.value=performance.now()-r.timeStamp,z[i.id]=!0,t(!0)}))}))}}))},J=[800,1800],K=function e(n){document.prerendering?C((function(){return e(n)})):"complete"!==document.readyState?addEventListener("load",(function(){return e(n)}),!0):setTimeout(n,0)},Q=function(e,n){n=n||{};var t=f("TTFB"),r=d(e,t,J,n.reportAllChanges);K((function(){var i=c();i&&(t.value=Math.max(i.responseStart-u(),0),t.entries=[i],r(!0),a((function(){t=f("TTFB",0),(r=d(e,t,J,n.reportAllChanges))(!0)})))}))},U={passive:!0,capture:!0},V=new Date,W=function(e,i){n||(n=i,t=e,r=new Date,Z(removeEventListener),X())},X=function(){if(t>=0&&t<r-V){var e={entryType:"first-input",name:n.type,target:n.target,cancelable:n.cancelable,startTime:n.timeStamp,processingStart:n.timeStamp+t};i.forEach((function(n){n(e)})),i=[]}},Y=function(e){if(e.cancelable){var n=(e.timeStamp>1e12?new Date:performance.now())-e.timeStamp;"pointerdown"==e.type?function(e,n){var t=function(){W(e,n),i()},r=function(){i()},i=function(){removeEventListener("pointerup",t,U),removeEventListener("pointercancel",r,U)};addEventListener("pointerup",t,U),addEventListener("pointercancel",r,U)}(n,e):W(n,e)}},Z=function(e){["mousedown","keydown","touchstart","pointerdown"].forEach((function(n){return e(n,Y,U)}))},$=(/* unused pure expression or super */ null && ([100,300])),ee=function(e,r){r=r||{},C((function(){var o,c=E(),u=f("FID"),l=function(e){e.startTime<c.firstHiddenTime&&(u.value=e.processingStart-e.startTime,u.entries.push(e),o(!0))},m=function(e){e.forEach(l)},h=s("first-input",m);o=d(e,u,$,r.reportAllChanges),h&&(p(v((function(){m(h.takeRecords()),h.disconnect()}))),a((function(){var a;u=f("FID"),o=d(e,u,$,r.reportAllChanges),i=[],t=-1,n=null,Z(addEventListener),a=l,i.push(a),X()})))}))};


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [9774,179], () => (__webpack_exec__(6840), __webpack_exec__(30165)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);